
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired751"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired751"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jpaef", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $e2084958f4c8b842$export$ffb0004e005737fa, (v) => $e2084958f4c8b842$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $e2084958f4c8b842$export$34b9dba7ce09269b, (v) => $e2084958f4c8b842$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $e2084958f4c8b842$export$25062201e9e25d76, (v) => $e2084958f4c8b842$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e2084958f4c8b842$export$ffb0004e005737fa;
var $e2084958f4c8b842$export$34b9dba7ce09269b;
var $e2084958f4c8b842$export$25062201e9e25d76;
"use strict";
var $e2084958f4c8b842$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $e2084958f4c8b842$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $e2084958f4c8b842$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $e2084958f4c8b842$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$e2084958f4c8b842$export$ffb0004e005737fa = $e2084958f4c8b842$var$REACT_FRAGMENT_TYPE;
$e2084958f4c8b842$export$34b9dba7ce09269b = $e2084958f4c8b842$var$jsxProd;
$e2084958f4c8b842$export$25062201e9e25d76 = $e2084958f4c8b842$var$jsxProd;

});

parcelRegister("9x51g", function(module, exports) {

$parcel$export(module.exports, "Children", () => $6f0b16db93ae96cf$export$dca3b0875bd9a954, (v) => $6f0b16db93ae96cf$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $6f0b16db93ae96cf$export$16fa2f45be04daa8, (v) => $6f0b16db93ae96cf$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $6f0b16db93ae96cf$export$ffb0004e005737fa, (v) => $6f0b16db93ae96cf$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $6f0b16db93ae96cf$export$e2c29f18771995cb, (v) => $6f0b16db93ae96cf$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $6f0b16db93ae96cf$export$221d75b3f55bb0bd, (v) => $6f0b16db93ae96cf$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $6f0b16db93ae96cf$export$5f8d39834fd61797, (v) => $6f0b16db93ae96cf$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6f0b16db93ae96cf$export$74bf444e3cd11ea5, (v) => $6f0b16db93ae96cf$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $6f0b16db93ae96cf$export$1ced07cd6b1985ce, (v) => $6f0b16db93ae96cf$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $6f0b16db93ae96cf$export$abd8e32b826d7ea7, (v) => $6f0b16db93ae96cf$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $6f0b16db93ae96cf$export$69a3209f1a06c04d, (v) => $6f0b16db93ae96cf$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cloneElement", () => $6f0b16db93ae96cf$export$e530037191fcd5d7, (v) => $6f0b16db93ae96cf$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $6f0b16db93ae96cf$export$fd42f52fd3ae1109, (v) => $6f0b16db93ae96cf$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $6f0b16db93ae96cf$export$c8a8987d4410bf2d, (v) => $6f0b16db93ae96cf$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $6f0b16db93ae96cf$export$7d1e3a5e95ceca43, (v) => $6f0b16db93ae96cf$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $6f0b16db93ae96cf$export$257a8862b851cb5b, (v) => $6f0b16db93ae96cf$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $6f0b16db93ae96cf$export$a8257692ac88316c, (v) => $6f0b16db93ae96cf$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $6f0b16db93ae96cf$export$488013bae63b21da, (v) => $6f0b16db93ae96cf$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $6f0b16db93ae96cf$export$7c73462e0d25e514, (v) => $6f0b16db93ae96cf$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $6f0b16db93ae96cf$export$7568632d0d33d16d, (v) => $6f0b16db93ae96cf$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $6f0b16db93ae96cf$export$f93f40ac0ca7e3a8, (v) => $6f0b16db93ae96cf$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $6f0b16db93ae96cf$export$1f96ae73734a86cc, (v) => $6f0b16db93ae96cf$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $6f0b16db93ae96cf$export$9a47ced3238df325, (v) => $6f0b16db93ae96cf$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $6f0b16db93ae96cf$export$35808ee640e87ca7, (v) => $6f0b16db93ae96cf$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $6f0b16db93ae96cf$export$fae74005e78b1a27, (v) => $6f0b16db93ae96cf$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $6f0b16db93ae96cf$export$dc8fbce3eb94dc1e, (v) => $6f0b16db93ae96cf$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $6f0b16db93ae96cf$export$6a7bc4e911dc01cf, (v) => $6f0b16db93ae96cf$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $6f0b16db93ae96cf$export$6d9c69b0de29b591, (v) => $6f0b16db93ae96cf$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $6f0b16db93ae96cf$export$f680877a34711e37, (v) => $6f0b16db93ae96cf$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $6f0b16db93ae96cf$export$d5a552a76deda3c2, (v) => $6f0b16db93ae96cf$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $6f0b16db93ae96cf$export$aaabe4eda9ed9969, (v) => $6f0b16db93ae96cf$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $6f0b16db93ae96cf$export$e5c5a5f917a5871c, (v) => $6f0b16db93ae96cf$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $6f0b16db93ae96cf$export$1538c33de8887b59, (v) => $6f0b16db93ae96cf$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $6f0b16db93ae96cf$export$fca7f784ae7a249a, (v) => $6f0b16db93ae96cf$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $6f0b16db93ae96cf$export$13e3392192263954, (v) => $6f0b16db93ae96cf$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $6f0b16db93ae96cf$export$b8f5890fc79d6aca, (v) => $6f0b16db93ae96cf$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $6f0b16db93ae96cf$export$60241385465d0a34, (v) => $6f0b16db93ae96cf$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $6f0b16db93ae96cf$export$306c0aa65ff9ec16, (v) => $6f0b16db93ae96cf$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $6f0b16db93ae96cf$export$7b286972b8d8ccbf, (v) => $6f0b16db93ae96cf$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $6f0b16db93ae96cf$export$83d89fbfd8236492, (v) => $6f0b16db93ae96cf$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6f0b16db93ae96cf$export$dca3b0875bd9a954;
var $6f0b16db93ae96cf$export$16fa2f45be04daa8;
var $6f0b16db93ae96cf$export$ffb0004e005737fa;
var $6f0b16db93ae96cf$export$e2c29f18771995cb;
var $6f0b16db93ae96cf$export$221d75b3f55bb0bd;
var $6f0b16db93ae96cf$export$5f8d39834fd61797;
var $6f0b16db93ae96cf$export$74bf444e3cd11ea5;
var $6f0b16db93ae96cf$export$1ced07cd6b1985ce;
var $6f0b16db93ae96cf$export$abd8e32b826d7ea7;
var $6f0b16db93ae96cf$export$69a3209f1a06c04d;
var $6f0b16db93ae96cf$export$e530037191fcd5d7;
var $6f0b16db93ae96cf$export$fd42f52fd3ae1109;
var $6f0b16db93ae96cf$export$c8a8987d4410bf2d;
var $6f0b16db93ae96cf$export$7d1e3a5e95ceca43;
var $6f0b16db93ae96cf$export$257a8862b851cb5b;
var $6f0b16db93ae96cf$export$a8257692ac88316c;
var $6f0b16db93ae96cf$export$488013bae63b21da;
var $6f0b16db93ae96cf$export$7c73462e0d25e514;
var $6f0b16db93ae96cf$export$7568632d0d33d16d;
var $6f0b16db93ae96cf$export$f93f40ac0ca7e3a8;
var $6f0b16db93ae96cf$export$1f96ae73734a86cc;
var $6f0b16db93ae96cf$export$9a47ced3238df325;
var $6f0b16db93ae96cf$export$35808ee640e87ca7;
var $6f0b16db93ae96cf$export$fae74005e78b1a27;
var $6f0b16db93ae96cf$export$dc8fbce3eb94dc1e;
var $6f0b16db93ae96cf$export$6a7bc4e911dc01cf;
var $6f0b16db93ae96cf$export$6d9c69b0de29b591;
var $6f0b16db93ae96cf$export$f680877a34711e37;
var $6f0b16db93ae96cf$export$d5a552a76deda3c2;
var $6f0b16db93ae96cf$export$aaabe4eda9ed9969;
var $6f0b16db93ae96cf$export$e5c5a5f917a5871c;
var $6f0b16db93ae96cf$export$1538c33de8887b59;
var $6f0b16db93ae96cf$export$fca7f784ae7a249a;
var $6f0b16db93ae96cf$export$13e3392192263954;
var $6f0b16db93ae96cf$export$b8f5890fc79d6aca;
var $6f0b16db93ae96cf$export$60241385465d0a34;
var $6f0b16db93ae96cf$export$306c0aa65ff9ec16;
var $6f0b16db93ae96cf$export$7b286972b8d8ccbf;
var $6f0b16db93ae96cf$export$83d89fbfd8236492;
"use strict";
var $6f0b16db93ae96cf$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $6f0b16db93ae96cf$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $6f0b16db93ae96cf$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $6f0b16db93ae96cf$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $6f0b16db93ae96cf$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $6f0b16db93ae96cf$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $6f0b16db93ae96cf$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $6f0b16db93ae96cf$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $6f0b16db93ae96cf$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $6f0b16db93ae96cf$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $6f0b16db93ae96cf$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $6f0b16db93ae96cf$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $6f0b16db93ae96cf$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $6f0b16db93ae96cf$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$6f0b16db93ae96cf$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $6f0b16db93ae96cf$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $6f0b16db93ae96cf$var$assign = Object.assign, $6f0b16db93ae96cf$var$emptyObject = {};
function $6f0b16db93ae96cf$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $6f0b16db93ae96cf$var$emptyObject;
    this.updater = updater || $6f0b16db93ae96cf$var$ReactNoopUpdateQueue;
}
$6f0b16db93ae96cf$var$Component.prototype.isReactComponent = {};
$6f0b16db93ae96cf$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$6f0b16db93ae96cf$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $6f0b16db93ae96cf$var$ComponentDummy() {}
$6f0b16db93ae96cf$var$ComponentDummy.prototype = $6f0b16db93ae96cf$var$Component.prototype;
function $6f0b16db93ae96cf$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $6f0b16db93ae96cf$var$emptyObject;
    this.updater = updater || $6f0b16db93ae96cf$var$ReactNoopUpdateQueue;
}
var $6f0b16db93ae96cf$var$pureComponentPrototype = $6f0b16db93ae96cf$var$PureComponent.prototype = new $6f0b16db93ae96cf$var$ComponentDummy();
$6f0b16db93ae96cf$var$pureComponentPrototype.constructor = $6f0b16db93ae96cf$var$PureComponent;
$6f0b16db93ae96cf$var$assign($6f0b16db93ae96cf$var$pureComponentPrototype, $6f0b16db93ae96cf$var$Component.prototype);
$6f0b16db93ae96cf$var$pureComponentPrototype.isPureReactComponent = !0;
var $6f0b16db93ae96cf$var$isArrayImpl = Array.isArray, $6f0b16db93ae96cf$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null,
    V: null
}, $6f0b16db93ae96cf$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $6f0b16db93ae96cf$var$ReactElement(type, key, self, source, owner, props) {
    self = props.ref;
    return {
        $$typeof: $6f0b16db93ae96cf$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== self ? self : null,
        props: props
    };
}
function $6f0b16db93ae96cf$var$cloneAndReplaceKey(oldElement, newKey) {
    return $6f0b16db93ae96cf$var$ReactElement(oldElement.type, newKey, void 0, void 0, void 0, oldElement.props);
}
function $6f0b16db93ae96cf$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $6f0b16db93ae96cf$var$REACT_ELEMENT_TYPE;
}
function $6f0b16db93ae96cf$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $6f0b16db93ae96cf$var$userProvidedKeyEscapeRegex = /\/+/g;
function $6f0b16db93ae96cf$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $6f0b16db93ae96cf$var$escape("" + element.key) : index.toString(36);
}
function $6f0b16db93ae96cf$var$noop$1() {}
function $6f0b16db93ae96cf$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($6f0b16db93ae96cf$var$noop$1, $6f0b16db93ae96cf$var$noop$1) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $6f0b16db93ae96cf$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $6f0b16db93ae96cf$var$REACT_ELEMENT_TYPE:
                case $6f0b16db93ae96cf$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $6f0b16db93ae96cf$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $6f0b16db93ae96cf$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $6f0b16db93ae96cf$var$getElementKey(children, 0) : nameSoFar, $6f0b16db93ae96cf$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($6f0b16db93ae96cf$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $6f0b16db93ae96cf$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($6f0b16db93ae96cf$var$isValidElement(callback) && (callback = $6f0b16db93ae96cf$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($6f0b16db93ae96cf$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($6f0b16db93ae96cf$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $6f0b16db93ae96cf$var$getElementKey(nameSoFar, i), invokeCallback += $6f0b16db93ae96cf$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $6f0b16db93ae96cf$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $6f0b16db93ae96cf$var$getElementKey(nameSoFar, i++), invokeCallback += $6f0b16db93ae96cf$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $6f0b16db93ae96cf$var$mapIntoArray($6f0b16db93ae96cf$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $6f0b16db93ae96cf$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $6f0b16db93ae96cf$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $6f0b16db93ae96cf$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $6f0b16db93ae96cf$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $6f0b16db93ae96cf$var$noop() {}
$6f0b16db93ae96cf$export$dca3b0875bd9a954 = {
    map: $6f0b16db93ae96cf$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $6f0b16db93ae96cf$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $6f0b16db93ae96cf$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $6f0b16db93ae96cf$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$6f0b16db93ae96cf$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$6f0b16db93ae96cf$export$16fa2f45be04daa8 = $6f0b16db93ae96cf$var$Component;
$6f0b16db93ae96cf$export$ffb0004e005737fa = $6f0b16db93ae96cf$var$REACT_FRAGMENT_TYPE;
$6f0b16db93ae96cf$export$e2c29f18771995cb = $6f0b16db93ae96cf$var$REACT_PROFILER_TYPE;
$6f0b16db93ae96cf$export$221d75b3f55bb0bd = $6f0b16db93ae96cf$var$PureComponent;
$6f0b16db93ae96cf$export$5f8d39834fd61797 = $6f0b16db93ae96cf$var$REACT_STRICT_MODE_TYPE;
$6f0b16db93ae96cf$export$74bf444e3cd11ea5 = $6f0b16db93ae96cf$var$REACT_SUSPENSE_TYPE;
$6f0b16db93ae96cf$export$1ced07cd6b1985ce = $6f0b16db93ae96cf$var$ReactSharedInternals;
$6f0b16db93ae96cf$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$6f0b16db93ae96cf$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$6f0b16db93ae96cf$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $6f0b16db93ae96cf$var$assign({}, element.props), key = element.key, owner = void 0;
    if (null != config) for(propName in void 0 !== config.ref && (owner = void 0), void 0 !== config.key && (key = "" + config.key), config)!$6f0b16db93ae96cf$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $6f0b16db93ae96cf$var$ReactElement(element.type, key, void 0, void 0, owner, props);
};
$6f0b16db93ae96cf$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $6f0b16db93ae96cf$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $6f0b16db93ae96cf$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$6f0b16db93ae96cf$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$6f0b16db93ae96cf$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $6f0b16db93ae96cf$var$ReactElement(type, key, void 0, void 0, null, props);
};
$6f0b16db93ae96cf$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$6f0b16db93ae96cf$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $6f0b16db93ae96cf$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$6f0b16db93ae96cf$export$a8257692ac88316c = $6f0b16db93ae96cf$var$isValidElement;
$6f0b16db93ae96cf$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $6f0b16db93ae96cf$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $6f0b16db93ae96cf$var$lazyInitializer
    };
};
$6f0b16db93ae96cf$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $6f0b16db93ae96cf$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$6f0b16db93ae96cf$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $6f0b16db93ae96cf$var$ReactSharedInternals.T, currentTransition = {};
    $6f0b16db93ae96cf$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $6f0b16db93ae96cf$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($6f0b16db93ae96cf$var$noop, $6f0b16db93ae96cf$var$reportGlobalError);
    } catch (error) {
        $6f0b16db93ae96cf$var$reportGlobalError(error);
    } finally{
        $6f0b16db93ae96cf$var$ReactSharedInternals.T = prevTransition;
    }
};
$6f0b16db93ae96cf$export$f93f40ac0ca7e3a8 = function() {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useCacheRefresh();
};
$6f0b16db93ae96cf$export$1f96ae73734a86cc = function(usable) {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.use(usable);
};
$6f0b16db93ae96cf$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$6f0b16db93ae96cf$export$35808ee640e87ca7 = function(callback, deps) {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$6f0b16db93ae96cf$export$fae74005e78b1a27 = function(Context) {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useContext(Context);
};
$6f0b16db93ae96cf$export$dc8fbce3eb94dc1e = function() {};
$6f0b16db93ae96cf$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$6f0b16db93ae96cf$export$6d9c69b0de29b591 = function(create, createDeps, update) {
    var dispatcher = $6f0b16db93ae96cf$var$ReactSharedInternals.H;
    if ("function" === typeof update) throw Error("useEffect CRUD overload is not enabled in this build of React.");
    return dispatcher.useEffect(create, createDeps);
};
$6f0b16db93ae96cf$export$f680877a34711e37 = function() {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useId();
};
$6f0b16db93ae96cf$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$6f0b16db93ae96cf$export$aaabe4eda9ed9969 = function(create, deps) {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$6f0b16db93ae96cf$export$e5c5a5f917a5871c = function(create, deps) {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$6f0b16db93ae96cf$export$1538c33de8887b59 = function(create, deps) {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useMemo(create, deps);
};
$6f0b16db93ae96cf$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$6f0b16db93ae96cf$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$6f0b16db93ae96cf$export$b8f5890fc79d6aca = function(initialValue) {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useRef(initialValue);
};
$6f0b16db93ae96cf$export$60241385465d0a34 = function(initialState) {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useState(initialState);
};
$6f0b16db93ae96cf$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$6f0b16db93ae96cf$export$7b286972b8d8ccbf = function() {
    return $6f0b16db93ae96cf$var$ReactSharedInternals.H.useTransition();
};
$6f0b16db93ae96cf$export$83d89fbfd8236492 = "19.1.1";

});

parcelRegister("dhnve", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $9aaf1809a83fe6d0$export$2b8d127b894957b9, (v) => $9aaf1809a83fe6d0$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $9aaf1809a83fe6d0$export$cea3a54a6425200c, (v) => $9aaf1809a83fe6d0$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $9aaf1809a83fe6d0$export$a7c73072b1a182ae, (v) => $9aaf1809a83fe6d0$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $9aaf1809a83fe6d0$export$9f27bc3417b4524d, (v) => $9aaf1809a83fe6d0$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $9aaf1809a83fe6d0$export$db77ccec0bb4ccac, (v) => $9aaf1809a83fe6d0$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $9aaf1809a83fe6d0$export$8392c0c9d3dcbd35, (v) => $9aaf1809a83fe6d0$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $9aaf1809a83fe6d0$export$ffb0004e005737fa, (v) => $9aaf1809a83fe6d0$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $9aaf1809a83fe6d0$export$b624eff549462981, (v) => $9aaf1809a83fe6d0$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $9aaf1809a83fe6d0$export$7897aa7841a5380c, (v) => $9aaf1809a83fe6d0$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $9aaf1809a83fe6d0$export$602eac185826482c, (v) => $9aaf1809a83fe6d0$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $9aaf1809a83fe6d0$export$e2c29f18771995cb, (v) => $9aaf1809a83fe6d0$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $9aaf1809a83fe6d0$export$5f8d39834fd61797, (v) => $9aaf1809a83fe6d0$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $9aaf1809a83fe6d0$export$74bf444e3cd11ea5, (v) => $9aaf1809a83fe6d0$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $9aaf1809a83fe6d0$export$92387174baf9b227, (v) => $9aaf1809a83fe6d0$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $9aaf1809a83fe6d0$export$ec112efeb987d9c6, (v) => $9aaf1809a83fe6d0$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $9aaf1809a83fe6d0$export$b706b080d889d2c9, (v) => $9aaf1809a83fe6d0$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $9aaf1809a83fe6d0$export$5be5a87408f70ddc, (v) => $9aaf1809a83fe6d0$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $9aaf1809a83fe6d0$export$45a5e7f76e0caa8d, (v) => $9aaf1809a83fe6d0$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $9aaf1809a83fe6d0$export$455c2e768291efa6, (v) => $9aaf1809a83fe6d0$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $9aaf1809a83fe6d0$export$9522e17588c12572, (v) => $9aaf1809a83fe6d0$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $9aaf1809a83fe6d0$export$2110ac352bb060b9, (v) => $9aaf1809a83fe6d0$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $9aaf1809a83fe6d0$export$56885ab8b9c456ab, (v) => $9aaf1809a83fe6d0$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $9aaf1809a83fe6d0$export$d927fcb6adf8f9de, (v) => $9aaf1809a83fe6d0$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $9aaf1809a83fe6d0$export$b82d16f27459e05a, (v) => $9aaf1809a83fe6d0$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $9aaf1809a83fe6d0$export$522c17b4f5e123e8, (v) => $9aaf1809a83fe6d0$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $9aaf1809a83fe6d0$export$1aabd8a0274ecfd6, (v) => $9aaf1809a83fe6d0$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $9aaf1809a83fe6d0$export$9b621391a187a31a, (v) => $9aaf1809a83fe6d0$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $9aaf1809a83fe6d0$export$f5bbd400c2f4426f, (v) => $9aaf1809a83fe6d0$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9aaf1809a83fe6d0$export$2b8d127b894957b9;
var $9aaf1809a83fe6d0$export$cea3a54a6425200c;
var $9aaf1809a83fe6d0$export$a7c73072b1a182ae;
var $9aaf1809a83fe6d0$export$9f27bc3417b4524d;
var $9aaf1809a83fe6d0$export$db77ccec0bb4ccac;
var $9aaf1809a83fe6d0$export$8392c0c9d3dcbd35;
var $9aaf1809a83fe6d0$export$ffb0004e005737fa;
var $9aaf1809a83fe6d0$export$b624eff549462981;
var $9aaf1809a83fe6d0$export$7897aa7841a5380c;
var $9aaf1809a83fe6d0$export$602eac185826482c;
var $9aaf1809a83fe6d0$export$e2c29f18771995cb;
var $9aaf1809a83fe6d0$export$5f8d39834fd61797;
var $9aaf1809a83fe6d0$export$74bf444e3cd11ea5;
var $9aaf1809a83fe6d0$export$92387174baf9b227;
var $9aaf1809a83fe6d0$export$ec112efeb987d9c6;
var $9aaf1809a83fe6d0$export$b706b080d889d2c9;
var $9aaf1809a83fe6d0$export$5be5a87408f70ddc;
var $9aaf1809a83fe6d0$export$45a5e7f76e0caa8d;
var $9aaf1809a83fe6d0$export$455c2e768291efa6;
var $9aaf1809a83fe6d0$export$9522e17588c12572;
var $9aaf1809a83fe6d0$export$2110ac352bb060b9;
var $9aaf1809a83fe6d0$export$56885ab8b9c456ab;
var $9aaf1809a83fe6d0$export$d927fcb6adf8f9de;
var $9aaf1809a83fe6d0$export$b82d16f27459e05a;
var $9aaf1809a83fe6d0$export$522c17b4f5e123e8;
var $9aaf1809a83fe6d0$export$1aabd8a0274ecfd6;
var $9aaf1809a83fe6d0$export$9b621391a187a31a;
var $9aaf1809a83fe6d0$export$f5bbd400c2f4426f;
'use strict';
var $9aaf1809a83fe6d0$var$b = "function" === typeof Symbol && Symbol.for, $9aaf1809a83fe6d0$var$c = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.element") : 60103, $9aaf1809a83fe6d0$var$d = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.portal") : 60106, $9aaf1809a83fe6d0$var$e = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.fragment") : 60107, $9aaf1809a83fe6d0$var$f = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.strict_mode") : 60108, $9aaf1809a83fe6d0$var$g = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.profiler") : 60114, $9aaf1809a83fe6d0$var$h = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.provider") : 60109, $9aaf1809a83fe6d0$var$k = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.context") : 60110, $9aaf1809a83fe6d0$var$l = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.async_mode") : 60111, $9aaf1809a83fe6d0$var$m = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.concurrent_mode") : 60111, $9aaf1809a83fe6d0$var$n = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.forward_ref") : 60112, $9aaf1809a83fe6d0$var$p = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.suspense") : 60113, $9aaf1809a83fe6d0$var$q = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.suspense_list") : 60120, $9aaf1809a83fe6d0$var$r = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.memo") : 60115, $9aaf1809a83fe6d0$var$t = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.lazy") : 60116, $9aaf1809a83fe6d0$var$v = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.block") : 60121, $9aaf1809a83fe6d0$var$w = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.fundamental") : 60117, $9aaf1809a83fe6d0$var$x = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.responder") : 60118, $9aaf1809a83fe6d0$var$y = $9aaf1809a83fe6d0$var$b ? Symbol.for("react.scope") : 60119;
function $9aaf1809a83fe6d0$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $9aaf1809a83fe6d0$var$c:
                switch(a = a.type, a){
                    case $9aaf1809a83fe6d0$var$l:
                    case $9aaf1809a83fe6d0$var$m:
                    case $9aaf1809a83fe6d0$var$e:
                    case $9aaf1809a83fe6d0$var$g:
                    case $9aaf1809a83fe6d0$var$f:
                    case $9aaf1809a83fe6d0$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $9aaf1809a83fe6d0$var$k:
                            case $9aaf1809a83fe6d0$var$n:
                            case $9aaf1809a83fe6d0$var$t:
                            case $9aaf1809a83fe6d0$var$r:
                            case $9aaf1809a83fe6d0$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $9aaf1809a83fe6d0$var$d:
                return u;
        }
    }
}
function $9aaf1809a83fe6d0$var$A(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$m;
}
$9aaf1809a83fe6d0$export$2b8d127b894957b9 = $9aaf1809a83fe6d0$var$l;
$9aaf1809a83fe6d0$export$cea3a54a6425200c = $9aaf1809a83fe6d0$var$m;
$9aaf1809a83fe6d0$export$a7c73072b1a182ae = $9aaf1809a83fe6d0$var$k;
$9aaf1809a83fe6d0$export$9f27bc3417b4524d = $9aaf1809a83fe6d0$var$h;
$9aaf1809a83fe6d0$export$db77ccec0bb4ccac = $9aaf1809a83fe6d0$var$c;
$9aaf1809a83fe6d0$export$8392c0c9d3dcbd35 = $9aaf1809a83fe6d0$var$n;
$9aaf1809a83fe6d0$export$ffb0004e005737fa = $9aaf1809a83fe6d0$var$e;
$9aaf1809a83fe6d0$export$b624eff549462981 = $9aaf1809a83fe6d0$var$t;
$9aaf1809a83fe6d0$export$7897aa7841a5380c = $9aaf1809a83fe6d0$var$r;
$9aaf1809a83fe6d0$export$602eac185826482c = $9aaf1809a83fe6d0$var$d;
$9aaf1809a83fe6d0$export$e2c29f18771995cb = $9aaf1809a83fe6d0$var$g;
$9aaf1809a83fe6d0$export$5f8d39834fd61797 = $9aaf1809a83fe6d0$var$f;
$9aaf1809a83fe6d0$export$74bf444e3cd11ea5 = $9aaf1809a83fe6d0$var$p;
$9aaf1809a83fe6d0$export$92387174baf9b227 = function(a) {
    return $9aaf1809a83fe6d0$var$A(a) || $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$l;
};
$9aaf1809a83fe6d0$export$ec112efeb987d9c6 = $9aaf1809a83fe6d0$var$A;
$9aaf1809a83fe6d0$export$b706b080d889d2c9 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$k;
};
$9aaf1809a83fe6d0$export$5be5a87408f70ddc = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$h;
};
$9aaf1809a83fe6d0$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $9aaf1809a83fe6d0$var$c;
};
$9aaf1809a83fe6d0$export$455c2e768291efa6 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$n;
};
$9aaf1809a83fe6d0$export$9522e17588c12572 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$e;
};
$9aaf1809a83fe6d0$export$2110ac352bb060b9 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$t;
};
$9aaf1809a83fe6d0$export$56885ab8b9c456ab = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$r;
};
$9aaf1809a83fe6d0$export$d927fcb6adf8f9de = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$d;
};
$9aaf1809a83fe6d0$export$b82d16f27459e05a = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$g;
};
$9aaf1809a83fe6d0$export$522c17b4f5e123e8 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$f;
};
$9aaf1809a83fe6d0$export$1aabd8a0274ecfd6 = function(a) {
    return $9aaf1809a83fe6d0$var$z(a) === $9aaf1809a83fe6d0$var$p;
};
$9aaf1809a83fe6d0$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $9aaf1809a83fe6d0$var$e || a === $9aaf1809a83fe6d0$var$m || a === $9aaf1809a83fe6d0$var$g || a === $9aaf1809a83fe6d0$var$f || a === $9aaf1809a83fe6d0$var$p || a === $9aaf1809a83fe6d0$var$q || "object" === typeof a && null !== a && (a.$$typeof === $9aaf1809a83fe6d0$var$t || a.$$typeof === $9aaf1809a83fe6d0$var$r || a.$$typeof === $9aaf1809a83fe6d0$var$h || a.$$typeof === $9aaf1809a83fe6d0$var$k || a.$$typeof === $9aaf1809a83fe6d0$var$n || a.$$typeof === $9aaf1809a83fe6d0$var$w || a.$$typeof === $9aaf1809a83fe6d0$var$x || a.$$typeof === $9aaf1809a83fe6d0$var$y || a.$$typeof === $9aaf1809a83fe6d0$var$v);
};
$9aaf1809a83fe6d0$export$f5bbd400c2f4426f = $9aaf1809a83fe6d0$var$z;

});

parcelRegister("dZnzp", function(module, exports) {

$parcel$export(module.exports, "observable", () => observable);
$parcel$export(module.exports, "isObservableObject", () => isObservableObject);
$parcel$export(module.exports, "isObservableArray", () => isObservableArray);
$parcel$export(module.exports, "isObservableMap", () => isObservableMap);
$parcel$export(module.exports, "computed", () => computed);
$parcel$export(module.exports, "_allowStateChanges", () => allowStateChanges);
$parcel$export(module.exports, "untracked", () => untracked);
$parcel$export(module.exports, "_getGlobalState", () => getGlobalState);
$parcel$export(module.exports, "getDependencyTree", () => getDependencyTree);
$parcel$export(module.exports, "Reaction", () => Reaction);
$parcel$export(module.exports, "reaction", () => reaction);
$parcel$export(module.exports, "configure", () => configure);
$parcel$export(module.exports, "toJS", () => toJS);
$parcel$export(module.exports, "makeObservable", () => makeObservable);
$parcel$export(module.exports, "runInAction", () => runInAction);
var niceErrors = {
    0: "Invalid value for configuration 'enforceActions', expected 'never', 'always' or 'observed'",
    1: function _(annotationType, key) {
        return "Cannot apply '" + annotationType + "' to '" + key.toString() + "': Field not found.";
    },
    /*
  2(prop) {
      return `invalid decorator for '${prop.toString()}'`
  },
  3(prop) {
      return `Cannot decorate '${prop.toString()}': action can only be used on properties with a function value.`
  },
  4(prop) {
      return `Cannot decorate '${prop.toString()}': computed can only be used on getter properties.`
  },
  */ 5: "'keys()' can only be used on observable objects, arrays, sets and maps",
    6: "'values()' can only be used on observable objects, arrays, sets and maps",
    7: "'entries()' can only be used on observable objects, arrays and maps",
    8: "'set()' can only be used on observable objects, arrays and maps",
    9: "'remove()' can only be used on observable objects, arrays and maps",
    10: "'has()' can only be used on observable objects, arrays and maps",
    11: "'get()' can only be used on observable objects, arrays and maps",
    12: "Invalid annotation",
    13: "Dynamic observable objects cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    14: "Intercept handlers should return nothing or a change object",
    15: "Observable arrays cannot be frozen. If you're passing observables to 3rd party component/function that calls Object.freeze, pass copy instead: toJS(observable)",
    16: "Modification exception: the internal structure of an observable array was changed.",
    17: function _(index, length) {
        return "[mobx.array] Index out of bounds, " + index + " is larger than " + length;
    },
    18: "mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js",
    19: function _(other) {
        return "Cannot initialize from classes that inherit from Map: " + other.constructor.name;
    },
    20: function _(other) {
        return "Cannot initialize map from " + other;
    },
    21: function _(dataStructure) {
        return "Cannot convert to map from '" + dataStructure + "'";
    },
    22: "mobx.set requires Set polyfill for the current browser. Check babel-polyfill or core-js/es6/set.js",
    23: "It is not possible to get index atoms from arrays",
    24: function _(thing) {
        return "Cannot obtain administration from " + thing;
    },
    25: function _(property, name) {
        return "the entry '" + property + "' does not exist in the observable map '" + name + "'";
    },
    26: "please specify a property",
    27: function _(property, name) {
        return "no observable property '" + property.toString() + "' found on the observable object '" + name + "'";
    },
    28: function _(thing) {
        return "Cannot obtain atom from " + thing;
    },
    29: "Expecting some object",
    30: "invalid action stack. did you forget to finish an action?",
    31: "missing option for computed: get",
    32: function _(name, derivation) {
        return "Cycle detected in computation " + name + ": " + derivation;
    },
    33: function _(name) {
        return "The setter of computed value '" + name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?";
    },
    34: function _(name) {
        return "[ComputedValue '" + name + "'] It is not possible to assign a new value to a computed value.";
    },
    35: "There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`",
    36: "isolateGlobalState should be called before MobX is running any reactions",
    37: function _(method) {
        return "[mobx] `observableArray." + method + "()` mutates the array in-place, which is not allowed inside a derivation. Use `array.slice()." + method + "()` instead";
    },
    38: "'ownKeys()' can only be used on observable objects",
    39: "'defineProperty()' can only be used on observable objects"
};
var errors = {};
function die(error) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var e;
    throw new Error(typeof error === "number" ? "[MobX] minified error nr: " + error + (args.length ? " " + args.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + error);
}
var mockGlobal = {};
function getGlobal() {
    if (typeof globalThis !== "undefined") return globalThis;
    if (typeof window !== "undefined") return window;
    if (typeof $parcel$global !== "undefined") return $parcel$global;
    if (typeof self !== "undefined") return self;
    return mockGlobal;
}
// We shorten anything used > 5 times
var assign = Object.assign;
var getDescriptor = Object.getOwnPropertyDescriptor;
var defineProperty = Object.defineProperty;
var objectPrototype = Object.prototype;
var EMPTY_ARRAY = [];
Object.freeze(EMPTY_ARRAY);
var EMPTY_OBJECT = {};
Object.freeze(EMPTY_OBJECT);
var hasProxy = typeof Proxy !== "undefined";
var plainObjectString = /*#__PURE__*/ Object.toString();
function assertProxies() {
    if (!hasProxy) die("Proxy not available");
}
function warnAboutProxyRequirement(msg) {}
function getNextId() {
    return ++globalState.mobxGuid;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */ function once(func) {
    var invoked = false;
    return function() {
        if (invoked) return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop = function noop() {};
function isFunction(fn) {
    return typeof fn === "function";
}
function isStringish(value) {
    var t = typeof value;
    switch(t){
        case "string":
        case "symbol":
        case "number":
            return true;
    }
    return false;
}
function isObject(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject(value) {
    if (!isObject(value)) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto == null) return true;
    var protoConstructor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof protoConstructor === "function" && protoConstructor.toString() === plainObjectString;
}
// https://stackoverflow.com/a/37865170
function isGenerator(obj) {
    var constructor = obj == null ? void 0 : obj.constructor;
    if (!constructor) return false;
    if ("GeneratorFunction" === constructor.name || "GeneratorFunction" === constructor.displayName) return true;
    return false;
}
function addHiddenProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp(object, propName, value) {
    defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function createInstanceofPredicate(name, theClass) {
    var propName = "isMobX" + name;
    theClass.prototype[propName] = true;
    return function(x) {
        return isObject(x) && x[propName] === true;
    };
}
/**
 * Yields true for both native and observable Map, even across different windows.
 */ function isES6Map(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Map]";
}
/**
 * Makes sure a Map is an instance of non-inherited native or observable Map.
 */ function isPlainES6Map(thing) {
    var mapProto = Object.getPrototypeOf(thing);
    var objectProto = Object.getPrototypeOf(mapProto);
    var nullProto = Object.getPrototypeOf(objectProto);
    return nullProto === null;
}
/**
 * Yields true for both native and observable Set, even across different windows.
 */ function isES6Set(thing) {
    return thing != null && Object.prototype.toString.call(thing) === "[object Set]";
}
var hasGetOwnPropertySymbols = typeof Object.getOwnPropertySymbols !== "undefined";
/**
 * Returns the following: own enumerable keys and symbols.
 */ function getPlainObjectKeys(object) {
    var keys = Object.keys(object);
    // Not supported in IE, so there are not going to be symbol props anyway...
    if (!hasGetOwnPropertySymbols) return keys;
    var symbols = Object.getOwnPropertySymbols(object);
    if (!symbols.length) return keys;
    return [].concat(keys, symbols.filter(function(s) {
        return objectPrototype.propertyIsEnumerable.call(object, s);
    }));
}
// From Immer utils
// Returns all own keys, including non-enumerable and symbolic
var ownKeys = typeof Reflect !== "undefined" && Reflect.ownKeys ? Reflect.ownKeys : hasGetOwnPropertySymbols ? function(obj) {
    return Object.getOwnPropertyNames(obj).concat(Object.getOwnPropertySymbols(obj));
} : /* istanbul ignore next */ Object.getOwnPropertyNames;
function stringifyKey(key) {
    if (typeof key === "string") return key;
    if (typeof key === "symbol") return key.toString();
    return new String(key).toString();
}
function toPrimitive(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}
function hasProp(target, prop) {
    return objectPrototype.hasOwnProperty.call(target, prop);
}
// From Immer utils
var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(target) {
    // Polyfill needed for Hermes and IE, see https://github.com/facebook/hermes/issues/274
    var res = {};
    // Note: without polyfill for ownKeys, symbols won't be picked up
    ownKeys(target).forEach(function(key) {
        res[key] = getDescriptor(target, key);
    });
    return res;
};
function getFlag(flags, mask) {
    return !!(flags & mask);
}
function setFlag(flags, mask, newValue) {
    if (newValue) flags |= mask;
    else flags &= ~mask;
    return flags;
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
var storedAnnotationsSymbol = /*#__PURE__*/ Symbol("mobx-stored-annotations");
/**
 * Creates a function that acts as
 * - decorator
 * - annotation object
 */ function createDecoratorAnnotation(annotation) {
    function decorator(target, property) {
        if (is20223Decorator(property)) return annotation.decorate_20223_(target, property);
        else storeAnnotation(target, property, annotation);
    }
    return Object.assign(decorator, annotation);
}
/**
 * Stores annotation to prototype,
 * so it can be inspected later by `makeObservable` called from constructor
 */ function storeAnnotation(prototype, key, annotation) {
    if (!hasProp(prototype, storedAnnotationsSymbol)) addHiddenProp(prototype, storedAnnotationsSymbol, _extends({}, prototype[storedAnnotationsSymbol]));
    var fieldName;
    // Cannot re-decorate
    assertNotDecorated(prototype, annotation, key);
    // Ignore override
    if (!isOverride(annotation)) prototype[storedAnnotationsSymbol][key] = annotation;
}
function assertNotDecorated(prototype, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
/**
 * Collects annotations from prototypes and stores them on target (instance)
 */ function collectStoredAnnotations(target) {
    if (!hasProp(target, storedAnnotationsSymbol)) // if (__DEV__ && !target[storedAnnotationsSymbol]) {
    //     die(
    //         `No annotations were passed to makeObservable, but no decorated members have been found either`
    //     )
    // }
    // We need a copy as we will remove annotation from the list once it's applied.
    addHiddenProp(target, storedAnnotationsSymbol, _extends({}, target[storedAnnotationsSymbol]));
    return target[storedAnnotationsSymbol];
}
function is20223Decorator(context) {
    return typeof context == "object" && typeof context["kind"] == "string";
}
function assert20223DecoratorType(context, types) {}
var $mobx = /*#__PURE__*/ Symbol("mobx administration");
var Atom = /*#__PURE__*/ function() {
    /**
   * Create a new atom. For debugging purposes it is recommended to give it a name.
   * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
   */ function Atom(name_) {
        if (name_ === void 0) name_ = "Atom";
        this.name_ = void 0;
        this.flags_ = 0;
        this.observers_ = new Set();
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.NOT_TRACKING_;
        // onBecomeObservedListeners
        this.onBOL = void 0;
        // onBecomeUnobservedListeners
        this.onBUOL = void 0;
        this.name_ = name_;
    }
    // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
    var _proto = Atom.prototype;
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.reportObserved = function reportObserved$1() {
        return reportObserved(this);
    };
    _proto.reportChanged = function reportChanged() {
        startBatch();
        propagateChanged(this);
        endBatch();
    };
    _proto.toString = function toString() {
        return this.name_;
    };
    return _createClass(Atom, [
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, Atom.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, Atom.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Atom.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Atom.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Atom.isBeingObservedMask_ = 1;
Atom.isPendingUnobservationMask_ = 2;
Atom.diffValueMask_ = 4;
var isAtom = /*#__PURE__*/ createInstanceofPredicate("Atom", Atom);
function createAtom(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) onBecomeObservedHandler = noop;
    if (onBecomeUnobservedHandler === void 0) onBecomeUnobservedHandler = noop;
    var atom = new Atom(name);
    // default `noop` listener will not initialize the hook Set
    if (onBecomeObservedHandler !== noop) onBecomeObserved(atom, onBecomeObservedHandler);
    if (onBecomeUnobservedHandler !== noop) onBecomeUnobserved(atom, onBecomeUnobservedHandler);
    return atom;
}
function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual(a, b);
}
function shallowComparer(a, b) {
    return deepEqual(a, b, 1);
}
function defaultComparer(a, b) {
    if (Object.is) return Object.is(a, b);
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
}
var comparer = {
    identity: identityComparer,
    structural: structuralComparer,
    "default": defaultComparer,
    shallow: shallowComparer
};
function deepEnhancer(v, _, name) {
    // it is an observable already, done
    if (isObservable(v)) return v;
    // something that can be converted and mutated?
    if (Array.isArray(v)) return observable.array(v, {
        name: name
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name
    });
    if (typeof v === "function" && !isAction(v) && !isFlow(v)) {
        if (isGenerator(v)) return flow(v);
        else return autoAction(name, v);
    }
    return v;
}
function shallowEnhancer(v, _, name) {
    if (v === undefined || v === null) return v;
    if (isObservableObject(v) || isObservableArray(v) || isObservableMap(v) || isObservableSet(v)) return v;
    if (Array.isArray(v)) return observable.array(v, {
        name: name,
        deep: false
    });
    if (isPlainObject(v)) return observable.object(v, undefined, {
        name: name,
        deep: false
    });
    if (isES6Map(v)) return observable.map(v, {
        name: name,
        deep: false
    });
    if (isES6Set(v)) return observable.set(v, {
        name: name,
        deep: false
    });
}
function referenceEnhancer(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer(v, oldValue) {
    if (deepEqual(v, oldValue)) return oldValue;
    return v;
}
var OVERRIDE = "override";
var override = /*#__PURE__*/ createDecoratorAnnotation({
    annotationType_: OVERRIDE,
    make_: make_,
    extend_: extend_,
    decorate_20223_: decorate_20223_
});
function isOverride(annotation) {
    return annotation.annotationType_ === OVERRIDE;
}
function make_(adm, key) {
    return 0 /* MakeResult.Cancel */ ;
}
function extend_(adm, key, descriptor, proxyTrap) {
    die("'" + this.annotationType_ + "' can only be used with 'makeObservable'");
}
function decorate_20223_(desc, context) {
    console.warn("'" + this.annotationType_ + "' cannot be used with decorators - this is a no-op");
}
function createActionAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$1,
        extend_: extend_$1,
        decorate_20223_: decorate_20223_$1
    };
}
function make_$1(adm, key, descriptor, source) {
    var _this$options_;
    // bound
    if ((_this$options_ = this.options_) != null && _this$options_.bound) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    if (isAction(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor, false);
    defineProperty(source, key, actionDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$1(adm, key, descriptor, proxyTrap) {
    var actionDescriptor = createActionDescriptor(adm, this, key, descriptor);
    return adm.defineProperty_(key, actionDescriptor, proxyTrap);
}
function decorate_20223_$1(mthd, context) {
    var kind = context.kind, name = context.name, addInitializer = context.addInitializer;
    var ann = this;
    var _createAction = function _createAction(m) {
        var _ann$options_$name, _ann$options_, _ann$options_$autoAct, _ann$options_2;
        return createAction((_ann$options_$name = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.name) != null ? _ann$options_$name : name.toString(), m, (_ann$options_$autoAct = (_ann$options_2 = ann.options_) == null ? void 0 : _ann$options_2.autoAction) != null ? _ann$options_$autoAct : false);
    };
    if (kind == "field") return function(initMthd) {
        var _ann$options_3;
        var mthd = initMthd;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_ann$options_3 = ann.options_) != null && _ann$options_3.bound) {
            mthd = mthd.bind(this);
            mthd.isMobxAction = true;
        }
        return mthd;
    };
    if (kind == "method") {
        var _this$options_2;
        if (!isAction(mthd)) mthd = _createAction(mthd);
        if ((_this$options_2 = this.options_) != null && _this$options_2.bound) addInitializer(function() {
            var self1 = this;
            var bound = self1[name].bind(self1);
            bound.isMobxAction = true;
            self1[name] = bound;
        });
        return mthd;
    }
    die("Cannot apply '" + ann.annotationType_ + "' to '" + String(name) + "' (kind: " + kind + "):" + ("\n'" + ann.annotationType_ + "' can only be used on properties with a function value."));
}
function assertActionDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createActionDescriptor(adm, annotation, key, descriptor, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    var _annotation$options_, _annotation$options_$, _annotation$options_2, _annotation$options_$2, _annotation$options_3, _annotation$options_4, _adm$proxy_2;
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertActionDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    if ((_annotation$options_ = annotation.options_) != null && _annotation$options_.bound) {
        var _adm$proxy_;
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return {
        value: createAction((_annotation$options_$ = (_annotation$options_2 = annotation.options_) == null ? void 0 : _annotation$options_2.name) != null ? _annotation$options_$ : key.toString(), value, (_annotation$options_$2 = (_annotation$options_3 = annotation.options_) == null ? void 0 : _annotation$options_3.autoAction) != null ? _annotation$options_$2 : false, // https://github.com/mobxjs/mobx/discussions/3140
        (_annotation$options_4 = annotation.options_) != null && _annotation$options_4.bound ? (_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_ : undefined),
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createFlowAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$2,
        extend_: extend_$2,
        decorate_20223_: decorate_20223_$2
    };
}
function make_$2(adm, key, descriptor, source) {
    var _this$options_;
    // own
    if (source === adm.target_) return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
    // prototype
    // bound - must annotate protos to support super.flow()
    if ((_this$options_ = this.options_) != null && _this$options_.bound && (!hasProp(adm.target_, key) || !isFlow(adm.target_[key]))) {
        if (this.extend_(adm, key, descriptor, false) === null) return 0 /* MakeResult.Cancel */ ;
    }
    if (isFlow(descriptor.value)) // A prototype could have been annotated already by other constructor,
    // rest of the proto chain must be annotated already
    return 1 /* MakeResult.Break */ ;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, false, false);
    defineProperty(source, key, flowDescriptor);
    return 2 /* MakeResult.Continue */ ;
}
function extend_$2(adm, key, descriptor, proxyTrap) {
    var _this$options_2;
    var flowDescriptor = createFlowDescriptor(adm, this, key, descriptor, (_this$options_2 = this.options_) == null ? void 0 : _this$options_2.bound);
    return adm.defineProperty_(key, flowDescriptor, proxyTrap);
}
function decorate_20223_$2(mthd, context) {
    var _this$options_3;
    var name = context.name, addInitializer = context.addInitializer;
    if (!isFlow(mthd)) mthd = flow(mthd);
    if ((_this$options_3 = this.options_) != null && _this$options_3.bound) addInitializer(function() {
        var self1 = this;
        var bound = self1[name].bind(self1);
        bound.isMobXFlow = true;
        self1[name] = bound;
    });
    return mthd;
}
function assertFlowDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var value = _ref2.value;
}
function createFlowDescriptor(adm, annotation, key, descriptor, bound, // provides ability to disable safeDescriptors for prototypes
safeDescriptors) {
    if (safeDescriptors === void 0) safeDescriptors = globalState.safeDescriptors;
    assertFlowDescriptor(adm, annotation, key, descriptor);
    var value = descriptor.value;
    // In case of flow.bound, the descriptor can be from already annotated prototype
    if (!isFlow(value)) value = flow(value);
    if (bound) {
        var _adm$proxy_;
        // We do not keep original function around, so we bind the existing flow
        value = value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
        // This is normally set by `flow`, but `bind` returns new function...
        value.isMobXFlow = true;
    }
    return {
        value: value,
        // Non-configurable for classes
        // prevents accidental field redefinition in subclass
        configurable: safeDescriptors ? adm.isPlainObject_ : true,
        // https://github.com/mobxjs/mobx/pull/2641#issuecomment-737292058
        enumerable: false,
        // Non-obsevable, therefore non-writable
        // Also prevents rewriting in subclass constructor
        writable: safeDescriptors ? false : true
    };
}
function createComputedAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$3,
        extend_: extend_$3,
        decorate_20223_: decorate_20223_$3
    };
}
function make_$3(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$3(adm, key, descriptor, proxyTrap) {
    assertComputedDescriptor(adm, this, key, descriptor);
    return adm.defineComputedProperty_(key, _extends({}, this.options_, {
        get: descriptor.get,
        set: descriptor.set
    }), proxyTrap);
}
function decorate_20223_$3(get, context) {
    var ann = this;
    var key = context.name, addInitializer = context.addInitializer;
    addInitializer(function() {
        var adm = asObservableObject(this)[$mobx];
        var options = _extends({}, ann.options_, {
            get: get,
            context: this
        });
        options.name || (options.name = "ObservableObject." + key.toString());
        adm.values_.set(key, new ComputedValue(options));
    });
    return function() {
        return this[$mobx].getObservablePropValue_(key);
    };
}
function assertComputedDescriptor(adm, _ref, key, _ref2) {
    var annotationType_ = _ref.annotationType_;
    var get = _ref2.get;
}
function createObservableAnnotation(name, options) {
    return {
        annotationType_: name,
        options_: options,
        make_: make_$4,
        extend_: extend_$4,
        decorate_20223_: decorate_20223_$4
    };
}
function make_$4(adm, key, descriptor) {
    return this.extend_(adm, key, descriptor, false) === null ? 0 /* MakeResult.Cancel */  : 1 /* MakeResult.Break */ ;
}
function extend_$4(adm, key, descriptor, proxyTrap) {
    var _this$options_$enhanc, _this$options_;
    assertObservableDescriptor(adm, this, key, descriptor);
    return adm.defineObservableProperty_(key, descriptor.value, (_this$options_$enhanc = (_this$options_ = this.options_) == null ? void 0 : _this$options_.enhancer) != null ? _this$options_$enhanc : deepEnhancer, proxyTrap);
}
function decorate_20223_$4(desc, context) {
    var ann = this;
    var kind = context.kind, name = context.name;
    // The laziness here is not ideal... It's a workaround to how 2022.3 Decorators are implemented:
    //   `addInitializer` callbacks are executed _before_ any accessors are defined (instead of the ideal-for-us right after each).
    //   This means that, if we were to do our stuff in an `addInitializer`, we'd attempt to read a private slot
    //   before it has been initialized. The runtime doesn't like that and throws a `Cannot read private member
    //   from an object whose class did not declare it` error.
    // TODO: it seems that this will not be required anymore in the final version of the spec
    // See TODO: link
    var initializedObjects = new WeakSet();
    function initializeObservable(target, value) {
        var _ann$options_$enhance, _ann$options_;
        var adm = asObservableObject(target)[$mobx];
        var observable = new ObservableValue(value, (_ann$options_$enhance = (_ann$options_ = ann.options_) == null ? void 0 : _ann$options_.enhancer) != null ? _ann$options_$enhance : deepEnhancer, "ObservableObject." + name.toString(), false);
        adm.values_.set(name, observable);
        initializedObjects.add(target);
    }
    if (kind == "accessor") return {
        get: function get() {
            if (!initializedObjects.has(this)) initializeObservable(this, desc.get.call(this));
            return this[$mobx].getObservablePropValue_(name);
        },
        set: function set(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return this[$mobx].setObservablePropValue_(name, value);
        },
        init: function init(value) {
            if (!initializedObjects.has(this)) initializeObservable(this, value);
            return value;
        }
    };
    return;
}
function assertObservableDescriptor(adm, _ref, key, descriptor) {
    var annotationType_ = _ref.annotationType_;
}
var AUTO = "true";
var autoAnnotation = /*#__PURE__*/ createAutoAnnotation();
function createAutoAnnotation(options) {
    return {
        annotationType_: AUTO,
        options_: options,
        make_: make_$5,
        extend_: extend_$5,
        decorate_20223_: decorate_20223_$5
    };
}
function make_$5(adm, key, descriptor, source) {
    var _this$options_3, _this$options_4;
    // getter -> computed
    if (descriptor.get) return computed.make_(adm, key, descriptor, source);
    // lone setter -> action setter
    if (descriptor.set) {
        // TODO make action applicable to setter and delegate to action.make_
        var set = createAction(key.toString(), descriptor.set);
        // own
        if (source === adm.target_) return adm.defineProperty_(key, {
            configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
            set: set
        }) === null ? 0 /* MakeResult.Cancel */  : 2 /* MakeResult.Continue */ ;
        // proto
        defineProperty(source, key, {
            configurable: true,
            set: set
        });
        return 2 /* MakeResult.Continue */ ;
    }
    // function on proto -> autoAction/flow
    if (source !== adm.target_ && typeof descriptor.value === "function") {
        var _this$options_2;
        if (isGenerator(descriptor.value)) {
            var _this$options_;
            var flowAnnotation = (_this$options_ = this.options_) != null && _this$options_.autoBind ? flow.bound : flow;
            return flowAnnotation.make_(adm, key, descriptor, source);
        }
        var actionAnnotation = (_this$options_2 = this.options_) != null && _this$options_2.autoBind ? autoAction.bound : autoAction;
        return actionAnnotation.make_(adm, key, descriptor, source);
    }
    // other -> observable
    // Copy props from proto as well, see test:
    // "decorate should work with Object.create"
    var observableAnnotation = ((_this$options_3 = this.options_) == null ? void 0 : _this$options_3.deep) === false ? observable.ref : observable;
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_4 = this.options_) != null && _this$options_4.autoBind) {
        var _adm$proxy_;
        descriptor.value = descriptor.value.bind((_adm$proxy_ = adm.proxy_) != null ? _adm$proxy_ : adm.target_);
    }
    return observableAnnotation.make_(adm, key, descriptor, source);
}
function extend_$5(adm, key, descriptor, proxyTrap) {
    var _this$options_5, _this$options_6;
    // getter -> computed
    if (descriptor.get) return computed.extend_(adm, key, descriptor, proxyTrap);
    // lone setter -> action setter
    if (descriptor.set) // TODO make action applicable to setter and delegate to action.extend_
    return adm.defineProperty_(key, {
        configurable: globalState.safeDescriptors ? adm.isPlainObject_ : true,
        set: createAction(key.toString(), descriptor.set)
    }, proxyTrap);
    // other -> observable
    // if function respect autoBind option
    if (typeof descriptor.value === "function" && (_this$options_5 = this.options_) != null && _this$options_5.autoBind) {
        var _adm$proxy_2;
        descriptor.value = descriptor.value.bind((_adm$proxy_2 = adm.proxy_) != null ? _adm$proxy_2 : adm.target_);
    }
    var observableAnnotation = ((_this$options_6 = this.options_) == null ? void 0 : _this$options_6.deep) === false ? observable.ref : observable;
    return observableAnnotation.extend_(adm, key, descriptor, proxyTrap);
}
function decorate_20223_$5(desc, context) {
    die("'" + this.annotationType_ + "' cannot be used as a decorator");
}
var OBSERVABLE = "observable";
var OBSERVABLE_REF = "observable.ref";
var OBSERVABLE_SHALLOW = "observable.shallow";
var OBSERVABLE_STRUCT = "observable.struct";
// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions);
function asCreateObservableOptions(thing) {
    return thing || defaultCreateObservableOptions;
}
var observableAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE);
var observableRefAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_REF, {
    enhancer: referenceEnhancer
});
var observableShallowAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_SHALLOW, {
    enhancer: shallowEnhancer
});
var observableStructAnnotation = /*#__PURE__*/ createObservableAnnotation(OBSERVABLE_STRUCT, {
    enhancer: refStructEnhancer
});
var observableDecoratorAnnotation = /*#__PURE__*/ createDecoratorAnnotation(observableAnnotation);
function getEnhancerFromOptions(options) {
    return options.deep === true ? deepEnhancer : options.deep === false ? referenceEnhancer : getEnhancerFromAnnotation(options.defaultDecorator);
}
function getAnnotationFromOptions(options) {
    var _options$defaultDecor;
    return options ? (_options$defaultDecor = options.defaultDecorator) != null ? _options$defaultDecor : createAutoAnnotation(options) : undefined;
}
function getEnhancerFromAnnotation(annotation) {
    var _annotation$options_$, _annotation$options_;
    return !annotation ? deepEnhancer : (_annotation$options_$ = (_annotation$options_ = annotation.options_) == null ? void 0 : _annotation$options_.enhancer) != null ? _annotation$options_$ : deepEnhancer;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */ function createObservable(v, arg2, arg3) {
    // @observable someProp; (2022.3 Decorators)
    if (is20223Decorator(arg2)) return observableAnnotation.decorate_20223_(v, arg2);
    // @observable someProp;
    if (isStringish(arg2)) {
        storeAnnotation(v, arg2, observableAnnotation);
        return;
    }
    // already observable - ignore
    if (isObservable(v)) return v;
    // plain object
    if (isPlainObject(v)) return observable.object(v, arg2, arg3);
    // Array
    if (Array.isArray(v)) return observable.array(v, arg2);
    // Map
    if (isES6Map(v)) return observable.map(v, arg2);
    // Set
    if (isES6Set(v)) return observable.set(v, arg2);
    // other object - ignore
    if (typeof v === "object" && v !== null) return v;
    // anything else
    return observable.box(v, arg2);
}
assign(createObservable, observableDecoratorAnnotation);
var observableFactories = {
    box: function box(value, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableValue(value, getEnhancerFromOptions(o), o.name, true, o.equals);
    },
    array: function array(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return (globalState.useProxies === false || o.proxy === false ? createLegacyArray : createObservableArray)(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function map(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableMap(initialValues, getEnhancerFromOptions(o), o.name);
    },
    set: function set(initialValues, options) {
        var o = asCreateObservableOptions(options);
        return new ObservableSet(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function object(props, decorators, options) {
        return initObservable(function() {
            return extendObservable(globalState.useProxies === false || (options == null ? void 0 : options.proxy) === false ? asObservableObject({}, options) : asDynamicObservableObject({}, options), props, decorators);
        });
    },
    ref: /*#__PURE__*/ createDecoratorAnnotation(observableRefAnnotation),
    shallow: /*#__PURE__*/ createDecoratorAnnotation(observableShallowAnnotation),
    deep: observableDecoratorAnnotation,
    struct: /*#__PURE__*/ createDecoratorAnnotation(observableStructAnnotation)
};
// eslint-disable-next-line
var observable = /*#__PURE__*/ assign(createObservable, observableFactories);
var COMPUTED = "computed";
var COMPUTED_STRUCT = "computed.struct";
var computedAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED);
var computedStructAnnotation = /*#__PURE__*/ createComputedAnnotation(COMPUTED_STRUCT, {
    equals: comparer.structural
});
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */ var computed = function computed(arg1, arg2) {
    if (is20223Decorator(arg2)) // @computed (2022.3 Decorators)
    return computedAnnotation.decorate_20223_(arg1, arg2);
    if (isStringish(arg2)) // @computed
    return storeAnnotation(arg1, arg2, computedAnnotation);
    if (isPlainObject(arg1)) // @computed({ options })
    return createDecoratorAnnotation(createComputedAnnotation(COMPUTED, arg1));
    var opts = isPlainObject(arg2) ? arg2 : {};
    opts.get = arg1;
    opts.name || (opts.name = arg1.name || ""); /* for generated name */ 
    return new ComputedValue(opts);
};
Object.assign(computed, computedAnnotation);
computed.struct = /*#__PURE__*/ createDecoratorAnnotation(computedStructAnnotation);
var _getDescriptor$config, _getDescriptor;
// we don't use globalState for these in order to avoid possible issues with multiple
// mobx versions
var currentActionId = 0;
var nextActionId = 1;
var isFunctionNameConfigurable = (_getDescriptor$config = (_getDescriptor = /*#__PURE__*/ getDescriptor(function() {}, "name")) == null ? void 0 : _getDescriptor.configurable) != null ? _getDescriptor$config : false;
// we can safely recycle this object
var tmpNameDescriptor = {
    value: "action",
    configurable: true,
    writable: false,
    enumerable: false
};
function createAction(actionName, fn, autoAction, ref) {
    if (autoAction === void 0) autoAction = false;
    function res() {
        return executeAction(actionName, autoAction, fn, ref || this, arguments);
    }
    res.isMobxAction = true;
    res.toString = function() {
        return fn.toString();
    };
    if (isFunctionNameConfigurable) {
        tmpNameDescriptor.value = actionName;
        defineProperty(res, "name", tmpNameDescriptor);
    }
    return res;
}
function executeAction(actionName, canRunAsDerivation, fn, scope, args) {
    var runInfo = _startAction(actionName, canRunAsDerivation, scope, args);
    try {
        return fn.apply(scope, args);
    } catch (err) {
        runInfo.error_ = err;
        throw err;
    } finally{
        _endAction(runInfo);
    }
}
function _startAction(actionName, canRunAsDerivation, // true for autoAction
scope, args) {
    var notifySpy_ = false;
    var startTime_ = 0;
    var flattenedArgs;
    var prevDerivation_ = globalState.trackingDerivation;
    var runAsAction = !canRunAsDerivation || !prevDerivation_;
    startBatch();
    var prevAllowStateChanges_ = globalState.allowStateChanges; // by default preserve previous allow
    if (runAsAction) {
        untrackedStart();
        prevAllowStateChanges_ = allowStateChangesStart(true);
    }
    var prevAllowStateReads_ = allowStateReadsStart(true);
    var runInfo = {
        runAsAction_: runAsAction,
        prevDerivation_: prevDerivation_,
        prevAllowStateChanges_: prevAllowStateChanges_,
        prevAllowStateReads_: prevAllowStateReads_,
        notifySpy_: notifySpy_,
        startTime_: startTime_,
        actionId_: nextActionId++,
        parentActionId_: currentActionId
    };
    currentActionId = runInfo.actionId_;
    return runInfo;
}
function _endAction(runInfo) {
    if (currentActionId !== runInfo.actionId_) die(30);
    currentActionId = runInfo.parentActionId_;
    if (runInfo.error_ !== undefined) globalState.suppressReactionErrors = true;
    allowStateChangesEnd(runInfo.prevAllowStateChanges_);
    allowStateReadsEnd(runInfo.prevAllowStateReads_);
    endBatch();
    if (runInfo.runAsAction_) untrackedEnd(runInfo.prevDerivation_);
    globalState.suppressReactionErrors = false;
}
function allowStateChanges(allowStateChanges, func) {
    var prev = allowStateChangesStart(allowStateChanges);
    try {
        return func();
    } finally{
        allowStateChangesEnd(prev);
    }
}
function allowStateChangesStart(allowStateChanges) {
    var prev = globalState.allowStateChanges;
    globalState.allowStateChanges = allowStateChanges;
    return prev;
}
function allowStateChangesEnd(prev) {
    globalState.allowStateChanges = prev;
}
var CREATE = "create";
var ObservableValue = /*#__PURE__*/ function(_Atom) {
    function ObservableValue(value, enhancer, name_, notifySpy, equals) {
        var _this;
        if (name_ === void 0) name_ = "ObservableValue";
        if (notifySpy === void 0) notifySpy = true;
        if (equals === void 0) equals = comparer["default"];
        _this = _Atom.call(this, name_) || this;
        _this.enhancer = void 0;
        _this.name_ = void 0;
        _this.equals = void 0;
        _this.hasUnreportedChange_ = false;
        _this.interceptors_ = void 0;
        _this.changeListeners_ = void 0;
        _this.value_ = void 0;
        _this.dehancer = void 0;
        _this.enhancer = enhancer;
        _this.name_ = name_;
        _this.equals = equals;
        _this.value_ = enhancer(value, undefined, name_);
        return _this;
    }
    _inheritsLoose(ObservableValue, _Atom);
    var _proto = ObservableValue.prototype;
    _proto.dehanceValue = function dehanceValue(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.set = function set(newValue) {
        var oldValue = this.value_;
        newValue = this.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            this.setNewValue_(newValue);
        }
    };
    _proto.prepareNewValue_ = function prepareNewValue_(newValue) {
        checkIfStateModificationsAreAllowed(this);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this,
                type: UPDATE,
                newValue: newValue
            });
            if (!change) return globalState.UNCHANGED;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value_, this.name_);
        return this.equals(this.value_, newValue) ? globalState.UNCHANGED : newValue;
    };
    _proto.setNewValue_ = function setNewValue_(newValue) {
        var oldValue = this.value_;
        this.value_ = newValue;
        this.reportChanged();
        if (hasListeners(this)) notifyListeners(this, {
            type: UPDATE,
            object: this,
            newValue: newValue,
            oldValue: oldValue
        });
    };
    _proto.get = function get() {
        this.reportObserved();
        return this.dehanceValue(this.value_);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately) listener({
            observableKind: "value",
            debugObjectName: this.name_,
            object: this,
            type: UPDATE,
            newValue: this.value_,
            oldValue: undefined
        });
        return registerListener(this, listener);
    };
    _proto.raw = function raw() {
        // used by MST ot get undehanced value
        return this.value_;
    };
    _proto.toJSON = function toJSON() {
        return this.get();
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.value_ + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return ObservableValue;
}(Atom);
var isObservableValue = /*#__PURE__*/ createInstanceofPredicate("ObservableValue", ObservableValue);
/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */ var ComputedValue = /*#__PURE__*/ function() {
    /**
   * Create a new computed value based on a function expression.
   *
   * The `name` property is for debug purposes only.
   *
   * The `equals` property specifies the comparer function to use to determine if a newly produced
   * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
   * compares based on identity comparison (===), and `structuralComparer` deeply compares the structure.
   * Structural comparison can be convenient if you always produce a new aggregated object and
   * don't want to notify observers if it is structurally the same.
   * This is useful for working with vectors, mouse coordinates etc.
   */ function ComputedValue(options) {
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = null;
        // during tracking it's an array with new observed observers
        this.observers_ = new Set();
        this.runId_ = 0;
        this.lastAccessedBy_ = 0;
        this.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
        this.unboundDepsCount_ = 0;
        this.value_ = new CaughtException(null);
        this.name_ = void 0;
        this.triggeredBy_ = void 0;
        this.flags_ = 0;
        this.derivation = void 0;
        // N.B: unminified as it is used by MST
        this.setter_ = void 0;
        this.isTracing_ = TraceMode.NONE;
        this.scope_ = void 0;
        this.equals_ = void 0;
        this.requiresReaction_ = void 0;
        this.keepAlive_ = void 0;
        this.onBOL = void 0;
        this.onBUOL = void 0;
        if (!options.get) die(31);
        this.derivation = options.get;
        this.name_ = options.name || "ComputedValue";
        if (options.set) this.setter_ = createAction("ComputedValue-setter", options.set);
        this.equals_ = options.equals || (options.compareStructural || options.struct ? comparer.structural : comparer["default"]);
        this.scope_ = options.context;
        this.requiresReaction_ = options.requiresReaction;
        this.keepAlive_ = !!options.keepAlive;
    }
    var _proto = ComputedValue.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        propagateMaybeChanged(this);
    };
    _proto.onBO = function onBO() {
        if (this.onBOL) this.onBOL.forEach(function(listener) {
            return listener();
        });
    };
    _proto.onBUO = function onBUO() {
        if (this.onBUOL) this.onBUOL.forEach(function(listener) {
            return listener();
        });
    };
    /**
   * Returns the current value of this computed value.
   * Will evaluate its computation first if needed.
   */ _proto.get = function get() {
        if (this.isComputing) die(32, this.name_, this.derivation);
        if (globalState.inBatch === 0 && // !globalState.trackingDerivatpion &&
        this.observers_.size === 0 && !this.keepAlive_) {
            if (shouldCompute(this)) {
                this.warnAboutUntrackedRead_();
                startBatch(); // See perf test 'computed memoization'
                this.value_ = this.computeValue_(false);
                endBatch();
            }
        } else {
            reportObserved(this);
            if (shouldCompute(this)) {
                var prevTrackingContext = globalState.trackingContext;
                if (this.keepAlive_ && !prevTrackingContext) globalState.trackingContext = this;
                if (this.trackAndCompute()) propagateChangeConfirmed(this);
                globalState.trackingContext = prevTrackingContext;
            }
        }
        var result = this.value_;
        if (isCaughtException(result)) throw result.cause;
        return result;
    };
    _proto.set = function set(value) {
        if (this.setter_) {
            if (this.isRunningSetter) die(33, this.name_);
            this.isRunningSetter = true;
            try {
                this.setter_.call(this.scope_, value);
            } finally{
                this.isRunningSetter = false;
            }
        } else die(34, this.name_);
    };
    _proto.trackAndCompute = function trackAndCompute() {
        // N.B: unminified as it is used by MST
        var oldValue = this.value_;
        var wasSuspended = /* see #1208 */ this.dependenciesState_ === IDerivationState_.NOT_TRACKING_;
        var newValue = this.computeValue_(true);
        var changed = wasSuspended || isCaughtException(oldValue) || isCaughtException(newValue) || !this.equals_(oldValue, newValue);
        if (changed) this.value_ = newValue;
        return changed;
    };
    _proto.computeValue_ = function computeValue_(track) {
        this.isComputing = true;
        // don't allow state changes during computation
        var prev = allowStateChangesStart(false);
        var res;
        if (track) res = trackDerivedFunction(this, this.derivation, this.scope_);
        else {
            if (globalState.disableErrorBoundaries === true) res = this.derivation.call(this.scope_);
            else try {
                res = this.derivation.call(this.scope_);
            } catch (e) {
                res = new CaughtException(e);
            }
        }
        allowStateChangesEnd(prev);
        this.isComputing = false;
        return res;
    };
    _proto.suspend_ = function suspend_() {
        if (!this.keepAlive_) {
            clearObserving(this);
            this.value_ = undefined; // don't hold on to computed value!
        }
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun(function() {
            // TODO: why is this in a different place than the spyReport() function? in all other observables it's called in the same place
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart();
                listener({
                    observableKind: "computed",
                    debugObjectName: _this.name_,
                    type: UPDATE,
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    _proto.warnAboutUntrackedRead_ = function warnAboutUntrackedRead_() {
        return;
    };
    _proto.toString = function toString() {
        return this.name_ + "[" + this.derivation.toString() + "]";
    };
    _proto.valueOf = function valueOf() {
        return toPrimitive(this.get());
    };
    _proto[Symbol.toPrimitive] = function() {
        return this.valueOf();
    };
    return _createClass(ComputedValue, [
        {
            key: "isComputing",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isComputingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isComputingMask_, newValue);
            }
        },
        {
            key: "isRunningSetter",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isRunningSetterMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isRunningSetterMask_, newValue);
            }
        },
        {
            key: "isBeingObserved",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isBeingObservedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isBeingObservedMask_, newValue);
            }
        },
        {
            key: "isPendingUnobservation",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.isPendingUnobservationMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.isPendingUnobservationMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, ComputedValue.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, ComputedValue.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
ComputedValue.isComputingMask_ = 1;
ComputedValue.isRunningSetterMask_ = 2;
ComputedValue.isBeingObservedMask_ = 4;
ComputedValue.isPendingUnobservationMask_ = 8;
ComputedValue.diffValueMask_ = 16;
var isComputedValue = /*#__PURE__*/ createInstanceofPredicate("ComputedValue", ComputedValue);
var IDerivationState_;
(function(IDerivationState_) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState_[IDerivationState_["NOT_TRACKING_"] = -1] = "NOT_TRACKING_";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState_[IDerivationState_["UP_TO_DATE_"] = 0] = "UP_TO_DATE_";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState_[IDerivationState_["POSSIBLY_STALE_"] = 1] = "POSSIBLY_STALE_";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState_[IDerivationState_["STALE_"] = 2] = "STALE_";
})(IDerivationState_ || (IDerivationState_ = {}));
var TraceMode;
(function(TraceMode) {
    TraceMode[TraceMode["NONE"] = 0] = "NONE";
    TraceMode[TraceMode["LOG"] = 1] = "LOG";
    TraceMode[TraceMode["BREAK"] = 2] = "BREAK";
})(TraceMode || (TraceMode = {}));
var CaughtException = function CaughtException(cause) {
    this.cause = void 0;
    this.cause = cause;
// Empty
};
function isCaughtException(e) {
    return e instanceof CaughtException;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */ function shouldCompute(derivation) {
    switch(derivation.dependenciesState_){
        case IDerivationState_.UP_TO_DATE_:
            return false;
        case IDerivationState_.NOT_TRACKING_:
        case IDerivationState_.STALE_:
            return true;
        case IDerivationState_.POSSIBLY_STALE_:
            // state propagation can occur outside of action/reactive context #2195
            var prevAllowStateReads = allowStateReadsStart(true);
            var prevUntracked = untrackedStart(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing_, l = obs.length;
            for(var i = 0; i < l; i++){
                var obj = obs[i];
                if (isComputedValue(obj)) {
                    if (globalState.disableErrorBoundaries) obj.get();
                    else try {
                        obj.get();
                    } catch (e) {
                        // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState_ === IDerivationState_.STALE_) {
                        untrackedEnd(prevUntracked);
                        allowStateReadsEnd(prevAllowStateReads);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0(derivation);
            untrackedEnd(prevUntracked);
            allowStateReadsEnd(prevAllowStateReads);
            return false;
    }
}
function isComputingDerivation() {
    return globalState.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed(atom) {
    var hasObservers;
    return;
}
function checkIfStateReadsAreAllowed(observable) {}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */ function trackDerivedFunction(derivation, f, context) {
    var prevAllowStateReads = allowStateReadsStart(true);
    changeDependenciesStateTo0(derivation);
    // Preallocate array; will be trimmed by bindDependencies.
    derivation.newObserving_ = new Array(// Reserve constant space for initial dependencies, dynamic space otherwise.
    // See https://github.com/mobxjs/mobx/pull/3833
    derivation.runId_ === 0 ? 100 : derivation.observing_.length);
    derivation.unboundDepsCount_ = 0;
    derivation.runId_ = ++globalState.runId;
    var prevTracking = globalState.trackingDerivation;
    globalState.trackingDerivation = derivation;
    globalState.inBatch++;
    var result;
    if (globalState.disableErrorBoundaries === true) result = f.call(context);
    else try {
        result = f.call(context);
    } catch (e) {
        result = new CaughtException(e);
    }
    globalState.inBatch--;
    globalState.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    warnAboutDerivationWithoutDependencies(derivation);
    allowStateReadsEnd(prevAllowStateReads);
    return result;
}
function warnAboutDerivationWithoutDependencies(derivation) {
    return;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */ function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing_;
    var observing = derivation.observing_ = derivation.newObserving_;
    var lowestNewObservingDerivationState = IDerivationState_.UP_TO_DATE_;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount_;
    for(var i = 0; i < l; i++){
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i) observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState_ > lowestNewObservingDerivationState) lowestNewObservingDerivationState = dep.dependenciesState_;
    }
    observing.length = i0;
    derivation.newObserving_ = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while(l--){
        var _dep = prevObserving[l];
        if (_dep.diffValue === 0) removeObserver(_dep, derivation);
        _dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while(i0--){
        var _dep2 = observing[i0];
        if (_dep2.diffValue === 1) {
            _dep2.diffValue = 0;
            addObserver(_dep2, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState_.UP_TO_DATE_) {
        derivation.dependenciesState_ = lowestNewObservingDerivationState;
        derivation.onBecomeStale_();
    }
}
function clearObserving(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing_;
    derivation.observing_ = [];
    var i = obs.length;
    while(i--)removeObserver(obs[i], derivation);
    derivation.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
}
function untracked(action) {
    var prev = untrackedStart();
    try {
        return action();
    } finally{
        untrackedEnd(prev);
    }
}
function untrackedStart() {
    var prev = globalState.trackingDerivation;
    globalState.trackingDerivation = null;
    return prev;
}
function untrackedEnd(prev) {
    globalState.trackingDerivation = prev;
}
function allowStateReadsStart(allowStateReads) {
    var prev = globalState.allowStateReads;
    globalState.allowStateReads = allowStateReads;
    return prev;
}
function allowStateReadsEnd(prev) {
    globalState.allowStateReads = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */ function changeDependenciesStateTo0(derivation) {
    if (derivation.dependenciesState_ === IDerivationState_.UP_TO_DATE_) return;
    derivation.dependenciesState_ = IDerivationState_.UP_TO_DATE_;
    var obs = derivation.observing_;
    var i = obs.length;
    while(i--)obs[i].lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
}
/**
 * These values will persist if global state is reset
 */ var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "reactionRequiresObservable",
    "observableRequiresReaction",
    "allowStateReads",
    "disableErrorBoundaries",
    "runId",
    "UNCHANGED",
    "useProxies"
];
var MobXGlobals = function MobXGlobals() {
    /**
   * MobXGlobals version.
   * MobX compatiblity with other versions loaded in memory as long as this version matches.
   * It indicates that the global state still stores similar information
   *
   * N.B: this version is unrelated to the package version of MobX, and is only the version of the
   * internal state storage of MobX, and can be the same across many different package versions
   */ this.version = 6;
    /**
   * globally unique token to signal unchanged
   */ this.UNCHANGED = {};
    /**
   * Currently running derivation
   */ this.trackingDerivation = null;
    /**
   * Currently running reaction. This determines if we currently have a reactive context.
   * (Tracking derivation is also set for temporal tracking of computed values inside actions,
   * but trackingReaction can only be set by a form of Reaction)
   */ this.trackingContext = null;
    /**
   * Each time a derivation is tracked, it is assigned a unique run-id
   */ this.runId = 0;
    /**
   * 'guid' for general purpose. Will be persisted amongst resets.
   */ this.mobxGuid = 0;
    /**
   * Are we in a batch block? (and how many of them)
   */ this.inBatch = 0;
    /**
   * Observables that don't have observers anymore, and are about to be
   * suspended, unless somebody else accesses it in the same batch
   *
   * @type {IObservable[]}
   */ this.pendingUnobservations = [];
    /**
   * List of scheduled, not yet executed, reactions.
   */ this.pendingReactions = [];
    /**
   * Are we currently processing reactions?
   */ this.isRunningReactions = false;
    /**
   * Is it allowed to change observables at this point?
   * In general, MobX doesn't allow that when running computations and React.render.
   * To ensure that those functions stay pure.
   */ this.allowStateChanges = false;
    /**
   * Is it allowed to read observables at this point?
   * Used to hold the state needed for `observableRequiresReaction`
   */ this.allowStateReads = true;
    /**
   * If strict mode is enabled, state changes are by default not allowed
   */ this.enforceActions = true;
    /**
   * Spy callbacks
   */ this.spyListeners = [];
    /**
   * Globally attached error handlers that react specifically to errors in reactions
   */ this.globalReactionErrorHandlers = [];
    /**
   * Warn if computed values are accessed outside a reactive context
   */ this.computedRequiresReaction = false;
    /**
   * (Experimental)
   * Warn if you try to create to derivation / reactive context without accessing any observable.
   */ this.reactionRequiresObservable = false;
    /**
   * (Experimental)
   * Warn if observables are accessed outside a reactive context
   */ this.observableRequiresReaction = false;
    /*
   * Don't catch and rethrow exceptions. This is useful for inspecting the state of
   * the stack when an exception occurs while debugging.
   */ this.disableErrorBoundaries = false;
    /*
   * If true, we are already handling an exception in an action. Any errors in reactions should be suppressed, as
   * they are not the cause, see: https://github.com/mobxjs/mobx/issues/1836
   */ this.suppressReactionErrors = false;
    this.useProxies = true;
    /*
   * print warnings about code that would fail if proxies weren't available
   */ this.verifyProxies = false;
    /**
   * False forces all object's descriptors to
   * writable: true
   * configurable: true
   */ this.safeDescriptors = true;
};
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState = /*#__PURE__*/ function() {
    var global1 = /*#__PURE__*/ getGlobal();
    if (global1.__mobxInstanceCount > 0 && !global1.__mobxGlobals) canMergeGlobalState = false;
    if (global1.__mobxGlobals && global1.__mobxGlobals.version !== new MobXGlobals().version) canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        // Because this is a IIFE we need to let isolateCalled a chance to change
        // so we run it after the event loop completed at least 1 iteration
        setTimeout(function() {
            if (!isolateCalled) die(35);
        }, 1);
        return new MobXGlobals();
    } else if (global1.__mobxGlobals) {
        global1.__mobxInstanceCount += 1;
        if (!global1.__mobxGlobals.UNCHANGED) global1.__mobxGlobals.UNCHANGED = {};
         // make merge backward compatible
        return global1.__mobxGlobals;
    } else {
        global1.__mobxInstanceCount = 1;
        return global1.__mobxGlobals = /*#__PURE__*/ new MobXGlobals();
    }
}();
function isolateGlobalState() {
    if (globalState.pendingReactions.length || globalState.inBatch || globalState.isRunningReactions) die(36);
    isolateCalled = true;
    if (canMergeGlobalState) {
        var global1 = getGlobal();
        if (--global1.__mobxInstanceCount === 0) global1.__mobxGlobals = undefined;
        globalState = new MobXGlobals();
    }
}
function getGlobalState() {
    return globalState;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */ function resetGlobalState() {
    var defaultGlobals = new MobXGlobals();
    for(var key in defaultGlobals)if (persistentKeys.indexOf(key) === -1) globalState[key] = defaultGlobals[key];
    globalState.allowStateChanges = !globalState.enforceActions;
}
function hasObservers(observable) {
    return observable.observers_ && observable.observers_.size > 0;
}
function getObservers(observable) {
    return observable.observers_;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver(observable, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable.observers_.add(node);
    if (observable.lowestObserverState_ > node.dependenciesState_) observable.lowestObserverState_ = node.dependenciesState_;
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver(observable, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable.observers_["delete"](node);
    if (observable.observers_.size === 0) // deleting last observer
    queueForUnobservation(observable);
// invariantObservers(observable);
// invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation(observable) {
    if (observable.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable.isPendingUnobservation = true;
        globalState.pendingUnobservations.push(observable);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */ function startBatch() {
    globalState.inBatch++;
}
function endBatch() {
    if (--globalState.inBatch === 0) {
        runReactions();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState.pendingUnobservations;
        for(var i = 0; i < list.length; i++){
            var observable = list[i];
            observable.isPendingUnobservation = false;
            if (observable.observers_.size === 0) {
                if (observable.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable.isBeingObserved = false;
                    observable.onBUO();
                }
                if (observable instanceof ComputedValue) // computed values are automatically teared down when the last observer leaves
                // this process happens recursively, this computed might be the last observabe of another, etc..
                observable.suspend_();
            }
        }
        globalState.pendingUnobservations = [];
    }
}
function reportObserved(observable) {
    checkIfStateReadsAreAllowed(observable);
    var derivation = globalState.trackingDerivation;
    if (derivation !== null) {
        /**
     * Simple optimization, give each derivation run an unique id (runId)
     * Check if last time this observable was accessed the same runId is used
     * if this is the case, the relation is already known
     */ if (derivation.runId_ !== observable.lastAccessedBy_) {
            observable.lastAccessedBy_ = derivation.runId_;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving_[derivation.unboundDepsCount_++] = observable;
            if (!observable.isBeingObserved && globalState.trackingContext) {
                observable.isBeingObserved = true;
                observable.onBO();
            }
        }
        return observable.isBeingObserved;
    } else if (observable.observers_.size === 0 && globalState.inBatch > 0) queueForUnobservation(observable);
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */ // Called by Atom when its value changes
function propagateChanged(observable) {
    // invariantLOS(observable, "changed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) d.onBecomeStale_();
        d.dependenciesState_ = IDerivationState_.STALE_;
    });
// invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed(observable) {
    // invariantLOS(observable, "confirmed start");
    if (observable.lowestObserverState_ === IDerivationState_.STALE_) return;
    observable.lowestObserverState_ = IDerivationState_.STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.POSSIBLY_STALE_) d.dependenciesState_ = IDerivationState_.STALE_;
        else if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_ // this happens during computing of `d`, just keep lowestObserverState up to date.
        ) observable.lowestObserverState_ = IDerivationState_.UP_TO_DATE_;
    });
// invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged(observable) {
    // invariantLOS(observable, "maybe start");
    if (observable.lowestObserverState_ !== IDerivationState_.UP_TO_DATE_) return;
    observable.lowestObserverState_ = IDerivationState_.POSSIBLY_STALE_;
    observable.observers_.forEach(function(d) {
        if (d.dependenciesState_ === IDerivationState_.UP_TO_DATE_) {
            d.dependenciesState_ = IDerivationState_.POSSIBLY_STALE_;
            d.onBecomeStale_();
        }
    });
// invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable) {
    console.log("[mobx.trace] '" + derivation.name_ + "' is invalidated due to a change in: '" + observable.name_ + "'");
    if (derivation.isTracing_ === TraceMode.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name_ + "'\n\nYou are entering this break point because derivation '" + derivation.name_ + "' is being traced and '" + observable.name_ + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue ? derivation.derivation.toString().replace(/[*]\//g, "/") : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + "\t".repeat(depth - 1) + tree.name);
    if (tree.dependencies) tree.dependencies.forEach(function(child) {
        return printDepTree(child, lines, depth + 1);
    });
}
var Reaction = /*#__PURE__*/ function() {
    function Reaction(name_, onInvalidate_, errorHandler_, requiresObservable_) {
        if (name_ === void 0) name_ = "Reaction";
        this.name_ = void 0;
        this.onInvalidate_ = void 0;
        this.errorHandler_ = void 0;
        this.requiresObservable_ = void 0;
        this.observing_ = [];
        // nodes we are looking at. Our value depends on these nodes
        this.newObserving_ = [];
        this.dependenciesState_ = IDerivationState_.NOT_TRACKING_;
        this.runId_ = 0;
        this.unboundDepsCount_ = 0;
        this.flags_ = 0;
        this.isTracing_ = TraceMode.NONE;
        this.name_ = name_;
        this.onInvalidate_ = onInvalidate_;
        this.errorHandler_ = errorHandler_;
        this.requiresObservable_ = requiresObservable_;
    }
    var _proto = Reaction.prototype;
    _proto.onBecomeStale_ = function onBecomeStale_() {
        this.schedule_();
    };
    _proto.schedule_ = function schedule_() {
        if (!this.isScheduled) {
            this.isScheduled = true;
            globalState.pendingReactions.push(this);
            runReactions();
        }
    };
    _proto.runReaction_ = function runReaction_() {
        if (!this.isDisposed) {
            startBatch();
            this.isScheduled = false;
            var prev = globalState.trackingContext;
            globalState.trackingContext = this;
            if (shouldCompute(this)) {
                this.isTrackPending = true;
                try {
                    this.onInvalidate_();
                } catch (e) {
                    this.reportExceptionInDerivation_(e);
                }
            }
            globalState.trackingContext = prev;
            endBatch();
        }
    };
    _proto.track = function track(fn) {
        if (this.isDisposed) return;
        startBatch();
        var notify = isSpyEnabled();
        var startTime;
        this.isRunning = true;
        var prevReaction = globalState.trackingContext; // reactions could create reactions...
        globalState.trackingContext = this;
        var result = trackDerivedFunction(this, fn, undefined);
        globalState.trackingContext = prevReaction;
        this.isRunning = false;
        this.isTrackPending = false;
        if (this.isDisposed) // disposed during last run. Clean up everything that was bound after the dispose call.
        clearObserving(this);
        if (isCaughtException(result)) this.reportExceptionInDerivation_(result.cause);
        endBatch();
    };
    _proto.reportExceptionInDerivation_ = function reportExceptionInDerivation_(error) {
        var _this = this;
        if (this.errorHandler_) {
            this.errorHandler_(error, this);
            return;
        }
        if (globalState.disableErrorBoundaries) throw error;
        var message = "[mobx] uncaught error in '" + this + "'";
        if (!globalState.suppressReactionErrors) console.error(message, error);
         // prettier-ignore
        globalState.globalReactionErrorHandlers.forEach(function(f) {
            return f(error, _this);
        });
    };
    _proto.dispose = function dispose() {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this.isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch();
                clearObserving(this);
                endBatch();
            }
        }
    };
    _proto.getDisposer_ = function getDisposer_(abortSignal) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2.dispose();
            abortSignal == null || abortSignal.removeEventListener == null || abortSignal.removeEventListener("abort", dispose);
        };
        abortSignal == null || abortSignal.addEventListener == null || abortSignal.addEventListener("abort", dispose);
        dispose[$mobx] = this;
        return dispose;
    };
    _proto.toString = function toString() {
        return "Reaction[" + this.name_ + "]";
    };
    _proto.trace = function trace$1(enterBreakPoint) {
        if (enterBreakPoint === void 0) enterBreakPoint = false;
        trace(this, enterBreakPoint);
    };
    return _createClass(Reaction, [
        {
            key: "isDisposed",
            get: function get() {
                return getFlag(this.flags_, Reaction.isDisposedMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isDisposedMask_, newValue);
            }
        },
        {
            key: "isScheduled",
            get: function get() {
                return getFlag(this.flags_, Reaction.isScheduledMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isScheduledMask_, newValue);
            }
        },
        {
            key: "isTrackPending",
            get: function get() {
                return getFlag(this.flags_, Reaction.isTrackPendingMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isTrackPendingMask_, newValue);
            }
        },
        {
            key: "isRunning",
            get: function get() {
                return getFlag(this.flags_, Reaction.isRunningMask_);
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.isRunningMask_, newValue);
            }
        },
        {
            key: "diffValue",
            get: function get() {
                return getFlag(this.flags_, Reaction.diffValueMask_) ? 1 : 0;
            },
            set: function set(newValue) {
                this.flags_ = setFlag(this.flags_, Reaction.diffValueMask_, newValue === 1 ? true : false);
            }
        }
    ]);
}();
Reaction.isDisposedMask_ = 1;
Reaction.isScheduledMask_ = 2;
Reaction.isTrackPendingMask_ = 4;
Reaction.isRunningMask_ = 8;
Reaction.diffValueMask_ = 16;
function onReactionError(handler) {
    globalState.globalReactionErrorHandlers.push(handler);
    return function() {
        var idx = globalState.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0) globalState.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */ var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function reactionScheduler(f) {
    return f();
};
function runReactions() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState.inBatch > 0 || globalState.isRunningReactions) return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState.isRunningReactions = true;
    var allReactions = globalState.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while(allReactions.length > 0){
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("[mobx] cycle in reaction: " + allReactions[0]);
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for(var i = 0, l = remainingReactions.length; i < l; i++)remainingReactions[i].runReaction_();
    }
    globalState.isRunningReactions = false;
}
var isReaction = /*#__PURE__*/ createInstanceofPredicate("Reaction", Reaction);
function setReactionScheduler(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function reactionScheduler(f) {
        return fn(function() {
            return baseScheduler(f);
        });
    };
}
function isSpyEnabled() {
    return false;
}
function spyReport(event) {
    var listeners, i, l;
    return;
}
function spyReportStart(event) {
    var change;
    return;
}
var END_EVENT = {
    type: "report-end",
    spyReportEnd: true
};
function spyReportEnd(change) {
    return;
}
function spy(listener) {
    console.warn("[mobx.spy] Is a no-op in production builds");
    return function() {};
}
var ACTION = "action";
var ACTION_BOUND = "action.bound";
var AUTOACTION = "autoAction";
var AUTOACTION_BOUND = "autoAction.bound";
var DEFAULT_ACTION_NAME = "<unnamed action>";
var actionAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION);
var actionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(ACTION_BOUND, {
    bound: true
});
var autoActionAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION, {
    autoAction: true
});
var autoActionBoundAnnotation = /*#__PURE__*/ createActionAnnotation(AUTOACTION_BOUND, {
    autoAction: true,
    bound: true
});
function createActionFactory(autoAction) {
    var res = function action(arg1, arg2) {
        // action(fn() {})
        if (isFunction(arg1)) return createAction(arg1.name || DEFAULT_ACTION_NAME, arg1, autoAction);
        // action("name", fn() {})
        if (isFunction(arg2)) return createAction(arg1, arg2, autoAction);
        // @action (2022.3 Decorators)
        if (is20223Decorator(arg2)) return (autoAction ? autoActionAnnotation : actionAnnotation).decorate_20223_(arg1, arg2);
        // @action
        if (isStringish(arg2)) return storeAnnotation(arg1, arg2, autoAction ? autoActionAnnotation : actionAnnotation);
        // action("name") & @action("name")
        if (isStringish(arg1)) return createDecoratorAnnotation(createActionAnnotation(autoAction ? AUTOACTION : ACTION, {
            name: arg1,
            autoAction: autoAction
        }));
    };
    return res;
}
var action = /*#__PURE__*/ createActionFactory(false);
Object.assign(action, actionAnnotation);
var autoAction = /*#__PURE__*/ createActionFactory(true);
Object.assign(autoAction, autoActionAnnotation);
action.bound = /*#__PURE__*/ createDecoratorAnnotation(actionBoundAnnotation);
autoAction.bound = /*#__PURE__*/ createDecoratorAnnotation(autoActionBoundAnnotation);
function runInAction(fn) {
    return executeAction(fn.name || DEFAULT_ACTION_NAME, false, fn, this, undefined);
}
function isAction(thing) {
    return isFunction(thing) && thing.isMobxAction === true;
}
/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */ function autorun(view, opts) {
    var _opts$name, _opts, _opts2, _opts3;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name = (_opts = opts) == null ? void 0 : _opts.name) != null ? _opts$name : "Autorun";
    var runSync = !opts.scheduler && !opts.delay;
    var reaction;
    if (runSync) // normal autorun
    reaction = new Reaction(name, function() {
        this.track(reactionRunner);
    }, opts.onError, opts.requiresObservable);
    else {
        var scheduler = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled = false;
        reaction = new Reaction(name, function() {
            if (!isScheduled) {
                isScheduled = true;
                scheduler(function() {
                    isScheduled = false;
                    if (!reaction.isDisposed) reaction.track(reactionRunner);
                });
            }
        }, opts.onError, opts.requiresObservable);
    }
    function reactionRunner() {
        view(reaction);
    }
    if (!((_opts2 = opts) != null && (_opts2 = _opts2.signal) != null && _opts2.aborted)) reaction.schedule_();
    return reaction.getDisposer_((_opts3 = opts) == null ? void 0 : _opts3.signal);
}
var run = function run(f) {
    return f();
};
function createSchedulerFromOptions(opts) {
    return opts.scheduler ? opts.scheduler : opts.delay ? function(f) {
        return setTimeout(f, opts.delay);
    } : run;
}
function reaction(expression, effect, opts) {
    var _opts$name2, _opts4, _opts5;
    if (opts === void 0) opts = EMPTY_OBJECT;
    var name = (_opts$name2 = opts.name) != null ? _opts$name2 : "Reaction";
    var effectAction = action(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural ? comparer.structural : opts.equals || comparer["default"];
    var r = new Reaction(name, function() {
        if (firstTime || runSync) reactionRunner();
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError, opts.requiresObservable);
    function reactionRunner() {
        isScheduled = false;
        if (r.isDisposed) return;
        var changed = false;
        var oldValue = value;
        r.track(function() {
            var nextValue = allowStateChanges(false, function() {
                return expression(r);
            });
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately) effectAction(value, oldValue, r);
        else if (!firstTime && changed) effectAction(value, oldValue, r);
        firstTime = false;
    }
    if (!((_opts4 = opts) != null && (_opts4 = _opts4.signal) != null && _opts4.aborted)) r.schedule_();
    return r.getDisposer_((_opts5 = opts) == null ? void 0 : _opts5.signal);
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function() {
        try {
            return baseFn.apply(this, arguments);
        } catch (e) {
            errorHandler.call(this, e);
        }
    };
}
var ON_BECOME_OBSERVED = "onBO";
var ON_BECOME_UNOBSERVED = "onBUO";
function onBecomeObserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_OBSERVED, thing, arg2, arg3);
}
function onBecomeUnobserved(thing, arg2, arg3) {
    return interceptHook(ON_BECOME_UNOBSERVED, thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg3 === "function" ? getAtom(thing, arg2) : getAtom(thing);
    var cb = isFunction(arg3) ? arg3 : arg2;
    var listenersKey = hook + "L";
    if (atom[listenersKey]) atom[listenersKey].add(cb);
    else atom[listenersKey] = new Set([
        cb
    ]);
    return function() {
        var hookListeners = atom[listenersKey];
        if (hookListeners) {
            hookListeners["delete"](cb);
            if (hookListeners.size === 0) delete atom[listenersKey];
        }
    };
}
var NEVER = "never";
var ALWAYS = "always";
var OBSERVED = "observed";
// const IF_AVAILABLE = "ifavailable"
function configure(options) {
    if (options.isolateGlobalState === true) isolateGlobalState();
    var useProxies = options.useProxies, enforceActions = options.enforceActions;
    if (useProxies !== undefined) globalState.useProxies = useProxies === ALWAYS ? true : useProxies === NEVER ? false : typeof Proxy !== "undefined";
    if (useProxies === "ifavailable") globalState.verifyProxies = true;
    if (enforceActions !== undefined) {
        var ea = enforceActions === ALWAYS ? ALWAYS : enforceActions === OBSERVED;
        globalState.enforceActions = ea;
        globalState.allowStateChanges = ea === true || ea === ALWAYS ? false : true;
    }
    [
        "computedRequiresReaction",
        "reactionRequiresObservable",
        "observableRequiresReaction",
        "disableErrorBoundaries",
        "safeDescriptors"
    ].forEach(function(key) {
        if (key in options) globalState[key] = !!options[key];
    });
    globalState.allowStateReads = !globalState.observableRequiresReaction;
    if (options.reactionScheduler) setReactionScheduler(options.reactionScheduler);
}
function extendObservable(target, properties, annotations, options) {
    // Pull descriptors first, so we don't have to deal with props added by administration ($mobx)
    var descriptors = getOwnPropertyDescriptors(properties);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        ownKeys(descriptors).forEach(function(key) {
            adm.extend_(key, descriptors[key], // must pass "undefined" for { key: undefined }
            !annotations ? true : key in annotations ? annotations[key] : true);
        });
    });
    return target;
}
function getDependencyTree(thing, property) {
    return nodeToDependencyTree(getAtom(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name_
    };
    if (node.observing_ && node.observing_.length > 0) result.dependencies = unique(node.observing_).map(nodeToDependencyTree);
    return result;
}
function getObserverTree(thing, property) {
    return nodeToObserverTree(getAtom(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name_
    };
    if (hasObservers(node)) result.observers = Array.from(getObservers(node)).map(nodeToObserverTree);
    return result;
}
function unique(list) {
    return Array.from(new Set(list));
}
var generatorId = 0;
function FlowCancellationError() {
    this.message = "FLOW_CANCELLED";
}
FlowCancellationError.prototype = /*#__PURE__*/ Object.create(Error.prototype);
function isFlowCancellationError(error) {
    return error instanceof FlowCancellationError;
}
var flowAnnotation = /*#__PURE__*/ createFlowAnnotation("flow");
var flowBoundAnnotation = /*#__PURE__*/ createFlowAnnotation("flow.bound", {
    bound: true
});
var flow = /*#__PURE__*/ Object.assign(function flow(arg1, arg2) {
    // @flow (2022.3 Decorators)
    if (is20223Decorator(arg2)) return flowAnnotation.decorate_20223_(arg1, arg2);
    // @flow
    if (isStringish(arg2)) return storeAnnotation(arg1, arg2, flowAnnotation);
    var generator = arg1;
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    var res = function res() {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var promise = new Promise(function(resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action(name + " - runid: " + runId + " - yield " + stepId++, gen["throw"]).call(gen, err);
                } catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (isFunction(ret == null ? void 0 : ret.then)) {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done) return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        promise.cancel = action(name + " - runid: " + runId + " - cancel", function() {
            try {
                if (pendingPromise) cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var _res = gen["return"](undefined);
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(_res.value);
                yieldedPromise.then(noop, noop);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new FlowCancellationError());
            } catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return promise;
    };
    res.isMobXFlow = true;
    return res;
}, flowAnnotation);
flow.bound = /*#__PURE__*/ createDecoratorAnnotation(flowBoundAnnotation);
function cancelPromise(promise) {
    if (isFunction(promise.cancel)) promise.cancel();
}
function flowResult(result) {
    return result; // just tricking TypeScript :)
}
function isFlow(fn) {
    return (fn == null ? void 0 : fn.isMobXFlow) === true;
}
function interceptReads(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap(thing) || isObservableArray(thing) || isObservableValue(thing)) target = getAdministration(thing);
    else if (isObservableObject(thing)) target = getAdministration(thing, propOrHandler);
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function() {
        target.dehancer = undefined;
    };
}
function intercept(thing, propOrHandler, handler) {
    if (isFunction(handler)) return interceptProperty(thing, propOrHandler, handler);
    else return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration(thing).intercept_(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration(thing, property).intercept_(handler);
}
function _isComputed(value, property) {
    if (property === undefined) return isComputedValue(value);
    if (isObservableObject(value) === false) return false;
    if (!value[$mobx].values_.has(property)) return false;
    var atom = getAtom(value, property);
    return isComputedValue(atom);
}
function isComputed(value) {
    return _isComputed(value);
}
function isComputedProp(value, propName) {
    return _isComputed(value, propName);
}
function _isObservable(value, property) {
    if (!value) return false;
    if (property !== undefined) {
        if (isObservableObject(value)) return value[$mobx].values_.has(property);
        return false;
    }
    // For first check, see #701
    return isObservableObject(value) || !!value[$mobx] || isAtom(value) || isReaction(value) || isComputedValue(value);
}
function isObservable(value) {
    return _isObservable(value);
}
function isObservableProp(value, propName) {
    return _isObservable(value, propName);
}
function keys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].keys_();
    if (isObservableMap(obj) || isObservableSet(obj)) return Array.from(obj.keys());
    if (isObservableArray(obj)) return obj.map(function(_, index) {
        return index;
    });
    die(5);
}
function values(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return obj[key];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return obj.get(key);
    });
    if (isObservableSet(obj)) return Array.from(obj.values());
    if (isObservableArray(obj)) return obj.slice();
    die(6);
}
function entries(obj) {
    if (isObservableObject(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj[key]
        ];
    });
    if (isObservableMap(obj)) return keys(obj).map(function(key) {
        return [
            key,
            obj.get(key)
        ];
    });
    if (isObservableSet(obj)) return Array.from(obj.entries());
    if (isObservableArray(obj)) return obj.map(function(key, index) {
        return [
            index,
            key
        ];
    });
    die(7);
}
function set(obj, key, value) {
    if (arguments.length === 2 && !isObservableSet(obj)) {
        startBatch();
        var _values = key;
        try {
            for(var _key in _values)set(obj, _key, _values[_key]);
        } finally{
            endBatch();
        }
        return;
    }
    if (isObservableObject(obj)) obj[$mobx].set_(key, value);
    else if (isObservableMap(obj)) obj.set(key, value);
    else if (isObservableSet(obj)) obj.add(key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        if (key < 0) die("Invalid index: '" + key + "'");
        startBatch();
        if (key >= obj.length) obj.length = key + 1;
        obj[key] = value;
        endBatch();
    } else die(8);
}
function remove(obj, key) {
    if (isObservableObject(obj)) obj[$mobx].delete_(key);
    else if (isObservableMap(obj)) obj["delete"](key);
    else if (isObservableSet(obj)) obj["delete"](key);
    else if (isObservableArray(obj)) {
        if (typeof key !== "number") key = parseInt(key, 10);
        obj.splice(key, 1);
    } else die(9);
}
function has(obj, key) {
    if (isObservableObject(obj)) return obj[$mobx].has_(key);
    else if (isObservableMap(obj)) return obj.has(key);
    else if (isObservableSet(obj)) return obj.has(key);
    else if (isObservableArray(obj)) return key >= 0 && key < obj.length;
    die(10);
}
function get(obj, key) {
    if (!has(obj, key)) return undefined;
    if (isObservableObject(obj)) return obj[$mobx].get_(key);
    else if (isObservableMap(obj)) return obj.get(key);
    else if (isObservableArray(obj)) return obj[key];
    die(11);
}
function apiDefineProperty(obj, key, descriptor) {
    if (isObservableObject(obj)) return obj[$mobx].defineProperty_(key, descriptor);
    die(39);
}
function apiOwnKeys(obj) {
    if (isObservableObject(obj)) return obj[$mobx].ownKeys_();
    die(38);
}
function observe(thing, propOrCb, cbOrFire, fireImmediately) {
    if (isFunction(cbOrFire)) return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration(thing).observe_(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration(thing, property).observe_(listener, fireImmediately);
}
function cache(map, key, value) {
    map.set(key, value);
    return value;
}
function toJSHelper(source, __alreadySeen) {
    if (source == null || typeof source !== "object" || source instanceof Date || !isObservable(source)) return source;
    if (isObservableValue(source) || isComputedValue(source)) return toJSHelper(source.get(), __alreadySeen);
    if (__alreadySeen.has(source)) return __alreadySeen.get(source);
    if (isObservableArray(source)) {
        var res = cache(__alreadySeen, source, new Array(source.length));
        source.forEach(function(value, idx) {
            res[idx] = toJSHelper(value, __alreadySeen);
        });
        return res;
    }
    if (isObservableSet(source)) {
        var _res = cache(__alreadySeen, source, new Set());
        source.forEach(function(value) {
            _res.add(toJSHelper(value, __alreadySeen));
        });
        return _res;
    }
    if (isObservableMap(source)) {
        var _res2 = cache(__alreadySeen, source, new Map());
        source.forEach(function(value, key) {
            _res2.set(key, toJSHelper(value, __alreadySeen));
        });
        return _res2;
    } else {
        // must be observable object
        var _res3 = cache(__alreadySeen, source, {});
        apiOwnKeys(source).forEach(function(key) {
            if (objectPrototype.propertyIsEnumerable.call(source, key)) _res3[key] = toJSHelper(source[key], __alreadySeen);
        });
        return _res3;
    }
}
/**
 * Recursively converts an observable to it's non-observable native counterpart.
 * It does NOT recurse into non-observables, these are left as they are, even if they contain observables.
 * Computed and other non-enumerable properties are completely ignored.
 * Complex scenarios require custom solution, eg implementing `toJSON` or using `serializr` lib.
 */ function toJS(source, options) {
    return toJSHelper(source, new Map());
}
function trace() {
    var enterBreakPoint, _len, args, _key, derivation;
    return;
}
function getAtomFromArgs(args) {
    switch(args.length){
        case 0:
            return globalState.trackingDerivation;
        case 1:
            return getAtom(args[0]);
        case 2:
            return getAtom(args[0], args[1]);
    }
}
/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */ function transaction(action, thisArg) {
    if (thisArg === void 0) thisArg = undefined;
    startBatch();
    try {
        return action.apply(thisArg);
    } finally{
        endBatch();
    }
}
function when(predicate, arg1, arg2) {
    if (arguments.length === 1 || arg1 && typeof arg1 === "object") return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        var error = new Error("WHEN_TIMEOUT");
        timeoutHandle = setTimeout(function() {
            if (!disposer[$mobx].isDisposed) {
                disposer();
                if (opts.onError) opts.onError(error);
                else throw error;
            }
        }, opts.timeout);
    }
    opts.name = "When";
    var effectAction = createAction("When-effect", effect);
    // eslint-disable-next-line
    var disposer = autorun(function(r) {
        // predicate should not change state
        var cond = allowStateChanges(false, predicate);
        if (cond) {
            r.dispose();
            if (timeoutHandle) clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    var _opts$signal;
    if (opts != null && (_opts$signal = opts.signal) != null && _opts$signal.aborted) return Object.assign(Promise.reject(new Error("WHEN_ABORTED")), {
        cancel: function cancel() {
            return null;
        }
    });
    var cancel;
    var abort;
    var res = new Promise(function(resolve, reject) {
        var _opts$signal2;
        var disposer = _when(predicate, resolve, _extends({}, opts, {
            onError: reject
        }));
        cancel = function cancel() {
            disposer();
            reject(new Error("WHEN_CANCELLED"));
        };
        abort = function abort() {
            disposer();
            reject(new Error("WHEN_ABORTED"));
        };
        opts == null || (_opts$signal2 = opts.signal) == null || _opts$signal2.addEventListener == null || _opts$signal2.addEventListener("abort", abort);
    })["finally"](function() {
        var _opts$signal3;
        return opts == null || (_opts$signal3 = opts.signal) == null || _opts$signal3.removeEventListener == null ? void 0 : _opts$signal3.removeEventListener("abort", abort);
    });
    res.cancel = cancel;
    return res;
}
function getAdm(target) {
    return target[$mobx];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function has(target, name) {
        return getAdm(target).has_(name);
    },
    get: function get(target, name) {
        return getAdm(target).get_(name);
    },
    set: function set(target, name, value) {
        var _getAdm$set_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$set_ = getAdm(target).set_(name, value, true)) != null ? _getAdm$set_ : true;
    },
    deleteProperty: function deleteProperty(target, name) {
        var _getAdm$delete_;
        if (!isStringish(name)) return false;
        // null (intercepted) -> true (success)
        return (_getAdm$delete_ = getAdm(target).delete_(name, true)) != null ? _getAdm$delete_ : true;
    },
    defineProperty: function defineProperty(target, name, descriptor) {
        var _getAdm$definePropert;
        // null (intercepted) -> true (success)
        return (_getAdm$definePropert = getAdm(target).defineProperty_(name, descriptor)) != null ? _getAdm$definePropert : true;
    },
    ownKeys: function ownKeys(target) {
        return getAdm(target).ownKeys_();
    },
    preventExtensions: function preventExtensions(target) {
        die(13);
    }
};
function asDynamicObservableObject(target, options) {
    var _target$$mobx, _target$$mobx$proxy_;
    assertProxies();
    target = asObservableObject(target, options);
    return (_target$$mobx$proxy_ = (_target$$mobx = target[$mobx]).proxy_) != null ? _target$$mobx$proxy_ : _target$$mobx.proxy_ = new Proxy(target, objectProxyTraps);
}
function hasInterceptors(interceptable) {
    return interceptable.interceptors_ !== undefined && interceptable.interceptors_.length > 0;
}
function registerInterceptor(interceptable, handler) {
    var interceptors = interceptable.interceptors_ || (interceptable.interceptors_ = []);
    interceptors.push(handler);
    return once(function() {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1) interceptors.splice(idx, 1);
    });
}
function interceptChange(interceptable, change) {
    var prevU = untrackedStart();
    try {
        // Interceptor can modify the array, copy it to avoid concurrent modification, see #1950
        var interceptors = [].concat(interceptable.interceptors_ || []);
        for(var i = 0, l = interceptors.length; i < l; i++){
            change = interceptors[i](change);
            if (change && !change.type) die(14);
            if (!change) break;
        }
        return change;
    } finally{
        untrackedEnd(prevU);
    }
}
function hasListeners(listenable) {
    return listenable.changeListeners_ !== undefined && listenable.changeListeners_.length > 0;
}
function registerListener(listenable, handler) {
    var listeners = listenable.changeListeners_ || (listenable.changeListeners_ = []);
    listeners.push(handler);
    return once(function() {
        var idx = listeners.indexOf(handler);
        if (idx !== -1) listeners.splice(idx, 1);
    });
}
function notifyListeners(listenable, change) {
    var prevU = untrackedStart();
    var listeners = listenable.changeListeners_;
    if (!listeners) return;
    listeners = listeners.slice();
    for(var i = 0, l = listeners.length; i < l; i++)listeners[i](change);
    untrackedEnd(prevU);
}
function makeObservable(target, annotations, options) {
    initObservable(function() {
        var _annotations;
        var adm = asObservableObject(target, options)[$mobx];
        // Default to decorators
        (_annotations = annotations) != null ? _annotations : annotations = collectStoredAnnotations(target);
        // Annotate
        ownKeys(annotations).forEach(function(key) {
            return adm.make_(key, annotations[key]);
        });
    });
    return target;
}
// proto[keysSymbol] = new Set<PropertyKey>()
var keysSymbol = /*#__PURE__*/ Symbol("mobx-keys");
function makeAutoObservable(target, overrides, options) {
    // Optimization: avoid visiting protos
    // Assumes that annotation.make_/.extend_ works the same for plain objects
    if (isPlainObject(target)) return extendObservable(target, target, overrides, options);
    initObservable(function() {
        var adm = asObservableObject(target, options)[$mobx];
        // Optimization: cache keys on proto
        // Assumes makeAutoObservable can be called only once per object and can't be used in subclass
        if (!target[keysSymbol]) {
            var proto = Object.getPrototypeOf(target);
            var keys = new Set([].concat(ownKeys(target), ownKeys(proto)));
            keys["delete"]("constructor");
            keys["delete"]($mobx);
            addHiddenProp(proto, keysSymbol, keys);
        }
        target[keysSymbol].forEach(function(key) {
            return adm.make_(key, // must pass "undefined" for { key: undefined }
            !overrides ? true : key in overrides ? overrides[key] : true);
        });
    });
    return target;
}
var SPLICE = "splice";
var UPDATE = "update";
var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function get(target, name) {
        var adm = target[$mobx];
        if (name === $mobx) return adm;
        if (name === "length") return adm.getArrayLength_();
        if (typeof name === "string" && !isNaN(name)) return adm.get_(parseInt(name));
        if (hasProp(arrayExtensions, name)) return arrayExtensions[name];
        return target[name];
    },
    set: function set(target, name, value) {
        var adm = target[$mobx];
        if (name === "length") adm.setArrayLength_(value);
        if (typeof name === "symbol" || isNaN(name)) target[name] = value;
        else // numeric string
        adm.set_(parseInt(name), value);
        return true;
    },
    preventExtensions: function preventExtensions() {
        die(15);
    }
};
var ObservableArrayAdministration = /*#__PURE__*/ function() {
    function ObservableArrayAdministration(name, enhancer, owned_, legacyMode_) {
        if (name === void 0) name = "ObservableArray";
        this.owned_ = void 0;
        this.legacyMode_ = void 0;
        this.atom_ = void 0;
        this.values_ = [];
        // this is the prop that gets proxied, so can't replace it!
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.enhancer_ = void 0;
        this.dehancer = void 0;
        this.proxy_ = void 0;
        this.lastKnownLength_ = 0;
        this.owned_ = owned_;
        this.legacyMode_ = legacyMode_;
        this.atom_ = new Atom(name);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, "ObservableArray[..]");
        };
    }
    var _proto = ObservableArrayAdministration.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.dehanceValues_ = function dehanceValues_(values) {
        if (this.dehancer !== undefined && values.length > 0) return values.map(this.dehancer);
        return values;
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        if (fireImmediately === void 0) fireImmediately = false;
        if (fireImmediately) listener({
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: "splice",
            index: 0,
            added: this.values_.slice(),
            addedCount: this.values_.length,
            removed: [],
            removedCount: 0
        });
        return registerListener(this, listener);
    };
    _proto.getArrayLength_ = function getArrayLength_() {
        this.atom_.reportObserved();
        return this.values_.length;
    };
    _proto.setArrayLength_ = function setArrayLength_(newLength) {
        if (typeof newLength !== "number" || isNaN(newLength) || newLength < 0) die("Out of range: " + newLength);
        var currentLength = this.values_.length;
        if (newLength === currentLength) return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for(var i = 0; i < newLength - currentLength; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            this.spliceWithArray_(currentLength, 0, newItems);
        } else this.spliceWithArray_(newLength, currentLength - newLength);
    };
    _proto.updateArrayLength_ = function updateArrayLength_(oldLength, delta) {
        if (oldLength !== this.lastKnownLength_) die(16);
        this.lastKnownLength_ += delta;
        if (this.legacyMode_ && delta > 0) reserveArrayBuffer(oldLength + delta + 1);
    };
    _proto.spliceWithArray_ = function spliceWithArray_(index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        var length = this.values_.length;
        if (index === undefined) index = 0;
        else if (index > length) index = length;
        else if (index < 0) index = Math.max(0, length + index);
        if (arguments.length === 1) deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null) deleteCount = 0;
        else deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined) newItems = EMPTY_ARRAY;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_,
                type: SPLICE,
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change) return EMPTY_ARRAY;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function(v) {
            return _this.enhancer_(v, undefined);
        });
        if (this.legacyMode_ || false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength_(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues_(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0) this.notifyArraySplice_(index, newItems, res);
        return this.dehanceValues_(res);
    };
    _proto.spliceItemsIntoValues_ = function spliceItemsIntoValues_(index, deleteCount, newItems) {
        if (newItems.length < MAX_SPLICE_SIZE) {
            var _this$values_;
            return (_this$values_ = this.values_).splice.apply(_this$values_, [
                index,
                deleteCount
            ].concat(newItems));
        } else {
            // The items removed by the splice
            var res = this.values_.slice(index, index + deleteCount);
            // The items that that should remain at the end of the array
            var oldItems = this.values_.slice(index + deleteCount);
            // New length is the previous length + addition count - deletion count
            this.values_.length += newItems.length - deleteCount;
            for(var i = 0; i < newItems.length; i++)this.values_[index + i] = newItems[i];
            for(var _i = 0; _i < oldItems.length; _i++)this.values_[index + newItems.length + _i] = oldItems[_i];
            return res;
        }
    };
    _proto.notifyArrayChildUpdate_ = function notifyArrayChildUpdate_(index, newValue, oldValue) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            type: UPDATE,
            debugObjectName: this.atom_.name_,
            index: index,
            newValue: newValue,
            oldValue: oldValue
        } : null;
        this.atom_.reportChanged();
        if (notify) notifyListeners(this, change);
    };
    _proto.notifyArraySplice_ = function notifyArraySplice_(index, added, removed) {
        var notifySpy = !this.owned_ && isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "array",
            object: this.proxy_,
            debugObjectName: this.atom_.name_,
            type: SPLICE,
            index: index,
            removed: removed,
            added: added,
            removedCount: removed.length,
            addedCount: added.length
        } : null;
        this.atom_.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify) notifyListeners(this, change);
    };
    _proto.get_ = function get_(index) {
        if (this.legacyMode_ && index >= this.values_.length) {
            console.warn("[mobx] Out of bounds read: " + index);
            return undefined;
        }
        this.atom_.reportObserved();
        return this.dehanceValue_(this.values_[index]);
    };
    _proto.set_ = function set_(index, newValue) {
        var values = this.values_;
        if (this.legacyMode_ && index > values.length) // out of bounds
        die(17, index, values.length);
        if (index < values.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed(this.atom_);
            var oldValue = values[index];
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    type: UPDATE,
                    object: this.proxy_,
                    // since "this" is the real array we need to pass its proxy
                    index: index,
                    newValue: newValue
                });
                if (!change) return;
                newValue = change.newValue;
            }
            newValue = this.enhancer_(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values[index] = newValue;
                this.notifyArrayChildUpdate_(index, newValue, oldValue);
            }
        } else {
            // For out of bound index, we don't create an actual sparse array,
            // but rather fill the holes with undefined (same as setArrayLength_).
            // This could be considered a bug.
            var newItems = new Array(index + 1 - values.length);
            for(var i = 0; i < newItems.length - 1; i++)newItems[i] = undefined;
             // No Array.fill everywhere...
            newItems[newItems.length - 1] = newValue;
            this.spliceWithArray_(values.length, 0, newItems);
        }
    };
    return ObservableArrayAdministration;
}();
function createObservableArray(initialValues, enhancer, name, owned) {
    if (name === void 0) name = "ObservableArray";
    if (owned === void 0) owned = false;
    assertProxies();
    return initObservable(function() {
        var adm = new ObservableArrayAdministration(name, enhancer, owned, false);
        addHiddenFinalProp(adm.values_, $mobx, adm);
        var proxy = new Proxy(adm.values_, arrayTraps);
        adm.proxy_ = proxy;
        if (initialValues && initialValues.length) adm.spliceWithArray_(0, 0, initialValues);
        return proxy;
    });
}
// eslint-disable-next-line
var arrayExtensions = {
    clear: function clear() {
        return this.splice(0);
    },
    replace: function replace(newItems) {
        var adm = this[$mobx];
        return adm.spliceWithArray_(0, adm.values_.length, newItems);
    },
    // Used by JSON.stringify
    toJSON: function toJSON() {
        return this.slice();
    },
    /*
   * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
   * since these functions alter the inner structure of the array, the have side effects.
   * Because the have side effects, they should not be used in computed function,
   * and for that reason the do not call dependencyState.notifyObserved
   */ splice: function splice(index, deleteCount) {
        for(var _len = arguments.length, newItems = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)newItems[_key - 2] = arguments[_key];
        var adm = this[$mobx];
        switch(arguments.length){
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray_(index);
            case 2:
                return adm.spliceWithArray_(index, deleteCount);
        }
        return adm.spliceWithArray_(index, deleteCount, newItems);
    },
    spliceWithArray: function spliceWithArray(index, deleteCount, newItems) {
        return this[$mobx].spliceWithArray_(index, deleteCount, newItems);
    },
    push: function push() {
        var adm = this[$mobx];
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        adm.spliceWithArray_(adm.values_.length, 0, items);
        return adm.values_.length;
    },
    pop: function pop() {
        return this.splice(Math.max(this[$mobx].values_.length - 1, 0), 1)[0];
    },
    shift: function shift() {
        return this.splice(0, 1)[0];
    },
    unshift: function unshift() {
        var adm = this[$mobx];
        for(var _len3 = arguments.length, items = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)items[_key3] = arguments[_key3];
        adm.spliceWithArray_(0, 0, items);
        return adm.values_.length;
    },
    reverse: function reverse() {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        if (globalState.trackingDerivation) die(37, "reverse");
        this.replace(this.slice().reverse());
        return this;
    },
    sort: function sort() {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (globalState.trackingDerivation) die(37, "sort");
        var copy = this.slice();
        copy.sort.apply(copy, arguments);
        this.replace(copy);
        return this;
    },
    remove: function remove(value) {
        var adm = this[$mobx];
        var idx = adm.dehanceValues_(adm.values_).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    }
};
/**
 * Wrap function from prototype
 * Without this, everything works as well, but this works
 * faster as everything works on unproxied values
 */ addArrayExtension("at", simpleFunc);
addArrayExtension("concat", simpleFunc);
addArrayExtension("flat", simpleFunc);
addArrayExtension("includes", simpleFunc);
addArrayExtension("indexOf", simpleFunc);
addArrayExtension("join", simpleFunc);
addArrayExtension("lastIndexOf", simpleFunc);
addArrayExtension("slice", simpleFunc);
addArrayExtension("toString", simpleFunc);
addArrayExtension("toLocaleString", simpleFunc);
addArrayExtension("toSorted", simpleFunc);
addArrayExtension("toSpliced", simpleFunc);
addArrayExtension("with", simpleFunc);
// map
addArrayExtension("every", mapLikeFunc);
addArrayExtension("filter", mapLikeFunc);
addArrayExtension("find", mapLikeFunc);
addArrayExtension("findIndex", mapLikeFunc);
addArrayExtension("findLast", mapLikeFunc);
addArrayExtension("findLastIndex", mapLikeFunc);
addArrayExtension("flatMap", mapLikeFunc);
addArrayExtension("forEach", mapLikeFunc);
addArrayExtension("map", mapLikeFunc);
addArrayExtension("some", mapLikeFunc);
addArrayExtension("toReversed", mapLikeFunc);
// reduce
addArrayExtension("reduce", reduceLikeFunc);
addArrayExtension("reduceRight", reduceLikeFunc);
function addArrayExtension(funcName, funcFactory) {
    if (typeof Array.prototype[funcName] === "function") arrayExtensions[funcName] = funcFactory(funcName);
}
// Report and delegate to dehanced array
function simpleFunc(funcName) {
    return function() {
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
// Make sure callbacks receive correct array arg #2326
function mapLikeFunc(funcName) {
    return function(callback, thisArg) {
        var _this2 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        return dehancedValues[funcName](function(element, index) {
            return callback.call(thisArg, element, index, _this2);
        });
    };
}
// Make sure callbacks receive correct array arg #2326
function reduceLikeFunc(funcName) {
    return function() {
        var _this3 = this;
        var adm = this[$mobx];
        adm.atom_.reportObserved();
        var dehancedValues = adm.dehanceValues_(adm.values_);
        // #2432 - reduce behavior depends on arguments.length
        var callback = arguments[0];
        arguments[0] = function(accumulator, currentValue, index) {
            return callback(accumulator, currentValue, index, _this3);
        };
        return dehancedValues[funcName].apply(dehancedValues, arguments);
    };
}
var isObservableArrayAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray(thing) {
    return isObject(thing) && isObservableArrayAdministration(thing[$mobx]);
}
var ObservableMapMarker = {};
var ADD = "add";
var DELETE = "delete";
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap = /*#__PURE__*/ function() {
    function ObservableMap(initialData, enhancer_, name_) {
        var _this = this;
        if (enhancer_ === void 0) enhancer_ = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableMap";
        this.enhancer_ = void 0;
        this.name_ = void 0;
        this[$mobx] = ObservableMapMarker;
        this.data_ = void 0;
        this.hasMap_ = void 0;
        // hasMap, not hashMap >-).
        this.keysAtom_ = void 0;
        this.interceptors_ = void 0;
        this.changeListeners_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = enhancer_;
        this.name_ = name_;
        if (!isFunction(Map)) die(18);
        initObservable(function() {
            _this.keysAtom_ = createAtom("ObservableMap.keys()");
            _this.data_ = new Map();
            _this.hasMap_ = new Map();
            if (initialData) _this.merge(initialData);
        });
    }
    var _proto = ObservableMap.prototype;
    _proto.has_ = function has_(key) {
        return this.data_.has(key);
    };
    _proto.has = function has(key) {
        var _this2 = this;
        if (!globalState.trackingDerivation) return this.has_(key);
        var entry = this.hasMap_.get(key);
        if (!entry) {
            var newEntry = entry = new ObservableValue(this.has_(key), referenceEnhancer, "ObservableMap.key?", false);
            this.hasMap_.set(key, newEntry);
            onBecomeUnobserved(newEntry, function() {
                return _this2.hasMap_["delete"](key);
            });
        }
        return entry.get();
    };
    _proto.set = function set(key, value) {
        var hasKey = this.has_(key);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: hasKey ? UPDATE : ADD,
                object: this,
                newValue: value,
                name: key
            });
            if (!change) return this;
            value = change.newValue;
        }
        if (hasKey) this.updateValue_(key, value);
        else this.addValue_(key, value);
        return this;
    };
    _proto["delete"] = function _delete(key) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                name: key
            });
            if (!change) return false;
        }
        if (this.has_(key)) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: this.data_.get(key).value_,
                name: key
            } : null;
            transaction(function() {
                var _this3$hasMap_$get;
                _this3.keysAtom_.reportChanged();
                (_this3$hasMap_$get = _this3.hasMap_.get(key)) == null || _this3$hasMap_$get.setNewValue_(false);
                var observable = _this3.data_.get(key);
                observable.setNewValue_(undefined);
                _this3.data_["delete"](key);
            });
            if (notify) notifyListeners(this, _change);
            return true;
        }
        return false;
    };
    _proto.updateValue_ = function updateValue_(key, newValue) {
        var observable = this.data_.get(key);
        newValue = observable.prepareNewValue_(newValue);
        if (newValue !== globalState.UNCHANGED) {
            var notifySpy = isSpyEnabled();
            var notify = hasListeners(this);
            var change = notify || notifySpy ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: UPDATE,
                object: this,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, change);
        }
    };
    _proto.addValue_ = function addValue_(key, newValue) {
        var _this4 = this;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        transaction(function() {
            var _this4$hasMap_$get;
            var observable = new ObservableValue(newValue, _this4.enhancer_, "ObservableMap.key", false);
            _this4.data_.set(key, observable);
            newValue = observable.value_; // value might have been changed
            (_this4$hasMap_$get = _this4.hasMap_.get(key)) == null || _this4$hasMap_$get.setNewValue_(true);
            _this4.keysAtom_.reportChanged();
        });
        var notifySpy = isSpyEnabled();
        var notify = hasListeners(this);
        var change = notify || notifySpy ? {
            observableKind: "map",
            debugObjectName: this.name_,
            type: ADD,
            object: this,
            name: key,
            newValue: newValue
        } : null;
        if (notify) notifyListeners(this, change);
    };
    _proto.get = function get(key) {
        if (this.has(key)) return this.dehanceValue_(this.data_.get(key).get());
        return this.dehanceValue_(undefined);
    };
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.keys = function keys() {
        this.keysAtom_.reportObserved();
        return this.data_.keys();
    };
    _proto.values = function values() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next = keys.next(), done = _keys$next.done, value = _keys$next.value;
                return {
                    done: done,
                    value: done ? undefined : self1.get(value)
                };
            }
        });
    };
    _proto.entries = function entries() {
        var self1 = this;
        var keys = this.keys();
        return makeIterableForMap({
            next: function next() {
                var _keys$next2 = keys.next(), done = _keys$next2.done, value = _keys$next2.value;
                return {
                    done: done,
                    value: done ? undefined : [
                        value,
                        self1.get(value)
                    ]
                };
            }
        });
    };
    _proto[Symbol.iterator] = function() {
        return this.entries();
    };
    _proto.forEach = function forEach(callback, thisArg) {
        for(var _iterator = _createForOfIteratorHelperLoose(this), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            callback.call(thisArg, value, key, this);
        }
    };
    _proto.merge = function merge(other) {
        var _this5 = this;
        if (isObservableMap(other)) other = new Map(other);
        transaction(function() {
            if (isPlainObject(other)) getPlainObjectKeys(other).forEach(function(key) {
                return _this5.set(key, other[key]);
            });
            else if (Array.isArray(other)) other.forEach(function(_ref) {
                var key = _ref[0], value = _ref[1];
                return _this5.set(key, value);
            });
            else if (isES6Map(other)) {
                if (!isPlainES6Map(other)) die(19, other);
                other.forEach(function(value, key) {
                    return _this5.set(key, value);
                });
            } else if (other !== null && other !== undefined) die(20, other);
        });
        return this;
    };
    _proto.clear = function clear() {
        var _this6 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator2 = _createForOfIteratorHelperLoose(_this6.keys()), _step2; !(_step2 = _iterator2()).done;){
                    var key = _step2.value;
                    _this6["delete"](key);
                }
            });
        });
    };
    _proto.replace = function replace(values) {
        var _this7 = this;
        // Implementation requirements:
        // - respect ordering of replacement map
        // - allow interceptors to run and potentially prevent individual operations
        // - don't recreate observables that already exist in original map (so we don't destroy existing subscriptions)
        // - don't _keysAtom.reportChanged if the keys of resulting map are indentical (order matters!)
        // - note that result map may differ from replacement map due to the interceptors
        transaction(function() {
            // Convert to map so we can do quick key lookups
            var replacementMap = convertToMap(values);
            var orderedData = new Map();
            // Used for optimization
            var keysReportChangedCalled = false;
            // Delete keys that don't exist in replacement map
            // if the key deletion is prevented by interceptor
            // add entry at the beginning of the result map
            for(var _iterator3 = _createForOfIteratorHelperLoose(_this7.data_.keys()), _step3; !(_step3 = _iterator3()).done;){
                var key = _step3.value;
                // Concurrently iterating/deleting keys
                // iterator should handle this correctly
                if (!replacementMap.has(key)) {
                    var deleted = _this7["delete"](key);
                    // Was the key removed?
                    if (deleted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                    else {
                        // Delete prevented by interceptor
                        var value = _this7.data_.get(key);
                        orderedData.set(key, value);
                    }
                }
            }
            // Merge entries
            for(var _iterator4 = _createForOfIteratorHelperLoose(replacementMap.entries()), _step4; !(_step4 = _iterator4()).done;){
                var _step4$value = _step4.value, _key = _step4$value[0], _value = _step4$value[1];
                // We will want to know whether a new key is added
                var keyExisted = _this7.data_.has(_key);
                // Add or update value
                _this7.set(_key, _value);
                // The addition could have been prevent by interceptor
                if (_this7.data_.has(_key)) {
                    // The update could have been prevented by interceptor
                    // and also we want to preserve existing values
                    // so use value from _data map (instead of replacement map)
                    var _value2 = _this7.data_.get(_key);
                    orderedData.set(_key, _value2);
                    // Was a new key added?
                    if (!keyExisted) // _keysAtom.reportChanged() was already called
                    keysReportChangedCalled = true;
                }
            }
            // Check for possible key order change
            if (!keysReportChangedCalled) {
                if (_this7.data_.size !== orderedData.size) // If size differs, keys are definitely modified
                _this7.keysAtom_.reportChanged();
                else {
                    var iter1 = _this7.data_.keys();
                    var iter2 = orderedData.keys();
                    var next1 = iter1.next();
                    var next2 = iter2.next();
                    while(!next1.done){
                        if (next1.value !== next2.value) {
                            _this7.keysAtom_.reportChanged();
                            break;
                        }
                        next1 = iter1.next();
                        next2 = iter2.next();
                    }
                }
            }
            // Use correctly ordered map
            _this7.data_ = orderedData;
        });
        return this;
    };
    _proto.toString = function toString() {
        return "[object ObservableMap]";
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    /**
   * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
   * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
   * for callback details
   */ _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    return _createClass(ObservableMap, [
        {
            key: "size",
            get: function get() {
                this.keysAtom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Map";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableMap = /*#__PURE__*/ createInstanceofPredicate("ObservableMap", ObservableMap);
function makeIterableForMap(iterator) {
    iterator[Symbol.toStringTag] = "MapIterator";
    return makeIterable(iterator);
}
function convertToMap(dataStructure) {
    if (isES6Map(dataStructure) || isObservableMap(dataStructure)) return dataStructure;
    else if (Array.isArray(dataStructure)) return new Map(dataStructure);
    else if (isPlainObject(dataStructure)) {
        var map = new Map();
        for(var key in dataStructure)map.set(key, dataStructure[key]);
        return map;
    } else return die(21, dataStructure);
}
var ObservableSetMarker = {};
var ObservableSet = /*#__PURE__*/ function() {
    function ObservableSet(initialData, enhancer, name_) {
        var _this = this;
        if (enhancer === void 0) enhancer = deepEnhancer;
        if (name_ === void 0) name_ = "ObservableSet";
        this.name_ = void 0;
        this[$mobx] = ObservableSetMarker;
        this.data_ = new Set();
        this.atom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.dehancer = void 0;
        this.enhancer_ = void 0;
        this.name_ = name_;
        if (!isFunction(Set)) die(22);
        this.enhancer_ = function(newV, oldV) {
            return enhancer(newV, oldV, name_);
        };
        initObservable(function() {
            _this.atom_ = createAtom(_this.name_);
            if (initialData) _this.replace(initialData);
        });
    }
    var _proto = ObservableSet.prototype;
    _proto.dehanceValue_ = function dehanceValue_(value) {
        if (this.dehancer !== undefined) return this.dehancer(value);
        return value;
    };
    _proto.clear = function clear() {
        var _this2 = this;
        transaction(function() {
            untracked(function() {
                for(var _iterator = _createForOfIteratorHelperLoose(_this2.data_.values()), _step; !(_step = _iterator()).done;){
                    var value = _step.value;
                    _this2["delete"](value);
                }
            });
        });
    };
    _proto.forEach = function forEach(callbackFn, thisArg) {
        for(var _iterator2 = _createForOfIteratorHelperLoose(this), _step2; !(_step2 = _iterator2()).done;){
            var value = _step2.value;
            callbackFn.call(thisArg, value, value, this);
        }
    };
    _proto.add = function add(value) {
        var _this3 = this;
        checkIfStateModificationsAreAllowed(this.atom_);
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: ADD,
                object: this,
                newValue: value
            });
            if (!change) return this;
            // implemented reassignment same as it's done for ObservableMap
            value = change.newValue;
        }
        if (!this.has(value)) {
            transaction(function() {
                _this3.data_.add(_this3.enhancer_(value, undefined));
                _this3.atom_.reportChanged();
            });
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: ADD,
                object: this,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, _change);
        }
        return this;
    };
    _proto["delete"] = function _delete(value) {
        var _this4 = this;
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: DELETE,
                object: this,
                oldValue: value
            });
            if (!change) return false;
        }
        if (this.has(value)) {
            var notifySpy = false;
            var notify = hasListeners(this);
            var _change2 = notify || notifySpy ? {
                observableKind: "set",
                debugObjectName: this.name_,
                type: DELETE,
                object: this,
                oldValue: value
            } : null;
            transaction(function() {
                _this4.atom_.reportChanged();
                _this4.data_["delete"](value);
            });
            if (notify) notifyListeners(this, _change2);
            return true;
        }
        return false;
    };
    _proto.has = function has(value) {
        this.atom_.reportObserved();
        return this.data_.has(this.dehanceValue_(value));
    };
    _proto.entries = function entries() {
        var values = this.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next = values.next(), value = _values$next.value, done = _values$next.done;
                return !done ? {
                    value: [
                        value,
                        value
                    ],
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.keys = function keys() {
        return this.values();
    };
    _proto.values = function values() {
        this.atom_.reportObserved();
        var self1 = this;
        var values = this.data_.values();
        return makeIterableForSet({
            next: function next() {
                var _values$next2 = values.next(), value = _values$next2.value, done = _values$next2.done;
                return !done ? {
                    value: self1.dehanceValue_(value),
                    done: done
                } : {
                    value: undefined,
                    done: done
                };
            }
        });
    };
    _proto.intersection = function intersection(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.intersection(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.intersection(otherSet);
        }
    };
    _proto.union = function union(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.union(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.union(otherSet);
        }
    };
    _proto.difference = function difference(otherSet) {
        return new Set(this).difference(otherSet);
    };
    _proto.symmetricDifference = function symmetricDifference(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.symmetricDifference(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.symmetricDifference(otherSet);
        }
    };
    _proto.isSubsetOf = function isSubsetOf(otherSet) {
        return new Set(this).isSubsetOf(otherSet);
    };
    _proto.isSupersetOf = function isSupersetOf(otherSet) {
        return new Set(this).isSupersetOf(otherSet);
    };
    _proto.isDisjointFrom = function isDisjointFrom(otherSet) {
        if (isES6Set(otherSet) && !isObservableSet(otherSet)) return otherSet.isDisjointFrom(this);
        else {
            var dehancedSet = new Set(this);
            return dehancedSet.isDisjointFrom(otherSet);
        }
    };
    _proto.replace = function replace(other) {
        var _this5 = this;
        if (isObservableSet(other)) other = new Set(other);
        transaction(function() {
            if (Array.isArray(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (isES6Set(other)) {
                _this5.clear();
                other.forEach(function(value) {
                    return _this5.add(value);
                });
            } else if (other !== null && other !== undefined) die("Cannot initialize set from " + other);
        });
        return this;
    };
    _proto.observe_ = function observe_(listener, fireImmediately) {
        return registerListener(this, listener);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.toJSON = function toJSON() {
        return Array.from(this);
    };
    _proto.toString = function toString() {
        return "[object ObservableSet]";
    };
    _proto[Symbol.iterator] = function() {
        return this.values();
    };
    return _createClass(ObservableSet, [
        {
            key: "size",
            get: function get() {
                this.atom_.reportObserved();
                return this.data_.size;
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Set";
            }
        }
    ]);
}();
// eslint-disable-next-line
var isObservableSet = /*#__PURE__*/ createInstanceofPredicate("ObservableSet", ObservableSet);
function makeIterableForSet(iterator) {
    iterator[Symbol.toStringTag] = "SetIterator";
    return makeIterable(iterator);
}
var descriptorCache = /*#__PURE__*/ Object.create(null);
var REMOVE = "remove";
var ObservableObjectAdministration = /*#__PURE__*/ function() {
    function ObservableObjectAdministration(target_, values_, name_, // Used anytime annotation is not explicitely provided
    defaultAnnotation_) {
        if (values_ === void 0) values_ = new Map();
        if (defaultAnnotation_ === void 0) defaultAnnotation_ = autoAnnotation;
        this.target_ = void 0;
        this.values_ = void 0;
        this.name_ = void 0;
        this.defaultAnnotation_ = void 0;
        this.keysAtom_ = void 0;
        this.changeListeners_ = void 0;
        this.interceptors_ = void 0;
        this.proxy_ = void 0;
        this.isPlainObject_ = void 0;
        this.appliedAnnotations_ = void 0;
        this.pendingKeys_ = void 0;
        this.target_ = target_;
        this.values_ = values_;
        this.name_ = name_;
        this.defaultAnnotation_ = defaultAnnotation_;
        this.keysAtom_ = new Atom("ObservableObject.keys");
        // Optimization: we use this frequently
        this.isPlainObject_ = isPlainObject(this.target_);
    }
    var _proto = ObservableObjectAdministration.prototype;
    _proto.getObservablePropValue_ = function getObservablePropValue_(key) {
        return this.values_.get(key).get();
    };
    _proto.setObservablePropValue_ = function setObservablePropValue_(key, newValue) {
        var observable = this.values_.get(key);
        if (observable instanceof ComputedValue) {
            observable.set(newValue);
            return true;
        }
        // intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                type: UPDATE,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: newValue
            });
            if (!change) return null;
            newValue = change.newValue;
        }
        newValue = observable.prepareNewValue_(newValue);
        // notify spy & observers
        if (newValue !== globalState.UNCHANGED) {
            var notify = hasListeners(this);
            var notifySpy = false;
            var _change = notify || notifySpy ? {
                type: UPDATE,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                oldValue: observable.value_,
                name: key,
                newValue: newValue
            } : null;
            observable.setNewValue_(newValue);
            if (notify) notifyListeners(this, _change);
        }
        return true;
    };
    _proto.get_ = function get_(key) {
        if (globalState.trackingDerivation && !hasProp(this.target_, key)) // Key doesn't exist yet, subscribe for it in case it's added later
        this.has_(key);
        return this.target_[key];
    };
    _proto.set_ = function set_(key, value, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        // Don't use .has(key) - we care about own
        if (hasProp(this.target_, key)) {
            // Existing prop
            if (this.values_.has(key)) // Observable (can be intercepted)
            return this.setObservablePropValue_(key, value);
            else if (proxyTrap) // Non-observable - proxy
            return Reflect.set(this.target_, key, value);
            else {
                // Non-observable
                this.target_[key] = value;
                return true;
            }
        } else // New prop
        return this.extend_(key, {
            value: value,
            enumerable: true,
            writable: true,
            configurable: true
        }, this.defaultAnnotation_, proxyTrap);
    };
    _proto.has_ = function has_(key) {
        if (!globalState.trackingDerivation) // Skip key subscription outside derivation
        return key in this.target_;
        this.pendingKeys_ || (this.pendingKeys_ = new Map());
        var entry = this.pendingKeys_.get(key);
        if (!entry) {
            entry = new ObservableValue(key in this.target_, referenceEnhancer, "ObservableObject.key?", false);
            this.pendingKeys_.set(key, entry);
        }
        return entry.get();
    };
    _proto.make_ = function make_(key, annotation) {
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return;
        assertAnnotable(this, annotation, key);
        if (!(key in this.target_)) {
            var _this$target_$storedA;
            // Throw on missing key, except for decorators:
            // Decorator annotations are collected from whole prototype chain.
            // When called from super() some props may not exist yet.
            // However we don't have to worry about missing prop,
            // because the decorator must have been applied to something.
            if ((_this$target_$storedA = this.target_[storedAnnotationsSymbol]) != null && _this$target_$storedA[key]) return; // will be annotated by subclass constructor
            else die(1, annotation.annotationType_, this.name_ + "." + key.toString());
        }
        var source = this.target_;
        while(source && source !== objectPrototype){
            var descriptor = getDescriptor(source, key);
            if (descriptor) {
                var outcome = annotation.make_(this, key, descriptor, source);
                if (outcome === 0 /* MakeResult.Cancel */ ) return;
                if (outcome === 1 /* MakeResult.Break */ ) break;
            }
            source = Object.getPrototypeOf(source);
        }
        recordAnnotationApplied(this, annotation, key);
    };
    _proto.extend_ = function extend_(key, descriptor, annotation, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        if (annotation === true) annotation = this.defaultAnnotation_;
        if (annotation === false) return this.defineProperty_(key, descriptor, proxyTrap);
        assertAnnotable(this, annotation, key);
        var outcome = annotation.extend_(this, key, descriptor, proxyTrap);
        if (outcome) recordAnnotationApplied(this, annotation, key);
        return outcome;
    };
    _proto.defineProperty_ = function defineProperty_(key, descriptor, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: descriptor.value
                });
                if (!change) return null;
                var newValue = change.newValue;
                if (descriptor.value !== newValue) descriptor = _extends({}, descriptor, {
                    value: newValue
                });
            }
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            // Notify
            this.notifyPropertyAddition_(key, descriptor.value);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineObservableProperty_ = function defineObservableProperty_(key, value, enhancer, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: value
                });
                if (!change) return null;
                value = change.newValue;
            }
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: true,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            var observable = new ObservableValue(value, enhancer, "ObservableObject.key", false);
            this.values_.set(key, observable);
            // Notify (value possibly changed by ObservableValue)
            this.notifyPropertyAddition_(key, observable.value_);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.defineComputedProperty_ = function defineComputedProperty_(key, options, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        try {
            startBatch();
            // Delete
            var deleteOutcome = this.delete_(key);
            if (!deleteOutcome) // Failure or intercepted
            return deleteOutcome;
            // ADD interceptor
            if (hasInterceptors(this)) {
                var change = interceptChange(this, {
                    object: this.proxy_ || this.target_,
                    name: key,
                    type: ADD,
                    newValue: undefined
                });
                if (!change) return null;
            }
            options.name || (options.name = "ObservableObject.key");
            options.context = this.proxy_ || this.target_;
            var cachedDescriptor = getCachedObservablePropDescriptor(key);
            var descriptor = {
                configurable: globalState.safeDescriptors ? this.isPlainObject_ : true,
                enumerable: false,
                get: cachedDescriptor.get,
                set: cachedDescriptor.set
            };
            // Define
            if (proxyTrap) {
                if (!Reflect.defineProperty(this.target_, key, descriptor)) return false;
            } else defineProperty(this.target_, key, descriptor);
            this.values_.set(key, new ComputedValue(options));
            // Notify
            this.notifyPropertyAddition_(key, undefined);
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.delete_ = function delete_(key, proxyTrap) {
        if (proxyTrap === void 0) proxyTrap = false;
        checkIfStateModificationsAreAllowed(this.keysAtom_);
        // No such prop
        if (!hasProp(this.target_, key)) return true;
        // Intercept
        if (hasInterceptors(this)) {
            var change = interceptChange(this, {
                object: this.proxy_ || this.target_,
                name: key,
                type: REMOVE
            });
            // Cancelled
            if (!change) return null;
        }
        // Delete
        try {
            var _this$pendingKeys_;
            startBatch();
            var notify = hasListeners(this);
            var notifySpy = false;
            var observable = this.values_.get(key);
            // Value needed for spies/listeners
            var value = undefined;
            // Optimization: don't pull the value unless we will need it
            if (!observable && (notify || notifySpy)) {
                var _getDescriptor;
                value = (_getDescriptor = getDescriptor(this.target_, key)) == null ? void 0 : _getDescriptor.value;
            }
            // delete prop (do first, may fail)
            if (proxyTrap) {
                if (!Reflect.deleteProperty(this.target_, key)) return false;
            } else delete this.target_[key];
            // Clear observable
            if (observable) {
                this.values_["delete"](key);
                // for computed, value is undefined
                if (observable instanceof ObservableValue) value = observable.value_;
                // Notify: autorun(() => obj[key]), see #1796
                propagateChanged(observable);
            }
            // Notify "keys/entries/values" observers
            this.keysAtom_.reportChanged();
            // Notify "has" observers
            // "in" as it may still exist in proto
            (_this$pendingKeys_ = this.pendingKeys_) == null || (_this$pendingKeys_ = _this$pendingKeys_.get(key)) == null || _this$pendingKeys_.set(key in this.target_);
            // Notify spies/listeners
            if (notify || notifySpy) {
                var _change2 = {
                    type: REMOVE,
                    observableKind: "object",
                    object: this.proxy_ || this.target_,
                    debugObjectName: this.name_,
                    oldValue: value,
                    name: key
                };
                if (notify) notifyListeners(this, _change2);
            }
        } finally{
            endBatch();
        }
        return true;
    };
    _proto.observe_ = function observe_(callback, fireImmediately) {
        return registerListener(this, callback);
    };
    _proto.intercept_ = function intercept_(handler) {
        return registerInterceptor(this, handler);
    };
    _proto.notifyPropertyAddition_ = function notifyPropertyAddition_(key, value) {
        var _this$pendingKeys_2;
        var notify = hasListeners(this);
        var notifySpy = false;
        if (notify || notifySpy) {
            var change = notify || notifySpy ? {
                type: ADD,
                observableKind: "object",
                debugObjectName: this.name_,
                object: this.proxy_ || this.target_,
                name: key,
                newValue: value
            } : null;
            if (notify) notifyListeners(this, change);
        }
        (_this$pendingKeys_2 = this.pendingKeys_) == null || (_this$pendingKeys_2 = _this$pendingKeys_2.get(key)) == null || _this$pendingKeys_2.set(true);
        // Notify "keys/entries/values" observers
        this.keysAtom_.reportChanged();
    };
    _proto.ownKeys_ = function ownKeys_() {
        this.keysAtom_.reportObserved();
        return ownKeys(this.target_);
    };
    _proto.keys_ = function keys_() {
        // Returns enumerable && own, but unfortunately keysAtom will report on ANY key change.
        // There is no way to distinguish between Object.keys(object) and Reflect.ownKeys(object) - both are handled by ownKeys trap.
        // We can either over-report in Object.keys(object) or under-report in Reflect.ownKeys(object)
        // We choose to over-report in Object.keys(object), because:
        // - typically it's used with simple data objects
        // - when symbolic/non-enumerable keys are relevant Reflect.ownKeys works as expected
        this.keysAtom_.reportObserved();
        return Object.keys(this.target_);
    };
    return ObservableObjectAdministration;
}();
function asObservableObject(target, options) {
    var _options$name;
    if (hasProp(target, $mobx)) return target;
    var name = (_options$name = options == null ? void 0 : options.name) != null ? _options$name : "ObservableObject";
    var adm = new ObservableObjectAdministration(target, new Map(), String(name), getAnnotationFromOptions(options));
    addHiddenProp(target, $mobx, adm);
    return target;
}
var isObservableObjectAdministration = /*#__PURE__*/ createInstanceofPredicate("ObservableObjectAdministration", ObservableObjectAdministration);
function getCachedObservablePropDescriptor(key) {
    return descriptorCache[key] || (descriptorCache[key] = {
        get: function get() {
            return this[$mobx].getObservablePropValue_(key);
        },
        set: function set(value) {
            return this[$mobx].setObservablePropValue_(key, value);
        }
    });
}
function isObservableObject(thing) {
    if (isObject(thing)) return isObservableObjectAdministration(thing[$mobx]);
    return false;
}
function recordAnnotationApplied(adm, annotation, key) {
    var _adm$target_$storedAn;
    // Remove applied decorator annotation so we don't try to apply it again in subclass constructor
    (_adm$target_$storedAn = adm.target_[storedAnnotationsSymbol]) == null || delete _adm$target_$storedAn[key];
}
function assertAnnotable(adm, annotation, key) {
    var fieldName, currentAnnotationType, requestedAnnotationType;
}
// Bug in safari 9.* (or iOS 9 safari mobile). See #364
var ENTRY_0 = /*#__PURE__*/ createArrayEntryDescriptor(0);
var safariPrototypeSetterInheritanceBug = /*#__PURE__*/ function() {
    var v = false;
    var p = {};
    Object.defineProperty(p, "0", {
        set: function set() {
            v = true;
        }
    });
    /*#__PURE__*/ Object.create(p)["0"] = 1;
    return v === false;
}();
/**
 * This array buffer contains two lists of properties, so that all arrays
 * can recycle their property definitions, which significantly improves performance of creating
 * properties on the fly.
 */ var OBSERVABLE_ARRAY_BUFFER_SIZE = 0;
// Typescript workaround to make sure ObservableArray extends Array
var StubArray = function StubArray() {};
function inherit(ctor, proto) {
    if (Object.setPrototypeOf) Object.setPrototypeOf(ctor.prototype, proto);
    else if (ctor.prototype.__proto__ !== undefined) ctor.prototype.__proto__ = proto;
    else ctor.prototype = proto;
}
inherit(StubArray, Array.prototype);
// Weex proto freeze protection was here,
// but it is unclear why the hack is need as MobX never changed the prototype
// anyway, so removed it in V6
var LegacyObservableArray = /*#__PURE__*/ function(_StubArray) {
    function LegacyObservableArray(initialValues, enhancer, name, owned) {
        var _this;
        if (name === void 0) name = "ObservableArray";
        if (owned === void 0) owned = false;
        _this = _StubArray.call(this) || this;
        initObservable(function() {
            var adm = new ObservableArrayAdministration(name, enhancer, owned, true);
            adm.proxy_ = _this;
            addHiddenFinalProp(_this, $mobx, adm);
            if (initialValues && initialValues.length) // @ts-ignore
            _this.spliceWithArray(0, 0, initialValues);
            if (safariPrototypeSetterInheritanceBug) // Seems that Safari won't use numeric prototype setter until any * numeric property is
            // defined on the instance. After that it works fine, even if this property is deleted.
            Object.defineProperty(_this, "0", ENTRY_0);
        });
        return _this;
    }
    _inheritsLoose(LegacyObservableArray, _StubArray);
    var _proto = LegacyObservableArray.prototype;
    _proto.concat = function concat() {
        this[$mobx].atom_.reportObserved();
        for(var _len = arguments.length, arrays = new Array(_len), _key = 0; _key < _len; _key++)arrays[_key] = arguments[_key];
        return Array.prototype.concat.apply(this.slice(), //@ts-ignore
        arrays.map(function(a) {
            return isObservableArray(a) ? a.slice() : a;
        }));
    };
    _proto[Symbol.iterator] = function() {
        var self1 = this;
        var nextIndex = 0;
        return makeIterable({
            next: function next() {
                return nextIndex < self1.length ? {
                    value: self1[nextIndex++],
                    done: false
                } : {
                    done: true,
                    value: undefined
                };
            }
        });
    };
    return _createClass(LegacyObservableArray, [
        {
            key: "length",
            get: function get() {
                return this[$mobx].getArrayLength_();
            },
            set: function set(newLength) {
                this[$mobx].setArrayLength_(newLength);
            }
        },
        {
            key: Symbol.toStringTag,
            get: function get() {
                return "Array";
            }
        }
    ]);
}(StubArray);
Object.entries(arrayExtensions).forEach(function(_ref) {
    var prop = _ref[0], fn = _ref[1];
    if (prop !== "concat") addHiddenProp(LegacyObservableArray.prototype, prop, fn);
});
function createArrayEntryDescriptor(index) {
    return {
        enumerable: false,
        configurable: true,
        get: function get() {
            return this[$mobx].get_(index);
        },
        set: function set(value) {
            this[$mobx].set_(index, value);
        }
    };
}
function createArrayBufferItem(index) {
    defineProperty(LegacyObservableArray.prototype, "" + index, createArrayEntryDescriptor(index));
}
function reserveArrayBuffer(max) {
    if (max > OBSERVABLE_ARRAY_BUFFER_SIZE) {
        for(var index = OBSERVABLE_ARRAY_BUFFER_SIZE; index < max + 100; index++)createArrayBufferItem(index);
        OBSERVABLE_ARRAY_BUFFER_SIZE = max;
    }
}
reserveArrayBuffer(1000);
function createLegacyArray(initialValues, enhancer, name) {
    return new LegacyObservableArray(initialValues, enhancer, name);
}
function getAtom(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray(thing)) {
            if (property !== undefined) die(23);
            return thing[$mobx].atom_;
        }
        if (isObservableSet(thing)) return thing.atom_;
        if (isObservableMap(thing)) {
            if (property === undefined) return thing.keysAtom_;
            var observable = thing.data_.get(property) || thing.hasMap_.get(property);
            if (!observable) die(25, property, getDebugName(thing));
            return observable;
        }
        if (isObservableObject(thing)) {
            if (!property) return die(26);
            var _observable = thing[$mobx].values_.get(property);
            if (!_observable) die(27, property, getDebugName(thing));
            return _observable;
        }
        if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    } else if (isFunction(thing)) {
        if (isReaction(thing[$mobx])) // disposer function
        return thing[$mobx];
    }
    die(28);
}
function getAdministration(thing, property) {
    if (!thing) die(29);
    if (property !== undefined) return getAdministration(getAtom(thing, property));
    if (isAtom(thing) || isComputedValue(thing) || isReaction(thing)) return thing;
    if (isObservableMap(thing) || isObservableSet(thing)) return thing;
    if (thing[$mobx]) return thing[$mobx];
    die(24, thing);
}
function getDebugName(thing, property) {
    var named;
    if (property !== undefined) named = getAtom(thing, property);
    else if (isAction(thing)) return thing.name;
    else if (isObservableObject(thing) || isObservableMap(thing) || isObservableSet(thing)) named = getAdministration(thing);
    else // valid for arrays as well
    named = getAtom(thing);
    return named.name_;
}
/**
 * Helper function for initializing observable structures, it applies:
 * 1. allowStateChanges so we don't violate enforceActions.
 * 2. untracked so we don't accidentaly subscribe to anything observable accessed during init in case the observable is created inside derivation.
 * 3. batch to avoid state version updates
 */ function initObservable(cb) {
    var derivation = untrackedStart();
    var allowStateChanges = allowStateChangesStart(true);
    startBatch();
    try {
        return cb();
    } finally{
        endBatch();
        allowStateChangesEnd(allowStateChanges);
        untrackedEnd(derivation);
    }
}
var toString = objectPrototype.toString;
function deepEqual(a, b, depth) {
    if (depth === void 0) depth = -1;
    return eq(a, b, depth);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Modified: "Deep compare objects" part to iterate over keys in forward order instead of reverse order.
//
// Internal recursive comparison function for `isEqual`.
function eq(a, b, depth, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object") return false;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch(className){
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a) return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b);
        case "[object Map]":
        case "[object Set]":
            // Maps and Sets are unwrapped to arrays of entry-pairs, adding an incidental level.
            // Hide this extra level by increasing the depth.
            if (depth >= 0) depth++;
            break;
    }
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object") return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor && !(isFunction(aCtor) && aCtor instanceof aCtor && isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
    }
    if (depth === 0) return false;
    else if (depth < 0) depth = -1;
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while(length--){
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a) return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length) return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while(length--){
            if (!eq(a[length], b[length], depth - 1, aStack, bStack)) return false;
        }
    } else {
        // Deep compare objects.
        var keys = Object.keys(a);
        var _length = keys.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== _length) return false;
        for(var i = 0; i < _length; i++){
            // Deep compare each member
            var key = keys[i];
            if (!(hasProp(b, key) && eq(a[key], b[key], depth - 1, aStack, bStack))) return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray(a)) return a.slice();
    if (isES6Map(a) || isObservableMap(a)) return Array.from(a.entries());
    if (isES6Set(a) || isObservableSet(a)) return Array.from(a.entries());
    return a;
}
var _getGlobal$Iterator;
// safely get iterator prototype if available
var maybeIteratorPrototype = ((_getGlobal$Iterator = /*#__PURE__*/ getGlobal().Iterator) == null ? void 0 : _getGlobal$Iterator.prototype) || {};
function makeIterable(iterator) {
    iterator[Symbol.iterator] = getSelf;
    return Object.assign(Object.create(maybeIteratorPrototype), iterator);
}
function getSelf() {
    return this;
}
function isAnnotation(thing) {
    return(// Can be function
    thing instanceof Object && typeof thing.annotationType_ === "string" && isFunction(thing.make_) && isFunction(thing.extend_));
}
/**
 * (c) Michel Weststrate 2015 - 2020
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get a global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */ [
    "Symbol",
    "Map",
    "Set"
].forEach(function(m) {
    var g = getGlobal();
    if (typeof g[m] === "undefined") die("MobX requires global '" + m + "' to be available or polyfilled");
});
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") // See: https://github.com/andykog/mobx-devtools/
__MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
    spy: spy,
    extras: {
        getDebugName: getDebugName
    },
    $mobx: $mobx
});

});

parcelRegister("7oYVV", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $563a0a6108185525$export$69ce8ef3fe5cead0, (v) => $563a0a6108185525$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $563a0a6108185525$export$d39a5bbd09211389, (v) => $563a0a6108185525$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $563a0a6108185525$export$cd75ccfd720a3cd4, (v) => $563a0a6108185525$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $563a0a6108185525$export$a0816fa17a9e79be, (v) => $563a0a6108185525$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $563a0a6108185525$export$7292efcadded39f3, (v) => $563a0a6108185525$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $563a0a6108185525$export$da407abadb9b8f86, (v) => $563a0a6108185525$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $563a0a6108185525$export$314cfea32580671c, (v) => $563a0a6108185525$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $563a0a6108185525$export$513ccb98c53b8039, (v) => $563a0a6108185525$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $563a0a6108185525$export$dbca993bc2d264a, (v) => $563a0a6108185525$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $563a0a6108185525$export$4797a8006f0655d0, (v) => $563a0a6108185525$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $563a0a6108185525$export$c78a37762a8d58e1, (v) => $563a0a6108185525$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $563a0a6108185525$export$606f11b2eb45ecc6, (v) => $563a0a6108185525$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $563a0a6108185525$export$f7e8a0bf92324b1e, (v) => $563a0a6108185525$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $563a0a6108185525$export$83d89fbfd8236492, (v) => $563a0a6108185525$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $563a0a6108185525$export$69ce8ef3fe5cead0;
var $563a0a6108185525$export$d39a5bbd09211389;
var $563a0a6108185525$export$cd75ccfd720a3cd4;
var $563a0a6108185525$export$a0816fa17a9e79be;
var $563a0a6108185525$export$7292efcadded39f3;
var $563a0a6108185525$export$da407abadb9b8f86;
var $563a0a6108185525$export$314cfea32580671c;
var $563a0a6108185525$export$513ccb98c53b8039;
var $563a0a6108185525$export$dbca993bc2d264a;
var $563a0a6108185525$export$4797a8006f0655d0;
var $563a0a6108185525$export$c78a37762a8d58e1;
var $563a0a6108185525$export$606f11b2eb45ecc6;
var $563a0a6108185525$export$f7e8a0bf92324b1e;
var $563a0a6108185525$export$83d89fbfd8236492;
"use strict";

var $dNU7X = parcelRequire("dNU7X");
function $563a0a6108185525$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $563a0a6108185525$var$noop() {}
var $563a0a6108185525$var$Internals = {
    d: {
        f: $563a0a6108185525$var$noop,
        r: function() {
            throw Error($563a0a6108185525$var$formatProdErrorMessage(522));
        },
        D: $563a0a6108185525$var$noop,
        C: $563a0a6108185525$var$noop,
        L: $563a0a6108185525$var$noop,
        m: $563a0a6108185525$var$noop,
        X: $563a0a6108185525$var$noop,
        S: $563a0a6108185525$var$noop,
        M: $563a0a6108185525$var$noop
    },
    p: 0,
    findDOMNode: null
}, $563a0a6108185525$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $563a0a6108185525$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $563a0a6108185525$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $563a0a6108185525$var$ReactSharedInternals = $dNU7X.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $563a0a6108185525$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$563a0a6108185525$export$69ce8ef3fe5cead0 = $563a0a6108185525$var$Internals;
$563a0a6108185525$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($563a0a6108185525$var$formatProdErrorMessage(299));
    return $563a0a6108185525$var$createPortal$1(children, container, null, key);
};
$563a0a6108185525$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $563a0a6108185525$var$ReactSharedInternals.T, previousUpdatePriority = $563a0a6108185525$var$Internals.p;
    try {
        if ($563a0a6108185525$var$ReactSharedInternals.T = null, $563a0a6108185525$var$Internals.p = 2, fn) return fn();
    } finally{
        $563a0a6108185525$var$ReactSharedInternals.T = previousTransition, $563a0a6108185525$var$Internals.p = previousUpdatePriority, $563a0a6108185525$var$Internals.d.f();
    }
};
$563a0a6108185525$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $563a0a6108185525$var$Internals.d.C(href, options));
};
$563a0a6108185525$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $563a0a6108185525$var$Internals.d.D(href);
};
$563a0a6108185525$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $563a0a6108185525$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $563a0a6108185525$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $563a0a6108185525$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$563a0a6108185525$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $563a0a6108185525$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $563a0a6108185525$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $563a0a6108185525$var$Internals.d.M(href);
    }
};
$563a0a6108185525$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $563a0a6108185525$var$getCrossOriginStringAs(as, options.crossOrigin);
        $563a0a6108185525$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$563a0a6108185525$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $563a0a6108185525$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $563a0a6108185525$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $563a0a6108185525$var$Internals.d.m(href);
    }
};
$563a0a6108185525$export$4797a8006f0655d0 = function(form) {
    $563a0a6108185525$var$Internals.d.r(form);
};
$563a0a6108185525$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$563a0a6108185525$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $563a0a6108185525$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$563a0a6108185525$export$f7e8a0bf92324b1e = function() {
    return $563a0a6108185525$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$563a0a6108185525$export$83d89fbfd8236492 = "19.1.1";

});
parcelRegister("dNU7X", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9x51g"));

});


parcelRegister("asJeQ", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $79df9c4e770270ed$export$306c0aa65ff9ec16, (v) => $79df9c4e770270ed$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $79df9c4e770270ed$export$306c0aa65ff9ec16;
"use strict";

var $dNU7X = parcelRequire("dNU7X");
function $79df9c4e770270ed$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $79df9c4e770270ed$var$objectIs = "function" === typeof Object.is ? Object.is : $79df9c4e770270ed$var$is, $79df9c4e770270ed$var$useState = $dNU7X.useState, $79df9c4e770270ed$var$useEffect = $dNU7X.useEffect, $79df9c4e770270ed$var$useLayoutEffect = $dNU7X.useLayoutEffect, $79df9c4e770270ed$var$useDebugValue = $dNU7X.useDebugValue;
function $79df9c4e770270ed$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $79df9c4e770270ed$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $79df9c4e770270ed$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $79df9c4e770270ed$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $79df9c4e770270ed$var$useEffect(function() {
        $79df9c4e770270ed$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $79df9c4e770270ed$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $79df9c4e770270ed$var$useDebugValue(value);
    return value;
}
function $79df9c4e770270ed$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$79df9c4e770270ed$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $79df9c4e770270ed$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $79df9c4e770270ed$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $79df9c4e770270ed$var$useSyncExternalStore$1 : $79df9c4e770270ed$var$useSyncExternalStore$2;
$79df9c4e770270ed$export$306c0aa65ff9ec16 = void 0 !== $dNU7X.useSyncExternalStore ? $dNU7X.useSyncExternalStore : $79df9c4e770270ed$var$shim;

});

parcelRegister("ceFTv", function(module, exports) {

$parcel$export(module.exports, "__generator", () => $8e874a2fb001c377$export$67ebef60e6f28a6);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $8e874a2fb001c377$var$extendStatics = function(d, b) {
    $8e874a2fb001c377$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $8e874a2fb001c377$var$extendStatics(d, b);
};
function $8e874a2fb001c377$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $8e874a2fb001c377$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $8e874a2fb001c377$export$18ce0697a983be9b = function() {
    $8e874a2fb001c377$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8e874a2fb001c377$export$18ce0697a983be9b.apply(this, arguments);
};
function $8e874a2fb001c377$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $8e874a2fb001c377$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $8e874a2fb001c377$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $8e874a2fb001c377$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $8e874a2fb001c377$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $8e874a2fb001c377$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $8e874a2fb001c377$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $8e874a2fb001c377$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $8e874a2fb001c377$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $8e874a2fb001c377$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $8e874a2fb001c377$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $8e874a2fb001c377$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $8e874a2fb001c377$export$45d3717a4c69092e(o, m, p);
}
function $8e874a2fb001c377$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $8e874a2fb001c377$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $8e874a2fb001c377$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($8e874a2fb001c377$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $8e874a2fb001c377$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $8e874a2fb001c377$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $8e874a2fb001c377$export$10c90e4f7922046c(v) {
    return this instanceof $8e874a2fb001c377$export$10c90e4f7922046c ? (this.v = v, this) : new $8e874a2fb001c377$export$10c90e4f7922046c(v);
}
function $8e874a2fb001c377$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $8e874a2fb001c377$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $8e874a2fb001c377$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $8e874a2fb001c377$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $8e874a2fb001c377$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $8e874a2fb001c377$export$19a8beecd37a4c45 === "function" ? $8e874a2fb001c377$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $8e874a2fb001c377$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $8e874a2fb001c377$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $8e874a2fb001c377$var$ownKeys = function(o) {
    $8e874a2fb001c377$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $8e874a2fb001c377$var$ownKeys(o);
};
function $8e874a2fb001c377$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $8e874a2fb001c377$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $8e874a2fb001c377$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $8e874a2fb001c377$var$__setModuleDefault(result, mod);
    return result;
}
function $8e874a2fb001c377$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $8e874a2fb001c377$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $8e874a2fb001c377$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $8e874a2fb001c377$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $8e874a2fb001c377$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $8e874a2fb001c377$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $8e874a2fb001c377$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $8e874a2fb001c377$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $8e874a2fb001c377$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $8e874a2fb001c377$export$2e2bcd8739ae039 = {
    __extends: $8e874a2fb001c377$export$a8ba968b8961cb8a,
    __assign: $8e874a2fb001c377$export$18ce0697a983be9b,
    __rest: $8e874a2fb001c377$export$3c9a16f847548506,
    __decorate: $8e874a2fb001c377$export$29e00dfd3077644b,
    __param: $8e874a2fb001c377$export$d5ad3fd78186038f,
    __esDecorate: $8e874a2fb001c377$export$3a84e1ae4e97e9b0,
    __runInitializers: $8e874a2fb001c377$export$d831c04e792af3d,
    __propKey: $8e874a2fb001c377$export$6a2a36740a146cb8,
    __setFunctionName: $8e874a2fb001c377$export$d1a06452d3489bc7,
    __metadata: $8e874a2fb001c377$export$f1db080c865becb9,
    __awaiter: $8e874a2fb001c377$export$1050f835b63b671e,
    __generator: $8e874a2fb001c377$export$67ebef60e6f28a6,
    __createBinding: $8e874a2fb001c377$export$45d3717a4c69092e,
    __exportStar: $8e874a2fb001c377$export$f33643c0debef087,
    __values: $8e874a2fb001c377$export$19a8beecd37a4c45,
    __read: $8e874a2fb001c377$export$8d051b38c9118094,
    __spread: $8e874a2fb001c377$export$afc72e2116322959,
    __spreadArrays: $8e874a2fb001c377$export$6388937ca91ccae8,
    __spreadArray: $8e874a2fb001c377$export$1216008129fb82ed,
    __await: $8e874a2fb001c377$export$10c90e4f7922046c,
    __asyncGenerator: $8e874a2fb001c377$export$e427f37a30a4de9b,
    __asyncDelegator: $8e874a2fb001c377$export$bbd80228419bb833,
    __asyncValues: $8e874a2fb001c377$export$e3b29a3d6162315f,
    __makeTemplateObject: $8e874a2fb001c377$export$4fb47efe1390b86f,
    __importStar: $8e874a2fb001c377$export$c21735bcef00d192,
    __importDefault: $8e874a2fb001c377$export$da59b14a69baef04,
    __classPrivateFieldGet: $8e874a2fb001c377$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $8e874a2fb001c377$export$d40a35129aaff81f,
    __classPrivateFieldIn: $8e874a2fb001c377$export$81fdc39f203e4e04,
    __addDisposableResource: $8e874a2fb001c377$export$88ac25d8e944e405,
    __disposeResources: $8e874a2fb001c377$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $8e874a2fb001c377$export$889dfb5d17574b0b
};

});

parcelRegister("bYRhh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8b8ea0274baf1c04$export$2e2bcd8739ae039);

var $dNU7X = parcelRequire("dNU7X");

var $5Ndpg = parcelRequire("5Ndpg");

var $62bxO = parcelRequire("62bxO");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $8b8ea0274baf1c04$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $8b8ea0274baf1c04$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $8b8ea0274baf1c04$var$ReactEditorJS(_a) {
    var { factory: factory, holder: holder, defaultValue: defaultValue, children: children, value: value, onInitialize: onInitialize } = _a, restProps = $8b8ea0274baf1c04$var$__rest(_a, [
        "factory",
        "holder",
        "defaultValue",
        "children",
        "value",
        "onInitialize"
    ]);
    const memoizedHolder = (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).useRef(holder !== null && holder !== void 0 ? holder : `react-editor-js-${Date.now().toString(16)}`);
    const editorJS = (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).useEffect(()=>{
        editorJS.current = factory(Object.assign(Object.assign({
            holder: memoizedHolder.current
        }, defaultValue && {
            data: defaultValue
        }), restProps));
        onInitialize === null || onInitialize === void 0 || onInitialize(editorJS.current);
        return ()=>{
            var _a;
            (_a = editorJS.current) === null || _a === void 0 || _a.destroy();
        };
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).useEffect(()=>{
        var _a;
        if (value) (_a = editorJS.current) === null || _a === void 0 || _a.render(value);
    }, [
        value
    ]);
    return children || (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).createElement("div", {
        id: memoizedHolder.current
    });
}
class $8b8ea0274baf1c04$var$ClientEditorCore {
    constructor(_a){
        var { tools: tools } = _a, config = $8b8ea0274baf1c04$var$__rest(_a, [
            "tools"
        ]);
        const extendTools = Object.assign({
            // default tools
            paragraph: {
                class: (0, $62bxO.default),
                inlineToolbar: true
            }
        }, tools);
        this._editorJS = new (0, $5Ndpg.default)(Object.assign({
            tools: extendTools
        }, config));
    }
    get dangerouslyLowLevelInstance() {
        return this._editorJS;
    }
    clear() {
        return $8b8ea0274baf1c04$var$__awaiter(this, void 0, void 0, function*() {
            yield this._editorJS.clear();
        });
    }
    save() {
        return $8b8ea0274baf1c04$var$__awaiter(this, void 0, void 0, function*() {
            return this._editorJS.save();
        });
    }
    destroy() {
        return $8b8ea0274baf1c04$var$__awaiter(this, void 0, void 0, function*() {
            yield this._editorJS.isReady;
            yield this._editorJS.destroy();
        });
    }
    render(data) {
        return $8b8ea0274baf1c04$var$__awaiter(this, void 0, void 0, function*() {
            yield this._editorJS.render(data);
        });
    }
}
function $8b8ea0274baf1c04$export$2e2bcd8739ae039(props) {
    const factory = (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).useCallback((config)=>new $8b8ea0274baf1c04$var$ClientEditorCore(config), []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).createElement($8b8ea0274baf1c04$var$ReactEditorJS, Object.assign({
        factory: factory
    }, props));
}

});
parcelRegister("5Ndpg", function(module, exports) {

$parcel$export(module.exports, "default", () => $cdae29d26d2e7999$export$2e2bcd8739ae039);
(function() {
    "use strict";
    try {
        if (typeof document < "u") {
            var e = document.createElement("style");
            e.appendChild(document.createTextNode(".ce-hint--align-start{text-align:left}.ce-hint--align-center{text-align:center}.ce-hint__description{opacity:.6;margin-top:3px}")), document.head.appendChild(e);
        }
    } catch (t1) {
        console.error("vite-plugin-css-injected-by-js", t1);
    }
})();
var $cdae29d26d2e7999$var$Ce = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof $parcel$global < "u" ? $parcel$global : typeof self < "u" ? self : {};
function $cdae29d26d2e7999$var$Ke(n) {
    return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
function $cdae29d26d2e7999$var$Xn(n) {
    if (n.__esModule) return n;
    var e = n.default;
    if (typeof e == "function") {
        var t1 = function o() {
            return this instanceof o ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
        };
        t1.prototype = e.prototype;
    } else t1 = {};
    return Object.defineProperty(t1, "__esModule", {
        value: !0
    }), Object.keys(n).forEach(function(o) {
        var i = Object.getOwnPropertyDescriptor(n, o);
        Object.defineProperty(t1, o, i.get ? i : {
            enumerable: !0,
            get: function() {
                return n[o];
            }
        });
    }), t1;
}
function $cdae29d26d2e7999$var$ot() {}
Object.assign($cdae29d26d2e7999$var$ot, {
    default: $cdae29d26d2e7999$var$ot,
    register: $cdae29d26d2e7999$var$ot,
    revert: function() {},
    __esModule: !0
});
Element.prototype.matches || (Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function(n) {
    const e = (this.document || this.ownerDocument).querySelectorAll(n);
    let t1 = e.length;
    for(; --t1 >= 0 && e.item(t1) !== this;);
    return t1 > -1;
});
Element.prototype.closest || (Element.prototype.closest = function(n) {
    let e = this;
    if (!document.documentElement.contains(e)) return null;
    do {
        if (e.matches(n)) return e;
        e = e.parentElement || e.parentNode;
    }while (e !== null);
    return null;
});
Element.prototype.prepend || (Element.prototype.prepend = function(e) {
    const t1 = document.createDocumentFragment();
    Array.isArray(e) || (e = [
        e
    ]), e.forEach((o)=>{
        const i = o instanceof Node;
        t1.appendChild(i ? o : document.createTextNode(o));
    }), this.insertBefore(t1, this.firstChild);
});
Element.prototype.scrollIntoViewIfNeeded || (Element.prototype.scrollIntoViewIfNeeded = function(n) {
    n = arguments.length === 0 ? !0 : !!n;
    const e = this.parentNode, t1 = window.getComputedStyle(e, null), o = parseInt(t1.getPropertyValue("border-top-width")), i = parseInt(t1.getPropertyValue("border-left-width")), s = this.offsetTop - e.offsetTop < e.scrollTop, r = this.offsetTop - e.offsetTop + this.clientHeight - o > e.scrollTop + e.clientHeight, a = this.offsetLeft - e.offsetLeft < e.scrollLeft, l = this.offsetLeft - e.offsetLeft + this.clientWidth - i > e.scrollLeft + e.clientWidth, c = s && !r;
    (s || r) && n && (e.scrollTop = this.offsetTop - e.offsetTop - e.clientHeight / 2 - o + this.clientHeight / 2), (a || l) && n && (e.scrollLeft = this.offsetLeft - e.offsetLeft - e.clientWidth / 2 - i + this.clientWidth / 2), (s || r || a || l) && !n && this.scrollIntoView(c);
});
window.requestIdleCallback = window.requestIdleCallback || function(n) {
    const e = Date.now();
    return setTimeout(function() {
        n({
            didTimeout: !1,
            timeRemaining: function() {
                return Math.max(0, 50 - (Date.now() - e));
            }
        });
    }, 1);
};
window.cancelIdleCallback = window.cancelIdleCallback || function(n) {
    clearTimeout(n);
};
let $cdae29d26d2e7999$var$Vn = (n = 21)=>crypto.getRandomValues(new Uint8Array(n)).reduce((e, t1)=>(t1 &= 63, t1 < 36 ? e += t1.toString(36) : t1 < 62 ? e += (t1 - 26).toString(36).toUpperCase() : t1 > 62 ? e += "-" : e += "_", e), "");
var $cdae29d26d2e7999$var$Lo = /* @__PURE__ */ ((n)=>(n.VERBOSE = "VERBOSE", n.INFO = "INFO", n.WARN = "WARN", n.ERROR = "ERROR", n))($cdae29d26d2e7999$var$Lo || {});
const $cdae29d26d2e7999$var$y = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    DOWN: 40,
    RIGHT: 39,
    DELETE: 46,
    META: 91,
    SLASH: 191
}, $cdae29d26d2e7999$var$qn = {
    LEFT: 0,
    WHEEL: 1,
    RIGHT: 2,
    BACKWARD: 3,
    FORWARD: 4
};
function $cdae29d26d2e7999$var$Ie(n, e, t1 = "log", o, i = "color: inherit") {
    if (!("console" in window) || !window.console[t1]) return;
    const s = [
        "info",
        "log",
        "warn",
        "error"
    ].includes(t1), r = [];
    switch($cdae29d26d2e7999$var$Ie.logLevel){
        case "ERROR":
            if (t1 !== "error") return;
            break;
        case "WARN":
            if (![
                "error",
                "warn"
            ].includes(t1)) return;
            break;
        case "INFO":
            if (!s || n) return;
            break;
    }
    o && r.push(o);
    const a = "Editor.js 2.31.0", l = `line-height: 1em;
            color: #006FEA;
            display: inline-block;
            font-size: 11px;
            line-height: 1em;
            background-color: #fff;
            padding: 4px 9px;
            border-radius: 30px;
            border: 1px solid rgba(56, 138, 229, 0.16);
            margin: 4px 5px 4px 0;`;
    n && (s ? (r.unshift(l, i), e = `%c${a}%c ${e}`) : e = `( ${a} )${e}`);
    try {
        s ? o ? console[t1](`${e} %o`, ...r) : console[t1](e, ...r) : console[t1](e);
    } catch  {}
}
$cdae29d26d2e7999$var$Ie.logLevel = "VERBOSE";
function $cdae29d26d2e7999$var$Zn(n) {
    $cdae29d26d2e7999$var$Ie.logLevel = n;
}
const $cdae29d26d2e7999$var$S = $cdae29d26d2e7999$var$Ie.bind(window, !1), $cdae29d26d2e7999$var$X = $cdae29d26d2e7999$var$Ie.bind(window, !0);
function $cdae29d26d2e7999$var$le(n) {
    return Object.prototype.toString.call(n).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}
function $cdae29d26d2e7999$var$A(n) {
    return $cdae29d26d2e7999$var$le(n) === "function" || $cdae29d26d2e7999$var$le(n) === "asyncfunction";
}
function $cdae29d26d2e7999$var$D(n) {
    return $cdae29d26d2e7999$var$le(n) === "object";
}
function $cdae29d26d2e7999$var$te(n) {
    return $cdae29d26d2e7999$var$le(n) === "string";
}
function $cdae29d26d2e7999$var$Gn(n) {
    return $cdae29d26d2e7999$var$le(n) === "boolean";
}
function $cdae29d26d2e7999$var$yo(n) {
    return $cdae29d26d2e7999$var$le(n) === "number";
}
function $cdae29d26d2e7999$var$wo(n) {
    return $cdae29d26d2e7999$var$le(n) === "undefined";
}
function $cdae29d26d2e7999$var$V(n) {
    return n ? Object.keys(n).length === 0 && n.constructor === Object : !0;
}
function $cdae29d26d2e7999$var$Po(n) {
    return n > 47 && n < 58 || // number keys
    n === 32 || n === 13 || // Space bar & return key(s)
    n === 229 || // processing key input for certain languages — Chinese, Japanese, etc.
    n > 64 && n < 91 || // letter keys
    n > 95 && n < 112 || // Numpad keys
    n > 185 && n < 193 || // ;=,-./` (in order)
    n > 218 && n < 223;
}
async function $cdae29d26d2e7999$var$Qn(n, e = ()=>{}, t1 = ()=>{}) {
    async function o(i, s, r) {
        try {
            await i.function(i.data), await s($cdae29d26d2e7999$var$wo(i.data) ? {} : i.data);
        } catch  {
            r($cdae29d26d2e7999$var$wo(i.data) ? {} : i.data);
        }
    }
    return n.reduce(async (i, s)=>(await i, o(s, e, t1)), Promise.resolve());
}
function $cdae29d26d2e7999$var$No(n) {
    return Array.prototype.slice.call(n);
}
function $cdae29d26d2e7999$var$Fe(n, e) {
    return function() {
        const t1 = this, o = arguments;
        window.setTimeout(()=>n.apply(t1, o), e);
    };
}
function $cdae29d26d2e7999$var$Jn(n) {
    return n.name.split(".").pop();
}
function $cdae29d26d2e7999$var$ei(n) {
    return /^[-\w]+\/([-+\w]+|\*)$/.test(n);
}
function $cdae29d26d2e7999$var$Eo(n, e, t1) {
    let o;
    return (...i)=>{
        const s = this, r = ()=>{
            o = null, t1 || n.apply(s, i);
        }, a = t1 && !o;
        window.clearTimeout(o), o = window.setTimeout(r, e), a && n.apply(s, i);
    };
}
function $cdae29d26d2e7999$var$dt(n, e, t1) {
    let o, i, s, r = null, a = 0;
    t1 || (t1 = {});
    const l = function() {
        a = t1.leading === !1 ? 0 : Date.now(), r = null, s = n.apply(o, i), r || (o = i = null);
    };
    return function() {
        const c = Date.now();
        !a && t1.leading === !1 && (a = c);
        const d = e - (c - a);
        return o = this, i = arguments, d <= 0 || d > e ? (r && (clearTimeout(r), r = null), a = c, s = n.apply(o, i), r || (o = i = null)) : !r && t1.trailing !== !1 && (r = setTimeout(l, d)), s;
    };
}
function $cdae29d26d2e7999$var$ti() {
    const n = {
        win: !1,
        mac: !1,
        x11: !1,
        linux: !1
    }, e = Object.keys(n).find((t1)=>window.navigator.appVersion.toLowerCase().indexOf(t1) !== -1);
    return e && (n[e] = !0), n;
}
function $cdae29d26d2e7999$var$je(n) {
    return n[0].toUpperCase() + n.slice(1);
}
function $cdae29d26d2e7999$var$ut(n, ...e) {
    if (!e.length) return n;
    const t1 = e.shift();
    if ($cdae29d26d2e7999$var$D(n) && $cdae29d26d2e7999$var$D(t1)) for(const o in t1)$cdae29d26d2e7999$var$D(t1[o]) ? (n[o] || Object.assign(n, {
        [o]: {}
    }), $cdae29d26d2e7999$var$ut(n[o], t1[o])) : Object.assign(n, {
        [o]: t1[o]
    });
    return $cdae29d26d2e7999$var$ut(n, ...e);
}
function $cdae29d26d2e7999$var$vt(n) {
    const e = $cdae29d26d2e7999$var$ti();
    return n = n.replace(/shift/gi, "\u21E7").replace(/backspace/gi, "\u232B").replace(/enter/gi, "\u23CE").replace(/up/gi, "\u2191").replace(/left/gi, "\u2192").replace(/down/gi, "\u2193").replace(/right/gi, "\u2190").replace(/escape/gi, "\u238B").replace(/insert/gi, "Ins").replace(/delete/gi, "\u2421").replace(/\+/gi, " + "), e.mac ? n = n.replace(/ctrl|cmd/gi, "\u2318").replace(/alt/gi, "\u2325") : n = n.replace(/cmd/gi, "Ctrl").replace(/windows/gi, "WIN"), n;
}
function $cdae29d26d2e7999$var$oi(n) {
    try {
        return new URL(n).href;
    } catch  {}
    return n.substring(0, 2) === "//" ? window.location.protocol + n : window.location.origin + n;
}
function $cdae29d26d2e7999$var$ni() {
    return $cdae29d26d2e7999$var$Vn(10);
}
function $cdae29d26d2e7999$var$ii(n) {
    window.open(n, "_blank");
}
function $cdae29d26d2e7999$var$si(n = "") {
    return `${n}${Math.floor(Math.random() * 1e8).toString(16)}`;
}
function $cdae29d26d2e7999$var$ht(n, e, t1) {
    const o = `\xab${e}\xbb is deprecated and will be removed in the next major release. Please use the \xab${t1}\xbb instead.`;
    n && $cdae29d26d2e7999$var$X(o, "warn");
}
function $cdae29d26d2e7999$var$me(n, e, t1) {
    const o = t1.value ? "value" : "get", i = t1[o], s = `#${e}Cache`;
    if (t1[o] = function(...r) {
        return this[s] === void 0 && (this[s] = i.apply(this, ...r)), this[s];
    }, o === "get" && t1.set) {
        const r = t1.set;
        t1.set = function(a) {
            delete n[s], r.apply(this, a);
        };
    }
    return t1;
}
const $cdae29d26d2e7999$var$Ro = 650;
function $cdae29d26d2e7999$var$be() {
    return window.matchMedia(`(max-width: ${$cdae29d26d2e7999$var$Ro}px)`).matches;
}
const $cdae29d26d2e7999$var$pt = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
function $cdae29d26d2e7999$var$ri(n, e) {
    const t1 = Array.isArray(n) || $cdae29d26d2e7999$var$D(n), o = Array.isArray(e) || $cdae29d26d2e7999$var$D(e);
    return t1 || o ? JSON.stringify(n) === JSON.stringify(e) : n === e;
}
class $cdae29d26d2e7999$var$u {
    /**
   * Check if passed tag has no closed tag
   *
   * @param {HTMLElement} tag - element to check
   * @returns {boolean}
   */ static isSingleTag(e) {
        return e.tagName && [
            "AREA",
            "BASE",
            "BR",
            "COL",
            "COMMAND",
            "EMBED",
            "HR",
            "IMG",
            "INPUT",
            "KEYGEN",
            "LINK",
            "META",
            "PARAM",
            "SOURCE",
            "TRACK",
            "WBR"
        ].includes(e.tagName);
    }
    /**
   * Check if element is BR or WBR
   *
   * @param {HTMLElement} element - element to check
   * @returns {boolean}
   */ static isLineBreakTag(e) {
        return e && e.tagName && [
            "BR",
            "WBR"
        ].includes(e.tagName);
    }
    /**
   * Helper for making Elements with class name and attributes
   *
   * @param  {string} tagName - new Element tag name
   * @param  {string[]|string} [classNames] - list or name of CSS class name(s)
   * @param  {object} [attributes] - any attributes
   * @returns {HTMLElement}
   */ static make(e, t1 = null, o = {}) {
        const i = document.createElement(e);
        if (Array.isArray(t1)) {
            const s = t1.filter((r)=>r !== void 0);
            i.classList.add(...s);
        } else t1 && i.classList.add(t1);
        for(const s in o)Object.prototype.hasOwnProperty.call(o, s) && (i[s] = o[s]);
        return i;
    }
    /**
   * Creates Text Node with the passed content
   *
   * @param {string} content - text content
   * @returns {Text}
   */ static text(e) {
        return document.createTextNode(e);
    }
    /**
   * Append one or several elements to the parent
   *
   * @param  {Element|DocumentFragment} parent - where to append
   * @param  {Element|Element[]|DocumentFragment|Text|Text[]} elements - element or elements list
   */ static append(e, t1) {
        Array.isArray(t1) ? t1.forEach((o)=>e.appendChild(o)) : e.appendChild(t1);
    }
    /**
   * Append element or a couple to the beginning of the parent elements
   *
   * @param {Element} parent - where to append
   * @param {Element|Element[]} elements - element or elements list
   */ static prepend(e, t1) {
        Array.isArray(t1) ? (t1 = t1.reverse(), t1.forEach((o)=>e.prepend(o))) : e.prepend(t1);
    }
    /**
   * Swap two elements in parent
   *
   * @param {HTMLElement} el1 - from
   * @param {HTMLElement} el2 - to
   * @deprecated
   */ static swap(e, t1) {
        const o = document.createElement("div"), i = e.parentNode;
        i.insertBefore(o, e), i.insertBefore(e, t1), i.insertBefore(t1, o), i.removeChild(o);
    }
    /**
   * Selector Decorator
   *
   * Returns first match
   *
   * @param {Element} el - element we searching inside. Default - DOM Document
   * @param {string} selector - searching string
   * @returns {Element}
   */ static find(e = document, t1) {
        return e.querySelector(t1);
    }
    /**
   * Get Element by Id
   *
   * @param {string} id - id to find
   * @returns {HTMLElement | null}
   */ static get(e) {
        return document.getElementById(e);
    }
    /**
   * Selector Decorator.
   *
   * Returns all matches
   *
   * @param {Element|Document} el - element we searching inside. Default - DOM Document
   * @param {string} selector - searching string
   * @returns {NodeList}
   */ static findAll(e = document, t1) {
        return e.querySelectorAll(t1);
    }
    /**
   * Returns CSS selector for all text inputs
   */ static get allInputsSelector() {
        return "[contenteditable=true], textarea, input:not([type]), " + [
            "text",
            "password",
            "email",
            "number",
            "search",
            "tel",
            "url"
        ].map((t1)=>`input[type="${t1}"]`).join(", ");
    }
    /**
   * Find all contenteditable, textarea and editable input elements passed holder contains
   *
   * @param holder - element where to find inputs
   */ static findAllInputs(e) {
        return $cdae29d26d2e7999$var$No(e.querySelectorAll($cdae29d26d2e7999$var$u.allInputsSelector)).reduce((t1, o)=>$cdae29d26d2e7999$var$u.isNativeInput(o) || $cdae29d26d2e7999$var$u.containsOnlyInlineElements(o) ? [
                ...t1,
                o
            ] : [
                ...t1,
                ...$cdae29d26d2e7999$var$u.getDeepestBlockElements(o)
            ], []);
    }
    /**
   * Search for deepest node which is Leaf.
   * Leaf is the vertex that doesn't have any child nodes
   *
   * @description Method recursively goes throw the all Node until it finds the Leaf
   * @param {Node} node - root Node. From this vertex we start Deep-first search
   *                      {@link https://en.wikipedia.org/wiki/Depth-first_search}
   * @param {boolean} [atLast] - find last text node
   * @returns - it can be text Node or Element Node, so that caret will able to work with it
   *            Can return null if node is Document or DocumentFragment, or node is not attached to the DOM
   */ static getDeepestNode(e, t1 = !1) {
        const o = t1 ? "lastChild" : "firstChild", i = t1 ? "previousSibling" : "nextSibling";
        if (e && e.nodeType === Node.ELEMENT_NODE && e[o]) {
            let s = e[o];
            if ($cdae29d26d2e7999$var$u.isSingleTag(s) && !$cdae29d26d2e7999$var$u.isNativeInput(s) && !$cdae29d26d2e7999$var$u.isLineBreakTag(s)) {
                if (s[i]) s = s[i];
                else if (s.parentNode[i]) s = s.parentNode[i];
                else return s.parentNode;
            }
            return this.getDeepestNode(s, t1);
        }
        return e;
    }
    /**
   * Check if object is DOM node
   *
   * @param {*} node - object to check
   * @returns {boolean}
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static isElement(e) {
        return $cdae29d26d2e7999$var$yo(e) ? !1 : e && e.nodeType && e.nodeType === Node.ELEMENT_NODE;
    }
    /**
   * Check if object is DocumentFragment node
   *
   * @param {object} node - object to check
   * @returns {boolean}
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static isFragment(e) {
        return $cdae29d26d2e7999$var$yo(e) ? !1 : e && e.nodeType && e.nodeType === Node.DOCUMENT_FRAGMENT_NODE;
    }
    /**
   * Check if passed element is contenteditable
   *
   * @param {HTMLElement} element - html element to check
   * @returns {boolean}
   */ static isContentEditable(e) {
        return e.contentEditable === "true";
    }
    /**
   * Checks target if it is native input
   *
   * @param {*} target - HTML element or string
   * @returns {boolean}
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    static isNativeInput(e) {
        const t1 = [
            "INPUT",
            "TEXTAREA"
        ];
        return e && e.tagName ? t1.includes(e.tagName) : !1;
    }
    /**
   * Checks if we can set caret
   *
   * @param {HTMLElement} target - target to check
   * @returns {boolean}
   */ static canSetCaret(e) {
        let t1 = !0;
        if ($cdae29d26d2e7999$var$u.isNativeInput(e)) switch(e.type){
            case "file":
            case "checkbox":
            case "radio":
            case "hidden":
            case "submit":
            case "button":
            case "image":
            case "reset":
                t1 = !1;
                break;
        }
        else t1 = $cdae29d26d2e7999$var$u.isContentEditable(e);
        return t1;
    }
    /**
   * Checks node if it is empty
   *
   * @description Method checks simple Node without any childs for emptiness
   * If you have Node with 2 or more children id depth, you better use {@link Dom#isEmpty} method
   * @param {Node} node - node to check
   * @param {string} [ignoreChars] - char or substring to treat as empty
   * @returns {boolean} true if it is empty
   */ static isNodeEmpty(e, t1) {
        let o;
        return this.isSingleTag(e) && !this.isLineBreakTag(e) ? !1 : (this.isElement(e) && this.isNativeInput(e) ? o = e.value : o = e.textContent.replace("\u200B", ""), t1 && (o = o.replace(new RegExp(t1, "g"), "")), o.length === 0);
    }
    /**
   * checks node if it is doesn't have any child nodes
   *
   * @param {Node} node - node to check
   * @returns {boolean}
   */ static isLeaf(e) {
        return e ? e.childNodes.length === 0 : !1;
    }
    /**
   * breadth-first search (BFS)
   * {@link https://en.wikipedia.org/wiki/Breadth-first_search}
   *
   * @description Pushes to stack all DOM leafs and checks for emptiness
   * @param {Node} node - node to check
   * @param {string} [ignoreChars] - char or substring to treat as empty
   * @returns {boolean}
   */ static isEmpty(e, t1) {
        const o = [
            e
        ];
        for(; o.length > 0;)if (e = o.shift(), !!e) {
            if (this.isLeaf(e) && !this.isNodeEmpty(e, t1)) return !1;
            e.childNodes && o.push(...Array.from(e.childNodes));
        }
        return !0;
    }
    /**
   * Check if string contains html elements
   *
   * @param {string} str - string to check
   * @returns {boolean}
   */ static isHTMLString(e) {
        const t1 = $cdae29d26d2e7999$var$u.make("div");
        return t1.innerHTML = e, t1.childElementCount > 0;
    }
    /**
   * Return length of node`s text content
   *
   * @param {Node} node - node with content
   * @returns {number}
   */ static getContentLength(e) {
        return $cdae29d26d2e7999$var$u.isNativeInput(e) ? e.value.length : e.nodeType === Node.TEXT_NODE ? e.length : e.textContent.length;
    }
    /**
   * Return array of names of block html elements
   *
   * @returns {string[]}
   */ static get blockElements() {
        return [
            "address",
            "article",
            "aside",
            "blockquote",
            "canvas",
            "div",
            "dl",
            "dt",
            "fieldset",
            "figcaption",
            "figure",
            "footer",
            "form",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "header",
            "hgroup",
            "hr",
            "li",
            "main",
            "nav",
            "noscript",
            "ol",
            "output",
            "p",
            "pre",
            "ruby",
            "section",
            "table",
            "tbody",
            "thead",
            "tr",
            "tfoot",
            "ul",
            "video"
        ];
    }
    /**
   * Check if passed content includes only inline elements
   *
   * @param {string|HTMLElement} data - element or html string
   * @returns {boolean}
   */ static containsOnlyInlineElements(e) {
        let t1;
        $cdae29d26d2e7999$var$te(e) ? (t1 = document.createElement("div"), t1.innerHTML = e) : t1 = e;
        const o = (i)=>!$cdae29d26d2e7999$var$u.blockElements.includes(i.tagName.toLowerCase()) && Array.from(i.children).every(o);
        return Array.from(t1.children).every(o);
    }
    /**
   * Find and return all block elements in the passed parent (including subtree)
   *
   * @param {HTMLElement} parent - root element
   * @returns {HTMLElement[]}
   */ static getDeepestBlockElements(e) {
        return $cdae29d26d2e7999$var$u.containsOnlyInlineElements(e) ? [
            e
        ] : Array.from(e.children).reduce((t1, o)=>[
                ...t1,
                ...$cdae29d26d2e7999$var$u.getDeepestBlockElements(o)
            ], []);
    }
    /**
   * Helper for get holder from {string} or return HTMLElement
   *
   * @param {string | HTMLElement} element - holder's id or holder's HTML Element
   * @returns {HTMLElement}
   */ static getHolder(e) {
        return $cdae29d26d2e7999$var$te(e) ? document.getElementById(e) : e;
    }
    /**
   * Returns true if element is anchor (is A tag)
   *
   * @param {Element} element - element to check
   * @returns {boolean}
   */ static isAnchor(e) {
        return e.tagName.toLowerCase() === "a";
    }
    /**
   * Return element's offset related to the document
   *
   * @todo handle case when editor initialized in scrollable popup
   * @param el - element to compute offset
   */ static offset(e) {
        const t1 = e.getBoundingClientRect(), o = window.pageXOffset || document.documentElement.scrollLeft, i = window.pageYOffset || document.documentElement.scrollTop, s = t1.top + i, r = t1.left + o;
        return {
            top: s,
            left: r,
            bottom: s + t1.height,
            right: r + t1.width
        };
    }
    /**
   * Find text node and offset by total content offset
   *
   * @param {Node} root - root node to start search from
   * @param {number} totalOffset - offset relative to the root node content
   * @returns {{node: Node | null, offset: number}} - node and offset inside node
   */ static getNodeByOffset(e, t1) {
        let o = 0, i = null;
        const s = document.createTreeWalker(e, NodeFilter.SHOW_TEXT, null);
        let r = s.nextNode();
        for(; r;){
            const c = r.textContent, d = c === null ? 0 : c.length;
            if (i = r, o + d >= t1) break;
            o += d, r = s.nextNode();
        }
        if (!i) return {
            node: null,
            offset: 0
        };
        const a = i.textContent;
        if (a === null || a.length === 0) return {
            node: null,
            offset: 0
        };
        const l = Math.min(t1 - o, a.length);
        return {
            node: i,
            offset: l
        };
    }
}
function $cdae29d26d2e7999$var$ai(n) {
    return !/[^\t\n\r ]/.test(n);
}
function $cdae29d26d2e7999$var$li(n) {
    const e = window.getComputedStyle(n), t1 = parseFloat(e.fontSize), o = parseFloat(e.lineHeight) || t1 * 1.2, i = parseFloat(e.paddingTop), s = parseFloat(e.borderTopWidth), r = parseFloat(e.marginTop), a = t1 * 0.8, l = (o - t1) / 2;
    return r + s + i + l + a;
}
function $cdae29d26d2e7999$var$Do(n) {
    n.dataset.empty = $cdae29d26d2e7999$var$u.isEmpty(n) ? "true" : "false";
}
const $cdae29d26d2e7999$var$ci = {
    blockTunes: {
        toggler: {
            "Click to tune": "",
            "or drag to move": ""
        }
    },
    inlineToolbar: {
        converter: {
            "Convert to": ""
        }
    },
    toolbar: {
        toolbox: {
            Add: ""
        }
    },
    popover: {
        Filter: "",
        "Nothing found": "",
        "Convert to": ""
    }
}, $cdae29d26d2e7999$var$di = {
    Text: "",
    Link: "",
    Bold: "",
    Italic: ""
}, $cdae29d26d2e7999$var$ui = {
    link: {
        "Add a link": ""
    },
    stub: {
        "The block can not be displayed correctly.": ""
    }
}, $cdae29d26d2e7999$var$hi = {
    delete: {
        Delete: "",
        "Click to delete": ""
    },
    moveUp: {
        "Move up": ""
    },
    moveDown: {
        "Move down": ""
    }
}, $cdae29d26d2e7999$var$Fo = {
    ui: $cdae29d26d2e7999$var$ci,
    toolNames: $cdae29d26d2e7999$var$di,
    tools: $cdae29d26d2e7999$var$ui,
    blockTunes: $cdae29d26d2e7999$var$hi
}, $cdae29d26d2e7999$var$jo = class he {
    /**
   * Type-safe translation for internal UI texts:
   * Perform translation of the string by namespace and a key
   *
   * @example I18n.ui(I18nInternalNS.ui.blockTunes.toggler, 'Click to tune')
   * @param internalNamespace - path to translated string in dictionary
   * @param dictKey - dictionary key. Better to use default locale original text
   */ static ui(e, t1) {
        return he._t(e, t1);
    }
    /**
   * Translate for external strings that is not presented in default dictionary.
   * For example, for user-specified tool names
   *
   * @param namespace - path to translated string in dictionary
   * @param dictKey - dictionary key. Better to use default locale original text
   */ static t(e, t1) {
        return he._t(e, t1);
    }
    /**
   * Adjust module for using external dictionary
   *
   * @param dictionary - new messages list to override default
   */ static setDictionary(e) {
        he.currentDictionary = e;
    }
    /**
   * Perform translation both for internal and external namespaces
   * If there is no translation found, returns passed key as a translated message
   *
   * @param namespace - path to translated string in dictionary
   * @param dictKey - dictionary key. Better to use default locale original text
   */ static _t(e, t1) {
        const o = he.getNamespace(e);
        return !o || !o[t1] ? t1 : o[t1];
    }
    /**
   * Find messages section by namespace path
   *
   * @param namespace - path to section
   */ static getNamespace(e) {
        return e.split(".").reduce((o, i)=>!o || !Object.keys(o).length ? {} : o[i], he.currentDictionary);
    }
};
$cdae29d26d2e7999$var$jo.currentDictionary = $cdae29d26d2e7999$var$Fo;
let $cdae29d26d2e7999$var$z = $cdae29d26d2e7999$var$jo;
class $cdae29d26d2e7999$var$Ho extends Error {
}
class $cdae29d26d2e7999$var$Oe {
    constructor(){
        this.subscribers = {};
    }
    /**
   * Subscribe any event on callback
   *
   * @param eventName - event name
   * @param callback - subscriber
   */ on(e, t1) {
        e in this.subscribers || (this.subscribers[e] = []), this.subscribers[e].push(t1);
    }
    /**
   * Subscribe any event on callback. Callback will be called once and be removed from subscribers array after call.
   *
   * @param eventName - event name
   * @param callback - subscriber
   */ once(e, t1) {
        e in this.subscribers || (this.subscribers[e] = []);
        const o = (i)=>{
            const s = t1(i), r = this.subscribers[e].indexOf(o);
            return r !== -1 && this.subscribers[e].splice(r, 1), s;
        };
        this.subscribers[e].push(o);
    }
    /**
   * Emit callbacks with passed data
   *
   * @param eventName - event name
   * @param data - subscribers get this data when they were fired
   */ emit(e, t1) {
        $cdae29d26d2e7999$var$V(this.subscribers) || !this.subscribers[e] || this.subscribers[e].reduce((o, i)=>{
            const s = i(o);
            return s !== void 0 ? s : o;
        }, t1);
    }
    /**
   * Unsubscribe callback from event
   *
   * @param eventName - event name
   * @param callback - event handler
   */ off(e, t1) {
        if (this.subscribers[e] === void 0) {
            console.warn(`EventDispatcher .off(): there is no subscribers for event "${e.toString()}". Probably, .off() called before .on()`);
            return;
        }
        for(let o = 0; o < this.subscribers[e].length; o++)if (this.subscribers[e][o] === t1) {
            delete this.subscribers[e][o];
            break;
        }
    }
    /**
   * Destroyer
   * clears subscribers list
   */ destroy() {
        this.subscribers = {};
    }
}
function $cdae29d26d2e7999$var$J(n) {
    Object.setPrototypeOf(this, {
        /**
     * Block id
     *
     * @returns {string}
     */ get id () {
            return n.id;
        },
        /**
     * Tool name
     *
     * @returns {string}
     */ get name () {
            return n.name;
        },
        /**
     * Tool config passed on Editor's initialization
     *
     * @returns {ToolConfig}
     */ get config () {
            return n.config;
        },
        /**
     * .ce-block element, that wraps plugin contents
     *
     * @returns {HTMLElement}
     */ get holder () {
            return n.holder;
        },
        /**
     * True if Block content is empty
     *
     * @returns {boolean}
     */ get isEmpty () {
            return n.isEmpty;
        },
        /**
     * True if Block is selected with Cross-Block selection
     *
     * @returns {boolean}
     */ get selected () {
            return n.selected;
        },
        /**
     * Set Block's stretch state
     *
     * @param {boolean} state — state to set
     */ set stretched (t){
            n.stretched = t;
        },
        /**
     * True if Block is stretched
     *
     * @returns {boolean}
     */ get stretched () {
            return n.stretched;
        },
        /**
     * True if Block has inputs to be focused
     */ get focusable () {
            return n.focusable;
        },
        /**
     * Call Tool method with errors handler under-the-hood
     *
     * @param {string} methodName - method to call
     * @param {object} param - object with parameters
     * @returns {unknown}
     */ call (t1, o) {
            return n.call(t1, o);
        },
        /**
     * Save Block content
     *
     * @returns {Promise<void|SavedData>}
     */ save () {
            return n.save();
        },
        /**
     * Validate Block data
     *
     * @param {BlockToolData} data - data to validate
     * @returns {Promise<boolean>}
     */ validate (t1) {
            return n.validate(t1);
        },
        /**
     * Allows to say Editor that Block was changed. Used to manually trigger Editor's 'onChange' callback
     * Can be useful for block changes invisible for editor core.
     */ dispatchChange () {
            n.dispatchChange();
        },
        /**
     * Tool could specify several entries to be displayed at the Toolbox (for example, "Heading 1", "Heading 2", "Heading 3")
     * This method returns the entry that is related to the Block (depended on the Block data)
     */ getActiveToolboxEntry () {
            return n.getActiveToolboxEntry();
        }
    });
}
class $cdae29d26d2e7999$var$_e {
    constructor(){
        this.allListeners = [];
    }
    /**
   * Assigns event listener on element and returns unique identifier
   *
   * @param {EventTarget} element - DOM element that needs to be listened
   * @param {string} eventType - event type
   * @param {Function} handler - method that will be fired on event
   * @param {boolean|AddEventListenerOptions} options - useCapture or {capture, passive, once}
   */ on(e, t1, o, i = !1) {
        const s = $cdae29d26d2e7999$var$si("l"), r = {
            id: s,
            element: e,
            eventType: t1,
            handler: o,
            options: i
        };
        if (!this.findOne(e, t1, o)) return this.allListeners.push(r), e.addEventListener(t1, o, i), s;
    }
    /**
   * Removes event listener from element
   *
   * @param {EventTarget} element - DOM element that we removing listener
   * @param {string} eventType - event type
   * @param {Function} handler - remove handler, if element listens several handlers on the same event type
   * @param {boolean|AddEventListenerOptions} options - useCapture or {capture, passive, once}
   */ off(e, t1, o, i) {
        const s = this.findAll(e, t1, o);
        s.forEach((r, a)=>{
            const l = this.allListeners.indexOf(s[a]);
            l > -1 && (this.allListeners.splice(l, 1), r.element.removeEventListener(r.eventType, r.handler, r.options));
        });
    }
    /**
   * Removes listener by id
   *
   * @param {string} id - listener identifier
   */ offById(e) {
        const t1 = this.findById(e);
        t1 && t1.element.removeEventListener(t1.eventType, t1.handler, t1.options);
    }
    /**
   * Finds and returns first listener by passed params
   *
   * @param {EventTarget} element - event target
   * @param {string} [eventType] - event type
   * @param {Function} [handler] - event handler
   * @returns {ListenerData|null}
   */ findOne(e, t1, o) {
        const i = this.findAll(e, t1, o);
        return i.length > 0 ? i[0] : null;
    }
    /**
   * Return all stored listeners by passed params
   *
   * @param {EventTarget} element - event target
   * @param {string} eventType - event type
   * @param {Function} handler - event handler
   * @returns {ListenerData[]}
   */ findAll(e, t1, o) {
        let i;
        const s = e ? this.findByEventTarget(e) : [];
        return e && t1 && o ? i = s.filter((r)=>r.eventType === t1 && r.handler === o) : e && t1 ? i = s.filter((r)=>r.eventType === t1) : i = s, i;
    }
    /**
   * Removes all listeners
   */ removeAll() {
        this.allListeners.map((e)=>{
            e.element.removeEventListener(e.eventType, e.handler, e.options);
        }), this.allListeners = [];
    }
    /**
   * Module cleanup on destruction
   */ destroy() {
        this.removeAll();
    }
    /**
   * Search method: looks for listener by passed element
   *
   * @param {EventTarget} element - searching element
   * @returns {Array} listeners that found on element
   */ findByEventTarget(e) {
        return this.allListeners.filter((t1)=>{
            if (t1.element === e) return t1;
        });
    }
    /**
   * Search method: looks for listener by passed event type
   *
   * @param {string} eventType - event type
   * @returns {ListenerData[]} listeners that found on element
   */ findByType(e) {
        return this.allListeners.filter((t1)=>{
            if (t1.eventType === e) return t1;
        });
    }
    /**
   * Search method: looks for listener by passed handler
   *
   * @param {Function} handler - event handler
   * @returns {ListenerData[]} listeners that found on element
   */ findByHandler(e) {
        return this.allListeners.filter((t1)=>{
            if (t1.handler === e) return t1;
        });
    }
    /**
   * Returns listener data found by id
   *
   * @param {string} id - listener identifier
   * @returns {ListenerData}
   */ findById(e) {
        return this.allListeners.find((t1)=>t1.id === e);
    }
}
class $cdae29d26d2e7999$var$E {
    /**
   * @class
   * @param options - Module options
   * @param options.config - Module config
   * @param options.eventsDispatcher - Common event bus
   */ constructor({ config: e, eventsDispatcher: t1 }){
        if (this.nodes = {}, this.listeners = new $cdae29d26d2e7999$var$_e(), this.readOnlyMutableListeners = {
            /**
       * Assigns event listener on DOM element and pushes into special array that might be removed
       *
       * @param {EventTarget} element - DOM Element
       * @param {string} eventType - Event name
       * @param {Function} handler - Event handler
       * @param {boolean|AddEventListenerOptions} options - Listening options
       */ on: (o, i, s, r = !1)=>{
                this.mutableListenerIds.push(this.listeners.on(o, i, s, r));
            },
            /**
       * Clears all mutable listeners
       */ clearAll: ()=>{
                for (const o of this.mutableListenerIds)this.listeners.offById(o);
                this.mutableListenerIds = [];
            }
        }, this.mutableListenerIds = [], new.target === $cdae29d26d2e7999$var$E) throw new TypeError("Constructors for abstract class Module are not allowed.");
        this.config = e, this.eventsDispatcher = t1;
    }
    /**
   * Editor modules setter
   *
   * @param {EditorModules} Editor - Editor's Modules
   */ set state(e) {
        this.Editor = e;
    }
    /**
   * Remove memorized nodes
   */ removeAllNodes() {
        for(const e in this.nodes){
            const t1 = this.nodes[e];
            t1 instanceof HTMLElement && t1.remove();
        }
    }
    /**
   * Returns true if current direction is RTL (Right-To-Left)
   */ get isRtl() {
        return this.config.i18n.direction === "rtl";
    }
}
class $cdae29d26d2e7999$var$b {
    constructor(){
        this.instance = null, this.selection = null, this.savedSelectionRange = null, this.isFakeBackgroundEnabled = !1, this.commandBackground = "backColor", this.commandRemoveFormat = "removeFormat";
    }
    /**
   * Editor styles
   *
   * @returns {{editorWrapper: string, editorZone: string}}
   */ static get CSS() {
        return {
            editorWrapper: "codex-editor",
            editorZone: "codex-editor__redactor"
        };
    }
    /**
   * Returns selected anchor
   * {@link https://developer.mozilla.org/ru/docs/Web/API/Selection/anchorNode}
   *
   * @returns {Node|null}
   */ static get anchorNode() {
        const e = window.getSelection();
        return e ? e.anchorNode : null;
    }
    /**
   * Returns selected anchor element
   *
   * @returns {Element|null}
   */ static get anchorElement() {
        const e = window.getSelection();
        if (!e) return null;
        const t1 = e.anchorNode;
        return t1 ? $cdae29d26d2e7999$var$u.isElement(t1) ? t1 : t1.parentElement : null;
    }
    /**
   * Returns selection offset according to the anchor node
   * {@link https://developer.mozilla.org/ru/docs/Web/API/Selection/anchorOffset}
   *
   * @returns {number|null}
   */ static get anchorOffset() {
        const e = window.getSelection();
        return e ? e.anchorOffset : null;
    }
    /**
   * Is current selection range collapsed
   *
   * @returns {boolean|null}
   */ static get isCollapsed() {
        const e = window.getSelection();
        return e ? e.isCollapsed : null;
    }
    /**
   * Check current selection if it is at Editor's zone
   *
   * @returns {boolean}
   */ static get isAtEditor() {
        return this.isSelectionAtEditor($cdae29d26d2e7999$var$b.get());
    }
    /**
   * Check if passed selection is at Editor's zone
   *
   * @param selection - Selection object to check
   */ static isSelectionAtEditor(e) {
        if (!e) return !1;
        let t1 = e.anchorNode || e.focusNode;
        t1 && t1.nodeType === Node.TEXT_NODE && (t1 = t1.parentNode);
        let o = null;
        return t1 && t1 instanceof Element && (o = t1.closest(`.${$cdae29d26d2e7999$var$b.CSS.editorZone}`)), o ? o.nodeType === Node.ELEMENT_NODE : !1;
    }
    /**
   * Check if passed range at Editor zone
   *
   * @param range - range to check
   */ static isRangeAtEditor(e) {
        if (!e) return;
        let t1 = e.startContainer;
        t1 && t1.nodeType === Node.TEXT_NODE && (t1 = t1.parentNode);
        let o = null;
        return t1 && t1 instanceof Element && (o = t1.closest(`.${$cdae29d26d2e7999$var$b.CSS.editorZone}`)), o ? o.nodeType === Node.ELEMENT_NODE : !1;
    }
    /**
   * Methods return boolean that true if selection exists on the page
   */ static get isSelectionExists() {
        return !!$cdae29d26d2e7999$var$b.get().anchorNode;
    }
    /**
   * Return first range
   *
   * @returns {Range|null}
   */ static get range() {
        return this.getRangeFromSelection(this.get());
    }
    /**
   * Returns range from passed Selection object
   *
   * @param selection - Selection object to get Range from
   */ static getRangeFromSelection(e) {
        return e && e.rangeCount ? e.getRangeAt(0) : null;
    }
    /**
   * Calculates position and size of selected text
   *
   * @returns {DOMRect | ClientRect}
   */ static get rect() {
        let e = document.selection, t1, o = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        if (e && e.type !== "Control") return e, t1 = e.createRange(), o.x = t1.boundingLeft, o.y = t1.boundingTop, o.width = t1.boundingWidth, o.height = t1.boundingHeight, o;
        if (!window.getSelection) return $cdae29d26d2e7999$var$S("Method window.getSelection is not supported", "warn"), o;
        if (e = window.getSelection(), e.rangeCount === null || isNaN(e.rangeCount)) return $cdae29d26d2e7999$var$S("Method SelectionUtils.rangeCount is not supported", "warn"), o;
        if (e.rangeCount === 0) return o;
        if (t1 = e.getRangeAt(0).cloneRange(), t1.getBoundingClientRect && (o = t1.getBoundingClientRect()), o.x === 0 && o.y === 0) {
            const i = document.createElement("span");
            if (i.getBoundingClientRect) {
                i.appendChild(document.createTextNode("\u200B")), t1.insertNode(i), o = i.getBoundingClientRect();
                const s = i.parentNode;
                s.removeChild(i), s.normalize();
            }
        }
        return o;
    }
    /**
   * Returns selected text as String
   *
   * @returns {string}
   */ static get text() {
        return window.getSelection ? window.getSelection().toString() : "";
    }
    /**
   * Returns window SelectionUtils
   * {@link https://developer.mozilla.org/ru/docs/Web/API/Window/getSelection}
   *
   * @returns {Selection}
   */ static get() {
        return window.getSelection();
    }
    /**
   * Set focus to contenteditable or native input element
   *
   * @param element - element where to set focus
   * @param offset - offset of cursor
   */ static setCursor(e, t1 = 0) {
        const o = document.createRange(), i = window.getSelection();
        return $cdae29d26d2e7999$var$u.isNativeInput(e) ? $cdae29d26d2e7999$var$u.canSetCaret(e) ? (e.focus(), e.selectionStart = e.selectionEnd = t1, e.getBoundingClientRect()) : void 0 : (o.setStart(e, t1), o.setEnd(e, t1), i.removeAllRanges(), i.addRange(o), o.getBoundingClientRect());
    }
    /**
   * Check if current range exists and belongs to container
   *
   * @param container - where range should be
   */ static isRangeInsideContainer(e) {
        const t1 = $cdae29d26d2e7999$var$b.range;
        return t1 === null ? !1 : e.contains(t1.startContainer);
    }
    /**
   * Adds fake cursor to the current range
   */ static addFakeCursor() {
        const e = $cdae29d26d2e7999$var$b.range;
        if (e === null) return;
        const t1 = $cdae29d26d2e7999$var$u.make("span", "codex-editor__fake-cursor");
        t1.dataset.mutationFree = "true", e.collapse(), e.insertNode(t1);
    }
    /**
   * Check if passed element contains a fake cursor
   *
   * @param el - where to check
   */ static isFakeCursorInsideContainer(e) {
        return $cdae29d26d2e7999$var$u.find(e, ".codex-editor__fake-cursor") !== null;
    }
    /**
   * Removes fake cursor from a container
   *
   * @param container - container to look for
   */ static removeFakeCursor(e = document.body) {
        const t1 = $cdae29d26d2e7999$var$u.find(e, ".codex-editor__fake-cursor");
        t1 && t1.remove();
    }
    /**
   * Removes fake background
   */ removeFakeBackground() {
        this.isFakeBackgroundEnabled && (this.isFakeBackgroundEnabled = !1, document.execCommand(this.commandRemoveFormat));
    }
    /**
   * Sets fake background
   */ setFakeBackground() {
        document.execCommand(this.commandBackground, !1, "#a8d6ff"), this.isFakeBackgroundEnabled = !0;
    }
    /**
   * Save SelectionUtils's range
   */ save() {
        this.savedSelectionRange = $cdae29d26d2e7999$var$b.range;
    }
    /**
   * Restore saved SelectionUtils's range
   */ restore() {
        if (!this.savedSelectionRange) return;
        const e = window.getSelection();
        e.removeAllRanges(), e.addRange(this.savedSelectionRange);
    }
    /**
   * Clears saved selection
   */ clearSaved() {
        this.savedSelectionRange = null;
    }
    /**
   * Collapse current selection
   */ collapseToEnd() {
        const e = window.getSelection(), t1 = document.createRange();
        t1.selectNodeContents(e.focusNode), t1.collapse(!1), e.removeAllRanges(), e.addRange(t1);
    }
    /**
   * Looks ahead to find passed tag from current selection
   *
   * @param  {string} tagName       - tag to found
   * @param  {string} [className]   - tag's class name
   * @param  {number} [searchDepth] - count of tags that can be included. For better performance.
   * @returns {HTMLElement|null}
   */ findParentTag(e, t1, o = 10) {
        const i = window.getSelection();
        let s = null;
        return !i || !i.anchorNode || !i.focusNode ? null : ([
            /** the Node in which the selection begins */ i.anchorNode,
            /** the Node in which the selection ends */ i.focusNode
        ].forEach((a)=>{
            let l = o;
            for(; l > 0 && a.parentNode && !(a.tagName === e && (s = a, t1 && a.classList && !a.classList.contains(t1) && (s = null), s));)a = a.parentNode, l--;
        }), s);
    }
    /**
   * Expands selection range to the passed parent node
   *
   * @param {HTMLElement} element - element which contents should be selected
   */ expandToTag(e) {
        const t1 = window.getSelection();
        t1.removeAllRanges();
        const o = document.createRange();
        o.selectNodeContents(e), t1.addRange(o);
    }
}
function $cdae29d26d2e7999$var$pi(n, e) {
    const { type: t1, target: o, addedNodes: i, removedNodes: s } = n;
    return n.type === "attributes" && n.attributeName === "data-empty" ? !1 : !!(e.contains(o) || t1 === "childList" && (Array.from(i).some((l)=>l === e) || Array.from(s).some((l)=>l === e)));
}
const $cdae29d26d2e7999$var$ft = "redactor dom changed", $cdae29d26d2e7999$var$$o = "block changed", $cdae29d26d2e7999$var$zo = "fake cursor is about to be toggled", $cdae29d26d2e7999$var$Uo = "fake cursor have been set", $cdae29d26d2e7999$var$Te = "editor mobile layout toggled";
function $cdae29d26d2e7999$var$gt(n, e) {
    if (!n.conversionConfig) return !1;
    const t1 = n.conversionConfig[e];
    return $cdae29d26d2e7999$var$A(t1) || $cdae29d26d2e7999$var$te(t1);
}
function $cdae29d26d2e7999$var$He(n, e) {
    return $cdae29d26d2e7999$var$gt(n.tool, e);
}
function $cdae29d26d2e7999$var$Wo(n, e) {
    return Object.entries(n).some(([t1, o])=>e[t1] && $cdae29d26d2e7999$var$ri(e[t1], o));
}
async function $cdae29d26d2e7999$var$Yo(n, e) {
    const o = (await n.save()).data, i = e.find((s)=>s.name === n.name);
    return i !== void 0 && !$cdae29d26d2e7999$var$gt(i, "export") ? [] : e.reduce((s, r)=>{
        if (!$cdae29d26d2e7999$var$gt(r, "import") || r.toolbox === void 0) return s;
        const a = r.toolbox.filter((l)=>{
            if ($cdae29d26d2e7999$var$V(l) || l.icon === void 0) return !1;
            if (l.data !== void 0) {
                if ($cdae29d26d2e7999$var$Wo(l.data, o)) return !1;
            } else if (r.name === n.name) return !1;
            return !0;
        });
        return s.push({
            ...r,
            toolbox: a
        }), s;
    }, []);
}
function $cdae29d26d2e7999$var$xo(n, e) {
    return n.mergeable ? n.name === e.name ? !0 : $cdae29d26d2e7999$var$He(e, "export") && $cdae29d26d2e7999$var$He(n, "import") : !1;
}
function $cdae29d26d2e7999$var$fi(n, e) {
    const t1 = e == null ? void 0 : e.export;
    return $cdae29d26d2e7999$var$A(t1) ? t1(n) : $cdae29d26d2e7999$var$te(t1) ? n[t1] : (t1 !== void 0 && $cdae29d26d2e7999$var$S("Conversion \xabexport\xbb property must be a string or function. String means key of saved data object to export. Function should export processed string to export."), "");
}
function $cdae29d26d2e7999$var$Bo(n, e, t1) {
    const o = e == null ? void 0 : e.import;
    return $cdae29d26d2e7999$var$A(o) ? o(n, t1) : $cdae29d26d2e7999$var$te(o) ? {
        [o]: n
    } : (o !== void 0 && $cdae29d26d2e7999$var$S("Conversion \xabimport\xbb property must be a string or function. String means key of tool data to import. Function accepts a imported string and return composed tool data."), {});
}
var $cdae29d26d2e7999$var$_ = /* @__PURE__ */ ((n)=>(n.Default = "default", n.Separator = "separator", n.Html = "html", n))($cdae29d26d2e7999$var$_ || {}), $cdae29d26d2e7999$var$ee = /* @__PURE__ */ ((n)=>(n.APPEND_CALLBACK = "appendCallback", n.RENDERED = "rendered", n.MOVED = "moved", n.UPDATED = "updated", n.REMOVED = "removed", n.ON_PASTE = "onPaste", n))($cdae29d26d2e7999$var$ee || {});
class $cdae29d26d2e7999$var$R extends $cdae29d26d2e7999$var$Oe {
    /**
   * @param options - block constructor options
   * @param [options.id] - block's id. Will be generated if omitted.
   * @param options.data - Tool's initial data
   * @param options.tool — block's tool
   * @param options.api - Editor API module for pass it to the Block Tunes
   * @param options.readOnly - Read-Only flag
   * @param [eventBus] - Editor common event bus. Allows to subscribe on some Editor events. Could be omitted when "virtual" Block is created. See BlocksAPI@composeBlockData.
   */ constructor({ id: e = $cdae29d26d2e7999$var$ni(), data: t1, tool: o, readOnly: i, tunesData: s }, r){
        super(), this.cachedInputs = [], this.toolRenderedElement = null, this.tunesInstances = /* @__PURE__ */ new Map(), this.defaultTunesInstances = /* @__PURE__ */ new Map(), this.unavailableTunesData = {}, this.inputIndex = 0, this.editorEventBus = null, this.handleFocus = ()=>{
            this.dropInputsCache(), this.updateCurrentInput();
        }, this.didMutated = (a)=>{
            const l = a === void 0, c = a instanceof InputEvent;
            !l && !c && this.detectToolRootChange(a);
            let d;
            l || c ? d = !0 : d = !(a.length > 0 && a.every((p)=>{
                const { addedNodes: g, removedNodes: f, target: v } = p;
                return [
                    ...Array.from(g),
                    ...Array.from(f),
                    v
                ].some((T)=>($cdae29d26d2e7999$var$u.isElement(T) || (T = T.parentElement), T && T.closest('[data-mutation-free="true"]') !== null));
            })), d && (this.dropInputsCache(), this.updateCurrentInput(), this.toggleInputsEmptyMark(), this.call("updated"), this.emit("didMutated", this));
        }, this.name = o.name, this.id = e, this.settings = o.settings, this.config = o.settings.config || {}, this.editorEventBus = r || null, this.blockAPI = new $cdae29d26d2e7999$var$J(this), this.tool = o, this.toolInstance = o.create(t1, this.blockAPI, i), this.tunes = o.tunes, this.composeTunes(s), this.holder = this.compose(), window.requestIdleCallback(()=>{
            this.watchBlockMutations(), this.addInputEvents(), this.toggleInputsEmptyMark();
        });
    }
    /**
   * CSS classes for the Block
   *
   * @returns {{wrapper: string, content: string}}
   */ static get CSS() {
        return {
            wrapper: "ce-block",
            wrapperStretched: "ce-block--stretched",
            content: "ce-block__content",
            selected: "ce-block--selected",
            dropTarget: "ce-block--drop-target"
        };
    }
    /**
   * Find and return all editable elements (contenteditable and native inputs) in the Tool HTML
   */ get inputs() {
        if (this.cachedInputs.length !== 0) return this.cachedInputs;
        const e = $cdae29d26d2e7999$var$u.findAllInputs(this.holder);
        return this.inputIndex > e.length - 1 && (this.inputIndex = e.length - 1), this.cachedInputs = e, e;
    }
    /**
   * Return current Tool`s input
   * If Block doesn't contain inputs, return undefined
   */ get currentInput() {
        return this.inputs[this.inputIndex];
    }
    /**
   * Set input index to the passed element
   *
   * @param element - HTML Element to set as current input
   */ set currentInput(e) {
        const t1 = this.inputs.findIndex((o)=>o === e || o.contains(e));
        t1 !== -1 && (this.inputIndex = t1);
    }
    /**
   * Return first Tool`s input
   * If Block doesn't contain inputs, return undefined
   */ get firstInput() {
        return this.inputs[0];
    }
    /**
   * Return first Tool`s input
   * If Block doesn't contain inputs, return undefined
   */ get lastInput() {
        const e = this.inputs;
        return e[e.length - 1];
    }
    /**
   * Return next Tool`s input or undefined if it doesn't exist
   * If Block doesn't contain inputs, return undefined
   */ get nextInput() {
        return this.inputs[this.inputIndex + 1];
    }
    /**
   * Return previous Tool`s input or undefined if it doesn't exist
   * If Block doesn't contain inputs, return undefined
   */ get previousInput() {
        return this.inputs[this.inputIndex - 1];
    }
    /**
   * Get Block's JSON data
   *
   * @returns {object}
   */ get data() {
        return this.save().then((e)=>e && !$cdae29d26d2e7999$var$V(e.data) ? e.data : {});
    }
    /**
   * Returns tool's sanitizer config
   *
   * @returns {object}
   */ get sanitize() {
        return this.tool.sanitizeConfig;
    }
    /**
   * is block mergeable
   * We plugin have merge function then we call it mergeable
   *
   * @returns {boolean}
   */ get mergeable() {
        return $cdae29d26d2e7999$var$A(this.toolInstance.merge);
    }
    /**
   * If Block contains inputs, it is focusable
   */ get focusable() {
        return this.inputs.length !== 0;
    }
    /**
   * Check block for emptiness
   *
   * @returns {boolean}
   */ get isEmpty() {
        const e = $cdae29d26d2e7999$var$u.isEmpty(this.pluginsContent, "/"), t1 = !this.hasMedia;
        return e && t1;
    }
    /**
   * Check if block has a media content such as images, iframe and other
   *
   * @returns {boolean}
   */ get hasMedia() {
        const e = [
            "img",
            "iframe",
            "video",
            "audio",
            "source",
            "input",
            "textarea",
            "twitterwidget"
        ];
        return !!this.holder.querySelector(e.join(","));
    }
    /**
   * Set selected state
   * We don't need to mark Block as Selected when it is empty
   *
   * @param {boolean} state - 'true' to select, 'false' to remove selection
   */ set selected(e) {
        var i, s;
        this.holder.classList.toggle($cdae29d26d2e7999$var$R.CSS.selected, e);
        const t1 = e === !0 && $cdae29d26d2e7999$var$b.isRangeInsideContainer(this.holder), o = e === !1 && $cdae29d26d2e7999$var$b.isFakeCursorInsideContainer(this.holder);
        (t1 || o) && ((i = this.editorEventBus) == null || i.emit($cdae29d26d2e7999$var$zo, {
            state: e
        }), t1 ? $cdae29d26d2e7999$var$b.addFakeCursor() : $cdae29d26d2e7999$var$b.removeFakeCursor(this.holder), (s = this.editorEventBus) == null || s.emit($cdae29d26d2e7999$var$Uo, {
            state: e
        }));
    }
    /**
   * Returns True if it is Selected
   *
   * @returns {boolean}
   */ get selected() {
        return this.holder.classList.contains($cdae29d26d2e7999$var$R.CSS.selected);
    }
    /**
   * Set stretched state
   *
   * @param {boolean} state - 'true' to enable, 'false' to disable stretched state
   */ set stretched(e) {
        this.holder.classList.toggle($cdae29d26d2e7999$var$R.CSS.wrapperStretched, e);
    }
    /**
   * Return Block's stretched state
   *
   * @returns {boolean}
   */ get stretched() {
        return this.holder.classList.contains($cdae29d26d2e7999$var$R.CSS.wrapperStretched);
    }
    /**
   * Toggle drop target state
   *
   * @param {boolean} state - 'true' if block is drop target, false otherwise
   */ set dropTarget(e) {
        this.holder.classList.toggle($cdae29d26d2e7999$var$R.CSS.dropTarget, e);
    }
    /**
   * Returns Plugins content
   *
   * @returns {HTMLElement}
   */ get pluginsContent() {
        return this.toolRenderedElement;
    }
    /**
   * Calls Tool's method
   *
   * Method checks tool property {MethodName}. Fires method with passes params If it is instance of Function
   *
   * @param {string} methodName - method to call
   * @param {object} params - method argument
   */ call(e, t1) {
        if ($cdae29d26d2e7999$var$A(this.toolInstance[e])) {
            e === "appendCallback" && $cdae29d26d2e7999$var$S("`appendCallback` hook is deprecated and will be removed in the next major release. Use `rendered` hook instead", "warn");
            try {
                this.toolInstance[e].call(this.toolInstance, t1);
            } catch (o) {
                $cdae29d26d2e7999$var$S(`Error during '${e}' call: ${o.message}`, "error");
            }
        }
    }
    /**
   * Call plugins merge method
   *
   * @param {BlockToolData} data - data to merge
   */ async mergeWith(e) {
        await this.toolInstance.merge(e);
    }
    /**
   * Extracts data from Block
   * Groups Tool's save processing time
   *
   * @returns {object}
   */ async save() {
        const e = await this.toolInstance.save(this.pluginsContent), t1 = this.unavailableTunesData;
        [
            ...this.tunesInstances.entries(),
            ...this.defaultTunesInstances.entries()
        ].forEach(([s, r])=>{
            if ($cdae29d26d2e7999$var$A(r.save)) try {
                t1[s] = r.save();
            } catch (a) {
                $cdae29d26d2e7999$var$S(`Tune ${r.constructor.name} save method throws an Error %o`, "warn", a);
            }
        });
        const o = window.performance.now();
        let i;
        return Promise.resolve(e).then((s)=>(i = window.performance.now(), {
                id: this.id,
                tool: this.name,
                data: s,
                tunes: t1,
                time: i - o
            })).catch((s)=>{
            $cdae29d26d2e7999$var$S(`Saving process for ${this.name} tool failed due to the ${s}`, "log", "red");
        });
    }
    /**
   * Uses Tool's validation method to check the correctness of output data
   * Tool's validation method is optional
   *
   * @description Method returns true|false whether data passed the validation or not
   * @param {BlockToolData} data - data to validate
   * @returns {Promise<boolean>} valid
   */ async validate(e) {
        let t1 = !0;
        return this.toolInstance.validate instanceof Function && (t1 = await this.toolInstance.validate(e)), t1;
    }
    /**
   * Returns data to render in Block Tunes menu.
   * Splits block tunes into 2 groups: block specific tunes and common tunes
   */ getTunes() {
        const e = [], t1 = [], o = typeof this.toolInstance.renderSettings == "function" ? this.toolInstance.renderSettings() : [];
        return $cdae29d26d2e7999$var$u.isElement(o) ? e.push({
            type: $cdae29d26d2e7999$var$_.Html,
            element: o
        }) : Array.isArray(o) ? e.push(...o) : e.push(o), [
            ...this.tunesInstances.values(),
            ...this.defaultTunesInstances.values()
        ].map((s)=>s.render()).forEach((s)=>{
            $cdae29d26d2e7999$var$u.isElement(s) ? t1.push({
                type: $cdae29d26d2e7999$var$_.Html,
                element: s
            }) : Array.isArray(s) ? t1.push(...s) : t1.push(s);
        }), {
            toolTunes: e,
            commonTunes: t1
        };
    }
    /**
   * Update current input index with selection anchor node
   */ updateCurrentInput() {
        this.currentInput = $cdae29d26d2e7999$var$u.isNativeInput(document.activeElement) || !$cdae29d26d2e7999$var$b.anchorNode ? document.activeElement : $cdae29d26d2e7999$var$b.anchorNode;
    }
    /**
   * Allows to say Editor that Block was changed. Used to manually trigger Editor's 'onChange' callback
   * Can be useful for block changes invisible for editor core.
   */ dispatchChange() {
        this.didMutated();
    }
    /**
   * Call Tool instance destroy method
   */ destroy() {
        this.unwatchBlockMutations(), this.removeInputEvents(), super.destroy(), $cdae29d26d2e7999$var$A(this.toolInstance.destroy) && this.toolInstance.destroy();
    }
    /**
   * Tool could specify several entries to be displayed at the Toolbox (for example, "Heading 1", "Heading 2", "Heading 3")
   * This method returns the entry that is related to the Block (depended on the Block data)
   */ async getActiveToolboxEntry() {
        const e = this.tool.toolbox;
        if (e.length === 1) return Promise.resolve(this.tool.toolbox[0]);
        const t1 = await this.data, o = e;
        return o == null ? void 0 : o.find((i)=>$cdae29d26d2e7999$var$Wo(i.data, t1));
    }
    /**
   * Exports Block data as string using conversion config
   */ async exportDataAsString() {
        const e = await this.data;
        return $cdae29d26d2e7999$var$fi(e, this.tool.conversionConfig);
    }
    /**
   * Make default Block wrappers and put Tool`s content there
   *
   * @returns {HTMLDivElement}
   */ compose() {
        const e = $cdae29d26d2e7999$var$u.make("div", $cdae29d26d2e7999$var$R.CSS.wrapper), t1 = $cdae29d26d2e7999$var$u.make("div", $cdae29d26d2e7999$var$R.CSS.content), o = this.toolInstance.render();
        e.dataset.id = this.id, this.toolRenderedElement = o, t1.appendChild(this.toolRenderedElement);
        let i = t1;
        return [
            ...this.tunesInstances.values(),
            ...this.defaultTunesInstances.values()
        ].forEach((s)=>{
            if ($cdae29d26d2e7999$var$A(s.wrap)) try {
                i = s.wrap(i);
            } catch (r) {
                $cdae29d26d2e7999$var$S(`Tune ${s.constructor.name} wrap method throws an Error %o`, "warn", r);
            }
        }), e.appendChild(i), e;
    }
    /**
   * Instantiate Block Tunes
   *
   * @param tunesData - current Block tunes data
   * @private
   */ composeTunes(e) {
        Array.from(this.tunes.values()).forEach((t1)=>{
            (t1.isInternal ? this.defaultTunesInstances : this.tunesInstances).set(t1.name, t1.create(e[t1.name], this.blockAPI));
        }), Object.entries(e).forEach(([t1, o])=>{
            this.tunesInstances.has(t1) || (this.unavailableTunesData[t1] = o);
        });
    }
    /**
   * Adds focus event listeners to all inputs and contenteditable
   */ addInputEvents() {
        this.inputs.forEach((e)=>{
            e.addEventListener("focus", this.handleFocus), $cdae29d26d2e7999$var$u.isNativeInput(e) && e.addEventListener("input", this.didMutated);
        });
    }
    /**
   * removes focus event listeners from all inputs and contenteditable
   */ removeInputEvents() {
        this.inputs.forEach((e)=>{
            e.removeEventListener("focus", this.handleFocus), $cdae29d26d2e7999$var$u.isNativeInput(e) && e.removeEventListener("input", this.didMutated);
        });
    }
    /**
   * Listen common editor Dom Changed event and detect mutations related to the  Block
   */ watchBlockMutations() {
        var e;
        this.redactorDomChangedCallback = (t1)=>{
            const { mutations: o } = t1;
            o.some((s)=>$cdae29d26d2e7999$var$pi(s, this.toolRenderedElement)) && this.didMutated(o);
        }, (e = this.editorEventBus) == null || e.on($cdae29d26d2e7999$var$ft, this.redactorDomChangedCallback);
    }
    /**
   * Remove redactor dom change event listener
   */ unwatchBlockMutations() {
        var e;
        (e = this.editorEventBus) == null || e.off($cdae29d26d2e7999$var$ft, this.redactorDomChangedCallback);
    }
    /**
   * Sometimes Tool can replace own main element, for example H2 -> H4 or UL -> OL
   * We need to detect such changes and update a link to tools main element with the new one
   *
   * @param mutations - records of block content mutations
   */ detectToolRootChange(e) {
        e.forEach((t1)=>{
            if (Array.from(t1.removedNodes).includes(this.toolRenderedElement)) {
                const i = t1.addedNodes[t1.addedNodes.length - 1];
                this.toolRenderedElement = i;
            }
        });
    }
    /**
   * Clears inputs cached value
   */ dropInputsCache() {
        this.cachedInputs = [];
    }
    /**
   * Mark inputs with 'data-empty' attribute with the empty state
   */ toggleInputsEmptyMark() {
        this.inputs.forEach($cdae29d26d2e7999$var$Do);
    }
}
class $cdae29d26d2e7999$var$gi extends $cdae29d26d2e7999$var$E {
    constructor(){
        super(...arguments), this.insert = (e = this.config.defaultBlock, t1 = {}, o = {}, i, s, r, a)=>{
            const l = this.Editor.BlockManager.insert({
                id: a,
                tool: e,
                data: t1,
                index: i,
                needToFocus: s,
                replace: r
            });
            return new $cdae29d26d2e7999$var$J(l);
        }, this.composeBlockData = async (e)=>{
            const t1 = this.Editor.Tools.blockTools.get(e);
            return new $cdae29d26d2e7999$var$R({
                tool: t1,
                api: this.Editor.API,
                readOnly: !0,
                data: {},
                tunesData: {}
            }).data;
        }, this.update = async (e, t1, o)=>{
            const { BlockManager: i } = this.Editor, s = i.getBlockById(e);
            if (s === void 0) throw new Error(`Block with id "${e}" not found`);
            const r = await i.update(s, t1, o);
            return new $cdae29d26d2e7999$var$J(r);
        }, this.convert = async (e, t1, o)=>{
            var h, p;
            const { BlockManager: i, Tools: s } = this.Editor, r = i.getBlockById(e);
            if (!r) throw new Error(`Block with id "${e}" not found`);
            const a = s.blockTools.get(r.name), l = s.blockTools.get(t1);
            if (!l) throw new Error(`Block Tool with type "${t1}" not found`);
            const c = ((h = a == null ? void 0 : a.conversionConfig) == null ? void 0 : h.export) !== void 0, d = ((p = l.conversionConfig) == null ? void 0 : p.import) !== void 0;
            if (c && d) {
                const g = await i.convert(r, t1, o);
                return new $cdae29d26d2e7999$var$J(g);
            } else {
                const g = [
                    c ? !1 : $cdae29d26d2e7999$var$je(r.name),
                    d ? !1 : $cdae29d26d2e7999$var$je(t1)
                ].filter(Boolean).join(" and ");
                throw new Error(`Conversion from "${r.name}" to "${t1}" is not possible. ${g} tool(s) should provide a "conversionConfig"`);
            }
        }, this.insertMany = (e, t1 = this.Editor.BlockManager.blocks.length - 1)=>{
            this.validateIndex(t1);
            const o = e.map(({ id: i, type: s, data: r })=>this.Editor.BlockManager.composeBlock({
                    id: i,
                    tool: s || this.config.defaultBlock,
                    data: r
                }));
            return this.Editor.BlockManager.insertMany(o, t1), o.map((i)=>new $cdae29d26d2e7999$var$J(i));
        };
    }
    /**
   * Available methods
   *
   * @returns {Blocks}
   */ get methods() {
        return {
            clear: ()=>this.clear(),
            render: (e)=>this.render(e),
            renderFromHTML: (e)=>this.renderFromHTML(e),
            delete: (e)=>this.delete(e),
            swap: (e, t1)=>this.swap(e, t1),
            move: (e, t1)=>this.move(e, t1),
            getBlockByIndex: (e)=>this.getBlockByIndex(e),
            getById: (e)=>this.getById(e),
            getCurrentBlockIndex: ()=>this.getCurrentBlockIndex(),
            getBlockIndex: (e)=>this.getBlockIndex(e),
            getBlocksCount: ()=>this.getBlocksCount(),
            getBlockByElement: (e)=>this.getBlockByElement(e),
            stretchBlock: (e, t1 = !0)=>this.stretchBlock(e, t1),
            insertNewBlock: ()=>this.insertNewBlock(),
            insert: this.insert,
            insertMany: this.insertMany,
            update: this.update,
            composeBlockData: this.composeBlockData,
            convert: this.convert
        };
    }
    /**
   * Returns Blocks count
   *
   * @returns {number}
   */ getBlocksCount() {
        return this.Editor.BlockManager.blocks.length;
    }
    /**
   * Returns current block index
   *
   * @returns {number}
   */ getCurrentBlockIndex() {
        return this.Editor.BlockManager.currentBlockIndex;
    }
    /**
   * Returns the index of Block by id;
   *
   * @param id - block id
   */ getBlockIndex(e) {
        const t1 = this.Editor.BlockManager.getBlockById(e);
        if (!t1) {
            $cdae29d26d2e7999$var$X("There is no block with id `" + e + "`", "warn");
            return;
        }
        return this.Editor.BlockManager.getBlockIndex(t1);
    }
    /**
   * Returns BlockAPI object by Block index
   *
   * @param {number} index - index to get
   */ getBlockByIndex(e) {
        const t1 = this.Editor.BlockManager.getBlockByIndex(e);
        if (t1 === void 0) {
            $cdae29d26d2e7999$var$X("There is no block at index `" + e + "`", "warn");
            return;
        }
        return new $cdae29d26d2e7999$var$J(t1);
    }
    /**
   * Returns BlockAPI object by Block id
   *
   * @param id - id of block to get
   */ getById(e) {
        const t1 = this.Editor.BlockManager.getBlockById(e);
        return t1 === void 0 ? ($cdae29d26d2e7999$var$X("There is no block with id `" + e + "`", "warn"), null) : new $cdae29d26d2e7999$var$J(t1);
    }
    /**
   * Get Block API object by any child html element
   *
   * @param element - html element to get Block by
   */ getBlockByElement(e) {
        const t1 = this.Editor.BlockManager.getBlock(e);
        if (t1 === void 0) {
            $cdae29d26d2e7999$var$X("There is no block corresponding to element `" + e + "`", "warn");
            return;
        }
        return new $cdae29d26d2e7999$var$J(t1);
    }
    /**
   * Call Block Manager method that swap Blocks
   *
   * @param {number} fromIndex - position of first Block
   * @param {number} toIndex - position of second Block
   * @deprecated — use 'move' instead
   */ swap(e, t1) {
        $cdae29d26d2e7999$var$S("`blocks.swap()` method is deprecated and will be removed in the next major release. Use `block.move()` method instead", "info"), this.Editor.BlockManager.swap(e, t1);
    }
    /**
   * Move block from one index to another
   *
   * @param {number} toIndex - index to move to
   * @param {number} fromIndex - index to move from
   */ move(e, t1) {
        this.Editor.BlockManager.move(e, t1);
    }
    /**
   * Deletes Block
   *
   * @param {number} blockIndex - index of Block to delete
   */ delete(e = this.Editor.BlockManager.currentBlockIndex) {
        try {
            const t1 = this.Editor.BlockManager.getBlockByIndex(e);
            this.Editor.BlockManager.removeBlock(t1);
        } catch (t1) {
            $cdae29d26d2e7999$var$X(t1, "warn");
            return;
        }
        this.Editor.BlockManager.blocks.length === 0 && this.Editor.BlockManager.insert(), this.Editor.BlockManager.currentBlock && this.Editor.Caret.setToBlock(this.Editor.BlockManager.currentBlock, this.Editor.Caret.positions.END), this.Editor.Toolbar.close();
    }
    /**
   * Clear Editor's area
   */ async clear() {
        await this.Editor.BlockManager.clear(!0), this.Editor.InlineToolbar.close();
    }
    /**
   * Fills Editor with Blocks data
   *
   * @param {OutputData} data — Saved Editor data
   */ async render(e) {
        if (e === void 0 || e.blocks === void 0) throw new Error("Incorrect data passed to the render() method");
        this.Editor.ModificationsObserver.disable(), await this.Editor.BlockManager.clear(), await this.Editor.Renderer.render(e.blocks), this.Editor.ModificationsObserver.enable();
    }
    /**
   * Render passed HTML string
   *
   * @param {string} data - HTML string to render
   * @returns {Promise<void>}
   */ async renderFromHTML(e) {
        return await this.Editor.BlockManager.clear(), this.Editor.Paste.processText(e, !0);
    }
    /**
   * Stretch Block's content
   *
   * @param {number} index - index of Block to stretch
   * @param {boolean} status - true to enable, false to disable
   * @deprecated Use BlockAPI interface to stretch Blocks
   */ stretchBlock(e, t1 = !0) {
        $cdae29d26d2e7999$var$ht(!0, "blocks.stretchBlock()", "BlockAPI");
        const o = this.Editor.BlockManager.getBlockByIndex(e);
        o && (o.stretched = t1);
    }
    /**
   * Insert new Block
   * After set caret to this Block
   *
   * @todo remove in 3.0.0
   * @deprecated with insert() method
   */ insertNewBlock() {
        $cdae29d26d2e7999$var$S("Method blocks.insertNewBlock() is deprecated and it will be removed in the next major release. Use blocks.insert() instead.", "warn"), this.insert();
    }
    /**
   * Validated block index and throws an error if it's invalid
   *
   * @param index - index to validate
   */ validateIndex(e) {
        if (typeof e != "number") throw new Error("Index should be a number");
        if (e < 0) throw new Error("Index should be greater than or equal to 0");
        if (e === null) throw new Error("Index should be greater than or equal to 0");
    }
}
function $cdae29d26d2e7999$var$mi(n, e) {
    return typeof n == "number" ? e.BlockManager.getBlockByIndex(n) : typeof n == "string" ? e.BlockManager.getBlockById(n) : e.BlockManager.getBlockById(n.id);
}
class $cdae29d26d2e7999$var$bi extends $cdae29d26d2e7999$var$E {
    constructor(){
        super(...arguments), this.setToFirstBlock = (e = this.Editor.Caret.positions.DEFAULT, t1 = 0)=>this.Editor.BlockManager.firstBlock ? (this.Editor.Caret.setToBlock(this.Editor.BlockManager.firstBlock, e, t1), !0) : !1, this.setToLastBlock = (e = this.Editor.Caret.positions.DEFAULT, t1 = 0)=>this.Editor.BlockManager.lastBlock ? (this.Editor.Caret.setToBlock(this.Editor.BlockManager.lastBlock, e, t1), !0) : !1, this.setToPreviousBlock = (e = this.Editor.Caret.positions.DEFAULT, t1 = 0)=>this.Editor.BlockManager.previousBlock ? (this.Editor.Caret.setToBlock(this.Editor.BlockManager.previousBlock, e, t1), !0) : !1, this.setToNextBlock = (e = this.Editor.Caret.positions.DEFAULT, t1 = 0)=>this.Editor.BlockManager.nextBlock ? (this.Editor.Caret.setToBlock(this.Editor.BlockManager.nextBlock, e, t1), !0) : !1, this.setToBlock = (e, t1 = this.Editor.Caret.positions.DEFAULT, o = 0)=>{
            const i = $cdae29d26d2e7999$var$mi(e, this.Editor);
            return i === void 0 ? !1 : (this.Editor.Caret.setToBlock(i, t1, o), !0);
        }, this.focus = (e = !1)=>e ? this.setToLastBlock(this.Editor.Caret.positions.END) : this.setToFirstBlock(this.Editor.Caret.positions.START);
    }
    /**
   * Available methods
   *
   * @returns {Caret}
   */ get methods() {
        return {
            setToFirstBlock: this.setToFirstBlock,
            setToLastBlock: this.setToLastBlock,
            setToPreviousBlock: this.setToPreviousBlock,
            setToNextBlock: this.setToNextBlock,
            setToBlock: this.setToBlock,
            focus: this.focus
        };
    }
}
class $cdae29d26d2e7999$var$vi extends $cdae29d26d2e7999$var$E {
    /**
   * Available methods
   *
   * @returns {Events}
   */ get methods() {
        return {
            emit: (e, t1)=>this.emit(e, t1),
            off: (e, t1)=>this.off(e, t1),
            on: (e, t1)=>this.on(e, t1)
        };
    }
    /**
   * Subscribe on Events
   *
   * @param {string} eventName - event name to subscribe
   * @param {Function} callback - event handler
   */ on(e, t1) {
        this.eventsDispatcher.on(e, t1);
    }
    /**
   * Emit event with data
   *
   * @param {string} eventName - event to emit
   * @param {object} data - event's data
   */ emit(e, t1) {
        this.eventsDispatcher.emit(e, t1);
    }
    /**
   * Unsubscribe from Event
   *
   * @param {string} eventName - event to unsubscribe
   * @param {Function} callback - event handler
   */ off(e, t1) {
        this.eventsDispatcher.off(e, t1);
    }
}
class $cdae29d26d2e7999$var$kt extends $cdae29d26d2e7999$var$E {
    /**
   * Return namespace section for tool or block tune
   *
   * @param toolName - tool name
   * @param isTune - is tool a block tune
   */ static getNamespace(e, t1) {
        return t1 ? `blockTunes.${e}` : `tools.${e}`;
    }
    /**
   * Return I18n API methods with global dictionary access
   */ get methods() {
        return {
            t: ()=>{
                $cdae29d26d2e7999$var$X("I18n.t() method can be accessed only from Tools", "warn");
            }
        };
    }
    /**
   * Return I18n API methods with tool namespaced dictionary
   *
   * @param toolName - tool name
   * @param isTune - is tool a block tune
   */ getMethodsForTool(e, t1) {
        return Object.assign(this.methods, {
            t: (o)=>$cdae29d26d2e7999$var$z.t($cdae29d26d2e7999$var$kt.getNamespace(e, t1), o)
        });
    }
}
class $cdae29d26d2e7999$var$ki extends $cdae29d26d2e7999$var$E {
    /**
   * Editor.js Core API modules
   */ get methods() {
        return {
            blocks: this.Editor.BlocksAPI.methods,
            caret: this.Editor.CaretAPI.methods,
            tools: this.Editor.ToolsAPI.methods,
            events: this.Editor.EventsAPI.methods,
            listeners: this.Editor.ListenersAPI.methods,
            notifier: this.Editor.NotifierAPI.methods,
            sanitizer: this.Editor.SanitizerAPI.methods,
            saver: this.Editor.SaverAPI.methods,
            selection: this.Editor.SelectionAPI.methods,
            styles: this.Editor.StylesAPI.classes,
            toolbar: this.Editor.ToolbarAPI.methods,
            inlineToolbar: this.Editor.InlineToolbarAPI.methods,
            tooltip: this.Editor.TooltipAPI.methods,
            i18n: this.Editor.I18nAPI.methods,
            readOnly: this.Editor.ReadOnlyAPI.methods,
            ui: this.Editor.UiAPI.methods
        };
    }
    /**
   * Returns Editor.js Core API methods for passed tool
   *
   * @param toolName - tool name
   * @param isTune - is tool a block tune
   */ getMethodsForTool(e, t1) {
        return Object.assign(this.methods, {
            i18n: this.Editor.I18nAPI.getMethodsForTool(e, t1)
        });
    }
}
class $cdae29d26d2e7999$var$yi extends $cdae29d26d2e7999$var$E {
    /**
   * Available methods
   *
   * @returns {InlineToolbar}
   */ get methods() {
        return {
            close: ()=>this.close(),
            open: ()=>this.open()
        };
    }
    /**
   * Open Inline Toolbar
   */ open() {
        this.Editor.InlineToolbar.tryToShow();
    }
    /**
   * Close Inline Toolbar
   */ close() {
        this.Editor.InlineToolbar.close();
    }
}
class $cdae29d26d2e7999$var$wi extends $cdae29d26d2e7999$var$E {
    /**
   * Available methods
   *
   * @returns {Listeners}
   */ get methods() {
        return {
            on: (e, t1, o, i)=>this.on(e, t1, o, i),
            off: (e, t1, o, i)=>this.off(e, t1, o, i),
            offById: (e)=>this.offById(e)
        };
    }
    /**
   * Ads a DOM event listener. Return it's id.
   *
   * @param {HTMLElement} element - Element to set handler to
   * @param {string} eventType - event type
   * @param {() => void} handler - event handler
   * @param {boolean} useCapture - capture event or not
   */ on(e, t1, o, i) {
        return this.listeners.on(e, t1, o, i);
    }
    /**
   * Removes DOM listener from element
   *
   * @param {Element} element - Element to remove handler from
   * @param eventType - event type
   * @param handler - event handler
   * @param {boolean} useCapture - capture event or not
   */ off(e, t1, o, i) {
        this.listeners.off(e, t1, o, i);
    }
    /**
   * Removes DOM listener by the listener id
   *
   * @param id - id of the listener to remove
   */ offById(e) {
        this.listeners.offById(e);
    }
}
var $cdae29d26d2e7999$var$Ko = {
    exports: {}
};
(function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })(window, function() {
        return function(t1) {
            var o = {};
            function i(s) {
                if (o[s]) return o[s].exports;
                var r = o[s] = {
                    i: s,
                    l: !1,
                    exports: {}
                };
                return t1[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
            }
            return i.m = t1, i.c = o, i.d = function(s, r, a) {
                i.o(s, r) || Object.defineProperty(s, r, {
                    enumerable: !0,
                    get: a
                });
            }, i.r = function(s) {
                typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(s, "__esModule", {
                    value: !0
                });
            }, i.t = function(s, r) {
                if (1 & r && (s = i(s)), 8 & r || 4 & r && typeof s == "object" && s && s.__esModule) return s;
                var a = /* @__PURE__ */ Object.create(null);
                if (i.r(a), Object.defineProperty(a, "default", {
                    enumerable: !0,
                    value: s
                }), 2 & r && typeof s != "string") for(var l in s)i.d(a, l, (function(c) {
                    return s[c];
                }).bind(null, l));
                return a;
            }, i.n = function(s) {
                var r = s && s.__esModule ? function() {
                    return s.default;
                } : function() {
                    return s;
                };
                return i.d(r, "a", r), r;
            }, i.o = function(s, r) {
                return Object.prototype.hasOwnProperty.call(s, r);
            }, i.p = "/", i(i.s = 0);
        }([
            function(t1, o, i) {
                i(1), /*!
       * Codex JavaScript Notification module
       * https://github.com/codex-team/js-notifier
       */ t1.exports = function() {
                    var s = i(6), r = "cdx-notify--bounce-in", a = null;
                    return {
                        show: function(l) {
                            if (l.message) {
                                (function() {
                                    if (a) return !0;
                                    a = s.getWrapper(), document.body.appendChild(a);
                                })();
                                var c = null, d = l.time || 8e3;
                                switch(l.type){
                                    case "confirm":
                                        c = s.confirm(l);
                                        break;
                                    case "prompt":
                                        c = s.prompt(l);
                                        break;
                                    default:
                                        c = s.alert(l), window.setTimeout(function() {
                                            c.remove();
                                        }, d);
                                }
                                a.appendChild(c), c.classList.add(r);
                            }
                        }
                    };
                }();
            },
            function(t1, o, i) {
                var s = i(2);
                typeof s == "string" && (s = [
                    [
                        t1.i,
                        s,
                        ""
                    ]
                ]);
                var r = {
                    hmr: !0,
                    transform: void 0,
                    insertInto: void 0
                };
                i(4)(s, r), s.locals && (t1.exports = s.locals);
            },
            function(t1, o, i) {
                (t1.exports = i(3)(!1)).push([
                    t1.i,
                    `.cdx-notify--error{background:#fffbfb!important}.cdx-notify--error::before{background:#fb5d5d!important}.cdx-notify__input{max-width:130px;padding:5px 10px;background:#f7f7f7;border:0;border-radius:3px;font-size:13px;color:#656b7c;outline:0}.cdx-notify__input:-ms-input-placeholder{color:#656b7c}.cdx-notify__input::placeholder{color:#656b7c}.cdx-notify__input:focus:-ms-input-placeholder{color:rgba(101,107,124,.3)}.cdx-notify__input:focus::placeholder{color:rgba(101,107,124,.3)}.cdx-notify__button{border:none;border-radius:3px;font-size:13px;padding:5px 10px;cursor:pointer}.cdx-notify__button:last-child{margin-left:10px}.cdx-notify__button--cancel{background:#f2f5f7;box-shadow:0 2px 1px 0 rgba(16,19,29,0);color:#656b7c}.cdx-notify__button--cancel:hover{background:#eee}.cdx-notify__button--confirm{background:#34c992;box-shadow:0 1px 1px 0 rgba(18,49,35,.05);color:#fff}.cdx-notify__button--confirm:hover{background:#33b082}.cdx-notify__btns-wrapper{display:-ms-flexbox;display:flex;-ms-flex-flow:row nowrap;flex-flow:row nowrap;margin-top:5px}.cdx-notify__cross{position:absolute;top:5px;right:5px;width:10px;height:10px;padding:5px;opacity:.54;cursor:pointer}.cdx-notify__cross::after,.cdx-notify__cross::before{content:'';position:absolute;left:9px;top:5px;height:12px;width:2px;background:#575d67}.cdx-notify__cross::before{transform:rotate(-45deg)}.cdx-notify__cross::after{transform:rotate(45deg)}.cdx-notify__cross:hover{opacity:1}.cdx-notifies{position:fixed;z-index:2;bottom:20px;left:20px;font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen,Ubuntu,Cantarell,"Fira Sans","Droid Sans","Helvetica Neue",sans-serif}.cdx-notify{position:relative;width:220px;margin-top:15px;padding:13px 16px;background:#fff;box-shadow:0 11px 17px 0 rgba(23,32,61,.13);border-radius:5px;font-size:14px;line-height:1.4em;word-wrap:break-word}.cdx-notify::before{content:'';position:absolute;display:block;top:0;left:0;width:3px;height:calc(100% - 6px);margin:3px;border-radius:5px;background:0 0}@keyframes bounceIn{0%{opacity:0;transform:scale(.3)}50%{opacity:1;transform:scale(1.05)}70%{transform:scale(.9)}100%{transform:scale(1)}}.cdx-notify--bounce-in{animation-name:bounceIn;animation-duration:.6s;animation-iteration-count:1}.cdx-notify--success{background:#fafffe!important}.cdx-notify--success::before{background:#41ffb1!important}`,
                    ""
                ]);
            },
            function(t1, o) {
                t1.exports = function(i) {
                    var s = [];
                    return s.toString = function() {
                        return this.map(function(r) {
                            var a = function(l, c) {
                                var d = l[1] || "", h = l[3];
                                if (!h) return d;
                                if (c && typeof btoa == "function") {
                                    var p = (f = h, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(f)))) + " */"), g = h.sources.map(function(v) {
                                        return "/*# sourceURL=" + h.sourceRoot + v + " */";
                                    });
                                    return [
                                        d
                                    ].concat(g).concat([
                                        p
                                    ]).join(`
`);
                                }
                                var f;
                                return [
                                    d
                                ].join(`
`);
                            }(r, i);
                            return r[2] ? "@media " + r[2] + "{" + a + "}" : a;
                        }).join("");
                    }, s.i = function(r, a) {
                        typeof r == "string" && (r = [
                            [
                                null,
                                r,
                                ""
                            ]
                        ]);
                        for(var l = {}, c = 0; c < this.length; c++){
                            var d = this[c][0];
                            typeof d == "number" && (l[d] = !0);
                        }
                        for(c = 0; c < r.length; c++){
                            var h = r[c];
                            typeof h[0] == "number" && l[h[0]] || (a && !h[2] ? h[2] = a : a && (h[2] = "(" + h[2] + ") and (" + a + ")"), s.push(h));
                        }
                    }, s;
                };
            },
            function(t1, o, i) {
                var s, r, a = {}, l = (s = function() {
                    return window && document && document.all && !window.atob;
                }, function() {
                    return r === void 0 && (r = s.apply(this, arguments)), r;
                }), c = function(k) {
                    var m = {};
                    return function(w) {
                        if (typeof w == "function") return w();
                        if (m[w] === void 0) {
                            var x = (function(I) {
                                return document.querySelector(I);
                            }).call(this, w);
                            if (window.HTMLIFrameElement && x instanceof window.HTMLIFrameElement) try {
                                x = x.contentDocument.head;
                            } catch  {
                                x = null;
                            }
                            m[w] = x;
                        }
                        return m[w];
                    };
                }(), d = null, h = 0, p = [], g = i(5);
                function f(k, m) {
                    for(var w = 0; w < k.length; w++){
                        var x = k[w], I = a[x.id];
                        if (I) {
                            I.refs++;
                            for(var C = 0; C < I.parts.length; C++)I.parts[C](x.parts[C]);
                            for(; C < x.parts.length; C++)I.parts.push(F(x.parts[C], m));
                        } else {
                            var N = [];
                            for(C = 0; C < x.parts.length; C++)N.push(F(x.parts[C], m));
                            a[x.id] = {
                                id: x.id,
                                refs: 1,
                                parts: N
                            };
                        }
                    }
                }
                function v(k, m) {
                    for(var w = [], x = {}, I = 0; I < k.length; I++){
                        var C = k[I], N = m.base ? C[0] + m.base : C[0], B = {
                            css: C[1],
                            media: C[2],
                            sourceMap: C[3]
                        };
                        x[N] ? x[N].parts.push(B) : w.push(x[N] = {
                            id: N,
                            parts: [
                                B
                            ]
                        });
                    }
                    return w;
                }
                function O(k, m) {
                    var w = c(k.insertInto);
                    if (!w) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
                    var x = p[p.length - 1];
                    if (k.insertAt === "top") x ? x.nextSibling ? w.insertBefore(m, x.nextSibling) : w.appendChild(m) : w.insertBefore(m, w.firstChild), p.push(m);
                    else if (k.insertAt === "bottom") w.appendChild(m);
                    else {
                        if (typeof k.insertAt != "object" || !k.insertAt.before) throw new Error(`[Style Loader]

 Invalid value for parameter 'insertAt' ('options.insertAt') found.
 Must be 'top', 'bottom', or Object.
 (https://github.com/webpack-contrib/style-loader#insertat)
`);
                        var I = c(k.insertInto + " " + k.insertAt.before);
                        w.insertBefore(m, I);
                    }
                }
                function T(k) {
                    if (k.parentNode === null) return !1;
                    k.parentNode.removeChild(k);
                    var m = p.indexOf(k);
                    m >= 0 && p.splice(m, 1);
                }
                function M(k) {
                    var m = document.createElement("style");
                    return k.attrs.type === void 0 && (k.attrs.type = "text/css"), q(m, k.attrs), O(k, m), m;
                }
                function q(k, m) {
                    Object.keys(m).forEach(function(w) {
                        k.setAttribute(w, m[w]);
                    });
                }
                function F(k, m) {
                    var w, x, I, C;
                    if (m.transform && k.css) {
                        if (!(C = m.transform(k.css))) return function() {};
                        k.css = C;
                    }
                    if (m.singleton) {
                        var N = h++;
                        w = d || (d = M(m)), x = ie.bind(null, w, N, !1), I = ie.bind(null, w, N, !0);
                    } else k.sourceMap && typeof URL == "function" && typeof URL.createObjectURL == "function" && typeof URL.revokeObjectURL == "function" && typeof Blob == "function" && typeof btoa == "function" ? (w = function(B) {
                        var W = document.createElement("link");
                        return B.attrs.type === void 0 && (B.attrs.type = "text/css"), B.attrs.rel = "stylesheet", q(W, B.attrs), O(B, W), W;
                    }(m), x = (function(B, W, ve) {
                        var se = ve.css, tt = ve.sourceMap, Yn = W.convertToAbsoluteUrls === void 0 && tt;
                        (W.convertToAbsoluteUrls || Yn) && (se = g(se)), tt && (se += `
/*# sourceMappingURL=data:application/json;base64,` + btoa(unescape(encodeURIComponent(JSON.stringify(tt)))) + " */");
                        var Kn = new Blob([
                            se
                        ], {
                            type: "text/css"
                        }), ko = B.href;
                        B.href = URL.createObjectURL(Kn), ko && URL.revokeObjectURL(ko);
                    }).bind(null, w, m), I = function() {
                        T(w), w.href && URL.revokeObjectURL(w.href);
                    }) : (w = M(m), x = (function(B, W) {
                        var ve = W.css, se = W.media;
                        if (se && B.setAttribute("media", se), B.styleSheet) B.styleSheet.cssText = ve;
                        else {
                            for(; B.firstChild;)B.removeChild(B.firstChild);
                            B.appendChild(document.createTextNode(ve));
                        }
                    }).bind(null, w), I = function() {
                        T(w);
                    });
                    return x(k), function(B) {
                        if (B) {
                            if (B.css === k.css && B.media === k.media && B.sourceMap === k.sourceMap) return;
                            x(k = B);
                        } else I();
                    };
                }
                t1.exports = function(k, m) {
                    if (typeof DEBUG < "u" && DEBUG && typeof document != "object") throw new Error("The style-loader cannot be used in a non-browser environment");
                    (m = m || {}).attrs = typeof m.attrs == "object" ? m.attrs : {}, m.singleton || typeof m.singleton == "boolean" || (m.singleton = l()), m.insertInto || (m.insertInto = "head"), m.insertAt || (m.insertAt = "bottom");
                    var w = v(k, m);
                    return f(w, m), function(x) {
                        for(var I = [], C = 0; C < w.length; C++){
                            var N = w[C];
                            (B = a[N.id]).refs--, I.push(B);
                        }
                        for(x && f(v(x, m), m), C = 0; C < I.length; C++){
                            var B;
                            if ((B = I[C]).refs === 0) {
                                for(var W = 0; W < B.parts.length; W++)B.parts[W]();
                                delete a[B.id];
                            }
                        }
                    };
                };
                var H, Q = (H = [], function(k, m) {
                    return H[k] = m, H.filter(Boolean).join(`
`);
                });
                function ie(k, m, w, x) {
                    var I = w ? "" : x.css;
                    if (k.styleSheet) k.styleSheet.cssText = Q(m, I);
                    else {
                        var C = document.createTextNode(I), N = k.childNodes;
                        N[m] && k.removeChild(N[m]), N.length ? k.insertBefore(C, N[m]) : k.appendChild(C);
                    }
                }
            },
            function(t1, o) {
                t1.exports = function(i) {
                    var s = typeof window < "u" && window.location;
                    if (!s) throw new Error("fixUrls requires window.location");
                    if (!i || typeof i != "string") return i;
                    var r = s.protocol + "//" + s.host, a = r + s.pathname.replace(/\/[^\/]*$/, "/");
                    return i.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(l, c) {
                        var d, h = c.trim().replace(/^"(.*)"$/, function(p, g) {
                            return g;
                        }).replace(/^'(.*)'$/, function(p, g) {
                            return g;
                        });
                        return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(h) ? l : (d = h.indexOf("//") === 0 ? h : h.indexOf("/") === 0 ? r + h : a + h.replace(/^\.\//, ""), "url(" + JSON.stringify(d) + ")");
                    });
                };
            },
            function(t1, o, i) {
                var s, r, a, l, c, d, h, p, g;
                t1.exports = (s = "cdx-notifies", r = "cdx-notify", a = "cdx-notify__cross", l = "cdx-notify__button--confirm", c = "cdx-notify__button--cancel", d = "cdx-notify__input", h = "cdx-notify__button", p = "cdx-notify__btns-wrapper", {
                    alert: g = function(f) {
                        var v = document.createElement("DIV"), O = document.createElement("DIV"), T = f.message, M = f.style;
                        return v.classList.add(r), M && v.classList.add(r + "--" + M), v.innerHTML = T, O.classList.add(a), O.addEventListener("click", v.remove.bind(v)), v.appendChild(O), v;
                    },
                    confirm: function(f) {
                        var v = g(f), O = document.createElement("div"), T = document.createElement("button"), M = document.createElement("button"), q = v.querySelector("." + a), F = f.cancelHandler, H = f.okHandler;
                        return O.classList.add(p), T.innerHTML = f.okText || "Confirm", M.innerHTML = f.cancelText || "Cancel", T.classList.add(h), M.classList.add(h), T.classList.add(l), M.classList.add(c), F && typeof F == "function" && (M.addEventListener("click", F), q.addEventListener("click", F)), H && typeof H == "function" && T.addEventListener("click", H), T.addEventListener("click", v.remove.bind(v)), M.addEventListener("click", v.remove.bind(v)), O.appendChild(T), O.appendChild(M), v.appendChild(O), v;
                    },
                    prompt: function(f) {
                        var v = g(f), O = document.createElement("div"), T = document.createElement("button"), M = document.createElement("input"), q = v.querySelector("." + a), F = f.cancelHandler, H = f.okHandler;
                        return O.classList.add(p), T.innerHTML = f.okText || "Ok", T.classList.add(h), T.classList.add(l), M.classList.add(d), f.placeholder && M.setAttribute("placeholder", f.placeholder), f.default && (M.value = f.default), f.inputType && (M.type = f.inputType), F && typeof F == "function" && q.addEventListener("click", F), H && typeof H == "function" && T.addEventListener("click", function() {
                            H(M.value);
                        }), T.addEventListener("click", v.remove.bind(v)), O.appendChild(M), O.appendChild(T), v.appendChild(O), v;
                    },
                    getWrapper: function() {
                        var f = document.createElement("DIV");
                        return f.classList.add(s), f;
                    }
                });
            }
        ]);
    });
})($cdae29d26d2e7999$var$Ko);
var $cdae29d26d2e7999$var$Ei = $cdae29d26d2e7999$var$Ko.exports;
const $cdae29d26d2e7999$var$xi = /* @__PURE__ */ $cdae29d26d2e7999$var$Ke($cdae29d26d2e7999$var$Ei);
class $cdae29d26d2e7999$var$Bi {
    /**
   * Show web notification
   *
   * @param {NotifierOptions | ConfirmNotifierOptions | PromptNotifierOptions} options - notification options
   */ show(e) {
        $cdae29d26d2e7999$var$xi.show(e);
    }
}
class $cdae29d26d2e7999$var$Ci extends $cdae29d26d2e7999$var$E {
    /**
   * @param moduleConfiguration - Module Configuration
   * @param moduleConfiguration.config - Editor's config
   * @param moduleConfiguration.eventsDispatcher - Editor's event dispatcher
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        }), this.notifier = new $cdae29d26d2e7999$var$Bi();
    }
    /**
   * Available methods
   */ get methods() {
        return {
            show: (e)=>this.show(e)
        };
    }
    /**
   * Show notification
   *
   * @param {NotifierOptions} options - message option
   */ show(e) {
        return this.notifier.show(e);
    }
}
class $cdae29d26d2e7999$var$Ti extends $cdae29d26d2e7999$var$E {
    /**
   * Available methods
   */ get methods() {
        const e = ()=>this.isEnabled;
        return {
            toggle: (t1)=>this.toggle(t1),
            get isEnabled () {
                return e();
            }
        };
    }
    /**
   * Set or toggle read-only state
   *
   * @param {boolean|undefined} state - set or toggle state
   * @returns {boolean} current value
   */ toggle(e) {
        return this.Editor.ReadOnly.toggle(e);
    }
    /**
   * Returns current read-only state
   */ get isEnabled() {
        return this.Editor.ReadOnly.isEnabled;
    }
}
var $cdae29d26d2e7999$var$Xo = {
    exports: {}
};
(function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })($cdae29d26d2e7999$var$Ce, function() {
        function t1(h) {
            var p = h.tags, g = Object.keys(p), f = g.map(function(v) {
                return typeof p[v];
            }).every(function(v) {
                return v === "object" || v === "boolean" || v === "function";
            });
            if (!f) throw new Error("The configuration was invalid");
            this.config = h;
        }
        var o = [
            "P",
            "LI",
            "TD",
            "TH",
            "DIV",
            "H1",
            "H2",
            "H3",
            "H4",
            "H5",
            "H6",
            "PRE"
        ];
        function i(h) {
            return o.indexOf(h.nodeName) !== -1;
        }
        var s = [
            "A",
            "B",
            "STRONG",
            "I",
            "EM",
            "SUB",
            "SUP",
            "U",
            "STRIKE"
        ];
        function r(h) {
            return s.indexOf(h.nodeName) !== -1;
        }
        t1.prototype.clean = function(h) {
            const p = document.implementation.createHTMLDocument(), g = p.createElement("div");
            return g.innerHTML = h, this._sanitize(p, g), g.innerHTML;
        }, t1.prototype._sanitize = function(h, p) {
            var g = a(h, p), f = g.firstChild();
            if (f) do {
                if (f.nodeType === Node.TEXT_NODE) {
                    if (f.data.trim() === "" && (f.previousElementSibling && i(f.previousElementSibling) || f.nextElementSibling && i(f.nextElementSibling))) {
                        p.removeChild(f), this._sanitize(h, p);
                        break;
                    } else continue;
                }
                if (f.nodeType === Node.COMMENT_NODE) {
                    p.removeChild(f), this._sanitize(h, p);
                    break;
                }
                var v = r(f), O;
                v && (O = Array.prototype.some.call(f.childNodes, i));
                var T = !!p.parentNode, M = i(p) && i(f) && T, q = f.nodeName.toLowerCase(), F = l(this.config, q, f), H = v && O;
                if (H || c(f, F) || !this.config.keepNestedBlockElements && M) {
                    if (!(f.nodeName === "SCRIPT" || f.nodeName === "STYLE")) for(; f.childNodes.length > 0;)p.insertBefore(f.childNodes[0], f);
                    p.removeChild(f), this._sanitize(h, p);
                    break;
                }
                for(var Q = 0; Q < f.attributes.length; Q += 1){
                    var ie = f.attributes[Q];
                    d(ie, F, f) && (f.removeAttribute(ie.name), Q = Q - 1);
                }
                this._sanitize(h, f);
            }while (f = g.nextSibling());
        };
        function a(h, p) {
            return h.createTreeWalker(p, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT, null, !1);
        }
        function l(h, p, g) {
            return typeof h.tags[p] == "function" ? h.tags[p](g) : h.tags[p];
        }
        function c(h, p) {
            return typeof p > "u" ? !0 : typeof p == "boolean" ? !p : !1;
        }
        function d(h, p, g) {
            var f = h.name.toLowerCase();
            return p === !0 ? !1 : typeof p[f] == "function" ? !p[f](h.value, g) : typeof p[f] > "u" || p[f] === !1 ? !0 : typeof p[f] == "string" ? p[f] !== h.value : !1;
        }
        return t1;
    });
})($cdae29d26d2e7999$var$Xo);
var $cdae29d26d2e7999$var$Si = $cdae29d26d2e7999$var$Xo.exports;
const $cdae29d26d2e7999$var$Ii = /* @__PURE__ */ $cdae29d26d2e7999$var$Ke($cdae29d26d2e7999$var$Si);
function $cdae29d26d2e7999$var$yt(n, e) {
    return n.map((t1)=>{
        const o = $cdae29d26d2e7999$var$A(e) ? e(t1.tool) : e;
        return $cdae29d26d2e7999$var$V(o) || (t1.data = $cdae29d26d2e7999$var$wt(t1.data, o)), t1;
    });
}
function $cdae29d26d2e7999$var$Z(n, e = {}) {
    const t1 = {
        tags: e
    };
    return new $cdae29d26d2e7999$var$Ii(t1).clean(n);
}
function $cdae29d26d2e7999$var$wt(n, e) {
    return Array.isArray(n) ? $cdae29d26d2e7999$var$Oi(n, e) : $cdae29d26d2e7999$var$D(n) ? $cdae29d26d2e7999$var$_i(n, e) : $cdae29d26d2e7999$var$te(n) ? $cdae29d26d2e7999$var$Mi(n, e) : n;
}
function $cdae29d26d2e7999$var$Oi(n, e) {
    return n.map((t1)=>$cdae29d26d2e7999$var$wt(t1, e));
}
function $cdae29d26d2e7999$var$_i(n, e) {
    const t1 = {};
    for(const o in n){
        if (!Object.prototype.hasOwnProperty.call(n, o)) continue;
        const i = n[o], s = $cdae29d26d2e7999$var$Ai(e[o]) ? e[o] : e;
        t1[o] = $cdae29d26d2e7999$var$wt(i, s);
    }
    return t1;
}
function $cdae29d26d2e7999$var$Mi(n, e) {
    return $cdae29d26d2e7999$var$D(e) ? $cdae29d26d2e7999$var$Z(n, e) : e === !1 ? $cdae29d26d2e7999$var$Z(n, {}) : n;
}
function $cdae29d26d2e7999$var$Ai(n) {
    return $cdae29d26d2e7999$var$D(n) || $cdae29d26d2e7999$var$Gn(n) || $cdae29d26d2e7999$var$A(n);
}
class $cdae29d26d2e7999$var$Li extends $cdae29d26d2e7999$var$E {
    /**
   * Available methods
   *
   * @returns {SanitizerConfig}
   */ get methods() {
        return {
            clean: (e, t1)=>this.clean(e, t1)
        };
    }
    /**
   * Perform sanitizing of a string
   *
   * @param {string} taintString - what to sanitize
   * @param {SanitizerConfig} config - sanitizer config
   * @returns {string}
   */ clean(e, t1) {
        return $cdae29d26d2e7999$var$Z(e, t1);
    }
}
class $cdae29d26d2e7999$var$Pi extends $cdae29d26d2e7999$var$E {
    /**
   * Available methods
   *
   * @returns {Saver}
   */ get methods() {
        return {
            save: ()=>this.save()
        };
    }
    /**
   * Return Editor's data
   *
   * @returns {OutputData}
   */ save() {
        const e = "Editor's content can not be saved in read-only mode";
        return this.Editor.ReadOnly.isEnabled ? ($cdae29d26d2e7999$var$X(e, "warn"), Promise.reject(new Error(e))) : this.Editor.Saver.save();
    }
}
class $cdae29d26d2e7999$var$Ni extends $cdae29d26d2e7999$var$E {
    constructor(){
        super(...arguments), this.selectionUtils = new $cdae29d26d2e7999$var$b();
    }
    /**
   * Available methods
   *
   * @returns {SelectionAPIInterface}
   */ get methods() {
        return {
            findParentTag: (e, t1)=>this.findParentTag(e, t1),
            expandToTag: (e)=>this.expandToTag(e),
            save: ()=>this.selectionUtils.save(),
            restore: ()=>this.selectionUtils.restore(),
            setFakeBackground: ()=>this.selectionUtils.setFakeBackground(),
            removeFakeBackground: ()=>this.selectionUtils.removeFakeBackground()
        };
    }
    /**
   * Looks ahead from selection and find passed tag with class name
   *
   * @param {string} tagName - tag to find
   * @param {string} className - tag's class name
   * @returns {HTMLElement|null}
   */ findParentTag(e, t1) {
        return this.selectionUtils.findParentTag(e, t1);
    }
    /**
   * Expand selection to passed tag
   *
   * @param {HTMLElement} node - tag that should contain selection
   */ expandToTag(e) {
        this.selectionUtils.expandToTag(e);
    }
}
class $cdae29d26d2e7999$var$Ri extends $cdae29d26d2e7999$var$E {
    /**
   * Available methods
   */ get methods() {
        return {
            getBlockTools: ()=>Array.from(this.Editor.Tools.blockTools.values())
        };
    }
}
class $cdae29d26d2e7999$var$Di extends $cdae29d26d2e7999$var$E {
    /**
   * Exported classes
   */ get classes() {
        return {
            /**
       * Base Block styles
       */ block: "cdx-block",
            /**
       * Inline Tools styles
       */ inlineToolButton: "ce-inline-tool",
            inlineToolButtonActive: "ce-inline-tool--active",
            /**
       * UI elements
       */ input: "cdx-input",
            loader: "cdx-loader",
            button: "cdx-button",
            /**
       * Settings styles
       */ settingsButton: "cdx-settings-button",
            settingsButtonActive: "cdx-settings-button--active"
        };
    }
}
class $cdae29d26d2e7999$var$Fi extends $cdae29d26d2e7999$var$E {
    /**
   * Available methods
   *
   * @returns {Toolbar}
   */ get methods() {
        return {
            close: ()=>this.close(),
            open: ()=>this.open(),
            toggleBlockSettings: (e)=>this.toggleBlockSettings(e),
            toggleToolbox: (e)=>this.toggleToolbox(e)
        };
    }
    /**
   * Open toolbar
   */ open() {
        this.Editor.Toolbar.moveAndOpen();
    }
    /**
   * Close toolbar and all included elements
   */ close() {
        this.Editor.Toolbar.close();
    }
    /**
   * Toggles Block Setting of the current block
   *
   * @param {boolean} openingState —  opening state of Block Setting
   */ toggleBlockSettings(e) {
        if (this.Editor.BlockManager.currentBlockIndex === -1) {
            $cdae29d26d2e7999$var$X("Could't toggle the Toolbar because there is no block selected ", "warn");
            return;
        }
        e ?? !this.Editor.BlockSettings.opened ? (this.Editor.Toolbar.moveAndOpen(), this.Editor.BlockSettings.open()) : this.Editor.BlockSettings.close();
    }
    /**
   * Open toolbox
   *
   * @param {boolean} openingState - Opening state of toolbox
   */ toggleToolbox(e) {
        if (this.Editor.BlockManager.currentBlockIndex === -1) {
            $cdae29d26d2e7999$var$X("Could't toggle the Toolbox because there is no block selected ", "warn");
            return;
        }
        e ?? !this.Editor.Toolbar.toolbox.opened ? (this.Editor.Toolbar.moveAndOpen(), this.Editor.Toolbar.toolbox.open()) : this.Editor.Toolbar.toolbox.close();
    }
}
var $cdae29d26d2e7999$var$Vo = {
    exports: {}
};
/*!
 * CodeX.Tooltips
 * 
 * @version 1.0.5
 * 
 * @licence MIT
 * @author CodeX <https://codex.so>
 * 
 * 
 */ (function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })(window, function() {
        return function(t1) {
            var o = {};
            function i(s) {
                if (o[s]) return o[s].exports;
                var r = o[s] = {
                    i: s,
                    l: !1,
                    exports: {}
                };
                return t1[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
            }
            return i.m = t1, i.c = o, i.d = function(s, r, a) {
                i.o(s, r) || Object.defineProperty(s, r, {
                    enumerable: !0,
                    get: a
                });
            }, i.r = function(s) {
                typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(s, "__esModule", {
                    value: !0
                });
            }, i.t = function(s, r) {
                if (1 & r && (s = i(s)), 8 & r || 4 & r && typeof s == "object" && s && s.__esModule) return s;
                var a = /* @__PURE__ */ Object.create(null);
                if (i.r(a), Object.defineProperty(a, "default", {
                    enumerable: !0,
                    value: s
                }), 2 & r && typeof s != "string") for(var l in s)i.d(a, l, (function(c) {
                    return s[c];
                }).bind(null, l));
                return a;
            }, i.n = function(s) {
                var r = s && s.__esModule ? function() {
                    return s.default;
                } : function() {
                    return s;
                };
                return i.d(r, "a", r), r;
            }, i.o = function(s, r) {
                return Object.prototype.hasOwnProperty.call(s, r);
            }, i.p = "", i(i.s = 0);
        }([
            function(t1, o, i) {
                t1.exports = i(1);
            },
            function(t1, o, i) {
                i.r(o), i.d(o, "default", function() {
                    return s;
                });
                class s {
                    constructor(){
                        this.nodes = {
                            wrapper: null,
                            content: null
                        }, this.showed = !1, this.offsetTop = 10, this.offsetLeft = 10, this.offsetRight = 10, this.hidingDelay = 0, this.handleWindowScroll = ()=>{
                            this.showed && this.hide(!0);
                        }, this.loadStyles(), this.prepare(), window.addEventListener("scroll", this.handleWindowScroll, {
                            passive: !0
                        });
                    }
                    get CSS() {
                        return {
                            tooltip: "ct",
                            tooltipContent: "ct__content",
                            tooltipShown: "ct--shown",
                            placement: {
                                left: "ct--left",
                                bottom: "ct--bottom",
                                right: "ct--right",
                                top: "ct--top"
                            }
                        };
                    }
                    show(a, l, c) {
                        this.nodes.wrapper || this.prepare(), this.hidingTimeout && clearTimeout(this.hidingTimeout);
                        const d = Object.assign({
                            placement: "bottom",
                            marginTop: 0,
                            marginLeft: 0,
                            marginRight: 0,
                            marginBottom: 0,
                            delay: 70,
                            hidingDelay: 0
                        }, c);
                        if (d.hidingDelay && (this.hidingDelay = d.hidingDelay), this.nodes.content.innerHTML = "", typeof l == "string") this.nodes.content.appendChild(document.createTextNode(l));
                        else {
                            if (!(l instanceof Node)) throw Error("[CodeX Tooltip] Wrong type of \xabcontent\xbb passed. It should be an instance of Node or String. But " + typeof l + " given.");
                            this.nodes.content.appendChild(l);
                        }
                        switch(this.nodes.wrapper.classList.remove(...Object.values(this.CSS.placement)), d.placement){
                            case "top":
                                this.placeTop(a, d);
                                break;
                            case "left":
                                this.placeLeft(a, d);
                                break;
                            case "right":
                                this.placeRight(a, d);
                                break;
                            case "bottom":
                            default:
                                this.placeBottom(a, d);
                        }
                        d && d.delay ? this.showingTimeout = setTimeout(()=>{
                            this.nodes.wrapper.classList.add(this.CSS.tooltipShown), this.showed = !0;
                        }, d.delay) : (this.nodes.wrapper.classList.add(this.CSS.tooltipShown), this.showed = !0);
                    }
                    hide(a = !1) {
                        if (this.hidingDelay && !a) return this.hidingTimeout && clearTimeout(this.hidingTimeout), void (this.hidingTimeout = setTimeout(()=>{
                            this.hide(!0);
                        }, this.hidingDelay));
                        this.nodes.wrapper.classList.remove(this.CSS.tooltipShown), this.showed = !1, this.showingTimeout && clearTimeout(this.showingTimeout);
                    }
                    onHover(a, l, c) {
                        a.addEventListener("mouseenter", ()=>{
                            this.show(a, l, c);
                        }), a.addEventListener("mouseleave", ()=>{
                            this.hide();
                        });
                    }
                    destroy() {
                        this.nodes.wrapper.remove(), window.removeEventListener("scroll", this.handleWindowScroll);
                    }
                    prepare() {
                        this.nodes.wrapper = this.make("div", this.CSS.tooltip), this.nodes.content = this.make("div", this.CSS.tooltipContent), this.append(this.nodes.wrapper, this.nodes.content), this.append(document.body, this.nodes.wrapper);
                    }
                    loadStyles() {
                        const a = "codex-tooltips-style";
                        if (document.getElementById(a)) return;
                        const l = i(2), c = this.make("style", null, {
                            textContent: l.toString(),
                            id: a
                        });
                        this.prepend(document.head, c);
                    }
                    placeBottom(a, l) {
                        const c = a.getBoundingClientRect(), d = c.left + a.clientWidth / 2 - this.nodes.wrapper.offsetWidth / 2, h = c.bottom + window.pageYOffset + this.offsetTop + l.marginTop;
                        this.applyPlacement("bottom", d, h);
                    }
                    placeTop(a, l) {
                        const c = a.getBoundingClientRect(), d = c.left + a.clientWidth / 2 - this.nodes.wrapper.offsetWidth / 2, h = c.top + window.pageYOffset - this.nodes.wrapper.clientHeight - this.offsetTop;
                        this.applyPlacement("top", d, h);
                    }
                    placeLeft(a, l) {
                        const c = a.getBoundingClientRect(), d = c.left - this.nodes.wrapper.offsetWidth - this.offsetLeft - l.marginLeft, h = c.top + window.pageYOffset + a.clientHeight / 2 - this.nodes.wrapper.offsetHeight / 2;
                        this.applyPlacement("left", d, h);
                    }
                    placeRight(a, l) {
                        const c = a.getBoundingClientRect(), d = c.right + this.offsetRight + l.marginRight, h = c.top + window.pageYOffset + a.clientHeight / 2 - this.nodes.wrapper.offsetHeight / 2;
                        this.applyPlacement("right", d, h);
                    }
                    applyPlacement(a, l, c) {
                        this.nodes.wrapper.classList.add(this.CSS.placement[a]), this.nodes.wrapper.style.left = l + "px", this.nodes.wrapper.style.top = c + "px";
                    }
                    make(a, l = null, c = {}) {
                        const d = document.createElement(a);
                        Array.isArray(l) ? d.classList.add(...l) : l && d.classList.add(l);
                        for(const h in c)c.hasOwnProperty(h) && (d[h] = c[h]);
                        return d;
                    }
                    append(a, l) {
                        Array.isArray(l) ? l.forEach((c)=>a.appendChild(c)) : a.appendChild(l);
                    }
                    prepend(a, l) {
                        Array.isArray(l) ? (l = l.reverse()).forEach((c)=>a.prepend(c)) : a.prepend(l);
                    }
                }
            },
            function(t1, o) {
                t1.exports = `.ct{z-index:999;opacity:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none;-webkit-transition:opacity 50ms ease-in,-webkit-transform 70ms cubic-bezier(.215,.61,.355,1);transition:opacity 50ms ease-in,-webkit-transform 70ms cubic-bezier(.215,.61,.355,1);transition:opacity 50ms ease-in,transform 70ms cubic-bezier(.215,.61,.355,1);transition:opacity 50ms ease-in,transform 70ms cubic-bezier(.215,.61,.355,1),-webkit-transform 70ms cubic-bezier(.215,.61,.355,1);will-change:opacity,top,left;-webkit-box-shadow:0 8px 12px 0 rgba(29,32,43,.17),0 4px 5px -3px rgba(5,6,12,.49);box-shadow:0 8px 12px 0 rgba(29,32,43,.17),0 4px 5px -3px rgba(5,6,12,.49);border-radius:9px}.ct,.ct:before{position:absolute;top:0;left:0}.ct:before{content:"";bottom:0;right:0;background-color:#1d202b;z-index:-1;border-radius:4px}@supports(-webkit-mask-box-image:url("")){.ct:before{border-radius:0;-webkit-mask-box-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M10.71 0h2.58c3.02 0 4.64.42 6.1 1.2a8.18 8.18 0 013.4 3.4C23.6 6.07 24 7.7 24 10.71v2.58c0 3.02-.42 4.64-1.2 6.1a8.18 8.18 0 01-3.4 3.4c-1.47.8-3.1 1.21-6.11 1.21H10.7c-3.02 0-4.64-.42-6.1-1.2a8.18 8.18 0 01-3.4-3.4C.4 17.93 0 16.3 0 13.29V10.7c0-3.02.42-4.64 1.2-6.1a8.18 8.18 0 013.4-3.4C6.07.4 7.7 0 10.71 0z"/></svg>') 48% 41% 37.9% 53.3%}}@media (--mobile){.ct{display:none}}.ct__content{padding:6px 10px;color:#cdd1e0;font-size:12px;text-align:center;letter-spacing:.02em;line-height:1em}.ct:after{content:"";width:8px;height:8px;position:absolute;background-color:#1d202b;z-index:-1}.ct--bottom{-webkit-transform:translateY(5px);transform:translateY(5px)}.ct--bottom:after{top:-3px;left:50%;-webkit-transform:translateX(-50%) rotate(-45deg);transform:translateX(-50%) rotate(-45deg)}.ct--top{-webkit-transform:translateY(-5px);transform:translateY(-5px)}.ct--top:after{top:auto;bottom:-3px;left:50%;-webkit-transform:translateX(-50%) rotate(-45deg);transform:translateX(-50%) rotate(-45deg)}.ct--left{-webkit-transform:translateX(-5px);transform:translateX(-5px)}.ct--left:after{top:50%;left:auto;right:0;-webkit-transform:translate(41.6%,-50%) rotate(-45deg);transform:translate(41.6%,-50%) rotate(-45deg)}.ct--right{-webkit-transform:translateX(5px);transform:translateX(5px)}.ct--right:after{top:50%;left:0;-webkit-transform:translate(-41.6%,-50%) rotate(-45deg);transform:translate(-41.6%,-50%) rotate(-45deg)}.ct--shown{opacity:1;-webkit-transform:none;transform:none}`;
            }
        ]).default;
    });
})($cdae29d26d2e7999$var$Vo);
var $cdae29d26d2e7999$var$ji = $cdae29d26d2e7999$var$Vo.exports;
const $cdae29d26d2e7999$var$Hi = /* @__PURE__ */ $cdae29d26d2e7999$var$Ke($cdae29d26d2e7999$var$ji);
let $cdae29d26d2e7999$var$U = null;
function $cdae29d26d2e7999$var$Et() {
    $cdae29d26d2e7999$var$U || ($cdae29d26d2e7999$var$U = new $cdae29d26d2e7999$var$Hi());
}
function $cdae29d26d2e7999$var$$i(n, e, t1) {
    $cdae29d26d2e7999$var$Et(), $cdae29d26d2e7999$var$U == null || $cdae29d26d2e7999$var$U.show(n, e, t1);
}
function $cdae29d26d2e7999$var$$e(n = !1) {
    $cdae29d26d2e7999$var$Et(), $cdae29d26d2e7999$var$U == null || $cdae29d26d2e7999$var$U.hide(n);
}
function $cdae29d26d2e7999$var$ze(n, e, t1) {
    $cdae29d26d2e7999$var$Et(), $cdae29d26d2e7999$var$U == null || $cdae29d26d2e7999$var$U.onHover(n, e, t1);
}
function $cdae29d26d2e7999$var$zi() {
    $cdae29d26d2e7999$var$U == null || $cdae29d26d2e7999$var$U.destroy(), $cdae29d26d2e7999$var$U = null;
}
class $cdae29d26d2e7999$var$Ui extends $cdae29d26d2e7999$var$E {
    /**
   * @class
   * @param moduleConfiguration - Module Configuration
   * @param moduleConfiguration.config - Editor's config
   * @param moduleConfiguration.eventsDispatcher - Editor's event dispatcher
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        });
    }
    /**
   * Available methods
   */ get methods() {
        return {
            show: (e, t1, o)=>this.show(e, t1, o),
            hide: ()=>this.hide(),
            onHover: (e, t1, o)=>this.onHover(e, t1, o)
        };
    }
    /**
   * Method show tooltip on element with passed HTML content
   *
   * @param {HTMLElement} element - element on which tooltip should be shown
   * @param {TooltipContent} content - tooltip content
   * @param {TooltipOptions} options - tooltip options
   */ show(e, t1, o) {
        $cdae29d26d2e7999$var$$i(e, t1, o);
    }
    /**
   * Method hides tooltip on HTML page
   */ hide() {
        $cdae29d26d2e7999$var$$e();
    }
    /**
   * Decorator for showing Tooltip by mouseenter/mouseleave
   *
   * @param {HTMLElement} element - element on which tooltip should be shown
   * @param {TooltipContent} content - tooltip content
   * @param {TooltipOptions} options - tooltip options
   */ onHover(e, t1, o) {
        $cdae29d26d2e7999$var$ze(e, t1, o);
    }
}
class $cdae29d26d2e7999$var$Wi extends $cdae29d26d2e7999$var$E {
    /**
   * Available methods / getters
   */ get methods() {
        return {
            nodes: this.editorNodes
        };
    }
    /**
   * Exported classes
   */ get editorNodes() {
        return {
            /**
       * Top-level editor instance wrapper
       */ wrapper: this.Editor.UI.nodes.wrapper,
            /**
       * Element that holds all the Blocks
       */ redactor: this.Editor.UI.nodes.redactor
        };
    }
}
function $cdae29d26d2e7999$var$qo(n, e) {
    const t1 = {};
    return Object.entries(n).forEach(([o, i])=>{
        if ($cdae29d26d2e7999$var$D(i)) {
            const s = e ? `${e}.${o}` : o;
            Object.values(i).every((a)=>$cdae29d26d2e7999$var$te(a)) ? t1[o] = s : t1[o] = $cdae29d26d2e7999$var$qo(i, s);
            return;
        }
        t1[o] = i;
    }), t1;
}
const $cdae29d26d2e7999$var$K = $cdae29d26d2e7999$var$qo($cdae29d26d2e7999$var$Fo);
function $cdae29d26d2e7999$var$Yi(n, e) {
    const t1 = {};
    return Object.keys(n).forEach((o)=>{
        const i = e[o];
        i !== void 0 ? t1[i] = n[o] : t1[o] = n[o];
    }), t1;
}
const $cdae29d26d2e7999$var$Zo = class Ee {
    /**
   * @param {HTMLElement[]} nodeList — the list of iterable HTML-items
   * @param {string} focusedCssClass - user-provided CSS-class that will be set in flipping process
   */ constructor(e, t1){
        this.cursor = -1, this.items = [], this.items = e || [], this.focusedCssClass = t1;
    }
    /**
   * Returns Focused button Node
   *
   * @returns {HTMLElement}
   */ get currentItem() {
        return this.cursor === -1 ? null : this.items[this.cursor];
    }
    /**
   * Sets cursor to specified position
   *
   * @param cursorPosition - new cursor position
   */ setCursor(e) {
        e < this.items.length && e >= -1 && (this.dropCursor(), this.cursor = e, this.items[this.cursor].classList.add(this.focusedCssClass));
    }
    /**
   * Sets items. Can be used when iterable items changed dynamically
   *
   * @param {HTMLElement[]} nodeList - nodes to iterate
   */ setItems(e) {
        this.items = e;
    }
    /**
   * Sets cursor next to the current
   */ next() {
        this.cursor = this.leafNodesAndReturnIndex(Ee.directions.RIGHT);
    }
    /**
   * Sets cursor before current
   */ previous() {
        this.cursor = this.leafNodesAndReturnIndex(Ee.directions.LEFT);
    }
    /**
   * Sets cursor to the default position and removes CSS-class from previously focused item
   */ dropCursor() {
        this.cursor !== -1 && (this.items[this.cursor].classList.remove(this.focusedCssClass), this.cursor = -1);
    }
    /**
   * Leafs nodes inside the target list from active element
   *
   * @param {string} direction - leaf direction. Can be 'left' or 'right'
   * @returns {number} index of focused node
   */ leafNodesAndReturnIndex(e) {
        if (this.items.length === 0) return this.cursor;
        let t1 = this.cursor;
        return t1 === -1 ? t1 = e === Ee.directions.RIGHT ? -1 : 0 : this.items[t1].classList.remove(this.focusedCssClass), e === Ee.directions.RIGHT ? t1 = (t1 + 1) % this.items.length : t1 = (this.items.length + t1 - 1) % this.items.length, $cdae29d26d2e7999$var$u.canSetCaret(this.items[t1]) && $cdae29d26d2e7999$var$Fe(()=>$cdae29d26d2e7999$var$b.setCursor(this.items[t1]), 50)(), this.items[t1].classList.add(this.focusedCssClass), t1;
    }
};
$cdae29d26d2e7999$var$Zo.directions = {
    RIGHT: "right",
    LEFT: "left"
};
let $cdae29d26d2e7999$var$ke = $cdae29d26d2e7999$var$Zo;
class $cdae29d26d2e7999$var$ce {
    /**
   * @param options - different constructing settings
   */ constructor(e){
        this.iterator = null, this.activated = !1, this.flipCallbacks = [], this.onKeyDown = (t1)=>{
            if (!(!this.isEventReadyForHandling(t1) || t1.shiftKey === !0)) switch($cdae29d26d2e7999$var$ce.usedKeys.includes(t1.keyCode) && t1.preventDefault(), t1.keyCode){
                case $cdae29d26d2e7999$var$y.TAB:
                    this.handleTabPress(t1);
                    break;
                case $cdae29d26d2e7999$var$y.LEFT:
                case $cdae29d26d2e7999$var$y.UP:
                    this.flipLeft();
                    break;
                case $cdae29d26d2e7999$var$y.RIGHT:
                case $cdae29d26d2e7999$var$y.DOWN:
                    this.flipRight();
                    break;
                case $cdae29d26d2e7999$var$y.ENTER:
                    this.handleEnterPress(t1);
                    break;
            }
        }, this.iterator = new $cdae29d26d2e7999$var$ke(e.items, e.focusedItemClass), this.activateCallback = e.activateCallback, this.allowedKeys = e.allowedKeys || $cdae29d26d2e7999$var$ce.usedKeys;
    }
    /**
   * True if flipper is currently activated
   */ get isActivated() {
        return this.activated;
    }
    /**
   * Array of keys (codes) that is handled by Flipper
   * Used to:
   *  - preventDefault only for this keys, not all keydowns (@see constructor)
   *  - to skip external behaviours only for these keys, when filler is activated (@see BlockEvents@arrowRightAndDown)
   */ static get usedKeys() {
        return [
            $cdae29d26d2e7999$var$y.TAB,
            $cdae29d26d2e7999$var$y.LEFT,
            $cdae29d26d2e7999$var$y.RIGHT,
            $cdae29d26d2e7999$var$y.ENTER,
            $cdae29d26d2e7999$var$y.UP,
            $cdae29d26d2e7999$var$y.DOWN
        ];
    }
    /**
   * Active tab/arrows handling by flipper
   *
   * @param items - Some modules (like, InlineToolbar, BlockSettings) might refresh buttons dynamically
   * @param cursorPosition - index of the item that should be focused once flipper is activated
   */ activate(e, t1) {
        this.activated = !0, e && this.iterator.setItems(e), t1 !== void 0 && this.iterator.setCursor(t1), document.addEventListener("keydown", this.onKeyDown, !0);
    }
    /**
   * Disable tab/arrows handling by flipper
   */ deactivate() {
        this.activated = !1, this.dropCursor(), document.removeEventListener("keydown", this.onKeyDown);
    }
    /**
   * Focus first item
   */ focusFirst() {
        this.dropCursor(), this.flipRight();
    }
    /**
   * Focuses previous flipper iterator item
   */ flipLeft() {
        this.iterator.previous(), this.flipCallback();
    }
    /**
   * Focuses next flipper iterator item
   */ flipRight() {
        this.iterator.next(), this.flipCallback();
    }
    /**
   * Return true if some button is focused
   */ hasFocus() {
        return !!this.iterator.currentItem;
    }
    /**
   * Registeres function that should be executed on each navigation action
   *
   * @param cb - function to execute
   */ onFlip(e) {
        this.flipCallbacks.push(e);
    }
    /**
   * Unregisteres function that is executed on each navigation action
   *
   * @param cb - function to stop executing
   */ removeOnFlip(e) {
        this.flipCallbacks = this.flipCallbacks.filter((t1)=>t1 !== e);
    }
    /**
   * Drops flipper's iterator cursor
   *
   * @see DomIterator#dropCursor
   */ dropCursor() {
        this.iterator.dropCursor();
    }
    /**
   * This function is fired before handling flipper keycodes
   * The result of this function defines if it is need to be handled or not
   *
   * @param {KeyboardEvent} event - keydown keyboard event
   * @returns {boolean}
   */ isEventReadyForHandling(e) {
        return this.activated && this.allowedKeys.includes(e.keyCode);
    }
    /**
   * When flipper is activated tab press will leaf the items
   *
   * @param {KeyboardEvent} event - tab keydown event
   */ handleTabPress(e) {
        switch(e.shiftKey ? $cdae29d26d2e7999$var$ke.directions.LEFT : $cdae29d26d2e7999$var$ke.directions.RIGHT){
            case $cdae29d26d2e7999$var$ke.directions.RIGHT:
                this.flipRight();
                break;
            case $cdae29d26d2e7999$var$ke.directions.LEFT:
                this.flipLeft();
                break;
        }
    }
    /**
   * Enter press will click current item if flipper is activated
   *
   * @param {KeyboardEvent} event - enter keydown event
   */ handleEnterPress(e) {
        this.activated && (this.iterator.currentItem && (e.stopPropagation(), e.preventDefault(), this.iterator.currentItem.click()), $cdae29d26d2e7999$var$A(this.activateCallback) && this.activateCallback(this.iterator.currentItem));
    }
    /**
   * Fired after flipping in any direction
   */ flipCallback() {
        this.iterator.currentItem && this.iterator.currentItem.scrollIntoViewIfNeeded(), this.flipCallbacks.forEach((e)=>e());
    }
}
const $cdae29d26d2e7999$var$Ki = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M9 12L9 7.1C9 7.04477 9.04477 7 9.1 7H10.4C11.5 7 14 7.1 14 9.5C14 9.5 14 12 11 12M9 12V16.8C9 16.9105 9.08954 17 9.2 17H12.5C14 17 15 16 15 14.5C15 11.7046 11 12 11 12M9 12H11"/></svg>', $cdae29d26d2e7999$var$Xi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7 10L11.8586 14.8586C11.9367 14.9367 12.0633 14.9367 12.1414 14.8586L17 10"/></svg>', $cdae29d26d2e7999$var$Vi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M14.5 17.5L9.64142 12.6414C9.56331 12.5633 9.56331 12.4367 9.64142 12.3586L14.5 7.5"/></svg>', $cdae29d26d2e7999$var$qi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M9.58284 17.5L14.4414 12.6414C14.5195 12.5633 14.5195 12.4367 14.4414 12.3586L9.58284 7.5"/></svg>', $cdae29d26d2e7999$var$Zi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7 15L11.8586 10.1414C11.9367 10.0633 12.0633 10.0633 12.1414 10.1414L17 15"/></svg>', $cdae29d26d2e7999$var$Gi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 8L12 12M12 12L16 16M12 12L16 8M12 12L8 16"/></svg>', $cdae29d26d2e7999$var$Qi = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="2"/></svg>', $cdae29d26d2e7999$var$Ji = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M13.34 10C12.4223 12.7337 11 17 11 17"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M14.21 7H14.2"/></svg>', $cdae29d26d2e7999$var$Co = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M7.69998 12.6L7.67896 12.62C6.53993 13.7048 6.52012 15.5155 7.63516 16.625V16.625C8.72293 17.7073 10.4799 17.7102 11.5712 16.6314L13.0263 15.193C14.0703 14.1609 14.2141 12.525 13.3662 11.3266L13.22 11.12"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M16.22 11.12L16.3564 10.9805C17.2895 10.0265 17.3478 8.5207 16.4914 7.49733V7.49733C15.5691 6.39509 13.9269 6.25143 12.8271 7.17675L11.3901 8.38588C10.0935 9.47674 9.95706 11.4241 11.0888 12.6852L11.12 12.72"/></svg>', $cdae29d26d2e7999$var$es = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.40999 7.29999H9.4"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 7.29999H14.59"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.30999 12H9.3"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 12H14.59"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M9.40999 16.7H9.4"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2.6" d="M14.6 16.7H14.59"/></svg>', $cdae29d26d2e7999$var$ts = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12 7V12M12 17V12M17 12H12M12 12H7"/></svg>', $cdae29d26d2e7999$var$Go = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M11.5 17.5L5 11M5 11V15.5M5 11H9.5"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12.5 6.5L19 13M19 13V8.5M19 13H14.5"/></svg>', $cdae29d26d2e7999$var$os = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><circle cx="10.5" cy="10.5" r="5.5" stroke="currentColor" stroke-width="2"/><line x1="15.4142" x2="19" y1="15" y2="18.5858" stroke="currentColor" stroke-linecap="round" stroke-width="2"/></svg>', $cdae29d26d2e7999$var$ns = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M15.7795 11.5C15.7795 11.5 16.053 11.1962 16.5497 10.6722C17.4442 9.72856 17.4701 8.2475 16.5781 7.30145V7.30145C15.6482 6.31522 14.0873 6.29227 13.1288 7.25073L11.8796 8.49999"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8.24517 12.3883C8.24517 12.3883 7.97171 12.6922 7.47504 13.2161C6.58051 14.1598 6.55467 15.6408 7.44666 16.5869V16.5869C8.37653 17.5731 9.93744 17.5961 10.8959 16.6376L12.1452 15.3883"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M17.7802 15.1032L16.597 14.9422C16.0109 14.8624 15.4841 15.3059 15.4627 15.8969L15.4199 17.0818"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M6.39064 9.03238L7.58432 9.06668C8.17551 9.08366 8.6522 8.58665 8.61056 7.99669L8.5271 6.81397"/><line x1="12.1142" x2="11.7" y1="12.2" y2="11.7858" stroke="currentColor" stroke-linecap="round" stroke-width="2"/></svg>', $cdae29d26d2e7999$var$is = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><rect width="14" height="14" x="5" y="5" stroke="currentColor" stroke-width="2" rx="4"/><line x1="12" x2="12" y1="9" y2="12" stroke="currentColor" stroke-linecap="round" stroke-width="2"/><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M12 15.02V15.01"/></svg>', $cdae29d26d2e7999$var$ss = "__", $cdae29d26d2e7999$var$rs = "--";
function $cdae29d26d2e7999$var$ne(n) {
    return (e, t1)=>[
            [
                n,
                e
            ].filter((i)=>!!i).join($cdae29d26d2e7999$var$ss),
            t1
        ].filter((i)=>!!i).join($cdae29d26d2e7999$var$rs);
}
const $cdae29d26d2e7999$var$ye = $cdae29d26d2e7999$var$ne("ce-hint"), $cdae29d26d2e7999$var$we = {
    root: $cdae29d26d2e7999$var$ye(),
    alignedStart: $cdae29d26d2e7999$var$ye(null, "align-left"),
    alignedCenter: $cdae29d26d2e7999$var$ye(null, "align-center"),
    title: $cdae29d26d2e7999$var$ye("title"),
    description: $cdae29d26d2e7999$var$ye("description")
};
class $cdae29d26d2e7999$var$as {
    /**
   * Constructs the hint content instance
   *
   * @param params - hint content parameters
   */ constructor(e){
        this.nodes = {
            root: $cdae29d26d2e7999$var$u.make("div", [
                $cdae29d26d2e7999$var$we.root,
                e.alignment === "center" ? $cdae29d26d2e7999$var$we.alignedCenter : $cdae29d26d2e7999$var$we.alignedStart
            ]),
            title: $cdae29d26d2e7999$var$u.make("div", $cdae29d26d2e7999$var$we.title, {
                textContent: e.title
            })
        }, this.nodes.root.appendChild(this.nodes.title), e.description !== void 0 && (this.nodes.description = $cdae29d26d2e7999$var$u.make("div", $cdae29d26d2e7999$var$we.description, {
            textContent: e.description
        }), this.nodes.root.appendChild(this.nodes.description));
    }
    /**
   * Returns the root element of the hint content
   */ getElement() {
        return this.nodes.root;
    }
}
class $cdae29d26d2e7999$var$xt {
    /**
   * Constructs the instance
   *
   * @param params - instance parameters
   */ constructor(e){
        this.params = e;
    }
    /**
   * Item name if exists
   */ get name() {
        if (this.params !== void 0 && "name" in this.params) return this.params.name;
    }
    /**
   * Destroys the instance
   */ destroy() {
        $cdae29d26d2e7999$var$$e();
    }
    /**
   * Called when children popover is opened (if exists)
   */ onChildrenOpen() {
        var e;
        this.params !== void 0 && "children" in this.params && typeof ((e = this.params.children) == null ? void 0 : e.onOpen) == "function" && this.params.children.onOpen();
    }
    /**
   * Called when children popover is closed (if exists)
   */ onChildrenClose() {
        var e;
        this.params !== void 0 && "children" in this.params && typeof ((e = this.params.children) == null ? void 0 : e.onClose) == "function" && this.params.children.onClose();
    }
    /**
   * Called on popover item click
   */ handleClick() {
        var e, t1;
        this.params !== void 0 && "onActivate" in this.params && ((t1 = (e = this.params).onActivate) == null || t1.call(e, this.params));
    }
    /**
   * Adds hint to the item element if hint data is provided
   *
   * @param itemElement - popover item root element to add hint to
   * @param hintData - hint data
   */ addHint(e, t1) {
        const o = new $cdae29d26d2e7999$var$as(t1);
        $cdae29d26d2e7999$var$ze(e, o.getElement(), {
            placement: t1.position,
            hidingDelay: 100
        });
    }
    /**
   * Returns item children that are represented as popover items
   */ get children() {
        var e;
        return this.params !== void 0 && "children" in this.params && ((e = this.params.children) == null ? void 0 : e.items) !== void 0 ? this.params.children.items : [];
    }
    /**
   * Returns true if item has any type of children
   */ get hasChildren() {
        return this.children.length > 0;
    }
    /**
   * Returns true if item children should be open instantly after popover is opened and not on item click/hover
   */ get isChildrenOpen() {
        var e;
        return this.params !== void 0 && "children" in this.params && ((e = this.params.children) == null ? void 0 : e.isOpen) === !0;
    }
    /**
   * True if item children items should be navigatable via keyboard
   */ get isChildrenFlippable() {
        var e;
        return !(this.params === void 0 || !("children" in this.params) || ((e = this.params.children) == null ? void 0 : e.isFlippable) === !1);
    }
    /**
   * Returns true if item has children that should be searchable
   */ get isChildrenSearchable() {
        var e;
        return this.params !== void 0 && "children" in this.params && ((e = this.params.children) == null ? void 0 : e.searchable) === !0;
    }
    /**
   * True if popover should close once item is activated
   */ get closeOnActivate() {
        return this.params !== void 0 && "closeOnActivate" in this.params && this.params.closeOnActivate;
    }
    /**
   * True if item is active
   */ get isActive() {
        return this.params === void 0 || !("isActive" in this.params) ? !1 : typeof this.params.isActive == "function" ? this.params.isActive() : this.params.isActive === !0;
    }
}
const $cdae29d26d2e7999$var$Y = $cdae29d26d2e7999$var$ne("ce-popover-item"), $cdae29d26d2e7999$var$L = {
    container: $cdae29d26d2e7999$var$Y(),
    active: $cdae29d26d2e7999$var$Y(null, "active"),
    disabled: $cdae29d26d2e7999$var$Y(null, "disabled"),
    focused: $cdae29d26d2e7999$var$Y(null, "focused"),
    hidden: $cdae29d26d2e7999$var$Y(null, "hidden"),
    confirmationState: $cdae29d26d2e7999$var$Y(null, "confirmation"),
    noHover: $cdae29d26d2e7999$var$Y(null, "no-hover"),
    noFocus: $cdae29d26d2e7999$var$Y(null, "no-focus"),
    title: $cdae29d26d2e7999$var$Y("title"),
    secondaryTitle: $cdae29d26d2e7999$var$Y("secondary-title"),
    icon: $cdae29d26d2e7999$var$Y("icon"),
    iconTool: $cdae29d26d2e7999$var$Y("icon", "tool"),
    iconChevronRight: $cdae29d26d2e7999$var$Y("icon", "chevron-right"),
    wobbleAnimation: $cdae29d26d2e7999$var$ne("wobble")()
};
class $cdae29d26d2e7999$var$re extends $cdae29d26d2e7999$var$xt {
    /**
   * Constructs popover item instance
   *
   * @param params - popover item construction params
   * @param renderParams - popover item render params.
   * The parameters that are not set by user via popover api but rather depend on technical implementation
   */ constructor(e, t1){
        super(e), this.params = e, this.nodes = {
            root: null,
            icon: null
        }, this.confirmationState = null, this.removeSpecialFocusBehavior = ()=>{
            var o;
            (o = this.nodes.root) == null || o.classList.remove($cdae29d26d2e7999$var$L.noFocus);
        }, this.removeSpecialHoverBehavior = ()=>{
            var o;
            (o = this.nodes.root) == null || o.classList.remove($cdae29d26d2e7999$var$L.noHover);
        }, this.onErrorAnimationEnd = ()=>{
            var o, i;
            (o = this.nodes.icon) == null || o.classList.remove($cdae29d26d2e7999$var$L.wobbleAnimation), (i = this.nodes.icon) == null || i.removeEventListener("animationend", this.onErrorAnimationEnd);
        }, this.nodes.root = this.make(e, t1);
    }
    /**
   * True if item is disabled and hence not clickable
   */ get isDisabled() {
        return this.params.isDisabled === !0;
    }
    /**
   * Exposes popover item toggle parameter
   */ get toggle() {
        return this.params.toggle;
    }
    /**
   * Item title
   */ get title() {
        return this.params.title;
    }
    /**
   * True if confirmation state is enabled for popover item
   */ get isConfirmationStateEnabled() {
        return this.confirmationState !== null;
    }
    /**
   * True if item is focused in keyboard navigation process
   */ get isFocused() {
        return this.nodes.root === null ? !1 : this.nodes.root.classList.contains($cdae29d26d2e7999$var$L.focused);
    }
    /**
   * Returns popover item root element
   */ getElement() {
        return this.nodes.root;
    }
    /**
   * Called on popover item click
   */ handleClick() {
        if (this.isConfirmationStateEnabled && this.confirmationState !== null) {
            this.activateOrEnableConfirmationMode(this.confirmationState);
            return;
        }
        this.activateOrEnableConfirmationMode(this.params);
    }
    /**
   * Toggles item active state
   *
   * @param isActive - true if item should strictly should become active
   */ toggleActive(e) {
        var t1;
        (t1 = this.nodes.root) == null || t1.classList.toggle($cdae29d26d2e7999$var$L.active, e);
    }
    /**
   * Toggles item hidden state
   *
   * @param isHidden - true if item should be hidden
   */ toggleHidden(e) {
        var t1;
        (t1 = this.nodes.root) == null || t1.classList.toggle($cdae29d26d2e7999$var$L.hidden, e);
    }
    /**
   * Resets popover item to its original state
   */ reset() {
        this.isConfirmationStateEnabled && this.disableConfirmationMode();
    }
    /**
   * Method called once item becomes focused during keyboard navigation
   */ onFocus() {
        this.disableSpecialHoverAndFocusBehavior();
    }
    /**
   * Constructs HTML element corresponding to popover item params
   *
   * @param params - item construction params
   * @param renderParams - popover item render params
   */ make(e, t1) {
        var s, r;
        const o = (t1 == null ? void 0 : t1.wrapperTag) || "div", i = $cdae29d26d2e7999$var$u.make(o, $cdae29d26d2e7999$var$L.container, {
            type: o === "button" ? "button" : void 0
        });
        return e.name && (i.dataset.itemName = e.name), this.nodes.icon = $cdae29d26d2e7999$var$u.make("div", [
            $cdae29d26d2e7999$var$L.icon,
            $cdae29d26d2e7999$var$L.iconTool
        ], {
            innerHTML: e.icon || $cdae29d26d2e7999$var$Qi
        }), i.appendChild(this.nodes.icon), e.title !== void 0 && i.appendChild($cdae29d26d2e7999$var$u.make("div", $cdae29d26d2e7999$var$L.title, {
            innerHTML: e.title || ""
        })), e.secondaryLabel && i.appendChild($cdae29d26d2e7999$var$u.make("div", $cdae29d26d2e7999$var$L.secondaryTitle, {
            textContent: e.secondaryLabel
        })), this.hasChildren && i.appendChild($cdae29d26d2e7999$var$u.make("div", [
            $cdae29d26d2e7999$var$L.icon,
            $cdae29d26d2e7999$var$L.iconChevronRight
        ], {
            innerHTML: $cdae29d26d2e7999$var$qi
        })), this.isActive && i.classList.add($cdae29d26d2e7999$var$L.active), e.isDisabled && i.classList.add($cdae29d26d2e7999$var$L.disabled), e.hint !== void 0 && ((s = t1 == null ? void 0 : t1.hint) == null ? void 0 : s.enabled) !== !1 && this.addHint(i, {
            ...e.hint,
            position: ((r = t1 == null ? void 0 : t1.hint) == null ? void 0 : r.position) || "right"
        }), i;
    }
    /**
   * Activates confirmation mode for the item.
   *
   * @param newState - new popover item params that should be applied
   */ enableConfirmationMode(e) {
        if (this.nodes.root === null) return;
        const t1 = {
            ...this.params,
            ...e,
            confirmation: "confirmation" in e ? e.confirmation : void 0
        }, o = this.make(t1);
        this.nodes.root.innerHTML = o.innerHTML, this.nodes.root.classList.add($cdae29d26d2e7999$var$L.confirmationState), this.confirmationState = e, this.enableSpecialHoverAndFocusBehavior();
    }
    /**
   * Returns item to its original state
   */ disableConfirmationMode() {
        if (this.nodes.root === null) return;
        const e = this.make(this.params);
        this.nodes.root.innerHTML = e.innerHTML, this.nodes.root.classList.remove($cdae29d26d2e7999$var$L.confirmationState), this.confirmationState = null, this.disableSpecialHoverAndFocusBehavior();
    }
    /**
   * Enables special focus and hover behavior for item in confirmation state.
   * This is needed to prevent item from being highlighted as hovered/focused just after click.
   */ enableSpecialHoverAndFocusBehavior() {
        var e, t1, o;
        (e = this.nodes.root) == null || e.classList.add($cdae29d26d2e7999$var$L.noHover), (t1 = this.nodes.root) == null || t1.classList.add($cdae29d26d2e7999$var$L.noFocus), (o = this.nodes.root) == null || o.addEventListener("mouseleave", this.removeSpecialHoverBehavior, {
            once: !0
        });
    }
    /**
   * Disables special focus and hover behavior
   */ disableSpecialHoverAndFocusBehavior() {
        var e;
        this.removeSpecialFocusBehavior(), this.removeSpecialHoverBehavior(), (e = this.nodes.root) == null || e.removeEventListener("mouseleave", this.removeSpecialHoverBehavior);
    }
    /**
   * Executes item's onActivate callback if the item has no confirmation configured
   *
   * @param item - item to activate or bring to confirmation mode
   */ activateOrEnableConfirmationMode(e) {
        var t1;
        if (!("confirmation" in e) || e.confirmation === void 0) try {
            (t1 = e.onActivate) == null || t1.call(e, e), this.disableConfirmationMode();
        } catch  {
            this.animateError();
        }
        else this.enableConfirmationMode(e.confirmation);
    }
    /**
   * Animates item which symbolizes that error occured while executing 'onActivate()' callback
   */ animateError() {
        var e, t1, o;
        (e = this.nodes.icon) != null && e.classList.contains($cdae29d26d2e7999$var$L.wobbleAnimation) || ((t1 = this.nodes.icon) == null || t1.classList.add($cdae29d26d2e7999$var$L.wobbleAnimation), (o = this.nodes.icon) == null || o.addEventListener("animationend", this.onErrorAnimationEnd));
    }
}
const $cdae29d26d2e7999$var$nt = $cdae29d26d2e7999$var$ne("ce-popover-item-separator"), $cdae29d26d2e7999$var$it = {
    container: $cdae29d26d2e7999$var$nt(),
    line: $cdae29d26d2e7999$var$nt("line"),
    hidden: $cdae29d26d2e7999$var$nt(null, "hidden")
};
class $cdae29d26d2e7999$var$Qo extends $cdae29d26d2e7999$var$xt {
    /**
   * Constructs the instance
   */ constructor(){
        super(), this.nodes = {
            root: $cdae29d26d2e7999$var$u.make("div", $cdae29d26d2e7999$var$it.container),
            line: $cdae29d26d2e7999$var$u.make("div", $cdae29d26d2e7999$var$it.line)
        }, this.nodes.root.appendChild(this.nodes.line);
    }
    /**
   * Returns popover separator root element
   */ getElement() {
        return this.nodes.root;
    }
    /**
   * Toggles item hidden state
   *
   * @param isHidden - true if item should be hidden
   */ toggleHidden(e) {
        var t1;
        (t1 = this.nodes.root) == null || t1.classList.toggle($cdae29d26d2e7999$var$it.hidden, e);
    }
}
var $cdae29d26d2e7999$var$G = /* @__PURE__ */ ((n)=>(n.Closed = "closed", n.ClosedOnActivate = "closed-on-activate", n))($cdae29d26d2e7999$var$G || {});
const $cdae29d26d2e7999$var$$ = $cdae29d26d2e7999$var$ne("ce-popover"), $cdae29d26d2e7999$var$P = {
    popover: $cdae29d26d2e7999$var$$(),
    popoverContainer: $cdae29d26d2e7999$var$$("container"),
    popoverOpenTop: $cdae29d26d2e7999$var$$(null, "open-top"),
    popoverOpenLeft: $cdae29d26d2e7999$var$$(null, "open-left"),
    popoverOpened: $cdae29d26d2e7999$var$$(null, "opened"),
    search: $cdae29d26d2e7999$var$$("search"),
    nothingFoundMessage: $cdae29d26d2e7999$var$$("nothing-found-message"),
    nothingFoundMessageDisplayed: $cdae29d26d2e7999$var$$("nothing-found-message", "displayed"),
    items: $cdae29d26d2e7999$var$$("items"),
    overlay: $cdae29d26d2e7999$var$$("overlay"),
    overlayHidden: $cdae29d26d2e7999$var$$("overlay", "hidden"),
    popoverNested: $cdae29d26d2e7999$var$$(null, "nested"),
    getPopoverNestedClass: (n)=>$cdae29d26d2e7999$var$$(null, `nested-level-${n.toString()}`),
    popoverInline: $cdae29d26d2e7999$var$$(null, "inline"),
    popoverHeader: $cdae29d26d2e7999$var$$("header")
};
var $cdae29d26d2e7999$var$fe = /* @__PURE__ */ ((n)=>(n.NestingLevel = "--nesting-level", n.PopoverHeight = "--popover-height", n.InlinePopoverWidth = "--inline-popover-width", n.TriggerItemLeft = "--trigger-item-left", n.TriggerItemTop = "--trigger-item-top", n))($cdae29d26d2e7999$var$fe || {});
const $cdae29d26d2e7999$var$To = $cdae29d26d2e7999$var$ne("ce-popover-item-html"), $cdae29d26d2e7999$var$So = {
    root: $cdae29d26d2e7999$var$To(),
    hidden: $cdae29d26d2e7999$var$To(null, "hidden")
};
class $cdae29d26d2e7999$var$Se extends $cdae29d26d2e7999$var$xt {
    /**
   * Constructs the instance
   *
   * @param params – instance parameters
   * @param renderParams – popover item render params.
   * The parameters that are not set by user via popover api but rather depend on technical implementation
   */ constructor(e, t1){
        var o, i;
        super(e), this.nodes = {
            root: $cdae29d26d2e7999$var$u.make("div", $cdae29d26d2e7999$var$So.root)
        }, this.nodes.root.appendChild(e.element), e.name && (this.nodes.root.dataset.itemName = e.name), e.hint !== void 0 && ((o = t1 == null ? void 0 : t1.hint) == null ? void 0 : o.enabled) !== !1 && this.addHint(this.nodes.root, {
            ...e.hint,
            position: ((i = t1 == null ? void 0 : t1.hint) == null ? void 0 : i.position) || "right"
        });
    }
    /**
   * Returns popover item root element
   */ getElement() {
        return this.nodes.root;
    }
    /**
   * Toggles item hidden state
   *
   * @param isHidden - true if item should be hidden
   */ toggleHidden(e) {
        var t1;
        (t1 = this.nodes.root) == null || t1.classList.toggle($cdae29d26d2e7999$var$So.hidden, e);
    }
    /**
   * Returns list of buttons and inputs inside custom content
   */ getControls() {
        const e = this.nodes.root.querySelectorAll(`button, ${$cdae29d26d2e7999$var$u.allInputsSelector}`);
        return Array.from(e);
    }
}
class $cdae29d26d2e7999$var$Jo extends $cdae29d26d2e7999$var$Oe {
    /**
   * Constructs the instance
   *
   * @param params - popover construction params
   * @param itemsRenderParams - popover item render params.
   * The parameters that are not set by user via popover api but rather depend on technical implementation
   */ constructor(e, t1 = {}){
        super(), this.params = e, this.itemsRenderParams = t1, this.listeners = new $cdae29d26d2e7999$var$_e(), this.messages = {
            nothingFound: "Nothing found",
            search: "Search"
        }, this.items = this.buildItems(e.items), e.messages && (this.messages = {
            ...this.messages,
            ...e.messages
        }), this.nodes = {}, this.nodes.popoverContainer = $cdae29d26d2e7999$var$u.make("div", [
            $cdae29d26d2e7999$var$P.popoverContainer
        ]), this.nodes.nothingFoundMessage = $cdae29d26d2e7999$var$u.make("div", [
            $cdae29d26d2e7999$var$P.nothingFoundMessage
        ], {
            textContent: this.messages.nothingFound
        }), this.nodes.popoverContainer.appendChild(this.nodes.nothingFoundMessage), this.nodes.items = $cdae29d26d2e7999$var$u.make("div", [
            $cdae29d26d2e7999$var$P.items
        ]), this.items.forEach((o)=>{
            const i = o.getElement();
            i !== null && this.nodes.items.appendChild(i);
        }), this.nodes.popoverContainer.appendChild(this.nodes.items), this.listeners.on(this.nodes.popoverContainer, "click", (o)=>this.handleClick(o)), this.nodes.popover = $cdae29d26d2e7999$var$u.make("div", [
            $cdae29d26d2e7999$var$P.popover,
            this.params.class
        ]), this.nodes.popover.appendChild(this.nodes.popoverContainer);
    }
    /**
   * List of default popover items that are searchable and may have confirmation state
   */ get itemsDefault() {
        return this.items.filter((e)=>e instanceof $cdae29d26d2e7999$var$re);
    }
    /**
   * Returns HTML element corresponding to the popover
   */ getElement() {
        return this.nodes.popover;
    }
    /**
   * Open popover
   */ show() {
        this.nodes.popover.classList.add($cdae29d26d2e7999$var$P.popoverOpened), this.search !== void 0 && this.search.focus();
    }
    /**
   * Closes popover
   */ hide() {
        this.nodes.popover.classList.remove($cdae29d26d2e7999$var$P.popoverOpened), this.nodes.popover.classList.remove($cdae29d26d2e7999$var$P.popoverOpenTop), this.itemsDefault.forEach((e)=>e.reset()), this.search !== void 0 && this.search.clear(), this.emit($cdae29d26d2e7999$var$G.Closed);
    }
    /**
   * Clears memory
   */ destroy() {
        var e;
        this.items.forEach((t1)=>t1.destroy()), this.nodes.popover.remove(), this.listeners.removeAll(), (e = this.search) == null || e.destroy();
    }
    /**
   * Looks for the item by name and imitates click on it
   *
   * @param name - name of the item to activate
   */ activateItemByName(e) {
        const t1 = this.items.find((o)=>o.name === e);
        this.handleItemClick(t1);
    }
    /**
   * Factory method for creating popover items
   *
   * @param items - list of items params
   */ buildItems(e) {
        return e.map((t1)=>{
            switch(t1.type){
                case $cdae29d26d2e7999$var$_.Separator:
                    return new $cdae29d26d2e7999$var$Qo();
                case $cdae29d26d2e7999$var$_.Html:
                    return new $cdae29d26d2e7999$var$Se(t1, this.itemsRenderParams[$cdae29d26d2e7999$var$_.Html]);
                default:
                    return new $cdae29d26d2e7999$var$re(t1, this.itemsRenderParams[$cdae29d26d2e7999$var$_.Default]);
            }
        });
    }
    /**
   * Retrieves popover item that is the target of the specified event
   *
   * @param event - event to retrieve popover item from
   */ getTargetItem(e) {
        return this.items.filter((t1)=>t1 instanceof $cdae29d26d2e7999$var$re || t1 instanceof $cdae29d26d2e7999$var$Se).find((t1)=>{
            const o = t1.getElement();
            return o === null ? !1 : e.composedPath().includes(o);
        });
    }
    /**
   * Handles popover item click
   *
   * @param item - item to handle click of
   */ handleItemClick(e) {
        if (!("isDisabled" in e && e.isDisabled)) {
            if (e.hasChildren) {
                this.showNestedItems(e), "handleClick" in e && typeof e.handleClick == "function" && e.handleClick();
                return;
            }
            this.itemsDefault.filter((t1)=>t1 !== e).forEach((t1)=>t1.reset()), "handleClick" in e && typeof e.handleClick == "function" && e.handleClick(), this.toggleItemActivenessIfNeeded(e), e.closeOnActivate && (this.hide(), this.emit($cdae29d26d2e7999$var$G.ClosedOnActivate));
        }
    }
    /**
   * Handles clicks inside popover
   *
   * @param event - item to handle click of
   */ handleClick(e) {
        const t1 = this.getTargetItem(e);
        t1 !== void 0 && this.handleItemClick(t1);
    }
    /**
   * - Toggles item active state, if clicked popover item has property 'toggle' set to true.
   *
   * - Performs radiobutton-like behavior if the item has property 'toggle' set to string key.
   * (All the other items with the same key get inactive, and the item gets active)
   *
   * @param clickedItem - popover item that was clicked
   */ toggleItemActivenessIfNeeded(e) {
        if (e instanceof $cdae29d26d2e7999$var$re && (e.toggle === !0 && e.toggleActive(), typeof e.toggle == "string")) {
            const t1 = this.itemsDefault.filter((o)=>o.toggle === e.toggle);
            if (t1.length === 1) {
                e.toggleActive();
                return;
            }
            t1.forEach((o)=>{
                o.toggleActive(o === e);
            });
        }
    }
}
var $cdae29d26d2e7999$var$Ue = /* @__PURE__ */ ((n)=>(n.Search = "search", n))($cdae29d26d2e7999$var$Ue || {});
const $cdae29d26d2e7999$var$st = $cdae29d26d2e7999$var$ne("cdx-search-field"), $cdae29d26d2e7999$var$rt = {
    wrapper: $cdae29d26d2e7999$var$st(),
    icon: $cdae29d26d2e7999$var$st("icon"),
    input: $cdae29d26d2e7999$var$st("input")
};
class $cdae29d26d2e7999$var$ls extends $cdae29d26d2e7999$var$Oe {
    /**
   * @param options - available config
   * @param options.items - searchable items list
   * @param options.placeholder - input placeholder
   */ constructor({ items: e, placeholder: t1 }){
        super(), this.listeners = new $cdae29d26d2e7999$var$_e(), this.items = e, this.wrapper = $cdae29d26d2e7999$var$u.make("div", $cdae29d26d2e7999$var$rt.wrapper);
        const o = $cdae29d26d2e7999$var$u.make("div", $cdae29d26d2e7999$var$rt.icon, {
            innerHTML: $cdae29d26d2e7999$var$os
        });
        this.input = $cdae29d26d2e7999$var$u.make("input", $cdae29d26d2e7999$var$rt.input, {
            placeholder: t1,
            /**
       * Used to prevent focusing on the input by Tab key
       * (Popover in the Toolbar lays below the blocks,
       * so Tab in the last block will focus this hidden input if this property is not set)
       */ tabIndex: -1
        }), this.wrapper.appendChild(o), this.wrapper.appendChild(this.input), this.listeners.on(this.input, "input", ()=>{
            this.searchQuery = this.input.value, this.emit($cdae29d26d2e7999$var$Ue.Search, {
                query: this.searchQuery,
                items: this.foundItems
            });
        });
    }
    /**
   * Returns search field element
   */ getElement() {
        return this.wrapper;
    }
    /**
   * Sets focus to the input
   */ focus() {
        this.input.focus();
    }
    /**
   * Clears search query and results
   */ clear() {
        this.input.value = "", this.searchQuery = "", this.emit($cdae29d26d2e7999$var$Ue.Search, {
            query: "",
            items: this.foundItems
        });
    }
    /**
   * Clears memory
   */ destroy() {
        this.listeners.removeAll();
    }
    /**
   * Returns list of found items for the current search query
   */ get foundItems() {
        return this.items.filter((e)=>this.checkItem(e));
    }
    /**
   * Contains logic for checking whether passed item conforms the search query
   *
   * @param item - item to be checked
   */ checkItem(e) {
        var i, s;
        const t1 = ((i = e.title) == null ? void 0 : i.toLowerCase()) || "", o = (s = this.searchQuery) == null ? void 0 : s.toLowerCase();
        return o !== void 0 ? t1.includes(o) : !1;
    }
}
var $cdae29d26d2e7999$var$cs = Object.defineProperty, $cdae29d26d2e7999$var$ds = Object.getOwnPropertyDescriptor, $cdae29d26d2e7999$var$us = (n, e, t1, o)=>{
    for(var i = o > 1 ? void 0 : o ? $cdae29d26d2e7999$var$ds(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $cdae29d26d2e7999$var$cs(e, t1, i), i;
};
const $cdae29d26d2e7999$var$en = class tn extends $cdae29d26d2e7999$var$Jo {
    /**
   * Construct the instance
   *
   * @param params - popover params
   * @param itemsRenderParams – popover item render params.
   * The parameters that are not set by user via popover api but rather depend on technical implementation
   */ constructor(e, t1){
        super(e, t1), this.nestingLevel = 0, this.nestedPopoverTriggerItem = null, this.previouslyHoveredItem = null, this.scopeElement = document.body, this.hide = ()=>{
            var o;
            super.hide(), this.destroyNestedPopoverIfExists(), (o = this.flipper) == null || o.deactivate(), this.previouslyHoveredItem = null;
        }, this.onFlip = ()=>{
            const o = this.itemsDefault.find((i)=>i.isFocused);
            o == null || o.onFocus();
        }, this.onSearch = (o)=>{
            var a;
            const i = o.query === "", s = o.items.length === 0;
            this.items.forEach((l)=>{
                let c = !1;
                l instanceof $cdae29d26d2e7999$var$re ? c = !o.items.includes(l) : (l instanceof $cdae29d26d2e7999$var$Qo || l instanceof $cdae29d26d2e7999$var$Se) && (c = s || !i), l.toggleHidden(c);
            }), this.toggleNothingFoundMessage(s);
            const r = o.query === "" ? this.flippableElements : o.items.map((l)=>l.getElement());
            (a = this.flipper) != null && a.isActivated && (this.flipper.deactivate(), this.flipper.activate(r));
        }, e.nestingLevel !== void 0 && (this.nestingLevel = e.nestingLevel), this.nestingLevel > 0 && this.nodes.popover.classList.add($cdae29d26d2e7999$var$P.popoverNested), e.scopeElement !== void 0 && (this.scopeElement = e.scopeElement), this.nodes.popoverContainer !== null && this.listeners.on(this.nodes.popoverContainer, "mouseover", (o)=>this.handleHover(o)), e.searchable && this.addSearch(), e.flippable !== !1 && (this.flipper = new $cdae29d26d2e7999$var$ce({
            items: this.flippableElements,
            focusedItemClass: $cdae29d26d2e7999$var$L.focused,
            allowedKeys: [
                $cdae29d26d2e7999$var$y.TAB,
                $cdae29d26d2e7999$var$y.UP,
                $cdae29d26d2e7999$var$y.DOWN,
                $cdae29d26d2e7999$var$y.ENTER
            ]
        }), this.flipper.onFlip(this.onFlip));
    }
    /**
   * Returns true if some item inside popover is focused
   */ hasFocus() {
        return this.flipper === void 0 ? !1 : this.flipper.hasFocus();
    }
    /**
   * Scroll position inside items container of the popover
   */ get scrollTop() {
        return this.nodes.items === null ? 0 : this.nodes.items.scrollTop;
    }
    /**
   * Returns visible element offset top
   */ get offsetTop() {
        return this.nodes.popoverContainer === null ? 0 : this.nodes.popoverContainer.offsetTop;
    }
    /**
   * Open popover
   */ show() {
        var e;
        this.nodes.popover.style.setProperty($cdae29d26d2e7999$var$fe.PopoverHeight, this.size.height + "px"), this.shouldOpenBottom || this.nodes.popover.classList.add($cdae29d26d2e7999$var$P.popoverOpenTop), this.shouldOpenRight || this.nodes.popover.classList.add($cdae29d26d2e7999$var$P.popoverOpenLeft), super.show(), (e = this.flipper) == null || e.activate(this.flippableElements);
    }
    /**
   * Clears memory
   */ destroy() {
        this.hide(), super.destroy();
    }
    /**
   * Handles displaying nested items for the item.
   *
   * @param item – item to show nested popover for
   */ showNestedItems(e) {
        this.nestedPopover !== null && this.nestedPopover !== void 0 || (this.nestedPopoverTriggerItem = e, this.showNestedPopoverForItem(e));
    }
    /**
   * Handles hover events inside popover items container
   *
   * @param event - hover event data
   */ handleHover(e) {
        const t1 = this.getTargetItem(e);
        t1 !== void 0 && this.previouslyHoveredItem !== t1 && (this.destroyNestedPopoverIfExists(), this.previouslyHoveredItem = t1, t1.hasChildren && this.showNestedPopoverForItem(t1));
    }
    /**
   * Sets CSS variable with position of item near which nested popover should be displayed.
   * Is used for correct positioning of the nested popover
   *
   * @param nestedPopoverEl - nested popover element
   * @param item – item near which nested popover should be displayed
   */ setTriggerItemPosition(e, t1) {
        const o = t1.getElement(), i = (o ? o.offsetTop : 0) - this.scrollTop, s = this.offsetTop + i;
        e.style.setProperty($cdae29d26d2e7999$var$fe.TriggerItemTop, s + "px");
    }
    /**
   * Destroys existing nested popover
   */ destroyNestedPopoverIfExists() {
        var e, t1;
        this.nestedPopover === void 0 || this.nestedPopover === null || (this.nestedPopover.off($cdae29d26d2e7999$var$G.ClosedOnActivate, this.hide), this.nestedPopover.hide(), this.nestedPopover.destroy(), this.nestedPopover.getElement().remove(), this.nestedPopover = null, (e = this.flipper) == null || e.activate(this.flippableElements), (t1 = this.nestedPopoverTriggerItem) == null || t1.onChildrenClose());
    }
    /**
   * Creates and displays nested popover for specified item.
   * Is used only on desktop
   *
   * @param item - item to display nested popover by
   */ showNestedPopoverForItem(e) {
        var o;
        this.nestedPopover = new tn({
            searchable: e.isChildrenSearchable,
            items: e.children,
            nestingLevel: this.nestingLevel + 1,
            flippable: e.isChildrenFlippable,
            messages: this.messages
        }), e.onChildrenOpen(), this.nestedPopover.on($cdae29d26d2e7999$var$G.ClosedOnActivate, this.hide);
        const t1 = this.nestedPopover.getElement();
        return this.nodes.popover.appendChild(t1), this.setTriggerItemPosition(t1, e), t1.style.setProperty($cdae29d26d2e7999$var$fe.NestingLevel, this.nestedPopover.nestingLevel.toString()), this.nestedPopover.show(), (o = this.flipper) == null || o.deactivate(), this.nestedPopover;
    }
    /**
   * Checks if popover should be opened bottom.
   * It should happen when there is enough space below or not enough space above
   */ get shouldOpenBottom() {
        if (this.nodes.popover === void 0 || this.nodes.popover === null) return !1;
        const e = this.nodes.popoverContainer.getBoundingClientRect(), t1 = this.scopeElement.getBoundingClientRect(), o = this.size.height, i = e.top + o, s = e.top - o, r = Math.min(window.innerHeight, t1.bottom);
        return s < t1.top || i <= r;
    }
    /**
   * Checks if popover should be opened left.
   * It should happen when there is enough space in the right or not enough space in the left
   */ get shouldOpenRight() {
        if (this.nodes.popover === void 0 || this.nodes.popover === null) return !1;
        const e = this.nodes.popover.getBoundingClientRect(), t1 = this.scopeElement.getBoundingClientRect(), o = this.size.width, i = e.right + o, s = e.left - o, r = Math.min(window.innerWidth, t1.right);
        return s < t1.left || i <= r;
    }
    get size() {
        var i;
        const e = {
            height: 0,
            width: 0
        };
        if (this.nodes.popover === null) return e;
        const t1 = this.nodes.popover.cloneNode(!0);
        t1.style.visibility = "hidden", t1.style.position = "absolute", t1.style.top = "-1000px", t1.classList.add($cdae29d26d2e7999$var$P.popoverOpened), (i = t1.querySelector("." + $cdae29d26d2e7999$var$P.popoverNested)) == null || i.remove(), document.body.appendChild(t1);
        const o = t1.querySelector("." + $cdae29d26d2e7999$var$P.popoverContainer);
        return e.height = o.offsetHeight, e.width = o.offsetWidth, t1.remove(), e;
    }
    /**
   * Returns list of elements available for keyboard navigation.
   */ get flippableElements() {
        return this.items.map((t1)=>{
            if (t1 instanceof $cdae29d26d2e7999$var$re) return t1.getElement();
            if (t1 instanceof $cdae29d26d2e7999$var$Se) return t1.getControls();
        }).flat().filter((t1)=>t1 != null);
    }
    /**
   * Adds search to the popover
   */ addSearch() {
        this.search = new $cdae29d26d2e7999$var$ls({
            items: this.itemsDefault,
            placeholder: this.messages.search
        }), this.search.on($cdae29d26d2e7999$var$Ue.Search, this.onSearch);
        const e = this.search.getElement();
        e.classList.add($cdae29d26d2e7999$var$P.search), this.nodes.popoverContainer.insertBefore(e, this.nodes.popoverContainer.firstChild);
    }
    /**
   * Toggles nothing found message visibility
   *
   * @param isDisplayed - true if the message should be displayed
   */ toggleNothingFoundMessage(e) {
        this.nodes.nothingFoundMessage.classList.toggle($cdae29d26d2e7999$var$P.nothingFoundMessageDisplayed, e);
    }
};
$cdae29d26d2e7999$var$us([
    $cdae29d26d2e7999$var$me
], $cdae29d26d2e7999$var$en.prototype, "size", 1);
let $cdae29d26d2e7999$var$Bt = $cdae29d26d2e7999$var$en;
class $cdae29d26d2e7999$var$hs extends $cdae29d26d2e7999$var$Bt {
    /**
   * Constructs the instance
   *
   * @param params - instance parameters
   */ constructor(e){
        const t1 = !$cdae29d26d2e7999$var$be();
        super({
            ...e,
            class: $cdae29d26d2e7999$var$P.popoverInline
        }, {
            [$cdae29d26d2e7999$var$_.Default]: {
                /**
           * We use button instead of div here to fix bug associated with focus loss (which leads to selection change) on click in safari
           *
           * @todo figure out better way to solve the issue
           */ wrapperTag: "button",
                hint: {
                    position: "top",
                    alignment: "center",
                    enabled: t1
                }
            },
            [$cdae29d26d2e7999$var$_.Html]: {
                hint: {
                    position: "top",
                    alignment: "center",
                    enabled: t1
                }
            }
        }), this.items.forEach((o)=>{
            !(o instanceof $cdae29d26d2e7999$var$re) && !(o instanceof $cdae29d26d2e7999$var$Se) || o.hasChildren && o.isChildrenOpen && this.showNestedItems(o);
        });
    }
    /**
   * Returns visible element offset top
   */ get offsetLeft() {
        return this.nodes.popoverContainer === null ? 0 : this.nodes.popoverContainer.offsetLeft;
    }
    /**
   * Open popover
   */ show() {
        this.nestingLevel === 0 && this.nodes.popover.style.setProperty($cdae29d26d2e7999$var$fe.InlinePopoverWidth, this.size.width + "px"), super.show();
    }
    /**
   * Disable hover event handling.
   * Overrides parent's class behavior
   */ handleHover() {}
    /**
   * Sets CSS variable with position of item near which nested popover should be displayed.
   * Is used to position nested popover right below clicked item
   *
   * @param nestedPopoverEl - nested popover element
   * @param item – item near which nested popover should be displayed
   */ setTriggerItemPosition(e, t1) {
        const o = t1.getElement(), i = o ? o.offsetLeft : 0, s = this.offsetLeft + i;
        e.style.setProperty($cdae29d26d2e7999$var$fe.TriggerItemLeft, s + "px");
    }
    /**
   * Handles displaying nested items for the item.
   * Overriding in order to add toggling behaviour
   *
   * @param item – item to toggle nested popover for
   */ showNestedItems(e) {
        if (this.nestedPopoverTriggerItem === e) {
            this.destroyNestedPopoverIfExists(), this.nestedPopoverTriggerItem = null;
            return;
        }
        super.showNestedItems(e);
    }
    /**
   * Creates and displays nested popover for specified item.
   * Is used only on desktop
   *
   * @param item - item to display nested popover by
   */ showNestedPopoverForItem(e) {
        const t1 = super.showNestedPopoverForItem(e);
        return t1.getElement().classList.add($cdae29d26d2e7999$var$P.getPopoverNestedClass(t1.nestingLevel)), t1;
    }
    /**
   * Overrides default item click handling.
   * Helps to close nested popover once other item is clicked.
   *
   * @param item - clicked item
   */ handleItemClick(e) {
        var t1;
        e !== this.nestedPopoverTriggerItem && ((t1 = this.nestedPopoverTriggerItem) == null || t1.handleClick(), super.destroyNestedPopoverIfExists()), super.handleItemClick(e);
    }
}
const $cdae29d26d2e7999$var$on = class xe {
    constructor(){
        this.scrollPosition = null;
    }
    /**
   * Locks body element scroll
   */ lock() {
        $cdae29d26d2e7999$var$pt ? this.lockHard() : document.body.classList.add(xe.CSS.scrollLocked);
    }
    /**
   * Unlocks body element scroll
   */ unlock() {
        $cdae29d26d2e7999$var$pt ? this.unlockHard() : document.body.classList.remove(xe.CSS.scrollLocked);
    }
    /**
   * Locks scroll in a hard way (via setting fixed position to body element)
   */ lockHard() {
        this.scrollPosition = window.pageYOffset, document.documentElement.style.setProperty("--window-scroll-offset", `${this.scrollPosition}px`), document.body.classList.add(xe.CSS.scrollLockedHard);
    }
    /**
   * Unlocks hard scroll lock
   */ unlockHard() {
        document.body.classList.remove(xe.CSS.scrollLockedHard), this.scrollPosition !== null && window.scrollTo(0, this.scrollPosition), this.scrollPosition = null;
    }
};
$cdae29d26d2e7999$var$on.CSS = {
    scrollLocked: "ce-scroll-locked",
    scrollLockedHard: "ce-scroll-locked--hard"
};
let $cdae29d26d2e7999$var$ps = $cdae29d26d2e7999$var$on;
const $cdae29d26d2e7999$var$at = $cdae29d26d2e7999$var$ne("ce-popover-header"), $cdae29d26d2e7999$var$lt = {
    root: $cdae29d26d2e7999$var$at(),
    text: $cdae29d26d2e7999$var$at("text"),
    backButton: $cdae29d26d2e7999$var$at("back-button")
};
class $cdae29d26d2e7999$var$fs {
    /**
   * Constructs the instance
   *
   * @param params - popover header params
   */ constructor({ text: e, onBackButtonClick: t1 }){
        this.listeners = new $cdae29d26d2e7999$var$_e(), this.text = e, this.onBackButtonClick = t1, this.nodes = {
            root: $cdae29d26d2e7999$var$u.make("div", [
                $cdae29d26d2e7999$var$lt.root
            ]),
            backButton: $cdae29d26d2e7999$var$u.make("button", [
                $cdae29d26d2e7999$var$lt.backButton
            ]),
            text: $cdae29d26d2e7999$var$u.make("div", [
                $cdae29d26d2e7999$var$lt.text
            ])
        }, this.nodes.backButton.innerHTML = $cdae29d26d2e7999$var$Vi, this.nodes.root.appendChild(this.nodes.backButton), this.listeners.on(this.nodes.backButton, "click", this.onBackButtonClick), this.nodes.text.innerText = this.text, this.nodes.root.appendChild(this.nodes.text);
    }
    /**
   * Returns popover header root html element
   */ getElement() {
        return this.nodes.root;
    }
    /**
   * Destroys the instance
   */ destroy() {
        this.nodes.root.remove(), this.listeners.destroy();
    }
}
class $cdae29d26d2e7999$var$gs {
    constructor(){
        this.history = [];
    }
    /**
   * Push new popover state
   *
   * @param state - new state
   */ push(e) {
        this.history.push(e);
    }
    /**
   * Pop last popover state
   */ pop() {
        return this.history.pop();
    }
    /**
   * Title retrieved from the current state
   */ get currentTitle() {
        return this.history.length === 0 ? "" : this.history[this.history.length - 1].title;
    }
    /**
   * Items list retrieved from the current state
   */ get currentItems() {
        return this.history.length === 0 ? [] : this.history[this.history.length - 1].items;
    }
    /**
   * Returns history to initial popover state
   */ reset() {
        for(; this.history.length > 1;)this.pop();
    }
}
class $cdae29d26d2e7999$var$nn extends $cdae29d26d2e7999$var$Jo {
    /**
   * Construct the instance
   *
   * @param params - popover params
   */ constructor(e){
        super(e, {
            [$cdae29d26d2e7999$var$_.Default]: {
                hint: {
                    enabled: !1
                }
            },
            [$cdae29d26d2e7999$var$_.Html]: {
                hint: {
                    enabled: !1
                }
            }
        }), this.scrollLocker = new $cdae29d26d2e7999$var$ps(), this.history = new $cdae29d26d2e7999$var$gs(), this.isHidden = !0, this.nodes.overlay = $cdae29d26d2e7999$var$u.make("div", [
            $cdae29d26d2e7999$var$P.overlay,
            $cdae29d26d2e7999$var$P.overlayHidden
        ]), this.nodes.popover.insertBefore(this.nodes.overlay, this.nodes.popover.firstChild), this.listeners.on(this.nodes.overlay, "click", ()=>{
            this.hide();
        }), this.history.push({
            items: e.items
        });
    }
    /**
   * Open popover
   */ show() {
        this.nodes.overlay.classList.remove($cdae29d26d2e7999$var$P.overlayHidden), super.show(), this.scrollLocker.lock(), this.isHidden = !1;
    }
    /**
   * Closes popover
   */ hide() {
        this.isHidden || (super.hide(), this.nodes.overlay.classList.add($cdae29d26d2e7999$var$P.overlayHidden), this.scrollLocker.unlock(), this.history.reset(), this.isHidden = !0);
    }
    /**
   * Clears memory
   */ destroy() {
        super.destroy(), this.scrollLocker.unlock();
    }
    /**
   * Handles displaying nested items for the item
   *
   * @param item – item to show nested popover for
   */ showNestedItems(e) {
        this.updateItemsAndHeader(e.children, e.title), this.history.push({
            title: e.title,
            items: e.children
        });
    }
    /**
   * Removes rendered popover items and header and displays new ones
   *
   * @param items - new popover items
   * @param title - new popover header text
   */ updateItemsAndHeader(e, t1) {
        if (this.header !== null && this.header !== void 0 && (this.header.destroy(), this.header = null), t1 !== void 0) {
            this.header = new $cdae29d26d2e7999$var$fs({
                text: t1,
                onBackButtonClick: ()=>{
                    this.history.pop(), this.updateItemsAndHeader(this.history.currentItems, this.history.currentTitle);
                }
            });
            const o = this.header.getElement();
            o !== null && this.nodes.popoverContainer.insertBefore(o, this.nodes.popoverContainer.firstChild);
        }
        this.items.forEach((o)=>{
            var i;
            return (i = o.getElement()) == null ? void 0 : i.remove();
        }), this.items = this.buildItems(e), this.items.forEach((o)=>{
            var s;
            const i = o.getElement();
            i !== null && ((s = this.nodes.items) == null || s.appendChild(i));
        });
    }
}
class $cdae29d26d2e7999$var$ms extends $cdae29d26d2e7999$var$E {
    constructor(){
        super(...arguments), this.opened = !1, this.selection = new $cdae29d26d2e7999$var$b(), this.popover = null, this.close = ()=>{
            this.opened && (this.opened = !1, $cdae29d26d2e7999$var$b.isAtEditor || this.selection.restore(), this.selection.clearSaved(), !this.Editor.CrossBlockSelection.isCrossBlockSelectionStarted && this.Editor.BlockManager.currentBlock && this.Editor.BlockSelection.unselectBlock(this.Editor.BlockManager.currentBlock), this.eventsDispatcher.emit(this.events.closed), this.popover && (this.popover.off($cdae29d26d2e7999$var$G.Closed, this.onPopoverClose), this.popover.destroy(), this.popover.getElement().remove(), this.popover = null));
        }, this.onPopoverClose = ()=>{
            this.close();
        };
    }
    /**
   * Module Events
   */ get events() {
        return {
            opened: "block-settings-opened",
            closed: "block-settings-closed"
        };
    }
    /**
   * Block Settings CSS
   */ get CSS() {
        return {
            settings: "ce-settings"
        };
    }
    /**
   * Getter for inner popover's flipper instance
   *
   * @todo remove once BlockSettings becomes standalone non-module class
   */ get flipper() {
        var e;
        if (this.popover !== null) return "flipper" in this.popover ? (e = this.popover) == null ? void 0 : e.flipper : void 0;
    }
    /**
   * Panel with block settings with 2 sections:
   *  - Tool's Settings
   *  - Default Settings [Move, Remove, etc]
   */ make() {
        this.nodes.wrapper = $cdae29d26d2e7999$var$u.make("div", [
            this.CSS.settings
        ]), this.eventsDispatcher.on($cdae29d26d2e7999$var$Te, this.close);
    }
    /**
   * Destroys module
   */ destroy() {
        this.removeAllNodes(), this.listeners.destroy(), this.eventsDispatcher.off($cdae29d26d2e7999$var$Te, this.close);
    }
    /**
   * Open Block Settings pane
   *
   * @param targetBlock - near which Block we should open BlockSettings
   */ async open(e = this.Editor.BlockManager.currentBlock) {
        var s;
        this.opened = !0, this.selection.save(), this.Editor.BlockSelection.selectBlock(e), this.Editor.BlockSelection.clearCache();
        const { toolTunes: t1, commonTunes: o } = e.getTunes();
        this.eventsDispatcher.emit(this.events.opened);
        const i = $cdae29d26d2e7999$var$be() ? $cdae29d26d2e7999$var$nn : $cdae29d26d2e7999$var$Bt;
        this.popover = new i({
            searchable: !0,
            items: await this.getTunesItems(e, o, t1),
            scopeElement: this.Editor.API.methods.ui.nodes.redactor,
            messages: {
                nothingFound: $cdae29d26d2e7999$var$z.ui($cdae29d26d2e7999$var$K.ui.popover, "Nothing found"),
                search: $cdae29d26d2e7999$var$z.ui($cdae29d26d2e7999$var$K.ui.popover, "Filter")
            }
        }), this.popover.on($cdae29d26d2e7999$var$G.Closed, this.onPopoverClose), (s = this.nodes.wrapper) == null || s.append(this.popover.getElement()), this.popover.show();
    }
    /**
   * Returns root block settings element
   */ getElement() {
        return this.nodes.wrapper;
    }
    /**
   * Returns list of items to be displayed in block tunes menu.
   * Merges tool specific tunes, conversion menu and common tunes in one list in predefined order
   *
   * @param currentBlock –  block we are about to open block tunes for
   * @param commonTunes – common tunes
   * @param toolTunes - tool specific tunes
   */ async getTunesItems(e, t1, o) {
        const i = [];
        o !== void 0 && o.length > 0 && (i.push(...o), i.push({
            type: $cdae29d26d2e7999$var$_.Separator
        }));
        const s = Array.from(this.Editor.Tools.blockTools.values()), a = (await $cdae29d26d2e7999$var$Yo(e, s)).reduce((l, c)=>(c.toolbox.forEach((d)=>{
                l.push({
                    icon: d.icon,
                    title: $cdae29d26d2e7999$var$z.t($cdae29d26d2e7999$var$K.toolNames, d.title),
                    name: c.name,
                    closeOnActivate: !0,
                    onActivate: async ()=>{
                        const { BlockManager: h, Caret: p, Toolbar: g } = this.Editor, f = await h.convert(e, c.name, d.data);
                        g.close(), p.setToBlock(f, p.positions.END);
                    }
                });
            }), l), []);
        return a.length > 0 && (i.push({
            icon: $cdae29d26d2e7999$var$Go,
            name: "convert-to",
            title: $cdae29d26d2e7999$var$z.ui($cdae29d26d2e7999$var$K.ui.popover, "Convert to"),
            children: {
                searchable: !0,
                items: a
            }
        }), i.push({
            type: $cdae29d26d2e7999$var$_.Separator
        })), i.push(...t1), i.map((l)=>this.resolveTuneAliases(l));
    }
    /**
   * Resolves aliases in tunes menu items
   *
   * @param item - item with resolved aliases
   */ resolveTuneAliases(e) {
        if (e.type === $cdae29d26d2e7999$var$_.Separator || e.type === $cdae29d26d2e7999$var$_.Html) return e;
        const t1 = $cdae29d26d2e7999$var$Yi(e, {
            label: "title"
        });
        return e.confirmation && (t1.confirmation = this.resolveTuneAliases(e.confirmation)), t1;
    }
}
var $cdae29d26d2e7999$var$sn = {
    exports: {}
};
/*!
 * Library for handling keyboard shortcuts
 * @copyright CodeX (https://codex.so)
 * @license MIT
 * @author CodeX (https://codex.so)
 * @version 1.2.0
 */ (function(n, e) {
    (function(t1, o) {
        n.exports = o();
    })(window, function() {
        return function(t1) {
            var o = {};
            function i(s) {
                if (o[s]) return o[s].exports;
                var r = o[s] = {
                    i: s,
                    l: !1,
                    exports: {}
                };
                return t1[s].call(r.exports, r, r.exports, i), r.l = !0, r.exports;
            }
            return i.m = t1, i.c = o, i.d = function(s, r, a) {
                i.o(s, r) || Object.defineProperty(s, r, {
                    enumerable: !0,
                    get: a
                });
            }, i.r = function(s) {
                typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(s, Symbol.toStringTag, {
                    value: "Module"
                }), Object.defineProperty(s, "__esModule", {
                    value: !0
                });
            }, i.t = function(s, r) {
                if (1 & r && (s = i(s)), 8 & r || 4 & r && typeof s == "object" && s && s.__esModule) return s;
                var a = /* @__PURE__ */ Object.create(null);
                if (i.r(a), Object.defineProperty(a, "default", {
                    enumerable: !0,
                    value: s
                }), 2 & r && typeof s != "string") for(var l in s)i.d(a, l, (function(c) {
                    return s[c];
                }).bind(null, l));
                return a;
            }, i.n = function(s) {
                var r = s && s.__esModule ? function() {
                    return s.default;
                } : function() {
                    return s;
                };
                return i.d(r, "a", r), r;
            }, i.o = function(s, r) {
                return Object.prototype.hasOwnProperty.call(s, r);
            }, i.p = "", i(i.s = 0);
        }([
            function(t1, o, i) {
                function s(l, c) {
                    for(var d = 0; d < c.length; d++){
                        var h = c[d];
                        h.enumerable = h.enumerable || !1, h.configurable = !0, "value" in h && (h.writable = !0), Object.defineProperty(l, h.key, h);
                    }
                }
                function r(l, c, d) {
                    return c && s(l.prototype, c), d && s(l, d), l;
                }
                i.r(o);
                var a = function() {
                    function l(c) {
                        var d = this;
                        (function(h, p) {
                            if (!(h instanceof p)) throw new TypeError("Cannot call a class as a function");
                        })(this, l), this.commands = {}, this.keys = {}, this.name = c.name, this.parseShortcutName(c.name), this.element = c.on, this.callback = c.callback, this.executeShortcut = function(h) {
                            d.execute(h);
                        }, this.element.addEventListener("keydown", this.executeShortcut, !1);
                    }
                    return r(l, null, [
                        {
                            key: "supportedCommands",
                            get: function() {
                                return {
                                    SHIFT: [
                                        "SHIFT"
                                    ],
                                    CMD: [
                                        "CMD",
                                        "CONTROL",
                                        "COMMAND",
                                        "WINDOWS",
                                        "CTRL"
                                    ],
                                    ALT: [
                                        "ALT",
                                        "OPTION"
                                    ]
                                };
                            }
                        },
                        {
                            key: "keyCodes",
                            get: function() {
                                return {
                                    0: 48,
                                    1: 49,
                                    2: 50,
                                    3: 51,
                                    4: 52,
                                    5: 53,
                                    6: 54,
                                    7: 55,
                                    8: 56,
                                    9: 57,
                                    A: 65,
                                    B: 66,
                                    C: 67,
                                    D: 68,
                                    E: 69,
                                    F: 70,
                                    G: 71,
                                    H: 72,
                                    I: 73,
                                    J: 74,
                                    K: 75,
                                    L: 76,
                                    M: 77,
                                    N: 78,
                                    O: 79,
                                    P: 80,
                                    Q: 81,
                                    R: 82,
                                    S: 83,
                                    T: 84,
                                    U: 85,
                                    V: 86,
                                    W: 87,
                                    X: 88,
                                    Y: 89,
                                    Z: 90,
                                    BACKSPACE: 8,
                                    ENTER: 13,
                                    ESCAPE: 27,
                                    LEFT: 37,
                                    UP: 38,
                                    RIGHT: 39,
                                    DOWN: 40,
                                    INSERT: 45,
                                    DELETE: 46,
                                    ".": 190
                                };
                            }
                        }
                    ]), r(l, [
                        {
                            key: "parseShortcutName",
                            value: function(c) {
                                c = c.split("+");
                                for(var d = 0; d < c.length; d++){
                                    c[d] = c[d].toUpperCase();
                                    var h = !1;
                                    for(var p in l.supportedCommands)if (l.supportedCommands[p].includes(c[d])) {
                                        h = this.commands[p] = !0;
                                        break;
                                    }
                                    h || (this.keys[c[d]] = !0);
                                }
                                for(var g in l.supportedCommands)this.commands[g] || (this.commands[g] = !1);
                            }
                        },
                        {
                            key: "execute",
                            value: function(c) {
                                var d, h = {
                                    CMD: c.ctrlKey || c.metaKey,
                                    SHIFT: c.shiftKey,
                                    ALT: c.altKey
                                }, p = !0;
                                for(d in this.commands)this.commands[d] !== h[d] && (p = !1);
                                var g, f = !0;
                                for(g in this.keys)f = f && c.keyCode === l.keyCodes[g];
                                p && f && this.callback(c);
                            }
                        },
                        {
                            key: "remove",
                            value: function() {
                                this.element.removeEventListener("keydown", this.executeShortcut);
                            }
                        }
                    ]), l;
                }();
                o.default = a;
            }
        ]).default;
    });
})($cdae29d26d2e7999$var$sn);
var $cdae29d26d2e7999$var$bs = $cdae29d26d2e7999$var$sn.exports;
const $cdae29d26d2e7999$var$vs = /* @__PURE__ */ $cdae29d26d2e7999$var$Ke($cdae29d26d2e7999$var$bs);
class $cdae29d26d2e7999$var$ks {
    constructor(){
        this.registeredShortcuts = /* @__PURE__ */ new Map();
    }
    /**
   * Register shortcut
   *
   * @param shortcut - shortcut options
   */ add(e) {
        if (this.findShortcut(e.on, e.name)) throw Error(`Shortcut ${e.name} is already registered for ${e.on}. Please remove it before add a new handler.`);
        const o = new $cdae29d26d2e7999$var$vs({
            name: e.name,
            on: e.on,
            callback: e.handler
        }), i = this.registeredShortcuts.get(e.on) || [];
        this.registeredShortcuts.set(e.on, [
            ...i,
            o
        ]);
    }
    /**
   * Remove shortcut
   *
   * @param element - Element shortcut is set for
   * @param name - shortcut name
   */ remove(e, t1) {
        const o = this.findShortcut(e, t1);
        if (!o) return;
        o.remove();
        const s = this.registeredShortcuts.get(e).filter((r)=>r !== o);
        if (s.length === 0) {
            this.registeredShortcuts.delete(e);
            return;
        }
        this.registeredShortcuts.set(e, s);
    }
    /**
   * Get Shortcut instance if exist
   *
   * @param element - Element shorcut is set for
   * @param shortcut - shortcut name
   * @returns {number} index - shortcut index if exist
   */ findShortcut(e, t1) {
        return (this.registeredShortcuts.get(e) || []).find(({ name: i })=>i === t1);
    }
}
const $cdae29d26d2e7999$var$ge = new $cdae29d26d2e7999$var$ks();
var $cdae29d26d2e7999$var$ys = Object.defineProperty, $cdae29d26d2e7999$var$ws = Object.getOwnPropertyDescriptor, $cdae29d26d2e7999$var$rn = (n, e, t1, o)=>{
    for(var i = o > 1 ? void 0 : o ? $cdae29d26d2e7999$var$ws(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $cdae29d26d2e7999$var$ys(e, t1, i), i;
}, $cdae29d26d2e7999$var$Le = /* @__PURE__ */ ((n)=>(n.Opened = "toolbox-opened", n.Closed = "toolbox-closed", n.BlockAdded = "toolbox-block-added", n))($cdae29d26d2e7999$var$Le || {});
const $cdae29d26d2e7999$var$Ct = class an extends $cdae29d26d2e7999$var$Oe {
    /**
   * Toolbox constructor
   *
   * @param options - available parameters
   * @param options.api - Editor API methods
   * @param options.tools - Tools available to check whether some of them should be displayed at the Toolbox or not
   */ constructor({ api: e, tools: t1, i18nLabels: o }){
        super(), this.opened = !1, this.listeners = new $cdae29d26d2e7999$var$_e(), this.popover = null, this.handleMobileLayoutToggle = ()=>{
            this.destroyPopover(), this.initPopover();
        }, this.onPopoverClose = ()=>{
            this.opened = !1, this.emit("toolbox-closed");
        }, this.api = e, this.tools = t1, this.i18nLabels = o, this.enableShortcuts(), this.nodes = {
            toolbox: $cdae29d26d2e7999$var$u.make("div", an.CSS.toolbox)
        }, this.initPopover(), this.api.events.on($cdae29d26d2e7999$var$Te, this.handleMobileLayoutToggle);
    }
    /**
   * Returns True if Toolbox is Empty and nothing to show
   *
   * @returns {boolean}
   */ get isEmpty() {
        return this.toolsToBeDisplayed.length === 0;
    }
    /**
   * CSS styles
   */ static get CSS() {
        return {
            toolbox: "ce-toolbox"
        };
    }
    /**
   * Returns root block settings element
   */ getElement() {
        return this.nodes.toolbox;
    }
    /**
   * Returns true if the Toolbox has the Flipper activated and the Flipper has selected button
   */ hasFocus() {
        if (this.popover !== null) return "hasFocus" in this.popover ? this.popover.hasFocus() : void 0;
    }
    /**
   * Destroy Module
   */ destroy() {
        var e;
        super.destroy(), this.nodes && this.nodes.toolbox && this.nodes.toolbox.remove(), this.removeAllShortcuts(), (e = this.popover) == null || e.off($cdae29d26d2e7999$var$G.Closed, this.onPopoverClose), this.listeners.destroy(), this.api.events.off($cdae29d26d2e7999$var$Te, this.handleMobileLayoutToggle);
    }
    /**
   * Toolbox Tool's button click handler
   *
   * @param toolName - tool type to be activated
   * @param blockDataOverrides - Block data predefined by the activated Toolbox item
   */ toolButtonActivated(e, t1) {
        this.insertNewBlock(e, t1);
    }
    /**
   * Open Toolbox with Tools
   */ open() {
        var e;
        this.isEmpty || ((e = this.popover) == null || e.show(), this.opened = !0, this.emit("toolbox-opened"));
    }
    /**
   * Close Toolbox
   */ close() {
        var e;
        (e = this.popover) == null || e.hide(), this.opened = !1, this.emit("toolbox-closed");
    }
    /**
   * Close Toolbox
   */ toggle() {
        this.opened ? this.close() : this.open();
    }
    /**
   * Creates toolbox popover and appends it inside wrapper element
   */ initPopover() {
        var t1;
        const e = $cdae29d26d2e7999$var$be() ? $cdae29d26d2e7999$var$nn : $cdae29d26d2e7999$var$Bt;
        this.popover = new e({
            scopeElement: this.api.ui.nodes.redactor,
            searchable: !0,
            messages: {
                nothingFound: this.i18nLabels.nothingFound,
                search: this.i18nLabels.filter
            },
            items: this.toolboxItemsToBeDisplayed
        }), this.popover.on($cdae29d26d2e7999$var$G.Closed, this.onPopoverClose), (t1 = this.nodes.toolbox) == null || t1.append(this.popover.getElement());
    }
    /**
   * Destroys popover instance and removes it from DOM
   */ destroyPopover() {
        this.popover !== null && (this.popover.hide(), this.popover.off($cdae29d26d2e7999$var$G.Closed, this.onPopoverClose), this.popover.destroy(), this.popover = null), this.nodes.toolbox !== null && (this.nodes.toolbox.innerHTML = "");
    }
    get toolsToBeDisplayed() {
        const e = [];
        return this.tools.forEach((t1)=>{
            t1.toolbox && e.push(t1);
        }), e;
    }
    get toolboxItemsToBeDisplayed() {
        const e = (t1, o, i = !0)=>({
                icon: t1.icon,
                title: $cdae29d26d2e7999$var$z.t($cdae29d26d2e7999$var$K.toolNames, t1.title || $cdae29d26d2e7999$var$je(o.name)),
                name: o.name,
                onActivate: ()=>{
                    this.toolButtonActivated(o.name, t1.data);
                },
                secondaryLabel: o.shortcut && i ? $cdae29d26d2e7999$var$vt(o.shortcut) : ""
            });
        return this.toolsToBeDisplayed.reduce((t1, o)=>(Array.isArray(o.toolbox) ? o.toolbox.forEach((i, s)=>{
                t1.push(e(i, o, s === 0));
            }) : o.toolbox !== void 0 && t1.push(e(o.toolbox, o)), t1), []);
    }
    /**
   * Iterate all tools and enable theirs shortcuts if specified
   */ enableShortcuts() {
        this.toolsToBeDisplayed.forEach((e)=>{
            const t1 = e.shortcut;
            t1 && this.enableShortcutForTool(e.name, t1);
        });
    }
    /**
   * Enable shortcut Block Tool implemented shortcut
   *
   * @param {string} toolName - Tool name
   * @param {string} shortcut - shortcut according to the ShortcutData Module format
   */ enableShortcutForTool(e, t1) {
        $cdae29d26d2e7999$var$ge.add({
            name: t1,
            on: this.api.ui.nodes.redactor,
            handler: async (o)=>{
                o.preventDefault();
                const i = this.api.blocks.getCurrentBlockIndex(), s = this.api.blocks.getBlockByIndex(i);
                if (s) try {
                    const r = await this.api.blocks.convert(s.id, e);
                    this.api.caret.setToBlock(r, "end");
                    return;
                } catch  {}
                this.insertNewBlock(e);
            }
        });
    }
    /**
   * Removes all added shortcuts
   * Fired when the Read-Only mode is activated
   */ removeAllShortcuts() {
        this.toolsToBeDisplayed.forEach((e)=>{
            const t1 = e.shortcut;
            t1 && $cdae29d26d2e7999$var$ge.remove(this.api.ui.nodes.redactor, t1);
        });
    }
    /**
   * Inserts new block
   * Can be called when button clicked on Toolbox or by ShortcutData
   *
   * @param {string} toolName - Tool name
   * @param blockDataOverrides - predefined Block data
   */ async insertNewBlock(e, t1) {
        const o = this.api.blocks.getCurrentBlockIndex(), i = this.api.blocks.getBlockByIndex(o);
        if (!i) return;
        const s = i.isEmpty ? o : o + 1;
        let r;
        if (t1) {
            const l = await this.api.blocks.composeBlockData(e);
            r = Object.assign(l, t1);
        }
        const a = this.api.blocks.insert(e, r, void 0, s, void 0, i.isEmpty);
        a.call($cdae29d26d2e7999$var$ee.APPEND_CALLBACK), this.api.caret.setToBlock(s), this.emit("toolbox-block-added", {
            block: a
        }), this.api.toolbar.close();
    }
};
$cdae29d26d2e7999$var$rn([
    $cdae29d26d2e7999$var$me
], $cdae29d26d2e7999$var$Ct.prototype, "toolsToBeDisplayed", 1);
$cdae29d26d2e7999$var$rn([
    $cdae29d26d2e7999$var$me
], $cdae29d26d2e7999$var$Ct.prototype, "toolboxItemsToBeDisplayed", 1);
let $cdae29d26d2e7999$var$Es = $cdae29d26d2e7999$var$Ct;
const $cdae29d26d2e7999$var$ln = "block hovered";
async function $cdae29d26d2e7999$var$xs(n, e) {
    const t1 = navigator.keyboard;
    if (!t1) return e;
    try {
        return (await t1.getLayoutMap()).get(n) || e;
    } catch (o) {
        return console.error(o), e;
    }
}
class $cdae29d26d2e7999$var$Bs extends $cdae29d26d2e7999$var$E {
    /**
   * @class
   * @param moduleConfiguration - Module Configuration
   * @param moduleConfiguration.config - Editor's config
   * @param moduleConfiguration.eventsDispatcher - Editor's event dispatcher
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        }), this.toolboxInstance = null;
    }
    /**
   * CSS styles
   *
   * @returns {object}
   */ get CSS() {
        return {
            toolbar: "ce-toolbar",
            content: "ce-toolbar__content",
            actions: "ce-toolbar__actions",
            actionsOpened: "ce-toolbar__actions--opened",
            toolbarOpened: "ce-toolbar--opened",
            openedToolboxHolderModifier: "codex-editor--toolbox-opened",
            plusButton: "ce-toolbar__plus",
            plusButtonShortcut: "ce-toolbar__plus-shortcut",
            settingsToggler: "ce-toolbar__settings-btn",
            settingsTogglerHidden: "ce-toolbar__settings-btn--hidden"
        };
    }
    /**
   * Returns the Toolbar opening state
   *
   * @returns {boolean}
   */ get opened() {
        return this.nodes.wrapper.classList.contains(this.CSS.toolbarOpened);
    }
    /**
   * Public interface for accessing the Toolbox
   */ get toolbox() {
        var e;
        return {
            opened: (e = this.toolboxInstance) == null ? void 0 : e.opened,
            close: ()=>{
                var t1;
                (t1 = this.toolboxInstance) == null || t1.close();
            },
            open: ()=>{
                if (this.toolboxInstance === null) {
                    $cdae29d26d2e7999$var$S("toolbox.open() called before initialization is finished", "warn");
                    return;
                }
                this.Editor.BlockManager.currentBlock = this.hoveredBlock, this.toolboxInstance.open();
            },
            toggle: ()=>{
                if (this.toolboxInstance === null) {
                    $cdae29d26d2e7999$var$S("toolbox.toggle() called before initialization is finished", "warn");
                    return;
                }
                this.toolboxInstance.toggle();
            },
            hasFocus: ()=>{
                var t1;
                return (t1 = this.toolboxInstance) == null ? void 0 : t1.hasFocus();
            }
        };
    }
    /**
   * Block actions appearance manipulations
   */ get blockActions() {
        return {
            hide: ()=>{
                this.nodes.actions.classList.remove(this.CSS.actionsOpened);
            },
            show: ()=>{
                this.nodes.actions.classList.add(this.CSS.actionsOpened);
            }
        };
    }
    /**
   * Methods for working with Block Tunes toggler
   */ get blockTunesToggler() {
        return {
            hide: ()=>this.nodes.settingsToggler.classList.add(this.CSS.settingsTogglerHidden),
            show: ()=>this.nodes.settingsToggler.classList.remove(this.CSS.settingsTogglerHidden)
        };
    }
    /**
   * Toggles read-only mode
   *
   * @param {boolean} readOnlyEnabled - read-only mode
   */ toggleReadOnly(e) {
        e ? (this.destroy(), this.Editor.BlockSettings.destroy(), this.disableModuleBindings()) : window.requestIdleCallback(()=>{
            this.drawUI(), this.enableModuleBindings();
        }, {
            timeout: 2e3
        });
    }
    /**
   * Move Toolbar to the passed (or current) Block
   *
   * @param block - block to move Toolbar near it
   */ moveAndOpen(e = this.Editor.BlockManager.currentBlock) {
        if (this.toolboxInstance === null) {
            $cdae29d26d2e7999$var$S("Can't open Toolbar since Editor initialization is not finished yet", "warn");
            return;
        }
        if (this.toolboxInstance.opened && this.toolboxInstance.close(), this.Editor.BlockSettings.opened && this.Editor.BlockSettings.close(), !e) return;
        this.hoveredBlock = e;
        const t1 = e.holder, { isMobile: o } = this.Editor.UI;
        let i;
        const s = 20, r = e.firstInput, a = t1.getBoundingClientRect(), l = r !== void 0 ? r.getBoundingClientRect() : null, c = l !== null ? l.top - a.top : null, d = c !== null ? c > s : void 0;
        if (o) i = t1.offsetTop + t1.offsetHeight;
        else if (r === void 0 || d) {
            const h = parseInt(window.getComputedStyle(e.pluginsContent).paddingTop);
            i = t1.offsetTop + h;
        } else {
            const h = $cdae29d26d2e7999$var$li(r), p = parseInt(window.getComputedStyle(this.nodes.plusButton).height, 10), g = 8;
            i = t1.offsetTop + h - p + g + c;
        }
        this.nodes.wrapper.style.top = `${Math.floor(i)}px`, this.Editor.BlockManager.blocks.length === 1 && e.isEmpty ? this.blockTunesToggler.hide() : this.blockTunesToggler.show(), this.open();
    }
    /**
   * Close the Toolbar
   */ close() {
        var e, t1;
        this.Editor.ReadOnly.isEnabled || ((e = this.nodes.wrapper) == null || e.classList.remove(this.CSS.toolbarOpened), this.blockActions.hide(), (t1 = this.toolboxInstance) == null || t1.close(), this.Editor.BlockSettings.close(), this.reset());
    }
    /**
   * Reset the Toolbar position to prevent DOM height growth, for example after blocks deletion
   */ reset() {
        this.nodes.wrapper.style.top = "unset";
    }
    /**
   * Open Toolbar with Plus Button and Actions
   *
   * @param {boolean} withBlockActions - by default, Toolbar opens with Block Actions.
   *                                     This flag allows to open Toolbar without Actions.
   */ open(e = !0) {
        this.nodes.wrapper.classList.add(this.CSS.toolbarOpened), e ? this.blockActions.show() : this.blockActions.hide();
    }
    /**
   * Draws Toolbar elements
   */ async make() {
        this.nodes.wrapper = $cdae29d26d2e7999$var$u.make("div", this.CSS.toolbar), [
            "content",
            "actions"
        ].forEach((s)=>{
            this.nodes[s] = $cdae29d26d2e7999$var$u.make("div", this.CSS[s]);
        }), $cdae29d26d2e7999$var$u.append(this.nodes.wrapper, this.nodes.content), $cdae29d26d2e7999$var$u.append(this.nodes.content, this.nodes.actions), this.nodes.plusButton = $cdae29d26d2e7999$var$u.make("div", this.CSS.plusButton, {
            innerHTML: $cdae29d26d2e7999$var$ts
        }), $cdae29d26d2e7999$var$u.append(this.nodes.actions, this.nodes.plusButton), this.readOnlyMutableListeners.on(this.nodes.plusButton, "click", ()=>{
            $cdae29d26d2e7999$var$$e(!0), this.plusButtonClicked();
        }, !1);
        const e = $cdae29d26d2e7999$var$u.make("div");
        e.appendChild(document.createTextNode($cdae29d26d2e7999$var$z.ui($cdae29d26d2e7999$var$K.ui.toolbar.toolbox, "Add"))), e.appendChild($cdae29d26d2e7999$var$u.make("div", this.CSS.plusButtonShortcut, {
            textContent: "/"
        })), $cdae29d26d2e7999$var$ze(this.nodes.plusButton, e, {
            hidingDelay: 400
        }), this.nodes.settingsToggler = $cdae29d26d2e7999$var$u.make("span", this.CSS.settingsToggler, {
            innerHTML: $cdae29d26d2e7999$var$es
        }), $cdae29d26d2e7999$var$u.append(this.nodes.actions, this.nodes.settingsToggler);
        const t1 = $cdae29d26d2e7999$var$u.make("div"), o = $cdae29d26d2e7999$var$u.text($cdae29d26d2e7999$var$z.ui($cdae29d26d2e7999$var$K.ui.blockTunes.toggler, "Click to tune")), i = await $cdae29d26d2e7999$var$xs("Slash", "/");
        t1.appendChild(o), t1.appendChild($cdae29d26d2e7999$var$u.make("div", this.CSS.plusButtonShortcut, {
            textContent: $cdae29d26d2e7999$var$vt(`CMD + ${i}`)
        })), $cdae29d26d2e7999$var$ze(this.nodes.settingsToggler, t1, {
            hidingDelay: 400
        }), $cdae29d26d2e7999$var$u.append(this.nodes.actions, this.makeToolbox()), $cdae29d26d2e7999$var$u.append(this.nodes.actions, this.Editor.BlockSettings.getElement()), $cdae29d26d2e7999$var$u.append(this.Editor.UI.nodes.wrapper, this.nodes.wrapper);
    }
    /**
   * Creates the Toolbox instance and return it's rendered element
   */ makeToolbox() {
        return this.toolboxInstance = new $cdae29d26d2e7999$var$Es({
            api: this.Editor.API.methods,
            tools: this.Editor.Tools.blockTools,
            i18nLabels: {
                filter: $cdae29d26d2e7999$var$z.ui($cdae29d26d2e7999$var$K.ui.popover, "Filter"),
                nothingFound: $cdae29d26d2e7999$var$z.ui($cdae29d26d2e7999$var$K.ui.popover, "Nothing found")
            }
        }), this.toolboxInstance.on($cdae29d26d2e7999$var$Le.Opened, ()=>{
            this.Editor.UI.nodes.wrapper.classList.add(this.CSS.openedToolboxHolderModifier);
        }), this.toolboxInstance.on($cdae29d26d2e7999$var$Le.Closed, ()=>{
            this.Editor.UI.nodes.wrapper.classList.remove(this.CSS.openedToolboxHolderModifier);
        }), this.toolboxInstance.on($cdae29d26d2e7999$var$Le.BlockAdded, ({ block: e })=>{
            const { BlockManager: t1, Caret: o } = this.Editor, i = t1.getBlockById(e.id);
            i.inputs.length === 0 && (i === t1.lastBlock ? (t1.insertAtEnd(), o.setToBlock(t1.lastBlock)) : o.setToBlock(t1.nextBlock));
        }), this.toolboxInstance.getElement();
    }
    /**
   * Handler for Plus Button
   */ plusButtonClicked() {
        var e;
        this.Editor.BlockManager.currentBlock = this.hoveredBlock, (e = this.toolboxInstance) == null || e.toggle();
    }
    /**
   * Enable bindings
   */ enableModuleBindings() {
        this.readOnlyMutableListeners.on(this.nodes.settingsToggler, "mousedown", (e)=>{
            var t1;
            e.stopPropagation(), this.settingsTogglerClicked(), (t1 = this.toolboxInstance) != null && t1.opened && this.toolboxInstance.close(), $cdae29d26d2e7999$var$$e(!0);
        }, !0), $cdae29d26d2e7999$var$be() || this.eventsDispatcher.on($cdae29d26d2e7999$var$ln, (e)=>{
            var t1;
            this.Editor.BlockSettings.opened || (t1 = this.toolboxInstance) != null && t1.opened || this.moveAndOpen(e.block);
        });
    }
    /**
   * Disable bindings
   */ disableModuleBindings() {
        this.readOnlyMutableListeners.clearAll();
    }
    /**
   * Clicks on the Block Settings toggler
   */ settingsTogglerClicked() {
        this.Editor.BlockManager.currentBlock = this.hoveredBlock, this.Editor.BlockSettings.opened ? this.Editor.BlockSettings.close() : this.Editor.BlockSettings.open(this.hoveredBlock);
    }
    /**
   * Draws Toolbar UI
   *
   * Toolbar contains BlockSettings and Toolbox.
   * That's why at first we draw its components and then Toolbar itself
   *
   * Steps:
   *  - Make Toolbar dependent components like BlockSettings, Toolbox and so on
   *  - Make itself and append dependent nodes to itself
   *
   */ drawUI() {
        this.Editor.BlockSettings.make(), this.make();
    }
    /**
   * Removes all created and saved HTMLElements
   * It is used in Read-Only mode
   */ destroy() {
        this.removeAllNodes(), this.toolboxInstance && this.toolboxInstance.destroy();
    }
}
var $cdae29d26d2e7999$var$ae = /* @__PURE__ */ ((n)=>(n[n.Block = 0] = "Block", n[n.Inline = 1] = "Inline", n[n.Tune = 2] = "Tune", n))($cdae29d26d2e7999$var$ae || {}), $cdae29d26d2e7999$var$Pe = /* @__PURE__ */ ((n)=>(n.Shortcut = "shortcut", n.Toolbox = "toolbox", n.EnabledInlineTools = "inlineToolbar", n.EnabledBlockTunes = "tunes", n.Config = "config", n))($cdae29d26d2e7999$var$Pe || {}), $cdae29d26d2e7999$var$cn = /* @__PURE__ */ ((n)=>(n.Shortcut = "shortcut", n.SanitizeConfig = "sanitize", n))($cdae29d26d2e7999$var$cn || {}), $cdae29d26d2e7999$var$pe = /* @__PURE__ */ ((n)=>(n.IsEnabledLineBreaks = "enableLineBreaks", n.Toolbox = "toolbox", n.ConversionConfig = "conversionConfig", n.IsReadOnlySupported = "isReadOnlySupported", n.PasteConfig = "pasteConfig", n))($cdae29d26d2e7999$var$pe || {}), $cdae29d26d2e7999$var$We = /* @__PURE__ */ ((n)=>(n.IsInline = "isInline", n.Title = "title", n.IsReadOnlySupported = "isReadOnlySupported", n))($cdae29d26d2e7999$var$We || {}), $cdae29d26d2e7999$var$mt = /* @__PURE__ */ ((n)=>(n.IsTune = "isTune", n))($cdae29d26d2e7999$var$mt || {});
class $cdae29d26d2e7999$var$Tt {
    /**
   * @class
   * @param {ConstructorOptions} options - Constructor options
   */ constructor({ name: e, constructable: t1, config: o, api: i, isDefault: s, isInternal: r = !1, defaultPlaceholder: a }){
        this.api = i, this.name = e, this.constructable = t1, this.config = o, this.isDefault = s, this.isInternal = r, this.defaultPlaceholder = a;
    }
    /**
   * Returns Tool user configuration
   */ get settings() {
        const e = this.config.config || {};
        return this.isDefault && !("placeholder" in e) && this.defaultPlaceholder && (e.placeholder = this.defaultPlaceholder), e;
    }
    /**
   * Calls Tool's reset method
   */ reset() {
        if ($cdae29d26d2e7999$var$A(this.constructable.reset)) return this.constructable.reset();
    }
    /**
   * Calls Tool's prepare method
   */ prepare() {
        if ($cdae29d26d2e7999$var$A(this.constructable.prepare)) return this.constructable.prepare({
            toolName: this.name,
            config: this.settings
        });
    }
    /**
   * Returns shortcut for Tool (internal or specified by user)
   */ get shortcut() {
        const e = this.constructable.shortcut;
        return this.config.shortcut || e;
    }
    /**
   * Returns Tool's sanitizer configuration
   */ get sanitizeConfig() {
        return this.constructable.sanitize || {};
    }
    /**
   * Returns true if Tools is inline
   */ isInline() {
        return this.type === $cdae29d26d2e7999$var$ae.Inline;
    }
    /**
   * Returns true if Tools is block
   */ isBlock() {
        return this.type === $cdae29d26d2e7999$var$ae.Block;
    }
    /**
   * Returns true if Tools is tune
   */ isTune() {
        return this.type === $cdae29d26d2e7999$var$ae.Tune;
    }
}
class $cdae29d26d2e7999$var$Cs extends $cdae29d26d2e7999$var$E {
    /**
   * @param moduleConfiguration - Module Configuration
   * @param moduleConfiguration.config - Editor's config
   * @param moduleConfiguration.eventsDispatcher - Editor's event dispatcher
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        }), this.CSS = {
            inlineToolbar: "ce-inline-toolbar"
        }, this.opened = !1, this.popover = null, this.toolbarVerticalMargin = $cdae29d26d2e7999$var$be() ? 20 : 6, this.tools = /* @__PURE__ */ new Map(), window.requestIdleCallback(()=>{
            this.make();
        }, {
            timeout: 2e3
        });
    }
    /**
   *  Moving / appearance
   *  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
   */ /**
   * Shows Inline Toolbar if something is selected
   *
   * @param [needToClose] - pass true to close toolbar if it is not allowed.
   *                                  Avoid to use it just for closing IT, better call .close() clearly.
   */ async tryToShow(e = !1) {
        e && this.close(), this.allowedToShow() && (await this.open(), this.Editor.Toolbar.close());
    }
    /**
   * Hides Inline Toolbar
   */ close() {
        var e, t1;
        if (this.opened) {
            for (const [o, i] of this.tools){
                const s = this.getToolShortcut(o.name);
                s !== void 0 && $cdae29d26d2e7999$var$ge.remove(this.Editor.UI.nodes.redactor, s), $cdae29d26d2e7999$var$A(i.clear) && i.clear();
            }
            this.tools = /* @__PURE__ */ new Map(), this.reset(), this.opened = !1, (e = this.popover) == null || e.hide(), (t1 = this.popover) == null || t1.destroy(), this.popover = null;
        }
    }
    /**
   * Check if node is contained by Inline Toolbar
   *
   * @param {Node} node — node to check
   */ containsNode(e) {
        return this.nodes.wrapper === void 0 ? !1 : this.nodes.wrapper.contains(e);
    }
    /**
   * Removes UI and its components
   */ destroy() {
        var e;
        this.removeAllNodes(), (e = this.popover) == null || e.destroy(), this.popover = null;
    }
    /**
   * Making DOM
   */ make() {
        this.nodes.wrapper = $cdae29d26d2e7999$var$u.make("div", [
            this.CSS.inlineToolbar,
            ...this.isRtl ? [
                this.Editor.UI.CSS.editorRtlFix
            ] : []
        ]), $cdae29d26d2e7999$var$u.append(this.Editor.UI.nodes.wrapper, this.nodes.wrapper);
    }
    /**
   * Shows Inline Toolbar
   */ async open() {
        var t1;
        if (this.opened) return;
        this.opened = !0, this.popover !== null && this.popover.destroy(), this.createToolsInstances();
        const e = await this.getPopoverItems();
        this.popover = new $cdae29d26d2e7999$var$hs({
            items: e,
            scopeElement: this.Editor.API.methods.ui.nodes.redactor,
            messages: {
                nothingFound: $cdae29d26d2e7999$var$z.ui($cdae29d26d2e7999$var$K.ui.popover, "Nothing found"),
                search: $cdae29d26d2e7999$var$z.ui($cdae29d26d2e7999$var$K.ui.popover, "Filter")
            }
        }), this.move(this.popover.size.width), (t1 = this.nodes.wrapper) == null || t1.append(this.popover.getElement()), this.popover.show();
    }
    /**
   * Move Toolbar to the selected text
   *
   * @param popoverWidth - width of the toolbar popover
   */ move(e) {
        const t1 = $cdae29d26d2e7999$var$b.rect, o = this.Editor.UI.nodes.wrapper.getBoundingClientRect(), i = {
            x: t1.x - o.x,
            y: t1.y + t1.height - // + window.scrollY
            o.top + this.toolbarVerticalMargin
        };
        i.x + e + o.x > this.Editor.UI.contentRect.right && (i.x = this.Editor.UI.contentRect.right - e - o.x), this.nodes.wrapper.style.left = Math.floor(i.x) + "px", this.nodes.wrapper.style.top = Math.floor(i.y) + "px";
    }
    /**
   * Clear orientation classes and reset position
   */ reset() {
        this.nodes.wrapper.style.left = "0", this.nodes.wrapper.style.top = "0";
    }
    /**
   * Need to show Inline Toolbar or not
   */ allowedToShow() {
        const e = [
            "IMG",
            "INPUT"
        ], t1 = $cdae29d26d2e7999$var$b.get(), o = $cdae29d26d2e7999$var$b.text;
        if (!t1 || !t1.anchorNode || t1.isCollapsed || o.length < 1) return !1;
        const i = $cdae29d26d2e7999$var$u.isElement(t1.anchorNode) ? t1.anchorNode : t1.anchorNode.parentElement;
        if (i === null || t1 !== null && e.includes(i.tagName)) return !1;
        const s = this.Editor.BlockManager.getBlock(t1.anchorNode);
        return !s || this.getTools().some((c)=>s.tool.inlineTools.has(c.name)) === !1 ? !1 : i.closest("[contenteditable]") !== null;
    }
    /**
   *  Working with Tools
   *  ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
   */ /**
   * Returns tools that are available for current block
   *
   * Used to check if Inline Toolbar could be shown
   * and to render tools in the Inline Toolbar
   */ getTools() {
        const e = this.Editor.BlockManager.currentBlock;
        return e ? Array.from(e.tool.inlineTools.values()).filter((o)=>!(this.Editor.ReadOnly.isEnabled && o.isReadOnlySupported !== !0)) : [];
    }
    /**
   * Constructs tools instances and saves them to this.tools
   */ createToolsInstances() {
        this.tools = /* @__PURE__ */ new Map(), this.getTools().forEach((t1)=>{
            const o = t1.create();
            this.tools.set(t1, o);
        });
    }
    /**
   * Returns Popover Items for tools segregated by their appearance type: regular items and custom html elements.
   */ async getPopoverItems() {
        const e = [];
        let t1 = 0;
        for (const [o, i] of this.tools){
            const s = await i.render(), r = this.getToolShortcut(o.name);
            if (r !== void 0) try {
                this.enableShortcuts(o.name, r);
            } catch  {}
            const a = r !== void 0 ? $cdae29d26d2e7999$var$vt(r) : void 0, l = $cdae29d26d2e7999$var$z.t($cdae29d26d2e7999$var$K.toolNames, o.title || $cdae29d26d2e7999$var$je(o.name));
            [
                s
            ].flat().forEach((c)=>{
                var h, p;
                const d = {
                    name: o.name,
                    onActivate: ()=>{
                        this.toolClicked(i);
                    },
                    hint: {
                        title: l,
                        description: a
                    }
                };
                if ($cdae29d26d2e7999$var$u.isElement(c)) {
                    const g = {
                        ...d,
                        element: c,
                        type: $cdae29d26d2e7999$var$_.Html
                    };
                    if ($cdae29d26d2e7999$var$A(i.renderActions)) {
                        const f = i.renderActions();
                        g.children = {
                            isOpen: (h = i.checkState) == null ? void 0 : h.call(i, $cdae29d26d2e7999$var$b.get()),
                            /** Disable keyboard navigation in actions, as it might conflict with enter press handling */ isFlippable: !1,
                            items: [
                                {
                                    type: $cdae29d26d2e7999$var$_.Html,
                                    element: f
                                }
                            ]
                        };
                    } else (p = i.checkState) == null || p.call(i, $cdae29d26d2e7999$var$b.get());
                    e.push(g);
                } else if (c.type === $cdae29d26d2e7999$var$_.Html) e.push({
                    ...d,
                    ...c,
                    type: $cdae29d26d2e7999$var$_.Html
                });
                else if (c.type === $cdae29d26d2e7999$var$_.Separator) e.push({
                    type: $cdae29d26d2e7999$var$_.Separator
                });
                else {
                    const g = {
                        ...d,
                        ...c,
                        type: $cdae29d26d2e7999$var$_.Default
                    };
                    "children" in g && t1 !== 0 && e.push({
                        type: $cdae29d26d2e7999$var$_.Separator
                    }), e.push(g), "children" in g && t1 < this.tools.size - 1 && e.push({
                        type: $cdae29d26d2e7999$var$_.Separator
                    });
                }
            }), t1++;
        }
        return e;
    }
    /**
   * Get shortcut name for tool
   *
   * @param toolName — Tool name
   */ getToolShortcut(e) {
        const { Tools: t1 } = this.Editor, o = t1.inlineTools.get(e), i = t1.internal.inlineTools;
        return Array.from(i.keys()).includes(e) ? this.inlineTools[e][$cdae29d26d2e7999$var$cn.Shortcut] : o == null ? void 0 : o.shortcut;
    }
    /**
   * Enable Tool shortcut with Editor Shortcuts Module
   *
   * @param toolName - tool name
   * @param shortcut - shortcut according to the ShortcutData Module format
   */ enableShortcuts(e, t1) {
        $cdae29d26d2e7999$var$ge.add({
            name: t1,
            handler: (o)=>{
                var s;
                const { currentBlock: i } = this.Editor.BlockManager;
                i && i.tool.enabledInlineTools && (o.preventDefault(), (s = this.popover) == null || s.activateItemByName(e));
            },
            /**
       * We need to bind shortcut to the document to make it work in read-only mode
       */ on: document
        });
    }
    /**
   * Inline Tool button clicks
   *
   * @param tool - Tool's instance
   */ toolClicked(e) {
        var o;
        const t1 = $cdae29d26d2e7999$var$b.range;
        (o = e.surround) == null || o.call(e, t1), this.checkToolsState();
    }
    /**
   * Check Tools` state by selection
   */ checkToolsState() {
        var e;
        (e = this.tools) == null || e.forEach((t1)=>{
            var o;
            (o = t1.checkState) == null || o.call(t1, $cdae29d26d2e7999$var$b.get());
        });
    }
    /**
   * Get inline tools tools
   * Tools that has isInline is true
   */ get inlineTools() {
        const e = {};
        return Array.from(this.Editor.Tools.inlineTools.entries()).forEach(([t1, o])=>{
            e[t1] = o.create();
        }), e;
    }
}
function $cdae29d26d2e7999$var$dn() {
    const n = window.getSelection();
    if (n === null) return [
        null,
        0
    ];
    let e = n.focusNode, t1 = n.focusOffset;
    return e === null ? [
        null,
        0
    ] : (e.nodeType !== Node.TEXT_NODE && e.childNodes.length > 0 && (e.childNodes[t1] ? (e = e.childNodes[t1], t1 = 0) : (e = e.childNodes[t1 - 1], t1 = e.textContent.length)), [
        e,
        t1
    ]);
}
function $cdae29d26d2e7999$var$un(n, e, t1, o) {
    const i = document.createRange();
    o === "left" ? (i.setStart(n, 0), i.setEnd(e, t1)) : (i.setStart(e, t1), i.setEnd(n, n.childNodes.length));
    const s = i.cloneContents(), r = document.createElement("div");
    r.appendChild(s);
    const a = r.textContent || "";
    return $cdae29d26d2e7999$var$ai(a);
}
function $cdae29d26d2e7999$var$Ne(n) {
    const e = $cdae29d26d2e7999$var$u.getDeepestNode(n);
    if (e === null || $cdae29d26d2e7999$var$u.isEmpty(n)) return !0;
    if ($cdae29d26d2e7999$var$u.isNativeInput(e)) return e.selectionEnd === 0;
    if ($cdae29d26d2e7999$var$u.isEmpty(n)) return !0;
    const [t1, o] = $cdae29d26d2e7999$var$dn();
    return t1 === null ? !1 : $cdae29d26d2e7999$var$un(n, t1, o, "left");
}
function $cdae29d26d2e7999$var$Re(n) {
    const e = $cdae29d26d2e7999$var$u.getDeepestNode(n, !0);
    if (e === null) return !0;
    if ($cdae29d26d2e7999$var$u.isNativeInput(e)) return e.selectionEnd === e.value.length;
    const [t1, o] = $cdae29d26d2e7999$var$dn();
    return t1 === null ? !1 : $cdae29d26d2e7999$var$un(n, t1, o, "right");
}
var $cdae29d26d2e7999$var$hn = {}, $cdae29d26d2e7999$var$St = {}, $cdae29d26d2e7999$var$Xe = {}, $cdae29d26d2e7999$var$de = {}, $cdae29d26d2e7999$var$It = {}, $cdae29d26d2e7999$var$Ot = {};
Object.defineProperty($cdae29d26d2e7999$var$Ot, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$Ot.allInputsSelector = $cdae29d26d2e7999$var$Ts;
function $cdae29d26d2e7999$var$Ts() {
    var n = [
        "text",
        "password",
        "email",
        "number",
        "search",
        "tel",
        "url"
    ];
    return "[contenteditable=true], textarea, input:not([type]), " + n.map(function(e) {
        return 'input[type="'.concat(e, '"]');
    }).join(", ");
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.allInputsSelector = void 0;
    var e = $cdae29d26d2e7999$var$Ot;
    Object.defineProperty(n, "allInputsSelector", {
        enumerable: !0,
        get: function() {
            return e.allInputsSelector;
        }
    });
})($cdae29d26d2e7999$var$It);
var $cdae29d26d2e7999$var$ue = {}, $cdae29d26d2e7999$var$_t = {};
Object.defineProperty($cdae29d26d2e7999$var$_t, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$_t.isNativeInput = $cdae29d26d2e7999$var$Ss;
function $cdae29d26d2e7999$var$Ss(n) {
    var e = [
        "INPUT",
        "TEXTAREA"
    ];
    return n && n.tagName ? e.includes(n.tagName) : !1;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isNativeInput = void 0;
    var e = $cdae29d26d2e7999$var$_t;
    Object.defineProperty(n, "isNativeInput", {
        enumerable: !0,
        get: function() {
            return e.isNativeInput;
        }
    });
})($cdae29d26d2e7999$var$ue);
var $cdae29d26d2e7999$var$pn = {}, $cdae29d26d2e7999$var$Mt = {};
Object.defineProperty($cdae29d26d2e7999$var$Mt, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$Mt.append = $cdae29d26d2e7999$var$Is;
function $cdae29d26d2e7999$var$Is(n, e) {
    Array.isArray(e) ? e.forEach(function(t1) {
        n.appendChild(t1);
    }) : n.appendChild(e);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.append = void 0;
    var e = $cdae29d26d2e7999$var$Mt;
    Object.defineProperty(n, "append", {
        enumerable: !0,
        get: function() {
            return e.append;
        }
    });
})($cdae29d26d2e7999$var$pn);
var $cdae29d26d2e7999$var$At = {}, $cdae29d26d2e7999$var$Lt = {};
Object.defineProperty($cdae29d26d2e7999$var$Lt, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$Lt.blockElements = $cdae29d26d2e7999$var$Os;
function $cdae29d26d2e7999$var$Os() {
    return [
        "address",
        "article",
        "aside",
        "blockquote",
        "canvas",
        "div",
        "dl",
        "dt",
        "fieldset",
        "figcaption",
        "figure",
        "footer",
        "form",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "header",
        "hgroup",
        "hr",
        "li",
        "main",
        "nav",
        "noscript",
        "ol",
        "output",
        "p",
        "pre",
        "ruby",
        "section",
        "table",
        "tbody",
        "thead",
        "tr",
        "tfoot",
        "ul",
        "video"
    ];
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.blockElements = void 0;
    var e = $cdae29d26d2e7999$var$Lt;
    Object.defineProperty(n, "blockElements", {
        enumerable: !0,
        get: function() {
            return e.blockElements;
        }
    });
})($cdae29d26d2e7999$var$At);
var $cdae29d26d2e7999$var$fn = {}, $cdae29d26d2e7999$var$Pt = {};
Object.defineProperty($cdae29d26d2e7999$var$Pt, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$Pt.calculateBaseline = $cdae29d26d2e7999$var$_s;
function $cdae29d26d2e7999$var$_s(n) {
    var e = window.getComputedStyle(n), t1 = parseFloat(e.fontSize), o = parseFloat(e.lineHeight) || t1 * 1.2, i = parseFloat(e.paddingTop), s = parseFloat(e.borderTopWidth), r = parseFloat(e.marginTop), a = t1 * 0.8, l = (o - t1) / 2, c = r + s + i + l + a;
    return c;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.calculateBaseline = void 0;
    var e = $cdae29d26d2e7999$var$Pt;
    Object.defineProperty(n, "calculateBaseline", {
        enumerable: !0,
        get: function() {
            return e.calculateBaseline;
        }
    });
})($cdae29d26d2e7999$var$fn);
var $cdae29d26d2e7999$var$gn = {}, $cdae29d26d2e7999$var$Nt = {}, $cdae29d26d2e7999$var$Rt = {}, $cdae29d26d2e7999$var$Dt = {};
Object.defineProperty($cdae29d26d2e7999$var$Dt, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$Dt.isContentEditable = $cdae29d26d2e7999$var$Ms;
function $cdae29d26d2e7999$var$Ms(n) {
    return n.contentEditable === "true";
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isContentEditable = void 0;
    var e = $cdae29d26d2e7999$var$Dt;
    Object.defineProperty(n, "isContentEditable", {
        enumerable: !0,
        get: function() {
            return e.isContentEditable;
        }
    });
})($cdae29d26d2e7999$var$Rt);
Object.defineProperty($cdae29d26d2e7999$var$Nt, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$Nt.canSetCaret = $cdae29d26d2e7999$var$Ps;
var $cdae29d26d2e7999$var$As = $cdae29d26d2e7999$var$ue, $cdae29d26d2e7999$var$Ls = $cdae29d26d2e7999$var$Rt;
function $cdae29d26d2e7999$var$Ps(n) {
    var e = !0;
    if ((0, $cdae29d26d2e7999$var$As.isNativeInput)(n)) switch(n.type){
        case "file":
        case "checkbox":
        case "radio":
        case "hidden":
        case "submit":
        case "button":
        case "image":
        case "reset":
            e = !1;
            break;
    }
    else e = (0, $cdae29d26d2e7999$var$Ls.isContentEditable)(n);
    return e;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.canSetCaret = void 0;
    var e = $cdae29d26d2e7999$var$Nt;
    Object.defineProperty(n, "canSetCaret", {
        enumerable: !0,
        get: function() {
            return e.canSetCaret;
        }
    });
})($cdae29d26d2e7999$var$gn);
var $cdae29d26d2e7999$var$Ve = {}, $cdae29d26d2e7999$var$Ft = {};
function $cdae29d26d2e7999$var$Ns(n, e, t1) {
    const o = t1.value !== void 0 ? "value" : "get", i = t1[o], s = `#${e}Cache`;
    if (t1[o] = function(...r) {
        return this[s] === void 0 && (this[s] = i.apply(this, r)), this[s];
    }, o === "get" && t1.set) {
        const r = t1.set;
        t1.set = function(a) {
            delete n[s], r.apply(this, a);
        };
    }
    return t1;
}
function $cdae29d26d2e7999$var$mn() {
    const n = {
        win: !1,
        mac: !1,
        x11: !1,
        linux: !1
    }, e = Object.keys(n).find((t1)=>window.navigator.appVersion.toLowerCase().indexOf(t1) !== -1);
    return e !== void 0 && (n[e] = !0), n;
}
function $cdae29d26d2e7999$var$jt(n) {
    return n != null && n !== "" && (typeof n != "object" || Object.keys(n).length > 0);
}
function $cdae29d26d2e7999$var$Rs(n) {
    return !$cdae29d26d2e7999$var$jt(n);
}
const $cdae29d26d2e7999$var$Ds = ()=>typeof window < "u" && window.navigator !== null && $cdae29d26d2e7999$var$jt(window.navigator.platform) && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);
function $cdae29d26d2e7999$var$Fs(n) {
    const e = $cdae29d26d2e7999$var$mn();
    return n = n.replace(/shift/gi, "\u21E7").replace(/backspace/gi, "\u232B").replace(/enter/gi, "\u23CE").replace(/up/gi, "\u2191").replace(/left/gi, "\u2192").replace(/down/gi, "\u2193").replace(/right/gi, "\u2190").replace(/escape/gi, "\u238B").replace(/insert/gi, "Ins").replace(/delete/gi, "\u2421").replace(/\+/gi, "+"), e.mac ? n = n.replace(/ctrl|cmd/gi, "\u2318").replace(/alt/gi, "\u2325") : n = n.replace(/cmd/gi, "Ctrl").replace(/windows/gi, "WIN"), n;
}
function $cdae29d26d2e7999$var$js(n) {
    return n[0].toUpperCase() + n.slice(1);
}
function $cdae29d26d2e7999$var$Hs(n) {
    const e = document.createElement("div");
    e.style.position = "absolute", e.style.left = "-999px", e.style.bottom = "-999px", e.innerHTML = n, document.body.appendChild(e);
    const t1 = window.getSelection(), o = document.createRange();
    if (o.selectNode(e), t1 === null) throw new Error("Cannot copy text to clipboard");
    t1.removeAllRanges(), t1.addRange(o), document.execCommand("copy"), document.body.removeChild(e);
}
function $cdae29d26d2e7999$var$$s(n, e, t1) {
    let o;
    return (...i)=>{
        const s = this, r = ()=>{
            o = void 0, t1 !== !0 && n.apply(s, i);
        }, a = t1 === !0 && o !== void 0;
        window.clearTimeout(o), o = window.setTimeout(r, e), a && n.apply(s, i);
    };
}
function $cdae29d26d2e7999$var$oe(n) {
    return Object.prototype.toString.call(n).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
}
function $cdae29d26d2e7999$var$zs(n) {
    return $cdae29d26d2e7999$var$oe(n) === "boolean";
}
function $cdae29d26d2e7999$var$bn(n) {
    return $cdae29d26d2e7999$var$oe(n) === "function" || $cdae29d26d2e7999$var$oe(n) === "asyncfunction";
}
function $cdae29d26d2e7999$var$Us(n) {
    return $cdae29d26d2e7999$var$bn(n) && /^\s*class\s+/.test(n.toString());
}
function $cdae29d26d2e7999$var$Ws(n) {
    return $cdae29d26d2e7999$var$oe(n) === "number";
}
function $cdae29d26d2e7999$var$De(n) {
    return $cdae29d26d2e7999$var$oe(n) === "object";
}
function $cdae29d26d2e7999$var$Ys(n) {
    return Promise.resolve(n) === n;
}
function $cdae29d26d2e7999$var$Ks(n) {
    return $cdae29d26d2e7999$var$oe(n) === "string";
}
function $cdae29d26d2e7999$var$Xs(n) {
    return $cdae29d26d2e7999$var$oe(n) === "undefined";
}
function $cdae29d26d2e7999$var$bt(n, ...e) {
    if (!e.length) return n;
    const t1 = e.shift();
    if ($cdae29d26d2e7999$var$De(n) && $cdae29d26d2e7999$var$De(t1)) for(const o in t1)$cdae29d26d2e7999$var$De(t1[o]) ? (n[o] === void 0 && Object.assign(n, {
        [o]: {}
    }), $cdae29d26d2e7999$var$bt(n[o], t1[o])) : Object.assign(n, {
        [o]: t1[o]
    });
    return $cdae29d26d2e7999$var$bt(n, ...e);
}
function $cdae29d26d2e7999$var$Vs(n, e, t1) {
    const o = `\xab${e}\xbb is deprecated and will be removed in the next major release. Please use the \xab${t1}\xbb instead.`;
    n && console.warn(o);
}
function $cdae29d26d2e7999$var$qs(n) {
    try {
        return new URL(n).href;
    } catch  {}
    return n.substring(0, 2) === "//" ? window.location.protocol + n : window.location.origin + n;
}
function $cdae29d26d2e7999$var$Zs(n) {
    return n > 47 && n < 58 || n === 32 || n === 13 || n === 229 || n > 64 && n < 91 || n > 95 && n < 112 || n > 185 && n < 193 || n > 218 && n < 223;
}
const $cdae29d26d2e7999$var$Gs = {
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    DOWN: 40,
    RIGHT: 39,
    DELETE: 46,
    META: 91,
    SLASH: 191
}, $cdae29d26d2e7999$var$Qs = {
    LEFT: 0,
    WHEEL: 1,
    RIGHT: 2,
    BACKWARD: 3,
    FORWARD: 4
};
let $cdae29d26d2e7999$var$Js = class {
    constructor(){
        this.completed = Promise.resolve();
    }
    /**
   * Add new promise to queue
   * @param operation - promise should be added to queue
   */ add(e) {
        return new Promise((t1, o)=>{
            this.completed = this.completed.then(e).then(t1).catch(o);
        });
    }
};
function $cdae29d26d2e7999$var$er(n, e, t1) {
    let o, i, s, r = null, a = 0;
    t1 || (t1 = {});
    const l = function() {
        a = t1.leading === !1 ? 0 : Date.now(), r = null, s = n.apply(o, i), r === null && (o = i = null);
    };
    return function() {
        const c = Date.now();
        !a && t1.leading === !1 && (a = c);
        const d = e - (c - a);
        return o = this, i = arguments, d <= 0 || d > e ? (r && (clearTimeout(r), r = null), a = c, s = n.apply(o, i), r === null && (o = i = null)) : !r && t1.trailing !== !1 && (r = setTimeout(l, d)), s;
    };
}
const $cdae29d26d2e7999$var$tr = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    PromiseQueue: $cdae29d26d2e7999$var$Js,
    beautifyShortcut: $cdae29d26d2e7999$var$Fs,
    cacheable: $cdae29d26d2e7999$var$Ns,
    capitalize: $cdae29d26d2e7999$var$js,
    copyTextToClipboard: $cdae29d26d2e7999$var$Hs,
    debounce: $cdae29d26d2e7999$var$$s,
    deepMerge: $cdae29d26d2e7999$var$bt,
    deprecationAssert: $cdae29d26d2e7999$var$Vs,
    getUserOS: $cdae29d26d2e7999$var$mn,
    getValidUrl: $cdae29d26d2e7999$var$qs,
    isBoolean: $cdae29d26d2e7999$var$zs,
    isClass: $cdae29d26d2e7999$var$Us,
    isEmpty: $cdae29d26d2e7999$var$Rs,
    isFunction: $cdae29d26d2e7999$var$bn,
    isIosDevice: $cdae29d26d2e7999$var$Ds,
    isNumber: $cdae29d26d2e7999$var$Ws,
    isObject: $cdae29d26d2e7999$var$De,
    isPrintableKey: $cdae29d26d2e7999$var$Zs,
    isPromise: $cdae29d26d2e7999$var$Ys,
    isString: $cdae29d26d2e7999$var$Ks,
    isUndefined: $cdae29d26d2e7999$var$Xs,
    keyCodes: $cdae29d26d2e7999$var$Gs,
    mouseButtons: $cdae29d26d2e7999$var$Qs,
    notEmpty: $cdae29d26d2e7999$var$jt,
    throttle: $cdae29d26d2e7999$var$er,
    typeOf: $cdae29d26d2e7999$var$oe
}, Symbol.toStringTag, {
    value: "Module"
})), $cdae29d26d2e7999$var$Ht = /* @__PURE__ */ $cdae29d26d2e7999$var$Xn($cdae29d26d2e7999$var$tr);
Object.defineProperty($cdae29d26d2e7999$var$Ft, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$Ft.containsOnlyInlineElements = $cdae29d26d2e7999$var$ir;
var $cdae29d26d2e7999$var$or = $cdae29d26d2e7999$var$Ht, $cdae29d26d2e7999$var$nr = $cdae29d26d2e7999$var$At;
function $cdae29d26d2e7999$var$ir(n) {
    var e;
    (0, $cdae29d26d2e7999$var$or.isString)(n) ? (e = document.createElement("div"), e.innerHTML = n) : e = n;
    var t1 = function(o) {
        return !(0, $cdae29d26d2e7999$var$nr.blockElements)().includes(o.tagName.toLowerCase()) && Array.from(o.children).every(t1);
    };
    return Array.from(e.children).every(t1);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.containsOnlyInlineElements = void 0;
    var e = $cdae29d26d2e7999$var$Ft;
    Object.defineProperty(n, "containsOnlyInlineElements", {
        enumerable: !0,
        get: function() {
            return e.containsOnlyInlineElements;
        }
    });
})($cdae29d26d2e7999$var$Ve);
var $cdae29d26d2e7999$var$vn = {}, $cdae29d26d2e7999$var$$t = {}, $cdae29d26d2e7999$var$qe = {}, $cdae29d26d2e7999$var$zt = {};
Object.defineProperty($cdae29d26d2e7999$var$zt, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$zt.make = $cdae29d26d2e7999$var$sr;
function $cdae29d26d2e7999$var$sr(n, e, t1) {
    var o;
    e === void 0 && (e = null), t1 === void 0 && (t1 = {});
    var i = document.createElement(n);
    if (Array.isArray(e)) {
        var s = e.filter(function(a) {
            return a !== void 0;
        });
        (o = i.classList).add.apply(o, s);
    } else e !== null && i.classList.add(e);
    for(var r in t1)Object.prototype.hasOwnProperty.call(t1, r) && (i[r] = t1[r]);
    return i;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.make = void 0;
    var e = $cdae29d26d2e7999$var$zt;
    Object.defineProperty(n, "make", {
        enumerable: !0,
        get: function() {
            return e.make;
        }
    });
})($cdae29d26d2e7999$var$qe);
Object.defineProperty($cdae29d26d2e7999$var$$t, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$$t.fragmentToString = $cdae29d26d2e7999$var$ar;
var $cdae29d26d2e7999$var$rr = $cdae29d26d2e7999$var$qe;
function $cdae29d26d2e7999$var$ar(n) {
    var e = (0, $cdae29d26d2e7999$var$rr.make)("div");
    return e.appendChild(n), e.innerHTML;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.fragmentToString = void 0;
    var e = $cdae29d26d2e7999$var$$t;
    Object.defineProperty(n, "fragmentToString", {
        enumerable: !0,
        get: function() {
            return e.fragmentToString;
        }
    });
})($cdae29d26d2e7999$var$vn);
var $cdae29d26d2e7999$var$kn = {}, $cdae29d26d2e7999$var$Ut = {};
Object.defineProperty($cdae29d26d2e7999$var$Ut, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$Ut.getContentLength = $cdae29d26d2e7999$var$cr;
var $cdae29d26d2e7999$var$lr = $cdae29d26d2e7999$var$ue;
function $cdae29d26d2e7999$var$cr(n) {
    var e, t1;
    return (0, $cdae29d26d2e7999$var$lr.isNativeInput)(n) ? n.value.length : n.nodeType === Node.TEXT_NODE ? n.length : (t1 = (e = n.textContent) === null || e === void 0 ? void 0 : e.length) !== null && t1 !== void 0 ? t1 : 0;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getContentLength = void 0;
    var e = $cdae29d26d2e7999$var$Ut;
    Object.defineProperty(n, "getContentLength", {
        enumerable: !0,
        get: function() {
            return e.getContentLength;
        }
    });
})($cdae29d26d2e7999$var$kn);
var $cdae29d26d2e7999$var$Wt = {}, $cdae29d26d2e7999$var$Yt = {}, $cdae29d26d2e7999$var$Io = $cdae29d26d2e7999$var$Ce && $cdae29d26d2e7999$var$Ce.__spreadArray || function(n, e, t1) {
    if (t1 || arguments.length === 2) for(var o = 0, i = e.length, s; o < i; o++)(s || !(o in e)) && (s || (s = Array.prototype.slice.call(e, 0, o)), s[o] = e[o]);
    return n.concat(s || Array.prototype.slice.call(e));
};
Object.defineProperty($cdae29d26d2e7999$var$Yt, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$Yt.getDeepestBlockElements = $cdae29d26d2e7999$var$yn;
var $cdae29d26d2e7999$var$dr = $cdae29d26d2e7999$var$Ve;
function $cdae29d26d2e7999$var$yn(n) {
    return (0, $cdae29d26d2e7999$var$dr.containsOnlyInlineElements)(n) ? [
        n
    ] : Array.from(n.children).reduce(function(e, t1) {
        return $cdae29d26d2e7999$var$Io($cdae29d26d2e7999$var$Io([], e, !0), $cdae29d26d2e7999$var$yn(t1), !0);
    }, []);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getDeepestBlockElements = void 0;
    var e = $cdae29d26d2e7999$var$Yt;
    Object.defineProperty(n, "getDeepestBlockElements", {
        enumerable: !0,
        get: function() {
            return e.getDeepestBlockElements;
        }
    });
})($cdae29d26d2e7999$var$Wt);
var $cdae29d26d2e7999$var$wn = {}, $cdae29d26d2e7999$var$Kt = {}, $cdae29d26d2e7999$var$Ze = {}, $cdae29d26d2e7999$var$Xt = {};
Object.defineProperty($cdae29d26d2e7999$var$Xt, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$Xt.isLineBreakTag = $cdae29d26d2e7999$var$ur;
function $cdae29d26d2e7999$var$ur(n) {
    return [
        "BR",
        "WBR"
    ].includes(n.tagName);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isLineBreakTag = void 0;
    var e = $cdae29d26d2e7999$var$Xt;
    Object.defineProperty(n, "isLineBreakTag", {
        enumerable: !0,
        get: function() {
            return e.isLineBreakTag;
        }
    });
})($cdae29d26d2e7999$var$Ze);
var $cdae29d26d2e7999$var$Ge = {}, $cdae29d26d2e7999$var$Vt = {};
Object.defineProperty($cdae29d26d2e7999$var$Vt, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$Vt.isSingleTag = $cdae29d26d2e7999$var$hr;
function $cdae29d26d2e7999$var$hr(n) {
    return [
        "AREA",
        "BASE",
        "BR",
        "COL",
        "COMMAND",
        "EMBED",
        "HR",
        "IMG",
        "INPUT",
        "KEYGEN",
        "LINK",
        "META",
        "PARAM",
        "SOURCE",
        "TRACK",
        "WBR"
    ].includes(n.tagName);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isSingleTag = void 0;
    var e = $cdae29d26d2e7999$var$Vt;
    Object.defineProperty(n, "isSingleTag", {
        enumerable: !0,
        get: function() {
            return e.isSingleTag;
        }
    });
})($cdae29d26d2e7999$var$Ge);
Object.defineProperty($cdae29d26d2e7999$var$Kt, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$Kt.getDeepestNode = $cdae29d26d2e7999$var$En;
var $cdae29d26d2e7999$var$pr = $cdae29d26d2e7999$var$ue, $cdae29d26d2e7999$var$fr = $cdae29d26d2e7999$var$Ze, $cdae29d26d2e7999$var$gr = $cdae29d26d2e7999$var$Ge;
function $cdae29d26d2e7999$var$En(n, e) {
    e === void 0 && (e = !1);
    var t1 = e ? "lastChild" : "firstChild", o = e ? "previousSibling" : "nextSibling";
    if (n.nodeType === Node.ELEMENT_NODE && n[t1]) {
        var i = n[t1];
        if ((0, $cdae29d26d2e7999$var$gr.isSingleTag)(i) && !(0, $cdae29d26d2e7999$var$pr.isNativeInput)(i) && !(0, $cdae29d26d2e7999$var$fr.isLineBreakTag)(i)) {
            if (i[o]) i = i[o];
            else if (i.parentNode !== null && i.parentNode[o]) i = i.parentNode[o];
            else return i.parentNode;
        }
        return $cdae29d26d2e7999$var$En(i, e);
    }
    return n;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getDeepestNode = void 0;
    var e = $cdae29d26d2e7999$var$Kt;
    Object.defineProperty(n, "getDeepestNode", {
        enumerable: !0,
        get: function() {
            return e.getDeepestNode;
        }
    });
})($cdae29d26d2e7999$var$wn);
var $cdae29d26d2e7999$var$xn = {}, $cdae29d26d2e7999$var$qt = {}, $cdae29d26d2e7999$var$Me = $cdae29d26d2e7999$var$Ce && $cdae29d26d2e7999$var$Ce.__spreadArray || function(n, e, t1) {
    if (t1 || arguments.length === 2) for(var o = 0, i = e.length, s; o < i; o++)(s || !(o in e)) && (s || (s = Array.prototype.slice.call(e, 0, o)), s[o] = e[o]);
    return n.concat(s || Array.prototype.slice.call(e));
};
Object.defineProperty($cdae29d26d2e7999$var$qt, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$qt.findAllInputs = $cdae29d26d2e7999$var$yr;
var $cdae29d26d2e7999$var$mr = $cdae29d26d2e7999$var$Ve, $cdae29d26d2e7999$var$br = $cdae29d26d2e7999$var$Wt, $cdae29d26d2e7999$var$vr = $cdae29d26d2e7999$var$It, $cdae29d26d2e7999$var$kr = $cdae29d26d2e7999$var$ue;
function $cdae29d26d2e7999$var$yr(n) {
    return Array.from(n.querySelectorAll((0, $cdae29d26d2e7999$var$vr.allInputsSelector)())).reduce(function(e, t1) {
        return (0, $cdae29d26d2e7999$var$kr.isNativeInput)(t1) || (0, $cdae29d26d2e7999$var$mr.containsOnlyInlineElements)(t1) ? $cdae29d26d2e7999$var$Me($cdae29d26d2e7999$var$Me([], e, !0), [
            t1
        ], !1) : $cdae29d26d2e7999$var$Me($cdae29d26d2e7999$var$Me([], e, !0), (0, $cdae29d26d2e7999$var$br.getDeepestBlockElements)(t1), !0);
    }, []);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.findAllInputs = void 0;
    var e = $cdae29d26d2e7999$var$qt;
    Object.defineProperty(n, "findAllInputs", {
        enumerable: !0,
        get: function() {
            return e.findAllInputs;
        }
    });
})($cdae29d26d2e7999$var$xn);
var $cdae29d26d2e7999$var$Bn = {}, $cdae29d26d2e7999$var$Zt = {};
Object.defineProperty($cdae29d26d2e7999$var$Zt, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$Zt.isCollapsedWhitespaces = $cdae29d26d2e7999$var$wr;
function $cdae29d26d2e7999$var$wr(n) {
    return !/[^\t\n\r ]/.test(n);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isCollapsedWhitespaces = void 0;
    var e = $cdae29d26d2e7999$var$Zt;
    Object.defineProperty(n, "isCollapsedWhitespaces", {
        enumerable: !0,
        get: function() {
            return e.isCollapsedWhitespaces;
        }
    });
})($cdae29d26d2e7999$var$Bn);
var $cdae29d26d2e7999$var$Gt = {}, $cdae29d26d2e7999$var$Qt = {};
Object.defineProperty($cdae29d26d2e7999$var$Qt, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$Qt.isElement = $cdae29d26d2e7999$var$xr;
var $cdae29d26d2e7999$var$Er = $cdae29d26d2e7999$var$Ht;
function $cdae29d26d2e7999$var$xr(n) {
    return (0, $cdae29d26d2e7999$var$Er.isNumber)(n) ? !1 : !!n && !!n.nodeType && n.nodeType === Node.ELEMENT_NODE;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isElement = void 0;
    var e = $cdae29d26d2e7999$var$Qt;
    Object.defineProperty(n, "isElement", {
        enumerable: !0,
        get: function() {
            return e.isElement;
        }
    });
})($cdae29d26d2e7999$var$Gt);
var $cdae29d26d2e7999$var$Cn = {}, $cdae29d26d2e7999$var$Jt = {}, $cdae29d26d2e7999$var$eo = {}, $cdae29d26d2e7999$var$to = {};
Object.defineProperty($cdae29d26d2e7999$var$to, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$to.isLeaf = $cdae29d26d2e7999$var$Br;
function $cdae29d26d2e7999$var$Br(n) {
    return n === null ? !1 : n.childNodes.length === 0;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isLeaf = void 0;
    var e = $cdae29d26d2e7999$var$to;
    Object.defineProperty(n, "isLeaf", {
        enumerable: !0,
        get: function() {
            return e.isLeaf;
        }
    });
})($cdae29d26d2e7999$var$eo);
var $cdae29d26d2e7999$var$oo = {}, $cdae29d26d2e7999$var$no = {};
Object.defineProperty($cdae29d26d2e7999$var$no, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$no.isNodeEmpty = $cdae29d26d2e7999$var$Or;
var $cdae29d26d2e7999$var$Cr = $cdae29d26d2e7999$var$Ze, $cdae29d26d2e7999$var$Tr = $cdae29d26d2e7999$var$Gt, $cdae29d26d2e7999$var$Sr = $cdae29d26d2e7999$var$ue, $cdae29d26d2e7999$var$Ir = $cdae29d26d2e7999$var$Ge;
function $cdae29d26d2e7999$var$Or(n, e) {
    var t1 = "";
    return (0, $cdae29d26d2e7999$var$Ir.isSingleTag)(n) && !(0, $cdae29d26d2e7999$var$Cr.isLineBreakTag)(n) ? !1 : ((0, $cdae29d26d2e7999$var$Tr.isElement)(n) && (0, $cdae29d26d2e7999$var$Sr.isNativeInput)(n) ? t1 = n.value : n.textContent !== null && (t1 = n.textContent.replace("\u200B", "")), e !== void 0 && (t1 = t1.replace(new RegExp(e, "g"), "")), t1.trim().length === 0);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isNodeEmpty = void 0;
    var e = $cdae29d26d2e7999$var$no;
    Object.defineProperty(n, "isNodeEmpty", {
        enumerable: !0,
        get: function() {
            return e.isNodeEmpty;
        }
    });
})($cdae29d26d2e7999$var$oo);
Object.defineProperty($cdae29d26d2e7999$var$Jt, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$Jt.isEmpty = $cdae29d26d2e7999$var$Ar;
var $cdae29d26d2e7999$var$_r = $cdae29d26d2e7999$var$eo, $cdae29d26d2e7999$var$Mr = $cdae29d26d2e7999$var$oo;
function $cdae29d26d2e7999$var$Ar(n, e) {
    n.normalize();
    for(var t1 = [
        n
    ]; t1.length > 0;){
        var o = t1.shift();
        if (o) {
            if (n = o, (0, $cdae29d26d2e7999$var$_r.isLeaf)(n) && !(0, $cdae29d26d2e7999$var$Mr.isNodeEmpty)(n, e)) return !1;
            t1.push.apply(t1, Array.from(n.childNodes));
        }
    }
    return !0;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isEmpty = void 0;
    var e = $cdae29d26d2e7999$var$Jt;
    Object.defineProperty(n, "isEmpty", {
        enumerable: !0,
        get: function() {
            return e.isEmpty;
        }
    });
})($cdae29d26d2e7999$var$Cn);
var $cdae29d26d2e7999$var$Tn = {}, $cdae29d26d2e7999$var$io = {};
Object.defineProperty($cdae29d26d2e7999$var$io, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$io.isFragment = $cdae29d26d2e7999$var$Pr;
var $cdae29d26d2e7999$var$Lr = $cdae29d26d2e7999$var$Ht;
function $cdae29d26d2e7999$var$Pr(n) {
    return (0, $cdae29d26d2e7999$var$Lr.isNumber)(n) ? !1 : !!n && !!n.nodeType && n.nodeType === Node.DOCUMENT_FRAGMENT_NODE;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isFragment = void 0;
    var e = $cdae29d26d2e7999$var$io;
    Object.defineProperty(n, "isFragment", {
        enumerable: !0,
        get: function() {
            return e.isFragment;
        }
    });
})($cdae29d26d2e7999$var$Tn);
var $cdae29d26d2e7999$var$Sn = {}, $cdae29d26d2e7999$var$so = {};
Object.defineProperty($cdae29d26d2e7999$var$so, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$so.isHTMLString = $cdae29d26d2e7999$var$Rr;
var $cdae29d26d2e7999$var$Nr = $cdae29d26d2e7999$var$qe;
function $cdae29d26d2e7999$var$Rr(n) {
    var e = (0, $cdae29d26d2e7999$var$Nr.make)("div");
    return e.innerHTML = n, e.childElementCount > 0;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isHTMLString = void 0;
    var e = $cdae29d26d2e7999$var$so;
    Object.defineProperty(n, "isHTMLString", {
        enumerable: !0,
        get: function() {
            return e.isHTMLString;
        }
    });
})($cdae29d26d2e7999$var$Sn);
var $cdae29d26d2e7999$var$In = {}, $cdae29d26d2e7999$var$ro = {};
Object.defineProperty($cdae29d26d2e7999$var$ro, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$ro.offset = $cdae29d26d2e7999$var$Dr;
function $cdae29d26d2e7999$var$Dr(n) {
    var e = n.getBoundingClientRect(), t1 = window.pageXOffset || document.documentElement.scrollLeft, o = window.pageYOffset || document.documentElement.scrollTop, i = e.top + o, s = e.left + t1;
    return {
        top: i,
        left: s,
        bottom: i + e.height,
        right: s + e.width
    };
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.offset = void 0;
    var e = $cdae29d26d2e7999$var$ro;
    Object.defineProperty(n, "offset", {
        enumerable: !0,
        get: function() {
            return e.offset;
        }
    });
})($cdae29d26d2e7999$var$In);
var $cdae29d26d2e7999$var$On = {}, $cdae29d26d2e7999$var$ao = {};
Object.defineProperty($cdae29d26d2e7999$var$ao, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$ao.prepend = $cdae29d26d2e7999$var$Fr;
function $cdae29d26d2e7999$var$Fr(n, e) {
    Array.isArray(e) ? (e = e.reverse(), e.forEach(function(t1) {
        return n.prepend(t1);
    })) : n.prepend(e);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.prepend = void 0;
    var e = $cdae29d26d2e7999$var$ao;
    Object.defineProperty(n, "prepend", {
        enumerable: !0,
        get: function() {
            return e.prepend;
        }
    });
})($cdae29d26d2e7999$var$On);
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.prepend = n.offset = n.make = n.isLineBreakTag = n.isSingleTag = n.isNodeEmpty = n.isLeaf = n.isHTMLString = n.isFragment = n.isEmpty = n.isElement = n.isContentEditable = n.isCollapsedWhitespaces = n.findAllInputs = n.isNativeInput = n.allInputsSelector = n.getDeepestNode = n.getDeepestBlockElements = n.getContentLength = n.fragmentToString = n.containsOnlyInlineElements = n.canSetCaret = n.calculateBaseline = n.blockElements = n.append = void 0;
    var e = $cdae29d26d2e7999$var$It;
    Object.defineProperty(n, "allInputsSelector", {
        enumerable: !0,
        get: function() {
            return e.allInputsSelector;
        }
    });
    var t1 = $cdae29d26d2e7999$var$ue;
    Object.defineProperty(n, "isNativeInput", {
        enumerable: !0,
        get: function() {
            return t1.isNativeInput;
        }
    });
    var o = $cdae29d26d2e7999$var$pn;
    Object.defineProperty(n, "append", {
        enumerable: !0,
        get: function() {
            return o.append;
        }
    });
    var i = $cdae29d26d2e7999$var$At;
    Object.defineProperty(n, "blockElements", {
        enumerable: !0,
        get: function() {
            return i.blockElements;
        }
    });
    var s = $cdae29d26d2e7999$var$fn;
    Object.defineProperty(n, "calculateBaseline", {
        enumerable: !0,
        get: function() {
            return s.calculateBaseline;
        }
    });
    var r = $cdae29d26d2e7999$var$gn;
    Object.defineProperty(n, "canSetCaret", {
        enumerable: !0,
        get: function() {
            return r.canSetCaret;
        }
    });
    var a = $cdae29d26d2e7999$var$Ve;
    Object.defineProperty(n, "containsOnlyInlineElements", {
        enumerable: !0,
        get: function() {
            return a.containsOnlyInlineElements;
        }
    });
    var l = $cdae29d26d2e7999$var$vn;
    Object.defineProperty(n, "fragmentToString", {
        enumerable: !0,
        get: function() {
            return l.fragmentToString;
        }
    });
    var c = $cdae29d26d2e7999$var$kn;
    Object.defineProperty(n, "getContentLength", {
        enumerable: !0,
        get: function() {
            return c.getContentLength;
        }
    });
    var d = $cdae29d26d2e7999$var$Wt;
    Object.defineProperty(n, "getDeepestBlockElements", {
        enumerable: !0,
        get: function() {
            return d.getDeepestBlockElements;
        }
    });
    var h = $cdae29d26d2e7999$var$wn;
    Object.defineProperty(n, "getDeepestNode", {
        enumerable: !0,
        get: function() {
            return h.getDeepestNode;
        }
    });
    var p = $cdae29d26d2e7999$var$xn;
    Object.defineProperty(n, "findAllInputs", {
        enumerable: !0,
        get: function() {
            return p.findAllInputs;
        }
    });
    var g = $cdae29d26d2e7999$var$Bn;
    Object.defineProperty(n, "isCollapsedWhitespaces", {
        enumerable: !0,
        get: function() {
            return g.isCollapsedWhitespaces;
        }
    });
    var f = $cdae29d26d2e7999$var$Rt;
    Object.defineProperty(n, "isContentEditable", {
        enumerable: !0,
        get: function() {
            return f.isContentEditable;
        }
    });
    var v = $cdae29d26d2e7999$var$Gt;
    Object.defineProperty(n, "isElement", {
        enumerable: !0,
        get: function() {
            return v.isElement;
        }
    });
    var O = $cdae29d26d2e7999$var$Cn;
    Object.defineProperty(n, "isEmpty", {
        enumerable: !0,
        get: function() {
            return O.isEmpty;
        }
    });
    var T = $cdae29d26d2e7999$var$Tn;
    Object.defineProperty(n, "isFragment", {
        enumerable: !0,
        get: function() {
            return T.isFragment;
        }
    });
    var M = $cdae29d26d2e7999$var$Sn;
    Object.defineProperty(n, "isHTMLString", {
        enumerable: !0,
        get: function() {
            return M.isHTMLString;
        }
    });
    var q = $cdae29d26d2e7999$var$eo;
    Object.defineProperty(n, "isLeaf", {
        enumerable: !0,
        get: function() {
            return q.isLeaf;
        }
    });
    var F = $cdae29d26d2e7999$var$oo;
    Object.defineProperty(n, "isNodeEmpty", {
        enumerable: !0,
        get: function() {
            return F.isNodeEmpty;
        }
    });
    var H = $cdae29d26d2e7999$var$Ze;
    Object.defineProperty(n, "isLineBreakTag", {
        enumerable: !0,
        get: function() {
            return H.isLineBreakTag;
        }
    });
    var Q = $cdae29d26d2e7999$var$Ge;
    Object.defineProperty(n, "isSingleTag", {
        enumerable: !0,
        get: function() {
            return Q.isSingleTag;
        }
    });
    var ie = $cdae29d26d2e7999$var$qe;
    Object.defineProperty(n, "make", {
        enumerable: !0,
        get: function() {
            return ie.make;
        }
    });
    var k = $cdae29d26d2e7999$var$In;
    Object.defineProperty(n, "offset", {
        enumerable: !0,
        get: function() {
            return k.offset;
        }
    });
    var m = $cdae29d26d2e7999$var$On;
    Object.defineProperty(n, "prepend", {
        enumerable: !0,
        get: function() {
            return m.prepend;
        }
    });
})($cdae29d26d2e7999$var$de);
var $cdae29d26d2e7999$var$Qe = {};
Object.defineProperty($cdae29d26d2e7999$var$Qe, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$Qe.getContenteditableSlice = $cdae29d26d2e7999$var$Hr;
var $cdae29d26d2e7999$var$jr = $cdae29d26d2e7999$var$de;
function $cdae29d26d2e7999$var$Hr(n, e, t1, o, i) {
    var s;
    i === void 0 && (i = !1);
    var r = document.createRange();
    if (o === "left" ? (r.setStart(n, 0), r.setEnd(e, t1)) : (r.setStart(e, t1), r.setEnd(n, n.childNodes.length)), i === !0) {
        var a = r.extractContents();
        return (0, $cdae29d26d2e7999$var$jr.fragmentToString)(a);
    }
    var l = r.cloneContents(), c = document.createElement("div");
    c.appendChild(l);
    var d = (s = c.textContent) !== null && s !== void 0 ? s : "";
    return d;
}
Object.defineProperty($cdae29d26d2e7999$var$Xe, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$Xe.checkContenteditableSliceForEmptiness = $cdae29d26d2e7999$var$Ur;
var $cdae29d26d2e7999$var$$r = $cdae29d26d2e7999$var$de, $cdae29d26d2e7999$var$zr = $cdae29d26d2e7999$var$Qe;
function $cdae29d26d2e7999$var$Ur(n, e, t1, o) {
    var i = (0, $cdae29d26d2e7999$var$zr.getContenteditableSlice)(n, e, t1, o);
    return (0, $cdae29d26d2e7999$var$$r.isCollapsedWhitespaces)(i);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.checkContenteditableSliceForEmptiness = void 0;
    var e = $cdae29d26d2e7999$var$Xe;
    Object.defineProperty(n, "checkContenteditableSliceForEmptiness", {
        enumerable: !0,
        get: function() {
            return e.checkContenteditableSliceForEmptiness;
        }
    });
})($cdae29d26d2e7999$var$St);
var $cdae29d26d2e7999$var$_n = {};
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getContenteditableSlice = void 0;
    var e = $cdae29d26d2e7999$var$Qe;
    Object.defineProperty(n, "getContenteditableSlice", {
        enumerable: !0,
        get: function() {
            return e.getContenteditableSlice;
        }
    });
})($cdae29d26d2e7999$var$_n);
var $cdae29d26d2e7999$var$Mn = {}, $cdae29d26d2e7999$var$lo = {};
Object.defineProperty($cdae29d26d2e7999$var$lo, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$lo.focus = $cdae29d26d2e7999$var$Yr;
var $cdae29d26d2e7999$var$Wr = $cdae29d26d2e7999$var$de;
function $cdae29d26d2e7999$var$Yr(n, e) {
    var t1, o;
    if (e === void 0 && (e = !0), (0, $cdae29d26d2e7999$var$Wr.isNativeInput)(n)) {
        n.focus();
        var i = e ? 0 : n.value.length;
        n.setSelectionRange(i, i);
    } else {
        var s = document.createRange(), r = window.getSelection();
        if (!r) return;
        var a = function(p) {
            var g = document.createTextNode("");
            p.appendChild(g), s.setStart(g, 0), s.setEnd(g, 0);
        }, l = function(p) {
            return p != null;
        }, c = n.childNodes, d = e ? c[0] : c[c.length - 1];
        if (l(d)) {
            for(; l(d) && d.nodeType !== Node.TEXT_NODE;)d = e ? d.firstChild : d.lastChild;
            if (l(d) && d.nodeType === Node.TEXT_NODE) {
                var h = (o = (t1 = d.textContent) === null || t1 === void 0 ? void 0 : t1.length) !== null && o !== void 0 ? o : 0, i = e ? 0 : h;
                s.setStart(d, i), s.setEnd(d, i);
            } else a(n);
        } else a(n);
        r.removeAllRanges(), r.addRange(s);
    }
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.focus = void 0;
    var e = $cdae29d26d2e7999$var$lo;
    Object.defineProperty(n, "focus", {
        enumerable: !0,
        get: function() {
            return e.focus;
        }
    });
})($cdae29d26d2e7999$var$Mn);
var $cdae29d26d2e7999$var$co = {}, $cdae29d26d2e7999$var$Je = {};
Object.defineProperty($cdae29d26d2e7999$var$Je, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$Je.getCaretNodeAndOffset = $cdae29d26d2e7999$var$Kr;
function $cdae29d26d2e7999$var$Kr() {
    var n = window.getSelection();
    if (n === null) return [
        null,
        0
    ];
    var e = n.focusNode, t1 = n.focusOffset;
    return e === null ? [
        null,
        0
    ] : (e.nodeType !== Node.TEXT_NODE && e.childNodes.length > 0 && (e.childNodes[t1] !== void 0 ? (e = e.childNodes[t1], t1 = 0) : (e = e.childNodes[t1 - 1], e.textContent !== null && (t1 = e.textContent.length))), [
        e,
        t1
    ]);
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getCaretNodeAndOffset = void 0;
    var e = $cdae29d26d2e7999$var$Je;
    Object.defineProperty(n, "getCaretNodeAndOffset", {
        enumerable: !0,
        get: function() {
            return e.getCaretNodeAndOffset;
        }
    });
})($cdae29d26d2e7999$var$co);
var $cdae29d26d2e7999$var$An = {}, $cdae29d26d2e7999$var$et = {};
Object.defineProperty($cdae29d26d2e7999$var$et, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$et.getRange = $cdae29d26d2e7999$var$Xr;
function $cdae29d26d2e7999$var$Xr() {
    var n = window.getSelection();
    return n && n.rangeCount ? n.getRangeAt(0) : null;
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.getRange = void 0;
    var e = $cdae29d26d2e7999$var$et;
    Object.defineProperty(n, "getRange", {
        enumerable: !0,
        get: function() {
            return e.getRange;
        }
    });
})($cdae29d26d2e7999$var$An);
var $cdae29d26d2e7999$var$Ln = {}, $cdae29d26d2e7999$var$uo = {};
Object.defineProperty($cdae29d26d2e7999$var$uo, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$uo.isCaretAtEndOfInput = $cdae29d26d2e7999$var$Zr;
var $cdae29d26d2e7999$var$Oo = $cdae29d26d2e7999$var$de, $cdae29d26d2e7999$var$Vr = $cdae29d26d2e7999$var$co, $cdae29d26d2e7999$var$qr = $cdae29d26d2e7999$var$St;
function $cdae29d26d2e7999$var$Zr(n) {
    var e = (0, $cdae29d26d2e7999$var$Oo.getDeepestNode)(n, !0);
    if (e === null) return !0;
    if ((0, $cdae29d26d2e7999$var$Oo.isNativeInput)(e)) return e.selectionEnd === e.value.length;
    var t1 = (0, $cdae29d26d2e7999$var$Vr.getCaretNodeAndOffset)(), o = t1[0], i = t1[1];
    return o === null ? !1 : (0, $cdae29d26d2e7999$var$qr.checkContenteditableSliceForEmptiness)(n, o, i, "right");
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isCaretAtEndOfInput = void 0;
    var e = $cdae29d26d2e7999$var$uo;
    Object.defineProperty(n, "isCaretAtEndOfInput", {
        enumerable: !0,
        get: function() {
            return e.isCaretAtEndOfInput;
        }
    });
})($cdae29d26d2e7999$var$Ln);
var $cdae29d26d2e7999$var$Pn = {}, $cdae29d26d2e7999$var$ho = {};
Object.defineProperty($cdae29d26d2e7999$var$ho, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$ho.isCaretAtStartOfInput = $cdae29d26d2e7999$var$Jr;
var $cdae29d26d2e7999$var$Ae = $cdae29d26d2e7999$var$de, $cdae29d26d2e7999$var$Gr = $cdae29d26d2e7999$var$Je, $cdae29d26d2e7999$var$Qr = $cdae29d26d2e7999$var$Xe;
function $cdae29d26d2e7999$var$Jr(n) {
    var e = (0, $cdae29d26d2e7999$var$Ae.getDeepestNode)(n);
    if (e === null || (0, $cdae29d26d2e7999$var$Ae.isEmpty)(n)) return !0;
    if ((0, $cdae29d26d2e7999$var$Ae.isNativeInput)(e)) return e.selectionEnd === 0;
    if ((0, $cdae29d26d2e7999$var$Ae.isEmpty)(n)) return !0;
    var t1 = (0, $cdae29d26d2e7999$var$Gr.getCaretNodeAndOffset)(), o = t1[0], i = t1[1];
    return o === null ? !1 : (0, $cdae29d26d2e7999$var$Qr.checkContenteditableSliceForEmptiness)(n, o, i, "left");
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.isCaretAtStartOfInput = void 0;
    var e = $cdae29d26d2e7999$var$ho;
    Object.defineProperty(n, "isCaretAtStartOfInput", {
        enumerable: !0,
        get: function() {
            return e.isCaretAtStartOfInput;
        }
    });
})($cdae29d26d2e7999$var$Pn);
var $cdae29d26d2e7999$var$Nn = {}, $cdae29d26d2e7999$var$po = {};
Object.defineProperty($cdae29d26d2e7999$var$po, "__esModule", {
    value: !0
});
$cdae29d26d2e7999$var$po.save = $cdae29d26d2e7999$var$oa;
var $cdae29d26d2e7999$var$ea = $cdae29d26d2e7999$var$de, $cdae29d26d2e7999$var$ta = $cdae29d26d2e7999$var$et;
function $cdae29d26d2e7999$var$oa() {
    var n = (0, $cdae29d26d2e7999$var$ta.getRange)(), e = (0, $cdae29d26d2e7999$var$ea.make)("span");
    if (e.id = "cursor", e.hidden = !0, !!n) return n.insertNode(e), function() {
        var o = window.getSelection();
        o && (n.setStartAfter(e), n.setEndAfter(e), o.removeAllRanges(), o.addRange(n), setTimeout(function() {
            e.remove();
        }, 150));
    };
}
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.save = void 0;
    var e = $cdae29d26d2e7999$var$po;
    Object.defineProperty(n, "save", {
        enumerable: !0,
        get: function() {
            return e.save;
        }
    });
})($cdae29d26d2e7999$var$Nn);
(function(n) {
    Object.defineProperty(n, "__esModule", {
        value: !0
    }), n.save = n.isCaretAtStartOfInput = n.isCaretAtEndOfInput = n.getRange = n.getCaretNodeAndOffset = n.focus = n.getContenteditableSlice = n.checkContenteditableSliceForEmptiness = void 0;
    var e = $cdae29d26d2e7999$var$St;
    Object.defineProperty(n, "checkContenteditableSliceForEmptiness", {
        enumerable: !0,
        get: function() {
            return e.checkContenteditableSliceForEmptiness;
        }
    });
    var t1 = $cdae29d26d2e7999$var$_n;
    Object.defineProperty(n, "getContenteditableSlice", {
        enumerable: !0,
        get: function() {
            return t1.getContenteditableSlice;
        }
    });
    var o = $cdae29d26d2e7999$var$Mn;
    Object.defineProperty(n, "focus", {
        enumerable: !0,
        get: function() {
            return o.focus;
        }
    });
    var i = $cdae29d26d2e7999$var$co;
    Object.defineProperty(n, "getCaretNodeAndOffset", {
        enumerable: !0,
        get: function() {
            return i.getCaretNodeAndOffset;
        }
    });
    var s = $cdae29d26d2e7999$var$An;
    Object.defineProperty(n, "getRange", {
        enumerable: !0,
        get: function() {
            return s.getRange;
        }
    });
    var r = $cdae29d26d2e7999$var$Ln;
    Object.defineProperty(n, "isCaretAtEndOfInput", {
        enumerable: !0,
        get: function() {
            return r.isCaretAtEndOfInput;
        }
    });
    var a = $cdae29d26d2e7999$var$Pn;
    Object.defineProperty(n, "isCaretAtStartOfInput", {
        enumerable: !0,
        get: function() {
            return a.isCaretAtStartOfInput;
        }
    });
    var l = $cdae29d26d2e7999$var$Nn;
    Object.defineProperty(n, "save", {
        enumerable: !0,
        get: function() {
            return l.save;
        }
    });
})($cdae29d26d2e7999$var$hn);
class $cdae29d26d2e7999$var$na extends $cdae29d26d2e7999$var$E {
    /**
   * All keydowns on Block
   *
   * @param {KeyboardEvent} event - keydown
   */ keydown(e) {
        switch(this.beforeKeydownProcessing(e), e.keyCode){
            case $cdae29d26d2e7999$var$y.BACKSPACE:
                this.backspace(e);
                break;
            case $cdae29d26d2e7999$var$y.DELETE:
                this.delete(e);
                break;
            case $cdae29d26d2e7999$var$y.ENTER:
                this.enter(e);
                break;
            case $cdae29d26d2e7999$var$y.DOWN:
            case $cdae29d26d2e7999$var$y.RIGHT:
                this.arrowRightAndDown(e);
                break;
            case $cdae29d26d2e7999$var$y.UP:
            case $cdae29d26d2e7999$var$y.LEFT:
                this.arrowLeftAndUp(e);
                break;
            case $cdae29d26d2e7999$var$y.TAB:
                this.tabPressed(e);
                break;
        }
        e.key === "/" && !e.ctrlKey && !e.metaKey && this.slashPressed(e), e.code === "Slash" && (e.ctrlKey || e.metaKey) && (e.preventDefault(), this.commandSlashPressed());
    }
    /**
   * Fires on keydown before event processing
   *
   * @param {KeyboardEvent} event - keydown
   */ beforeKeydownProcessing(e) {
        this.needToolbarClosing(e) && $cdae29d26d2e7999$var$Po(e.keyCode) && (this.Editor.Toolbar.close(), e.ctrlKey || e.metaKey || e.altKey || e.shiftKey || this.Editor.BlockSelection.clearSelection(e));
    }
    /**
   * Key up on Block:
   * - shows Inline Toolbar if something selected
   * - shows conversion toolbar with 85% of block selection
   *
   * @param {KeyboardEvent} event - keyup event
   */ keyup(e) {
        e.shiftKey || this.Editor.UI.checkEmptiness();
    }
    /**
   * Add drop target styles
   *
   * @param {DragEvent} event - drag over event
   */ dragOver(e) {
        const t1 = this.Editor.BlockManager.getBlockByChildNode(e.target);
        t1.dropTarget = !0;
    }
    /**
   * Remove drop target style
   *
   * @param {DragEvent} event - drag leave event
   */ dragLeave(e) {
        const t1 = this.Editor.BlockManager.getBlockByChildNode(e.target);
        t1.dropTarget = !1;
    }
    /**
   * Copying selected blocks
   * Before putting to the clipboard we sanitize all blocks and then copy to the clipboard
   *
   * @param {ClipboardEvent} event - clipboard event
   */ handleCommandC(e) {
        const { BlockSelection: t1 } = this.Editor;
        t1.anyBlockSelected && t1.copySelectedBlocks(e);
    }
    /**
   * Copy and Delete selected Blocks
   *
   * @param {ClipboardEvent} event - clipboard event
   */ handleCommandX(e) {
        const { BlockSelection: t1, BlockManager: o, Caret: i } = this.Editor;
        t1.anyBlockSelected && t1.copySelectedBlocks(e).then(()=>{
            const s = o.removeSelectedBlocks(), r = o.insertDefaultBlockAtIndex(s, !0);
            i.setToBlock(r, i.positions.START), t1.clearSelection(e);
        });
    }
    /**
   * Tab pressed inside a Block.
   *
   * @param {KeyboardEvent} event - keydown
   */ tabPressed(e) {
        const { InlineToolbar: t1, Caret: o } = this.Editor;
        if (t1.opened) return;
        (e.shiftKey ? o.navigatePrevious(!0) : o.navigateNext(!0)) && e.preventDefault();
    }
    /**
   * '/' + 'command' keydown inside a Block
   */ commandSlashPressed() {
        this.Editor.BlockSelection.selectedBlocks.length > 1 || this.activateBlockSettings();
    }
    /**
   * '/' keydown inside a Block
   *
   * @param event - keydown
   */ slashPressed(e) {
        !this.Editor.UI.nodes.wrapper.contains(e.target) || !this.Editor.BlockManager.currentBlock.isEmpty || (e.preventDefault(), this.Editor.Caret.insertContentAtCaretPosition("/"), this.activateToolbox());
    }
    /**
   * ENTER pressed on block
   *
   * @param {KeyboardEvent} event - keydown
   */ enter(e) {
        const { BlockManager: t1, UI: o } = this.Editor, i = t1.currentBlock;
        if (i === void 0 || i.tool.isLineBreaksEnabled || o.someToolbarOpened && o.someFlipperButtonFocused || e.shiftKey && !$cdae29d26d2e7999$var$pt) return;
        let s = i;
        i.currentInput !== void 0 && $cdae29d26d2e7999$var$Ne(i.currentInput) && !i.hasMedia ? this.Editor.BlockManager.insertDefaultBlockAtIndex(this.Editor.BlockManager.currentBlockIndex) : i.currentInput && $cdae29d26d2e7999$var$Re(i.currentInput) ? s = this.Editor.BlockManager.insertDefaultBlockAtIndex(this.Editor.BlockManager.currentBlockIndex + 1) : s = this.Editor.BlockManager.split(), this.Editor.Caret.setToBlock(s), this.Editor.Toolbar.moveAndOpen(s), e.preventDefault();
    }
    /**
   * Handle backspace keydown on Block
   *
   * @param {KeyboardEvent} event - keydown
   */ backspace(e) {
        const { BlockManager: t1, Caret: o } = this.Editor, { currentBlock: i, previousBlock: s } = t1;
        if (i === void 0 || !$cdae29d26d2e7999$var$b.isCollapsed || !i.currentInput || !$cdae29d26d2e7999$var$Ne(i.currentInput)) return;
        if (e.preventDefault(), this.Editor.Toolbar.close(), !(i.currentInput === i.firstInput)) {
            o.navigatePrevious();
            return;
        }
        if (s === null) return;
        if (s.isEmpty) {
            t1.removeBlock(s);
            return;
        }
        if (i.isEmpty) {
            t1.removeBlock(i);
            const l = t1.currentBlock;
            o.setToBlock(l, o.positions.END);
            return;
        }
        $cdae29d26d2e7999$var$xo(s, i) ? this.mergeBlocks(s, i) : o.setToBlock(s, o.positions.END);
    }
    /**
   * Handles delete keydown on Block
   * Removes char after the caret.
   * If caret is at the end of the block, merge next block with current
   *
   * @param {KeyboardEvent} event - keydown
   */ delete(e) {
        const { BlockManager: t1, Caret: o } = this.Editor, { currentBlock: i, nextBlock: s } = t1;
        if (!$cdae29d26d2e7999$var$b.isCollapsed || !$cdae29d26d2e7999$var$Re(i.currentInput)) return;
        if (e.preventDefault(), this.Editor.Toolbar.close(), !(i.currentInput === i.lastInput)) {
            o.navigateNext();
            return;
        }
        if (s === null) return;
        if (s.isEmpty) {
            t1.removeBlock(s);
            return;
        }
        if (i.isEmpty) {
            t1.removeBlock(i), o.setToBlock(s, o.positions.START);
            return;
        }
        $cdae29d26d2e7999$var$xo(i, s) ? this.mergeBlocks(i, s) : o.setToBlock(s, o.positions.START);
    }
    /**
   * Merge passed Blocks
   *
   * @param targetBlock - to which Block we want to merge
   * @param blockToMerge - what Block we want to merge
   */ mergeBlocks(e, t1) {
        const { BlockManager: o, Toolbar: i } = this.Editor;
        e.lastInput !== void 0 && ($cdae29d26d2e7999$var$hn.focus(e.lastInput, !1), o.mergeBlocks(e, t1).then(()=>{
            i.close();
        }));
    }
    /**
   * Handle right and down keyboard keys
   *
   * @param {KeyboardEvent} event - keyboard event
   */ arrowRightAndDown(e) {
        const t1 = $cdae29d26d2e7999$var$ce.usedKeys.includes(e.keyCode) && (!e.shiftKey || e.keyCode === $cdae29d26d2e7999$var$y.TAB);
        if (this.Editor.UI.someToolbarOpened && t1) return;
        this.Editor.Toolbar.close();
        const { currentBlock: o } = this.Editor.BlockManager, s = ((o == null ? void 0 : o.currentInput) !== void 0 ? $cdae29d26d2e7999$var$Re(o.currentInput) : void 0) || this.Editor.BlockSelection.anyBlockSelected;
        if (e.shiftKey && e.keyCode === $cdae29d26d2e7999$var$y.DOWN && s) {
            this.Editor.CrossBlockSelection.toggleBlockSelectedState();
            return;
        }
        if (e.keyCode === $cdae29d26d2e7999$var$y.DOWN || e.keyCode === $cdae29d26d2e7999$var$y.RIGHT && !this.isRtl ? this.Editor.Caret.navigateNext() : this.Editor.Caret.navigatePrevious()) {
            e.preventDefault();
            return;
        }
        $cdae29d26d2e7999$var$Fe(()=>{
            this.Editor.BlockManager.currentBlock && this.Editor.BlockManager.currentBlock.updateCurrentInput();
        }, 20)(), this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * Handle left and up keyboard keys
   *
   * @param {KeyboardEvent} event - keyboard event
   */ arrowLeftAndUp(e) {
        if (this.Editor.UI.someToolbarOpened) {
            if ($cdae29d26d2e7999$var$ce.usedKeys.includes(e.keyCode) && (!e.shiftKey || e.keyCode === $cdae29d26d2e7999$var$y.TAB)) return;
            this.Editor.UI.closeAllToolbars();
        }
        this.Editor.Toolbar.close();
        const { currentBlock: t1 } = this.Editor.BlockManager, i = ((t1 == null ? void 0 : t1.currentInput) !== void 0 ? $cdae29d26d2e7999$var$Ne(t1.currentInput) : void 0) || this.Editor.BlockSelection.anyBlockSelected;
        if (e.shiftKey && e.keyCode === $cdae29d26d2e7999$var$y.UP && i) {
            this.Editor.CrossBlockSelection.toggleBlockSelectedState(!1);
            return;
        }
        if (e.keyCode === $cdae29d26d2e7999$var$y.UP || e.keyCode === $cdae29d26d2e7999$var$y.LEFT && !this.isRtl ? this.Editor.Caret.navigatePrevious() : this.Editor.Caret.navigateNext()) {
            e.preventDefault();
            return;
        }
        $cdae29d26d2e7999$var$Fe(()=>{
            this.Editor.BlockManager.currentBlock && this.Editor.BlockManager.currentBlock.updateCurrentInput();
        }, 20)(), this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * Cases when we need to close Toolbar
   *
   * @param {KeyboardEvent} event - keyboard event
   */ needToolbarClosing(e) {
        const t1 = e.keyCode === $cdae29d26d2e7999$var$y.ENTER && this.Editor.Toolbar.toolbox.opened, o = e.keyCode === $cdae29d26d2e7999$var$y.ENTER && this.Editor.BlockSettings.opened, i = e.keyCode === $cdae29d26d2e7999$var$y.ENTER && this.Editor.InlineToolbar.opened, s = e.keyCode === $cdae29d26d2e7999$var$y.TAB;
        return !(e.shiftKey || s || t1 || o || i);
    }
    /**
   * If Toolbox is not open, then just open it and show plus button
   */ activateToolbox() {
        this.Editor.Toolbar.opened || this.Editor.Toolbar.moveAndOpen(), this.Editor.Toolbar.toolbox.open();
    }
    /**
   * Open Toolbar and show BlockSettings before flipping Tools
   */ activateBlockSettings() {
        this.Editor.Toolbar.opened || this.Editor.Toolbar.moveAndOpen(), this.Editor.BlockSettings.opened || this.Editor.BlockSettings.open();
    }
}
class $cdae29d26d2e7999$var$ct {
    /**
   * @class
   * @param {HTMLElement} workingArea — editor`s working node
   */ constructor(e){
        this.blocks = [], this.workingArea = e;
    }
    /**
   * Get length of Block instances array
   *
   * @returns {number}
   */ get length() {
        return this.blocks.length;
    }
    /**
   * Get Block instances array
   *
   * @returns {Block[]}
   */ get array() {
        return this.blocks;
    }
    /**
   * Get blocks html elements array
   *
   * @returns {HTMLElement[]}
   */ get nodes() {
        return $cdae29d26d2e7999$var$No(this.workingArea.children);
    }
    /**
   * Proxy trap to implement array-like setter
   *
   * @example
   * blocks[0] = new Block(...)
   * @param {Blocks} instance — Blocks instance
   * @param {PropertyKey} property — block index or any Blocks class property key to set
   * @param {Block} value — value to set
   * @returns {boolean}
   */ static set(e, t1, o) {
        return isNaN(Number(t1)) ? (Reflect.set(e, t1, o), !0) : (e.insert(+t1, o), !0);
    }
    /**
   * Proxy trap to implement array-like getter
   *
   * @param {Blocks} instance — Blocks instance
   * @param {PropertyKey} property — Blocks class property key
   * @returns {Block|*}
   */ static get(e, t1) {
        return isNaN(Number(t1)) ? Reflect.get(e, t1) : e.get(+t1);
    }
    /**
   * Push new Block to the blocks array and append it to working area
   *
   * @param {Block} block - Block to add
   */ push(e) {
        this.blocks.push(e), this.insertToDOM(e);
    }
    /**
   * Swaps blocks with indexes first and second
   *
   * @param {number} first - first block index
   * @param {number} second - second block index
   * @deprecated — use 'move' instead
   */ swap(e, t1) {
        const o = this.blocks[t1];
        $cdae29d26d2e7999$var$u.swap(this.blocks[e].holder, o.holder), this.blocks[t1] = this.blocks[e], this.blocks[e] = o;
    }
    /**
   * Move a block from one to another index
   *
   * @param {number} toIndex - new index of the block
   * @param {number} fromIndex - block to move
   */ move(e, t1) {
        const o = this.blocks.splice(t1, 1)[0], i = e - 1, s = Math.max(0, i), r = this.blocks[s];
        e > 0 ? this.insertToDOM(o, "afterend", r) : this.insertToDOM(o, "beforebegin", r), this.blocks.splice(e, 0, o);
        const a = this.composeBlockEvent("move", {
            fromIndex: t1,
            toIndex: e
        });
        o.call($cdae29d26d2e7999$var$ee.MOVED, a);
    }
    /**
   * Insert new Block at passed index
   *
   * @param {number} index — index to insert Block
   * @param {Block} block — Block to insert
   * @param {boolean} replace — it true, replace block on given index
   */ insert(e, t1, o = !1) {
        if (!this.length) {
            this.push(t1);
            return;
        }
        e > this.length && (e = this.length), o && (this.blocks[e].holder.remove(), this.blocks[e].call($cdae29d26d2e7999$var$ee.REMOVED));
        const i = o ? 1 : 0;
        if (this.blocks.splice(e, i, t1), e > 0) {
            const s = this.blocks[e - 1];
            this.insertToDOM(t1, "afterend", s);
        } else {
            const s = this.blocks[e + 1];
            s ? this.insertToDOM(t1, "beforebegin", s) : this.insertToDOM(t1);
        }
    }
    /**
   * Replaces block under passed index with passed block
   *
   * @param index - index of existed block
   * @param block - new block
   */ replace(e, t1) {
        if (this.blocks[e] === void 0) throw Error("Incorrect index");
        this.blocks[e].holder.replaceWith(t1.holder), this.blocks[e] = t1;
    }
    /**
   * Inserts several blocks at once
   *
   * @param blocks - blocks to insert
   * @param index - index to insert blocks at
   */ insertMany(e, t1) {
        const o = new DocumentFragment();
        for (const i of e)o.appendChild(i.holder);
        if (this.length > 0) {
            if (t1 > 0) {
                const i = Math.min(t1 - 1, this.length - 1);
                this.blocks[i].holder.after(o);
            } else t1 === 0 && this.workingArea.prepend(o);
            this.blocks.splice(t1, 0, ...e);
        } else this.blocks.push(...e), this.workingArea.appendChild(o);
        e.forEach((i)=>i.call($cdae29d26d2e7999$var$ee.RENDERED));
    }
    /**
   * Remove block
   *
   * @param {number} index - index of Block to remove
   */ remove(e) {
        isNaN(e) && (e = this.length - 1), this.blocks[e].holder.remove(), this.blocks[e].call($cdae29d26d2e7999$var$ee.REMOVED), this.blocks.splice(e, 1);
    }
    /**
   * Remove all blocks
   */ removeAll() {
        this.workingArea.innerHTML = "", this.blocks.forEach((e)=>e.call($cdae29d26d2e7999$var$ee.REMOVED)), this.blocks.length = 0;
    }
    /**
   * Insert Block after passed target
   *
   * @todo decide if this method is necessary
   * @param {Block} targetBlock — target after which Block should be inserted
   * @param {Block} newBlock — Block to insert
   */ insertAfter(e, t1) {
        const o = this.blocks.indexOf(e);
        this.insert(o + 1, t1);
    }
    /**
   * Get Block by index
   *
   * @param {number} index — Block index
   * @returns {Block}
   */ get(e) {
        return this.blocks[e];
    }
    /**
   * Return index of passed Block
   *
   * @param {Block} block - Block to find
   * @returns {number}
   */ indexOf(e) {
        return this.blocks.indexOf(e);
    }
    /**
   * Insert new Block into DOM
   *
   * @param {Block} block - Block to insert
   * @param {InsertPosition} position — insert position (if set, will use insertAdjacentElement)
   * @param {Block} target — Block related to position
   */ insertToDOM(e, t1, o) {
        t1 ? o.holder.insertAdjacentElement(t1, e.holder) : this.workingArea.appendChild(e.holder), e.call($cdae29d26d2e7999$var$ee.RENDERED);
    }
    /**
   * Composes Block event with passed type and details
   *
   * @param {string} type - event type
   * @param {object} detail - event detail
   */ composeBlockEvent(e, t1) {
        return new CustomEvent(e, {
            detail: t1
        });
    }
}
const $cdae29d26d2e7999$var$_o = "block-removed", $cdae29d26d2e7999$var$Mo = "block-added", $cdae29d26d2e7999$var$ia = "block-moved", $cdae29d26d2e7999$var$Ao = "block-changed";
class $cdae29d26d2e7999$var$sa {
    constructor(){
        this.completed = Promise.resolve();
    }
    /**
   * Add new promise to queue
   *
   * @param operation - promise should be added to queue
   */ add(e) {
        return new Promise((t1, o)=>{
            this.completed = this.completed.then(e).then(t1).catch(o);
        });
    }
}
class $cdae29d26d2e7999$var$ra extends $cdae29d26d2e7999$var$E {
    constructor(){
        super(...arguments), this._currentBlockIndex = -1, this._blocks = null;
    }
    /**
   * Returns current Block index
   *
   * @returns {number}
   */ get currentBlockIndex() {
        return this._currentBlockIndex;
    }
    /**
   * Set current Block index and fire Block lifecycle callbacks
   *
   * @param {number} newIndex - index of Block to set as current
   */ set currentBlockIndex(e) {
        this._currentBlockIndex = e;
    }
    /**
   * returns first Block
   *
   * @returns {Block}
   */ get firstBlock() {
        return this._blocks[0];
    }
    /**
   * returns last Block
   *
   * @returns {Block}
   */ get lastBlock() {
        return this._blocks[this._blocks.length - 1];
    }
    /**
   * Get current Block instance
   *
   * @returns {Block}
   */ get currentBlock() {
        return this._blocks[this.currentBlockIndex];
    }
    /**
   * Set passed Block as a current
   *
   * @param block - block to set as a current
   */ set currentBlock(e) {
        this.currentBlockIndex = this.getBlockIndex(e);
    }
    /**
   * Returns next Block instance
   *
   * @returns {Block|null}
   */ get nextBlock() {
        return this.currentBlockIndex === this._blocks.length - 1 ? null : this._blocks[this.currentBlockIndex + 1];
    }
    /**
   * Return first Block with inputs after current Block
   *
   * @returns {Block | undefined}
   */ get nextContentfulBlock() {
        return this.blocks.slice(this.currentBlockIndex + 1).find((t1)=>!!t1.inputs.length);
    }
    /**
   * Return first Block with inputs before current Block
   *
   * @returns {Block | undefined}
   */ get previousContentfulBlock() {
        return this.blocks.slice(0, this.currentBlockIndex).reverse().find((t1)=>!!t1.inputs.length);
    }
    /**
   * Returns previous Block instance
   *
   * @returns {Block|null}
   */ get previousBlock() {
        return this.currentBlockIndex === 0 ? null : this._blocks[this.currentBlockIndex - 1];
    }
    /**
   * Get array of Block instances
   *
   * @returns {Block[]} {@link Blocks#array}
   */ get blocks() {
        return this._blocks.array;
    }
    /**
   * Check if each Block is empty
   *
   * @returns {boolean}
   */ get isEditorEmpty() {
        return this.blocks.every((e)=>e.isEmpty);
    }
    /**
   * Should be called after Editor.UI preparation
   * Define this._blocks property
   */ prepare() {
        const e = new $cdae29d26d2e7999$var$ct(this.Editor.UI.nodes.redactor);
        this._blocks = new Proxy(e, {
            set: $cdae29d26d2e7999$var$ct.set,
            get: $cdae29d26d2e7999$var$ct.get
        }), this.listeners.on(document, "copy", (t1)=>this.Editor.BlockEvents.handleCommandC(t1));
    }
    /**
   * Toggle read-only state
   *
   * If readOnly is true:
   *  - Unbind event handlers from created Blocks
   *
   * if readOnly is false:
   *  - Bind event handlers to all existing Blocks
   *
   * @param {boolean} readOnlyEnabled - "read only" state
   */ toggleReadOnly(e) {
        e ? this.disableModuleBindings() : this.enableModuleBindings();
    }
    /**
   * Creates Block instance by tool name
   *
   * @param {object} options - block creation options
   * @param {string} options.tool - tools passed in editor config {@link EditorConfig#tools}
   * @param {string} [options.id] - unique id for this block
   * @param {BlockToolData} [options.data] - constructor params
   * @returns {Block}
   */ composeBlock({ tool: e, data: t1 = {}, id: o, tunes: i = {} }) {
        const s = this.Editor.ReadOnly.isEnabled, r = this.Editor.Tools.blockTools.get(e), a = new $cdae29d26d2e7999$var$R({
            id: o,
            data: t1,
            tool: r,
            api: this.Editor.API,
            readOnly: s,
            tunesData: i
        }, this.eventsDispatcher);
        return s || window.requestIdleCallback(()=>{
            this.bindBlockEvents(a);
        }, {
            timeout: 2e3
        }), a;
    }
    /**
   * Insert new block into _blocks
   *
   * @param {object} options - insert options
   * @param {string} [options.id] - block's unique id
   * @param {string} [options.tool] - plugin name, by default method inserts the default block type
   * @param {object} [options.data] - plugin data
   * @param {number} [options.index] - index where to insert new Block
   * @param {boolean} [options.needToFocus] - flag shows if needed to update current Block index
   * @param {boolean} [options.replace] - flag shows if block by passed index should be replaced with inserted one
   * @returns {Block}
   */ insert({ id: e, tool: t1 = this.config.defaultBlock, data: o = {}, index: i, needToFocus: s = !0, replace: r = !1, tunes: a = {} } = {}) {
        let l = i;
        l === void 0 && (l = this.currentBlockIndex + (r ? 0 : 1));
        const c = this.composeBlock({
            id: e,
            tool: t1,
            data: o,
            tunes: a
        });
        return r && this.blockDidMutated($cdae29d26d2e7999$var$_o, this.getBlockByIndex(l), {
            index: l
        }), this._blocks.insert(l, c, r), this.blockDidMutated($cdae29d26d2e7999$var$Mo, c, {
            index: l
        }), s ? this.currentBlockIndex = l : l <= this.currentBlockIndex && this.currentBlockIndex++, c;
    }
    /**
   * Inserts several blocks at once
   *
   * @param blocks - blocks to insert
   * @param index - index where to insert
   */ insertMany(e, t1 = 0) {
        this._blocks.insertMany(e, t1);
    }
    /**
   * Update Block data.
   *
   * Currently we don't have an 'update' method in the Tools API, so we just create a new block with the same id and type
   * Should not trigger 'block-removed' or 'block-added' events.
   *
   * If neither data nor tunes is provided, return the provided block instead.
   *
   * @param block - block to update
   * @param data - (optional) new data
   * @param tunes - (optional) tune data
   */ async update(e, t1, o) {
        if (!t1 && !o) return e;
        const i = await e.data, s = this.composeBlock({
            id: e.id,
            tool: e.name,
            data: Object.assign({}, i, t1 ?? {}),
            tunes: o ?? e.tunes
        }), r = this.getBlockIndex(e);
        return this._blocks.replace(r, s), this.blockDidMutated($cdae29d26d2e7999$var$Ao, s, {
            index: r
        }), s;
    }
    /**
   * Replace passed Block with the new one with specified Tool and data
   *
   * @param block - block to replace
   * @param newTool - new Tool name
   * @param data - new Tool data
   */ replace(e, t1, o) {
        const i = this.getBlockIndex(e);
        return this.insert({
            tool: t1,
            data: o,
            index: i,
            replace: !0
        });
    }
    /**
   * Insert pasted content. Call onPaste callback after insert.
   *
   * @param {string} toolName - name of Tool to insert
   * @param {PasteEvent} pasteEvent - pasted data
   * @param {boolean} replace - should replace current block
   */ paste(e, t1, o = !1) {
        const i = this.insert({
            tool: e,
            replace: o
        });
        try {
            window.requestIdleCallback(()=>{
                i.call($cdae29d26d2e7999$var$ee.ON_PASTE, t1);
            });
        } catch (s) {
            $cdae29d26d2e7999$var$S(`${e}: onPaste callback call is failed`, "error", s);
        }
        return i;
    }
    /**
   * Insert new default block at passed index
   *
   * @param {number} index - index where Block should be inserted
   * @param {boolean} needToFocus - if true, updates current Block index
   *
   * TODO: Remove method and use insert() with index instead (?)
   * @returns {Block} inserted Block
   */ insertDefaultBlockAtIndex(e, t1 = !1) {
        const o = this.composeBlock({
            tool: this.config.defaultBlock
        });
        return this._blocks[e] = o, this.blockDidMutated($cdae29d26d2e7999$var$Mo, o, {
            index: e
        }), t1 ? this.currentBlockIndex = e : e <= this.currentBlockIndex && this.currentBlockIndex++, o;
    }
    /**
   * Always inserts at the end
   *
   * @returns {Block}
   */ insertAtEnd() {
        return this.currentBlockIndex = this.blocks.length - 1, this.insert();
    }
    /**
   * Merge two blocks
   *
   * @param {Block} targetBlock - previous block will be append to this block
   * @param {Block} blockToMerge - block that will be merged with target block
   * @returns {Promise} - the sequence that can be continued
   */ async mergeBlocks(e, t1) {
        let o;
        if (e.name === t1.name && e.mergeable) {
            const i = await t1.data;
            if ($cdae29d26d2e7999$var$V(i)) {
                console.error("Could not merge Block. Failed to extract original Block data.");
                return;
            }
            const [s] = $cdae29d26d2e7999$var$yt([
                i
            ], e.tool.sanitizeConfig);
            o = s;
        } else if (e.mergeable && $cdae29d26d2e7999$var$He(t1, "export") && $cdae29d26d2e7999$var$He(e, "import")) {
            const i = await t1.exportDataAsString(), s = $cdae29d26d2e7999$var$Z(i, e.tool.sanitizeConfig);
            o = $cdae29d26d2e7999$var$Bo(s, e.tool.conversionConfig);
        }
        o !== void 0 && (await e.mergeWith(o), this.removeBlock(t1), this.currentBlockIndex = this._blocks.indexOf(e));
    }
    /**
   * Remove passed Block
   *
   * @param block - Block to remove
   * @param addLastBlock - if true, adds new default block at the end. @todo remove this logic and use event-bus instead
   */ removeBlock(e, t1 = !0) {
        return new Promise((o)=>{
            const i = this._blocks.indexOf(e);
            if (!this.validateIndex(i)) throw new Error("Can't find a Block to remove");
            this._blocks.remove(i), e.destroy(), this.blockDidMutated($cdae29d26d2e7999$var$_o, e, {
                index: i
            }), this.currentBlockIndex >= i && this.currentBlockIndex--, this.blocks.length ? i === 0 && (this.currentBlockIndex = 0) : (this.unsetCurrentBlock(), t1 && this.insert()), o();
        });
    }
    /**
   * Remove only selected Blocks
   * and returns first Block index where started removing...
   *
   * @returns {number|undefined}
   */ removeSelectedBlocks() {
        let e;
        for(let t1 = this.blocks.length - 1; t1 >= 0; t1--)this.blocks[t1].selected && (this.removeBlock(this.blocks[t1]), e = t1);
        return e;
    }
    /**
   * Attention!
   * After removing insert the new default typed Block and focus on it
   * Removes all blocks
   */ removeAllBlocks() {
        for(let e = this.blocks.length - 1; e >= 0; e--)this._blocks.remove(e);
        this.unsetCurrentBlock(), this.insert(), this.currentBlock.firstInput.focus();
    }
    /**
   * Split current Block
   * 1. Extract content from Caret position to the Block`s end
   * 2. Insert a new Block below current one with extracted content
   *
   * @returns {Block}
   */ split() {
        const e = this.Editor.Caret.extractFragmentFromCaretPosition(), t1 = $cdae29d26d2e7999$var$u.make("div");
        t1.appendChild(e);
        const o = {
            text: $cdae29d26d2e7999$var$u.isEmpty(t1) ? "" : t1.innerHTML
        };
        return this.insert({
            data: o
        });
    }
    /**
   * Returns Block by passed index
   *
   * @param {number} index - index to get. -1 to get last
   * @returns {Block}
   */ getBlockByIndex(e) {
        return e === -1 && (e = this._blocks.length - 1), this._blocks[e];
    }
    /**
   * Returns an index for passed Block
   *
   * @param block - block to find index
   */ getBlockIndex(e) {
        return this._blocks.indexOf(e);
    }
    /**
   * Returns the Block by passed id
   *
   * @param id - id of block to get
   * @returns {Block}
   */ getBlockById(e) {
        return this._blocks.array.find((t1)=>t1.id === e);
    }
    /**
   * Get Block instance by html element
   *
   * @param {Node} element - html element to get Block by
   */ getBlock(e) {
        $cdae29d26d2e7999$var$u.isElement(e) || (e = e.parentNode);
        const t1 = this._blocks.nodes, o = e.closest(`.${$cdae29d26d2e7999$var$R.CSS.wrapper}`), i = t1.indexOf(o);
        if (i >= 0) return this._blocks[i];
    }
    /**
   * 1) Find first-level Block from passed child Node
   * 2) Mark it as current
   *
   * @param {Node} childNode - look ahead from this node.
   * @returns {Block | undefined} can return undefined in case when the passed child note is not a part of the current editor instance
   */ setCurrentBlockByChildNode(e) {
        $cdae29d26d2e7999$var$u.isElement(e) || (e = e.parentNode);
        const t1 = e.closest(`.${$cdae29d26d2e7999$var$R.CSS.wrapper}`);
        if (!t1) return;
        const o = t1.closest(`.${this.Editor.UI.CSS.editorWrapper}`);
        if (o != null && o.isEqualNode(this.Editor.UI.nodes.wrapper)) return this.currentBlockIndex = this._blocks.nodes.indexOf(t1), this.currentBlock.updateCurrentInput(), this.currentBlock;
    }
    /**
   * Return block which contents passed node
   *
   * @param {Node} childNode - node to get Block by
   * @returns {Block}
   */ getBlockByChildNode(e) {
        if (!e || !(e instanceof Node)) return;
        $cdae29d26d2e7999$var$u.isElement(e) || (e = e.parentNode);
        const t1 = e.closest(`.${$cdae29d26d2e7999$var$R.CSS.wrapper}`);
        return this.blocks.find((o)=>o.holder === t1);
    }
    /**
   * Swap Blocks Position
   *
   * @param {number} fromIndex - index of first block
   * @param {number} toIndex - index of second block
   * @deprecated — use 'move' instead
   */ swap(e, t1) {
        this._blocks.swap(e, t1), this.currentBlockIndex = t1;
    }
    /**
   * Move a block to a new index
   *
   * @param {number} toIndex - index where to move Block
   * @param {number} fromIndex - index of Block to move
   */ move(e, t1 = this.currentBlockIndex) {
        if (isNaN(e) || isNaN(t1)) {
            $cdae29d26d2e7999$var$S("Warning during 'move' call: incorrect indices provided.", "warn");
            return;
        }
        if (!this.validateIndex(e) || !this.validateIndex(t1)) {
            $cdae29d26d2e7999$var$S("Warning during 'move' call: indices cannot be lower than 0 or greater than the amount of blocks.", "warn");
            return;
        }
        this._blocks.move(e, t1), this.currentBlockIndex = e, this.blockDidMutated($cdae29d26d2e7999$var$ia, this.currentBlock, {
            fromIndex: t1,
            toIndex: e
        });
    }
    /**
   * Converts passed Block to the new Tool
   * Uses Conversion Config
   *
   * @param blockToConvert - Block that should be converted
   * @param targetToolName - name of the Tool to convert to
   * @param blockDataOverrides - optional new Block data overrides
   */ async convert(e, t1, o) {
        if (!await e.save()) throw new Error("Could not convert Block. Failed to extract original Block data.");
        const s = this.Editor.Tools.blockTools.get(t1);
        if (!s) throw new Error(`Could not convert Block. Tool \xab${t1}\xbb not found.`);
        const r = await e.exportDataAsString(), a = $cdae29d26d2e7999$var$Z(r, s.sanitizeConfig);
        let l = $cdae29d26d2e7999$var$Bo(a, s.conversionConfig, s.settings);
        return o && (l = Object.assign(l, o)), this.replace(e, s.name, l);
    }
    /**
   * Sets current Block Index -1 which means unknown
   * and clear highlights
   */ unsetCurrentBlock() {
        this.currentBlockIndex = -1;
    }
    /**
   * Clears Editor
   *
   * @param {boolean} needToAddDefaultBlock - 1) in internal calls (for example, in api.blocks.render)
   *                                             we don't need to add an empty default block
   *                                        2) in api.blocks.clear we should add empty block
   */ async clear(e = !1) {
        const t1 = new $cdae29d26d2e7999$var$sa();
        [
            ...this.blocks
        ].forEach((i)=>{
            t1.add(async ()=>{
                await this.removeBlock(i, !1);
            });
        }), await t1.completed, this.unsetCurrentBlock(), e && this.insert(), this.Editor.UI.checkEmptiness();
    }
    /**
   * Cleans up all the block tools' resources
   * This is called when editor is destroyed
   */ async destroy() {
        await Promise.all(this.blocks.map((e)=>e.destroy()));
    }
    /**
   * Bind Block events
   *
   * @param {Block} block - Block to which event should be bound
   */ bindBlockEvents(e) {
        const { BlockEvents: t1 } = this.Editor;
        this.readOnlyMutableListeners.on(e.holder, "keydown", (o)=>{
            t1.keydown(o);
        }), this.readOnlyMutableListeners.on(e.holder, "keyup", (o)=>{
            t1.keyup(o);
        }), this.readOnlyMutableListeners.on(e.holder, "dragover", (o)=>{
            t1.dragOver(o);
        }), this.readOnlyMutableListeners.on(e.holder, "dragleave", (o)=>{
            t1.dragLeave(o);
        }), e.on("didMutated", (o)=>this.blockDidMutated($cdae29d26d2e7999$var$Ao, o, {
                index: this.getBlockIndex(o)
            }));
    }
    /**
   * Disable mutable handlers and bindings
   */ disableModuleBindings() {
        this.readOnlyMutableListeners.clearAll();
    }
    /**
   * Enables all module handlers and bindings for all Blocks
   */ enableModuleBindings() {
        this.readOnlyMutableListeners.on(document, "cut", (e)=>this.Editor.BlockEvents.handleCommandX(e)), this.blocks.forEach((e)=>{
            this.bindBlockEvents(e);
        });
    }
    /**
   * Validates that the given index is not lower than 0 or higher than the amount of blocks
   *
   * @param {number} index - index of blocks array to validate
   * @returns {boolean}
   */ validateIndex(e) {
        return !(e < 0 || e >= this._blocks.length);
    }
    /**
   * Block mutation callback
   *
   * @param mutationType - what happened with block
   * @param block - mutated block
   * @param detailData - additional data to pass with change event
   */ blockDidMutated(e, t1, o) {
        const i = new CustomEvent(e, {
            detail: {
                target: new $cdae29d26d2e7999$var$J(t1),
                ...o
            }
        });
        return this.eventsDispatcher.emit($cdae29d26d2e7999$var$$o, {
            event: i
        }), t1;
    }
}
class $cdae29d26d2e7999$var$aa extends $cdae29d26d2e7999$var$E {
    constructor(){
        super(...arguments), this.anyBlockSelectedCache = null, this.needToSelectAll = !1, this.nativeInputSelected = !1, this.readyToBlockSelection = !1;
    }
    /**
   * Sanitizer Config
   *
   * @returns {SanitizerConfig}
   */ get sanitizerConfig() {
        return {
            p: {},
            h1: {},
            h2: {},
            h3: {},
            h4: {},
            h5: {},
            h6: {},
            ol: {},
            ul: {},
            li: {},
            br: !0,
            img: {
                src: !0,
                width: !0,
                height: !0
            },
            a: {
                href: !0
            },
            b: {},
            i: {},
            u: {}
        };
    }
    /**
   * Flag that identifies all Blocks selection
   *
   * @returns {boolean}
   */ get allBlocksSelected() {
        const { BlockManager: e } = this.Editor;
        return e.blocks.every((t1)=>t1.selected === !0);
    }
    /**
   * Set selected all blocks
   *
   * @param {boolean} state - state to set
   */ set allBlocksSelected(e) {
        const { BlockManager: t1 } = this.Editor;
        t1.blocks.forEach((o)=>{
            o.selected = e;
        }), this.clearCache();
    }
    /**
   * Flag that identifies any Block selection
   *
   * @returns {boolean}
   */ get anyBlockSelected() {
        const { BlockManager: e } = this.Editor;
        return this.anyBlockSelectedCache === null && (this.anyBlockSelectedCache = e.blocks.some((t1)=>t1.selected === !0)), this.anyBlockSelectedCache;
    }
    /**
   * Return selected Blocks array
   *
   * @returns {Block[]}
   */ get selectedBlocks() {
        return this.Editor.BlockManager.blocks.filter((e)=>e.selected);
    }
    /**
   * Module Preparation
   * Registers Shortcuts CMD+A and CMD+C
   * to select all and copy them
   */ prepare() {
        this.selection = new $cdae29d26d2e7999$var$b(), $cdae29d26d2e7999$var$ge.add({
            name: "CMD+A",
            handler: (e)=>{
                const { BlockManager: t1, ReadOnly: o } = this.Editor;
                if (o.isEnabled) {
                    e.preventDefault(), this.selectAllBlocks();
                    return;
                }
                t1.currentBlock && this.handleCommandA(e);
            },
            on: this.Editor.UI.nodes.redactor
        });
    }
    /**
   * Toggle read-only state
   *
   *  - Remove all ranges
   *  - Unselect all Blocks
   */ toggleReadOnly() {
        $cdae29d26d2e7999$var$b.get().removeAllRanges(), this.allBlocksSelected = !1;
    }
    /**
   * Remove selection of Block
   *
   * @param {number?} index - Block index according to the BlockManager's indexes
   */ unSelectBlockByIndex(e) {
        const { BlockManager: t1 } = this.Editor;
        let o;
        isNaN(e) ? o = t1.currentBlock : o = t1.getBlockByIndex(e), o.selected = !1, this.clearCache();
    }
    /**
   * Clear selection from Blocks
   *
   * @param {Event} reason - event caused clear of selection
   * @param {boolean} restoreSelection - if true, restore saved selection
   */ clearSelection(e, t1 = !1) {
        const { BlockManager: o, Caret: i, RectangleSelection: s } = this.Editor;
        this.needToSelectAll = !1, this.nativeInputSelected = !1, this.readyToBlockSelection = !1;
        const r = e && e instanceof KeyboardEvent, a = r && $cdae29d26d2e7999$var$Po(e.keyCode);
        if (this.anyBlockSelected && r && a && !$cdae29d26d2e7999$var$b.isSelectionExists) {
            const l = o.removeSelectedBlocks();
            o.insertDefaultBlockAtIndex(l, !0), i.setToBlock(o.currentBlock), $cdae29d26d2e7999$var$Fe(()=>{
                const c = e.key;
                i.insertContentAtCaretPosition(c.length > 1 ? "" : c);
            }, 20)();
        }
        if (this.Editor.CrossBlockSelection.clear(e), !this.anyBlockSelected || s.isRectActivated()) {
            this.Editor.RectangleSelection.clearSelection();
            return;
        }
        t1 && this.selection.restore(), this.allBlocksSelected = !1;
    }
    /**
   * Reduce each Block and copy its content
   *
   * @param {ClipboardEvent} e - copy/cut event
   * @returns {Promise<void>}
   */ copySelectedBlocks(e) {
        e.preventDefault();
        const t1 = $cdae29d26d2e7999$var$u.make("div");
        this.selectedBlocks.forEach((s)=>{
            const r = $cdae29d26d2e7999$var$Z(s.holder.innerHTML, this.sanitizerConfig), a = $cdae29d26d2e7999$var$u.make("p");
            a.innerHTML = r, t1.appendChild(a);
        });
        const o = Array.from(t1.childNodes).map((s)=>s.textContent).join(`

`), i = t1.innerHTML;
        return e.clipboardData.setData("text/plain", o), e.clipboardData.setData("text/html", i), Promise.all(this.selectedBlocks.map((s)=>s.save())).then((s)=>{
            try {
                e.clipboardData.setData(this.Editor.Paste.MIME_TYPE, JSON.stringify(s));
            } catch  {}
        });
    }
    /**
   * Select Block by its index
   *
   * @param {number?} index - Block index according to the BlockManager's indexes
   */ selectBlockByIndex(e) {
        const { BlockManager: t1 } = this.Editor, o = t1.getBlockByIndex(e);
        o !== void 0 && this.selectBlock(o);
    }
    /**
   * Select passed Block
   *
   * @param {Block} block - Block to select
   */ selectBlock(e) {
        this.selection.save(), $cdae29d26d2e7999$var$b.get().removeAllRanges(), e.selected = !0, this.clearCache(), this.Editor.InlineToolbar.close();
    }
    /**
   * Remove selection from passed Block
   *
   * @param {Block} block - Block to unselect
   */ unselectBlock(e) {
        e.selected = !1, this.clearCache();
    }
    /**
   * Clear anyBlockSelected cache
   */ clearCache() {
        this.anyBlockSelectedCache = null;
    }
    /**
   * Module destruction
   * De-registers Shortcut CMD+A
   */ destroy() {
        $cdae29d26d2e7999$var$ge.remove(this.Editor.UI.nodes.redactor, "CMD+A");
    }
    /**
   * First CMD+A selects all input content by native behaviour,
   * next CMD+A keypress selects all blocks
   *
   * @param {KeyboardEvent} event - keyboard event
   */ handleCommandA(e) {
        if (this.Editor.RectangleSelection.clearSelection(), $cdae29d26d2e7999$var$u.isNativeInput(e.target) && !this.readyToBlockSelection) {
            this.readyToBlockSelection = !0;
            return;
        }
        const t1 = this.Editor.BlockManager.getBlock(e.target), o = t1.inputs;
        if (o.length > 1 && !this.readyToBlockSelection) {
            this.readyToBlockSelection = !0;
            return;
        }
        if (o.length === 1 && !this.needToSelectAll) {
            this.needToSelectAll = !0;
            return;
        }
        this.needToSelectAll ? (e.preventDefault(), this.selectAllBlocks(), this.needToSelectAll = !1, this.readyToBlockSelection = !1) : this.readyToBlockSelection && (e.preventDefault(), this.selectBlock(t1), this.needToSelectAll = !0);
    }
    /**
   * Select All Blocks
   * Each Block has selected setter that makes Block copyable
   */ selectAllBlocks() {
        this.selection.save(), $cdae29d26d2e7999$var$b.get().removeAllRanges(), this.allBlocksSelected = !0, this.Editor.InlineToolbar.close();
    }
}
class $cdae29d26d2e7999$var$Ye extends $cdae29d26d2e7999$var$E {
    /**
   * Allowed caret positions in input
   *
   * @static
   * @returns {{START: string, END: string, DEFAULT: string}}
   */ get positions() {
        return {
            START: "start",
            END: "end",
            DEFAULT: "default"
        };
    }
    /**
   * Elements styles that can be useful for Caret Module
   */ static get CSS() {
        return {
            shadowCaret: "cdx-shadow-caret"
        };
    }
    /**
   * Method gets Block instance and puts caret to the text node with offset
   * There two ways that method applies caret position:
   *   - first found text node: sets at the beginning, but you can pass an offset
   *   - last found text node: sets at the end of the node. Also, you can customize the behaviour
   *
   * @param {Block} block - Block class
   * @param {string} position - position where to set caret.
   *                            If default - leave default behaviour and apply offset if it's passed
   * @param {number} offset - caret offset regarding to the block content
   */ setToBlock(e, t1 = this.positions.DEFAULT, o = 0) {
        var c;
        const { BlockManager: i, BlockSelection: s } = this.Editor;
        if (s.clearSelection(), !e.focusable) {
            (c = window.getSelection()) == null || c.removeAllRanges(), s.selectBlock(e), i.currentBlock = e;
            return;
        }
        let r;
        switch(t1){
            case this.positions.START:
                r = e.firstInput;
                break;
            case this.positions.END:
                r = e.lastInput;
                break;
            default:
                r = e.currentInput;
        }
        if (!r) return;
        let a, l = o;
        if (t1 === this.positions.START) a = $cdae29d26d2e7999$var$u.getDeepestNode(r, !1), l = 0;
        else if (t1 === this.positions.END) a = $cdae29d26d2e7999$var$u.getDeepestNode(r, !0), l = $cdae29d26d2e7999$var$u.getContentLength(a);
        else {
            const { node: d, offset: h } = $cdae29d26d2e7999$var$u.getNodeByOffset(r, o);
            d ? (a = d, l = h) : (a = $cdae29d26d2e7999$var$u.getDeepestNode(r, !1), l = 0);
        }
        this.set(a, l), i.setCurrentBlockByChildNode(e.holder), i.currentBlock.currentInput = r;
    }
    /**
   * Set caret to the current input of current Block.
   *
   * @param {HTMLElement} input - input where caret should be set
   * @param {string} position - position of the caret.
   *                            If default - leave default behaviour and apply offset if it's passed
   * @param {number} offset - caret offset regarding to the text node
   */ setToInput(e, t1 = this.positions.DEFAULT, o = 0) {
        const { currentBlock: i } = this.Editor.BlockManager, s = $cdae29d26d2e7999$var$u.getDeepestNode(e);
        switch(t1){
            case this.positions.START:
                this.set(s, 0);
                break;
            case this.positions.END:
                this.set(s, $cdae29d26d2e7999$var$u.getContentLength(s));
                break;
            default:
                o && this.set(s, o);
        }
        i.currentInput = e;
    }
    /**
   * Creates Document Range and sets caret to the element with offset
   *
   * @param {HTMLElement} element - target node.
   * @param {number} offset - offset
   */ set(e, t1 = 0) {
        const { top: i, bottom: s } = $cdae29d26d2e7999$var$b.setCursor(e, t1), { innerHeight: r } = window;
        i < 0 ? window.scrollBy(0, i - 30) : s > r && window.scrollBy(0, s - r + 30);
    }
    /**
   * Set Caret to the last Block
   * If last block is not empty, append another empty block
   */ setToTheLastBlock() {
        const e = this.Editor.BlockManager.lastBlock;
        if (e) {
            if (e.tool.isDefault && e.isEmpty) this.setToBlock(e);
            else {
                const t1 = this.Editor.BlockManager.insertAtEnd();
                this.setToBlock(t1);
            }
        }
    }
    /**
   * Extract content fragment of current Block from Caret position to the end of the Block
   */ extractFragmentFromCaretPosition() {
        const e = $cdae29d26d2e7999$var$b.get();
        if (e.rangeCount) {
            const t1 = e.getRangeAt(0), o = this.Editor.BlockManager.currentBlock.currentInput;
            if (t1.deleteContents(), o) {
                if ($cdae29d26d2e7999$var$u.isNativeInput(o)) {
                    const i = o, s = document.createDocumentFragment(), r = i.value.substring(0, i.selectionStart), a = i.value.substring(i.selectionStart);
                    return s.textContent = a, i.value = r, s;
                } else {
                    const i = t1.cloneRange();
                    return i.selectNodeContents(o), i.setStart(t1.endContainer, t1.endOffset), i.extractContents();
                }
            }
        }
    }
    /**
   * Set's caret to the next Block or Tool`s input
   * Before moving caret, we should check if caret position is at the end of Plugins node
   * Using {@link Dom#getDeepestNode} to get a last node and match with current selection
   *
   * @param {boolean} force - pass true to skip check for caret position
   */ navigateNext(e = !1) {
        const { BlockManager: t1 } = this.Editor, { currentBlock: o, nextBlock: i } = t1;
        if (o === void 0) return !1;
        const { nextInput: s, currentInput: r } = o, a = r !== void 0 ? $cdae29d26d2e7999$var$Re(r) : void 0;
        let l = i;
        const c = e || a || !o.focusable;
        if (s && c) return this.setToInput(s, this.positions.START), !0;
        if (l === null) {
            if (o.tool.isDefault || !c) return !1;
            l = t1.insertAtEnd();
        }
        return c ? (this.setToBlock(l, this.positions.START), !0) : !1;
    }
    /**
   * Set's caret to the previous Tool`s input or Block
   * Before moving caret, we should check if caret position is start of the Plugins node
   * Using {@link Dom#getDeepestNode} to get a last node and match with current selection
   *
   * @param {boolean} force - pass true to skip check for caret position
   */ navigatePrevious(e = !1) {
        const { currentBlock: t1, previousBlock: o } = this.Editor.BlockManager;
        if (!t1) return !1;
        const { previousInput: i, currentInput: s } = t1, r = s !== void 0 ? $cdae29d26d2e7999$var$Ne(s) : void 0, a = e || r || !t1.focusable;
        return i && a ? (this.setToInput(i, this.positions.END), !0) : o !== null && a ? (this.setToBlock(o, this.positions.END), !0) : !1;
    }
    /**
   * Inserts shadow element after passed element where caret can be placed
   *
   * @param {Element} element - element after which shadow caret should be inserted
   */ createShadow(e) {
        const t1 = document.createElement("span");
        t1.classList.add($cdae29d26d2e7999$var$Ye.CSS.shadowCaret), e.insertAdjacentElement("beforeend", t1);
    }
    /**
   * Restores caret position
   *
   * @param {HTMLElement} element - element where caret should be restored
   */ restoreCaret(e) {
        const t1 = e.querySelector(`.${$cdae29d26d2e7999$var$Ye.CSS.shadowCaret}`);
        if (!t1) return;
        new $cdae29d26d2e7999$var$b().expandToTag(t1);
        const i = document.createRange();
        i.selectNode(t1), i.extractContents();
    }
    /**
   * Inserts passed content at caret position
   *
   * @param {string} content - content to insert
   */ insertContentAtCaretPosition(e) {
        const t1 = document.createDocumentFragment(), o = document.createElement("div"), i = $cdae29d26d2e7999$var$b.get(), s = $cdae29d26d2e7999$var$b.range;
        o.innerHTML = e, Array.from(o.childNodes).forEach((c)=>t1.appendChild(c)), t1.childNodes.length === 0 && t1.appendChild(new Text());
        const r = t1.lastChild;
        s.deleteContents(), s.insertNode(t1);
        const a = document.createRange(), l = r.nodeType === Node.TEXT_NODE ? r : r.firstChild;
        l !== null && l.textContent !== null && a.setStart(l, l.textContent.length), i.removeAllRanges(), i.addRange(a);
    }
}
class $cdae29d26d2e7999$var$la extends $cdae29d26d2e7999$var$E {
    constructor(){
        super(...arguments), this.onMouseUp = ()=>{
            this.listeners.off(document, "mouseover", this.onMouseOver), this.listeners.off(document, "mouseup", this.onMouseUp);
        }, this.onMouseOver = (e)=>{
            const { BlockManager: t1, BlockSelection: o } = this.Editor;
            if (e.relatedTarget === null && e.target === null) return;
            const i = t1.getBlockByChildNode(e.relatedTarget) || this.lastSelectedBlock, s = t1.getBlockByChildNode(e.target);
            if (!(!i || !s) && s !== i) {
                if (i === this.firstSelectedBlock) {
                    $cdae29d26d2e7999$var$b.get().removeAllRanges(), i.selected = !0, s.selected = !0, o.clearCache();
                    return;
                }
                if (s === this.firstSelectedBlock) {
                    i.selected = !1, s.selected = !1, o.clearCache();
                    return;
                }
                this.Editor.InlineToolbar.close(), this.toggleBlocksSelectedState(i, s), this.lastSelectedBlock = s;
            }
        };
    }
    /**
   * Module preparation
   *
   * @returns {Promise}
   */ async prepare() {
        this.listeners.on(document, "mousedown", (e)=>{
            this.enableCrossBlockSelection(e);
        });
    }
    /**
   * Sets up listeners
   *
   * @param {MouseEvent} event - mouse down event
   */ watchSelection(e) {
        if (e.button !== $cdae29d26d2e7999$var$qn.LEFT) return;
        const { BlockManager: t1 } = this.Editor;
        this.firstSelectedBlock = t1.getBlock(e.target), this.lastSelectedBlock = this.firstSelectedBlock, this.listeners.on(document, "mouseover", this.onMouseOver), this.listeners.on(document, "mouseup", this.onMouseUp);
    }
    /**
   * Return boolean is cross block selection started:
   * there should be at least 2 selected blocks
   */ get isCrossBlockSelectionStarted() {
        return !!this.firstSelectedBlock && !!this.lastSelectedBlock && this.firstSelectedBlock !== this.lastSelectedBlock;
    }
    /**
   * Change selection state of the next Block
   * Used for CBS via Shift + arrow keys
   *
   * @param {boolean} next - if true, toggle next block. Previous otherwise
   */ toggleBlockSelectedState(e = !0) {
        const { BlockManager: t1, BlockSelection: o } = this.Editor;
        this.lastSelectedBlock || (this.lastSelectedBlock = this.firstSelectedBlock = t1.currentBlock), this.firstSelectedBlock === this.lastSelectedBlock && (this.firstSelectedBlock.selected = !0, o.clearCache(), $cdae29d26d2e7999$var$b.get().removeAllRanges());
        const i = t1.blocks.indexOf(this.lastSelectedBlock) + (e ? 1 : -1), s = t1.blocks[i];
        s && (this.lastSelectedBlock.selected !== s.selected ? (s.selected = !0, o.clearCache()) : (this.lastSelectedBlock.selected = !1, o.clearCache()), this.lastSelectedBlock = s, this.Editor.InlineToolbar.close(), s.holder.scrollIntoView({
            block: "nearest"
        }));
    }
    /**
   * Clear saved state
   *
   * @param {Event} reason - event caused clear of selection
   */ clear(e) {
        const { BlockManager: t1, BlockSelection: o, Caret: i } = this.Editor, s = t1.blocks.indexOf(this.firstSelectedBlock), r = t1.blocks.indexOf(this.lastSelectedBlock);
        if (o.anyBlockSelected && s > -1 && r > -1 && e && e instanceof KeyboardEvent) switch(e.keyCode){
            case $cdae29d26d2e7999$var$y.DOWN:
            case $cdae29d26d2e7999$var$y.RIGHT:
                i.setToBlock(t1.blocks[Math.max(s, r)], i.positions.END);
                break;
            case $cdae29d26d2e7999$var$y.UP:
            case $cdae29d26d2e7999$var$y.LEFT:
                i.setToBlock(t1.blocks[Math.min(s, r)], i.positions.START);
                break;
            default:
                i.setToBlock(t1.blocks[Math.max(s, r)], i.positions.END);
        }
        this.firstSelectedBlock = this.lastSelectedBlock = null;
    }
    /**
   * Enables Cross Block Selection
   *
   * @param {MouseEvent} event - mouse down event
   */ enableCrossBlockSelection(e) {
        const { UI: t1 } = this.Editor;
        $cdae29d26d2e7999$var$b.isCollapsed || this.Editor.BlockSelection.clearSelection(e), t1.nodes.redactor.contains(e.target) ? this.watchSelection(e) : this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * Change blocks selection state between passed two blocks.
   *
   * @param {Block} firstBlock - first block in range
   * @param {Block} lastBlock - last block in range
   */ toggleBlocksSelectedState(e, t1) {
        const { BlockManager: o, BlockSelection: i } = this.Editor, s = o.blocks.indexOf(e), r = o.blocks.indexOf(t1), a = e.selected !== t1.selected;
        for(let l = Math.min(s, r); l <= Math.max(s, r); l++){
            const c = o.blocks[l];
            c !== this.firstSelectedBlock && c !== (a ? e : t1) && (o.blocks[l].selected = !o.blocks[l].selected, i.clearCache());
        }
    }
}
class $cdae29d26d2e7999$var$ca extends $cdae29d26d2e7999$var$E {
    constructor(){
        super(...arguments), this.isStartedAtEditor = !1;
    }
    /**
   * Toggle read-only state
   *
   * if state is true:
   *  - disable all drag-n-drop event handlers
   *
   * if state is false:
   *  - restore drag-n-drop event handlers
   *
   * @param {boolean} readOnlyEnabled - "read only" state
   */ toggleReadOnly(e) {
        e ? this.disableModuleBindings() : this.enableModuleBindings();
    }
    /**
   * Add drag events listeners to editor zone
   */ enableModuleBindings() {
        const { UI: e } = this.Editor;
        this.readOnlyMutableListeners.on(e.nodes.holder, "drop", async (t1)=>{
            await this.processDrop(t1);
        }, !0), this.readOnlyMutableListeners.on(e.nodes.holder, "dragstart", ()=>{
            this.processDragStart();
        }), this.readOnlyMutableListeners.on(e.nodes.holder, "dragover", (t1)=>{
            this.processDragOver(t1);
        }, !0);
    }
    /**
   * Unbind drag-n-drop event handlers
   */ disableModuleBindings() {
        this.readOnlyMutableListeners.clearAll();
    }
    /**
   * Handle drop event
   *
   * @param {DragEvent} dropEvent - drop event
   */ async processDrop(e) {
        const { BlockManager: t1, Paste: o, Caret: i } = this.Editor;
        e.preventDefault(), t1.blocks.forEach((r)=>{
            r.dropTarget = !1;
        }), $cdae29d26d2e7999$var$b.isAtEditor && !$cdae29d26d2e7999$var$b.isCollapsed && this.isStartedAtEditor && document.execCommand("delete"), this.isStartedAtEditor = !1;
        const s = t1.setCurrentBlockByChildNode(e.target);
        if (s) this.Editor.Caret.setToBlock(s, i.positions.END);
        else {
            const r = t1.setCurrentBlockByChildNode(t1.lastBlock.holder);
            this.Editor.Caret.setToBlock(r, i.positions.END);
        }
        await o.processDataTransfer(e.dataTransfer, !0);
    }
    /**
   * Handle drag start event
   */ processDragStart() {
        $cdae29d26d2e7999$var$b.isAtEditor && !$cdae29d26d2e7999$var$b.isCollapsed && (this.isStartedAtEditor = !0), this.Editor.InlineToolbar.close();
    }
    /**
   * @param {DragEvent} dragEvent - drag event
   */ processDragOver(e) {
        e.preventDefault();
    }
}
const $cdae29d26d2e7999$var$da = 180, $cdae29d26d2e7999$var$ua = 400;
class $cdae29d26d2e7999$var$ha extends $cdae29d26d2e7999$var$E {
    /**
   * Prepare the module
   *
   * @param options - options used by the modification observer module
   * @param options.config - Editor configuration object
   * @param options.eventsDispatcher - common Editor event bus
   */ constructor({ config: e, eventsDispatcher: t1 }){
        super({
            config: e,
            eventsDispatcher: t1
        }), this.disabled = !1, this.batchingTimeout = null, this.batchingOnChangeQueue = /* @__PURE__ */ new Map(), this.batchTime = $cdae29d26d2e7999$var$ua, this.mutationObserver = new MutationObserver((o)=>{
            this.redactorChanged(o);
        }), this.eventsDispatcher.on($cdae29d26d2e7999$var$$o, (o)=>{
            this.particularBlockChanged(o.event);
        }), this.eventsDispatcher.on($cdae29d26d2e7999$var$zo, ()=>{
            this.disable();
        }), this.eventsDispatcher.on($cdae29d26d2e7999$var$Uo, ()=>{
            this.enable();
        });
    }
    /**
   * Enables onChange event
   */ enable() {
        this.mutationObserver.observe(this.Editor.UI.nodes.redactor, {
            childList: !0,
            subtree: !0,
            characterData: !0,
            attributes: !0
        }), this.disabled = !1;
    }
    /**
   * Disables onChange event
   */ disable() {
        this.mutationObserver.disconnect(), this.disabled = !0;
    }
    /**
   * Call onChange event passed to Editor.js configuration
   *
   * @param event - some of our custom change events
   */ particularBlockChanged(e) {
        this.disabled || !$cdae29d26d2e7999$var$A(this.config.onChange) || (this.batchingOnChangeQueue.set(`block:${e.detail.target.id}:event:${e.type}`, e), this.batchingTimeout && clearTimeout(this.batchingTimeout), this.batchingTimeout = setTimeout(()=>{
            let t1;
            this.batchingOnChangeQueue.size === 1 ? t1 = this.batchingOnChangeQueue.values().next().value : t1 = Array.from(this.batchingOnChangeQueue.values()), this.config.onChange && this.config.onChange(this.Editor.API.methods, t1), this.batchingOnChangeQueue.clear();
        }, this.batchTime));
    }
    /**
   * Fired on every blocks wrapper dom change
   *
   * @param mutations - mutations happened
   */ redactorChanged(e) {
        this.eventsDispatcher.emit($cdae29d26d2e7999$var$ft, {
            mutations: e
        });
    }
}
const $cdae29d26d2e7999$var$Rn = class Dn extends $cdae29d26d2e7999$var$E {
    constructor(){
        super(...arguments), this.MIME_TYPE = "application/x-editor-js", this.toolsTags = {}, this.tagsByTool = {}, this.toolsPatterns = [], this.toolsFiles = {}, this.exceptionList = [], this.processTool = (e)=>{
            try {
                const t1 = e.create({}, {}, !1);
                if (e.pasteConfig === !1) {
                    this.exceptionList.push(e.name);
                    return;
                }
                if (!$cdae29d26d2e7999$var$A(t1.onPaste)) return;
                this.getTagsConfig(e), this.getFilesConfig(e), this.getPatternsConfig(e);
            } catch (t1) {
                $cdae29d26d2e7999$var$S(`Paste handling for \xab${e.name}\xbb Tool hasn't been set up because of the error`, "warn", t1);
            }
        }, this.handlePasteEvent = async (e)=>{
            const { BlockManager: t1, Toolbar: o } = this.Editor, i = t1.setCurrentBlockByChildNode(e.target);
            !i || this.isNativeBehaviour(e.target) && !e.clipboardData.types.includes("Files") || i && this.exceptionList.includes(i.name) || (e.preventDefault(), this.processDataTransfer(e.clipboardData), o.close());
        };
    }
    /**
   * Set onPaste callback and collect tools` paste configurations
   */ async prepare() {
        this.processTools();
    }
    /**
   * Set read-only state
   *
   * @param {boolean} readOnlyEnabled - read only flag value
   */ toggleReadOnly(e) {
        e ? this.unsetCallback() : this.setCallback();
    }
    /**
   * Handle pasted or dropped data transfer object
   *
   * @param {DataTransfer} dataTransfer - pasted or dropped data transfer object
   * @param {boolean} isDragNDrop - true if data transfer comes from drag'n'drop events
   */ async processDataTransfer(e, t1 = !1) {
        const { Tools: o } = this.Editor, i = e.types;
        if ((i.includes ? i.includes("Files") : i.contains("Files")) && !$cdae29d26d2e7999$var$V(this.toolsFiles)) {
            await this.processFiles(e.files);
            return;
        }
        const r = e.getData(this.MIME_TYPE), a = e.getData("text/plain");
        let l = e.getData("text/html");
        if (r) try {
            this.insertEditorJSData(JSON.parse(r));
            return;
        } catch  {}
        t1 && a.trim() && l.trim() && (l = "<p>" + (l.trim() ? l : a) + "</p>");
        const c = Object.keys(this.toolsTags).reduce((p, g)=>(p[g.toLowerCase()] = this.toolsTags[g].sanitizationConfig ?? {}, p), {}), d = Object.assign({}, c, o.getAllInlineToolsSanitizeConfig(), {
            br: {}
        }), h = $cdae29d26d2e7999$var$Z(l, d);
        !h.trim() || h.trim() === a || !$cdae29d26d2e7999$var$u.isHTMLString(h) ? await this.processText(a) : await this.processText(h, !0);
    }
    /**
   * Process pasted text and divide them into Blocks
   *
   * @param {string} data - text to process. Can be HTML or plain.
   * @param {boolean} isHTML - if passed string is HTML, this parameter should be true
   */ async processText(e, t1 = !1) {
        const { Caret: o, BlockManager: i } = this.Editor, s = t1 ? this.processHTML(e) : this.processPlain(e);
        if (!s.length) return;
        if (s.length === 1) {
            s[0].isBlock ? this.processSingleBlock(s.pop()) : this.processInlinePaste(s.pop());
            return;
        }
        const a = i.currentBlock && i.currentBlock.tool.isDefault && i.currentBlock.isEmpty;
        s.map(async (l, c)=>this.insertBlock(l, c === 0 && a)), i.currentBlock && o.setToBlock(i.currentBlock, o.positions.END);
    }
    /**
   * Set onPaste callback handler
   */ setCallback() {
        this.listeners.on(this.Editor.UI.nodes.holder, "paste", this.handlePasteEvent);
    }
    /**
   * Unset onPaste callback handler
   */ unsetCallback() {
        this.listeners.off(this.Editor.UI.nodes.holder, "paste", this.handlePasteEvent);
    }
    /**
   * Get and process tool`s paste configs
   */ processTools() {
        const e = this.Editor.Tools.blockTools;
        Array.from(e.values()).forEach(this.processTool);
    }
    /**
   * Get tags name list from either tag name or sanitization config.
   *
   * @param {string | object} tagOrSanitizeConfig - tag name or sanitize config object.
   * @returns {string[]} array of tags.
   */ collectTagNames(e) {
        return $cdae29d26d2e7999$var$te(e) ? [
            e
        ] : $cdae29d26d2e7999$var$D(e) ? Object.keys(e) : [];
    }
    /**
   * Get tags to substitute by Tool
   *
   * @param tool - BlockTool object
   */ getTagsConfig(e) {
        if (e.pasteConfig === !1) return;
        const t1 = e.pasteConfig.tags || [], o = [];
        t1.forEach((i)=>{
            const s = this.collectTagNames(i);
            o.push(...s), s.forEach((r)=>{
                if (Object.prototype.hasOwnProperty.call(this.toolsTags, r)) {
                    $cdae29d26d2e7999$var$S(`Paste handler for \xab${e.name}\xbb Tool on \xab${r}\xbb tag is skipped because it is already used by \xab${this.toolsTags[r].tool.name}\xbb Tool.`, "warn");
                    return;
                }
                const a = $cdae29d26d2e7999$var$D(i) ? i[r] : null;
                this.toolsTags[r.toUpperCase()] = {
                    tool: e,
                    sanitizationConfig: a
                };
            });
        }), this.tagsByTool[e.name] = o.map((i)=>i.toUpperCase());
    }
    /**
   * Get files` types and extensions to substitute by Tool
   *
   * @param tool - BlockTool object
   */ getFilesConfig(e) {
        if (e.pasteConfig === !1) return;
        const { files: t1 = {} } = e.pasteConfig;
        let { extensions: o, mimeTypes: i } = t1;
        !o && !i || (o && !Array.isArray(o) && ($cdae29d26d2e7999$var$S(`\xabextensions\xbb property of the onDrop config for \xab${e.name}\xbb Tool should be an array`), o = []), i && !Array.isArray(i) && ($cdae29d26d2e7999$var$S(`\xabmimeTypes\xbb property of the onDrop config for \xab${e.name}\xbb Tool should be an array`), i = []), i && (i = i.filter((s)=>$cdae29d26d2e7999$var$ei(s) ? !0 : ($cdae29d26d2e7999$var$S(`MIME type value \xab${s}\xbb for the \xab${e.name}\xbb Tool is not a valid MIME type`, "warn"), !1))), this.toolsFiles[e.name] = {
            extensions: o || [],
            mimeTypes: i || []
        });
    }
    /**
   * Get RegExp patterns to substitute by Tool
   *
   * @param tool - BlockTool object
   */ getPatternsConfig(e) {
        e.pasteConfig === !1 || !e.pasteConfig.patterns || $cdae29d26d2e7999$var$V(e.pasteConfig.patterns) || Object.entries(e.pasteConfig.patterns).forEach(([t1, o])=>{
            o instanceof RegExp || $cdae29d26d2e7999$var$S(`Pattern ${o} for \xab${e.name}\xbb Tool is skipped because it should be a Regexp instance.`, "warn"), this.toolsPatterns.push({
                key: t1,
                pattern: o,
                tool: e
            });
        });
    }
    /**
   * Check if browser behavior suits better
   *
   * @param {EventTarget} element - element where content has been pasted
   * @returns {boolean}
   */ isNativeBehaviour(e) {
        return $cdae29d26d2e7999$var$u.isNativeInput(e);
    }
    /**
   * Get files from data transfer object and insert related Tools
   *
   * @param {FileList} items - pasted or dropped items
   */ async processFiles(e) {
        const { BlockManager: t1 } = this.Editor;
        let o;
        o = await Promise.all(Array.from(e).map((r)=>this.processFile(r))), o = o.filter((r)=>!!r);
        const s = t1.currentBlock.tool.isDefault && t1.currentBlock.isEmpty;
        o.forEach((r, a)=>{
            t1.paste(r.type, r.event, a === 0 && s);
        });
    }
    /**
   * Get information about file and find Tool to handle it
   *
   * @param {File} file - file to process
   */ async processFile(e) {
        const t1 = $cdae29d26d2e7999$var$Jn(e), o = Object.entries(this.toolsFiles).find(([r, { mimeTypes: a, extensions: l }])=>{
            const [c, d] = e.type.split("/"), h = l.find((g)=>g.toLowerCase() === t1.toLowerCase()), p = a.find((g)=>{
                const [f, v] = g.split("/");
                return f === c && (v === d || v === "*");
            });
            return !!h || !!p;
        });
        if (!o) return;
        const [i] = o;
        return {
            event: this.composePasteEvent("file", {
                file: e
            }),
            type: i
        };
    }
    /**
   * Split HTML string to blocks and return it as array of Block data
   *
   * @param {string} innerHTML - html string to process
   * @returns {PasteData[]}
   */ processHTML(e) {
        const { Tools: t1 } = this.Editor, o = $cdae29d26d2e7999$var$u.make("DIV");
        return o.innerHTML = e, this.getNodes(o).map((s)=>{
            let r, a = t1.defaultTool, l = !1;
            switch(s.nodeType){
                case Node.DOCUMENT_FRAGMENT_NODE:
                    r = $cdae29d26d2e7999$var$u.make("div"), r.appendChild(s);
                    break;
                case Node.ELEMENT_NODE:
                    r = s, l = !0, this.toolsTags[r.tagName] && (a = this.toolsTags[r.tagName].tool);
                    break;
            }
            const { tags: c } = a.pasteConfig || {
                tags: []
            }, d = c.reduce((g, f)=>(this.collectTagNames(f).forEach((O)=>{
                    const T = $cdae29d26d2e7999$var$D(f) ? f[O] : null;
                    g[O.toLowerCase()] = T || {};
                }), g), {}), h = Object.assign({}, d, a.baseSanitizeConfig);
            if (r.tagName.toLowerCase() === "table") {
                const g = $cdae29d26d2e7999$var$Z(r.outerHTML, h);
                r = $cdae29d26d2e7999$var$u.make("div", void 0, {
                    innerHTML: g
                }).firstChild;
            } else r.innerHTML = $cdae29d26d2e7999$var$Z(r.innerHTML, h);
            const p = this.composePasteEvent("tag", {
                data: r
            });
            return {
                content: r,
                isBlock: l,
                tool: a.name,
                event: p
            };
        }).filter((s)=>{
            const r = $cdae29d26d2e7999$var$u.isEmpty(s.content), a = $cdae29d26d2e7999$var$u.isSingleTag(s.content);
            return !r || a;
        });
    }
    /**
   * Split plain text by new line symbols and return it as array of Block data
   *
   * @param {string} plain - string to process
   * @returns {PasteData[]}
   */ processPlain(e) {
        const { defaultBlock: t1 } = this.config;
        if (!e) return [];
        const o = t1;
        return e.split(/\r?\n/).filter((i)=>i.trim()).map((i)=>{
            const s = $cdae29d26d2e7999$var$u.make("div");
            s.textContent = i;
            const r = this.composePasteEvent("tag", {
                data: s
            });
            return {
                content: s,
                tool: o,
                isBlock: !1,
                event: r
            };
        });
    }
    /**
   * Process paste of single Block tool content
   *
   * @param {PasteData} dataToInsert - data of Block to insert
   */ async processSingleBlock(e) {
        const { Caret: t1, BlockManager: o } = this.Editor, { currentBlock: i } = o;
        if (!i || e.tool !== i.name || !$cdae29d26d2e7999$var$u.containsOnlyInlineElements(e.content.innerHTML)) {
            this.insertBlock(e, (i == null ? void 0 : i.tool.isDefault) && i.isEmpty);
            return;
        }
        t1.insertContentAtCaretPosition(e.content.innerHTML);
    }
    /**
   * Process paste to single Block:
   * 1. Find patterns` matches
   * 2. Insert new block if it is not the same type as current one
   * 3. Just insert text if there is no substitutions
   *
   * @param {PasteData} dataToInsert - data of Block to insert
   */ async processInlinePaste(e) {
        const { BlockManager: t1, Caret: o } = this.Editor, { content: i } = e;
        if (t1.currentBlock && t1.currentBlock.tool.isDefault && i.textContent.length < Dn.PATTERN_PROCESSING_MAX_LENGTH) {
            const r = await this.processPattern(i.textContent);
            if (r) {
                const a = t1.currentBlock && t1.currentBlock.tool.isDefault && t1.currentBlock.isEmpty, l = t1.paste(r.tool, r.event, a);
                o.setToBlock(l, o.positions.END);
                return;
            }
        }
        if (t1.currentBlock && t1.currentBlock.currentInput) {
            const r = t1.currentBlock.tool.baseSanitizeConfig;
            document.execCommand("insertHTML", !1, $cdae29d26d2e7999$var$Z(i.innerHTML, r));
        } else this.insertBlock(e);
    }
    /**
   * Get patterns` matches
   *
   * @param {string} text - text to process
   * @returns {Promise<{event: PasteEvent, tool: string}>}
   */ async processPattern(e) {
        const t1 = this.toolsPatterns.find((i)=>{
            const s = i.pattern.exec(e);
            return s ? e === s.shift() : !1;
        });
        return t1 ? {
            event: this.composePasteEvent("pattern", {
                key: t1.key,
                data: e
            }),
            tool: t1.tool.name
        } : void 0;
    }
    /**
   * Insert pasted Block content to Editor
   *
   * @param {PasteData} data - data to insert
   * @param {boolean} canReplaceCurrentBlock - if true and is current Block is empty, will replace current Block
   * @returns {void}
   */ insertBlock(e, t1 = !1) {
        const { BlockManager: o, Caret: i } = this.Editor, { currentBlock: s } = o;
        let r;
        if (t1 && s && s.isEmpty) {
            r = o.paste(e.tool, e.event, !0), i.setToBlock(r, i.positions.END);
            return;
        }
        r = o.paste(e.tool, e.event), i.setToBlock(r, i.positions.END);
    }
    /**
   * Insert data passed as application/x-editor-js JSON
   *
   * @param {Array} blocks — Blocks' data to insert
   * @returns {void}
   */ insertEditorJSData(e) {
        const { BlockManager: t1, Caret: o, Tools: i } = this.Editor;
        $cdae29d26d2e7999$var$yt(e, (r)=>i.blockTools.get(r).sanitizeConfig).forEach(({ tool: r, data: a }, l)=>{
            let c = !1;
            l === 0 && (c = t1.currentBlock && t1.currentBlock.tool.isDefault && t1.currentBlock.isEmpty);
            const d = t1.insert({
                tool: r,
                data: a,
                replace: c
            });
            o.setToBlock(d, o.positions.END);
        });
    }
    /**
   * Fetch nodes from Element node
   *
   * @param {Node} node - current node
   * @param {Node[]} nodes - processed nodes
   * @param {Node} destNode - destination node
   */ processElementNode(e, t1, o) {
        const i = Object.keys(this.toolsTags), s = e, { tool: r } = this.toolsTags[s.tagName] || {}, a = this.tagsByTool[r == null ? void 0 : r.name] || [], l = i.includes(s.tagName), c = $cdae29d26d2e7999$var$u.blockElements.includes(s.tagName.toLowerCase()), d = Array.from(s.children).some(({ tagName: p })=>i.includes(p) && !a.includes(p)), h = Array.from(s.children).some(({ tagName: p })=>$cdae29d26d2e7999$var$u.blockElements.includes(p.toLowerCase()));
        if (!c && !l && !d) return o.appendChild(s), [
            ...t1,
            o
        ];
        if (l && !d || c && !h && !d) return [
            ...t1,
            o,
            s
        ];
    }
    /**
   * Recursively divide HTML string to two types of nodes:
   * 1. Block element
   * 2. Document Fragments contained text and markup tags like a, b, i etc.
   *
   * @param {Node} wrapper - wrapper of paster HTML content
   * @returns {Node[]}
   */ getNodes(e) {
        const t1 = Array.from(e.childNodes);
        let o;
        const i = (s, r)=>{
            if ($cdae29d26d2e7999$var$u.isEmpty(r) && !$cdae29d26d2e7999$var$u.isSingleTag(r)) return s;
            const a = s[s.length - 1];
            let l = new DocumentFragment();
            switch(a && $cdae29d26d2e7999$var$u.isFragment(a) && (l = s.pop()), r.nodeType){
                case Node.ELEMENT_NODE:
                    if (o = this.processElementNode(r, s, l), o) return o;
                    break;
                case Node.TEXT_NODE:
                    return l.appendChild(r), [
                        ...s,
                        l
                    ];
                default:
                    return [
                        ...s,
                        l
                    ];
            }
            return [
                ...s,
                ...Array.from(r.childNodes).reduce(i, [])
            ];
        };
        return t1.reduce(i, []);
    }
    /**
   * Compose paste event with passed type and detail
   *
   * @param {string} type - event type
   * @param {PasteEventDetail} detail - event detail
   */ composePasteEvent(e, t1) {
        return new CustomEvent(e, {
            detail: t1
        });
    }
};
$cdae29d26d2e7999$var$Rn.PATTERN_PROCESSING_MAX_LENGTH = 450;
let $cdae29d26d2e7999$var$pa = $cdae29d26d2e7999$var$Rn;
class $cdae29d26d2e7999$var$fa extends $cdae29d26d2e7999$var$E {
    constructor(){
        super(...arguments), this.toolsDontSupportReadOnly = [], this.readOnlyEnabled = !1;
    }
    /**
   * Returns state of read only mode
   */ get isEnabled() {
        return this.readOnlyEnabled;
    }
    /**
   * Set initial state
   */ async prepare() {
        const { Tools: e } = this.Editor, { blockTools: t1 } = e, o = [];
        Array.from(t1.entries()).forEach(([i, s])=>{
            s.isReadOnlySupported || o.push(i);
        }), this.toolsDontSupportReadOnly = o, this.config.readOnly && o.length > 0 && this.throwCriticalError(), this.toggle(this.config.readOnly, !0);
    }
    /**
   * Set read-only mode or toggle current state
   * Call all Modules `toggleReadOnly` method and re-render Editor
   *
   * @param state - (optional) read-only state or toggle
   * @param isInitial - (optional) true when editor is initializing
   */ async toggle(e = !this.readOnlyEnabled, t1 = !1) {
        e && this.toolsDontSupportReadOnly.length > 0 && this.throwCriticalError();
        const o = this.readOnlyEnabled;
        this.readOnlyEnabled = e;
        for(const s in this.Editor)this.Editor[s].toggleReadOnly && this.Editor[s].toggleReadOnly(e);
        if (o === e) return this.readOnlyEnabled;
        if (t1) return this.readOnlyEnabled;
        this.Editor.ModificationsObserver.disable();
        const i = await this.Editor.Saver.save();
        return await this.Editor.BlockManager.clear(), await this.Editor.Renderer.render(i.blocks), this.Editor.ModificationsObserver.enable(), this.readOnlyEnabled;
    }
    /**
   * Throws an error about tools which don't support read-only mode
   */ throwCriticalError() {
        throw new $cdae29d26d2e7999$var$Ho(`To enable read-only mode all connected tools should support it. Tools ${this.toolsDontSupportReadOnly.join(", ")} don't support read-only mode.`);
    }
}
class $cdae29d26d2e7999$var$Be extends $cdae29d26d2e7999$var$E {
    constructor(){
        super(...arguments), this.isRectSelectionActivated = !1, this.SCROLL_SPEED = 3, this.HEIGHT_OF_SCROLL_ZONE = 40, this.BOTTOM_SCROLL_ZONE = 1, this.TOP_SCROLL_ZONE = 2, this.MAIN_MOUSE_BUTTON = 0, this.mousedown = !1, this.isScrolling = !1, this.inScrollZone = null, this.startX = 0, this.startY = 0, this.mouseX = 0, this.mouseY = 0, this.stackOfSelected = [], this.listenerIds = [];
    }
    /**
   * CSS classes for the Block
   *
   * @returns {{wrapper: string, content: string}}
   */ static get CSS() {
        return {
            overlay: "codex-editor-overlay",
            overlayContainer: "codex-editor-overlay__container",
            rect: "codex-editor-overlay__rectangle",
            topScrollZone: "codex-editor-overlay__scroll-zone--top",
            bottomScrollZone: "codex-editor-overlay__scroll-zone--bottom"
        };
    }
    /**
   * Module Preparation
   * Creating rect and hang handlers
   */ prepare() {
        this.enableModuleBindings();
    }
    /**
   * Init rect params
   *
   * @param {number} pageX - X coord of mouse
   * @param {number} pageY - Y coord of mouse
   */ startSelection(e, t1) {
        const o = document.elementFromPoint(e - window.pageXOffset, t1 - window.pageYOffset);
        o.closest(`.${this.Editor.Toolbar.CSS.toolbar}`) || (this.Editor.BlockSelection.allBlocksSelected = !1, this.clearSelection(), this.stackOfSelected = []);
        const s = [
            `.${$cdae29d26d2e7999$var$R.CSS.content}`,
            `.${this.Editor.Toolbar.CSS.toolbar}`,
            `.${this.Editor.InlineToolbar.CSS.inlineToolbar}`
        ], r = o.closest("." + this.Editor.UI.CSS.editorWrapper), a = s.some((l)=>!!o.closest(l));
        !r || a || (this.mousedown = !0, this.startX = e, this.startY = t1);
    }
    /**
   * Clear all params to end selection
   */ endSelection() {
        this.mousedown = !1, this.startX = 0, this.startY = 0, this.overlayRectangle.style.display = "none";
    }
    /**
   * is RectSelection Activated
   */ isRectActivated() {
        return this.isRectSelectionActivated;
    }
    /**
   * Mark that selection is end
   */ clearSelection() {
        this.isRectSelectionActivated = !1;
    }
    /**
   * Sets Module necessary event handlers
   */ enableModuleBindings() {
        const { container: e } = this.genHTML();
        this.listeners.on(e, "mousedown", (t1)=>{
            this.processMouseDown(t1);
        }, !1), this.listeners.on(document.body, "mousemove", $cdae29d26d2e7999$var$dt((t1)=>{
            this.processMouseMove(t1);
        }, 10), {
            passive: !0
        }), this.listeners.on(document.body, "mouseleave", ()=>{
            this.processMouseLeave();
        }), this.listeners.on(window, "scroll", $cdae29d26d2e7999$var$dt((t1)=>{
            this.processScroll(t1);
        }, 10), {
            passive: !0
        }), this.listeners.on(document.body, "mouseup", ()=>{
            this.processMouseUp();
        }, !1);
    }
    /**
   * Handle mouse down events
   *
   * @param {MouseEvent} mouseEvent - mouse event payload
   */ processMouseDown(e) {
        if (e.button !== this.MAIN_MOUSE_BUTTON) return;
        e.target.closest($cdae29d26d2e7999$var$u.allInputsSelector) !== null || this.startSelection(e.pageX, e.pageY);
    }
    /**
   * Handle mouse move events
   *
   * @param {MouseEvent} mouseEvent - mouse event payload
   */ processMouseMove(e) {
        this.changingRectangle(e), this.scrollByZones(e.clientY);
    }
    /**
   * Handle mouse leave
   */ processMouseLeave() {
        this.clearSelection(), this.endSelection();
    }
    /**
   * @param {MouseEvent} mouseEvent - mouse event payload
   */ processScroll(e) {
        this.changingRectangle(e);
    }
    /**
   * Handle mouse up
   */ processMouseUp() {
        this.clearSelection(), this.endSelection();
    }
    /**
   * Scroll If mouse in scroll zone
   *
   * @param {number} clientY - Y coord of mouse
   */ scrollByZones(e) {
        if (this.inScrollZone = null, e <= this.HEIGHT_OF_SCROLL_ZONE && (this.inScrollZone = this.TOP_SCROLL_ZONE), document.documentElement.clientHeight - e <= this.HEIGHT_OF_SCROLL_ZONE && (this.inScrollZone = this.BOTTOM_SCROLL_ZONE), !this.inScrollZone) {
            this.isScrolling = !1;
            return;
        }
        this.isScrolling || (this.scrollVertical(this.inScrollZone === this.TOP_SCROLL_ZONE ? -this.SCROLL_SPEED : this.SCROLL_SPEED), this.isScrolling = !0);
    }
    /**
   * Generates required HTML elements
   *
   * @returns {Object<string, Element>}
   */ genHTML() {
        const { UI: e } = this.Editor, t1 = e.nodes.holder.querySelector("." + e.CSS.editorWrapper), o = $cdae29d26d2e7999$var$u.make("div", $cdae29d26d2e7999$var$Be.CSS.overlay, {}), i = $cdae29d26d2e7999$var$u.make("div", $cdae29d26d2e7999$var$Be.CSS.overlayContainer, {}), s = $cdae29d26d2e7999$var$u.make("div", $cdae29d26d2e7999$var$Be.CSS.rect, {});
        return i.appendChild(s), o.appendChild(i), t1.appendChild(o), this.overlayRectangle = s, {
            container: t1,
            overlay: o
        };
    }
    /**
   * Activates scrolling if blockSelection is active and mouse is in scroll zone
   *
   * @param {number} speed - speed of scrolling
   */ scrollVertical(e) {
        if (!(this.inScrollZone && this.mousedown)) return;
        const t1 = window.pageYOffset;
        window.scrollBy(0, e), this.mouseY += window.pageYOffset - t1, setTimeout(()=>{
            this.scrollVertical(e);
        }, 0);
    }
    /**
   * Handles the change in the rectangle and its effect
   *
   * @param {MouseEvent} event - mouse event
   */ changingRectangle(e) {
        if (!this.mousedown) return;
        e.pageY !== void 0 && (this.mouseX = e.pageX, this.mouseY = e.pageY);
        const { rightPos: t1, leftPos: o, index: i } = this.genInfoForMouseSelection(), s = this.startX > t1 && this.mouseX > t1, r = this.startX < o && this.mouseX < o;
        this.rectCrossesBlocks = !(s || r), this.isRectSelectionActivated || (this.rectCrossesBlocks = !1, this.isRectSelectionActivated = !0, this.shrinkRectangleToPoint(), this.overlayRectangle.style.display = "block"), this.updateRectangleSize(), this.Editor.Toolbar.close(), i !== void 0 && (this.trySelectNextBlock(i), this.inverseSelection(), $cdae29d26d2e7999$var$b.get().removeAllRanges());
    }
    /**
   * Shrink rect to singular point
   */ shrinkRectangleToPoint() {
        this.overlayRectangle.style.left = `${this.startX - window.pageXOffset}px`, this.overlayRectangle.style.top = `${this.startY - window.pageYOffset}px`, this.overlayRectangle.style.bottom = `calc(100% - ${this.startY - window.pageYOffset}px`, this.overlayRectangle.style.right = `calc(100% - ${this.startX - window.pageXOffset}px`;
    }
    /**
   * Select or unselect all of blocks in array if rect is out or in selectable area
   */ inverseSelection() {
        const t1 = this.Editor.BlockManager.getBlockByIndex(this.stackOfSelected[0]).selected;
        if (this.rectCrossesBlocks && !t1) for (const o of this.stackOfSelected)this.Editor.BlockSelection.selectBlockByIndex(o);
        if (!this.rectCrossesBlocks && t1) for (const o of this.stackOfSelected)this.Editor.BlockSelection.unSelectBlockByIndex(o);
    }
    /**
   * Updates size of rectangle
   */ updateRectangleSize() {
        this.mouseY >= this.startY ? (this.overlayRectangle.style.top = `${this.startY - window.pageYOffset}px`, this.overlayRectangle.style.bottom = `calc(100% - ${this.mouseY - window.pageYOffset}px`) : (this.overlayRectangle.style.bottom = `calc(100% - ${this.startY - window.pageYOffset}px`, this.overlayRectangle.style.top = `${this.mouseY - window.pageYOffset}px`), this.mouseX >= this.startX ? (this.overlayRectangle.style.left = `${this.startX - window.pageXOffset}px`, this.overlayRectangle.style.right = `calc(100% - ${this.mouseX - window.pageXOffset}px`) : (this.overlayRectangle.style.right = `calc(100% - ${this.startX - window.pageXOffset}px`, this.overlayRectangle.style.left = `${this.mouseX - window.pageXOffset}px`);
    }
    /**
   * Collects information needed to determine the behavior of the rectangle
   *
   * @returns {object} index - index next Block, leftPos - start of left border of Block, rightPos - right border
   */ genInfoForMouseSelection() {
        const t1 = document.body.offsetWidth / 2, o = this.mouseY - window.pageYOffset, i = document.elementFromPoint(t1, o), s = this.Editor.BlockManager.getBlockByChildNode(i);
        let r;
        s !== void 0 && (r = this.Editor.BlockManager.blocks.findIndex((h)=>h.holder === s.holder));
        const a = this.Editor.BlockManager.lastBlock.holder.querySelector("." + $cdae29d26d2e7999$var$R.CSS.content), l = Number.parseInt(window.getComputedStyle(a).width, 10) / 2, c = t1 - l, d = t1 + l;
        return {
            index: r,
            leftPos: c,
            rightPos: d
        };
    }
    /**
   * Select block with index index
   *
   * @param index - index of block in redactor
   */ addBlockInSelection(e) {
        this.rectCrossesBlocks && this.Editor.BlockSelection.selectBlockByIndex(e), this.stackOfSelected.push(e);
    }
    /**
   * Adds a block to the selection and determines which blocks should be selected
   *
   * @param {object} index - index of new block in the reactor
   */ trySelectNextBlock(e) {
        const t1 = this.stackOfSelected[this.stackOfSelected.length - 1] === e, o = this.stackOfSelected.length, i = 1, s = -1, r = 0;
        if (t1) return;
        const a = this.stackOfSelected[o - 1] - this.stackOfSelected[o - 2] > 0;
        let l = r;
        o > 1 && (l = a ? i : s);
        const c = e > this.stackOfSelected[o - 1] && l === i, d = e < this.stackOfSelected[o - 1] && l === s, p = !(c || d || l === r);
        if (!p && (e > this.stackOfSelected[o - 1] || this.stackOfSelected[o - 1] === void 0)) {
            let v = this.stackOfSelected[o - 1] + 1 || e;
            for(v; v <= e; v++)this.addBlockInSelection(v);
            return;
        }
        if (!p && e < this.stackOfSelected[o - 1]) {
            for(let v = this.stackOfSelected[o - 1] - 1; v >= e; v--)this.addBlockInSelection(v);
            return;
        }
        if (!p) return;
        let g = o - 1, f;
        for(e > this.stackOfSelected[o - 1] ? f = ()=>e > this.stackOfSelected[g] : f = ()=>e < this.stackOfSelected[g]; f();)this.rectCrossesBlocks && this.Editor.BlockSelection.unSelectBlockByIndex(this.stackOfSelected[g]), this.stackOfSelected.pop(), g--;
    }
}
class $cdae29d26d2e7999$var$ga extends $cdae29d26d2e7999$var$E {
    /**
   * Renders passed blocks as one batch
   *
   * @param blocksData - blocks to render
   */ async render(e) {
        return new Promise((t1)=>{
            const { Tools: o, BlockManager: i } = this.Editor;
            if (e.length === 0) i.insert();
            else {
                const s = e.map(({ type: r, data: a, tunes: l, id: c })=>{
                    o.available.has(r) === !1 && ($cdae29d26d2e7999$var$X(`Tool \xab${r}\xbb is not found. Check 'tools' property at the Editor.js config.`, "warn"), a = this.composeStubDataForTool(r, a, c), r = o.stubTool);
                    let d;
                    try {
                        d = i.composeBlock({
                            id: c,
                            tool: r,
                            data: a,
                            tunes: l
                        });
                    } catch (h) {
                        $cdae29d26d2e7999$var$S(`Block \xab${r}\xbb skipped because of plugins error`, "error", {
                            data: a,
                            error: h
                        }), a = this.composeStubDataForTool(r, a, c), r = o.stubTool, d = i.composeBlock({
                            id: c,
                            tool: r,
                            data: a,
                            tunes: l
                        });
                    }
                    return d;
                });
                i.insertMany(s);
            }
            window.requestIdleCallback(()=>{
                t1();
            }, {
                timeout: 2e3
            });
        });
    }
    /**
   * Create data for the Stub Tool that will be used instead of unavailable tool
   *
   * @param tool - unavailable tool name to stub
   * @param data - data of unavailable block
   * @param [id] - id of unavailable block
   */ composeStubDataForTool(e, t1, o) {
        const { Tools: i } = this.Editor;
        let s = e;
        if (i.unavailable.has(e)) {
            const r = i.unavailable.get(e).toolbox;
            r !== void 0 && r[0].title !== void 0 && (s = r[0].title);
        }
        return {
            savedData: {
                id: o,
                type: e,
                data: t1
            },
            title: s
        };
    }
}
class $cdae29d26d2e7999$var$ma extends $cdae29d26d2e7999$var$E {
    /**
   * Composes new chain of Promises to fire them alternatelly
   *
   * @returns {OutputData}
   */ async save() {
        const { BlockManager: e, Tools: t1 } = this.Editor, o = e.blocks, i = [];
        try {
            o.forEach((a)=>{
                i.push(this.getSavedData(a));
            });
            const s = await Promise.all(i), r = await $cdae29d26d2e7999$var$yt(s, (a)=>t1.blockTools.get(a).sanitizeConfig);
            return this.makeOutput(r);
        } catch (s) {
            $cdae29d26d2e7999$var$X("Saving failed due to the Error %o", "error", s);
        }
    }
    /**
   * Saves and validates
   *
   * @param {Block} block - Editor's Tool
   * @returns {ValidatedData} - Tool's validated data
   */ async getSavedData(e) {
        const t1 = await e.save(), o = t1 && await e.validate(t1.data);
        return {
            ...t1,
            isValid: o
        };
    }
    /**
   * Creates output object with saved data, time and version of editor
   *
   * @param {ValidatedData} allExtractedData - data extracted from Blocks
   * @returns {OutputData}
   */ makeOutput(e) {
        const t1 = [];
        return e.forEach(({ id: o, tool: i, data: s, tunes: r, isValid: a })=>{
            if (!a) {
                $cdae29d26d2e7999$var$S(`Block \xab${i}\xbb skipped because saved data is invalid`);
                return;
            }
            if (i === this.Editor.Tools.stubTool) {
                t1.push(s);
                return;
            }
            const l = {
                id: o,
                type: i,
                data: s,
                ...!$cdae29d26d2e7999$var$V(r) && {
                    tunes: r
                }
            };
            t1.push(l);
        }), {
            time: +/* @__PURE__ */ new Date(),
            blocks: t1,
            version: "2.31.0"
        };
    }
}
(function() {
    try {
        if (typeof document < "u") {
            var n = document.createElement("style");
            n.appendChild(document.createTextNode(".ce-paragraph{line-height:1.6em;outline:none}.ce-block:only-of-type .ce-paragraph[data-placeholder-active]:empty:before,.ce-block:only-of-type .ce-paragraph[data-placeholder-active][data-empty=true]:before{content:attr(data-placeholder-active)}.ce-paragraph p:first-of-type{margin-top:0}.ce-paragraph p:last-of-type{margin-bottom:0}")), document.head.appendChild(n);
        }
    } catch (e) {
        console.error("vite-plugin-css-injected-by-js", e);
    }
})();
const $cdae29d26d2e7999$var$ba = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 9V7.2C8 7.08954 8.08954 7 8.2 7L12 7M16 9V7.2C16 7.08954 15.9105 7 15.8 7L12 7M12 7L12 17M12 17H10M12 17H14"/></svg>';
function $cdae29d26d2e7999$var$va(n) {
    const e = document.createElement("div");
    e.innerHTML = n.trim();
    const t1 = document.createDocumentFragment();
    return t1.append(...Array.from(e.childNodes)), t1;
}
/**
 * Base Paragraph Block for the Editor.js.
 * Represents a regular text block
 *
 * @author CodeX (team@codex.so)
 * @copyright CodeX 2018
 * @license The MIT License (MIT)
 */ class $cdae29d26d2e7999$var$fo {
    /**
   * Default placeholder for Paragraph Tool
   *
   * @returns {string}
   * @class
   */ static get DEFAULT_PLACEHOLDER() {
        return "";
    }
    /**
   * Render plugin`s main Element and fill it with saved data
   *
   * @param {object} params - constructor params
   * @param {ParagraphData} params.data - previously saved data
   * @param {ParagraphConfig} params.config - user config for Tool
   * @param {object} params.api - editor.js api
   * @param {boolean} readOnly - read only mode flag
   */ constructor({ data: e, config: t1, api: o, readOnly: i }){
        this.api = o, this.readOnly = i, this._CSS = {
            block: this.api.styles.block,
            wrapper: "ce-paragraph"
        }, this.readOnly || (this.onKeyUp = this.onKeyUp.bind(this)), this._placeholder = t1.placeholder ? t1.placeholder : $cdae29d26d2e7999$var$fo.DEFAULT_PLACEHOLDER, this._data = e ?? {}, this._element = null, this._preserveBlank = t1.preserveBlank ?? !1;
    }
    /**
   * Check if text content is empty and set empty string to inner html.
   * We need this because some browsers (e.g. Safari) insert <br> into empty contenteditanle elements
   *
   * @param {KeyboardEvent} e - key up event
   */ onKeyUp(e) {
        if (e.code !== "Backspace" && e.code !== "Delete" || !this._element) return;
        const { textContent: t1 } = this._element;
        t1 === "" && (this._element.innerHTML = "");
    }
    /**
   * Create Tool's view
   *
   * @returns {HTMLDivElement}
   * @private
   */ drawView() {
        const e = document.createElement("DIV");
        return e.classList.add(this._CSS.wrapper, this._CSS.block), e.contentEditable = "false", e.dataset.placeholderActive = this.api.i18n.t(this._placeholder), this._data.text && (e.innerHTML = this._data.text), this.readOnly || (e.contentEditable = "true", e.addEventListener("keyup", this.onKeyUp)), e;
    }
    /**
   * Return Tool's view
   *
   * @returns {HTMLDivElement}
   */ render() {
        return this._element = this.drawView(), this._element;
    }
    /**
   * Method that specified how to merge two Text blocks.
   * Called by Editor.js by backspace at the beginning of the Block
   *
   * @param {ParagraphData} data
   * @public
   */ merge(e) {
        if (!this._element) return;
        this._data.text += e.text;
        const t1 = $cdae29d26d2e7999$var$va(e.text);
        this._element.appendChild(t1), this._element.normalize();
    }
    /**
   * Validate Paragraph block data:
   * - check for emptiness
   *
   * @param {ParagraphData} savedData — data received after saving
   * @returns {boolean} false if saved data is not correct, otherwise true
   * @public
   */ validate(e) {
        return !(e.text.trim() === "" && !this._preserveBlank);
    }
    /**
   * Extract Tool's data from the view
   *
   * @param {HTMLDivElement} toolsContent - Paragraph tools rendered view
   * @returns {ParagraphData} - saved data
   * @public
   */ save(e) {
        return {
            text: e.innerHTML
        };
    }
    /**
   * On paste callback fired from Editor.
   *
   * @param {HTMLPasteEvent} event - event with pasted data
   */ onPaste(e) {
        const t1 = {
            text: e.detail.data.innerHTML
        };
        this._data = t1, window.requestAnimationFrame(()=>{
            this._element && (this._element.innerHTML = this._data.text || "");
        });
    }
    /**
   * Enable Conversion Toolbar. Paragraph can be converted to/from other tools
   * @returns {ConversionConfig}
   */ static get conversionConfig() {
        return {
            export: "text",
            // to convert Paragraph to other block, use 'text' property of saved data
            import: "text"
        };
    }
    /**
   * Sanitizer rules
   * @returns {SanitizerConfig} - Edtior.js sanitizer config
   */ static get sanitize() {
        return {
            text: {
                br: !0
            }
        };
    }
    /**
   * Returns true to notify the core that read-only mode is supported
   *
   * @returns {boolean}
   */ static get isReadOnlySupported() {
        return !0;
    }
    /**
   * Used by Editor paste handling API.
   * Provides configuration to handle P tags.
   *
   * @returns {PasteConfig} - Paragraph Paste Setting
   */ static get pasteConfig() {
        return {
            tags: [
                "P"
            ]
        };
    }
    /**
   * Icon and title for displaying at the Toolbox
   *
   * @returns {ToolboxConfig} - Paragraph Toolbox Setting
   */ static get toolbox() {
        return {
            icon: $cdae29d26d2e7999$var$ba,
            title: "Text"
        };
    }
}
class $cdae29d26d2e7999$var$go {
    constructor(){
        this.commandName = "bold";
    }
    /**
   * Sanitizer Rule
   * Leave <b> tags
   *
   * @returns {object}
   */ static get sanitize() {
        return {
            b: {}
        };
    }
    /**
   * Create button for Inline Toolbar
   */ render() {
        return {
            icon: $cdae29d26d2e7999$var$Ki,
            name: "bold",
            onActivate: ()=>{
                document.execCommand(this.commandName);
            },
            isActive: ()=>document.queryCommandState(this.commandName)
        };
    }
    /**
   * Set a shortcut
   *
   * @returns {boolean}
   */ get shortcut() {
        return "CMD+B";
    }
}
$cdae29d26d2e7999$var$go.isInline = !0;
$cdae29d26d2e7999$var$go.title = "Bold";
class $cdae29d26d2e7999$var$mo {
    constructor(){
        this.commandName = "italic", this.CSS = {
            button: "ce-inline-tool",
            buttonActive: "ce-inline-tool--active",
            buttonModifier: "ce-inline-tool--italic"
        }, this.nodes = {
            button: null
        };
    }
    /**
   * Sanitizer Rule
   * Leave <i> tags
   *
   * @returns {object}
   */ static get sanitize() {
        return {
            i: {}
        };
    }
    /**
   * Create button for Inline Toolbar
   */ render() {
        return this.nodes.button = document.createElement("button"), this.nodes.button.type = "button", this.nodes.button.classList.add(this.CSS.button, this.CSS.buttonModifier), this.nodes.button.innerHTML = $cdae29d26d2e7999$var$Ji, this.nodes.button;
    }
    /**
   * Wrap range with <i> tag
   */ surround() {
        document.execCommand(this.commandName);
    }
    /**
   * Check selection and set activated state to button if there are <i> tag
   */ checkState() {
        const e = document.queryCommandState(this.commandName);
        return this.nodes.button.classList.toggle(this.CSS.buttonActive, e), e;
    }
    /**
   * Set a shortcut
   */ get shortcut() {
        return "CMD+I";
    }
}
$cdae29d26d2e7999$var$mo.isInline = !0;
$cdae29d26d2e7999$var$mo.title = "Italic";
class $cdae29d26d2e7999$var$bo {
    /**
   * @param api - Editor.js API
   */ constructor({ api: e }){
        this.commandLink = "createLink", this.commandUnlink = "unlink", this.ENTER_KEY = 13, this.CSS = {
            button: "ce-inline-tool",
            buttonActive: "ce-inline-tool--active",
            buttonModifier: "ce-inline-tool--link",
            buttonUnlink: "ce-inline-tool--unlink",
            input: "ce-inline-tool-input",
            inputShowed: "ce-inline-tool-input--showed"
        }, this.nodes = {
            button: null,
            input: null
        }, this.inputOpened = !1, this.toolbar = e.toolbar, this.inlineToolbar = e.inlineToolbar, this.notifier = e.notifier, this.i18n = e.i18n, this.selection = new $cdae29d26d2e7999$var$b();
    }
    /**
   * Sanitizer Rule
   * Leave <a> tags
   *
   * @returns {object}
   */ static get sanitize() {
        return {
            a: {
                href: !0,
                target: "_blank",
                rel: "nofollow"
            }
        };
    }
    /**
   * Create button for Inline Toolbar
   */ render() {
        return this.nodes.button = document.createElement("button"), this.nodes.button.type = "button", this.nodes.button.classList.add(this.CSS.button, this.CSS.buttonModifier), this.nodes.button.innerHTML = $cdae29d26d2e7999$var$Co, this.nodes.button;
    }
    /**
   * Input for the link
   */ renderActions() {
        return this.nodes.input = document.createElement("input"), this.nodes.input.placeholder = this.i18n.t("Add a link"), this.nodes.input.enterKeyHint = "done", this.nodes.input.classList.add(this.CSS.input), this.nodes.input.addEventListener("keydown", (e)=>{
            e.keyCode === this.ENTER_KEY && this.enterPressed(e);
        }), this.nodes.input;
    }
    /**
   * Handle clicks on the Inline Toolbar icon
   *
   * @param {Range} range - range to wrap with link
   */ surround(e) {
        if (e) {
            this.inputOpened ? (this.selection.restore(), this.selection.removeFakeBackground()) : (this.selection.setFakeBackground(), this.selection.save());
            const t1 = this.selection.findParentTag("A");
            if (t1) {
                this.selection.expandToTag(t1), this.unlink(), this.closeActions(), this.checkState(), this.toolbar.close();
                return;
            }
        }
        this.toggleActions();
    }
    /**
   * Check selection and set activated state to button if there are <a> tag
   */ checkState() {
        const e = this.selection.findParentTag("A");
        if (e) {
            this.nodes.button.innerHTML = $cdae29d26d2e7999$var$ns, this.nodes.button.classList.add(this.CSS.buttonUnlink), this.nodes.button.classList.add(this.CSS.buttonActive), this.openActions();
            const t1 = e.getAttribute("href");
            this.nodes.input.value = t1 !== "null" ? t1 : "", this.selection.save();
        } else this.nodes.button.innerHTML = $cdae29d26d2e7999$var$Co, this.nodes.button.classList.remove(this.CSS.buttonUnlink), this.nodes.button.classList.remove(this.CSS.buttonActive);
        return !!e;
    }
    /**
   * Function called with Inline Toolbar closing
   */ clear() {
        this.closeActions();
    }
    /**
   * Set a shortcut
   */ get shortcut() {
        return "CMD+K";
    }
    /**
   * Show/close link input
   */ toggleActions() {
        this.inputOpened ? this.closeActions(!1) : this.openActions(!0);
    }
    /**
   * @param {boolean} needFocus - on link creation we need to focus input. On editing - nope.
   */ openActions(e = !1) {
        this.nodes.input.classList.add(this.CSS.inputShowed), e && this.nodes.input.focus(), this.inputOpened = !0;
    }
    /**
   * Close input
   *
   * @param {boolean} clearSavedSelection — we don't need to clear saved selection
   *                                        on toggle-clicks on the icon of opened Toolbar
   */ closeActions(e = !0) {
        if (this.selection.isFakeBackgroundEnabled) {
            const t1 = new $cdae29d26d2e7999$var$b();
            t1.save(), this.selection.restore(), this.selection.removeFakeBackground(), t1.restore();
        }
        this.nodes.input.classList.remove(this.CSS.inputShowed), this.nodes.input.value = "", e && this.selection.clearSaved(), this.inputOpened = !1;
    }
    /**
   * Enter pressed on input
   *
   * @param {KeyboardEvent} event - enter keydown event
   */ enterPressed(e) {
        let t1 = this.nodes.input.value || "";
        if (!t1.trim()) {
            this.selection.restore(), this.unlink(), e.preventDefault(), this.closeActions();
            return;
        }
        if (!this.validateURL(t1)) {
            this.notifier.show({
                message: "Pasted link is not valid.",
                style: "error"
            }), $cdae29d26d2e7999$var$S("Incorrect Link pasted", "warn", t1);
            return;
        }
        t1 = this.prepareLink(t1), this.selection.restore(), this.selection.removeFakeBackground(), this.insertLink(t1), e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation(), this.selection.collapseToEnd(), this.inlineToolbar.close();
    }
    /**
   * Detects if passed string is URL
   *
   * @param {string} str - string to validate
   * @returns {boolean}
   */ validateURL(e) {
        return !/\s/.test(e);
    }
    /**
   * Process link before injection
   * - sanitize
   * - add protocol for links like 'google.com'
   *
   * @param {string} link - raw user input
   */ prepareLink(e) {
        return e = e.trim(), e = this.addProtocol(e), e;
    }
    /**
   * Add 'http' protocol to the links like 'vc.ru', 'google.com'
   *
   * @param {string} link - string to process
   */ addProtocol(e) {
        if (/^(\w+):(\/\/)?/.test(e)) return e;
        const t1 = /^\/[^/\s]/.test(e), o = e.substring(0, 1) === "#", i = /^\/\/[^/\s]/.test(e);
        return !t1 && !o && !i && (e = "http://" + e), e;
    }
    /**
   * Inserts <a> tag with "href"
   *
   * @param {string} link - "href" value
   */ insertLink(e) {
        const t1 = this.selection.findParentTag("A");
        t1 && this.selection.expandToTag(t1), document.execCommand(this.commandLink, !1, e);
    }
    /**
   * Removes <a> tag
   */ unlink() {
        document.execCommand(this.commandUnlink);
    }
}
$cdae29d26d2e7999$var$bo.isInline = !0;
$cdae29d26d2e7999$var$bo.title = "Link";
class $cdae29d26d2e7999$var$Fn {
    /**
   * @param api - Editor.js API
   */ constructor({ api: e }){
        this.i18nAPI = e.i18n, this.blocksAPI = e.blocks, this.selectionAPI = e.selection, this.toolsAPI = e.tools, this.caretAPI = e.caret;
    }
    /**
   * Returns tool's UI config
   */ async render() {
        const e = $cdae29d26d2e7999$var$b.get(), t1 = this.blocksAPI.getBlockByElement(e.anchorNode);
        if (t1 === void 0) return [];
        const o = this.toolsAPI.getBlockTools(), i = await $cdae29d26d2e7999$var$Yo(t1, o);
        if (i.length === 0) return [];
        const s = i.reduce((c, d)=>{
            var h;
            return (h = d.toolbox) == null || h.forEach((p)=>{
                c.push({
                    icon: p.icon,
                    title: $cdae29d26d2e7999$var$z.t($cdae29d26d2e7999$var$K.toolNames, p.title),
                    name: d.name,
                    closeOnActivate: !0,
                    onActivate: async ()=>{
                        const g = await this.blocksAPI.convert(t1.id, d.name, p.data);
                        this.caretAPI.setToBlock(g, "end");
                    }
                });
            }), c;
        }, []), r = await t1.getActiveToolboxEntry(), a = r !== void 0 ? r.icon : $cdae29d26d2e7999$var$Go, l = !$cdae29d26d2e7999$var$be();
        return {
            icon: a,
            name: "convert-to",
            hint: {
                title: this.i18nAPI.t("Convert to")
            },
            children: {
                searchable: l,
                items: s,
                onOpen: ()=>{
                    l && (this.selectionAPI.setFakeBackground(), this.selectionAPI.save());
                },
                onClose: ()=>{
                    l && (this.selectionAPI.restore(), this.selectionAPI.removeFakeBackground());
                }
            }
        };
    }
}
$cdae29d26d2e7999$var$Fn.isInline = !0;
class $cdae29d26d2e7999$var$jn {
    /**
   * @param options - constructor options
   * @param options.data - stub tool data
   * @param options.api - Editor.js API
   */ constructor({ data: e, api: t1 }){
        this.CSS = {
            wrapper: "ce-stub",
            info: "ce-stub__info",
            title: "ce-stub__title",
            subtitle: "ce-stub__subtitle"
        }, this.api = t1, this.title = e.title || this.api.i18n.t("Error"), this.subtitle = this.api.i18n.t("The block can not be displayed correctly."), this.savedData = e.savedData, this.wrapper = this.make();
    }
    /**
   * Returns stub holder
   *
   * @returns {HTMLElement}
   */ render() {
        return this.wrapper;
    }
    /**
   * Return original Tool data
   *
   * @returns {BlockToolData}
   */ save() {
        return this.savedData;
    }
    /**
   * Create Tool html markup
   *
   * @returns {HTMLElement}
   */ make() {
        const e = $cdae29d26d2e7999$var$u.make("div", this.CSS.wrapper), t1 = $cdae29d26d2e7999$var$is, o = $cdae29d26d2e7999$var$u.make("div", this.CSS.info), i = $cdae29d26d2e7999$var$u.make("div", this.CSS.title, {
            textContent: this.title
        }), s = $cdae29d26d2e7999$var$u.make("div", this.CSS.subtitle, {
            textContent: this.subtitle
        });
        return e.innerHTML = t1, o.appendChild(i), o.appendChild(s), e.appendChild(o), e;
    }
}
$cdae29d26d2e7999$var$jn.isReadOnlySupported = !0;
class $cdae29d26d2e7999$var$ka extends $cdae29d26d2e7999$var$Tt {
    constructor(){
        super(...arguments), this.type = $cdae29d26d2e7999$var$ae.Inline;
    }
    /**
   * Returns title for Inline Tool if specified by user
   */ get title() {
        return this.constructable[$cdae29d26d2e7999$var$We.Title];
    }
    /**
   * Constructs new InlineTool instance from constructable
   */ create() {
        return new this.constructable({
            api: this.api,
            config: this.settings
        });
    }
    /**
   * Allows inline tool to be available in read-only mode
   * Can be used, for example, by comments tool
   */ get isReadOnlySupported() {
        return this.constructable[$cdae29d26d2e7999$var$We.IsReadOnlySupported] ?? !1;
    }
}
class $cdae29d26d2e7999$var$ya extends $cdae29d26d2e7999$var$Tt {
    constructor(){
        super(...arguments), this.type = $cdae29d26d2e7999$var$ae.Tune;
    }
    /**
   * Constructs new BlockTune instance from constructable
   *
   * @param data - Tune data
   * @param block - Block API object
   */ create(e, t1) {
        return new this.constructable({
            api: this.api,
            config: this.settings,
            block: t1,
            data: e
        });
    }
}
class $cdae29d26d2e7999$var$j extends Map {
    /**
   * Returns Block Tools collection
   */ get blockTools() {
        const e = Array.from(this.entries()).filter(([, t1])=>t1.isBlock());
        return new $cdae29d26d2e7999$var$j(e);
    }
    /**
   * Returns Inline Tools collection
   */ get inlineTools() {
        const e = Array.from(this.entries()).filter(([, t1])=>t1.isInline());
        return new $cdae29d26d2e7999$var$j(e);
    }
    /**
   * Returns Block Tunes collection
   */ get blockTunes() {
        const e = Array.from(this.entries()).filter(([, t1])=>t1.isTune());
        return new $cdae29d26d2e7999$var$j(e);
    }
    /**
   * Returns internal Tools collection
   */ get internalTools() {
        const e = Array.from(this.entries()).filter(([, t1])=>t1.isInternal);
        return new $cdae29d26d2e7999$var$j(e);
    }
    /**
   * Returns Tools collection provided by user
   */ get externalTools() {
        const e = Array.from(this.entries()).filter(([, t1])=>!t1.isInternal);
        return new $cdae29d26d2e7999$var$j(e);
    }
}
var $cdae29d26d2e7999$var$wa = Object.defineProperty, $cdae29d26d2e7999$var$Ea = Object.getOwnPropertyDescriptor, $cdae29d26d2e7999$var$Hn = (n, e, t1, o)=>{
    for(var i = o > 1 ? void 0 : o ? $cdae29d26d2e7999$var$Ea(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $cdae29d26d2e7999$var$wa(e, t1, i), i;
};
class $cdae29d26d2e7999$var$vo extends $cdae29d26d2e7999$var$Tt {
    constructor(){
        super(...arguments), this.type = $cdae29d26d2e7999$var$ae.Block, this.inlineTools = new $cdae29d26d2e7999$var$j(), this.tunes = new $cdae29d26d2e7999$var$j();
    }
    /**
   * Creates new Tool instance
   *
   * @param data - Tool data
   * @param block - BlockAPI for current Block
   * @param readOnly - True if Editor is in read-only mode
   */ create(e, t1, o) {
        return new this.constructable({
            data: e,
            block: t1,
            readOnly: o,
            api: this.api,
            config: this.settings
        });
    }
    /**
   * Returns true if read-only mode is supported by Tool
   */ get isReadOnlySupported() {
        return this.constructable[$cdae29d26d2e7999$var$pe.IsReadOnlySupported] === !0;
    }
    /**
   * Returns true if Tool supports linebreaks
   */ get isLineBreaksEnabled() {
        return this.constructable[$cdae29d26d2e7999$var$pe.IsEnabledLineBreaks];
    }
    /**
   * Returns Tool toolbox configuration (internal or user-specified).
   *
   * Merges internal and user-defined toolbox configs based on the following rules:
   *
   * - If both internal and user-defined toolbox configs are arrays their items are merged.
   * Length of the second one is kept.
   *
   * - If both are objects their properties are merged.
   *
   * - If one is an object and another is an array than internal config is replaced with user-defined
   * config. This is made to allow user to override default tool's toolbox representation (single/multiple entries)
   */ get toolbox() {
        const e = this.constructable[$cdae29d26d2e7999$var$pe.Toolbox], t1 = this.config[$cdae29d26d2e7999$var$Pe.Toolbox];
        if (!$cdae29d26d2e7999$var$V(e) && t1 !== !1) return t1 ? Array.isArray(e) ? Array.isArray(t1) ? t1.map((o, i)=>{
            const s = e[i];
            return s ? {
                ...s,
                ...o
            } : o;
        }) : [
            t1
        ] : Array.isArray(t1) ? t1 : [
            {
                ...e,
                ...t1
            }
        ] : Array.isArray(e) ? e : [
            e
        ];
    }
    /**
   * Returns Tool conversion configuration
   */ get conversionConfig() {
        return this.constructable[$cdae29d26d2e7999$var$pe.ConversionConfig];
    }
    /**
   * Returns enabled inline tools for Tool
   */ get enabledInlineTools() {
        return this.config[$cdae29d26d2e7999$var$Pe.EnabledInlineTools] || !1;
    }
    /**
   * Returns enabled tunes for Tool
   */ get enabledBlockTunes() {
        return this.config[$cdae29d26d2e7999$var$Pe.EnabledBlockTunes];
    }
    /**
   * Returns Tool paste configuration
   */ get pasteConfig() {
        return this.constructable[$cdae29d26d2e7999$var$pe.PasteConfig] ?? {};
    }
    get sanitizeConfig() {
        const e = super.sanitizeConfig, t1 = this.baseSanitizeConfig;
        if ($cdae29d26d2e7999$var$V(e)) return t1;
        const o = {};
        for(const i in e)if (Object.prototype.hasOwnProperty.call(e, i)) {
            const s = e[i];
            $cdae29d26d2e7999$var$D(s) ? o[i] = Object.assign({}, t1, s) : o[i] = s;
        }
        return o;
    }
    get baseSanitizeConfig() {
        const e = {};
        return Array.from(this.inlineTools.values()).forEach((t1)=>Object.assign(e, t1.sanitizeConfig)), Array.from(this.tunes.values()).forEach((t1)=>Object.assign(e, t1.sanitizeConfig)), e;
    }
}
$cdae29d26d2e7999$var$Hn([
    $cdae29d26d2e7999$var$me
], $cdae29d26d2e7999$var$vo.prototype, "sanitizeConfig", 1);
$cdae29d26d2e7999$var$Hn([
    $cdae29d26d2e7999$var$me
], $cdae29d26d2e7999$var$vo.prototype, "baseSanitizeConfig", 1);
class $cdae29d26d2e7999$var$xa {
    /**
   * @class
   * @param config - tools config
   * @param editorConfig - EditorJS config
   * @param api - EditorJS API module
   */ constructor(e, t1, o){
        this.api = o, this.config = e, this.editorConfig = t1;
    }
    /**
   * Returns Tool object based on it's type
   *
   * @param name - tool name
   */ get(e) {
        const { class: t1, isInternal: o = !1, ...i } = this.config[e], s = this.getConstructor(t1), r = t1[$cdae29d26d2e7999$var$mt.IsTune];
        return new s({
            name: e,
            constructable: t1,
            config: i,
            api: this.api.getMethodsForTool(e, r),
            isDefault: e === this.editorConfig.defaultBlock,
            defaultPlaceholder: this.editorConfig.placeholder,
            isInternal: o
        });
    }
    /**
   * Find appropriate Tool object constructor for Tool constructable
   *
   * @param constructable - Tools constructable
   */ getConstructor(e) {
        switch(!0){
            case e[$cdae29d26d2e7999$var$We.IsInline]:
                return $cdae29d26d2e7999$var$ka;
            case e[$cdae29d26d2e7999$var$mt.IsTune]:
                return $cdae29d26d2e7999$var$ya;
            default:
                return $cdae29d26d2e7999$var$vo;
        }
    }
}
class $cdae29d26d2e7999$var$$n {
    /**
   * MoveDownTune constructor
   *
   * @param {API} api — Editor's API
   */ constructor({ api: e }){
        this.CSS = {
            animation: "wobble"
        }, this.api = e;
    }
    /**
   * Tune's appearance in block settings menu
   */ render() {
        return {
            icon: $cdae29d26d2e7999$var$Xi,
            title: this.api.i18n.t("Move down"),
            onActivate: ()=>this.handleClick(),
            name: "move-down"
        };
    }
    /**
   * Handle clicks on 'move down' button
   */ handleClick() {
        const e = this.api.blocks.getCurrentBlockIndex(), t1 = this.api.blocks.getBlockByIndex(e + 1);
        if (!t1) throw new Error("Unable to move Block down since it is already the last");
        const o = t1.holder, i = o.getBoundingClientRect();
        let s = Math.abs(window.innerHeight - o.offsetHeight);
        i.top < window.innerHeight && (s = window.scrollY + o.offsetHeight), window.scrollTo(0, s), this.api.blocks.move(e + 1), this.api.toolbar.toggleBlockSettings(!0);
    }
}
$cdae29d26d2e7999$var$$n.isTune = !0;
class $cdae29d26d2e7999$var$zn {
    /**
   * DeleteTune constructor
   *
   * @param {API} api - Editor's API
   */ constructor({ api: e }){
        this.api = e;
    }
    /**
   * Tune's appearance in block settings menu
   */ render() {
        return {
            icon: $cdae29d26d2e7999$var$Gi,
            title: this.api.i18n.t("Delete"),
            name: "delete",
            confirmation: {
                title: this.api.i18n.t("Click to delete"),
                onActivate: ()=>this.handleClick()
            }
        };
    }
    /**
   * Delete block conditions passed
   */ handleClick() {
        this.api.blocks.delete();
    }
}
$cdae29d26d2e7999$var$zn.isTune = !0;
class $cdae29d26d2e7999$var$Un {
    /**
   * MoveUpTune constructor
   *
   * @param {API} api - Editor's API
   */ constructor({ api: e }){
        this.CSS = {
            animation: "wobble"
        }, this.api = e;
    }
    /**
   * Tune's appearance in block settings menu
   */ render() {
        return {
            icon: $cdae29d26d2e7999$var$Zi,
            title: this.api.i18n.t("Move up"),
            onActivate: ()=>this.handleClick(),
            name: "move-up"
        };
    }
    /**
   * Move current block up
   */ handleClick() {
        const e = this.api.blocks.getCurrentBlockIndex(), t1 = this.api.blocks.getBlockByIndex(e), o = this.api.blocks.getBlockByIndex(e - 1);
        if (e === 0 || !t1 || !o) throw new Error("Unable to move Block up since it is already the first");
        const i = t1.holder, s = o.holder, r = i.getBoundingClientRect(), a = s.getBoundingClientRect();
        let l;
        a.top > 0 ? l = Math.abs(r.top) - Math.abs(a.top) : l = Math.abs(r.top) + a.height, window.scrollBy(0, -1 * l), this.api.blocks.move(e - 1), this.api.toolbar.toggleBlockSettings(!0);
    }
}
$cdae29d26d2e7999$var$Un.isTune = !0;
var $cdae29d26d2e7999$var$Ba = Object.defineProperty, $cdae29d26d2e7999$var$Ca = Object.getOwnPropertyDescriptor, $cdae29d26d2e7999$var$Ta = (n, e, t1, o)=>{
    for(var i = o > 1 ? void 0 : o ? $cdae29d26d2e7999$var$Ca(e, t1) : e, s = n.length - 1, r; s >= 0; s--)(r = n[s]) && (i = (o ? r(e, t1, i) : r(i)) || i);
    return o && i && $cdae29d26d2e7999$var$Ba(e, t1, i), i;
};
class $cdae29d26d2e7999$var$Wn extends $cdae29d26d2e7999$var$E {
    constructor(){
        super(...arguments), this.stubTool = "stub", this.toolsAvailable = new $cdae29d26d2e7999$var$j(), this.toolsUnavailable = new $cdae29d26d2e7999$var$j();
    }
    /**
   * Returns available Tools
   */ get available() {
        return this.toolsAvailable;
    }
    /**
   * Returns unavailable Tools
   */ get unavailable() {
        return this.toolsUnavailable;
    }
    /**
   * Return Tools for the Inline Toolbar
   */ get inlineTools() {
        return this.available.inlineTools;
    }
    /**
   * Return editor block tools
   */ get blockTools() {
        return this.available.blockTools;
    }
    /**
   * Return available Block Tunes
   *
   * @returns {object} - object of Inline Tool's classes
   */ get blockTunes() {
        return this.available.blockTunes;
    }
    /**
   * Returns default Tool object
   */ get defaultTool() {
        return this.blockTools.get(this.config.defaultBlock);
    }
    /**
   * Returns internal tools
   */ get internal() {
        return this.available.internalTools;
    }
    /**
   * Creates instances via passed or default configuration
   *
   * @returns {Promise<void>}
   */ async prepare() {
        if (this.validateTools(), this.config.tools = $cdae29d26d2e7999$var$ut({}, this.internalTools, this.config.tools), !Object.prototype.hasOwnProperty.call(this.config, "tools") || Object.keys(this.config.tools).length === 0) throw Error("Can't start without tools");
        const e = this.prepareConfig();
        this.factory = new $cdae29d26d2e7999$var$xa(e, this.config, this.Editor.API);
        const t1 = this.getListOfPrepareFunctions(e);
        if (t1.length === 0) return Promise.resolve();
        await $cdae29d26d2e7999$var$Qn(t1, (o)=>{
            this.toolPrepareMethodSuccess(o);
        }, (o)=>{
            this.toolPrepareMethodFallback(o);
        }), this.prepareBlockTools();
    }
    getAllInlineToolsSanitizeConfig() {
        const e = {};
        return Array.from(this.inlineTools.values()).forEach((t1)=>{
            Object.assign(e, t1.sanitizeConfig);
        }), e;
    }
    /**
   * Calls each Tool reset method to clean up anything set by Tool
   */ destroy() {
        Object.values(this.available).forEach(async (e)=>{
            $cdae29d26d2e7999$var$A(e.reset) && await e.reset();
        });
    }
    /**
   * Returns internal tools
   * Includes Bold, Italic, Link and Paragraph
   */ get internalTools() {
        return {
            convertTo: {
                class: $cdae29d26d2e7999$var$Fn,
                isInternal: !0
            },
            link: {
                class: $cdae29d26d2e7999$var$bo,
                isInternal: !0
            },
            bold: {
                class: $cdae29d26d2e7999$var$go,
                isInternal: !0
            },
            italic: {
                class: $cdae29d26d2e7999$var$mo,
                isInternal: !0
            },
            paragraph: {
                class: $cdae29d26d2e7999$var$fo,
                inlineToolbar: !0,
                isInternal: !0
            },
            stub: {
                class: $cdae29d26d2e7999$var$jn,
                isInternal: !0
            },
            moveUp: {
                class: $cdae29d26d2e7999$var$Un,
                isInternal: !0
            },
            delete: {
                class: $cdae29d26d2e7999$var$zn,
                isInternal: !0
            },
            moveDown: {
                class: $cdae29d26d2e7999$var$$n,
                isInternal: !0
            }
        };
    }
    /**
   * Tool prepare method success callback
   *
   * @param {object} data - append tool to available list
   */ toolPrepareMethodSuccess(e) {
        const t1 = this.factory.get(e.toolName);
        if (t1.isInline()) {
            const i = [
                "render"
            ].filter((s)=>!t1.create()[s]);
            if (i.length) {
                $cdae29d26d2e7999$var$S(`Incorrect Inline Tool: ${t1.name}. Some of required methods is not implemented %o`, "warn", i), this.toolsUnavailable.set(t1.name, t1);
                return;
            }
        }
        this.toolsAvailable.set(t1.name, t1);
    }
    /**
   * Tool prepare method fail callback
   *
   * @param {object} data - append tool to unavailable list
   */ toolPrepareMethodFallback(e) {
        this.toolsUnavailable.set(e.toolName, this.factory.get(e.toolName));
    }
    /**
   * Binds prepare function of plugins with user or default config
   *
   * @returns {Array} list of functions that needs to be fired sequentially
   * @param config - tools config
   */ getListOfPrepareFunctions(e) {
        const t1 = [];
        return Object.entries(e).forEach(([o, i])=>{
            t1.push({
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                function: $cdae29d26d2e7999$var$A(i.class.prepare) ? i.class.prepare : ()=>{},
                data: {
                    toolName: o,
                    config: i.config
                }
            });
        }), t1;
    }
    /**
   * Assign enabled Inline Tools and Block Tunes for Block Tool
   */ prepareBlockTools() {
        Array.from(this.blockTools.values()).forEach((e)=>{
            this.assignInlineToolsToBlockTool(e), this.assignBlockTunesToBlockTool(e);
        });
    }
    /**
   * Assign enabled Inline Tools for Block Tool
   *
   * @param tool - Block Tool
   */ assignInlineToolsToBlockTool(e) {
        if (this.config.inlineToolbar !== !1) {
            if (e.enabledInlineTools === !0) {
                e.inlineTools = new $cdae29d26d2e7999$var$j(Array.isArray(this.config.inlineToolbar) ? this.config.inlineToolbar.map((t1)=>[
                        t1,
                        this.inlineTools.get(t1)
                    ]) : Array.from(this.inlineTools.entries()));
                return;
            }
            Array.isArray(e.enabledInlineTools) && (e.inlineTools = new $cdae29d26d2e7999$var$j(/** Prepend ConvertTo Inline Tool */ [
                "convertTo",
                ...e.enabledInlineTools
            ].map((t1)=>[
                    t1,
                    this.inlineTools.get(t1)
                ])));
        }
    }
    /**
   * Assign enabled Block Tunes for Block Tool
   *
   * @param tool — Block Tool
   */ assignBlockTunesToBlockTool(e) {
        if (e.enabledBlockTunes !== !1) {
            if (Array.isArray(e.enabledBlockTunes)) {
                const t1 = new $cdae29d26d2e7999$var$j(e.enabledBlockTunes.map((o)=>[
                        o,
                        this.blockTunes.get(o)
                    ]));
                e.tunes = new $cdae29d26d2e7999$var$j([
                    ...t1,
                    ...this.blockTunes.internalTools
                ]);
                return;
            }
            if (Array.isArray(this.config.tunes)) {
                const t1 = new $cdae29d26d2e7999$var$j(this.config.tunes.map((o)=>[
                        o,
                        this.blockTunes.get(o)
                    ]));
                e.tunes = new $cdae29d26d2e7999$var$j([
                    ...t1,
                    ...this.blockTunes.internalTools
                ]);
                return;
            }
            e.tunes = this.blockTunes.internalTools;
        }
    }
    /**
   * Validate Tools configuration objects and throw Error for user if it is invalid
   */ validateTools() {
        for(const e in this.config.tools)if (Object.prototype.hasOwnProperty.call(this.config.tools, e)) {
            if (e in this.internalTools) return;
            const t1 = this.config.tools[e];
            if (!$cdae29d26d2e7999$var$A(t1) && !$cdae29d26d2e7999$var$A(t1.class)) throw Error(`Tool \xab${e}\xbb must be a constructor function or an object with function in the \xabclass\xbb property`);
        }
    }
    /**
   * Unify tools config
   */ prepareConfig() {
        const e = {};
        for(const t1 in this.config.tools)$cdae29d26d2e7999$var$D(this.config.tools[t1]) ? e[t1] = this.config.tools[t1] : e[t1] = {
            class: this.config.tools[t1]
        };
        return e;
    }
}
$cdae29d26d2e7999$var$Ta([
    $cdae29d26d2e7999$var$me
], $cdae29d26d2e7999$var$Wn.prototype, "getAllInlineToolsSanitizeConfig", 1);
const $cdae29d26d2e7999$var$Sa = `:root{--selectionColor: #e1f2ff;--inlineSelectionColor: #d4ecff;--bg-light: #eff2f5;--grayText: #707684;--color-dark: #1D202B;--color-active-icon: #388AE5;--color-gray-border: rgba(201, 201, 204, .48);--content-width: 650px;--narrow-mode-right-padding: 50px;--toolbox-buttons-size: 26px;--toolbox-buttons-size--mobile: 36px;--icon-size: 20px;--icon-size--mobile: 28px;--block-padding-vertical: .4em;--color-line-gray: #EFF0F1 }.codex-editor{position:relative;-webkit-box-sizing:border-box;box-sizing:border-box;z-index:1}.codex-editor .hide{display:none}.codex-editor__redactor [contenteditable]:empty:after{content:"\\feff"}@media (min-width: 651px){.codex-editor--narrow .codex-editor__redactor{margin-right:50px}}@media (min-width: 651px){.codex-editor--narrow.codex-editor--rtl .codex-editor__redactor{margin-left:50px;margin-right:0}}@media (min-width: 651px){.codex-editor--narrow .ce-toolbar__actions{right:-5px}}.codex-editor-copyable{position:absolute;height:1px;width:1px;top:-400%;opacity:.001}.codex-editor-overlay{position:fixed;top:0;left:0;right:0;bottom:0;z-index:999;pointer-events:none;overflow:hidden}.codex-editor-overlay__container{position:relative;pointer-events:auto;z-index:0}.codex-editor-overlay__rectangle{position:absolute;pointer-events:none;background-color:#2eaadc33;border:1px solid transparent}.codex-editor svg{max-height:100%}.codex-editor path{stroke:currentColor}.codex-editor ::-moz-selection{background-color:#d4ecff}.codex-editor ::selection{background-color:#d4ecff}.codex-editor--toolbox-opened [contentEditable=true][data-placeholder]:focus:before{opacity:0!important}.ce-scroll-locked{overflow:hidden}.ce-scroll-locked--hard{overflow:hidden;top:calc(-1 * var(--window-scroll-offset));position:fixed;width:100%}.ce-toolbar{position:absolute;left:0;right:0;top:0;-webkit-transition:opacity .1s ease;transition:opacity .1s ease;will-change:opacity,top;display:none}.ce-toolbar--opened{display:block}.ce-toolbar__content{max-width:650px;margin:0 auto;position:relative}.ce-toolbar__plus{color:#1d202b;cursor:pointer;width:26px;height:26px;border-radius:7px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-ms-flex-negative:0;flex-shrink:0}@media (max-width: 650px){.ce-toolbar__plus{width:36px;height:36px}}@media (hover: hover){.ce-toolbar__plus:hover{background-color:#eff2f5}}.ce-toolbar__plus--active{background-color:#eff2f5;-webkit-animation:bounceIn .75s 1;animation:bounceIn .75s 1;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}.ce-toolbar__plus-shortcut{opacity:.6;word-spacing:-2px;margin-top:5px}@media (max-width: 650px){.ce-toolbar__plus{position:absolute;background-color:#fff;border:1px solid #E8E8EB;-webkit-box-shadow:0 3px 15px -3px rgba(13,20,33,.13);box-shadow:0 3px 15px -3px #0d142121;border-radius:6px;z-index:2;position:static}.ce-toolbar__plus--left-oriented:before{left:15px;margin-left:0}.ce-toolbar__plus--right-oriented:before{left:auto;right:15px;margin-left:0}}.ce-toolbar__actions{position:absolute;right:100%;opacity:0;display:-webkit-box;display:-ms-flexbox;display:flex;padding-right:5px}.ce-toolbar__actions--opened{opacity:1}@media (max-width: 650px){.ce-toolbar__actions{right:auto}}.ce-toolbar__settings-btn{color:#1d202b;width:26px;height:26px;border-radius:7px;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;margin-left:3px;cursor:pointer;user-select:none}@media (max-width: 650px){.ce-toolbar__settings-btn{width:36px;height:36px}}@media (hover: hover){.ce-toolbar__settings-btn:hover{background-color:#eff2f5}}.ce-toolbar__settings-btn--active{background-color:#eff2f5;-webkit-animation:bounceIn .75s 1;animation:bounceIn .75s 1;-webkit-animation-fill-mode:forwards;animation-fill-mode:forwards}@media (min-width: 651px){.ce-toolbar__settings-btn{width:24px}}.ce-toolbar__settings-btn--hidden{display:none}@media (max-width: 650px){.ce-toolbar__settings-btn{position:absolute;background-color:#fff;border:1px solid #E8E8EB;-webkit-box-shadow:0 3px 15px -3px rgba(13,20,33,.13);box-shadow:0 3px 15px -3px #0d142121;border-radius:6px;z-index:2;position:static}.ce-toolbar__settings-btn--left-oriented:before{left:15px;margin-left:0}.ce-toolbar__settings-btn--right-oriented:before{left:auto;right:15px;margin-left:0}}.ce-toolbar__plus svg,.ce-toolbar__settings-btn svg{width:24px;height:24px}@media (min-width: 651px){.codex-editor--narrow .ce-toolbar__plus{left:5px}}@media (min-width: 651px){.codex-editor--narrow .ce-toolbox .ce-popover{right:0;left:auto;left:initial}}.ce-inline-toolbar{--y-offset: 8px;--color-background-icon-active: rgba(56, 138, 229, .1);--color-text-icon-active: #388AE5;--color-text-primary: black;position:absolute;visibility:hidden;-webkit-transition:opacity .25s ease;transition:opacity .25s ease;will-change:opacity,left,top;top:0;left:0;z-index:3;opacity:1;visibility:visible}.ce-inline-toolbar [hidden]{display:none!important}.ce-inline-toolbar__toggler-and-button-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;padding:0 6px}.ce-inline-toolbar__buttons{display:-webkit-box;display:-ms-flexbox;display:flex}.ce-inline-toolbar__dropdown{display:-webkit-box;display:-ms-flexbox;display:flex;padding:6px;margin:0 6px 0 -6px;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer;border-right:1px solid rgba(201,201,204,.48);-webkit-box-sizing:border-box;box-sizing:border-box}@media (hover: hover){.ce-inline-toolbar__dropdown:hover{background:#eff2f5}}.ce-inline-toolbar__dropdown--hidden{display:none}.ce-inline-toolbar__dropdown-content,.ce-inline-toolbar__dropdown-arrow{display:-webkit-box;display:-ms-flexbox;display:flex}.ce-inline-toolbar__dropdown-content svg,.ce-inline-toolbar__dropdown-arrow svg{width:20px;height:20px}.ce-inline-toolbar__shortcut{opacity:.6;word-spacing:-3px;margin-top:3px}.ce-inline-tool{color:var(--color-text-primary);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;border:0;border-radius:4px;line-height:normal;height:100%;padding:0;width:28px;background-color:transparent;cursor:pointer}@media (max-width: 650px){.ce-inline-tool{width:36px;height:36px}}@media (hover: hover){.ce-inline-tool:hover{background-color:#f8f8f8}}.ce-inline-tool svg{display:block;width:20px;height:20px}@media (max-width: 650px){.ce-inline-tool svg{width:28px;height:28px}}.ce-inline-tool--link .icon--unlink,.ce-inline-tool--unlink .icon--link{display:none}.ce-inline-tool--unlink .icon--unlink{display:inline-block;margin-bottom:-1px}.ce-inline-tool-input{background:#F8F8F8;border:1px solid rgba(226,226,229,.2);border-radius:6px;padding:4px 8px;font-size:14px;line-height:22px;outline:none;margin:0;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box;display:none;font-weight:500;-webkit-appearance:none;font-family:inherit}@media (max-width: 650px){.ce-inline-tool-input{font-size:15px;font-weight:500}}.ce-inline-tool-input::-webkit-input-placeholder{color:#707684}.ce-inline-tool-input::-moz-placeholder{color:#707684}.ce-inline-tool-input:-ms-input-placeholder{color:#707684}.ce-inline-tool-input::-ms-input-placeholder{color:#707684}.ce-inline-tool-input::placeholder{color:#707684}.ce-inline-tool-input--showed{display:block}.ce-inline-tool--active{background:var(--color-background-icon-active);color:var(--color-text-icon-active)}@-webkit-keyframes fade-in{0%{opacity:0}to{opacity:1}}@keyframes fade-in{0%{opacity:0}to{opacity:1}}.ce-block{-webkit-animation:fade-in .3s ease;animation:fade-in .3s ease;-webkit-animation-fill-mode:none;animation-fill-mode:none;-webkit-animation-fill-mode:initial;animation-fill-mode:initial}.ce-block:first-of-type{margin-top:0}.ce-block--selected .ce-block__content{background:#e1f2ff}.ce-block--selected .ce-block__content [contenteditable]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ce-block--selected .ce-block__content img,.ce-block--selected .ce-block__content .ce-stub{opacity:.55}.ce-block--stretched .ce-block__content{max-width:none}.ce-block__content{position:relative;max-width:650px;margin:0 auto;-webkit-transition:background-color .15s ease;transition:background-color .15s ease}.ce-block--drop-target .ce-block__content:before{content:"";position:absolute;top:100%;left:-20px;margin-top:-1px;height:8px;width:8px;border:solid #388AE5;border-width:1px 1px 0 0;-webkit-transform-origin:right;transform-origin:right;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.ce-block--drop-target .ce-block__content:after{content:"";position:absolute;top:100%;height:1px;width:100%;color:#388ae5;background:repeating-linear-gradient(90deg,#388AE5,#388AE5 1px,#fff 1px,#fff 6px)}.ce-block a{cursor:pointer;-webkit-text-decoration:underline;text-decoration:underline}.ce-block b{font-weight:700}.ce-block i{font-style:italic}@-webkit-keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}20%{-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}60%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@keyframes bounceIn{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.9,.9,.9);transform:scale3d(.9,.9,.9)}20%{-webkit-transform:scale3d(1.03,1.03,1.03);transform:scale3d(1.03,1.03,1.03)}60%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@-webkit-keyframes selectionBounce{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}50%{-webkit-transform:scale3d(1.01,1.01,1.01);transform:scale3d(1.01,1.01,1.01)}70%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@keyframes selectionBounce{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}50%{-webkit-transform:scale3d(1.01,1.01,1.01);transform:scale3d(1.01,1.01,1.01)}70%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@-webkit-keyframes buttonClicked{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.95,.95,.95);transform:scale3d(.95,.95,.95)}60%{-webkit-transform:scale3d(1.02,1.02,1.02);transform:scale3d(1.02,1.02,1.02)}80%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}@keyframes buttonClicked{0%,20%,40%,60%,80%,to{-webkit-animation-timing-function:cubic-bezier(.215,.61,.355,1);animation-timing-function:cubic-bezier(.215,.61,.355,1)}0%{-webkit-transform:scale3d(.95,.95,.95);transform:scale3d(.95,.95,.95)}60%{-webkit-transform:scale3d(1.02,1.02,1.02);transform:scale3d(1.02,1.02,1.02)}80%{-webkit-transform:scale3d(1,1,1);transform:scaleZ(1)}}.cdx-block{padding:.4em 0}.cdx-block::-webkit-input-placeholder{line-height:normal!important}.cdx-input{border:1px solid rgba(201,201,204,.48);-webkit-box-shadow:inset 0 1px 2px 0 rgba(35,44,72,.06);box-shadow:inset 0 1px 2px #232c480f;border-radius:3px;padding:10px 12px;outline:none;width:100%;-webkit-box-sizing:border-box;box-sizing:border-box}.cdx-input[data-placeholder]:before{position:static!important}.cdx-input[data-placeholder]:before{display:inline-block;width:0;white-space:nowrap;pointer-events:none}.cdx-settings-button{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;border-radius:3px;cursor:pointer;border:0;outline:none;background-color:transparent;vertical-align:bottom;color:inherit;margin:0;min-width:26px;min-height:26px}.cdx-settings-button--focused{background:rgba(34,186,255,.08)!important}.cdx-settings-button--focused{-webkit-box-shadow:inset 0 0 0px 1px rgba(7,161,227,.08);box-shadow:inset 0 0 0 1px #07a1e314}.cdx-settings-button--focused-animated{-webkit-animation-name:buttonClicked;animation-name:buttonClicked;-webkit-animation-duration:.25s;animation-duration:.25s}.cdx-settings-button--active{color:#388ae5}.cdx-settings-button svg{width:auto;height:auto}@media (max-width: 650px){.cdx-settings-button svg{width:28px;height:28px}}@media (max-width: 650px){.cdx-settings-button{width:36px;height:36px;border-radius:8px}}@media (hover: hover){.cdx-settings-button:hover{background-color:#eff2f5}}.cdx-loader{position:relative;border:1px solid rgba(201,201,204,.48)}.cdx-loader:before{content:"";position:absolute;left:50%;top:50%;width:18px;height:18px;margin:-11px 0 0 -11px;border:2px solid rgba(201,201,204,.48);border-left-color:#388ae5;border-radius:50%;-webkit-animation:cdxRotation 1.2s infinite linear;animation:cdxRotation 1.2s infinite linear}@-webkit-keyframes cdxRotation{0%{-webkit-transform:rotate(0deg);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}@keyframes cdxRotation{0%{-webkit-transform:rotate(0deg);transform:rotate(0)}to{-webkit-transform:rotate(360deg);transform:rotate(360deg)}}.cdx-button{padding:13px;border-radius:3px;border:1px solid rgba(201,201,204,.48);font-size:14.9px;background:#fff;-webkit-box-shadow:0 2px 2px 0 rgba(18,30,57,.04);box-shadow:0 2px 2px #121e390a;color:#707684;text-align:center;cursor:pointer}@media (hover: hover){.cdx-button:hover{background:#FBFCFE;-webkit-box-shadow:0 1px 3px 0 rgba(18,30,57,.08);box-shadow:0 1px 3px #121e3914}}.cdx-button svg{height:20px;margin-right:.2em;margin-top:-2px}.ce-stub{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:12px 18px;margin:10px 0;border-radius:10px;background:#eff2f5;border:1px solid #EFF0F1;color:#707684;font-size:14px}.ce-stub svg{width:20px;height:20px}.ce-stub__info{margin-left:14px}.ce-stub__title{font-weight:500;text-transform:capitalize}.codex-editor.codex-editor--rtl{direction:rtl}.codex-editor.codex-editor--rtl .cdx-list{padding-left:0;padding-right:40px}.codex-editor.codex-editor--rtl .ce-toolbar__plus{right:-26px;left:auto}.codex-editor.codex-editor--rtl .ce-toolbar__actions{right:auto;left:-26px}@media (max-width: 650px){.codex-editor.codex-editor--rtl .ce-toolbar__actions{margin-left:0;margin-right:auto;padding-right:0;padding-left:10px}}.codex-editor.codex-editor--rtl .ce-settings{left:5px;right:auto}.codex-editor.codex-editor--rtl .ce-settings:before{right:auto;left:25px}.codex-editor.codex-editor--rtl .ce-settings__button:not(:nth-child(3n+3)){margin-left:3px;margin-right:0}.codex-editor.codex-editor--rtl .ce-conversion-tool__icon{margin-right:0;margin-left:10px}.codex-editor.codex-editor--rtl .ce-inline-toolbar__dropdown{border-right:0px solid transparent;border-left:1px solid rgba(201,201,204,.48);margin:0 -6px 0 6px}.codex-editor.codex-editor--rtl .ce-inline-toolbar__dropdown .icon--toggler-down{margin-left:0;margin-right:4px}@media (min-width: 651px){.codex-editor--narrow.codex-editor--rtl .ce-toolbar__plus{left:0;right:5px}}@media (min-width: 651px){.codex-editor--narrow.codex-editor--rtl .ce-toolbar__actions{left:-5px}}.cdx-search-field{--icon-margin-right: 10px;background:#F8F8F8;border:1px solid rgba(226,226,229,.2);border-radius:6px;padding:2px;display:grid;grid-template-columns:auto auto 1fr;grid-template-rows:auto}.cdx-search-field__icon{width:26px;height:26px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin-right:var(--icon-margin-right)}.cdx-search-field__icon svg{width:20px;height:20px;color:#707684}.cdx-search-field__input{font-size:14px;outline:none;font-weight:500;font-family:inherit;border:0;background:transparent;margin:0;padding:0;line-height:22px;min-width:calc(100% - 26px - var(--icon-margin-right))}.cdx-search-field__input::-webkit-input-placeholder{color:#707684;font-weight:500}.cdx-search-field__input::-moz-placeholder{color:#707684;font-weight:500}.cdx-search-field__input:-ms-input-placeholder{color:#707684;font-weight:500}.cdx-search-field__input::-ms-input-placeholder{color:#707684;font-weight:500}.cdx-search-field__input::placeholder{color:#707684;font-weight:500}.ce-popover{--border-radius: 6px;--width: 200px;--max-height: 270px;--padding: 6px;--offset-from-target: 8px;--color-border: #EFF0F1;--color-shadow: rgba(13, 20, 33, .1);--color-background: white;--color-text-primary: black;--color-text-secondary: #707684;--color-border-icon: rgba(201, 201, 204, .48);--color-border-icon-disabled: #EFF0F1;--color-text-icon-active: #388AE5;--color-background-icon-active: rgba(56, 138, 229, .1);--color-background-item-focus: rgba(34, 186, 255, .08);--color-shadow-item-focus: rgba(7, 161, 227, .08);--color-background-item-hover: #F8F8F8;--color-background-item-confirm: #E24A4A;--color-background-item-confirm-hover: #CE4343;--popover-top: calc(100% + var(--offset-from-target));--popover-left: 0;--nested-popover-overlap: 4px;--icon-size: 20px;--item-padding: 3px;--item-height: calc(var(--icon-size) + 2 * var(--item-padding))}.ce-popover__container{min-width:var(--width);width:var(--width);max-height:var(--max-height);border-radius:var(--border-radius);overflow:hidden;-webkit-box-sizing:border-box;box-sizing:border-box;-webkit-box-shadow:0px 3px 15px -3px var(--color-shadow);box-shadow:0 3px 15px -3px var(--color-shadow);position:absolute;left:var(--popover-left);top:var(--popover-top);background:var(--color-background);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;z-index:4;opacity:0;max-height:0;pointer-events:none;padding:0;border:none}.ce-popover--opened>.ce-popover__container{opacity:1;padding:var(--padding);max-height:var(--max-height);pointer-events:auto;-webkit-animation:panelShowing .1s ease;animation:panelShowing .1s ease;border:1px solid var(--color-border)}@media (max-width: 650px){.ce-popover--opened>.ce-popover__container{-webkit-animation:panelShowingMobile .25s ease;animation:panelShowingMobile .25s ease}}.ce-popover--open-top .ce-popover__container{--popover-top: calc(-1 * (var(--offset-from-target) + var(--popover-height)))}.ce-popover--open-left .ce-popover__container{--popover-left: calc(-1 * var(--width) + 100%)}.ce-popover__items{overflow-y:auto;-ms-scroll-chaining:none;overscroll-behavior:contain}@media (max-width: 650px){.ce-popover__overlay{position:fixed;top:0;bottom:0;left:0;right:0;background:#1D202B;z-index:3;opacity:.5;-webkit-transition:opacity .12s ease-in;transition:opacity .12s ease-in;will-change:opacity;visibility:visible}}.ce-popover__overlay--hidden{display:none}@media (max-width: 650px){.ce-popover .ce-popover__container{--offset: 5px;position:fixed;max-width:none;min-width:calc(100% - var(--offset) * 2);left:var(--offset);right:var(--offset);bottom:calc(var(--offset) + env(safe-area-inset-bottom));top:auto;border-radius:10px}}.ce-popover__search{margin-bottom:5px}.ce-popover__nothing-found-message{color:#707684;display:none;cursor:default;padding:3px;font-size:14px;line-height:20px;font-weight:500;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.ce-popover__nothing-found-message--displayed{display:block}.ce-popover--nested .ce-popover__container{--popover-left: calc(var(--nesting-level) * (var(--width) - var(--nested-popover-overlap)));top:calc(var(--trigger-item-top) - var(--nested-popover-overlap));position:absolute}.ce-popover--open-top.ce-popover--nested .ce-popover__container{top:calc(var(--trigger-item-top) - var(--popover-height) + var(--item-height) + var(--offset-from-target) + var(--nested-popover-overlap))}.ce-popover--open-left .ce-popover--nested .ce-popover__container{--popover-left: calc(-1 * (var(--nesting-level) + 1) * var(--width) + 100%)}.ce-popover-item-separator{padding:4px 3px}.ce-popover-item-separator--hidden{display:none}.ce-popover-item-separator__line{height:1px;background:var(--color-border);width:100%}.ce-popover-item-html--hidden{display:none}.ce-popover-item{--border-radius: 6px;border-radius:var(--border-radius);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;padding:var(--item-padding);color:var(--color-text-primary);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;border:none;background:transparent}@media (max-width: 650px){.ce-popover-item{padding:4px}}.ce-popover-item:not(:last-of-type){margin-bottom:1px}.ce-popover-item__icon{width:26px;height:26px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.ce-popover-item__icon svg{width:20px;height:20px}@media (max-width: 650px){.ce-popover-item__icon{width:36px;height:36px;border-radius:8px}.ce-popover-item__icon svg{width:28px;height:28px}}.ce-popover-item__icon--tool{margin-right:4px}.ce-popover-item__title{font-size:14px;line-height:20px;font-weight:500;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;margin-right:auto}@media (max-width: 650px){.ce-popover-item__title{font-size:16px}}.ce-popover-item__secondary-title{color:var(--color-text-secondary);font-size:12px;white-space:nowrap;letter-spacing:-.1em;padding-right:5px;opacity:.6}@media (max-width: 650px){.ce-popover-item__secondary-title{display:none}}.ce-popover-item--active{background:var(--color-background-icon-active);color:var(--color-text-icon-active)}.ce-popover-item--disabled{color:var(--color-text-secondary);cursor:default;pointer-events:none}.ce-popover-item--focused:not(.ce-popover-item--no-focus){background:var(--color-background-item-focus)!important}.ce-popover-item--hidden{display:none}@media (hover: hover){.ce-popover-item:hover{cursor:pointer}.ce-popover-item:hover:not(.ce-popover-item--no-hover){background-color:var(--color-background-item-hover)}}.ce-popover-item--confirmation{background:var(--color-background-item-confirm)}.ce-popover-item--confirmation .ce-popover-item__title,.ce-popover-item--confirmation .ce-popover-item__icon{color:#fff}@media (hover: hover){.ce-popover-item--confirmation:not(.ce-popover-item--no-hover):hover{background:var(--color-background-item-confirm-hover)}}.ce-popover-item--confirmation:not(.ce-popover-item--no-focus).ce-popover-item--focused{background:var(--color-background-item-confirm-hover)!important}@-webkit-keyframes panelShowing{0%{opacity:0;-webkit-transform:translateY(-8px) scale(.9);transform:translateY(-8px) scale(.9)}70%{opacity:1;-webkit-transform:translateY(2px);transform:translateY(2px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes panelShowing{0%{opacity:0;-webkit-transform:translateY(-8px) scale(.9);transform:translateY(-8px) scale(.9)}70%{opacity:1;-webkit-transform:translateY(2px);transform:translateY(2px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@-webkit-keyframes panelShowingMobile{0%{opacity:0;-webkit-transform:translateY(14px) scale(.98);transform:translateY(14px) scale(.98)}70%{opacity:1;-webkit-transform:translateY(-4px);transform:translateY(-4px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}@keyframes panelShowingMobile{0%{opacity:0;-webkit-transform:translateY(14px) scale(.98);transform:translateY(14px) scale(.98)}70%{opacity:1;-webkit-transform:translateY(-4px);transform:translateY(-4px)}to{-webkit-transform:translateY(0);transform:translateY(0)}}.wobble{-webkit-animation-name:wobble;animation-name:wobble;-webkit-animation-duration:.4s;animation-duration:.4s}@-webkit-keyframes wobble{0%{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}15%{-webkit-transform:translate3d(-9%,0,0);transform:translate3d(-9%,0,0)}30%{-webkit-transform:translate3d(9%,0,0);transform:translate3d(9%,0,0)}45%{-webkit-transform:translate3d(-4%,0,0);transform:translate3d(-4%,0,0)}60%{-webkit-transform:translate3d(4%,0,0);transform:translate3d(4%,0,0)}75%{-webkit-transform:translate3d(-1%,0,0);transform:translate3d(-1%,0,0)}to{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}}@keyframes wobble{0%{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}15%{-webkit-transform:translate3d(-9%,0,0);transform:translate3d(-9%,0,0)}30%{-webkit-transform:translate3d(9%,0,0);transform:translate3d(9%,0,0)}45%{-webkit-transform:translate3d(-4%,0,0);transform:translate3d(-4%,0,0)}60%{-webkit-transform:translate3d(4%,0,0);transform:translate3d(4%,0,0)}75%{-webkit-transform:translate3d(-1%,0,0);transform:translate3d(-1%,0,0)}to{-webkit-transform:translate3d(0,0,0);transform:translateZ(0)}}.ce-popover-header{margin-bottom:8px;margin-top:4px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ce-popover-header__text{font-size:18px;font-weight:600}.ce-popover-header__back-button{border:0;background:transparent;width:36px;height:36px;color:var(--color-text-primary)}.ce-popover-header__back-button svg{display:block;width:28px;height:28px}.ce-popover--inline{--height: 38px;--height-mobile: 46px;--container-padding: 4px;position:relative}.ce-popover--inline .ce-popover__custom-content{margin-bottom:0}.ce-popover--inline .ce-popover__items{display:-webkit-box;display:-ms-flexbox;display:flex}.ce-popover--inline .ce-popover__container{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;padding:var(--container-padding);height:var(--height);top:0;min-width:-webkit-max-content;min-width:-moz-max-content;min-width:max-content;width:-webkit-max-content;width:-moz-max-content;width:max-content;-webkit-animation:none;animation:none}@media (max-width: 650px){.ce-popover--inline .ce-popover__container{height:var(--height-mobile);position:absolute}}.ce-popover--inline .ce-popover-item-separator{padding:0 4px}.ce-popover--inline .ce-popover-item-separator__line{height:100%;width:1px}.ce-popover--inline .ce-popover-item{border-radius:4px;padding:4px}.ce-popover--inline .ce-popover-item__icon--tool{-webkit-box-shadow:none;box-shadow:none;background:transparent;margin-right:0}.ce-popover--inline .ce-popover-item__icon{width:auto;width:initial;height:auto;height:initial}.ce-popover--inline .ce-popover-item__icon svg{width:20px;height:20px}@media (max-width: 650px){.ce-popover--inline .ce-popover-item__icon svg{width:28px;height:28px}}.ce-popover--inline .ce-popover-item:not(:last-of-type){margin-bottom:0;margin-bottom:initial}.ce-popover--inline .ce-popover-item-html{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ce-popover--inline .ce-popover-item__icon--chevron-right{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.ce-popover--inline .ce-popover--nested-level-1 .ce-popover__container{--offset: 3px;left:0;top:calc(var(--height) + var(--offset))}@media (max-width: 650px){.ce-popover--inline .ce-popover--nested-level-1 .ce-popover__container{top:calc(var(--height-mobile) + var(--offset))}}.ce-popover--inline .ce-popover--nested .ce-popover__container{min-width:var(--width);width:var(--width);height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;padding:6px;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ce-popover--inline .ce-popover--nested .ce-popover__items{display:block;width:100%}.ce-popover--inline .ce-popover--nested .ce-popover-item{border-radius:6px;padding:3px}@media (max-width: 650px){.ce-popover--inline .ce-popover--nested .ce-popover-item{padding:4px}}.ce-popover--inline .ce-popover--nested .ce-popover-item__icon--tool{margin-right:4px}.ce-popover--inline .ce-popover--nested .ce-popover-item__icon{width:26px;height:26px}.ce-popover--inline .ce-popover--nested .ce-popover-item-separator{padding:4px 3px}.ce-popover--inline .ce-popover--nested .ce-popover-item-separator__line{width:100%;height:1px}.codex-editor [data-placeholder]:empty:before,.codex-editor [data-placeholder][data-empty=true]:before{pointer-events:none;color:#707684;cursor:text;content:attr(data-placeholder)}.codex-editor [data-placeholder-active]:empty:before,.codex-editor [data-placeholder-active][data-empty=true]:before{pointer-events:none;color:#707684;cursor:text}.codex-editor [data-placeholder-active]:empty:focus:before,.codex-editor [data-placeholder-active][data-empty=true]:focus:before{content:attr(data-placeholder-active)}
`;
class $cdae29d26d2e7999$var$Ia extends $cdae29d26d2e7999$var$E {
    constructor(){
        super(...arguments), this.isMobile = !1, this.contentRectCache = null, this.resizeDebouncer = $cdae29d26d2e7999$var$Eo(()=>{
            this.windowResize();
        }, 200), this.selectionChangeDebounced = $cdae29d26d2e7999$var$Eo(()=>{
            this.selectionChanged();
        }, $cdae29d26d2e7999$var$da), this.documentTouchedListener = (e)=>{
            this.documentTouched(e);
        };
    }
    /**
   * Editor.js UI CSS class names
   *
   * @returns {{editorWrapper: string, editorZone: string}}
   */ get CSS() {
        return {
            editorWrapper: "codex-editor",
            editorWrapperNarrow: "codex-editor--narrow",
            editorZone: "codex-editor__redactor",
            editorZoneHidden: "codex-editor__redactor--hidden",
            editorEmpty: "codex-editor--empty",
            editorRtlFix: "codex-editor--rtl"
        };
    }
    /**
   * Return Width of center column of Editor
   *
   * @returns {DOMRect}
   */ get contentRect() {
        if (this.contentRectCache !== null) return this.contentRectCache;
        const e = this.nodes.wrapper.querySelector(`.${$cdae29d26d2e7999$var$R.CSS.content}`);
        return e ? (this.contentRectCache = e.getBoundingClientRect(), this.contentRectCache) : {
            width: 650,
            left: 0,
            right: 0
        };
    }
    /**
   * Making main interface
   */ async prepare() {
        this.setIsMobile(), this.make(), this.loadStyles();
    }
    /**
   * Toggle read-only state
   *
   * If readOnly is true:
   *  - removes all listeners from main UI module elements
   *
   * if readOnly is false:
   *  - enables all listeners to UI module elements
   *
   * @param {boolean} readOnlyEnabled - "read only" state
   */ toggleReadOnly(e) {
        e ? this.unbindReadOnlySensitiveListeners() : window.requestIdleCallback(()=>{
            this.bindReadOnlySensitiveListeners();
        }, {
            timeout: 2e3
        });
    }
    /**
   * Check if Editor is empty and set CSS class to wrapper
   */ checkEmptiness() {
        const { BlockManager: e } = this.Editor;
        this.nodes.wrapper.classList.toggle(this.CSS.editorEmpty, e.isEditorEmpty);
    }
    /**
   * Check if one of Toolbar is opened
   * Used to prevent global keydowns (for example, Enter) conflicts with Enter-on-toolbar
   *
   * @returns {boolean}
   */ get someToolbarOpened() {
        const { Toolbar: e, BlockSettings: t1, InlineToolbar: o } = this.Editor;
        return !!(t1.opened || o.opened || e.toolbox.opened);
    }
    /**
   * Check for some Flipper-buttons is under focus
   */ get someFlipperButtonFocused() {
        return this.Editor.Toolbar.toolbox.hasFocus() ? !0 : Object.entries(this.Editor).filter(([e, t1])=>t1.flipper instanceof $cdae29d26d2e7999$var$ce).some(([e, t1])=>t1.flipper.hasFocus());
    }
    /**
   * Clean editor`s UI
   */ destroy() {
        this.nodes.holder.innerHTML = "", this.unbindReadOnlyInsensitiveListeners();
    }
    /**
   * Close all Editor's toolbars
   */ closeAllToolbars() {
        const { Toolbar: e, BlockSettings: t1, InlineToolbar: o } = this.Editor;
        t1.close(), o.close(), e.toolbox.close();
    }
    /**
   * Check for mobile mode and save the result
   */ setIsMobile() {
        const e = window.innerWidth < $cdae29d26d2e7999$var$Ro;
        e !== this.isMobile && this.eventsDispatcher.emit($cdae29d26d2e7999$var$Te, {
            isEnabled: this.isMobile
        }), this.isMobile = e;
    }
    /**
   * Makes Editor.js interface
   */ make() {
        this.nodes.holder = $cdae29d26d2e7999$var$u.getHolder(this.config.holder), this.nodes.wrapper = $cdae29d26d2e7999$var$u.make("div", [
            this.CSS.editorWrapper,
            ...this.isRtl ? [
                this.CSS.editorRtlFix
            ] : []
        ]), this.nodes.redactor = $cdae29d26d2e7999$var$u.make("div", this.CSS.editorZone), this.nodes.holder.offsetWidth < this.contentRect.width && this.nodes.wrapper.classList.add(this.CSS.editorWrapperNarrow), this.nodes.redactor.style.paddingBottom = this.config.minHeight + "px", this.nodes.wrapper.appendChild(this.nodes.redactor), this.nodes.holder.appendChild(this.nodes.wrapper), this.bindReadOnlyInsensitiveListeners();
    }
    /**
   * Appends CSS
   */ loadStyles() {
        const e = "editor-js-styles";
        if ($cdae29d26d2e7999$var$u.get(e)) return;
        const t1 = $cdae29d26d2e7999$var$u.make("style", null, {
            id: e,
            textContent: $cdae29d26d2e7999$var$Sa.toString()
        });
        this.config.style && !$cdae29d26d2e7999$var$V(this.config.style) && this.config.style.nonce && t1.setAttribute("nonce", this.config.style.nonce), $cdae29d26d2e7999$var$u.prepend(document.head, t1);
    }
    /**
   * Adds listeners that should work both in read-only and read-write modes
   */ bindReadOnlyInsensitiveListeners() {
        this.listeners.on(document, "selectionchange", this.selectionChangeDebounced), this.listeners.on(window, "resize", this.resizeDebouncer, {
            passive: !0
        }), this.listeners.on(this.nodes.redactor, "mousedown", this.documentTouchedListener, {
            capture: !0,
            passive: !0
        }), this.listeners.on(this.nodes.redactor, "touchstart", this.documentTouchedListener, {
            capture: !0,
            passive: !0
        });
    }
    /**
   * Removes listeners that should work both in read-only and read-write modes
   */ unbindReadOnlyInsensitiveListeners() {
        this.listeners.off(document, "selectionchange", this.selectionChangeDebounced), this.listeners.off(window, "resize", this.resizeDebouncer), this.listeners.off(this.nodes.redactor, "mousedown", this.documentTouchedListener), this.listeners.off(this.nodes.redactor, "touchstart", this.documentTouchedListener);
    }
    /**
   * Adds listeners that should work only in read-only mode
   */ bindReadOnlySensitiveListeners() {
        this.readOnlyMutableListeners.on(this.nodes.redactor, "click", (e)=>{
            this.redactorClicked(e);
        }, !1), this.readOnlyMutableListeners.on(document, "keydown", (e)=>{
            this.documentKeydown(e);
        }, !0), this.readOnlyMutableListeners.on(document, "mousedown", (e)=>{
            this.documentClicked(e);
        }, !0), this.watchBlockHoveredEvents(), this.enableInputsEmptyMark();
    }
    /**
   * Listen redactor mousemove to emit 'block-hovered' event
   */ watchBlockHoveredEvents() {
        let e;
        this.readOnlyMutableListeners.on(this.nodes.redactor, "mousemove", $cdae29d26d2e7999$var$dt((t1)=>{
            const o = t1.target.closest(".ce-block");
            this.Editor.BlockSelection.anyBlockSelected || o && e !== o && (e = o, this.eventsDispatcher.emit($cdae29d26d2e7999$var$ln, {
                block: this.Editor.BlockManager.getBlockByChildNode(o)
            }));
        }, 20), {
            passive: !0
        });
    }
    /**
   * Unbind events that should work only in read-only mode
   */ unbindReadOnlySensitiveListeners() {
        this.readOnlyMutableListeners.clearAll();
    }
    /**
   * Resize window handler
   */ windowResize() {
        this.contentRectCache = null, this.setIsMobile();
    }
    /**
   * All keydowns on document
   *
   * @param {KeyboardEvent} event - keyboard event
   */ documentKeydown(e) {
        switch(e.keyCode){
            case $cdae29d26d2e7999$var$y.ENTER:
                this.enterPressed(e);
                break;
            case $cdae29d26d2e7999$var$y.BACKSPACE:
            case $cdae29d26d2e7999$var$y.DELETE:
                this.backspacePressed(e);
                break;
            case $cdae29d26d2e7999$var$y.ESC:
                this.escapePressed(e);
                break;
            default:
                this.defaultBehaviour(e);
                break;
        }
    }
    /**
   * Ignore all other document's keydown events
   *
   * @param {KeyboardEvent} event - keyboard event
   */ defaultBehaviour(e) {
        const { currentBlock: t1 } = this.Editor.BlockManager, o = e.target.closest(`.${this.CSS.editorWrapper}`), i = e.altKey || e.ctrlKey || e.metaKey || e.shiftKey;
        if (t1 !== void 0 && o === null) {
            this.Editor.BlockEvents.keydown(e);
            return;
        }
        o || t1 && i || (this.Editor.BlockManager.unsetCurrentBlock(), this.Editor.Toolbar.close());
    }
    /**
   * @param {KeyboardEvent} event - keyboard event
   */ backspacePressed(e) {
        const { BlockManager: t1, BlockSelection: o, Caret: i } = this.Editor;
        if (o.anyBlockSelected && !$cdae29d26d2e7999$var$b.isSelectionExists) {
            const s = t1.removeSelectedBlocks(), r = t1.insertDefaultBlockAtIndex(s, !0);
            i.setToBlock(r, i.positions.START), o.clearSelection(e), e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation();
        }
    }
    /**
   * Escape pressed
   * If some of Toolbar components are opened, then close it otherwise close Toolbar
   *
   * @param {Event} event - escape keydown event
   */ escapePressed(e) {
        this.Editor.BlockSelection.clearSelection(e), this.Editor.Toolbar.toolbox.opened ? (this.Editor.Toolbar.toolbox.close(), this.Editor.Caret.setToBlock(this.Editor.BlockManager.currentBlock, this.Editor.Caret.positions.END)) : this.Editor.BlockSettings.opened ? this.Editor.BlockSettings.close() : this.Editor.InlineToolbar.opened ? this.Editor.InlineToolbar.close() : this.Editor.Toolbar.close();
    }
    /**
   * Enter pressed on document
   *
   * @param {KeyboardEvent} event - keyboard event
   */ enterPressed(e) {
        const { BlockManager: t1, BlockSelection: o } = this.Editor;
        if (this.someToolbarOpened) return;
        const i = t1.currentBlockIndex >= 0;
        if (o.anyBlockSelected && !$cdae29d26d2e7999$var$b.isSelectionExists) {
            o.clearSelection(e), e.preventDefault(), e.stopImmediatePropagation(), e.stopPropagation();
            return;
        }
        if (!this.someToolbarOpened && i && e.target.tagName === "BODY") {
            const s = this.Editor.BlockManager.insert();
            e.preventDefault(), this.Editor.Caret.setToBlock(s), this.Editor.Toolbar.moveAndOpen(s);
        }
        this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * All clicks on document
   *
   * @param {MouseEvent} event - Click event
   */ documentClicked(e) {
        var a, l;
        if (!e.isTrusted) return;
        const t1 = e.target;
        this.nodes.holder.contains(t1) || $cdae29d26d2e7999$var$b.isAtEditor || (this.Editor.BlockManager.unsetCurrentBlock(), this.Editor.Toolbar.close());
        const i = (a = this.Editor.BlockSettings.nodes.wrapper) == null ? void 0 : a.contains(t1), s = (l = this.Editor.Toolbar.nodes.settingsToggler) == null ? void 0 : l.contains(t1), r = i || s;
        if (this.Editor.BlockSettings.opened && !r) {
            this.Editor.BlockSettings.close();
            const c = this.Editor.BlockManager.getBlockByChildNode(t1);
            this.Editor.Toolbar.moveAndOpen(c);
        }
        this.Editor.BlockSelection.clearSelection(e);
    }
    /**
   * First touch on editor
   * Fired before click
   *
   * Used to change current block — we need to do it before 'selectionChange' event.
   * Also:
   * - Move and show the Toolbar
   * - Set a Caret
   *
   * @param event - touch or mouse event
   */ documentTouched(e) {
        let t1 = e.target;
        if (t1 === this.nodes.redactor) {
            const o = e instanceof MouseEvent ? e.clientX : e.touches[0].clientX, i = e instanceof MouseEvent ? e.clientY : e.touches[0].clientY;
            t1 = document.elementFromPoint(o, i);
        }
        try {
            this.Editor.BlockManager.setCurrentBlockByChildNode(t1);
        } catch  {
            this.Editor.RectangleSelection.isRectActivated() || this.Editor.Caret.setToTheLastBlock();
        }
        this.Editor.ReadOnly.isEnabled || this.Editor.Toolbar.moveAndOpen();
    }
    /**
   * All clicks on the redactor zone
   *
   * @param {MouseEvent} event - click event
   * @description
   * - By clicks on the Editor's bottom zone:
   *      - if last Block is empty, set a Caret to this
   *      - otherwise, add a new empty Block and set a Caret to that
   */ redactorClicked(e) {
        if (!$cdae29d26d2e7999$var$b.isCollapsed) return;
        const t1 = e.target, o = e.metaKey || e.ctrlKey;
        if ($cdae29d26d2e7999$var$u.isAnchor(t1) && o) {
            e.stopImmediatePropagation(), e.stopPropagation();
            const i = t1.getAttribute("href"), s = $cdae29d26d2e7999$var$oi(i);
            $cdae29d26d2e7999$var$ii(s);
            return;
        }
        this.processBottomZoneClick(e);
    }
    /**
   * Check if user clicks on the Editor's bottom zone:
   *  - set caret to the last block
   *  - or add new empty block
   *
   * @param event - click event
   */ processBottomZoneClick(e) {
        const t1 = this.Editor.BlockManager.getBlockByIndex(-1), o = $cdae29d26d2e7999$var$u.offset(t1.holder).bottom, i = e.pageY, { BlockSelection: s } = this.Editor;
        if (e.target instanceof Element && e.target.isEqualNode(this.nodes.redactor) && /**
    * If there is cross block selection started, target will be equal to redactor so we need additional check
    */ !s.anyBlockSelected && /**
    * Prevent caret jumping (to last block) when clicking between blocks
    */ o < i) {
            e.stopImmediatePropagation(), e.stopPropagation();
            const { BlockManager: a, Caret: l, Toolbar: c } = this.Editor;
            (!a.lastBlock.tool.isDefault || !a.lastBlock.isEmpty) && a.insertAtEnd(), l.setToTheLastBlock(), c.moveAndOpen(a.lastBlock);
        }
    }
    /**
   * Handle selection changes on mobile devices
   * Uses for showing the Inline Toolbar
   */ selectionChanged() {
        const { CrossBlockSelection: e, BlockSelection: t1 } = this.Editor, o = $cdae29d26d2e7999$var$b.anchorElement;
        if (e.isCrossBlockSelectionStarted && t1.anyBlockSelected && $cdae29d26d2e7999$var$b.get().removeAllRanges(), !o) {
            $cdae29d26d2e7999$var$b.range || this.Editor.InlineToolbar.close();
            return;
        }
        const i = o.closest(`.${$cdae29d26d2e7999$var$R.CSS.content}`);
        (i === null || i.closest(`.${$cdae29d26d2e7999$var$b.CSS.editorWrapper}`) !== this.nodes.wrapper) && (this.Editor.InlineToolbar.containsNode(o) || this.Editor.InlineToolbar.close(), !(o.dataset.inlineToolbar === "true")) || (this.Editor.BlockManager.currentBlock || this.Editor.BlockManager.setCurrentBlockByChildNode(o), this.Editor.InlineToolbar.tryToShow(!0));
    }
    /**
   * Editor.js provides and ability to show placeholders for empty contenteditable elements
   *
   * This method watches for input and focus events and toggles 'data-empty' attribute
   * to workaroud the case, when inputs contains only <br>s and has no visible content
   * Then, CSS could rely on this attribute to show placeholders
   */ enableInputsEmptyMark() {
        function e(t1) {
            const o = t1.target;
            $cdae29d26d2e7999$var$Do(o);
        }
        this.readOnlyMutableListeners.on(this.nodes.wrapper, "input", e), this.readOnlyMutableListeners.on(this.nodes.wrapper, "focusin", e), this.readOnlyMutableListeners.on(this.nodes.wrapper, "focusout", e);
    }
}
const $cdae29d26d2e7999$var$Oa = {
    // API Modules
    BlocksAPI: $cdae29d26d2e7999$var$gi,
    CaretAPI: $cdae29d26d2e7999$var$bi,
    EventsAPI: $cdae29d26d2e7999$var$vi,
    I18nAPI: $cdae29d26d2e7999$var$kt,
    API: $cdae29d26d2e7999$var$ki,
    InlineToolbarAPI: $cdae29d26d2e7999$var$yi,
    ListenersAPI: $cdae29d26d2e7999$var$wi,
    NotifierAPI: $cdae29d26d2e7999$var$Ci,
    ReadOnlyAPI: $cdae29d26d2e7999$var$Ti,
    SanitizerAPI: $cdae29d26d2e7999$var$Li,
    SaverAPI: $cdae29d26d2e7999$var$Pi,
    SelectionAPI: $cdae29d26d2e7999$var$Ni,
    ToolsAPI: $cdae29d26d2e7999$var$Ri,
    StylesAPI: $cdae29d26d2e7999$var$Di,
    ToolbarAPI: $cdae29d26d2e7999$var$Fi,
    TooltipAPI: $cdae29d26d2e7999$var$Ui,
    UiAPI: $cdae29d26d2e7999$var$Wi,
    // Toolbar Modules
    BlockSettings: $cdae29d26d2e7999$var$ms,
    Toolbar: $cdae29d26d2e7999$var$Bs,
    InlineToolbar: $cdae29d26d2e7999$var$Cs,
    // Modules
    BlockEvents: $cdae29d26d2e7999$var$na,
    BlockManager: $cdae29d26d2e7999$var$ra,
    BlockSelection: $cdae29d26d2e7999$var$aa,
    Caret: $cdae29d26d2e7999$var$Ye,
    CrossBlockSelection: $cdae29d26d2e7999$var$la,
    DragNDrop: $cdae29d26d2e7999$var$ca,
    ModificationsObserver: $cdae29d26d2e7999$var$ha,
    Paste: $cdae29d26d2e7999$var$pa,
    ReadOnly: $cdae29d26d2e7999$var$fa,
    RectangleSelection: $cdae29d26d2e7999$var$Be,
    Renderer: $cdae29d26d2e7999$var$ga,
    Saver: $cdae29d26d2e7999$var$ma,
    Tools: $cdae29d26d2e7999$var$Wn,
    UI: $cdae29d26d2e7999$var$Ia
};
class $cdae29d26d2e7999$var$_a {
    /**
   * @param {EditorConfig} config - user configuration
   */ constructor(e){
        this.moduleInstances = {}, this.eventsDispatcher = new $cdae29d26d2e7999$var$Oe();
        let t1, o;
        this.isReady = new Promise((i, s)=>{
            t1 = i, o = s;
        }), Promise.resolve().then(async ()=>{
            this.configuration = e, this.validate(), this.init(), await this.start(), await this.render();
            const { BlockManager: i, Caret: s, UI: r, ModificationsObserver: a } = this.moduleInstances;
            r.checkEmptiness(), a.enable(), this.configuration.autofocus === !0 && this.configuration.readOnly !== !0 && s.setToBlock(i.blocks[0], s.positions.START), t1();
        }).catch((i)=>{
            $cdae29d26d2e7999$var$S(`Editor.js is not ready because of ${i}`, "error"), o(i);
        });
    }
    /**
   * Setting for configuration
   *
   * @param {EditorConfig|string} config - Editor's config to set
   */ set configuration(e) {
        var o, i;
        $cdae29d26d2e7999$var$D(e) ? this.config = {
            ...e
        } : this.config = {
            holder: e
        }, $cdae29d26d2e7999$var$ht(!!this.config.holderId, "config.holderId", "config.holder"), this.config.holderId && !this.config.holder && (this.config.holder = this.config.holderId, this.config.holderId = null), this.config.holder == null && (this.config.holder = "editorjs"), this.config.logLevel || (this.config.logLevel = $cdae29d26d2e7999$var$Lo.VERBOSE), $cdae29d26d2e7999$var$Zn(this.config.logLevel), $cdae29d26d2e7999$var$ht(!!this.config.initialBlock, "config.initialBlock", "config.defaultBlock"), this.config.defaultBlock = this.config.defaultBlock || this.config.initialBlock || "paragraph", this.config.minHeight = this.config.minHeight !== void 0 ? this.config.minHeight : 300;
        const t1 = {
            type: this.config.defaultBlock,
            data: {}
        };
        this.config.placeholder = this.config.placeholder || !1, this.config.sanitizer = this.config.sanitizer || {
            p: !0,
            b: !0,
            a: !0
        }, this.config.hideToolbar = this.config.hideToolbar ? this.config.hideToolbar : !1, this.config.tools = this.config.tools || {}, this.config.i18n = this.config.i18n || {}, this.config.data = this.config.data || {
            blocks: []
        }, this.config.onReady = this.config.onReady || (()=>{}), this.config.onChange = this.config.onChange || (()=>{}), this.config.inlineToolbar = this.config.inlineToolbar !== void 0 ? this.config.inlineToolbar : !0, ($cdae29d26d2e7999$var$V(this.config.data) || !this.config.data.blocks || this.config.data.blocks.length === 0) && (this.config.data = {
            blocks: [
                t1
            ]
        }), this.config.readOnly = this.config.readOnly || !1, (o = this.config.i18n) != null && o.messages && $cdae29d26d2e7999$var$z.setDictionary(this.config.i18n.messages), this.config.i18n.direction = ((i = this.config.i18n) == null ? void 0 : i.direction) || "ltr";
    }
    /**
   * Returns private property
   *
   * @returns {EditorConfig}
   */ get configuration() {
        return this.config;
    }
    /**
   * Checks for required fields in Editor's config
   */ validate() {
        const { holderId: e, holder: t1 } = this.config;
        if (e && t1) throw Error("\xabholderId\xbb and \xabholder\xbb param can't assign at the same time.");
        if ($cdae29d26d2e7999$var$te(t1) && !$cdae29d26d2e7999$var$u.get(t1)) throw Error(`element with ID \xab${t1}\xbb is missing. Pass correct holder's ID.`);
        if (t1 && $cdae29d26d2e7999$var$D(t1) && !$cdae29d26d2e7999$var$u.isElement(t1)) throw Error("\xabholder\xbb value must be an Element node");
    }
    /**
   * Initializes modules:
   *  - make and save instances
   *  - configure
   */ init() {
        this.constructModules(), this.configureModules();
    }
    /**
   * Start Editor!
   *
   * Get list of modules that needs to be prepared and return a sequence (Promise)
   *
   * @returns {Promise<void>}
   */ async start() {
        await [
            "Tools",
            "UI",
            "BlockManager",
            "Paste",
            "BlockSelection",
            "RectangleSelection",
            "CrossBlockSelection",
            "ReadOnly"
        ].reduce((t1, o)=>t1.then(async ()=>{
                try {
                    await this.moduleInstances[o].prepare();
                } catch (i) {
                    if (i instanceof $cdae29d26d2e7999$var$Ho) throw new Error(i.message);
                    $cdae29d26d2e7999$var$S(`Module ${o} was skipped because of %o`, "warn", i);
                }
            }), Promise.resolve());
    }
    /**
   * Render initial data
   */ render() {
        return this.moduleInstances.Renderer.render(this.config.data.blocks);
    }
    /**
   * Make modules instances and save it to the @property this.moduleInstances
   */ constructModules() {
        Object.entries($cdae29d26d2e7999$var$Oa).forEach(([e, t1])=>{
            try {
                this.moduleInstances[e] = new t1({
                    config: this.configuration,
                    eventsDispatcher: this.eventsDispatcher
                });
            } catch (o) {
                $cdae29d26d2e7999$var$S("[constructModules]", `Module ${e} skipped because`, "error", o);
            }
        });
    }
    /**
   * Modules instances configuration:
   *  - pass other modules to the 'state' property
   *  - ...
   */ configureModules() {
        for(const e in this.moduleInstances)Object.prototype.hasOwnProperty.call(this.moduleInstances, e) && (this.moduleInstances[e].state = this.getModulesDiff(e));
    }
    /**
   * Return modules without passed name
   *
   * @param {string} name - module for witch modules difference should be calculated
   */ getModulesDiff(e) {
        const t1 = {};
        for(const o in this.moduleInstances)o !== e && (t1[o] = this.moduleInstances[o]);
        return t1;
    }
}
/**
 * Editor.js
 *
 * @license Apache-2.0
 * @see Editor.js <https://editorjs.io>
 * @author CodeX Team <https://codex.so>
 */ class $cdae29d26d2e7999$export$2e2bcd8739ae039 {
    /** Editor version */ static get version() {
        return "2.31.0";
    }
    /**
   * @param {EditorConfig|string|undefined} [configuration] - user configuration
   */ constructor(e){
        let t1 = ()=>{};
        $cdae29d26d2e7999$var$D(e) && $cdae29d26d2e7999$var$A(e.onReady) && (t1 = e.onReady);
        const o = new $cdae29d26d2e7999$var$_a(e);
        this.isReady = o.isReady.then(()=>{
            this.exportAPI(o), t1();
        });
    }
    /**
   * Export external API methods
   *
   * @param {Core} editor — Editor's instance
   */ exportAPI(e) {
        const t1 = [
            "configuration"
        ], o = ()=>{
            Object.values(e.moduleInstances).forEach((s)=>{
                $cdae29d26d2e7999$var$A(s.destroy) && s.destroy(), s.listeners.removeAll();
            }), $cdae29d26d2e7999$var$zi(), e = null;
            for(const s in this)Object.prototype.hasOwnProperty.call(this, s) && delete this[s];
            Object.setPrototypeOf(this, null);
        };
        t1.forEach((s)=>{
            this[s] = e[s];
        }), this.destroy = o, Object.setPrototypeOf(this, e.moduleInstances.API.methods), delete this.exportAPI, Object.entries({
            blocks: {
                clear: "clear",
                render: "render"
            },
            caret: {
                focus: "focus"
            },
            events: {
                on: "on",
                off: "off",
                emit: "emit"
            },
            saver: {
                save: "save"
            }
        }).forEach(([s, r])=>{
            Object.entries(r).forEach(([a, l])=>{
                this[l] = e.moduleInstances.API.methods[s][a];
            });
        });
    }
}

});

parcelRegister("62bxO", function(module, exports) {

$parcel$export(module.exports, "default", () => $892a05942d3d6c0a$export$2e2bcd8739ae039);
(function() {
    "use strict";
    try {
        if (typeof document < "u") {
            var e = document.createElement("style");
            e.appendChild(document.createTextNode(".ce-paragraph{line-height:1.6em;outline:none}.ce-block:only-of-type .ce-paragraph[data-placeholder-active]:empty:before,.ce-block:only-of-type .ce-paragraph[data-placeholder-active][data-empty=true]:before{content:attr(data-placeholder-active)}.ce-paragraph p:first-of-type{margin-top:0}.ce-paragraph p:last-of-type{margin-bottom:0}")), document.head.appendChild(e);
        }
    } catch (a) {
        console.error("vite-plugin-css-injected-by-js", a);
    }
})();
const $892a05942d3d6c0a$var$a = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><path stroke="currentColor" stroke-linecap="round" stroke-width="2" d="M8 9V7.2C8 7.08954 8.08954 7 8.2 7L12 7M16 9V7.2C16 7.08954 15.9105 7 15.8 7L12 7M12 7L12 17M12 17H10M12 17H14"/></svg>';
function $892a05942d3d6c0a$var$l(r) {
    const t = document.createElement("div");
    t.innerHTML = r.trim();
    const e = document.createDocumentFragment();
    return e.append(...Array.from(t.childNodes)), e;
}
/**
 * Base Paragraph Block for the Editor.js.
 * Represents a regular text block
 *
 * @author CodeX (team@codex.so)
 * @copyright CodeX 2018
 * @license The MIT License (MIT)
 */ class $892a05942d3d6c0a$export$2e2bcd8739ae039 {
    /**
   * Default placeholder for Paragraph Tool
   *
   * @returns {string}
   * @class
   */ static get DEFAULT_PLACEHOLDER() {
        return "";
    }
    /**
   * Render plugin`s main Element and fill it with saved data
   *
   * @param {object} params - constructor params
   * @param {ParagraphData} params.data - previously saved data
   * @param {ParagraphConfig} params.config - user config for Tool
   * @param {object} params.api - editor.js api
   * @param {boolean} readOnly - read only mode flag
   */ constructor({ data: t, config: e, api: i, readOnly: s }){
        this.api = i, this.readOnly = s, this._CSS = {
            block: this.api.styles.block,
            wrapper: "ce-paragraph"
        }, this.readOnly || (this.onKeyUp = this.onKeyUp.bind(this)), this._placeholder = e.placeholder ? e.placeholder : $892a05942d3d6c0a$export$2e2bcd8739ae039.DEFAULT_PLACEHOLDER, this._data = t ?? {}, this._element = null, this._preserveBlank = e.preserveBlank ?? !1;
    }
    /**
   * Check if text content is empty and set empty string to inner html.
   * We need this because some browsers (e.g. Safari) insert <br> into empty contenteditanle elements
   *
   * @param {KeyboardEvent} e - key up event
   */ onKeyUp(t) {
        if (t.code !== "Backspace" && t.code !== "Delete" || !this._element) return;
        const { textContent: e } = this._element;
        e === "" && (this._element.innerHTML = "");
    }
    /**
   * Create Tool's view
   *
   * @returns {HTMLDivElement}
   * @private
   */ drawView() {
        const t = document.createElement("DIV");
        return t.classList.add(this._CSS.wrapper, this._CSS.block), t.contentEditable = "false", t.dataset.placeholderActive = this.api.i18n.t(this._placeholder), this._data.text && (t.innerHTML = this._data.text), this.readOnly || (t.contentEditable = "true", t.addEventListener("keyup", this.onKeyUp)), t;
    }
    /**
   * Return Tool's view
   *
   * @returns {HTMLDivElement}
   */ render() {
        return this._element = this.drawView(), this._element;
    }
    /**
   * Method that specified how to merge two Text blocks.
   * Called by Editor.js by backspace at the beginning of the Block
   *
   * @param {ParagraphData} data
   * @public
   */ merge(t) {
        if (!this._element) return;
        this._data.text += t.text;
        const e = $892a05942d3d6c0a$var$l(t.text);
        this._element.appendChild(e), this._element.normalize();
    }
    /**
   * Validate Paragraph block data:
   * - check for emptiness
   *
   * @param {ParagraphData} savedData — data received after saving
   * @returns {boolean} false if saved data is not correct, otherwise true
   * @public
   */ validate(t) {
        return !(t.text.trim() === "" && !this._preserveBlank);
    }
    /**
   * Extract Tool's data from the view
   *
   * @param {HTMLDivElement} toolsContent - Paragraph tools rendered view
   * @returns {ParagraphData} - saved data
   * @public
   */ save(t) {
        return {
            text: t.innerHTML
        };
    }
    /**
   * On paste callback fired from Editor.
   *
   * @param {HTMLPasteEvent} event - event with pasted data
   */ onPaste(t) {
        const e = {
            text: t.detail.data.innerHTML
        };
        this._data = e, window.requestAnimationFrame(()=>{
            this._element && (this._element.innerHTML = this._data.text || "");
        });
    }
    /**
   * Enable Conversion Toolbar. Paragraph can be converted to/from other tools
   * @returns {ConversionConfig}
   */ static get conversionConfig() {
        return {
            export: "text",
            // to convert Paragraph to other block, use 'text' property of saved data
            import: "text"
        };
    }
    /**
   * Sanitizer rules
   * @returns {SanitizerConfig} - Edtior.js sanitizer config
   */ static get sanitize() {
        return {
            text: {
                br: !0
            }
        };
    }
    /**
   * Returns true to notify the core that read-only mode is supported
   *
   * @returns {boolean}
   */ static get isReadOnlySupported() {
        return !0;
    }
    /**
   * Used by Editor paste handling API.
   * Provides configuration to handle P tags.
   *
   * @returns {PasteConfig} - Paragraph Paste Setting
   */ static get pasteConfig() {
        return {
            tags: [
                "P"
            ]
        };
    }
    /**
   * Icon and title for displaying at the Toolbox
   *
   * @returns {ToolboxConfig} - Paragraph Toolbox Setting
   */ static get toolbox() {
        return {
            icon: $892a05942d3d6c0a$var$a,
            title: "Text"
        };
    }
}

});


parcelRegister("cghEl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8ed4ab8bfb8bc392$export$2e2bcd8739ae039);

var $dNU7X = parcelRequire("dNU7X");
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $8ed4ab8bfb8bc392$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $8ed4ab8bfb8bc392$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $8ed4ab8bfb8bc392$var$ReactEditorJS(_a) {
    var { factory: factory, holder: holder, defaultValue: defaultValue, children: children, value: value, onInitialize: onInitialize } = _a, restProps = $8ed4ab8bfb8bc392$var$__rest(_a, [
        "factory",
        "holder",
        "defaultValue",
        "children",
        "value",
        "onInitialize"
    ]);
    const memoizedHolder = (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).useRef(holder !== null && holder !== void 0 ? holder : `react-editor-js-${Date.now().toString(16)}`);
    const editorJS = (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).useRef(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).useEffect(()=>{
        editorJS.current = factory(Object.assign(Object.assign({
            holder: memoizedHolder.current
        }, defaultValue && {
            data: defaultValue
        }), restProps));
        onInitialize === null || onInitialize === void 0 || onInitialize(editorJS.current);
        return ()=>{
            var _a;
            (_a = editorJS.current) === null || _a === void 0 || _a.destroy();
        };
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).useEffect(()=>{
        var _a;
        if (value) (_a = editorJS.current) === null || _a === void 0 || _a.render(value);
    }, [
        value
    ]);
    return children || (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).createElement("div", {
        id: memoizedHolder.current
    });
}
class $8ed4ab8bfb8bc392$var$ServerEditorCore {
    constructor({ data: data }){
        if (data) this._memoizedData = data;
    }
    get dangerouslyLowLevelInstance() {
        return null;
    }
    clear() {
        return $8ed4ab8bfb8bc392$var$__awaiter(this, void 0, void 0, function*() {});
    }
    save() {
        return $8ed4ab8bfb8bc392$var$__awaiter(this, void 0, void 0, function*() {
            return this._memoizedData;
        });
    }
    destroy() {
        return $8ed4ab8bfb8bc392$var$__awaiter(this, void 0, void 0, function*() {});
    }
    render() {
        return $8ed4ab8bfb8bc392$var$__awaiter(this, void 0, void 0, function*() {});
    }
}
function $8ed4ab8bfb8bc392$export$2e2bcd8739ae039(props) {
    const factory = (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).useCallback((config)=>new $8ed4ab8bfb8bc392$var$ServerEditorCore(config), []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).createElement($8ed4ab8bfb8bc392$var$ReactEditorJS, Object.assign({
        factory: factory
    }, props));
}

});

parcelRegister("dflA0", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $lNqgI = parcelRequire("lNqgI");
function $9a4d6a57aaaab11e$var$emptyFunction() {}
function $9a4d6a57aaaab11e$var$emptyFunctionWithReset() {}
$9a4d6a57aaaab11e$var$emptyFunctionWithReset.resetWarningCache = $9a4d6a57aaaab11e$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $lNqgI) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $9a4d6a57aaaab11e$var$emptyFunctionWithReset,
        resetWarningCache: $9a4d6a57aaaab11e$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("lNqgI", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $fde28cfe61c36500$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $fde28cfe61c36500$var$ReactPropTypesSecret;

});


parcelRegister("dYe7D", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding('util');
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__['delete'](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= UNORDERED_COMPARE_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */ function isEqualWith(value, other, customizer) {
    customizer = typeof customizer == 'function' ? customizer : undefined;
    var result = customizer ? customizer(value, other) : undefined;
    return result === undefined ? baseIsEqual(value, other, customizer) : !!result;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = isEqualWith;

});

parcelRegister("lnmxF", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $f8fd3b4e5f17ffb5$export$882461b6382ed46c, (v) => $f8fd3b4e5f17ffb5$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $f8fd3b4e5f17ffb5$export$757ceba2d55c277e, (v) => $f8fd3b4e5f17ffb5$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $f8fd3b4e5f17ffb5$export$83d89fbfd8236492, (v) => $f8fd3b4e5f17ffb5$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $f8fd3b4e5f17ffb5$export$882461b6382ed46c;
var $f8fd3b4e5f17ffb5$export$757ceba2d55c277e;
var $f8fd3b4e5f17ffb5$export$83d89fbfd8236492;
"use strict";

var $hNfVH = parcelRequire("hNfVH");

var $dNU7X = parcelRequire("dNU7X");

var $boCrV = parcelRequire("boCrV");
function $f8fd3b4e5f17ffb5$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $f8fd3b4e5f17ffb5$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $f8fd3b4e5f17ffb5$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $f8fd3b4e5f17ffb5$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $f8fd3b4e5f17ffb5$var$assertIsMounted(fiber) {
    if ($f8fd3b4e5f17ffb5$var$getNearestMountedFiber(fiber) !== fiber) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(188));
}
function $f8fd3b4e5f17ffb5$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $f8fd3b4e5f17ffb5$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $f8fd3b4e5f17ffb5$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $f8fd3b4e5f17ffb5$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $f8fd3b4e5f17ffb5$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $f8fd3b4e5f17ffb5$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $f8fd3b4e5f17ffb5$var$assign = Object.assign, $f8fd3b4e5f17ffb5$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $f8fd3b4e5f17ffb5$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $f8fd3b4e5f17ffb5$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $f8fd3b4e5f17ffb5$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $f8fd3b4e5f17ffb5$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $f8fd3b4e5f17ffb5$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $f8fd3b4e5f17ffb5$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $f8fd3b4e5f17ffb5$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $f8fd3b4e5f17ffb5$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $f8fd3b4e5f17ffb5$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $f8fd3b4e5f17ffb5$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $f8fd3b4e5f17ffb5$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $f8fd3b4e5f17ffb5$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $f8fd3b4e5f17ffb5$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $f8fd3b4e5f17ffb5$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $f8fd3b4e5f17ffb5$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $f8fd3b4e5f17ffb5$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $f8fd3b4e5f17ffb5$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $f8fd3b4e5f17ffb5$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$f8fd3b4e5f17ffb5$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $f8fd3b4e5f17ffb5$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $f8fd3b4e5f17ffb5$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $f8fd3b4e5f17ffb5$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $f8fd3b4e5f17ffb5$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $f8fd3b4e5f17ffb5$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $f8fd3b4e5f17ffb5$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $f8fd3b4e5f17ffb5$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $f8fd3b4e5f17ffb5$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $f8fd3b4e5f17ffb5$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $f8fd3b4e5f17ffb5$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $f8fd3b4e5f17ffb5$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $f8fd3b4e5f17ffb5$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $f8fd3b4e5f17ffb5$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $f8fd3b4e5f17ffb5$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $f8fd3b4e5f17ffb5$var$getComponentNameFromType(type.type) || "Memo";
        case $f8fd3b4e5f17ffb5$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $f8fd3b4e5f17ffb5$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $f8fd3b4e5f17ffb5$var$isArrayImpl = Array.isArray, $f8fd3b4e5f17ffb5$var$ReactSharedInternals = $dNU7X.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals = $boCrV.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $f8fd3b4e5f17ffb5$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $f8fd3b4e5f17ffb5$var$valueStack = [], $f8fd3b4e5f17ffb5$var$index = -1;
function $f8fd3b4e5f17ffb5$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $f8fd3b4e5f17ffb5$var$pop(cursor) {
    0 > $f8fd3b4e5f17ffb5$var$index || (cursor.current = $f8fd3b4e5f17ffb5$var$valueStack[$f8fd3b4e5f17ffb5$var$index], $f8fd3b4e5f17ffb5$var$valueStack[$f8fd3b4e5f17ffb5$var$index] = null, $f8fd3b4e5f17ffb5$var$index--);
}
function $f8fd3b4e5f17ffb5$var$push(cursor, value) {
    $f8fd3b4e5f17ffb5$var$index++;
    $f8fd3b4e5f17ffb5$var$valueStack[$f8fd3b4e5f17ffb5$var$index] = cursor.current;
    cursor.current = value;
}
var $f8fd3b4e5f17ffb5$var$contextStackCursor = $f8fd3b4e5f17ffb5$var$createCursor(null), $f8fd3b4e5f17ffb5$var$contextFiberStackCursor = $f8fd3b4e5f17ffb5$var$createCursor(null), $f8fd3b4e5f17ffb5$var$rootInstanceStackCursor = $f8fd3b4e5f17ffb5$var$createCursor(null), $f8fd3b4e5f17ffb5$var$hostTransitionProviderCursor = $f8fd3b4e5f17ffb5$var$createCursor(null);
function $f8fd3b4e5f17ffb5$var$pushHostContainer(fiber, nextRootInstance) {
    $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$rootInstanceStackCursor, nextRootInstance);
    $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$contextFiberStackCursor, fiber);
    $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $f8fd3b4e5f17ffb5$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $f8fd3b4e5f17ffb5$var$getOwnHostContext(nextRootInstance), fiber = $f8fd3b4e5f17ffb5$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$contextStackCursor);
    $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$contextStackCursor, fiber);
}
function $f8fd3b4e5f17ffb5$var$popHostContainer() {
    $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$contextStackCursor);
    $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$contextFiberStackCursor);
    $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$rootInstanceStackCursor);
}
function $f8fd3b4e5f17ffb5$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$hostTransitionProviderCursor, fiber);
    var context = $f8fd3b4e5f17ffb5$var$contextStackCursor.current;
    var JSCompiler_inline_result = $f8fd3b4e5f17ffb5$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$contextFiberStackCursor, fiber), $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$contextStackCursor, JSCompiler_inline_result));
}
function $f8fd3b4e5f17ffb5$var$popHostContext(fiber) {
    $f8fd3b4e5f17ffb5$var$contextFiberStackCursor.current === fiber && ($f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$contextStackCursor), $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$contextFiberStackCursor));
    $f8fd3b4e5f17ffb5$var$hostTransitionProviderCursor.current === fiber && ($f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$hostTransitionProviderCursor), $f8fd3b4e5f17ffb5$var$HostTransitionContext._currentValue = $f8fd3b4e5f17ffb5$var$sharedNotPendingObject);
}
var $f8fd3b4e5f17ffb5$var$hasOwnProperty = Object.prototype.hasOwnProperty, $f8fd3b4e5f17ffb5$var$scheduleCallback$3 = $hNfVH.unstable_scheduleCallback, $f8fd3b4e5f17ffb5$var$cancelCallback$1 = $hNfVH.unstable_cancelCallback, $f8fd3b4e5f17ffb5$var$shouldYield = $hNfVH.unstable_shouldYield, $f8fd3b4e5f17ffb5$var$requestPaint = $hNfVH.unstable_requestPaint, $f8fd3b4e5f17ffb5$var$now = $hNfVH.unstable_now, $f8fd3b4e5f17ffb5$var$getCurrentPriorityLevel = $hNfVH.unstable_getCurrentPriorityLevel, $f8fd3b4e5f17ffb5$var$ImmediatePriority = $hNfVH.unstable_ImmediatePriority, $f8fd3b4e5f17ffb5$var$UserBlockingPriority = $hNfVH.unstable_UserBlockingPriority, $f8fd3b4e5f17ffb5$var$NormalPriority$1 = $hNfVH.unstable_NormalPriority, $f8fd3b4e5f17ffb5$var$LowPriority = $hNfVH.unstable_LowPriority, $f8fd3b4e5f17ffb5$var$IdlePriority = $hNfVH.unstable_IdlePriority, $f8fd3b4e5f17ffb5$var$log$1 = $hNfVH.log, $f8fd3b4e5f17ffb5$var$unstable_setDisableYieldValue = $hNfVH.unstable_setDisableYieldValue, $f8fd3b4e5f17ffb5$var$rendererID = null, $f8fd3b4e5f17ffb5$var$injectedHook = null;
function $f8fd3b4e5f17ffb5$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $f8fd3b4e5f17ffb5$var$log$1 && $f8fd3b4e5f17ffb5$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($f8fd3b4e5f17ffb5$var$injectedHook && "function" === typeof $f8fd3b4e5f17ffb5$var$injectedHook.setStrictMode) try {
        $f8fd3b4e5f17ffb5$var$injectedHook.setStrictMode($f8fd3b4e5f17ffb5$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $f8fd3b4e5f17ffb5$var$clz32 = Math.clz32 ? Math.clz32 : $f8fd3b4e5f17ffb5$var$clz32Fallback, $f8fd3b4e5f17ffb5$var$log = Math.log, $f8fd3b4e5f17ffb5$var$LN2 = Math.LN2;
function $f8fd3b4e5f17ffb5$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($f8fd3b4e5f17ffb5$var$log(x) / $f8fd3b4e5f17ffb5$var$LN2 | 0) | 0;
}
var $f8fd3b4e5f17ffb5$var$nextTransitionLane = 256, $f8fd3b4e5f17ffb5$var$nextRetryLane = 4194304;
function $f8fd3b4e5f17ffb5$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 4194048;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $f8fd3b4e5f17ffb5$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $f8fd3b4e5f17ffb5$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $f8fd3b4e5f17ffb5$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $f8fd3b4e5f17ffb5$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $f8fd3b4e5f17ffb5$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $f8fd3b4e5f17ffb5$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $f8fd3b4e5f17ffb5$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $f8fd3b4e5f17ffb5$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $f8fd3b4e5f17ffb5$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $f8fd3b4e5f17ffb5$var$claimNextTransitionLane() {
    var lane = $f8fd3b4e5f17ffb5$var$nextTransitionLane;
    $f8fd3b4e5f17ffb5$var$nextTransitionLane <<= 1;
    0 === ($f8fd3b4e5f17ffb5$var$nextTransitionLane & 4194048) && ($f8fd3b4e5f17ffb5$var$nextTransitionLane = 256);
    return lane;
}
function $f8fd3b4e5f17ffb5$var$claimNextRetryLane() {
    var lane = $f8fd3b4e5f17ffb5$var$nextRetryLane;
    $f8fd3b4e5f17ffb5$var$nextRetryLane <<= 1;
    0 === ($f8fd3b4e5f17ffb5$var$nextRetryLane & 62914560) && ($f8fd3b4e5f17ffb5$var$nextRetryLane = 4194304);
    return lane;
}
function $f8fd3b4e5f17ffb5$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $f8fd3b4e5f17ffb5$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $f8fd3b4e5f17ffb5$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$5 = 31 - $f8fd3b4e5f17ffb5$var$clz32(remainingLanes), lane = 1 << index$5;
        entanglements[index$5] = 0;
        expirationTimes[index$5] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$5];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$5] = null, index$5 = 0; index$5 < hiddenUpdatesForLane.length; index$5++){
            var update = hiddenUpdatesForLane[index$5];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $f8fd3b4e5f17ffb5$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $f8fd3b4e5f17ffb5$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $f8fd3b4e5f17ffb5$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194090;
}
function $f8fd3b4e5f17ffb5$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$6 = 31 - $f8fd3b4e5f17ffb5$var$clz32(rootEntangledLanes), lane = 1 << index$6;
        lane & entangledLanes | root[index$6] & entangledLanes && (root[index$6] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $f8fd3b4e5f17ffb5$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $f8fd3b4e5f17ffb5$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $f8fd3b4e5f17ffb5$var$resolveUpdatePriority() {
    var updatePriority = $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $f8fd3b4e5f17ffb5$var$getEventPriority(updatePriority.type);
}
function $f8fd3b4e5f17ffb5$var$runWithPriority(priority, fn) {
    var previousPriority = $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p;
    try {
        return $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $f8fd3b4e5f17ffb5$var$randomKey = Math.random().toString(36).slice(2), $f8fd3b4e5f17ffb5$var$internalInstanceKey = "__reactFiber$" + $f8fd3b4e5f17ffb5$var$randomKey, $f8fd3b4e5f17ffb5$var$internalPropsKey = "__reactProps$" + $f8fd3b4e5f17ffb5$var$randomKey, $f8fd3b4e5f17ffb5$var$internalContainerInstanceKey = "__reactContainer$" + $f8fd3b4e5f17ffb5$var$randomKey, $f8fd3b4e5f17ffb5$var$internalEventHandlersKey = "__reactEvents$" + $f8fd3b4e5f17ffb5$var$randomKey, $f8fd3b4e5f17ffb5$var$internalEventHandlerListenersKey = "__reactListeners$" + $f8fd3b4e5f17ffb5$var$randomKey, $f8fd3b4e5f17ffb5$var$internalEventHandlesSetKey = "__reactHandles$" + $f8fd3b4e5f17ffb5$var$randomKey, $f8fd3b4e5f17ffb5$var$internalRootNodeResourcesKey = "__reactResources$" + $f8fd3b4e5f17ffb5$var$randomKey, $f8fd3b4e5f17ffb5$var$internalHoistableMarker = "__reactMarker$" + $f8fd3b4e5f17ffb5$var$randomKey;
function $f8fd3b4e5f17ffb5$var$detachDeletedInstance(node) {
    delete node[$f8fd3b4e5f17ffb5$var$internalInstanceKey];
    delete node[$f8fd3b4e5f17ffb5$var$internalPropsKey];
    delete node[$f8fd3b4e5f17ffb5$var$internalEventHandlersKey];
    delete node[$f8fd3b4e5f17ffb5$var$internalEventHandlerListenersKey];
    delete node[$f8fd3b4e5f17ffb5$var$internalEventHandlesSetKey];
}
function $f8fd3b4e5f17ffb5$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$f8fd3b4e5f17ffb5$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$f8fd3b4e5f17ffb5$var$internalContainerInstanceKey] || parentNode[$f8fd3b4e5f17ffb5$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $f8fd3b4e5f17ffb5$var$getParentSuspenseInstance(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$f8fd3b4e5f17ffb5$var$internalInstanceKey]) return parentNode;
                targetNode = $f8fd3b4e5f17ffb5$var$getParentSuspenseInstance(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $f8fd3b4e5f17ffb5$var$getInstanceFromNode(node) {
    if (node = node[$f8fd3b4e5f17ffb5$var$internalInstanceKey] || node[$f8fd3b4e5f17ffb5$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $f8fd3b4e5f17ffb5$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(33));
}
function $f8fd3b4e5f17ffb5$var$getResourcesFromRoot(root) {
    var resources = root[$f8fd3b4e5f17ffb5$var$internalRootNodeResourcesKey];
    resources || (resources = root[$f8fd3b4e5f17ffb5$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(node) {
    node[$f8fd3b4e5f17ffb5$var$internalHoistableMarker] = !0;
}
var $f8fd3b4e5f17ffb5$var$allNativeEvents = new Set(), $f8fd3b4e5f17ffb5$var$registrationNameDependencies = {};
function $f8fd3b4e5f17ffb5$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $f8fd3b4e5f17ffb5$var$registerDirectEvent(registrationName, dependencies);
    $f8fd3b4e5f17ffb5$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $f8fd3b4e5f17ffb5$var$registerDirectEvent(registrationName, dependencies) {
    $f8fd3b4e5f17ffb5$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$f8fd3b4e5f17ffb5$var$allNativeEvents.add(dependencies[registrationName]);
}
var $f8fd3b4e5f17ffb5$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $f8fd3b4e5f17ffb5$var$illegalAttributeNameCache = {}, $f8fd3b4e5f17ffb5$var$validatedAttributeNameCache = {};
function $f8fd3b4e5f17ffb5$var$isAttributeNameSafe(attributeName) {
    if ($f8fd3b4e5f17ffb5$var$hasOwnProperty.call($f8fd3b4e5f17ffb5$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($f8fd3b4e5f17ffb5$var$hasOwnProperty.call($f8fd3b4e5f17ffb5$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($f8fd3b4e5f17ffb5$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $f8fd3b4e5f17ffb5$var$validatedAttributeNameCache[attributeName] = !0;
    $f8fd3b4e5f17ffb5$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $f8fd3b4e5f17ffb5$var$setValueForAttribute(node, name, value) {
    if ($f8fd3b4e5f17ffb5$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$8 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$8 && "aria-" !== prefix$8) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $f8fd3b4e5f17ffb5$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $f8fd3b4e5f17ffb5$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
var $f8fd3b4e5f17ffb5$var$prefix, $f8fd3b4e5f17ffb5$var$suffix;
function $f8fd3b4e5f17ffb5$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $f8fd3b4e5f17ffb5$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $f8fd3b4e5f17ffb5$var$prefix = match && match[1] || "";
        $f8fd3b4e5f17ffb5$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $f8fd3b4e5f17ffb5$var$prefix + name + $f8fd3b4e5f17ffb5$var$suffix;
}
var $f8fd3b4e5f17ffb5$var$reentry = !1;
function $f8fd3b4e5f17ffb5$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $f8fd3b4e5f17ffb5$var$reentry) return "";
    $f8fd3b4e5f17ffb5$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$9) {
                                control = x$9;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$10) {
                            control = x$10;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $f8fd3b4e5f17ffb5$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $f8fd3b4e5f17ffb5$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $f8fd3b4e5f17ffb5$var$describeFiber(fiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $f8fd3b4e5f17ffb5$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $f8fd3b4e5f17ffb5$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return $f8fd3b4e5f17ffb5$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $f8fd3b4e5f17ffb5$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $f8fd3b4e5f17ffb5$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $f8fd3b4e5f17ffb5$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $f8fd3b4e5f17ffb5$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $f8fd3b4e5f17ffb5$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $f8fd3b4e5f17ffb5$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "";
        do info += $f8fd3b4e5f17ffb5$var$describeFiber(workInProgress), workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
function $f8fd3b4e5f17ffb5$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $f8fd3b4e5f17ffb5$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $f8fd3b4e5f17ffb5$var$trackValueOnNode(node) {
    var valueField = $f8fd3b4e5f17ffb5$var$isCheckable(node) ? "checked" : "value", descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField), currentValue = "" + node[valueField];
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $f8fd3b4e5f17ffb5$var$track(node) {
    node._valueTracker || (node._valueTracker = $f8fd3b4e5f17ffb5$var$trackValueOnNode(node));
}
function $f8fd3b4e5f17ffb5$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $f8fd3b4e5f17ffb5$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $f8fd3b4e5f17ffb5$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $f8fd3b4e5f17ffb5$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $f8fd3b4e5f17ffb5$var$getToStringValue(value);
        } else element.value !== "" + $f8fd3b4e5f17ffb5$var$getToStringValue(value) && (element.value = "" + $f8fd3b4e5f17ffb5$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $f8fd3b4e5f17ffb5$var$setDefaultValue(element, type, $f8fd3b4e5f17ffb5$var$getToStringValue(value)) : null != defaultValue ? $f8fd3b4e5f17ffb5$var$setDefaultValue(element, type, $f8fd3b4e5f17ffb5$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $f8fd3b4e5f17ffb5$var$getToStringValue(name) : element.removeAttribute("name");
}
function $f8fd3b4e5f17ffb5$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) return;
        defaultValue = null != defaultValue ? "" + $f8fd3b4e5f17ffb5$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $f8fd3b4e5f17ffb5$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
}
function $f8fd3b4e5f17ffb5$var$setDefaultValue(node, type, value) {
    "number" === type && $f8fd3b4e5f17ffb5$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $f8fd3b4e5f17ffb5$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $f8fd3b4e5f17ffb5$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $f8fd3b4e5f17ffb5$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $f8fd3b4e5f17ffb5$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $f8fd3b4e5f17ffb5$var$getToStringValue(defaultValue) : "";
}
function $f8fd3b4e5f17ffb5$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(92));
            if ($f8fd3b4e5f17ffb5$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $f8fd3b4e5f17ffb5$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
}
function $f8fd3b4e5f17ffb5$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $f8fd3b4e5f17ffb5$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $f8fd3b4e5f17ffb5$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $f8fd3b4e5f17ffb5$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $f8fd3b4e5f17ffb5$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $f8fd3b4e5f17ffb5$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $f8fd3b4e5f17ffb5$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $f8fd3b4e5f17ffb5$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $f8fd3b4e5f17ffb5$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $f8fd3b4e5f17ffb5$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $f8fd3b4e5f17ffb5$var$sanitizeURL(url) {
    return $f8fd3b4e5f17ffb5$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $f8fd3b4e5f17ffb5$var$currentReplayingEvent = null;
function $f8fd3b4e5f17ffb5$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $f8fd3b4e5f17ffb5$var$restoreTarget = null, $f8fd3b4e5f17ffb5$var$restoreQueue = null;
function $f8fd3b4e5f17ffb5$var$restoreStateOfTarget(target) {
    var internalInstance = $f8fd3b4e5f17ffb5$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$f8fd3b4e5f17ffb5$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $f8fd3b4e5f17ffb5$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$f8fd3b4e5f17ffb5$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(90));
                            $f8fd3b4e5f17ffb5$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $f8fd3b4e5f17ffb5$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $f8fd3b4e5f17ffb5$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $f8fd3b4e5f17ffb5$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $f8fd3b4e5f17ffb5$var$isInsideEventHandler = !1;
function $f8fd3b4e5f17ffb5$var$batchedUpdates$1(fn, a, b) {
    if ($f8fd3b4e5f17ffb5$var$isInsideEventHandler) return fn(a, b);
    $f8fd3b4e5f17ffb5$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($f8fd3b4e5f17ffb5$var$isInsideEventHandler = !1, null !== $f8fd3b4e5f17ffb5$var$restoreTarget || null !== $f8fd3b4e5f17ffb5$var$restoreQueue) {
            if ($f8fd3b4e5f17ffb5$var$flushSyncWork$1(), $f8fd3b4e5f17ffb5$var$restoreTarget && (a = $f8fd3b4e5f17ffb5$var$restoreTarget, fn = $f8fd3b4e5f17ffb5$var$restoreQueue, $f8fd3b4e5f17ffb5$var$restoreQueue = $f8fd3b4e5f17ffb5$var$restoreTarget = null, $f8fd3b4e5f17ffb5$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$f8fd3b4e5f17ffb5$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $f8fd3b4e5f17ffb5$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$f8fd3b4e5f17ffb5$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $f8fd3b4e5f17ffb5$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $f8fd3b4e5f17ffb5$var$passiveBrowserEventsSupported = !1;
if ($f8fd3b4e5f17ffb5$var$canUseDOM) try {
    var $f8fd3b4e5f17ffb5$var$options = {};
    Object.defineProperty($f8fd3b4e5f17ffb5$var$options, "passive", {
        get: function() {
            $f8fd3b4e5f17ffb5$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $f8fd3b4e5f17ffb5$var$options, $f8fd3b4e5f17ffb5$var$options);
    window.removeEventListener("test", $f8fd3b4e5f17ffb5$var$options, $f8fd3b4e5f17ffb5$var$options);
} catch (e) {
    $f8fd3b4e5f17ffb5$var$passiveBrowserEventsSupported = !1;
}
var $f8fd3b4e5f17ffb5$var$root = null, $f8fd3b4e5f17ffb5$var$startText = null, $f8fd3b4e5f17ffb5$var$fallbackText = null;
function $f8fd3b4e5f17ffb5$var$getData() {
    if ($f8fd3b4e5f17ffb5$var$fallbackText) return $f8fd3b4e5f17ffb5$var$fallbackText;
    var start, startValue = $f8fd3b4e5f17ffb5$var$startText, startLength = startValue.length, end, endValue = "value" in $f8fd3b4e5f17ffb5$var$root ? $f8fd3b4e5f17ffb5$var$root.value : $f8fd3b4e5f17ffb5$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $f8fd3b4e5f17ffb5$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $f8fd3b4e5f17ffb5$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $f8fd3b4e5f17ffb5$var$functionThatReturnsTrue() {
    return !0;
}
function $f8fd3b4e5f17ffb5$var$functionThatReturnsFalse() {
    return !1;
}
function $f8fd3b4e5f17ffb5$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $f8fd3b4e5f17ffb5$var$functionThatReturnsTrue : $f8fd3b4e5f17ffb5$var$functionThatReturnsFalse;
        this.isPropagationStopped = $f8fd3b4e5f17ffb5$var$functionThatReturnsFalse;
        return this;
    }
    $f8fd3b4e5f17ffb5$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $f8fd3b4e5f17ffb5$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $f8fd3b4e5f17ffb5$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $f8fd3b4e5f17ffb5$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $f8fd3b4e5f17ffb5$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $f8fd3b4e5f17ffb5$var$SyntheticEvent = $f8fd3b4e5f17ffb5$var$createSyntheticEvent($f8fd3b4e5f17ffb5$var$EventInterface), $f8fd3b4e5f17ffb5$var$UIEventInterface = $f8fd3b4e5f17ffb5$var$assign({}, $f8fd3b4e5f17ffb5$var$EventInterface, {
    view: 0,
    detail: 0
}), $f8fd3b4e5f17ffb5$var$SyntheticUIEvent = $f8fd3b4e5f17ffb5$var$createSyntheticEvent($f8fd3b4e5f17ffb5$var$UIEventInterface), $f8fd3b4e5f17ffb5$var$lastMovementX, $f8fd3b4e5f17ffb5$var$lastMovementY, $f8fd3b4e5f17ffb5$var$lastMouseEvent, $f8fd3b4e5f17ffb5$var$MouseEventInterface = $f8fd3b4e5f17ffb5$var$assign({}, $f8fd3b4e5f17ffb5$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $f8fd3b4e5f17ffb5$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $f8fd3b4e5f17ffb5$var$lastMouseEvent && ($f8fd3b4e5f17ffb5$var$lastMouseEvent && "mousemove" === event.type ? ($f8fd3b4e5f17ffb5$var$lastMovementX = event.screenX - $f8fd3b4e5f17ffb5$var$lastMouseEvent.screenX, $f8fd3b4e5f17ffb5$var$lastMovementY = event.screenY - $f8fd3b4e5f17ffb5$var$lastMouseEvent.screenY) : $f8fd3b4e5f17ffb5$var$lastMovementY = $f8fd3b4e5f17ffb5$var$lastMovementX = 0, $f8fd3b4e5f17ffb5$var$lastMouseEvent = event);
        return $f8fd3b4e5f17ffb5$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $f8fd3b4e5f17ffb5$var$lastMovementY;
    }
}), $f8fd3b4e5f17ffb5$var$SyntheticMouseEvent = $f8fd3b4e5f17ffb5$var$createSyntheticEvent($f8fd3b4e5f17ffb5$var$MouseEventInterface), $f8fd3b4e5f17ffb5$var$DragEventInterface = $f8fd3b4e5f17ffb5$var$assign({}, $f8fd3b4e5f17ffb5$var$MouseEventInterface, {
    dataTransfer: 0
}), $f8fd3b4e5f17ffb5$var$SyntheticDragEvent = $f8fd3b4e5f17ffb5$var$createSyntheticEvent($f8fd3b4e5f17ffb5$var$DragEventInterface), $f8fd3b4e5f17ffb5$var$FocusEventInterface = $f8fd3b4e5f17ffb5$var$assign({}, $f8fd3b4e5f17ffb5$var$UIEventInterface, {
    relatedTarget: 0
}), $f8fd3b4e5f17ffb5$var$SyntheticFocusEvent = $f8fd3b4e5f17ffb5$var$createSyntheticEvent($f8fd3b4e5f17ffb5$var$FocusEventInterface), $f8fd3b4e5f17ffb5$var$AnimationEventInterface = $f8fd3b4e5f17ffb5$var$assign({}, $f8fd3b4e5f17ffb5$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f8fd3b4e5f17ffb5$var$SyntheticAnimationEvent = $f8fd3b4e5f17ffb5$var$createSyntheticEvent($f8fd3b4e5f17ffb5$var$AnimationEventInterface), $f8fd3b4e5f17ffb5$var$ClipboardEventInterface = $f8fd3b4e5f17ffb5$var$assign({}, $f8fd3b4e5f17ffb5$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $f8fd3b4e5f17ffb5$var$SyntheticClipboardEvent = $f8fd3b4e5f17ffb5$var$createSyntheticEvent($f8fd3b4e5f17ffb5$var$ClipboardEventInterface), $f8fd3b4e5f17ffb5$var$CompositionEventInterface = $f8fd3b4e5f17ffb5$var$assign({}, $f8fd3b4e5f17ffb5$var$EventInterface, {
    data: 0
}), $f8fd3b4e5f17ffb5$var$SyntheticCompositionEvent = $f8fd3b4e5f17ffb5$var$createSyntheticEvent($f8fd3b4e5f17ffb5$var$CompositionEventInterface), $f8fd3b4e5f17ffb5$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $f8fd3b4e5f17ffb5$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $f8fd3b4e5f17ffb5$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $f8fd3b4e5f17ffb5$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $f8fd3b4e5f17ffb5$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $f8fd3b4e5f17ffb5$var$getEventModifierState() {
    return $f8fd3b4e5f17ffb5$var$modifierStateGetter;
}
var $f8fd3b4e5f17ffb5$var$KeyboardEventInterface = $f8fd3b4e5f17ffb5$var$assign({}, $f8fd3b4e5f17ffb5$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $f8fd3b4e5f17ffb5$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $f8fd3b4e5f17ffb5$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $f8fd3b4e5f17ffb5$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $f8fd3b4e5f17ffb5$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $f8fd3b4e5f17ffb5$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $f8fd3b4e5f17ffb5$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $f8fd3b4e5f17ffb5$var$SyntheticKeyboardEvent = $f8fd3b4e5f17ffb5$var$createSyntheticEvent($f8fd3b4e5f17ffb5$var$KeyboardEventInterface), $f8fd3b4e5f17ffb5$var$PointerEventInterface = $f8fd3b4e5f17ffb5$var$assign({}, $f8fd3b4e5f17ffb5$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $f8fd3b4e5f17ffb5$var$SyntheticPointerEvent = $f8fd3b4e5f17ffb5$var$createSyntheticEvent($f8fd3b4e5f17ffb5$var$PointerEventInterface), $f8fd3b4e5f17ffb5$var$TouchEventInterface = $f8fd3b4e5f17ffb5$var$assign({}, $f8fd3b4e5f17ffb5$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $f8fd3b4e5f17ffb5$var$getEventModifierState
}), $f8fd3b4e5f17ffb5$var$SyntheticTouchEvent = $f8fd3b4e5f17ffb5$var$createSyntheticEvent($f8fd3b4e5f17ffb5$var$TouchEventInterface), $f8fd3b4e5f17ffb5$var$TransitionEventInterface = $f8fd3b4e5f17ffb5$var$assign({}, $f8fd3b4e5f17ffb5$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f8fd3b4e5f17ffb5$var$SyntheticTransitionEvent = $f8fd3b4e5f17ffb5$var$createSyntheticEvent($f8fd3b4e5f17ffb5$var$TransitionEventInterface), $f8fd3b4e5f17ffb5$var$WheelEventInterface = $f8fd3b4e5f17ffb5$var$assign({}, $f8fd3b4e5f17ffb5$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $f8fd3b4e5f17ffb5$var$SyntheticWheelEvent = $f8fd3b4e5f17ffb5$var$createSyntheticEvent($f8fd3b4e5f17ffb5$var$WheelEventInterface), $f8fd3b4e5f17ffb5$var$ToggleEventInterface = $f8fd3b4e5f17ffb5$var$assign({}, $f8fd3b4e5f17ffb5$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $f8fd3b4e5f17ffb5$var$SyntheticToggleEvent = $f8fd3b4e5f17ffb5$var$createSyntheticEvent($f8fd3b4e5f17ffb5$var$ToggleEventInterface), $f8fd3b4e5f17ffb5$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $f8fd3b4e5f17ffb5$var$canUseCompositionEvent = $f8fd3b4e5f17ffb5$var$canUseDOM && "CompositionEvent" in window, $f8fd3b4e5f17ffb5$var$documentMode = null;
$f8fd3b4e5f17ffb5$var$canUseDOM && "documentMode" in document && ($f8fd3b4e5f17ffb5$var$documentMode = document.documentMode);
var $f8fd3b4e5f17ffb5$var$canUseTextInputEvent = $f8fd3b4e5f17ffb5$var$canUseDOM && "TextEvent" in window && !$f8fd3b4e5f17ffb5$var$documentMode, $f8fd3b4e5f17ffb5$var$useFallbackCompositionData = $f8fd3b4e5f17ffb5$var$canUseDOM && (!$f8fd3b4e5f17ffb5$var$canUseCompositionEvent || $f8fd3b4e5f17ffb5$var$documentMode && 8 < $f8fd3b4e5f17ffb5$var$documentMode && 11 >= $f8fd3b4e5f17ffb5$var$documentMode), $f8fd3b4e5f17ffb5$var$SPACEBAR_CHAR = String.fromCharCode(32), $f8fd3b4e5f17ffb5$var$hasSpaceKeypress = !1;
function $f8fd3b4e5f17ffb5$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $f8fd3b4e5f17ffb5$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $f8fd3b4e5f17ffb5$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $f8fd3b4e5f17ffb5$var$isComposing = !1;
function $f8fd3b4e5f17ffb5$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $f8fd3b4e5f17ffb5$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $f8fd3b4e5f17ffb5$var$hasSpaceKeypress = !0;
            return $f8fd3b4e5f17ffb5$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $f8fd3b4e5f17ffb5$var$SPACEBAR_CHAR && $f8fd3b4e5f17ffb5$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $f8fd3b4e5f17ffb5$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($f8fd3b4e5f17ffb5$var$isComposing) return "compositionend" === domEventName || !$f8fd3b4e5f17ffb5$var$canUseCompositionEvent && $f8fd3b4e5f17ffb5$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $f8fd3b4e5f17ffb5$var$getData(), $f8fd3b4e5f17ffb5$var$fallbackText = $f8fd3b4e5f17ffb5$var$startText = $f8fd3b4e5f17ffb5$var$root = null, $f8fd3b4e5f17ffb5$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $f8fd3b4e5f17ffb5$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $f8fd3b4e5f17ffb5$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $f8fd3b4e5f17ffb5$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$f8fd3b4e5f17ffb5$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $f8fd3b4e5f17ffb5$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $f8fd3b4e5f17ffb5$var$restoreTarget ? $f8fd3b4e5f17ffb5$var$restoreQueue ? $f8fd3b4e5f17ffb5$var$restoreQueue.push(target) : $f8fd3b4e5f17ffb5$var$restoreQueue = [
        target
    ] : $f8fd3b4e5f17ffb5$var$restoreTarget = target;
    inst = $f8fd3b4e5f17ffb5$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $f8fd3b4e5f17ffb5$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $f8fd3b4e5f17ffb5$var$activeElement$1 = null, $f8fd3b4e5f17ffb5$var$activeElementInst$1 = null;
function $f8fd3b4e5f17ffb5$var$runEventInBatch(dispatchQueue) {
    $f8fd3b4e5f17ffb5$var$processDispatchQueue(dispatchQueue, 0);
}
function $f8fd3b4e5f17ffb5$var$getInstIfValueChanged(targetInst) {
    var targetNode = $f8fd3b4e5f17ffb5$var$getNodeFromInstance(targetInst);
    if ($f8fd3b4e5f17ffb5$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $f8fd3b4e5f17ffb5$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $f8fd3b4e5f17ffb5$var$isInputEventSupported = !1;
if ($f8fd3b4e5f17ffb5$var$canUseDOM) {
    var $f8fd3b4e5f17ffb5$var$JSCompiler_inline_result$jscomp$282;
    if ($f8fd3b4e5f17ffb5$var$canUseDOM) {
        var $f8fd3b4e5f17ffb5$var$isSupported$jscomp$inline_417 = "oninput" in document;
        if (!$f8fd3b4e5f17ffb5$var$isSupported$jscomp$inline_417) {
            var $f8fd3b4e5f17ffb5$var$element$jscomp$inline_418 = document.createElement("div");
            $f8fd3b4e5f17ffb5$var$element$jscomp$inline_418.setAttribute("oninput", "return;");
            $f8fd3b4e5f17ffb5$var$isSupported$jscomp$inline_417 = "function" === typeof $f8fd3b4e5f17ffb5$var$element$jscomp$inline_418.oninput;
        }
        $f8fd3b4e5f17ffb5$var$JSCompiler_inline_result$jscomp$282 = $f8fd3b4e5f17ffb5$var$isSupported$jscomp$inline_417;
    } else $f8fd3b4e5f17ffb5$var$JSCompiler_inline_result$jscomp$282 = !1;
    $f8fd3b4e5f17ffb5$var$isInputEventSupported = $f8fd3b4e5f17ffb5$var$JSCompiler_inline_result$jscomp$282 && (!document.documentMode || 9 < document.documentMode);
}
function $f8fd3b4e5f17ffb5$var$stopWatchingForValueChange() {
    $f8fd3b4e5f17ffb5$var$activeElement$1 && ($f8fd3b4e5f17ffb5$var$activeElement$1.detachEvent("onpropertychange", $f8fd3b4e5f17ffb5$var$handlePropertyChange), $f8fd3b4e5f17ffb5$var$activeElementInst$1 = $f8fd3b4e5f17ffb5$var$activeElement$1 = null);
}
function $f8fd3b4e5f17ffb5$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $f8fd3b4e5f17ffb5$var$getInstIfValueChanged($f8fd3b4e5f17ffb5$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $f8fd3b4e5f17ffb5$var$createAndAccumulateChangeEvent(dispatchQueue, $f8fd3b4e5f17ffb5$var$activeElementInst$1, nativeEvent, $f8fd3b4e5f17ffb5$var$getEventTarget(nativeEvent));
        $f8fd3b4e5f17ffb5$var$batchedUpdates$1($f8fd3b4e5f17ffb5$var$runEventInBatch, dispatchQueue);
    }
}
function $f8fd3b4e5f17ffb5$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($f8fd3b4e5f17ffb5$var$stopWatchingForValueChange(), $f8fd3b4e5f17ffb5$var$activeElement$1 = target, $f8fd3b4e5f17ffb5$var$activeElementInst$1 = targetInst, $f8fd3b4e5f17ffb5$var$activeElement$1.attachEvent("onpropertychange", $f8fd3b4e5f17ffb5$var$handlePropertyChange)) : "focusout" === domEventName && $f8fd3b4e5f17ffb5$var$stopWatchingForValueChange();
}
function $f8fd3b4e5f17ffb5$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $f8fd3b4e5f17ffb5$var$getInstIfValueChanged($f8fd3b4e5f17ffb5$var$activeElementInst$1);
}
function $f8fd3b4e5f17ffb5$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $f8fd3b4e5f17ffb5$var$getInstIfValueChanged(targetInst);
}
function $f8fd3b4e5f17ffb5$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $f8fd3b4e5f17ffb5$var$getInstIfValueChanged(targetInst);
}
function $f8fd3b4e5f17ffb5$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $f8fd3b4e5f17ffb5$var$objectIs = "function" === typeof Object.is ? Object.is : $f8fd3b4e5f17ffb5$var$is;
function $f8fd3b4e5f17ffb5$var$shallowEqual(objA, objB) {
    if ($f8fd3b4e5f17ffb5$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$f8fd3b4e5f17ffb5$var$hasOwnProperty.call(objB, currentKey) || !$f8fd3b4e5f17ffb5$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $f8fd3b4e5f17ffb5$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $f8fd3b4e5f17ffb5$var$getNodeForCharacterOffset(root, offset) {
    var node = $f8fd3b4e5f17ffb5$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $f8fd3b4e5f17ffb5$var$getLeafNode(node);
    }
}
function $f8fd3b4e5f17ffb5$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $f8fd3b4e5f17ffb5$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $f8fd3b4e5f17ffb5$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $f8fd3b4e5f17ffb5$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $f8fd3b4e5f17ffb5$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $f8fd3b4e5f17ffb5$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $f8fd3b4e5f17ffb5$var$skipSelectionChangeEvent = $f8fd3b4e5f17ffb5$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $f8fd3b4e5f17ffb5$var$activeElement = null, $f8fd3b4e5f17ffb5$var$activeElementInst = null, $f8fd3b4e5f17ffb5$var$lastSelection = null, $f8fd3b4e5f17ffb5$var$mouseDown = !1;
function $f8fd3b4e5f17ffb5$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $f8fd3b4e5f17ffb5$var$mouseDown || null == $f8fd3b4e5f17ffb5$var$activeElement || $f8fd3b4e5f17ffb5$var$activeElement !== $f8fd3b4e5f17ffb5$var$getActiveElement(doc) || (doc = $f8fd3b4e5f17ffb5$var$activeElement, "selectionStart" in doc && $f8fd3b4e5f17ffb5$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $f8fd3b4e5f17ffb5$var$lastSelection && $f8fd3b4e5f17ffb5$var$shallowEqual($f8fd3b4e5f17ffb5$var$lastSelection, doc) || ($f8fd3b4e5f17ffb5$var$lastSelection = doc, doc = $f8fd3b4e5f17ffb5$var$accumulateTwoPhaseListeners($f8fd3b4e5f17ffb5$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $f8fd3b4e5f17ffb5$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $f8fd3b4e5f17ffb5$var$activeElement)));
}
function $f8fd3b4e5f17ffb5$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $f8fd3b4e5f17ffb5$var$vendorPrefixes = {
    animationend: $f8fd3b4e5f17ffb5$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $f8fd3b4e5f17ffb5$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $f8fd3b4e5f17ffb5$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $f8fd3b4e5f17ffb5$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $f8fd3b4e5f17ffb5$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $f8fd3b4e5f17ffb5$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $f8fd3b4e5f17ffb5$var$makePrefixMap("Transition", "TransitionEnd")
}, $f8fd3b4e5f17ffb5$var$prefixedEventNames = {}, $f8fd3b4e5f17ffb5$var$style = {};
$f8fd3b4e5f17ffb5$var$canUseDOM && ($f8fd3b4e5f17ffb5$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $f8fd3b4e5f17ffb5$var$vendorPrefixes.animationend.animation, delete $f8fd3b4e5f17ffb5$var$vendorPrefixes.animationiteration.animation, delete $f8fd3b4e5f17ffb5$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $f8fd3b4e5f17ffb5$var$vendorPrefixes.transitionend.transition);
function $f8fd3b4e5f17ffb5$var$getVendorPrefixedEventName(eventName) {
    if ($f8fd3b4e5f17ffb5$var$prefixedEventNames[eventName]) return $f8fd3b4e5f17ffb5$var$prefixedEventNames[eventName];
    if (!$f8fd3b4e5f17ffb5$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $f8fd3b4e5f17ffb5$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $f8fd3b4e5f17ffb5$var$style) return $f8fd3b4e5f17ffb5$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $f8fd3b4e5f17ffb5$var$ANIMATION_END = $f8fd3b4e5f17ffb5$var$getVendorPrefixedEventName("animationend"), $f8fd3b4e5f17ffb5$var$ANIMATION_ITERATION = $f8fd3b4e5f17ffb5$var$getVendorPrefixedEventName("animationiteration"), $f8fd3b4e5f17ffb5$var$ANIMATION_START = $f8fd3b4e5f17ffb5$var$getVendorPrefixedEventName("animationstart"), $f8fd3b4e5f17ffb5$var$TRANSITION_RUN = $f8fd3b4e5f17ffb5$var$getVendorPrefixedEventName("transitionrun"), $f8fd3b4e5f17ffb5$var$TRANSITION_START = $f8fd3b4e5f17ffb5$var$getVendorPrefixedEventName("transitionstart"), $f8fd3b4e5f17ffb5$var$TRANSITION_CANCEL = $f8fd3b4e5f17ffb5$var$getVendorPrefixedEventName("transitioncancel"), $f8fd3b4e5f17ffb5$var$TRANSITION_END = $f8fd3b4e5f17ffb5$var$getVendorPrefixedEventName("transitionend"), $f8fd3b4e5f17ffb5$var$topLevelEventsToReactNames = new Map(), $f8fd3b4e5f17ffb5$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$f8fd3b4e5f17ffb5$var$simpleEventPluginEvents.push("scrollEnd");
function $f8fd3b4e5f17ffb5$var$registerSimpleEvent(domEventName, reactName) {
    $f8fd3b4e5f17ffb5$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $f8fd3b4e5f17ffb5$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $f8fd3b4e5f17ffb5$var$CapturedStacks = new WeakMap();
function $f8fd3b4e5f17ffb5$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $f8fd3b4e5f17ffb5$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $f8fd3b4e5f17ffb5$var$getStackByFiberInDevAndProd(source)
        };
        $f8fd3b4e5f17ffb5$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $f8fd3b4e5f17ffb5$var$getStackByFiberInDevAndProd(source)
    };
}
var $f8fd3b4e5f17ffb5$var$concurrentQueues = [], $f8fd3b4e5f17ffb5$var$concurrentQueuesIndex = 0, $f8fd3b4e5f17ffb5$var$concurrentlyUpdatedLanes = 0;
function $f8fd3b4e5f17ffb5$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $f8fd3b4e5f17ffb5$var$concurrentQueuesIndex, i = $f8fd3b4e5f17ffb5$var$concurrentlyUpdatedLanes = $f8fd3b4e5f17ffb5$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $f8fd3b4e5f17ffb5$var$concurrentQueues[i];
        $f8fd3b4e5f17ffb5$var$concurrentQueues[i++] = null;
        var queue = $f8fd3b4e5f17ffb5$var$concurrentQueues[i];
        $f8fd3b4e5f17ffb5$var$concurrentQueues[i++] = null;
        var update = $f8fd3b4e5f17ffb5$var$concurrentQueues[i];
        $f8fd3b4e5f17ffb5$var$concurrentQueues[i++] = null;
        var lane = $f8fd3b4e5f17ffb5$var$concurrentQueues[i];
        $f8fd3b4e5f17ffb5$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $f8fd3b4e5f17ffb5$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $f8fd3b4e5f17ffb5$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $f8fd3b4e5f17ffb5$var$concurrentQueues[$f8fd3b4e5f17ffb5$var$concurrentQueuesIndex++] = fiber;
    $f8fd3b4e5f17ffb5$var$concurrentQueues[$f8fd3b4e5f17ffb5$var$concurrentQueuesIndex++] = queue;
    $f8fd3b4e5f17ffb5$var$concurrentQueues[$f8fd3b4e5f17ffb5$var$concurrentQueuesIndex++] = update;
    $f8fd3b4e5f17ffb5$var$concurrentQueues[$f8fd3b4e5f17ffb5$var$concurrentQueuesIndex++] = lane;
    $f8fd3b4e5f17ffb5$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $f8fd3b4e5f17ffb5$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $f8fd3b4e5f17ffb5$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $f8fd3b4e5f17ffb5$var$getRootForUpdatedFiber(fiber);
}
function $f8fd3b4e5f17ffb5$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $f8fd3b4e5f17ffb5$var$enqueueUpdate$1(fiber, null, null, lane);
    return $f8fd3b4e5f17ffb5$var$getRootForUpdatedFiber(fiber);
}
function $f8fd3b4e5f17ffb5$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $f8fd3b4e5f17ffb5$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $f8fd3b4e5f17ffb5$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $f8fd3b4e5f17ffb5$var$nestedUpdateCount) throw $f8fd3b4e5f17ffb5$var$nestedUpdateCount = 0, $f8fd3b4e5f17ffb5$var$rootWithNestedUpdates = null, Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $f8fd3b4e5f17ffb5$var$emptyContextObject = {};
function $f8fd3b4e5f17ffb5$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $f8fd3b4e5f17ffb5$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $f8fd3b4e5f17ffb5$var$FiberNode(tag, pendingProps, key, mode);
}
function $f8fd3b4e5f17ffb5$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $f8fd3b4e5f17ffb5$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $f8fd3b4e5f17ffb5$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $f8fd3b4e5f17ffb5$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $f8fd3b4e5f17ffb5$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $f8fd3b4e5f17ffb5$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $f8fd3b4e5f17ffb5$var$isHostHoistableType(type, pendingProps, $f8fd3b4e5f17ffb5$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $f8fd3b4e5f17ffb5$var$REACT_ACTIVITY_TYPE:
            return type = $f8fd3b4e5f17ffb5$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $f8fd3b4e5f17ffb5$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $f8fd3b4e5f17ffb5$var$REACT_FRAGMENT_TYPE:
            return $f8fd3b4e5f17ffb5$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $f8fd3b4e5f17ffb5$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $f8fd3b4e5f17ffb5$var$REACT_PROFILER_TYPE:
            return type = $f8fd3b4e5f17ffb5$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $f8fd3b4e5f17ffb5$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $f8fd3b4e5f17ffb5$var$REACT_SUSPENSE_TYPE:
            return type = $f8fd3b4e5f17ffb5$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $f8fd3b4e5f17ffb5$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $f8fd3b4e5f17ffb5$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $f8fd3b4e5f17ffb5$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $f8fd3b4e5f17ffb5$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $f8fd3b4e5f17ffb5$var$REACT_PROVIDER_TYPE:
                case $f8fd3b4e5f17ffb5$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $f8fd3b4e5f17ffb5$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $f8fd3b4e5f17ffb5$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $f8fd3b4e5f17ffb5$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $f8fd3b4e5f17ffb5$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $f8fd3b4e5f17ffb5$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $f8fd3b4e5f17ffb5$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $f8fd3b4e5f17ffb5$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $f8fd3b4e5f17ffb5$var$createFiberFromText(content, mode, lanes) {
    content = $f8fd3b4e5f17ffb5$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $f8fd3b4e5f17ffb5$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $f8fd3b4e5f17ffb5$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $f8fd3b4e5f17ffb5$var$forkStack = [], $f8fd3b4e5f17ffb5$var$forkStackIndex = 0, $f8fd3b4e5f17ffb5$var$treeForkProvider = null, $f8fd3b4e5f17ffb5$var$treeForkCount = 0, $f8fd3b4e5f17ffb5$var$idStack = [], $f8fd3b4e5f17ffb5$var$idStackIndex = 0, $f8fd3b4e5f17ffb5$var$treeContextProvider = null, $f8fd3b4e5f17ffb5$var$treeContextId = 1, $f8fd3b4e5f17ffb5$var$treeContextOverflow = "";
function $f8fd3b4e5f17ffb5$var$pushTreeFork(workInProgress, totalChildren) {
    $f8fd3b4e5f17ffb5$var$forkStack[$f8fd3b4e5f17ffb5$var$forkStackIndex++] = $f8fd3b4e5f17ffb5$var$treeForkCount;
    $f8fd3b4e5f17ffb5$var$forkStack[$f8fd3b4e5f17ffb5$var$forkStackIndex++] = $f8fd3b4e5f17ffb5$var$treeForkProvider;
    $f8fd3b4e5f17ffb5$var$treeForkProvider = workInProgress;
    $f8fd3b4e5f17ffb5$var$treeForkCount = totalChildren;
}
function $f8fd3b4e5f17ffb5$var$pushTreeId(workInProgress, totalChildren, index) {
    $f8fd3b4e5f17ffb5$var$idStack[$f8fd3b4e5f17ffb5$var$idStackIndex++] = $f8fd3b4e5f17ffb5$var$treeContextId;
    $f8fd3b4e5f17ffb5$var$idStack[$f8fd3b4e5f17ffb5$var$idStackIndex++] = $f8fd3b4e5f17ffb5$var$treeContextOverflow;
    $f8fd3b4e5f17ffb5$var$idStack[$f8fd3b4e5f17ffb5$var$idStackIndex++] = $f8fd3b4e5f17ffb5$var$treeContextProvider;
    $f8fd3b4e5f17ffb5$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $f8fd3b4e5f17ffb5$var$treeContextId;
    workInProgress = $f8fd3b4e5f17ffb5$var$treeContextOverflow;
    var baseLength = 32 - $f8fd3b4e5f17ffb5$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $f8fd3b4e5f17ffb5$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $f8fd3b4e5f17ffb5$var$treeContextId = 1 << 32 - $f8fd3b4e5f17ffb5$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $f8fd3b4e5f17ffb5$var$treeContextOverflow = length + workInProgress;
    } else $f8fd3b4e5f17ffb5$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $f8fd3b4e5f17ffb5$var$treeContextOverflow = workInProgress;
}
function $f8fd3b4e5f17ffb5$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($f8fd3b4e5f17ffb5$var$pushTreeFork(workInProgress, 1), $f8fd3b4e5f17ffb5$var$pushTreeId(workInProgress, 1, 0));
}
function $f8fd3b4e5f17ffb5$var$popTreeContext(workInProgress) {
    for(; workInProgress === $f8fd3b4e5f17ffb5$var$treeForkProvider;)$f8fd3b4e5f17ffb5$var$treeForkProvider = $f8fd3b4e5f17ffb5$var$forkStack[--$f8fd3b4e5f17ffb5$var$forkStackIndex], $f8fd3b4e5f17ffb5$var$forkStack[$f8fd3b4e5f17ffb5$var$forkStackIndex] = null, $f8fd3b4e5f17ffb5$var$treeForkCount = $f8fd3b4e5f17ffb5$var$forkStack[--$f8fd3b4e5f17ffb5$var$forkStackIndex], $f8fd3b4e5f17ffb5$var$forkStack[$f8fd3b4e5f17ffb5$var$forkStackIndex] = null;
    for(; workInProgress === $f8fd3b4e5f17ffb5$var$treeContextProvider;)$f8fd3b4e5f17ffb5$var$treeContextProvider = $f8fd3b4e5f17ffb5$var$idStack[--$f8fd3b4e5f17ffb5$var$idStackIndex], $f8fd3b4e5f17ffb5$var$idStack[$f8fd3b4e5f17ffb5$var$idStackIndex] = null, $f8fd3b4e5f17ffb5$var$treeContextOverflow = $f8fd3b4e5f17ffb5$var$idStack[--$f8fd3b4e5f17ffb5$var$idStackIndex], $f8fd3b4e5f17ffb5$var$idStack[$f8fd3b4e5f17ffb5$var$idStackIndex] = null, $f8fd3b4e5f17ffb5$var$treeContextId = $f8fd3b4e5f17ffb5$var$idStack[--$f8fd3b4e5f17ffb5$var$idStackIndex], $f8fd3b4e5f17ffb5$var$idStack[$f8fd3b4e5f17ffb5$var$idStackIndex] = null;
}
var $f8fd3b4e5f17ffb5$var$hydrationParentFiber = null, $f8fd3b4e5f17ffb5$var$nextHydratableInstance = null, $f8fd3b4e5f17ffb5$var$isHydrating = !1, $f8fd3b4e5f17ffb5$var$hydrationErrors = null, $f8fd3b4e5f17ffb5$var$rootOrSingletonContext = !1, $f8fd3b4e5f17ffb5$var$HydrationMismatchException = Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(519));
function $f8fd3b4e5f17ffb5$var$throwOnHydrationMismatch(fiber) {
    var error = Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(418, ""));
    $f8fd3b4e5f17ffb5$var$queueHydrationError($f8fd3b4e5f17ffb5$var$createCapturedValueAtFiber(error, fiber));
    throw $f8fd3b4e5f17ffb5$var$HydrationMismatchException;
}
function $f8fd3b4e5f17ffb5$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$f8fd3b4e5f17ffb5$var$internalInstanceKey] = fiber;
    instance[$f8fd3b4e5f17ffb5$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("cancel", instance);
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $f8fd3b4e5f17ffb5$var$mediaEventTypes.length; type++)$f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent($f8fd3b4e5f17ffb5$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("error", instance);
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("invalid", instance);
            $f8fd3b4e5f17ffb5$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            $f8fd3b4e5f17ffb5$var$track(instance);
            break;
        case "select":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("invalid", instance), $f8fd3b4e5f17ffb5$var$initTextarea(instance, props.value, props.defaultValue, props.children), $f8fd3b4e5f17ffb5$var$track(instance);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $f8fd3b4e5f17ffb5$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("beforetoggle", instance), $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $f8fd3b4e5f17ffb5$var$noop$1), instance = !0) : instance = !1;
    instance || $f8fd3b4e5f17ffb5$var$throwOnHydrationMismatch(fiber);
}
function $f8fd3b4e5f17ffb5$var$popToNextHostParent(fiber) {
    for($f8fd3b4e5f17ffb5$var$hydrationParentFiber = fiber.return; $f8fd3b4e5f17ffb5$var$hydrationParentFiber;)switch($f8fd3b4e5f17ffb5$var$hydrationParentFiber.tag){
        case 5:
        case 13:
            $f8fd3b4e5f17ffb5$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $f8fd3b4e5f17ffb5$var$rootOrSingletonContext = !0;
            return;
        default:
            $f8fd3b4e5f17ffb5$var$hydrationParentFiber = $f8fd3b4e5f17ffb5$var$hydrationParentFiber.return;
    }
}
function $f8fd3b4e5f17ffb5$var$popHydrationState(fiber) {
    if (fiber !== $f8fd3b4e5f17ffb5$var$hydrationParentFiber) return !1;
    if (!$f8fd3b4e5f17ffb5$var$isHydrating) return $f8fd3b4e5f17ffb5$var$popToNextHostParent(fiber), $f8fd3b4e5f17ffb5$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $f8fd3b4e5f17ffb5$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $f8fd3b4e5f17ffb5$var$nextHydratableInstance && $f8fd3b4e5f17ffb5$var$throwOnHydrationMismatch(fiber);
    $f8fd3b4e5f17ffb5$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(317));
        a: {
            fiber = fiber.nextSibling;
            for(tag = 0; fiber;){
                if (8 === fiber.nodeType) {
                    if (JSCompiler_temp = fiber.data, "/$" === JSCompiler_temp) {
                        if (0 === tag) {
                            $f8fd3b4e5f17ffb5$var$nextHydratableInstance = $f8fd3b4e5f17ffb5$var$getNextHydratable(fiber.nextSibling);
                            break a;
                        }
                        tag--;
                    } else "$" !== JSCompiler_temp && "$!" !== JSCompiler_temp && "$?" !== JSCompiler_temp || tag++;
                }
                fiber = fiber.nextSibling;
            }
            $f8fd3b4e5f17ffb5$var$nextHydratableInstance = null;
        }
    } else 27 === tag ? (tag = $f8fd3b4e5f17ffb5$var$nextHydratableInstance, $f8fd3b4e5f17ffb5$var$isSingletonScope(fiber.type) ? (fiber = $f8fd3b4e5f17ffb5$var$previousHydratableOnEnteringScopedSingleton, $f8fd3b4e5f17ffb5$var$previousHydratableOnEnteringScopedSingleton = null, $f8fd3b4e5f17ffb5$var$nextHydratableInstance = fiber) : $f8fd3b4e5f17ffb5$var$nextHydratableInstance = tag) : $f8fd3b4e5f17ffb5$var$nextHydratableInstance = $f8fd3b4e5f17ffb5$var$hydrationParentFiber ? $f8fd3b4e5f17ffb5$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $f8fd3b4e5f17ffb5$var$resetHydrationState() {
    $f8fd3b4e5f17ffb5$var$nextHydratableInstance = $f8fd3b4e5f17ffb5$var$hydrationParentFiber = null;
    $f8fd3b4e5f17ffb5$var$isHydrating = !1;
}
function $f8fd3b4e5f17ffb5$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $f8fd3b4e5f17ffb5$var$hydrationErrors;
    null !== queuedErrors && (null === $f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors ? $f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors = queuedErrors : $f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors.push.apply($f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors, queuedErrors), $f8fd3b4e5f17ffb5$var$hydrationErrors = null);
    return queuedErrors;
}
function $f8fd3b4e5f17ffb5$var$queueHydrationError(error) {
    null === $f8fd3b4e5f17ffb5$var$hydrationErrors ? $f8fd3b4e5f17ffb5$var$hydrationErrors = [
        error
    ] : $f8fd3b4e5f17ffb5$var$hydrationErrors.push(error);
}
var $f8fd3b4e5f17ffb5$var$valueCursor = $f8fd3b4e5f17ffb5$var$createCursor(null), $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber$1 = null, $f8fd3b4e5f17ffb5$var$lastContextDependency = null;
function $f8fd3b4e5f17ffb5$var$pushProvider(providerFiber, context, nextValue) {
    $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $f8fd3b4e5f17ffb5$var$popProvider(context) {
    context._currentValue = $f8fd3b4e5f17ffb5$var$valueCursor.current;
    $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$valueCursor);
}
function $f8fd3b4e5f17ffb5$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $f8fd3b4e5f17ffb5$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $f8fd3b4e5f17ffb5$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $f8fd3b4e5f17ffb5$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $f8fd3b4e5f17ffb5$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $f8fd3b4e5f17ffb5$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $f8fd3b4e5f17ffb5$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($f8fd3b4e5f17ffb5$var$HostTransitionContext) : current = [
                $f8fd3b4e5f17ffb5$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $f8fd3b4e5f17ffb5$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $f8fd3b4e5f17ffb5$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$f8fd3b4e5f17ffb5$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $f8fd3b4e5f17ffb5$var$prepareToReadContext(workInProgress) {
    $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber$1 = workInProgress;
    $f8fd3b4e5f17ffb5$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $f8fd3b4e5f17ffb5$var$readContext(context) {
    return $f8fd3b4e5f17ffb5$var$readContextForConsumer($f8fd3b4e5f17ffb5$var$currentlyRenderingFiber$1, context);
}
function $f8fd3b4e5f17ffb5$var$readContextDuringReconciliation(consumer, context) {
    null === $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber$1 && $f8fd3b4e5f17ffb5$var$prepareToReadContext(consumer);
    return $f8fd3b4e5f17ffb5$var$readContextForConsumer(consumer, context);
}
function $f8fd3b4e5f17ffb5$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $f8fd3b4e5f17ffb5$var$lastContextDependency) {
        if (null === consumer) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(308));
        $f8fd3b4e5f17ffb5$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $f8fd3b4e5f17ffb5$var$lastContextDependency = $f8fd3b4e5f17ffb5$var$lastContextDependency.next = context;
    return value;
}
var $f8fd3b4e5f17ffb5$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $f8fd3b4e5f17ffb5$var$scheduleCallback$2 = $hNfVH.unstable_scheduleCallback, $f8fd3b4e5f17ffb5$var$NormalPriority = $hNfVH.unstable_NormalPriority, $f8fd3b4e5f17ffb5$var$CacheContext = {
    $$typeof: $f8fd3b4e5f17ffb5$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $f8fd3b4e5f17ffb5$var$createCache() {
    return {
        controller: new $f8fd3b4e5f17ffb5$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $f8fd3b4e5f17ffb5$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $f8fd3b4e5f17ffb5$var$scheduleCallback$2($f8fd3b4e5f17ffb5$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $f8fd3b4e5f17ffb5$var$currentEntangledListeners = null, $f8fd3b4e5f17ffb5$var$currentEntangledPendingCount = 0, $f8fd3b4e5f17ffb5$var$currentEntangledLane = 0, $f8fd3b4e5f17ffb5$var$currentEntangledActionThenable = null;
function $f8fd3b4e5f17ffb5$var$entangleAsyncAction(transition, thenable) {
    if (null === $f8fd3b4e5f17ffb5$var$currentEntangledListeners) {
        var entangledListeners = $f8fd3b4e5f17ffb5$var$currentEntangledListeners = [];
        $f8fd3b4e5f17ffb5$var$currentEntangledPendingCount = 0;
        $f8fd3b4e5f17ffb5$var$currentEntangledLane = $f8fd3b4e5f17ffb5$var$requestTransitionLane();
        $f8fd3b4e5f17ffb5$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $f8fd3b4e5f17ffb5$var$currentEntangledPendingCount++;
    thenable.then($f8fd3b4e5f17ffb5$var$pingEngtangledActionScope, $f8fd3b4e5f17ffb5$var$pingEngtangledActionScope);
    return thenable;
}
function $f8fd3b4e5f17ffb5$var$pingEngtangledActionScope() {
    if (0 === --$f8fd3b4e5f17ffb5$var$currentEntangledPendingCount && null !== $f8fd3b4e5f17ffb5$var$currentEntangledListeners) {
        null !== $f8fd3b4e5f17ffb5$var$currentEntangledActionThenable && ($f8fd3b4e5f17ffb5$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $f8fd3b4e5f17ffb5$var$currentEntangledListeners;
        $f8fd3b4e5f17ffb5$var$currentEntangledListeners = null;
        $f8fd3b4e5f17ffb5$var$currentEntangledLane = 0;
        $f8fd3b4e5f17ffb5$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $f8fd3b4e5f17ffb5$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $f8fd3b4e5f17ffb5$var$prevOnStartTransitionFinish = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.S;
$f8fd3b4e5f17ffb5$var$ReactSharedInternals.S = function(transition, returnValue) {
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $f8fd3b4e5f17ffb5$var$entangleAsyncAction(transition, returnValue);
    null !== $f8fd3b4e5f17ffb5$var$prevOnStartTransitionFinish && $f8fd3b4e5f17ffb5$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $f8fd3b4e5f17ffb5$var$resumedCache = $f8fd3b4e5f17ffb5$var$createCursor(null);
function $f8fd3b4e5f17ffb5$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $f8fd3b4e5f17ffb5$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $f8fd3b4e5f17ffb5$var$workInProgressRoot.pooledCache;
}
function $f8fd3b4e5f17ffb5$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$resumedCache, $f8fd3b4e5f17ffb5$var$resumedCache.current) : $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$resumedCache, prevCachePool.pool);
}
function $f8fd3b4e5f17ffb5$var$getSuspendedCache() {
    var cacheFromPool = $f8fd3b4e5f17ffb5$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $f8fd3b4e5f17ffb5$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $f8fd3b4e5f17ffb5$var$SuspenseException = Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(460)), $f8fd3b4e5f17ffb5$var$SuspenseyCommitException = Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(474)), $f8fd3b4e5f17ffb5$var$SuspenseActionException = Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(542)), $f8fd3b4e5f17ffb5$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $f8fd3b4e5f17ffb5$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $f8fd3b4e5f17ffb5$var$noop$3() {}
function $f8fd3b4e5f17ffb5$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($f8fd3b4e5f17ffb5$var$noop$3, $f8fd3b4e5f17ffb5$var$noop$3), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $f8fd3b4e5f17ffb5$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($f8fd3b4e5f17ffb5$var$noop$3, $f8fd3b4e5f17ffb5$var$noop$3);
            else {
                thenableState = $f8fd3b4e5f17ffb5$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $f8fd3b4e5f17ffb5$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $f8fd3b4e5f17ffb5$var$suspendedThenable = thenable;
            throw $f8fd3b4e5f17ffb5$var$SuspenseException;
    }
}
var $f8fd3b4e5f17ffb5$var$suspendedThenable = null;
function $f8fd3b4e5f17ffb5$var$getSuspendedThenable() {
    if (null === $f8fd3b4e5f17ffb5$var$suspendedThenable) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(459));
    var thenable = $f8fd3b4e5f17ffb5$var$suspendedThenable;
    $f8fd3b4e5f17ffb5$var$suspendedThenable = null;
    return thenable;
}
function $f8fd3b4e5f17ffb5$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $f8fd3b4e5f17ffb5$var$SuspenseException || rejectedReason === $f8fd3b4e5f17ffb5$var$SuspenseActionException) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(483));
}
var $f8fd3b4e5f17ffb5$var$hasForceUpdate = !1;
function $f8fd3b4e5f17ffb5$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $f8fd3b4e5f17ffb5$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $f8fd3b4e5f17ffb5$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $f8fd3b4e5f17ffb5$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($f8fd3b4e5f17ffb5$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $f8fd3b4e5f17ffb5$var$getRootForUpdatedFiber(fiber);
        $f8fd3b4e5f17ffb5$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $f8fd3b4e5f17ffb5$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $f8fd3b4e5f17ffb5$var$getRootForUpdatedFiber(fiber);
}
function $f8fd3b4e5f17ffb5$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $f8fd3b4e5f17ffb5$var$markRootEntangled(root, lane);
    }
}
function $f8fd3b4e5f17ffb5$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $f8fd3b4e5f17ffb5$var$didReadFromEntangledAsyncAction = !1;
function $f8fd3b4e5f17ffb5$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($f8fd3b4e5f17ffb5$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $f8fd3b4e5f17ffb5$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $f8fd3b4e5f17ffb5$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $f8fd3b4e5f17ffb5$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $f8fd3b4e5f17ffb5$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $f8fd3b4e5f17ffb5$var$currentEntangledLane && ($f8fd3b4e5f17ffb5$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $f8fd3b4e5f17ffb5$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $f8fd3b4e5f17ffb5$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $f8fd3b4e5f17ffb5$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $f8fd3b4e5f17ffb5$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $f8fd3b4e5f17ffb5$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$f8fd3b4e5f17ffb5$var$callCallback(callbacks[updateQueue], context);
}
var $f8fd3b4e5f17ffb5$var$currentTreeHiddenStackCursor = $f8fd3b4e5f17ffb5$var$createCursor(null), $f8fd3b4e5f17ffb5$var$prevEntangledRenderLanesCursor = $f8fd3b4e5f17ffb5$var$createCursor(0);
function $f8fd3b4e5f17ffb5$var$pushHiddenContext(fiber, context) {
    fiber = $f8fd3b4e5f17ffb5$var$entangledRenderLanes;
    $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$prevEntangledRenderLanesCursor, fiber);
    $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$currentTreeHiddenStackCursor, context);
    $f8fd3b4e5f17ffb5$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $f8fd3b4e5f17ffb5$var$reuseHiddenContextOnStack() {
    $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$prevEntangledRenderLanesCursor, $f8fd3b4e5f17ffb5$var$entangledRenderLanes);
    $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$currentTreeHiddenStackCursor, $f8fd3b4e5f17ffb5$var$currentTreeHiddenStackCursor.current);
}
function $f8fd3b4e5f17ffb5$var$popHiddenContext() {
    $f8fd3b4e5f17ffb5$var$entangledRenderLanes = $f8fd3b4e5f17ffb5$var$prevEntangledRenderLanesCursor.current;
    $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$currentTreeHiddenStackCursor);
    $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$prevEntangledRenderLanesCursor);
}
var $f8fd3b4e5f17ffb5$var$renderLanes = 0, $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber = null, $f8fd3b4e5f17ffb5$var$currentHook = null, $f8fd3b4e5f17ffb5$var$workInProgressHook = null, $f8fd3b4e5f17ffb5$var$didScheduleRenderPhaseUpdate = !1, $f8fd3b4e5f17ffb5$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $f8fd3b4e5f17ffb5$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $f8fd3b4e5f17ffb5$var$localIdCounter = 0, $f8fd3b4e5f17ffb5$var$thenableIndexCounter$1 = 0, $f8fd3b4e5f17ffb5$var$thenableState$1 = null, $f8fd3b4e5f17ffb5$var$globalClientIdCounter = 0;
function $f8fd3b4e5f17ffb5$var$throwInvalidHookError() {
    throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(321));
}
function $f8fd3b4e5f17ffb5$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$f8fd3b4e5f17ffb5$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $f8fd3b4e5f17ffb5$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $f8fd3b4e5f17ffb5$var$renderLanes = nextRenderLanes;
    $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $f8fd3b4e5f17ffb5$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $f8fd3b4e5f17ffb5$var$HooksDispatcherOnMount : $f8fd3b4e5f17ffb5$var$HooksDispatcherOnUpdate;
    $f8fd3b4e5f17ffb5$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $f8fd3b4e5f17ffb5$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $f8fd3b4e5f17ffb5$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $f8fd3b4e5f17ffb5$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $f8fd3b4e5f17ffb5$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $f8fd3b4e5f17ffb5$var$finishRenderingHooks(current) {
    $f8fd3b4e5f17ffb5$var$ReactSharedInternals.H = $f8fd3b4e5f17ffb5$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $f8fd3b4e5f17ffb5$var$currentHook && null !== $f8fd3b4e5f17ffb5$var$currentHook.next;
    $f8fd3b4e5f17ffb5$var$renderLanes = 0;
    $f8fd3b4e5f17ffb5$var$workInProgressHook = $f8fd3b4e5f17ffb5$var$currentHook = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber = null;
    $f8fd3b4e5f17ffb5$var$didScheduleRenderPhaseUpdate = !1;
    $f8fd3b4e5f17ffb5$var$thenableIndexCounter$1 = 0;
    $f8fd3b4e5f17ffb5$var$thenableState$1 = null;
    if (didRenderTooFewHooks) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(300));
    null === current || $f8fd3b4e5f17ffb5$var$didReceiveUpdate || (current = current.dependencies, null !== current && $f8fd3b4e5f17ffb5$var$checkIfContextChanged(current) && ($f8fd3b4e5f17ffb5$var$didReceiveUpdate = !0));
}
function $f8fd3b4e5f17ffb5$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $f8fd3b4e5f17ffb5$var$didScheduleRenderPhaseUpdateDuringThisPass && ($f8fd3b4e5f17ffb5$var$thenableState$1 = null);
        $f8fd3b4e5f17ffb5$var$thenableIndexCounter$1 = 0;
        $f8fd3b4e5f17ffb5$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $f8fd3b4e5f17ffb5$var$workInProgressHook = $f8fd3b4e5f17ffb5$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $f8fd3b4e5f17ffb5$var$ReactSharedInternals.H = $f8fd3b4e5f17ffb5$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($f8fd3b4e5f17ffb5$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $f8fd3b4e5f17ffb5$var$TransitionAwareHostComponent() {
    var dispatcher = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $f8fd3b4e5f17ffb5$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $f8fd3b4e5f17ffb5$var$currentHook ? $f8fd3b4e5f17ffb5$var$currentHook.memoizedState : null) !== dispatcher && ($f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $f8fd3b4e5f17ffb5$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $f8fd3b4e5f17ffb5$var$localIdCounter;
    $f8fd3b4e5f17ffb5$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $f8fd3b4e5f17ffb5$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $f8fd3b4e5f17ffb5$var$resetHooksOnUnwind(workInProgress) {
    if ($f8fd3b4e5f17ffb5$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $f8fd3b4e5f17ffb5$var$didScheduleRenderPhaseUpdate = !1;
    }
    $f8fd3b4e5f17ffb5$var$renderLanes = 0;
    $f8fd3b4e5f17ffb5$var$workInProgressHook = $f8fd3b4e5f17ffb5$var$currentHook = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber = null;
    $f8fd3b4e5f17ffb5$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $f8fd3b4e5f17ffb5$var$thenableIndexCounter$1 = $f8fd3b4e5f17ffb5$var$localIdCounter = 0;
    $f8fd3b4e5f17ffb5$var$thenableState$1 = null;
}
function $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $f8fd3b4e5f17ffb5$var$workInProgressHook ? $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.memoizedState = $f8fd3b4e5f17ffb5$var$workInProgressHook = hook : $f8fd3b4e5f17ffb5$var$workInProgressHook = $f8fd3b4e5f17ffb5$var$workInProgressHook.next = hook;
    return $f8fd3b4e5f17ffb5$var$workInProgressHook;
}
function $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook() {
    if (null === $f8fd3b4e5f17ffb5$var$currentHook) {
        var nextCurrentHook = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $f8fd3b4e5f17ffb5$var$currentHook.next;
    var nextWorkInProgressHook = null === $f8fd3b4e5f17ffb5$var$workInProgressHook ? $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.memoizedState : $f8fd3b4e5f17ffb5$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $f8fd3b4e5f17ffb5$var$workInProgressHook = nextWorkInProgressHook, $f8fd3b4e5f17ffb5$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.alternate) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(467));
            throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(310));
        }
        $f8fd3b4e5f17ffb5$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $f8fd3b4e5f17ffb5$var$currentHook.memoizedState,
            baseState: $f8fd3b4e5f17ffb5$var$currentHook.baseState,
            baseQueue: $f8fd3b4e5f17ffb5$var$currentHook.baseQueue,
            queue: $f8fd3b4e5f17ffb5$var$currentHook.queue,
            next: null
        };
        null === $f8fd3b4e5f17ffb5$var$workInProgressHook ? $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.memoizedState = $f8fd3b4e5f17ffb5$var$workInProgressHook = nextCurrentHook : $f8fd3b4e5f17ffb5$var$workInProgressHook = $f8fd3b4e5f17ffb5$var$workInProgressHook.next = nextCurrentHook;
    }
    return $f8fd3b4e5f17ffb5$var$workInProgressHook;
}
function $f8fd3b4e5f17ffb5$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $f8fd3b4e5f17ffb5$var$useThenable(thenable) {
    var index = $f8fd3b4e5f17ffb5$var$thenableIndexCounter$1;
    $f8fd3b4e5f17ffb5$var$thenableIndexCounter$1 += 1;
    null === $f8fd3b4e5f17ffb5$var$thenableState$1 && ($f8fd3b4e5f17ffb5$var$thenableState$1 = []);
    thenable = $f8fd3b4e5f17ffb5$var$trackUsedThenable($f8fd3b4e5f17ffb5$var$thenableState$1, thenable, index);
    index = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber;
    null === (null === $f8fd3b4e5f17ffb5$var$workInProgressHook ? index.memoizedState : $f8fd3b4e5f17ffb5$var$workInProgressHook.next) && (index = index.alternate, $f8fd3b4e5f17ffb5$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $f8fd3b4e5f17ffb5$var$HooksDispatcherOnMount : $f8fd3b4e5f17ffb5$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $f8fd3b4e5f17ffb5$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $f8fd3b4e5f17ffb5$var$useThenable(usable);
        if (usable.$$typeof === $f8fd3b4e5f17ffb5$var$REACT_CONTEXT_TYPE) return $f8fd3b4e5f17ffb5$var$readContext(usable);
    }
    throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(438, String(usable)));
}
function $f8fd3b4e5f17ffb5$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $f8fd3b4e5f17ffb5$var$createFunctionComponentUpdateQueue(), $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $f8fd3b4e5f17ffb5$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $f8fd3b4e5f17ffb5$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $f8fd3b4e5f17ffb5$var$updateReducer(reducer) {
    var hook = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook();
    return $f8fd3b4e5f17ffb5$var$updateReducerImpl(hook, $f8fd3b4e5f17ffb5$var$currentHook, reducer);
}
function $f8fd3b4e5f17ffb5$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$32 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($f8fd3b4e5f17ffb5$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $f8fd3b4e5f17ffb5$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                else if (($f8fd3b4e5f17ffb5$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $f8fd3b4e5f17ffb5$var$currentEntangledLane && (didReadFromEntangledAsyncAction$32 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.lanes |= revertLane, $f8fd3b4e5f17ffb5$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $f8fd3b4e5f17ffb5$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.lanes |= updateLane, $f8fd3b4e5f17ffb5$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$f8fd3b4e5f17ffb5$var$objectIs(pendingQueue, hook.memoizedState) && ($f8fd3b4e5f17ffb5$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$32 && (reducer = $f8fd3b4e5f17ffb5$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $f8fd3b4e5f17ffb5$var$rerenderReducer(reducer) {
    var hook = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $f8fd3b4e5f17ffb5$var$objectIs(newState, hook.memoizedState) || ($f8fd3b4e5f17ffb5$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $f8fd3b4e5f17ffb5$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber, hook = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $f8fd3b4e5f17ffb5$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$f8fd3b4e5f17ffb5$var$objectIs(($f8fd3b4e5f17ffb5$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $f8fd3b4e5f17ffb5$var$didReceiveUpdate = !0);
    hook = hook.queue;
    var create = $f8fd3b4e5f17ffb5$var$subscribeToStore.bind(null, fiber, hook, subscribe);
    $f8fd3b4e5f17ffb5$var$updateEffectImpl(2048, 8, create, [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $f8fd3b4e5f17ffb5$var$workInProgressHook && $f8fd3b4e5f17ffb5$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $f8fd3b4e5f17ffb5$var$pushSimpleEffect(9, $f8fd3b4e5f17ffb5$var$createEffectInstance(), $f8fd3b4e5f17ffb5$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $f8fd3b4e5f17ffb5$var$workInProgressRoot) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($f8fd3b4e5f17ffb5$var$renderLanes & 124) || $f8fd3b4e5f17ffb5$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $f8fd3b4e5f17ffb5$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $f8fd3b4e5f17ffb5$var$createFunctionComponentUpdateQueue(), $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $f8fd3b4e5f17ffb5$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $f8fd3b4e5f17ffb5$var$checkIfSnapshotChanged(inst) && $f8fd3b4e5f17ffb5$var$forceStoreRerender(fiber);
}
function $f8fd3b4e5f17ffb5$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $f8fd3b4e5f17ffb5$var$checkIfSnapshotChanged(inst) && $f8fd3b4e5f17ffb5$var$forceStoreRerender(fiber);
    });
}
function $f8fd3b4e5f17ffb5$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$f8fd3b4e5f17ffb5$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $f8fd3b4e5f17ffb5$var$forceStoreRerender(fiber) {
    var root = $f8fd3b4e5f17ffb5$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $f8fd3b4e5f17ffb5$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $f8fd3b4e5f17ffb5$var$mountStateImpl(initialState) {
    var hook = $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($f8fd3b4e5f17ffb5$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $f8fd3b4e5f17ffb5$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $f8fd3b4e5f17ffb5$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $f8fd3b4e5f17ffb5$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $f8fd3b4e5f17ffb5$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $f8fd3b4e5f17ffb5$var$updateReducerImpl(hook, $f8fd3b4e5f17ffb5$var$currentHook, "function" === typeof reducer ? reducer : $f8fd3b4e5f17ffb5$var$basicStateReducer);
}
function $f8fd3b4e5f17ffb5$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($f8fd3b4e5f17ffb5$var$isRenderPhaseUpdate(fiber)) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $f8fd3b4e5f17ffb5$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $f8fd3b4e5f17ffb5$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T, currentTransition = {};
        $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $f8fd3b4e5f17ffb5$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $f8fd3b4e5f17ffb5$var$onActionError(actionQueue, node, error);
        } finally{
            $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $f8fd3b4e5f17ffb5$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$38) {
        $f8fd3b4e5f17ffb5$var$onActionError(actionQueue, node, error$38);
    }
}
function $f8fd3b4e5f17ffb5$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $f8fd3b4e5f17ffb5$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $f8fd3b4e5f17ffb5$var$onActionError(actionQueue, node, error);
    }) : $f8fd3b4e5f17ffb5$var$onActionSuccess(actionQueue, node, returnValue);
}
function $f8fd3b4e5f17ffb5$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $f8fd3b4e5f17ffb5$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $f8fd3b4e5f17ffb5$var$runActionStateAction(actionQueue, nextState)));
}
function $f8fd3b4e5f17ffb5$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $f8fd3b4e5f17ffb5$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $f8fd3b4e5f17ffb5$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $f8fd3b4e5f17ffb5$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $f8fd3b4e5f17ffb5$var$mountActionState(action, initialStateProp) {
    if ($f8fd3b4e5f17ffb5$var$isHydrating) {
        var ssrFormState = $f8fd3b4e5f17ffb5$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber;
                if ($f8fd3b4e5f17ffb5$var$isHydrating) {
                    if ($f8fd3b4e5f17ffb5$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $f8fd3b4e5f17ffb5$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $f8fd3b4e5f17ffb5$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $f8fd3b4e5f17ffb5$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $f8fd3b4e5f17ffb5$var$nextHydratableInstance = $f8fd3b4e5f17ffb5$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $f8fd3b4e5f17ffb5$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $f8fd3b4e5f17ffb5$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $f8fd3b4e5f17ffb5$var$dispatchSetState.bind(null, $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $f8fd3b4e5f17ffb5$var$mountStateImpl(!1);
    inRootOrSingleton = $f8fd3b4e5f17ffb5$var$dispatchOptimisticSetState.bind(null, $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $f8fd3b4e5f17ffb5$var$dispatchActionState.bind(null, $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $f8fd3b4e5f17ffb5$var$updateActionState(action) {
    var stateHook = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook();
    return $f8fd3b4e5f17ffb5$var$updateActionStateImpl(stateHook, $f8fd3b4e5f17ffb5$var$currentHook, action);
}
function $f8fd3b4e5f17ffb5$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $f8fd3b4e5f17ffb5$var$updateReducerImpl(stateHook, currentStateHook, $f8fd3b4e5f17ffb5$var$actionStateReducer)[0];
    stateHook = $f8fd3b4e5f17ffb5$var$updateReducer($f8fd3b4e5f17ffb5$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $f8fd3b4e5f17ffb5$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $f8fd3b4e5f17ffb5$var$SuspenseException) throw $f8fd3b4e5f17ffb5$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.flags |= 2048, $f8fd3b4e5f17ffb5$var$pushSimpleEffect(9, $f8fd3b4e5f17ffb5$var$createEffectInstance(), $f8fd3b4e5f17ffb5$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $f8fd3b4e5f17ffb5$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $f8fd3b4e5f17ffb5$var$rerenderActionState(action) {
    var stateHook = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook(), currentStateHook = $f8fd3b4e5f17ffb5$var$currentHook;
    if (null !== currentStateHook) return $f8fd3b4e5f17ffb5$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $f8fd3b4e5f17ffb5$var$pushSimpleEffect(tag, inst, create, createDeps) {
    tag = {
        tag: tag,
        create: create,
        deps: createDeps,
        inst: inst,
        next: null
    };
    inst = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $f8fd3b4e5f17ffb5$var$createFunctionComponentUpdateQueue(), $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (createDeps = create.next, create.next = tag, tag.next = createDeps, inst.lastEffect = tag);
    return tag;
}
function $f8fd3b4e5f17ffb5$var$createEffectInstance() {
    return {
        destroy: void 0,
        resource: void 0
    };
}
function $f8fd3b4e5f17ffb5$var$updateRef() {
    return $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook().memoizedState;
}
function $f8fd3b4e5f17ffb5$var$mountEffectImpl(fiberFlags, hookFlags, create, createDeps) {
    var hook = $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook();
    createDeps = void 0 === createDeps ? null : createDeps;
    $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $f8fd3b4e5f17ffb5$var$pushSimpleEffect(1 | hookFlags, $f8fd3b4e5f17ffb5$var$createEffectInstance(), create, createDeps);
}
function $f8fd3b4e5f17ffb5$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $f8fd3b4e5f17ffb5$var$currentHook && null !== deps && $f8fd3b4e5f17ffb5$var$areHookInputsEqual(deps, $f8fd3b4e5f17ffb5$var$currentHook.memoizedState.deps) ? hook.memoizedState = $f8fd3b4e5f17ffb5$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $f8fd3b4e5f17ffb5$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $f8fd3b4e5f17ffb5$var$mountEffect(create, createDeps) {
    $f8fd3b4e5f17ffb5$var$mountEffectImpl(8390656, 8, create, createDeps);
}
function $f8fd3b4e5f17ffb5$var$updateEffect(create, createDeps) {
    $f8fd3b4e5f17ffb5$var$updateEffectImpl(2048, 8, create, createDeps);
}
function $f8fd3b4e5f17ffb5$var$updateInsertionEffect(create, deps) {
    return $f8fd3b4e5f17ffb5$var$updateEffectImpl(4, 2, create, deps);
}
function $f8fd3b4e5f17ffb5$var$updateLayoutEffect(create, deps) {
    return $f8fd3b4e5f17ffb5$var$updateEffectImpl(4, 4, create, deps);
}
function $f8fd3b4e5f17ffb5$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $f8fd3b4e5f17ffb5$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $f8fd3b4e5f17ffb5$var$updateEffectImpl(4, 4, $f8fd3b4e5f17ffb5$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $f8fd3b4e5f17ffb5$var$mountDebugValue() {}
function $f8fd3b4e5f17ffb5$var$updateCallback(callback, deps) {
    var hook = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $f8fd3b4e5f17ffb5$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $f8fd3b4e5f17ffb5$var$updateMemo(nextCreate, deps) {
    var hook = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $f8fd3b4e5f17ffb5$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($f8fd3b4e5f17ffb5$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $f8fd3b4e5f17ffb5$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $f8fd3b4e5f17ffb5$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $f8fd3b4e5f17ffb5$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($f8fd3b4e5f17ffb5$var$renderLanes & 1073741824)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $f8fd3b4e5f17ffb5$var$requestDeferredLane();
    $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.lanes |= hook;
    $f8fd3b4e5f17ffb5$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $f8fd3b4e5f17ffb5$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($f8fd3b4e5f17ffb5$var$objectIs(value, prevValue)) return value;
    if (null !== $f8fd3b4e5f17ffb5$var$currentTreeHiddenStackCursor.current) return hook = $f8fd3b4e5f17ffb5$var$mountDeferredValueImpl(hook, value, initialValue), $f8fd3b4e5f17ffb5$var$objectIs(hook, prevValue) || ($f8fd3b4e5f17ffb5$var$didReceiveUpdate = !0), hook;
    if (0 === ($f8fd3b4e5f17ffb5$var$renderLanes & 42)) return $f8fd3b4e5f17ffb5$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $f8fd3b4e5f17ffb5$var$requestDeferredLane();
    $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber.lanes |= hook;
    $f8fd3b4e5f17ffb5$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $f8fd3b4e5f17ffb5$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p;
    $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T, currentTransition = {};
    $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = currentTransition;
    $f8fd3b4e5f17ffb5$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $f8fd3b4e5f17ffb5$var$chainThenableValue(returnValue, finishedState);
            $f8fd3b4e5f17ffb5$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $f8fd3b4e5f17ffb5$var$requestUpdateLane(fiber));
        } else $f8fd3b4e5f17ffb5$var$dispatchSetStateInternal(fiber, queue, finishedState, $f8fd3b4e5f17ffb5$var$requestUpdateLane(fiber));
    } catch (error) {
        $f8fd3b4e5f17ffb5$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $f8fd3b4e5f17ffb5$var$requestUpdateLane());
    } finally{
        $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = previousPriority, $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = prevTransition;
    }
}
function $f8fd3b4e5f17ffb5$var$noop$2() {}
function $f8fd3b4e5f17ffb5$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(476));
    var queue = $f8fd3b4e5f17ffb5$var$ensureFormComponentIsStateful(formFiber).queue;
    $f8fd3b4e5f17ffb5$var$startTransition(formFiber, queue, pendingState, $f8fd3b4e5f17ffb5$var$sharedNotPendingObject, null === action ? $f8fd3b4e5f17ffb5$var$noop$2 : function() {
        $f8fd3b4e5f17ffb5$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $f8fd3b4e5f17ffb5$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $f8fd3b4e5f17ffb5$var$sharedNotPendingObject,
        baseState: $f8fd3b4e5f17ffb5$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $f8fd3b4e5f17ffb5$var$basicStateReducer,
            lastRenderedState: $f8fd3b4e5f17ffb5$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $f8fd3b4e5f17ffb5$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $f8fd3b4e5f17ffb5$var$requestFormReset$1(formFiber) {
    var resetStateQueue = $f8fd3b4e5f17ffb5$var$ensureFormComponentIsStateful(formFiber).next.queue;
    $f8fd3b4e5f17ffb5$var$dispatchSetStateInternal(formFiber, resetStateQueue, {}, $f8fd3b4e5f17ffb5$var$requestUpdateLane());
}
function $f8fd3b4e5f17ffb5$var$useHostTransitionStatus() {
    return $f8fd3b4e5f17ffb5$var$readContext($f8fd3b4e5f17ffb5$var$HostTransitionContext);
}
function $f8fd3b4e5f17ffb5$var$updateId() {
    return $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook().memoizedState;
}
function $f8fd3b4e5f17ffb5$var$updateRefresh() {
    return $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook().memoizedState;
}
function $f8fd3b4e5f17ffb5$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $f8fd3b4e5f17ffb5$var$requestUpdateLane();
                fiber = $f8fd3b4e5f17ffb5$var$createUpdate(lane);
                var root$41 = $f8fd3b4e5f17ffb5$var$enqueueUpdate(provider, fiber, lane);
                null !== root$41 && ($f8fd3b4e5f17ffb5$var$scheduleUpdateOnFiber(root$41, provider, lane), $f8fd3b4e5f17ffb5$var$entangleTransitions(root$41, provider, lane));
                provider = {
                    cache: $f8fd3b4e5f17ffb5$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $f8fd3b4e5f17ffb5$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $f8fd3b4e5f17ffb5$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $f8fd3b4e5f17ffb5$var$isRenderPhaseUpdate(fiber) ? $f8fd3b4e5f17ffb5$var$enqueueRenderPhaseUpdate(queue, action) : (action = $f8fd3b4e5f17ffb5$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($f8fd3b4e5f17ffb5$var$scheduleUpdateOnFiber(action, fiber, lane), $f8fd3b4e5f17ffb5$var$entangleTransitionUpdate(action, queue, lane)));
}
function $f8fd3b4e5f17ffb5$var$dispatchSetState(fiber, queue, action) {
    var lane = $f8fd3b4e5f17ffb5$var$requestUpdateLane();
    $f8fd3b4e5f17ffb5$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $f8fd3b4e5f17ffb5$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f8fd3b4e5f17ffb5$var$isRenderPhaseUpdate(fiber)) $f8fd3b4e5f17ffb5$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($f8fd3b4e5f17ffb5$var$objectIs(eagerState, currentState)) return $f8fd3b4e5f17ffb5$var$enqueueUpdate$1(fiber, queue, update, 0), null === $f8fd3b4e5f17ffb5$var$workInProgressRoot && $f8fd3b4e5f17ffb5$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $f8fd3b4e5f17ffb5$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $f8fd3b4e5f17ffb5$var$scheduleUpdateOnFiber(action, fiber, lane), $f8fd3b4e5f17ffb5$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $f8fd3b4e5f17ffb5$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $f8fd3b4e5f17ffb5$var$requestTransitionLane(),
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f8fd3b4e5f17ffb5$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $f8fd3b4e5f17ffb5$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $f8fd3b4e5f17ffb5$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $f8fd3b4e5f17ffb5$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber || null !== alternate && alternate === $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber;
}
function $f8fd3b4e5f17ffb5$var$enqueueRenderPhaseUpdate(queue, update) {
    $f8fd3b4e5f17ffb5$var$didScheduleRenderPhaseUpdateDuringThisPass = $f8fd3b4e5f17ffb5$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $f8fd3b4e5f17ffb5$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $f8fd3b4e5f17ffb5$var$markRootEntangled(root, lane);
    }
}
var $f8fd3b4e5f17ffb5$var$ContextOnlyDispatcher = {
    readContext: $f8fd3b4e5f17ffb5$var$readContext,
    use: $f8fd3b4e5f17ffb5$var$use,
    useCallback: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useContext: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useEffect: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useImperativeHandle: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useLayoutEffect: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useInsertionEffect: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useMemo: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useReducer: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useRef: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useState: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useDebugValue: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useDeferredValue: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useTransition: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useSyncExternalStore: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useId: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useHostTransitionStatus: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useFormState: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useActionState: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useOptimistic: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useMemoCache: $f8fd3b4e5f17ffb5$var$throwInvalidHookError,
    useCacheRefresh: $f8fd3b4e5f17ffb5$var$throwInvalidHookError
}, $f8fd3b4e5f17ffb5$var$HooksDispatcherOnMount = {
    readContext: $f8fd3b4e5f17ffb5$var$readContext,
    use: $f8fd3b4e5f17ffb5$var$use,
    useCallback: function(callback, deps) {
        $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $f8fd3b4e5f17ffb5$var$readContext,
    useEffect: $f8fd3b4e5f17ffb5$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $f8fd3b4e5f17ffb5$var$mountEffectImpl(4194308, 4, $f8fd3b4e5f17ffb5$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $f8fd3b4e5f17ffb5$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $f8fd3b4e5f17ffb5$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($f8fd3b4e5f17ffb5$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $f8fd3b4e5f17ffb5$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $f8fd3b4e5f17ffb5$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($f8fd3b4e5f17ffb5$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $f8fd3b4e5f17ffb5$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $f8fd3b4e5f17ffb5$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $f8fd3b4e5f17ffb5$var$dispatchReducerAction.bind(null, $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $f8fd3b4e5f17ffb5$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $f8fd3b4e5f17ffb5$var$dispatchSetState.bind(null, $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $f8fd3b4e5f17ffb5$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook();
        return $f8fd3b4e5f17ffb5$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $f8fd3b4e5f17ffb5$var$mountStateImpl(!1);
        stateHook = $f8fd3b4e5f17ffb5$var$startTransition.bind(null, $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber, hook = $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook();
        if ($f8fd3b4e5f17ffb5$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $f8fd3b4e5f17ffb5$var$workInProgressRoot) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(349));
            0 !== ($f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes & 124) || $f8fd3b4e5f17ffb5$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $f8fd3b4e5f17ffb5$var$mountEffect($f8fd3b4e5f17ffb5$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $f8fd3b4e5f17ffb5$var$pushSimpleEffect(9, $f8fd3b4e5f17ffb5$var$createEffectInstance(), $f8fd3b4e5f17ffb5$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook(), identifierPrefix = $f8fd3b4e5f17ffb5$var$workInProgressRoot.identifierPrefix;
        if ($f8fd3b4e5f17ffb5$var$isHydrating) {
            var JSCompiler_inline_result = $f8fd3b4e5f17ffb5$var$treeContextOverflow;
            var idWithLeadingBit = $f8fd3b4e5f17ffb5$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $f8fd3b4e5f17ffb5$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "\u00ab" + identifierPrefix + "R" + JSCompiler_inline_result;
            JSCompiler_inline_result = $f8fd3b4e5f17ffb5$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "\u00bb";
        } else JSCompiler_inline_result = $f8fd3b4e5f17ffb5$var$globalClientIdCounter++, identifierPrefix = "\u00ab" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + "\u00bb";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $f8fd3b4e5f17ffb5$var$useHostTransitionStatus,
    useFormState: $f8fd3b4e5f17ffb5$var$mountActionState,
    useActionState: $f8fd3b4e5f17ffb5$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $f8fd3b4e5f17ffb5$var$dispatchOptimisticSetState.bind(null, $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $f8fd3b4e5f17ffb5$var$useMemoCache,
    useCacheRefresh: function() {
        return $f8fd3b4e5f17ffb5$var$mountWorkInProgressHook().memoizedState = $f8fd3b4e5f17ffb5$var$refreshCache.bind(null, $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber);
    }
}, $f8fd3b4e5f17ffb5$var$HooksDispatcherOnUpdate = {
    readContext: $f8fd3b4e5f17ffb5$var$readContext,
    use: $f8fd3b4e5f17ffb5$var$use,
    useCallback: $f8fd3b4e5f17ffb5$var$updateCallback,
    useContext: $f8fd3b4e5f17ffb5$var$readContext,
    useEffect: $f8fd3b4e5f17ffb5$var$updateEffect,
    useImperativeHandle: $f8fd3b4e5f17ffb5$var$updateImperativeHandle,
    useInsertionEffect: $f8fd3b4e5f17ffb5$var$updateInsertionEffect,
    useLayoutEffect: $f8fd3b4e5f17ffb5$var$updateLayoutEffect,
    useMemo: $f8fd3b4e5f17ffb5$var$updateMemo,
    useReducer: $f8fd3b4e5f17ffb5$var$updateReducer,
    useRef: $f8fd3b4e5f17ffb5$var$updateRef,
    useState: function() {
        return $f8fd3b4e5f17ffb5$var$updateReducer($f8fd3b4e5f17ffb5$var$basicStateReducer);
    },
    useDebugValue: $f8fd3b4e5f17ffb5$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook();
        return $f8fd3b4e5f17ffb5$var$updateDeferredValueImpl(hook, $f8fd3b4e5f17ffb5$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $f8fd3b4e5f17ffb5$var$updateReducer($f8fd3b4e5f17ffb5$var$basicStateReducer)[0], start = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $f8fd3b4e5f17ffb5$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $f8fd3b4e5f17ffb5$var$updateSyncExternalStore,
    useId: $f8fd3b4e5f17ffb5$var$updateId,
    useHostTransitionStatus: $f8fd3b4e5f17ffb5$var$useHostTransitionStatus,
    useFormState: $f8fd3b4e5f17ffb5$var$updateActionState,
    useActionState: $f8fd3b4e5f17ffb5$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook();
        return $f8fd3b4e5f17ffb5$var$updateOptimisticImpl(hook, $f8fd3b4e5f17ffb5$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $f8fd3b4e5f17ffb5$var$useMemoCache,
    useCacheRefresh: $f8fd3b4e5f17ffb5$var$updateRefresh
}, $f8fd3b4e5f17ffb5$var$HooksDispatcherOnRerender = {
    readContext: $f8fd3b4e5f17ffb5$var$readContext,
    use: $f8fd3b4e5f17ffb5$var$use,
    useCallback: $f8fd3b4e5f17ffb5$var$updateCallback,
    useContext: $f8fd3b4e5f17ffb5$var$readContext,
    useEffect: $f8fd3b4e5f17ffb5$var$updateEffect,
    useImperativeHandle: $f8fd3b4e5f17ffb5$var$updateImperativeHandle,
    useInsertionEffect: $f8fd3b4e5f17ffb5$var$updateInsertionEffect,
    useLayoutEffect: $f8fd3b4e5f17ffb5$var$updateLayoutEffect,
    useMemo: $f8fd3b4e5f17ffb5$var$updateMemo,
    useReducer: $f8fd3b4e5f17ffb5$var$rerenderReducer,
    useRef: $f8fd3b4e5f17ffb5$var$updateRef,
    useState: function() {
        return $f8fd3b4e5f17ffb5$var$rerenderReducer($f8fd3b4e5f17ffb5$var$basicStateReducer);
    },
    useDebugValue: $f8fd3b4e5f17ffb5$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook();
        return null === $f8fd3b4e5f17ffb5$var$currentHook ? $f8fd3b4e5f17ffb5$var$mountDeferredValueImpl(hook, value, initialValue) : $f8fd3b4e5f17ffb5$var$updateDeferredValueImpl(hook, $f8fd3b4e5f17ffb5$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $f8fd3b4e5f17ffb5$var$rerenderReducer($f8fd3b4e5f17ffb5$var$basicStateReducer)[0], start = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $f8fd3b4e5f17ffb5$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $f8fd3b4e5f17ffb5$var$updateSyncExternalStore,
    useId: $f8fd3b4e5f17ffb5$var$updateId,
    useHostTransitionStatus: $f8fd3b4e5f17ffb5$var$useHostTransitionStatus,
    useFormState: $f8fd3b4e5f17ffb5$var$rerenderActionState,
    useActionState: $f8fd3b4e5f17ffb5$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $f8fd3b4e5f17ffb5$var$updateWorkInProgressHook();
        if (null !== $f8fd3b4e5f17ffb5$var$currentHook) return $f8fd3b4e5f17ffb5$var$updateOptimisticImpl(hook, $f8fd3b4e5f17ffb5$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $f8fd3b4e5f17ffb5$var$useMemoCache,
    useCacheRefresh: $f8fd3b4e5f17ffb5$var$updateRefresh
}, $f8fd3b4e5f17ffb5$var$thenableState = null, $f8fd3b4e5f17ffb5$var$thenableIndexCounter = 0;
function $f8fd3b4e5f17ffb5$var$unwrapThenable(thenable) {
    var index = $f8fd3b4e5f17ffb5$var$thenableIndexCounter;
    $f8fd3b4e5f17ffb5$var$thenableIndexCounter += 1;
    null === $f8fd3b4e5f17ffb5$var$thenableState && ($f8fd3b4e5f17ffb5$var$thenableState = []);
    return $f8fd3b4e5f17ffb5$var$trackUsedThenable($f8fd3b4e5f17ffb5$var$thenableState, thenable, index);
}
function $f8fd3b4e5f17ffb5$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $f8fd3b4e5f17ffb5$var$throwOnInvalidObjectType(returnFiber, newChild) {
    if (newChild.$$typeof === $f8fd3b4e5f17ffb5$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $f8fd3b4e5f17ffb5$var$resolveLazy(lazyType) {
    var init = lazyType._init;
    return init(lazyType._payload);
}
function $f8fd3b4e5f17ffb5$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $f8fd3b4e5f17ffb5$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $f8fd3b4e5f17ffb5$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $f8fd3b4e5f17ffb5$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $f8fd3b4e5f17ffb5$var$REACT_LAZY_TYPE && $f8fd3b4e5f17ffb5$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $f8fd3b4e5f17ffb5$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $f8fd3b4e5f17ffb5$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $f8fd3b4e5f17ffb5$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $f8fd3b4e5f17ffb5$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $f8fd3b4e5f17ffb5$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $f8fd3b4e5f17ffb5$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $f8fd3b4e5f17ffb5$var$REACT_ELEMENT_TYPE:
                    return lanes = $f8fd3b4e5f17ffb5$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $f8fd3b4e5f17ffb5$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $f8fd3b4e5f17ffb5$var$REACT_PORTAL_TYPE:
                    return newChild = $f8fd3b4e5f17ffb5$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $f8fd3b4e5f17ffb5$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return createChild(returnFiber, newChild, lanes);
            }
            if ($f8fd3b4e5f17ffb5$var$isArrayImpl(newChild) || $f8fd3b4e5f17ffb5$var$getIteratorFn(newChild)) return newChild = $f8fd3b4e5f17ffb5$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $f8fd3b4e5f17ffb5$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $f8fd3b4e5f17ffb5$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $f8fd3b4e5f17ffb5$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $f8fd3b4e5f17ffb5$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $f8fd3b4e5f17ffb5$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $f8fd3b4e5f17ffb5$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $f8fd3b4e5f17ffb5$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($f8fd3b4e5f17ffb5$var$isArrayImpl(newChild) || $f8fd3b4e5f17ffb5$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $f8fd3b4e5f17ffb5$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $f8fd3b4e5f17ffb5$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $f8fd3b4e5f17ffb5$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $f8fd3b4e5f17ffb5$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $f8fd3b4e5f17ffb5$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $f8fd3b4e5f17ffb5$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $f8fd3b4e5f17ffb5$var$REACT_LAZY_TYPE:
                    var init = newChild._init;
                    newChild = init(newChild._payload);
                    return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($f8fd3b4e5f17ffb5$var$isArrayImpl(newChild) || $f8fd3b4e5f17ffb5$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $f8fd3b4e5f17ffb5$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $f8fd3b4e5f17ffb5$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $f8fd3b4e5f17ffb5$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $f8fd3b4e5f17ffb5$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $f8fd3b4e5f17ffb5$var$isHydrating && $f8fd3b4e5f17ffb5$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $f8fd3b4e5f17ffb5$var$isHydrating && $f8fd3b4e5f17ffb5$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $f8fd3b4e5f17ffb5$var$isHydrating && $f8fd3b4e5f17ffb5$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $f8fd3b4e5f17ffb5$var$isHydrating && $f8fd3b4e5f17ffb5$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $f8fd3b4e5f17ffb5$var$isHydrating && $f8fd3b4e5f17ffb5$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $f8fd3b4e5f17ffb5$var$isHydrating && $f8fd3b4e5f17ffb5$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $f8fd3b4e5f17ffb5$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $f8fd3b4e5f17ffb5$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $f8fd3b4e5f17ffb5$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $f8fd3b4e5f17ffb5$var$REACT_LAZY_TYPE && $f8fd3b4e5f17ffb5$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $f8fd3b4e5f17ffb5$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $f8fd3b4e5f17ffb5$var$REACT_FRAGMENT_TYPE ? (lanes = $f8fd3b4e5f17ffb5$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $f8fd3b4e5f17ffb5$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $f8fd3b4e5f17ffb5$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $f8fd3b4e5f17ffb5$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $f8fd3b4e5f17ffb5$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $f8fd3b4e5f17ffb5$var$REACT_LAZY_TYPE:
                    return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($f8fd3b4e5f17ffb5$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($f8fd3b4e5f17ffb5$var$getIteratorFn(newChild)) {
                key = $f8fd3b4e5f17ffb5$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $f8fd3b4e5f17ffb5$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $f8fd3b4e5f17ffb5$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $f8fd3b4e5f17ffb5$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $f8fd3b4e5f17ffb5$var$throwOnInvalidObjectType(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $f8fd3b4e5f17ffb5$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $f8fd3b4e5f17ffb5$var$thenableIndexCounter = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $f8fd3b4e5f17ffb5$var$thenableState = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $f8fd3b4e5f17ffb5$var$SuspenseException || x === $f8fd3b4e5f17ffb5$var$SuspenseActionException) throw x;
            var fiber = $f8fd3b4e5f17ffb5$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $f8fd3b4e5f17ffb5$var$reconcileChildFibers = $f8fd3b4e5f17ffb5$var$createChildReconciler(!0), $f8fd3b4e5f17ffb5$var$mountChildFibers = $f8fd3b4e5f17ffb5$var$createChildReconciler(!1), $f8fd3b4e5f17ffb5$var$suspenseHandlerStackCursor = $f8fd3b4e5f17ffb5$var$createCursor(null), $f8fd3b4e5f17ffb5$var$shellBoundary = null;
function $f8fd3b4e5f17ffb5$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$suspenseStackCursor, $f8fd3b4e5f17ffb5$var$suspenseStackCursor.current & 1);
    $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$suspenseHandlerStackCursor, handler);
    null === $f8fd3b4e5f17ffb5$var$shellBoundary && (null === current || null !== $f8fd3b4e5f17ffb5$var$currentTreeHiddenStackCursor.current ? $f8fd3b4e5f17ffb5$var$shellBoundary = handler : null !== current.memoizedState && ($f8fd3b4e5f17ffb5$var$shellBoundary = handler));
}
function $f8fd3b4e5f17ffb5$var$pushOffscreenSuspenseHandler(fiber) {
    if (22 === fiber.tag) {
        if ($f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$suspenseStackCursor, $f8fd3b4e5f17ffb5$var$suspenseStackCursor.current), $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$suspenseHandlerStackCursor, fiber), null === $f8fd3b4e5f17ffb5$var$shellBoundary) {
            var current = fiber.alternate;
            null !== current && null !== current.memoizedState && ($f8fd3b4e5f17ffb5$var$shellBoundary = fiber);
        }
    } else $f8fd3b4e5f17ffb5$var$reuseSuspenseHandlerOnStack(fiber);
}
function $f8fd3b4e5f17ffb5$var$reuseSuspenseHandlerOnStack() {
    $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$suspenseStackCursor, $f8fd3b4e5f17ffb5$var$suspenseStackCursor.current);
    $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$suspenseHandlerStackCursor, $f8fd3b4e5f17ffb5$var$suspenseHandlerStackCursor.current);
}
function $f8fd3b4e5f17ffb5$var$popSuspenseHandler(fiber) {
    $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$suspenseHandlerStackCursor);
    $f8fd3b4e5f17ffb5$var$shellBoundary === fiber && ($f8fd3b4e5f17ffb5$var$shellBoundary = null);
    $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$suspenseStackCursor);
}
var $f8fd3b4e5f17ffb5$var$suspenseStackCursor = $f8fd3b4e5f17ffb5$var$createCursor(0);
function $f8fd3b4e5f17ffb5$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || "$?" === state.data || $f8fd3b4e5f17ffb5$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
function $f8fd3b4e5f17ffb5$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $f8fd3b4e5f17ffb5$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $f8fd3b4e5f17ffb5$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $f8fd3b4e5f17ffb5$var$requestUpdateLane(), update = $f8fd3b4e5f17ffb5$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $f8fd3b4e5f17ffb5$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($f8fd3b4e5f17ffb5$var$scheduleUpdateOnFiber(payload, inst, lane), $f8fd3b4e5f17ffb5$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $f8fd3b4e5f17ffb5$var$requestUpdateLane(), update = $f8fd3b4e5f17ffb5$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $f8fd3b4e5f17ffb5$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($f8fd3b4e5f17ffb5$var$scheduleUpdateOnFiber(payload, inst, lane), $f8fd3b4e5f17ffb5$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $f8fd3b4e5f17ffb5$var$requestUpdateLane(), update = $f8fd3b4e5f17ffb5$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $f8fd3b4e5f17ffb5$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($f8fd3b4e5f17ffb5$var$scheduleUpdateOnFiber(callback, inst, lane), $f8fd3b4e5f17ffb5$var$entangleTransitions(callback, inst, lane));
    }
};
function $f8fd3b4e5f17ffb5$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$f8fd3b4e5f17ffb5$var$shallowEqual(oldProps, newProps) || !$f8fd3b4e5f17ffb5$var$shallowEqual(oldState, newState) : !0;
}
function $f8fd3b4e5f17ffb5$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $f8fd3b4e5f17ffb5$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $f8fd3b4e5f17ffb5$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $f8fd3b4e5f17ffb5$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
var $f8fd3b4e5f17ffb5$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $f8fd3b4e5f17ffb5$var$defaultOnUncaughtError(error) {
    $f8fd3b4e5f17ffb5$var$reportGlobalError(error);
}
function $f8fd3b4e5f17ffb5$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $f8fd3b4e5f17ffb5$var$defaultOnRecoverableError(error) {
    $f8fd3b4e5f17ffb5$var$reportGlobalError(error);
}
function $f8fd3b4e5f17ffb5$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $f8fd3b4e5f17ffb5$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $f8fd3b4e5f17ffb5$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $f8fd3b4e5f17ffb5$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $f8fd3b4e5f17ffb5$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $f8fd3b4e5f17ffb5$var$createClassErrorUpdate(lane) {
    lane = $f8fd3b4e5f17ffb5$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $f8fd3b4e5f17ffb5$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $f8fd3b4e5f17ffb5$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $f8fd3b4e5f17ffb5$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $f8fd3b4e5f17ffb5$var$legacyErrorBoundariesThatAlreadyFailed ? $f8fd3b4e5f17ffb5$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $f8fd3b4e5f17ffb5$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $f8fd3b4e5f17ffb5$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $f8fd3b4e5f17ffb5$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $f8fd3b4e5f17ffb5$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 13:
                    return null === $f8fd3b4e5f17ffb5$var$shellBoundary ? $f8fd3b4e5f17ffb5$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus && ($f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $f8fd3b4e5f17ffb5$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $f8fd3b4e5f17ffb5$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $f8fd3b4e5f17ffb5$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $f8fd3b4e5f17ffb5$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $f8fd3b4e5f17ffb5$var$attachPingListener(root, value, rootRenderLanes);
        $f8fd3b4e5f17ffb5$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($f8fd3b4e5f17ffb5$var$isHydrating) return returnFiber = $f8fd3b4e5f17ffb5$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $f8fd3b4e5f17ffb5$var$HydrationMismatchException && (root = Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(422), {
        cause: value
    }), $f8fd3b4e5f17ffb5$var$queueHydrationError($f8fd3b4e5f17ffb5$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $f8fd3b4e5f17ffb5$var$HydrationMismatchException && (returnFiber = Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(423), {
        cause: value
    }), $f8fd3b4e5f17ffb5$var$queueHydrationError($f8fd3b4e5f17ffb5$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $f8fd3b4e5f17ffb5$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $f8fd3b4e5f17ffb5$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $f8fd3b4e5f17ffb5$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus && ($f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $f8fd3b4e5f17ffb5$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $f8fd3b4e5f17ffb5$var$workInProgressRootConcurrentErrors ? $f8fd3b4e5f17ffb5$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $f8fd3b4e5f17ffb5$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus && ($f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $f8fd3b4e5f17ffb5$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $f8fd3b4e5f17ffb5$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $f8fd3b4e5f17ffb5$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $f8fd3b4e5f17ffb5$var$legacyErrorBoundariesThatAlreadyFailed || !$f8fd3b4e5f17ffb5$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $f8fd3b4e5f17ffb5$var$createClassErrorUpdate(rootRenderLanes), $f8fd3b4e5f17ffb5$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $f8fd3b4e5f17ffb5$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $f8fd3b4e5f17ffb5$var$SelectiveHydrationException = Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(461)), $f8fd3b4e5f17ffb5$var$didReceiveUpdate = !1;
function $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $f8fd3b4e5f17ffb5$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $f8fd3b4e5f17ffb5$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $f8fd3b4e5f17ffb5$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $f8fd3b4e5f17ffb5$var$prepareToReadContext(workInProgress);
    nextProps = $f8fd3b4e5f17ffb5$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $f8fd3b4e5f17ffb5$var$checkDidRenderIdHook();
    if (null !== current && !$f8fd3b4e5f17ffb5$var$didReceiveUpdate) return $f8fd3b4e5f17ffb5$var$bailoutHooks(current, workInProgress, renderLanes), $f8fd3b4e5f17ffb5$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $f8fd3b4e5f17ffb5$var$isHydrating && key && $f8fd3b4e5f17ffb5$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $f8fd3b4e5f17ffb5$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$f8fd3b4e5f17ffb5$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $f8fd3b4e5f17ffb5$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $f8fd3b4e5f17ffb5$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$f8fd3b4e5f17ffb5$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $f8fd3b4e5f17ffb5$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $f8fd3b4e5f17ffb5$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $f8fd3b4e5f17ffb5$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $f8fd3b4e5f17ffb5$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($f8fd3b4e5f17ffb5$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($f8fd3b4e5f17ffb5$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $f8fd3b4e5f17ffb5$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($f8fd3b4e5f17ffb5$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $f8fd3b4e5f17ffb5$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $f8fd3b4e5f17ffb5$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $f8fd3b4e5f17ffb5$var$updateOffscreenComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextChildren = workInProgress.child = current.child;
                for(prevState = 0; null !== nextChildren;)prevState = prevState | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                workInProgress.childLanes = prevState & ~nextProps;
            } else workInProgress.childLanes = 0, workInProgress.child = null;
            return $f8fd3b4e5f17ffb5$var$deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $f8fd3b4e5f17ffb5$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $f8fd3b4e5f17ffb5$var$pushHiddenContext(workInProgress, prevState) : $f8fd3b4e5f17ffb5$var$reuseHiddenContextOnStack(), $f8fd3b4e5f17ffb5$var$pushOffscreenSuspenseHandler(workInProgress);
        else return workInProgress.lanes = workInProgress.childLanes = 536870912, $f8fd3b4e5f17ffb5$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
    } else null !== prevState ? ($f8fd3b4e5f17ffb5$var$pushTransition(workInProgress, prevState.cachePool), $f8fd3b4e5f17ffb5$var$pushHiddenContext(workInProgress, prevState), $f8fd3b4e5f17ffb5$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $f8fd3b4e5f17ffb5$var$pushTransition(workInProgress, null), $f8fd3b4e5f17ffb5$var$reuseHiddenContextOnStack(), $f8fd3b4e5f17ffb5$var$reuseSuspenseHandlerOnStack(workInProgress));
    $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $f8fd3b4e5f17ffb5$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
    var JSCompiler_inline_result = $f8fd3b4e5f17ffb5$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $f8fd3b4e5f17ffb5$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $f8fd3b4e5f17ffb5$var$pushTransition(workInProgress, null);
    $f8fd3b4e5f17ffb5$var$reuseHiddenContextOnStack();
    $f8fd3b4e5f17ffb5$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $f8fd3b4e5f17ffb5$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    return null;
}
function $f8fd3b4e5f17ffb5$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $f8fd3b4e5f17ffb5$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $f8fd3b4e5f17ffb5$var$prepareToReadContext(workInProgress);
    Component = $f8fd3b4e5f17ffb5$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $f8fd3b4e5f17ffb5$var$checkDidRenderIdHook();
    if (null !== current && !$f8fd3b4e5f17ffb5$var$didReceiveUpdate) return $f8fd3b4e5f17ffb5$var$bailoutHooks(current, workInProgress, renderLanes), $f8fd3b4e5f17ffb5$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $f8fd3b4e5f17ffb5$var$isHydrating && nextProps && $f8fd3b4e5f17ffb5$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $f8fd3b4e5f17ffb5$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $f8fd3b4e5f17ffb5$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $f8fd3b4e5f17ffb5$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $f8fd3b4e5f17ffb5$var$finishRenderingHooks(current);
    Component = $f8fd3b4e5f17ffb5$var$checkDidRenderIdHook();
    if (null !== current && !$f8fd3b4e5f17ffb5$var$didReceiveUpdate) return $f8fd3b4e5f17ffb5$var$bailoutHooks(current, workInProgress, renderLanes), $f8fd3b4e5f17ffb5$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $f8fd3b4e5f17ffb5$var$isHydrating && Component && $f8fd3b4e5f17ffb5$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $f8fd3b4e5f17ffb5$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $f8fd3b4e5f17ffb5$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $f8fd3b4e5f17ffb5$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $f8fd3b4e5f17ffb5$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $f8fd3b4e5f17ffb5$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $f8fd3b4e5f17ffb5$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $f8fd3b4e5f17ffb5$var$readContext(contextType) : $f8fd3b4e5f17ffb5$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($f8fd3b4e5f17ffb5$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $f8fd3b4e5f17ffb5$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $f8fd3b4e5f17ffb5$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $f8fd3b4e5f17ffb5$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $f8fd3b4e5f17ffb5$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $f8fd3b4e5f17ffb5$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $f8fd3b4e5f17ffb5$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $f8fd3b4e5f17ffb5$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $f8fd3b4e5f17ffb5$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $f8fd3b4e5f17ffb5$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $f8fd3b4e5f17ffb5$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $f8fd3b4e5f17ffb5$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($f8fd3b4e5f17ffb5$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $f8fd3b4e5f17ffb5$var$hasForceUpdate || $f8fd3b4e5f17ffb5$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $f8fd3b4e5f17ffb5$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $f8fd3b4e5f17ffb5$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $f8fd3b4e5f17ffb5$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $f8fd3b4e5f17ffb5$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $f8fd3b4e5f17ffb5$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $f8fd3b4e5f17ffb5$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $f8fd3b4e5f17ffb5$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $f8fd3b4e5f17ffb5$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $f8fd3b4e5f17ffb5$var$hasForceUpdate || null !== current && null !== current.dependencies && $f8fd3b4e5f17ffb5$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($f8fd3b4e5f17ffb5$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $f8fd3b4e5f17ffb5$var$hasForceUpdate || $f8fd3b4e5f17ffb5$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $f8fd3b4e5f17ffb5$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $f8fd3b4e5f17ffb5$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $f8fd3b4e5f17ffb5$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $f8fd3b4e5f17ffb5$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $f8fd3b4e5f17ffb5$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $f8fd3b4e5f17ffb5$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $f8fd3b4e5f17ffb5$var$resetHydrationState();
    workInProgress.flags |= 256;
    $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $f8fd3b4e5f17ffb5$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $f8fd3b4e5f17ffb5$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $f8fd3b4e5f17ffb5$var$getSuspendedCache()
    };
}
function $f8fd3b4e5f17ffb5$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $f8fd3b4e5f17ffb5$var$workInProgressDeferredLane);
    return current;
}
function $f8fd3b4e5f17ffb5$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($f8fd3b4e5f17ffb5$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($f8fd3b4e5f17ffb5$var$isHydrating) {
            showFallback ? $f8fd3b4e5f17ffb5$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $f8fd3b4e5f17ffb5$var$reuseSuspenseHandlerOnStack(workInProgress);
            if ($f8fd3b4e5f17ffb5$var$isHydrating) {
                var nextInstance = $f8fd3b4e5f17ffb5$var$nextHydratableInstance, JSCompiler_temp$jscomp$0;
                if (JSCompiler_temp$jscomp$0 = nextInstance) {
                    c: {
                        JSCompiler_temp$jscomp$0 = nextInstance;
                        for(nextInstance = $f8fd3b4e5f17ffb5$var$rootOrSingletonContext; 8 !== JSCompiler_temp$jscomp$0.nodeType;){
                            if (!nextInstance) {
                                nextInstance = null;
                                break c;
                            }
                            JSCompiler_temp$jscomp$0 = $f8fd3b4e5f17ffb5$var$getNextHydratable(JSCompiler_temp$jscomp$0.nextSibling);
                            if (null === JSCompiler_temp$jscomp$0) {
                                nextInstance = null;
                                break c;
                            }
                        }
                        nextInstance = JSCompiler_temp$jscomp$0;
                    }
                    null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== $f8fd3b4e5f17ffb5$var$treeContextProvider ? {
                            id: $f8fd3b4e5f17ffb5$var$treeContextId,
                            overflow: $f8fd3b4e5f17ffb5$var$treeContextOverflow
                        } : null,
                        retryLane: 536870912,
                        hydrationErrors: null
                    }, JSCompiler_temp$jscomp$0 = $f8fd3b4e5f17ffb5$var$createFiberImplClass(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, $f8fd3b4e5f17ffb5$var$hydrationParentFiber = workInProgress, $f8fd3b4e5f17ffb5$var$nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                }
                JSCompiler_temp$jscomp$0 || $f8fd3b4e5f17ffb5$var$throwOnHydrationMismatch(workInProgress);
            }
            nextInstance = workInProgress.memoizedState;
            if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return $f8fd3b4e5f17ffb5$var$isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912, null;
            $f8fd3b4e5f17ffb5$var$popSuspenseHandler(workInProgress);
        }
        nextInstance = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $f8fd3b4e5f17ffb5$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = $f8fd3b4e5f17ffb5$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextInstance
        }, showFallback), nextProps = $f8fd3b4e5f17ffb5$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = $f8fd3b4e5f17ffb5$var$mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = $f8fd3b4e5f17ffb5$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $f8fd3b4e5f17ffb5$var$SUSPENDED_MARKER, nextProps;
        $f8fd3b4e5f17ffb5$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $f8fd3b4e5f17ffb5$var$mountSuspensePrimaryChildren(workInProgress, nextInstance);
    }
    JSCompiler_temp$jscomp$0 = current.memoizedState;
    if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
        if (didSuspend) workInProgress.flags & 256 ? ($f8fd3b4e5f17ffb5$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $f8fd3b4e5f17ffb5$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($f8fd3b4e5f17ffb5$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($f8fd3b4e5f17ffb5$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = $f8fd3b4e5f17ffb5$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, nextInstance), showFallback = $f8fd3b4e5f17ffb5$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $f8fd3b4e5f17ffb5$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $f8fd3b4e5f17ffb5$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $f8fd3b4e5f17ffb5$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $f8fd3b4e5f17ffb5$var$SUSPENDED_MARKER, workInProgress = showFallback);
        else if ($f8fd3b4e5f17ffb5$var$pushPrimaryTreeSuspenseHandler(workInProgress), $f8fd3b4e5f17ffb5$var$isSuspenseInstanceFallback(nextInstance)) {
            JSCompiler_temp = nextInstance.nextSibling && nextInstance.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $f8fd3b4e5f17ffb5$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $f8fd3b4e5f17ffb5$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($f8fd3b4e5f17ffb5$var$didReceiveUpdate || $f8fd3b4e5f17ffb5$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $f8fd3b4e5f17ffb5$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $f8fd3b4e5f17ffb5$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = renderLanes & -renderLanes, nextProps = 0 !== (nextProps & 42) ? 1 : $f8fd3b4e5f17ffb5$var$getBumpedLaneForHydrationByLane(nextProps), nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps, 0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane)) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, $f8fd3b4e5f17ffb5$var$enqueueConcurrentRenderForLane(current, nextProps), $f8fd3b4e5f17ffb5$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $f8fd3b4e5f17ffb5$var$SelectiveHydrationException;
            "$?" === nextInstance.data || $f8fd3b4e5f17ffb5$var$renderDidSuspendDelayIfPossible();
            workInProgress = $f8fd3b4e5f17ffb5$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else "$?" === nextInstance.data ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, $f8fd3b4e5f17ffb5$var$nextHydratableInstance = $f8fd3b4e5f17ffb5$var$getNextHydratable(nextInstance.nextSibling), $f8fd3b4e5f17ffb5$var$hydrationParentFiber = workInProgress, $f8fd3b4e5f17ffb5$var$isHydrating = !0, $f8fd3b4e5f17ffb5$var$hydrationErrors = null, $f8fd3b4e5f17ffb5$var$rootOrSingletonContext = !1, null !== current && ($f8fd3b4e5f17ffb5$var$idStack[$f8fd3b4e5f17ffb5$var$idStackIndex++] = $f8fd3b4e5f17ffb5$var$treeContextId, $f8fd3b4e5f17ffb5$var$idStack[$f8fd3b4e5f17ffb5$var$idStackIndex++] = $f8fd3b4e5f17ffb5$var$treeContextOverflow, $f8fd3b4e5f17ffb5$var$idStack[$f8fd3b4e5f17ffb5$var$idStackIndex++] = $f8fd3b4e5f17ffb5$var$treeContextProvider, $f8fd3b4e5f17ffb5$var$treeContextId = current.id, $f8fd3b4e5f17ffb5$var$treeContextOverflow = current.overflow, $f8fd3b4e5f17ffb5$var$treeContextProvider = workInProgress), workInProgress = $f8fd3b4e5f17ffb5$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $f8fd3b4e5f17ffb5$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, digest = JSCompiler_temp$jscomp$0.sibling, nextProps = $f8fd3b4e5f17ffb5$var$createWorkInProgress(JSCompiler_temp$jscomp$0, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 65011712, null !== digest ? showFallback = $f8fd3b4e5f17ffb5$var$createWorkInProgress(digest, showFallback) : (showFallback = $f8fd3b4e5f17ffb5$var$createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = $f8fd3b4e5f17ffb5$var$mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (digest = $f8fd3b4e5f17ffb5$var$CacheContext._currentValue, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== digest ? {
        parent: digest,
        pool: digest
    } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = $f8fd3b4e5f17ffb5$var$getSuspendedCache(), nextInstance = {
        baseLanes: nextInstance.baseLanes | renderLanes,
        cachePool: JSCompiler_temp$jscomp$0
    }), showFallback.memoizedState = nextInstance, showFallback.childLanes = $f8fd3b4e5f17ffb5$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $f8fd3b4e5f17ffb5$var$SUSPENDED_MARKER, nextProps;
    $f8fd3b4e5f17ffb5$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $f8fd3b4e5f17ffb5$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $f8fd3b4e5f17ffb5$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $f8fd3b4e5f17ffb5$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $f8fd3b4e5f17ffb5$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $f8fd3b4e5f17ffb5$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    offscreenProps.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    };
    return offscreenProps;
}
function $f8fd3b4e5f17ffb5$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $f8fd3b4e5f17ffb5$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $f8fd3b4e5f17ffb5$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $f8fd3b4e5f17ffb5$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $f8fd3b4e5f17ffb5$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $f8fd3b4e5f17ffb5$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
}
function $f8fd3b4e5f17ffb5$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
    nextProps = $f8fd3b4e5f17ffb5$var$suspenseStackCursor.current;
    if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
    else {
        if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
            if (13 === current.tag) null !== current.memoizedState && $f8fd3b4e5f17ffb5$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (19 === current.tag) $f8fd3b4e5f17ffb5$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
            else if (null !== current.child) {
                current.child.return = current;
                current = current.child;
                continue;
            }
            if (current === workInProgress) break a;
            for(; null === current.sibling;){
                if (null === current.return || current.return === workInProgress) break a;
                current = current.return;
            }
            current.sibling.return = current.return;
            current = current.sibling;
        }
        nextProps &= 1;
    }
    $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$suspenseStackCursor, nextProps);
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $f8fd3b4e5f17ffb5$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $f8fd3b4e5f17ffb5$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
            break;
        case "backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $f8fd3b4e5f17ffb5$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $f8fd3b4e5f17ffb5$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
            break;
        case "together":
            $f8fd3b4e5f17ffb5$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $f8fd3b4e5f17ffb5$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $f8fd3b4e5f17ffb5$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($f8fd3b4e5f17ffb5$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $f8fd3b4e5f17ffb5$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $f8fd3b4e5f17ffb5$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $f8fd3b4e5f17ffb5$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $f8fd3b4e5f17ffb5$var$checkIfContextChanged(current) ? !0 : !1;
}
function $f8fd3b4e5f17ffb5$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $f8fd3b4e5f17ffb5$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $f8fd3b4e5f17ffb5$var$pushProvider(workInProgress, $f8fd3b4e5f17ffb5$var$CacheContext, current.memoizedState.cache);
            $f8fd3b4e5f17ffb5$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $f8fd3b4e5f17ffb5$var$pushHostContext(workInProgress);
            break;
        case 4:
            $f8fd3b4e5f17ffb5$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $f8fd3b4e5f17ffb5$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 13:
            var state = workInProgress.memoizedState;
            if (null !== state) {
                if (null !== state.dehydrated) return $f8fd3b4e5f17ffb5$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $f8fd3b4e5f17ffb5$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $f8fd3b4e5f17ffb5$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $f8fd3b4e5f17ffb5$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $f8fd3b4e5f17ffb5$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state = 0 !== (renderLanes & workInProgress.childLanes);
            state || ($f8fd3b4e5f17ffb5$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state) return $f8fd3b4e5f17ffb5$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$suspenseStackCursor, $f8fd3b4e5f17ffb5$var$suspenseStackCursor.current);
            if (state) break;
            else return null;
        case 22:
        case 23:
            return workInProgress.lanes = 0, $f8fd3b4e5f17ffb5$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            $f8fd3b4e5f17ffb5$var$pushProvider(workInProgress, $f8fd3b4e5f17ffb5$var$CacheContext, current.memoizedState.cache);
    }
    return $f8fd3b4e5f17ffb5$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $f8fd3b4e5f17ffb5$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $f8fd3b4e5f17ffb5$var$didReceiveUpdate = !0;
        else {
            if (!$f8fd3b4e5f17ffb5$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $f8fd3b4e5f17ffb5$var$didReceiveUpdate = !1, $f8fd3b4e5f17ffb5$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $f8fd3b4e5f17ffb5$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $f8fd3b4e5f17ffb5$var$didReceiveUpdate = !1, $f8fd3b4e5f17ffb5$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $f8fd3b4e5f17ffb5$var$pushTreeId(workInProgress, $f8fd3b4e5f17ffb5$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                current = workInProgress.pendingProps;
                var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                lazyComponent = init(lazyComponent._payload);
                workInProgress.type = lazyComponent;
                if ("function" === typeof lazyComponent) $f8fd3b4e5f17ffb5$var$shouldConstruct(lazyComponent) ? (current = $f8fd3b4e5f17ffb5$var$resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = $f8fd3b4e5f17ffb5$var$updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = $f8fd3b4e5f17ffb5$var$updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                else {
                    if (void 0 !== lazyComponent && null !== lazyComponent) {
                        if (init = lazyComponent.$$typeof, init === $f8fd3b4e5f17ffb5$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $f8fd3b4e5f17ffb5$var$updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        } else if (init === $f8fd3b4e5f17ffb5$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $f8fd3b4e5f17ffb5$var$updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $f8fd3b4e5f17ffb5$var$getComponentNameFromType(lazyComponent) || lazyComponent;
                    throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $f8fd3b4e5f17ffb5$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return lazyComponent = workInProgress.type, init = $f8fd3b4e5f17ffb5$var$resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), $f8fd3b4e5f17ffb5$var$updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
        case 3:
            a: {
                $f8fd3b4e5f17ffb5$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(387));
                lazyComponent = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                init = prevState.element;
                $f8fd3b4e5f17ffb5$var$cloneUpdateQueue(current, workInProgress);
                $f8fd3b4e5f17ffb5$var$processUpdateQueue(workInProgress, lazyComponent, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                lazyComponent = nextState.cache;
                $f8fd3b4e5f17ffb5$var$pushProvider(workInProgress, $f8fd3b4e5f17ffb5$var$CacheContext, lazyComponent);
                lazyComponent !== prevState.cache && $f8fd3b4e5f17ffb5$var$propagateContextChanges(workInProgress, [
                    $f8fd3b4e5f17ffb5$var$CacheContext
                ], renderLanes, !0);
                $f8fd3b4e5f17ffb5$var$suspendIfUpdateReadFromEntangledAsyncAction();
                lazyComponent = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: lazyComponent,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $f8fd3b4e5f17ffb5$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else if (lazyComponent !== init) {
                        init = $f8fd3b4e5f17ffb5$var$createCapturedValueAtFiber(Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(424)), workInProgress);
                        $f8fd3b4e5f17ffb5$var$queueHydrationError(init);
                        workInProgress = $f8fd3b4e5f17ffb5$var$mountHostRootWithoutHydrating(current, workInProgress, lazyComponent, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $f8fd3b4e5f17ffb5$var$nextHydratableInstance = $f8fd3b4e5f17ffb5$var$getNextHydratable(current.firstChild);
                        $f8fd3b4e5f17ffb5$var$hydrationParentFiber = workInProgress;
                        $f8fd3b4e5f17ffb5$var$isHydrating = !0;
                        $f8fd3b4e5f17ffb5$var$hydrationErrors = null;
                        $f8fd3b4e5f17ffb5$var$rootOrSingletonContext = !0;
                        renderLanes = $f8fd3b4e5f17ffb5$var$mountChildFibers(workInProgress, null, lazyComponent, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $f8fd3b4e5f17ffb5$var$resetHydrationState();
                    if (lazyComponent === init) {
                        workInProgress = $f8fd3b4e5f17ffb5$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $f8fd3b4e5f17ffb5$var$markRef(current, workInProgress), null === current ? (renderLanes = $f8fd3b4e5f17ffb5$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $f8fd3b4e5f17ffb5$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, lazyComponent = $f8fd3b4e5f17ffb5$var$getOwnerDocumentFromRootContainer($f8fd3b4e5f17ffb5$var$rootInstanceStackCursor.current).createElement(renderLanes), lazyComponent[$f8fd3b4e5f17ffb5$var$internalInstanceKey] = workInProgress, lazyComponent[$f8fd3b4e5f17ffb5$var$internalPropsKey] = current, $f8fd3b4e5f17ffb5$var$setInitialProperties(lazyComponent, renderLanes, current), $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(lazyComponent), workInProgress.stateNode = lazyComponent) : workInProgress.memoizedState = $f8fd3b4e5f17ffb5$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $f8fd3b4e5f17ffb5$var$pushHostContext(workInProgress), null === current && $f8fd3b4e5f17ffb5$var$isHydrating && (lazyComponent = workInProgress.stateNode = $f8fd3b4e5f17ffb5$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $f8fd3b4e5f17ffb5$var$rootInstanceStackCursor.current), $f8fd3b4e5f17ffb5$var$hydrationParentFiber = workInProgress, $f8fd3b4e5f17ffb5$var$rootOrSingletonContext = !0, init = $f8fd3b4e5f17ffb5$var$nextHydratableInstance, $f8fd3b4e5f17ffb5$var$isSingletonScope(workInProgress.type) ? ($f8fd3b4e5f17ffb5$var$previousHydratableOnEnteringScopedSingleton = init, $f8fd3b4e5f17ffb5$var$nextHydratableInstance = $f8fd3b4e5f17ffb5$var$getNextHydratable(lazyComponent.firstChild)) : $f8fd3b4e5f17ffb5$var$nextHydratableInstance = init), $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $f8fd3b4e5f17ffb5$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $f8fd3b4e5f17ffb5$var$isHydrating) {
                if (init = lazyComponent = $f8fd3b4e5f17ffb5$var$nextHydratableInstance) lazyComponent = $f8fd3b4e5f17ffb5$var$canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, $f8fd3b4e5f17ffb5$var$rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, $f8fd3b4e5f17ffb5$var$hydrationParentFiber = workInProgress, $f8fd3b4e5f17ffb5$var$nextHydratableInstance = $f8fd3b4e5f17ffb5$var$getNextHydratable(lazyComponent.firstChild), $f8fd3b4e5f17ffb5$var$rootOrSingletonContext = !1, init = !0) : init = !1;
                init || $f8fd3b4e5f17ffb5$var$throwOnHydrationMismatch(workInProgress);
            }
            $f8fd3b4e5f17ffb5$var$pushHostContext(workInProgress);
            init = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            lazyComponent = prevState.children;
            $f8fd3b4e5f17ffb5$var$shouldSetTextContent(init, prevState) ? lazyComponent = null : null !== nextState && $f8fd3b4e5f17ffb5$var$shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && (init = $f8fd3b4e5f17ffb5$var$renderWithHooks(current, workInProgress, $f8fd3b4e5f17ffb5$var$TransitionAwareHostComponent, null, null, renderLanes), $f8fd3b4e5f17ffb5$var$HostTransitionContext._currentValue = init);
            $f8fd3b4e5f17ffb5$var$markRef(current, workInProgress);
            $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $f8fd3b4e5f17ffb5$var$isHydrating) {
                if (current = renderLanes = $f8fd3b4e5f17ffb5$var$nextHydratableInstance) renderLanes = $f8fd3b4e5f17ffb5$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $f8fd3b4e5f17ffb5$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $f8fd3b4e5f17ffb5$var$hydrationParentFiber = workInProgress, $f8fd3b4e5f17ffb5$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $f8fd3b4e5f17ffb5$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $f8fd3b4e5f17ffb5$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $f8fd3b4e5f17ffb5$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = $f8fd3b4e5f17ffb5$var$reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 11:
            return $f8fd3b4e5f17ffb5$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return lazyComponent = workInProgress.pendingProps, $f8fd3b4e5f17ffb5$var$pushProvider(workInProgress, workInProgress.type, lazyComponent.value), $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
        case 9:
            return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, $f8fd3b4e5f17ffb5$var$prepareToReadContext(workInProgress), init = $f8fd3b4e5f17ffb5$var$readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
        case 14:
            return $f8fd3b4e5f17ffb5$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $f8fd3b4e5f17ffb5$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $f8fd3b4e5f17ffb5$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return lazyComponent = workInProgress.pendingProps, renderLanes = workInProgress.mode, lazyComponent = {
                mode: lazyComponent.mode,
                children: lazyComponent.children
            }, null === current ? (renderLanes = $f8fd3b4e5f17ffb5$var$mountWorkInProgressOffscreenFiber(lazyComponent, renderLanes), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes) : (renderLanes = $f8fd3b4e5f17ffb5$var$createWorkInProgress(current.child, lazyComponent), renderLanes.ref = workInProgress.ref, workInProgress.child = renderLanes, renderLanes.return = workInProgress, workInProgress = renderLanes), workInProgress;
        case 22:
            return $f8fd3b4e5f17ffb5$var$updateOffscreenComponent(current, workInProgress, renderLanes);
        case 24:
            return $f8fd3b4e5f17ffb5$var$prepareToReadContext(workInProgress), lazyComponent = $f8fd3b4e5f17ffb5$var$readContext($f8fd3b4e5f17ffb5$var$CacheContext), null === current ? (init = $f8fd3b4e5f17ffb5$var$peekCacheFromPool(), null === init && (init = $f8fd3b4e5f17ffb5$var$workInProgressRoot, prevState = $f8fd3b4e5f17ffb5$var$createCache(), init.pooledCache = prevState, prevState.refCount++, null !== prevState && (init.pooledCacheLanes |= renderLanes), init = prevState), workInProgress.memoizedState = {
                parent: lazyComponent,
                cache: init
            }, $f8fd3b4e5f17ffb5$var$initializeUpdateQueue(workInProgress), $f8fd3b4e5f17ffb5$var$pushProvider(workInProgress, $f8fd3b4e5f17ffb5$var$CacheContext, init)) : (0 !== (current.lanes & renderLanes) && ($f8fd3b4e5f17ffb5$var$cloneUpdateQueue(current, workInProgress), $f8fd3b4e5f17ffb5$var$processUpdateQueue(workInProgress, null, null, renderLanes), $f8fd3b4e5f17ffb5$var$suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, prevState = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                parent: lazyComponent,
                cache: lazyComponent
            }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), $f8fd3b4e5f17ffb5$var$pushProvider(workInProgress, $f8fd3b4e5f17ffb5$var$CacheContext, lazyComponent)) : (lazyComponent = prevState.cache, $f8fd3b4e5f17ffb5$var$pushProvider(workInProgress, $f8fd3b4e5f17ffb5$var$CacheContext, lazyComponent), lazyComponent !== init.cache && $f8fd3b4e5f17ffb5$var$propagateContextChanges(workInProgress, [
                $f8fd3b4e5f17ffb5$var$CacheContext
            ], renderLanes, !0))), $f8fd3b4e5f17ffb5$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $f8fd3b4e5f17ffb5$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $f8fd3b4e5f17ffb5$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$f8fd3b4e5f17ffb5$var$preloadResource(resource)) {
        resource = $f8fd3b4e5f17ffb5$var$suspenseHandlerStackCursor.current;
        if (null !== resource && (($f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes & 4194048) === $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes ? null !== $f8fd3b4e5f17ffb5$var$shellBoundary : ($f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes & 62914560) !== $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes && 0 === ($f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes & 536870912) || resource !== $f8fd3b4e5f17ffb5$var$shellBoundary)) throw $f8fd3b4e5f17ffb5$var$suspendedThenable = $f8fd3b4e5f17ffb5$var$noopSuspenseyCommitThenable, $f8fd3b4e5f17ffb5$var$SuspenseyCommitException;
        workInProgress.flags |= 8192;
    }
}
function $f8fd3b4e5f17ffb5$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $f8fd3b4e5f17ffb5$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $f8fd3b4e5f17ffb5$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $f8fd3b4e5f17ffb5$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$f8fd3b4e5f17ffb5$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$113 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$113 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$113 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$113.sibling = null;
    }
}
function $f8fd3b4e5f17ffb5$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags & 65011712, subtreeFlags |= child$114.flags & 65011712, child$114.return = completedWork, child$114 = child$114.sibling;
    else for(child$114 = completedWork.child; null !== child$114;)newChildLanes |= child$114.lanes | child$114.childLanes, subtreeFlags |= child$114.subtreeFlags, subtreeFlags |= child$114.flags, child$114.return = completedWork, child$114 = child$114.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $f8fd3b4e5f17ffb5$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $f8fd3b4e5f17ffb5$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 31:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress), null;
        case 1:
            return $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $f8fd3b4e5f17ffb5$var$popProvider($f8fd3b4e5f17ffb5$var$CacheContext);
            $f8fd3b4e5f17ffb5$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $f8fd3b4e5f17ffb5$var$popHydrationState(workInProgress) ? $f8fd3b4e5f17ffb5$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $f8fd3b4e5f17ffb5$var$upgradeHydrationErrorsToRecoverable());
            $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            return renderLanes = workInProgress.memoizedState, null === current ? ($f8fd3b4e5f17ffb5$var$markUpdate(workInProgress), null !== renderLanes ? ($f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress), $f8fd3b4e5f17ffb5$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217)) : renderLanes ? renderLanes !== current.memoizedState ? ($f8fd3b4e5f17ffb5$var$markUpdate(workInProgress), $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress), $f8fd3b4e5f17ffb5$var$preloadResourceAndSuspendIfNeeded(workInProgress, renderLanes)) : ($f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current.memoizedProps !== newProps && $f8fd3b4e5f17ffb5$var$markUpdate(workInProgress), $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217), null;
        case 27:
            $f8fd3b4e5f17ffb5$var$popHostContext(workInProgress);
            renderLanes = $f8fd3b4e5f17ffb5$var$rootInstanceStackCursor.current;
            var type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $f8fd3b4e5f17ffb5$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(166));
                    $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $f8fd3b4e5f17ffb5$var$contextStackCursor.current;
                $f8fd3b4e5f17ffb5$var$popHydrationState(workInProgress) ? $f8fd3b4e5f17ffb5$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $f8fd3b4e5f17ffb5$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $f8fd3b4e5f17ffb5$var$markUpdate(workInProgress));
            }
            $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $f8fd3b4e5f17ffb5$var$popHostContext(workInProgress);
            renderLanes = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $f8fd3b4e5f17ffb5$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(166));
                    $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $f8fd3b4e5f17ffb5$var$contextStackCursor.current;
                if ($f8fd3b4e5f17ffb5$var$popHydrationState(workInProgress)) $f8fd3b4e5f17ffb5$var$prepareToHydrateHostInstance(workInProgress, current);
                else {
                    type = $f8fd3b4e5f17ffb5$var$getOwnerDocumentFromRootContainer($f8fd3b4e5f17ffb5$var$rootInstanceStackCursor.current);
                    switch(current){
                        case 1:
                            current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                            break;
                        case 2:
                            current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                            break;
                        default:
                            switch(renderLanes){
                                case "svg":
                                    current = type.createElementNS("http://www.w3.org/2000/svg", renderLanes);
                                    break;
                                case "math":
                                    current = type.createElementNS("http://www.w3.org/1998/Math/MathML", renderLanes);
                                    break;
                                case "script":
                                    current = type.createElement("div");
                                    current.innerHTML = "<script>\x3c/script>";
                                    current = current.removeChild(current.firstChild);
                                    break;
                                case "select":
                                    current = "string" === typeof newProps.is ? type.createElement("select", {
                                        is: newProps.is
                                    }) : type.createElement("select");
                                    newProps.multiple ? current.multiple = !0 : newProps.size && (current.size = newProps.size);
                                    break;
                                default:
                                    current = "string" === typeof newProps.is ? type.createElement(renderLanes, {
                                        is: newProps.is
                                    }) : type.createElement(renderLanes);
                            }
                    }
                    current[$f8fd3b4e5f17ffb5$var$internalInstanceKey] = workInProgress;
                    current[$f8fd3b4e5f17ffb5$var$internalPropsKey] = newProps;
                    a: for(type = workInProgress.child; null !== type;){
                        if (5 === type.tag || 6 === type.tag) current.appendChild(type.stateNode);
                        else if (4 !== type.tag && 27 !== type.tag && null !== type.child) {
                            type.child.return = type;
                            type = type.child;
                            continue;
                        }
                        if (type === workInProgress) break a;
                        for(; null === type.sibling;){
                            if (null === type.return || type.return === workInProgress) break a;
                            type = type.return;
                        }
                        type.sibling.return = type.return;
                        type = type.sibling;
                    }
                    workInProgress.stateNode = current;
                    a: switch($f8fd3b4e5f17ffb5$var$setInitialProperties(current, renderLanes, newProps), renderLanes){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            current = !!newProps.autoFocus;
                            break a;
                        case "img":
                            current = !0;
                            break a;
                        default:
                            current = !1;
                    }
                    current && $f8fd3b4e5f17ffb5$var$markUpdate(workInProgress);
                }
            }
            $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress);
            workInProgress.flags &= -16777217;
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $f8fd3b4e5f17ffb5$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(166));
                current = $f8fd3b4e5f17ffb5$var$rootInstanceStackCursor.current;
                if ($f8fd3b4e5f17ffb5$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $f8fd3b4e5f17ffb5$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$f8fd3b4e5f17ffb5$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $f8fd3b4e5f17ffb5$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $f8fd3b4e5f17ffb5$var$throwOnHydrationMismatch(workInProgress);
                } else current = $f8fd3b4e5f17ffb5$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$f8fd3b4e5f17ffb5$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $f8fd3b4e5f17ffb5$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(317));
                        type[$f8fd3b4e5f17ffb5$var$internalInstanceKey] = workInProgress;
                    } else $f8fd3b4e5f17ffb5$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $f8fd3b4e5f17ffb5$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $f8fd3b4e5f17ffb5$var$popSuspenseHandler(workInProgress), workInProgress;
                    $f8fd3b4e5f17ffb5$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $f8fd3b4e5f17ffb5$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            if (renderLanes) {
                newProps = workInProgress.child;
                type = null;
                null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool);
                var cache$127 = null;
                null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$127 = newProps.memoizedState.cachePool.pool);
                cache$127 !== type && (newProps.flags |= 2048);
            }
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $f8fd3b4e5f17ffb5$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $f8fd3b4e5f17ffb5$var$popHostContainer(), null === current && $f8fd3b4e5f17ffb5$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress), null;
        case 10:
            return $f8fd3b4e5f17ffb5$var$popProvider(workInProgress.type), $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress), null;
        case 19:
            $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$suspenseStackCursor);
            type = workInProgress.memoizedState;
            if (null === type) return $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress), null;
            newProps = 0 !== (workInProgress.flags & 128);
            cache$127 = type.rendering;
            if (null === cache$127) {
                if (newProps) $f8fd3b4e5f17ffb5$var$cutOffTailIfNeeded(type, !1);
                else {
                    if (0 !== $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        cache$127 = $f8fd3b4e5f17ffb5$var$findFirstSuspended(current);
                        if (null !== cache$127) {
                            workInProgress.flags |= 128;
                            $f8fd3b4e5f17ffb5$var$cutOffTailIfNeeded(type, !1);
                            current = cache$127.updateQueue;
                            workInProgress.updateQueue = current;
                            $f8fd3b4e5f17ffb5$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$f8fd3b4e5f17ffb5$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$suspenseStackCursor, $f8fd3b4e5f17ffb5$var$suspenseStackCursor.current & 1 | 2);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== type.tail && $f8fd3b4e5f17ffb5$var$now() > $f8fd3b4e5f17ffb5$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, $f8fd3b4e5f17ffb5$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!newProps) {
                    if (current = $f8fd3b4e5f17ffb5$var$findFirstSuspended(cache$127), null !== current) {
                        if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, $f8fd3b4e5f17ffb5$var$scheduleRetryEffect(workInProgress, current), $f8fd3b4e5f17ffb5$var$cutOffTailIfNeeded(type, !0), null === type.tail && "hidden" === type.tailMode && !cache$127.alternate && !$f8fd3b4e5f17ffb5$var$isHydrating) return $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress), null;
                    } else 2 * $f8fd3b4e5f17ffb5$var$now() - type.renderingStartTime > $f8fd3b4e5f17ffb5$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, $f8fd3b4e5f17ffb5$var$cutOffTailIfNeeded(type, !1), workInProgress.lanes = 4194304);
                }
                type.isBackwards ? (cache$127.sibling = workInProgress.child, workInProgress.child = cache$127) : (current = type.last, null !== current ? current.sibling = cache$127 : workInProgress.child = cache$127, type.last = cache$127);
            }
            if (null !== type.tail) return workInProgress = type.tail, type.rendering = workInProgress, type.tail = workInProgress.sibling, type.renderingStartTime = $f8fd3b4e5f17ffb5$var$now(), workInProgress.sibling = null, current = $f8fd3b4e5f17ffb5$var$suspenseStackCursor.current, $f8fd3b4e5f17ffb5$var$push($f8fd3b4e5f17ffb5$var$suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
            $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $f8fd3b4e5f17ffb5$var$popSuspenseHandler(workInProgress), $f8fd3b4e5f17ffb5$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $f8fd3b4e5f17ffb5$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $f8fd3b4e5f17ffb5$var$popProvider($f8fd3b4e5f17ffb5$var$CacheContext), $f8fd3b4e5f17ffb5$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $f8fd3b4e5f17ffb5$var$unwindWork(current, workInProgress) {
    $f8fd3b4e5f17ffb5$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $f8fd3b4e5f17ffb5$var$popProvider($f8fd3b4e5f17ffb5$var$CacheContext), $f8fd3b4e5f17ffb5$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $f8fd3b4e5f17ffb5$var$popHostContext(workInProgress), null;
        case 13:
            $f8fd3b4e5f17ffb5$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(340));
                $f8fd3b4e5f17ffb5$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$suspenseStackCursor), null;
        case 4:
            return $f8fd3b4e5f17ffb5$var$popHostContainer(), null;
        case 10:
            return $f8fd3b4e5f17ffb5$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $f8fd3b4e5f17ffb5$var$popSuspenseHandler(workInProgress), $f8fd3b4e5f17ffb5$var$popHiddenContext(), null !== current && $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $f8fd3b4e5f17ffb5$var$popProvider($f8fd3b4e5f17ffb5$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $f8fd3b4e5f17ffb5$var$unwindInterruptedWork(current, interruptedWork) {
    $f8fd3b4e5f17ffb5$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $f8fd3b4e5f17ffb5$var$popProvider($f8fd3b4e5f17ffb5$var$CacheContext);
            $f8fd3b4e5f17ffb5$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $f8fd3b4e5f17ffb5$var$popHostContext(interruptedWork);
            break;
        case 4:
            $f8fd3b4e5f17ffb5$var$popHostContainer();
            break;
        case 13:
            $f8fd3b4e5f17ffb5$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$suspenseStackCursor);
            break;
        case 10:
            $f8fd3b4e5f17ffb5$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $f8fd3b4e5f17ffb5$var$popSuspenseHandler(interruptedWork);
            $f8fd3b4e5f17ffb5$var$popHiddenContext();
            null !== current && $f8fd3b4e5f17ffb5$var$pop($f8fd3b4e5f17ffb5$var$resumedCache);
            break;
        case 24:
            $f8fd3b4e5f17ffb5$var$popProvider($f8fd3b4e5f17ffb5$var$CacheContext);
    }
}
function $f8fd3b4e5f17ffb5$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f8fd3b4e5f17ffb5$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f8fd3b4e5f17ffb5$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $f8fd3b4e5f17ffb5$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $f8fd3b4e5f17ffb5$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $f8fd3b4e5f17ffb5$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $f8fd3b4e5f17ffb5$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $f8fd3b4e5f17ffb5$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$143) {
            $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(current, nearestMountedAncestor, error$143);
        }
        else ref.current = null;
    }
}
function $f8fd3b4e5f17ffb5$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f8fd3b4e5f17ffb5$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $f8fd3b4e5f17ffb5$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$f8fd3b4e5f17ffb5$var$internalPropsKey] = newProps;
    } catch (error) {
        $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f8fd3b4e5f17ffb5$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $f8fd3b4e5f17ffb5$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $f8fd3b4e5f17ffb5$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $f8fd3b4e5f17ffb5$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $f8fd3b4e5f17ffb5$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $f8fd3b4e5f17ffb5$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $f8fd3b4e5f17ffb5$var$noop$1));
    else if (4 !== tag && (27 === tag && $f8fd3b4e5f17ffb5$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($f8fd3b4e5f17ffb5$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$f8fd3b4e5f17ffb5$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $f8fd3b4e5f17ffb5$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $f8fd3b4e5f17ffb5$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($f8fd3b4e5f17ffb5$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$f8fd3b4e5f17ffb5$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $f8fd3b4e5f17ffb5$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $f8fd3b4e5f17ffb5$var$setInitialProperties(singleton, type, props);
        singleton[$f8fd3b4e5f17ffb5$var$internalInstanceKey] = finishedWork;
        singleton[$f8fd3b4e5f17ffb5$var$internalPropsKey] = props;
    } catch (error) {
        $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $f8fd3b4e5f17ffb5$var$offscreenSubtreeIsHidden = !1, $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden = !1, $f8fd3b4e5f17ffb5$var$needsFormReset = !1, $f8fd3b4e5f17ffb5$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $f8fd3b4e5f17ffb5$var$nextEffect = null;
function $f8fd3b4e5f17ffb5$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $f8fd3b4e5f17ffb5$var$eventsEnabled = $f8fd3b4e5f17ffb5$var$_enabled;
    root = $f8fd3b4e5f17ffb5$var$getActiveElementDeep(root);
    if ($f8fd3b4e5f17ffb5$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $f8fd3b4e5f17ffb5$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $f8fd3b4e5f17ffb5$var$_enabled = !1;
    for($f8fd3b4e5f17ffb5$var$nextEffect = firstChild; null !== $f8fd3b4e5f17ffb5$var$nextEffect;)if (firstChild = $f8fd3b4e5f17ffb5$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1024) && null !== root) root.return = firstChild, $f8fd3b4e5f17ffb5$var$nextEffect = root;
    else for(; null !== $f8fd3b4e5f17ffb5$var$nextEffect;){
        firstChild = $f8fd3b4e5f17ffb5$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $f8fd3b4e5f17ffb5$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset, JSCompiler_temp.elementType === JSCompiler_temp.type);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $f8fd3b4e5f17ffb5$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $f8fd3b4e5f17ffb5$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $f8fd3b4e5f17ffb5$var$nextEffect = root;
            break;
        }
        $f8fd3b4e5f17ffb5$var$nextEffect = firstChild.return;
    }
}
function $f8fd3b4e5f17ffb5$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $f8fd3b4e5f17ffb5$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $f8fd3b4e5f17ffb5$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$142) {
                        $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$142);
                    }
                }
            }
            flags & 64 && $f8fd3b4e5f17ffb5$var$commitClassCallbacks(finishedWork);
            flags & 512 && $f8fd3b4e5f17ffb5$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $f8fd3b4e5f17ffb5$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $f8fd3b4e5f17ffb5$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $f8fd3b4e5f17ffb5$var$commitHostMount(finishedWork);
            flags & 512 && $f8fd3b4e5f17ffb5$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 13:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $f8fd3b4e5f17ffb5$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $f8fd3b4e5f17ffb5$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $f8fd3b4e5f17ffb5$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $f8fd3b4e5f17ffb5$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden;
                prevProps = $f8fd3b4e5f17ffb5$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden;
                $f8fd3b4e5f17ffb5$var$offscreenSubtreeIsHidden = flags;
                ($f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $f8fd3b4e5f17ffb5$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $f8fd3b4e5f17ffb5$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $f8fd3b4e5f17ffb5$var$offscreenSubtreeIsHidden = prevProps;
                $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $f8fd3b4e5f17ffb5$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $f8fd3b4e5f17ffb5$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $f8fd3b4e5f17ffb5$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $f8fd3b4e5f17ffb5$var$hostParent = null, $f8fd3b4e5f17ffb5$var$hostParentIsContainer = !1;
function $f8fd3b4e5f17ffb5$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$f8fd3b4e5f17ffb5$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $f8fd3b4e5f17ffb5$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($f8fd3b4e5f17ffb5$var$injectedHook && "function" === typeof $f8fd3b4e5f17ffb5$var$injectedHook.onCommitFiberUnmount) try {
        $f8fd3b4e5f17ffb5$var$injectedHook.onCommitFiberUnmount($f8fd3b4e5f17ffb5$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden || $f8fd3b4e5f17ffb5$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden || $f8fd3b4e5f17ffb5$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $f8fd3b4e5f17ffb5$var$hostParent, prevHostParentIsContainer = $f8fd3b4e5f17ffb5$var$hostParentIsContainer;
            $f8fd3b4e5f17ffb5$var$isSingletonScope(deletedFiber.type) && ($f8fd3b4e5f17ffb5$var$hostParent = deletedFiber.stateNode, $f8fd3b4e5f17ffb5$var$hostParentIsContainer = !1);
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $f8fd3b4e5f17ffb5$var$releaseSingletonInstance(deletedFiber.stateNode);
            $f8fd3b4e5f17ffb5$var$hostParent = prevHostParent;
            $f8fd3b4e5f17ffb5$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden || $f8fd3b4e5f17ffb5$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $f8fd3b4e5f17ffb5$var$hostParent;
            prevHostParentIsContainer = $f8fd3b4e5f17ffb5$var$hostParentIsContainer;
            $f8fd3b4e5f17ffb5$var$hostParent = null;
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $f8fd3b4e5f17ffb5$var$hostParent = prevHostParent;
            $f8fd3b4e5f17ffb5$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $f8fd3b4e5f17ffb5$var$hostParent) {
                if ($f8fd3b4e5f17ffb5$var$hostParentIsContainer) try {
                    (9 === $f8fd3b4e5f17ffb5$var$hostParent.nodeType ? $f8fd3b4e5f17ffb5$var$hostParent.body : "HTML" === $f8fd3b4e5f17ffb5$var$hostParent.nodeName ? $f8fd3b4e5f17ffb5$var$hostParent.ownerDocument.body : $f8fd3b4e5f17ffb5$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $f8fd3b4e5f17ffb5$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $f8fd3b4e5f17ffb5$var$hostParent && ($f8fd3b4e5f17ffb5$var$hostParentIsContainer ? (finishedRoot = $f8fd3b4e5f17ffb5$var$hostParent, $f8fd3b4e5f17ffb5$var$clearSuspenseBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $f8fd3b4e5f17ffb5$var$retryIfBlockedOn(finishedRoot)) : $f8fd3b4e5f17ffb5$var$clearSuspenseBoundary($f8fd3b4e5f17ffb5$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $f8fd3b4e5f17ffb5$var$hostParent;
            prevHostParentIsContainer = $f8fd3b4e5f17ffb5$var$hostParentIsContainer;
            $f8fd3b4e5f17ffb5$var$hostParent = deletedFiber.stateNode.containerInfo;
            $f8fd3b4e5f17ffb5$var$hostParentIsContainer = !0;
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $f8fd3b4e5f17ffb5$var$hostParent = prevHostParent;
            $f8fd3b4e5f17ffb5$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden || $f8fd3b4e5f17ffb5$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden || $f8fd3b4e5f17ffb5$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden || ($f8fd3b4e5f17ffb5$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $f8fd3b4e5f17ffb5$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden = (prevHostParent = $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $f8fd3b4e5f17ffb5$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $f8fd3b4e5f17ffb5$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f8fd3b4e5f17ffb5$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $f8fd3b4e5f17ffb5$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $f8fd3b4e5f17ffb5$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $f8fd3b4e5f17ffb5$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $f8fd3b4e5f17ffb5$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        var retry = $f8fd3b4e5f17ffb5$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
        retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
    });
}
function $f8fd3b4e5f17ffb5$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($f8fd3b4e5f17ffb5$var$isSingletonScope(parent.type)) {
                        $f8fd3b4e5f17ffb5$var$hostParent = parent.stateNode;
                        $f8fd3b4e5f17ffb5$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $f8fd3b4e5f17ffb5$var$hostParent = parent.stateNode;
                    $f8fd3b4e5f17ffb5$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $f8fd3b4e5f17ffb5$var$hostParent = parent.stateNode.containerInfo;
                    $f8fd3b4e5f17ffb5$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $f8fd3b4e5f17ffb5$var$hostParent) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(160));
        $f8fd3b4e5f17ffb5$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $f8fd3b4e5f17ffb5$var$hostParent = null;
        $f8fd3b4e5f17ffb5$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)$f8fd3b4e5f17ffb5$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $f8fd3b4e5f17ffb5$var$currentHoistableRoot = null;
function $f8fd3b4e5f17ffb5$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f8fd3b4e5f17ffb5$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($f8fd3b4e5f17ffb5$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $f8fd3b4e5f17ffb5$var$commitHookEffectListMount(3, finishedWork), $f8fd3b4e5f17ffb5$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f8fd3b4e5f17ffb5$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden || null === current || $f8fd3b4e5f17ffb5$var$safelyDetachRef(current, current.return));
            flags & 64 && $f8fd3b4e5f17ffb5$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $f8fd3b4e5f17ffb5$var$currentHoistableRoot;
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f8fd3b4e5f17ffb5$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden || null === current || $f8fd3b4e5f17ffb5$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$f8fd3b4e5f17ffb5$var$internalHoistableMarker] || currentResource[$f8fd3b4e5f17ffb5$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $f8fd3b4e5f17ffb5$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$f8fd3b4e5f17ffb5$var$internalInstanceKey] = finishedWork;
                                        $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $f8fd3b4e5f17ffb5$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $f8fd3b4e5f17ffb5$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $f8fd3b4e5f17ffb5$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $f8fd3b4e5f17ffb5$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$f8fd3b4e5f17ffb5$var$internalInstanceKey] = finishedWork;
                                $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $f8fd3b4e5f17ffb5$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $f8fd3b4e5f17ffb5$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $f8fd3b4e5f17ffb5$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $f8fd3b4e5f17ffb5$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $f8fd3b4e5f17ffb5$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f8fd3b4e5f17ffb5$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden || null === current || $f8fd3b4e5f17ffb5$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $f8fd3b4e5f17ffb5$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f8fd3b4e5f17ffb5$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden || null === current || $f8fd3b4e5f17ffb5$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $f8fd3b4e5f17ffb5$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $f8fd3b4e5f17ffb5$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($f8fd3b4e5f17ffb5$var$needsFormReset = !0);
            break;
        case 6:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f8fd3b4e5f17ffb5$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $f8fd3b4e5f17ffb5$var$tagCaches = null;
            hoistableRoot = $f8fd3b4e5f17ffb5$var$currentHoistableRoot;
            $f8fd3b4e5f17ffb5$var$currentHoistableRoot = $f8fd3b4e5f17ffb5$var$getHoistableRoot(root.containerInfo);
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f8fd3b4e5f17ffb5$var$currentHoistableRoot = hoistableRoot;
            $f8fd3b4e5f17ffb5$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $f8fd3b4e5f17ffb5$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $f8fd3b4e5f17ffb5$var$needsFormReset && ($f8fd3b4e5f17ffb5$var$needsFormReset = !1, $f8fd3b4e5f17ffb5$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $f8fd3b4e5f17ffb5$var$currentHoistableRoot;
            $f8fd3b4e5f17ffb5$var$currentHoistableRoot = $f8fd3b4e5f17ffb5$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f8fd3b4e5f17ffb5$var$commitReconciliationEffects(finishedWork);
            $f8fd3b4e5f17ffb5$var$currentHoistableRoot = flags;
            break;
        case 12:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f8fd3b4e5f17ffb5$var$commitReconciliationEffects(finishedWork);
            break;
        case 13:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f8fd3b4e5f17ffb5$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($f8fd3b4e5f17ffb5$var$globalMostRecentFallbackTime = $f8fd3b4e5f17ffb5$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $f8fd3b4e5f17ffb5$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $f8fd3b4e5f17ffb5$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden;
            $f8fd3b4e5f17ffb5$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $f8fd3b4e5f17ffb5$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $f8fd3b4e5f17ffb5$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $f8fd3b4e5f17ffb5$var$offscreenSubtreeIsHidden || $f8fd3b4e5f17ffb5$var$offscreenSubtreeWasHidden || $f8fd3b4e5f17ffb5$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $f8fd3b4e5f17ffb5$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f8fd3b4e5f17ffb5$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $f8fd3b4e5f17ffb5$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $f8fd3b4e5f17ffb5$var$recursivelyTraverseMutationEffects(root, finishedWork), $f8fd3b4e5f17ffb5$var$commitReconciliationEffects(finishedWork);
    }
}
function $f8fd3b4e5f17ffb5$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($f8fd3b4e5f17ffb5$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $f8fd3b4e5f17ffb5$var$getHostSibling(finishedWork);
                    $f8fd3b4e5f17ffb5$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$144 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($f8fd3b4e5f17ffb5$var$setTextContent(parent$144, ""), hostParentFiber.flags &= -33);
                    var before$145 = $f8fd3b4e5f17ffb5$var$getHostSibling(finishedWork);
                    $f8fd3b4e5f17ffb5$var$insertOrAppendPlacementNode(finishedWork, before$145, parent$144);
                    break;
                case 3:
                case 4:
                    var parent$146 = hostParentFiber.stateNode.containerInfo, before$147 = $f8fd3b4e5f17ffb5$var$getHostSibling(finishedWork);
                    $f8fd3b4e5f17ffb5$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$147, parent$146);
                    break;
                default:
                    throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $f8fd3b4e5f17ffb5$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $f8fd3b4e5f17ffb5$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $f8fd3b4e5f17ffb5$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$f8fd3b4e5f17ffb5$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $f8fd3b4e5f17ffb5$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $f8fd3b4e5f17ffb5$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $f8fd3b4e5f17ffb5$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $f8fd3b4e5f17ffb5$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $f8fd3b4e5f17ffb5$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $f8fd3b4e5f17ffb5$var$safelyDetachRef(finishedWork, finishedWork.return);
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $f8fd3b4e5f17ffb5$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $f8fd3b4e5f17ffb5$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $f8fd3b4e5f17ffb5$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$f8fd3b4e5f17ffb5$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $f8fd3b4e5f17ffb5$var$commitClassCallbacks(finishedWork);
                $f8fd3b4e5f17ffb5$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $f8fd3b4e5f17ffb5$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $f8fd3b4e5f17ffb5$var$commitHostMount(finishedWork);
                $f8fd3b4e5f17ffb5$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 13:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $f8fd3b4e5f17ffb5$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $f8fd3b4e5f17ffb5$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $f8fd3b4e5f17ffb5$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $f8fd3b4e5f17ffb5$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $f8fd3b4e5f17ffb5$var$releaseCache(previousCache));
}
function $f8fd3b4e5f17ffb5$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $f8fd3b4e5f17ffb5$var$releaseCache(current));
}
function $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$f8fd3b4e5f17ffb5$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $f8fd3b4e5f17ffb5$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $f8fd3b4e5f17ffb5$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $f8fd3b4e5f17ffb5$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $f8fd3b4e5f17ffb5$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $f8fd3b4e5f17ffb5$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
            flags & 2048 && $f8fd3b4e5f17ffb5$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $f8fd3b4e5f17ffb5$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $f8fd3b4e5f17ffb5$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $f8fd3b4e5f17ffb5$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $f8fd3b4e5f17ffb5$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $f8fd3b4e5f17ffb5$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $f8fd3b4e5f17ffb5$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $f8fd3b4e5f17ffb5$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $f8fd3b4e5f17ffb5$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $f8fd3b4e5f17ffb5$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $f8fd3b4e5f17ffb5$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $f8fd3b4e5f17ffb5$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $f8fd3b4e5f17ffb5$var$suspenseyCommitFlag = 8192;
function $f8fd3b4e5f17ffb5$var$recursivelyAccumulateSuspenseyCommit(parentFiber) {
    if (parentFiber.subtreeFlags & $f8fd3b4e5f17ffb5$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$f8fd3b4e5f17ffb5$var$accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $f8fd3b4e5f17ffb5$var$accumulateSuspenseyCommitOnFiber(fiber) {
    switch(fiber.tag){
        case 26:
            $f8fd3b4e5f17ffb5$var$recursivelyAccumulateSuspenseyCommit(fiber);
            fiber.flags & $f8fd3b4e5f17ffb5$var$suspenseyCommitFlag && null !== fiber.memoizedState && $f8fd3b4e5f17ffb5$var$suspendResource($f8fd3b4e5f17ffb5$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $f8fd3b4e5f17ffb5$var$recursivelyAccumulateSuspenseyCommit(fiber);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $f8fd3b4e5f17ffb5$var$currentHoistableRoot;
            $f8fd3b4e5f17ffb5$var$currentHoistableRoot = $f8fd3b4e5f17ffb5$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $f8fd3b4e5f17ffb5$var$recursivelyAccumulateSuspenseyCommit(fiber);
            $f8fd3b4e5f17ffb5$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $f8fd3b4e5f17ffb5$var$suspenseyCommitFlag, $f8fd3b4e5f17ffb5$var$suspenseyCommitFlag = 16777216, $f8fd3b4e5f17ffb5$var$recursivelyAccumulateSuspenseyCommit(fiber), $f8fd3b4e5f17ffb5$var$suspenseyCommitFlag = previousHoistableRoot) : $f8fd3b4e5f17ffb5$var$recursivelyAccumulateSuspenseyCommit(fiber));
            break;
        default:
            $f8fd3b4e5f17ffb5$var$recursivelyAccumulateSuspenseyCommit(fiber);
    }
}
function $f8fd3b4e5f17ffb5$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $f8fd3b4e5f17ffb5$var$nextEffect = childToDelete;
            $f8fd3b4e5f17ffb5$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $f8fd3b4e5f17ffb5$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$f8fd3b4e5f17ffb5$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $f8fd3b4e5f17ffb5$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $f8fd3b4e5f17ffb5$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $f8fd3b4e5f17ffb5$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $f8fd3b4e5f17ffb5$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $f8fd3b4e5f17ffb5$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $f8fd3b4e5f17ffb5$var$nextEffect = childToDelete;
            $f8fd3b4e5f17ffb5$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $f8fd3b4e5f17ffb5$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $f8fd3b4e5f17ffb5$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $f8fd3b4e5f17ffb5$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $f8fd3b4e5f17ffb5$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $f8fd3b4e5f17ffb5$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $f8fd3b4e5f17ffb5$var$nextEffect;){
        var fiber = $f8fd3b4e5f17ffb5$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $f8fd3b4e5f17ffb5$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $f8fd3b4e5f17ffb5$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $f8fd3b4e5f17ffb5$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $f8fd3b4e5f17ffb5$var$nextEffect;){
            cache = $f8fd3b4e5f17ffb5$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $f8fd3b4e5f17ffb5$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $f8fd3b4e5f17ffb5$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $f8fd3b4e5f17ffb5$var$nextEffect = sibling;
                break a;
            }
            $f8fd3b4e5f17ffb5$var$nextEffect = returnFiber;
        }
    }
}
var $f8fd3b4e5f17ffb5$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $f8fd3b4e5f17ffb5$var$readContext($f8fd3b4e5f17ffb5$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    }
}, $f8fd3b4e5f17ffb5$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $f8fd3b4e5f17ffb5$var$executionContext = 0, $f8fd3b4e5f17ffb5$var$workInProgressRoot = null, $f8fd3b4e5f17ffb5$var$workInProgress = null, $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes = 0, $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 0, $f8fd3b4e5f17ffb5$var$workInProgressThrownValue = null, $f8fd3b4e5f17ffb5$var$workInProgressRootDidSkipSuspendedSiblings = !1, $f8fd3b4e5f17ffb5$var$workInProgressRootIsPrerendering = !1, $f8fd3b4e5f17ffb5$var$workInProgressRootDidAttachPingListener = !1, $f8fd3b4e5f17ffb5$var$entangledRenderLanes = 0, $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus = 0, $f8fd3b4e5f17ffb5$var$workInProgressRootSkippedLanes = 0, $f8fd3b4e5f17ffb5$var$workInProgressRootInterleavedUpdatedLanes = 0, $f8fd3b4e5f17ffb5$var$workInProgressRootPingedLanes = 0, $f8fd3b4e5f17ffb5$var$workInProgressDeferredLane = 0, $f8fd3b4e5f17ffb5$var$workInProgressSuspendedRetryLanes = 0, $f8fd3b4e5f17ffb5$var$workInProgressRootConcurrentErrors = null, $f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors = null, $f8fd3b4e5f17ffb5$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $f8fd3b4e5f17ffb5$var$globalMostRecentFallbackTime = 0, $f8fd3b4e5f17ffb5$var$workInProgressRootRenderTargetTime = Infinity, $f8fd3b4e5f17ffb5$var$workInProgressTransitions = null, $f8fd3b4e5f17ffb5$var$legacyErrorBoundariesThatAlreadyFailed = null, $f8fd3b4e5f17ffb5$var$pendingEffectsStatus = 0, $f8fd3b4e5f17ffb5$var$pendingEffectsRoot = null, $f8fd3b4e5f17ffb5$var$pendingFinishedWork = null, $f8fd3b4e5f17ffb5$var$pendingEffectsLanes = 0, $f8fd3b4e5f17ffb5$var$pendingEffectsRemainingLanes = 0, $f8fd3b4e5f17ffb5$var$pendingPassiveTransitions = null, $f8fd3b4e5f17ffb5$var$pendingRecoverableErrors = null, $f8fd3b4e5f17ffb5$var$nestedUpdateCount = 0, $f8fd3b4e5f17ffb5$var$rootWithNestedUpdates = null;
function $f8fd3b4e5f17ffb5$var$requestUpdateLane() {
    if (0 !== ($f8fd3b4e5f17ffb5$var$executionContext & 2) && 0 !== $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes) return $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes & -$f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes;
    if (null !== $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T) {
        var actionScopeLane = $f8fd3b4e5f17ffb5$var$currentEntangledLane;
        return 0 !== actionScopeLane ? actionScopeLane : $f8fd3b4e5f17ffb5$var$requestTransitionLane();
    }
    return $f8fd3b4e5f17ffb5$var$resolveUpdatePriority();
}
function $f8fd3b4e5f17ffb5$var$requestDeferredLane() {
    0 === $f8fd3b4e5f17ffb5$var$workInProgressDeferredLane && ($f8fd3b4e5f17ffb5$var$workInProgressDeferredLane = 0 === ($f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes & 536870912) || $f8fd3b4e5f17ffb5$var$isHydrating ? $f8fd3b4e5f17ffb5$var$claimNextTransitionLane() : 536870912);
    var suspenseHandler = $f8fd3b4e5f17ffb5$var$suspenseHandlerStackCursor.current;
    null !== suspenseHandler && (suspenseHandler.flags |= 32);
    return $f8fd3b4e5f17ffb5$var$workInProgressDeferredLane;
}
function $f8fd3b4e5f17ffb5$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $f8fd3b4e5f17ffb5$var$workInProgressRoot && (2 === $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason || 9 === $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $f8fd3b4e5f17ffb5$var$prepareFreshStack(root, 0), $f8fd3b4e5f17ffb5$var$markRootSuspended(root, $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes, $f8fd3b4e5f17ffb5$var$workInProgressDeferredLane, !1);
    $f8fd3b4e5f17ffb5$var$markRootUpdated$1(root, lane);
    if (0 === ($f8fd3b4e5f17ffb5$var$executionContext & 2) || root !== $f8fd3b4e5f17ffb5$var$workInProgressRoot) root === $f8fd3b4e5f17ffb5$var$workInProgressRoot && (0 === ($f8fd3b4e5f17ffb5$var$executionContext & 2) && ($f8fd3b4e5f17ffb5$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus && $f8fd3b4e5f17ffb5$var$markRootSuspended(root, $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes, $f8fd3b4e5f17ffb5$var$workInProgressDeferredLane, !1)), $f8fd3b4e5f17ffb5$var$ensureRootIsScheduled(root);
}
function $f8fd3b4e5f17ffb5$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($f8fd3b4e5f17ffb5$var$executionContext & 6)) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 124) && 0 === (lanes & root$jscomp$0.expiredLanes) || $f8fd3b4e5f17ffb5$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $f8fd3b4e5f17ffb5$var$renderRootConcurrent(root$jscomp$0, lanes) : $f8fd3b4e5f17ffb5$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $f8fd3b4e5f17ffb5$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $f8fd3b4e5f17ffb5$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$f8fd3b4e5f17ffb5$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $f8fd3b4e5f17ffb5$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $f8fd3b4e5f17ffb5$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($f8fd3b4e5f17ffb5$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $f8fd3b4e5f17ffb5$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($f8fd3b4e5f17ffb5$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $f8fd3b4e5f17ffb5$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors;
                            $f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors ? $f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors.push.apply($f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $f8fd3b4e5f17ffb5$var$prepareFreshStack(root$jscomp$0, 0);
                $f8fd3b4e5f17ffb5$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $f8fd3b4e5f17ffb5$var$markRootSuspended(shouldTimeSlice, lanes, $f8fd3b4e5f17ffb5$var$workInProgressDeferredLane, !$f8fd3b4e5f17ffb5$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $f8fd3b4e5f17ffb5$var$globalMostRecentFallbackTime + 300 - $f8fd3b4e5f17ffb5$var$now(), 10 < exitStatus)) {
                    $f8fd3b4e5f17ffb5$var$markRootSuspended(shouldTimeSlice, lanes, $f8fd3b4e5f17ffb5$var$workInProgressDeferredLane, !$f8fd3b4e5f17ffb5$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $f8fd3b4e5f17ffb5$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    shouldTimeSlice.timeoutHandle = $f8fd3b4e5f17ffb5$var$scheduleTimeout($f8fd3b4e5f17ffb5$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors, $f8fd3b4e5f17ffb5$var$workInProgressTransitions, $f8fd3b4e5f17ffb5$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $f8fd3b4e5f17ffb5$var$workInProgressDeferredLane, $f8fd3b4e5f17ffb5$var$workInProgressRootInterleavedUpdatedLanes, $f8fd3b4e5f17ffb5$var$workInProgressSuspendedRetryLanes, $f8fd3b4e5f17ffb5$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 2, -0, 0), exitStatus);
                    break a;
                }
                $f8fd3b4e5f17ffb5$var$commitRootWhenReady(shouldTimeSlice, forceSync, $f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors, $f8fd3b4e5f17ffb5$var$workInProgressTransitions, $f8fd3b4e5f17ffb5$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $f8fd3b4e5f17ffb5$var$workInProgressDeferredLane, $f8fd3b4e5f17ffb5$var$workInProgressRootInterleavedUpdatedLanes, $f8fd3b4e5f17ffb5$var$workInProgressSuspendedRetryLanes, $f8fd3b4e5f17ffb5$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, 0, -0, 0);
            }
        }
        break;
    }while (1);
    $f8fd3b4e5f17ffb5$var$ensureRootIsScheduled(root$jscomp$0);
}
function $f8fd3b4e5f17ffb5$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        if ($f8fd3b4e5f17ffb5$var$suspendedState = {
            stylesheets: null,
            count: 0,
            unsuspend: $f8fd3b4e5f17ffb5$var$noop
        }, $f8fd3b4e5f17ffb5$var$accumulateSuspenseyCommitOnFiber(finishedWork), suspendedCommitReason = $f8fd3b4e5f17ffb5$var$waitForCommitToBeReady(), null !== suspendedCommitReason) {
            root.cancelPendingCommit = suspendedCommitReason($f8fd3b4e5f17ffb5$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, 1, completedRenderStartTime, completedRenderEndTime));
            $f8fd3b4e5f17ffb5$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $f8fd3b4e5f17ffb5$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $f8fd3b4e5f17ffb5$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$f8fd3b4e5f17ffb5$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $f8fd3b4e5f17ffb5$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$f8fd3b4e5f17ffb5$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$f8fd3b4e5f17ffb5$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$4 = 31 - $f8fd3b4e5f17ffb5$var$clz32(lanes), lane = 1 << index$4;
        didAttemptEntireTree[index$4] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $f8fd3b4e5f17ffb5$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $f8fd3b4e5f17ffb5$var$flushSyncWork$1() {
    return 0 === ($f8fd3b4e5f17ffb5$var$executionContext & 6) ? ($f8fd3b4e5f17ffb5$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $f8fd3b4e5f17ffb5$var$resetWorkInProgressStack() {
    if (null !== $f8fd3b4e5f17ffb5$var$workInProgress) {
        if (0 === $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason) var interruptedWork = $f8fd3b4e5f17ffb5$var$workInProgress.return;
        else interruptedWork = $f8fd3b4e5f17ffb5$var$workInProgress, $f8fd3b4e5f17ffb5$var$lastContextDependency = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber$1 = null, $f8fd3b4e5f17ffb5$var$resetHooksOnUnwind(interruptedWork), $f8fd3b4e5f17ffb5$var$thenableState = null, $f8fd3b4e5f17ffb5$var$thenableIndexCounter = 0, interruptedWork = $f8fd3b4e5f17ffb5$var$workInProgress;
        for(; null !== interruptedWork;)$f8fd3b4e5f17ffb5$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $f8fd3b4e5f17ffb5$var$workInProgress = null;
    }
}
function $f8fd3b4e5f17ffb5$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $f8fd3b4e5f17ffb5$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $f8fd3b4e5f17ffb5$var$resetWorkInProgressStack();
    $f8fd3b4e5f17ffb5$var$workInProgressRoot = root;
    $f8fd3b4e5f17ffb5$var$workInProgress = timeoutHandle = $f8fd3b4e5f17ffb5$var$createWorkInProgress(root.current, null);
    $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes = lanes;
    $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 0;
    $f8fd3b4e5f17ffb5$var$workInProgressThrownValue = null;
    $f8fd3b4e5f17ffb5$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $f8fd3b4e5f17ffb5$var$workInProgressRootIsPrerendering = $f8fd3b4e5f17ffb5$var$checkIfRootIsPrerendering(root, lanes);
    $f8fd3b4e5f17ffb5$var$workInProgressRootDidAttachPingListener = !1;
    $f8fd3b4e5f17ffb5$var$workInProgressSuspendedRetryLanes = $f8fd3b4e5f17ffb5$var$workInProgressDeferredLane = $f8fd3b4e5f17ffb5$var$workInProgressRootPingedLanes = $f8fd3b4e5f17ffb5$var$workInProgressRootInterleavedUpdatedLanes = $f8fd3b4e5f17ffb5$var$workInProgressRootSkippedLanes = $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus = 0;
    $f8fd3b4e5f17ffb5$var$workInProgressRootRecoverableErrors = $f8fd3b4e5f17ffb5$var$workInProgressRootConcurrentErrors = null;
    $f8fd3b4e5f17ffb5$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$2 = 31 - $f8fd3b4e5f17ffb5$var$clz32(allEntangledLanes), lane = 1 << index$2;
        lanes |= root[index$2];
        allEntangledLanes &= ~lane;
    }
    $f8fd3b4e5f17ffb5$var$entangledRenderLanes = lanes;
    $f8fd3b4e5f17ffb5$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $f8fd3b4e5f17ffb5$var$handleThrow(root, thrownValue) {
    $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber = null;
    $f8fd3b4e5f17ffb5$var$ReactSharedInternals.H = $f8fd3b4e5f17ffb5$var$ContextOnlyDispatcher;
    thrownValue === $f8fd3b4e5f17ffb5$var$SuspenseException || thrownValue === $f8fd3b4e5f17ffb5$var$SuspenseActionException ? (thrownValue = $f8fd3b4e5f17ffb5$var$getSuspendedThenable(), $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 3) : thrownValue === $f8fd3b4e5f17ffb5$var$SuspenseyCommitException ? (thrownValue = $f8fd3b4e5f17ffb5$var$getSuspendedThenable(), $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 4) : $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = thrownValue === $f8fd3b4e5f17ffb5$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $f8fd3b4e5f17ffb5$var$workInProgressThrownValue = thrownValue;
    null === $f8fd3b4e5f17ffb5$var$workInProgress && ($f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus = 1, $f8fd3b4e5f17ffb5$var$logUncaughtError(root, $f8fd3b4e5f17ffb5$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $f8fd3b4e5f17ffb5$var$pushDispatcher() {
    var prevDispatcher = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.H;
    $f8fd3b4e5f17ffb5$var$ReactSharedInternals.H = $f8fd3b4e5f17ffb5$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $f8fd3b4e5f17ffb5$var$ContextOnlyDispatcher : prevDispatcher;
}
function $f8fd3b4e5f17ffb5$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.A;
    $f8fd3b4e5f17ffb5$var$ReactSharedInternals.A = $f8fd3b4e5f17ffb5$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $f8fd3b4e5f17ffb5$var$renderDidSuspendDelayIfPossible() {
    $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus = 4;
    $f8fd3b4e5f17ffb5$var$workInProgressRootDidSkipSuspendedSiblings || ($f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes & 4194048) !== $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes && null !== $f8fd3b4e5f17ffb5$var$suspenseHandlerStackCursor.current || ($f8fd3b4e5f17ffb5$var$workInProgressRootIsPrerendering = !0);
    0 === ($f8fd3b4e5f17ffb5$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($f8fd3b4e5f17ffb5$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $f8fd3b4e5f17ffb5$var$workInProgressRoot || $f8fd3b4e5f17ffb5$var$markRootSuspended($f8fd3b4e5f17ffb5$var$workInProgressRoot, $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes, $f8fd3b4e5f17ffb5$var$workInProgressDeferredLane, !1);
}
function $f8fd3b4e5f17ffb5$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $f8fd3b4e5f17ffb5$var$executionContext;
    $f8fd3b4e5f17ffb5$var$executionContext |= 2;
    var prevDispatcher = $f8fd3b4e5f17ffb5$var$pushDispatcher(), prevAsyncDispatcher = $f8fd3b4e5f17ffb5$var$pushAsyncDispatcher();
    if ($f8fd3b4e5f17ffb5$var$workInProgressRoot !== root || $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes !== lanes) $f8fd3b4e5f17ffb5$var$workInProgressTransitions = null, $f8fd3b4e5f17ffb5$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason && null !== $f8fd3b4e5f17ffb5$var$workInProgress) {
            var unitOfWork = $f8fd3b4e5f17ffb5$var$workInProgress, thrownValue = $f8fd3b4e5f17ffb5$var$workInProgressThrownValue;
            switch($f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason){
                case 8:
                    $f8fd3b4e5f17ffb5$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $f8fd3b4e5f17ffb5$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason;
                    $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 0;
                    $f8fd3b4e5f17ffb5$var$workInProgressThrownValue = null;
                    $f8fd3b4e5f17ffb5$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $f8fd3b4e5f17ffb5$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason, $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 0, $f8fd3b4e5f17ffb5$var$workInProgressThrownValue = null, $f8fd3b4e5f17ffb5$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $f8fd3b4e5f17ffb5$var$workLoopSync();
        exitStatus = $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$167) {
        $f8fd3b4e5f17ffb5$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $f8fd3b4e5f17ffb5$var$lastContextDependency = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber$1 = null;
    $f8fd3b4e5f17ffb5$var$executionContext = prevExecutionContext;
    $f8fd3b4e5f17ffb5$var$ReactSharedInternals.H = prevDispatcher;
    $f8fd3b4e5f17ffb5$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $f8fd3b4e5f17ffb5$var$workInProgress && ($f8fd3b4e5f17ffb5$var$workInProgressRoot = null, $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes = 0, $f8fd3b4e5f17ffb5$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $f8fd3b4e5f17ffb5$var$workLoopSync() {
    for(; null !== $f8fd3b4e5f17ffb5$var$workInProgress;)$f8fd3b4e5f17ffb5$var$performUnitOfWork($f8fd3b4e5f17ffb5$var$workInProgress);
}
function $f8fd3b4e5f17ffb5$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $f8fd3b4e5f17ffb5$var$executionContext;
    $f8fd3b4e5f17ffb5$var$executionContext |= 2;
    var prevDispatcher = $f8fd3b4e5f17ffb5$var$pushDispatcher(), prevAsyncDispatcher = $f8fd3b4e5f17ffb5$var$pushAsyncDispatcher();
    $f8fd3b4e5f17ffb5$var$workInProgressRoot !== root || $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes !== lanes ? ($f8fd3b4e5f17ffb5$var$workInProgressTransitions = null, $f8fd3b4e5f17ffb5$var$workInProgressRootRenderTargetTime = $f8fd3b4e5f17ffb5$var$now() + 500, $f8fd3b4e5f17ffb5$var$prepareFreshStack(root, lanes)) : $f8fd3b4e5f17ffb5$var$workInProgressRootIsPrerendering = $f8fd3b4e5f17ffb5$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason && null !== $f8fd3b4e5f17ffb5$var$workInProgress) {
            lanes = $f8fd3b4e5f17ffb5$var$workInProgress;
            var thrownValue = $f8fd3b4e5f17ffb5$var$workInProgressThrownValue;
            b: switch($f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason){
                case 1:
                    $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 0;
                    $f8fd3b4e5f17ffb5$var$workInProgressThrownValue = null;
                    $f8fd3b4e5f17ffb5$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($f8fd3b4e5f17ffb5$var$isThenableResolved(thrownValue)) {
                        $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 0;
                        $f8fd3b4e5f17ffb5$var$workInProgressThrownValue = null;
                        $f8fd3b4e5f17ffb5$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason && 9 !== $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason || $f8fd3b4e5f17ffb5$var$workInProgressRoot !== root || ($f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 7);
                        $f8fd3b4e5f17ffb5$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $f8fd3b4e5f17ffb5$var$isThenableResolved(thrownValue) ? ($f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 0, $f8fd3b4e5f17ffb5$var$workInProgressThrownValue = null, $f8fd3b4e5f17ffb5$var$replaySuspendedUnitOfWork(lanes)) : ($f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 0, $f8fd3b4e5f17ffb5$var$workInProgressThrownValue = null, $f8fd3b4e5f17ffb5$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($f8fd3b4e5f17ffb5$var$workInProgress.tag){
                        case 26:
                            resource = $f8fd3b4e5f17ffb5$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $f8fd3b4e5f17ffb5$var$workInProgress;
                            if (resource ? $f8fd3b4e5f17ffb5$var$preloadResource(resource) : 1) {
                                $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 0;
                                $f8fd3b4e5f17ffb5$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $f8fd3b4e5f17ffb5$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($f8fd3b4e5f17ffb5$var$workInProgress = returnFiber, $f8fd3b4e5f17ffb5$var$completeUnitOfWork(returnFiber)) : $f8fd3b4e5f17ffb5$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 0;
                    $f8fd3b4e5f17ffb5$var$workInProgressThrownValue = null;
                    $f8fd3b4e5f17ffb5$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason = 0;
                    $f8fd3b4e5f17ffb5$var$workInProgressThrownValue = null;
                    $f8fd3b4e5f17ffb5$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $f8fd3b4e5f17ffb5$var$resetWorkInProgressStack();
                    $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(462));
            }
        }
        $f8fd3b4e5f17ffb5$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$169) {
        $f8fd3b4e5f17ffb5$var$handleThrow(root, thrownValue$169);
    }
    while (1);
    $f8fd3b4e5f17ffb5$var$lastContextDependency = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber$1 = null;
    $f8fd3b4e5f17ffb5$var$ReactSharedInternals.H = prevDispatcher;
    $f8fd3b4e5f17ffb5$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $f8fd3b4e5f17ffb5$var$executionContext = prevExecutionContext;
    if (null !== $f8fd3b4e5f17ffb5$var$workInProgress) return 0;
    $f8fd3b4e5f17ffb5$var$workInProgressRoot = null;
    $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes = 0;
    $f8fd3b4e5f17ffb5$var$finishQueueingConcurrentUpdates();
    return $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus;
}
function $f8fd3b4e5f17ffb5$var$workLoopConcurrentByScheduler() {
    for(; null !== $f8fd3b4e5f17ffb5$var$workInProgress && !$f8fd3b4e5f17ffb5$var$shouldYield();)$f8fd3b4e5f17ffb5$var$performUnitOfWork($f8fd3b4e5f17ffb5$var$workInProgress);
}
function $f8fd3b4e5f17ffb5$var$performUnitOfWork(unitOfWork) {
    var next = $f8fd3b4e5f17ffb5$var$beginWork(unitOfWork.alternate, unitOfWork, $f8fd3b4e5f17ffb5$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $f8fd3b4e5f17ffb5$var$completeUnitOfWork(unitOfWork) : $f8fd3b4e5f17ffb5$var$workInProgress = next;
}
function $f8fd3b4e5f17ffb5$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $f8fd3b4e5f17ffb5$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $f8fd3b4e5f17ffb5$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $f8fd3b4e5f17ffb5$var$resetHooksOnUnwind(next);
        default:
            $f8fd3b4e5f17ffb5$var$unwindInterruptedWork(current, next), next = $f8fd3b4e5f17ffb5$var$workInProgress = $f8fd3b4e5f17ffb5$var$resetWorkInProgress(next, $f8fd3b4e5f17ffb5$var$entangledRenderLanes), next = $f8fd3b4e5f17ffb5$var$beginWork(current, next, $f8fd3b4e5f17ffb5$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $f8fd3b4e5f17ffb5$var$completeUnitOfWork(unitOfWork) : $f8fd3b4e5f17ffb5$var$workInProgress = next;
}
function $f8fd3b4e5f17ffb5$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $f8fd3b4e5f17ffb5$var$lastContextDependency = $f8fd3b4e5f17ffb5$var$currentlyRenderingFiber$1 = null;
    $f8fd3b4e5f17ffb5$var$resetHooksOnUnwind(unitOfWork);
    $f8fd3b4e5f17ffb5$var$thenableState = null;
    $f8fd3b4e5f17ffb5$var$thenableIndexCounter = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($f8fd3b4e5f17ffb5$var$throwException(root, returnFiber, unitOfWork, thrownValue, $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes)) {
            $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus = 1;
            $f8fd3b4e5f17ffb5$var$logUncaughtError(root, $f8fd3b4e5f17ffb5$var$createCapturedValueAtFiber(thrownValue, root.current));
            $f8fd3b4e5f17ffb5$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $f8fd3b4e5f17ffb5$var$workInProgress = returnFiber, error;
        $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus = 1;
        $f8fd3b4e5f17ffb5$var$logUncaughtError(root, $f8fd3b4e5f17ffb5$var$createCapturedValueAtFiber(thrownValue, root.current));
        $f8fd3b4e5f17ffb5$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($f8fd3b4e5f17ffb5$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($f8fd3b4e5f17ffb5$var$workInProgressRootIsPrerendering || 0 !== ($f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($f8fd3b4e5f17ffb5$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $f8fd3b4e5f17ffb5$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $f8fd3b4e5f17ffb5$var$unwindUnitOfWork(unitOfWork, root);
    } else $f8fd3b4e5f17ffb5$var$completeUnitOfWork(unitOfWork);
}
function $f8fd3b4e5f17ffb5$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $f8fd3b4e5f17ffb5$var$unwindUnitOfWork(completedWork, $f8fd3b4e5f17ffb5$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $f8fd3b4e5f17ffb5$var$completeWork(completedWork.alternate, completedWork, $f8fd3b4e5f17ffb5$var$entangledRenderLanes);
        if (null !== next) {
            $f8fd3b4e5f17ffb5$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $f8fd3b4e5f17ffb5$var$workInProgress = completedWork;
            return;
        }
        $f8fd3b4e5f17ffb5$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus && ($f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus = 5);
}
function $f8fd3b4e5f17ffb5$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $f8fd3b4e5f17ffb5$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $f8fd3b4e5f17ffb5$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $f8fd3b4e5f17ffb5$var$workInProgress = unitOfWork;
            return;
        }
        $f8fd3b4e5f17ffb5$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus = 6;
    $f8fd3b4e5f17ffb5$var$workInProgress = null;
}
function $f8fd3b4e5f17ffb5$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $f8fd3b4e5f17ffb5$var$flushPendingEffects();
    while (0 !== $f8fd3b4e5f17ffb5$var$pendingEffectsStatus);
    if (0 !== ($f8fd3b4e5f17ffb5$var$executionContext & 6)) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $f8fd3b4e5f17ffb5$var$concurrentlyUpdatedLanes;
        $f8fd3b4e5f17ffb5$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $f8fd3b4e5f17ffb5$var$workInProgressRoot && ($f8fd3b4e5f17ffb5$var$workInProgress = $f8fd3b4e5f17ffb5$var$workInProgressRoot = null, $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes = 0);
        $f8fd3b4e5f17ffb5$var$pendingFinishedWork = finishedWork;
        $f8fd3b4e5f17ffb5$var$pendingEffectsRoot = root;
        $f8fd3b4e5f17ffb5$var$pendingEffectsLanes = lanes;
        $f8fd3b4e5f17ffb5$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $f8fd3b4e5f17ffb5$var$pendingPassiveTransitions = transitions;
        $f8fd3b4e5f17ffb5$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $f8fd3b4e5f17ffb5$var$scheduleCallback$1($f8fd3b4e5f17ffb5$var$NormalPriority$1, function() {
            $f8fd3b4e5f17ffb5$var$flushPassiveEffects(!0);
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T;
            $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = null;
            transitions = $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p;
            $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $f8fd3b4e5f17ffb5$var$executionContext;
            $f8fd3b4e5f17ffb5$var$executionContext |= 4;
            try {
                $f8fd3b4e5f17ffb5$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $f8fd3b4e5f17ffb5$var$executionContext = spawnedLane, $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = transitions, $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $f8fd3b4e5f17ffb5$var$pendingEffectsStatus = 1;
        $f8fd3b4e5f17ffb5$var$flushMutationEffects();
        $f8fd3b4e5f17ffb5$var$flushLayoutEffects();
        $f8fd3b4e5f17ffb5$var$flushSpawnedWork();
    }
}
function $f8fd3b4e5f17ffb5$var$flushMutationEffects() {
    if (1 === $f8fd3b4e5f17ffb5$var$pendingEffectsStatus) {
        $f8fd3b4e5f17ffb5$var$pendingEffectsStatus = 0;
        var root = $f8fd3b4e5f17ffb5$var$pendingEffectsRoot, finishedWork = $f8fd3b4e5f17ffb5$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T;
            $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = null;
            var previousPriority = $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p;
            $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $f8fd3b4e5f17ffb5$var$executionContext;
            $f8fd3b4e5f17ffb5$var$executionContext |= 4;
            try {
                $f8fd3b4e5f17ffb5$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $f8fd3b4e5f17ffb5$var$selectionInformation, curFocusedElem = $f8fd3b4e5f17ffb5$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $f8fd3b4e5f17ffb5$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $f8fd3b4e5f17ffb5$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $f8fd3b4e5f17ffb5$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $f8fd3b4e5f17ffb5$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $f8fd3b4e5f17ffb5$var$_enabled = !!$f8fd3b4e5f17ffb5$var$eventsEnabled;
                $f8fd3b4e5f17ffb5$var$selectionInformation = $f8fd3b4e5f17ffb5$var$eventsEnabled = null;
            } finally{
                $f8fd3b4e5f17ffb5$var$executionContext = prevExecutionContext, $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = previousPriority, $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $f8fd3b4e5f17ffb5$var$pendingEffectsStatus = 2;
    }
}
function $f8fd3b4e5f17ffb5$var$flushLayoutEffects() {
    if (2 === $f8fd3b4e5f17ffb5$var$pendingEffectsStatus) {
        $f8fd3b4e5f17ffb5$var$pendingEffectsStatus = 0;
        var root = $f8fd3b4e5f17ffb5$var$pendingEffectsRoot, finishedWork = $f8fd3b4e5f17ffb5$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T;
            $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = null;
            var previousPriority = $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p;
            $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $f8fd3b4e5f17ffb5$var$executionContext;
            $f8fd3b4e5f17ffb5$var$executionContext |= 4;
            try {
                $f8fd3b4e5f17ffb5$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $f8fd3b4e5f17ffb5$var$executionContext = prevExecutionContext, $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = previousPriority, $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $f8fd3b4e5f17ffb5$var$pendingEffectsStatus = 3;
    }
}
function $f8fd3b4e5f17ffb5$var$flushSpawnedWork() {
    if (4 === $f8fd3b4e5f17ffb5$var$pendingEffectsStatus || 3 === $f8fd3b4e5f17ffb5$var$pendingEffectsStatus) {
        $f8fd3b4e5f17ffb5$var$pendingEffectsStatus = 0;
        $f8fd3b4e5f17ffb5$var$requestPaint();
        var root = $f8fd3b4e5f17ffb5$var$pendingEffectsRoot, finishedWork = $f8fd3b4e5f17ffb5$var$pendingFinishedWork, lanes = $f8fd3b4e5f17ffb5$var$pendingEffectsLanes, recoverableErrors = $f8fd3b4e5f17ffb5$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $f8fd3b4e5f17ffb5$var$pendingEffectsStatus = 5 : ($f8fd3b4e5f17ffb5$var$pendingEffectsStatus = 0, $f8fd3b4e5f17ffb5$var$pendingFinishedWork = $f8fd3b4e5f17ffb5$var$pendingEffectsRoot = null, $f8fd3b4e5f17ffb5$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($f8fd3b4e5f17ffb5$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $f8fd3b4e5f17ffb5$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($f8fd3b4e5f17ffb5$var$injectedHook && "function" === typeof $f8fd3b4e5f17ffb5$var$injectedHook.onCommitFiberRoot) try {
            $f8fd3b4e5f17ffb5$var$injectedHook.onCommitFiberRoot($f8fd3b4e5f17ffb5$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T;
            remainingLanes = $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p;
            $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = 2;
            $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = finishedWork, $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($f8fd3b4e5f17ffb5$var$pendingEffectsLanes & 3) && $f8fd3b4e5f17ffb5$var$flushPendingEffects();
        $f8fd3b4e5f17ffb5$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 4194090) && 0 !== (remainingLanes & 42) ? root === $f8fd3b4e5f17ffb5$var$rootWithNestedUpdates ? $f8fd3b4e5f17ffb5$var$nestedUpdateCount++ : ($f8fd3b4e5f17ffb5$var$nestedUpdateCount = 0, $f8fd3b4e5f17ffb5$var$rootWithNestedUpdates = root) : $f8fd3b4e5f17ffb5$var$nestedUpdateCount = 0;
        $f8fd3b4e5f17ffb5$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $f8fd3b4e5f17ffb5$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $f8fd3b4e5f17ffb5$var$releaseCache(remainingLanes)));
}
function $f8fd3b4e5f17ffb5$var$flushPendingEffects(wasDelayedCommit) {
    $f8fd3b4e5f17ffb5$var$flushMutationEffects();
    $f8fd3b4e5f17ffb5$var$flushLayoutEffects();
    $f8fd3b4e5f17ffb5$var$flushSpawnedWork();
    return $f8fd3b4e5f17ffb5$var$flushPassiveEffects(wasDelayedCommit);
}
function $f8fd3b4e5f17ffb5$var$flushPassiveEffects() {
    if (5 !== $f8fd3b4e5f17ffb5$var$pendingEffectsStatus) return !1;
    var root = $f8fd3b4e5f17ffb5$var$pendingEffectsRoot, remainingLanes = $f8fd3b4e5f17ffb5$var$pendingEffectsRemainingLanes;
    $f8fd3b4e5f17ffb5$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $f8fd3b4e5f17ffb5$var$lanesToEventPriority($f8fd3b4e5f17ffb5$var$pendingEffectsLanes), prevTransition = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T, previousPriority = $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p;
    try {
        $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = null;
        renderPriority = $f8fd3b4e5f17ffb5$var$pendingPassiveTransitions;
        $f8fd3b4e5f17ffb5$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $f8fd3b4e5f17ffb5$var$pendingEffectsRoot, lanes = $f8fd3b4e5f17ffb5$var$pendingEffectsLanes;
        $f8fd3b4e5f17ffb5$var$pendingEffectsStatus = 0;
        $f8fd3b4e5f17ffb5$var$pendingFinishedWork = $f8fd3b4e5f17ffb5$var$pendingEffectsRoot = null;
        $f8fd3b4e5f17ffb5$var$pendingEffectsLanes = 0;
        if (0 !== ($f8fd3b4e5f17ffb5$var$executionContext & 6)) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(331));
        var prevExecutionContext = $f8fd3b4e5f17ffb5$var$executionContext;
        $f8fd3b4e5f17ffb5$var$executionContext |= 4;
        $f8fd3b4e5f17ffb5$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $f8fd3b4e5f17ffb5$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $f8fd3b4e5f17ffb5$var$executionContext = prevExecutionContext;
        $f8fd3b4e5f17ffb5$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($f8fd3b4e5f17ffb5$var$injectedHook && "function" === typeof $f8fd3b4e5f17ffb5$var$injectedHook.onPostCommitFiberRoot) try {
            $f8fd3b4e5f17ffb5$var$injectedHook.onPostCommitFiberRoot($f8fd3b4e5f17ffb5$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = previousPriority, $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = prevTransition, $f8fd3b4e5f17ffb5$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $f8fd3b4e5f17ffb5$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $f8fd3b4e5f17ffb5$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $f8fd3b4e5f17ffb5$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $f8fd3b4e5f17ffb5$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($f8fd3b4e5f17ffb5$var$markRootUpdated$1(rootFiber, 2), $f8fd3b4e5f17ffb5$var$ensureRootIsScheduled(rootFiber));
}
function $f8fd3b4e5f17ffb5$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $f8fd3b4e5f17ffb5$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $f8fd3b4e5f17ffb5$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $f8fd3b4e5f17ffb5$var$legacyErrorBoundariesThatAlreadyFailed || !$f8fd3b4e5f17ffb5$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $f8fd3b4e5f17ffb5$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $f8fd3b4e5f17ffb5$var$createClassErrorUpdate(2);
                instance = $f8fd3b4e5f17ffb5$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($f8fd3b4e5f17ffb5$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $f8fd3b4e5f17ffb5$var$markRootUpdated$1(instance, 2), $f8fd3b4e5f17ffb5$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $f8fd3b4e5f17ffb5$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $f8fd3b4e5f17ffb5$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($f8fd3b4e5f17ffb5$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $f8fd3b4e5f17ffb5$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $f8fd3b4e5f17ffb5$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $f8fd3b4e5f17ffb5$var$workInProgressRoot === root && ($f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus || 3 === $f8fd3b4e5f17ffb5$var$workInProgressRootExitStatus && ($f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes & 62914560) === $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes && 300 > $f8fd3b4e5f17ffb5$var$now() - $f8fd3b4e5f17ffb5$var$globalMostRecentFallbackTime ? 0 === ($f8fd3b4e5f17ffb5$var$executionContext & 2) && $f8fd3b4e5f17ffb5$var$prepareFreshStack(root, 0) : $f8fd3b4e5f17ffb5$var$workInProgressRootPingedLanes |= pingedLanes, $f8fd3b4e5f17ffb5$var$workInProgressSuspendedRetryLanes === $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes && ($f8fd3b4e5f17ffb5$var$workInProgressSuspendedRetryLanes = 0));
    $f8fd3b4e5f17ffb5$var$ensureRootIsScheduled(root);
}
function $f8fd3b4e5f17ffb5$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $f8fd3b4e5f17ffb5$var$claimNextRetryLane());
    boundaryFiber = $f8fd3b4e5f17ffb5$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($f8fd3b4e5f17ffb5$var$markRootUpdated$1(boundaryFiber, retryLane), $f8fd3b4e5f17ffb5$var$ensureRootIsScheduled(boundaryFiber));
}
function $f8fd3b4e5f17ffb5$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $f8fd3b4e5f17ffb5$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $f8fd3b4e5f17ffb5$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $f8fd3b4e5f17ffb5$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $f8fd3b4e5f17ffb5$var$scheduleCallback$1(priorityLevel, callback) {
    return $f8fd3b4e5f17ffb5$var$scheduleCallback$3(priorityLevel, callback);
}
var $f8fd3b4e5f17ffb5$var$firstScheduledRoot = null, $f8fd3b4e5f17ffb5$var$lastScheduledRoot = null, $f8fd3b4e5f17ffb5$var$didScheduleMicrotask = !1, $f8fd3b4e5f17ffb5$var$mightHavePendingSyncWork = !1, $f8fd3b4e5f17ffb5$var$isFlushingWork = !1, $f8fd3b4e5f17ffb5$var$currentEventTransitionLane = 0;
function $f8fd3b4e5f17ffb5$var$ensureRootIsScheduled(root) {
    root !== $f8fd3b4e5f17ffb5$var$lastScheduledRoot && null === root.next && (null === $f8fd3b4e5f17ffb5$var$lastScheduledRoot ? $f8fd3b4e5f17ffb5$var$firstScheduledRoot = $f8fd3b4e5f17ffb5$var$lastScheduledRoot = root : $f8fd3b4e5f17ffb5$var$lastScheduledRoot = $f8fd3b4e5f17ffb5$var$lastScheduledRoot.next = root);
    $f8fd3b4e5f17ffb5$var$mightHavePendingSyncWork = !0;
    $f8fd3b4e5f17ffb5$var$didScheduleMicrotask || ($f8fd3b4e5f17ffb5$var$didScheduleMicrotask = !0, $f8fd3b4e5f17ffb5$var$scheduleImmediateRootScheduleTask());
}
function $f8fd3b4e5f17ffb5$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$f8fd3b4e5f17ffb5$var$isFlushingWork && $f8fd3b4e5f17ffb5$var$mightHavePendingSyncWork) {
        $f8fd3b4e5f17ffb5$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$174 = $f8fd3b4e5f17ffb5$var$firstScheduledRoot; null !== root$174;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$174.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$174.suspendedLanes, pingedLanes = root$174.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $f8fd3b4e5f17ffb5$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $f8fd3b4e5f17ffb5$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $f8fd3b4e5f17ffb5$var$getNextLanes(root$174, root$174 === $f8fd3b4e5f17ffb5$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$174.cancelPendingCommit || -1 !== root$174.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $f8fd3b4e5f17ffb5$var$checkIfRootIsPrerendering(root$174, JSCompiler_inline_result) || (didPerformSomeWork = !0, $f8fd3b4e5f17ffb5$var$performSyncWorkOnRoot(root$174, JSCompiler_inline_result));
                }
                root$174 = root$174.next;
            }
        }while (didPerformSomeWork);
        $f8fd3b4e5f17ffb5$var$isFlushingWork = !1;
    }
}
function $f8fd3b4e5f17ffb5$var$processRootScheduleInImmediateTask() {
    $f8fd3b4e5f17ffb5$var$processRootScheduleInMicrotask();
}
function $f8fd3b4e5f17ffb5$var$processRootScheduleInMicrotask() {
    $f8fd3b4e5f17ffb5$var$mightHavePendingSyncWork = $f8fd3b4e5f17ffb5$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $f8fd3b4e5f17ffb5$var$currentEventTransitionLane && ($f8fd3b4e5f17ffb5$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $f8fd3b4e5f17ffb5$var$currentEventTransitionLane), $f8fd3b4e5f17ffb5$var$currentEventTransitionLane = 0);
    for(var currentTime = $f8fd3b4e5f17ffb5$var$now(), prev = null, root = $f8fd3b4e5f17ffb5$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $f8fd3b4e5f17ffb5$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $f8fd3b4e5f17ffb5$var$firstScheduledRoot = next : prev.next = next, null === next && ($f8fd3b4e5f17ffb5$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $f8fd3b4e5f17ffb5$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    $f8fd3b4e5f17ffb5$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
}
function $f8fd3b4e5f17ffb5$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$3 = 31 - $f8fd3b4e5f17ffb5$var$clz32(lanes), lane = 1 << index$3, expirationTime = expirationTimes[index$3];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$3] = $f8fd3b4e5f17ffb5$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $f8fd3b4e5f17ffb5$var$workInProgressRoot;
    suspendedLanes = $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes;
    suspendedLanes = $f8fd3b4e5f17ffb5$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason || 9 === $f8fd3b4e5f17ffb5$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $f8fd3b4e5f17ffb5$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $f8fd3b4e5f17ffb5$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $f8fd3b4e5f17ffb5$var$cancelCallback$1(pingedLanes);
        switch($f8fd3b4e5f17ffb5$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $f8fd3b4e5f17ffb5$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $f8fd3b4e5f17ffb5$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $f8fd3b4e5f17ffb5$var$IdlePriority;
                break;
            default:
                suspendedLanes = $f8fd3b4e5f17ffb5$var$NormalPriority$1;
        }
        pingedLanes = $f8fd3b4e5f17ffb5$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $f8fd3b4e5f17ffb5$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $f8fd3b4e5f17ffb5$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $f8fd3b4e5f17ffb5$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $f8fd3b4e5f17ffb5$var$pendingEffectsStatus && 5 !== $f8fd3b4e5f17ffb5$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($f8fd3b4e5f17ffb5$var$flushPendingEffects(!0) && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $f8fd3b4e5f17ffb5$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $f8fd3b4e5f17ffb5$var$getNextLanes(root, root === $f8fd3b4e5f17ffb5$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $f8fd3b4e5f17ffb5$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $f8fd3b4e5f17ffb5$var$scheduleTaskForRootDuringMicrotask(root, $f8fd3b4e5f17ffb5$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $f8fd3b4e5f17ffb5$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $f8fd3b4e5f17ffb5$var$performSyncWorkOnRoot(root, lanes) {
    if ($f8fd3b4e5f17ffb5$var$flushPendingEffects()) return null;
    $f8fd3b4e5f17ffb5$var$performWorkOnRoot(root, lanes, !0);
}
function $f8fd3b4e5f17ffb5$var$scheduleImmediateRootScheduleTask() {
    $f8fd3b4e5f17ffb5$var$scheduleMicrotask(function() {
        0 !== ($f8fd3b4e5f17ffb5$var$executionContext & 6) ? $f8fd3b4e5f17ffb5$var$scheduleCallback$3($f8fd3b4e5f17ffb5$var$ImmediatePriority, $f8fd3b4e5f17ffb5$var$processRootScheduleInImmediateTask) : $f8fd3b4e5f17ffb5$var$processRootScheduleInMicrotask();
    });
}
function $f8fd3b4e5f17ffb5$var$requestTransitionLane() {
    0 === $f8fd3b4e5f17ffb5$var$currentEventTransitionLane && ($f8fd3b4e5f17ffb5$var$currentEventTransitionLane = $f8fd3b4e5f17ffb5$var$claimNextTransitionLane());
    return $f8fd3b4e5f17ffb5$var$currentEventTransitionLane;
}
function $f8fd3b4e5f17ffb5$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $f8fd3b4e5f17ffb5$var$sanitizeURL("" + actionProp);
}
function $f8fd3b4e5f17ffb5$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $f8fd3b4e5f17ffb5$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $f8fd3b4e5f17ffb5$var$coerceFormActionProp((nativeEventTarget[$f8fd3b4e5f17ffb5$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$f8fd3b4e5f17ffb5$var$internalPropsKey] || null) ? $f8fd3b4e5f17ffb5$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $f8fd3b4e5f17ffb5$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $f8fd3b4e5f17ffb5$var$currentEventTransitionLane) {
                                var formData = submitter ? $f8fd3b4e5f17ffb5$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $f8fd3b4e5f17ffb5$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $f8fd3b4e5f17ffb5$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $f8fd3b4e5f17ffb5$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $f8fd3b4e5f17ffb5$var$i$jscomp$inline_1528 = 0; $f8fd3b4e5f17ffb5$var$i$jscomp$inline_1528 < $f8fd3b4e5f17ffb5$var$simpleEventPluginEvents.length; $f8fd3b4e5f17ffb5$var$i$jscomp$inline_1528++){
    var $f8fd3b4e5f17ffb5$var$eventName$jscomp$inline_1529 = $f8fd3b4e5f17ffb5$var$simpleEventPluginEvents[$f8fd3b4e5f17ffb5$var$i$jscomp$inline_1528], $f8fd3b4e5f17ffb5$var$domEventName$jscomp$inline_1530 = $f8fd3b4e5f17ffb5$var$eventName$jscomp$inline_1529.toLowerCase(), $f8fd3b4e5f17ffb5$var$capitalizedEvent$jscomp$inline_1531 = $f8fd3b4e5f17ffb5$var$eventName$jscomp$inline_1529[0].toUpperCase() + $f8fd3b4e5f17ffb5$var$eventName$jscomp$inline_1529.slice(1);
    $f8fd3b4e5f17ffb5$var$registerSimpleEvent($f8fd3b4e5f17ffb5$var$domEventName$jscomp$inline_1530, "on" + $f8fd3b4e5f17ffb5$var$capitalizedEvent$jscomp$inline_1531);
}
$f8fd3b4e5f17ffb5$var$registerSimpleEvent($f8fd3b4e5f17ffb5$var$ANIMATION_END, "onAnimationEnd");
$f8fd3b4e5f17ffb5$var$registerSimpleEvent($f8fd3b4e5f17ffb5$var$ANIMATION_ITERATION, "onAnimationIteration");
$f8fd3b4e5f17ffb5$var$registerSimpleEvent($f8fd3b4e5f17ffb5$var$ANIMATION_START, "onAnimationStart");
$f8fd3b4e5f17ffb5$var$registerSimpleEvent("dblclick", "onDoubleClick");
$f8fd3b4e5f17ffb5$var$registerSimpleEvent("focusin", "onFocus");
$f8fd3b4e5f17ffb5$var$registerSimpleEvent("focusout", "onBlur");
$f8fd3b4e5f17ffb5$var$registerSimpleEvent($f8fd3b4e5f17ffb5$var$TRANSITION_RUN, "onTransitionRun");
$f8fd3b4e5f17ffb5$var$registerSimpleEvent($f8fd3b4e5f17ffb5$var$TRANSITION_START, "onTransitionStart");
$f8fd3b4e5f17ffb5$var$registerSimpleEvent($f8fd3b4e5f17ffb5$var$TRANSITION_CANCEL, "onTransitionCancel");
$f8fd3b4e5f17ffb5$var$registerSimpleEvent($f8fd3b4e5f17ffb5$var$TRANSITION_END, "onTransitionEnd");
$f8fd3b4e5f17ffb5$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$f8fd3b4e5f17ffb5$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$f8fd3b4e5f17ffb5$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$f8fd3b4e5f17ffb5$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$f8fd3b4e5f17ffb5$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$f8fd3b4e5f17ffb5$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$f8fd3b4e5f17ffb5$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$f8fd3b4e5f17ffb5$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$f8fd3b4e5f17ffb5$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$f8fd3b4e5f17ffb5$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $f8fd3b4e5f17ffb5$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $f8fd3b4e5f17ffb5$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($f8fd3b4e5f17ffb5$var$mediaEventTypes));
function $f8fd3b4e5f17ffb5$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $f8fd3b4e5f17ffb5$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $f8fd3b4e5f17ffb5$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$f8fd3b4e5f17ffb5$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$f8fd3b4e5f17ffb5$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($f8fd3b4e5f17ffb5$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $f8fd3b4e5f17ffb5$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $f8fd3b4e5f17ffb5$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $f8fd3b4e5f17ffb5$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $f8fd3b4e5f17ffb5$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$f8fd3b4e5f17ffb5$var$listeningMarker]) {
        rootContainerElement[$f8fd3b4e5f17ffb5$var$listeningMarker] = !0;
        $f8fd3b4e5f17ffb5$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($f8fd3b4e5f17ffb5$var$nonDelegatedEvents.has(domEventName) || $f8fd3b4e5f17ffb5$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $f8fd3b4e5f17ffb5$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$f8fd3b4e5f17ffb5$var$listeningMarker] || (ownerDocument[$f8fd3b4e5f17ffb5$var$listeningMarker] = !0, $f8fd3b4e5f17ffb5$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $f8fd3b4e5f17ffb5$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($f8fd3b4e5f17ffb5$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $f8fd3b4e5f17ffb5$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $f8fd3b4e5f17ffb5$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $f8fd3b4e5f17ffb5$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$f8fd3b4e5f17ffb5$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $f8fd3b4e5f17ffb5$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $f8fd3b4e5f17ffb5$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $f8fd3b4e5f17ffb5$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $f8fd3b4e5f17ffb5$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $f8fd3b4e5f17ffb5$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $f8fd3b4e5f17ffb5$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticTouchEvent;
                        break;
                    case $f8fd3b4e5f17ffb5$var$ANIMATION_END:
                    case $f8fd3b4e5f17ffb5$var$ANIMATION_ITERATION:
                    case $f8fd3b4e5f17ffb5$var$ANIMATION_START:
                        SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticAnimationEvent;
                        break;
                    case $f8fd3b4e5f17ffb5$var$TRANSITION_END:
                        SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $f8fd3b4e5f17ffb5$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $f8fd3b4e5f17ffb5$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($f8fd3b4e5f17ffb5$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $f8fd3b4e5f17ffb5$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($f8fd3b4e5f17ffb5$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$f8fd3b4e5f17ffb5$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $f8fd3b4e5f17ffb5$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $f8fd3b4e5f17ffb5$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $f8fd3b4e5f17ffb5$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $f8fd3b4e5f17ffb5$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $f8fd3b4e5f17ffb5$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $f8fd3b4e5f17ffb5$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $f8fd3b4e5f17ffb5$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = SyntheticEventCtor;
                            reactEventName = reactEventType;
                            instance = 0;
                            for(lastHostComponent = inCapturePhase; lastHostComponent; lastHostComponent = $f8fd3b4e5f17ffb5$var$getParent(lastHostComponent))instance++;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = $f8fd3b4e5f17ffb5$var$getParent(_instance))lastHostComponent++;
                            for(; 0 < instance - lastHostComponent;)inCapturePhase = $f8fd3b4e5f17ffb5$var$getParent(inCapturePhase), instance--;
                            for(; 0 < lastHostComponent - instance;)reactEventName = $f8fd3b4e5f17ffb5$var$getParent(reactEventName), lastHostComponent--;
                            for(; instance--;){
                                if (inCapturePhase === reactEventName || null !== reactEventName && inCapturePhase === reactEventName.alternate) break b;
                                inCapturePhase = $f8fd3b4e5f17ffb5$var$getParent(inCapturePhase);
                                reactEventName = $f8fd3b4e5f17ffb5$var$getParent(reactEventName);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $f8fd3b4e5f17ffb5$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $f8fd3b4e5f17ffb5$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $f8fd3b4e5f17ffb5$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $f8fd3b4e5f17ffb5$var$getTargetInstForChangeEvent;
                else if ($f8fd3b4e5f17ffb5$var$isTextInputElement(reactName)) {
                    if ($f8fd3b4e5f17ffb5$var$isInputEventSupported) getTargetInstFunc = $f8fd3b4e5f17ffb5$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $f8fd3b4e5f17ffb5$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $f8fd3b4e5f17ffb5$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $f8fd3b4e5f17ffb5$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $f8fd3b4e5f17ffb5$var$getTargetInstForChangeEvent) : getTargetInstFunc = $f8fd3b4e5f17ffb5$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $f8fd3b4e5f17ffb5$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $f8fd3b4e5f17ffb5$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $f8fd3b4e5f17ffb5$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($f8fd3b4e5f17ffb5$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $f8fd3b4e5f17ffb5$var$activeElement = handleEventFunc, $f8fd3b4e5f17ffb5$var$activeElementInst = targetInst, $f8fd3b4e5f17ffb5$var$lastSelection = null;
                    break;
                case "focusout":
                    $f8fd3b4e5f17ffb5$var$lastSelection = $f8fd3b4e5f17ffb5$var$activeElementInst = $f8fd3b4e5f17ffb5$var$activeElement = null;
                    break;
                case "mousedown":
                    $f8fd3b4e5f17ffb5$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $f8fd3b4e5f17ffb5$var$mouseDown = !1;
                    $f8fd3b4e5f17ffb5$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($f8fd3b4e5f17ffb5$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $f8fd3b4e5f17ffb5$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($f8fd3b4e5f17ffb5$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $f8fd3b4e5f17ffb5$var$isComposing ? $f8fd3b4e5f17ffb5$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($f8fd3b4e5f17ffb5$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($f8fd3b4e5f17ffb5$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $f8fd3b4e5f17ffb5$var$isComposing && (fallbackData = $f8fd3b4e5f17ffb5$var$getData()) : ($f8fd3b4e5f17ffb5$var$root = nativeEventTarget, $f8fd3b4e5f17ffb5$var$startText = "value" in $f8fd3b4e5f17ffb5$var$root ? $f8fd3b4e5f17ffb5$var$root.value : $f8fd3b4e5f17ffb5$var$root.textContent, $f8fd3b4e5f17ffb5$var$isComposing = !0)), handleEventFunc = $f8fd3b4e5f17ffb5$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $f8fd3b4e5f17ffb5$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $f8fd3b4e5f17ffb5$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $f8fd3b4e5f17ffb5$var$canUseTextInputEvent ? $f8fd3b4e5f17ffb5$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $f8fd3b4e5f17ffb5$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $f8fd3b4e5f17ffb5$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $f8fd3b4e5f17ffb5$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $f8fd3b4e5f17ffb5$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $f8fd3b4e5f17ffb5$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $f8fd3b4e5f17ffb5$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $f8fd3b4e5f17ffb5$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $f8fd3b4e5f17ffb5$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($f8fd3b4e5f17ffb5$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $f8fd3b4e5f17ffb5$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($f8fd3b4e5f17ffb5$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $f8fd3b4e5f17ffb5$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $f8fd3b4e5f17ffb5$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $f8fd3b4e5f17ffb5$var$getListener(target, registrationName), null != stateNode && listeners.unshift($f8fd3b4e5f17ffb5$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $f8fd3b4e5f17ffb5$var$getListener(target, registrationName), null != stateNode && listeners.push($f8fd3b4e5f17ffb5$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $f8fd3b4e5f17ffb5$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $f8fd3b4e5f17ffb5$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $f8fd3b4e5f17ffb5$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($f8fd3b4e5f17ffb5$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($f8fd3b4e5f17ffb5$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $f8fd3b4e5f17ffb5$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $f8fd3b4e5f17ffb5$var$normalizeMarkupForTextOrAttribute(clientText);
    return $f8fd3b4e5f17ffb5$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $f8fd3b4e5f17ffb5$var$noop$1() {}
function $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $f8fd3b4e5f17ffb5$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $f8fd3b4e5f17ffb5$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $f8fd3b4e5f17ffb5$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $f8fd3b4e5f17ffb5$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $f8fd3b4e5f17ffb5$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $f8fd3b4e5f17ffb5$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $f8fd3b4e5f17ffb5$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $f8fd3b4e5f17ffb5$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, "name", props.name, props, null), $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($f8fd3b4e5f17ffb5$var$setProp(domElement, tag, "encType", props.encType, props, null), $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, "method", props.method, props, null), $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $f8fd3b4e5f17ffb5$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $f8fd3b4e5f17ffb5$var$noop$1);
            break;
        case "onScroll":
            null != value && $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $f8fd3b4e5f17ffb5$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("toggle", domElement);
            $f8fd3b4e5f17ffb5$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $f8fd3b4e5f17ffb5$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $f8fd3b4e5f17ffb5$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $f8fd3b4e5f17ffb5$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $f8fd3b4e5f17ffb5$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $f8fd3b4e5f17ffb5$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $f8fd3b4e5f17ffb5$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $f8fd3b4e5f17ffb5$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $f8fd3b4e5f17ffb5$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $f8fd3b4e5f17ffb5$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $f8fd3b4e5f17ffb5$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $f8fd3b4e5f17ffb5$var$aliases.get(key) || key, $f8fd3b4e5f17ffb5$var$setValueForAttribute(domElement, key, value);
    }
}
function $f8fd3b4e5f17ffb5$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $f8fd3b4e5f17ffb5$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $f8fd3b4e5f17ffb5$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $f8fd3b4e5f17ffb5$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $f8fd3b4e5f17ffb5$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$f8fd3b4e5f17ffb5$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$f8fd3b4e5f17ffb5$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $f8fd3b4e5f17ffb5$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $f8fd3b4e5f17ffb5$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("error", domElement);
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(137, tag));
                    default:
                        $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$188 = props[hasSrc];
                if (null != propValue$188) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$188;
                        break;
                    case "type":
                        propValue = propValue$188;
                        break;
                    case "checked":
                        checked = propValue$188;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$188;
                        break;
                    case "value":
                        propKey = propValue$188;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$188;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$188) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, hasSrc, propValue$188, props, null);
                }
            }
            $f8fd3b4e5f17ffb5$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            $f8fd3b4e5f17ffb5$var$track(domElement);
            return;
        case "select":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $f8fd3b4e5f17ffb5$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $f8fd3b4e5f17ffb5$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(91));
                    break;
                default:
                    $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $f8fd3b4e5f17ffb5$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            $f8fd3b4e5f17ffb5$var$track(domElement);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("toggle", domElement);
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("cancel", domElement);
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $f8fd3b4e5f17ffb5$var$mediaEventTypes.length; hasSrc++)$f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent($f8fd3b4e5f17ffb5$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("error", domElement);
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("error", domElement), $f8fd3b4e5f17ffb5$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(137, tag));
                default:
                    $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($f8fd3b4e5f17ffb5$var$isCustomElement(tag)) {
                for(propValue$188 in props)props.hasOwnProperty(propValue$188) && (hasSrc = props[propValue$188], void 0 !== hasSrc && $f8fd3b4e5f17ffb5$var$setPropOnCustomElement(domElement, tag, propValue$188, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $f8fd3b4e5f17ffb5$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$205 in nextProps){
                var propKey = nextProps[propKey$205];
                lastProp = lastProps[propKey$205];
                if (nextProps.hasOwnProperty(propKey$205) && (null != propKey || null != lastProp)) switch(propKey$205){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, propKey$205, propKey, nextProps, lastProp);
                }
            }
            $f8fd3b4e5f17ffb5$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$205 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$205 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$205 ? $f8fd3b4e5f17ffb5$var$updateOptions(domElement, !!lastProps, propKey$205, !1) : !!nextProps !== !!lastProps && (null != tag ? $f8fd3b4e5f17ffb5$var$updateOptions(domElement, !!lastProps, tag, !0) : $f8fd3b4e5f17ffb5$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$205 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$205 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $f8fd3b4e5f17ffb5$var$updateTextarea(domElement, propKey$205, propKey);
            return;
        case "option":
            for(var propKey$221 in lastProps)if (propKey$205 = lastProps[propKey$221], lastProps.hasOwnProperty(propKey$221) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$221)) switch(propKey$221){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, propKey$221, null, nextProps, propKey$205);
            }
            for(lastDefaultValue in nextProps)if (propKey$205 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$205 && "function" !== typeof propKey$205 && "symbol" !== typeof propKey$205;
                    break;
                default:
                    $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, lastDefaultValue, propKey$205, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$226 in lastProps)propKey$205 = lastProps[propKey$226], lastProps.hasOwnProperty(propKey$226) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$226) && $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, propKey$226, null, nextProps, propKey$205);
            for(checked in nextProps)if (propKey$205 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$205 !== propKey && (null != propKey$205 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$205) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, checked, propKey$205, nextProps, propKey);
            }
            return;
        default:
            if ($f8fd3b4e5f17ffb5$var$isCustomElement(tag)) {
                for(var propKey$231 in lastProps)propKey$205 = lastProps[propKey$231], lastProps.hasOwnProperty(propKey$231) && void 0 !== propKey$205 && !nextProps.hasOwnProperty(propKey$231) && $f8fd3b4e5f17ffb5$var$setPropOnCustomElement(domElement, tag, propKey$231, void 0, nextProps, propKey$205);
                for(defaultChecked in nextProps)propKey$205 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$205 === propKey || void 0 === propKey$205 && void 0 === propKey || $f8fd3b4e5f17ffb5$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$205, nextProps, propKey);
                return;
            }
    }
    for(var propKey$236 in lastProps)propKey$205 = lastProps[propKey$236], lastProps.hasOwnProperty(propKey$236) && null != propKey$205 && !nextProps.hasOwnProperty(propKey$236) && $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, propKey$236, null, nextProps, propKey$205);
    for(lastProp in nextProps)propKey$205 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$205 === propKey || null == propKey$205 && null == propKey || $f8fd3b4e5f17ffb5$var$setProp(domElement, tag, lastProp, propKey$205, nextProps, propKey);
}
var $f8fd3b4e5f17ffb5$var$eventsEnabled = null, $f8fd3b4e5f17ffb5$var$selectionInformation = null;
function $f8fd3b4e5f17ffb5$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $f8fd3b4e5f17ffb5$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $f8fd3b4e5f17ffb5$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $f8fd3b4e5f17ffb5$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $f8fd3b4e5f17ffb5$var$currentPopstateTransitionEvent = null;
function $f8fd3b4e5f17ffb5$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $f8fd3b4e5f17ffb5$var$currentPopstateTransitionEvent) return !1;
        $f8fd3b4e5f17ffb5$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $f8fd3b4e5f17ffb5$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $f8fd3b4e5f17ffb5$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $f8fd3b4e5f17ffb5$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $f8fd3b4e5f17ffb5$var$localPromise = "function" === typeof Promise ? Promise : void 0, $f8fd3b4e5f17ffb5$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $f8fd3b4e5f17ffb5$var$localPromise ? function(callback) {
    return $f8fd3b4e5f17ffb5$var$localPromise.resolve(null).then(callback).catch($f8fd3b4e5f17ffb5$var$handleErrorInNextTick);
} : $f8fd3b4e5f17ffb5$var$scheduleTimeout;
function $f8fd3b4e5f17ffb5$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $f8fd3b4e5f17ffb5$var$isSingletonScope(type) {
    return "head" === type;
}
function $f8fd3b4e5f17ffb5$var$clearSuspenseBoundary(parentInstance, suspenseInstance) {
    var node = suspenseInstance, possiblePreambleContribution = 0, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 < possiblePreambleContribution && 8 > possiblePreambleContribution) {
                    node = possiblePreambleContribution;
                    var ownerDocument = parentInstance.ownerDocument;
                    node & 1 && $f8fd3b4e5f17ffb5$var$releaseSingletonInstance(ownerDocument.documentElement);
                    node & 2 && $f8fd3b4e5f17ffb5$var$releaseSingletonInstance(ownerDocument.body);
                    if (node & 4) for(node = ownerDocument.head, $f8fd3b4e5f17ffb5$var$releaseSingletonInstance(node), ownerDocument = node.firstChild; ownerDocument;){
                        var nextNode$jscomp$0 = ownerDocument.nextSibling, nodeName = ownerDocument.nodeName;
                        ownerDocument[$f8fd3b4e5f17ffb5$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === ownerDocument.rel.toLowerCase() || node.removeChild(ownerDocument);
                        ownerDocument = nextNode$jscomp$0;
                    }
                }
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $f8fd3b4e5f17ffb5$var$retryIfBlockedOn(suspenseInstance);
                    return;
                }
                depth--;
            } else "$" === node || "$?" === node || "$!" === node ? depth++ : possiblePreambleContribution = node.charCodeAt(0) - 48;
        } else possiblePreambleContribution = 0;
        node = nextNode;
    }while (node);
    $f8fd3b4e5f17ffb5$var$retryIfBlockedOn(suspenseInstance);
}
function $f8fd3b4e5f17ffb5$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $f8fd3b4e5f17ffb5$var$clearContainerSparingly(node);
                $f8fd3b4e5f17ffb5$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $f8fd3b4e5f17ffb5$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$f8fd3b4e5f17ffb5$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $f8fd3b4e5f17ffb5$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $f8fd3b4e5f17ffb5$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $f8fd3b4e5f17ffb5$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $f8fd3b4e5f17ffb5$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "complete" === instance.ownerDocument.readyState;
}
function $f8fd3b4e5f17ffb5$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$?" !== instance.data || "complete" === ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $f8fd3b4e5f17ffb5$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType) return null;
        }
    }
    return node;
}
var $f8fd3b4e5f17ffb5$var$previousHydratableOnEnteringScopedSingleton = null;
function $f8fd3b4e5f17ffb5$var$getParentSuspenseInstance(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" === data && depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $f8fd3b4e5f17ffb5$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $f8fd3b4e5f17ffb5$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(451));
    }
}
function $f8fd3b4e5f17ffb5$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $f8fd3b4e5f17ffb5$var$detachDeletedInstance(instance);
}
var $f8fd3b4e5f17ffb5$var$preloadPropsMap = new Map(), $f8fd3b4e5f17ffb5$var$preconnectsSet = new Set();
function $f8fd3b4e5f17ffb5$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $f8fd3b4e5f17ffb5$var$previousDispatcher = $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.d;
$f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.d = {
    f: $f8fd3b4e5f17ffb5$var$flushSyncWork,
    r: $f8fd3b4e5f17ffb5$var$requestFormReset,
    D: $f8fd3b4e5f17ffb5$var$prefetchDNS,
    C: $f8fd3b4e5f17ffb5$var$preconnect,
    L: $f8fd3b4e5f17ffb5$var$preload,
    m: $f8fd3b4e5f17ffb5$var$preloadModule,
    X: $f8fd3b4e5f17ffb5$var$preinitScript,
    S: $f8fd3b4e5f17ffb5$var$preinitStyle,
    M: $f8fd3b4e5f17ffb5$var$preinitModuleScript
};
function $f8fd3b4e5f17ffb5$var$flushSyncWork() {
    var previousWasRendering = $f8fd3b4e5f17ffb5$var$previousDispatcher.f(), wasRendering = $f8fd3b4e5f17ffb5$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $f8fd3b4e5f17ffb5$var$requestFormReset(form) {
    var formInst = $f8fd3b4e5f17ffb5$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $f8fd3b4e5f17ffb5$var$requestFormReset$1(formInst) : $f8fd3b4e5f17ffb5$var$previousDispatcher.r(form);
}
var $f8fd3b4e5f17ffb5$var$globalDocument = "undefined" === typeof document ? null : document;
function $f8fd3b4e5f17ffb5$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $f8fd3b4e5f17ffb5$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $f8fd3b4e5f17ffb5$var$preconnectsSet.has(limitedEscapedHref) || ($f8fd3b4e5f17ffb5$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $f8fd3b4e5f17ffb5$var$setInitialProperties(href, "link", rel), $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $f8fd3b4e5f17ffb5$var$prefetchDNS(href) {
    $f8fd3b4e5f17ffb5$var$previousDispatcher.D(href);
    $f8fd3b4e5f17ffb5$var$preconnectAs("dns-prefetch", href, null);
}
function $f8fd3b4e5f17ffb5$var$preconnect(href, crossOrigin) {
    $f8fd3b4e5f17ffb5$var$previousDispatcher.C(href, crossOrigin);
    $f8fd3b4e5f17ffb5$var$preconnectAs("preconnect", href, crossOrigin);
}
function $f8fd3b4e5f17ffb5$var$preload(href, as, options) {
    $f8fd3b4e5f17ffb5$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $f8fd3b4e5f17ffb5$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $f8fd3b4e5f17ffb5$var$getStyleKey(href);
                break;
            case "script":
                key = $f8fd3b4e5f17ffb5$var$getScriptKey(href);
        }
        $f8fd3b4e5f17ffb5$var$preloadPropsMap.has(key) || (href = $f8fd3b4e5f17ffb5$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $f8fd3b4e5f17ffb5$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($f8fd3b4e5f17ffb5$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($f8fd3b4e5f17ffb5$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $f8fd3b4e5f17ffb5$var$setInitialProperties(as, "link", href), $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $f8fd3b4e5f17ffb5$var$preloadModule(href, options) {
    $f8fd3b4e5f17ffb5$var$previousDispatcher.m(href, options);
    var ownerDocument = $f8fd3b4e5f17ffb5$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $f8fd3b4e5f17ffb5$var$getScriptKey(href);
        }
        if (!$f8fd3b4e5f17ffb5$var$preloadPropsMap.has(key) && (href = $f8fd3b4e5f17ffb5$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $f8fd3b4e5f17ffb5$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($f8fd3b4e5f17ffb5$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $f8fd3b4e5f17ffb5$var$setInitialProperties(as, "link", href);
            $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $f8fd3b4e5f17ffb5$var$preinitStyle(href, precedence, options) {
    $f8fd3b4e5f17ffb5$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $f8fd3b4e5f17ffb5$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $f8fd3b4e5f17ffb5$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $f8fd3b4e5f17ffb5$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($f8fd3b4e5f17ffb5$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $f8fd3b4e5f17ffb5$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $f8fd3b4e5f17ffb5$var$preloadPropsMap.get(key)) && $f8fd3b4e5f17ffb5$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(link);
                $f8fd3b4e5f17ffb5$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $f8fd3b4e5f17ffb5$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $f8fd3b4e5f17ffb5$var$preinitScript(src, options) {
    $f8fd3b4e5f17ffb5$var$previousDispatcher.X(src, options);
    var ownerDocument = $f8fd3b4e5f17ffb5$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $f8fd3b4e5f17ffb5$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $f8fd3b4e5f17ffb5$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($f8fd3b4e5f17ffb5$var$getScriptSelectorFromKey(key)), resource || (src = $f8fd3b4e5f17ffb5$var$assign({
            src: src,
            async: !0
        }, options), (options = $f8fd3b4e5f17ffb5$var$preloadPropsMap.get(key)) && $f8fd3b4e5f17ffb5$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(resource), $f8fd3b4e5f17ffb5$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $f8fd3b4e5f17ffb5$var$preinitModuleScript(src, options) {
    $f8fd3b4e5f17ffb5$var$previousDispatcher.M(src, options);
    var ownerDocument = $f8fd3b4e5f17ffb5$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $f8fd3b4e5f17ffb5$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $f8fd3b4e5f17ffb5$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($f8fd3b4e5f17ffb5$var$getScriptSelectorFromKey(key)), resource || (src = $f8fd3b4e5f17ffb5$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $f8fd3b4e5f17ffb5$var$preloadPropsMap.get(key)) && $f8fd3b4e5f17ffb5$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(resource), $f8fd3b4e5f17ffb5$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $f8fd3b4e5f17ffb5$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $f8fd3b4e5f17ffb5$var$rootInstanceStackCursor.current) ? $f8fd3b4e5f17ffb5$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $f8fd3b4e5f17ffb5$var$getStyleKey(pendingProps.href), pendingProps = $f8fd3b4e5f17ffb5$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $f8fd3b4e5f17ffb5$var$getStyleKey(pendingProps.href);
                var styles$244 = $f8fd3b4e5f17ffb5$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$245 = styles$244.get(type);
                resource$245 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$245 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$244.set(type, resource$245), (styles$244 = JSCompiler_inline_result.querySelector($f8fd3b4e5f17ffb5$var$getStylesheetSelectorFromKey(type))) && !styles$244._p && (resource$245.instance = styles$244, resource$245.state.loading = 5), $f8fd3b4e5f17ffb5$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $f8fd3b4e5f17ffb5$var$preloadPropsMap.set(type, pendingProps), styles$244 || $f8fd3b4e5f17ffb5$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$245.state)));
                if (currentProps && null === currentResource) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(528, ""));
                return resource$245;
            }
            if (currentProps && null !== currentResource) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $f8fd3b4e5f17ffb5$var$getScriptKey(pendingProps), pendingProps = $f8fd3b4e5f17ffb5$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(444, type));
    }
}
function $f8fd3b4e5f17ffb5$var$getStyleKey(href) {
    return 'href="' + $f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $f8fd3b4e5f17ffb5$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $f8fd3b4e5f17ffb5$var$stylesheetPropsFromRawProps(rawProps) {
    return $f8fd3b4e5f17ffb5$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $f8fd3b4e5f17ffb5$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $f8fd3b4e5f17ffb5$var$setInitialProperties(key, "link", preloadProps), $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $f8fd3b4e5f17ffb5$var$getScriptKey(src) {
    return '[src="' + $f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $f8fd3b4e5f17ffb5$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $f8fd3b4e5f17ffb5$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $f8fd3b4e5f17ffb5$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(instance), instance;
            var styleProps = $f8fd3b4e5f17ffb5$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(instance);
            $f8fd3b4e5f17ffb5$var$setInitialProperties(instance, "style", styleProps);
            $f8fd3b4e5f17ffb5$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $f8fd3b4e5f17ffb5$var$getStyleKey(props.href);
            var instance$250 = hoistableRoot.querySelector($f8fd3b4e5f17ffb5$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$250) return resource.state.loading |= 4, resource.instance = instance$250, $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(instance$250), instance$250;
            instance = $f8fd3b4e5f17ffb5$var$stylesheetPropsFromRawProps(props);
            (styleProps = $f8fd3b4e5f17ffb5$var$preloadPropsMap.get(styleProps)) && $f8fd3b4e5f17ffb5$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$250 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(instance$250);
            var linkInstance = instance$250;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $f8fd3b4e5f17ffb5$var$setInitialProperties(instance$250, "link", instance);
            resource.state.loading |= 4;
            $f8fd3b4e5f17ffb5$var$insertStylesheet(instance$250, props.precedence, hoistableRoot);
            return resource.instance = instance$250;
        case "script":
            instance$250 = $f8fd3b4e5f17ffb5$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($f8fd3b4e5f17ffb5$var$getScriptSelectorFromKey(instance$250))) return resource.instance = styleProps, $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $f8fd3b4e5f17ffb5$var$preloadPropsMap.get(instance$250)) instance = $f8fd3b4e5f17ffb5$var$assign({}, props), $f8fd3b4e5f17ffb5$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(styleProps);
            $f8fd3b4e5f17ffb5$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $f8fd3b4e5f17ffb5$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $f8fd3b4e5f17ffb5$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $f8fd3b4e5f17ffb5$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $f8fd3b4e5f17ffb5$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $f8fd3b4e5f17ffb5$var$tagCaches = null;
function $f8fd3b4e5f17ffb5$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $f8fd3b4e5f17ffb5$var$tagCaches) {
        var cache = new Map();
        var caches = $f8fd3b4e5f17ffb5$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $f8fd3b4e5f17ffb5$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$f8fd3b4e5f17ffb5$var$internalHoistableMarker] || node[$f8fd3b4e5f17ffb5$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $f8fd3b4e5f17ffb5$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $f8fd3b4e5f17ffb5$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $f8fd3b4e5f17ffb5$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
var $f8fd3b4e5f17ffb5$var$suspendedState = null;
function $f8fd3b4e5f17ffb5$var$noop() {}
function $f8fd3b4e5f17ffb5$var$suspendResource(hoistableRoot, resource, props) {
    if (null === $f8fd3b4e5f17ffb5$var$suspendedState) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(475));
    var state = $f8fd3b4e5f17ffb5$var$suspendedState;
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $f8fd3b4e5f17ffb5$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($f8fd3b4e5f17ffb5$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $f8fd3b4e5f17ffb5$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $f8fd3b4e5f17ffb5$var$stylesheetPropsFromRawProps(props);
            (key = $f8fd3b4e5f17ffb5$var$preloadPropsMap.get(key)) && $f8fd3b4e5f17ffb5$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $f8fd3b4e5f17ffb5$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $f8fd3b4e5f17ffb5$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $f8fd3b4e5f17ffb5$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
function $f8fd3b4e5f17ffb5$var$waitForCommitToBeReady() {
    if (null === $f8fd3b4e5f17ffb5$var$suspendedState) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(475));
    var state = $f8fd3b4e5f17ffb5$var$suspendedState;
    state.stylesheets && 0 === state.count && $f8fd3b4e5f17ffb5$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $f8fd3b4e5f17ffb5$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
        };
    } : null;
}
function $f8fd3b4e5f17ffb5$var$onUnsuspend() {
    this.count--;
    if (0 === this.count) {
        if (this.stylesheets) $f8fd3b4e5f17ffb5$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $f8fd3b4e5f17ffb5$var$precedencesByRoot = null;
function $f8fd3b4e5f17ffb5$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $f8fd3b4e5f17ffb5$var$precedencesByRoot = new Map(), resources.forEach($f8fd3b4e5f17ffb5$var$insertStylesheetIntoRoot, state), $f8fd3b4e5f17ffb5$var$precedencesByRoot = null, $f8fd3b4e5f17ffb5$var$onUnsuspend.call(state));
}
function $f8fd3b4e5f17ffb5$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $f8fd3b4e5f17ffb5$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $f8fd3b4e5f17ffb5$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $f8fd3b4e5f17ffb5$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $f8fd3b4e5f17ffb5$var$HostTransitionContext = {
    $$typeof: $f8fd3b4e5f17ffb5$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $f8fd3b4e5f17ffb5$var$sharedNotPendingObject,
    _currentValue2: $f8fd3b4e5f17ffb5$var$sharedNotPendingObject,
    _threadCount: 0
};
function $f8fd3b4e5f17ffb5$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $f8fd3b4e5f17ffb5$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $f8fd3b4e5f17ffb5$var$createLaneMap(0);
    this.hiddenUpdates = $f8fd3b4e5f17ffb5$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $f8fd3b4e5f17ffb5$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
    containerInfo = new $f8fd3b4e5f17ffb5$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $f8fd3b4e5f17ffb5$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $f8fd3b4e5f17ffb5$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $f8fd3b4e5f17ffb5$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $f8fd3b4e5f17ffb5$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $f8fd3b4e5f17ffb5$var$emptyContextObject;
    parentComponent = $f8fd3b4e5f17ffb5$var$emptyContextObject;
    return parentComponent;
}
function $f8fd3b4e5f17ffb5$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $f8fd3b4e5f17ffb5$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $f8fd3b4e5f17ffb5$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $f8fd3b4e5f17ffb5$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($f8fd3b4e5f17ffb5$var$scheduleUpdateOnFiber(element, rootFiber, lane), $f8fd3b4e5f17ffb5$var$entangleTransitions(element, rootFiber, lane));
}
function $f8fd3b4e5f17ffb5$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $f8fd3b4e5f17ffb5$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $f8fd3b4e5f17ffb5$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $f8fd3b4e5f17ffb5$var$markRetryLaneImpl(fiber, retryLane);
}
function $f8fd3b4e5f17ffb5$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag) {
        var root = $f8fd3b4e5f17ffb5$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $f8fd3b4e5f17ffb5$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $f8fd3b4e5f17ffb5$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
var $f8fd3b4e5f17ffb5$var$_enabled = !0;
function $f8fd3b4e5f17ffb5$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T;
    $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = null;
    var previousPriority = $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p;
    try {
        $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = 2, $f8fd3b4e5f17ffb5$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = previousPriority, $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = prevTransition;
    }
}
function $f8fd3b4e5f17ffb5$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T;
    $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = null;
    var previousPriority = $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p;
    try {
        $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = 8, $f8fd3b4e5f17ffb5$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.p = previousPriority, $f8fd3b4e5f17ffb5$var$ReactSharedInternals.T = prevTransition;
    }
}
function $f8fd3b4e5f17ffb5$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($f8fd3b4e5f17ffb5$var$_enabled) {
        var blockedOn = $f8fd3b4e5f17ffb5$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $f8fd3b4e5f17ffb5$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $f8fd3b4e5f17ffb5$var$return_targetInst, targetContainer), $f8fd3b4e5f17ffb5$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($f8fd3b4e5f17ffb5$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($f8fd3b4e5f17ffb5$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $f8fd3b4e5f17ffb5$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $f8fd3b4e5f17ffb5$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $f8fd3b4e5f17ffb5$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $f8fd3b4e5f17ffb5$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $f8fd3b4e5f17ffb5$var$ensureRootIsScheduled(fiber);
                                0 === ($f8fd3b4e5f17ffb5$var$executionContext & 6) && ($f8fd3b4e5f17ffb5$var$workInProgressRootRenderTargetTime = $f8fd3b4e5f17ffb5$var$now() + 500, $f8fd3b4e5f17ffb5$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 13:
                        root = $f8fd3b4e5f17ffb5$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $f8fd3b4e5f17ffb5$var$scheduleUpdateOnFiber(root, fiber, 2), $f8fd3b4e5f17ffb5$var$flushSyncWork$1(), $f8fd3b4e5f17ffb5$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $f8fd3b4e5f17ffb5$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $f8fd3b4e5f17ffb5$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $f8fd3b4e5f17ffb5$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $f8fd3b4e5f17ffb5$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $f8fd3b4e5f17ffb5$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $f8fd3b4e5f17ffb5$var$getEventTarget(nativeEvent);
    return $f8fd3b4e5f17ffb5$var$findInstanceBlockingTarget(nativeEvent);
}
var $f8fd3b4e5f17ffb5$var$return_targetInst = null;
function $f8fd3b4e5f17ffb5$var$findInstanceBlockingTarget(targetNode) {
    $f8fd3b4e5f17ffb5$var$return_targetInst = null;
    targetNode = $f8fd3b4e5f17ffb5$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $f8fd3b4e5f17ffb5$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $f8fd3b4e5f17ffb5$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $f8fd3b4e5f17ffb5$var$return_targetInst = targetNode;
    return null;
}
function $f8fd3b4e5f17ffb5$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($f8fd3b4e5f17ffb5$var$getCurrentPriorityLevel()){
                case $f8fd3b4e5f17ffb5$var$ImmediatePriority:
                    return 2;
                case $f8fd3b4e5f17ffb5$var$UserBlockingPriority:
                    return 8;
                case $f8fd3b4e5f17ffb5$var$NormalPriority$1:
                case $f8fd3b4e5f17ffb5$var$LowPriority:
                    return 32;
                case $f8fd3b4e5f17ffb5$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $f8fd3b4e5f17ffb5$var$hasScheduledReplayAttempt = !1, $f8fd3b4e5f17ffb5$var$queuedFocus = null, $f8fd3b4e5f17ffb5$var$queuedDrag = null, $f8fd3b4e5f17ffb5$var$queuedMouse = null, $f8fd3b4e5f17ffb5$var$queuedPointers = new Map(), $f8fd3b4e5f17ffb5$var$queuedPointerCaptures = new Map(), $f8fd3b4e5f17ffb5$var$queuedExplicitHydrationTargets = [], $f8fd3b4e5f17ffb5$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $f8fd3b4e5f17ffb5$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $f8fd3b4e5f17ffb5$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $f8fd3b4e5f17ffb5$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $f8fd3b4e5f17ffb5$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $f8fd3b4e5f17ffb5$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $f8fd3b4e5f17ffb5$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $f8fd3b4e5f17ffb5$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $f8fd3b4e5f17ffb5$var$getInstanceFromNode(blockedOn), null !== blockedOn && $f8fd3b4e5f17ffb5$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $f8fd3b4e5f17ffb5$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $f8fd3b4e5f17ffb5$var$queuedFocus = $f8fd3b4e5f17ffb5$var$accumulateOrCreateContinuousQueuedReplayableEvent($f8fd3b4e5f17ffb5$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $f8fd3b4e5f17ffb5$var$queuedDrag = $f8fd3b4e5f17ffb5$var$accumulateOrCreateContinuousQueuedReplayableEvent($f8fd3b4e5f17ffb5$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $f8fd3b4e5f17ffb5$var$queuedMouse = $f8fd3b4e5f17ffb5$var$accumulateOrCreateContinuousQueuedReplayableEvent($f8fd3b4e5f17ffb5$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $f8fd3b4e5f17ffb5$var$queuedPointers.set(pointerId, $f8fd3b4e5f17ffb5$var$accumulateOrCreateContinuousQueuedReplayableEvent($f8fd3b4e5f17ffb5$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $f8fd3b4e5f17ffb5$var$queuedPointerCaptures.set(pointerId, $f8fd3b4e5f17ffb5$var$accumulateOrCreateContinuousQueuedReplayableEvent($f8fd3b4e5f17ffb5$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $f8fd3b4e5f17ffb5$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $f8fd3b4e5f17ffb5$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $f8fd3b4e5f17ffb5$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $f8fd3b4e5f17ffb5$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $f8fd3b4e5f17ffb5$var$runWithPriority(queuedTarget.priority, function() {
                        if (13 === nearestMounted.tag) {
                            var lane = $f8fd3b4e5f17ffb5$var$requestUpdateLane();
                            lane = $f8fd3b4e5f17ffb5$var$getBumpedLaneForHydrationByLane(lane);
                            var root = $f8fd3b4e5f17ffb5$var$enqueueConcurrentRenderForLane(nearestMounted, lane);
                            null !== root && $f8fd3b4e5f17ffb5$var$scheduleUpdateOnFiber(root, nearestMounted, lane);
                            $f8fd3b4e5f17ffb5$var$markRetryLaneIfNotHydrated(nearestMounted, lane);
                        }
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $f8fd3b4e5f17ffb5$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $f8fd3b4e5f17ffb5$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $f8fd3b4e5f17ffb5$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $f8fd3b4e5f17ffb5$var$currentReplayingEvent = null;
        } else return targetContainers = $f8fd3b4e5f17ffb5$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $f8fd3b4e5f17ffb5$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $f8fd3b4e5f17ffb5$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $f8fd3b4e5f17ffb5$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $f8fd3b4e5f17ffb5$var$replayUnblockedEvents() {
    $f8fd3b4e5f17ffb5$var$hasScheduledReplayAttempt = !1;
    null !== $f8fd3b4e5f17ffb5$var$queuedFocus && $f8fd3b4e5f17ffb5$var$attemptReplayContinuousQueuedEvent($f8fd3b4e5f17ffb5$var$queuedFocus) && ($f8fd3b4e5f17ffb5$var$queuedFocus = null);
    null !== $f8fd3b4e5f17ffb5$var$queuedDrag && $f8fd3b4e5f17ffb5$var$attemptReplayContinuousQueuedEvent($f8fd3b4e5f17ffb5$var$queuedDrag) && ($f8fd3b4e5f17ffb5$var$queuedDrag = null);
    null !== $f8fd3b4e5f17ffb5$var$queuedMouse && $f8fd3b4e5f17ffb5$var$attemptReplayContinuousQueuedEvent($f8fd3b4e5f17ffb5$var$queuedMouse) && ($f8fd3b4e5f17ffb5$var$queuedMouse = null);
    $f8fd3b4e5f17ffb5$var$queuedPointers.forEach($f8fd3b4e5f17ffb5$var$attemptReplayContinuousQueuedEventInMap);
    $f8fd3b4e5f17ffb5$var$queuedPointerCaptures.forEach($f8fd3b4e5f17ffb5$var$attemptReplayContinuousQueuedEventInMap);
}
function $f8fd3b4e5f17ffb5$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $f8fd3b4e5f17ffb5$var$hasScheduledReplayAttempt || ($f8fd3b4e5f17ffb5$var$hasScheduledReplayAttempt = !0, $hNfVH.unstable_scheduleCallback($hNfVH.unstable_NormalPriority, $f8fd3b4e5f17ffb5$var$replayUnblockedEvents)));
}
var $f8fd3b4e5f17ffb5$var$lastScheduledReplayQueue = null;
function $f8fd3b4e5f17ffb5$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $f8fd3b4e5f17ffb5$var$lastScheduledReplayQueue !== formReplayingQueue && ($f8fd3b4e5f17ffb5$var$lastScheduledReplayQueue = formReplayingQueue, $hNfVH.unstable_scheduleCallback($hNfVH.unstable_NormalPriority, function() {
        $f8fd3b4e5f17ffb5$var$lastScheduledReplayQueue === formReplayingQueue && ($f8fd3b4e5f17ffb5$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $f8fd3b4e5f17ffb5$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $f8fd3b4e5f17ffb5$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $f8fd3b4e5f17ffb5$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $f8fd3b4e5f17ffb5$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $f8fd3b4e5f17ffb5$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $f8fd3b4e5f17ffb5$var$queuedFocus && $f8fd3b4e5f17ffb5$var$scheduleCallbackIfUnblocked($f8fd3b4e5f17ffb5$var$queuedFocus, unblocked);
    null !== $f8fd3b4e5f17ffb5$var$queuedDrag && $f8fd3b4e5f17ffb5$var$scheduleCallbackIfUnblocked($f8fd3b4e5f17ffb5$var$queuedDrag, unblocked);
    null !== $f8fd3b4e5f17ffb5$var$queuedMouse && $f8fd3b4e5f17ffb5$var$scheduleCallbackIfUnblocked($f8fd3b4e5f17ffb5$var$queuedMouse, unblocked);
    $f8fd3b4e5f17ffb5$var$queuedPointers.forEach(unblock);
    $f8fd3b4e5f17ffb5$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $f8fd3b4e5f17ffb5$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $f8fd3b4e5f17ffb5$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $f8fd3b4e5f17ffb5$var$queuedExplicitHydrationTargets.length && (i = $f8fd3b4e5f17ffb5$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$f8fd3b4e5f17ffb5$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $f8fd3b4e5f17ffb5$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$f8fd3b4e5f17ffb5$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $f8fd3b4e5f17ffb5$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$f8fd3b4e5f17ffb5$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $f8fd3b4e5f17ffb5$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $f8fd3b4e5f17ffb5$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $f8fd3b4e5f17ffb5$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$f8fd3b4e5f17ffb5$var$ReactDOMHydrationRoot.prototype.render = $f8fd3b4e5f17ffb5$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(409));
    var current = root.current, lane = $f8fd3b4e5f17ffb5$var$requestUpdateLane();
    $f8fd3b4e5f17ffb5$var$updateContainerImpl(current, lane, children, root, null, null);
};
$f8fd3b4e5f17ffb5$var$ReactDOMHydrationRoot.prototype.unmount = $f8fd3b4e5f17ffb5$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $f8fd3b4e5f17ffb5$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $f8fd3b4e5f17ffb5$var$flushSyncWork$1();
        container[$f8fd3b4e5f17ffb5$var$internalContainerInstanceKey] = null;
    }
};
function $f8fd3b4e5f17ffb5$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$f8fd3b4e5f17ffb5$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $f8fd3b4e5f17ffb5$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $f8fd3b4e5f17ffb5$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $f8fd3b4e5f17ffb5$var$queuedExplicitHydrationTargets[i].priority; i++);
        $f8fd3b4e5f17ffb5$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $f8fd3b4e5f17ffb5$var$attemptExplicitHydrationTarget(target);
    }
};
var $f8fd3b4e5f17ffb5$var$isomorphicReactPackageVersion$jscomp$inline_1785 = $dNU7X.version;
if ("19.1.1" !== $f8fd3b4e5f17ffb5$var$isomorphicReactPackageVersion$jscomp$inline_1785) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(527, $f8fd3b4e5f17ffb5$var$isomorphicReactPackageVersion$jscomp$inline_1785, "19.1.1"));
$f8fd3b4e5f17ffb5$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $f8fd3b4e5f17ffb5$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $f8fd3b4e5f17ffb5$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $f8fd3b4e5f17ffb5$var$internals$jscomp$inline_2256 = {
    bundleType: 0,
    version: "19.1.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $f8fd3b4e5f17ffb5$var$ReactSharedInternals,
    reconcilerVersion: "19.1.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $f8fd3b4e5f17ffb5$var$hook$jscomp$inline_2257 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$f8fd3b4e5f17ffb5$var$hook$jscomp$inline_2257.isDisabled && $f8fd3b4e5f17ffb5$var$hook$jscomp$inline_2257.supportsFiber) try {
        $f8fd3b4e5f17ffb5$var$rendererID = $f8fd3b4e5f17ffb5$var$hook$jscomp$inline_2257.inject($f8fd3b4e5f17ffb5$var$internals$jscomp$inline_2256), $f8fd3b4e5f17ffb5$var$injectedHook = $f8fd3b4e5f17ffb5$var$hook$jscomp$inline_2257;
    } catch (err) {}
}
$f8fd3b4e5f17ffb5$export$882461b6382ed46c = function(container, options) {
    if (!$f8fd3b4e5f17ffb5$var$isValidContainer(container)) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $f8fd3b4e5f17ffb5$var$defaultOnUncaughtError, onCaughtError = $f8fd3b4e5f17ffb5$var$defaultOnCaughtError, onRecoverableError = $f8fd3b4e5f17ffb5$var$defaultOnRecoverableError, transitionCallbacks = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks));
    options = $f8fd3b4e5f17ffb5$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    container[$f8fd3b4e5f17ffb5$var$internalContainerInstanceKey] = options.current;
    $f8fd3b4e5f17ffb5$var$listenToAllSupportedEvents(container);
    return new $f8fd3b4e5f17ffb5$var$ReactDOMRoot(options);
};
$f8fd3b4e5f17ffb5$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$f8fd3b4e5f17ffb5$var$isValidContainer(container)) throw Error($f8fd3b4e5f17ffb5$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $f8fd3b4e5f17ffb5$var$defaultOnUncaughtError, onCaughtError = $f8fd3b4e5f17ffb5$var$defaultOnCaughtError, onRecoverableError = $f8fd3b4e5f17ffb5$var$defaultOnRecoverableError, transitionCallbacks = null, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.unstable_transitionCallbacks && (transitionCallbacks = options.unstable_transitionCallbacks), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $f8fd3b4e5f17ffb5$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
    initialChildren.context = $f8fd3b4e5f17ffb5$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $f8fd3b4e5f17ffb5$var$requestUpdateLane();
    isStrictMode = $f8fd3b4e5f17ffb5$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $f8fd3b4e5f17ffb5$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $f8fd3b4e5f17ffb5$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $f8fd3b4e5f17ffb5$var$markRootUpdated$1(initialChildren, options);
    $f8fd3b4e5f17ffb5$var$ensureRootIsScheduled(initialChildren);
    container[$f8fd3b4e5f17ffb5$var$internalContainerInstanceKey] = initialChildren.current;
    $f8fd3b4e5f17ffb5$var$listenToAllSupportedEvents(container);
    return new $f8fd3b4e5f17ffb5$var$ReactDOMHydrationRoot(initialChildren);
};
$f8fd3b4e5f17ffb5$export$83d89fbfd8236492 = "19.1.1";

});
parcelRegister("hNfVH", function(module, exports) {
'use strict';

module.exports = (parcelRequire("k8s7f"));

});
parcelRegister("k8s7f", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $ea8a5d3bfd1fa17f$export$c4744153514ff05d, (v) => $ea8a5d3bfd1fa17f$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $ea8a5d3bfd1fa17f$export$3e506c1ccc9cc1a7, (v) => $ea8a5d3bfd1fa17f$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $ea8a5d3bfd1fa17f$export$e26fe2ed2fa76875, (v) => $ea8a5d3bfd1fa17f$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $ea8a5d3bfd1fa17f$export$502329bbf4b505b1, (v) => $ea8a5d3bfd1fa17f$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $ea8a5d3bfd1fa17f$export$6e3807111c4874c4, (v) => $ea8a5d3bfd1fa17f$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $ea8a5d3bfd1fa17f$export$c27134553091fb3a, (v) => $ea8a5d3bfd1fa17f$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $ea8a5d3bfd1fa17f$export$33ee1acdc04fd2a2, (v) => $ea8a5d3bfd1fa17f$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $ea8a5d3bfd1fa17f$export$b00a404bbd5edef2, (v) => $ea8a5d3bfd1fa17f$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $ea8a5d3bfd1fa17f$export$d66a1c1c77bd778b, (v) => $ea8a5d3bfd1fa17f$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $ea8a5d3bfd1fa17f$export$d3dfb8e4810cb555, (v) => $ea8a5d3bfd1fa17f$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $ea8a5d3bfd1fa17f$export$72fdf0e06517287b, (v) => $ea8a5d3bfd1fa17f$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $ea8a5d3bfd1fa17f$export$816d2913ae6b83b1, (v) => $ea8a5d3bfd1fa17f$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $ea8a5d3bfd1fa17f$export$61bcfe829111a1d0, (v) => $ea8a5d3bfd1fa17f$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $ea8a5d3bfd1fa17f$export$7ee8c9beb337bc3f, (v) => $ea8a5d3bfd1fa17f$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $ea8a5d3bfd1fa17f$export$b5836b71941fa3ed, (v) => $ea8a5d3bfd1fa17f$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $ea8a5d3bfd1fa17f$export$cf845f2c119da08a, (v) => $ea8a5d3bfd1fa17f$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ea8a5d3bfd1fa17f$export$c4744153514ff05d;
var $ea8a5d3bfd1fa17f$export$3e506c1ccc9cc1a7;
var $ea8a5d3bfd1fa17f$export$e26fe2ed2fa76875;
var $ea8a5d3bfd1fa17f$export$502329bbf4b505b1;
var $ea8a5d3bfd1fa17f$export$6e3807111c4874c4;
var $ea8a5d3bfd1fa17f$export$c27134553091fb3a;
var $ea8a5d3bfd1fa17f$export$33ee1acdc04fd2a2;
var $ea8a5d3bfd1fa17f$export$b00a404bbd5edef2;
var $ea8a5d3bfd1fa17f$export$d66a1c1c77bd778b;
var $ea8a5d3bfd1fa17f$export$d3dfb8e4810cb555;
var $ea8a5d3bfd1fa17f$export$72fdf0e06517287b;
var $ea8a5d3bfd1fa17f$export$816d2913ae6b83b1;
var $ea8a5d3bfd1fa17f$export$61bcfe829111a1d0;
var $ea8a5d3bfd1fa17f$export$7ee8c9beb337bc3f;
var $ea8a5d3bfd1fa17f$export$b5836b71941fa3ed;
var $ea8a5d3bfd1fa17f$export$cf845f2c119da08a;
"use strict";
function $ea8a5d3bfd1fa17f$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $ea8a5d3bfd1fa17f$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $ea8a5d3bfd1fa17f$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $ea8a5d3bfd1fa17f$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $ea8a5d3bfd1fa17f$var$compare(left, last)) rightIndex < length && 0 > $ea8a5d3bfd1fa17f$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $ea8a5d3bfd1fa17f$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $ea8a5d3bfd1fa17f$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$ea8a5d3bfd1fa17f$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $ea8a5d3bfd1fa17f$var$localPerformance = performance;
    $ea8a5d3bfd1fa17f$export$c4744153514ff05d = function() {
        return $ea8a5d3bfd1fa17f$var$localPerformance.now();
    };
} else {
    var $ea8a5d3bfd1fa17f$var$localDate = Date, $ea8a5d3bfd1fa17f$var$initialTime = $ea8a5d3bfd1fa17f$var$localDate.now();
    $ea8a5d3bfd1fa17f$export$c4744153514ff05d = function() {
        return $ea8a5d3bfd1fa17f$var$localDate.now() - $ea8a5d3bfd1fa17f$var$initialTime;
    };
}
var $ea8a5d3bfd1fa17f$var$taskQueue = [], $ea8a5d3bfd1fa17f$var$timerQueue = [], $ea8a5d3bfd1fa17f$var$taskIdCounter = 1, $ea8a5d3bfd1fa17f$var$currentTask = null, $ea8a5d3bfd1fa17f$var$currentPriorityLevel = 3, $ea8a5d3bfd1fa17f$var$isPerformingWork = !1, $ea8a5d3bfd1fa17f$var$isHostCallbackScheduled = !1, $ea8a5d3bfd1fa17f$var$isHostTimeoutScheduled = !1, $ea8a5d3bfd1fa17f$var$needsPaint = !1, $ea8a5d3bfd1fa17f$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $ea8a5d3bfd1fa17f$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $ea8a5d3bfd1fa17f$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $ea8a5d3bfd1fa17f$var$advanceTimers(currentTime) {
    for(var timer = $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$timerQueue); null !== timer;){
        if (null === timer.callback) $ea8a5d3bfd1fa17f$var$pop($ea8a5d3bfd1fa17f$var$timerQueue);
        else if (timer.startTime <= currentTime) $ea8a5d3bfd1fa17f$var$pop($ea8a5d3bfd1fa17f$var$timerQueue), timer.sortIndex = timer.expirationTime, $ea8a5d3bfd1fa17f$var$push($ea8a5d3bfd1fa17f$var$taskQueue, timer);
        else break;
        timer = $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$timerQueue);
    }
}
function $ea8a5d3bfd1fa17f$var$handleTimeout(currentTime) {
    $ea8a5d3bfd1fa17f$var$isHostTimeoutScheduled = !1;
    $ea8a5d3bfd1fa17f$var$advanceTimers(currentTime);
    if (!$ea8a5d3bfd1fa17f$var$isHostCallbackScheduled) {
        if (null !== $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$taskQueue)) $ea8a5d3bfd1fa17f$var$isHostCallbackScheduled = !0, $ea8a5d3bfd1fa17f$var$isMessageLoopRunning || ($ea8a5d3bfd1fa17f$var$isMessageLoopRunning = !0, $ea8a5d3bfd1fa17f$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$timerQueue);
            null !== firstTimer && $ea8a5d3bfd1fa17f$var$requestHostTimeout($ea8a5d3bfd1fa17f$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $ea8a5d3bfd1fa17f$var$isMessageLoopRunning = !1, $ea8a5d3bfd1fa17f$var$taskTimeoutID = -1, $ea8a5d3bfd1fa17f$var$frameInterval = 5, $ea8a5d3bfd1fa17f$var$startTime = -1;
function $ea8a5d3bfd1fa17f$var$shouldYieldToHost() {
    return $ea8a5d3bfd1fa17f$var$needsPaint ? !0 : $ea8a5d3bfd1fa17f$export$c4744153514ff05d() - $ea8a5d3bfd1fa17f$var$startTime < $ea8a5d3bfd1fa17f$var$frameInterval ? !1 : !0;
}
function $ea8a5d3bfd1fa17f$var$performWorkUntilDeadline() {
    $ea8a5d3bfd1fa17f$var$needsPaint = !1;
    if ($ea8a5d3bfd1fa17f$var$isMessageLoopRunning) {
        var currentTime = $ea8a5d3bfd1fa17f$export$c4744153514ff05d();
        $ea8a5d3bfd1fa17f$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $ea8a5d3bfd1fa17f$var$isHostCallbackScheduled = !1;
                $ea8a5d3bfd1fa17f$var$isHostTimeoutScheduled && ($ea8a5d3bfd1fa17f$var$isHostTimeoutScheduled = !1, $ea8a5d3bfd1fa17f$var$localClearTimeout($ea8a5d3bfd1fa17f$var$taskTimeoutID), $ea8a5d3bfd1fa17f$var$taskTimeoutID = -1);
                $ea8a5d3bfd1fa17f$var$isPerformingWork = !0;
                var previousPriorityLevel = $ea8a5d3bfd1fa17f$var$currentPriorityLevel;
                try {
                    b: {
                        $ea8a5d3bfd1fa17f$var$advanceTimers(currentTime);
                        for($ea8a5d3bfd1fa17f$var$currentTask = $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$taskQueue); null !== $ea8a5d3bfd1fa17f$var$currentTask && !($ea8a5d3bfd1fa17f$var$currentTask.expirationTime > currentTime && $ea8a5d3bfd1fa17f$var$shouldYieldToHost());){
                            var callback = $ea8a5d3bfd1fa17f$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $ea8a5d3bfd1fa17f$var$currentTask.callback = null;
                                $ea8a5d3bfd1fa17f$var$currentPriorityLevel = $ea8a5d3bfd1fa17f$var$currentTask.priorityLevel;
                                var continuationCallback = callback($ea8a5d3bfd1fa17f$var$currentTask.expirationTime <= currentTime);
                                currentTime = $ea8a5d3bfd1fa17f$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $ea8a5d3bfd1fa17f$var$currentTask.callback = continuationCallback;
                                    $ea8a5d3bfd1fa17f$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $ea8a5d3bfd1fa17f$var$currentTask === $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$taskQueue) && $ea8a5d3bfd1fa17f$var$pop($ea8a5d3bfd1fa17f$var$taskQueue);
                                $ea8a5d3bfd1fa17f$var$advanceTimers(currentTime);
                            } else $ea8a5d3bfd1fa17f$var$pop($ea8a5d3bfd1fa17f$var$taskQueue);
                            $ea8a5d3bfd1fa17f$var$currentTask = $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$taskQueue);
                        }
                        if (null !== $ea8a5d3bfd1fa17f$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$timerQueue);
                            null !== firstTimer && $ea8a5d3bfd1fa17f$var$requestHostTimeout($ea8a5d3bfd1fa17f$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $ea8a5d3bfd1fa17f$var$currentTask = null, $ea8a5d3bfd1fa17f$var$currentPriorityLevel = previousPriorityLevel, $ea8a5d3bfd1fa17f$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $ea8a5d3bfd1fa17f$var$schedulePerformWorkUntilDeadline() : $ea8a5d3bfd1fa17f$var$isMessageLoopRunning = !1;
        }
    }
}
var $ea8a5d3bfd1fa17f$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $ea8a5d3bfd1fa17f$var$localSetImmediate) $ea8a5d3bfd1fa17f$var$schedulePerformWorkUntilDeadline = function() {
    $ea8a5d3bfd1fa17f$var$localSetImmediate($ea8a5d3bfd1fa17f$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $ea8a5d3bfd1fa17f$var$channel = new MessageChannel(), $ea8a5d3bfd1fa17f$var$port = $ea8a5d3bfd1fa17f$var$channel.port2;
    $ea8a5d3bfd1fa17f$var$channel.port1.onmessage = $ea8a5d3bfd1fa17f$var$performWorkUntilDeadline;
    $ea8a5d3bfd1fa17f$var$schedulePerformWorkUntilDeadline = function() {
        $ea8a5d3bfd1fa17f$var$port.postMessage(null);
    };
} else $ea8a5d3bfd1fa17f$var$schedulePerformWorkUntilDeadline = function() {
    $ea8a5d3bfd1fa17f$var$localSetTimeout($ea8a5d3bfd1fa17f$var$performWorkUntilDeadline, 0);
};
function $ea8a5d3bfd1fa17f$var$requestHostTimeout(callback, ms) {
    $ea8a5d3bfd1fa17f$var$taskTimeoutID = $ea8a5d3bfd1fa17f$var$localSetTimeout(function() {
        callback($ea8a5d3bfd1fa17f$export$c4744153514ff05d());
    }, ms);
}
$ea8a5d3bfd1fa17f$export$3e506c1ccc9cc1a7 = 5;
$ea8a5d3bfd1fa17f$export$e26fe2ed2fa76875 = 1;
$ea8a5d3bfd1fa17f$export$502329bbf4b505b1 = 4;
$ea8a5d3bfd1fa17f$export$6e3807111c4874c4 = 3;
$ea8a5d3bfd1fa17f$export$c27134553091fb3a = null;
$ea8a5d3bfd1fa17f$export$33ee1acdc04fd2a2 = 2;
$ea8a5d3bfd1fa17f$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$ea8a5d3bfd1fa17f$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $ea8a5d3bfd1fa17f$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$ea8a5d3bfd1fa17f$export$d3dfb8e4810cb555 = function() {
    return $ea8a5d3bfd1fa17f$var$currentPriorityLevel;
};
$ea8a5d3bfd1fa17f$export$72fdf0e06517287b = function(eventHandler) {
    switch($ea8a5d3bfd1fa17f$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $ea8a5d3bfd1fa17f$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $ea8a5d3bfd1fa17f$var$currentPriorityLevel;
    $ea8a5d3bfd1fa17f$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $ea8a5d3bfd1fa17f$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$ea8a5d3bfd1fa17f$export$816d2913ae6b83b1 = function() {
    $ea8a5d3bfd1fa17f$var$needsPaint = !0;
};
$ea8a5d3bfd1fa17f$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $ea8a5d3bfd1fa17f$var$currentPriorityLevel;
    $ea8a5d3bfd1fa17f$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $ea8a5d3bfd1fa17f$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$ea8a5d3bfd1fa17f$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $ea8a5d3bfd1fa17f$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $ea8a5d3bfd1fa17f$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $ea8a5d3bfd1fa17f$var$push($ea8a5d3bfd1fa17f$var$timerQueue, priorityLevel), null === $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$taskQueue) && priorityLevel === $ea8a5d3bfd1fa17f$var$peek($ea8a5d3bfd1fa17f$var$timerQueue) && ($ea8a5d3bfd1fa17f$var$isHostTimeoutScheduled ? ($ea8a5d3bfd1fa17f$var$localClearTimeout($ea8a5d3bfd1fa17f$var$taskTimeoutID), $ea8a5d3bfd1fa17f$var$taskTimeoutID = -1) : $ea8a5d3bfd1fa17f$var$isHostTimeoutScheduled = !0, $ea8a5d3bfd1fa17f$var$requestHostTimeout($ea8a5d3bfd1fa17f$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $ea8a5d3bfd1fa17f$var$push($ea8a5d3bfd1fa17f$var$taskQueue, priorityLevel), $ea8a5d3bfd1fa17f$var$isHostCallbackScheduled || $ea8a5d3bfd1fa17f$var$isPerformingWork || ($ea8a5d3bfd1fa17f$var$isHostCallbackScheduled = !0, $ea8a5d3bfd1fa17f$var$isMessageLoopRunning || ($ea8a5d3bfd1fa17f$var$isMessageLoopRunning = !0, $ea8a5d3bfd1fa17f$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$ea8a5d3bfd1fa17f$export$b5836b71941fa3ed = $ea8a5d3bfd1fa17f$var$shouldYieldToHost;
$ea8a5d3bfd1fa17f$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $ea8a5d3bfd1fa17f$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $ea8a5d3bfd1fa17f$var$currentPriorityLevel;
        $ea8a5d3bfd1fa17f$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $ea8a5d3bfd1fa17f$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("boCrV", function(module, exports) {
'use strict';
function $84bfc2d503de3ab8$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($84bfc2d503de3ab8$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$84bfc2d503de3ab8$var$checkDCE();

module.exports = (parcelRequire("7oYVV"));

});


parcelRegister("3n3kp", function(module, exports) {

$parcel$export(module.exports, "renderToStaticMarkup", () => $274619feb1928437$export$eb3a06aef9e6ee51, (v) => $274619feb1928437$export$eb3a06aef9e6ee51 = v);
$parcel$export(module.exports, "renderToString", () => $274619feb1928437$export$80e7718417253a51, (v) => $274619feb1928437$export$80e7718417253a51 = v);
$parcel$export(module.exports, "version", () => $274619feb1928437$export$83d89fbfd8236492, (v) => $274619feb1928437$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server-legacy.browser.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*


 JS Implementation of MurmurHash3 (r136) (as of May 20, 2011)

 Copyright (c) 2011 Gary Court
 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in
 all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.
*/ var $274619feb1928437$export$eb3a06aef9e6ee51;
var $274619feb1928437$export$80e7718417253a51;
var $274619feb1928437$export$83d89fbfd8236492;
"use strict";

var $dNU7X = parcelRequire("dNU7X");

var $boCrV = parcelRequire("boCrV");
function $274619feb1928437$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $274619feb1928437$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $274619feb1928437$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $274619feb1928437$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $274619feb1928437$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $274619feb1928437$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $274619feb1928437$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $274619feb1928437$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $274619feb1928437$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $274619feb1928437$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $274619feb1928437$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $274619feb1928437$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $274619feb1928437$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $274619feb1928437$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $274619feb1928437$var$REACT_SCOPE_TYPE = Symbol.for("react.scope"), $274619feb1928437$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $274619feb1928437$var$REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden"), $274619feb1928437$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $274619feb1928437$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $274619feb1928437$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator, $274619feb1928437$var$isArrayImpl = Array.isArray;
function $274619feb1928437$var$murmurhash3_32_gc(key, seed) {
    var remainder = key.length & 3;
    var bytes = key.length - remainder;
    var h1 = seed;
    for(seed = 0; seed < bytes;){
        var k1 = key.charCodeAt(seed) & 255 | (key.charCodeAt(++seed) & 255) << 8 | (key.charCodeAt(++seed) & 255) << 16 | (key.charCodeAt(++seed) & 255) << 24;
        ++seed;
        k1 = 3432918353 * (k1 & 65535) + ((3432918353 * (k1 >>> 16) & 65535) << 16) & 4294967295;
        k1 = k1 << 15 | k1 >>> 17;
        k1 = 461845907 * (k1 & 65535) + ((461845907 * (k1 >>> 16) & 65535) << 16) & 4294967295;
        h1 ^= k1;
        h1 = h1 << 13 | h1 >>> 19;
        h1 = 5 * (h1 & 65535) + ((5 * (h1 >>> 16) & 65535) << 16) & 4294967295;
        h1 = (h1 & 65535) + 27492 + (((h1 >>> 16) + 58964 & 65535) << 16);
    }
    k1 = 0;
    switch(remainder){
        case 3:
            k1 ^= (key.charCodeAt(seed + 2) & 255) << 16;
        case 2:
            k1 ^= (key.charCodeAt(seed + 1) & 255) << 8;
        case 1:
            k1 ^= key.charCodeAt(seed) & 255, k1 = 3432918353 * (k1 & 65535) + ((3432918353 * (k1 >>> 16) & 65535) << 16) & 4294967295, k1 = k1 << 15 | k1 >>> 17, h1 ^= 461845907 * (k1 & 65535) + ((461845907 * (k1 >>> 16) & 65535) << 16) & 4294967295;
    }
    h1 ^= key.length;
    h1 ^= h1 >>> 16;
    h1 = 2246822507 * (h1 & 65535) + ((2246822507 * (h1 >>> 16) & 65535) << 16) & 4294967295;
    h1 ^= h1 >>> 13;
    h1 = 3266489909 * (h1 & 65535) + ((3266489909 * (h1 >>> 16) & 65535) << 16) & 4294967295;
    return (h1 ^ h1 >>> 16) >>> 0;
}
var $274619feb1928437$var$assign = Object.assign, $274619feb1928437$var$hasOwnProperty = Object.prototype.hasOwnProperty, $274619feb1928437$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $274619feb1928437$var$illegalAttributeNameCache = {}, $274619feb1928437$var$validatedAttributeNameCache = {};
function $274619feb1928437$var$isAttributeNameSafe(attributeName) {
    if ($274619feb1928437$var$hasOwnProperty.call($274619feb1928437$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($274619feb1928437$var$hasOwnProperty.call($274619feb1928437$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($274619feb1928437$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $274619feb1928437$var$validatedAttributeNameCache[attributeName] = !0;
    $274619feb1928437$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
var $274619feb1928437$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" ")), $274619feb1928437$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $274619feb1928437$var$matchHtmlRegExp = /["'&<>]/;
function $274619feb1928437$var$escapeTextForBrowser(text) {
    if ("boolean" === typeof text || "number" === typeof text || "bigint" === typeof text) return "" + text;
    text = "" + text;
    var match = $274619feb1928437$var$matchHtmlRegExp.exec(text);
    if (match) {
        var html = "", index, lastIndex = 0;
        for(index = match.index; index < text.length; index++){
            switch(text.charCodeAt(index)){
                case 34:
                    match = "&quot;";
                    break;
                case 38:
                    match = "&amp;";
                    break;
                case 39:
                    match = "&#x27;";
                    break;
                case 60:
                    match = "&lt;";
                    break;
                case 62:
                    match = "&gt;";
                    break;
                default:
                    continue;
            }
            lastIndex !== index && (html += text.slice(lastIndex, index));
            lastIndex = index + 1;
            html += match;
        }
        text = lastIndex !== index ? html + text.slice(lastIndex, index) : html;
    }
    return text;
}
var $274619feb1928437$var$uppercasePattern = /([A-Z])/g, $274619feb1928437$var$msPattern = /^ms-/, $274619feb1928437$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $274619feb1928437$var$sanitizeURL(url) {
    return $274619feb1928437$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $274619feb1928437$var$ReactSharedInternals = $dNU7X.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $274619feb1928437$var$ReactDOMSharedInternals = $boCrV.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $274619feb1928437$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $274619feb1928437$var$previousDispatcher = $274619feb1928437$var$ReactDOMSharedInternals.d;
$274619feb1928437$var$ReactDOMSharedInternals.d = {
    f: $274619feb1928437$var$previousDispatcher.f,
    r: $274619feb1928437$var$previousDispatcher.r,
    D: $274619feb1928437$var$prefetchDNS,
    C: $274619feb1928437$var$preconnect,
    L: $274619feb1928437$var$preload,
    m: $274619feb1928437$var$preloadModule,
    X: $274619feb1928437$var$preinitScript,
    S: $274619feb1928437$var$preinitStyle,
    M: $274619feb1928437$var$preinitModuleScript
};
var $274619feb1928437$var$PRELOAD_NO_CREDS = [], $274619feb1928437$var$scriptRegex = /(<\/|<)(s)(cript)/gi;
function $274619feb1928437$var$scriptReplacer(match, prefix, s, suffix) {
    return "" + prefix + ("s" === s ? "\\u0073" : "\\u0053") + suffix;
}
function $274619feb1928437$var$createResumableState(identifierPrefix, externalRuntimeConfig, bootstrapScriptContent, bootstrapScripts, bootstrapModules) {
    return {
        idPrefix: void 0 === identifierPrefix ? "" : identifierPrefix,
        nextFormID: 0,
        streamingFormat: 0,
        bootstrapScriptContent: bootstrapScriptContent,
        bootstrapScripts: bootstrapScripts,
        bootstrapModules: bootstrapModules,
        instructions: 0,
        hasBody: !1,
        hasHtml: !1,
        unknownResources: {},
        dnsResources: {},
        connectResources: {
            default: {},
            anonymous: {},
            credentials: {}
        },
        imageResources: {},
        styleResources: {},
        scriptResources: {},
        moduleUnknownResources: {},
        moduleScriptResources: {}
    };
}
function $274619feb1928437$var$createPreambleState() {
    return {
        htmlChunks: null,
        headChunks: null,
        bodyChunks: null,
        contribution: 0
    };
}
function $274619feb1928437$var$createFormatContext(insertionMode, selectedValue, tagScope) {
    return {
        insertionMode: insertionMode,
        selectedValue: selectedValue,
        tagScope: tagScope
    };
}
function $274619feb1928437$var$getChildFormatContext(parentContext, type, props) {
    switch(type){
        case "noscript":
            return $274619feb1928437$var$createFormatContext(2, null, parentContext.tagScope | 1);
        case "select":
            return $274619feb1928437$var$createFormatContext(2, null != props.value ? props.value : props.defaultValue, parentContext.tagScope);
        case "svg":
            return $274619feb1928437$var$createFormatContext(4, null, parentContext.tagScope);
        case "picture":
            return $274619feb1928437$var$createFormatContext(2, null, parentContext.tagScope | 2);
        case "math":
            return $274619feb1928437$var$createFormatContext(5, null, parentContext.tagScope);
        case "foreignObject":
            return $274619feb1928437$var$createFormatContext(2, null, parentContext.tagScope);
        case "table":
            return $274619feb1928437$var$createFormatContext(6, null, parentContext.tagScope);
        case "thead":
        case "tbody":
        case "tfoot":
            return $274619feb1928437$var$createFormatContext(7, null, parentContext.tagScope);
        case "colgroup":
            return $274619feb1928437$var$createFormatContext(9, null, parentContext.tagScope);
        case "tr":
            return $274619feb1928437$var$createFormatContext(8, null, parentContext.tagScope);
        case "head":
            if (2 > parentContext.insertionMode) return $274619feb1928437$var$createFormatContext(3, null, parentContext.tagScope);
            break;
        case "html":
            if (0 === parentContext.insertionMode) return $274619feb1928437$var$createFormatContext(1, null, parentContext.tagScope);
    }
    return 6 <= parentContext.insertionMode || 2 > parentContext.insertionMode ? $274619feb1928437$var$createFormatContext(2, null, parentContext.tagScope) : parentContext;
}
var $274619feb1928437$var$styleNameCache = new Map();
function $274619feb1928437$var$pushStyleAttribute(target, style) {
    if ("object" !== typeof style) throw Error($274619feb1928437$var$formatProdErrorMessage(62));
    var isFirst = !0, styleName;
    for(styleName in style)if ($274619feb1928437$var$hasOwnProperty.call(style, styleName)) {
        var styleValue = style[styleName];
        if (null != styleValue && "boolean" !== typeof styleValue && "" !== styleValue) {
            if (0 === styleName.indexOf("--")) {
                var nameChunk = $274619feb1928437$var$escapeTextForBrowser(styleName);
                styleValue = $274619feb1928437$var$escapeTextForBrowser(("" + styleValue).trim());
            } else nameChunk = $274619feb1928437$var$styleNameCache.get(styleName), void 0 === nameChunk && (nameChunk = $274619feb1928437$var$escapeTextForBrowser(styleName.replace($274619feb1928437$var$uppercasePattern, "-$1").toLowerCase().replace($274619feb1928437$var$msPattern, "-ms-")), $274619feb1928437$var$styleNameCache.set(styleName, nameChunk)), styleValue = "number" === typeof styleValue ? 0 === styleValue || $274619feb1928437$var$unitlessNumbers.has(styleName) ? "" + styleValue : styleValue + "px" : $274619feb1928437$var$escapeTextForBrowser(("" + styleValue).trim());
            isFirst ? (isFirst = !1, target.push(' style="', nameChunk, ":", styleValue)) : target.push(";", nameChunk, ":", styleValue);
        }
    }
    isFirst || target.push('"');
}
function $274619feb1928437$var$pushBooleanAttribute(target, name, value) {
    value && "function" !== typeof value && "symbol" !== typeof value && target.push(" ", name, '=""');
}
function $274619feb1928437$var$pushStringAttribute(target, name, value) {
    "function" !== typeof value && "symbol" !== typeof value && "boolean" !== typeof value && target.push(" ", name, '="', $274619feb1928437$var$escapeTextForBrowser(value), '"');
}
var $274619feb1928437$var$actionJavaScriptURL = $274619feb1928437$var$escapeTextForBrowser("javascript:throw new Error('React form unexpectedly submitted.')");
function $274619feb1928437$var$pushAdditionalFormField(value, key) {
    this.push('<input type="hidden"');
    $274619feb1928437$var$validateAdditionalFormField(value);
    $274619feb1928437$var$pushStringAttribute(this, "name", key);
    $274619feb1928437$var$pushStringAttribute(this, "value", value);
    this.push("/>");
}
function $274619feb1928437$var$validateAdditionalFormField(value) {
    if ("string" !== typeof value) throw Error($274619feb1928437$var$formatProdErrorMessage(480));
}
function $274619feb1928437$var$getCustomFormFields(resumableState, formAction) {
    if ("function" === typeof formAction.$$FORM_ACTION) {
        var id = resumableState.nextFormID++;
        resumableState = resumableState.idPrefix + id;
        try {
            var customFields = formAction.$$FORM_ACTION(resumableState);
            if (customFields) {
                var formData = customFields.data;
                null != formData && formData.forEach($274619feb1928437$var$validateAdditionalFormField);
            }
            return customFields;
        } catch (x) {
            if ("object" === typeof x && null !== x && "function" === typeof x.then) throw x;
        }
    }
    return null;
}
function $274619feb1928437$var$pushFormActionAttribute(target, resumableState, renderState, formAction, formEncType, formMethod, formTarget, name) {
    var formData = null;
    if ("function" === typeof formAction) {
        var customFields = $274619feb1928437$var$getCustomFormFields(resumableState, formAction);
        null !== customFields ? (name = customFields.name, formAction = customFields.action || "", formEncType = customFields.encType, formMethod = customFields.method, formTarget = customFields.target, formData = customFields.data) : (target.push(" ", "formAction", '="', $274619feb1928437$var$actionJavaScriptURL, '"'), formTarget = formMethod = formEncType = formAction = name = null, $274619feb1928437$var$injectFormReplayingRuntime(resumableState, renderState));
    }
    null != name && $274619feb1928437$var$pushAttribute(target, "name", name);
    null != formAction && $274619feb1928437$var$pushAttribute(target, "formAction", formAction);
    null != formEncType && $274619feb1928437$var$pushAttribute(target, "formEncType", formEncType);
    null != formMethod && $274619feb1928437$var$pushAttribute(target, "formMethod", formMethod);
    null != formTarget && $274619feb1928437$var$pushAttribute(target, "formTarget", formTarget);
    return formData;
}
function $274619feb1928437$var$pushAttribute(target, name, value) {
    switch(name){
        case "className":
            $274619feb1928437$var$pushStringAttribute(target, "class", value);
            break;
        case "tabIndex":
            $274619feb1928437$var$pushStringAttribute(target, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $274619feb1928437$var$pushStringAttribute(target, name, value);
            break;
        case "style":
            $274619feb1928437$var$pushStyleAttribute(target, value);
            break;
        case "src":
        case "href":
            if ("" === value) break;
        case "action":
        case "formAction":
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) break;
            value = $274619feb1928437$var$sanitizeURL("" + value);
            target.push(" ", name, '="', $274619feb1928437$var$escapeTextForBrowser(value), '"');
            break;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "ref":
            break;
        case "autoFocus":
        case "multiple":
        case "muted":
            $274619feb1928437$var$pushBooleanAttribute(target, name.toLowerCase(), value);
            break;
        case "xlinkHref":
            if ("function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) break;
            value = $274619feb1928437$var$sanitizeURL("" + value);
            target.push(" ", "xlink:href", '="', $274619feb1928437$var$escapeTextForBrowser(value), '"');
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            "function" !== typeof value && "symbol" !== typeof value && target.push(" ", name, '="', $274619feb1928437$var$escapeTextForBrowser(value), '"');
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value && target.push(" ", name, '=""');
            break;
        case "capture":
        case "download":
            !0 === value ? target.push(" ", name, '=""') : !1 !== value && "function" !== typeof value && "symbol" !== typeof value && target.push(" ", name, '="', $274619feb1928437$var$escapeTextForBrowser(value), '"');
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value && target.push(" ", name, '="', $274619feb1928437$var$escapeTextForBrowser(value), '"');
            break;
        case "rowSpan":
        case "start":
            "function" === typeof value || "symbol" === typeof value || isNaN(value) || target.push(" ", name, '="', $274619feb1928437$var$escapeTextForBrowser(value), '"');
            break;
        case "xlinkActuate":
            $274619feb1928437$var$pushStringAttribute(target, "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $274619feb1928437$var$pushStringAttribute(target, "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $274619feb1928437$var$pushStringAttribute(target, "xlink:role", value);
            break;
        case "xlinkShow":
            $274619feb1928437$var$pushStringAttribute(target, "xlink:show", value);
            break;
        case "xlinkTitle":
            $274619feb1928437$var$pushStringAttribute(target, "xlink:title", value);
            break;
        case "xlinkType":
            $274619feb1928437$var$pushStringAttribute(target, "xlink:type", value);
            break;
        case "xmlBase":
            $274619feb1928437$var$pushStringAttribute(target, "xml:base", value);
            break;
        case "xmlLang":
            $274619feb1928437$var$pushStringAttribute(target, "xml:lang", value);
            break;
        case "xmlSpace":
            $274619feb1928437$var$pushStringAttribute(target, "xml:space", value);
            break;
        default:
            if (!(2 < name.length) || "o" !== name[0] && "O" !== name[0] || "n" !== name[1] && "N" !== name[1]) {
                if (name = $274619feb1928437$var$aliases.get(name) || name, $274619feb1928437$var$isAttributeNameSafe(name)) {
                    switch(typeof value){
                        case "function":
                        case "symbol":
                            return;
                        case "boolean":
                            var prefix$8 = name.toLowerCase().slice(0, 5);
                            if ("data-" !== prefix$8 && "aria-" !== prefix$8) return;
                    }
                    target.push(" ", name, '="', $274619feb1928437$var$escapeTextForBrowser(value), '"');
                }
            }
    }
}
function $274619feb1928437$var$pushInnerHTML(target, innerHTML, children) {
    if (null != innerHTML) {
        if (null != children) throw Error($274619feb1928437$var$formatProdErrorMessage(60));
        if ("object" !== typeof innerHTML || !("__html" in innerHTML)) throw Error($274619feb1928437$var$formatProdErrorMessage(61));
        innerHTML = innerHTML.__html;
        null !== innerHTML && void 0 !== innerHTML && target.push("" + innerHTML);
    }
}
function $274619feb1928437$var$flattenOptionChildren(children) {
    var content = "";
    $dNU7X.Children.forEach(children, function(child) {
        null != child && (content += child);
    });
    return content;
}
function $274619feb1928437$var$injectFormReplayingRuntime(resumableState, renderState) {
    0 === (resumableState.instructions & 16) && (resumableState.instructions |= 16, renderState.bootstrapChunks.unshift(renderState.startInlineScript, 'addEventListener("submit",function(a){if(!a.defaultPrevented){var c=a.target,d=a.submitter,e=c.action,b=d;if(d){var f=d.getAttribute("formAction");null!=f&&(e=f,b=null)}"javascript:throw new Error(\'React form unexpectedly submitted.\')"===e&&(a.preventDefault(),b?(a=document.createElement("input"),a.name=b.name,a.value=b.value,b.parentNode.insertBefore(a,b),b=new FormData(c),a.parentNode.removeChild(a)):b=new FormData(c),a=c.ownerDocument||c,(a.$$reactFormReplay=a.$$reactFormReplay||[]).push(c,d,b))}});', "\x3c/script>"));
}
function $274619feb1928437$var$pushLinkImpl(target, props) {
    target.push($274619feb1928437$var$startChunkForTag("link"));
    for(var propKey in props)if ($274619feb1928437$var$hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue) switch(propKey){
            case "children":
            case "dangerouslySetInnerHTML":
                throw Error($274619feb1928437$var$formatProdErrorMessage(399, "link"));
            default:
                $274619feb1928437$var$pushAttribute(target, propKey, propValue);
        }
    }
    target.push("/>");
    return null;
}
var $274619feb1928437$var$styleRegex = /(<\/|<)(s)(tyle)/gi;
function $274619feb1928437$var$styleReplacer(match, prefix, s, suffix) {
    return "" + prefix + ("s" === s ? "\\73 " : "\\53 ") + suffix;
}
function $274619feb1928437$var$pushSelfClosing(target, props, tag) {
    target.push($274619feb1928437$var$startChunkForTag(tag));
    for(var propKey in props)if ($274619feb1928437$var$hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue) switch(propKey){
            case "children":
            case "dangerouslySetInnerHTML":
                throw Error($274619feb1928437$var$formatProdErrorMessage(399, tag));
            default:
                $274619feb1928437$var$pushAttribute(target, propKey, propValue);
        }
    }
    target.push("/>");
    return null;
}
function $274619feb1928437$var$pushTitleImpl(target, props) {
    target.push($274619feb1928437$var$startChunkForTag("title"));
    var children = null, innerHTML = null, propKey;
    for(propKey in props)if ($274619feb1928437$var$hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue) switch(propKey){
            case "children":
                children = propValue;
                break;
            case "dangerouslySetInnerHTML":
                innerHTML = propValue;
                break;
            default:
                $274619feb1928437$var$pushAttribute(target, propKey, propValue);
        }
    }
    target.push(">");
    props = Array.isArray(children) ? 2 > children.length ? children[0] : null : children;
    "function" !== typeof props && "symbol" !== typeof props && null !== props && void 0 !== props && target.push($274619feb1928437$var$escapeTextForBrowser("" + props));
    $274619feb1928437$var$pushInnerHTML(target, innerHTML, children);
    target.push($274619feb1928437$var$endChunkForTag("title"));
    return null;
}
function $274619feb1928437$var$pushScriptImpl(target, props) {
    target.push($274619feb1928437$var$startChunkForTag("script"));
    var children = null, innerHTML = null, propKey;
    for(propKey in props)if ($274619feb1928437$var$hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue) switch(propKey){
            case "children":
                children = propValue;
                break;
            case "dangerouslySetInnerHTML":
                innerHTML = propValue;
                break;
            default:
                $274619feb1928437$var$pushAttribute(target, propKey, propValue);
        }
    }
    target.push(">");
    $274619feb1928437$var$pushInnerHTML(target, innerHTML, children);
    "string" === typeof children && target.push(("" + children).replace($274619feb1928437$var$scriptRegex, $274619feb1928437$var$scriptReplacer));
    target.push($274619feb1928437$var$endChunkForTag("script"));
    return null;
}
function $274619feb1928437$var$pushStartSingletonElement(target, props, tag) {
    target.push($274619feb1928437$var$startChunkForTag(tag));
    var innerHTML = tag = null, propKey;
    for(propKey in props)if ($274619feb1928437$var$hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue) switch(propKey){
            case "children":
                tag = propValue;
                break;
            case "dangerouslySetInnerHTML":
                innerHTML = propValue;
                break;
            default:
                $274619feb1928437$var$pushAttribute(target, propKey, propValue);
        }
    }
    target.push(">");
    $274619feb1928437$var$pushInnerHTML(target, innerHTML, tag);
    return tag;
}
function $274619feb1928437$var$pushStartGenericElement(target, props, tag) {
    target.push($274619feb1928437$var$startChunkForTag(tag));
    var innerHTML = tag = null, propKey;
    for(propKey in props)if ($274619feb1928437$var$hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue) switch(propKey){
            case "children":
                tag = propValue;
                break;
            case "dangerouslySetInnerHTML":
                innerHTML = propValue;
                break;
            default:
                $274619feb1928437$var$pushAttribute(target, propKey, propValue);
        }
    }
    target.push(">");
    $274619feb1928437$var$pushInnerHTML(target, innerHTML, tag);
    return "string" === typeof tag ? (target.push($274619feb1928437$var$escapeTextForBrowser(tag)), null) : tag;
}
var $274619feb1928437$var$VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $274619feb1928437$var$validatedTagCache = new Map();
function $274619feb1928437$var$startChunkForTag(tag) {
    var tagStartChunk = $274619feb1928437$var$validatedTagCache.get(tag);
    if (void 0 === tagStartChunk) {
        if (!$274619feb1928437$var$VALID_TAG_REGEX.test(tag)) throw Error($274619feb1928437$var$formatProdErrorMessage(65, tag));
        tagStartChunk = "<" + tag;
        $274619feb1928437$var$validatedTagCache.set(tag, tagStartChunk);
    }
    return tagStartChunk;
}
function $274619feb1928437$var$pushStartInstance(target$jscomp$0, type, props, resumableState, renderState, preambleState, hoistableState, formatContext, textEmbedded, isFallback) {
    switch(type){
        case "div":
        case "span":
        case "svg":
        case "path":
            break;
        case "a":
            target$jscomp$0.push($274619feb1928437$var$startChunkForTag("a"));
            var children = null, innerHTML = null, propKey;
            for(propKey in props)if ($274619feb1928437$var$hasOwnProperty.call(props, propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "children":
                        children = propValue;
                        break;
                    case "dangerouslySetInnerHTML":
                        innerHTML = propValue;
                        break;
                    case "href":
                        "" === propValue ? $274619feb1928437$var$pushStringAttribute(target$jscomp$0, "href", "") : $274619feb1928437$var$pushAttribute(target$jscomp$0, propKey, propValue);
                        break;
                    default:
                        $274619feb1928437$var$pushAttribute(target$jscomp$0, propKey, propValue);
                }
            }
            target$jscomp$0.push(">");
            $274619feb1928437$var$pushInnerHTML(target$jscomp$0, innerHTML, children);
            if ("string" === typeof children) {
                target$jscomp$0.push($274619feb1928437$var$escapeTextForBrowser(children));
                var JSCompiler_inline_result = null;
            } else JSCompiler_inline_result = children;
            return JSCompiler_inline_result;
        case "g":
        case "p":
        case "li":
            break;
        case "select":
            target$jscomp$0.push($274619feb1928437$var$startChunkForTag("select"));
            var children$jscomp$0 = null, innerHTML$jscomp$0 = null, propKey$jscomp$0;
            for(propKey$jscomp$0 in props)if ($274619feb1928437$var$hasOwnProperty.call(props, propKey$jscomp$0)) {
                var propValue$jscomp$0 = props[propKey$jscomp$0];
                if (null != propValue$jscomp$0) switch(propKey$jscomp$0){
                    case "children":
                        children$jscomp$0 = propValue$jscomp$0;
                        break;
                    case "dangerouslySetInnerHTML":
                        innerHTML$jscomp$0 = propValue$jscomp$0;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $274619feb1928437$var$pushAttribute(target$jscomp$0, propKey$jscomp$0, propValue$jscomp$0);
                }
            }
            target$jscomp$0.push(">");
            $274619feb1928437$var$pushInnerHTML(target$jscomp$0, innerHTML$jscomp$0, children$jscomp$0);
            return children$jscomp$0;
        case "option":
            var selectedValue = formatContext.selectedValue;
            target$jscomp$0.push($274619feb1928437$var$startChunkForTag("option"));
            var children$jscomp$1 = null, value = null, selected = null, innerHTML$jscomp$1 = null, propKey$jscomp$1;
            for(propKey$jscomp$1 in props)if ($274619feb1928437$var$hasOwnProperty.call(props, propKey$jscomp$1)) {
                var propValue$jscomp$1 = props[propKey$jscomp$1];
                if (null != propValue$jscomp$1) switch(propKey$jscomp$1){
                    case "children":
                        children$jscomp$1 = propValue$jscomp$1;
                        break;
                    case "selected":
                        selected = propValue$jscomp$1;
                        break;
                    case "dangerouslySetInnerHTML":
                        innerHTML$jscomp$1 = propValue$jscomp$1;
                        break;
                    case "value":
                        value = propValue$jscomp$1;
                    default:
                        $274619feb1928437$var$pushAttribute(target$jscomp$0, propKey$jscomp$1, propValue$jscomp$1);
                }
            }
            if (null != selectedValue) {
                var stringValue = null !== value ? "" + value : $274619feb1928437$var$flattenOptionChildren(children$jscomp$1);
                if ($274619feb1928437$var$isArrayImpl(selectedValue)) {
                    for(var i = 0; i < selectedValue.length; i++)if ("" + selectedValue[i] === stringValue) {
                        target$jscomp$0.push(' selected=""');
                        break;
                    }
                } else "" + selectedValue === stringValue && target$jscomp$0.push(' selected=""');
            } else selected && target$jscomp$0.push(' selected=""');
            target$jscomp$0.push(">");
            $274619feb1928437$var$pushInnerHTML(target$jscomp$0, innerHTML$jscomp$1, children$jscomp$1);
            return children$jscomp$1;
        case "textarea":
            target$jscomp$0.push($274619feb1928437$var$startChunkForTag("textarea"));
            var value$jscomp$0 = null, defaultValue = null, children$jscomp$2 = null, propKey$jscomp$2;
            for(propKey$jscomp$2 in props)if ($274619feb1928437$var$hasOwnProperty.call(props, propKey$jscomp$2)) {
                var propValue$jscomp$2 = props[propKey$jscomp$2];
                if (null != propValue$jscomp$2) switch(propKey$jscomp$2){
                    case "children":
                        children$jscomp$2 = propValue$jscomp$2;
                        break;
                    case "value":
                        value$jscomp$0 = propValue$jscomp$2;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$jscomp$2;
                        break;
                    case "dangerouslySetInnerHTML":
                        throw Error($274619feb1928437$var$formatProdErrorMessage(91));
                    default:
                        $274619feb1928437$var$pushAttribute(target$jscomp$0, propKey$jscomp$2, propValue$jscomp$2);
                }
            }
            null === value$jscomp$0 && null !== defaultValue && (value$jscomp$0 = defaultValue);
            target$jscomp$0.push(">");
            if (null != children$jscomp$2) {
                if (null != value$jscomp$0) throw Error($274619feb1928437$var$formatProdErrorMessage(92));
                if ($274619feb1928437$var$isArrayImpl(children$jscomp$2)) {
                    if (1 < children$jscomp$2.length) throw Error($274619feb1928437$var$formatProdErrorMessage(93));
                    value$jscomp$0 = "" + children$jscomp$2[0];
                }
                value$jscomp$0 = "" + children$jscomp$2;
            }
            "string" === typeof value$jscomp$0 && "\n" === value$jscomp$0[0] && target$jscomp$0.push("\n");
            null !== value$jscomp$0 && target$jscomp$0.push($274619feb1928437$var$escapeTextForBrowser("" + value$jscomp$0));
            return null;
        case "input":
            target$jscomp$0.push($274619feb1928437$var$startChunkForTag("input"));
            var name = null, formAction = null, formEncType = null, formMethod = null, formTarget = null, value$jscomp$1 = null, defaultValue$jscomp$0 = null, checked = null, defaultChecked = null, propKey$jscomp$3;
            for(propKey$jscomp$3 in props)if ($274619feb1928437$var$hasOwnProperty.call(props, propKey$jscomp$3)) {
                var propValue$jscomp$3 = props[propKey$jscomp$3];
                if (null != propValue$jscomp$3) switch(propKey$jscomp$3){
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($274619feb1928437$var$formatProdErrorMessage(399, "input"));
                    case "name":
                        name = propValue$jscomp$3;
                        break;
                    case "formAction":
                        formAction = propValue$jscomp$3;
                        break;
                    case "formEncType":
                        formEncType = propValue$jscomp$3;
                        break;
                    case "formMethod":
                        formMethod = propValue$jscomp$3;
                        break;
                    case "formTarget":
                        formTarget = propValue$jscomp$3;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$jscomp$3;
                        break;
                    case "defaultValue":
                        defaultValue$jscomp$0 = propValue$jscomp$3;
                        break;
                    case "checked":
                        checked = propValue$jscomp$3;
                        break;
                    case "value":
                        value$jscomp$1 = propValue$jscomp$3;
                        break;
                    default:
                        $274619feb1928437$var$pushAttribute(target$jscomp$0, propKey$jscomp$3, propValue$jscomp$3);
                }
            }
            var formData = $274619feb1928437$var$pushFormActionAttribute(target$jscomp$0, resumableState, renderState, formAction, formEncType, formMethod, formTarget, name);
            null !== checked ? $274619feb1928437$var$pushBooleanAttribute(target$jscomp$0, "checked", checked) : null !== defaultChecked && $274619feb1928437$var$pushBooleanAttribute(target$jscomp$0, "checked", defaultChecked);
            null !== value$jscomp$1 ? $274619feb1928437$var$pushAttribute(target$jscomp$0, "value", value$jscomp$1) : null !== defaultValue$jscomp$0 && $274619feb1928437$var$pushAttribute(target$jscomp$0, "value", defaultValue$jscomp$0);
            target$jscomp$0.push("/>");
            null != formData && formData.forEach($274619feb1928437$var$pushAdditionalFormField, target$jscomp$0);
            return null;
        case "button":
            target$jscomp$0.push($274619feb1928437$var$startChunkForTag("button"));
            var children$jscomp$3 = null, innerHTML$jscomp$2 = null, name$jscomp$0 = null, formAction$jscomp$0 = null, formEncType$jscomp$0 = null, formMethod$jscomp$0 = null, formTarget$jscomp$0 = null, propKey$jscomp$4;
            for(propKey$jscomp$4 in props)if ($274619feb1928437$var$hasOwnProperty.call(props, propKey$jscomp$4)) {
                var propValue$jscomp$4 = props[propKey$jscomp$4];
                if (null != propValue$jscomp$4) switch(propKey$jscomp$4){
                    case "children":
                        children$jscomp$3 = propValue$jscomp$4;
                        break;
                    case "dangerouslySetInnerHTML":
                        innerHTML$jscomp$2 = propValue$jscomp$4;
                        break;
                    case "name":
                        name$jscomp$0 = propValue$jscomp$4;
                        break;
                    case "formAction":
                        formAction$jscomp$0 = propValue$jscomp$4;
                        break;
                    case "formEncType":
                        formEncType$jscomp$0 = propValue$jscomp$4;
                        break;
                    case "formMethod":
                        formMethod$jscomp$0 = propValue$jscomp$4;
                        break;
                    case "formTarget":
                        formTarget$jscomp$0 = propValue$jscomp$4;
                        break;
                    default:
                        $274619feb1928437$var$pushAttribute(target$jscomp$0, propKey$jscomp$4, propValue$jscomp$4);
                }
            }
            var formData$jscomp$0 = $274619feb1928437$var$pushFormActionAttribute(target$jscomp$0, resumableState, renderState, formAction$jscomp$0, formEncType$jscomp$0, formMethod$jscomp$0, formTarget$jscomp$0, name$jscomp$0);
            target$jscomp$0.push(">");
            null != formData$jscomp$0 && formData$jscomp$0.forEach($274619feb1928437$var$pushAdditionalFormField, target$jscomp$0);
            $274619feb1928437$var$pushInnerHTML(target$jscomp$0, innerHTML$jscomp$2, children$jscomp$3);
            if ("string" === typeof children$jscomp$3) {
                target$jscomp$0.push($274619feb1928437$var$escapeTextForBrowser(children$jscomp$3));
                var JSCompiler_inline_result$jscomp$0 = null;
            } else JSCompiler_inline_result$jscomp$0 = children$jscomp$3;
            return JSCompiler_inline_result$jscomp$0;
        case "form":
            target$jscomp$0.push($274619feb1928437$var$startChunkForTag("form"));
            var children$jscomp$4 = null, innerHTML$jscomp$3 = null, formAction$jscomp$1 = null, formEncType$jscomp$1 = null, formMethod$jscomp$1 = null, formTarget$jscomp$1 = null, propKey$jscomp$5;
            for(propKey$jscomp$5 in props)if ($274619feb1928437$var$hasOwnProperty.call(props, propKey$jscomp$5)) {
                var propValue$jscomp$5 = props[propKey$jscomp$5];
                if (null != propValue$jscomp$5) switch(propKey$jscomp$5){
                    case "children":
                        children$jscomp$4 = propValue$jscomp$5;
                        break;
                    case "dangerouslySetInnerHTML":
                        innerHTML$jscomp$3 = propValue$jscomp$5;
                        break;
                    case "action":
                        formAction$jscomp$1 = propValue$jscomp$5;
                        break;
                    case "encType":
                        formEncType$jscomp$1 = propValue$jscomp$5;
                        break;
                    case "method":
                        formMethod$jscomp$1 = propValue$jscomp$5;
                        break;
                    case "target":
                        formTarget$jscomp$1 = propValue$jscomp$5;
                        break;
                    default:
                        $274619feb1928437$var$pushAttribute(target$jscomp$0, propKey$jscomp$5, propValue$jscomp$5);
                }
            }
            var formData$jscomp$1 = null, formActionName = null;
            if ("function" === typeof formAction$jscomp$1) {
                var customFields = $274619feb1928437$var$getCustomFormFields(resumableState, formAction$jscomp$1);
                null !== customFields ? (formAction$jscomp$1 = customFields.action || "", formEncType$jscomp$1 = customFields.encType, formMethod$jscomp$1 = customFields.method, formTarget$jscomp$1 = customFields.target, formData$jscomp$1 = customFields.data, formActionName = customFields.name) : (target$jscomp$0.push(" ", "action", '="', $274619feb1928437$var$actionJavaScriptURL, '"'), formTarget$jscomp$1 = formMethod$jscomp$1 = formEncType$jscomp$1 = formAction$jscomp$1 = null, $274619feb1928437$var$injectFormReplayingRuntime(resumableState, renderState));
            }
            null != formAction$jscomp$1 && $274619feb1928437$var$pushAttribute(target$jscomp$0, "action", formAction$jscomp$1);
            null != formEncType$jscomp$1 && $274619feb1928437$var$pushAttribute(target$jscomp$0, "encType", formEncType$jscomp$1);
            null != formMethod$jscomp$1 && $274619feb1928437$var$pushAttribute(target$jscomp$0, "method", formMethod$jscomp$1);
            null != formTarget$jscomp$1 && $274619feb1928437$var$pushAttribute(target$jscomp$0, "target", formTarget$jscomp$1);
            target$jscomp$0.push(">");
            null !== formActionName && (target$jscomp$0.push('<input type="hidden"'), $274619feb1928437$var$pushStringAttribute(target$jscomp$0, "name", formActionName), target$jscomp$0.push("/>"), null != formData$jscomp$1 && formData$jscomp$1.forEach($274619feb1928437$var$pushAdditionalFormField, target$jscomp$0));
            $274619feb1928437$var$pushInnerHTML(target$jscomp$0, innerHTML$jscomp$3, children$jscomp$4);
            if ("string" === typeof children$jscomp$4) {
                target$jscomp$0.push($274619feb1928437$var$escapeTextForBrowser(children$jscomp$4));
                var JSCompiler_inline_result$jscomp$1 = null;
            } else JSCompiler_inline_result$jscomp$1 = children$jscomp$4;
            return JSCompiler_inline_result$jscomp$1;
        case "menuitem":
            target$jscomp$0.push($274619feb1928437$var$startChunkForTag("menuitem"));
            for(var propKey$jscomp$6 in props)if ($274619feb1928437$var$hasOwnProperty.call(props, propKey$jscomp$6)) {
                var propValue$jscomp$6 = props[propKey$jscomp$6];
                if (null != propValue$jscomp$6) switch(propKey$jscomp$6){
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($274619feb1928437$var$formatProdErrorMessage(400));
                    default:
                        $274619feb1928437$var$pushAttribute(target$jscomp$0, propKey$jscomp$6, propValue$jscomp$6);
                }
            }
            target$jscomp$0.push(">");
            return null;
        case "object":
            target$jscomp$0.push($274619feb1928437$var$startChunkForTag("object"));
            var children$jscomp$5 = null, innerHTML$jscomp$4 = null, propKey$jscomp$7;
            for(propKey$jscomp$7 in props)if ($274619feb1928437$var$hasOwnProperty.call(props, propKey$jscomp$7)) {
                var propValue$jscomp$7 = props[propKey$jscomp$7];
                if (null != propValue$jscomp$7) switch(propKey$jscomp$7){
                    case "children":
                        children$jscomp$5 = propValue$jscomp$7;
                        break;
                    case "dangerouslySetInnerHTML":
                        innerHTML$jscomp$4 = propValue$jscomp$7;
                        break;
                    case "data":
                        var sanitizedValue = $274619feb1928437$var$sanitizeURL("" + propValue$jscomp$7);
                        if ("" === sanitizedValue) break;
                        target$jscomp$0.push(" ", "data", '="', $274619feb1928437$var$escapeTextForBrowser(sanitizedValue), '"');
                        break;
                    default:
                        $274619feb1928437$var$pushAttribute(target$jscomp$0, propKey$jscomp$7, propValue$jscomp$7);
                }
            }
            target$jscomp$0.push(">");
            $274619feb1928437$var$pushInnerHTML(target$jscomp$0, innerHTML$jscomp$4, children$jscomp$5);
            if ("string" === typeof children$jscomp$5) {
                target$jscomp$0.push($274619feb1928437$var$escapeTextForBrowser(children$jscomp$5));
                var JSCompiler_inline_result$jscomp$2 = null;
            } else JSCompiler_inline_result$jscomp$2 = children$jscomp$5;
            return JSCompiler_inline_result$jscomp$2;
        case "title":
            if (4 === formatContext.insertionMode || formatContext.tagScope & 1 || null != props.itemProp) var JSCompiler_inline_result$jscomp$3 = $274619feb1928437$var$pushTitleImpl(target$jscomp$0, props);
            else isFallback ? JSCompiler_inline_result$jscomp$3 = null : ($274619feb1928437$var$pushTitleImpl(renderState.hoistableChunks, props), JSCompiler_inline_result$jscomp$3 = void 0);
            return JSCompiler_inline_result$jscomp$3;
        case "link":
            var rel = props.rel, href = props.href, precedence = props.precedence;
            if (4 === formatContext.insertionMode || formatContext.tagScope & 1 || null != props.itemProp || "string" !== typeof rel || "string" !== typeof href || "" === href) {
                $274619feb1928437$var$pushLinkImpl(target$jscomp$0, props);
                var JSCompiler_inline_result$jscomp$4 = null;
            } else if ("stylesheet" === props.rel) {
                if ("string" !== typeof precedence || null != props.disabled || props.onLoad || props.onError) JSCompiler_inline_result$jscomp$4 = $274619feb1928437$var$pushLinkImpl(target$jscomp$0, props);
                else {
                    var styleQueue = renderState.styles.get(precedence), resourceState = resumableState.styleResources.hasOwnProperty(href) ? resumableState.styleResources[href] : void 0;
                    if (null !== resourceState) {
                        resumableState.styleResources[href] = null;
                        styleQueue || (styleQueue = {
                            precedence: $274619feb1928437$var$escapeTextForBrowser(precedence),
                            rules: [],
                            hrefs: [],
                            sheets: new Map()
                        }, renderState.styles.set(precedence, styleQueue));
                        var resource = {
                            state: 0,
                            props: $274619feb1928437$var$assign({}, props, {
                                "data-precedence": props.precedence,
                                precedence: null
                            })
                        };
                        if (resourceState) {
                            2 === resourceState.length && $274619feb1928437$var$adoptPreloadCredentials(resource.props, resourceState);
                            var preloadResource = renderState.preloads.stylesheets.get(href);
                            preloadResource && 0 < preloadResource.length ? preloadResource.length = 0 : resource.state = 1;
                        }
                        styleQueue.sheets.set(href, resource);
                        hoistableState && hoistableState.stylesheets.add(resource);
                    } else if (styleQueue) {
                        var resource$9 = styleQueue.sheets.get(href);
                        resource$9 && hoistableState && hoistableState.stylesheets.add(resource$9);
                    }
                    textEmbedded && target$jscomp$0.push("\x3c!-- --\x3e");
                    JSCompiler_inline_result$jscomp$4 = null;
                }
            } else props.onLoad || props.onError ? JSCompiler_inline_result$jscomp$4 = $274619feb1928437$var$pushLinkImpl(target$jscomp$0, props) : (textEmbedded && target$jscomp$0.push("\x3c!-- --\x3e"), JSCompiler_inline_result$jscomp$4 = isFallback ? null : $274619feb1928437$var$pushLinkImpl(renderState.hoistableChunks, props));
            return JSCompiler_inline_result$jscomp$4;
        case "script":
            var asyncProp = props.async;
            if ("string" !== typeof props.src || !props.src || !asyncProp || "function" === typeof asyncProp || "symbol" === typeof asyncProp || props.onLoad || props.onError || 4 === formatContext.insertionMode || formatContext.tagScope & 1 || null != props.itemProp) var JSCompiler_inline_result$jscomp$5 = $274619feb1928437$var$pushScriptImpl(target$jscomp$0, props);
            else {
                var key = props.src;
                if ("module" === props.type) {
                    var resources = resumableState.moduleScriptResources;
                    var preloads = renderState.preloads.moduleScripts;
                } else resources = resumableState.scriptResources, preloads = renderState.preloads.scripts;
                var resourceState$jscomp$0 = resources.hasOwnProperty(key) ? resources[key] : void 0;
                if (null !== resourceState$jscomp$0) {
                    resources[key] = null;
                    var scriptProps = props;
                    if (resourceState$jscomp$0) {
                        2 === resourceState$jscomp$0.length && (scriptProps = $274619feb1928437$var$assign({}, props), $274619feb1928437$var$adoptPreloadCredentials(scriptProps, resourceState$jscomp$0));
                        var preloadResource$jscomp$0 = preloads.get(key);
                        preloadResource$jscomp$0 && (preloadResource$jscomp$0.length = 0);
                    }
                    var resource$jscomp$0 = [];
                    renderState.scripts.add(resource$jscomp$0);
                    $274619feb1928437$var$pushScriptImpl(resource$jscomp$0, scriptProps);
                }
                textEmbedded && target$jscomp$0.push("\x3c!-- --\x3e");
                JSCompiler_inline_result$jscomp$5 = null;
            }
            return JSCompiler_inline_result$jscomp$5;
        case "style":
            var precedence$jscomp$0 = props.precedence, href$jscomp$0 = props.href;
            if (4 === formatContext.insertionMode || formatContext.tagScope & 1 || null != props.itemProp || "string" !== typeof precedence$jscomp$0 || "string" !== typeof href$jscomp$0 || "" === href$jscomp$0) {
                target$jscomp$0.push($274619feb1928437$var$startChunkForTag("style"));
                var children$jscomp$6 = null, innerHTML$jscomp$5 = null, propKey$jscomp$8;
                for(propKey$jscomp$8 in props)if ($274619feb1928437$var$hasOwnProperty.call(props, propKey$jscomp$8)) {
                    var propValue$jscomp$8 = props[propKey$jscomp$8];
                    if (null != propValue$jscomp$8) switch(propKey$jscomp$8){
                        case "children":
                            children$jscomp$6 = propValue$jscomp$8;
                            break;
                        case "dangerouslySetInnerHTML":
                            innerHTML$jscomp$5 = propValue$jscomp$8;
                            break;
                        default:
                            $274619feb1928437$var$pushAttribute(target$jscomp$0, propKey$jscomp$8, propValue$jscomp$8);
                    }
                }
                target$jscomp$0.push(">");
                var child = Array.isArray(children$jscomp$6) ? 2 > children$jscomp$6.length ? children$jscomp$6[0] : null : children$jscomp$6;
                "function" !== typeof child && "symbol" !== typeof child && null !== child && void 0 !== child && target$jscomp$0.push(("" + child).replace($274619feb1928437$var$styleRegex, $274619feb1928437$var$styleReplacer));
                $274619feb1928437$var$pushInnerHTML(target$jscomp$0, innerHTML$jscomp$5, children$jscomp$6);
                target$jscomp$0.push($274619feb1928437$var$endChunkForTag("style"));
                var JSCompiler_inline_result$jscomp$6 = null;
            } else {
                var styleQueue$jscomp$0 = renderState.styles.get(precedence$jscomp$0);
                if (null !== (resumableState.styleResources.hasOwnProperty(href$jscomp$0) ? resumableState.styleResources[href$jscomp$0] : void 0)) {
                    resumableState.styleResources[href$jscomp$0] = null;
                    styleQueue$jscomp$0 ? styleQueue$jscomp$0.hrefs.push($274619feb1928437$var$escapeTextForBrowser(href$jscomp$0)) : (styleQueue$jscomp$0 = {
                        precedence: $274619feb1928437$var$escapeTextForBrowser(precedence$jscomp$0),
                        rules: [],
                        hrefs: [
                            $274619feb1928437$var$escapeTextForBrowser(href$jscomp$0)
                        ],
                        sheets: new Map()
                    }, renderState.styles.set(precedence$jscomp$0, styleQueue$jscomp$0));
                    var target = styleQueue$jscomp$0.rules, children$jscomp$7 = null, innerHTML$jscomp$6 = null, propKey$jscomp$9;
                    for(propKey$jscomp$9 in props)if ($274619feb1928437$var$hasOwnProperty.call(props, propKey$jscomp$9)) {
                        var propValue$jscomp$9 = props[propKey$jscomp$9];
                        if (null != propValue$jscomp$9) switch(propKey$jscomp$9){
                            case "children":
                                children$jscomp$7 = propValue$jscomp$9;
                                break;
                            case "dangerouslySetInnerHTML":
                                innerHTML$jscomp$6 = propValue$jscomp$9;
                        }
                    }
                    var child$jscomp$0 = Array.isArray(children$jscomp$7) ? 2 > children$jscomp$7.length ? children$jscomp$7[0] : null : children$jscomp$7;
                    "function" !== typeof child$jscomp$0 && "symbol" !== typeof child$jscomp$0 && null !== child$jscomp$0 && void 0 !== child$jscomp$0 && target.push(("" + child$jscomp$0).replace($274619feb1928437$var$styleRegex, $274619feb1928437$var$styleReplacer));
                    $274619feb1928437$var$pushInnerHTML(target, innerHTML$jscomp$6, children$jscomp$7);
                }
                styleQueue$jscomp$0 && hoistableState && hoistableState.styles.add(styleQueue$jscomp$0);
                textEmbedded && target$jscomp$0.push("\x3c!-- --\x3e");
                JSCompiler_inline_result$jscomp$6 = void 0;
            }
            return JSCompiler_inline_result$jscomp$6;
        case "meta":
            if (4 === formatContext.insertionMode || formatContext.tagScope & 1 || null != props.itemProp) var JSCompiler_inline_result$jscomp$7 = $274619feb1928437$var$pushSelfClosing(target$jscomp$0, props, "meta");
            else textEmbedded && target$jscomp$0.push("\x3c!-- --\x3e"), JSCompiler_inline_result$jscomp$7 = isFallback ? null : "string" === typeof props.charSet ? $274619feb1928437$var$pushSelfClosing(renderState.charsetChunks, props, "meta") : "viewport" === props.name ? $274619feb1928437$var$pushSelfClosing(renderState.viewportChunks, props, "meta") : $274619feb1928437$var$pushSelfClosing(renderState.hoistableChunks, props, "meta");
            return JSCompiler_inline_result$jscomp$7;
        case "listing":
        case "pre":
            target$jscomp$0.push($274619feb1928437$var$startChunkForTag(type));
            var children$jscomp$8 = null, innerHTML$jscomp$7 = null, propKey$jscomp$10;
            for(propKey$jscomp$10 in props)if ($274619feb1928437$var$hasOwnProperty.call(props, propKey$jscomp$10)) {
                var propValue$jscomp$10 = props[propKey$jscomp$10];
                if (null != propValue$jscomp$10) switch(propKey$jscomp$10){
                    case "children":
                        children$jscomp$8 = propValue$jscomp$10;
                        break;
                    case "dangerouslySetInnerHTML":
                        innerHTML$jscomp$7 = propValue$jscomp$10;
                        break;
                    default:
                        $274619feb1928437$var$pushAttribute(target$jscomp$0, propKey$jscomp$10, propValue$jscomp$10);
                }
            }
            target$jscomp$0.push(">");
            if (null != innerHTML$jscomp$7) {
                if (null != children$jscomp$8) throw Error($274619feb1928437$var$formatProdErrorMessage(60));
                if ("object" !== typeof innerHTML$jscomp$7 || !("__html" in innerHTML$jscomp$7)) throw Error($274619feb1928437$var$formatProdErrorMessage(61));
                var html = innerHTML$jscomp$7.__html;
                null !== html && void 0 !== html && ("string" === typeof html && 0 < html.length && "\n" === html[0] ? target$jscomp$0.push("\n", html) : target$jscomp$0.push("" + html));
            }
            "string" === typeof children$jscomp$8 && "\n" === children$jscomp$8[0] && target$jscomp$0.push("\n");
            return children$jscomp$8;
        case "img":
            var src = props.src, srcSet = props.srcSet;
            if (!("lazy" === props.loading || !src && !srcSet || "string" !== typeof src && null != src || "string" !== typeof srcSet && null != srcSet) && "low" !== props.fetchPriority && !1 === !!(formatContext.tagScope & 3) && ("string" !== typeof src || ":" !== src[4] || "d" !== src[0] && "D" !== src[0] || "a" !== src[1] && "A" !== src[1] || "t" !== src[2] && "T" !== src[2] || "a" !== src[3] && "A" !== src[3]) && ("string" !== typeof srcSet || ":" !== srcSet[4] || "d" !== srcSet[0] && "D" !== srcSet[0] || "a" !== srcSet[1] && "A" !== srcSet[1] || "t" !== srcSet[2] && "T" !== srcSet[2] || "a" !== srcSet[3] && "A" !== srcSet[3])) {
                var sizes = "string" === typeof props.sizes ? props.sizes : void 0, key$jscomp$0 = srcSet ? srcSet + "\n" + (sizes || "") : src, promotablePreloads = renderState.preloads.images, resource$jscomp$1 = promotablePreloads.get(key$jscomp$0);
                if (resource$jscomp$1) {
                    if ("high" === props.fetchPriority || 10 > renderState.highImagePreloads.size) promotablePreloads.delete(key$jscomp$0), renderState.highImagePreloads.add(resource$jscomp$1);
                } else if (!resumableState.imageResources.hasOwnProperty(key$jscomp$0)) {
                    resumableState.imageResources[key$jscomp$0] = $274619feb1928437$var$PRELOAD_NO_CREDS;
                    var input = props.crossOrigin;
                    var JSCompiler_inline_result$jscomp$8 = "string" === typeof input ? "use-credentials" === input ? input : "" : void 0;
                    var headers = renderState.headers, header;
                    headers && 0 < headers.remainingCapacity && "string" !== typeof props.srcSet && ("high" === props.fetchPriority || 500 > headers.highImagePreloads.length) && (header = $274619feb1928437$var$getPreloadAsHeader(src, "image", {
                        imageSrcSet: props.srcSet,
                        imageSizes: props.sizes,
                        crossOrigin: JSCompiler_inline_result$jscomp$8,
                        integrity: props.integrity,
                        nonce: props.nonce,
                        type: props.type,
                        fetchPriority: props.fetchPriority,
                        referrerPolicy: props.refererPolicy
                    }), 0 <= (headers.remainingCapacity -= header.length + 2)) ? (renderState.resets.image[key$jscomp$0] = $274619feb1928437$var$PRELOAD_NO_CREDS, headers.highImagePreloads && (headers.highImagePreloads += ", "), headers.highImagePreloads += header) : (resource$jscomp$1 = [], $274619feb1928437$var$pushLinkImpl(resource$jscomp$1, {
                        rel: "preload",
                        as: "image",
                        href: srcSet ? void 0 : src,
                        imageSrcSet: srcSet,
                        imageSizes: sizes,
                        crossOrigin: JSCompiler_inline_result$jscomp$8,
                        integrity: props.integrity,
                        type: props.type,
                        fetchPriority: props.fetchPriority,
                        referrerPolicy: props.referrerPolicy
                    }), "high" === props.fetchPriority || 10 > renderState.highImagePreloads.size ? renderState.highImagePreloads.add(resource$jscomp$1) : (renderState.bulkPreloads.add(resource$jscomp$1), promotablePreloads.set(key$jscomp$0, resource$jscomp$1)));
                }
            }
            return $274619feb1928437$var$pushSelfClosing(target$jscomp$0, props, "img");
        case "base":
        case "area":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "param":
        case "source":
        case "track":
        case "wbr":
            return $274619feb1928437$var$pushSelfClosing(target$jscomp$0, props, type);
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            break;
        case "head":
            if (2 > formatContext.insertionMode) {
                var preamble = preambleState || renderState.preamble;
                if (preamble.headChunks) throw Error($274619feb1928437$var$formatProdErrorMessage(545, "`<head>`"));
                preamble.headChunks = [];
                var JSCompiler_inline_result$jscomp$9 = $274619feb1928437$var$pushStartSingletonElement(preamble.headChunks, props, "head");
            } else JSCompiler_inline_result$jscomp$9 = $274619feb1928437$var$pushStartGenericElement(target$jscomp$0, props, "head");
            return JSCompiler_inline_result$jscomp$9;
        case "body":
            if (2 > formatContext.insertionMode) {
                var preamble$jscomp$0 = preambleState || renderState.preamble;
                if (preamble$jscomp$0.bodyChunks) throw Error($274619feb1928437$var$formatProdErrorMessage(545, "`<body>`"));
                preamble$jscomp$0.bodyChunks = [];
                var JSCompiler_inline_result$jscomp$10 = $274619feb1928437$var$pushStartSingletonElement(preamble$jscomp$0.bodyChunks, props, "body");
            } else JSCompiler_inline_result$jscomp$10 = $274619feb1928437$var$pushStartGenericElement(target$jscomp$0, props, "body");
            return JSCompiler_inline_result$jscomp$10;
        case "html":
            if (0 === formatContext.insertionMode) {
                var preamble$jscomp$1 = preambleState || renderState.preamble;
                if (preamble$jscomp$1.htmlChunks) throw Error($274619feb1928437$var$formatProdErrorMessage(545, "`<html>`"));
                preamble$jscomp$1.htmlChunks = [
                    ""
                ];
                var JSCompiler_inline_result$jscomp$11 = $274619feb1928437$var$pushStartSingletonElement(preamble$jscomp$1.htmlChunks, props, "html");
            } else JSCompiler_inline_result$jscomp$11 = $274619feb1928437$var$pushStartGenericElement(target$jscomp$0, props, "html");
            return JSCompiler_inline_result$jscomp$11;
        default:
            if (-1 !== type.indexOf("-")) {
                target$jscomp$0.push($274619feb1928437$var$startChunkForTag(type));
                var children$jscomp$9 = null, innerHTML$jscomp$8 = null, propKey$jscomp$11;
                for(propKey$jscomp$11 in props)if ($274619feb1928437$var$hasOwnProperty.call(props, propKey$jscomp$11)) {
                    var propValue$jscomp$11 = props[propKey$jscomp$11];
                    if (null != propValue$jscomp$11) {
                        var attributeName = propKey$jscomp$11;
                        switch(propKey$jscomp$11){
                            case "children":
                                children$jscomp$9 = propValue$jscomp$11;
                                break;
                            case "dangerouslySetInnerHTML":
                                innerHTML$jscomp$8 = propValue$jscomp$11;
                                break;
                            case "style":
                                $274619feb1928437$var$pushStyleAttribute(target$jscomp$0, propValue$jscomp$11);
                                break;
                            case "suppressContentEditableWarning":
                            case "suppressHydrationWarning":
                            case "ref":
                                break;
                            case "className":
                                attributeName = "class";
                            default:
                                if ($274619feb1928437$var$isAttributeNameSafe(propKey$jscomp$11) && "function" !== typeof propValue$jscomp$11 && "symbol" !== typeof propValue$jscomp$11 && !1 !== propValue$jscomp$11) {
                                    if (!0 === propValue$jscomp$11) propValue$jscomp$11 = "";
                                    else if ("object" === typeof propValue$jscomp$11) continue;
                                    target$jscomp$0.push(" ", attributeName, '="', $274619feb1928437$var$escapeTextForBrowser(propValue$jscomp$11), '"');
                                }
                        }
                    }
                }
                target$jscomp$0.push(">");
                $274619feb1928437$var$pushInnerHTML(target$jscomp$0, innerHTML$jscomp$8, children$jscomp$9);
                return children$jscomp$9;
            }
    }
    return $274619feb1928437$var$pushStartGenericElement(target$jscomp$0, props, type);
}
var $274619feb1928437$var$endTagCache = new Map();
function $274619feb1928437$var$endChunkForTag(tag) {
    var chunk = $274619feb1928437$var$endTagCache.get(tag);
    void 0 === chunk && (chunk = "</" + tag + ">", $274619feb1928437$var$endTagCache.set(tag, chunk));
    return chunk;
}
function $274619feb1928437$var$hoistPreambleState(renderState, preambleState) {
    renderState = renderState.preamble;
    null === renderState.htmlChunks && preambleState.htmlChunks && (renderState.htmlChunks = preambleState.htmlChunks, preambleState.contribution |= 1);
    null === renderState.headChunks && preambleState.headChunks && (renderState.headChunks = preambleState.headChunks, preambleState.contribution |= 4);
    null === renderState.bodyChunks && preambleState.bodyChunks && (renderState.bodyChunks = preambleState.bodyChunks, preambleState.contribution |= 2);
}
function $274619feb1928437$var$writeBootstrap(destination, renderState) {
    renderState = renderState.bootstrapChunks;
    for(var i = 0; i < renderState.length - 1; i++)destination.push(renderState[i]);
    return i < renderState.length ? (i = renderState[i], renderState.length = 0, destination.push(i)) : !0;
}
function $274619feb1928437$var$writeStartPendingSuspenseBoundary(destination, renderState, id) {
    destination.push('\x3c!--$?--\x3e<template id="');
    if (null === id) throw Error($274619feb1928437$var$formatProdErrorMessage(395));
    destination.push(renderState.boundaryPrefix);
    renderState = id.toString(16);
    destination.push(renderState);
    return destination.push('"></template>');
}
function $274619feb1928437$var$writePreambleContribution(destination, preambleState) {
    preambleState = preambleState.contribution;
    0 !== preambleState && (destination.push("\x3c!--"), destination.push("" + preambleState), destination.push("--\x3e"));
}
function $274619feb1928437$var$writeStartSegment(destination, renderState, formatContext, id) {
    switch(formatContext.insertionMode){
        case 0:
        case 1:
        case 3:
        case 2:
            return destination.push('<div hidden id="'), destination.push(renderState.segmentPrefix), renderState = id.toString(16), destination.push(renderState), destination.push('">');
        case 4:
            return destination.push('<svg aria-hidden="true" style="display:none" id="'), destination.push(renderState.segmentPrefix), renderState = id.toString(16), destination.push(renderState), destination.push('">');
        case 5:
            return destination.push('<math aria-hidden="true" style="display:none" id="'), destination.push(renderState.segmentPrefix), renderState = id.toString(16), destination.push(renderState), destination.push('">');
        case 6:
            return destination.push('<table hidden id="'), destination.push(renderState.segmentPrefix), renderState = id.toString(16), destination.push(renderState), destination.push('">');
        case 7:
            return destination.push('<table hidden><tbody id="'), destination.push(renderState.segmentPrefix), renderState = id.toString(16), destination.push(renderState), destination.push('">');
        case 8:
            return destination.push('<table hidden><tr id="'), destination.push(renderState.segmentPrefix), renderState = id.toString(16), destination.push(renderState), destination.push('">');
        case 9:
            return destination.push('<table hidden><colgroup id="'), destination.push(renderState.segmentPrefix), renderState = id.toString(16), destination.push(renderState), destination.push('">');
        default:
            throw Error($274619feb1928437$var$formatProdErrorMessage(397));
    }
}
function $274619feb1928437$var$writeEndSegment(destination, formatContext) {
    switch(formatContext.insertionMode){
        case 0:
        case 1:
        case 3:
        case 2:
            return destination.push("</div>");
        case 4:
            return destination.push("</svg>");
        case 5:
            return destination.push("</math>");
        case 6:
            return destination.push("</table>");
        case 7:
            return destination.push("</tbody></table>");
        case 8:
            return destination.push("</tr></table>");
        case 9:
            return destination.push("</colgroup></table>");
        default:
            throw Error($274619feb1928437$var$formatProdErrorMessage(397));
    }
}
var $274619feb1928437$var$regexForJSStringsInInstructionScripts = /[<\u2028\u2029]/g;
function $274619feb1928437$var$escapeJSStringsForInstructionScripts(input) {
    return JSON.stringify(input).replace($274619feb1928437$var$regexForJSStringsInInstructionScripts, function(match) {
        switch(match){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var $274619feb1928437$var$regexForJSStringsInScripts = /[&><\u2028\u2029]/g;
function $274619feb1928437$var$escapeJSObjectForInstructionScripts(input) {
    return JSON.stringify(input).replace($274619feb1928437$var$regexForJSStringsInScripts, function(match) {
        switch(match){
            case "&":
                return "\\u0026";
            case ">":
                return "\\u003e";
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSObjectForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var $274619feb1928437$var$currentlyRenderingBoundaryHasStylesToHoist = !1, $274619feb1928437$var$destinationHasCapacity = !0;
function $274619feb1928437$var$flushStyleTagsLateForBoundary(styleQueue) {
    var rules = styleQueue.rules, hrefs = styleQueue.hrefs, i = 0;
    if (hrefs.length) {
        this.push('<style media="not all" data-precedence="');
        this.push(styleQueue.precedence);
        for(this.push('" data-href="'); i < hrefs.length - 1; i++)this.push(hrefs[i]), this.push(" ");
        this.push(hrefs[i]);
        this.push('">');
        for(i = 0; i < rules.length; i++)this.push(rules[i]);
        $274619feb1928437$var$destinationHasCapacity = this.push("</style>");
        $274619feb1928437$var$currentlyRenderingBoundaryHasStylesToHoist = !0;
        rules.length = 0;
        hrefs.length = 0;
    }
}
function $274619feb1928437$var$hasStylesToHoist(stylesheet) {
    return 2 !== stylesheet.state ? $274619feb1928437$var$currentlyRenderingBoundaryHasStylesToHoist = !0 : !1;
}
function $274619feb1928437$var$writeHoistablesForBoundary(destination, hoistableState, renderState) {
    $274619feb1928437$var$currentlyRenderingBoundaryHasStylesToHoist = !1;
    $274619feb1928437$var$destinationHasCapacity = !0;
    hoistableState.styles.forEach($274619feb1928437$var$flushStyleTagsLateForBoundary, destination);
    hoistableState.stylesheets.forEach($274619feb1928437$var$hasStylesToHoist);
    $274619feb1928437$var$currentlyRenderingBoundaryHasStylesToHoist && (renderState.stylesToHoist = !0);
    return $274619feb1928437$var$destinationHasCapacity;
}
function $274619feb1928437$var$flushResource(resource) {
    for(var i = 0; i < resource.length; i++)this.push(resource[i]);
    resource.length = 0;
}
var $274619feb1928437$var$stylesheetFlushingQueue = [];
function $274619feb1928437$var$flushStyleInPreamble(stylesheet) {
    $274619feb1928437$var$pushLinkImpl($274619feb1928437$var$stylesheetFlushingQueue, stylesheet.props);
    for(var i = 0; i < $274619feb1928437$var$stylesheetFlushingQueue.length; i++)this.push($274619feb1928437$var$stylesheetFlushingQueue[i]);
    $274619feb1928437$var$stylesheetFlushingQueue.length = 0;
    stylesheet.state = 2;
}
function $274619feb1928437$var$flushStylesInPreamble(styleQueue) {
    var hasStylesheets = 0 < styleQueue.sheets.size;
    styleQueue.sheets.forEach($274619feb1928437$var$flushStyleInPreamble, this);
    styleQueue.sheets.clear();
    var rules = styleQueue.rules, hrefs = styleQueue.hrefs;
    if (!hasStylesheets || hrefs.length) {
        this.push('<style data-precedence="');
        this.push(styleQueue.precedence);
        styleQueue = 0;
        if (hrefs.length) {
            for(this.push('" data-href="'); styleQueue < hrefs.length - 1; styleQueue++)this.push(hrefs[styleQueue]), this.push(" ");
            this.push(hrefs[styleQueue]);
        }
        this.push('">');
        for(styleQueue = 0; styleQueue < rules.length; styleQueue++)this.push(rules[styleQueue]);
        this.push("</style>");
        rules.length = 0;
        hrefs.length = 0;
    }
}
function $274619feb1928437$var$preloadLateStyle(stylesheet) {
    if (0 === stylesheet.state) {
        stylesheet.state = 1;
        var props = stylesheet.props;
        $274619feb1928437$var$pushLinkImpl($274619feb1928437$var$stylesheetFlushingQueue, {
            rel: "preload",
            as: "style",
            href: stylesheet.props.href,
            crossOrigin: props.crossOrigin,
            fetchPriority: props.fetchPriority,
            integrity: props.integrity,
            media: props.media,
            hrefLang: props.hrefLang,
            referrerPolicy: props.referrerPolicy
        });
        for(stylesheet = 0; stylesheet < $274619feb1928437$var$stylesheetFlushingQueue.length; stylesheet++)this.push($274619feb1928437$var$stylesheetFlushingQueue[stylesheet]);
        $274619feb1928437$var$stylesheetFlushingQueue.length = 0;
    }
}
function $274619feb1928437$var$preloadLateStyles(styleQueue) {
    styleQueue.sheets.forEach($274619feb1928437$var$preloadLateStyle, this);
    styleQueue.sheets.clear();
}
function $274619feb1928437$var$writeStyleResourceDependenciesInJS(destination, hoistableState) {
    destination.push("[");
    var nextArrayOpenBrackChunk = "[";
    hoistableState.stylesheets.forEach(function(resource) {
        if (2 !== resource.state) {
            if (3 === resource.state) destination.push(nextArrayOpenBrackChunk), resource = $274619feb1928437$var$escapeJSObjectForInstructionScripts("" + resource.props.href), destination.push(resource), destination.push("]"), nextArrayOpenBrackChunk = ",[";
            else {
                destination.push(nextArrayOpenBrackChunk);
                var precedence = resource.props["data-precedence"], props = resource.props, coercedHref = $274619feb1928437$var$sanitizeURL("" + resource.props.href);
                coercedHref = $274619feb1928437$var$escapeJSObjectForInstructionScripts(coercedHref);
                destination.push(coercedHref);
                precedence = "" + precedence;
                destination.push(",");
                precedence = $274619feb1928437$var$escapeJSObjectForInstructionScripts(precedence);
                destination.push(precedence);
                for(var propKey in props)if ($274619feb1928437$var$hasOwnProperty.call(props, propKey) && (precedence = props[propKey], null != precedence)) switch(propKey){
                    case "href":
                    case "rel":
                    case "precedence":
                    case "data-precedence":
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($274619feb1928437$var$formatProdErrorMessage(399, "link"));
                    default:
                        $274619feb1928437$var$writeStyleResourceAttributeInJS(destination, propKey, precedence);
                }
                destination.push("]");
                nextArrayOpenBrackChunk = ",[";
                resource.state = 3;
            }
        }
    });
    destination.push("]");
}
function $274619feb1928437$var$writeStyleResourceAttributeInJS(destination, name, value) {
    var attributeName = name.toLowerCase();
    switch(typeof value){
        case "function":
        case "symbol":
            return;
    }
    switch(name){
        case "innerHTML":
        case "dangerouslySetInnerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "style":
        case "ref":
            return;
        case "className":
            attributeName = "class";
            name = "" + value;
            break;
        case "hidden":
            if (!1 === value) return;
            name = "";
            break;
        case "src":
        case "href":
            value = $274619feb1928437$var$sanitizeURL(value);
            name = "" + value;
            break;
        default:
            if (2 < name.length && ("o" === name[0] || "O" === name[0]) && ("n" === name[1] || "N" === name[1]) || !$274619feb1928437$var$isAttributeNameSafe(name)) return;
            name = "" + value;
    }
    destination.push(",");
    attributeName = $274619feb1928437$var$escapeJSObjectForInstructionScripts(attributeName);
    destination.push(attributeName);
    destination.push(",");
    attributeName = $274619feb1928437$var$escapeJSObjectForInstructionScripts(name);
    destination.push(attributeName);
}
function $274619feb1928437$var$createHoistableState() {
    return {
        styles: new Set(),
        stylesheets: new Set()
    };
}
function $274619feb1928437$var$prefetchDNS(href) {
    var request = $274619feb1928437$var$currentRequest ? $274619feb1928437$var$currentRequest : null;
    if (request) {
        var resumableState = request.resumableState, renderState = request.renderState;
        if ("string" === typeof href && href) {
            if (!resumableState.dnsResources.hasOwnProperty(href)) {
                resumableState.dnsResources[href] = null;
                resumableState = renderState.headers;
                var header, JSCompiler_temp;
                if (JSCompiler_temp = resumableState && 0 < resumableState.remainingCapacity) JSCompiler_temp = (header = "<" + ("" + href).replace($274619feb1928437$var$regexForHrefInLinkHeaderURLContext, $274619feb1928437$var$escapeHrefForLinkHeaderURLContextReplacer) + ">; rel=dns-prefetch", 0 <= (resumableState.remainingCapacity -= header.length + 2));
                JSCompiler_temp ? (renderState.resets.dns[href] = null, resumableState.preconnects && (resumableState.preconnects += ", "), resumableState.preconnects += header) : (header = [], $274619feb1928437$var$pushLinkImpl(header, {
                    href: href,
                    rel: "dns-prefetch"
                }), renderState.preconnects.add(header));
            }
            $274619feb1928437$var$enqueueFlush(request);
        }
    } else $274619feb1928437$var$previousDispatcher.D(href);
}
function $274619feb1928437$var$preconnect(href, crossOrigin) {
    var request = $274619feb1928437$var$currentRequest ? $274619feb1928437$var$currentRequest : null;
    if (request) {
        var resumableState = request.resumableState, renderState = request.renderState;
        if ("string" === typeof href && href) {
            var bucket = "use-credentials" === crossOrigin ? "credentials" : "string" === typeof crossOrigin ? "anonymous" : "default";
            if (!resumableState.connectResources[bucket].hasOwnProperty(href)) {
                resumableState.connectResources[bucket][href] = null;
                resumableState = renderState.headers;
                var header, JSCompiler_temp;
                if (JSCompiler_temp = resumableState && 0 < resumableState.remainingCapacity) {
                    JSCompiler_temp = "<" + ("" + href).replace($274619feb1928437$var$regexForHrefInLinkHeaderURLContext, $274619feb1928437$var$escapeHrefForLinkHeaderURLContextReplacer) + ">; rel=preconnect";
                    if ("string" === typeof crossOrigin) {
                        var escapedCrossOrigin = ("" + crossOrigin).replace($274619feb1928437$var$regexForLinkHeaderQuotedParamValueContext, $274619feb1928437$var$escapeStringForLinkHeaderQuotedParamValueContextReplacer);
                        JSCompiler_temp += '; crossorigin="' + escapedCrossOrigin + '"';
                    }
                    JSCompiler_temp = (header = JSCompiler_temp, 0 <= (resumableState.remainingCapacity -= header.length + 2));
                }
                JSCompiler_temp ? (renderState.resets.connect[bucket][href] = null, resumableState.preconnects && (resumableState.preconnects += ", "), resumableState.preconnects += header) : (bucket = [], $274619feb1928437$var$pushLinkImpl(bucket, {
                    rel: "preconnect",
                    href: href,
                    crossOrigin: crossOrigin
                }), renderState.preconnects.add(bucket));
            }
            $274619feb1928437$var$enqueueFlush(request);
        }
    } else $274619feb1928437$var$previousDispatcher.C(href, crossOrigin);
}
function $274619feb1928437$var$preload(href, as, options) {
    var request = $274619feb1928437$var$currentRequest ? $274619feb1928437$var$currentRequest : null;
    if (request) {
        var resumableState = request.resumableState, renderState = request.renderState;
        if (as && href) {
            switch(as){
                case "image":
                    if (options) {
                        var imageSrcSet = options.imageSrcSet;
                        var imageSizes = options.imageSizes;
                        var fetchPriority = options.fetchPriority;
                    }
                    var key = imageSrcSet ? imageSrcSet + "\n" + (imageSizes || "") : href;
                    if (resumableState.imageResources.hasOwnProperty(key)) return;
                    resumableState.imageResources[key] = $274619feb1928437$var$PRELOAD_NO_CREDS;
                    resumableState = renderState.headers;
                    var header;
                    resumableState && 0 < resumableState.remainingCapacity && "string" !== typeof imageSrcSet && "high" === fetchPriority && (header = $274619feb1928437$var$getPreloadAsHeader(href, as, options), 0 <= (resumableState.remainingCapacity -= header.length + 2)) ? (renderState.resets.image[key] = $274619feb1928437$var$PRELOAD_NO_CREDS, resumableState.highImagePreloads && (resumableState.highImagePreloads += ", "), resumableState.highImagePreloads += header) : (resumableState = [], $274619feb1928437$var$pushLinkImpl(resumableState, $274619feb1928437$var$assign({
                        rel: "preload",
                        href: imageSrcSet ? void 0 : href,
                        as: as
                    }, options)), "high" === fetchPriority ? renderState.highImagePreloads.add(resumableState) : (renderState.bulkPreloads.add(resumableState), renderState.preloads.images.set(key, resumableState)));
                    break;
                case "style":
                    if (resumableState.styleResources.hasOwnProperty(href)) return;
                    imageSrcSet = [];
                    $274619feb1928437$var$pushLinkImpl(imageSrcSet, $274619feb1928437$var$assign({
                        rel: "preload",
                        href: href,
                        as: as
                    }, options));
                    resumableState.styleResources[href] = !options || "string" !== typeof options.crossOrigin && "string" !== typeof options.integrity ? $274619feb1928437$var$PRELOAD_NO_CREDS : [
                        options.crossOrigin,
                        options.integrity
                    ];
                    renderState.preloads.stylesheets.set(href, imageSrcSet);
                    renderState.bulkPreloads.add(imageSrcSet);
                    break;
                case "script":
                    if (resumableState.scriptResources.hasOwnProperty(href)) return;
                    imageSrcSet = [];
                    renderState.preloads.scripts.set(href, imageSrcSet);
                    renderState.bulkPreloads.add(imageSrcSet);
                    $274619feb1928437$var$pushLinkImpl(imageSrcSet, $274619feb1928437$var$assign({
                        rel: "preload",
                        href: href,
                        as: as
                    }, options));
                    resumableState.scriptResources[href] = !options || "string" !== typeof options.crossOrigin && "string" !== typeof options.integrity ? $274619feb1928437$var$PRELOAD_NO_CREDS : [
                        options.crossOrigin,
                        options.integrity
                    ];
                    break;
                default:
                    if (resumableState.unknownResources.hasOwnProperty(as)) {
                        if (imageSrcSet = resumableState.unknownResources[as], imageSrcSet.hasOwnProperty(href)) return;
                    } else imageSrcSet = {}, resumableState.unknownResources[as] = imageSrcSet;
                    imageSrcSet[href] = $274619feb1928437$var$PRELOAD_NO_CREDS;
                    if ((resumableState = renderState.headers) && 0 < resumableState.remainingCapacity && "font" === as && (key = $274619feb1928437$var$getPreloadAsHeader(href, as, options), 0 <= (resumableState.remainingCapacity -= key.length + 2))) renderState.resets.font[href] = $274619feb1928437$var$PRELOAD_NO_CREDS, resumableState.fontPreloads && (resumableState.fontPreloads += ", "), resumableState.fontPreloads += key;
                    else switch(resumableState = [], href = $274619feb1928437$var$assign({
                        rel: "preload",
                        href: href,
                        as: as
                    }, options), $274619feb1928437$var$pushLinkImpl(resumableState, href), as){
                        case "font":
                            renderState.fontPreloads.add(resumableState);
                            break;
                        default:
                            renderState.bulkPreloads.add(resumableState);
                    }
            }
            $274619feb1928437$var$enqueueFlush(request);
        }
    } else $274619feb1928437$var$previousDispatcher.L(href, as, options);
}
function $274619feb1928437$var$preloadModule(href, options) {
    var request = $274619feb1928437$var$currentRequest ? $274619feb1928437$var$currentRequest : null;
    if (request) {
        var resumableState = request.resumableState, renderState = request.renderState;
        if (href) {
            var as = options && "string" === typeof options.as ? options.as : "script";
            switch(as){
                case "script":
                    if (resumableState.moduleScriptResources.hasOwnProperty(href)) return;
                    as = [];
                    resumableState.moduleScriptResources[href] = !options || "string" !== typeof options.crossOrigin && "string" !== typeof options.integrity ? $274619feb1928437$var$PRELOAD_NO_CREDS : [
                        options.crossOrigin,
                        options.integrity
                    ];
                    renderState.preloads.moduleScripts.set(href, as);
                    break;
                default:
                    if (resumableState.moduleUnknownResources.hasOwnProperty(as)) {
                        var resources = resumableState.unknownResources[as];
                        if (resources.hasOwnProperty(href)) return;
                    } else resources = {}, resumableState.moduleUnknownResources[as] = resources;
                    as = [];
                    resources[href] = $274619feb1928437$var$PRELOAD_NO_CREDS;
            }
            $274619feb1928437$var$pushLinkImpl(as, $274619feb1928437$var$assign({
                rel: "modulepreload",
                href: href
            }, options));
            renderState.bulkPreloads.add(as);
            $274619feb1928437$var$enqueueFlush(request);
        }
    } else $274619feb1928437$var$previousDispatcher.m(href, options);
}
function $274619feb1928437$var$preinitStyle(href, precedence, options) {
    var request = $274619feb1928437$var$currentRequest ? $274619feb1928437$var$currentRequest : null;
    if (request) {
        var resumableState = request.resumableState, renderState = request.renderState;
        if (href) {
            precedence = precedence || "default";
            var styleQueue = renderState.styles.get(precedence), resourceState = resumableState.styleResources.hasOwnProperty(href) ? resumableState.styleResources[href] : void 0;
            null !== resourceState && (resumableState.styleResources[href] = null, styleQueue || (styleQueue = {
                precedence: $274619feb1928437$var$escapeTextForBrowser(precedence),
                rules: [],
                hrefs: [],
                sheets: new Map()
            }, renderState.styles.set(precedence, styleQueue)), precedence = {
                state: 0,
                props: $274619feb1928437$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options)
            }, resourceState && (2 === resourceState.length && $274619feb1928437$var$adoptPreloadCredentials(precedence.props, resourceState), (renderState = renderState.preloads.stylesheets.get(href)) && 0 < renderState.length ? renderState.length = 0 : precedence.state = 1), styleQueue.sheets.set(href, precedence), $274619feb1928437$var$enqueueFlush(request));
        }
    } else $274619feb1928437$var$previousDispatcher.S(href, precedence, options);
}
function $274619feb1928437$var$preinitScript(src, options) {
    var request = $274619feb1928437$var$currentRequest ? $274619feb1928437$var$currentRequest : null;
    if (request) {
        var resumableState = request.resumableState, renderState = request.renderState;
        if (src) {
            var resourceState = resumableState.scriptResources.hasOwnProperty(src) ? resumableState.scriptResources[src] : void 0;
            null !== resourceState && (resumableState.scriptResources[src] = null, options = $274619feb1928437$var$assign({
                src: src,
                async: !0
            }, options), resourceState && (2 === resourceState.length && $274619feb1928437$var$adoptPreloadCredentials(options, resourceState), src = renderState.preloads.scripts.get(src)) && (src.length = 0), src = [], renderState.scripts.add(src), $274619feb1928437$var$pushScriptImpl(src, options), $274619feb1928437$var$enqueueFlush(request));
        }
    } else $274619feb1928437$var$previousDispatcher.X(src, options);
}
function $274619feb1928437$var$preinitModuleScript(src, options) {
    var request = $274619feb1928437$var$currentRequest ? $274619feb1928437$var$currentRequest : null;
    if (request) {
        var resumableState = request.resumableState, renderState = request.renderState;
        if (src) {
            var resourceState = resumableState.moduleScriptResources.hasOwnProperty(src) ? resumableState.moduleScriptResources[src] : void 0;
            null !== resourceState && (resumableState.moduleScriptResources[src] = null, options = $274619feb1928437$var$assign({
                src: src,
                type: "module",
                async: !0
            }, options), resourceState && (2 === resourceState.length && $274619feb1928437$var$adoptPreloadCredentials(options, resourceState), src = renderState.preloads.moduleScripts.get(src)) && (src.length = 0), src = [], renderState.scripts.add(src), $274619feb1928437$var$pushScriptImpl(src, options), $274619feb1928437$var$enqueueFlush(request));
        }
    } else $274619feb1928437$var$previousDispatcher.M(src, options);
}
function $274619feb1928437$var$adoptPreloadCredentials(target, preloadState) {
    null == target.crossOrigin && (target.crossOrigin = preloadState[0]);
    null == target.integrity && (target.integrity = preloadState[1]);
}
function $274619feb1928437$var$getPreloadAsHeader(href, as, params) {
    href = ("" + href).replace($274619feb1928437$var$regexForHrefInLinkHeaderURLContext, $274619feb1928437$var$escapeHrefForLinkHeaderURLContextReplacer);
    as = ("" + as).replace($274619feb1928437$var$regexForLinkHeaderQuotedParamValueContext, $274619feb1928437$var$escapeStringForLinkHeaderQuotedParamValueContextReplacer);
    as = "<" + href + '>; rel=preload; as="' + as + '"';
    for(var paramName in params)$274619feb1928437$var$hasOwnProperty.call(params, paramName) && (href = params[paramName], "string" === typeof href && (as += "; " + paramName.toLowerCase() + '="' + ("" + href).replace($274619feb1928437$var$regexForLinkHeaderQuotedParamValueContext, $274619feb1928437$var$escapeStringForLinkHeaderQuotedParamValueContextReplacer) + '"'));
    return as;
}
var $274619feb1928437$var$regexForHrefInLinkHeaderURLContext = /[<>\r\n]/g;
function $274619feb1928437$var$escapeHrefForLinkHeaderURLContextReplacer(match) {
    switch(match){
        case "<":
            return "%3C";
        case ">":
            return "%3E";
        case "\n":
            return "%0A";
        case "\r":
            return "%0D";
        default:
            throw Error("escapeLinkHrefForHeaderContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
    }
}
var $274619feb1928437$var$regexForLinkHeaderQuotedParamValueContext = /["';,\r\n]/g;
function $274619feb1928437$var$escapeStringForLinkHeaderQuotedParamValueContextReplacer(match) {
    switch(match){
        case '"':
            return "%22";
        case "'":
            return "%27";
        case ";":
            return "%3B";
        case ",":
            return "%2C";
        case "\n":
            return "%0A";
        case "\r":
            return "%0D";
        default:
            throw Error("escapeStringForLinkHeaderQuotedParamValueContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
    }
}
function $274619feb1928437$var$hoistStyleQueueDependency(styleQueue) {
    this.styles.add(styleQueue);
}
function $274619feb1928437$var$hoistStylesheetDependency(stylesheet) {
    this.stylesheets.add(stylesheet);
}
function $274619feb1928437$var$createRenderState(resumableState, generateStaticMarkup) {
    var idPrefix = resumableState.idPrefix, bootstrapChunks = [], bootstrapScriptContent = resumableState.bootstrapScriptContent, bootstrapScripts = resumableState.bootstrapScripts, bootstrapModules = resumableState.bootstrapModules;
    void 0 !== bootstrapScriptContent && bootstrapChunks.push("<script>", ("" + bootstrapScriptContent).replace($274619feb1928437$var$scriptRegex, $274619feb1928437$var$scriptReplacer), "\x3c/script>");
    bootstrapScriptContent = idPrefix + "P:";
    var JSCompiler_object_inline_segmentPrefix_1542 = idPrefix + "S:";
    idPrefix += "B:";
    var JSCompiler_object_inline_preamble_1545 = $274619feb1928437$var$createPreambleState(), JSCompiler_object_inline_preconnects_1555 = new Set(), JSCompiler_object_inline_fontPreloads_1556 = new Set(), JSCompiler_object_inline_highImagePreloads_1557 = new Set(), JSCompiler_object_inline_styles_1558 = new Map(), JSCompiler_object_inline_bootstrapScripts_1559 = new Set(), JSCompiler_object_inline_scripts_1560 = new Set(), JSCompiler_object_inline_bulkPreloads_1561 = new Set(), JSCompiler_object_inline_preloads_1562 = {
        images: new Map(),
        stylesheets: new Map(),
        scripts: new Map(),
        moduleScripts: new Map()
    };
    if (void 0 !== bootstrapScripts) for(var i = 0; i < bootstrapScripts.length; i++){
        var scriptConfig = bootstrapScripts[i], src, crossOrigin = void 0, integrity = void 0, props = {
            rel: "preload",
            as: "script",
            fetchPriority: "low",
            nonce: void 0
        };
        "string" === typeof scriptConfig ? props.href = src = scriptConfig : (props.href = src = scriptConfig.src, props.integrity = integrity = "string" === typeof scriptConfig.integrity ? scriptConfig.integrity : void 0, props.crossOrigin = crossOrigin = "string" === typeof scriptConfig || null == scriptConfig.crossOrigin ? void 0 : "use-credentials" === scriptConfig.crossOrigin ? "use-credentials" : "");
        scriptConfig = resumableState;
        var href = src;
        scriptConfig.scriptResources[href] = null;
        scriptConfig.moduleScriptResources[href] = null;
        scriptConfig = [];
        $274619feb1928437$var$pushLinkImpl(scriptConfig, props);
        JSCompiler_object_inline_bootstrapScripts_1559.add(scriptConfig);
        bootstrapChunks.push('<script src="', $274619feb1928437$var$escapeTextForBrowser(src));
        "string" === typeof integrity && bootstrapChunks.push('" integrity="', $274619feb1928437$var$escapeTextForBrowser(integrity));
        "string" === typeof crossOrigin && bootstrapChunks.push('" crossorigin="', $274619feb1928437$var$escapeTextForBrowser(crossOrigin));
        bootstrapChunks.push('" async="">\x3c/script>');
    }
    if (void 0 !== bootstrapModules) for(bootstrapScripts = 0; bootstrapScripts < bootstrapModules.length; bootstrapScripts++)props = bootstrapModules[bootstrapScripts], crossOrigin = src = void 0, integrity = {
        rel: "modulepreload",
        fetchPriority: "low",
        nonce: void 0
    }, "string" === typeof props ? integrity.href = i = props : (integrity.href = i = props.src, integrity.integrity = crossOrigin = "string" === typeof props.integrity ? props.integrity : void 0, integrity.crossOrigin = src = "string" === typeof props || null == props.crossOrigin ? void 0 : "use-credentials" === props.crossOrigin ? "use-credentials" : ""), props = resumableState, scriptConfig = i, props.scriptResources[scriptConfig] = null, props.moduleScriptResources[scriptConfig] = null, props = [], $274619feb1928437$var$pushLinkImpl(props, integrity), JSCompiler_object_inline_bootstrapScripts_1559.add(props), bootstrapChunks.push('<script type="module" src="', $274619feb1928437$var$escapeTextForBrowser(i)), "string" === typeof crossOrigin && bootstrapChunks.push('" integrity="', $274619feb1928437$var$escapeTextForBrowser(crossOrigin)), "string" === typeof src && bootstrapChunks.push('" crossorigin="', $274619feb1928437$var$escapeTextForBrowser(src)), bootstrapChunks.push('" async="">\x3c/script>');
    return {
        placeholderPrefix: bootstrapScriptContent,
        segmentPrefix: JSCompiler_object_inline_segmentPrefix_1542,
        boundaryPrefix: idPrefix,
        startInlineScript: "<script>",
        preamble: JSCompiler_object_inline_preamble_1545,
        externalRuntimeScript: null,
        bootstrapChunks: bootstrapChunks,
        importMapChunks: [],
        onHeaders: void 0,
        headers: null,
        resets: {
            font: {},
            dns: {},
            connect: {
                default: {},
                anonymous: {},
                credentials: {}
            },
            image: {},
            style: {}
        },
        charsetChunks: [],
        viewportChunks: [],
        hoistableChunks: [],
        preconnects: JSCompiler_object_inline_preconnects_1555,
        fontPreloads: JSCompiler_object_inline_fontPreloads_1556,
        highImagePreloads: JSCompiler_object_inline_highImagePreloads_1557,
        styles: JSCompiler_object_inline_styles_1558,
        bootstrapScripts: JSCompiler_object_inline_bootstrapScripts_1559,
        scripts: JSCompiler_object_inline_scripts_1560,
        bulkPreloads: JSCompiler_object_inline_bulkPreloads_1561,
        preloads: JSCompiler_object_inline_preloads_1562,
        stylesToHoist: !1,
        generateStaticMarkup: generateStaticMarkup
    };
}
function $274619feb1928437$var$pushTextInstance(target, text, renderState, textEmbedded) {
    if (renderState.generateStaticMarkup) return target.push($274619feb1928437$var$escapeTextForBrowser(text)), !1;
    "" === text ? target = textEmbedded : (textEmbedded && target.push("\x3c!-- --\x3e"), target.push($274619feb1928437$var$escapeTextForBrowser(text)), target = !0);
    return target;
}
function $274619feb1928437$var$pushSegmentFinale(target, renderState, lastPushedText, textEmbedded) {
    renderState.generateStaticMarkup || lastPushedText && textEmbedded && target.push("\x3c!-- --\x3e");
}
var $274619feb1928437$var$bind = Function.prototype.bind, $274619feb1928437$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $274619feb1928437$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $274619feb1928437$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $274619feb1928437$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $274619feb1928437$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $274619feb1928437$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $274619feb1928437$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $274619feb1928437$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $274619feb1928437$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $274619feb1928437$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $274619feb1928437$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $274619feb1928437$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $274619feb1928437$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $274619feb1928437$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $274619feb1928437$var$getComponentNameFromType(type.type) || "Memo";
        case $274619feb1928437$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $274619feb1928437$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $274619feb1928437$var$emptyContextObject = {}, $274619feb1928437$var$currentActiveSnapshot = null;
function $274619feb1928437$var$popToNearestCommonAncestor(prev, next) {
    if (prev !== next) {
        prev.context._currentValue2 = prev.parentValue;
        prev = prev.parent;
        var parentNext = next.parent;
        if (null === prev) {
            if (null !== parentNext) throw Error($274619feb1928437$var$formatProdErrorMessage(401));
        } else {
            if (null === parentNext) throw Error($274619feb1928437$var$formatProdErrorMessage(401));
            $274619feb1928437$var$popToNearestCommonAncestor(prev, parentNext);
        }
        next.context._currentValue2 = next.value;
    }
}
function $274619feb1928437$var$popAllPrevious(prev) {
    prev.context._currentValue2 = prev.parentValue;
    prev = prev.parent;
    null !== prev && $274619feb1928437$var$popAllPrevious(prev);
}
function $274619feb1928437$var$pushAllNext(next) {
    var parentNext = next.parent;
    null !== parentNext && $274619feb1928437$var$pushAllNext(parentNext);
    next.context._currentValue2 = next.value;
}
function $274619feb1928437$var$popPreviousToCommonLevel(prev, next) {
    prev.context._currentValue2 = prev.parentValue;
    prev = prev.parent;
    if (null === prev) throw Error($274619feb1928437$var$formatProdErrorMessage(402));
    prev.depth === next.depth ? $274619feb1928437$var$popToNearestCommonAncestor(prev, next) : $274619feb1928437$var$popPreviousToCommonLevel(prev, next);
}
function $274619feb1928437$var$popNextToCommonLevel(prev, next) {
    var parentNext = next.parent;
    if (null === parentNext) throw Error($274619feb1928437$var$formatProdErrorMessage(402));
    prev.depth === parentNext.depth ? $274619feb1928437$var$popToNearestCommonAncestor(prev, parentNext) : $274619feb1928437$var$popNextToCommonLevel(prev, parentNext);
    next.context._currentValue2 = next.value;
}
function $274619feb1928437$var$switchContext(newSnapshot) {
    var prev = $274619feb1928437$var$currentActiveSnapshot;
    prev !== newSnapshot && (null === prev ? $274619feb1928437$var$pushAllNext(newSnapshot) : null === newSnapshot ? $274619feb1928437$var$popAllPrevious(prev) : prev.depth === newSnapshot.depth ? $274619feb1928437$var$popToNearestCommonAncestor(prev, newSnapshot) : prev.depth > newSnapshot.depth ? $274619feb1928437$var$popPreviousToCommonLevel(prev, newSnapshot) : $274619feb1928437$var$popNextToCommonLevel(prev, newSnapshot), $274619feb1928437$var$currentActiveSnapshot = newSnapshot);
}
var $274619feb1928437$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload) {
        inst = inst._reactInternals;
        null !== inst.queue && inst.queue.push(payload);
    },
    enqueueReplaceState: function(inst, payload) {
        inst = inst._reactInternals;
        inst.replace = !0;
        inst.queue = [
            payload
        ];
    },
    enqueueForceUpdate: function() {}
}, $274619feb1928437$var$emptyTreeContext = {
    id: 1,
    overflow: ""
};
function $274619feb1928437$var$pushTreeContext(baseContext, totalChildren, index) {
    var baseIdWithLeadingBit = baseContext.id;
    baseContext = baseContext.overflow;
    var baseLength = 32 - $274619feb1928437$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $274619feb1928437$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        return {
            id: 1 << 32 - $274619feb1928437$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit,
            overflow: length + baseContext
        };
    }
    return {
        id: 1 << length | index << baseLength | baseIdWithLeadingBit,
        overflow: baseContext
    };
}
var $274619feb1928437$var$clz32 = Math.clz32 ? Math.clz32 : $274619feb1928437$var$clz32Fallback, $274619feb1928437$var$log = Math.log, $274619feb1928437$var$LN2 = Math.LN2;
function $274619feb1928437$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($274619feb1928437$var$log(x) / $274619feb1928437$var$LN2 | 0) | 0;
}
var $274619feb1928437$var$SuspenseException = Error($274619feb1928437$var$formatProdErrorMessage(460));
function $274619feb1928437$var$noop$2() {}
function $274619feb1928437$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($274619feb1928437$var$noop$2, $274619feb1928437$var$noop$2), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            "string" === typeof thenable.status ? thenable.then($274619feb1928437$var$noop$2, $274619feb1928437$var$noop$2) : (thenableState = thenable, thenableState.status = "pending", thenableState.then(function(fulfilledValue) {
                if ("pending" === thenable.status) {
                    var fulfilledThenable = thenable;
                    fulfilledThenable.status = "fulfilled";
                    fulfilledThenable.value = fulfilledValue;
                }
            }, function(error) {
                if ("pending" === thenable.status) {
                    var rejectedThenable = thenable;
                    rejectedThenable.status = "rejected";
                    rejectedThenable.reason = error;
                }
            }));
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
            $274619feb1928437$var$suspendedThenable = thenable;
            throw $274619feb1928437$var$SuspenseException;
    }
}
var $274619feb1928437$var$suspendedThenable = null;
function $274619feb1928437$var$getSuspendedThenable() {
    if (null === $274619feb1928437$var$suspendedThenable) throw Error($274619feb1928437$var$formatProdErrorMessage(459));
    var thenable = $274619feb1928437$var$suspendedThenable;
    $274619feb1928437$var$suspendedThenable = null;
    return thenable;
}
function $274619feb1928437$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $274619feb1928437$var$objectIs = "function" === typeof Object.is ? Object.is : $274619feb1928437$var$is, $274619feb1928437$var$currentlyRenderingComponent = null, $274619feb1928437$var$currentlyRenderingTask = null, $274619feb1928437$var$currentlyRenderingRequest = null, $274619feb1928437$var$currentlyRenderingKeyPath = null, $274619feb1928437$var$firstWorkInProgressHook = null, $274619feb1928437$var$workInProgressHook = null, $274619feb1928437$var$isReRender = !1, $274619feb1928437$var$didScheduleRenderPhaseUpdate = !1, $274619feb1928437$var$localIdCounter = 0, $274619feb1928437$var$actionStateCounter = 0, $274619feb1928437$var$actionStateMatchingIndex = -1, $274619feb1928437$var$thenableIndexCounter = 0, $274619feb1928437$var$thenableState = null, $274619feb1928437$var$renderPhaseUpdates = null, $274619feb1928437$var$numberOfReRenders = 0;
function $274619feb1928437$var$resolveCurrentlyRenderingComponent() {
    if (null === $274619feb1928437$var$currentlyRenderingComponent) throw Error($274619feb1928437$var$formatProdErrorMessage(321));
    return $274619feb1928437$var$currentlyRenderingComponent;
}
function $274619feb1928437$var$createHook() {
    if (0 < $274619feb1928437$var$numberOfReRenders) throw Error($274619feb1928437$var$formatProdErrorMessage(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $274619feb1928437$var$createWorkInProgressHook() {
    null === $274619feb1928437$var$workInProgressHook ? null === $274619feb1928437$var$firstWorkInProgressHook ? ($274619feb1928437$var$isReRender = !1, $274619feb1928437$var$firstWorkInProgressHook = $274619feb1928437$var$workInProgressHook = $274619feb1928437$var$createHook()) : ($274619feb1928437$var$isReRender = !0, $274619feb1928437$var$workInProgressHook = $274619feb1928437$var$firstWorkInProgressHook) : null === $274619feb1928437$var$workInProgressHook.next ? ($274619feb1928437$var$isReRender = !1, $274619feb1928437$var$workInProgressHook = $274619feb1928437$var$workInProgressHook.next = $274619feb1928437$var$createHook()) : ($274619feb1928437$var$isReRender = !0, $274619feb1928437$var$workInProgressHook = $274619feb1928437$var$workInProgressHook.next);
    return $274619feb1928437$var$workInProgressHook;
}
function $274619feb1928437$var$getThenableStateAfterSuspending() {
    var state = $274619feb1928437$var$thenableState;
    $274619feb1928437$var$thenableState = null;
    return state;
}
function $274619feb1928437$var$resetHooksState() {
    $274619feb1928437$var$currentlyRenderingKeyPath = $274619feb1928437$var$currentlyRenderingRequest = $274619feb1928437$var$currentlyRenderingTask = $274619feb1928437$var$currentlyRenderingComponent = null;
    $274619feb1928437$var$didScheduleRenderPhaseUpdate = !1;
    $274619feb1928437$var$firstWorkInProgressHook = null;
    $274619feb1928437$var$numberOfReRenders = 0;
    $274619feb1928437$var$workInProgressHook = $274619feb1928437$var$renderPhaseUpdates = null;
}
function $274619feb1928437$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $274619feb1928437$var$useReducer(reducer, initialArg, init) {
    $274619feb1928437$var$currentlyRenderingComponent = $274619feb1928437$var$resolveCurrentlyRenderingComponent();
    $274619feb1928437$var$workInProgressHook = $274619feb1928437$var$createWorkInProgressHook();
    if ($274619feb1928437$var$isReRender) {
        var queue = $274619feb1928437$var$workInProgressHook.queue;
        initialArg = queue.dispatch;
        if (null !== $274619feb1928437$var$renderPhaseUpdates && (init = $274619feb1928437$var$renderPhaseUpdates.get(queue), void 0 !== init)) {
            $274619feb1928437$var$renderPhaseUpdates.delete(queue);
            queue = $274619feb1928437$var$workInProgressHook.memoizedState;
            do queue = reducer(queue, init.action), init = init.next;
            while (null !== init);
            $274619feb1928437$var$workInProgressHook.memoizedState = queue;
            return [
                queue,
                initialArg
            ];
        }
        return [
            $274619feb1928437$var$workInProgressHook.memoizedState,
            initialArg
        ];
    }
    reducer = reducer === $274619feb1928437$var$basicStateReducer ? "function" === typeof initialArg ? initialArg() : initialArg : void 0 !== init ? init(initialArg) : initialArg;
    $274619feb1928437$var$workInProgressHook.memoizedState = reducer;
    reducer = $274619feb1928437$var$workInProgressHook.queue = {
        last: null,
        dispatch: null
    };
    reducer = reducer.dispatch = $274619feb1928437$var$dispatchAction.bind(null, $274619feb1928437$var$currentlyRenderingComponent, reducer);
    return [
        $274619feb1928437$var$workInProgressHook.memoizedState,
        reducer
    ];
}
function $274619feb1928437$var$useMemo(nextCreate, deps) {
    $274619feb1928437$var$currentlyRenderingComponent = $274619feb1928437$var$resolveCurrentlyRenderingComponent();
    $274619feb1928437$var$workInProgressHook = $274619feb1928437$var$createWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    if (null !== $274619feb1928437$var$workInProgressHook) {
        var prevState = $274619feb1928437$var$workInProgressHook.memoizedState;
        if (null !== prevState && null !== deps) {
            var prevDeps = prevState[1];
            a: if (null === prevDeps) prevDeps = !1;
            else {
                for(var i = 0; i < prevDeps.length && i < deps.length; i++)if (!$274619feb1928437$var$objectIs(deps[i], prevDeps[i])) {
                    prevDeps = !1;
                    break a;
                }
                prevDeps = !0;
            }
            if (prevDeps) return prevState[0];
        }
    }
    nextCreate = nextCreate();
    $274619feb1928437$var$workInProgressHook.memoizedState = [
        nextCreate,
        deps
    ];
    return nextCreate;
}
function $274619feb1928437$var$dispatchAction(componentIdentity, queue, action) {
    if (25 <= $274619feb1928437$var$numberOfReRenders) throw Error($274619feb1928437$var$formatProdErrorMessage(301));
    if (componentIdentity === $274619feb1928437$var$currentlyRenderingComponent) {
        if ($274619feb1928437$var$didScheduleRenderPhaseUpdate = !0, componentIdentity = {
            action: action,
            next: null
        }, null === $274619feb1928437$var$renderPhaseUpdates && ($274619feb1928437$var$renderPhaseUpdates = new Map()), action = $274619feb1928437$var$renderPhaseUpdates.get(queue), void 0 === action) $274619feb1928437$var$renderPhaseUpdates.set(queue, componentIdentity);
        else {
            for(queue = action; null !== queue.next;)queue = queue.next;
            queue.next = componentIdentity;
        }
    }
}
function $274619feb1928437$var$unsupportedStartTransition() {
    throw Error($274619feb1928437$var$formatProdErrorMessage(394));
}
function $274619feb1928437$var$unsupportedSetOptimisticState() {
    throw Error($274619feb1928437$var$formatProdErrorMessage(479));
}
function $274619feb1928437$var$useActionState(action, initialState, permalink) {
    $274619feb1928437$var$resolveCurrentlyRenderingComponent();
    var actionStateHookIndex = $274619feb1928437$var$actionStateCounter++, request = $274619feb1928437$var$currentlyRenderingRequest;
    if ("function" === typeof action.$$FORM_ACTION) {
        var nextPostbackStateKey = null, componentKeyPath = $274619feb1928437$var$currentlyRenderingKeyPath;
        request = request.formState;
        var isSignatureEqual = action.$$IS_SIGNATURE_EQUAL;
        if (null !== request && "function" === typeof isSignatureEqual) {
            var postbackKey = request[1];
            isSignatureEqual.call(action, request[2], request[3]) && (nextPostbackStateKey = void 0 !== permalink ? "p" + permalink : "k" + $274619feb1928437$var$murmurhash3_32_gc(JSON.stringify([
                componentKeyPath,
                null,
                actionStateHookIndex
            ]), 0), postbackKey === nextPostbackStateKey && ($274619feb1928437$var$actionStateMatchingIndex = actionStateHookIndex, initialState = request[0]));
        }
        var boundAction = action.bind(null, initialState);
        action = function(payload) {
            boundAction(payload);
        };
        "function" === typeof boundAction.$$FORM_ACTION && (action.$$FORM_ACTION = function(prefix) {
            prefix = boundAction.$$FORM_ACTION(prefix);
            void 0 !== permalink && (permalink += "", prefix.action = permalink);
            var formData = prefix.data;
            formData && (null === nextPostbackStateKey && (nextPostbackStateKey = void 0 !== permalink ? "p" + permalink : "k" + $274619feb1928437$var$murmurhash3_32_gc(JSON.stringify([
                componentKeyPath,
                null,
                actionStateHookIndex
            ]), 0)), formData.append("$ACTION_KEY", nextPostbackStateKey));
            return prefix;
        });
        return [
            initialState,
            action,
            !1
        ];
    }
    var boundAction$22 = action.bind(null, initialState);
    return [
        initialState,
        function(payload) {
            boundAction$22(payload);
        },
        !1
    ];
}
function $274619feb1928437$var$unwrapThenable(thenable) {
    var index = $274619feb1928437$var$thenableIndexCounter;
    $274619feb1928437$var$thenableIndexCounter += 1;
    null === $274619feb1928437$var$thenableState && ($274619feb1928437$var$thenableState = []);
    return $274619feb1928437$var$trackUsedThenable($274619feb1928437$var$thenableState, thenable, index);
}
function $274619feb1928437$var$unsupportedRefresh() {
    throw Error($274619feb1928437$var$formatProdErrorMessage(393));
}
function $274619feb1928437$var$noop$1() {}
var $274619feb1928437$var$HooksDispatcher = {
    readContext: function(context) {
        return context._currentValue2;
    },
    use: function(usable) {
        if (null !== usable && "object" === typeof usable) {
            if ("function" === typeof usable.then) return $274619feb1928437$var$unwrapThenable(usable);
            if (usable.$$typeof === $274619feb1928437$var$REACT_CONTEXT_TYPE) return usable._currentValue2;
        }
        throw Error($274619feb1928437$var$formatProdErrorMessage(438, String(usable)));
    },
    useContext: function(context) {
        $274619feb1928437$var$resolveCurrentlyRenderingComponent();
        return context._currentValue2;
    },
    useMemo: $274619feb1928437$var$useMemo,
    useReducer: $274619feb1928437$var$useReducer,
    useRef: function(initialValue) {
        $274619feb1928437$var$currentlyRenderingComponent = $274619feb1928437$var$resolveCurrentlyRenderingComponent();
        $274619feb1928437$var$workInProgressHook = $274619feb1928437$var$createWorkInProgressHook();
        var previousRef = $274619feb1928437$var$workInProgressHook.memoizedState;
        return null === previousRef ? (initialValue = {
            current: initialValue
        }, $274619feb1928437$var$workInProgressHook.memoizedState = initialValue) : previousRef;
    },
    useState: function(initialState) {
        return $274619feb1928437$var$useReducer($274619feb1928437$var$basicStateReducer, initialState);
    },
    useInsertionEffect: $274619feb1928437$var$noop$1,
    useLayoutEffect: $274619feb1928437$var$noop$1,
    useCallback: function(callback, deps) {
        return $274619feb1928437$var$useMemo(function() {
            return callback;
        }, deps);
    },
    useImperativeHandle: $274619feb1928437$var$noop$1,
    useEffect: $274619feb1928437$var$noop$1,
    useDebugValue: $274619feb1928437$var$noop$1,
    useDeferredValue: function(value, initialValue) {
        $274619feb1928437$var$resolveCurrentlyRenderingComponent();
        return void 0 !== initialValue ? initialValue : value;
    },
    useTransition: function() {
        $274619feb1928437$var$resolveCurrentlyRenderingComponent();
        return [
            !1,
            $274619feb1928437$var$unsupportedStartTransition
        ];
    },
    useId: function() {
        var JSCompiler_inline_result = $274619feb1928437$var$currentlyRenderingTask.treeContext;
        var overflow = JSCompiler_inline_result.overflow;
        JSCompiler_inline_result = JSCompiler_inline_result.id;
        JSCompiler_inline_result = (JSCompiler_inline_result & ~(1 << 32 - $274619feb1928437$var$clz32(JSCompiler_inline_result) - 1)).toString(32) + overflow;
        var resumableState = $274619feb1928437$var$currentResumableState;
        if (null === resumableState) throw Error($274619feb1928437$var$formatProdErrorMessage(404));
        overflow = $274619feb1928437$var$localIdCounter++;
        JSCompiler_inline_result = "\u00ab" + resumableState.idPrefix + "R" + JSCompiler_inline_result;
        0 < overflow && (JSCompiler_inline_result += "H" + overflow.toString(32));
        return JSCompiler_inline_result + "\u00bb";
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        if (void 0 === getServerSnapshot) throw Error($274619feb1928437$var$formatProdErrorMessage(407));
        return getServerSnapshot();
    },
    useOptimistic: function(passthrough) {
        $274619feb1928437$var$resolveCurrentlyRenderingComponent();
        return [
            passthrough,
            $274619feb1928437$var$unsupportedSetOptimisticState
        ];
    },
    useActionState: $274619feb1928437$var$useActionState,
    useFormState: $274619feb1928437$var$useActionState,
    useHostTransitionStatus: function() {
        $274619feb1928437$var$resolveCurrentlyRenderingComponent();
        return $274619feb1928437$var$sharedNotPendingObject;
    },
    useMemoCache: function(size) {
        for(var data = Array(size), i = 0; i < size; i++)data[i] = $274619feb1928437$var$REACT_MEMO_CACHE_SENTINEL;
        return data;
    },
    useCacheRefresh: function() {
        return $274619feb1928437$var$unsupportedRefresh;
    }
}, $274619feb1928437$var$currentResumableState = null, $274619feb1928437$var$DefaultAsyncDispatcher = {
    getCacheForType: function() {
        throw Error($274619feb1928437$var$formatProdErrorMessage(248));
    }
}, $274619feb1928437$var$prefix, $274619feb1928437$var$suffix;
function $274619feb1928437$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $274619feb1928437$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $274619feb1928437$var$prefix = match && match[1] || "";
        $274619feb1928437$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $274619feb1928437$var$prefix + name + $274619feb1928437$var$suffix;
}
var $274619feb1928437$var$reentry = !1;
function $274619feb1928437$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $274619feb1928437$var$reentry) return "";
    $274619feb1928437$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$24) {
                                control = x$24;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$25) {
                            control = x$25;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $274619feb1928437$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $274619feb1928437$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $274619feb1928437$var$describeComponentStackByType(type) {
    if ("string" === typeof type) return $274619feb1928437$var$describeBuiltInComponentFrame(type);
    if ("function" === typeof type) return type.prototype && type.prototype.isReactComponent ? $274619feb1928437$var$describeNativeComponentFrame(type, !0) : $274619feb1928437$var$describeNativeComponentFrame(type, !1);
    if ("object" === typeof type && null !== type) {
        switch(type.$$typeof){
            case $274619feb1928437$var$REACT_FORWARD_REF_TYPE:
                return $274619feb1928437$var$describeNativeComponentFrame(type.render, !1);
            case $274619feb1928437$var$REACT_MEMO_TYPE:
                return $274619feb1928437$var$describeNativeComponentFrame(type.type, !1);
            case $274619feb1928437$var$REACT_LAZY_TYPE:
                var lazyComponent = type, payload = lazyComponent._payload;
                lazyComponent = lazyComponent._init;
                try {
                    type = lazyComponent(payload);
                } catch (x) {
                    return $274619feb1928437$var$describeBuiltInComponentFrame("Lazy");
                }
                return $274619feb1928437$var$describeComponentStackByType(type);
        }
        if ("string" === typeof type.name) return payload = type.env, $274619feb1928437$var$describeBuiltInComponentFrame(type.name + (payload ? " [" + payload + "]" : ""));
    }
    switch(type){
        case $274619feb1928437$var$REACT_SUSPENSE_LIST_TYPE:
            return $274619feb1928437$var$describeBuiltInComponentFrame("SuspenseList");
        case $274619feb1928437$var$REACT_SUSPENSE_TYPE:
            return $274619feb1928437$var$describeBuiltInComponentFrame("Suspense");
    }
    return "";
}
function $274619feb1928437$var$defaultErrorHandler(error) {
    if ("object" === typeof error && null !== error && "string" === typeof error.environmentName) {
        var JSCompiler_inline_result = error.environmentName;
        error = [
            error
        ].slice(0);
        "string" === typeof error[0] ? error.splice(0, 1, "[%s] " + error[0], " " + JSCompiler_inline_result + " ") : error.splice(0, 0, "[%s] ", " " + JSCompiler_inline_result + " ");
        error.unshift(console);
        JSCompiler_inline_result = $274619feb1928437$var$bind.apply(console.error, error);
        JSCompiler_inline_result();
    } else console.error(error);
    return null;
}
function $274619feb1928437$var$noop() {}
function $274619feb1928437$var$RequestInstance(resumableState, renderState, rootFormatContext, progressiveChunkSize, onError, onAllReady, onShellReady, onShellError, onFatalError, onPostpone, formState) {
    var abortSet = new Set();
    this.destination = null;
    this.flushScheduled = !1;
    this.resumableState = resumableState;
    this.renderState = renderState;
    this.rootFormatContext = rootFormatContext;
    this.progressiveChunkSize = void 0 === progressiveChunkSize ? 12800 : progressiveChunkSize;
    this.status = 10;
    this.fatalError = null;
    this.pendingRootTasks = this.allPendingTasks = this.nextSegmentId = 0;
    this.completedPreambleSegments = this.completedRootSegment = null;
    this.abortableTasks = abortSet;
    this.pingedTasks = [];
    this.clientRenderedBoundaries = [];
    this.completedBoundaries = [];
    this.partialBoundaries = [];
    this.trackedPostpones = null;
    this.onError = void 0 === onError ? $274619feb1928437$var$defaultErrorHandler : onError;
    this.onPostpone = void 0 === onPostpone ? $274619feb1928437$var$noop : onPostpone;
    this.onAllReady = void 0 === onAllReady ? $274619feb1928437$var$noop : onAllReady;
    this.onShellReady = void 0 === onShellReady ? $274619feb1928437$var$noop : onShellReady;
    this.onShellError = void 0 === onShellError ? $274619feb1928437$var$noop : onShellError;
    this.onFatalError = void 0 === onFatalError ? $274619feb1928437$var$noop : onFatalError;
    this.formState = void 0 === formState ? null : formState;
}
function $274619feb1928437$var$createRequest(children, resumableState, renderState, rootFormatContext, progressiveChunkSize, onError, onAllReady, onShellReady, onShellError, onFatalError, onPostpone, formState) {
    resumableState = new $274619feb1928437$var$RequestInstance(resumableState, renderState, rootFormatContext, progressiveChunkSize, onError, onAllReady, onShellReady, onShellError, onFatalError, onPostpone, formState);
    renderState = $274619feb1928437$var$createPendingSegment(resumableState, 0, null, rootFormatContext, !1, !1);
    renderState.parentFlushed = !0;
    children = $274619feb1928437$var$createRenderTask(resumableState, null, children, -1, null, renderState, null, null, resumableState.abortableTasks, null, rootFormatContext, null, $274619feb1928437$var$emptyTreeContext, null, !1);
    $274619feb1928437$var$pushComponentStack(children);
    resumableState.pingedTasks.push(children);
    return resumableState;
}
var $274619feb1928437$var$currentRequest = null;
function $274619feb1928437$var$pingTask(request, task) {
    request.pingedTasks.push(task);
    1 === request.pingedTasks.length && (request.flushScheduled = null !== request.destination, $274619feb1928437$var$performWork(request));
}
function $274619feb1928437$var$createSuspenseBoundary(request, fallbackAbortableTasks, contentPreamble, fallbackPreamble) {
    return {
        status: 0,
        rootSegmentID: -1,
        parentFlushed: !1,
        pendingTasks: 0,
        completedSegments: [],
        byteSize: 0,
        fallbackAbortableTasks: fallbackAbortableTasks,
        errorDigest: null,
        contentState: $274619feb1928437$var$createHoistableState(),
        fallbackState: $274619feb1928437$var$createHoistableState(),
        contentPreamble: contentPreamble,
        fallbackPreamble: fallbackPreamble,
        trackedContentKeyPath: null,
        trackedFallbackNode: null
    };
}
function $274619feb1928437$var$createRenderTask(request, thenableState, node, childIndex, blockedBoundary, blockedSegment, blockedPreamble, hoistableState, abortSet, keyPath, formatContext, context, treeContext, componentStack, isFallback) {
    request.allPendingTasks++;
    null === blockedBoundary ? request.pendingRootTasks++ : blockedBoundary.pendingTasks++;
    var task = {
        replay: null,
        node: node,
        childIndex: childIndex,
        ping: function() {
            return $274619feb1928437$var$pingTask(request, task);
        },
        blockedBoundary: blockedBoundary,
        blockedSegment: blockedSegment,
        blockedPreamble: blockedPreamble,
        hoistableState: hoistableState,
        abortSet: abortSet,
        keyPath: keyPath,
        formatContext: formatContext,
        context: context,
        treeContext: treeContext,
        componentStack: componentStack,
        thenableState: thenableState,
        isFallback: isFallback
    };
    abortSet.add(task);
    return task;
}
function $274619feb1928437$var$createReplayTask(request, thenableState, replay, node, childIndex, blockedBoundary, hoistableState, abortSet, keyPath, formatContext, context, treeContext, componentStack, isFallback) {
    request.allPendingTasks++;
    null === blockedBoundary ? request.pendingRootTasks++ : blockedBoundary.pendingTasks++;
    replay.pendingTasks++;
    var task = {
        replay: replay,
        node: node,
        childIndex: childIndex,
        ping: function() {
            return $274619feb1928437$var$pingTask(request, task);
        },
        blockedBoundary: blockedBoundary,
        blockedSegment: null,
        blockedPreamble: null,
        hoistableState: hoistableState,
        abortSet: abortSet,
        keyPath: keyPath,
        formatContext: formatContext,
        context: context,
        treeContext: treeContext,
        componentStack: componentStack,
        thenableState: thenableState,
        isFallback: isFallback
    };
    abortSet.add(task);
    return task;
}
function $274619feb1928437$var$createPendingSegment(request, index, boundary, parentFormatContext, lastPushedText, textEmbedded) {
    return {
        status: 0,
        parentFlushed: !1,
        id: -1,
        index: index,
        chunks: [],
        children: [],
        preambleChildren: [],
        parentFormatContext: parentFormatContext,
        boundary: boundary,
        lastPushedText: lastPushedText,
        textEmbedded: textEmbedded
    };
}
function $274619feb1928437$var$pushComponentStack(task) {
    var node = task.node;
    if ("object" === typeof node && null !== node) switch(node.$$typeof){
        case $274619feb1928437$var$REACT_ELEMENT_TYPE:
            task.componentStack = {
                parent: task.componentStack,
                type: node.type
            };
    }
}
function $274619feb1928437$var$getThrownInfo(node$jscomp$0) {
    var errorInfo = {};
    node$jscomp$0 && Object.defineProperty(errorInfo, "componentStack", {
        configurable: !0,
        enumerable: !0,
        get: function() {
            try {
                var info = "", node = node$jscomp$0;
                do info += $274619feb1928437$var$describeComponentStackByType(node.type), node = node.parent;
                while (node);
                var JSCompiler_inline_result = info;
            } catch (x) {
                JSCompiler_inline_result = "\nError generating stack: " + x.message + "\n" + x.stack;
            }
            Object.defineProperty(errorInfo, "componentStack", {
                value: JSCompiler_inline_result
            });
            return JSCompiler_inline_result;
        }
    });
    return errorInfo;
}
function $274619feb1928437$var$logRecoverableError(request, error, errorInfo) {
    request = request.onError;
    error = request(error, errorInfo);
    if (null == error || "string" === typeof error) return error;
}
function $274619feb1928437$var$fatalError(request, error) {
    var onShellError = request.onShellError, onFatalError = request.onFatalError;
    onShellError(error);
    onFatalError(error);
    null !== request.destination ? (request.status = 14, request.destination.destroy(error)) : (request.status = 13, request.fatalError = error);
}
function $274619feb1928437$var$renderWithHooks(request, task, keyPath, Component, props, secondArg) {
    var prevThenableState = task.thenableState;
    task.thenableState = null;
    $274619feb1928437$var$currentlyRenderingComponent = {};
    $274619feb1928437$var$currentlyRenderingTask = task;
    $274619feb1928437$var$currentlyRenderingRequest = request;
    $274619feb1928437$var$currentlyRenderingKeyPath = keyPath;
    $274619feb1928437$var$actionStateCounter = $274619feb1928437$var$localIdCounter = 0;
    $274619feb1928437$var$actionStateMatchingIndex = -1;
    $274619feb1928437$var$thenableIndexCounter = 0;
    $274619feb1928437$var$thenableState = prevThenableState;
    for(request = Component(props, secondArg); $274619feb1928437$var$didScheduleRenderPhaseUpdate;)$274619feb1928437$var$didScheduleRenderPhaseUpdate = !1, $274619feb1928437$var$actionStateCounter = $274619feb1928437$var$localIdCounter = 0, $274619feb1928437$var$actionStateMatchingIndex = -1, $274619feb1928437$var$thenableIndexCounter = 0, $274619feb1928437$var$numberOfReRenders += 1, $274619feb1928437$var$workInProgressHook = null, request = Component(props, secondArg);
    $274619feb1928437$var$resetHooksState();
    return request;
}
function $274619feb1928437$var$finishFunctionComponent(request, task, keyPath, children, hasId, actionStateCount, actionStateMatchingIndex) {
    var didEmitActionStateMarkers = !1;
    if (0 !== actionStateCount && null !== request.formState) {
        var segment = task.blockedSegment;
        if (null !== segment) {
            didEmitActionStateMarkers = !0;
            segment = segment.chunks;
            for(var i = 0; i < actionStateCount; i++)i === actionStateMatchingIndex ? segment.push("\x3c!--F!--\x3e") : segment.push("\x3c!--F--\x3e");
        }
    }
    actionStateCount = task.keyPath;
    task.keyPath = keyPath;
    hasId ? (keyPath = task.treeContext, task.treeContext = $274619feb1928437$var$pushTreeContext(keyPath, 1, 0), $274619feb1928437$var$renderNode(request, task, children, -1), task.treeContext = keyPath) : didEmitActionStateMarkers ? $274619feb1928437$var$renderNode(request, task, children, -1) : $274619feb1928437$var$renderNodeDestructive(request, task, children, -1);
    task.keyPath = actionStateCount;
}
function $274619feb1928437$var$renderElement(request, task, keyPath, type, props, ref) {
    if ("function" === typeof type) {
        if (type.prototype && type.prototype.isReactComponent) {
            var newProps = props;
            if ("ref" in props) {
                newProps = {};
                for(var propName in props)"ref" !== propName && (newProps[propName] = props[propName]);
            }
            var defaultProps = type.defaultProps;
            if (defaultProps) {
                newProps === props && (newProps = $274619feb1928437$var$assign({}, newProps, props));
                for(var propName$33 in defaultProps)void 0 === newProps[propName$33] && (newProps[propName$33] = defaultProps[propName$33]);
            }
            props = newProps;
            newProps = $274619feb1928437$var$emptyContextObject;
            defaultProps = type.contextType;
            "object" === typeof defaultProps && null !== defaultProps && (newProps = defaultProps._currentValue2);
            newProps = new type(props, newProps);
            var initialState = void 0 !== newProps.state ? newProps.state : null;
            newProps.updater = $274619feb1928437$var$classComponentUpdater;
            newProps.props = props;
            newProps.state = initialState;
            defaultProps = {
                queue: [],
                replace: !1
            };
            newProps._reactInternals = defaultProps;
            ref = type.contextType;
            newProps.context = "object" === typeof ref && null !== ref ? ref._currentValue2 : $274619feb1928437$var$emptyContextObject;
            ref = type.getDerivedStateFromProps;
            "function" === typeof ref && (ref = ref(props, initialState), initialState = null === ref || void 0 === ref ? initialState : $274619feb1928437$var$assign({}, initialState, ref), newProps.state = initialState);
            if ("function" !== typeof type.getDerivedStateFromProps && "function" !== typeof newProps.getSnapshotBeforeUpdate && ("function" === typeof newProps.UNSAFE_componentWillMount || "function" === typeof newProps.componentWillMount)) {
                if (type = newProps.state, "function" === typeof newProps.componentWillMount && newProps.componentWillMount(), "function" === typeof newProps.UNSAFE_componentWillMount && newProps.UNSAFE_componentWillMount(), type !== newProps.state && $274619feb1928437$var$classComponentUpdater.enqueueReplaceState(newProps, newProps.state, null), null !== defaultProps.queue && 0 < defaultProps.queue.length) {
                    if (type = defaultProps.queue, ref = defaultProps.replace, defaultProps.queue = null, defaultProps.replace = !1, ref && 1 === type.length) newProps.state = type[0];
                    else {
                        defaultProps = ref ? type[0] : newProps.state;
                        initialState = !0;
                        for(ref = ref ? 1 : 0; ref < type.length; ref++)propName$33 = type[ref], propName$33 = "function" === typeof propName$33 ? propName$33.call(newProps, defaultProps, props, void 0) : propName$33, null != propName$33 && (initialState ? (initialState = !1, defaultProps = $274619feb1928437$var$assign({}, defaultProps, propName$33)) : $274619feb1928437$var$assign(defaultProps, propName$33));
                        newProps.state = defaultProps;
                    }
                } else defaultProps.queue = null;
            }
            type = newProps.render();
            if (12 === request.status) throw null;
            props = task.keyPath;
            task.keyPath = keyPath;
            $274619feb1928437$var$renderNodeDestructive(request, task, type, -1);
            task.keyPath = props;
        } else {
            type = $274619feb1928437$var$renderWithHooks(request, task, keyPath, type, props, void 0);
            if (12 === request.status) throw null;
            $274619feb1928437$var$finishFunctionComponent(request, task, keyPath, type, 0 !== $274619feb1928437$var$localIdCounter, $274619feb1928437$var$actionStateCounter, $274619feb1928437$var$actionStateMatchingIndex);
        }
    } else if ("string" === typeof type) {
        if (newProps = task.blockedSegment, null === newProps) newProps = props.children, defaultProps = task.formatContext, initialState = task.keyPath, task.formatContext = $274619feb1928437$var$getChildFormatContext(defaultProps, type, props), task.keyPath = keyPath, $274619feb1928437$var$renderNode(request, task, newProps, -1), task.formatContext = defaultProps, task.keyPath = initialState;
        else {
            ref = $274619feb1928437$var$pushStartInstance(newProps.chunks, type, props, request.resumableState, request.renderState, task.blockedPreamble, task.hoistableState, task.formatContext, newProps.lastPushedText, task.isFallback);
            newProps.lastPushedText = !1;
            defaultProps = task.formatContext;
            initialState = task.keyPath;
            task.keyPath = keyPath;
            3 === (task.formatContext = $274619feb1928437$var$getChildFormatContext(defaultProps, type, props)).insertionMode ? (keyPath = $274619feb1928437$var$createPendingSegment(request, 0, null, task.formatContext, !1, !1), newProps.preambleChildren.push(keyPath), keyPath = $274619feb1928437$var$createRenderTask(request, null, ref, -1, task.blockedBoundary, keyPath, task.blockedPreamble, task.hoistableState, request.abortableTasks, task.keyPath, task.formatContext, task.context, task.treeContext, task.componentStack, task.isFallback), $274619feb1928437$var$pushComponentStack(keyPath), request.pingedTasks.push(keyPath)) : $274619feb1928437$var$renderNode(request, task, ref, -1);
            task.formatContext = defaultProps;
            task.keyPath = initialState;
            a: {
                task = newProps.chunks;
                request = request.resumableState;
                switch(type){
                    case "title":
                    case "style":
                    case "script":
                    case "area":
                    case "base":
                    case "br":
                    case "col":
                    case "embed":
                    case "hr":
                    case "img":
                    case "input":
                    case "keygen":
                    case "link":
                    case "meta":
                    case "param":
                    case "source":
                    case "track":
                    case "wbr":
                        break a;
                    case "body":
                        if (1 >= defaultProps.insertionMode) {
                            request.hasBody = !0;
                            break a;
                        }
                        break;
                    case "html":
                        if (0 === defaultProps.insertionMode) {
                            request.hasHtml = !0;
                            break a;
                        }
                        break;
                    case "head":
                        if (1 >= defaultProps.insertionMode) break a;
                }
                task.push($274619feb1928437$var$endChunkForTag(type));
            }
            newProps.lastPushedText = !1;
        }
    } else {
        switch(type){
            case $274619feb1928437$var$REACT_LEGACY_HIDDEN_TYPE:
            case $274619feb1928437$var$REACT_STRICT_MODE_TYPE:
            case $274619feb1928437$var$REACT_PROFILER_TYPE:
            case $274619feb1928437$var$REACT_FRAGMENT_TYPE:
                type = task.keyPath;
                task.keyPath = keyPath;
                $274619feb1928437$var$renderNodeDestructive(request, task, props.children, -1);
                task.keyPath = type;
                return;
            case $274619feb1928437$var$REACT_ACTIVITY_TYPE:
                "hidden" !== props.mode && (type = task.keyPath, task.keyPath = keyPath, $274619feb1928437$var$renderNodeDestructive(request, task, props.children, -1), task.keyPath = type);
                return;
            case $274619feb1928437$var$REACT_SUSPENSE_LIST_TYPE:
                type = task.keyPath;
                task.keyPath = keyPath;
                $274619feb1928437$var$renderNodeDestructive(request, task, props.children, -1);
                task.keyPath = type;
                return;
            case $274619feb1928437$var$REACT_VIEW_TRANSITION_TYPE:
            case $274619feb1928437$var$REACT_SCOPE_TYPE:
                throw Error($274619feb1928437$var$formatProdErrorMessage(343));
            case $274619feb1928437$var$REACT_SUSPENSE_TYPE:
                a: if (null !== task.replay) {
                    type = task.keyPath;
                    task.keyPath = keyPath;
                    keyPath = props.children;
                    try {
                        $274619feb1928437$var$renderNode(request, task, keyPath, -1);
                    } finally{
                        task.keyPath = type;
                    }
                } else {
                    type = task.keyPath;
                    var parentBoundary = task.blockedBoundary;
                    ref = task.blockedPreamble;
                    var parentHoistableState = task.hoistableState;
                    propName$33 = task.blockedSegment;
                    propName = props.fallback;
                    props = props.children;
                    var fallbackAbortSet = new Set();
                    var newBoundary = 2 > task.formatContext.insertionMode ? $274619feb1928437$var$createSuspenseBoundary(request, fallbackAbortSet, $274619feb1928437$var$createPreambleState(), $274619feb1928437$var$createPreambleState()) : $274619feb1928437$var$createSuspenseBoundary(request, fallbackAbortSet, null, null);
                    null !== request.trackedPostpones && (newBoundary.trackedContentKeyPath = keyPath);
                    var boundarySegment = $274619feb1928437$var$createPendingSegment(request, propName$33.chunks.length, newBoundary, task.formatContext, !1, !1);
                    propName$33.children.push(boundarySegment);
                    propName$33.lastPushedText = !1;
                    var contentRootSegment = $274619feb1928437$var$createPendingSegment(request, 0, null, task.formatContext, !1, !1);
                    contentRootSegment.parentFlushed = !0;
                    if (null !== request.trackedPostpones) {
                        newProps = [
                            keyPath[0],
                            "Suspense Fallback",
                            keyPath[2]
                        ];
                        defaultProps = [
                            newProps[1],
                            newProps[2],
                            [],
                            null
                        ];
                        request.trackedPostpones.workingMap.set(newProps, defaultProps);
                        newBoundary.trackedFallbackNode = defaultProps;
                        task.blockedSegment = boundarySegment;
                        task.blockedPreamble = newBoundary.fallbackPreamble;
                        task.keyPath = newProps;
                        boundarySegment.status = 6;
                        try {
                            $274619feb1928437$var$renderNode(request, task, propName, -1), $274619feb1928437$var$pushSegmentFinale(boundarySegment.chunks, request.renderState, boundarySegment.lastPushedText, boundarySegment.textEmbedded), boundarySegment.status = 1;
                        } catch (thrownValue) {
                            throw boundarySegment.status = 12 === request.status ? 3 : 4, thrownValue;
                        } finally{
                            task.blockedSegment = propName$33, task.blockedPreamble = ref, task.keyPath = type;
                        }
                        task = $274619feb1928437$var$createRenderTask(request, null, props, -1, newBoundary, contentRootSegment, newBoundary.contentPreamble, newBoundary.contentState, task.abortSet, keyPath, task.formatContext, task.context, task.treeContext, task.componentStack, task.isFallback);
                        $274619feb1928437$var$pushComponentStack(task);
                        request.pingedTasks.push(task);
                    } else {
                        task.blockedBoundary = newBoundary;
                        task.blockedPreamble = newBoundary.contentPreamble;
                        task.hoistableState = newBoundary.contentState;
                        task.blockedSegment = contentRootSegment;
                        task.keyPath = keyPath;
                        contentRootSegment.status = 6;
                        try {
                            if ($274619feb1928437$var$renderNode(request, task, props, -1), $274619feb1928437$var$pushSegmentFinale(contentRootSegment.chunks, request.renderState, contentRootSegment.lastPushedText, contentRootSegment.textEmbedded), contentRootSegment.status = 1, $274619feb1928437$var$queueCompletedSegment(newBoundary, contentRootSegment), 0 === newBoundary.pendingTasks && 0 === newBoundary.status) {
                                newBoundary.status = 1;
                                0 === request.pendingRootTasks && task.blockedPreamble && $274619feb1928437$var$preparePreamble(request);
                                break a;
                            }
                        } catch (thrownValue$28) {
                            newBoundary.status = 4, 12 === request.status ? (contentRootSegment.status = 3, newProps = request.fatalError) : (contentRootSegment.status = 4, newProps = thrownValue$28), defaultProps = $274619feb1928437$var$getThrownInfo(task.componentStack), initialState = $274619feb1928437$var$logRecoverableError(request, newProps, defaultProps), newBoundary.errorDigest = initialState, $274619feb1928437$var$untrackBoundary(request, newBoundary);
                        } finally{
                            task.blockedBoundary = parentBoundary, task.blockedPreamble = ref, task.hoistableState = parentHoistableState, task.blockedSegment = propName$33, task.keyPath = type;
                        }
                        task = $274619feb1928437$var$createRenderTask(request, null, propName, -1, parentBoundary, boundarySegment, newBoundary.fallbackPreamble, newBoundary.fallbackState, fallbackAbortSet, [
                            keyPath[0],
                            "Suspense Fallback",
                            keyPath[2]
                        ], task.formatContext, task.context, task.treeContext, task.componentStack, !0);
                        $274619feb1928437$var$pushComponentStack(task);
                        request.pingedTasks.push(task);
                    }
                }
                return;
        }
        if ("object" === typeof type && null !== type) switch(type.$$typeof){
            case $274619feb1928437$var$REACT_FORWARD_REF_TYPE:
                if ("ref" in props) for(newBoundary in newProps = {}, props)"ref" !== newBoundary && (newProps[newBoundary] = props[newBoundary]);
                else newProps = props;
                type = $274619feb1928437$var$renderWithHooks(request, task, keyPath, type.render, newProps, ref);
                $274619feb1928437$var$finishFunctionComponent(request, task, keyPath, type, 0 !== $274619feb1928437$var$localIdCounter, $274619feb1928437$var$actionStateCounter, $274619feb1928437$var$actionStateMatchingIndex);
                return;
            case $274619feb1928437$var$REACT_MEMO_TYPE:
                $274619feb1928437$var$renderElement(request, task, keyPath, type.type, props, ref);
                return;
            case $274619feb1928437$var$REACT_PROVIDER_TYPE:
            case $274619feb1928437$var$REACT_CONTEXT_TYPE:
                defaultProps = props.children;
                newProps = task.keyPath;
                props = props.value;
                initialState = type._currentValue2;
                type._currentValue2 = props;
                ref = $274619feb1928437$var$currentActiveSnapshot;
                $274619feb1928437$var$currentActiveSnapshot = type = {
                    parent: ref,
                    depth: null === ref ? 0 : ref.depth + 1,
                    context: type,
                    parentValue: initialState,
                    value: props
                };
                task.context = type;
                task.keyPath = keyPath;
                $274619feb1928437$var$renderNodeDestructive(request, task, defaultProps, -1);
                request = $274619feb1928437$var$currentActiveSnapshot;
                if (null === request) throw Error($274619feb1928437$var$formatProdErrorMessage(403));
                request.context._currentValue2 = request.parentValue;
                request = $274619feb1928437$var$currentActiveSnapshot = request.parent;
                task.context = request;
                task.keyPath = newProps;
                return;
            case $274619feb1928437$var$REACT_CONSUMER_TYPE:
                props = props.children;
                type = props(type._context._currentValue2);
                props = task.keyPath;
                task.keyPath = keyPath;
                $274619feb1928437$var$renderNodeDestructive(request, task, type, -1);
                task.keyPath = props;
                return;
            case $274619feb1928437$var$REACT_LAZY_TYPE:
                newProps = type._init;
                type = newProps(type._payload);
                if (12 === request.status) throw null;
                $274619feb1928437$var$renderElement(request, task, keyPath, type, props, ref);
                return;
        }
        throw Error($274619feb1928437$var$formatProdErrorMessage(130, null == type ? type : typeof type, ""));
    }
}
function $274619feb1928437$var$resumeNode(request, task, segmentId, node, childIndex) {
    var prevReplay = task.replay, blockedBoundary = task.blockedBoundary, resumedSegment = $274619feb1928437$var$createPendingSegment(request, 0, null, task.formatContext, !1, !1);
    resumedSegment.id = segmentId;
    resumedSegment.parentFlushed = !0;
    try {
        task.replay = null, task.blockedSegment = resumedSegment, $274619feb1928437$var$renderNode(request, task, node, childIndex), resumedSegment.status = 1, null === blockedBoundary ? request.completedRootSegment = resumedSegment : ($274619feb1928437$var$queueCompletedSegment(blockedBoundary, resumedSegment), blockedBoundary.parentFlushed && request.partialBoundaries.push(blockedBoundary));
    } finally{
        task.replay = prevReplay, task.blockedSegment = null;
    }
}
function $274619feb1928437$var$renderNodeDestructive(request, task, node, childIndex) {
    null !== task.replay && "number" === typeof task.replay.slots ? $274619feb1928437$var$resumeNode(request, task, task.replay.slots, node, childIndex) : (task.node = node, task.childIndex = childIndex, node = task.componentStack, $274619feb1928437$var$pushComponentStack(task), $274619feb1928437$var$retryNode(request, task), task.componentStack = node);
}
function $274619feb1928437$var$retryNode(request, task) {
    var node = task.node, childIndex = task.childIndex;
    if (null !== node) {
        if ("object" === typeof node) {
            switch(node.$$typeof){
                case $274619feb1928437$var$REACT_ELEMENT_TYPE:
                    var type = node.type, key = node.key, props = node.props;
                    node = props.ref;
                    var ref = void 0 !== node ? node : null, name = $274619feb1928437$var$getComponentNameFromType(type), keyOrIndex = null == key ? -1 === childIndex ? 0 : childIndex : key;
                    key = [
                        task.keyPath,
                        name,
                        keyOrIndex
                    ];
                    if (null !== task.replay) a: {
                        var replay = task.replay;
                        childIndex = replay.nodes;
                        for(node = 0; node < childIndex.length; node++){
                            var node$jscomp$0 = childIndex[node];
                            if (keyOrIndex === node$jscomp$0[1]) {
                                if (4 === node$jscomp$0.length) {
                                    if (null !== name && name !== node$jscomp$0[0]) throw Error($274619feb1928437$var$formatProdErrorMessage(490, node$jscomp$0[0], name));
                                    var childNodes = node$jscomp$0[2];
                                    name = node$jscomp$0[3];
                                    keyOrIndex = task.node;
                                    task.replay = {
                                        nodes: childNodes,
                                        slots: name,
                                        pendingTasks: 1
                                    };
                                    try {
                                        $274619feb1928437$var$renderElement(request, task, key, type, props, ref);
                                        if (1 === task.replay.pendingTasks && 0 < task.replay.nodes.length) throw Error($274619feb1928437$var$formatProdErrorMessage(488));
                                        task.replay.pendingTasks--;
                                    } catch (x) {
                                        if ("object" === typeof x && null !== x && (x === $274619feb1928437$var$SuspenseException || "function" === typeof x.then)) throw task.node === keyOrIndex && (task.replay = replay), x;
                                        task.replay.pendingTasks--;
                                        props = $274619feb1928437$var$getThrownInfo(task.componentStack);
                                        key = task.blockedBoundary;
                                        type = x;
                                        props = $274619feb1928437$var$logRecoverableError(request, type, props);
                                        $274619feb1928437$var$abortRemainingReplayNodes(request, key, childNodes, name, type, props);
                                    }
                                    task.replay = replay;
                                } else {
                                    if (type !== $274619feb1928437$var$REACT_SUSPENSE_TYPE) throw Error($274619feb1928437$var$formatProdErrorMessage(490, "Suspense", $274619feb1928437$var$getComponentNameFromType(type) || "Unknown"));
                                    b: {
                                        replay = void 0;
                                        type = node$jscomp$0[5];
                                        ref = node$jscomp$0[2];
                                        name = node$jscomp$0[3];
                                        keyOrIndex = null === node$jscomp$0[4] ? [] : node$jscomp$0[4][2];
                                        node$jscomp$0 = null === node$jscomp$0[4] ? null : node$jscomp$0[4][3];
                                        var prevKeyPath = task.keyPath, previousReplaySet = task.replay, parentBoundary = task.blockedBoundary, parentHoistableState = task.hoistableState, content = props.children, fallback = props.fallback, fallbackAbortSet = new Set();
                                        props = 2 > task.formatContext.insertionMode ? $274619feb1928437$var$createSuspenseBoundary(request, fallbackAbortSet, $274619feb1928437$var$createPreambleState(), $274619feb1928437$var$createPreambleState()) : $274619feb1928437$var$createSuspenseBoundary(request, fallbackAbortSet, null, null);
                                        props.parentFlushed = !0;
                                        props.rootSegmentID = type;
                                        task.blockedBoundary = props;
                                        task.hoistableState = props.contentState;
                                        task.keyPath = key;
                                        task.replay = {
                                            nodes: ref,
                                            slots: name,
                                            pendingTasks: 1
                                        };
                                        try {
                                            $274619feb1928437$var$renderNode(request, task, content, -1);
                                            if (1 === task.replay.pendingTasks && 0 < task.replay.nodes.length) throw Error($274619feb1928437$var$formatProdErrorMessage(488));
                                            task.replay.pendingTasks--;
                                            if (0 === props.pendingTasks && 0 === props.status) {
                                                props.status = 1;
                                                request.completedBoundaries.push(props);
                                                break b;
                                            }
                                        } catch (error) {
                                            props.status = 4, childNodes = $274619feb1928437$var$getThrownInfo(task.componentStack), replay = $274619feb1928437$var$logRecoverableError(request, error, childNodes), props.errorDigest = replay, task.replay.pendingTasks--, request.clientRenderedBoundaries.push(props);
                                        } finally{
                                            task.blockedBoundary = parentBoundary, task.hoistableState = parentHoistableState, task.replay = previousReplaySet, task.keyPath = prevKeyPath;
                                        }
                                        task = $274619feb1928437$var$createReplayTask(request, null, {
                                            nodes: keyOrIndex,
                                            slots: node$jscomp$0,
                                            pendingTasks: 0
                                        }, fallback, -1, parentBoundary, props.fallbackState, fallbackAbortSet, [
                                            key[0],
                                            "Suspense Fallback",
                                            key[2]
                                        ], task.formatContext, task.context, task.treeContext, task.componentStack, !0);
                                        $274619feb1928437$var$pushComponentStack(task);
                                        request.pingedTasks.push(task);
                                    }
                                }
                                childIndex.splice(node, 1);
                                break a;
                            }
                        }
                    }
                    else $274619feb1928437$var$renderElement(request, task, key, type, props, ref);
                    return;
                case $274619feb1928437$var$REACT_PORTAL_TYPE:
                    throw Error($274619feb1928437$var$formatProdErrorMessage(257));
                case $274619feb1928437$var$REACT_LAZY_TYPE:
                    childNodes = node._init;
                    node = childNodes(node._payload);
                    if (12 === request.status) throw null;
                    $274619feb1928437$var$renderNodeDestructive(request, task, node, childIndex);
                    return;
            }
            if ($274619feb1928437$var$isArrayImpl(node)) {
                $274619feb1928437$var$renderChildrenArray(request, task, node, childIndex);
                return;
            }
            null === node || "object" !== typeof node ? childNodes = null : (childNodes = $274619feb1928437$var$MAYBE_ITERATOR_SYMBOL && node[$274619feb1928437$var$MAYBE_ITERATOR_SYMBOL] || node["@@iterator"], childNodes = "function" === typeof childNodes ? childNodes : null);
            if (childNodes && (childNodes = childNodes.call(node))) {
                node = childNodes.next();
                if (!node.done) {
                    props = [];
                    do props.push(node.value), node = childNodes.next();
                    while (!node.done);
                    $274619feb1928437$var$renderChildrenArray(request, task, props, childIndex);
                }
                return;
            }
            if ("function" === typeof node.then) return task.thenableState = null, $274619feb1928437$var$renderNodeDestructive(request, task, $274619feb1928437$var$unwrapThenable(node), childIndex);
            if (node.$$typeof === $274619feb1928437$var$REACT_CONTEXT_TYPE) return $274619feb1928437$var$renderNodeDestructive(request, task, node._currentValue2, childIndex);
            childIndex = Object.prototype.toString.call(node);
            throw Error($274619feb1928437$var$formatProdErrorMessage(31, "[object Object]" === childIndex ? "object with keys {" + Object.keys(node).join(", ") + "}" : childIndex));
        }
        if ("string" === typeof node) childIndex = task.blockedSegment, null !== childIndex && (childIndex.lastPushedText = $274619feb1928437$var$pushTextInstance(childIndex.chunks, node, request.renderState, childIndex.lastPushedText));
        else if ("number" === typeof node || "bigint" === typeof node) childIndex = task.blockedSegment, null !== childIndex && (childIndex.lastPushedText = $274619feb1928437$var$pushTextInstance(childIndex.chunks, "" + node, request.renderState, childIndex.lastPushedText));
    }
}
function $274619feb1928437$var$renderChildrenArray(request, task, children, childIndex) {
    var prevKeyPath = task.keyPath;
    if (-1 !== childIndex && (task.keyPath = [
        task.keyPath,
        "Fragment",
        childIndex
    ], null !== task.replay)) {
        for(var replay = task.replay, replayNodes = replay.nodes, j = 0; j < replayNodes.length; j++){
            var node = replayNodes[j];
            if (node[1] === childIndex) {
                childIndex = node[2];
                node = node[3];
                task.replay = {
                    nodes: childIndex,
                    slots: node,
                    pendingTasks: 1
                };
                try {
                    $274619feb1928437$var$renderChildrenArray(request, task, children, -1);
                    if (1 === task.replay.pendingTasks && 0 < task.replay.nodes.length) throw Error($274619feb1928437$var$formatProdErrorMessage(488));
                    task.replay.pendingTasks--;
                } catch (x) {
                    if ("object" === typeof x && null !== x && (x === $274619feb1928437$var$SuspenseException || "function" === typeof x.then)) throw x;
                    task.replay.pendingTasks--;
                    children = $274619feb1928437$var$getThrownInfo(task.componentStack);
                    var boundary = task.blockedBoundary, error = x;
                    children = $274619feb1928437$var$logRecoverableError(request, error, children);
                    $274619feb1928437$var$abortRemainingReplayNodes(request, boundary, childIndex, node, error, children);
                }
                task.replay = replay;
                replayNodes.splice(j, 1);
                break;
            }
        }
        task.keyPath = prevKeyPath;
        return;
    }
    replay = task.treeContext;
    replayNodes = children.length;
    if (null !== task.replay && (j = task.replay.slots, null !== j && "object" === typeof j)) {
        for(childIndex = 0; childIndex < replayNodes; childIndex++)node = children[childIndex], task.treeContext = $274619feb1928437$var$pushTreeContext(replay, replayNodes, childIndex), boundary = j[childIndex], "number" === typeof boundary ? ($274619feb1928437$var$resumeNode(request, task, boundary, node, childIndex), delete j[childIndex]) : $274619feb1928437$var$renderNode(request, task, node, childIndex);
        task.treeContext = replay;
        task.keyPath = prevKeyPath;
        return;
    }
    for(j = 0; j < replayNodes; j++)childIndex = children[j], task.treeContext = $274619feb1928437$var$pushTreeContext(replay, replayNodes, j), $274619feb1928437$var$renderNode(request, task, childIndex, j);
    task.treeContext = replay;
    task.keyPath = prevKeyPath;
}
function $274619feb1928437$var$untrackBoundary(request, boundary) {
    request = request.trackedPostpones;
    null !== request && (boundary = boundary.trackedContentKeyPath, null !== boundary && (boundary = request.workingMap.get(boundary), void 0 !== boundary && (boundary.length = 4, boundary[2] = [], boundary[3] = null)));
}
function $274619feb1928437$var$spawnNewSuspendedReplayTask(request, task, thenableState) {
    return $274619feb1928437$var$createReplayTask(request, thenableState, task.replay, task.node, task.childIndex, task.blockedBoundary, task.hoistableState, task.abortSet, task.keyPath, task.formatContext, task.context, task.treeContext, task.componentStack, task.isFallback);
}
function $274619feb1928437$var$spawnNewSuspendedRenderTask(request, task, thenableState) {
    var segment = task.blockedSegment, newSegment = $274619feb1928437$var$createPendingSegment(request, segment.chunks.length, null, task.formatContext, segment.lastPushedText, !0);
    segment.children.push(newSegment);
    segment.lastPushedText = !1;
    return $274619feb1928437$var$createRenderTask(request, thenableState, task.node, task.childIndex, task.blockedBoundary, newSegment, task.blockedPreamble, task.hoistableState, task.abortSet, task.keyPath, task.formatContext, task.context, task.treeContext, task.componentStack, task.isFallback);
}
function $274619feb1928437$var$renderNode(request, task, node, childIndex) {
    var previousFormatContext = task.formatContext, previousContext = task.context, previousKeyPath = task.keyPath, previousTreeContext = task.treeContext, previousComponentStack = task.componentStack, segment = task.blockedSegment;
    if (null === segment) try {
        return $274619feb1928437$var$renderNodeDestructive(request, task, node, childIndex);
    } catch (thrownValue) {
        if ($274619feb1928437$var$resetHooksState(), node = thrownValue === $274619feb1928437$var$SuspenseException ? $274619feb1928437$var$getSuspendedThenable() : thrownValue, "object" === typeof node && null !== node) {
            if ("function" === typeof node.then) {
                childIndex = $274619feb1928437$var$getThenableStateAfterSuspending();
                request = $274619feb1928437$var$spawnNewSuspendedReplayTask(request, task, childIndex).ping;
                node.then(request, request);
                task.formatContext = previousFormatContext;
                task.context = previousContext;
                task.keyPath = previousKeyPath;
                task.treeContext = previousTreeContext;
                task.componentStack = previousComponentStack;
                $274619feb1928437$var$switchContext(previousContext);
                return;
            }
            if ("Maximum call stack size exceeded" === node.message) {
                node = $274619feb1928437$var$getThenableStateAfterSuspending();
                node = $274619feb1928437$var$spawnNewSuspendedReplayTask(request, task, node);
                request.pingedTasks.push(node);
                task.formatContext = previousFormatContext;
                task.context = previousContext;
                task.keyPath = previousKeyPath;
                task.treeContext = previousTreeContext;
                task.componentStack = previousComponentStack;
                $274619feb1928437$var$switchContext(previousContext);
                return;
            }
        }
    }
    else {
        var childrenLength = segment.children.length, chunkLength = segment.chunks.length;
        try {
            return $274619feb1928437$var$renderNodeDestructive(request, task, node, childIndex);
        } catch (thrownValue$48) {
            if ($274619feb1928437$var$resetHooksState(), segment.children.length = childrenLength, segment.chunks.length = chunkLength, node = thrownValue$48 === $274619feb1928437$var$SuspenseException ? $274619feb1928437$var$getSuspendedThenable() : thrownValue$48, "object" === typeof node && null !== node) {
                if ("function" === typeof node.then) {
                    childIndex = $274619feb1928437$var$getThenableStateAfterSuspending();
                    request = $274619feb1928437$var$spawnNewSuspendedRenderTask(request, task, childIndex).ping;
                    node.then(request, request);
                    task.formatContext = previousFormatContext;
                    task.context = previousContext;
                    task.keyPath = previousKeyPath;
                    task.treeContext = previousTreeContext;
                    task.componentStack = previousComponentStack;
                    $274619feb1928437$var$switchContext(previousContext);
                    return;
                }
                if ("Maximum call stack size exceeded" === node.message) {
                    node = $274619feb1928437$var$getThenableStateAfterSuspending();
                    node = $274619feb1928437$var$spawnNewSuspendedRenderTask(request, task, node);
                    request.pingedTasks.push(node);
                    task.formatContext = previousFormatContext;
                    task.context = previousContext;
                    task.keyPath = previousKeyPath;
                    task.treeContext = previousTreeContext;
                    task.componentStack = previousComponentStack;
                    $274619feb1928437$var$switchContext(previousContext);
                    return;
                }
            }
        }
    }
    task.formatContext = previousFormatContext;
    task.context = previousContext;
    task.keyPath = previousKeyPath;
    task.treeContext = previousTreeContext;
    $274619feb1928437$var$switchContext(previousContext);
    throw node;
}
function $274619feb1928437$var$abortTaskSoft(task) {
    var boundary = task.blockedBoundary;
    task = task.blockedSegment;
    null !== task && (task.status = 3, $274619feb1928437$var$finishedTask(this, boundary, task));
}
function $274619feb1928437$var$abortRemainingReplayNodes(request$jscomp$0, boundary, nodes, slots, error, errorDigest$jscomp$0) {
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (4 === node.length) $274619feb1928437$var$abortRemainingReplayNodes(request$jscomp$0, boundary, node[2], node[3], error, errorDigest$jscomp$0);
        else {
            node = node[5];
            var request = request$jscomp$0, errorDigest = errorDigest$jscomp$0, resumedBoundary = $274619feb1928437$var$createSuspenseBoundary(request, new Set(), null, null);
            resumedBoundary.parentFlushed = !0;
            resumedBoundary.rootSegmentID = node;
            resumedBoundary.status = 4;
            resumedBoundary.errorDigest = errorDigest;
            resumedBoundary.parentFlushed && request.clientRenderedBoundaries.push(resumedBoundary);
        }
    }
    nodes.length = 0;
    if (null !== slots) {
        if (null === boundary) throw Error($274619feb1928437$var$formatProdErrorMessage(487));
        4 !== boundary.status && (boundary.status = 4, boundary.errorDigest = errorDigest$jscomp$0, boundary.parentFlushed && request$jscomp$0.clientRenderedBoundaries.push(boundary));
        if ("object" === typeof slots) for(var index in slots)delete slots[index];
    }
}
function $274619feb1928437$var$abortTask(task, request, error) {
    var boundary = task.blockedBoundary, segment = task.blockedSegment;
    if (null !== segment) {
        if (6 === segment.status) return;
        segment.status = 3;
    }
    segment = $274619feb1928437$var$getThrownInfo(task.componentStack);
    if (null === boundary) {
        if (13 !== request.status && 14 !== request.status) {
            boundary = task.replay;
            if (null === boundary) {
                $274619feb1928437$var$logRecoverableError(request, error, segment);
                $274619feb1928437$var$fatalError(request, error);
                return;
            }
            boundary.pendingTasks--;
            0 === boundary.pendingTasks && 0 < boundary.nodes.length && (task = $274619feb1928437$var$logRecoverableError(request, error, segment), $274619feb1928437$var$abortRemainingReplayNodes(request, null, boundary.nodes, boundary.slots, error, task));
            request.pendingRootTasks--;
            0 === request.pendingRootTasks && $274619feb1928437$var$completeShell(request);
        }
    } else boundary.pendingTasks--, 4 !== boundary.status && (boundary.status = 4, task = $274619feb1928437$var$logRecoverableError(request, error, segment), boundary.status = 4, boundary.errorDigest = task, $274619feb1928437$var$untrackBoundary(request, boundary), boundary.parentFlushed && request.clientRenderedBoundaries.push(boundary)), boundary.fallbackAbortableTasks.forEach(function(fallbackTask) {
        return $274619feb1928437$var$abortTask(fallbackTask, request, error);
    }), boundary.fallbackAbortableTasks.clear();
    request.allPendingTasks--;
    0 === request.allPendingTasks && $274619feb1928437$var$completeAll(request);
}
function $274619feb1928437$var$safelyEmitEarlyPreloads(request, shellComplete) {
    try {
        var renderState = request.renderState, onHeaders = renderState.onHeaders;
        if (onHeaders) {
            var headers = renderState.headers;
            if (headers) {
                renderState.headers = null;
                var linkHeader = headers.preconnects;
                headers.fontPreloads && (linkHeader && (linkHeader += ", "), linkHeader += headers.fontPreloads);
                headers.highImagePreloads && (linkHeader && (linkHeader += ", "), linkHeader += headers.highImagePreloads);
                if (!shellComplete) {
                    var queueIter = renderState.styles.values(), queueStep = queueIter.next();
                    b: for(; 0 < headers.remainingCapacity && !queueStep.done; queueStep = queueIter.next())for(var sheetIter = queueStep.value.sheets.values(), sheetStep = sheetIter.next(); 0 < headers.remainingCapacity && !sheetStep.done; sheetStep = sheetIter.next()){
                        var sheet = sheetStep.value, props = sheet.props, key = props.href, props$jscomp$0 = sheet.props, header = $274619feb1928437$var$getPreloadAsHeader(props$jscomp$0.href, "style", {
                            crossOrigin: props$jscomp$0.crossOrigin,
                            integrity: props$jscomp$0.integrity,
                            nonce: props$jscomp$0.nonce,
                            type: props$jscomp$0.type,
                            fetchPriority: props$jscomp$0.fetchPriority,
                            referrerPolicy: props$jscomp$0.referrerPolicy,
                            media: props$jscomp$0.media
                        });
                        if (0 <= (headers.remainingCapacity -= header.length + 2)) renderState.resets.style[key] = $274619feb1928437$var$PRELOAD_NO_CREDS, linkHeader && (linkHeader += ", "), linkHeader += header, renderState.resets.style[key] = "string" === typeof props.crossOrigin || "string" === typeof props.integrity ? [
                            props.crossOrigin,
                            props.integrity
                        ] : $274619feb1928437$var$PRELOAD_NO_CREDS;
                        else break b;
                    }
                }
                linkHeader ? onHeaders({
                    Link: linkHeader
                }) : onHeaders({});
            }
        }
    } catch (error) {
        $274619feb1928437$var$logRecoverableError(request, error, {});
    }
}
function $274619feb1928437$var$completeShell(request) {
    null === request.trackedPostpones && $274619feb1928437$var$safelyEmitEarlyPreloads(request, !0);
    null === request.trackedPostpones && $274619feb1928437$var$preparePreamble(request);
    request.onShellError = $274619feb1928437$var$noop;
    request = request.onShellReady;
    request();
}
function $274619feb1928437$var$completeAll(request) {
    $274619feb1928437$var$safelyEmitEarlyPreloads(request, null === request.trackedPostpones ? !0 : null === request.completedRootSegment || 5 !== request.completedRootSegment.status);
    $274619feb1928437$var$preparePreamble(request);
    request = request.onAllReady;
    request();
}
function $274619feb1928437$var$queueCompletedSegment(boundary, segment) {
    if (0 === segment.chunks.length && 1 === segment.children.length && null === segment.children[0].boundary && -1 === segment.children[0].id) {
        var childSegment = segment.children[0];
        childSegment.id = segment.id;
        childSegment.parentFlushed = !0;
        1 === childSegment.status && $274619feb1928437$var$queueCompletedSegment(boundary, childSegment);
    } else boundary.completedSegments.push(segment);
}
function $274619feb1928437$var$finishedTask(request, boundary, segment) {
    if (null === boundary) {
        if (null !== segment && segment.parentFlushed) {
            if (null !== request.completedRootSegment) throw Error($274619feb1928437$var$formatProdErrorMessage(389));
            request.completedRootSegment = segment;
        }
        request.pendingRootTasks--;
        0 === request.pendingRootTasks && $274619feb1928437$var$completeShell(request);
    } else boundary.pendingTasks--, 4 !== boundary.status && (0 === boundary.pendingTasks ? (0 === boundary.status && (boundary.status = 1), null !== segment && segment.parentFlushed && 1 === segment.status && $274619feb1928437$var$queueCompletedSegment(boundary, segment), boundary.parentFlushed && request.completedBoundaries.push(boundary), 1 === boundary.status && (boundary.fallbackAbortableTasks.forEach($274619feb1928437$var$abortTaskSoft, request), boundary.fallbackAbortableTasks.clear(), 0 === request.pendingRootTasks && null === request.trackedPostpones && null !== boundary.contentPreamble && $274619feb1928437$var$preparePreamble(request))) : null !== segment && segment.parentFlushed && 1 === segment.status && ($274619feb1928437$var$queueCompletedSegment(boundary, segment), 1 === boundary.completedSegments.length && boundary.parentFlushed && request.partialBoundaries.push(boundary)));
    request.allPendingTasks--;
    0 === request.allPendingTasks && $274619feb1928437$var$completeAll(request);
}
function $274619feb1928437$var$performWork(request$jscomp$2) {
    if (14 !== request$jscomp$2.status && 13 !== request$jscomp$2.status) {
        var prevContext = $274619feb1928437$var$currentActiveSnapshot, prevDispatcher = $274619feb1928437$var$ReactSharedInternals.H;
        $274619feb1928437$var$ReactSharedInternals.H = $274619feb1928437$var$HooksDispatcher;
        var prevAsyncDispatcher = $274619feb1928437$var$ReactSharedInternals.A;
        $274619feb1928437$var$ReactSharedInternals.A = $274619feb1928437$var$DefaultAsyncDispatcher;
        var prevRequest = $274619feb1928437$var$currentRequest;
        $274619feb1928437$var$currentRequest = request$jscomp$2;
        var prevResumableState = $274619feb1928437$var$currentResumableState;
        $274619feb1928437$var$currentResumableState = request$jscomp$2.resumableState;
        try {
            var pingedTasks = request$jscomp$2.pingedTasks, i;
            for(i = 0; i < pingedTasks.length; i++){
                var task = pingedTasks[i], request = request$jscomp$2, segment = task.blockedSegment;
                if (null === segment) {
                    var request$jscomp$0 = request;
                    if (0 !== task.replay.pendingTasks) {
                        $274619feb1928437$var$switchContext(task.context);
                        try {
                            "number" === typeof task.replay.slots ? $274619feb1928437$var$resumeNode(request$jscomp$0, task, task.replay.slots, task.node, task.childIndex) : $274619feb1928437$var$retryNode(request$jscomp$0, task);
                            if (1 === task.replay.pendingTasks && 0 < task.replay.nodes.length) throw Error($274619feb1928437$var$formatProdErrorMessage(488));
                            task.replay.pendingTasks--;
                            task.abortSet.delete(task);
                            $274619feb1928437$var$finishedTask(request$jscomp$0, task.blockedBoundary, null);
                        } catch (thrownValue) {
                            $274619feb1928437$var$resetHooksState();
                            var x = thrownValue === $274619feb1928437$var$SuspenseException ? $274619feb1928437$var$getSuspendedThenable() : thrownValue;
                            if ("object" === typeof x && null !== x && "function" === typeof x.then) {
                                var ping = task.ping;
                                x.then(ping, ping);
                                task.thenableState = $274619feb1928437$var$getThenableStateAfterSuspending();
                            } else {
                                task.replay.pendingTasks--;
                                task.abortSet.delete(task);
                                var errorInfo = $274619feb1928437$var$getThrownInfo(task.componentStack);
                                request = void 0;
                                var request$jscomp$1 = request$jscomp$0, boundary = task.blockedBoundary, error$jscomp$0 = 12 === request$jscomp$0.status ? request$jscomp$0.fatalError : x, replayNodes = task.replay.nodes, resumeSlots = task.replay.slots;
                                request = $274619feb1928437$var$logRecoverableError(request$jscomp$1, error$jscomp$0, errorInfo);
                                $274619feb1928437$var$abortRemainingReplayNodes(request$jscomp$1, boundary, replayNodes, resumeSlots, error$jscomp$0, request);
                                request$jscomp$0.pendingRootTasks--;
                                0 === request$jscomp$0.pendingRootTasks && $274619feb1928437$var$completeShell(request$jscomp$0);
                                request$jscomp$0.allPendingTasks--;
                                0 === request$jscomp$0.allPendingTasks && $274619feb1928437$var$completeAll(request$jscomp$0);
                            }
                        } finally{}
                    }
                } else if (request$jscomp$0 = void 0, request$jscomp$1 = segment, 0 === request$jscomp$1.status) {
                    request$jscomp$1.status = 6;
                    $274619feb1928437$var$switchContext(task.context);
                    var childrenLength = request$jscomp$1.children.length, chunkLength = request$jscomp$1.chunks.length;
                    try {
                        $274619feb1928437$var$retryNode(request, task), $274619feb1928437$var$pushSegmentFinale(request$jscomp$1.chunks, request.renderState, request$jscomp$1.lastPushedText, request$jscomp$1.textEmbedded), task.abortSet.delete(task), request$jscomp$1.status = 1, $274619feb1928437$var$finishedTask(request, task.blockedBoundary, request$jscomp$1);
                    } catch (thrownValue) {
                        $274619feb1928437$var$resetHooksState();
                        request$jscomp$1.children.length = childrenLength;
                        request$jscomp$1.chunks.length = chunkLength;
                        var x$jscomp$0 = thrownValue === $274619feb1928437$var$SuspenseException ? $274619feb1928437$var$getSuspendedThenable() : 12 === request.status ? request.fatalError : thrownValue;
                        if ("object" === typeof x$jscomp$0 && null !== x$jscomp$0 && "function" === typeof x$jscomp$0.then) {
                            request$jscomp$1.status = 0;
                            task.thenableState = $274619feb1928437$var$getThenableStateAfterSuspending();
                            var ping$jscomp$0 = task.ping;
                            x$jscomp$0.then(ping$jscomp$0, ping$jscomp$0);
                        } else {
                            var errorInfo$jscomp$0 = $274619feb1928437$var$getThrownInfo(task.componentStack);
                            task.abortSet.delete(task);
                            request$jscomp$1.status = 4;
                            var boundary$jscomp$0 = task.blockedBoundary;
                            request$jscomp$0 = $274619feb1928437$var$logRecoverableError(request, x$jscomp$0, errorInfo$jscomp$0);
                            null === boundary$jscomp$0 ? $274619feb1928437$var$fatalError(request, x$jscomp$0) : (boundary$jscomp$0.pendingTasks--, 4 !== boundary$jscomp$0.status && (boundary$jscomp$0.status = 4, boundary$jscomp$0.errorDigest = request$jscomp$0, $274619feb1928437$var$untrackBoundary(request, boundary$jscomp$0), boundary$jscomp$0.parentFlushed && request.clientRenderedBoundaries.push(boundary$jscomp$0), 0 === request.pendingRootTasks && null === request.trackedPostpones && null !== boundary$jscomp$0.contentPreamble && $274619feb1928437$var$preparePreamble(request)));
                            request.allPendingTasks--;
                            0 === request.allPendingTasks && $274619feb1928437$var$completeAll(request);
                        }
                    } finally{}
                }
            }
            pingedTasks.splice(0, i);
            null !== request$jscomp$2.destination && $274619feb1928437$var$flushCompletedQueues(request$jscomp$2, request$jscomp$2.destination);
        } catch (error) {
            $274619feb1928437$var$logRecoverableError(request$jscomp$2, error, {}), $274619feb1928437$var$fatalError(request$jscomp$2, error);
        } finally{
            $274619feb1928437$var$currentResumableState = prevResumableState, $274619feb1928437$var$ReactSharedInternals.H = prevDispatcher, $274619feb1928437$var$ReactSharedInternals.A = prevAsyncDispatcher, prevDispatcher === $274619feb1928437$var$HooksDispatcher && $274619feb1928437$var$switchContext(prevContext), $274619feb1928437$var$currentRequest = prevRequest;
        }
    }
}
function $274619feb1928437$var$preparePreambleFromSubtree(request, segment, collectedPreambleSegments) {
    segment.preambleChildren.length && collectedPreambleSegments.push(segment.preambleChildren);
    for(var pendingPreambles = !1, i = 0; i < segment.children.length; i++)pendingPreambles = $274619feb1928437$var$preparePreambleFromSegment(request, segment.children[i], collectedPreambleSegments) || pendingPreambles;
    return pendingPreambles;
}
function $274619feb1928437$var$preparePreambleFromSegment(request, segment, collectedPreambleSegments) {
    var boundary = segment.boundary;
    if (null === boundary) return $274619feb1928437$var$preparePreambleFromSubtree(request, segment, collectedPreambleSegments);
    var preamble = boundary.contentPreamble, fallbackPreamble = boundary.fallbackPreamble;
    if (null === preamble || null === fallbackPreamble) return !1;
    switch(boundary.status){
        case 1:
            $274619feb1928437$var$hoistPreambleState(request.renderState, preamble);
            segment = boundary.completedSegments[0];
            if (!segment) throw Error($274619feb1928437$var$formatProdErrorMessage(391));
            return $274619feb1928437$var$preparePreambleFromSubtree(request, segment, collectedPreambleSegments);
        case 5:
            if (null !== request.trackedPostpones) return !0;
        case 4:
            if (1 === segment.status) return $274619feb1928437$var$hoistPreambleState(request.renderState, fallbackPreamble), $274619feb1928437$var$preparePreambleFromSubtree(request, segment, collectedPreambleSegments);
        default:
            return !0;
    }
}
function $274619feb1928437$var$preparePreamble(request) {
    if (request.completedRootSegment && null === request.completedPreambleSegments) {
        var collectedPreambleSegments = [], hasPendingPreambles = $274619feb1928437$var$preparePreambleFromSegment(request, request.completedRootSegment, collectedPreambleSegments), preamble = request.renderState.preamble;
        if (!1 === hasPendingPreambles || preamble.headChunks && preamble.bodyChunks) request.completedPreambleSegments = collectedPreambleSegments;
    }
}
function $274619feb1928437$var$flushSubtree(request, destination, segment, hoistableState) {
    segment.parentFlushed = !0;
    switch(segment.status){
        case 0:
            segment.id = request.nextSegmentId++;
        case 5:
            return hoistableState = segment.id, segment.lastPushedText = !1, segment.textEmbedded = !1, request = request.renderState, destination.push('<template id="'), destination.push(request.placeholderPrefix), request = hoistableState.toString(16), destination.push(request), destination.push('"></template>');
        case 1:
            segment.status = 2;
            var r = !0, chunks = segment.chunks, chunkIdx = 0;
            segment = segment.children;
            for(var childIdx = 0; childIdx < segment.length; childIdx++){
                for(r = segment[childIdx]; chunkIdx < r.index; chunkIdx++)destination.push(chunks[chunkIdx]);
                r = $274619feb1928437$var$flushSegment(request, destination, r, hoistableState);
            }
            for(; chunkIdx < chunks.length - 1; chunkIdx++)destination.push(chunks[chunkIdx]);
            chunkIdx < chunks.length && (r = destination.push(chunks[chunkIdx]));
            return r;
        default:
            throw Error($274619feb1928437$var$formatProdErrorMessage(390));
    }
}
function $274619feb1928437$var$flushSegment(request, destination, segment, hoistableState) {
    var boundary = segment.boundary;
    if (null === boundary) return $274619feb1928437$var$flushSubtree(request, destination, segment, hoistableState);
    boundary.parentFlushed = !0;
    if (4 === boundary.status) {
        if (!request.renderState.generateStaticMarkup) {
            var errorDigest = boundary.errorDigest;
            destination.push("\x3c!--$!--\x3e");
            destination.push("<template");
            errorDigest && (destination.push(' data-dgst="'), errorDigest = $274619feb1928437$var$escapeTextForBrowser(errorDigest), destination.push(errorDigest), destination.push('"'));
            destination.push("></template>");
        }
        $274619feb1928437$var$flushSubtree(request, destination, segment, hoistableState);
        request.renderState.generateStaticMarkup ? destination = !0 : ((request = boundary.fallbackPreamble) && $274619feb1928437$var$writePreambleContribution(destination, request), destination = destination.push("\x3c!--/$--\x3e"));
        return destination;
    }
    if (1 !== boundary.status) return 0 === boundary.status && (boundary.rootSegmentID = request.nextSegmentId++), 0 < boundary.completedSegments.length && request.partialBoundaries.push(boundary), $274619feb1928437$var$writeStartPendingSuspenseBoundary(destination, request.renderState, boundary.rootSegmentID), hoistableState && (boundary = boundary.fallbackState, boundary.styles.forEach($274619feb1928437$var$hoistStyleQueueDependency, hoistableState), boundary.stylesheets.forEach($274619feb1928437$var$hoistStylesheetDependency, hoistableState)), $274619feb1928437$var$flushSubtree(request, destination, segment, hoistableState), destination.push("\x3c!--/$--\x3e");
    if (boundary.byteSize > request.progressiveChunkSize) return boundary.rootSegmentID = request.nextSegmentId++, request.completedBoundaries.push(boundary), $274619feb1928437$var$writeStartPendingSuspenseBoundary(destination, request.renderState, boundary.rootSegmentID), $274619feb1928437$var$flushSubtree(request, destination, segment, hoistableState), destination.push("\x3c!--/$--\x3e");
    hoistableState && (segment = boundary.contentState, segment.styles.forEach($274619feb1928437$var$hoistStyleQueueDependency, hoistableState), segment.stylesheets.forEach($274619feb1928437$var$hoistStylesheetDependency, hoistableState));
    request.renderState.generateStaticMarkup || destination.push("\x3c!--$--\x3e");
    segment = boundary.completedSegments;
    if (1 !== segment.length) throw Error($274619feb1928437$var$formatProdErrorMessage(391));
    $274619feb1928437$var$flushSegment(request, destination, segment[0], hoistableState);
    request.renderState.generateStaticMarkup ? destination = !0 : ((request = boundary.contentPreamble) && $274619feb1928437$var$writePreambleContribution(destination, request), destination = destination.push("\x3c!--/$--\x3e"));
    return destination;
}
function $274619feb1928437$var$flushSegmentContainer(request, destination, segment, hoistableState) {
    $274619feb1928437$var$writeStartSegment(destination, request.renderState, segment.parentFormatContext, segment.id);
    $274619feb1928437$var$flushSegment(request, destination, segment, hoistableState);
    return $274619feb1928437$var$writeEndSegment(destination, segment.parentFormatContext);
}
function $274619feb1928437$var$flushCompletedBoundary(request, destination, boundary) {
    for(var completedSegments = boundary.completedSegments, i = 0; i < completedSegments.length; i++)$274619feb1928437$var$flushPartiallyCompletedSegment(request, destination, boundary, completedSegments[i]);
    completedSegments.length = 0;
    $274619feb1928437$var$writeHoistablesForBoundary(destination, boundary.contentState, request.renderState);
    completedSegments = request.resumableState;
    request = request.renderState;
    i = boundary.rootSegmentID;
    boundary = boundary.contentState;
    var requiresStyleInsertion = request.stylesToHoist;
    request.stylesToHoist = !1;
    destination.push(request.startInlineScript);
    requiresStyleInsertion ? 0 === (completedSegments.instructions & 2) ? (completedSegments.instructions |= 10, destination.push('$RC=function(b,c,e){c=document.getElementById(c);c.parentNode.removeChild(c);var a=document.getElementById(b);if(a){b=a.previousSibling;if(e)b.data="$!",a.setAttribute("data-dgst",e);else{e=b.parentNode;a=b.nextSibling;var f=0;do{if(a&&8===a.nodeType){var d=a.data;if("/$"===d)if(0===f)break;else f--;else"$"!==d&&"$?"!==d&&"$!"!==d||f++}d=a.nextSibling;e.removeChild(a);a=d}while(a);for(;c.firstChild;)e.insertBefore(c.firstChild,a);b.data="$"}b._reactRetry&&b._reactRetry()}};$RM=new Map;\n$RR=function(t,u,y){function v(n){this._p=null;n()}for(var w=$RC,p=$RM,q=new Map,r=document,g,b,h=r.querySelectorAll("link[data-precedence],style[data-precedence]"),x=[],k=0;b=h[k++];)"not all"===b.getAttribute("media")?x.push(b):("LINK"===b.tagName&&p.set(b.getAttribute("href"),b),q.set(b.dataset.precedence,g=b));b=0;h=[];var l,a;for(k=!0;;){if(k){var e=y[b++];if(!e){k=!1;b=0;continue}var c=!1,m=0;var d=e[m++];if(a=p.get(d)){var f=a._p;c=!0}else{a=r.createElement("link");a.href=\nd;a.rel="stylesheet";for(a.dataset.precedence=l=e[m++];f=e[m++];)a.setAttribute(f,e[m++]);f=a._p=new Promise(function(n,z){a.onload=v.bind(a,n);a.onerror=v.bind(a,z)});p.set(d,a)}d=a.getAttribute("media");!f||d&&!matchMedia(d).matches||h.push(f);if(c)continue}else{a=x[b++];if(!a)break;l=a.getAttribute("data-precedence");a.removeAttribute("media")}c=q.get(l)||g;c===g&&(g=a);q.set(l,a);c?c.parentNode.insertBefore(a,c.nextSibling):(c=r.head,c.insertBefore(a,c.firstChild))}Promise.all(h).then(w.bind(null,\nt,u,""),w.bind(null,t,u,"Resource failed to load"))};$RR("')) : 0 === (completedSegments.instructions & 8) ? (completedSegments.instructions |= 8, destination.push('$RM=new Map;\n$RR=function(t,u,y){function v(n){this._p=null;n()}for(var w=$RC,p=$RM,q=new Map,r=document,g,b,h=r.querySelectorAll("link[data-precedence],style[data-precedence]"),x=[],k=0;b=h[k++];)"not all"===b.getAttribute("media")?x.push(b):("LINK"===b.tagName&&p.set(b.getAttribute("href"),b),q.set(b.dataset.precedence,g=b));b=0;h=[];var l,a;for(k=!0;;){if(k){var e=y[b++];if(!e){k=!1;b=0;continue}var c=!1,m=0;var d=e[m++];if(a=p.get(d)){var f=a._p;c=!0}else{a=r.createElement("link");a.href=\nd;a.rel="stylesheet";for(a.dataset.precedence=l=e[m++];f=e[m++];)a.setAttribute(f,e[m++]);f=a._p=new Promise(function(n,z){a.onload=v.bind(a,n);a.onerror=v.bind(a,z)});p.set(d,a)}d=a.getAttribute("media");!f||d&&!matchMedia(d).matches||h.push(f);if(c)continue}else{a=x[b++];if(!a)break;l=a.getAttribute("data-precedence");a.removeAttribute("media")}c=q.get(l)||g;c===g&&(g=a);q.set(l,a);c?c.parentNode.insertBefore(a,c.nextSibling):(c=r.head,c.insertBefore(a,c.firstChild))}Promise.all(h).then(w.bind(null,\nt,u,""),w.bind(null,t,u,"Resource failed to load"))};$RR("')) : destination.push('$RR("') : 0 === (completedSegments.instructions & 2) ? (completedSegments.instructions |= 2, destination.push('$RC=function(b,c,e){c=document.getElementById(c);c.parentNode.removeChild(c);var a=document.getElementById(b);if(a){b=a.previousSibling;if(e)b.data="$!",a.setAttribute("data-dgst",e);else{e=b.parentNode;a=b.nextSibling;var f=0;do{if(a&&8===a.nodeType){var d=a.data;if("/$"===d)if(0===f)break;else f--;else"$"!==d&&"$?"!==d&&"$!"!==d||f++}d=a.nextSibling;e.removeChild(a);a=d}while(a);for(;c.firstChild;)e.insertBefore(c.firstChild,a);b.data="$"}b._reactRetry&&b._reactRetry()}};$RC("')) : destination.push('$RC("');
    completedSegments = i.toString(16);
    destination.push(request.boundaryPrefix);
    destination.push(completedSegments);
    destination.push('","');
    destination.push(request.segmentPrefix);
    destination.push(completedSegments);
    requiresStyleInsertion ? (destination.push('",'), $274619feb1928437$var$writeStyleResourceDependenciesInJS(destination, boundary)) : destination.push('"');
    boundary = destination.push(")\x3c/script>");
    return $274619feb1928437$var$writeBootstrap(destination, request) && boundary;
}
function $274619feb1928437$var$flushPartiallyCompletedSegment(request, destination, boundary, segment) {
    if (2 === segment.status) return !0;
    var hoistableState = boundary.contentState, segmentID = segment.id;
    if (-1 === segmentID) {
        if (-1 === (segment.id = boundary.rootSegmentID)) throw Error($274619feb1928437$var$formatProdErrorMessage(392));
        return $274619feb1928437$var$flushSegmentContainer(request, destination, segment, hoistableState);
    }
    if (segmentID === boundary.rootSegmentID) return $274619feb1928437$var$flushSegmentContainer(request, destination, segment, hoistableState);
    $274619feb1928437$var$flushSegmentContainer(request, destination, segment, hoistableState);
    boundary = request.resumableState;
    request = request.renderState;
    destination.push(request.startInlineScript);
    0 === (boundary.instructions & 1) ? (boundary.instructions |= 1, destination.push('$RS=function(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("')) : destination.push('$RS("');
    destination.push(request.segmentPrefix);
    segmentID = segmentID.toString(16);
    destination.push(segmentID);
    destination.push('","');
    destination.push(request.placeholderPrefix);
    destination.push(segmentID);
    destination = destination.push('")\x3c/script>');
    return destination;
}
function $274619feb1928437$var$flushCompletedQueues(request, destination) {
    try {
        if (!(0 < request.pendingRootTasks)) {
            var i, completedRootSegment = request.completedRootSegment;
            if (null !== completedRootSegment) {
                if (5 === completedRootSegment.status) return;
                var completedPreambleSegments = request.completedPreambleSegments;
                if (null === completedPreambleSegments) return;
                var renderState = request.renderState, preamble = renderState.preamble, htmlChunks = preamble.htmlChunks, headChunks = preamble.headChunks, i$jscomp$0;
                if (htmlChunks) {
                    for(i$jscomp$0 = 0; i$jscomp$0 < htmlChunks.length; i$jscomp$0++)destination.push(htmlChunks[i$jscomp$0]);
                    if (headChunks) for(i$jscomp$0 = 0; i$jscomp$0 < headChunks.length; i$jscomp$0++)destination.push(headChunks[i$jscomp$0]);
                    else {
                        var chunk = $274619feb1928437$var$startChunkForTag("head");
                        destination.push(chunk);
                        destination.push(">");
                    }
                } else if (headChunks) for(i$jscomp$0 = 0; i$jscomp$0 < headChunks.length; i$jscomp$0++)destination.push(headChunks[i$jscomp$0]);
                var charsetChunks = renderState.charsetChunks;
                for(i$jscomp$0 = 0; i$jscomp$0 < charsetChunks.length; i$jscomp$0++)destination.push(charsetChunks[i$jscomp$0]);
                charsetChunks.length = 0;
                renderState.preconnects.forEach($274619feb1928437$var$flushResource, destination);
                renderState.preconnects.clear();
                var viewportChunks = renderState.viewportChunks;
                for(i$jscomp$0 = 0; i$jscomp$0 < viewportChunks.length; i$jscomp$0++)destination.push(viewportChunks[i$jscomp$0]);
                viewportChunks.length = 0;
                renderState.fontPreloads.forEach($274619feb1928437$var$flushResource, destination);
                renderState.fontPreloads.clear();
                renderState.highImagePreloads.forEach($274619feb1928437$var$flushResource, destination);
                renderState.highImagePreloads.clear();
                renderState.styles.forEach($274619feb1928437$var$flushStylesInPreamble, destination);
                var importMapChunks = renderState.importMapChunks;
                for(i$jscomp$0 = 0; i$jscomp$0 < importMapChunks.length; i$jscomp$0++)destination.push(importMapChunks[i$jscomp$0]);
                importMapChunks.length = 0;
                renderState.bootstrapScripts.forEach($274619feb1928437$var$flushResource, destination);
                renderState.scripts.forEach($274619feb1928437$var$flushResource, destination);
                renderState.scripts.clear();
                renderState.bulkPreloads.forEach($274619feb1928437$var$flushResource, destination);
                renderState.bulkPreloads.clear();
                var hoistableChunks = renderState.hoistableChunks;
                for(i$jscomp$0 = 0; i$jscomp$0 < hoistableChunks.length; i$jscomp$0++)destination.push(hoistableChunks[i$jscomp$0]);
                for(renderState = hoistableChunks.length = 0; renderState < completedPreambleSegments.length; renderState++){
                    var segments = completedPreambleSegments[renderState];
                    for(preamble = 0; preamble < segments.length; preamble++)$274619feb1928437$var$flushSegment(request, destination, segments[preamble], null);
                }
                var preamble$jscomp$0 = request.renderState.preamble, headChunks$jscomp$0 = preamble$jscomp$0.headChunks;
                if (preamble$jscomp$0.htmlChunks || headChunks$jscomp$0) {
                    var chunk$jscomp$0 = $274619feb1928437$var$endChunkForTag("head");
                    destination.push(chunk$jscomp$0);
                }
                var bodyChunks = preamble$jscomp$0.bodyChunks;
                if (bodyChunks) for(completedPreambleSegments = 0; completedPreambleSegments < bodyChunks.length; completedPreambleSegments++)destination.push(bodyChunks[completedPreambleSegments]);
                $274619feb1928437$var$flushSegment(request, destination, completedRootSegment, null);
                request.completedRootSegment = null;
                $274619feb1928437$var$writeBootstrap(destination, request.renderState);
            }
            var renderState$jscomp$0 = request.renderState;
            completedRootSegment = 0;
            var viewportChunks$jscomp$0 = renderState$jscomp$0.viewportChunks;
            for(completedRootSegment = 0; completedRootSegment < viewportChunks$jscomp$0.length; completedRootSegment++)destination.push(viewportChunks$jscomp$0[completedRootSegment]);
            viewportChunks$jscomp$0.length = 0;
            renderState$jscomp$0.preconnects.forEach($274619feb1928437$var$flushResource, destination);
            renderState$jscomp$0.preconnects.clear();
            renderState$jscomp$0.fontPreloads.forEach($274619feb1928437$var$flushResource, destination);
            renderState$jscomp$0.fontPreloads.clear();
            renderState$jscomp$0.highImagePreloads.forEach($274619feb1928437$var$flushResource, destination);
            renderState$jscomp$0.highImagePreloads.clear();
            renderState$jscomp$0.styles.forEach($274619feb1928437$var$preloadLateStyles, destination);
            renderState$jscomp$0.scripts.forEach($274619feb1928437$var$flushResource, destination);
            renderState$jscomp$0.scripts.clear();
            renderState$jscomp$0.bulkPreloads.forEach($274619feb1928437$var$flushResource, destination);
            renderState$jscomp$0.bulkPreloads.clear();
            var hoistableChunks$jscomp$0 = renderState$jscomp$0.hoistableChunks;
            for(completedRootSegment = 0; completedRootSegment < hoistableChunks$jscomp$0.length; completedRootSegment++)destination.push(hoistableChunks$jscomp$0[completedRootSegment]);
            hoistableChunks$jscomp$0.length = 0;
            var clientRenderedBoundaries = request.clientRenderedBoundaries;
            for(i = 0; i < clientRenderedBoundaries.length; i++){
                var boundary = clientRenderedBoundaries[i];
                renderState$jscomp$0 = destination;
                var resumableState = request.resumableState, renderState$jscomp$1 = request.renderState, id = boundary.rootSegmentID, errorDigest = boundary.errorDigest;
                renderState$jscomp$0.push(renderState$jscomp$1.startInlineScript);
                0 === (resumableState.instructions & 4) ? (resumableState.instructions |= 4, renderState$jscomp$0.push('$RX=function(b,c,d,e,f){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),f&&(a.cstck=f),b._reactRetry&&b._reactRetry())};;$RX("')) : renderState$jscomp$0.push('$RX("');
                renderState$jscomp$0.push(renderState$jscomp$1.boundaryPrefix);
                var chunk$jscomp$1 = id.toString(16);
                renderState$jscomp$0.push(chunk$jscomp$1);
                renderState$jscomp$0.push('"');
                if (errorDigest) {
                    renderState$jscomp$0.push(",");
                    var chunk$jscomp$2 = $274619feb1928437$var$escapeJSStringsForInstructionScripts(errorDigest || "");
                    renderState$jscomp$0.push(chunk$jscomp$2);
                }
                var JSCompiler_inline_result = renderState$jscomp$0.push(")\x3c/script>");
                if (!JSCompiler_inline_result) {
                    request.destination = null;
                    i++;
                    clientRenderedBoundaries.splice(0, i);
                    return;
                }
            }
            clientRenderedBoundaries.splice(0, i);
            var completedBoundaries = request.completedBoundaries;
            for(i = 0; i < completedBoundaries.length; i++)if (!$274619feb1928437$var$flushCompletedBoundary(request, destination, completedBoundaries[i])) {
                request.destination = null;
                i++;
                completedBoundaries.splice(0, i);
                return;
            }
            completedBoundaries.splice(0, i);
            var partialBoundaries = request.partialBoundaries;
            for(i = 0; i < partialBoundaries.length; i++){
                var boundary$51 = partialBoundaries[i];
                a: {
                    clientRenderedBoundaries = request;
                    boundary = destination;
                    var completedSegments = boundary$51.completedSegments;
                    for(JSCompiler_inline_result = 0; JSCompiler_inline_result < completedSegments.length; JSCompiler_inline_result++)if (!$274619feb1928437$var$flushPartiallyCompletedSegment(clientRenderedBoundaries, boundary, boundary$51, completedSegments[JSCompiler_inline_result])) {
                        JSCompiler_inline_result++;
                        completedSegments.splice(0, JSCompiler_inline_result);
                        var JSCompiler_inline_result$jscomp$0 = !1;
                        break a;
                    }
                    completedSegments.splice(0, JSCompiler_inline_result);
                    JSCompiler_inline_result$jscomp$0 = $274619feb1928437$var$writeHoistablesForBoundary(boundary, boundary$51.contentState, clientRenderedBoundaries.renderState);
                }
                if (!JSCompiler_inline_result$jscomp$0) {
                    request.destination = null;
                    i++;
                    partialBoundaries.splice(0, i);
                    return;
                }
            }
            partialBoundaries.splice(0, i);
            var largeBoundaries = request.completedBoundaries;
            for(i = 0; i < largeBoundaries.length; i++)if (!$274619feb1928437$var$flushCompletedBoundary(request, destination, largeBoundaries[i])) {
                request.destination = null;
                i++;
                largeBoundaries.splice(0, i);
                return;
            }
            largeBoundaries.splice(0, i);
        }
    } finally{
        0 === request.allPendingTasks && 0 === request.pingedTasks.length && 0 === request.clientRenderedBoundaries.length && 0 === request.completedBoundaries.length && (request.flushScheduled = !1, i = request.resumableState, i.hasBody && (partialBoundaries = $274619feb1928437$var$endChunkForTag("body"), destination.push(partialBoundaries)), i.hasHtml && (i = $274619feb1928437$var$endChunkForTag("html"), destination.push(i)), request.status = 14, destination.push(null), request.destination = null);
    }
}
function $274619feb1928437$var$enqueueFlush(request) {
    if (!1 === request.flushScheduled && 0 === request.pingedTasks.length && null !== request.destination) {
        request.flushScheduled = !0;
        var destination = request.destination;
        destination ? $274619feb1928437$var$flushCompletedQueues(request, destination) : request.flushScheduled = !1;
    }
}
function $274619feb1928437$var$startFlowing(request, destination) {
    if (13 === request.status) request.status = 14, destination.destroy(request.fatalError);
    else if (14 !== request.status && null === request.destination) {
        request.destination = destination;
        try {
            $274619feb1928437$var$flushCompletedQueues(request, destination);
        } catch (error) {
            $274619feb1928437$var$logRecoverableError(request, error, {}), $274619feb1928437$var$fatalError(request, error);
        }
    }
}
function $274619feb1928437$var$abort(request, reason) {
    if (11 === request.status || 10 === request.status) request.status = 12;
    try {
        var abortableTasks = request.abortableTasks;
        if (0 < abortableTasks.size) {
            var error = void 0 === reason ? Error($274619feb1928437$var$formatProdErrorMessage(432)) : "object" === typeof reason && null !== reason && "function" === typeof reason.then ? Error($274619feb1928437$var$formatProdErrorMessage(530)) : reason;
            request.fatalError = error;
            abortableTasks.forEach(function(task) {
                return $274619feb1928437$var$abortTask(task, request, error);
            });
            abortableTasks.clear();
        }
        null !== request.destination && $274619feb1928437$var$flushCompletedQueues(request, request.destination);
    } catch (error$53) {
        $274619feb1928437$var$logRecoverableError(request, error$53, {}), $274619feb1928437$var$fatalError(request, error$53);
    }
}
function $274619feb1928437$var$onError() {}
function $274619feb1928437$var$renderToStringImpl(children, options, generateStaticMarkup, abortReason) {
    var didFatal = !1, fatalError = null, result = "", readyToStream = !1;
    options = $274619feb1928437$var$createResumableState(options ? options.identifierPrefix : void 0);
    children = $274619feb1928437$var$createRequest(children, options, $274619feb1928437$var$createRenderState(options, generateStaticMarkup), $274619feb1928437$var$createFormatContext(0, null, 0), Infinity, $274619feb1928437$var$onError, void 0, function() {
        readyToStream = !0;
    }, void 0, void 0, void 0);
    children.flushScheduled = null !== children.destination;
    $274619feb1928437$var$performWork(children);
    10 === children.status && (children.status = 11);
    null === children.trackedPostpones && $274619feb1928437$var$safelyEmitEarlyPreloads(children, 0 === children.pendingRootTasks);
    $274619feb1928437$var$abort(children, abortReason);
    $274619feb1928437$var$startFlowing(children, {
        push: function(chunk) {
            null !== chunk && (result += chunk);
            return !0;
        },
        destroy: function(error) {
            didFatal = !0;
            fatalError = error;
        }
    });
    if (didFatal && fatalError !== abortReason) throw fatalError;
    if (!readyToStream) throw Error($274619feb1928437$var$formatProdErrorMessage(426));
    return result;
}
$274619feb1928437$export$eb3a06aef9e6ee51 = function(children, options) {
    return $274619feb1928437$var$renderToStringImpl(children, options, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$274619feb1928437$export$80e7718417253a51 = function(children, options) {
    return $274619feb1928437$var$renderToStringImpl(children, options, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$274619feb1928437$export$83d89fbfd8236492 = "19.1.1";

});

parcelRegister("hiPWA", function(module, exports) {

$parcel$export(module.exports, "prerender", () => $c98c69161ea584a8$export$4f10e897d13fb72b, (v) => $c98c69161ea584a8$export$4f10e897d13fb72b = v);
$parcel$export(module.exports, "renderToReadableStream", () => $c98c69161ea584a8$export$7020a3240b287705, (v) => $c98c69161ea584a8$export$7020a3240b287705 = v);
$parcel$export(module.exports, "version", () => $c98c69161ea584a8$export$83d89fbfd8236492, (v) => $c98c69161ea584a8$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server.browser.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*


 JS Implementation of MurmurHash3 (r136) (as of May 20, 2011)

 Copyright (c) 2011 Gary Court
 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in
 all copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.
*/ var $c98c69161ea584a8$export$4f10e897d13fb72b;
var $c98c69161ea584a8$export$7020a3240b287705;
var $c98c69161ea584a8$export$83d89fbfd8236492;
"use strict";

var $dNU7X = parcelRequire("dNU7X");

var $boCrV = parcelRequire("boCrV");
function $c98c69161ea584a8$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $c98c69161ea584a8$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $c98c69161ea584a8$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $c98c69161ea584a8$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $c98c69161ea584a8$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $c98c69161ea584a8$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $c98c69161ea584a8$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider"), $c98c69161ea584a8$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $c98c69161ea584a8$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $c98c69161ea584a8$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $c98c69161ea584a8$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $c98c69161ea584a8$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $c98c69161ea584a8$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $c98c69161ea584a8$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $c98c69161ea584a8$var$REACT_SCOPE_TYPE = Symbol.for("react.scope"), $c98c69161ea584a8$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $c98c69161ea584a8$var$REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden"), $c98c69161ea584a8$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $c98c69161ea584a8$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $c98c69161ea584a8$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator, $c98c69161ea584a8$var$isArrayImpl = Array.isArray;
function $c98c69161ea584a8$var$murmurhash3_32_gc(key, seed) {
    var remainder = key.length & 3;
    var bytes = key.length - remainder;
    var h1 = seed;
    for(seed = 0; seed < bytes;){
        var k1 = key.charCodeAt(seed) & 255 | (key.charCodeAt(++seed) & 255) << 8 | (key.charCodeAt(++seed) & 255) << 16 | (key.charCodeAt(++seed) & 255) << 24;
        ++seed;
        k1 = 3432918353 * (k1 & 65535) + ((3432918353 * (k1 >>> 16) & 65535) << 16) & 4294967295;
        k1 = k1 << 15 | k1 >>> 17;
        k1 = 461845907 * (k1 & 65535) + ((461845907 * (k1 >>> 16) & 65535) << 16) & 4294967295;
        h1 ^= k1;
        h1 = h1 << 13 | h1 >>> 19;
        h1 = 5 * (h1 & 65535) + ((5 * (h1 >>> 16) & 65535) << 16) & 4294967295;
        h1 = (h1 & 65535) + 27492 + (((h1 >>> 16) + 58964 & 65535) << 16);
    }
    k1 = 0;
    switch(remainder){
        case 3:
            k1 ^= (key.charCodeAt(seed + 2) & 255) << 16;
        case 2:
            k1 ^= (key.charCodeAt(seed + 1) & 255) << 8;
        case 1:
            k1 ^= key.charCodeAt(seed) & 255, k1 = 3432918353 * (k1 & 65535) + ((3432918353 * (k1 >>> 16) & 65535) << 16) & 4294967295, k1 = k1 << 15 | k1 >>> 17, h1 ^= 461845907 * (k1 & 65535) + ((461845907 * (k1 >>> 16) & 65535) << 16) & 4294967295;
    }
    h1 ^= key.length;
    h1 ^= h1 >>> 16;
    h1 = 2246822507 * (h1 & 65535) + ((2246822507 * (h1 >>> 16) & 65535) << 16) & 4294967295;
    h1 ^= h1 >>> 13;
    h1 = 3266489909 * (h1 & 65535) + ((3266489909 * (h1 >>> 16) & 65535) << 16) & 4294967295;
    return (h1 ^ h1 >>> 16) >>> 0;
}
var $c98c69161ea584a8$var$channel = new MessageChannel(), $c98c69161ea584a8$var$taskQueue = [];
$c98c69161ea584a8$var$channel.port1.onmessage = function() {
    var task = $c98c69161ea584a8$var$taskQueue.shift();
    task && task();
};
function $c98c69161ea584a8$var$scheduleWork(callback) {
    $c98c69161ea584a8$var$taskQueue.push(callback);
    $c98c69161ea584a8$var$channel.port2.postMessage(null);
}
function $c98c69161ea584a8$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
var $c98c69161ea584a8$var$LocalPromise = Promise, $c98c69161ea584a8$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : function(callback) {
    $c98c69161ea584a8$var$LocalPromise.resolve(null).then(callback).catch($c98c69161ea584a8$var$handleErrorInNextTick);
}, $c98c69161ea584a8$var$currentView = null, $c98c69161ea584a8$var$writtenBytes = 0;
function $c98c69161ea584a8$var$writeChunk(destination, chunk) {
    if (0 !== chunk.byteLength) {
        if (2048 < chunk.byteLength) 0 < $c98c69161ea584a8$var$writtenBytes && (destination.enqueue(new Uint8Array($c98c69161ea584a8$var$currentView.buffer, 0, $c98c69161ea584a8$var$writtenBytes)), $c98c69161ea584a8$var$currentView = new Uint8Array(2048), $c98c69161ea584a8$var$writtenBytes = 0), destination.enqueue(chunk);
        else {
            var allowableBytes = $c98c69161ea584a8$var$currentView.length - $c98c69161ea584a8$var$writtenBytes;
            allowableBytes < chunk.byteLength && (0 === allowableBytes ? destination.enqueue($c98c69161ea584a8$var$currentView) : ($c98c69161ea584a8$var$currentView.set(chunk.subarray(0, allowableBytes), $c98c69161ea584a8$var$writtenBytes), destination.enqueue($c98c69161ea584a8$var$currentView), chunk = chunk.subarray(allowableBytes)), $c98c69161ea584a8$var$currentView = new Uint8Array(2048), $c98c69161ea584a8$var$writtenBytes = 0);
            $c98c69161ea584a8$var$currentView.set(chunk, $c98c69161ea584a8$var$writtenBytes);
            $c98c69161ea584a8$var$writtenBytes += chunk.byteLength;
        }
    }
}
function $c98c69161ea584a8$var$writeChunkAndReturn(destination, chunk) {
    $c98c69161ea584a8$var$writeChunk(destination, chunk);
    return !0;
}
function $c98c69161ea584a8$var$completeWriting(destination) {
    $c98c69161ea584a8$var$currentView && 0 < $c98c69161ea584a8$var$writtenBytes && (destination.enqueue(new Uint8Array($c98c69161ea584a8$var$currentView.buffer, 0, $c98c69161ea584a8$var$writtenBytes)), $c98c69161ea584a8$var$currentView = null, $c98c69161ea584a8$var$writtenBytes = 0);
}
var $c98c69161ea584a8$var$textEncoder = new TextEncoder();
function $c98c69161ea584a8$var$stringToChunk(content) {
    return $c98c69161ea584a8$var$textEncoder.encode(content);
}
function $c98c69161ea584a8$var$stringToPrecomputedChunk(content) {
    return $c98c69161ea584a8$var$textEncoder.encode(content);
}
function $c98c69161ea584a8$var$closeWithError(destination, error) {
    "function" === typeof destination.error ? destination.error(error) : destination.close();
}
var $c98c69161ea584a8$var$assign = Object.assign, $c98c69161ea584a8$var$hasOwnProperty = Object.prototype.hasOwnProperty, $c98c69161ea584a8$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $c98c69161ea584a8$var$illegalAttributeNameCache = {}, $c98c69161ea584a8$var$validatedAttributeNameCache = {};
function $c98c69161ea584a8$var$isAttributeNameSafe(attributeName) {
    if ($c98c69161ea584a8$var$hasOwnProperty.call($c98c69161ea584a8$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($c98c69161ea584a8$var$hasOwnProperty.call($c98c69161ea584a8$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($c98c69161ea584a8$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $c98c69161ea584a8$var$validatedAttributeNameCache[attributeName] = !0;
    $c98c69161ea584a8$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
var $c98c69161ea584a8$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" ")), $c98c69161ea584a8$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $c98c69161ea584a8$var$matchHtmlRegExp = /["'&<>]/;
function $c98c69161ea584a8$var$escapeTextForBrowser(text) {
    if ("boolean" === typeof text || "number" === typeof text || "bigint" === typeof text) return "" + text;
    text = "" + text;
    var match = $c98c69161ea584a8$var$matchHtmlRegExp.exec(text);
    if (match) {
        var html = "", index, lastIndex = 0;
        for(index = match.index; index < text.length; index++){
            switch(text.charCodeAt(index)){
                case 34:
                    match = "&quot;";
                    break;
                case 38:
                    match = "&amp;";
                    break;
                case 39:
                    match = "&#x27;";
                    break;
                case 60:
                    match = "&lt;";
                    break;
                case 62:
                    match = "&gt;";
                    break;
                default:
                    continue;
            }
            lastIndex !== index && (html += text.slice(lastIndex, index));
            lastIndex = index + 1;
            html += match;
        }
        text = lastIndex !== index ? html + text.slice(lastIndex, index) : html;
    }
    return text;
}
var $c98c69161ea584a8$var$uppercasePattern = /([A-Z])/g, $c98c69161ea584a8$var$msPattern = /^ms-/, $c98c69161ea584a8$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $c98c69161ea584a8$var$sanitizeURL(url) {
    return $c98c69161ea584a8$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
var $c98c69161ea584a8$var$ReactSharedInternals = $dNU7X.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $c98c69161ea584a8$var$ReactDOMSharedInternals = $boCrV.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $c98c69161ea584a8$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $c98c69161ea584a8$var$previousDispatcher = $c98c69161ea584a8$var$ReactDOMSharedInternals.d;
$c98c69161ea584a8$var$ReactDOMSharedInternals.d = {
    f: $c98c69161ea584a8$var$previousDispatcher.f,
    r: $c98c69161ea584a8$var$previousDispatcher.r,
    D: $c98c69161ea584a8$var$prefetchDNS,
    C: $c98c69161ea584a8$var$preconnect,
    L: $c98c69161ea584a8$var$preload,
    m: $c98c69161ea584a8$var$preloadModule,
    X: $c98c69161ea584a8$var$preinitScript,
    S: $c98c69161ea584a8$var$preinitStyle,
    M: $c98c69161ea584a8$var$preinitModuleScript
};
var $c98c69161ea584a8$var$PRELOAD_NO_CREDS = [];
$c98c69161ea584a8$var$stringToPrecomputedChunk('"></template>');
var $c98c69161ea584a8$var$startInlineScript = $c98c69161ea584a8$var$stringToPrecomputedChunk("<script>"), $c98c69161ea584a8$var$endInlineScript = $c98c69161ea584a8$var$stringToPrecomputedChunk("\x3c/script>"), $c98c69161ea584a8$var$startScriptSrc = $c98c69161ea584a8$var$stringToPrecomputedChunk('<script src="'), $c98c69161ea584a8$var$startModuleSrc = $c98c69161ea584a8$var$stringToPrecomputedChunk('<script type="module" src="'), $c98c69161ea584a8$var$scriptNonce = $c98c69161ea584a8$var$stringToPrecomputedChunk('" nonce="'), $c98c69161ea584a8$var$scriptIntegirty = $c98c69161ea584a8$var$stringToPrecomputedChunk('" integrity="'), $c98c69161ea584a8$var$scriptCrossOrigin = $c98c69161ea584a8$var$stringToPrecomputedChunk('" crossorigin="'), $c98c69161ea584a8$var$endAsyncScript = $c98c69161ea584a8$var$stringToPrecomputedChunk('" async="">\x3c/script>'), $c98c69161ea584a8$var$scriptRegex = /(<\/|<)(s)(cript)/gi;
function $c98c69161ea584a8$var$scriptReplacer(match, prefix, s, suffix) {
    return "" + prefix + ("s" === s ? "\\u0073" : "\\u0053") + suffix;
}
var $c98c69161ea584a8$var$importMapScriptStart = $c98c69161ea584a8$var$stringToPrecomputedChunk('<script type="importmap">'), $c98c69161ea584a8$var$importMapScriptEnd = $c98c69161ea584a8$var$stringToPrecomputedChunk("\x3c/script>");
function $c98c69161ea584a8$var$createRenderState(resumableState, nonce, externalRuntimeConfig, importMap, onHeaders, maxHeadersLength) {
    var inlineScriptWithNonce = void 0 === nonce ? $c98c69161ea584a8$var$startInlineScript : $c98c69161ea584a8$var$stringToPrecomputedChunk('<script nonce="' + $c98c69161ea584a8$var$escapeTextForBrowser(nonce) + '">'), idPrefix = resumableState.idPrefix;
    externalRuntimeConfig = [];
    var bootstrapScriptContent = resumableState.bootstrapScriptContent, bootstrapScripts = resumableState.bootstrapScripts, bootstrapModules = resumableState.bootstrapModules;
    void 0 !== bootstrapScriptContent && externalRuntimeConfig.push(inlineScriptWithNonce, $c98c69161ea584a8$var$stringToChunk(("" + bootstrapScriptContent).replace($c98c69161ea584a8$var$scriptRegex, $c98c69161ea584a8$var$scriptReplacer)), $c98c69161ea584a8$var$endInlineScript);
    bootstrapScriptContent = [];
    void 0 !== importMap && (bootstrapScriptContent.push($c98c69161ea584a8$var$importMapScriptStart), bootstrapScriptContent.push($c98c69161ea584a8$var$stringToChunk(("" + JSON.stringify(importMap)).replace($c98c69161ea584a8$var$scriptRegex, $c98c69161ea584a8$var$scriptReplacer))), bootstrapScriptContent.push($c98c69161ea584a8$var$importMapScriptEnd));
    importMap = onHeaders ? {
        preconnects: "",
        fontPreloads: "",
        highImagePreloads: "",
        remainingCapacity: 2 + ("number" === typeof maxHeadersLength ? maxHeadersLength : 2e3)
    } : null;
    onHeaders = {
        placeholderPrefix: $c98c69161ea584a8$var$stringToPrecomputedChunk(idPrefix + "P:"),
        segmentPrefix: $c98c69161ea584a8$var$stringToPrecomputedChunk(idPrefix + "S:"),
        boundaryPrefix: $c98c69161ea584a8$var$stringToPrecomputedChunk(idPrefix + "B:"),
        startInlineScript: inlineScriptWithNonce,
        preamble: $c98c69161ea584a8$var$createPreambleState(),
        externalRuntimeScript: null,
        bootstrapChunks: externalRuntimeConfig,
        importMapChunks: bootstrapScriptContent,
        onHeaders: onHeaders,
        headers: importMap,
        resets: {
            font: {},
            dns: {},
            connect: {
                default: {},
                anonymous: {},
                credentials: {}
            },
            image: {},
            style: {}
        },
        charsetChunks: [],
        viewportChunks: [],
        hoistableChunks: [],
        preconnects: new Set(),
        fontPreloads: new Set(),
        highImagePreloads: new Set(),
        styles: new Map(),
        bootstrapScripts: new Set(),
        scripts: new Set(),
        bulkPreloads: new Set(),
        preloads: {
            images: new Map(),
            stylesheets: new Map(),
            scripts: new Map(),
            moduleScripts: new Map()
        },
        nonce: nonce,
        hoistableState: null,
        stylesToHoist: !1
    };
    if (void 0 !== bootstrapScripts) for(importMap = 0; importMap < bootstrapScripts.length; importMap++){
        var scriptConfig = bootstrapScripts[importMap];
        idPrefix = inlineScriptWithNonce = void 0;
        bootstrapScriptContent = {
            rel: "preload",
            as: "script",
            fetchPriority: "low",
            nonce: nonce
        };
        "string" === typeof scriptConfig ? bootstrapScriptContent.href = maxHeadersLength = scriptConfig : (bootstrapScriptContent.href = maxHeadersLength = scriptConfig.src, bootstrapScriptContent.integrity = idPrefix = "string" === typeof scriptConfig.integrity ? scriptConfig.integrity : void 0, bootstrapScriptContent.crossOrigin = inlineScriptWithNonce = "string" === typeof scriptConfig || null == scriptConfig.crossOrigin ? void 0 : "use-credentials" === scriptConfig.crossOrigin ? "use-credentials" : "");
        scriptConfig = resumableState;
        var href = maxHeadersLength;
        scriptConfig.scriptResources[href] = null;
        scriptConfig.moduleScriptResources[href] = null;
        scriptConfig = [];
        $c98c69161ea584a8$var$pushLinkImpl(scriptConfig, bootstrapScriptContent);
        onHeaders.bootstrapScripts.add(scriptConfig);
        externalRuntimeConfig.push($c98c69161ea584a8$var$startScriptSrc, $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(maxHeadersLength)));
        nonce && externalRuntimeConfig.push($c98c69161ea584a8$var$scriptNonce, $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(nonce)));
        "string" === typeof idPrefix && externalRuntimeConfig.push($c98c69161ea584a8$var$scriptIntegirty, $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(idPrefix)));
        "string" === typeof inlineScriptWithNonce && externalRuntimeConfig.push($c98c69161ea584a8$var$scriptCrossOrigin, $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(inlineScriptWithNonce)));
        externalRuntimeConfig.push($c98c69161ea584a8$var$endAsyncScript);
    }
    if (void 0 !== bootstrapModules) for(bootstrapScripts = 0; bootstrapScripts < bootstrapModules.length; bootstrapScripts++)bootstrapScriptContent = bootstrapModules[bootstrapScripts], inlineScriptWithNonce = maxHeadersLength = void 0, idPrefix = {
        rel: "modulepreload",
        fetchPriority: "low",
        nonce: nonce
    }, "string" === typeof bootstrapScriptContent ? idPrefix.href = importMap = bootstrapScriptContent : (idPrefix.href = importMap = bootstrapScriptContent.src, idPrefix.integrity = inlineScriptWithNonce = "string" === typeof bootstrapScriptContent.integrity ? bootstrapScriptContent.integrity : void 0, idPrefix.crossOrigin = maxHeadersLength = "string" === typeof bootstrapScriptContent || null == bootstrapScriptContent.crossOrigin ? void 0 : "use-credentials" === bootstrapScriptContent.crossOrigin ? "use-credentials" : ""), bootstrapScriptContent = resumableState, scriptConfig = importMap, bootstrapScriptContent.scriptResources[scriptConfig] = null, bootstrapScriptContent.moduleScriptResources[scriptConfig] = null, bootstrapScriptContent = [], $c98c69161ea584a8$var$pushLinkImpl(bootstrapScriptContent, idPrefix), onHeaders.bootstrapScripts.add(bootstrapScriptContent), externalRuntimeConfig.push($c98c69161ea584a8$var$startModuleSrc, $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(importMap))), nonce && externalRuntimeConfig.push($c98c69161ea584a8$var$scriptNonce, $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(nonce))), "string" === typeof inlineScriptWithNonce && externalRuntimeConfig.push($c98c69161ea584a8$var$scriptIntegirty, $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(inlineScriptWithNonce))), "string" === typeof maxHeadersLength && externalRuntimeConfig.push($c98c69161ea584a8$var$scriptCrossOrigin, $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(maxHeadersLength))), externalRuntimeConfig.push($c98c69161ea584a8$var$endAsyncScript);
    return onHeaders;
}
function $c98c69161ea584a8$var$createResumableState(identifierPrefix, externalRuntimeConfig, bootstrapScriptContent, bootstrapScripts, bootstrapModules) {
    return {
        idPrefix: void 0 === identifierPrefix ? "" : identifierPrefix,
        nextFormID: 0,
        streamingFormat: 0,
        bootstrapScriptContent: bootstrapScriptContent,
        bootstrapScripts: bootstrapScripts,
        bootstrapModules: bootstrapModules,
        instructions: 0,
        hasBody: !1,
        hasHtml: !1,
        unknownResources: {},
        dnsResources: {},
        connectResources: {
            default: {},
            anonymous: {},
            credentials: {}
        },
        imageResources: {},
        styleResources: {},
        scriptResources: {},
        moduleUnknownResources: {},
        moduleScriptResources: {}
    };
}
function $c98c69161ea584a8$var$createPreambleState() {
    return {
        htmlChunks: null,
        headChunks: null,
        bodyChunks: null,
        contribution: 0
    };
}
function $c98c69161ea584a8$var$createFormatContext(insertionMode, selectedValue, tagScope) {
    return {
        insertionMode: insertionMode,
        selectedValue: selectedValue,
        tagScope: tagScope
    };
}
function $c98c69161ea584a8$var$createRootFormatContext(namespaceURI) {
    return $c98c69161ea584a8$var$createFormatContext("http://www.w3.org/2000/svg" === namespaceURI ? 4 : "http://www.w3.org/1998/Math/MathML" === namespaceURI ? 5 : 0, null, 0);
}
function $c98c69161ea584a8$var$getChildFormatContext(parentContext, type, props) {
    switch(type){
        case "noscript":
            return $c98c69161ea584a8$var$createFormatContext(2, null, parentContext.tagScope | 1);
        case "select":
            return $c98c69161ea584a8$var$createFormatContext(2, null != props.value ? props.value : props.defaultValue, parentContext.tagScope);
        case "svg":
            return $c98c69161ea584a8$var$createFormatContext(4, null, parentContext.tagScope);
        case "picture":
            return $c98c69161ea584a8$var$createFormatContext(2, null, parentContext.tagScope | 2);
        case "math":
            return $c98c69161ea584a8$var$createFormatContext(5, null, parentContext.tagScope);
        case "foreignObject":
            return $c98c69161ea584a8$var$createFormatContext(2, null, parentContext.tagScope);
        case "table":
            return $c98c69161ea584a8$var$createFormatContext(6, null, parentContext.tagScope);
        case "thead":
        case "tbody":
        case "tfoot":
            return $c98c69161ea584a8$var$createFormatContext(7, null, parentContext.tagScope);
        case "colgroup":
            return $c98c69161ea584a8$var$createFormatContext(9, null, parentContext.tagScope);
        case "tr":
            return $c98c69161ea584a8$var$createFormatContext(8, null, parentContext.tagScope);
        case "head":
            if (2 > parentContext.insertionMode) return $c98c69161ea584a8$var$createFormatContext(3, null, parentContext.tagScope);
            break;
        case "html":
            if (0 === parentContext.insertionMode) return $c98c69161ea584a8$var$createFormatContext(1, null, parentContext.tagScope);
    }
    return 6 <= parentContext.insertionMode || 2 > parentContext.insertionMode ? $c98c69161ea584a8$var$createFormatContext(2, null, parentContext.tagScope) : parentContext;
}
var $c98c69161ea584a8$var$textSeparator = $c98c69161ea584a8$var$stringToPrecomputedChunk("\x3c!-- --\x3e");
function $c98c69161ea584a8$var$pushTextInstance(target, text, renderState, textEmbedded) {
    if ("" === text) return textEmbedded;
    textEmbedded && target.push($c98c69161ea584a8$var$textSeparator);
    target.push($c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(text)));
    return !0;
}
var $c98c69161ea584a8$var$styleNameCache = new Map(), $c98c69161ea584a8$var$styleAttributeStart = $c98c69161ea584a8$var$stringToPrecomputedChunk(' style="'), $c98c69161ea584a8$var$styleAssign = $c98c69161ea584a8$var$stringToPrecomputedChunk(":"), $c98c69161ea584a8$var$styleSeparator = $c98c69161ea584a8$var$stringToPrecomputedChunk(";");
function $c98c69161ea584a8$var$pushStyleAttribute(target, style) {
    if ("object" !== typeof style) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(62));
    var isFirst = !0, styleName;
    for(styleName in style)if ($c98c69161ea584a8$var$hasOwnProperty.call(style, styleName)) {
        var styleValue = style[styleName];
        if (null != styleValue && "boolean" !== typeof styleValue && "" !== styleValue) {
            if (0 === styleName.indexOf("--")) {
                var nameChunk = $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(styleName));
                styleValue = $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(("" + styleValue).trim()));
            } else nameChunk = $c98c69161ea584a8$var$styleNameCache.get(styleName), void 0 === nameChunk && (nameChunk = $c98c69161ea584a8$var$stringToPrecomputedChunk($c98c69161ea584a8$var$escapeTextForBrowser(styleName.replace($c98c69161ea584a8$var$uppercasePattern, "-$1").toLowerCase().replace($c98c69161ea584a8$var$msPattern, "-ms-"))), $c98c69161ea584a8$var$styleNameCache.set(styleName, nameChunk)), styleValue = "number" === typeof styleValue ? 0 === styleValue || $c98c69161ea584a8$var$unitlessNumbers.has(styleName) ? $c98c69161ea584a8$var$stringToChunk("" + styleValue) : $c98c69161ea584a8$var$stringToChunk(styleValue + "px") : $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(("" + styleValue).trim()));
            isFirst ? (isFirst = !1, target.push($c98c69161ea584a8$var$styleAttributeStart, nameChunk, $c98c69161ea584a8$var$styleAssign, styleValue)) : target.push($c98c69161ea584a8$var$styleSeparator, nameChunk, $c98c69161ea584a8$var$styleAssign, styleValue);
        }
    }
    isFirst || target.push($c98c69161ea584a8$var$attributeEnd);
}
var $c98c69161ea584a8$var$attributeSeparator = $c98c69161ea584a8$var$stringToPrecomputedChunk(" "), $c98c69161ea584a8$var$attributeAssign = $c98c69161ea584a8$var$stringToPrecomputedChunk('="'), $c98c69161ea584a8$var$attributeEnd = $c98c69161ea584a8$var$stringToPrecomputedChunk('"'), $c98c69161ea584a8$var$attributeEmptyString = $c98c69161ea584a8$var$stringToPrecomputedChunk('=""');
function $c98c69161ea584a8$var$pushBooleanAttribute(target, name, value) {
    value && "function" !== typeof value && "symbol" !== typeof value && target.push($c98c69161ea584a8$var$attributeSeparator, $c98c69161ea584a8$var$stringToChunk(name), $c98c69161ea584a8$var$attributeEmptyString);
}
function $c98c69161ea584a8$var$pushStringAttribute(target, name, value) {
    "function" !== typeof value && "symbol" !== typeof value && "boolean" !== typeof value && target.push($c98c69161ea584a8$var$attributeSeparator, $c98c69161ea584a8$var$stringToChunk(name), $c98c69161ea584a8$var$attributeAssign, $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(value)), $c98c69161ea584a8$var$attributeEnd);
}
var $c98c69161ea584a8$var$actionJavaScriptURL = $c98c69161ea584a8$var$stringToPrecomputedChunk($c98c69161ea584a8$var$escapeTextForBrowser("javascript:throw new Error('React form unexpectedly submitted.')")), $c98c69161ea584a8$var$startHiddenInputChunk = $c98c69161ea584a8$var$stringToPrecomputedChunk('<input type="hidden"');
function $c98c69161ea584a8$var$pushAdditionalFormField(value, key) {
    this.push($c98c69161ea584a8$var$startHiddenInputChunk);
    $c98c69161ea584a8$var$validateAdditionalFormField(value);
    $c98c69161ea584a8$var$pushStringAttribute(this, "name", key);
    $c98c69161ea584a8$var$pushStringAttribute(this, "value", value);
    this.push($c98c69161ea584a8$var$endOfStartTagSelfClosing);
}
function $c98c69161ea584a8$var$validateAdditionalFormField(value) {
    if ("string" !== typeof value) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(480));
}
function $c98c69161ea584a8$var$getCustomFormFields(resumableState, formAction) {
    if ("function" === typeof formAction.$$FORM_ACTION) {
        var id = resumableState.nextFormID++;
        resumableState = resumableState.idPrefix + id;
        try {
            var customFields = formAction.$$FORM_ACTION(resumableState);
            if (customFields) {
                var formData = customFields.data;
                null != formData && formData.forEach($c98c69161ea584a8$var$validateAdditionalFormField);
            }
            return customFields;
        } catch (x) {
            if ("object" === typeof x && null !== x && "function" === typeof x.then) throw x;
        }
    }
    return null;
}
function $c98c69161ea584a8$var$pushFormActionAttribute(target, resumableState, renderState, formAction, formEncType, formMethod, formTarget, name) {
    var formData = null;
    if ("function" === typeof formAction) {
        var customFields = $c98c69161ea584a8$var$getCustomFormFields(resumableState, formAction);
        null !== customFields ? (name = customFields.name, formAction = customFields.action || "", formEncType = customFields.encType, formMethod = customFields.method, formTarget = customFields.target, formData = customFields.data) : (target.push($c98c69161ea584a8$var$attributeSeparator, $c98c69161ea584a8$var$stringToChunk("formAction"), $c98c69161ea584a8$var$attributeAssign, $c98c69161ea584a8$var$actionJavaScriptURL, $c98c69161ea584a8$var$attributeEnd), formTarget = formMethod = formEncType = formAction = name = null, $c98c69161ea584a8$var$injectFormReplayingRuntime(resumableState, renderState));
    }
    null != name && $c98c69161ea584a8$var$pushAttribute(target, "name", name);
    null != formAction && $c98c69161ea584a8$var$pushAttribute(target, "formAction", formAction);
    null != formEncType && $c98c69161ea584a8$var$pushAttribute(target, "formEncType", formEncType);
    null != formMethod && $c98c69161ea584a8$var$pushAttribute(target, "formMethod", formMethod);
    null != formTarget && $c98c69161ea584a8$var$pushAttribute(target, "formTarget", formTarget);
    return formData;
}
function $c98c69161ea584a8$var$pushAttribute(target, name, value) {
    switch(name){
        case "className":
            $c98c69161ea584a8$var$pushStringAttribute(target, "class", value);
            break;
        case "tabIndex":
            $c98c69161ea584a8$var$pushStringAttribute(target, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $c98c69161ea584a8$var$pushStringAttribute(target, name, value);
            break;
        case "style":
            $c98c69161ea584a8$var$pushStyleAttribute(target, value);
            break;
        case "src":
        case "href":
            if ("" === value) break;
        case "action":
        case "formAction":
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) break;
            value = $c98c69161ea584a8$var$sanitizeURL("" + value);
            target.push($c98c69161ea584a8$var$attributeSeparator, $c98c69161ea584a8$var$stringToChunk(name), $c98c69161ea584a8$var$attributeAssign, $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(value)), $c98c69161ea584a8$var$attributeEnd);
            break;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "ref":
            break;
        case "autoFocus":
        case "multiple":
        case "muted":
            $c98c69161ea584a8$var$pushBooleanAttribute(target, name.toLowerCase(), value);
            break;
        case "xlinkHref":
            if ("function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) break;
            value = $c98c69161ea584a8$var$sanitizeURL("" + value);
            target.push($c98c69161ea584a8$var$attributeSeparator, $c98c69161ea584a8$var$stringToChunk("xlink:href"), $c98c69161ea584a8$var$attributeAssign, $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(value)), $c98c69161ea584a8$var$attributeEnd);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            "function" !== typeof value && "symbol" !== typeof value && target.push($c98c69161ea584a8$var$attributeSeparator, $c98c69161ea584a8$var$stringToChunk(name), $c98c69161ea584a8$var$attributeAssign, $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(value)), $c98c69161ea584a8$var$attributeEnd);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value && target.push($c98c69161ea584a8$var$attributeSeparator, $c98c69161ea584a8$var$stringToChunk(name), $c98c69161ea584a8$var$attributeEmptyString);
            break;
        case "capture":
        case "download":
            !0 === value ? target.push($c98c69161ea584a8$var$attributeSeparator, $c98c69161ea584a8$var$stringToChunk(name), $c98c69161ea584a8$var$attributeEmptyString) : !1 !== value && "function" !== typeof value && "symbol" !== typeof value && target.push($c98c69161ea584a8$var$attributeSeparator, $c98c69161ea584a8$var$stringToChunk(name), $c98c69161ea584a8$var$attributeAssign, $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(value)), $c98c69161ea584a8$var$attributeEnd);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value && target.push($c98c69161ea584a8$var$attributeSeparator, $c98c69161ea584a8$var$stringToChunk(name), $c98c69161ea584a8$var$attributeAssign, $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(value)), $c98c69161ea584a8$var$attributeEnd);
            break;
        case "rowSpan":
        case "start":
            "function" === typeof value || "symbol" === typeof value || isNaN(value) || target.push($c98c69161ea584a8$var$attributeSeparator, $c98c69161ea584a8$var$stringToChunk(name), $c98c69161ea584a8$var$attributeAssign, $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(value)), $c98c69161ea584a8$var$attributeEnd);
            break;
        case "xlinkActuate":
            $c98c69161ea584a8$var$pushStringAttribute(target, "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $c98c69161ea584a8$var$pushStringAttribute(target, "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $c98c69161ea584a8$var$pushStringAttribute(target, "xlink:role", value);
            break;
        case "xlinkShow":
            $c98c69161ea584a8$var$pushStringAttribute(target, "xlink:show", value);
            break;
        case "xlinkTitle":
            $c98c69161ea584a8$var$pushStringAttribute(target, "xlink:title", value);
            break;
        case "xlinkType":
            $c98c69161ea584a8$var$pushStringAttribute(target, "xlink:type", value);
            break;
        case "xmlBase":
            $c98c69161ea584a8$var$pushStringAttribute(target, "xml:base", value);
            break;
        case "xmlLang":
            $c98c69161ea584a8$var$pushStringAttribute(target, "xml:lang", value);
            break;
        case "xmlSpace":
            $c98c69161ea584a8$var$pushStringAttribute(target, "xml:space", value);
            break;
        default:
            if (!(2 < name.length) || "o" !== name[0] && "O" !== name[0] || "n" !== name[1] && "N" !== name[1]) {
                if (name = $c98c69161ea584a8$var$aliases.get(name) || name, $c98c69161ea584a8$var$isAttributeNameSafe(name)) {
                    switch(typeof value){
                        case "function":
                        case "symbol":
                            return;
                        case "boolean":
                            var prefix$8 = name.toLowerCase().slice(0, 5);
                            if ("data-" !== prefix$8 && "aria-" !== prefix$8) return;
                    }
                    target.push($c98c69161ea584a8$var$attributeSeparator, $c98c69161ea584a8$var$stringToChunk(name), $c98c69161ea584a8$var$attributeAssign, $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(value)), $c98c69161ea584a8$var$attributeEnd);
                }
            }
    }
}
var $c98c69161ea584a8$var$endOfStartTag = $c98c69161ea584a8$var$stringToPrecomputedChunk(">"), $c98c69161ea584a8$var$endOfStartTagSelfClosing = $c98c69161ea584a8$var$stringToPrecomputedChunk("/>");
function $c98c69161ea584a8$var$pushInnerHTML(target, innerHTML, children) {
    if (null != innerHTML) {
        if (null != children) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(60));
        if ("object" !== typeof innerHTML || !("__html" in innerHTML)) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(61));
        innerHTML = innerHTML.__html;
        null !== innerHTML && void 0 !== innerHTML && target.push($c98c69161ea584a8$var$stringToChunk("" + innerHTML));
    }
}
function $c98c69161ea584a8$var$flattenOptionChildren(children) {
    var content = "";
    $dNU7X.Children.forEach(children, function(child) {
        null != child && (content += child);
    });
    return content;
}
var $c98c69161ea584a8$var$selectedMarkerAttribute = $c98c69161ea584a8$var$stringToPrecomputedChunk(' selected=""'), $c98c69161ea584a8$var$formReplayingRuntimeScript = $c98c69161ea584a8$var$stringToPrecomputedChunk('addEventListener("submit",function(a){if(!a.defaultPrevented){var c=a.target,d=a.submitter,e=c.action,b=d;if(d){var f=d.getAttribute("formAction");null!=f&&(e=f,b=null)}"javascript:throw new Error(\'React form unexpectedly submitted.\')"===e&&(a.preventDefault(),b?(a=document.createElement("input"),a.name=b.name,a.value=b.value,b.parentNode.insertBefore(a,b),b=new FormData(c),a.parentNode.removeChild(a)):b=new FormData(c),a=c.ownerDocument||c,(a.$$reactFormReplay=a.$$reactFormReplay||[]).push(c,d,b))}});');
function $c98c69161ea584a8$var$injectFormReplayingRuntime(resumableState, renderState) {
    0 === (resumableState.instructions & 16) && (resumableState.instructions |= 16, renderState.bootstrapChunks.unshift(renderState.startInlineScript, $c98c69161ea584a8$var$formReplayingRuntimeScript, $c98c69161ea584a8$var$endInlineScript));
}
var $c98c69161ea584a8$var$formStateMarkerIsMatching = $c98c69161ea584a8$var$stringToPrecomputedChunk("\x3c!--F!--\x3e"), $c98c69161ea584a8$var$formStateMarkerIsNotMatching = $c98c69161ea584a8$var$stringToPrecomputedChunk("\x3c!--F--\x3e");
function $c98c69161ea584a8$var$pushLinkImpl(target, props) {
    target.push($c98c69161ea584a8$var$startChunkForTag("link"));
    for(var propKey in props)if ($c98c69161ea584a8$var$hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue) switch(propKey){
            case "children":
            case "dangerouslySetInnerHTML":
                throw Error($c98c69161ea584a8$var$formatProdErrorMessage(399, "link"));
            default:
                $c98c69161ea584a8$var$pushAttribute(target, propKey, propValue);
        }
    }
    target.push($c98c69161ea584a8$var$endOfStartTagSelfClosing);
    return null;
}
var $c98c69161ea584a8$var$styleRegex = /(<\/|<)(s)(tyle)/gi;
function $c98c69161ea584a8$var$styleReplacer(match, prefix, s, suffix) {
    return "" + prefix + ("s" === s ? "\\73 " : "\\53 ") + suffix;
}
function $c98c69161ea584a8$var$pushSelfClosing(target, props, tag) {
    target.push($c98c69161ea584a8$var$startChunkForTag(tag));
    for(var propKey in props)if ($c98c69161ea584a8$var$hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue) switch(propKey){
            case "children":
            case "dangerouslySetInnerHTML":
                throw Error($c98c69161ea584a8$var$formatProdErrorMessage(399, tag));
            default:
                $c98c69161ea584a8$var$pushAttribute(target, propKey, propValue);
        }
    }
    target.push($c98c69161ea584a8$var$endOfStartTagSelfClosing);
    return null;
}
function $c98c69161ea584a8$var$pushTitleImpl(target, props) {
    target.push($c98c69161ea584a8$var$startChunkForTag("title"));
    var children = null, innerHTML = null, propKey;
    for(propKey in props)if ($c98c69161ea584a8$var$hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue) switch(propKey){
            case "children":
                children = propValue;
                break;
            case "dangerouslySetInnerHTML":
                innerHTML = propValue;
                break;
            default:
                $c98c69161ea584a8$var$pushAttribute(target, propKey, propValue);
        }
    }
    target.push($c98c69161ea584a8$var$endOfStartTag);
    props = Array.isArray(children) ? 2 > children.length ? children[0] : null : children;
    "function" !== typeof props && "symbol" !== typeof props && null !== props && void 0 !== props && target.push($c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser("" + props)));
    $c98c69161ea584a8$var$pushInnerHTML(target, innerHTML, children);
    target.push($c98c69161ea584a8$var$endChunkForTag("title"));
    return null;
}
function $c98c69161ea584a8$var$pushScriptImpl(target, props) {
    target.push($c98c69161ea584a8$var$startChunkForTag("script"));
    var children = null, innerHTML = null, propKey;
    for(propKey in props)if ($c98c69161ea584a8$var$hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue) switch(propKey){
            case "children":
                children = propValue;
                break;
            case "dangerouslySetInnerHTML":
                innerHTML = propValue;
                break;
            default:
                $c98c69161ea584a8$var$pushAttribute(target, propKey, propValue);
        }
    }
    target.push($c98c69161ea584a8$var$endOfStartTag);
    $c98c69161ea584a8$var$pushInnerHTML(target, innerHTML, children);
    "string" === typeof children && target.push($c98c69161ea584a8$var$stringToChunk(("" + children).replace($c98c69161ea584a8$var$scriptRegex, $c98c69161ea584a8$var$scriptReplacer)));
    target.push($c98c69161ea584a8$var$endChunkForTag("script"));
    return null;
}
function $c98c69161ea584a8$var$pushStartSingletonElement(target, props, tag) {
    target.push($c98c69161ea584a8$var$startChunkForTag(tag));
    var innerHTML = tag = null, propKey;
    for(propKey in props)if ($c98c69161ea584a8$var$hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue) switch(propKey){
            case "children":
                tag = propValue;
                break;
            case "dangerouslySetInnerHTML":
                innerHTML = propValue;
                break;
            default:
                $c98c69161ea584a8$var$pushAttribute(target, propKey, propValue);
        }
    }
    target.push($c98c69161ea584a8$var$endOfStartTag);
    $c98c69161ea584a8$var$pushInnerHTML(target, innerHTML, tag);
    return tag;
}
function $c98c69161ea584a8$var$pushStartGenericElement(target, props, tag) {
    target.push($c98c69161ea584a8$var$startChunkForTag(tag));
    var innerHTML = tag = null, propKey;
    for(propKey in props)if ($c98c69161ea584a8$var$hasOwnProperty.call(props, propKey)) {
        var propValue = props[propKey];
        if (null != propValue) switch(propKey){
            case "children":
                tag = propValue;
                break;
            case "dangerouslySetInnerHTML":
                innerHTML = propValue;
                break;
            default:
                $c98c69161ea584a8$var$pushAttribute(target, propKey, propValue);
        }
    }
    target.push($c98c69161ea584a8$var$endOfStartTag);
    $c98c69161ea584a8$var$pushInnerHTML(target, innerHTML, tag);
    return "string" === typeof tag ? (target.push($c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(tag))), null) : tag;
}
var $c98c69161ea584a8$var$leadingNewline = $c98c69161ea584a8$var$stringToPrecomputedChunk("\n"), $c98c69161ea584a8$var$VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $c98c69161ea584a8$var$validatedTagCache = new Map();
function $c98c69161ea584a8$var$startChunkForTag(tag) {
    var tagStartChunk = $c98c69161ea584a8$var$validatedTagCache.get(tag);
    if (void 0 === tagStartChunk) {
        if (!$c98c69161ea584a8$var$VALID_TAG_REGEX.test(tag)) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(65, tag));
        tagStartChunk = $c98c69161ea584a8$var$stringToPrecomputedChunk("<" + tag);
        $c98c69161ea584a8$var$validatedTagCache.set(tag, tagStartChunk);
    }
    return tagStartChunk;
}
var $c98c69161ea584a8$var$doctypeChunk = $c98c69161ea584a8$var$stringToPrecomputedChunk("<!DOCTYPE html>");
function $c98c69161ea584a8$var$pushStartInstance(target$jscomp$0, type, props, resumableState, renderState, preambleState, hoistableState, formatContext, textEmbedded, isFallback) {
    switch(type){
        case "div":
        case "span":
        case "svg":
        case "path":
            break;
        case "a":
            target$jscomp$0.push($c98c69161ea584a8$var$startChunkForTag("a"));
            var children = null, innerHTML = null, propKey;
            for(propKey in props)if ($c98c69161ea584a8$var$hasOwnProperty.call(props, propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "children":
                        children = propValue;
                        break;
                    case "dangerouslySetInnerHTML":
                        innerHTML = propValue;
                        break;
                    case "href":
                        "" === propValue ? $c98c69161ea584a8$var$pushStringAttribute(target$jscomp$0, "href", "") : $c98c69161ea584a8$var$pushAttribute(target$jscomp$0, propKey, propValue);
                        break;
                    default:
                        $c98c69161ea584a8$var$pushAttribute(target$jscomp$0, propKey, propValue);
                }
            }
            target$jscomp$0.push($c98c69161ea584a8$var$endOfStartTag);
            $c98c69161ea584a8$var$pushInnerHTML(target$jscomp$0, innerHTML, children);
            if ("string" === typeof children) {
                target$jscomp$0.push($c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(children)));
                var JSCompiler_inline_result = null;
            } else JSCompiler_inline_result = children;
            return JSCompiler_inline_result;
        case "g":
        case "p":
        case "li":
            break;
        case "select":
            target$jscomp$0.push($c98c69161ea584a8$var$startChunkForTag("select"));
            var children$jscomp$0 = null, innerHTML$jscomp$0 = null, propKey$jscomp$0;
            for(propKey$jscomp$0 in props)if ($c98c69161ea584a8$var$hasOwnProperty.call(props, propKey$jscomp$0)) {
                var propValue$jscomp$0 = props[propKey$jscomp$0];
                if (null != propValue$jscomp$0) switch(propKey$jscomp$0){
                    case "children":
                        children$jscomp$0 = propValue$jscomp$0;
                        break;
                    case "dangerouslySetInnerHTML":
                        innerHTML$jscomp$0 = propValue$jscomp$0;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $c98c69161ea584a8$var$pushAttribute(target$jscomp$0, propKey$jscomp$0, propValue$jscomp$0);
                }
            }
            target$jscomp$0.push($c98c69161ea584a8$var$endOfStartTag);
            $c98c69161ea584a8$var$pushInnerHTML(target$jscomp$0, innerHTML$jscomp$0, children$jscomp$0);
            return children$jscomp$0;
        case "option":
            var selectedValue = formatContext.selectedValue;
            target$jscomp$0.push($c98c69161ea584a8$var$startChunkForTag("option"));
            var children$jscomp$1 = null, value = null, selected = null, innerHTML$jscomp$1 = null, propKey$jscomp$1;
            for(propKey$jscomp$1 in props)if ($c98c69161ea584a8$var$hasOwnProperty.call(props, propKey$jscomp$1)) {
                var propValue$jscomp$1 = props[propKey$jscomp$1];
                if (null != propValue$jscomp$1) switch(propKey$jscomp$1){
                    case "children":
                        children$jscomp$1 = propValue$jscomp$1;
                        break;
                    case "selected":
                        selected = propValue$jscomp$1;
                        break;
                    case "dangerouslySetInnerHTML":
                        innerHTML$jscomp$1 = propValue$jscomp$1;
                        break;
                    case "value":
                        value = propValue$jscomp$1;
                    default:
                        $c98c69161ea584a8$var$pushAttribute(target$jscomp$0, propKey$jscomp$1, propValue$jscomp$1);
                }
            }
            if (null != selectedValue) {
                var stringValue = null !== value ? "" + value : $c98c69161ea584a8$var$flattenOptionChildren(children$jscomp$1);
                if ($c98c69161ea584a8$var$isArrayImpl(selectedValue)) {
                    for(var i = 0; i < selectedValue.length; i++)if ("" + selectedValue[i] === stringValue) {
                        target$jscomp$0.push($c98c69161ea584a8$var$selectedMarkerAttribute);
                        break;
                    }
                } else "" + selectedValue === stringValue && target$jscomp$0.push($c98c69161ea584a8$var$selectedMarkerAttribute);
            } else selected && target$jscomp$0.push($c98c69161ea584a8$var$selectedMarkerAttribute);
            target$jscomp$0.push($c98c69161ea584a8$var$endOfStartTag);
            $c98c69161ea584a8$var$pushInnerHTML(target$jscomp$0, innerHTML$jscomp$1, children$jscomp$1);
            return children$jscomp$1;
        case "textarea":
            target$jscomp$0.push($c98c69161ea584a8$var$startChunkForTag("textarea"));
            var value$jscomp$0 = null, defaultValue = null, children$jscomp$2 = null, propKey$jscomp$2;
            for(propKey$jscomp$2 in props)if ($c98c69161ea584a8$var$hasOwnProperty.call(props, propKey$jscomp$2)) {
                var propValue$jscomp$2 = props[propKey$jscomp$2];
                if (null != propValue$jscomp$2) switch(propKey$jscomp$2){
                    case "children":
                        children$jscomp$2 = propValue$jscomp$2;
                        break;
                    case "value":
                        value$jscomp$0 = propValue$jscomp$2;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$jscomp$2;
                        break;
                    case "dangerouslySetInnerHTML":
                        throw Error($c98c69161ea584a8$var$formatProdErrorMessage(91));
                    default:
                        $c98c69161ea584a8$var$pushAttribute(target$jscomp$0, propKey$jscomp$2, propValue$jscomp$2);
                }
            }
            null === value$jscomp$0 && null !== defaultValue && (value$jscomp$0 = defaultValue);
            target$jscomp$0.push($c98c69161ea584a8$var$endOfStartTag);
            if (null != children$jscomp$2) {
                if (null != value$jscomp$0) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(92));
                if ($c98c69161ea584a8$var$isArrayImpl(children$jscomp$2)) {
                    if (1 < children$jscomp$2.length) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(93));
                    value$jscomp$0 = "" + children$jscomp$2[0];
                }
                value$jscomp$0 = "" + children$jscomp$2;
            }
            "string" === typeof value$jscomp$0 && "\n" === value$jscomp$0[0] && target$jscomp$0.push($c98c69161ea584a8$var$leadingNewline);
            null !== value$jscomp$0 && target$jscomp$0.push($c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser("" + value$jscomp$0)));
            return null;
        case "input":
            target$jscomp$0.push($c98c69161ea584a8$var$startChunkForTag("input"));
            var name = null, formAction = null, formEncType = null, formMethod = null, formTarget = null, value$jscomp$1 = null, defaultValue$jscomp$0 = null, checked = null, defaultChecked = null, propKey$jscomp$3;
            for(propKey$jscomp$3 in props)if ($c98c69161ea584a8$var$hasOwnProperty.call(props, propKey$jscomp$3)) {
                var propValue$jscomp$3 = props[propKey$jscomp$3];
                if (null != propValue$jscomp$3) switch(propKey$jscomp$3){
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($c98c69161ea584a8$var$formatProdErrorMessage(399, "input"));
                    case "name":
                        name = propValue$jscomp$3;
                        break;
                    case "formAction":
                        formAction = propValue$jscomp$3;
                        break;
                    case "formEncType":
                        formEncType = propValue$jscomp$3;
                        break;
                    case "formMethod":
                        formMethod = propValue$jscomp$3;
                        break;
                    case "formTarget":
                        formTarget = propValue$jscomp$3;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$jscomp$3;
                        break;
                    case "defaultValue":
                        defaultValue$jscomp$0 = propValue$jscomp$3;
                        break;
                    case "checked":
                        checked = propValue$jscomp$3;
                        break;
                    case "value":
                        value$jscomp$1 = propValue$jscomp$3;
                        break;
                    default:
                        $c98c69161ea584a8$var$pushAttribute(target$jscomp$0, propKey$jscomp$3, propValue$jscomp$3);
                }
            }
            var formData = $c98c69161ea584a8$var$pushFormActionAttribute(target$jscomp$0, resumableState, renderState, formAction, formEncType, formMethod, formTarget, name);
            null !== checked ? $c98c69161ea584a8$var$pushBooleanAttribute(target$jscomp$0, "checked", checked) : null !== defaultChecked && $c98c69161ea584a8$var$pushBooleanAttribute(target$jscomp$0, "checked", defaultChecked);
            null !== value$jscomp$1 ? $c98c69161ea584a8$var$pushAttribute(target$jscomp$0, "value", value$jscomp$1) : null !== defaultValue$jscomp$0 && $c98c69161ea584a8$var$pushAttribute(target$jscomp$0, "value", defaultValue$jscomp$0);
            target$jscomp$0.push($c98c69161ea584a8$var$endOfStartTagSelfClosing);
            null != formData && formData.forEach($c98c69161ea584a8$var$pushAdditionalFormField, target$jscomp$0);
            return null;
        case "button":
            target$jscomp$0.push($c98c69161ea584a8$var$startChunkForTag("button"));
            var children$jscomp$3 = null, innerHTML$jscomp$2 = null, name$jscomp$0 = null, formAction$jscomp$0 = null, formEncType$jscomp$0 = null, formMethod$jscomp$0 = null, formTarget$jscomp$0 = null, propKey$jscomp$4;
            for(propKey$jscomp$4 in props)if ($c98c69161ea584a8$var$hasOwnProperty.call(props, propKey$jscomp$4)) {
                var propValue$jscomp$4 = props[propKey$jscomp$4];
                if (null != propValue$jscomp$4) switch(propKey$jscomp$4){
                    case "children":
                        children$jscomp$3 = propValue$jscomp$4;
                        break;
                    case "dangerouslySetInnerHTML":
                        innerHTML$jscomp$2 = propValue$jscomp$4;
                        break;
                    case "name":
                        name$jscomp$0 = propValue$jscomp$4;
                        break;
                    case "formAction":
                        formAction$jscomp$0 = propValue$jscomp$4;
                        break;
                    case "formEncType":
                        formEncType$jscomp$0 = propValue$jscomp$4;
                        break;
                    case "formMethod":
                        formMethod$jscomp$0 = propValue$jscomp$4;
                        break;
                    case "formTarget":
                        formTarget$jscomp$0 = propValue$jscomp$4;
                        break;
                    default:
                        $c98c69161ea584a8$var$pushAttribute(target$jscomp$0, propKey$jscomp$4, propValue$jscomp$4);
                }
            }
            var formData$jscomp$0 = $c98c69161ea584a8$var$pushFormActionAttribute(target$jscomp$0, resumableState, renderState, formAction$jscomp$0, formEncType$jscomp$0, formMethod$jscomp$0, formTarget$jscomp$0, name$jscomp$0);
            target$jscomp$0.push($c98c69161ea584a8$var$endOfStartTag);
            null != formData$jscomp$0 && formData$jscomp$0.forEach($c98c69161ea584a8$var$pushAdditionalFormField, target$jscomp$0);
            $c98c69161ea584a8$var$pushInnerHTML(target$jscomp$0, innerHTML$jscomp$2, children$jscomp$3);
            if ("string" === typeof children$jscomp$3) {
                target$jscomp$0.push($c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(children$jscomp$3)));
                var JSCompiler_inline_result$jscomp$0 = null;
            } else JSCompiler_inline_result$jscomp$0 = children$jscomp$3;
            return JSCompiler_inline_result$jscomp$0;
        case "form":
            target$jscomp$0.push($c98c69161ea584a8$var$startChunkForTag("form"));
            var children$jscomp$4 = null, innerHTML$jscomp$3 = null, formAction$jscomp$1 = null, formEncType$jscomp$1 = null, formMethod$jscomp$1 = null, formTarget$jscomp$1 = null, propKey$jscomp$5;
            for(propKey$jscomp$5 in props)if ($c98c69161ea584a8$var$hasOwnProperty.call(props, propKey$jscomp$5)) {
                var propValue$jscomp$5 = props[propKey$jscomp$5];
                if (null != propValue$jscomp$5) switch(propKey$jscomp$5){
                    case "children":
                        children$jscomp$4 = propValue$jscomp$5;
                        break;
                    case "dangerouslySetInnerHTML":
                        innerHTML$jscomp$3 = propValue$jscomp$5;
                        break;
                    case "action":
                        formAction$jscomp$1 = propValue$jscomp$5;
                        break;
                    case "encType":
                        formEncType$jscomp$1 = propValue$jscomp$5;
                        break;
                    case "method":
                        formMethod$jscomp$1 = propValue$jscomp$5;
                        break;
                    case "target":
                        formTarget$jscomp$1 = propValue$jscomp$5;
                        break;
                    default:
                        $c98c69161ea584a8$var$pushAttribute(target$jscomp$0, propKey$jscomp$5, propValue$jscomp$5);
                }
            }
            var formData$jscomp$1 = null, formActionName = null;
            if ("function" === typeof formAction$jscomp$1) {
                var customFields = $c98c69161ea584a8$var$getCustomFormFields(resumableState, formAction$jscomp$1);
                null !== customFields ? (formAction$jscomp$1 = customFields.action || "", formEncType$jscomp$1 = customFields.encType, formMethod$jscomp$1 = customFields.method, formTarget$jscomp$1 = customFields.target, formData$jscomp$1 = customFields.data, formActionName = customFields.name) : (target$jscomp$0.push($c98c69161ea584a8$var$attributeSeparator, $c98c69161ea584a8$var$stringToChunk("action"), $c98c69161ea584a8$var$attributeAssign, $c98c69161ea584a8$var$actionJavaScriptURL, $c98c69161ea584a8$var$attributeEnd), formTarget$jscomp$1 = formMethod$jscomp$1 = formEncType$jscomp$1 = formAction$jscomp$1 = null, $c98c69161ea584a8$var$injectFormReplayingRuntime(resumableState, renderState));
            }
            null != formAction$jscomp$1 && $c98c69161ea584a8$var$pushAttribute(target$jscomp$0, "action", formAction$jscomp$1);
            null != formEncType$jscomp$1 && $c98c69161ea584a8$var$pushAttribute(target$jscomp$0, "encType", formEncType$jscomp$1);
            null != formMethod$jscomp$1 && $c98c69161ea584a8$var$pushAttribute(target$jscomp$0, "method", formMethod$jscomp$1);
            null != formTarget$jscomp$1 && $c98c69161ea584a8$var$pushAttribute(target$jscomp$0, "target", formTarget$jscomp$1);
            target$jscomp$0.push($c98c69161ea584a8$var$endOfStartTag);
            null !== formActionName && (target$jscomp$0.push($c98c69161ea584a8$var$startHiddenInputChunk), $c98c69161ea584a8$var$pushStringAttribute(target$jscomp$0, "name", formActionName), target$jscomp$0.push($c98c69161ea584a8$var$endOfStartTagSelfClosing), null != formData$jscomp$1 && formData$jscomp$1.forEach($c98c69161ea584a8$var$pushAdditionalFormField, target$jscomp$0));
            $c98c69161ea584a8$var$pushInnerHTML(target$jscomp$0, innerHTML$jscomp$3, children$jscomp$4);
            if ("string" === typeof children$jscomp$4) {
                target$jscomp$0.push($c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(children$jscomp$4)));
                var JSCompiler_inline_result$jscomp$1 = null;
            } else JSCompiler_inline_result$jscomp$1 = children$jscomp$4;
            return JSCompiler_inline_result$jscomp$1;
        case "menuitem":
            target$jscomp$0.push($c98c69161ea584a8$var$startChunkForTag("menuitem"));
            for(var propKey$jscomp$6 in props)if ($c98c69161ea584a8$var$hasOwnProperty.call(props, propKey$jscomp$6)) {
                var propValue$jscomp$6 = props[propKey$jscomp$6];
                if (null != propValue$jscomp$6) switch(propKey$jscomp$6){
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($c98c69161ea584a8$var$formatProdErrorMessage(400));
                    default:
                        $c98c69161ea584a8$var$pushAttribute(target$jscomp$0, propKey$jscomp$6, propValue$jscomp$6);
                }
            }
            target$jscomp$0.push($c98c69161ea584a8$var$endOfStartTag);
            return null;
        case "object":
            target$jscomp$0.push($c98c69161ea584a8$var$startChunkForTag("object"));
            var children$jscomp$5 = null, innerHTML$jscomp$4 = null, propKey$jscomp$7;
            for(propKey$jscomp$7 in props)if ($c98c69161ea584a8$var$hasOwnProperty.call(props, propKey$jscomp$7)) {
                var propValue$jscomp$7 = props[propKey$jscomp$7];
                if (null != propValue$jscomp$7) switch(propKey$jscomp$7){
                    case "children":
                        children$jscomp$5 = propValue$jscomp$7;
                        break;
                    case "dangerouslySetInnerHTML":
                        innerHTML$jscomp$4 = propValue$jscomp$7;
                        break;
                    case "data":
                        var sanitizedValue = $c98c69161ea584a8$var$sanitizeURL("" + propValue$jscomp$7);
                        if ("" === sanitizedValue) break;
                        target$jscomp$0.push($c98c69161ea584a8$var$attributeSeparator, $c98c69161ea584a8$var$stringToChunk("data"), $c98c69161ea584a8$var$attributeAssign, $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(sanitizedValue)), $c98c69161ea584a8$var$attributeEnd);
                        break;
                    default:
                        $c98c69161ea584a8$var$pushAttribute(target$jscomp$0, propKey$jscomp$7, propValue$jscomp$7);
                }
            }
            target$jscomp$0.push($c98c69161ea584a8$var$endOfStartTag);
            $c98c69161ea584a8$var$pushInnerHTML(target$jscomp$0, innerHTML$jscomp$4, children$jscomp$5);
            if ("string" === typeof children$jscomp$5) {
                target$jscomp$0.push($c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(children$jscomp$5)));
                var JSCompiler_inline_result$jscomp$2 = null;
            } else JSCompiler_inline_result$jscomp$2 = children$jscomp$5;
            return JSCompiler_inline_result$jscomp$2;
        case "title":
            if (4 === formatContext.insertionMode || formatContext.tagScope & 1 || null != props.itemProp) var JSCompiler_inline_result$jscomp$3 = $c98c69161ea584a8$var$pushTitleImpl(target$jscomp$0, props);
            else isFallback ? JSCompiler_inline_result$jscomp$3 = null : ($c98c69161ea584a8$var$pushTitleImpl(renderState.hoistableChunks, props), JSCompiler_inline_result$jscomp$3 = void 0);
            return JSCompiler_inline_result$jscomp$3;
        case "link":
            var rel = props.rel, href = props.href, precedence = props.precedence;
            if (4 === formatContext.insertionMode || formatContext.tagScope & 1 || null != props.itemProp || "string" !== typeof rel || "string" !== typeof href || "" === href) {
                $c98c69161ea584a8$var$pushLinkImpl(target$jscomp$0, props);
                var JSCompiler_inline_result$jscomp$4 = null;
            } else if ("stylesheet" === props.rel) {
                if ("string" !== typeof precedence || null != props.disabled || props.onLoad || props.onError) JSCompiler_inline_result$jscomp$4 = $c98c69161ea584a8$var$pushLinkImpl(target$jscomp$0, props);
                else {
                    var styleQueue = renderState.styles.get(precedence), resourceState = resumableState.styleResources.hasOwnProperty(href) ? resumableState.styleResources[href] : void 0;
                    if (null !== resourceState) {
                        resumableState.styleResources[href] = null;
                        styleQueue || (styleQueue = {
                            precedence: $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(precedence)),
                            rules: [],
                            hrefs: [],
                            sheets: new Map()
                        }, renderState.styles.set(precedence, styleQueue));
                        var resource = {
                            state: 0,
                            props: $c98c69161ea584a8$var$assign({}, props, {
                                "data-precedence": props.precedence,
                                precedence: null
                            })
                        };
                        if (resourceState) {
                            2 === resourceState.length && $c98c69161ea584a8$var$adoptPreloadCredentials(resource.props, resourceState);
                            var preloadResource = renderState.preloads.stylesheets.get(href);
                            preloadResource && 0 < preloadResource.length ? preloadResource.length = 0 : resource.state = 1;
                        }
                        styleQueue.sheets.set(href, resource);
                        hoistableState && hoistableState.stylesheets.add(resource);
                    } else if (styleQueue) {
                        var resource$9 = styleQueue.sheets.get(href);
                        resource$9 && hoistableState && hoistableState.stylesheets.add(resource$9);
                    }
                    textEmbedded && target$jscomp$0.push($c98c69161ea584a8$var$textSeparator);
                    JSCompiler_inline_result$jscomp$4 = null;
                }
            } else props.onLoad || props.onError ? JSCompiler_inline_result$jscomp$4 = $c98c69161ea584a8$var$pushLinkImpl(target$jscomp$0, props) : (textEmbedded && target$jscomp$0.push($c98c69161ea584a8$var$textSeparator), JSCompiler_inline_result$jscomp$4 = isFallback ? null : $c98c69161ea584a8$var$pushLinkImpl(renderState.hoistableChunks, props));
            return JSCompiler_inline_result$jscomp$4;
        case "script":
            var asyncProp = props.async;
            if ("string" !== typeof props.src || !props.src || !asyncProp || "function" === typeof asyncProp || "symbol" === typeof asyncProp || props.onLoad || props.onError || 4 === formatContext.insertionMode || formatContext.tagScope & 1 || null != props.itemProp) var JSCompiler_inline_result$jscomp$5 = $c98c69161ea584a8$var$pushScriptImpl(target$jscomp$0, props);
            else {
                var key = props.src;
                if ("module" === props.type) {
                    var resources = resumableState.moduleScriptResources;
                    var preloads = renderState.preloads.moduleScripts;
                } else resources = resumableState.scriptResources, preloads = renderState.preloads.scripts;
                var resourceState$jscomp$0 = resources.hasOwnProperty(key) ? resources[key] : void 0;
                if (null !== resourceState$jscomp$0) {
                    resources[key] = null;
                    var scriptProps = props;
                    if (resourceState$jscomp$0) {
                        2 === resourceState$jscomp$0.length && (scriptProps = $c98c69161ea584a8$var$assign({}, props), $c98c69161ea584a8$var$adoptPreloadCredentials(scriptProps, resourceState$jscomp$0));
                        var preloadResource$jscomp$0 = preloads.get(key);
                        preloadResource$jscomp$0 && (preloadResource$jscomp$0.length = 0);
                    }
                    var resource$jscomp$0 = [];
                    renderState.scripts.add(resource$jscomp$0);
                    $c98c69161ea584a8$var$pushScriptImpl(resource$jscomp$0, scriptProps);
                }
                textEmbedded && target$jscomp$0.push($c98c69161ea584a8$var$textSeparator);
                JSCompiler_inline_result$jscomp$5 = null;
            }
            return JSCompiler_inline_result$jscomp$5;
        case "style":
            var precedence$jscomp$0 = props.precedence, href$jscomp$0 = props.href;
            if (4 === formatContext.insertionMode || formatContext.tagScope & 1 || null != props.itemProp || "string" !== typeof precedence$jscomp$0 || "string" !== typeof href$jscomp$0 || "" === href$jscomp$0) {
                target$jscomp$0.push($c98c69161ea584a8$var$startChunkForTag("style"));
                var children$jscomp$6 = null, innerHTML$jscomp$5 = null, propKey$jscomp$8;
                for(propKey$jscomp$8 in props)if ($c98c69161ea584a8$var$hasOwnProperty.call(props, propKey$jscomp$8)) {
                    var propValue$jscomp$8 = props[propKey$jscomp$8];
                    if (null != propValue$jscomp$8) switch(propKey$jscomp$8){
                        case "children":
                            children$jscomp$6 = propValue$jscomp$8;
                            break;
                        case "dangerouslySetInnerHTML":
                            innerHTML$jscomp$5 = propValue$jscomp$8;
                            break;
                        default:
                            $c98c69161ea584a8$var$pushAttribute(target$jscomp$0, propKey$jscomp$8, propValue$jscomp$8);
                    }
                }
                target$jscomp$0.push($c98c69161ea584a8$var$endOfStartTag);
                var child = Array.isArray(children$jscomp$6) ? 2 > children$jscomp$6.length ? children$jscomp$6[0] : null : children$jscomp$6;
                "function" !== typeof child && "symbol" !== typeof child && null !== child && void 0 !== child && target$jscomp$0.push($c98c69161ea584a8$var$stringToChunk(("" + child).replace($c98c69161ea584a8$var$styleRegex, $c98c69161ea584a8$var$styleReplacer)));
                $c98c69161ea584a8$var$pushInnerHTML(target$jscomp$0, innerHTML$jscomp$5, children$jscomp$6);
                target$jscomp$0.push($c98c69161ea584a8$var$endChunkForTag("style"));
                var JSCompiler_inline_result$jscomp$6 = null;
            } else {
                var styleQueue$jscomp$0 = renderState.styles.get(precedence$jscomp$0);
                if (null !== (resumableState.styleResources.hasOwnProperty(href$jscomp$0) ? resumableState.styleResources[href$jscomp$0] : void 0)) {
                    resumableState.styleResources[href$jscomp$0] = null;
                    styleQueue$jscomp$0 ? styleQueue$jscomp$0.hrefs.push($c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(href$jscomp$0))) : (styleQueue$jscomp$0 = {
                        precedence: $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(precedence$jscomp$0)),
                        rules: [],
                        hrefs: [
                            $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(href$jscomp$0))
                        ],
                        sheets: new Map()
                    }, renderState.styles.set(precedence$jscomp$0, styleQueue$jscomp$0));
                    var target = styleQueue$jscomp$0.rules, children$jscomp$7 = null, innerHTML$jscomp$6 = null, propKey$jscomp$9;
                    for(propKey$jscomp$9 in props)if ($c98c69161ea584a8$var$hasOwnProperty.call(props, propKey$jscomp$9)) {
                        var propValue$jscomp$9 = props[propKey$jscomp$9];
                        if (null != propValue$jscomp$9) switch(propKey$jscomp$9){
                            case "children":
                                children$jscomp$7 = propValue$jscomp$9;
                                break;
                            case "dangerouslySetInnerHTML":
                                innerHTML$jscomp$6 = propValue$jscomp$9;
                        }
                    }
                    var child$jscomp$0 = Array.isArray(children$jscomp$7) ? 2 > children$jscomp$7.length ? children$jscomp$7[0] : null : children$jscomp$7;
                    "function" !== typeof child$jscomp$0 && "symbol" !== typeof child$jscomp$0 && null !== child$jscomp$0 && void 0 !== child$jscomp$0 && target.push($c98c69161ea584a8$var$stringToChunk(("" + child$jscomp$0).replace($c98c69161ea584a8$var$styleRegex, $c98c69161ea584a8$var$styleReplacer)));
                    $c98c69161ea584a8$var$pushInnerHTML(target, innerHTML$jscomp$6, children$jscomp$7);
                }
                styleQueue$jscomp$0 && hoistableState && hoistableState.styles.add(styleQueue$jscomp$0);
                textEmbedded && target$jscomp$0.push($c98c69161ea584a8$var$textSeparator);
                JSCompiler_inline_result$jscomp$6 = void 0;
            }
            return JSCompiler_inline_result$jscomp$6;
        case "meta":
            if (4 === formatContext.insertionMode || formatContext.tagScope & 1 || null != props.itemProp) var JSCompiler_inline_result$jscomp$7 = $c98c69161ea584a8$var$pushSelfClosing(target$jscomp$0, props, "meta");
            else textEmbedded && target$jscomp$0.push($c98c69161ea584a8$var$textSeparator), JSCompiler_inline_result$jscomp$7 = isFallback ? null : "string" === typeof props.charSet ? $c98c69161ea584a8$var$pushSelfClosing(renderState.charsetChunks, props, "meta") : "viewport" === props.name ? $c98c69161ea584a8$var$pushSelfClosing(renderState.viewportChunks, props, "meta") : $c98c69161ea584a8$var$pushSelfClosing(renderState.hoistableChunks, props, "meta");
            return JSCompiler_inline_result$jscomp$7;
        case "listing":
        case "pre":
            target$jscomp$0.push($c98c69161ea584a8$var$startChunkForTag(type));
            var children$jscomp$8 = null, innerHTML$jscomp$7 = null, propKey$jscomp$10;
            for(propKey$jscomp$10 in props)if ($c98c69161ea584a8$var$hasOwnProperty.call(props, propKey$jscomp$10)) {
                var propValue$jscomp$10 = props[propKey$jscomp$10];
                if (null != propValue$jscomp$10) switch(propKey$jscomp$10){
                    case "children":
                        children$jscomp$8 = propValue$jscomp$10;
                        break;
                    case "dangerouslySetInnerHTML":
                        innerHTML$jscomp$7 = propValue$jscomp$10;
                        break;
                    default:
                        $c98c69161ea584a8$var$pushAttribute(target$jscomp$0, propKey$jscomp$10, propValue$jscomp$10);
                }
            }
            target$jscomp$0.push($c98c69161ea584a8$var$endOfStartTag);
            if (null != innerHTML$jscomp$7) {
                if (null != children$jscomp$8) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(60));
                if ("object" !== typeof innerHTML$jscomp$7 || !("__html" in innerHTML$jscomp$7)) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(61));
                var html = innerHTML$jscomp$7.__html;
                null !== html && void 0 !== html && ("string" === typeof html && 0 < html.length && "\n" === html[0] ? target$jscomp$0.push($c98c69161ea584a8$var$leadingNewline, $c98c69161ea584a8$var$stringToChunk(html)) : target$jscomp$0.push($c98c69161ea584a8$var$stringToChunk("" + html)));
            }
            "string" === typeof children$jscomp$8 && "\n" === children$jscomp$8[0] && target$jscomp$0.push($c98c69161ea584a8$var$leadingNewline);
            return children$jscomp$8;
        case "img":
            var src = props.src, srcSet = props.srcSet;
            if (!("lazy" === props.loading || !src && !srcSet || "string" !== typeof src && null != src || "string" !== typeof srcSet && null != srcSet) && "low" !== props.fetchPriority && !1 === !!(formatContext.tagScope & 3) && ("string" !== typeof src || ":" !== src[4] || "d" !== src[0] && "D" !== src[0] || "a" !== src[1] && "A" !== src[1] || "t" !== src[2] && "T" !== src[2] || "a" !== src[3] && "A" !== src[3]) && ("string" !== typeof srcSet || ":" !== srcSet[4] || "d" !== srcSet[0] && "D" !== srcSet[0] || "a" !== srcSet[1] && "A" !== srcSet[1] || "t" !== srcSet[2] && "T" !== srcSet[2] || "a" !== srcSet[3] && "A" !== srcSet[3])) {
                var sizes = "string" === typeof props.sizes ? props.sizes : void 0, key$jscomp$0 = srcSet ? srcSet + "\n" + (sizes || "") : src, promotablePreloads = renderState.preloads.images, resource$jscomp$1 = promotablePreloads.get(key$jscomp$0);
                if (resource$jscomp$1) {
                    if ("high" === props.fetchPriority || 10 > renderState.highImagePreloads.size) promotablePreloads.delete(key$jscomp$0), renderState.highImagePreloads.add(resource$jscomp$1);
                } else if (!resumableState.imageResources.hasOwnProperty(key$jscomp$0)) {
                    resumableState.imageResources[key$jscomp$0] = $c98c69161ea584a8$var$PRELOAD_NO_CREDS;
                    var input = props.crossOrigin;
                    var JSCompiler_inline_result$jscomp$8 = "string" === typeof input ? "use-credentials" === input ? input : "" : void 0;
                    var headers = renderState.headers, header;
                    headers && 0 < headers.remainingCapacity && "string" !== typeof props.srcSet && ("high" === props.fetchPriority || 500 > headers.highImagePreloads.length) && (header = $c98c69161ea584a8$var$getPreloadAsHeader(src, "image", {
                        imageSrcSet: props.srcSet,
                        imageSizes: props.sizes,
                        crossOrigin: JSCompiler_inline_result$jscomp$8,
                        integrity: props.integrity,
                        nonce: props.nonce,
                        type: props.type,
                        fetchPriority: props.fetchPriority,
                        referrerPolicy: props.refererPolicy
                    }), 0 <= (headers.remainingCapacity -= header.length + 2)) ? (renderState.resets.image[key$jscomp$0] = $c98c69161ea584a8$var$PRELOAD_NO_CREDS, headers.highImagePreloads && (headers.highImagePreloads += ", "), headers.highImagePreloads += header) : (resource$jscomp$1 = [], $c98c69161ea584a8$var$pushLinkImpl(resource$jscomp$1, {
                        rel: "preload",
                        as: "image",
                        href: srcSet ? void 0 : src,
                        imageSrcSet: srcSet,
                        imageSizes: sizes,
                        crossOrigin: JSCompiler_inline_result$jscomp$8,
                        integrity: props.integrity,
                        type: props.type,
                        fetchPriority: props.fetchPriority,
                        referrerPolicy: props.referrerPolicy
                    }), "high" === props.fetchPriority || 10 > renderState.highImagePreloads.size ? renderState.highImagePreloads.add(resource$jscomp$1) : (renderState.bulkPreloads.add(resource$jscomp$1), promotablePreloads.set(key$jscomp$0, resource$jscomp$1)));
                }
            }
            return $c98c69161ea584a8$var$pushSelfClosing(target$jscomp$0, props, "img");
        case "base":
        case "area":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "param":
        case "source":
        case "track":
        case "wbr":
            return $c98c69161ea584a8$var$pushSelfClosing(target$jscomp$0, props, type);
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            break;
        case "head":
            if (2 > formatContext.insertionMode) {
                var preamble = preambleState || renderState.preamble;
                if (preamble.headChunks) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(545, "`<head>`"));
                preamble.headChunks = [];
                var JSCompiler_inline_result$jscomp$9 = $c98c69161ea584a8$var$pushStartSingletonElement(preamble.headChunks, props, "head");
            } else JSCompiler_inline_result$jscomp$9 = $c98c69161ea584a8$var$pushStartGenericElement(target$jscomp$0, props, "head");
            return JSCompiler_inline_result$jscomp$9;
        case "body":
            if (2 > formatContext.insertionMode) {
                var preamble$jscomp$0 = preambleState || renderState.preamble;
                if (preamble$jscomp$0.bodyChunks) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(545, "`<body>`"));
                preamble$jscomp$0.bodyChunks = [];
                var JSCompiler_inline_result$jscomp$10 = $c98c69161ea584a8$var$pushStartSingletonElement(preamble$jscomp$0.bodyChunks, props, "body");
            } else JSCompiler_inline_result$jscomp$10 = $c98c69161ea584a8$var$pushStartGenericElement(target$jscomp$0, props, "body");
            return JSCompiler_inline_result$jscomp$10;
        case "html":
            if (0 === formatContext.insertionMode) {
                var preamble$jscomp$1 = preambleState || renderState.preamble;
                if (preamble$jscomp$1.htmlChunks) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(545, "`<html>`"));
                preamble$jscomp$1.htmlChunks = [
                    $c98c69161ea584a8$var$doctypeChunk
                ];
                var JSCompiler_inline_result$jscomp$11 = $c98c69161ea584a8$var$pushStartSingletonElement(preamble$jscomp$1.htmlChunks, props, "html");
            } else JSCompiler_inline_result$jscomp$11 = $c98c69161ea584a8$var$pushStartGenericElement(target$jscomp$0, props, "html");
            return JSCompiler_inline_result$jscomp$11;
        default:
            if (-1 !== type.indexOf("-")) {
                target$jscomp$0.push($c98c69161ea584a8$var$startChunkForTag(type));
                var children$jscomp$9 = null, innerHTML$jscomp$8 = null, propKey$jscomp$11;
                for(propKey$jscomp$11 in props)if ($c98c69161ea584a8$var$hasOwnProperty.call(props, propKey$jscomp$11)) {
                    var propValue$jscomp$11 = props[propKey$jscomp$11];
                    if (null != propValue$jscomp$11) {
                        var attributeName = propKey$jscomp$11;
                        switch(propKey$jscomp$11){
                            case "children":
                                children$jscomp$9 = propValue$jscomp$11;
                                break;
                            case "dangerouslySetInnerHTML":
                                innerHTML$jscomp$8 = propValue$jscomp$11;
                                break;
                            case "style":
                                $c98c69161ea584a8$var$pushStyleAttribute(target$jscomp$0, propValue$jscomp$11);
                                break;
                            case "suppressContentEditableWarning":
                            case "suppressHydrationWarning":
                            case "ref":
                                break;
                            case "className":
                                attributeName = "class";
                            default:
                                if ($c98c69161ea584a8$var$isAttributeNameSafe(propKey$jscomp$11) && "function" !== typeof propValue$jscomp$11 && "symbol" !== typeof propValue$jscomp$11 && !1 !== propValue$jscomp$11) {
                                    if (!0 === propValue$jscomp$11) propValue$jscomp$11 = "";
                                    else if ("object" === typeof propValue$jscomp$11) continue;
                                    target$jscomp$0.push($c98c69161ea584a8$var$attributeSeparator, $c98c69161ea584a8$var$stringToChunk(attributeName), $c98c69161ea584a8$var$attributeAssign, $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(propValue$jscomp$11)), $c98c69161ea584a8$var$attributeEnd);
                                }
                        }
                    }
                }
                target$jscomp$0.push($c98c69161ea584a8$var$endOfStartTag);
                $c98c69161ea584a8$var$pushInnerHTML(target$jscomp$0, innerHTML$jscomp$8, children$jscomp$9);
                return children$jscomp$9;
            }
    }
    return $c98c69161ea584a8$var$pushStartGenericElement(target$jscomp$0, props, type);
}
var $c98c69161ea584a8$var$endTagCache = new Map();
function $c98c69161ea584a8$var$endChunkForTag(tag) {
    var chunk = $c98c69161ea584a8$var$endTagCache.get(tag);
    void 0 === chunk && (chunk = $c98c69161ea584a8$var$stringToPrecomputedChunk("</" + tag + ">"), $c98c69161ea584a8$var$endTagCache.set(tag, chunk));
    return chunk;
}
function $c98c69161ea584a8$var$hoistPreambleState(renderState, preambleState) {
    renderState = renderState.preamble;
    null === renderState.htmlChunks && preambleState.htmlChunks && (renderState.htmlChunks = preambleState.htmlChunks, preambleState.contribution |= 1);
    null === renderState.headChunks && preambleState.headChunks && (renderState.headChunks = preambleState.headChunks, preambleState.contribution |= 4);
    null === renderState.bodyChunks && preambleState.bodyChunks && (renderState.bodyChunks = preambleState.bodyChunks, preambleState.contribution |= 2);
}
function $c98c69161ea584a8$var$writeBootstrap(destination, renderState) {
    renderState = renderState.bootstrapChunks;
    for(var i = 0; i < renderState.length - 1; i++)$c98c69161ea584a8$var$writeChunk(destination, renderState[i]);
    return i < renderState.length ? (i = renderState[i], renderState.length = 0, $c98c69161ea584a8$var$writeChunkAndReturn(destination, i)) : !0;
}
var $c98c69161ea584a8$var$placeholder1 = $c98c69161ea584a8$var$stringToPrecomputedChunk('<template id="'), $c98c69161ea584a8$var$placeholder2 = $c98c69161ea584a8$var$stringToPrecomputedChunk('"></template>'), $c98c69161ea584a8$var$startCompletedSuspenseBoundary = $c98c69161ea584a8$var$stringToPrecomputedChunk("\x3c!--$--\x3e"), $c98c69161ea584a8$var$startPendingSuspenseBoundary1 = $c98c69161ea584a8$var$stringToPrecomputedChunk('\x3c!--$?--\x3e<template id="'), $c98c69161ea584a8$var$startPendingSuspenseBoundary2 = $c98c69161ea584a8$var$stringToPrecomputedChunk('"></template>'), $c98c69161ea584a8$var$startClientRenderedSuspenseBoundary = $c98c69161ea584a8$var$stringToPrecomputedChunk("\x3c!--$!--\x3e"), $c98c69161ea584a8$var$endSuspenseBoundary = $c98c69161ea584a8$var$stringToPrecomputedChunk("\x3c!--/$--\x3e"), $c98c69161ea584a8$var$clientRenderedSuspenseBoundaryError1 = $c98c69161ea584a8$var$stringToPrecomputedChunk("<template"), $c98c69161ea584a8$var$clientRenderedSuspenseBoundaryErrorAttrInterstitial = $c98c69161ea584a8$var$stringToPrecomputedChunk('"'), $c98c69161ea584a8$var$clientRenderedSuspenseBoundaryError1A = $c98c69161ea584a8$var$stringToPrecomputedChunk(' data-dgst="');
$c98c69161ea584a8$var$stringToPrecomputedChunk(' data-msg="');
$c98c69161ea584a8$var$stringToPrecomputedChunk(' data-stck="');
$c98c69161ea584a8$var$stringToPrecomputedChunk(' data-cstck="');
var $c98c69161ea584a8$var$clientRenderedSuspenseBoundaryError2 = $c98c69161ea584a8$var$stringToPrecomputedChunk("></template>");
function $c98c69161ea584a8$var$writeStartPendingSuspenseBoundary(destination, renderState, id) {
    $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$startPendingSuspenseBoundary1);
    if (null === id) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(395));
    $c98c69161ea584a8$var$writeChunk(destination, renderState.boundaryPrefix);
    $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$stringToChunk(id.toString(16)));
    return $c98c69161ea584a8$var$writeChunkAndReturn(destination, $c98c69161ea584a8$var$startPendingSuspenseBoundary2);
}
var $c98c69161ea584a8$var$boundaryPreambleContributionChunkStart = $c98c69161ea584a8$var$stringToPrecomputedChunk("\x3c!--"), $c98c69161ea584a8$var$boundaryPreambleContributionChunkEnd = $c98c69161ea584a8$var$stringToPrecomputedChunk("--\x3e");
function $c98c69161ea584a8$var$writePreambleContribution(destination, preambleState) {
    preambleState = preambleState.contribution;
    0 !== preambleState && ($c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$boundaryPreambleContributionChunkStart), $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$stringToChunk("" + preambleState)), $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$boundaryPreambleContributionChunkEnd));
}
var $c98c69161ea584a8$var$startSegmentHTML = $c98c69161ea584a8$var$stringToPrecomputedChunk('<div hidden id="'), $c98c69161ea584a8$var$startSegmentHTML2 = $c98c69161ea584a8$var$stringToPrecomputedChunk('">'), $c98c69161ea584a8$var$endSegmentHTML = $c98c69161ea584a8$var$stringToPrecomputedChunk("</div>"), $c98c69161ea584a8$var$startSegmentSVG = $c98c69161ea584a8$var$stringToPrecomputedChunk('<svg aria-hidden="true" style="display:none" id="'), $c98c69161ea584a8$var$startSegmentSVG2 = $c98c69161ea584a8$var$stringToPrecomputedChunk('">'), $c98c69161ea584a8$var$endSegmentSVG = $c98c69161ea584a8$var$stringToPrecomputedChunk("</svg>"), $c98c69161ea584a8$var$startSegmentMathML = $c98c69161ea584a8$var$stringToPrecomputedChunk('<math aria-hidden="true" style="display:none" id="'), $c98c69161ea584a8$var$startSegmentMathML2 = $c98c69161ea584a8$var$stringToPrecomputedChunk('">'), $c98c69161ea584a8$var$endSegmentMathML = $c98c69161ea584a8$var$stringToPrecomputedChunk("</math>"), $c98c69161ea584a8$var$startSegmentTable = $c98c69161ea584a8$var$stringToPrecomputedChunk('<table hidden id="'), $c98c69161ea584a8$var$startSegmentTable2 = $c98c69161ea584a8$var$stringToPrecomputedChunk('">'), $c98c69161ea584a8$var$endSegmentTable = $c98c69161ea584a8$var$stringToPrecomputedChunk("</table>"), $c98c69161ea584a8$var$startSegmentTableBody = $c98c69161ea584a8$var$stringToPrecomputedChunk('<table hidden><tbody id="'), $c98c69161ea584a8$var$startSegmentTableBody2 = $c98c69161ea584a8$var$stringToPrecomputedChunk('">'), $c98c69161ea584a8$var$endSegmentTableBody = $c98c69161ea584a8$var$stringToPrecomputedChunk("</tbody></table>"), $c98c69161ea584a8$var$startSegmentTableRow = $c98c69161ea584a8$var$stringToPrecomputedChunk('<table hidden><tr id="'), $c98c69161ea584a8$var$startSegmentTableRow2 = $c98c69161ea584a8$var$stringToPrecomputedChunk('">'), $c98c69161ea584a8$var$endSegmentTableRow = $c98c69161ea584a8$var$stringToPrecomputedChunk("</tr></table>"), $c98c69161ea584a8$var$startSegmentColGroup = $c98c69161ea584a8$var$stringToPrecomputedChunk('<table hidden><colgroup id="'), $c98c69161ea584a8$var$startSegmentColGroup2 = $c98c69161ea584a8$var$stringToPrecomputedChunk('">'), $c98c69161ea584a8$var$endSegmentColGroup = $c98c69161ea584a8$var$stringToPrecomputedChunk("</colgroup></table>");
function $c98c69161ea584a8$var$writeStartSegment(destination, renderState, formatContext, id) {
    switch(formatContext.insertionMode){
        case 0:
        case 1:
        case 3:
        case 2:
            return $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$startSegmentHTML), $c98c69161ea584a8$var$writeChunk(destination, renderState.segmentPrefix), $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$stringToChunk(id.toString(16))), $c98c69161ea584a8$var$writeChunkAndReturn(destination, $c98c69161ea584a8$var$startSegmentHTML2);
        case 4:
            return $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$startSegmentSVG), $c98c69161ea584a8$var$writeChunk(destination, renderState.segmentPrefix), $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$stringToChunk(id.toString(16))), $c98c69161ea584a8$var$writeChunkAndReturn(destination, $c98c69161ea584a8$var$startSegmentSVG2);
        case 5:
            return $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$startSegmentMathML), $c98c69161ea584a8$var$writeChunk(destination, renderState.segmentPrefix), $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$stringToChunk(id.toString(16))), $c98c69161ea584a8$var$writeChunkAndReturn(destination, $c98c69161ea584a8$var$startSegmentMathML2);
        case 6:
            return $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$startSegmentTable), $c98c69161ea584a8$var$writeChunk(destination, renderState.segmentPrefix), $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$stringToChunk(id.toString(16))), $c98c69161ea584a8$var$writeChunkAndReturn(destination, $c98c69161ea584a8$var$startSegmentTable2);
        case 7:
            return $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$startSegmentTableBody), $c98c69161ea584a8$var$writeChunk(destination, renderState.segmentPrefix), $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$stringToChunk(id.toString(16))), $c98c69161ea584a8$var$writeChunkAndReturn(destination, $c98c69161ea584a8$var$startSegmentTableBody2);
        case 8:
            return $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$startSegmentTableRow), $c98c69161ea584a8$var$writeChunk(destination, renderState.segmentPrefix), $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$stringToChunk(id.toString(16))), $c98c69161ea584a8$var$writeChunkAndReturn(destination, $c98c69161ea584a8$var$startSegmentTableRow2);
        case 9:
            return $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$startSegmentColGroup), $c98c69161ea584a8$var$writeChunk(destination, renderState.segmentPrefix), $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$stringToChunk(id.toString(16))), $c98c69161ea584a8$var$writeChunkAndReturn(destination, $c98c69161ea584a8$var$startSegmentColGroup2);
        default:
            throw Error($c98c69161ea584a8$var$formatProdErrorMessage(397));
    }
}
function $c98c69161ea584a8$var$writeEndSegment(destination, formatContext) {
    switch(formatContext.insertionMode){
        case 0:
        case 1:
        case 3:
        case 2:
            return $c98c69161ea584a8$var$writeChunkAndReturn(destination, $c98c69161ea584a8$var$endSegmentHTML);
        case 4:
            return $c98c69161ea584a8$var$writeChunkAndReturn(destination, $c98c69161ea584a8$var$endSegmentSVG);
        case 5:
            return $c98c69161ea584a8$var$writeChunkAndReturn(destination, $c98c69161ea584a8$var$endSegmentMathML);
        case 6:
            return $c98c69161ea584a8$var$writeChunkAndReturn(destination, $c98c69161ea584a8$var$endSegmentTable);
        case 7:
            return $c98c69161ea584a8$var$writeChunkAndReturn(destination, $c98c69161ea584a8$var$endSegmentTableBody);
        case 8:
            return $c98c69161ea584a8$var$writeChunkAndReturn(destination, $c98c69161ea584a8$var$endSegmentTableRow);
        case 9:
            return $c98c69161ea584a8$var$writeChunkAndReturn(destination, $c98c69161ea584a8$var$endSegmentColGroup);
        default:
            throw Error($c98c69161ea584a8$var$formatProdErrorMessage(397));
    }
}
var $c98c69161ea584a8$var$completeSegmentScript1Full = $c98c69161ea584a8$var$stringToPrecomputedChunk('$RS=function(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), $c98c69161ea584a8$var$completeSegmentScript1Partial = $c98c69161ea584a8$var$stringToPrecomputedChunk('$RS("'), $c98c69161ea584a8$var$completeSegmentScript2 = $c98c69161ea584a8$var$stringToPrecomputedChunk('","'), $c98c69161ea584a8$var$completeSegmentScriptEnd = $c98c69161ea584a8$var$stringToPrecomputedChunk('")\x3c/script>');
$c98c69161ea584a8$var$stringToPrecomputedChunk('<template data-rsi="" data-sid="');
$c98c69161ea584a8$var$stringToPrecomputedChunk('" data-pid="');
var $c98c69161ea584a8$var$completeBoundaryScript1Full = $c98c69161ea584a8$var$stringToPrecomputedChunk('$RC=function(b,c,e){c=document.getElementById(c);c.parentNode.removeChild(c);var a=document.getElementById(b);if(a){b=a.previousSibling;if(e)b.data="$!",a.setAttribute("data-dgst",e);else{e=b.parentNode;a=b.nextSibling;var f=0;do{if(a&&8===a.nodeType){var d=a.data;if("/$"===d)if(0===f)break;else f--;else"$"!==d&&"$?"!==d&&"$!"!==d||f++}d=a.nextSibling;e.removeChild(a);a=d}while(a);for(;c.firstChild;)e.insertBefore(c.firstChild,a);b.data="$"}b._reactRetry&&b._reactRetry()}};$RC("'), $c98c69161ea584a8$var$completeBoundaryScript1Partial = $c98c69161ea584a8$var$stringToPrecomputedChunk('$RC("'), $c98c69161ea584a8$var$completeBoundaryWithStylesScript1FullBoth = $c98c69161ea584a8$var$stringToPrecomputedChunk('$RC=function(b,c,e){c=document.getElementById(c);c.parentNode.removeChild(c);var a=document.getElementById(b);if(a){b=a.previousSibling;if(e)b.data="$!",a.setAttribute("data-dgst",e);else{e=b.parentNode;a=b.nextSibling;var f=0;do{if(a&&8===a.nodeType){var d=a.data;if("/$"===d)if(0===f)break;else f--;else"$"!==d&&"$?"!==d&&"$!"!==d||f++}d=a.nextSibling;e.removeChild(a);a=d}while(a);for(;c.firstChild;)e.insertBefore(c.firstChild,a);b.data="$"}b._reactRetry&&b._reactRetry()}};$RM=new Map;\n$RR=function(t,u,y){function v(n){this._p=null;n()}for(var w=$RC,p=$RM,q=new Map,r=document,g,b,h=r.querySelectorAll("link[data-precedence],style[data-precedence]"),x=[],k=0;b=h[k++];)"not all"===b.getAttribute("media")?x.push(b):("LINK"===b.tagName&&p.set(b.getAttribute("href"),b),q.set(b.dataset.precedence,g=b));b=0;h=[];var l,a;for(k=!0;;){if(k){var e=y[b++];if(!e){k=!1;b=0;continue}var c=!1,m=0;var d=e[m++];if(a=p.get(d)){var f=a._p;c=!0}else{a=r.createElement("link");a.href=\nd;a.rel="stylesheet";for(a.dataset.precedence=l=e[m++];f=e[m++];)a.setAttribute(f,e[m++]);f=a._p=new Promise(function(n,z){a.onload=v.bind(a,n);a.onerror=v.bind(a,z)});p.set(d,a)}d=a.getAttribute("media");!f||d&&!matchMedia(d).matches||h.push(f);if(c)continue}else{a=x[b++];if(!a)break;l=a.getAttribute("data-precedence");a.removeAttribute("media")}c=q.get(l)||g;c===g&&(g=a);q.set(l,a);c?c.parentNode.insertBefore(a,c.nextSibling):(c=r.head,c.insertBefore(a,c.firstChild))}Promise.all(h).then(w.bind(null,\nt,u,""),w.bind(null,t,u,"Resource failed to load"))};$RR("'), $c98c69161ea584a8$var$completeBoundaryWithStylesScript1FullPartial = $c98c69161ea584a8$var$stringToPrecomputedChunk('$RM=new Map;\n$RR=function(t,u,y){function v(n){this._p=null;n()}for(var w=$RC,p=$RM,q=new Map,r=document,g,b,h=r.querySelectorAll("link[data-precedence],style[data-precedence]"),x=[],k=0;b=h[k++];)"not all"===b.getAttribute("media")?x.push(b):("LINK"===b.tagName&&p.set(b.getAttribute("href"),b),q.set(b.dataset.precedence,g=b));b=0;h=[];var l,a;for(k=!0;;){if(k){var e=y[b++];if(!e){k=!1;b=0;continue}var c=!1,m=0;var d=e[m++];if(a=p.get(d)){var f=a._p;c=!0}else{a=r.createElement("link");a.href=\nd;a.rel="stylesheet";for(a.dataset.precedence=l=e[m++];f=e[m++];)a.setAttribute(f,e[m++]);f=a._p=new Promise(function(n,z){a.onload=v.bind(a,n);a.onerror=v.bind(a,z)});p.set(d,a)}d=a.getAttribute("media");!f||d&&!matchMedia(d).matches||h.push(f);if(c)continue}else{a=x[b++];if(!a)break;l=a.getAttribute("data-precedence");a.removeAttribute("media")}c=q.get(l)||g;c===g&&(g=a);q.set(l,a);c?c.parentNode.insertBefore(a,c.nextSibling):(c=r.head,c.insertBefore(a,c.firstChild))}Promise.all(h).then(w.bind(null,\nt,u,""),w.bind(null,t,u,"Resource failed to load"))};$RR("'), $c98c69161ea584a8$var$completeBoundaryWithStylesScript1Partial = $c98c69161ea584a8$var$stringToPrecomputedChunk('$RR("'), $c98c69161ea584a8$var$completeBoundaryScript2 = $c98c69161ea584a8$var$stringToPrecomputedChunk('","'), $c98c69161ea584a8$var$completeBoundaryScript3a = $c98c69161ea584a8$var$stringToPrecomputedChunk('",'), $c98c69161ea584a8$var$completeBoundaryScript3b = $c98c69161ea584a8$var$stringToPrecomputedChunk('"'), $c98c69161ea584a8$var$completeBoundaryScriptEnd = $c98c69161ea584a8$var$stringToPrecomputedChunk(")\x3c/script>");
$c98c69161ea584a8$var$stringToPrecomputedChunk('<template data-rci="" data-bid="');
$c98c69161ea584a8$var$stringToPrecomputedChunk('<template data-rri="" data-bid="');
$c98c69161ea584a8$var$stringToPrecomputedChunk('" data-sid="');
$c98c69161ea584a8$var$stringToPrecomputedChunk('" data-sty="');
var $c98c69161ea584a8$var$clientRenderScript1Full = $c98c69161ea584a8$var$stringToPrecomputedChunk('$RX=function(b,c,d,e,f){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),f&&(a.cstck=f),b._reactRetry&&b._reactRetry())};;$RX("'), $c98c69161ea584a8$var$clientRenderScript1Partial = $c98c69161ea584a8$var$stringToPrecomputedChunk('$RX("'), $c98c69161ea584a8$var$clientRenderScript1A = $c98c69161ea584a8$var$stringToPrecomputedChunk('"'), $c98c69161ea584a8$var$clientRenderErrorScriptArgInterstitial = $c98c69161ea584a8$var$stringToPrecomputedChunk(","), $c98c69161ea584a8$var$clientRenderScriptEnd = $c98c69161ea584a8$var$stringToPrecomputedChunk(")\x3c/script>");
$c98c69161ea584a8$var$stringToPrecomputedChunk('<template data-rxi="" data-bid="');
$c98c69161ea584a8$var$stringToPrecomputedChunk('" data-dgst="');
$c98c69161ea584a8$var$stringToPrecomputedChunk('" data-msg="');
$c98c69161ea584a8$var$stringToPrecomputedChunk('" data-stck="');
$c98c69161ea584a8$var$stringToPrecomputedChunk('" data-cstck="');
var $c98c69161ea584a8$var$regexForJSStringsInInstructionScripts = /[<\u2028\u2029]/g;
function $c98c69161ea584a8$var$escapeJSStringsForInstructionScripts(input) {
    return JSON.stringify(input).replace($c98c69161ea584a8$var$regexForJSStringsInInstructionScripts, function(match) {
        switch(match){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var $c98c69161ea584a8$var$regexForJSStringsInScripts = /[&><\u2028\u2029]/g;
function $c98c69161ea584a8$var$escapeJSObjectForInstructionScripts(input) {
    return JSON.stringify(input).replace($c98c69161ea584a8$var$regexForJSStringsInScripts, function(match) {
        switch(match){
            case "&":
                return "\\u0026";
            case ">":
                return "\\u003e";
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSObjectForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var $c98c69161ea584a8$var$lateStyleTagResourceOpen1 = $c98c69161ea584a8$var$stringToPrecomputedChunk('<style media="not all" data-precedence="'), $c98c69161ea584a8$var$lateStyleTagResourceOpen2 = $c98c69161ea584a8$var$stringToPrecomputedChunk('" data-href="'), $c98c69161ea584a8$var$lateStyleTagResourceOpen3 = $c98c69161ea584a8$var$stringToPrecomputedChunk('">'), $c98c69161ea584a8$var$lateStyleTagTemplateClose = $c98c69161ea584a8$var$stringToPrecomputedChunk("</style>"), $c98c69161ea584a8$var$currentlyRenderingBoundaryHasStylesToHoist = !1, $c98c69161ea584a8$var$destinationHasCapacity = !0;
function $c98c69161ea584a8$var$flushStyleTagsLateForBoundary(styleQueue) {
    var rules = styleQueue.rules, hrefs = styleQueue.hrefs, i = 0;
    if (hrefs.length) {
        $c98c69161ea584a8$var$writeChunk(this, $c98c69161ea584a8$var$lateStyleTagResourceOpen1);
        $c98c69161ea584a8$var$writeChunk(this, styleQueue.precedence);
        for($c98c69161ea584a8$var$writeChunk(this, $c98c69161ea584a8$var$lateStyleTagResourceOpen2); i < hrefs.length - 1; i++)$c98c69161ea584a8$var$writeChunk(this, hrefs[i]), $c98c69161ea584a8$var$writeChunk(this, $c98c69161ea584a8$var$spaceSeparator);
        $c98c69161ea584a8$var$writeChunk(this, hrefs[i]);
        $c98c69161ea584a8$var$writeChunk(this, $c98c69161ea584a8$var$lateStyleTagResourceOpen3);
        for(i = 0; i < rules.length; i++)$c98c69161ea584a8$var$writeChunk(this, rules[i]);
        $c98c69161ea584a8$var$destinationHasCapacity = $c98c69161ea584a8$var$writeChunkAndReturn(this, $c98c69161ea584a8$var$lateStyleTagTemplateClose);
        $c98c69161ea584a8$var$currentlyRenderingBoundaryHasStylesToHoist = !0;
        rules.length = 0;
        hrefs.length = 0;
    }
}
function $c98c69161ea584a8$var$hasStylesToHoist(stylesheet) {
    return 2 !== stylesheet.state ? $c98c69161ea584a8$var$currentlyRenderingBoundaryHasStylesToHoist = !0 : !1;
}
function $c98c69161ea584a8$var$writeHoistablesForBoundary(destination, hoistableState, renderState) {
    $c98c69161ea584a8$var$currentlyRenderingBoundaryHasStylesToHoist = !1;
    $c98c69161ea584a8$var$destinationHasCapacity = !0;
    hoistableState.styles.forEach($c98c69161ea584a8$var$flushStyleTagsLateForBoundary, destination);
    hoistableState.stylesheets.forEach($c98c69161ea584a8$var$hasStylesToHoist);
    $c98c69161ea584a8$var$currentlyRenderingBoundaryHasStylesToHoist && (renderState.stylesToHoist = !0);
    return $c98c69161ea584a8$var$destinationHasCapacity;
}
function $c98c69161ea584a8$var$flushResource(resource) {
    for(var i = 0; i < resource.length; i++)$c98c69161ea584a8$var$writeChunk(this, resource[i]);
    resource.length = 0;
}
var $c98c69161ea584a8$var$stylesheetFlushingQueue = [];
function $c98c69161ea584a8$var$flushStyleInPreamble(stylesheet) {
    $c98c69161ea584a8$var$pushLinkImpl($c98c69161ea584a8$var$stylesheetFlushingQueue, stylesheet.props);
    for(var i = 0; i < $c98c69161ea584a8$var$stylesheetFlushingQueue.length; i++)$c98c69161ea584a8$var$writeChunk(this, $c98c69161ea584a8$var$stylesheetFlushingQueue[i]);
    $c98c69161ea584a8$var$stylesheetFlushingQueue.length = 0;
    stylesheet.state = 2;
}
var $c98c69161ea584a8$var$styleTagResourceOpen1 = $c98c69161ea584a8$var$stringToPrecomputedChunk('<style data-precedence="'), $c98c69161ea584a8$var$styleTagResourceOpen2 = $c98c69161ea584a8$var$stringToPrecomputedChunk('" data-href="'), $c98c69161ea584a8$var$spaceSeparator = $c98c69161ea584a8$var$stringToPrecomputedChunk(" "), $c98c69161ea584a8$var$styleTagResourceOpen3 = $c98c69161ea584a8$var$stringToPrecomputedChunk('">'), $c98c69161ea584a8$var$styleTagResourceClose = $c98c69161ea584a8$var$stringToPrecomputedChunk("</style>");
function $c98c69161ea584a8$var$flushStylesInPreamble(styleQueue) {
    var hasStylesheets = 0 < styleQueue.sheets.size;
    styleQueue.sheets.forEach($c98c69161ea584a8$var$flushStyleInPreamble, this);
    styleQueue.sheets.clear();
    var rules = styleQueue.rules, hrefs = styleQueue.hrefs;
    if (!hasStylesheets || hrefs.length) {
        $c98c69161ea584a8$var$writeChunk(this, $c98c69161ea584a8$var$styleTagResourceOpen1);
        $c98c69161ea584a8$var$writeChunk(this, styleQueue.precedence);
        styleQueue = 0;
        if (hrefs.length) {
            for($c98c69161ea584a8$var$writeChunk(this, $c98c69161ea584a8$var$styleTagResourceOpen2); styleQueue < hrefs.length - 1; styleQueue++)$c98c69161ea584a8$var$writeChunk(this, hrefs[styleQueue]), $c98c69161ea584a8$var$writeChunk(this, $c98c69161ea584a8$var$spaceSeparator);
            $c98c69161ea584a8$var$writeChunk(this, hrefs[styleQueue]);
        }
        $c98c69161ea584a8$var$writeChunk(this, $c98c69161ea584a8$var$styleTagResourceOpen3);
        for(styleQueue = 0; styleQueue < rules.length; styleQueue++)$c98c69161ea584a8$var$writeChunk(this, rules[styleQueue]);
        $c98c69161ea584a8$var$writeChunk(this, $c98c69161ea584a8$var$styleTagResourceClose);
        rules.length = 0;
        hrefs.length = 0;
    }
}
function $c98c69161ea584a8$var$preloadLateStyle(stylesheet) {
    if (0 === stylesheet.state) {
        stylesheet.state = 1;
        var props = stylesheet.props;
        $c98c69161ea584a8$var$pushLinkImpl($c98c69161ea584a8$var$stylesheetFlushingQueue, {
            rel: "preload",
            as: "style",
            href: stylesheet.props.href,
            crossOrigin: props.crossOrigin,
            fetchPriority: props.fetchPriority,
            integrity: props.integrity,
            media: props.media,
            hrefLang: props.hrefLang,
            referrerPolicy: props.referrerPolicy
        });
        for(stylesheet = 0; stylesheet < $c98c69161ea584a8$var$stylesheetFlushingQueue.length; stylesheet++)$c98c69161ea584a8$var$writeChunk(this, $c98c69161ea584a8$var$stylesheetFlushingQueue[stylesheet]);
        $c98c69161ea584a8$var$stylesheetFlushingQueue.length = 0;
    }
}
function $c98c69161ea584a8$var$preloadLateStyles(styleQueue) {
    styleQueue.sheets.forEach($c98c69161ea584a8$var$preloadLateStyle, this);
    styleQueue.sheets.clear();
}
var $c98c69161ea584a8$var$arrayFirstOpenBracket = $c98c69161ea584a8$var$stringToPrecomputedChunk("["), $c98c69161ea584a8$var$arraySubsequentOpenBracket = $c98c69161ea584a8$var$stringToPrecomputedChunk(",["), $c98c69161ea584a8$var$arrayInterstitial = $c98c69161ea584a8$var$stringToPrecomputedChunk(","), $c98c69161ea584a8$var$arrayCloseBracket = $c98c69161ea584a8$var$stringToPrecomputedChunk("]");
function $c98c69161ea584a8$var$writeStyleResourceDependenciesInJS(destination, hoistableState) {
    $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$arrayFirstOpenBracket);
    var nextArrayOpenBrackChunk = $c98c69161ea584a8$var$arrayFirstOpenBracket;
    hoistableState.stylesheets.forEach(function(resource) {
        if (2 !== resource.state) {
            if (3 === resource.state) $c98c69161ea584a8$var$writeChunk(destination, nextArrayOpenBrackChunk), $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeJSObjectForInstructionScripts("" + resource.props.href))), $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$arrayCloseBracket), nextArrayOpenBrackChunk = $c98c69161ea584a8$var$arraySubsequentOpenBracket;
            else {
                $c98c69161ea584a8$var$writeChunk(destination, nextArrayOpenBrackChunk);
                var precedence = resource.props["data-precedence"], props = resource.props, coercedHref = $c98c69161ea584a8$var$sanitizeURL("" + resource.props.href);
                $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeJSObjectForInstructionScripts(coercedHref)));
                precedence = "" + precedence;
                $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$arrayInterstitial);
                $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeJSObjectForInstructionScripts(precedence)));
                for(var propKey in props)if ($c98c69161ea584a8$var$hasOwnProperty.call(props, propKey) && (precedence = props[propKey], null != precedence)) switch(propKey){
                    case "href":
                    case "rel":
                    case "precedence":
                    case "data-precedence":
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($c98c69161ea584a8$var$formatProdErrorMessage(399, "link"));
                    default:
                        $c98c69161ea584a8$var$writeStyleResourceAttributeInJS(destination, propKey, precedence);
                }
                $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$arrayCloseBracket);
                nextArrayOpenBrackChunk = $c98c69161ea584a8$var$arraySubsequentOpenBracket;
                resource.state = 3;
            }
        }
    });
    $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$arrayCloseBracket);
}
function $c98c69161ea584a8$var$writeStyleResourceAttributeInJS(destination, name, value) {
    var attributeName = name.toLowerCase();
    switch(typeof value){
        case "function":
        case "symbol":
            return;
    }
    switch(name){
        case "innerHTML":
        case "dangerouslySetInnerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "style":
        case "ref":
            return;
        case "className":
            attributeName = "class";
            name = "" + value;
            break;
        case "hidden":
            if (!1 === value) return;
            name = "";
            break;
        case "src":
        case "href":
            value = $c98c69161ea584a8$var$sanitizeURL(value);
            name = "" + value;
            break;
        default:
            if (2 < name.length && ("o" === name[0] || "O" === name[0]) && ("n" === name[1] || "N" === name[1]) || !$c98c69161ea584a8$var$isAttributeNameSafe(name)) return;
            name = "" + value;
    }
    $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$arrayInterstitial);
    $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeJSObjectForInstructionScripts(attributeName)));
    $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$arrayInterstitial);
    $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeJSObjectForInstructionScripts(name)));
}
function $c98c69161ea584a8$var$createHoistableState() {
    return {
        styles: new Set(),
        stylesheets: new Set()
    };
}
function $c98c69161ea584a8$var$prefetchDNS(href) {
    var request = $c98c69161ea584a8$var$currentRequest ? $c98c69161ea584a8$var$currentRequest : null;
    if (request) {
        var resumableState = request.resumableState, renderState = request.renderState;
        if ("string" === typeof href && href) {
            if (!resumableState.dnsResources.hasOwnProperty(href)) {
                resumableState.dnsResources[href] = null;
                resumableState = renderState.headers;
                var header, JSCompiler_temp;
                if (JSCompiler_temp = resumableState && 0 < resumableState.remainingCapacity) JSCompiler_temp = (header = "<" + ("" + href).replace($c98c69161ea584a8$var$regexForHrefInLinkHeaderURLContext, $c98c69161ea584a8$var$escapeHrefForLinkHeaderURLContextReplacer) + ">; rel=dns-prefetch", 0 <= (resumableState.remainingCapacity -= header.length + 2));
                JSCompiler_temp ? (renderState.resets.dns[href] = null, resumableState.preconnects && (resumableState.preconnects += ", "), resumableState.preconnects += header) : (header = [], $c98c69161ea584a8$var$pushLinkImpl(header, {
                    href: href,
                    rel: "dns-prefetch"
                }), renderState.preconnects.add(header));
            }
            $c98c69161ea584a8$var$enqueueFlush(request);
        }
    } else $c98c69161ea584a8$var$previousDispatcher.D(href);
}
function $c98c69161ea584a8$var$preconnect(href, crossOrigin) {
    var request = $c98c69161ea584a8$var$currentRequest ? $c98c69161ea584a8$var$currentRequest : null;
    if (request) {
        var resumableState = request.resumableState, renderState = request.renderState;
        if ("string" === typeof href && href) {
            var bucket = "use-credentials" === crossOrigin ? "credentials" : "string" === typeof crossOrigin ? "anonymous" : "default";
            if (!resumableState.connectResources[bucket].hasOwnProperty(href)) {
                resumableState.connectResources[bucket][href] = null;
                resumableState = renderState.headers;
                var header, JSCompiler_temp;
                if (JSCompiler_temp = resumableState && 0 < resumableState.remainingCapacity) {
                    JSCompiler_temp = "<" + ("" + href).replace($c98c69161ea584a8$var$regexForHrefInLinkHeaderURLContext, $c98c69161ea584a8$var$escapeHrefForLinkHeaderURLContextReplacer) + ">; rel=preconnect";
                    if ("string" === typeof crossOrigin) {
                        var escapedCrossOrigin = ("" + crossOrigin).replace($c98c69161ea584a8$var$regexForLinkHeaderQuotedParamValueContext, $c98c69161ea584a8$var$escapeStringForLinkHeaderQuotedParamValueContextReplacer);
                        JSCompiler_temp += '; crossorigin="' + escapedCrossOrigin + '"';
                    }
                    JSCompiler_temp = (header = JSCompiler_temp, 0 <= (resumableState.remainingCapacity -= header.length + 2));
                }
                JSCompiler_temp ? (renderState.resets.connect[bucket][href] = null, resumableState.preconnects && (resumableState.preconnects += ", "), resumableState.preconnects += header) : (bucket = [], $c98c69161ea584a8$var$pushLinkImpl(bucket, {
                    rel: "preconnect",
                    href: href,
                    crossOrigin: crossOrigin
                }), renderState.preconnects.add(bucket));
            }
            $c98c69161ea584a8$var$enqueueFlush(request);
        }
    } else $c98c69161ea584a8$var$previousDispatcher.C(href, crossOrigin);
}
function $c98c69161ea584a8$var$preload(href, as, options) {
    var request = $c98c69161ea584a8$var$currentRequest ? $c98c69161ea584a8$var$currentRequest : null;
    if (request) {
        var resumableState = request.resumableState, renderState = request.renderState;
        if (as && href) {
            switch(as){
                case "image":
                    if (options) {
                        var imageSrcSet = options.imageSrcSet;
                        var imageSizes = options.imageSizes;
                        var fetchPriority = options.fetchPriority;
                    }
                    var key = imageSrcSet ? imageSrcSet + "\n" + (imageSizes || "") : href;
                    if (resumableState.imageResources.hasOwnProperty(key)) return;
                    resumableState.imageResources[key] = $c98c69161ea584a8$var$PRELOAD_NO_CREDS;
                    resumableState = renderState.headers;
                    var header;
                    resumableState && 0 < resumableState.remainingCapacity && "string" !== typeof imageSrcSet && "high" === fetchPriority && (header = $c98c69161ea584a8$var$getPreloadAsHeader(href, as, options), 0 <= (resumableState.remainingCapacity -= header.length + 2)) ? (renderState.resets.image[key] = $c98c69161ea584a8$var$PRELOAD_NO_CREDS, resumableState.highImagePreloads && (resumableState.highImagePreloads += ", "), resumableState.highImagePreloads += header) : (resumableState = [], $c98c69161ea584a8$var$pushLinkImpl(resumableState, $c98c69161ea584a8$var$assign({
                        rel: "preload",
                        href: imageSrcSet ? void 0 : href,
                        as: as
                    }, options)), "high" === fetchPriority ? renderState.highImagePreloads.add(resumableState) : (renderState.bulkPreloads.add(resumableState), renderState.preloads.images.set(key, resumableState)));
                    break;
                case "style":
                    if (resumableState.styleResources.hasOwnProperty(href)) return;
                    imageSrcSet = [];
                    $c98c69161ea584a8$var$pushLinkImpl(imageSrcSet, $c98c69161ea584a8$var$assign({
                        rel: "preload",
                        href: href,
                        as: as
                    }, options));
                    resumableState.styleResources[href] = !options || "string" !== typeof options.crossOrigin && "string" !== typeof options.integrity ? $c98c69161ea584a8$var$PRELOAD_NO_CREDS : [
                        options.crossOrigin,
                        options.integrity
                    ];
                    renderState.preloads.stylesheets.set(href, imageSrcSet);
                    renderState.bulkPreloads.add(imageSrcSet);
                    break;
                case "script":
                    if (resumableState.scriptResources.hasOwnProperty(href)) return;
                    imageSrcSet = [];
                    renderState.preloads.scripts.set(href, imageSrcSet);
                    renderState.bulkPreloads.add(imageSrcSet);
                    $c98c69161ea584a8$var$pushLinkImpl(imageSrcSet, $c98c69161ea584a8$var$assign({
                        rel: "preload",
                        href: href,
                        as: as
                    }, options));
                    resumableState.scriptResources[href] = !options || "string" !== typeof options.crossOrigin && "string" !== typeof options.integrity ? $c98c69161ea584a8$var$PRELOAD_NO_CREDS : [
                        options.crossOrigin,
                        options.integrity
                    ];
                    break;
                default:
                    if (resumableState.unknownResources.hasOwnProperty(as)) {
                        if (imageSrcSet = resumableState.unknownResources[as], imageSrcSet.hasOwnProperty(href)) return;
                    } else imageSrcSet = {}, resumableState.unknownResources[as] = imageSrcSet;
                    imageSrcSet[href] = $c98c69161ea584a8$var$PRELOAD_NO_CREDS;
                    if ((resumableState = renderState.headers) && 0 < resumableState.remainingCapacity && "font" === as && (key = $c98c69161ea584a8$var$getPreloadAsHeader(href, as, options), 0 <= (resumableState.remainingCapacity -= key.length + 2))) renderState.resets.font[href] = $c98c69161ea584a8$var$PRELOAD_NO_CREDS, resumableState.fontPreloads && (resumableState.fontPreloads += ", "), resumableState.fontPreloads += key;
                    else switch(resumableState = [], href = $c98c69161ea584a8$var$assign({
                        rel: "preload",
                        href: href,
                        as: as
                    }, options), $c98c69161ea584a8$var$pushLinkImpl(resumableState, href), as){
                        case "font":
                            renderState.fontPreloads.add(resumableState);
                            break;
                        default:
                            renderState.bulkPreloads.add(resumableState);
                    }
            }
            $c98c69161ea584a8$var$enqueueFlush(request);
        }
    } else $c98c69161ea584a8$var$previousDispatcher.L(href, as, options);
}
function $c98c69161ea584a8$var$preloadModule(href, options) {
    var request = $c98c69161ea584a8$var$currentRequest ? $c98c69161ea584a8$var$currentRequest : null;
    if (request) {
        var resumableState = request.resumableState, renderState = request.renderState;
        if (href) {
            var as = options && "string" === typeof options.as ? options.as : "script";
            switch(as){
                case "script":
                    if (resumableState.moduleScriptResources.hasOwnProperty(href)) return;
                    as = [];
                    resumableState.moduleScriptResources[href] = !options || "string" !== typeof options.crossOrigin && "string" !== typeof options.integrity ? $c98c69161ea584a8$var$PRELOAD_NO_CREDS : [
                        options.crossOrigin,
                        options.integrity
                    ];
                    renderState.preloads.moduleScripts.set(href, as);
                    break;
                default:
                    if (resumableState.moduleUnknownResources.hasOwnProperty(as)) {
                        var resources = resumableState.unknownResources[as];
                        if (resources.hasOwnProperty(href)) return;
                    } else resources = {}, resumableState.moduleUnknownResources[as] = resources;
                    as = [];
                    resources[href] = $c98c69161ea584a8$var$PRELOAD_NO_CREDS;
            }
            $c98c69161ea584a8$var$pushLinkImpl(as, $c98c69161ea584a8$var$assign({
                rel: "modulepreload",
                href: href
            }, options));
            renderState.bulkPreloads.add(as);
            $c98c69161ea584a8$var$enqueueFlush(request);
        }
    } else $c98c69161ea584a8$var$previousDispatcher.m(href, options);
}
function $c98c69161ea584a8$var$preinitStyle(href, precedence, options) {
    var request = $c98c69161ea584a8$var$currentRequest ? $c98c69161ea584a8$var$currentRequest : null;
    if (request) {
        var resumableState = request.resumableState, renderState = request.renderState;
        if (href) {
            precedence = precedence || "default";
            var styleQueue = renderState.styles.get(precedence), resourceState = resumableState.styleResources.hasOwnProperty(href) ? resumableState.styleResources[href] : void 0;
            null !== resourceState && (resumableState.styleResources[href] = null, styleQueue || (styleQueue = {
                precedence: $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(precedence)),
                rules: [],
                hrefs: [],
                sheets: new Map()
            }, renderState.styles.set(precedence, styleQueue)), precedence = {
                state: 0,
                props: $c98c69161ea584a8$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options)
            }, resourceState && (2 === resourceState.length && $c98c69161ea584a8$var$adoptPreloadCredentials(precedence.props, resourceState), (renderState = renderState.preloads.stylesheets.get(href)) && 0 < renderState.length ? renderState.length = 0 : precedence.state = 1), styleQueue.sheets.set(href, precedence), $c98c69161ea584a8$var$enqueueFlush(request));
        }
    } else $c98c69161ea584a8$var$previousDispatcher.S(href, precedence, options);
}
function $c98c69161ea584a8$var$preinitScript(src, options) {
    var request = $c98c69161ea584a8$var$currentRequest ? $c98c69161ea584a8$var$currentRequest : null;
    if (request) {
        var resumableState = request.resumableState, renderState = request.renderState;
        if (src) {
            var resourceState = resumableState.scriptResources.hasOwnProperty(src) ? resumableState.scriptResources[src] : void 0;
            null !== resourceState && (resumableState.scriptResources[src] = null, options = $c98c69161ea584a8$var$assign({
                src: src,
                async: !0
            }, options), resourceState && (2 === resourceState.length && $c98c69161ea584a8$var$adoptPreloadCredentials(options, resourceState), src = renderState.preloads.scripts.get(src)) && (src.length = 0), src = [], renderState.scripts.add(src), $c98c69161ea584a8$var$pushScriptImpl(src, options), $c98c69161ea584a8$var$enqueueFlush(request));
        }
    } else $c98c69161ea584a8$var$previousDispatcher.X(src, options);
}
function $c98c69161ea584a8$var$preinitModuleScript(src, options) {
    var request = $c98c69161ea584a8$var$currentRequest ? $c98c69161ea584a8$var$currentRequest : null;
    if (request) {
        var resumableState = request.resumableState, renderState = request.renderState;
        if (src) {
            var resourceState = resumableState.moduleScriptResources.hasOwnProperty(src) ? resumableState.moduleScriptResources[src] : void 0;
            null !== resourceState && (resumableState.moduleScriptResources[src] = null, options = $c98c69161ea584a8$var$assign({
                src: src,
                type: "module",
                async: !0
            }, options), resourceState && (2 === resourceState.length && $c98c69161ea584a8$var$adoptPreloadCredentials(options, resourceState), src = renderState.preloads.moduleScripts.get(src)) && (src.length = 0), src = [], renderState.scripts.add(src), $c98c69161ea584a8$var$pushScriptImpl(src, options), $c98c69161ea584a8$var$enqueueFlush(request));
        }
    } else $c98c69161ea584a8$var$previousDispatcher.M(src, options);
}
function $c98c69161ea584a8$var$adoptPreloadCredentials(target, preloadState) {
    null == target.crossOrigin && (target.crossOrigin = preloadState[0]);
    null == target.integrity && (target.integrity = preloadState[1]);
}
function $c98c69161ea584a8$var$getPreloadAsHeader(href, as, params) {
    href = ("" + href).replace($c98c69161ea584a8$var$regexForHrefInLinkHeaderURLContext, $c98c69161ea584a8$var$escapeHrefForLinkHeaderURLContextReplacer);
    as = ("" + as).replace($c98c69161ea584a8$var$regexForLinkHeaderQuotedParamValueContext, $c98c69161ea584a8$var$escapeStringForLinkHeaderQuotedParamValueContextReplacer);
    as = "<" + href + '>; rel=preload; as="' + as + '"';
    for(var paramName in params)$c98c69161ea584a8$var$hasOwnProperty.call(params, paramName) && (href = params[paramName], "string" === typeof href && (as += "; " + paramName.toLowerCase() + '="' + ("" + href).replace($c98c69161ea584a8$var$regexForLinkHeaderQuotedParamValueContext, $c98c69161ea584a8$var$escapeStringForLinkHeaderQuotedParamValueContextReplacer) + '"'));
    return as;
}
var $c98c69161ea584a8$var$regexForHrefInLinkHeaderURLContext = /[<>\r\n]/g;
function $c98c69161ea584a8$var$escapeHrefForLinkHeaderURLContextReplacer(match) {
    switch(match){
        case "<":
            return "%3C";
        case ">":
            return "%3E";
        case "\n":
            return "%0A";
        case "\r":
            return "%0D";
        default:
            throw Error("escapeLinkHrefForHeaderContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
    }
}
var $c98c69161ea584a8$var$regexForLinkHeaderQuotedParamValueContext = /["';,\r\n]/g;
function $c98c69161ea584a8$var$escapeStringForLinkHeaderQuotedParamValueContextReplacer(match) {
    switch(match){
        case '"':
            return "%22";
        case "'":
            return "%27";
        case ";":
            return "%3B";
        case ",":
            return "%2C";
        case "\n":
            return "%0A";
        case "\r":
            return "%0D";
        default:
            throw Error("escapeStringForLinkHeaderQuotedParamValueContextReplacer encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
    }
}
function $c98c69161ea584a8$var$hoistStyleQueueDependency(styleQueue) {
    this.styles.add(styleQueue);
}
function $c98c69161ea584a8$var$hoistStylesheetDependency(stylesheet) {
    this.stylesheets.add(stylesheet);
}
var $c98c69161ea584a8$var$bind = Function.prototype.bind, $c98c69161ea584a8$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $c98c69161ea584a8$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $c98c69161ea584a8$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $c98c69161ea584a8$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $c98c69161ea584a8$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $c98c69161ea584a8$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $c98c69161ea584a8$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $c98c69161ea584a8$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $c98c69161ea584a8$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $c98c69161ea584a8$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $c98c69161ea584a8$var$REACT_CONTEXT_TYPE:
            return (type.displayName || "Context") + ".Provider";
        case $c98c69161ea584a8$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $c98c69161ea584a8$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $c98c69161ea584a8$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $c98c69161ea584a8$var$getComponentNameFromType(type.type) || "Memo";
        case $c98c69161ea584a8$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $c98c69161ea584a8$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $c98c69161ea584a8$var$emptyContextObject = {}, $c98c69161ea584a8$var$currentActiveSnapshot = null;
function $c98c69161ea584a8$var$popToNearestCommonAncestor(prev, next) {
    if (prev !== next) {
        prev.context._currentValue = prev.parentValue;
        prev = prev.parent;
        var parentNext = next.parent;
        if (null === prev) {
            if (null !== parentNext) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(401));
        } else {
            if (null === parentNext) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(401));
            $c98c69161ea584a8$var$popToNearestCommonAncestor(prev, parentNext);
        }
        next.context._currentValue = next.value;
    }
}
function $c98c69161ea584a8$var$popAllPrevious(prev) {
    prev.context._currentValue = prev.parentValue;
    prev = prev.parent;
    null !== prev && $c98c69161ea584a8$var$popAllPrevious(prev);
}
function $c98c69161ea584a8$var$pushAllNext(next) {
    var parentNext = next.parent;
    null !== parentNext && $c98c69161ea584a8$var$pushAllNext(parentNext);
    next.context._currentValue = next.value;
}
function $c98c69161ea584a8$var$popPreviousToCommonLevel(prev, next) {
    prev.context._currentValue = prev.parentValue;
    prev = prev.parent;
    if (null === prev) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(402));
    prev.depth === next.depth ? $c98c69161ea584a8$var$popToNearestCommonAncestor(prev, next) : $c98c69161ea584a8$var$popPreviousToCommonLevel(prev, next);
}
function $c98c69161ea584a8$var$popNextToCommonLevel(prev, next) {
    var parentNext = next.parent;
    if (null === parentNext) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(402));
    prev.depth === parentNext.depth ? $c98c69161ea584a8$var$popToNearestCommonAncestor(prev, parentNext) : $c98c69161ea584a8$var$popNextToCommonLevel(prev, parentNext);
    next.context._currentValue = next.value;
}
function $c98c69161ea584a8$var$switchContext(newSnapshot) {
    var prev = $c98c69161ea584a8$var$currentActiveSnapshot;
    prev !== newSnapshot && (null === prev ? $c98c69161ea584a8$var$pushAllNext(newSnapshot) : null === newSnapshot ? $c98c69161ea584a8$var$popAllPrevious(prev) : prev.depth === newSnapshot.depth ? $c98c69161ea584a8$var$popToNearestCommonAncestor(prev, newSnapshot) : prev.depth > newSnapshot.depth ? $c98c69161ea584a8$var$popPreviousToCommonLevel(prev, newSnapshot) : $c98c69161ea584a8$var$popNextToCommonLevel(prev, newSnapshot), $c98c69161ea584a8$var$currentActiveSnapshot = newSnapshot);
}
var $c98c69161ea584a8$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload) {
        inst = inst._reactInternals;
        null !== inst.queue && inst.queue.push(payload);
    },
    enqueueReplaceState: function(inst, payload) {
        inst = inst._reactInternals;
        inst.replace = !0;
        inst.queue = [
            payload
        ];
    },
    enqueueForceUpdate: function() {}
}, $c98c69161ea584a8$var$emptyTreeContext = {
    id: 1,
    overflow: ""
};
function $c98c69161ea584a8$var$pushTreeContext(baseContext, totalChildren, index) {
    var baseIdWithLeadingBit = baseContext.id;
    baseContext = baseContext.overflow;
    var baseLength = 32 - $c98c69161ea584a8$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $c98c69161ea584a8$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        return {
            id: 1 << 32 - $c98c69161ea584a8$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit,
            overflow: length + baseContext
        };
    }
    return {
        id: 1 << length | index << baseLength | baseIdWithLeadingBit,
        overflow: baseContext
    };
}
var $c98c69161ea584a8$var$clz32 = Math.clz32 ? Math.clz32 : $c98c69161ea584a8$var$clz32Fallback, $c98c69161ea584a8$var$log = Math.log, $c98c69161ea584a8$var$LN2 = Math.LN2;
function $c98c69161ea584a8$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($c98c69161ea584a8$var$log(x) / $c98c69161ea584a8$var$LN2 | 0) | 0;
}
var $c98c69161ea584a8$var$SuspenseException = Error($c98c69161ea584a8$var$formatProdErrorMessage(460));
function $c98c69161ea584a8$var$noop$2() {}
function $c98c69161ea584a8$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($c98c69161ea584a8$var$noop$2, $c98c69161ea584a8$var$noop$2), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            "string" === typeof thenable.status ? thenable.then($c98c69161ea584a8$var$noop$2, $c98c69161ea584a8$var$noop$2) : (thenableState = thenable, thenableState.status = "pending", thenableState.then(function(fulfilledValue) {
                if ("pending" === thenable.status) {
                    var fulfilledThenable = thenable;
                    fulfilledThenable.status = "fulfilled";
                    fulfilledThenable.value = fulfilledValue;
                }
            }, function(error) {
                if ("pending" === thenable.status) {
                    var rejectedThenable = thenable;
                    rejectedThenable.status = "rejected";
                    rejectedThenable.reason = error;
                }
            }));
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
            $c98c69161ea584a8$var$suspendedThenable = thenable;
            throw $c98c69161ea584a8$var$SuspenseException;
    }
}
var $c98c69161ea584a8$var$suspendedThenable = null;
function $c98c69161ea584a8$var$getSuspendedThenable() {
    if (null === $c98c69161ea584a8$var$suspendedThenable) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(459));
    var thenable = $c98c69161ea584a8$var$suspendedThenable;
    $c98c69161ea584a8$var$suspendedThenable = null;
    return thenable;
}
function $c98c69161ea584a8$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c98c69161ea584a8$var$objectIs = "function" === typeof Object.is ? Object.is : $c98c69161ea584a8$var$is, $c98c69161ea584a8$var$currentlyRenderingComponent = null, $c98c69161ea584a8$var$currentlyRenderingTask = null, $c98c69161ea584a8$var$currentlyRenderingRequest = null, $c98c69161ea584a8$var$currentlyRenderingKeyPath = null, $c98c69161ea584a8$var$firstWorkInProgressHook = null, $c98c69161ea584a8$var$workInProgressHook = null, $c98c69161ea584a8$var$isReRender = !1, $c98c69161ea584a8$var$didScheduleRenderPhaseUpdate = !1, $c98c69161ea584a8$var$localIdCounter = 0, $c98c69161ea584a8$var$actionStateCounter = 0, $c98c69161ea584a8$var$actionStateMatchingIndex = -1, $c98c69161ea584a8$var$thenableIndexCounter = 0, $c98c69161ea584a8$var$thenableState = null, $c98c69161ea584a8$var$renderPhaseUpdates = null, $c98c69161ea584a8$var$numberOfReRenders = 0;
function $c98c69161ea584a8$var$resolveCurrentlyRenderingComponent() {
    if (null === $c98c69161ea584a8$var$currentlyRenderingComponent) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(321));
    return $c98c69161ea584a8$var$currentlyRenderingComponent;
}
function $c98c69161ea584a8$var$createHook() {
    if (0 < $c98c69161ea584a8$var$numberOfReRenders) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $c98c69161ea584a8$var$createWorkInProgressHook() {
    null === $c98c69161ea584a8$var$workInProgressHook ? null === $c98c69161ea584a8$var$firstWorkInProgressHook ? ($c98c69161ea584a8$var$isReRender = !1, $c98c69161ea584a8$var$firstWorkInProgressHook = $c98c69161ea584a8$var$workInProgressHook = $c98c69161ea584a8$var$createHook()) : ($c98c69161ea584a8$var$isReRender = !0, $c98c69161ea584a8$var$workInProgressHook = $c98c69161ea584a8$var$firstWorkInProgressHook) : null === $c98c69161ea584a8$var$workInProgressHook.next ? ($c98c69161ea584a8$var$isReRender = !1, $c98c69161ea584a8$var$workInProgressHook = $c98c69161ea584a8$var$workInProgressHook.next = $c98c69161ea584a8$var$createHook()) : ($c98c69161ea584a8$var$isReRender = !0, $c98c69161ea584a8$var$workInProgressHook = $c98c69161ea584a8$var$workInProgressHook.next);
    return $c98c69161ea584a8$var$workInProgressHook;
}
function $c98c69161ea584a8$var$getThenableStateAfterSuspending() {
    var state = $c98c69161ea584a8$var$thenableState;
    $c98c69161ea584a8$var$thenableState = null;
    return state;
}
function $c98c69161ea584a8$var$resetHooksState() {
    $c98c69161ea584a8$var$currentlyRenderingKeyPath = $c98c69161ea584a8$var$currentlyRenderingRequest = $c98c69161ea584a8$var$currentlyRenderingTask = $c98c69161ea584a8$var$currentlyRenderingComponent = null;
    $c98c69161ea584a8$var$didScheduleRenderPhaseUpdate = !1;
    $c98c69161ea584a8$var$firstWorkInProgressHook = null;
    $c98c69161ea584a8$var$numberOfReRenders = 0;
    $c98c69161ea584a8$var$workInProgressHook = $c98c69161ea584a8$var$renderPhaseUpdates = null;
}
function $c98c69161ea584a8$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $c98c69161ea584a8$var$useReducer(reducer, initialArg, init) {
    $c98c69161ea584a8$var$currentlyRenderingComponent = $c98c69161ea584a8$var$resolveCurrentlyRenderingComponent();
    $c98c69161ea584a8$var$workInProgressHook = $c98c69161ea584a8$var$createWorkInProgressHook();
    if ($c98c69161ea584a8$var$isReRender) {
        var queue = $c98c69161ea584a8$var$workInProgressHook.queue;
        initialArg = queue.dispatch;
        if (null !== $c98c69161ea584a8$var$renderPhaseUpdates && (init = $c98c69161ea584a8$var$renderPhaseUpdates.get(queue), void 0 !== init)) {
            $c98c69161ea584a8$var$renderPhaseUpdates.delete(queue);
            queue = $c98c69161ea584a8$var$workInProgressHook.memoizedState;
            do queue = reducer(queue, init.action), init = init.next;
            while (null !== init);
            $c98c69161ea584a8$var$workInProgressHook.memoizedState = queue;
            return [
                queue,
                initialArg
            ];
        }
        return [
            $c98c69161ea584a8$var$workInProgressHook.memoizedState,
            initialArg
        ];
    }
    reducer = reducer === $c98c69161ea584a8$var$basicStateReducer ? "function" === typeof initialArg ? initialArg() : initialArg : void 0 !== init ? init(initialArg) : initialArg;
    $c98c69161ea584a8$var$workInProgressHook.memoizedState = reducer;
    reducer = $c98c69161ea584a8$var$workInProgressHook.queue = {
        last: null,
        dispatch: null
    };
    reducer = reducer.dispatch = $c98c69161ea584a8$var$dispatchAction.bind(null, $c98c69161ea584a8$var$currentlyRenderingComponent, reducer);
    return [
        $c98c69161ea584a8$var$workInProgressHook.memoizedState,
        reducer
    ];
}
function $c98c69161ea584a8$var$useMemo(nextCreate, deps) {
    $c98c69161ea584a8$var$currentlyRenderingComponent = $c98c69161ea584a8$var$resolveCurrentlyRenderingComponent();
    $c98c69161ea584a8$var$workInProgressHook = $c98c69161ea584a8$var$createWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    if (null !== $c98c69161ea584a8$var$workInProgressHook) {
        var prevState = $c98c69161ea584a8$var$workInProgressHook.memoizedState;
        if (null !== prevState && null !== deps) {
            var prevDeps = prevState[1];
            a: if (null === prevDeps) prevDeps = !1;
            else {
                for(var i = 0; i < prevDeps.length && i < deps.length; i++)if (!$c98c69161ea584a8$var$objectIs(deps[i], prevDeps[i])) {
                    prevDeps = !1;
                    break a;
                }
                prevDeps = !0;
            }
            if (prevDeps) return prevState[0];
        }
    }
    nextCreate = nextCreate();
    $c98c69161ea584a8$var$workInProgressHook.memoizedState = [
        nextCreate,
        deps
    ];
    return nextCreate;
}
function $c98c69161ea584a8$var$dispatchAction(componentIdentity, queue, action) {
    if (25 <= $c98c69161ea584a8$var$numberOfReRenders) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(301));
    if (componentIdentity === $c98c69161ea584a8$var$currentlyRenderingComponent) {
        if ($c98c69161ea584a8$var$didScheduleRenderPhaseUpdate = !0, componentIdentity = {
            action: action,
            next: null
        }, null === $c98c69161ea584a8$var$renderPhaseUpdates && ($c98c69161ea584a8$var$renderPhaseUpdates = new Map()), action = $c98c69161ea584a8$var$renderPhaseUpdates.get(queue), void 0 === action) $c98c69161ea584a8$var$renderPhaseUpdates.set(queue, componentIdentity);
        else {
            for(queue = action; null !== queue.next;)queue = queue.next;
            queue.next = componentIdentity;
        }
    }
}
function $c98c69161ea584a8$var$unsupportedStartTransition() {
    throw Error($c98c69161ea584a8$var$formatProdErrorMessage(394));
}
function $c98c69161ea584a8$var$unsupportedSetOptimisticState() {
    throw Error($c98c69161ea584a8$var$formatProdErrorMessage(479));
}
function $c98c69161ea584a8$var$useActionState(action, initialState, permalink) {
    $c98c69161ea584a8$var$resolveCurrentlyRenderingComponent();
    var actionStateHookIndex = $c98c69161ea584a8$var$actionStateCounter++, request = $c98c69161ea584a8$var$currentlyRenderingRequest;
    if ("function" === typeof action.$$FORM_ACTION) {
        var nextPostbackStateKey = null, componentKeyPath = $c98c69161ea584a8$var$currentlyRenderingKeyPath;
        request = request.formState;
        var isSignatureEqual = action.$$IS_SIGNATURE_EQUAL;
        if (null !== request && "function" === typeof isSignatureEqual) {
            var postbackKey = request[1];
            isSignatureEqual.call(action, request[2], request[3]) && (nextPostbackStateKey = void 0 !== permalink ? "p" + permalink : "k" + $c98c69161ea584a8$var$murmurhash3_32_gc(JSON.stringify([
                componentKeyPath,
                null,
                actionStateHookIndex
            ]), 0), postbackKey === nextPostbackStateKey && ($c98c69161ea584a8$var$actionStateMatchingIndex = actionStateHookIndex, initialState = request[0]));
        }
        var boundAction = action.bind(null, initialState);
        action = function(payload) {
            boundAction(payload);
        };
        "function" === typeof boundAction.$$FORM_ACTION && (action.$$FORM_ACTION = function(prefix) {
            prefix = boundAction.$$FORM_ACTION(prefix);
            void 0 !== permalink && (permalink += "", prefix.action = permalink);
            var formData = prefix.data;
            formData && (null === nextPostbackStateKey && (nextPostbackStateKey = void 0 !== permalink ? "p" + permalink : "k" + $c98c69161ea584a8$var$murmurhash3_32_gc(JSON.stringify([
                componentKeyPath,
                null,
                actionStateHookIndex
            ]), 0)), formData.append("$ACTION_KEY", nextPostbackStateKey));
            return prefix;
        });
        return [
            initialState,
            action,
            !1
        ];
    }
    var boundAction$22 = action.bind(null, initialState);
    return [
        initialState,
        function(payload) {
            boundAction$22(payload);
        },
        !1
    ];
}
function $c98c69161ea584a8$var$unwrapThenable(thenable) {
    var index = $c98c69161ea584a8$var$thenableIndexCounter;
    $c98c69161ea584a8$var$thenableIndexCounter += 1;
    null === $c98c69161ea584a8$var$thenableState && ($c98c69161ea584a8$var$thenableState = []);
    return $c98c69161ea584a8$var$trackUsedThenable($c98c69161ea584a8$var$thenableState, thenable, index);
}
function $c98c69161ea584a8$var$unsupportedRefresh() {
    throw Error($c98c69161ea584a8$var$formatProdErrorMessage(393));
}
function $c98c69161ea584a8$var$noop$1() {}
var $c98c69161ea584a8$var$HooksDispatcher = {
    readContext: function(context) {
        return context._currentValue;
    },
    use: function(usable) {
        if (null !== usable && "object" === typeof usable) {
            if ("function" === typeof usable.then) return $c98c69161ea584a8$var$unwrapThenable(usable);
            if (usable.$$typeof === $c98c69161ea584a8$var$REACT_CONTEXT_TYPE) return usable._currentValue;
        }
        throw Error($c98c69161ea584a8$var$formatProdErrorMessage(438, String(usable)));
    },
    useContext: function(context) {
        $c98c69161ea584a8$var$resolveCurrentlyRenderingComponent();
        return context._currentValue;
    },
    useMemo: $c98c69161ea584a8$var$useMemo,
    useReducer: $c98c69161ea584a8$var$useReducer,
    useRef: function(initialValue) {
        $c98c69161ea584a8$var$currentlyRenderingComponent = $c98c69161ea584a8$var$resolveCurrentlyRenderingComponent();
        $c98c69161ea584a8$var$workInProgressHook = $c98c69161ea584a8$var$createWorkInProgressHook();
        var previousRef = $c98c69161ea584a8$var$workInProgressHook.memoizedState;
        return null === previousRef ? (initialValue = {
            current: initialValue
        }, $c98c69161ea584a8$var$workInProgressHook.memoizedState = initialValue) : previousRef;
    },
    useState: function(initialState) {
        return $c98c69161ea584a8$var$useReducer($c98c69161ea584a8$var$basicStateReducer, initialState);
    },
    useInsertionEffect: $c98c69161ea584a8$var$noop$1,
    useLayoutEffect: $c98c69161ea584a8$var$noop$1,
    useCallback: function(callback, deps) {
        return $c98c69161ea584a8$var$useMemo(function() {
            return callback;
        }, deps);
    },
    useImperativeHandle: $c98c69161ea584a8$var$noop$1,
    useEffect: $c98c69161ea584a8$var$noop$1,
    useDebugValue: $c98c69161ea584a8$var$noop$1,
    useDeferredValue: function(value, initialValue) {
        $c98c69161ea584a8$var$resolveCurrentlyRenderingComponent();
        return void 0 !== initialValue ? initialValue : value;
    },
    useTransition: function() {
        $c98c69161ea584a8$var$resolveCurrentlyRenderingComponent();
        return [
            !1,
            $c98c69161ea584a8$var$unsupportedStartTransition
        ];
    },
    useId: function() {
        var JSCompiler_inline_result = $c98c69161ea584a8$var$currentlyRenderingTask.treeContext;
        var overflow = JSCompiler_inline_result.overflow;
        JSCompiler_inline_result = JSCompiler_inline_result.id;
        JSCompiler_inline_result = (JSCompiler_inline_result & ~(1 << 32 - $c98c69161ea584a8$var$clz32(JSCompiler_inline_result) - 1)).toString(32) + overflow;
        var resumableState = $c98c69161ea584a8$var$currentResumableState;
        if (null === resumableState) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(404));
        overflow = $c98c69161ea584a8$var$localIdCounter++;
        JSCompiler_inline_result = "\u00ab" + resumableState.idPrefix + "R" + JSCompiler_inline_result;
        0 < overflow && (JSCompiler_inline_result += "H" + overflow.toString(32));
        return JSCompiler_inline_result + "\u00bb";
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        if (void 0 === getServerSnapshot) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(407));
        return getServerSnapshot();
    },
    useOptimistic: function(passthrough) {
        $c98c69161ea584a8$var$resolveCurrentlyRenderingComponent();
        return [
            passthrough,
            $c98c69161ea584a8$var$unsupportedSetOptimisticState
        ];
    },
    useActionState: $c98c69161ea584a8$var$useActionState,
    useFormState: $c98c69161ea584a8$var$useActionState,
    useHostTransitionStatus: function() {
        $c98c69161ea584a8$var$resolveCurrentlyRenderingComponent();
        return $c98c69161ea584a8$var$sharedNotPendingObject;
    },
    useMemoCache: function(size) {
        for(var data = Array(size), i = 0; i < size; i++)data[i] = $c98c69161ea584a8$var$REACT_MEMO_CACHE_SENTINEL;
        return data;
    },
    useCacheRefresh: function() {
        return $c98c69161ea584a8$var$unsupportedRefresh;
    }
}, $c98c69161ea584a8$var$currentResumableState = null, $c98c69161ea584a8$var$DefaultAsyncDispatcher = {
    getCacheForType: function() {
        throw Error($c98c69161ea584a8$var$formatProdErrorMessage(248));
    }
}, $c98c69161ea584a8$var$prefix, $c98c69161ea584a8$var$suffix;
function $c98c69161ea584a8$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $c98c69161ea584a8$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $c98c69161ea584a8$var$prefix = match && match[1] || "";
        $c98c69161ea584a8$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $c98c69161ea584a8$var$prefix + name + $c98c69161ea584a8$var$suffix;
}
var $c98c69161ea584a8$var$reentry = !1;
function $c98c69161ea584a8$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $c98c69161ea584a8$var$reentry) return "";
    $c98c69161ea584a8$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$24) {
                                control = x$24;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$25) {
                            control = x$25;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $c98c69161ea584a8$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $c98c69161ea584a8$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $c98c69161ea584a8$var$describeComponentStackByType(type) {
    if ("string" === typeof type) return $c98c69161ea584a8$var$describeBuiltInComponentFrame(type);
    if ("function" === typeof type) return type.prototype && type.prototype.isReactComponent ? $c98c69161ea584a8$var$describeNativeComponentFrame(type, !0) : $c98c69161ea584a8$var$describeNativeComponentFrame(type, !1);
    if ("object" === typeof type && null !== type) {
        switch(type.$$typeof){
            case $c98c69161ea584a8$var$REACT_FORWARD_REF_TYPE:
                return $c98c69161ea584a8$var$describeNativeComponentFrame(type.render, !1);
            case $c98c69161ea584a8$var$REACT_MEMO_TYPE:
                return $c98c69161ea584a8$var$describeNativeComponentFrame(type.type, !1);
            case $c98c69161ea584a8$var$REACT_LAZY_TYPE:
                var lazyComponent = type, payload = lazyComponent._payload;
                lazyComponent = lazyComponent._init;
                try {
                    type = lazyComponent(payload);
                } catch (x) {
                    return $c98c69161ea584a8$var$describeBuiltInComponentFrame("Lazy");
                }
                return $c98c69161ea584a8$var$describeComponentStackByType(type);
        }
        if ("string" === typeof type.name) return payload = type.env, $c98c69161ea584a8$var$describeBuiltInComponentFrame(type.name + (payload ? " [" + payload + "]" : ""));
    }
    switch(type){
        case $c98c69161ea584a8$var$REACT_SUSPENSE_LIST_TYPE:
            return $c98c69161ea584a8$var$describeBuiltInComponentFrame("SuspenseList");
        case $c98c69161ea584a8$var$REACT_SUSPENSE_TYPE:
            return $c98c69161ea584a8$var$describeBuiltInComponentFrame("Suspense");
    }
    return "";
}
function $c98c69161ea584a8$var$defaultErrorHandler(error) {
    if ("object" === typeof error && null !== error && "string" === typeof error.environmentName) {
        var JSCompiler_inline_result = error.environmentName;
        error = [
            error
        ].slice(0);
        "string" === typeof error[0] ? error.splice(0, 1, "%c%s%c " + error[0], "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px", " " + JSCompiler_inline_result + " ", "") : error.splice(0, 0, "%c%s%c ", "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px", " " + JSCompiler_inline_result + " ", "");
        error.unshift(console);
        JSCompiler_inline_result = $c98c69161ea584a8$var$bind.apply(console.error, error);
        JSCompiler_inline_result();
    } else console.error(error);
    return null;
}
function $c98c69161ea584a8$var$noop() {}
function $c98c69161ea584a8$var$RequestInstance(resumableState, renderState, rootFormatContext, progressiveChunkSize, onError, onAllReady, onShellReady, onShellError, onFatalError, onPostpone, formState) {
    var abortSet = new Set();
    this.destination = null;
    this.flushScheduled = !1;
    this.resumableState = resumableState;
    this.renderState = renderState;
    this.rootFormatContext = rootFormatContext;
    this.progressiveChunkSize = void 0 === progressiveChunkSize ? 12800 : progressiveChunkSize;
    this.status = 10;
    this.fatalError = null;
    this.pendingRootTasks = this.allPendingTasks = this.nextSegmentId = 0;
    this.completedPreambleSegments = this.completedRootSegment = null;
    this.abortableTasks = abortSet;
    this.pingedTasks = [];
    this.clientRenderedBoundaries = [];
    this.completedBoundaries = [];
    this.partialBoundaries = [];
    this.trackedPostpones = null;
    this.onError = void 0 === onError ? $c98c69161ea584a8$var$defaultErrorHandler : onError;
    this.onPostpone = void 0 === onPostpone ? $c98c69161ea584a8$var$noop : onPostpone;
    this.onAllReady = void 0 === onAllReady ? $c98c69161ea584a8$var$noop : onAllReady;
    this.onShellReady = void 0 === onShellReady ? $c98c69161ea584a8$var$noop : onShellReady;
    this.onShellError = void 0 === onShellError ? $c98c69161ea584a8$var$noop : onShellError;
    this.onFatalError = void 0 === onFatalError ? $c98c69161ea584a8$var$noop : onFatalError;
    this.formState = void 0 === formState ? null : formState;
}
function $c98c69161ea584a8$var$createRequest(children, resumableState, renderState, rootFormatContext, progressiveChunkSize, onError, onAllReady, onShellReady, onShellError, onFatalError, onPostpone, formState) {
    resumableState = new $c98c69161ea584a8$var$RequestInstance(resumableState, renderState, rootFormatContext, progressiveChunkSize, onError, onAllReady, onShellReady, onShellError, onFatalError, onPostpone, formState);
    renderState = $c98c69161ea584a8$var$createPendingSegment(resumableState, 0, null, rootFormatContext, !1, !1);
    renderState.parentFlushed = !0;
    children = $c98c69161ea584a8$var$createRenderTask(resumableState, null, children, -1, null, renderState, null, null, resumableState.abortableTasks, null, rootFormatContext, null, $c98c69161ea584a8$var$emptyTreeContext, null, !1);
    $c98c69161ea584a8$var$pushComponentStack(children);
    resumableState.pingedTasks.push(children);
    return resumableState;
}
function $c98c69161ea584a8$var$createPrerenderRequest(children, resumableState, renderState, rootFormatContext, progressiveChunkSize, onError, onAllReady, onShellReady, onShellError, onFatalError, onPostpone) {
    children = $c98c69161ea584a8$var$createRequest(children, resumableState, renderState, rootFormatContext, progressiveChunkSize, onError, onAllReady, onShellReady, onShellError, onFatalError, onPostpone, void 0);
    children.trackedPostpones = {
        workingMap: new Map(),
        rootNodes: [],
        rootSlots: null
    };
    return children;
}
var $c98c69161ea584a8$var$currentRequest = null;
function $c98c69161ea584a8$var$pingTask(request, task) {
    request.pingedTasks.push(task);
    1 === request.pingedTasks.length && (request.flushScheduled = null !== request.destination, null !== request.trackedPostpones || 10 === request.status ? $c98c69161ea584a8$var$scheduleMicrotask(function() {
        return $c98c69161ea584a8$var$performWork(request);
    }) : $c98c69161ea584a8$var$scheduleWork(function() {
        return $c98c69161ea584a8$var$performWork(request);
    }));
}
function $c98c69161ea584a8$var$createSuspenseBoundary(request, fallbackAbortableTasks, contentPreamble, fallbackPreamble) {
    return {
        status: 0,
        rootSegmentID: -1,
        parentFlushed: !1,
        pendingTasks: 0,
        completedSegments: [],
        byteSize: 0,
        fallbackAbortableTasks: fallbackAbortableTasks,
        errorDigest: null,
        contentState: $c98c69161ea584a8$var$createHoistableState(),
        fallbackState: $c98c69161ea584a8$var$createHoistableState(),
        contentPreamble: contentPreamble,
        fallbackPreamble: fallbackPreamble,
        trackedContentKeyPath: null,
        trackedFallbackNode: null
    };
}
function $c98c69161ea584a8$var$createRenderTask(request, thenableState, node, childIndex, blockedBoundary, blockedSegment, blockedPreamble, hoistableState, abortSet, keyPath, formatContext, context, treeContext, componentStack, isFallback) {
    request.allPendingTasks++;
    null === blockedBoundary ? request.pendingRootTasks++ : blockedBoundary.pendingTasks++;
    var task = {
        replay: null,
        node: node,
        childIndex: childIndex,
        ping: function() {
            return $c98c69161ea584a8$var$pingTask(request, task);
        },
        blockedBoundary: blockedBoundary,
        blockedSegment: blockedSegment,
        blockedPreamble: blockedPreamble,
        hoistableState: hoistableState,
        abortSet: abortSet,
        keyPath: keyPath,
        formatContext: formatContext,
        context: context,
        treeContext: treeContext,
        componentStack: componentStack,
        thenableState: thenableState,
        isFallback: isFallback
    };
    abortSet.add(task);
    return task;
}
function $c98c69161ea584a8$var$createReplayTask(request, thenableState, replay, node, childIndex, blockedBoundary, hoistableState, abortSet, keyPath, formatContext, context, treeContext, componentStack, isFallback) {
    request.allPendingTasks++;
    null === blockedBoundary ? request.pendingRootTasks++ : blockedBoundary.pendingTasks++;
    replay.pendingTasks++;
    var task = {
        replay: replay,
        node: node,
        childIndex: childIndex,
        ping: function() {
            return $c98c69161ea584a8$var$pingTask(request, task);
        },
        blockedBoundary: blockedBoundary,
        blockedSegment: null,
        blockedPreamble: null,
        hoistableState: hoistableState,
        abortSet: abortSet,
        keyPath: keyPath,
        formatContext: formatContext,
        context: context,
        treeContext: treeContext,
        componentStack: componentStack,
        thenableState: thenableState,
        isFallback: isFallback
    };
    abortSet.add(task);
    return task;
}
function $c98c69161ea584a8$var$createPendingSegment(request, index, boundary, parentFormatContext, lastPushedText, textEmbedded) {
    return {
        status: 0,
        parentFlushed: !1,
        id: -1,
        index: index,
        chunks: [],
        children: [],
        preambleChildren: [],
        parentFormatContext: parentFormatContext,
        boundary: boundary,
        lastPushedText: lastPushedText,
        textEmbedded: textEmbedded
    };
}
function $c98c69161ea584a8$var$pushComponentStack(task) {
    var node = task.node;
    if ("object" === typeof node && null !== node) switch(node.$$typeof){
        case $c98c69161ea584a8$var$REACT_ELEMENT_TYPE:
            task.componentStack = {
                parent: task.componentStack,
                type: node.type
            };
    }
}
function $c98c69161ea584a8$var$getThrownInfo(node$jscomp$0) {
    var errorInfo = {};
    node$jscomp$0 && Object.defineProperty(errorInfo, "componentStack", {
        configurable: !0,
        enumerable: !0,
        get: function() {
            try {
                var info = "", node = node$jscomp$0;
                do info += $c98c69161ea584a8$var$describeComponentStackByType(node.type), node = node.parent;
                while (node);
                var JSCompiler_inline_result = info;
            } catch (x) {
                JSCompiler_inline_result = "\nError generating stack: " + x.message + "\n" + x.stack;
            }
            Object.defineProperty(errorInfo, "componentStack", {
                value: JSCompiler_inline_result
            });
            return JSCompiler_inline_result;
        }
    });
    return errorInfo;
}
function $c98c69161ea584a8$var$logRecoverableError(request, error, errorInfo) {
    request = request.onError;
    error = request(error, errorInfo);
    if (null == error || "string" === typeof error) return error;
}
function $c98c69161ea584a8$var$fatalError(request, error) {
    var onShellError = request.onShellError, onFatalError = request.onFatalError;
    onShellError(error);
    onFatalError(error);
    null !== request.destination ? (request.status = 14, $c98c69161ea584a8$var$closeWithError(request.destination, error)) : (request.status = 13, request.fatalError = error);
}
function $c98c69161ea584a8$var$renderWithHooks(request, task, keyPath, Component, props, secondArg) {
    var prevThenableState = task.thenableState;
    task.thenableState = null;
    $c98c69161ea584a8$var$currentlyRenderingComponent = {};
    $c98c69161ea584a8$var$currentlyRenderingTask = task;
    $c98c69161ea584a8$var$currentlyRenderingRequest = request;
    $c98c69161ea584a8$var$currentlyRenderingKeyPath = keyPath;
    $c98c69161ea584a8$var$actionStateCounter = $c98c69161ea584a8$var$localIdCounter = 0;
    $c98c69161ea584a8$var$actionStateMatchingIndex = -1;
    $c98c69161ea584a8$var$thenableIndexCounter = 0;
    $c98c69161ea584a8$var$thenableState = prevThenableState;
    for(request = Component(props, secondArg); $c98c69161ea584a8$var$didScheduleRenderPhaseUpdate;)$c98c69161ea584a8$var$didScheduleRenderPhaseUpdate = !1, $c98c69161ea584a8$var$actionStateCounter = $c98c69161ea584a8$var$localIdCounter = 0, $c98c69161ea584a8$var$actionStateMatchingIndex = -1, $c98c69161ea584a8$var$thenableIndexCounter = 0, $c98c69161ea584a8$var$numberOfReRenders += 1, $c98c69161ea584a8$var$workInProgressHook = null, request = Component(props, secondArg);
    $c98c69161ea584a8$var$resetHooksState();
    return request;
}
function $c98c69161ea584a8$var$finishFunctionComponent(request, task, keyPath, children, hasId, actionStateCount, actionStateMatchingIndex) {
    var didEmitActionStateMarkers = !1;
    if (0 !== actionStateCount && null !== request.formState) {
        var segment = task.blockedSegment;
        if (null !== segment) {
            didEmitActionStateMarkers = !0;
            segment = segment.chunks;
            for(var i = 0; i < actionStateCount; i++)i === actionStateMatchingIndex ? segment.push($c98c69161ea584a8$var$formStateMarkerIsMatching) : segment.push($c98c69161ea584a8$var$formStateMarkerIsNotMatching);
        }
    }
    actionStateCount = task.keyPath;
    task.keyPath = keyPath;
    hasId ? (keyPath = task.treeContext, task.treeContext = $c98c69161ea584a8$var$pushTreeContext(keyPath, 1, 0), $c98c69161ea584a8$var$renderNode(request, task, children, -1), task.treeContext = keyPath) : didEmitActionStateMarkers ? $c98c69161ea584a8$var$renderNode(request, task, children, -1) : $c98c69161ea584a8$var$renderNodeDestructive(request, task, children, -1);
    task.keyPath = actionStateCount;
}
function $c98c69161ea584a8$var$renderElement(request, task, keyPath, type, props, ref) {
    if ("function" === typeof type) {
        if (type.prototype && type.prototype.isReactComponent) {
            var newProps = props;
            if ("ref" in props) {
                newProps = {};
                for(var propName in props)"ref" !== propName && (newProps[propName] = props[propName]);
            }
            var defaultProps = type.defaultProps;
            if (defaultProps) {
                newProps === props && (newProps = $c98c69161ea584a8$var$assign({}, newProps, props));
                for(var propName$33 in defaultProps)void 0 === newProps[propName$33] && (newProps[propName$33] = defaultProps[propName$33]);
            }
            props = newProps;
            newProps = $c98c69161ea584a8$var$emptyContextObject;
            defaultProps = type.contextType;
            "object" === typeof defaultProps && null !== defaultProps && (newProps = defaultProps._currentValue);
            newProps = new type(props, newProps);
            var initialState = void 0 !== newProps.state ? newProps.state : null;
            newProps.updater = $c98c69161ea584a8$var$classComponentUpdater;
            newProps.props = props;
            newProps.state = initialState;
            defaultProps = {
                queue: [],
                replace: !1
            };
            newProps._reactInternals = defaultProps;
            ref = type.contextType;
            newProps.context = "object" === typeof ref && null !== ref ? ref._currentValue : $c98c69161ea584a8$var$emptyContextObject;
            ref = type.getDerivedStateFromProps;
            "function" === typeof ref && (ref = ref(props, initialState), initialState = null === ref || void 0 === ref ? initialState : $c98c69161ea584a8$var$assign({}, initialState, ref), newProps.state = initialState);
            if ("function" !== typeof type.getDerivedStateFromProps && "function" !== typeof newProps.getSnapshotBeforeUpdate && ("function" === typeof newProps.UNSAFE_componentWillMount || "function" === typeof newProps.componentWillMount)) {
                if (type = newProps.state, "function" === typeof newProps.componentWillMount && newProps.componentWillMount(), "function" === typeof newProps.UNSAFE_componentWillMount && newProps.UNSAFE_componentWillMount(), type !== newProps.state && $c98c69161ea584a8$var$classComponentUpdater.enqueueReplaceState(newProps, newProps.state, null), null !== defaultProps.queue && 0 < defaultProps.queue.length) {
                    if (type = defaultProps.queue, ref = defaultProps.replace, defaultProps.queue = null, defaultProps.replace = !1, ref && 1 === type.length) newProps.state = type[0];
                    else {
                        defaultProps = ref ? type[0] : newProps.state;
                        initialState = !0;
                        for(ref = ref ? 1 : 0; ref < type.length; ref++)propName$33 = type[ref], propName$33 = "function" === typeof propName$33 ? propName$33.call(newProps, defaultProps, props, void 0) : propName$33, null != propName$33 && (initialState ? (initialState = !1, defaultProps = $c98c69161ea584a8$var$assign({}, defaultProps, propName$33)) : $c98c69161ea584a8$var$assign(defaultProps, propName$33));
                        newProps.state = defaultProps;
                    }
                } else defaultProps.queue = null;
            }
            type = newProps.render();
            if (12 === request.status) throw null;
            props = task.keyPath;
            task.keyPath = keyPath;
            $c98c69161ea584a8$var$renderNodeDestructive(request, task, type, -1);
            task.keyPath = props;
        } else {
            type = $c98c69161ea584a8$var$renderWithHooks(request, task, keyPath, type, props, void 0);
            if (12 === request.status) throw null;
            $c98c69161ea584a8$var$finishFunctionComponent(request, task, keyPath, type, 0 !== $c98c69161ea584a8$var$localIdCounter, $c98c69161ea584a8$var$actionStateCounter, $c98c69161ea584a8$var$actionStateMatchingIndex);
        }
    } else if ("string" === typeof type) {
        if (newProps = task.blockedSegment, null === newProps) newProps = props.children, defaultProps = task.formatContext, initialState = task.keyPath, task.formatContext = $c98c69161ea584a8$var$getChildFormatContext(defaultProps, type, props), task.keyPath = keyPath, $c98c69161ea584a8$var$renderNode(request, task, newProps, -1), task.formatContext = defaultProps, task.keyPath = initialState;
        else {
            ref = $c98c69161ea584a8$var$pushStartInstance(newProps.chunks, type, props, request.resumableState, request.renderState, task.blockedPreamble, task.hoistableState, task.formatContext, newProps.lastPushedText, task.isFallback);
            newProps.lastPushedText = !1;
            defaultProps = task.formatContext;
            initialState = task.keyPath;
            task.keyPath = keyPath;
            3 === (task.formatContext = $c98c69161ea584a8$var$getChildFormatContext(defaultProps, type, props)).insertionMode ? (keyPath = $c98c69161ea584a8$var$createPendingSegment(request, 0, null, task.formatContext, !1, !1), newProps.preambleChildren.push(keyPath), keyPath = $c98c69161ea584a8$var$createRenderTask(request, null, ref, -1, task.blockedBoundary, keyPath, task.blockedPreamble, task.hoistableState, request.abortableTasks, task.keyPath, task.formatContext, task.context, task.treeContext, task.componentStack, task.isFallback), $c98c69161ea584a8$var$pushComponentStack(keyPath), request.pingedTasks.push(keyPath)) : $c98c69161ea584a8$var$renderNode(request, task, ref, -1);
            task.formatContext = defaultProps;
            task.keyPath = initialState;
            a: {
                task = newProps.chunks;
                request = request.resumableState;
                switch(type){
                    case "title":
                    case "style":
                    case "script":
                    case "area":
                    case "base":
                    case "br":
                    case "col":
                    case "embed":
                    case "hr":
                    case "img":
                    case "input":
                    case "keygen":
                    case "link":
                    case "meta":
                    case "param":
                    case "source":
                    case "track":
                    case "wbr":
                        break a;
                    case "body":
                        if (1 >= defaultProps.insertionMode) {
                            request.hasBody = !0;
                            break a;
                        }
                        break;
                    case "html":
                        if (0 === defaultProps.insertionMode) {
                            request.hasHtml = !0;
                            break a;
                        }
                        break;
                    case "head":
                        if (1 >= defaultProps.insertionMode) break a;
                }
                task.push($c98c69161ea584a8$var$endChunkForTag(type));
            }
            newProps.lastPushedText = !1;
        }
    } else {
        switch(type){
            case $c98c69161ea584a8$var$REACT_LEGACY_HIDDEN_TYPE:
            case $c98c69161ea584a8$var$REACT_STRICT_MODE_TYPE:
            case $c98c69161ea584a8$var$REACT_PROFILER_TYPE:
            case $c98c69161ea584a8$var$REACT_FRAGMENT_TYPE:
                type = task.keyPath;
                task.keyPath = keyPath;
                $c98c69161ea584a8$var$renderNodeDestructive(request, task, props.children, -1);
                task.keyPath = type;
                return;
            case $c98c69161ea584a8$var$REACT_ACTIVITY_TYPE:
                "hidden" !== props.mode && (type = task.keyPath, task.keyPath = keyPath, $c98c69161ea584a8$var$renderNodeDestructive(request, task, props.children, -1), task.keyPath = type);
                return;
            case $c98c69161ea584a8$var$REACT_SUSPENSE_LIST_TYPE:
                type = task.keyPath;
                task.keyPath = keyPath;
                $c98c69161ea584a8$var$renderNodeDestructive(request, task, props.children, -1);
                task.keyPath = type;
                return;
            case $c98c69161ea584a8$var$REACT_VIEW_TRANSITION_TYPE:
            case $c98c69161ea584a8$var$REACT_SCOPE_TYPE:
                throw Error($c98c69161ea584a8$var$formatProdErrorMessage(343));
            case $c98c69161ea584a8$var$REACT_SUSPENSE_TYPE:
                a: if (null !== task.replay) {
                    type = task.keyPath;
                    task.keyPath = keyPath;
                    keyPath = props.children;
                    try {
                        $c98c69161ea584a8$var$renderNode(request, task, keyPath, -1);
                    } finally{
                        task.keyPath = type;
                    }
                } else {
                    type = task.keyPath;
                    var parentBoundary = task.blockedBoundary;
                    ref = task.blockedPreamble;
                    var parentHoistableState = task.hoistableState;
                    propName$33 = task.blockedSegment;
                    propName = props.fallback;
                    props = props.children;
                    var fallbackAbortSet = new Set();
                    var newBoundary = 2 > task.formatContext.insertionMode ? $c98c69161ea584a8$var$createSuspenseBoundary(request, fallbackAbortSet, $c98c69161ea584a8$var$createPreambleState(), $c98c69161ea584a8$var$createPreambleState()) : $c98c69161ea584a8$var$createSuspenseBoundary(request, fallbackAbortSet, null, null);
                    null !== request.trackedPostpones && (newBoundary.trackedContentKeyPath = keyPath);
                    var boundarySegment = $c98c69161ea584a8$var$createPendingSegment(request, propName$33.chunks.length, newBoundary, task.formatContext, !1, !1);
                    propName$33.children.push(boundarySegment);
                    propName$33.lastPushedText = !1;
                    var contentRootSegment = $c98c69161ea584a8$var$createPendingSegment(request, 0, null, task.formatContext, !1, !1);
                    contentRootSegment.parentFlushed = !0;
                    if (null !== request.trackedPostpones) {
                        newProps = [
                            keyPath[0],
                            "Suspense Fallback",
                            keyPath[2]
                        ];
                        defaultProps = [
                            newProps[1],
                            newProps[2],
                            [],
                            null
                        ];
                        request.trackedPostpones.workingMap.set(newProps, defaultProps);
                        newBoundary.trackedFallbackNode = defaultProps;
                        task.blockedSegment = boundarySegment;
                        task.blockedPreamble = newBoundary.fallbackPreamble;
                        task.keyPath = newProps;
                        boundarySegment.status = 6;
                        try {
                            $c98c69161ea584a8$var$renderNode(request, task, propName, -1), boundarySegment.lastPushedText && boundarySegment.textEmbedded && boundarySegment.chunks.push($c98c69161ea584a8$var$textSeparator), boundarySegment.status = 1;
                        } catch (thrownValue) {
                            throw boundarySegment.status = 12 === request.status ? 3 : 4, thrownValue;
                        } finally{
                            task.blockedSegment = propName$33, task.blockedPreamble = ref, task.keyPath = type;
                        }
                        task = $c98c69161ea584a8$var$createRenderTask(request, null, props, -1, newBoundary, contentRootSegment, newBoundary.contentPreamble, newBoundary.contentState, task.abortSet, keyPath, task.formatContext, task.context, task.treeContext, task.componentStack, task.isFallback);
                        $c98c69161ea584a8$var$pushComponentStack(task);
                        request.pingedTasks.push(task);
                    } else {
                        task.blockedBoundary = newBoundary;
                        task.blockedPreamble = newBoundary.contentPreamble;
                        task.hoistableState = newBoundary.contentState;
                        task.blockedSegment = contentRootSegment;
                        task.keyPath = keyPath;
                        contentRootSegment.status = 6;
                        try {
                            if ($c98c69161ea584a8$var$renderNode(request, task, props, -1), contentRootSegment.lastPushedText && contentRootSegment.textEmbedded && contentRootSegment.chunks.push($c98c69161ea584a8$var$textSeparator), contentRootSegment.status = 1, $c98c69161ea584a8$var$queueCompletedSegment(newBoundary, contentRootSegment), 0 === newBoundary.pendingTasks && 0 === newBoundary.status) {
                                newBoundary.status = 1;
                                0 === request.pendingRootTasks && task.blockedPreamble && $c98c69161ea584a8$var$preparePreamble(request);
                                break a;
                            }
                        } catch (thrownValue$28) {
                            newBoundary.status = 4, 12 === request.status ? (contentRootSegment.status = 3, newProps = request.fatalError) : (contentRootSegment.status = 4, newProps = thrownValue$28), defaultProps = $c98c69161ea584a8$var$getThrownInfo(task.componentStack), initialState = $c98c69161ea584a8$var$logRecoverableError(request, newProps, defaultProps), newBoundary.errorDigest = initialState, $c98c69161ea584a8$var$untrackBoundary(request, newBoundary);
                        } finally{
                            task.blockedBoundary = parentBoundary, task.blockedPreamble = ref, task.hoistableState = parentHoistableState, task.blockedSegment = propName$33, task.keyPath = type;
                        }
                        task = $c98c69161ea584a8$var$createRenderTask(request, null, propName, -1, parentBoundary, boundarySegment, newBoundary.fallbackPreamble, newBoundary.fallbackState, fallbackAbortSet, [
                            keyPath[0],
                            "Suspense Fallback",
                            keyPath[2]
                        ], task.formatContext, task.context, task.treeContext, task.componentStack, !0);
                        $c98c69161ea584a8$var$pushComponentStack(task);
                        request.pingedTasks.push(task);
                    }
                }
                return;
        }
        if ("object" === typeof type && null !== type) switch(type.$$typeof){
            case $c98c69161ea584a8$var$REACT_FORWARD_REF_TYPE:
                if ("ref" in props) for(newBoundary in newProps = {}, props)"ref" !== newBoundary && (newProps[newBoundary] = props[newBoundary]);
                else newProps = props;
                type = $c98c69161ea584a8$var$renderWithHooks(request, task, keyPath, type.render, newProps, ref);
                $c98c69161ea584a8$var$finishFunctionComponent(request, task, keyPath, type, 0 !== $c98c69161ea584a8$var$localIdCounter, $c98c69161ea584a8$var$actionStateCounter, $c98c69161ea584a8$var$actionStateMatchingIndex);
                return;
            case $c98c69161ea584a8$var$REACT_MEMO_TYPE:
                $c98c69161ea584a8$var$renderElement(request, task, keyPath, type.type, props, ref);
                return;
            case $c98c69161ea584a8$var$REACT_PROVIDER_TYPE:
            case $c98c69161ea584a8$var$REACT_CONTEXT_TYPE:
                defaultProps = props.children;
                newProps = task.keyPath;
                props = props.value;
                initialState = type._currentValue;
                type._currentValue = props;
                ref = $c98c69161ea584a8$var$currentActiveSnapshot;
                $c98c69161ea584a8$var$currentActiveSnapshot = type = {
                    parent: ref,
                    depth: null === ref ? 0 : ref.depth + 1,
                    context: type,
                    parentValue: initialState,
                    value: props
                };
                task.context = type;
                task.keyPath = keyPath;
                $c98c69161ea584a8$var$renderNodeDestructive(request, task, defaultProps, -1);
                request = $c98c69161ea584a8$var$currentActiveSnapshot;
                if (null === request) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(403));
                request.context._currentValue = request.parentValue;
                request = $c98c69161ea584a8$var$currentActiveSnapshot = request.parent;
                task.context = request;
                task.keyPath = newProps;
                return;
            case $c98c69161ea584a8$var$REACT_CONSUMER_TYPE:
                props = props.children;
                type = props(type._context._currentValue);
                props = task.keyPath;
                task.keyPath = keyPath;
                $c98c69161ea584a8$var$renderNodeDestructive(request, task, type, -1);
                task.keyPath = props;
                return;
            case $c98c69161ea584a8$var$REACT_LAZY_TYPE:
                newProps = type._init;
                type = newProps(type._payload);
                if (12 === request.status) throw null;
                $c98c69161ea584a8$var$renderElement(request, task, keyPath, type, props, ref);
                return;
        }
        throw Error($c98c69161ea584a8$var$formatProdErrorMessage(130, null == type ? type : typeof type, ""));
    }
}
function $c98c69161ea584a8$var$resumeNode(request, task, segmentId, node, childIndex) {
    var prevReplay = task.replay, blockedBoundary = task.blockedBoundary, resumedSegment = $c98c69161ea584a8$var$createPendingSegment(request, 0, null, task.formatContext, !1, !1);
    resumedSegment.id = segmentId;
    resumedSegment.parentFlushed = !0;
    try {
        task.replay = null, task.blockedSegment = resumedSegment, $c98c69161ea584a8$var$renderNode(request, task, node, childIndex), resumedSegment.status = 1, null === blockedBoundary ? request.completedRootSegment = resumedSegment : ($c98c69161ea584a8$var$queueCompletedSegment(blockedBoundary, resumedSegment), blockedBoundary.parentFlushed && request.partialBoundaries.push(blockedBoundary));
    } finally{
        task.replay = prevReplay, task.blockedSegment = null;
    }
}
function $c98c69161ea584a8$var$renderNodeDestructive(request, task, node, childIndex) {
    null !== task.replay && "number" === typeof task.replay.slots ? $c98c69161ea584a8$var$resumeNode(request, task, task.replay.slots, node, childIndex) : (task.node = node, task.childIndex = childIndex, node = task.componentStack, $c98c69161ea584a8$var$pushComponentStack(task), $c98c69161ea584a8$var$retryNode(request, task), task.componentStack = node);
}
function $c98c69161ea584a8$var$retryNode(request, task) {
    var node = task.node, childIndex = task.childIndex;
    if (null !== node) {
        if ("object" === typeof node) {
            switch(node.$$typeof){
                case $c98c69161ea584a8$var$REACT_ELEMENT_TYPE:
                    var type = node.type, key = node.key, props = node.props;
                    node = props.ref;
                    var ref = void 0 !== node ? node : null, name = $c98c69161ea584a8$var$getComponentNameFromType(type), keyOrIndex = null == key ? -1 === childIndex ? 0 : childIndex : key;
                    key = [
                        task.keyPath,
                        name,
                        keyOrIndex
                    ];
                    if (null !== task.replay) a: {
                        var replay = task.replay;
                        childIndex = replay.nodes;
                        for(node = 0; node < childIndex.length; node++){
                            var node$jscomp$0 = childIndex[node];
                            if (keyOrIndex === node$jscomp$0[1]) {
                                if (4 === node$jscomp$0.length) {
                                    if (null !== name && name !== node$jscomp$0[0]) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(490, node$jscomp$0[0], name));
                                    var childNodes = node$jscomp$0[2];
                                    name = node$jscomp$0[3];
                                    keyOrIndex = task.node;
                                    task.replay = {
                                        nodes: childNodes,
                                        slots: name,
                                        pendingTasks: 1
                                    };
                                    try {
                                        $c98c69161ea584a8$var$renderElement(request, task, key, type, props, ref);
                                        if (1 === task.replay.pendingTasks && 0 < task.replay.nodes.length) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(488));
                                        task.replay.pendingTasks--;
                                    } catch (x) {
                                        if ("object" === typeof x && null !== x && (x === $c98c69161ea584a8$var$SuspenseException || "function" === typeof x.then)) throw task.node === keyOrIndex && (task.replay = replay), x;
                                        task.replay.pendingTasks--;
                                        props = $c98c69161ea584a8$var$getThrownInfo(task.componentStack);
                                        key = task.blockedBoundary;
                                        type = x;
                                        props = $c98c69161ea584a8$var$logRecoverableError(request, type, props);
                                        $c98c69161ea584a8$var$abortRemainingReplayNodes(request, key, childNodes, name, type, props);
                                    }
                                    task.replay = replay;
                                } else {
                                    if (type !== $c98c69161ea584a8$var$REACT_SUSPENSE_TYPE) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(490, "Suspense", $c98c69161ea584a8$var$getComponentNameFromType(type) || "Unknown"));
                                    b: {
                                        replay = void 0;
                                        type = node$jscomp$0[5];
                                        ref = node$jscomp$0[2];
                                        name = node$jscomp$0[3];
                                        keyOrIndex = null === node$jscomp$0[4] ? [] : node$jscomp$0[4][2];
                                        node$jscomp$0 = null === node$jscomp$0[4] ? null : node$jscomp$0[4][3];
                                        var prevKeyPath = task.keyPath, previousReplaySet = task.replay, parentBoundary = task.blockedBoundary, parentHoistableState = task.hoistableState, content = props.children, fallback = props.fallback, fallbackAbortSet = new Set();
                                        props = 2 > task.formatContext.insertionMode ? $c98c69161ea584a8$var$createSuspenseBoundary(request, fallbackAbortSet, $c98c69161ea584a8$var$createPreambleState(), $c98c69161ea584a8$var$createPreambleState()) : $c98c69161ea584a8$var$createSuspenseBoundary(request, fallbackAbortSet, null, null);
                                        props.parentFlushed = !0;
                                        props.rootSegmentID = type;
                                        task.blockedBoundary = props;
                                        task.hoistableState = props.contentState;
                                        task.keyPath = key;
                                        task.replay = {
                                            nodes: ref,
                                            slots: name,
                                            pendingTasks: 1
                                        };
                                        try {
                                            $c98c69161ea584a8$var$renderNode(request, task, content, -1);
                                            if (1 === task.replay.pendingTasks && 0 < task.replay.nodes.length) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(488));
                                            task.replay.pendingTasks--;
                                            if (0 === props.pendingTasks && 0 === props.status) {
                                                props.status = 1;
                                                request.completedBoundaries.push(props);
                                                break b;
                                            }
                                        } catch (error) {
                                            props.status = 4, childNodes = $c98c69161ea584a8$var$getThrownInfo(task.componentStack), replay = $c98c69161ea584a8$var$logRecoverableError(request, error, childNodes), props.errorDigest = replay, task.replay.pendingTasks--, request.clientRenderedBoundaries.push(props);
                                        } finally{
                                            task.blockedBoundary = parentBoundary, task.hoistableState = parentHoistableState, task.replay = previousReplaySet, task.keyPath = prevKeyPath;
                                        }
                                        task = $c98c69161ea584a8$var$createReplayTask(request, null, {
                                            nodes: keyOrIndex,
                                            slots: node$jscomp$0,
                                            pendingTasks: 0
                                        }, fallback, -1, parentBoundary, props.fallbackState, fallbackAbortSet, [
                                            key[0],
                                            "Suspense Fallback",
                                            key[2]
                                        ], task.formatContext, task.context, task.treeContext, task.componentStack, !0);
                                        $c98c69161ea584a8$var$pushComponentStack(task);
                                        request.pingedTasks.push(task);
                                    }
                                }
                                childIndex.splice(node, 1);
                                break a;
                            }
                        }
                    }
                    else $c98c69161ea584a8$var$renderElement(request, task, key, type, props, ref);
                    return;
                case $c98c69161ea584a8$var$REACT_PORTAL_TYPE:
                    throw Error($c98c69161ea584a8$var$formatProdErrorMessage(257));
                case $c98c69161ea584a8$var$REACT_LAZY_TYPE:
                    childNodes = node._init;
                    node = childNodes(node._payload);
                    if (12 === request.status) throw null;
                    $c98c69161ea584a8$var$renderNodeDestructive(request, task, node, childIndex);
                    return;
            }
            if ($c98c69161ea584a8$var$isArrayImpl(node)) {
                $c98c69161ea584a8$var$renderChildrenArray(request, task, node, childIndex);
                return;
            }
            null === node || "object" !== typeof node ? childNodes = null : (childNodes = $c98c69161ea584a8$var$MAYBE_ITERATOR_SYMBOL && node[$c98c69161ea584a8$var$MAYBE_ITERATOR_SYMBOL] || node["@@iterator"], childNodes = "function" === typeof childNodes ? childNodes : null);
            if (childNodes && (childNodes = childNodes.call(node))) {
                node = childNodes.next();
                if (!node.done) {
                    props = [];
                    do props.push(node.value), node = childNodes.next();
                    while (!node.done);
                    $c98c69161ea584a8$var$renderChildrenArray(request, task, props, childIndex);
                }
                return;
            }
            if ("function" === typeof node.then) return task.thenableState = null, $c98c69161ea584a8$var$renderNodeDestructive(request, task, $c98c69161ea584a8$var$unwrapThenable(node), childIndex);
            if (node.$$typeof === $c98c69161ea584a8$var$REACT_CONTEXT_TYPE) return $c98c69161ea584a8$var$renderNodeDestructive(request, task, node._currentValue, childIndex);
            childIndex = Object.prototype.toString.call(node);
            throw Error($c98c69161ea584a8$var$formatProdErrorMessage(31, "[object Object]" === childIndex ? "object with keys {" + Object.keys(node).join(", ") + "}" : childIndex));
        }
        if ("string" === typeof node) childIndex = task.blockedSegment, null !== childIndex && (childIndex.lastPushedText = $c98c69161ea584a8$var$pushTextInstance(childIndex.chunks, node, request.renderState, childIndex.lastPushedText));
        else if ("number" === typeof node || "bigint" === typeof node) childIndex = task.blockedSegment, null !== childIndex && (childIndex.lastPushedText = $c98c69161ea584a8$var$pushTextInstance(childIndex.chunks, "" + node, request.renderState, childIndex.lastPushedText));
    }
}
function $c98c69161ea584a8$var$renderChildrenArray(request, task, children, childIndex) {
    var prevKeyPath = task.keyPath;
    if (-1 !== childIndex && (task.keyPath = [
        task.keyPath,
        "Fragment",
        childIndex
    ], null !== task.replay)) {
        for(var replay = task.replay, replayNodes = replay.nodes, j = 0; j < replayNodes.length; j++){
            var node = replayNodes[j];
            if (node[1] === childIndex) {
                childIndex = node[2];
                node = node[3];
                task.replay = {
                    nodes: childIndex,
                    slots: node,
                    pendingTasks: 1
                };
                try {
                    $c98c69161ea584a8$var$renderChildrenArray(request, task, children, -1);
                    if (1 === task.replay.pendingTasks && 0 < task.replay.nodes.length) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(488));
                    task.replay.pendingTasks--;
                } catch (x) {
                    if ("object" === typeof x && null !== x && (x === $c98c69161ea584a8$var$SuspenseException || "function" === typeof x.then)) throw x;
                    task.replay.pendingTasks--;
                    children = $c98c69161ea584a8$var$getThrownInfo(task.componentStack);
                    var boundary = task.blockedBoundary, error = x;
                    children = $c98c69161ea584a8$var$logRecoverableError(request, error, children);
                    $c98c69161ea584a8$var$abortRemainingReplayNodes(request, boundary, childIndex, node, error, children);
                }
                task.replay = replay;
                replayNodes.splice(j, 1);
                break;
            }
        }
        task.keyPath = prevKeyPath;
        return;
    }
    replay = task.treeContext;
    replayNodes = children.length;
    if (null !== task.replay && (j = task.replay.slots, null !== j && "object" === typeof j)) {
        for(childIndex = 0; childIndex < replayNodes; childIndex++)node = children[childIndex], task.treeContext = $c98c69161ea584a8$var$pushTreeContext(replay, replayNodes, childIndex), boundary = j[childIndex], "number" === typeof boundary ? ($c98c69161ea584a8$var$resumeNode(request, task, boundary, node, childIndex), delete j[childIndex]) : $c98c69161ea584a8$var$renderNode(request, task, node, childIndex);
        task.treeContext = replay;
        task.keyPath = prevKeyPath;
        return;
    }
    for(j = 0; j < replayNodes; j++)childIndex = children[j], task.treeContext = $c98c69161ea584a8$var$pushTreeContext(replay, replayNodes, j), $c98c69161ea584a8$var$renderNode(request, task, childIndex, j);
    task.treeContext = replay;
    task.keyPath = prevKeyPath;
}
function $c98c69161ea584a8$var$untrackBoundary(request, boundary) {
    request = request.trackedPostpones;
    null !== request && (boundary = boundary.trackedContentKeyPath, null !== boundary && (boundary = request.workingMap.get(boundary), void 0 !== boundary && (boundary.length = 4, boundary[2] = [], boundary[3] = null)));
}
function $c98c69161ea584a8$var$spawnNewSuspendedReplayTask(request, task, thenableState) {
    return $c98c69161ea584a8$var$createReplayTask(request, thenableState, task.replay, task.node, task.childIndex, task.blockedBoundary, task.hoistableState, task.abortSet, task.keyPath, task.formatContext, task.context, task.treeContext, task.componentStack, task.isFallback);
}
function $c98c69161ea584a8$var$spawnNewSuspendedRenderTask(request, task, thenableState) {
    var segment = task.blockedSegment, newSegment = $c98c69161ea584a8$var$createPendingSegment(request, segment.chunks.length, null, task.formatContext, segment.lastPushedText, !0);
    segment.children.push(newSegment);
    segment.lastPushedText = !1;
    return $c98c69161ea584a8$var$createRenderTask(request, thenableState, task.node, task.childIndex, task.blockedBoundary, newSegment, task.blockedPreamble, task.hoistableState, task.abortSet, task.keyPath, task.formatContext, task.context, task.treeContext, task.componentStack, task.isFallback);
}
function $c98c69161ea584a8$var$renderNode(request, task, node, childIndex) {
    var previousFormatContext = task.formatContext, previousContext = task.context, previousKeyPath = task.keyPath, previousTreeContext = task.treeContext, previousComponentStack = task.componentStack, segment = task.blockedSegment;
    if (null === segment) try {
        return $c98c69161ea584a8$var$renderNodeDestructive(request, task, node, childIndex);
    } catch (thrownValue) {
        if ($c98c69161ea584a8$var$resetHooksState(), node = thrownValue === $c98c69161ea584a8$var$SuspenseException ? $c98c69161ea584a8$var$getSuspendedThenable() : thrownValue, "object" === typeof node && null !== node) {
            if ("function" === typeof node.then) {
                childIndex = $c98c69161ea584a8$var$getThenableStateAfterSuspending();
                request = $c98c69161ea584a8$var$spawnNewSuspendedReplayTask(request, task, childIndex).ping;
                node.then(request, request);
                task.formatContext = previousFormatContext;
                task.context = previousContext;
                task.keyPath = previousKeyPath;
                task.treeContext = previousTreeContext;
                task.componentStack = previousComponentStack;
                $c98c69161ea584a8$var$switchContext(previousContext);
                return;
            }
            if ("Maximum call stack size exceeded" === node.message) {
                node = $c98c69161ea584a8$var$getThenableStateAfterSuspending();
                node = $c98c69161ea584a8$var$spawnNewSuspendedReplayTask(request, task, node);
                request.pingedTasks.push(node);
                task.formatContext = previousFormatContext;
                task.context = previousContext;
                task.keyPath = previousKeyPath;
                task.treeContext = previousTreeContext;
                task.componentStack = previousComponentStack;
                $c98c69161ea584a8$var$switchContext(previousContext);
                return;
            }
        }
    }
    else {
        var childrenLength = segment.children.length, chunkLength = segment.chunks.length;
        try {
            return $c98c69161ea584a8$var$renderNodeDestructive(request, task, node, childIndex);
        } catch (thrownValue$48) {
            if ($c98c69161ea584a8$var$resetHooksState(), segment.children.length = childrenLength, segment.chunks.length = chunkLength, node = thrownValue$48 === $c98c69161ea584a8$var$SuspenseException ? $c98c69161ea584a8$var$getSuspendedThenable() : thrownValue$48, "object" === typeof node && null !== node) {
                if ("function" === typeof node.then) {
                    childIndex = $c98c69161ea584a8$var$getThenableStateAfterSuspending();
                    request = $c98c69161ea584a8$var$spawnNewSuspendedRenderTask(request, task, childIndex).ping;
                    node.then(request, request);
                    task.formatContext = previousFormatContext;
                    task.context = previousContext;
                    task.keyPath = previousKeyPath;
                    task.treeContext = previousTreeContext;
                    task.componentStack = previousComponentStack;
                    $c98c69161ea584a8$var$switchContext(previousContext);
                    return;
                }
                if ("Maximum call stack size exceeded" === node.message) {
                    node = $c98c69161ea584a8$var$getThenableStateAfterSuspending();
                    node = $c98c69161ea584a8$var$spawnNewSuspendedRenderTask(request, task, node);
                    request.pingedTasks.push(node);
                    task.formatContext = previousFormatContext;
                    task.context = previousContext;
                    task.keyPath = previousKeyPath;
                    task.treeContext = previousTreeContext;
                    task.componentStack = previousComponentStack;
                    $c98c69161ea584a8$var$switchContext(previousContext);
                    return;
                }
            }
        }
    }
    task.formatContext = previousFormatContext;
    task.context = previousContext;
    task.keyPath = previousKeyPath;
    task.treeContext = previousTreeContext;
    $c98c69161ea584a8$var$switchContext(previousContext);
    throw node;
}
function $c98c69161ea584a8$var$abortTaskSoft(task) {
    var boundary = task.blockedBoundary;
    task = task.blockedSegment;
    null !== task && (task.status = 3, $c98c69161ea584a8$var$finishedTask(this, boundary, task));
}
function $c98c69161ea584a8$var$abortRemainingReplayNodes(request$jscomp$0, boundary, nodes, slots, error, errorDigest$jscomp$0) {
    for(var i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (4 === node.length) $c98c69161ea584a8$var$abortRemainingReplayNodes(request$jscomp$0, boundary, node[2], node[3], error, errorDigest$jscomp$0);
        else {
            node = node[5];
            var request = request$jscomp$0, errorDigest = errorDigest$jscomp$0, resumedBoundary = $c98c69161ea584a8$var$createSuspenseBoundary(request, new Set(), null, null);
            resumedBoundary.parentFlushed = !0;
            resumedBoundary.rootSegmentID = node;
            resumedBoundary.status = 4;
            resumedBoundary.errorDigest = errorDigest;
            resumedBoundary.parentFlushed && request.clientRenderedBoundaries.push(resumedBoundary);
        }
    }
    nodes.length = 0;
    if (null !== slots) {
        if (null === boundary) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(487));
        4 !== boundary.status && (boundary.status = 4, boundary.errorDigest = errorDigest$jscomp$0, boundary.parentFlushed && request$jscomp$0.clientRenderedBoundaries.push(boundary));
        if ("object" === typeof slots) for(var index in slots)delete slots[index];
    }
}
function $c98c69161ea584a8$var$abortTask(task, request, error) {
    var boundary = task.blockedBoundary, segment = task.blockedSegment;
    if (null !== segment) {
        if (6 === segment.status) return;
        segment.status = 3;
    }
    segment = $c98c69161ea584a8$var$getThrownInfo(task.componentStack);
    if (null === boundary) {
        if (13 !== request.status && 14 !== request.status) {
            boundary = task.replay;
            if (null === boundary) {
                $c98c69161ea584a8$var$logRecoverableError(request, error, segment);
                $c98c69161ea584a8$var$fatalError(request, error);
                return;
            }
            boundary.pendingTasks--;
            0 === boundary.pendingTasks && 0 < boundary.nodes.length && (task = $c98c69161ea584a8$var$logRecoverableError(request, error, segment), $c98c69161ea584a8$var$abortRemainingReplayNodes(request, null, boundary.nodes, boundary.slots, error, task));
            request.pendingRootTasks--;
            0 === request.pendingRootTasks && $c98c69161ea584a8$var$completeShell(request);
        }
    } else boundary.pendingTasks--, 4 !== boundary.status && (boundary.status = 4, task = $c98c69161ea584a8$var$logRecoverableError(request, error, segment), boundary.status = 4, boundary.errorDigest = task, $c98c69161ea584a8$var$untrackBoundary(request, boundary), boundary.parentFlushed && request.clientRenderedBoundaries.push(boundary)), boundary.fallbackAbortableTasks.forEach(function(fallbackTask) {
        return $c98c69161ea584a8$var$abortTask(fallbackTask, request, error);
    }), boundary.fallbackAbortableTasks.clear();
    request.allPendingTasks--;
    0 === request.allPendingTasks && $c98c69161ea584a8$var$completeAll(request);
}
function $c98c69161ea584a8$var$safelyEmitEarlyPreloads(request, shellComplete) {
    try {
        var renderState = request.renderState, onHeaders = renderState.onHeaders;
        if (onHeaders) {
            var headers = renderState.headers;
            if (headers) {
                renderState.headers = null;
                var linkHeader = headers.preconnects;
                headers.fontPreloads && (linkHeader && (linkHeader += ", "), linkHeader += headers.fontPreloads);
                headers.highImagePreloads && (linkHeader && (linkHeader += ", "), linkHeader += headers.highImagePreloads);
                if (!shellComplete) {
                    var queueIter = renderState.styles.values(), queueStep = queueIter.next();
                    b: for(; 0 < headers.remainingCapacity && !queueStep.done; queueStep = queueIter.next())for(var sheetIter = queueStep.value.sheets.values(), sheetStep = sheetIter.next(); 0 < headers.remainingCapacity && !sheetStep.done; sheetStep = sheetIter.next()){
                        var sheet = sheetStep.value, props = sheet.props, key = props.href, props$jscomp$0 = sheet.props, header = $c98c69161ea584a8$var$getPreloadAsHeader(props$jscomp$0.href, "style", {
                            crossOrigin: props$jscomp$0.crossOrigin,
                            integrity: props$jscomp$0.integrity,
                            nonce: props$jscomp$0.nonce,
                            type: props$jscomp$0.type,
                            fetchPriority: props$jscomp$0.fetchPriority,
                            referrerPolicy: props$jscomp$0.referrerPolicy,
                            media: props$jscomp$0.media
                        });
                        if (0 <= (headers.remainingCapacity -= header.length + 2)) renderState.resets.style[key] = $c98c69161ea584a8$var$PRELOAD_NO_CREDS, linkHeader && (linkHeader += ", "), linkHeader += header, renderState.resets.style[key] = "string" === typeof props.crossOrigin || "string" === typeof props.integrity ? [
                            props.crossOrigin,
                            props.integrity
                        ] : $c98c69161ea584a8$var$PRELOAD_NO_CREDS;
                        else break b;
                    }
                }
                linkHeader ? onHeaders({
                    Link: linkHeader
                }) : onHeaders({});
            }
        }
    } catch (error) {
        $c98c69161ea584a8$var$logRecoverableError(request, error, {});
    }
}
function $c98c69161ea584a8$var$completeShell(request) {
    null === request.trackedPostpones && $c98c69161ea584a8$var$safelyEmitEarlyPreloads(request, !0);
    null === request.trackedPostpones && $c98c69161ea584a8$var$preparePreamble(request);
    request.onShellError = $c98c69161ea584a8$var$noop;
    request = request.onShellReady;
    request();
}
function $c98c69161ea584a8$var$completeAll(request) {
    $c98c69161ea584a8$var$safelyEmitEarlyPreloads(request, null === request.trackedPostpones ? !0 : null === request.completedRootSegment || 5 !== request.completedRootSegment.status);
    $c98c69161ea584a8$var$preparePreamble(request);
    request = request.onAllReady;
    request();
}
function $c98c69161ea584a8$var$queueCompletedSegment(boundary, segment) {
    if (0 === segment.chunks.length && 1 === segment.children.length && null === segment.children[0].boundary && -1 === segment.children[0].id) {
        var childSegment = segment.children[0];
        childSegment.id = segment.id;
        childSegment.parentFlushed = !0;
        1 === childSegment.status && $c98c69161ea584a8$var$queueCompletedSegment(boundary, childSegment);
    } else boundary.completedSegments.push(segment);
}
function $c98c69161ea584a8$var$finishedTask(request, boundary, segment) {
    if (null === boundary) {
        if (null !== segment && segment.parentFlushed) {
            if (null !== request.completedRootSegment) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(389));
            request.completedRootSegment = segment;
        }
        request.pendingRootTasks--;
        0 === request.pendingRootTasks && $c98c69161ea584a8$var$completeShell(request);
    } else boundary.pendingTasks--, 4 !== boundary.status && (0 === boundary.pendingTasks ? (0 === boundary.status && (boundary.status = 1), null !== segment && segment.parentFlushed && 1 === segment.status && $c98c69161ea584a8$var$queueCompletedSegment(boundary, segment), boundary.parentFlushed && request.completedBoundaries.push(boundary), 1 === boundary.status && (boundary.fallbackAbortableTasks.forEach($c98c69161ea584a8$var$abortTaskSoft, request), boundary.fallbackAbortableTasks.clear(), 0 === request.pendingRootTasks && null === request.trackedPostpones && null !== boundary.contentPreamble && $c98c69161ea584a8$var$preparePreamble(request))) : null !== segment && segment.parentFlushed && 1 === segment.status && ($c98c69161ea584a8$var$queueCompletedSegment(boundary, segment), 1 === boundary.completedSegments.length && boundary.parentFlushed && request.partialBoundaries.push(boundary)));
    request.allPendingTasks--;
    0 === request.allPendingTasks && $c98c69161ea584a8$var$completeAll(request);
}
function $c98c69161ea584a8$var$performWork(request$jscomp$2) {
    if (14 !== request$jscomp$2.status && 13 !== request$jscomp$2.status) {
        var prevContext = $c98c69161ea584a8$var$currentActiveSnapshot, prevDispatcher = $c98c69161ea584a8$var$ReactSharedInternals.H;
        $c98c69161ea584a8$var$ReactSharedInternals.H = $c98c69161ea584a8$var$HooksDispatcher;
        var prevAsyncDispatcher = $c98c69161ea584a8$var$ReactSharedInternals.A;
        $c98c69161ea584a8$var$ReactSharedInternals.A = $c98c69161ea584a8$var$DefaultAsyncDispatcher;
        var prevRequest = $c98c69161ea584a8$var$currentRequest;
        $c98c69161ea584a8$var$currentRequest = request$jscomp$2;
        var prevResumableState = $c98c69161ea584a8$var$currentResumableState;
        $c98c69161ea584a8$var$currentResumableState = request$jscomp$2.resumableState;
        try {
            var pingedTasks = request$jscomp$2.pingedTasks, i;
            for(i = 0; i < pingedTasks.length; i++){
                var task = pingedTasks[i], request = request$jscomp$2, segment = task.blockedSegment;
                if (null === segment) {
                    var request$jscomp$0 = request;
                    if (0 !== task.replay.pendingTasks) {
                        $c98c69161ea584a8$var$switchContext(task.context);
                        try {
                            "number" === typeof task.replay.slots ? $c98c69161ea584a8$var$resumeNode(request$jscomp$0, task, task.replay.slots, task.node, task.childIndex) : $c98c69161ea584a8$var$retryNode(request$jscomp$0, task);
                            if (1 === task.replay.pendingTasks && 0 < task.replay.nodes.length) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(488));
                            task.replay.pendingTasks--;
                            task.abortSet.delete(task);
                            $c98c69161ea584a8$var$finishedTask(request$jscomp$0, task.blockedBoundary, null);
                        } catch (thrownValue) {
                            $c98c69161ea584a8$var$resetHooksState();
                            var x = thrownValue === $c98c69161ea584a8$var$SuspenseException ? $c98c69161ea584a8$var$getSuspendedThenable() : thrownValue;
                            if ("object" === typeof x && null !== x && "function" === typeof x.then) {
                                var ping = task.ping;
                                x.then(ping, ping);
                                task.thenableState = $c98c69161ea584a8$var$getThenableStateAfterSuspending();
                            } else {
                                task.replay.pendingTasks--;
                                task.abortSet.delete(task);
                                var errorInfo = $c98c69161ea584a8$var$getThrownInfo(task.componentStack);
                                request = void 0;
                                var request$jscomp$1 = request$jscomp$0, boundary = task.blockedBoundary, error$jscomp$0 = 12 === request$jscomp$0.status ? request$jscomp$0.fatalError : x, replayNodes = task.replay.nodes, resumeSlots = task.replay.slots;
                                request = $c98c69161ea584a8$var$logRecoverableError(request$jscomp$1, error$jscomp$0, errorInfo);
                                $c98c69161ea584a8$var$abortRemainingReplayNodes(request$jscomp$1, boundary, replayNodes, resumeSlots, error$jscomp$0, request);
                                request$jscomp$0.pendingRootTasks--;
                                0 === request$jscomp$0.pendingRootTasks && $c98c69161ea584a8$var$completeShell(request$jscomp$0);
                                request$jscomp$0.allPendingTasks--;
                                0 === request$jscomp$0.allPendingTasks && $c98c69161ea584a8$var$completeAll(request$jscomp$0);
                            }
                        } finally{}
                    }
                } else if (request$jscomp$0 = void 0, request$jscomp$1 = segment, 0 === request$jscomp$1.status) {
                    request$jscomp$1.status = 6;
                    $c98c69161ea584a8$var$switchContext(task.context);
                    var childrenLength = request$jscomp$1.children.length, chunkLength = request$jscomp$1.chunks.length;
                    try {
                        $c98c69161ea584a8$var$retryNode(request, task), request$jscomp$1.lastPushedText && request$jscomp$1.textEmbedded && request$jscomp$1.chunks.push($c98c69161ea584a8$var$textSeparator), task.abortSet.delete(task), request$jscomp$1.status = 1, $c98c69161ea584a8$var$finishedTask(request, task.blockedBoundary, request$jscomp$1);
                    } catch (thrownValue) {
                        $c98c69161ea584a8$var$resetHooksState();
                        request$jscomp$1.children.length = childrenLength;
                        request$jscomp$1.chunks.length = chunkLength;
                        var x$jscomp$0 = thrownValue === $c98c69161ea584a8$var$SuspenseException ? $c98c69161ea584a8$var$getSuspendedThenable() : 12 === request.status ? request.fatalError : thrownValue;
                        if ("object" === typeof x$jscomp$0 && null !== x$jscomp$0 && "function" === typeof x$jscomp$0.then) {
                            request$jscomp$1.status = 0;
                            task.thenableState = $c98c69161ea584a8$var$getThenableStateAfterSuspending();
                            var ping$jscomp$0 = task.ping;
                            x$jscomp$0.then(ping$jscomp$0, ping$jscomp$0);
                        } else {
                            var errorInfo$jscomp$0 = $c98c69161ea584a8$var$getThrownInfo(task.componentStack);
                            task.abortSet.delete(task);
                            request$jscomp$1.status = 4;
                            var boundary$jscomp$0 = task.blockedBoundary;
                            request$jscomp$0 = $c98c69161ea584a8$var$logRecoverableError(request, x$jscomp$0, errorInfo$jscomp$0);
                            null === boundary$jscomp$0 ? $c98c69161ea584a8$var$fatalError(request, x$jscomp$0) : (boundary$jscomp$0.pendingTasks--, 4 !== boundary$jscomp$0.status && (boundary$jscomp$0.status = 4, boundary$jscomp$0.errorDigest = request$jscomp$0, $c98c69161ea584a8$var$untrackBoundary(request, boundary$jscomp$0), boundary$jscomp$0.parentFlushed && request.clientRenderedBoundaries.push(boundary$jscomp$0), 0 === request.pendingRootTasks && null === request.trackedPostpones && null !== boundary$jscomp$0.contentPreamble && $c98c69161ea584a8$var$preparePreamble(request)));
                            request.allPendingTasks--;
                            0 === request.allPendingTasks && $c98c69161ea584a8$var$completeAll(request);
                        }
                    } finally{}
                }
            }
            pingedTasks.splice(0, i);
            null !== request$jscomp$2.destination && $c98c69161ea584a8$var$flushCompletedQueues(request$jscomp$2, request$jscomp$2.destination);
        } catch (error) {
            $c98c69161ea584a8$var$logRecoverableError(request$jscomp$2, error, {}), $c98c69161ea584a8$var$fatalError(request$jscomp$2, error);
        } finally{
            $c98c69161ea584a8$var$currentResumableState = prevResumableState, $c98c69161ea584a8$var$ReactSharedInternals.H = prevDispatcher, $c98c69161ea584a8$var$ReactSharedInternals.A = prevAsyncDispatcher, prevDispatcher === $c98c69161ea584a8$var$HooksDispatcher && $c98c69161ea584a8$var$switchContext(prevContext), $c98c69161ea584a8$var$currentRequest = prevRequest;
        }
    }
}
function $c98c69161ea584a8$var$preparePreambleFromSubtree(request, segment, collectedPreambleSegments) {
    segment.preambleChildren.length && collectedPreambleSegments.push(segment.preambleChildren);
    for(var pendingPreambles = !1, i = 0; i < segment.children.length; i++)pendingPreambles = $c98c69161ea584a8$var$preparePreambleFromSegment(request, segment.children[i], collectedPreambleSegments) || pendingPreambles;
    return pendingPreambles;
}
function $c98c69161ea584a8$var$preparePreambleFromSegment(request, segment, collectedPreambleSegments) {
    var boundary = segment.boundary;
    if (null === boundary) return $c98c69161ea584a8$var$preparePreambleFromSubtree(request, segment, collectedPreambleSegments);
    var preamble = boundary.contentPreamble, fallbackPreamble = boundary.fallbackPreamble;
    if (null === preamble || null === fallbackPreamble) return !1;
    switch(boundary.status){
        case 1:
            $c98c69161ea584a8$var$hoistPreambleState(request.renderState, preamble);
            segment = boundary.completedSegments[0];
            if (!segment) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(391));
            return $c98c69161ea584a8$var$preparePreambleFromSubtree(request, segment, collectedPreambleSegments);
        case 5:
            if (null !== request.trackedPostpones) return !0;
        case 4:
            if (1 === segment.status) return $c98c69161ea584a8$var$hoistPreambleState(request.renderState, fallbackPreamble), $c98c69161ea584a8$var$preparePreambleFromSubtree(request, segment, collectedPreambleSegments);
        default:
            return !0;
    }
}
function $c98c69161ea584a8$var$preparePreamble(request) {
    if (request.completedRootSegment && null === request.completedPreambleSegments) {
        var collectedPreambleSegments = [], hasPendingPreambles = $c98c69161ea584a8$var$preparePreambleFromSegment(request, request.completedRootSegment, collectedPreambleSegments), preamble = request.renderState.preamble;
        if (!1 === hasPendingPreambles || preamble.headChunks && preamble.bodyChunks) request.completedPreambleSegments = collectedPreambleSegments;
    }
}
function $c98c69161ea584a8$var$flushSubtree(request, destination, segment, hoistableState) {
    segment.parentFlushed = !0;
    switch(segment.status){
        case 0:
            segment.id = request.nextSegmentId++;
        case 5:
            return hoistableState = segment.id, segment.lastPushedText = !1, segment.textEmbedded = !1, request = request.renderState, $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$placeholder1), $c98c69161ea584a8$var$writeChunk(destination, request.placeholderPrefix), request = $c98c69161ea584a8$var$stringToChunk(hoistableState.toString(16)), $c98c69161ea584a8$var$writeChunk(destination, request), $c98c69161ea584a8$var$writeChunkAndReturn(destination, $c98c69161ea584a8$var$placeholder2);
        case 1:
            segment.status = 2;
            var r = !0, chunks = segment.chunks, chunkIdx = 0;
            segment = segment.children;
            for(var childIdx = 0; childIdx < segment.length; childIdx++){
                for(r = segment[childIdx]; chunkIdx < r.index; chunkIdx++)$c98c69161ea584a8$var$writeChunk(destination, chunks[chunkIdx]);
                r = $c98c69161ea584a8$var$flushSegment(request, destination, r, hoistableState);
            }
            for(; chunkIdx < chunks.length - 1; chunkIdx++)$c98c69161ea584a8$var$writeChunk(destination, chunks[chunkIdx]);
            chunkIdx < chunks.length && (r = $c98c69161ea584a8$var$writeChunkAndReturn(destination, chunks[chunkIdx]));
            return r;
        default:
            throw Error($c98c69161ea584a8$var$formatProdErrorMessage(390));
    }
}
function $c98c69161ea584a8$var$flushSegment(request, destination, segment, hoistableState) {
    var boundary = segment.boundary;
    if (null === boundary) return $c98c69161ea584a8$var$flushSubtree(request, destination, segment, hoistableState);
    boundary.parentFlushed = !0;
    if (4 === boundary.status) {
        var errorDigest = boundary.errorDigest;
        $c98c69161ea584a8$var$writeChunkAndReturn(destination, $c98c69161ea584a8$var$startClientRenderedSuspenseBoundary);
        $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$clientRenderedSuspenseBoundaryError1);
        errorDigest && ($c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$clientRenderedSuspenseBoundaryError1A), $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeTextForBrowser(errorDigest))), $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$clientRenderedSuspenseBoundaryErrorAttrInterstitial));
        $c98c69161ea584a8$var$writeChunkAndReturn(destination, $c98c69161ea584a8$var$clientRenderedSuspenseBoundaryError2);
        $c98c69161ea584a8$var$flushSubtree(request, destination, segment, hoistableState);
        (request = boundary.fallbackPreamble) && $c98c69161ea584a8$var$writePreambleContribution(destination, request);
        return $c98c69161ea584a8$var$writeChunkAndReturn(destination, $c98c69161ea584a8$var$endSuspenseBoundary);
    }
    if (1 !== boundary.status) return 0 === boundary.status && (boundary.rootSegmentID = request.nextSegmentId++), 0 < boundary.completedSegments.length && request.partialBoundaries.push(boundary), $c98c69161ea584a8$var$writeStartPendingSuspenseBoundary(destination, request.renderState, boundary.rootSegmentID), hoistableState && (boundary = boundary.fallbackState, boundary.styles.forEach($c98c69161ea584a8$var$hoistStyleQueueDependency, hoistableState), boundary.stylesheets.forEach($c98c69161ea584a8$var$hoistStylesheetDependency, hoistableState)), $c98c69161ea584a8$var$flushSubtree(request, destination, segment, hoistableState), $c98c69161ea584a8$var$writeChunkAndReturn(destination, $c98c69161ea584a8$var$endSuspenseBoundary);
    if (boundary.byteSize > request.progressiveChunkSize) return boundary.rootSegmentID = request.nextSegmentId++, request.completedBoundaries.push(boundary), $c98c69161ea584a8$var$writeStartPendingSuspenseBoundary(destination, request.renderState, boundary.rootSegmentID), $c98c69161ea584a8$var$flushSubtree(request, destination, segment, hoistableState), $c98c69161ea584a8$var$writeChunkAndReturn(destination, $c98c69161ea584a8$var$endSuspenseBoundary);
    hoistableState && (segment = boundary.contentState, segment.styles.forEach($c98c69161ea584a8$var$hoistStyleQueueDependency, hoistableState), segment.stylesheets.forEach($c98c69161ea584a8$var$hoistStylesheetDependency, hoistableState));
    $c98c69161ea584a8$var$writeChunkAndReturn(destination, $c98c69161ea584a8$var$startCompletedSuspenseBoundary);
    segment = boundary.completedSegments;
    if (1 !== segment.length) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(391));
    $c98c69161ea584a8$var$flushSegment(request, destination, segment[0], hoistableState);
    (request = boundary.contentPreamble) && $c98c69161ea584a8$var$writePreambleContribution(destination, request);
    return $c98c69161ea584a8$var$writeChunkAndReturn(destination, $c98c69161ea584a8$var$endSuspenseBoundary);
}
function $c98c69161ea584a8$var$flushSegmentContainer(request, destination, segment, hoistableState) {
    $c98c69161ea584a8$var$writeStartSegment(destination, request.renderState, segment.parentFormatContext, segment.id);
    $c98c69161ea584a8$var$flushSegment(request, destination, segment, hoistableState);
    return $c98c69161ea584a8$var$writeEndSegment(destination, segment.parentFormatContext);
}
function $c98c69161ea584a8$var$flushCompletedBoundary(request, destination, boundary) {
    for(var completedSegments = boundary.completedSegments, i = 0; i < completedSegments.length; i++)$c98c69161ea584a8$var$flushPartiallyCompletedSegment(request, destination, boundary, completedSegments[i]);
    completedSegments.length = 0;
    $c98c69161ea584a8$var$writeHoistablesForBoundary(destination, boundary.contentState, request.renderState);
    completedSegments = request.resumableState;
    request = request.renderState;
    i = boundary.rootSegmentID;
    boundary = boundary.contentState;
    var requiresStyleInsertion = request.stylesToHoist;
    request.stylesToHoist = !1;
    $c98c69161ea584a8$var$writeChunk(destination, request.startInlineScript);
    requiresStyleInsertion ? 0 === (completedSegments.instructions & 2) ? (completedSegments.instructions |= 10, $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$completeBoundaryWithStylesScript1FullBoth)) : 0 === (completedSegments.instructions & 8) ? (completedSegments.instructions |= 8, $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$completeBoundaryWithStylesScript1FullPartial)) : $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$completeBoundaryWithStylesScript1Partial) : 0 === (completedSegments.instructions & 2) ? (completedSegments.instructions |= 2, $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$completeBoundaryScript1Full)) : $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$completeBoundaryScript1Partial);
    completedSegments = $c98c69161ea584a8$var$stringToChunk(i.toString(16));
    $c98c69161ea584a8$var$writeChunk(destination, request.boundaryPrefix);
    $c98c69161ea584a8$var$writeChunk(destination, completedSegments);
    $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$completeBoundaryScript2);
    $c98c69161ea584a8$var$writeChunk(destination, request.segmentPrefix);
    $c98c69161ea584a8$var$writeChunk(destination, completedSegments);
    requiresStyleInsertion ? ($c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$completeBoundaryScript3a), $c98c69161ea584a8$var$writeStyleResourceDependenciesInJS(destination, boundary)) : $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$completeBoundaryScript3b);
    boundary = $c98c69161ea584a8$var$writeChunkAndReturn(destination, $c98c69161ea584a8$var$completeBoundaryScriptEnd);
    return $c98c69161ea584a8$var$writeBootstrap(destination, request) && boundary;
}
function $c98c69161ea584a8$var$flushPartiallyCompletedSegment(request, destination, boundary, segment) {
    if (2 === segment.status) return !0;
    var hoistableState = boundary.contentState, segmentID = segment.id;
    if (-1 === segmentID) {
        if (-1 === (segment.id = boundary.rootSegmentID)) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(392));
        return $c98c69161ea584a8$var$flushSegmentContainer(request, destination, segment, hoistableState);
    }
    if (segmentID === boundary.rootSegmentID) return $c98c69161ea584a8$var$flushSegmentContainer(request, destination, segment, hoistableState);
    $c98c69161ea584a8$var$flushSegmentContainer(request, destination, segment, hoistableState);
    boundary = request.resumableState;
    request = request.renderState;
    $c98c69161ea584a8$var$writeChunk(destination, request.startInlineScript);
    0 === (boundary.instructions & 1) ? (boundary.instructions |= 1, $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$completeSegmentScript1Full)) : $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$completeSegmentScript1Partial);
    $c98c69161ea584a8$var$writeChunk(destination, request.segmentPrefix);
    segmentID = $c98c69161ea584a8$var$stringToChunk(segmentID.toString(16));
    $c98c69161ea584a8$var$writeChunk(destination, segmentID);
    $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$completeSegmentScript2);
    $c98c69161ea584a8$var$writeChunk(destination, request.placeholderPrefix);
    $c98c69161ea584a8$var$writeChunk(destination, segmentID);
    destination = $c98c69161ea584a8$var$writeChunkAndReturn(destination, $c98c69161ea584a8$var$completeSegmentScriptEnd);
    return destination;
}
function $c98c69161ea584a8$var$flushCompletedQueues(request, destination) {
    $c98c69161ea584a8$var$currentView = new Uint8Array(2048);
    $c98c69161ea584a8$var$writtenBytes = 0;
    try {
        if (!(0 < request.pendingRootTasks)) {
            var i, completedRootSegment = request.completedRootSegment;
            if (null !== completedRootSegment) {
                if (5 === completedRootSegment.status) return;
                var completedPreambleSegments = request.completedPreambleSegments;
                if (null === completedPreambleSegments) return;
                var renderState = request.renderState, preamble = renderState.preamble, htmlChunks = preamble.htmlChunks, headChunks = preamble.headChunks, i$jscomp$0;
                if (htmlChunks) {
                    for(i$jscomp$0 = 0; i$jscomp$0 < htmlChunks.length; i$jscomp$0++)$c98c69161ea584a8$var$writeChunk(destination, htmlChunks[i$jscomp$0]);
                    if (headChunks) for(i$jscomp$0 = 0; i$jscomp$0 < headChunks.length; i$jscomp$0++)$c98c69161ea584a8$var$writeChunk(destination, headChunks[i$jscomp$0]);
                    else $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$startChunkForTag("head")), $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$endOfStartTag);
                } else if (headChunks) for(i$jscomp$0 = 0; i$jscomp$0 < headChunks.length; i$jscomp$0++)$c98c69161ea584a8$var$writeChunk(destination, headChunks[i$jscomp$0]);
                var charsetChunks = renderState.charsetChunks;
                for(i$jscomp$0 = 0; i$jscomp$0 < charsetChunks.length; i$jscomp$0++)$c98c69161ea584a8$var$writeChunk(destination, charsetChunks[i$jscomp$0]);
                charsetChunks.length = 0;
                renderState.preconnects.forEach($c98c69161ea584a8$var$flushResource, destination);
                renderState.preconnects.clear();
                var viewportChunks = renderState.viewportChunks;
                for(i$jscomp$0 = 0; i$jscomp$0 < viewportChunks.length; i$jscomp$0++)$c98c69161ea584a8$var$writeChunk(destination, viewportChunks[i$jscomp$0]);
                viewportChunks.length = 0;
                renderState.fontPreloads.forEach($c98c69161ea584a8$var$flushResource, destination);
                renderState.fontPreloads.clear();
                renderState.highImagePreloads.forEach($c98c69161ea584a8$var$flushResource, destination);
                renderState.highImagePreloads.clear();
                renderState.styles.forEach($c98c69161ea584a8$var$flushStylesInPreamble, destination);
                var importMapChunks = renderState.importMapChunks;
                for(i$jscomp$0 = 0; i$jscomp$0 < importMapChunks.length; i$jscomp$0++)$c98c69161ea584a8$var$writeChunk(destination, importMapChunks[i$jscomp$0]);
                importMapChunks.length = 0;
                renderState.bootstrapScripts.forEach($c98c69161ea584a8$var$flushResource, destination);
                renderState.scripts.forEach($c98c69161ea584a8$var$flushResource, destination);
                renderState.scripts.clear();
                renderState.bulkPreloads.forEach($c98c69161ea584a8$var$flushResource, destination);
                renderState.bulkPreloads.clear();
                var hoistableChunks = renderState.hoistableChunks;
                for(i$jscomp$0 = 0; i$jscomp$0 < hoistableChunks.length; i$jscomp$0++)$c98c69161ea584a8$var$writeChunk(destination, hoistableChunks[i$jscomp$0]);
                for(renderState = hoistableChunks.length = 0; renderState < completedPreambleSegments.length; renderState++){
                    var segments = completedPreambleSegments[renderState];
                    for(preamble = 0; preamble < segments.length; preamble++)$c98c69161ea584a8$var$flushSegment(request, destination, segments[preamble], null);
                }
                var preamble$jscomp$0 = request.renderState.preamble, headChunks$jscomp$0 = preamble$jscomp$0.headChunks;
                (preamble$jscomp$0.htmlChunks || headChunks$jscomp$0) && $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$endChunkForTag("head"));
                var bodyChunks = preamble$jscomp$0.bodyChunks;
                if (bodyChunks) for(completedPreambleSegments = 0; completedPreambleSegments < bodyChunks.length; completedPreambleSegments++)$c98c69161ea584a8$var$writeChunk(destination, bodyChunks[completedPreambleSegments]);
                $c98c69161ea584a8$var$flushSegment(request, destination, completedRootSegment, null);
                request.completedRootSegment = null;
                $c98c69161ea584a8$var$writeBootstrap(destination, request.renderState);
            }
            var renderState$jscomp$0 = request.renderState;
            completedRootSegment = 0;
            var viewportChunks$jscomp$0 = renderState$jscomp$0.viewportChunks;
            for(completedRootSegment = 0; completedRootSegment < viewportChunks$jscomp$0.length; completedRootSegment++)$c98c69161ea584a8$var$writeChunk(destination, viewportChunks$jscomp$0[completedRootSegment]);
            viewportChunks$jscomp$0.length = 0;
            renderState$jscomp$0.preconnects.forEach($c98c69161ea584a8$var$flushResource, destination);
            renderState$jscomp$0.preconnects.clear();
            renderState$jscomp$0.fontPreloads.forEach($c98c69161ea584a8$var$flushResource, destination);
            renderState$jscomp$0.fontPreloads.clear();
            renderState$jscomp$0.highImagePreloads.forEach($c98c69161ea584a8$var$flushResource, destination);
            renderState$jscomp$0.highImagePreloads.clear();
            renderState$jscomp$0.styles.forEach($c98c69161ea584a8$var$preloadLateStyles, destination);
            renderState$jscomp$0.scripts.forEach($c98c69161ea584a8$var$flushResource, destination);
            renderState$jscomp$0.scripts.clear();
            renderState$jscomp$0.bulkPreloads.forEach($c98c69161ea584a8$var$flushResource, destination);
            renderState$jscomp$0.bulkPreloads.clear();
            var hoistableChunks$jscomp$0 = renderState$jscomp$0.hoistableChunks;
            for(completedRootSegment = 0; completedRootSegment < hoistableChunks$jscomp$0.length; completedRootSegment++)$c98c69161ea584a8$var$writeChunk(destination, hoistableChunks$jscomp$0[completedRootSegment]);
            hoistableChunks$jscomp$0.length = 0;
            var clientRenderedBoundaries = request.clientRenderedBoundaries;
            for(i = 0; i < clientRenderedBoundaries.length; i++){
                var boundary = clientRenderedBoundaries[i];
                renderState$jscomp$0 = destination;
                var resumableState = request.resumableState, renderState$jscomp$1 = request.renderState, id = boundary.rootSegmentID, errorDigest = boundary.errorDigest;
                $c98c69161ea584a8$var$writeChunk(renderState$jscomp$0, renderState$jscomp$1.startInlineScript);
                0 === (resumableState.instructions & 4) ? (resumableState.instructions |= 4, $c98c69161ea584a8$var$writeChunk(renderState$jscomp$0, $c98c69161ea584a8$var$clientRenderScript1Full)) : $c98c69161ea584a8$var$writeChunk(renderState$jscomp$0, $c98c69161ea584a8$var$clientRenderScript1Partial);
                $c98c69161ea584a8$var$writeChunk(renderState$jscomp$0, renderState$jscomp$1.boundaryPrefix);
                $c98c69161ea584a8$var$writeChunk(renderState$jscomp$0, $c98c69161ea584a8$var$stringToChunk(id.toString(16)));
                $c98c69161ea584a8$var$writeChunk(renderState$jscomp$0, $c98c69161ea584a8$var$clientRenderScript1A);
                errorDigest && ($c98c69161ea584a8$var$writeChunk(renderState$jscomp$0, $c98c69161ea584a8$var$clientRenderErrorScriptArgInterstitial), $c98c69161ea584a8$var$writeChunk(renderState$jscomp$0, $c98c69161ea584a8$var$stringToChunk($c98c69161ea584a8$var$escapeJSStringsForInstructionScripts(errorDigest || ""))));
                var JSCompiler_inline_result = $c98c69161ea584a8$var$writeChunkAndReturn(renderState$jscomp$0, $c98c69161ea584a8$var$clientRenderScriptEnd);
                if (!JSCompiler_inline_result) {
                    request.destination = null;
                    i++;
                    clientRenderedBoundaries.splice(0, i);
                    return;
                }
            }
            clientRenderedBoundaries.splice(0, i);
            var completedBoundaries = request.completedBoundaries;
            for(i = 0; i < completedBoundaries.length; i++)if (!$c98c69161ea584a8$var$flushCompletedBoundary(request, destination, completedBoundaries[i])) {
                request.destination = null;
                i++;
                completedBoundaries.splice(0, i);
                return;
            }
            completedBoundaries.splice(0, i);
            $c98c69161ea584a8$var$completeWriting(destination);
            $c98c69161ea584a8$var$currentView = new Uint8Array(2048);
            $c98c69161ea584a8$var$writtenBytes = 0;
            var partialBoundaries = request.partialBoundaries;
            for(i = 0; i < partialBoundaries.length; i++){
                var boundary$51 = partialBoundaries[i];
                a: {
                    clientRenderedBoundaries = request;
                    boundary = destination;
                    var completedSegments = boundary$51.completedSegments;
                    for(JSCompiler_inline_result = 0; JSCompiler_inline_result < completedSegments.length; JSCompiler_inline_result++)if (!$c98c69161ea584a8$var$flushPartiallyCompletedSegment(clientRenderedBoundaries, boundary, boundary$51, completedSegments[JSCompiler_inline_result])) {
                        JSCompiler_inline_result++;
                        completedSegments.splice(0, JSCompiler_inline_result);
                        var JSCompiler_inline_result$jscomp$0 = !1;
                        break a;
                    }
                    completedSegments.splice(0, JSCompiler_inline_result);
                    JSCompiler_inline_result$jscomp$0 = $c98c69161ea584a8$var$writeHoistablesForBoundary(boundary, boundary$51.contentState, clientRenderedBoundaries.renderState);
                }
                if (!JSCompiler_inline_result$jscomp$0) {
                    request.destination = null;
                    i++;
                    partialBoundaries.splice(0, i);
                    return;
                }
            }
            partialBoundaries.splice(0, i);
            var largeBoundaries = request.completedBoundaries;
            for(i = 0; i < largeBoundaries.length; i++)if (!$c98c69161ea584a8$var$flushCompletedBoundary(request, destination, largeBoundaries[i])) {
                request.destination = null;
                i++;
                largeBoundaries.splice(0, i);
                return;
            }
            largeBoundaries.splice(0, i);
        }
    } finally{
        0 === request.allPendingTasks && 0 === request.pingedTasks.length && 0 === request.clientRenderedBoundaries.length && 0 === request.completedBoundaries.length ? (request.flushScheduled = !1, i = request.resumableState, i.hasBody && $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$endChunkForTag("body")), i.hasHtml && $c98c69161ea584a8$var$writeChunk(destination, $c98c69161ea584a8$var$endChunkForTag("html")), $c98c69161ea584a8$var$completeWriting(destination), request.status = 14, destination.close(), request.destination = null) : $c98c69161ea584a8$var$completeWriting(destination);
    }
}
function $c98c69161ea584a8$var$startWork(request) {
    request.flushScheduled = null !== request.destination;
    $c98c69161ea584a8$var$scheduleMicrotask(function() {
        return $c98c69161ea584a8$var$performWork(request);
    });
    $c98c69161ea584a8$var$scheduleWork(function() {
        10 === request.status && (request.status = 11);
        null === request.trackedPostpones && $c98c69161ea584a8$var$safelyEmitEarlyPreloads(request, 0 === request.pendingRootTasks);
    });
}
function $c98c69161ea584a8$var$enqueueFlush(request) {
    !1 === request.flushScheduled && 0 === request.pingedTasks.length && null !== request.destination && (request.flushScheduled = !0, $c98c69161ea584a8$var$scheduleWork(function() {
        var destination = request.destination;
        destination ? $c98c69161ea584a8$var$flushCompletedQueues(request, destination) : request.flushScheduled = !1;
    }));
}
function $c98c69161ea584a8$var$startFlowing(request, destination) {
    if (13 === request.status) request.status = 14, $c98c69161ea584a8$var$closeWithError(destination, request.fatalError);
    else if (14 !== request.status && null === request.destination) {
        request.destination = destination;
        try {
            $c98c69161ea584a8$var$flushCompletedQueues(request, destination);
        } catch (error) {
            $c98c69161ea584a8$var$logRecoverableError(request, error, {}), $c98c69161ea584a8$var$fatalError(request, error);
        }
    }
}
function $c98c69161ea584a8$var$abort(request, reason) {
    if (11 === request.status || 10 === request.status) request.status = 12;
    try {
        var abortableTasks = request.abortableTasks;
        if (0 < abortableTasks.size) {
            var error = void 0 === reason ? Error($c98c69161ea584a8$var$formatProdErrorMessage(432)) : "object" === typeof reason && null !== reason && "function" === typeof reason.then ? Error($c98c69161ea584a8$var$formatProdErrorMessage(530)) : reason;
            request.fatalError = error;
            abortableTasks.forEach(function(task) {
                return $c98c69161ea584a8$var$abortTask(task, request, error);
            });
            abortableTasks.clear();
        }
        null !== request.destination && $c98c69161ea584a8$var$flushCompletedQueues(request, request.destination);
    } catch (error$53) {
        $c98c69161ea584a8$var$logRecoverableError(request, error$53, {}), $c98c69161ea584a8$var$fatalError(request, error$53);
    }
}
function $c98c69161ea584a8$var$ensureCorrectIsomorphicReactVersion() {
    var isomorphicReactPackageVersion = $dNU7X.version;
    if ("19.1.1" !== isomorphicReactPackageVersion) throw Error($c98c69161ea584a8$var$formatProdErrorMessage(527, isomorphicReactPackageVersion, "19.1.1"));
}
$c98c69161ea584a8$var$ensureCorrectIsomorphicReactVersion();
$c98c69161ea584a8$var$ensureCorrectIsomorphicReactVersion();
$c98c69161ea584a8$export$4f10e897d13fb72b = function(children, options) {
    return new Promise(function(resolve, reject) {
        var onHeaders = options ? options.onHeaders : void 0, onHeadersImpl;
        onHeaders && (onHeadersImpl = function(headersDescriptor) {
            onHeaders(new Headers(headersDescriptor));
        });
        var resources = $c98c69161ea584a8$var$createResumableState(options ? options.identifierPrefix : void 0, options ? options.unstable_externalRuntimeSrc : void 0, options ? options.bootstrapScriptContent : void 0, options ? options.bootstrapScripts : void 0, options ? options.bootstrapModules : void 0), request = $c98c69161ea584a8$var$createPrerenderRequest(children, resources, $c98c69161ea584a8$var$createRenderState(resources, void 0, options ? options.unstable_externalRuntimeSrc : void 0, options ? options.importMap : void 0, onHeadersImpl, options ? options.maxHeadersLength : void 0), $c98c69161ea584a8$var$createRootFormatContext(options ? options.namespaceURI : void 0), options ? options.progressiveChunkSize : void 0, options ? options.onError : void 0, function() {
            var result = {
                prelude: new ReadableStream({
                    type: "bytes",
                    pull: function(controller) {
                        $c98c69161ea584a8$var$startFlowing(request, controller);
                    },
                    cancel: function(reason) {
                        request.destination = null;
                        $c98c69161ea584a8$var$abort(request, reason);
                    }
                }, {
                    highWaterMark: 0
                })
            };
            resolve(result);
        }, void 0, void 0, reject, options ? options.onPostpone : void 0);
        if (options && options.signal) {
            var signal = options.signal;
            if (signal.aborted) $c98c69161ea584a8$var$abort(request, signal.reason);
            else {
                var listener = function() {
                    $c98c69161ea584a8$var$abort(request, signal.reason);
                    signal.removeEventListener("abort", listener);
                };
                signal.addEventListener("abort", listener);
            }
        }
        $c98c69161ea584a8$var$startWork(request);
    });
};
$c98c69161ea584a8$export$7020a3240b287705 = function(children, options) {
    return new Promise(function(resolve, reject) {
        var onFatalError, onAllReady, allReady = new Promise(function(res, rej) {
            onAllReady = res;
            onFatalError = rej;
        }), onHeaders = options ? options.onHeaders : void 0, onHeadersImpl;
        onHeaders && (onHeadersImpl = function(headersDescriptor) {
            onHeaders(new Headers(headersDescriptor));
        });
        var resumableState = $c98c69161ea584a8$var$createResumableState(options ? options.identifierPrefix : void 0, options ? options.unstable_externalRuntimeSrc : void 0, options ? options.bootstrapScriptContent : void 0, options ? options.bootstrapScripts : void 0, options ? options.bootstrapModules : void 0), request = $c98c69161ea584a8$var$createRequest(children, resumableState, $c98c69161ea584a8$var$createRenderState(resumableState, options ? options.nonce : void 0, options ? options.unstable_externalRuntimeSrc : void 0, options ? options.importMap : void 0, onHeadersImpl, options ? options.maxHeadersLength : void 0), $c98c69161ea584a8$var$createRootFormatContext(options ? options.namespaceURI : void 0), options ? options.progressiveChunkSize : void 0, options ? options.onError : void 0, onAllReady, function() {
            var stream = new ReadableStream({
                type: "bytes",
                pull: function(controller) {
                    $c98c69161ea584a8$var$startFlowing(request, controller);
                },
                cancel: function(reason) {
                    request.destination = null;
                    $c98c69161ea584a8$var$abort(request, reason);
                }
            }, {
                highWaterMark: 0
            });
            stream.allReady = allReady;
            resolve(stream);
        }, function(error) {
            allReady.catch(function() {});
            reject(error);
        }, onFatalError, options ? options.onPostpone : void 0, options ? options.formState : void 0);
        if (options && options.signal) {
            var signal = options.signal;
            if (signal.aborted) $c98c69161ea584a8$var$abort(request, signal.reason);
            else {
                var listener = function() {
                    $c98c69161ea584a8$var$abort(request, signal.reason);
                    signal.removeEventListener("abort", listener);
                };
                signal.addEventListener("abort", listener);
            }
        }
        $c98c69161ea584a8$var$startWork(request);
    });
};
$c98c69161ea584a8$export$83d89fbfd8236492 = "19.1.1";

});

var $2111e08a92d70add$exports = {};
'use strict';

$2111e08a92d70add$exports = (parcelRequire("jpaef"));


var $e58ef2470199210d$exports = {};
var $e58ef2470199210d$var$$14c85ffeff1ab241$export$fad3c8302a7540c6, $e58ef2470199210d$var$$14c85ffeff1ab241$export$5f81b96ae5b0befd, $e58ef2470199210d$var$$14c85ffeff1ab241$export$1a22ace05a045e3f, $e58ef2470199210d$var$$14c85ffeff1ab241$export$c7aa240077ad8340, $e58ef2470199210d$var$$14c85ffeff1ab241$export$5add10f2a1e13991, $e58ef2470199210d$var$$4bfbcb67a3daf664$export$79ffe56a765070d2, $e58ef2470199210d$var$$4bfbcb67a3daf664$export$cddc5598d4bb8461, $e58ef2470199210d$var$$4bfbcb67a3daf664$export$73b7b5b52b6662d7, $e58ef2470199210d$var$$7d37db9df1578ff2$export$5c452ff88e35e47d, $e58ef2470199210d$var$$7d37db9df1578ff2$export$30d389775d7a0f3c, $e58ef2470199210d$var$$7d37db9df1578ff2$export$a8ff84c12d48cfa6, $e58ef2470199210d$var$$7d37db9df1578ff2$export$896c314ae37c4db9, $e58ef2470199210d$var$$7d37db9df1578ff2$export$717db1a952ac2d26, $e58ef2470199210d$var$$7d37db9df1578ff2$export$74fdf2685172213b, $e58ef2470199210d$var$$7d37db9df1578ff2$export$fb184b623420d9be, $e58ef2470199210d$var$$7d37db9df1578ff2$export$ec176431609ba4c9, $e58ef2470199210d$var$$7d37db9df1578ff2$export$ea7c3e02973c1d5b, $e58ef2470199210d$var$$c628d4ba96623bb8$export$1a22ace05a045e3f, $e58ef2470199210d$var$$c628d4ba96623bb8$export$c7aa240077ad8340;
var $44015290ab5c0623$export$71511d61b312f219;
"use strict";
var $d99f4a016ac4e7a1$export$71511d61b312f219;
"use strict";
function $d99f4a016ac4e7a1$var$_array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
$d99f4a016ac4e7a1$export$71511d61b312f219 = $d99f4a016ac4e7a1$var$_array_with_holes;


var $fbe5a6a7891777c2$export$71511d61b312f219;
"use strict";
function $fbe5a6a7891777c2$var$_iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
$fbe5a6a7891777c2$export$71511d61b312f219 = $fbe5a6a7891777c2$var$_iterable_to_array_limit;


var $fcf9c8c2e7d5c043$export$71511d61b312f219;
"use strict";
function $fcf9c8c2e7d5c043$var$_non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$fcf9c8c2e7d5c043$export$71511d61b312f219 = $fcf9c8c2e7d5c043$var$_non_iterable_rest;


var $ee22f18d51655989$export$71511d61b312f219;
"use strict";
var $f1f2a513a1d434f1$export$71511d61b312f219;
"use strict";
function $f1f2a513a1d434f1$var$_array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
$f1f2a513a1d434f1$export$71511d61b312f219 = $f1f2a513a1d434f1$var$_array_like_to_array;


function $ee22f18d51655989$var$_unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f1f2a513a1d434f1$export$71511d61b312f219(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f1f2a513a1d434f1$export$71511d61b312f219(o, minLen);
}
$ee22f18d51655989$export$71511d61b312f219 = $ee22f18d51655989$var$_unsupported_iterable_to_array;


function $44015290ab5c0623$var$_sliced_to_array(arr, i) {
    return $d99f4a016ac4e7a1$export$71511d61b312f219(arr) || $fbe5a6a7891777c2$export$71511d61b312f219(arr, i) || $ee22f18d51655989$export$71511d61b312f219(arr, i) || $fcf9c8c2e7d5c043$export$71511d61b312f219();
}
$44015290ab5c0623$export$71511d61b312f219 = $44015290ab5c0623$var$_sliced_to_array;


var $ca91dac30bd8a8fe$export$71511d61b312f219;
"use strict";
var $b120af89f9316587$export$71511d61b312f219;
"use strict";

function $b120af89f9316587$var$_array_without_holes(arr) {
    if (Array.isArray(arr)) return $f1f2a513a1d434f1$export$71511d61b312f219(arr);
}
$b120af89f9316587$export$71511d61b312f219 = $b120af89f9316587$var$_array_without_holes;


var $12645b8195910e7b$export$71511d61b312f219;
"use strict";
function $12645b8195910e7b$var$_iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
$12645b8195910e7b$export$71511d61b312f219 = $12645b8195910e7b$var$_iterable_to_array;


var $a0db71370622b2eb$export$71511d61b312f219;
"use strict";
function $a0db71370622b2eb$var$_non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$a0db71370622b2eb$export$71511d61b312f219 = $a0db71370622b2eb$var$_non_iterable_spread;



function $ca91dac30bd8a8fe$var$_to_consumable_array(arr) {
    return $b120af89f9316587$export$71511d61b312f219(arr) || $12645b8195910e7b$export$71511d61b312f219(arr) || $ee22f18d51655989$export$71511d61b312f219(arr) || $a0db71370622b2eb$export$71511d61b312f219();
}
$ca91dac30bd8a8fe$export$71511d61b312f219 = $ca91dac30bd8a8fe$var$_to_consumable_array;



var $852a55cf17d8b19d$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($852a55cf17d8b19d$exports) {
        classNames.default = classNames;
        $852a55cf17d8b19d$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


var $95518c9e748840bb$export$71511d61b312f219;
"use strict";
var $9ac8e64cff09d58e$export$71511d61b312f219;
"use strict";
function $9ac8e64cff09d58e$var$_get_prototype_of(o) {
    $9ac8e64cff09d58e$export$71511d61b312f219 = $9ac8e64cff09d58e$var$_get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9ac8e64cff09d58e$var$_get_prototype_of(o);
}
$9ac8e64cff09d58e$export$71511d61b312f219 = $9ac8e64cff09d58e$var$_get_prototype_of;


var $1f26b1989c741e87$export$71511d61b312f219;
"use strict";
function $1f26b1989c741e87$var$_is_native_reflect_construct() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($1f26b1989c741e87$export$71511d61b312f219 = $1f26b1989c741e87$var$_is_native_reflect_construct = function() {
        return !!result;
    })();
}
$1f26b1989c741e87$export$71511d61b312f219 = $1f26b1989c741e87$var$_is_native_reflect_construct;


var $0782f2494bcab272$export$71511d61b312f219;
"use strict";
var $548135c5314beecb$export$71511d61b312f219;
"use strict";
function $548135c5314beecb$var$_assert_this_initialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
$548135c5314beecb$export$71511d61b312f219 = $548135c5314beecb$var$_assert_this_initialized;


var $35f6c23f56aaf458$export$71511d61b312f219;
"use strict";
function $35f6c23f56aaf458$var$_type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
$35f6c23f56aaf458$export$71511d61b312f219 = $35f6c23f56aaf458$var$_type_of;


function $0782f2494bcab272$var$_possible_constructor_return(self, call) {
    if (call && ($35f6c23f56aaf458$export$71511d61b312f219(call) === "object" || typeof call === "function")) return call;
    return $548135c5314beecb$export$71511d61b312f219(self);
}
$0782f2494bcab272$export$71511d61b312f219 = $0782f2494bcab272$var$_possible_constructor_return;


function $95518c9e748840bb$var$_call_super(_this, derived, args) {
    // Super
    derived = $9ac8e64cff09d58e$export$71511d61b312f219(derived);
    return $0782f2494bcab272$export$71511d61b312f219(_this, $1f26b1989c741e87$export$71511d61b312f219() ? Reflect.construct(derived, args || [], $9ac8e64cff09d58e$export$71511d61b312f219(_this).constructor) : derived.apply(_this, args));
}
$95518c9e748840bb$export$71511d61b312f219 = $95518c9e748840bb$var$_call_super;


var $2b3af368dbb30b38$export$71511d61b312f219;
"use strict";
function $2b3af368dbb30b38$var$_class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
$2b3af368dbb30b38$export$71511d61b312f219 = $2b3af368dbb30b38$var$_class_call_check;


var $53cdca766716469e$export$71511d61b312f219;
"use strict";
function $53cdca766716469e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $53cdca766716469e$var$_create_class(Constructor, protoProps, staticProps) {
    if (protoProps) $53cdca766716469e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $53cdca766716469e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
$53cdca766716469e$export$71511d61b312f219 = $53cdca766716469e$var$_create_class;


var $92f5157d74f7ea45$export$71511d61b312f219;
"use strict";
var $0ef57a67a4dbd747$export$71511d61b312f219;
"use strict";
function $0ef57a67a4dbd747$var$_set_prototype_of(o, p) {
    $0ef57a67a4dbd747$export$71511d61b312f219 = $0ef57a67a4dbd747$var$_set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0ef57a67a4dbd747$var$_set_prototype_of(o, p);
}
$0ef57a67a4dbd747$export$71511d61b312f219 = $0ef57a67a4dbd747$var$_set_prototype_of;


function $92f5157d74f7ea45$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $0ef57a67a4dbd747$export$71511d61b312f219(subClass, superClass);
}
$92f5157d74f7ea45$export$71511d61b312f219 = $92f5157d74f7ea45$var$_inherits;



var $dNU7X = parcelRequire("dNU7X");
var $4799ffc520052701$exports = {};
/* **********************************************
     Begin prism-core.js
********************************************** */ /// <reference lib="WebWorker"/>
var $4799ffc520052701$var$_self = typeof window !== 'undefined' ? window // if in browser
 : typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope ? self // if in worker
 : {} // if in node js
;
/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */ var $4799ffc520052701$var$Prism = function(_self) {
    // Private helper vars
    var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
    var uniqueId = 0;
    // The grammar object for plaintext
    var plainTextGrammar = {};
    var _ = {
        /**
		 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
		 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
		 * additional languages or plugins yourself.
		 *
		 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
		 *
		 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.manual = true;
		 * // add a new <script> to load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ manual: _self.Prism && _self.Prism.manual,
        /**
		 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
		 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
		 * own worker, you don't want it to do this.
		 *
		 * By setting this value to `true`, Prism will not add its own listeners to the worker.
		 *
		 * You obviously have to change this value before Prism executes. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.disableWorkerMessageHandler = true;
		 * // Load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */ disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,
        /**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */ util: {
            encode: function encode(tokens) {
                if (tokens instanceof Token) return new Token(tokens.type, encode(tokens.content), tokens.alias);
                else if (Array.isArray(tokens)) return tokens.map(encode);
                else return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
            },
            /**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */ type: function(o) {
                return Object.prototype.toString.call(o).slice(8, -1);
            },
            /**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */ objId: function(obj) {
                if (!obj['__id']) Object.defineProperty(obj, '__id', {
                    value: ++uniqueId
                });
                return obj['__id'];
            },
            /**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */ clone: function deepClone(o, visited) {
                visited = visited || {};
                var clone;
                var id;
                switch(_.util.type(o)){
                    case 'Object':
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = /** @type {Record<string, any>} */ {};
                        visited[id] = clone;
                        for(var key in o)if (o.hasOwnProperty(key)) clone[key] = deepClone(o[key], visited);
                        return /** @type {any} */ clone;
                    case 'Array':
                        id = _.util.objId(o);
                        if (visited[id]) return visited[id];
                        clone = [];
                        visited[id] = clone;
                        /** @type {any} */ o.forEach(function(v, i) {
                            clone[i] = deepClone(v, visited);
                        });
                        return /** @type {any} */ clone;
                    default:
                        return o;
                }
            },
            /**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */ getLanguage: function(element) {
                while(element){
                    var m = lang.exec(element.className);
                    if (m) return m[1].toLowerCase();
                    element = element.parentElement;
                }
                return 'none';
            },
            /**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */ setLanguage: function(element, language) {
                // remove all `language-xxxx` classes
                // (this might leave behind a leading space)
                element.className = element.className.replace(RegExp(lang, 'gi'), '');
                // add the new `language-xxxx` class
                // (using `classList` will automatically clean up spaces for us)
                element.classList.add('language-' + language);
            },
            /**
			 * Returns the script element that is currently executing.
			 *
			 * This does __not__ work for line script element.
			 *
			 * @returns {HTMLScriptElement | null}
			 */ currentScript: function() {
                if (typeof document === 'undefined') return null;
                if (document.currentScript && document.currentScript.tagName === 'SCRIPT' && true /* hack to trip TS' flow analysis */ ) return /** @type {any} */ document.currentScript;
                // IE11 workaround
                // we'll get the src of the current script by parsing IE11's error stack trace
                // this will not work for inline scripts
                try {
                    throw new Error();
                } catch (err) {
                    // Get file src url from stack. Specifically works with the format of stack traces in IE.
                    // A stack will look like this:
                    //
                    // Error
                    //    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
                    //    at Global code (http://localhost/components/prism-core.js:606:1)
                    var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
                    if (src) {
                        var scripts = document.getElementsByTagName('script');
                        for(var i in scripts){
                            if (scripts[i].src == src) return scripts[i];
                        }
                    }
                    return null;
                }
            },
            /**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */ isActive: function(element, className, defaultActivation) {
                var no = 'no-' + className;
                while(element){
                    var classList = element.classList;
                    if (classList.contains(className)) return true;
                    if (classList.contains(no)) return false;
                    element = element.parentElement;
                }
                return !!defaultActivation;
            }
        },
        /**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ languages: {
            /**
			 * The grammar for plain, unformatted text.
			 */ plain: plainTextGrammar,
            plaintext: plainTextGrammar,
            text: plainTextGrammar,
            txt: plainTextGrammar,
            /**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */ extend: function(id, redef) {
                var lang = _.util.clone(_.languages[id]);
                for(var key in redef)lang[key] = redef[key];
                return lang;
            },
            /**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */ insertBefore: function(inside, before, insert, root) {
                root = root || /** @type {any} */ _.languages;
                var grammar = root[inside];
                /** @type {Grammar} */ var ret = {};
                for(var token in grammar)if (grammar.hasOwnProperty(token)) {
                    if (token == before) {
                        for(var newToken in insert)if (insert.hasOwnProperty(newToken)) ret[newToken] = insert[newToken];
                    }
                    // Do not insert token which also occur in insert. See #1525
                    if (!insert.hasOwnProperty(token)) ret[token] = grammar[token];
                }
                var old = root[inside];
                root[inside] = ret;
                // Update references in other language definitions
                _.languages.DFS(_.languages, function(key, value) {
                    if (value === old && key != inside) this[key] = ret;
                });
                return ret;
            },
            // Traverse a language definition with Depth First Search
            DFS: function DFS(o, callback, type, visited) {
                visited = visited || {};
                var objId = _.util.objId;
                for(var i in o)if (o.hasOwnProperty(i)) {
                    callback.call(o, i, o[i], type || i);
                    var property = o[i];
                    var propertyType = _.util.type(property);
                    if (propertyType === 'Object' && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, null, visited);
                    } else if (propertyType === 'Array' && !visited[objId(property)]) {
                        visited[objId(property)] = true;
                        DFS(property, callback, i, visited);
                    }
                }
            }
        },
        plugins: {},
        /**
		 * This is the most high-level function in Prism’s API.
		 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
		 * each one of them.
		 *
		 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
		 *
		 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
		 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
		 * @memberof Prism
		 * @public
		 */ highlightAll: function(async, callback) {
            _.highlightAllUnder(document, async, callback);
        },
        /**
		 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
		 * {@link Prism.highlightElement} on each one of them.
		 *
		 * The following hooks will be run:
		 * 1. `before-highlightall`
		 * 2. `before-all-elements-highlight`
		 * 3. All hooks of {@link Prism.highlightElement} for each element.
		 *
		 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
		 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
		 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
		 * @memberof Prism
		 * @public
		 */ highlightAllUnder: function(container, async, callback) {
            var env = {
                callback: callback,
                container: container,
                selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
            };
            _.hooks.run('before-highlightall', env);
            env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));
            _.hooks.run('before-all-elements-highlight', env);
            for(var i = 0, element; element = env.elements[i++];)_.highlightElement(element, async === true, env.callback);
        },
        /**
		 * Highlights the code inside a single element.
		 *
		 * The following hooks will be run:
		 * 1. `before-sanity-check`
		 * 2. `before-highlight`
		 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
		 * 4. `before-insert`
		 * 5. `after-highlight`
		 * 6. `complete`
		 *
		 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
		 * the element's language.
		 *
		 * @param {Element} element The element containing the code.
		 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
		 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
		 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
		 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
		 *
		 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
		 * asynchronous highlighting to work. You can build your own bundle on the
		 * [Download page](https://prismjs.com/download.html).
		 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
		 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
		 * @memberof Prism
		 * @public
		 */ highlightElement: function(element, async, callback) {
            // Find language
            var language = _.util.getLanguage(element);
            var grammar = _.languages[language];
            // Set language on the element, if not present
            _.util.setLanguage(element, language);
            // Set language on the parent, for styling
            var parent = element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === 'pre') _.util.setLanguage(parent, language);
            var code = element.textContent;
            var env = {
                element: element,
                language: language,
                grammar: grammar,
                code: code
            };
            function insertHighlightedCode(highlightedCode) {
                env.highlightedCode = highlightedCode;
                _.hooks.run('before-insert', env);
                env.element.innerHTML = env.highlightedCode;
                _.hooks.run('after-highlight', env);
                _.hooks.run('complete', env);
                callback && callback.call(env.element);
            }
            _.hooks.run('before-sanity-check', env);
            // plugins may change/add the parent/element
            parent = env.element.parentElement;
            if (parent && parent.nodeName.toLowerCase() === 'pre' && !parent.hasAttribute('tabindex')) parent.setAttribute('tabindex', '0');
            if (!env.code) {
                _.hooks.run('complete', env);
                callback && callback.call(env.element);
                return;
            }
            _.hooks.run('before-highlight', env);
            if (!env.grammar) {
                insertHighlightedCode(_.util.encode(env.code));
                return;
            }
            if (async && _self.Worker) {
                var worker = new Worker(_.filename);
                worker.onmessage = function(evt) {
                    insertHighlightedCode(evt.data);
                };
                worker.postMessage(JSON.stringify({
                    language: env.language,
                    code: env.code,
                    immediateClose: true
                }));
            } else insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
        },
        /**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */ highlight: function(text, grammar, language) {
            var env = {
                code: text,
                grammar: grammar,
                language: language
            };
            _.hooks.run('before-tokenize', env);
            if (!env.grammar) throw new Error('The language "' + env.language + '" has no grammar.');
            env.tokens = _.tokenize(env.code, env.grammar);
            _.hooks.run('after-tokenize', env);
            return Token.stringify(_.util.encode(env.tokens), env.language);
        },
        /**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */ tokenize: function(text, grammar) {
            var rest = grammar.rest;
            if (rest) {
                for(var token in rest)grammar[token] = rest[token];
                delete grammar.rest;
            }
            var tokenList = new LinkedList();
            addAfter(tokenList, tokenList.head, text);
            matchGrammar(text, tokenList, grammar, tokenList.head, 0);
            return toArray(tokenList);
        },
        /**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */ hooks: {
            all: {},
            /**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */ add: function(name, callback) {
                var hooks = _.hooks.all;
                hooks[name] = hooks[name] || [];
                hooks[name].push(callback);
            },
            /**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */ run: function(name, env) {
                var callbacks = _.hooks.all[name];
                if (!callbacks || !callbacks.length) return;
                for(var i = 0, callback; callback = callbacks[i++];)callback(env);
            }
        },
        Token: Token
    };
    _self.Prism = _;
    // Typescript note:
    // The following can be used to import the Token type in JSDoc:
    //
    //   @typedef {InstanceType<import("./prism-core")["Token"]>} Token
    /**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */ function Token(type, content, alias, matchedStr) {
        /**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */ this.type = type;
        /**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */ this.content = content;
        /**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */ this.alias = alias;
        // Copy of the full string this token was created from
        this.length = (matchedStr || '').length | 0;
    }
    /**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */ /**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */ Token.stringify = function stringify(o, language) {
        if (typeof o == 'string') return o;
        if (Array.isArray(o)) {
            var s = '';
            o.forEach(function(e) {
                s += stringify(e, language);
            });
            return s;
        }
        var env = {
            type: o.type,
            content: stringify(o.content, language),
            tag: 'span',
            classes: [
                'token',
                o.type
            ],
            attributes: {},
            language: language
        };
        var aliases = o.alias;
        if (aliases) {
            if (Array.isArray(aliases)) Array.prototype.push.apply(env.classes, aliases);
            else env.classes.push(aliases);
        }
        _.hooks.run('wrap', env);
        var attributes = '';
        for(var name in env.attributes)attributes += ' ' + name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
        return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + attributes + '>' + env.content + '</' + env.tag + '>';
    };
    /**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */ function matchPattern(pattern, pos, text, lookbehind) {
        pattern.lastIndex = pos;
        var match = pattern.exec(text);
        if (match && lookbehind && match[1]) {
            // change the match to remove the text matched by the Prism lookbehind group
            var lookbehindLength = match[1].length;
            match.index += lookbehindLength;
            match[0] = match[0].slice(lookbehindLength);
        }
        return match;
    }
    /**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */ function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
        for(var token in grammar){
            if (!grammar.hasOwnProperty(token) || !grammar[token]) continue;
            var patterns = grammar[token];
            patterns = Array.isArray(patterns) ? patterns : [
                patterns
            ];
            for(var j = 0; j < patterns.length; ++j){
                if (rematch && rematch.cause == token + ',' + j) return;
                var patternObj = patterns[j];
                var inside = patternObj.inside;
                var lookbehind = !!patternObj.lookbehind;
                var greedy = !!patternObj.greedy;
                var alias = patternObj.alias;
                if (greedy && !patternObj.pattern.global) {
                    // Without the global flag, lastIndex won't work
                    var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
                    patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
                }
                /** @type {RegExp} */ var pattern = patternObj.pattern || patternObj;
                for(var currentNode = startNode.next, pos = startPos; currentNode !== tokenList.tail; pos += currentNode.value.length, currentNode = currentNode.next){
                    if (rematch && pos >= rematch.reach) break;
                    var str = currentNode.value;
                    if (tokenList.length > text.length) // Something went terribly wrong, ABORT, ABORT!
                    return;
                    if (str instanceof Token) continue;
                    var removeCount = 1; // this is the to parameter of removeBetween
                    var match;
                    if (greedy) {
                        match = matchPattern(pattern, pos, text, lookbehind);
                        if (!match || match.index >= text.length) break;
                        var from = match.index;
                        var to = match.index + match[0].length;
                        var p = pos;
                        // find the node that contains the match
                        p += currentNode.value.length;
                        while(from >= p){
                            currentNode = currentNode.next;
                            p += currentNode.value.length;
                        }
                        // adjust pos (and p)
                        p -= currentNode.value.length;
                        pos = p;
                        // the current node is a Token, then the match starts inside another Token, which is invalid
                        if (currentNode.value instanceof Token) continue;
                        // find the last node which is affected by this match
                        for(var k = currentNode; k !== tokenList.tail && (p < to || typeof k.value === 'string'); k = k.next){
                            removeCount++;
                            p += k.value.length;
                        }
                        removeCount--;
                        // replace with the new match
                        str = text.slice(pos, p);
                        match.index -= pos;
                    } else {
                        match = matchPattern(pattern, 0, str, lookbehind);
                        if (!match) continue;
                    }
                    // eslint-disable-next-line no-redeclare
                    var from = match.index;
                    var matchStr = match[0];
                    var before = str.slice(0, from);
                    var after = str.slice(from + matchStr.length);
                    var reach = pos + str.length;
                    if (rematch && reach > rematch.reach) rematch.reach = reach;
                    var removeFrom = currentNode.prev;
                    if (before) {
                        removeFrom = addAfter(tokenList, removeFrom, before);
                        pos += before.length;
                    }
                    removeRange(tokenList, removeFrom, removeCount);
                    var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
                    currentNode = addAfter(tokenList, removeFrom, wrapped);
                    if (after) addAfter(tokenList, currentNode, after);
                    if (removeCount > 1) {
                        // at least one Token object was removed, so we have to do some rematching
                        // this can only happen if the current pattern is greedy
                        /** @type {RematchOptions} */ var nestedRematch = {
                            cause: token + ',' + j,
                            reach: reach
                        };
                        matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);
                        // the reach might have been extended because of the rematching
                        if (rematch && nestedRematch.reach > rematch.reach) rematch.reach = nestedRematch.reach;
                    }
                }
            }
        }
    }
    /**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */ /**
	 * @template T
	 * @private
	 */ function LinkedList() {
        /** @type {LinkedListNode<T>} */ var head = {
            value: null,
            prev: null,
            next: null
        };
        /** @type {LinkedListNode<T>} */ var tail = {
            value: null,
            prev: head,
            next: null
        };
        head.next = tail;
        /** @type {LinkedListNode<T>} */ this.head = head;
        /** @type {LinkedListNode<T>} */ this.tail = tail;
        this.length = 0;
    }
    /**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */ function addAfter(list, node, value) {
        // assumes that node != list.tail && values.length >= 0
        var next = node.next;
        var newNode = {
            value: value,
            prev: node,
            next: next
        };
        node.next = newNode;
        next.prev = newNode;
        list.length++;
        return newNode;
    }
    /**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */ function removeRange(list, node, count) {
        var next = node.next;
        for(var i = 0; i < count && next !== list.tail; i++)next = next.next;
        node.next = next;
        next.prev = node;
        list.length -= i;
    }
    /**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */ function toArray(list) {
        var array = [];
        var node = list.head.next;
        while(node !== list.tail){
            array.push(node.value);
            node = node.next;
        }
        return array;
    }
    if (!_self.document) {
        if (!_self.addEventListener) // in Node.js
        return _;
        if (!_.disableWorkerMessageHandler) // In worker
        _self.addEventListener('message', function(evt) {
            var message = JSON.parse(evt.data);
            var lang = message.language;
            var code = message.code;
            var immediateClose = message.immediateClose;
            _self.postMessage(_.highlight(code, _.languages[lang], lang));
            if (immediateClose) _self.close();
        }, false);
        return _;
    }
    // Get current script and highlight
    var script = _.util.currentScript();
    if (script) {
        _.filename = script.src;
        if (script.hasAttribute('data-manual')) _.manual = true;
    }
    function highlightAutomaticallyCallback() {
        if (!_.manual) _.highlightAll();
    }
    if (!_.manual) {
        // If the document state is "loading", then we'll use DOMContentLoaded.
        // If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
        // DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
        // might take longer one animation frame to execute which can create a race condition where only some plugins have
        // been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
        // See https://github.com/PrismJS/prism/issues/2102
        var readyState = document.readyState;
        if (readyState === 'loading' || readyState === 'interactive' && script && script.defer) document.addEventListener('DOMContentLoaded', highlightAutomaticallyCallback);
        else if (window.requestAnimationFrame) window.requestAnimationFrame(highlightAutomaticallyCallback);
        else window.setTimeout(highlightAutomaticallyCallback, 16);
    }
    return _;
}($4799ffc520052701$var$_self);
if ($4799ffc520052701$exports) $4799ffc520052701$exports = $4799ffc520052701$var$Prism;
// hack for components to work correctly in node.js
if (typeof $parcel$global !== 'undefined') $parcel$global.Prism = $4799ffc520052701$var$Prism;
// some additional documentation/types
/**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */ /**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */ /**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */ /**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */ /* **********************************************
     Begin prism-markup.js
********************************************** */ $4799ffc520052701$var$Prism.languages.markup = {
    'comment': {
        pattern: /<!--(?:(?!<!--)[\s\S])*?-->/,
        greedy: true
    },
    'prolog': {
        pattern: /<\?[\s\S]+?\?>/,
        greedy: true
    },
    'doctype': {
        // https://www.w3.org/TR/xml/#NT-doctypedecl
        pattern: /<!DOCTYPE(?:[^>"'[\]]|"[^"]*"|'[^']*')+(?:\[(?:[^<"'\]]|"[^"]*"|'[^']*'|<(?!!--)|<!--(?:[^-]|-(?!->))*-->)*\]\s*)?>/i,
        greedy: true,
        inside: {
            'internal-subset': {
                pattern: /(^[^\[]*\[)[\s\S]+(?=\]>$)/,
                lookbehind: true,
                greedy: true,
                inside: null // see below
            },
            'string': {
                pattern: /"[^"]*"|'[^']*'/,
                greedy: true
            },
            'punctuation': /^<!|>$|[[\]]/,
            'doctype-tag': /^DOCTYPE/i,
            'name': /[^\s<>'"]+/
        }
    },
    'cdata': {
        pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
        greedy: true
    },
    'tag': {
        pattern: /<\/?(?!\d)[^\s>\/=$<%]+(?:\s(?:\s*[^\s>\/=]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))|(?=[\s/>])))+)?\s*\/?>/,
        greedy: true,
        inside: {
            'tag': {
                pattern: /^<\/?[^\s>\/]+/,
                inside: {
                    'punctuation': /^<\/?/,
                    'namespace': /^[^\s>\/:]+:/
                }
            },
            'special-attr': [],
            'attr-value': {
                pattern: /=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+)/,
                inside: {
                    'punctuation': [
                        {
                            pattern: /^=/,
                            alias: 'attr-equals'
                        },
                        {
                            pattern: /^(\s*)["']|["']$/,
                            lookbehind: true
                        }
                    ]
                }
            },
            'punctuation': /\/?>/,
            'attr-name': {
                pattern: /[^\s>\/]+/,
                inside: {
                    'namespace': /^[^\s>\/:]+:/
                }
            }
        }
    },
    'entity': [
        {
            pattern: /&[\da-z]{1,8};/i,
            alias: 'named-entity'
        },
        /&#x?[\da-f]{1,8};/i
    ]
};
$4799ffc520052701$var$Prism.languages.markup['tag'].inside['attr-value'].inside['entity'] = $4799ffc520052701$var$Prism.languages.markup['entity'];
$4799ffc520052701$var$Prism.languages.markup['doctype'].inside['internal-subset'].inside = $4799ffc520052701$var$Prism.languages.markup;
// Plugin to make entity title show the real entity, idea by Roman Komarov
$4799ffc520052701$var$Prism.hooks.add('wrap', function(env) {
    if (env.type === 'entity') env.attributes['title'] = env.content.replace(/&amp;/, '&');
});
Object.defineProperty($4799ffc520052701$var$Prism.languages.markup.tag, 'addInlined', {
    /**
	 * Adds an inlined language to markup.
	 *
	 * An example of an inlined language is CSS with `<style>` tags.
	 *
	 * @param {string} tagName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addInlined('style', 'css');
	 */ value: function addInlined(tagName, lang) {
        var includedCdataInside = {};
        includedCdataInside['language-' + lang] = {
            pattern: /(^<!\[CDATA\[)[\s\S]+?(?=\]\]>$)/i,
            lookbehind: true,
            inside: $4799ffc520052701$var$Prism.languages[lang]
        };
        includedCdataInside['cdata'] = /^<!\[CDATA\[|\]\]>$/i;
        var inside = {
            'included-cdata': {
                pattern: /<!\[CDATA\[[\s\S]*?\]\]>/i,
                inside: includedCdataInside
            }
        };
        inside['language-' + lang] = {
            pattern: /[\s\S]+/,
            inside: $4799ffc520052701$var$Prism.languages[lang]
        };
        var def = {};
        def[tagName] = {
            pattern: RegExp(/(<__[^>]*>)(?:<!\[CDATA\[(?:[^\]]|\](?!\]>))*\]\]>|(?!<!\[CDATA\[)[\s\S])*?(?=<\/__>)/.source.replace(/__/g, function() {
                return tagName;
            }), 'i'),
            lookbehind: true,
            greedy: true,
            inside: inside
        };
        $4799ffc520052701$var$Prism.languages.insertBefore('markup', 'cdata', def);
    }
});
Object.defineProperty($4799ffc520052701$var$Prism.languages.markup.tag, 'addAttribute', {
    /**
	 * Adds an pattern to highlight languages embedded in HTML attributes.
	 *
	 * An example of an inlined language is CSS with `style` attributes.
	 *
	 * @param {string} attrName The name of the tag that contains the inlined language. This name will be treated as
	 * case insensitive.
	 * @param {string} lang The language key.
	 * @example
	 * addAttribute('style', 'css');
	 */ value: function(attrName, lang) {
        $4799ffc520052701$var$Prism.languages.markup.tag.inside['special-attr'].push({
            pattern: RegExp(/(^|["'\s])/.source + '(?:' + attrName + ')' + /\s*=\s*(?:"[^"]*"|'[^']*'|[^\s'">=]+(?=[\s>]))/.source, 'i'),
            lookbehind: true,
            inside: {
                'attr-name': /^[^\s=]+/,
                'attr-value': {
                    pattern: /=[\s\S]+/,
                    inside: {
                        'value': {
                            pattern: /(^=\s*(["']|(?!["'])))\S[\s\S]*(?=\2$)/,
                            lookbehind: true,
                            alias: [
                                lang,
                                'language-' + lang
                            ],
                            inside: $4799ffc520052701$var$Prism.languages[lang]
                        },
                        'punctuation': [
                            {
                                pattern: /^=/,
                                alias: 'attr-equals'
                            },
                            /"|'/
                        ]
                    }
                }
            }
        });
    }
});
$4799ffc520052701$var$Prism.languages.html = $4799ffc520052701$var$Prism.languages.markup;
$4799ffc520052701$var$Prism.languages.mathml = $4799ffc520052701$var$Prism.languages.markup;
$4799ffc520052701$var$Prism.languages.svg = $4799ffc520052701$var$Prism.languages.markup;
$4799ffc520052701$var$Prism.languages.xml = $4799ffc520052701$var$Prism.languages.extend('markup', {});
$4799ffc520052701$var$Prism.languages.ssml = $4799ffc520052701$var$Prism.languages.xml;
$4799ffc520052701$var$Prism.languages.atom = $4799ffc520052701$var$Prism.languages.xml;
$4799ffc520052701$var$Prism.languages.rss = $4799ffc520052701$var$Prism.languages.xml;
/* **********************************************
     Begin prism-css.js
********************************************** */ (function(Prism) {
    var string = /(?:"(?:\\(?:\r\n|[\s\S])|[^"\\\r\n])*"|'(?:\\(?:\r\n|[\s\S])|[^'\\\r\n])*')/;
    Prism.languages.css = {
        'comment': /\/\*[\s\S]*?\*\//,
        'atrule': {
            pattern: RegExp('@[\\w-](?:' + /[^;{\s"']|\s+(?!\s)/.source + '|' + string.source + ')*?' + /(?:;|(?=\s*\{))/.source),
            inside: {
                'rule': /^@[\w-]+/,
                'selector-function-argument': {
                    pattern: /(\bselector\s*\(\s*(?![\s)]))(?:[^()\s]|\s+(?![\s)])|\((?:[^()]|\([^()]*\))*\))+(?=\s*\))/,
                    lookbehind: true,
                    alias: 'selector'
                },
                'keyword': {
                    pattern: /(^|[^\w-])(?:and|not|only|or)(?![\w-])/,
                    lookbehind: true
                }
            }
        },
        'url': {
            // https://drafts.csswg.org/css-values-3/#urls
            pattern: RegExp('\\burl\\((?:' + string.source + '|' + /(?:[^\\\r\n()"']|\\[\s\S])*/.source + ')\\)', 'i'),
            greedy: true,
            inside: {
                'function': /^url/i,
                'punctuation': /^\(|\)$/,
                'string': {
                    pattern: RegExp('^' + string.source + '$'),
                    alias: 'url'
                }
            }
        },
        'selector': {
            pattern: RegExp('(^|[{}\\s])[^{}\\s](?:[^{};"\'\\s]|\\s+(?![\\s{])|' + string.source + ')*(?=\\s*\\{)'),
            lookbehind: true
        },
        'string': {
            pattern: string,
            greedy: true
        },
        'property': {
            pattern: /(^|[^-\w\xA0-\uFFFF])(?!\s)[-_a-z\xA0-\uFFFF](?:(?!\s)[-\w\xA0-\uFFFF])*(?=\s*:)/i,
            lookbehind: true
        },
        'important': /!important\b/i,
        'function': {
            pattern: /(^|[^-a-z0-9])[-a-z0-9]+(?=\()/i,
            lookbehind: true
        },
        'punctuation': /[(){};:,]/
    };
    Prism.languages.css['atrule'].inside.rest = Prism.languages.css;
    var markup = Prism.languages.markup;
    if (markup) {
        markup.tag.addInlined('style', 'css');
        markup.tag.addAttribute('style', 'css');
    }
})($4799ffc520052701$var$Prism);
/* **********************************************
     Begin prism-clike.js
********************************************** */ $4799ffc520052701$var$Prism.languages.clike = {
    'comment': [
        {
            pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
            lookbehind: true,
            greedy: true
        },
        {
            pattern: /(^|[^\\:])\/\/.*/,
            lookbehind: true,
            greedy: true
        }
    ],
    'string': {
        pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
        greedy: true
    },
    'class-name': {
        pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
        lookbehind: true,
        inside: {
            'punctuation': /[.\\]/
        }
    },
    'keyword': /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
    'boolean': /\b(?:false|true)\b/,
    'function': /\b\w+(?=\()/,
    'number': /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
    'operator': /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
    'punctuation': /[{}[\];(),.:]/
};
/* **********************************************
     Begin prism-javascript.js
********************************************** */ $4799ffc520052701$var$Prism.languages.javascript = $4799ffc520052701$var$Prism.languages.extend('clike', {
    'class-name': [
        $4799ffc520052701$var$Prism.languages.clike['class-name'],
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
            lookbehind: true
        }
    ],
    'keyword': [
        {
            pattern: /((?:^|\})\s*)catch\b/,
            lookbehind: true
        },
        {
            pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
            lookbehind: true
        }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    'function': /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    'number': {
        pattern: RegExp(/(^|[^\w$])/.source + '(?:' + // constant
        (/NaN|Infinity/.source + '|' + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + '|' + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + '|' + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + '|' + // decimal bigint
        /\d+(?:_\d+)*n/.source + '|' + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ')' + /(?![\w$])/.source),
        lookbehind: true
    },
    'operator': /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});
$4799ffc520052701$var$Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
$4799ffc520052701$var$Prism.languages.insertBefore('javascript', 'keyword', {
    'regex': {
        pattern: RegExp(// lookbehind
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
        // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
        // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
        // with the only syntax, so we have to define 2 different regex patterns.
        /\//.source + '(?:' + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + '|' + // `v` flag syntax. This supports 3 levels of nested character classes.
        /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ')' + // lookahead
        /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
        lookbehind: true,
        greedy: true,
        inside: {
            'regex-source': {
                pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                lookbehind: true,
                alias: 'language-regex',
                inside: $4799ffc520052701$var$Prism.languages.regex
            },
            'regex-delimiter': /^\/|\/$/,
            'regex-flags': /^[a-z]+$/
        }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    'function-variable': {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: 'function'
    },
    'parameter': [
        {
            pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
            lookbehind: true,
            inside: $4799ffc520052701$var$Prism.languages.javascript
        },
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
            lookbehind: true,
            inside: $4799ffc520052701$var$Prism.languages.javascript
        },
        {
            pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
            lookbehind: true,
            inside: $4799ffc520052701$var$Prism.languages.javascript
        },
        {
            pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
            lookbehind: true,
            inside: $4799ffc520052701$var$Prism.languages.javascript
        }
    ],
    'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});
$4799ffc520052701$var$Prism.languages.insertBefore('javascript', 'string', {
    'hashbang': {
        pattern: /^#!.*/,
        greedy: true,
        alias: 'comment'
    },
    'template-string': {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: true,
        inside: {
            'template-punctuation': {
                pattern: /^`|`$/,
                alias: 'string'
            },
            'interpolation': {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                lookbehind: true,
                inside: {
                    'interpolation-punctuation': {
                        pattern: /^\$\{|\}$/,
                        alias: 'punctuation'
                    },
                    rest: $4799ffc520052701$var$Prism.languages.javascript
                }
            },
            'string': /[\s\S]+/
        }
    },
    'string-property': {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: true,
        greedy: true,
        alias: 'property'
    }
});
$4799ffc520052701$var$Prism.languages.insertBefore('javascript', 'operator', {
    'literal-property': {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: true,
        alias: 'property'
    }
});
if ($4799ffc520052701$var$Prism.languages.markup) {
    $4799ffc520052701$var$Prism.languages.markup.tag.addInlined('script', 'javascript');
    // add attribute support for all DOM events.
    // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
    $4799ffc520052701$var$Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, 'javascript');
}
$4799ffc520052701$var$Prism.languages.js = $4799ffc520052701$var$Prism.languages.javascript;
/* **********************************************
     Begin prism-file-highlight.js
********************************************** */ (function() {
    if (typeof $4799ffc520052701$var$Prism === 'undefined' || typeof document === 'undefined') return;
    // https://developer.mozilla.org/en-US/docs/Web/API/Element/matches#Polyfill
    if (!Element.prototype.matches) Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
    var LOADING_MESSAGE = "Loading\u2026";
    var FAILURE_MESSAGE = function(status, message) {
        return "\u2716 Error " + status + ' while fetching file: ' + message;
    };
    var FAILURE_EMPTY_MESSAGE = "\u2716 Error: File does not exist or is empty";
    var EXTENSIONS = {
        'js': 'javascript',
        'py': 'python',
        'rb': 'ruby',
        'ps1': 'powershell',
        'psm1': 'powershell',
        'sh': 'bash',
        'bat': 'batch',
        'h': 'c',
        'tex': 'latex'
    };
    var STATUS_ATTR = 'data-src-status';
    var STATUS_LOADING = 'loading';
    var STATUS_LOADED = 'loaded';
    var STATUS_FAILED = 'failed';
    var SELECTOR = 'pre[data-src]:not([' + STATUS_ATTR + '="' + STATUS_LOADED + '"])' + ':not([' + STATUS_ATTR + '="' + STATUS_LOADING + '"])';
    /**
	 * Loads the given file.
	 *
	 * @param {string} src The URL or path of the source file to load.
	 * @param {(result: string) => void} success
	 * @param {(reason: string) => void} error
	 */ function loadFile(src, success, error) {
        var xhr = new XMLHttpRequest();
        xhr.open('GET', src, true);
        xhr.onreadystatechange = function() {
            if (xhr.readyState == 4) {
                if (xhr.status < 400 && xhr.responseText) success(xhr.responseText);
                else if (xhr.status >= 400) error(FAILURE_MESSAGE(xhr.status, xhr.statusText));
                else error(FAILURE_EMPTY_MESSAGE);
            }
        };
        xhr.send(null);
    }
    /**
	 * Parses the given range.
	 *
	 * This returns a range with inclusive ends.
	 *
	 * @param {string | null | undefined} range
	 * @returns {[number, number | undefined] | undefined}
	 */ function parseRange(range) {
        var m = /^\s*(\d+)\s*(?:(,)\s*(?:(\d+)\s*)?)?$/.exec(range || '');
        if (m) {
            var start = Number(m[1]);
            var comma = m[2];
            var end = m[3];
            if (!comma) return [
                start,
                start
            ];
            if (!end) return [
                start,
                undefined
            ];
            return [
                start,
                Number(end)
            ];
        }
        return undefined;
    }
    $4799ffc520052701$var$Prism.hooks.add('before-highlightall', function(env) {
        env.selector += ', ' + SELECTOR;
    });
    $4799ffc520052701$var$Prism.hooks.add('before-sanity-check', function(env) {
        var pre = /** @type {HTMLPreElement} */ env.element;
        if (pre.matches(SELECTOR)) {
            env.code = ''; // fast-path the whole thing and go to complete
            pre.setAttribute(STATUS_ATTR, STATUS_LOADING); // mark as loading
            // add code element with loading message
            var code = pre.appendChild(document.createElement('CODE'));
            code.textContent = LOADING_MESSAGE;
            var src = pre.getAttribute('data-src');
            var language = env.language;
            if (language === 'none') {
                // the language might be 'none' because there is no language set;
                // in this case, we want to use the extension as the language
                var extension = (/\.(\w+)$/.exec(src) || [
                    ,
                    'none'
                ])[1];
                language = EXTENSIONS[extension] || extension;
            }
            // set language classes
            $4799ffc520052701$var$Prism.util.setLanguage(code, language);
            $4799ffc520052701$var$Prism.util.setLanguage(pre, language);
            // preload the language
            var autoloader = $4799ffc520052701$var$Prism.plugins.autoloader;
            if (autoloader) autoloader.loadLanguages(language);
            // load file
            loadFile(src, function(text) {
                // mark as loaded
                pre.setAttribute(STATUS_ATTR, STATUS_LOADED);
                // handle data-range
                var range = parseRange(pre.getAttribute('data-range'));
                if (range) {
                    var lines = text.split(/\r\n?|\n/g);
                    // the range is one-based and inclusive on both ends
                    var start = range[0];
                    var end = range[1] == null ? lines.length : range[1];
                    if (start < 0) start += lines.length;
                    start = Math.max(0, Math.min(start - 1, lines.length));
                    if (end < 0) end += lines.length;
                    end = Math.max(0, Math.min(end, lines.length));
                    text = lines.slice(start, end).join('\n');
                    // add data-start for line numbers
                    if (!pre.hasAttribute('data-start')) pre.setAttribute('data-start', String(start + 1));
                }
                // highlight code
                code.textContent = text;
                $4799ffc520052701$var$Prism.highlightElement(code);
            }, function(error) {
                // mark as failed
                pre.setAttribute(STATUS_ATTR, STATUS_FAILED);
                code.textContent = error;
            });
        }
    });
    $4799ffc520052701$var$Prism.plugins.fileHighlight = {
        /**
		 * Executes the File Highlight plugin for all matching `pre` elements under the given container.
		 *
		 * Note: Elements which are already loaded or currently loading will not be touched by this method.
		 *
		 * @param {ParentNode} [container=document]
		 */ highlight: function highlight(container) {
            var elements = (container || document).querySelectorAll(SELECTOR);
            for(var i = 0, element; element = elements[i++];)$4799ffc520052701$var$Prism.highlightElement(element);
        }
    };
    var logged = false;
    /** @deprecated Use `Prism.plugins.fileHighlight.highlight` instead. */ $4799ffc520052701$var$Prism.fileHighlight = function() {
        if (!logged) {
            console.warn('Prism.fileHighlight is deprecated. Use `Prism.plugins.fileHighlight.highlight` instead.');
            logged = true;
        }
        $4799ffc520052701$var$Prism.plugins.fileHighlight.highlight.apply(this, arguments);
    };
})();


var $946384cc26da4067$exports = {};
'use strict';
Object.defineProperty($946384cc26da4067$exports, '__esModule', {
    value: true
});
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */ function $cdeacdf23b3f7c65$var$isObject(o) {
    return Object.prototype.toString.call(o) === '[object Object]';
}
function $cdeacdf23b3f7c65$export$53b83ca8eaab0383(o) {
    var ctor, prot;
    if ($cdeacdf23b3f7c65$var$isObject(o) === false) return false;
    // If has modified constructor
    ctor = o.constructor;
    if (ctor === undefined) return true;
    // If has modified prototype
    prot = ctor.prototype;
    if ($cdeacdf23b3f7c65$var$isObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (prot.hasOwnProperty('isPrototypeOf') === false) return false;
    // Most likely a plain Object
    return true;
}



var $dNU7X = parcelRequire("dNU7X");
var $7d8d2177dae91fdf$exports = {};
"use strict";
var $7d8d2177dae91fdf$var$__assign = $7d8d2177dae91fdf$exports && $7d8d2177dae91fdf$exports.__assign || function() {
    $7d8d2177dae91fdf$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7d8d2177dae91fdf$var$__assign.apply(this, arguments);
};
var $7d8d2177dae91fdf$var$__spreadArray = $7d8d2177dae91fdf$exports && $7d8d2177dae91fdf$exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty($7d8d2177dae91fdf$exports, "__esModule", {
    value: true
});
$7d8d2177dae91fdf$exports.prettyPrint = void 0;
var $7d8d2177dae91fdf$var$seen = [];
/**
 * Check if a value is an object or a function. Keep in mind that array, function, regexp, etc, are objects in JavaScript.
 *
 * @param value the value to check
 * @return true if the value is an object or a function
 */ function $7d8d2177dae91fdf$var$isObj(value) {
    var type = typeof value;
    return value !== null && (type === 'object' || type === 'function');
}
/**
 * Check if a value is a regular expression.
 *
 * @param value the value to check
 * @return true if the value is a regular expression
 */ function $7d8d2177dae91fdf$var$isRegexp(value) {
    return Object.prototype.toString.call(value) === '[object RegExp]';
}
/**
 * Get an array of all of the enumerable symbols for an object.
 *
 * @param object the object to get the enumerable symbols for
 */ function $7d8d2177dae91fdf$var$getOwnEnumPropSymbols(object) {
    return Object.getOwnPropertySymbols(object).filter(function(keySymbol) {
        return Object.prototype.propertyIsEnumerable.call(object, keySymbol);
    });
}
/**
 * pretty print an object
 *
 * @param input the object to pretty print
 * @param options the formatting options, transforms, and filters
 * @param pad the padding string
 */ function $7d8d2177dae91fdf$var$prettyPrint(input, options, pad) {
    if (pad === void 0) pad = '';
    // sensible option defaults
    var defaultOptions = {
        indent: '\t',
        singleQuotes: true
    };
    var combinedOptions = $7d8d2177dae91fdf$var$__assign($7d8d2177dae91fdf$var$__assign({}, defaultOptions), options);
    var tokens;
    if (combinedOptions.inlineCharacterLimit === undefined) tokens = {
        newLine: '\n',
        newLineOrSpace: '\n',
        pad: pad,
        indent: pad + combinedOptions.indent
    };
    else tokens = {
        newLine: '@@__PRETTY_PRINT_NEW_LINE__@@',
        newLineOrSpace: '@@__PRETTY_PRINT_NEW_LINE_OR_SPACE__@@',
        pad: '@@__PRETTY_PRINT_PAD__@@',
        indent: '@@__PRETTY_PRINT_INDENT__@@'
    };
    var expandWhiteSpace = function(string) {
        if (combinedOptions.inlineCharacterLimit === undefined) return string;
        var oneLined = string.replace(new RegExp(tokens.newLine, 'g'), '').replace(new RegExp(tokens.newLineOrSpace, 'g'), ' ').replace(new RegExp(tokens.pad + '|' + tokens.indent, 'g'), '');
        if (oneLined.length <= combinedOptions.inlineCharacterLimit) return oneLined;
        return string.replace(new RegExp(tokens.newLine + '|' + tokens.newLineOrSpace, 'g'), '\n').replace(new RegExp(tokens.pad, 'g'), pad).replace(new RegExp(tokens.indent, 'g'), pad + combinedOptions.indent);
    };
    if ($7d8d2177dae91fdf$var$seen.indexOf(input) !== -1) return '"[Circular]"';
    if (input === null || input === undefined || typeof input === 'number' || typeof input === 'boolean' || typeof input === 'function' || typeof input === 'symbol' || $7d8d2177dae91fdf$var$isRegexp(input)) return String(input);
    if (input instanceof Date) return "new Date('".concat(input.toISOString(), "')");
    if (Array.isArray(input)) {
        if (input.length === 0) return '[]';
        $7d8d2177dae91fdf$var$seen.push(input);
        var ret = '[' + tokens.newLine + input.map(function(el, i) {
            var eol = input.length - 1 === i ? tokens.newLine : ',' + tokens.newLineOrSpace;
            var value = $7d8d2177dae91fdf$var$prettyPrint(el, combinedOptions, pad + combinedOptions.indent);
            if (combinedOptions.transform) value = combinedOptions.transform(input, i, value);
            return tokens.indent + value + eol;
        }).join('') + tokens.pad + ']';
        $7d8d2177dae91fdf$var$seen.pop();
        return expandWhiteSpace(ret);
    }
    if ($7d8d2177dae91fdf$var$isObj(input)) {
        var objKeys_1 = $7d8d2177dae91fdf$var$__spreadArray($7d8d2177dae91fdf$var$__spreadArray([], Object.keys(input), true), $7d8d2177dae91fdf$var$getOwnEnumPropSymbols(input), true);
        if (combinedOptions.filter) objKeys_1 = objKeys_1.filter(function(el) {
            return combinedOptions.filter && combinedOptions.filter(input, el);
        });
        if (objKeys_1.length === 0) return '{}';
        $7d8d2177dae91fdf$var$seen.push(input);
        var ret = '{' + tokens.newLine + objKeys_1.map(function(el, i) {
            var eol = objKeys_1.length - 1 === i ? tokens.newLine : ',' + tokens.newLineOrSpace;
            var isSymbol = typeof el === 'symbol';
            var isClassic = !isSymbol && /^[a-z$_][a-z$_0-9]*$/i.test(el.toString());
            var key = isSymbol || isClassic ? el : $7d8d2177dae91fdf$var$prettyPrint(el, combinedOptions);
            var value = $7d8d2177dae91fdf$var$prettyPrint(input[el], combinedOptions, pad + combinedOptions.indent);
            if (combinedOptions.transform) value = combinedOptions.transform(input, el, value);
            return tokens.indent + String(key) + ': ' + value + eol;
        }).join('') + tokens.pad + '}';
        $7d8d2177dae91fdf$var$seen.pop();
        return expandWhiteSpace(ret);
    }
    input = String(input).replace(/[\r\n]/g, function(x) {
        return x === '\n' ? '\\n' : '\\r';
    });
    if (!combinedOptions.singleQuotes) {
        input = input.replace(/"/g, '\\"');
        return "\"".concat(input, "\"");
    }
    input = input.replace(/\\?'/g, '\\\'');
    return "'".concat(input, "'");
}
$7d8d2177dae91fdf$exports.prettyPrint = $7d8d2177dae91fdf$var$prettyPrint;


var $6df612c424d59fc3$exports = {};
'use strict';

$6df612c424d59fc3$exports = (parcelRequire("dhnve"));


function $946384cc26da4067$var$_interopDefaultLegacy(e) {
    return e && typeof e === 'object' && 'default' in e ? e : {
        'default': e
    };
}
function $946384cc26da4067$var$_interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) Object.keys(e).forEach(function(k) {
        if (k !== 'default') {
            var d = Object.getOwnPropertyDescriptor(e, k);
            Object.defineProperty(n, k, d.get ? d : {
                enumerable: true,
                get: function() {
                    return e[k];
                }
            });
        }
    });
    n["default"] = e;
    return Object.freeze(n);
}
var $946384cc26da4067$var$React__namespace = /*#__PURE__*/ $946384cc26da4067$var$_interopNamespace($dNU7X);
var $946384cc26da4067$var$React__default = /*#__PURE__*/ $946384cc26da4067$var$_interopDefaultLegacy($dNU7X);
var $946384cc26da4067$var$spacer = function(times, tabStop) {
    if (times === 0) return '';
    return new Array(times * tabStop).fill(' ').join('');
};
function $946384cc26da4067$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $946384cc26da4067$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $946384cc26da4067$var$_arrayLikeToArray(r);
}
function $946384cc26da4067$var$_defineProperty(e, r, t) {
    return (r = $946384cc26da4067$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $946384cc26da4067$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $946384cc26da4067$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $946384cc26da4067$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $946384cc26da4067$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $946384cc26da4067$var$ownKeys(Object(t), !0).forEach(function(r) {
            $946384cc26da4067$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $946384cc26da4067$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $946384cc26da4067$var$_toConsumableArray(r) {
    return $946384cc26da4067$var$_arrayWithoutHoles(r) || $946384cc26da4067$var$_iterableToArray(r) || $946384cc26da4067$var$_unsupportedIterableToArray(r) || $946384cc26da4067$var$_nonIterableSpread();
}
function $946384cc26da4067$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $946384cc26da4067$var$_toPropertyKey(t) {
    var i = $946384cc26da4067$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $946384cc26da4067$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $946384cc26da4067$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $946384cc26da4067$var$_typeof(o);
}
function $946384cc26da4067$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $946384cc26da4067$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $946384cc26da4067$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $946384cc26da4067$var$safeSortObject(value, seen) {
    // return non-object value as is
    if (value === null || $946384cc26da4067$var$_typeof(value) !== 'object') return value;
    // return date and regexp values as is
    if (value instanceof Date || value instanceof RegExp) return value;
    // return react element as is but remove _owner key because it can lead to recursion
    if (/*#__PURE__*/ $946384cc26da4067$var$React__namespace.isValidElement(value)) {
        var copyObj = $946384cc26da4067$var$_objectSpread2({}, value);
        delete copyObj._owner;
        return copyObj;
    }
    seen.add(value);
    // make a copy of array with each item passed through the sorting algorithm
    if (Array.isArray(value)) return value.map(function(v) {
        return $946384cc26da4067$var$safeSortObject(v, seen);
    });
    // make a copy of object with key sorted
    return Object.keys(value).sort().reduce(function(result, key) {
        if (key === 'current' || seen.has(value[key])) // eslint-disable-next-line no-param-reassign
        result[key] = '[Circular]';
        else // eslint-disable-next-line no-param-reassign
        result[key] = $946384cc26da4067$var$safeSortObject(value[key], seen);
        return result;
    }, {});
}
function $946384cc26da4067$var$sortObject(value) {
    return $946384cc26da4067$var$safeSortObject(value, new WeakSet());
}
/* eslint-disable no-use-before-define */ var $946384cc26da4067$var$createStringTreeNode = function createStringTreeNode(value) {
    return {
        type: 'string',
        value: value
    };
};
var $946384cc26da4067$var$createNumberTreeNode = function createNumberTreeNode(value) {
    return {
        type: 'number',
        value: value
    };
};
var $946384cc26da4067$var$createReactElementTreeNode = function createReactElementTreeNode(displayName, props, defaultProps, childrens) {
    return {
        type: 'ReactElement',
        displayName: displayName,
        props: props,
        defaultProps: defaultProps,
        childrens: childrens
    };
};
var $946384cc26da4067$var$createReactFragmentTreeNode = function createReactFragmentTreeNode(key, childrens) {
    return {
        type: 'ReactFragment',
        key: key,
        childrens: childrens
    };
};
var $946384cc26da4067$var$supportFragment = Boolean($dNU7X.Fragment);
var $946384cc26da4067$var$getFunctionTypeName = function getFunctionTypeName(functionType) {
    if (!functionType.name || functionType.name === '_default') return 'No Display Name';
    return functionType.name;
};
var $946384cc26da4067$var$_getWrappedComponentDisplayName = function getWrappedComponentDisplayName(Component) {
    switch(true){
        case Boolean(Component.displayName):
            return Component.displayName;
        case Component.$$typeof === $6df612c424d59fc3$exports.Memo:
            return $946384cc26da4067$var$_getWrappedComponentDisplayName(Component.type);
        case Component.$$typeof === $6df612c424d59fc3$exports.ForwardRef:
            return $946384cc26da4067$var$_getWrappedComponentDisplayName(Component.render);
        default:
            return $946384cc26da4067$var$getFunctionTypeName(Component);
    }
};
// heavily inspired by:
// https://github.com/facebook/react/blob/3746eaf985dd92f8aa5f5658941d07b6b855e9d9/packages/react-devtools-shared/src/backend/renderer.js#L399-L496
var $946384cc26da4067$var$getReactElementDisplayName = function getReactElementDisplayName(element) {
    switch(true){
        case typeof element.type === 'string':
            return element.type;
        case typeof element.type === 'function':
            if (element.type.displayName) return element.type.displayName;
            return $946384cc26da4067$var$getFunctionTypeName(element.type);
        case $6df612c424d59fc3$exports.isForwardRef(element):
        case $6df612c424d59fc3$exports.isMemo(element):
            return $946384cc26da4067$var$_getWrappedComponentDisplayName(element.type);
        case $6df612c424d59fc3$exports.isContextConsumer(element):
            return "".concat(element.type._context.displayName || 'Context', ".Consumer");
        case $6df612c424d59fc3$exports.isContextProvider(element):
            return "".concat(element.type.displayName || 'Context', ".Provider");
        case $6df612c424d59fc3$exports.isLazy(element):
            return 'Lazy';
        case $6df612c424d59fc3$exports.isProfiler(element):
            return 'Profiler';
        case $6df612c424d59fc3$exports.isStrictMode(element):
            return 'StrictMode';
        case $6df612c424d59fc3$exports.isSuspense(element):
            return 'Suspense';
        default:
            return 'UnknownElementType';
    }
};
var $946384cc26da4067$var$noChildren = function noChildren(propsValue, propName) {
    return propName !== 'children';
};
var $946384cc26da4067$var$onlyMeaningfulChildren = function onlyMeaningfulChildren(children) {
    return children !== true && children !== false && children !== null && children !== '';
};
var $946384cc26da4067$var$filterProps = function filterProps(originalProps, cb) {
    var filteredProps = {};
    Object.keys(originalProps).filter(function(key) {
        return cb(originalProps[key], key);
    }).forEach(function(key) {
        return filteredProps[key] = originalProps[key];
    });
    return filteredProps;
};
var $946384cc26da4067$var$_parseReactElement = function parseReactElement(element, options) {
    var _options$displayName = options.displayName, displayNameFn = _options$displayName === void 0 ? $946384cc26da4067$var$getReactElementDisplayName : _options$displayName;
    if (typeof element === 'string') return $946384cc26da4067$var$createStringTreeNode(element);
    else if (typeof element === 'number') return $946384cc26da4067$var$createNumberTreeNode(element);
    else if (!/*#__PURE__*/ $946384cc26da4067$var$React__default["default"].isValidElement(element)) throw new Error("react-element-to-jsx-string: Expected a React.Element, got `".concat($946384cc26da4067$var$_typeof(element), "`"));
    var displayName = displayNameFn(element);
    var props = $946384cc26da4067$var$filterProps(element.props, $946384cc26da4067$var$noChildren);
    var key = element.key;
    if (typeof key === 'string' && key.search(/^\./)) // React automatically add key=".X" when there are some children
    props.key = key;
    var defaultProps = $946384cc26da4067$var$filterProps(element.type.defaultProps || {}, $946384cc26da4067$var$noChildren);
    var childrens = $946384cc26da4067$var$React__default["default"].Children.toArray(element.props.children).filter($946384cc26da4067$var$onlyMeaningfulChildren).map(function(child) {
        return $946384cc26da4067$var$_parseReactElement(child, options);
    });
    if ($946384cc26da4067$var$supportFragment && element.type === $dNU7X.Fragment) return $946384cc26da4067$var$createReactFragmentTreeNode(key, childrens);
    return $946384cc26da4067$var$createReactElementTreeNode(displayName, props, defaultProps, childrens);
};
function $946384cc26da4067$var$noRefCheck() {}
var $946384cc26da4067$var$inlineFunction = function inlineFunction(fn) {
    return fn.toString().split('\n').map(function(line) {
        return line.trim();
    }).join('');
};
var $946384cc26da4067$var$preserveFunctionLineBreak = function preserveFunctionLineBreak(fn) {
    return fn.toString();
};
var $946384cc26da4067$var$defaultFunctionValue = $946384cc26da4067$var$inlineFunction;
var $946384cc26da4067$var$formatFunction = function(fn, options) {
    var _options$functionValu = options.functionValue, functionValue = _options$functionValu === void 0 ? $946384cc26da4067$var$defaultFunctionValue : _options$functionValu, showFunctions = options.showFunctions;
    if (!showFunctions && functionValue === $946384cc26da4067$var$defaultFunctionValue) return functionValue($946384cc26da4067$var$noRefCheck);
    return functionValue(fn);
};
var $946384cc26da4067$var$formatComplexDataStructure = function(value, inline, lvl, options) {
    var normalizedValue = $946384cc26da4067$var$sortObject(value);
    var stringifiedValue = $7d8d2177dae91fdf$exports.prettyPrint(normalizedValue, {
        transform: function transform(currentObj, prop, originalResult) {
            var currentValue = currentObj[prop];
            if (currentValue && /*#__PURE__*/ $dNU7X.isValidElement(currentValue)) return $946384cc26da4067$var$formatTreeNode($946384cc26da4067$var$_parseReactElement(currentValue, options), true, lvl, options);
            if (typeof currentValue === 'function') return $946384cc26da4067$var$formatFunction(currentValue, options);
            return originalResult;
        }
    });
    if (inline) return stringifiedValue.replace(/\s+/g, ' ').replace(/{ /g, '{').replace(/ }/g, '}').replace(/\[ /g, '[').replace(/ ]/g, ']');
    // Replace tabs with spaces, and add necessary indentation in front of each new line
    return stringifiedValue.replace(/\t/g, $946384cc26da4067$var$spacer(1, options.tabStop)).replace(/\n([^$])/g, "\n".concat($946384cc26da4067$var$spacer(lvl + 1, options.tabStop), "$1"));
};
var $946384cc26da4067$var$escape$1 = function escape(s) {
    return s.replace(/"/g, '&quot;');
};
var $946384cc26da4067$var$formatPropValue = function formatPropValue(propValue, inline, lvl, options) {
    if (typeof propValue === 'number') return "{".concat(String(propValue), "}");
    if (typeof propValue === 'string') return "\"".concat($946384cc26da4067$var$escape$1(propValue), "\"");
    // > "Symbols (new in ECMAScript 2015, not yet supported in Flow)"
    // @see: https://flow.org/en/docs/types/primitives/
    // $FlowFixMe: Flow does not support Symbol
    if ($946384cc26da4067$var$_typeof(propValue) === 'symbol') {
        var symbolDescription = propValue.valueOf().toString().replace(/Symbol\((.*)\)/, '$1');
        if (!symbolDescription) return "{Symbol()}";
        return "{Symbol('".concat(symbolDescription, "')}");
    }
    if (typeof propValue === 'function') return "{".concat($946384cc26da4067$var$formatFunction(propValue, options), "}");
    if (/*#__PURE__*/ $dNU7X.isValidElement(propValue)) return "{".concat($946384cc26da4067$var$formatTreeNode($946384cc26da4067$var$_parseReactElement(propValue, options), true, lvl, options), "}");
    if (propValue instanceof Date) {
        if (isNaN(propValue.valueOf())) return "{new Date(NaN)}";
        return "{new Date(\"".concat(propValue.toISOString(), "\")}");
    }
    if ($cdeacdf23b3f7c65$export$53b83ca8eaab0383(propValue) || Array.isArray(propValue)) return "{".concat($946384cc26da4067$var$formatComplexDataStructure(propValue, inline, lvl, options), "}");
    return "{".concat(String(propValue), "}");
};
var $946384cc26da4067$var$formatProp = function(name, hasValue, value, hasDefaultValue, defaultValue, inline, lvl, options) {
    if (!hasValue && !hasDefaultValue) throw new Error("The prop \"".concat(name, "\" has no value and no default: could not be formatted"));
    var usedValue = hasValue ? value : defaultValue;
    var useBooleanShorthandSyntax = options.useBooleanShorthandSyntax, tabStop = options.tabStop;
    var formattedPropValue = $946384cc26da4067$var$formatPropValue(usedValue, inline, lvl, options);
    var attributeFormattedInline = ' ';
    var attributeFormattedMultiline = "\n".concat($946384cc26da4067$var$spacer(lvl + 1, tabStop));
    var isMultilineAttribute = formattedPropValue.includes('\n');
    if (useBooleanShorthandSyntax && formattedPropValue === '{false}' && !hasDefaultValue) {
        // If a boolean is false and not different from it's default, we do not render the attribute
        attributeFormattedInline = '';
        attributeFormattedMultiline = '';
    } else if (useBooleanShorthandSyntax && formattedPropValue === '{true}') {
        attributeFormattedInline += "".concat(name);
        attributeFormattedMultiline += "".concat(name);
    } else {
        attributeFormattedInline += "".concat(name, "=").concat(formattedPropValue);
        attributeFormattedMultiline += "".concat(name, "=").concat(formattedPropValue);
    }
    return {
        attributeFormattedInline: attributeFormattedInline,
        attributeFormattedMultiline: attributeFormattedMultiline,
        isMultilineAttribute: isMultilineAttribute
    };
};
var $946384cc26da4067$var$mergeSiblingPlainStringChildrenReducer = function(previousNodes, currentNode) {
    var nodes = previousNodes.slice(0, previousNodes.length > 0 ? previousNodes.length - 1 : 0);
    var previousNode = previousNodes[previousNodes.length - 1];
    if (previousNode && (currentNode.type === 'string' || currentNode.type === 'number') && (previousNode.type === 'string' || previousNode.type === 'number')) nodes.push($946384cc26da4067$var$createStringTreeNode(String(previousNode.value) + String(currentNode.value)));
    else {
        if (previousNode) nodes.push(previousNode);
        nodes.push(currentNode);
    }
    return nodes;
};
var $946384cc26da4067$var$isKeyOrRefProps = function isKeyOrRefProps(propName) {
    return [
        'key',
        'ref'
    ].includes(propName);
};
var $946384cc26da4067$var$sortPropsByNames = function(shouldSortUserProps) {
    return function(props) {
        var haveKeyProp = props.includes('key');
        var haveRefProp = props.includes('ref');
        var userPropsOnly = props.filter(function(oneProp) {
            return !$946384cc26da4067$var$isKeyOrRefProps(oneProp);
        });
        var sortedProps = shouldSortUserProps ? $946384cc26da4067$var$_toConsumableArray(userPropsOnly.sort()) // We use basic lexical order
         : $946384cc26da4067$var$_toConsumableArray(userPropsOnly);
        if (haveRefProp) sortedProps.unshift('ref');
        if (haveKeyProp) sortedProps.unshift('key');
        return sortedProps;
    };
};
function $946384cc26da4067$var$createPropFilter(props, filter) {
    if (Array.isArray(filter)) return function(key) {
        return filter.indexOf(key) === -1;
    };
    else return function(key) {
        return filter(props[key], key);
    };
}
var $946384cc26da4067$var$compensateMultilineStringElementIndentation = function compensateMultilineStringElementIndentation(element, formattedElement, inline, lvl, options) {
    var tabStop = options.tabStop;
    if (element.type === 'string') return formattedElement.split('\n').map(function(line, offset) {
        if (offset === 0) return line;
        return "".concat($946384cc26da4067$var$spacer(lvl, tabStop)).concat(line);
    }).join('\n');
    return formattedElement;
};
var $946384cc26da4067$var$formatOneChildren = function formatOneChildren(inline, lvl, options) {
    return function(element) {
        return $946384cc26da4067$var$compensateMultilineStringElementIndentation(element, $946384cc26da4067$var$formatTreeNode(element, inline, lvl, options), inline, lvl, options);
    };
};
var $946384cc26da4067$var$onlyPropsWithOriginalValue = function onlyPropsWithOriginalValue(defaultProps, props) {
    return function(propName) {
        var haveDefaultValue = Object.keys(defaultProps).includes(propName);
        return !haveDefaultValue || haveDefaultValue && defaultProps[propName] !== props[propName];
    };
};
var $946384cc26da4067$var$isInlineAttributeTooLong = function isInlineAttributeTooLong(attributes, inlineAttributeString, lvl, tabStop, maxInlineAttributesLineLength) {
    if (!maxInlineAttributesLineLength) return attributes.length > 1;
    return $946384cc26da4067$var$spacer(lvl, tabStop).length + inlineAttributeString.length > maxInlineAttributesLineLength;
};
var $946384cc26da4067$var$shouldRenderMultilineAttr = function shouldRenderMultilineAttr(attributes, inlineAttributeString, containsMultilineAttr, inline, lvl, tabStop, maxInlineAttributesLineLength) {
    return ($946384cc26da4067$var$isInlineAttributeTooLong(attributes, inlineAttributeString, lvl, tabStop, maxInlineAttributesLineLength) || containsMultilineAttr) && !inline;
};
var $946384cc26da4067$var$formatReactElementNode = function(node, inline, lvl, options) {
    var type = node.type, _node$displayName = node.displayName, displayName = _node$displayName === void 0 ? '' : _node$displayName, childrens = node.childrens, _node$props = node.props, props = _node$props === void 0 ? {} : _node$props, _node$defaultProps = node.defaultProps, defaultProps = _node$defaultProps === void 0 ? {} : _node$defaultProps;
    if (type !== 'ReactElement') throw new Error("The \"formatReactElementNode\" function could only format node of type \"ReactElement\". Given:  ".concat(type));
    var filterProps = options.filterProps, maxInlineAttributesLineLength = options.maxInlineAttributesLineLength, showDefaultProps = options.showDefaultProps, sortProps = options.sortProps, tabStop = options.tabStop;
    var out = "<".concat(displayName);
    var outInlineAttr = out;
    var outMultilineAttr = out;
    var containsMultilineAttr = false;
    var visibleAttributeNames = [];
    var propFilter = $946384cc26da4067$var$createPropFilter(props, filterProps);
    Object.keys(props).filter(propFilter).filter($946384cc26da4067$var$onlyPropsWithOriginalValue(defaultProps, props)).forEach(function(propName) {
        return visibleAttributeNames.push(propName);
    });
    Object.keys(defaultProps).filter(propFilter).filter(function() {
        return showDefaultProps;
    }).filter(function(defaultPropName) {
        return !visibleAttributeNames.includes(defaultPropName);
    }).forEach(function(defaultPropName) {
        return visibleAttributeNames.push(defaultPropName);
    });
    var attributes = $946384cc26da4067$var$sortPropsByNames(sortProps)(visibleAttributeNames);
    attributes.forEach(function(attributeName) {
        var _formatProp = $946384cc26da4067$var$formatProp(attributeName, Object.keys(props).includes(attributeName), props[attributeName], Object.keys(defaultProps).includes(attributeName), defaultProps[attributeName], inline, lvl, options), attributeFormattedInline = _formatProp.attributeFormattedInline, attributeFormattedMultiline = _formatProp.attributeFormattedMultiline, isMultilineAttribute = _formatProp.isMultilineAttribute;
        if (isMultilineAttribute) containsMultilineAttr = true;
        outInlineAttr += attributeFormattedInline;
        outMultilineAttr += attributeFormattedMultiline;
    });
    outMultilineAttr += "\n".concat($946384cc26da4067$var$spacer(lvl, tabStop));
    if ($946384cc26da4067$var$shouldRenderMultilineAttr(attributes, outInlineAttr, containsMultilineAttr, inline, lvl, tabStop, maxInlineAttributesLineLength)) out = outMultilineAttr;
    else out = outInlineAttr;
    if (childrens && childrens.length > 0) {
        var newLvl = lvl + 1;
        out += '>';
        if (!inline) {
            out += '\n';
            out += $946384cc26da4067$var$spacer(newLvl, tabStop);
        }
        out += childrens.reduce($946384cc26da4067$var$mergeSiblingPlainStringChildrenReducer, []).map($946384cc26da4067$var$formatOneChildren(inline, newLvl, options)).join(!inline ? "\n".concat($946384cc26da4067$var$spacer(newLvl, tabStop)) : '');
        if (!inline) {
            out += '\n';
            out += $946384cc26da4067$var$spacer(newLvl - 1, tabStop);
        }
        out += "</".concat(displayName, ">");
    } else {
        if (!$946384cc26da4067$var$isInlineAttributeTooLong(attributes, outInlineAttr, lvl, tabStop, maxInlineAttributesLineLength)) out += ' ';
        out += '/>';
    }
    return out;
};
var $946384cc26da4067$var$REACT_FRAGMENT_TAG_NAME_SHORT_SYNTAX = '';
var $946384cc26da4067$var$REACT_FRAGMENT_TAG_NAME_EXPLICIT_SYNTAX = 'React.Fragment';
var $946384cc26da4067$var$toReactElementTreeNode = function toReactElementTreeNode(displayName, key, childrens) {
    var props = {};
    if (key) props = {
        key: key
    };
    return {
        type: 'ReactElement',
        displayName: displayName,
        props: props,
        defaultProps: {},
        childrens: childrens
    };
};
var $946384cc26da4067$var$isKeyedFragment = function isKeyedFragment(_ref) {
    var key = _ref.key;
    return Boolean(key);
};
var $946384cc26da4067$var$hasNoChildren = function hasNoChildren(_ref2) {
    var childrens = _ref2.childrens;
    return childrens.length === 0;
};
var $946384cc26da4067$var$formatReactFragmentNode = function(node, inline, lvl, options) {
    var type = node.type, key = node.key, childrens = node.childrens;
    if (type !== 'ReactFragment') throw new Error("The \"formatReactFragmentNode\" function could only format node of type \"ReactFragment\". Given: ".concat(type));
    var useFragmentShortSyntax = options.useFragmentShortSyntax;
    var displayName;
    if (useFragmentShortSyntax) {
        if ($946384cc26da4067$var$hasNoChildren(node) || $946384cc26da4067$var$isKeyedFragment(node)) displayName = $946384cc26da4067$var$REACT_FRAGMENT_TAG_NAME_EXPLICIT_SYNTAX;
        else displayName = $946384cc26da4067$var$REACT_FRAGMENT_TAG_NAME_SHORT_SYNTAX;
    } else displayName = $946384cc26da4067$var$REACT_FRAGMENT_TAG_NAME_EXPLICIT_SYNTAX;
    return $946384cc26da4067$var$formatReactElementNode($946384cc26da4067$var$toReactElementTreeNode(displayName, key, childrens), inline, lvl, options);
};
var $946384cc26da4067$var$jsxStopChars = [
    '<',
    '>',
    '{',
    '}'
];
var $946384cc26da4067$var$shouldBeEscaped = function shouldBeEscaped(s) {
    return $946384cc26da4067$var$jsxStopChars.some(function(jsxStopChar) {
        return s.includes(jsxStopChar);
    });
};
var $946384cc26da4067$var$escape = function escape(s) {
    if (!$946384cc26da4067$var$shouldBeEscaped(s)) return s;
    return "{`".concat(s, "`}");
};
var $946384cc26da4067$var$preserveTrailingSpace = function preserveTrailingSpace(s) {
    var result = s;
    if (result.endsWith(' ')) result = result.replace(/^(.*?)(\s+)$/, "$1{'$2'}");
    if (result.startsWith(' ')) result = result.replace(/^(\s+)(.*)$/, "{'$1'}$2");
    return result;
};
var $946384cc26da4067$var$formatTreeNode = function(node, inline, lvl, options) {
    if (node.type === 'number') return String(node.value);
    if (node.type === 'string') return node.value ? "".concat($946384cc26da4067$var$preserveTrailingSpace($946384cc26da4067$var$escape(String(node.value)))) : '';
    if (node.type === 'ReactElement') return $946384cc26da4067$var$formatReactElementNode(node, inline, lvl, options);
    if (node.type === 'ReactFragment') return $946384cc26da4067$var$formatReactFragmentNode(node, inline, lvl, options);
    throw new TypeError("Unknow format type \"".concat(node.type, "\""));
};
var $946384cc26da4067$var$formatTree = function(node, options) {
    return $946384cc26da4067$var$formatTreeNode(node, false, 0, options);
};
var $946384cc26da4067$var$reactElementToJsxString = function reactElementToJsxString(element) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref$filterProps = _ref.filterProps, filterProps = _ref$filterProps === void 0 ? [] : _ref$filterProps, _ref$showDefaultProps = _ref.showDefaultProps, showDefaultProps = _ref$showDefaultProps === void 0 ? true : _ref$showDefaultProps, _ref$showFunctions = _ref.showFunctions, showFunctions = _ref$showFunctions === void 0 ? false : _ref$showFunctions, functionValue = _ref.functionValue, _ref$tabStop = _ref.tabStop, tabStop = _ref$tabStop === void 0 ? 2 : _ref$tabStop, _ref$useBooleanShorth = _ref.useBooleanShorthandSyntax, useBooleanShorthandSyntax = _ref$useBooleanShorth === void 0 ? true : _ref$useBooleanShorth, _ref$useFragmentShort = _ref.useFragmentShortSyntax, useFragmentShortSyntax = _ref$useFragmentShort === void 0 ? true : _ref$useFragmentShort, _ref$sortProps = _ref.sortProps, sortProps = _ref$sortProps === void 0 ? true : _ref$sortProps, maxInlineAttributesLineLength = _ref.maxInlineAttributesLineLength, displayName = _ref.displayName;
    if (!element) throw new Error('react-element-to-jsx-string: Expected a ReactElement');
    var options = {
        filterProps: filterProps,
        showDefaultProps: showDefaultProps,
        showFunctions: showFunctions,
        functionValue: functionValue,
        tabStop: tabStop,
        useBooleanShorthandSyntax: useBooleanShorthandSyntax,
        useFragmentShortSyntax: useFragmentShortSyntax,
        sortProps: sortProps,
        maxInlineAttributesLineLength: maxInlineAttributesLineLength,
        displayName: displayName
    };
    return $946384cc26da4067$var$formatTree($946384cc26da4067$var$_parseReactElement(element, options), options);
};
$946384cc26da4067$exports["default"] = $946384cc26da4067$var$reactElementToJsxString;
$946384cc26da4067$exports.inlineFunction = $946384cc26da4067$var$inlineFunction;
$946384cc26da4067$exports.preserveFunctionLineBreak = $946384cc26da4067$var$preserveFunctionLineBreak;



var $3faf9a97cee68ddc$export$71511d61b312f219;
"use strict";
var $1836a557348c3c17$export$71511d61b312f219;
"use strict";


function $1836a557348c3c17$var$_construct(Parent, args, Class) {
    if ($1f26b1989c741e87$export$71511d61b312f219()) $1836a557348c3c17$export$71511d61b312f219 = $1836a557348c3c17$var$_construct = Reflect.construct;
    else $1836a557348c3c17$export$71511d61b312f219 = $1836a557348c3c17$var$_construct = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $0ef57a67a4dbd747$export$71511d61b312f219(instance, Class.prototype);
        return instance;
    };
    return $1836a557348c3c17$var$_construct.apply(null, arguments);
}
$1836a557348c3c17$export$71511d61b312f219 = $1836a557348c3c17$var$_construct;



var $0b2892733a91e389$export$71511d61b312f219;
"use strict";
function $0b2892733a91e389$var$_is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
$0b2892733a91e389$export$71511d61b312f219 = $0b2892733a91e389$var$_is_native_function;



function $3faf9a97cee68ddc$var$_wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $3faf9a97cee68ddc$export$71511d61b312f219 = $3faf9a97cee68ddc$var$_wrap_native_super = function(Class) {
        if (Class === null || !$0b2892733a91e389$export$71511d61b312f219(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $1836a557348c3c17$export$71511d61b312f219(Class, arguments, $9ac8e64cff09d58e$export$71511d61b312f219(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $0ef57a67a4dbd747$export$71511d61b312f219(Wrapper, Class);
    };
    return $3faf9a97cee68ddc$var$_wrap_native_super(Class);
}
$3faf9a97cee68ddc$export$71511d61b312f219 = $3faf9a97cee68ddc$var$_wrap_native_super;


function $c379f9436bbe0249$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $c379f9436bbe0249$var$$22de11b45b0eeb97$exports = {};
$c379f9436bbe0249$var$$parcel$export($c379f9436bbe0249$var$$22de11b45b0eeb97$exports, "Defer", function() {
    return $c379f9436bbe0249$export$c7e91f8aec23ae14;
});
$c379f9436bbe0249$var$$parcel$export($c379f9436bbe0249$var$$22de11b45b0eeb97$exports, "makeDefer", function() {
    return $c379f9436bbe0249$export$51ca94569b882c51;
});
class $c379f9436bbe0249$export$c7e91f8aec23ae14 {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
}
const $c379f9436bbe0249$export$51ca94569b882c51 = ()=>new $c379f9436bbe0249$export$c7e91f8aec23ae14();
var $c379f9436bbe0249$var$$e3640f413e0c36e7$exports = {};
$c379f9436bbe0249$var$$parcel$export($c379f9436bbe0249$var$$e3640f413e0c36e7$exports, "Observable", function() {
    return $c379f9436bbe0249$export$77cea355fa80b5f4;
});
if (!Symbol.observable) Reflect.set(Symbol, "observable", Symbol("observable"));
class $c379f9436bbe0249$export$77cea355fa80b5f4 {
    constructor(subscriber){
        this.subscriber = subscriber;
    }
    [Symbol.observable]() {
        return this;
    }
    async *[Symbol.asyncIterator]() {
        var queue = [
            new $c379f9436bbe0249$export$c7e91f8aec23ae14()
        ], canceler, done = false;
        const observer = {
            next (value) {
                if (done) return;
                queue[queue.length - 1].resolve(value);
                queue.push(new $c379f9436bbe0249$export$c7e91f8aec23ae14());
            },
            error (reason) {
                if (!done) queue[queue.length - 1].reject(reason), done = true;
                if (canceler) canceler();
            },
            complete () {
                if (!done) queue[queue.length - 1].resolve(), done = true;
                if (canceler) canceler();
            }
        };
        canceler = this.subscriber(observer);
        do {
            yield queue[0].promise;
            queue.shift();
        }while (queue[0]);
    }
    static fromStream(list) {
        return new this(({ next: next, complete: complete, error: error })=>{
            var stopped = false;
            (async ()=>{
                try {
                    for await (const item of list)if (!stopped) next(item);
                    else break;
                    if (!stopped) complete();
                } catch (bug) {
                    if (!stopped) error(bug);
                }
            })();
            return ()=>stopped = true;
        });
    }
    static of(...items) {
        return this.fromStream(items);
    }
    async toPromise() {
        const stack = [];
        for await (const item of this){
            stack.push(item);
            if (stack.length > 2) stack.shift();
        }
        return stack[0];
    }
    subscribe(onNext, onError, onComplete) {
        var stop = false;
        (async ()=>{
            try {
                for await (const item of this)if (!stop) onNext(item);
                else break;
                if (onComplete instanceof Function) onComplete();
            } catch (error) {
                if (onError instanceof Function) onError(error);
            }
        })();
        return {
            unsubscribe: ()=>stop = true,
            get closed () {
                return stop;
            }
        };
    }
    static from(observable) {
        if (Symbol.iterator in observable) return this.of(...observable);
        if (Symbol.asyncIterator in observable) return this.fromStream(observable);
        return new this(({ next: next, error: error, complete: complete })=>observable.subscribe(next, error, complete).unsubscribe);
    }
    static fromEvent(target, name) {
        return new this(({ next: next, error: error })=>{
            if (typeof target.on === "function") target.on(name, next).on("error", error);
            else {
                target.addEventListener(name, next);
                target.addEventListener("error", error);
            }
            return ()=>{
                if (typeof target.off === "function") target.off(name, next).off("error", error);
                else {
                    target.removeEventListener(name, next);
                    target.removeEventListener("error", error);
                }
            };
        });
    }
}
var $c379f9436bbe0249$var$$603f33a01a36ab56$exports = {};
$c379f9436bbe0249$var$$parcel$export($c379f9436bbe0249$var$$603f33a01a36ab56$exports, "createQueue", function() {
    return $c379f9436bbe0249$export$d16acf4b6e75743d;
});
function $c379f9436bbe0249$export$d16acf4b6e75743d() {
    var feedNext, stop;
    const observable = new $c379f9436bbe0249$export$77cea355fa80b5f4(({ next: next, complete: complete })=>{
        feedNext = next, stop = complete;
    });
    return {
        process (data) {
            const defer = new $c379f9436bbe0249$export$c7e91f8aec23ae14();
            if (!feedNext) throw Error("Can't process data before Queue consuming");
            feedNext({
                defer: defer,
                data: data
            });
            return defer.promise;
        },
        destroy () {
            if (!stop) throw Error("Can't stop a Queue before Queue consuming");
            stop();
        },
        observable: observable
    };
}



var $dZnzp = parcelRequire("dZnzp");

var $dZnzp = parcelRequire("dZnzp");

var $dNU7X = parcelRequire("dNU7X");

var $dZnzp = parcelRequire("dZnzp");

var $dNU7X = parcelRequire("dNU7X");
if (!(0, $dNU7X.useState)) throw new Error("mobx-react-lite requires React with Hooks support");
if (!(0, $dZnzp.makeObservable)) throw new Error("mobx-react-lite@3 requires mobx at least version 6 to be available");



var $boCrV = parcelRequire("boCrV");


var $boCrV = parcelRequire("boCrV");

var $dZnzp = parcelRequire("dZnzp");
function $40878e1329c3fe88$export$fb2daceae6f5097a(callback) {
    callback();
}
function $40878e1329c3fe88$export$294943bbc3c74f4f(reactionScheduler) {
    if (!reactionScheduler) reactionScheduler = $40878e1329c3fe88$export$fb2daceae6f5097a;
    (0, $dZnzp.configure)({
        reactionScheduler: reactionScheduler
    });
}
var $40878e1329c3fe88$export$13ce1459b9a04b51 = function() {
    return true;
};


var $4c0f96ad8121bb13$var$deprecatedMessages = [];
function $4c0f96ad8121bb13$export$be38475be17599d(msg) {
    if (!$4c0f96ad8121bb13$var$deprecatedMessages.includes(msg)) {
        $4c0f96ad8121bb13$var$deprecatedMessages.push(msg);
        console.warn(msg);
    }
}



var $dZnzp = parcelRequire("dZnzp");

var $dNU7X = parcelRequire("dNU7X");

var $dZnzp = parcelRequire("dZnzp");
function $985116b605499384$export$ef795f1f307682c7(v) {
    return (0, $dZnzp.getDependencyTree)(v);
}


var $9d355e114b027ae1$var$globalIsUsingStaticRendering = false;
function $9d355e114b027ae1$export$5d52eaa7c0f24c9e(enable) {
    $9d355e114b027ae1$var$globalIsUsingStaticRendering = enable;
}
function $9d355e114b027ae1$export$55979271896d643e() {
    return $9d355e114b027ae1$var$globalIsUsingStaticRendering;
}


var $9bce4a70dfa316fb$export$e901ba0ffe10ba41 = 10000;
var $9bce4a70dfa316fb$export$1ae22ce5a82f26b6 = 10000;
var $9bce4a70dfa316fb$export$b7a00d372cedeedd = /** @class */ function() {
    function TimerBasedFinalizationRegistry(finalize) {
        var _this = this;
        Object.defineProperty(this, "finalize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: finalize
        });
        Object.defineProperty(this, "registrations", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new Map()
        });
        Object.defineProperty(this, "sweepTimeout", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // Bound so it can be used directly as setTimeout callback.
        Object.defineProperty(this, "sweep", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function(maxAge) {
                if (maxAge === void 0) maxAge = $9bce4a70dfa316fb$export$e901ba0ffe10ba41;
                // cancel timeout so we can force sweep anytime
                clearTimeout(_this.sweepTimeout);
                _this.sweepTimeout = undefined;
                var now = Date.now();
                _this.registrations.forEach(function(registration, token) {
                    if (now - registration.registeredAt >= maxAge) {
                        _this.finalize(registration.value);
                        _this.registrations.delete(token);
                    }
                });
                if (_this.registrations.size > 0) _this.scheduleSweep();
            }
        });
        // Bound so it can be exported directly as clearTimers test utility.
        Object.defineProperty(this, "finalizeAllImmediately", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: function() {
                _this.sweep(0);
            }
        });
    }
    // Token is actually required with this impl
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "register", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(target, value, token) {
            this.registrations.set(token, {
                value: value,
                registeredAt: Date.now()
            });
            this.scheduleSweep();
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "unregister", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function(token) {
            this.registrations.delete(token);
        }
    });
    Object.defineProperty(TimerBasedFinalizationRegistry.prototype, "scheduleSweep", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function() {
            if (this.sweepTimeout === undefined) this.sweepTimeout = setTimeout(this.sweep, $9bce4a70dfa316fb$export$1ae22ce5a82f26b6);
        }
    });
    return TimerBasedFinalizationRegistry;
}();
var $9bce4a70dfa316fb$export$da5d55a244964b51 = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : $9bce4a70dfa316fb$export$b7a00d372cedeedd;


var $cc0827b12898b7be$export$10e8a12fbfd8583c = new (0, $9bce4a70dfa316fb$export$da5d55a244964b51)(function(adm) {
    var _a;
    (_a = adm.reaction) === null || _a === void 0 || _a.dispose();
    adm.reaction = null;
});


var $90a56482dd519527$exports = {};
'use strict';

$90a56482dd519527$exports = (parcelRequire("asJeQ"));


function $eaa4f39bce2f8f51$var$createReaction(adm) {
    adm.reaction = new (0, $dZnzp.Reaction)("observer".concat(adm.name), function() {
        var _a;
        adm.stateVersion = Symbol();
        // onStoreChange won't be available until the component "mounts".
        // If state changes in between initial render and mount,
        // `useSyncExternalStore` should handle that by checking the state version and issuing update.
        (_a = adm.onStoreChange) === null || _a === void 0 || _a.call(adm);
    });
}
function $eaa4f39bce2f8f51$export$b9c7ecd090a87b14(render, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    if ((0, $9d355e114b027ae1$export$55979271896d643e)()) return render();
    var admRef = (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).useRef(null);
    if (!admRef.current) {
        // First render
        var adm_1 = {
            reaction: null,
            onStoreChange: null,
            stateVersion: Symbol(),
            name: baseComponentName,
            subscribe: function(onStoreChange) {
                // Do NOT access admRef here!
                (0, $cc0827b12898b7be$export$10e8a12fbfd8583c).unregister(adm_1);
                adm_1.onStoreChange = onStoreChange;
                if (!adm_1.reaction) {
                    // We've lost our reaction and therefore all subscriptions, occurs when:
                    // 1. Timer based finalization registry disposed reaction before component mounted.
                    // 2. React "re-mounts" same component without calling render in between (typically <StrictMode>).
                    // We have to recreate reaction and schedule re-render to recreate subscriptions,
                    // even if state did not change.
                    $eaa4f39bce2f8f51$var$createReaction(adm_1);
                    // `onStoreChange` won't force update if subsequent `getSnapshot` returns same value.
                    // So we make sure that is not the case
                    adm_1.stateVersion = Symbol();
                }
                return function() {
                    var _a;
                    // Do NOT access admRef here!
                    adm_1.onStoreChange = null;
                    (_a = adm_1.reaction) === null || _a === void 0 || _a.dispose();
                    adm_1.reaction = null;
                };
            },
            getSnapshot: function() {
                // Do NOT access admRef here!
                return adm_1.stateVersion;
            }
        };
        admRef.current = adm_1;
    }
    var adm = admRef.current;
    if (!adm.reaction) {
        // First render or reaction was disposed by registry before subscribe
        $eaa4f39bce2f8f51$var$createReaction(adm);
        // StrictMode/ConcurrentMode/Suspense may mean that our component is
        // rendered and abandoned multiple times, so we need to track leaked
        // Reactions.
        (0, $cc0827b12898b7be$export$10e8a12fbfd8583c).register(admRef, adm, adm);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).useDebugValue(adm.reaction, (0, $985116b605499384$export$ef795f1f307682c7));
    (0, $90a56482dd519527$exports.useSyncExternalStore)(// Both of these must be stable, otherwise it would keep resubscribing every render.
    adm.subscribe, adm.getSnapshot, adm.getSnapshot);
    // render the original component, but have the
    // reaction track the observables, so that rendering
    // can be invalidated (see above) once a dependency changes
    var renderResult;
    var exception;
    adm.reaction.track(function() {
        try {
            renderResult = render();
        } catch (e) {
            exception = e;
        }
    });
    if (exception) throw exception; // re-throw any exceptions caught during rendering
    return renderResult;
}





var $dNU7X = parcelRequire("dNU7X");


var $3b071b5f52752ff6$var$_a, $3b071b5f52752ff6$var$_b;
var $3b071b5f52752ff6$var$warnObserverOptionsDeprecated = true;
var $3b071b5f52752ff6$var$warnLegacyContextTypes = true;
var $3b071b5f52752ff6$var$hasSymbol = typeof Symbol === "function" && Symbol.for;
var $3b071b5f52752ff6$var$isFunctionNameConfigurable = ($3b071b5f52752ff6$var$_b = ($3b071b5f52752ff6$var$_a = Object.getOwnPropertyDescriptor(function() {}, "name")) === null || $3b071b5f52752ff6$var$_a === void 0 ? void 0 : $3b071b5f52752ff6$var$_a.configurable) !== null && $3b071b5f52752ff6$var$_b !== void 0 ? $3b071b5f52752ff6$var$_b : false;
// Using react-is had some issues (and operates on elements, not on types), see #608 / #609
var $3b071b5f52752ff6$var$ReactForwardRefSymbol = $3b071b5f52752ff6$var$hasSymbol ? Symbol.for("react.forward_ref") : typeof (0, $dNU7X.forwardRef) === "function" && (0, $dNU7X.forwardRef)(function(props) {
    return null;
})["$$typeof"];
var $3b071b5f52752ff6$var$ReactMemoSymbol = $3b071b5f52752ff6$var$hasSymbol ? Symbol.for("react.memo") : typeof (0, $dNU7X.memo) === "function" && (0, $dNU7X.memo)(function(props) {
    return null;
})["$$typeof"];
function $3b071b5f52752ff6$export$b6ae1bc530f4c149(baseComponent, // TODO remove in next major
options) {
    var _a;
    if ($3b071b5f52752ff6$var$ReactMemoSymbol && baseComponent["$$typeof"] === $3b071b5f52752ff6$var$ReactMemoSymbol) throw new Error("[mobx-react-lite] You are trying to use `observer` on a function component wrapped in either another `observer` or `React.memo`. The observer already applies 'React.memo' for you.");
    // The working of observer is explained step by step in this talk: https://www.youtube.com/watch?v=cPF4iBedoF0&feature=youtu.be&t=1307
    if ((0, $9d355e114b027ae1$export$55979271896d643e)()) return baseComponent;
    var useForwardRef = (_a = options === null || options === void 0 ? void 0 : options.forwardRef) !== null && _a !== void 0 ? _a : false;
    var render = baseComponent;
    var baseComponentName = baseComponent.displayName || baseComponent.name;
    // If already wrapped with forwardRef, unwrap,
    // so we can patch render and apply memo
    if ($3b071b5f52752ff6$var$ReactForwardRefSymbol && baseComponent["$$typeof"] === $3b071b5f52752ff6$var$ReactForwardRefSymbol) {
        useForwardRef = true;
        render = baseComponent["render"];
        if (typeof render !== "function") throw new Error("[mobx-react-lite] `render` property of ForwardRef was not a function");
    }
    var observerComponent = function(props, ref) {
        return (0, $eaa4f39bce2f8f51$export$b9c7ecd090a87b14)(function() {
            return render(props, ref);
        }, baseComponentName);
    };
    observerComponent.displayName = baseComponent.displayName;
    if ($3b071b5f52752ff6$var$isFunctionNameConfigurable) Object.defineProperty(observerComponent, "name", {
        value: baseComponent.name,
        writable: true,
        configurable: true
    });
    // Support legacy context: `contextTypes` must be applied before `memo`
    if (baseComponent.contextTypes) observerComponent.contextTypes = baseComponent.contextTypes;
    if (useForwardRef) // `forwardRef` must be applied prior `memo`
    // `forwardRef(observer(cmp))` throws:
    // "forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...))"
    observerComponent = (0, $dNU7X.forwardRef)(observerComponent);
    // memo; we are not interested in deep updates
    // in props; we assume that if deep objects are changed,
    // this is in observables, which would have been tracked anyway
    observerComponent = (0, $dNU7X.memo)(observerComponent);
    $3b071b5f52752ff6$var$copyStaticProperties(baseComponent, observerComponent);
    return observerComponent;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $3b071b5f52752ff6$var$hoistBlackList = {
    $$typeof: true,
    render: true,
    compare: true,
    type: true,
    // Don't redefine `displayName`,
    // it's defined as getter-setter pair on `memo` (see #3192).
    displayName: true
};
function $3b071b5f52752ff6$var$copyStaticProperties(base, target) {
    Object.keys(base).forEach(function(key) {
        if (!$3b071b5f52752ff6$var$hoistBlackList[key]) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}



function $50337c239899897e$export$c1cbdee04e18ea8b(_a) {
    var children = _a.children, render = _a.render;
    if (children && render) console.error("MobX Observer: Do not use children and render in the same time in `Observer`");
    var component = children || render;
    if (typeof component !== "function") return null;
    return (0, $eaa4f39bce2f8f51$export$b9c7ecd090a87b14)(component);
}
$50337c239899897e$export$c1cbdee04e18ea8b.displayName = "Observer";
function $50337c239899897e$var$ObserverPropsCheck(props, key, componentName, location, propFullName) {
    var extraKey = key === "children" ? "render" : "children";
    var hasProp = typeof props[key] === "function";
    var hasExtraProp = typeof props[extraKey] === "function";
    if (hasProp && hasExtraProp) return new Error("MobX Observer: Do not use children and render in the same time in`" + componentName);
    if (hasProp || hasExtraProp) return null;
    return new Error("Invalid prop `" + propFullName + "` of type `" + typeof props[key] + "` supplied to" + " `" + componentName + "`, expected `function`.");
}



var $dZnzp = parcelRequire("dZnzp");

var $dNU7X = parcelRequire("dNU7X");
function $7626d1da3a6d501a$export$aa207039f277c5f(initializer, annotations) {
    return (0, $dNU7X.useState)(function() {
        return (0, $dZnzp.observable)(initializer(), annotations, {
            autoBind: true
        });
    })[0];
}



var $dZnzp = parcelRequire("dZnzp");

var $dNU7X = parcelRequire("dNU7X");



var $dZnzp = parcelRequire("dZnzp");

var $dNU7X = parcelRequire("dNU7X");
function $243fe61fc039628f$export$e0ded3646391939c(current) {
    // We're deliberately not using idiomatic destructuring for the hook here.
    // Accessing the state value as an array element prevents TypeScript from generating unnecessary helpers in the resulting code.
    // For further details, please refer to mobxjs/mobx#3842.
    var res = (0, $dNU7X.useState)(function() {
        return (0, $dZnzp.observable)(current, {}, {
            deep: false
        });
    })[0];
    (0, $dZnzp.runInAction)(function() {
        Object.assign(res, current);
    });
    return res;
}


function $92993e8a5c6457af$export$f5b97ae82d1eeaf3(initializer, current) {
    var source = current && (0, $243fe61fc039628f$export$e0ded3646391939c)(current);
    return (0, $dNU7X.useState)(function() {
        return (0, $dZnzp.observable)(initializer(source), undefined, {
            autoBind: true
        });
    })[0];
}



var $9a8715c36b21ed99$var$_a;
(0, $40878e1329c3fe88$export$294943bbc3c74f4f)((0, $boCrV.unstable_batchedUpdates));
var $9a8715c36b21ed99$export$469d51fb8d268227 = ($9a8715c36b21ed99$var$_a = (0, $cc0827b12898b7be$export$10e8a12fbfd8583c)["finalizeAllImmediately"]) !== null && $9a8715c36b21ed99$var$_a !== void 0 ? $9a8715c36b21ed99$var$_a : function() {};
function $9a8715c36b21ed99$export$b9c7ecd090a87b14(fn, baseComponentName) {
    if (baseComponentName === void 0) baseComponentName = "observed";
    return (0, $eaa4f39bce2f8f51$export$b9c7ecd090a87b14)(fn, baseComponentName);
}
function $9a8715c36b21ed99$export$7613124ee4202834(enable) {
    (0, $9d355e114b027ae1$export$5d52eaa7c0f24c9e)(enable);
}


function $47a6458a96730da2$var$shallowEqual(objA, objB) {
    //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if ($47a6458a96730da2$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.hasOwnProperty.call(objB, keysA[i]) || !$47a6458a96730da2$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
function $47a6458a96730da2$var$is(x, y) {
    // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
// based on https://github.com/mridgway/hoist-non-react-statics/blob/master/src/index.js
var $47a6458a96730da2$var$hoistBlackList = {
    $$typeof: 1,
    render: 1,
    compare: 1,
    type: 1,
    childContextTypes: 1,
    contextType: 1,
    contextTypes: 1,
    defaultProps: 1,
    getDefaultProps: 1,
    getDerivedStateFromError: 1,
    getDerivedStateFromProps: 1,
    mixins: 1,
    displayName: 1,
    propTypes: 1
};
function $47a6458a96730da2$var$copyStaticProperties(base, target) {
    var protoProps = Object.getOwnPropertyNames(Object.getPrototypeOf(base));
    Object.getOwnPropertyNames(base).forEach(function(key) {
        if (!$47a6458a96730da2$var$hoistBlackList[key] && protoProps.indexOf(key) === -1) Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(base, key));
    });
}
/**
 * Utilities for patching componentWillUnmount, to make sure @disposeOnUnmount works correctly icm with user defined hooks
 * and the handler provided by mobx-react
 */ var $47a6458a96730da2$var$mobxMixins = /*#__PURE__*/ Symbol("patchMixins");
var $47a6458a96730da2$var$mobxPatchedDefinition = /*#__PURE__*/ Symbol("patchedDefinition");
function $47a6458a96730da2$var$getMixins(target, methodName) {
    var mixins = target[$47a6458a96730da2$var$mobxMixins] = target[$47a6458a96730da2$var$mobxMixins] || {};
    var methodMixins = mixins[methodName] = mixins[methodName] || {};
    methodMixins.locks = methodMixins.locks || 0;
    methodMixins.methods = methodMixins.methods || [];
    return methodMixins;
}
function $47a6458a96730da2$var$wrapper(realMethod, mixins) {
    var _this = this;
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    // locks are used to ensure that mixins are invoked only once per invocation, even on recursive calls
    mixins.locks++;
    try {
        var retVal;
        if (realMethod !== undefined && realMethod !== null) retVal = realMethod.apply(this, args);
        return retVal;
    } finally{
        mixins.locks--;
        if (mixins.locks === 0) mixins.methods.forEach(function(mx) {
            mx.apply(_this, args);
        });
    }
}
function $47a6458a96730da2$var$wrapFunction(realMethod, mixins) {
    var fn = function fn() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        $47a6458a96730da2$var$wrapper.call.apply($47a6458a96730da2$var$wrapper, [
            this,
            realMethod,
            mixins
        ].concat(args));
    };
    return fn;
}
function $47a6458a96730da2$var$patch(target, methodName, mixinMethod) {
    var mixins = $47a6458a96730da2$var$getMixins(target, methodName);
    if (mixins.methods.indexOf(mixinMethod) < 0) mixins.methods.push(mixinMethod);
    var oldDefinition = Object.getOwnPropertyDescriptor(target, methodName);
    if (oldDefinition && oldDefinition[$47a6458a96730da2$var$mobxPatchedDefinition]) // already patched definition, do not repatch
    return;
    var originalMethod = target[methodName];
    var newDefinition = $47a6458a96730da2$var$createDefinition(target, methodName, oldDefinition ? oldDefinition.enumerable : undefined, mixins, originalMethod);
    Object.defineProperty(target, methodName, newDefinition);
}
function $47a6458a96730da2$var$createDefinition(target, methodName, enumerable, mixins, originalMethod) {
    var _ref;
    var wrappedFunc = $47a6458a96730da2$var$wrapFunction(originalMethod, mixins);
    return _ref = {}, _ref[$47a6458a96730da2$var$mobxPatchedDefinition] = true, _ref.get = function get() {
        return wrappedFunc;
    }, _ref.set = function set(value) {
        if (this === target) wrappedFunc = $47a6458a96730da2$var$wrapFunction(value, mixins);
        else {
            // when it is an instance of the prototype/a child prototype patch that particular case again separately
            // since we need to store separate values depending on wether it is the actual instance, the prototype, etc
            // e.g. the method for super might not be the same as the method for the prototype which might be not the same
            // as the method for the instance
            var newDefinition = $47a6458a96730da2$var$createDefinition(this, methodName, enumerable, mixins, value);
            Object.defineProperty(this, methodName, newDefinition);
        }
    }, _ref.configurable = true, _ref.enumerable = enumerable, _ref;
}
var $47a6458a96730da2$var$administrationSymbol = /*#__PURE__*/ Symbol("ObserverAdministration");
var $47a6458a96730da2$var$isMobXReactObserverSymbol = /*#__PURE__*/ Symbol("isMobXReactObserver");
var $47a6458a96730da2$var$observablePropDescriptors;
function $47a6458a96730da2$var$getAdministration(component) {
    var _component$administra;
    // We create administration lazily, because we can't patch constructor
    // and the exact moment of initialization partially depends on React internals.
    // At the time of writing this, the first thing invoked is one of the observable getter/setter (state/props/context).
    return (_component$administra = component[$47a6458a96730da2$var$administrationSymbol]) != null ? _component$administra : component[$47a6458a96730da2$var$administrationSymbol] = {
        reaction: null,
        mounted: false,
        reactionInvalidatedBeforeMount: false,
        forceUpdate: null,
        name: $47a6458a96730da2$var$getDisplayName(component.constructor),
        state: undefined,
        props: undefined,
        context: undefined
    };
}
function $47a6458a96730da2$var$makeClassComponentObserver(componentClass) {
    var prototype = componentClass.prototype;
    if (componentClass[$47a6458a96730da2$var$isMobXReactObserverSymbol]) {
        var displayName = $47a6458a96730da2$var$getDisplayName(componentClass);
        throw new Error("The provided component class (" + displayName + ") has already been declared as an observer component.");
    } else componentClass[$47a6458a96730da2$var$isMobXReactObserverSymbol] = true;
    if (prototype.componentWillReact) throw new Error("The componentWillReact life-cycle event is no longer supported");
    if (componentClass["__proto__"] !== (0, $dNU7X.PureComponent)) {
        if (!prototype.shouldComponentUpdate) prototype.shouldComponentUpdate = $47a6458a96730da2$var$observerSCU;
        else if (prototype.shouldComponentUpdate !== $47a6458a96730da2$var$observerSCU) // n.b. unequal check, instead of existence check, as @observer might be on superclass as well
        throw new Error("It is not allowed to use shouldComponentUpdate in observer based components.");
    }
    var originalRender = prototype.render;
    if (typeof originalRender !== "function") {
        var _displayName = $47a6458a96730da2$var$getDisplayName(componentClass);
        throw new Error("[mobx-react] class component (" + _displayName + ") is missing `render` method." + "\n`observer` requires `render` being a function defined on prototype." + "\n`render = () => {}` or `render = function() {}` is not supported.");
    }
    prototype.render = function() {
        Object.defineProperty(this, "render", {
            // There is no safe way to replace render, therefore it's forbidden.
            configurable: false,
            writable: false,
            value: (0, $9d355e114b027ae1$export$55979271896d643e)() ? originalRender : $47a6458a96730da2$var$createReactiveRender.call(this, originalRender)
        });
        return this.render();
    };
    var originalComponentDidMount = prototype.componentDidMount;
    prototype.componentDidMount = function() {
        var _this = this;
        var _displayName2;
        // `componentDidMount` may not be called at all. React can abandon the instance after `render`.
        // That's why we use finalization registry to dispose reaction created during render.
        // Happens with `<Suspend>` see #3492
        //
        // `componentDidMount` can be called immediately after `componentWillUnmount` without calling `render` in between.
        // Happens with `<StrictMode>`see #3395.
        //
        // If `componentDidMount` is called, it's guaranteed to run synchronously with render (similary to `useLayoutEffect`).
        // Therefore we don't have to worry about external (observable) state being updated before mount (no state version checking).
        //
        // Things may change: "In the future, React will provide a feature that lets components preserve state between unmounts"
        var admin = $47a6458a96730da2$var$getAdministration(this);
        admin.mounted = true;
        // Component instance committed, prevent reaction disposal.
        (0, $cc0827b12898b7be$export$10e8a12fbfd8583c).unregister(this);
        // We don't set forceUpdate before mount because it requires a reference to `this`,
        // therefore `this` could NOT be garbage collected before mount,
        // preventing reaction disposal by FinalizationRegistry and leading to memory leak.
        // As an alternative we could have `admin.instanceRef = new WeakRef(this)`, but lets avoid it if possible.
        admin.forceUpdate = function() {
            return _this.forceUpdate();
        };
        if (!admin.reaction || admin.reactionInvalidatedBeforeMount) // Missing reaction:
        // 1. Instance was unmounted (reaction disposed) and immediately remounted without running render #3395.
        // 2. Reaction was disposed by finalization registry before mount. Shouldn't ever happen for class components:
        // `componentDidMount` runs synchronously after render, but our registry are deferred (can't run in between).
        // In any case we lost subscriptions to observables, so we have to create new reaction and re-render to resubscribe.
        // The reaction will be created lazily by following render.
        // Reaction invalidated before mount:
        // 1. A descendant's `componenDidMount` invalidated it's parent #3730
        admin.forceUpdate();
        return originalComponentDidMount == null ? void 0 : originalComponentDidMount.apply(this, arguments);
    };
    // TODO@major Overly complicated "patch" is only needed to support the deprecated @disposeOnUnmount
    $47a6458a96730da2$var$patch(prototype, "componentWillUnmount", function() {
        var _admin$reaction;
        if ((0, $9d355e114b027ae1$export$55979271896d643e)()) return;
        var admin = $47a6458a96730da2$var$getAdministration(this);
        (_admin$reaction = admin.reaction) == null || _admin$reaction.dispose();
        admin.reaction = null;
        admin.forceUpdate = null;
        admin.mounted = false;
        admin.reactionInvalidatedBeforeMount = false;
    });
    return componentClass;
}
// Generates a friendly name for debugging
function $47a6458a96730da2$var$getDisplayName(componentClass) {
    return componentClass.displayName || componentClass.name || "<component>";
}
function $47a6458a96730da2$var$createReactiveRender(originalRender) {
    var boundOriginalRender = originalRender.bind(this);
    var admin = $47a6458a96730da2$var$getAdministration(this);
    function reactiveRender() {
        if (!admin.reaction) {
            // Create reaction lazily to support re-mounting #3395
            admin.reaction = $47a6458a96730da2$var$createReaction(admin);
            if (!admin.mounted) // React can abandon this instance and never call `componentDidMount`/`componentWillUnmount`,
            // we have to make sure reaction will be disposed.
            (0, $cc0827b12898b7be$export$10e8a12fbfd8583c).register(this, admin, this);
        }
        var error = undefined;
        var renderResult = undefined;
        admin.reaction.track(function() {
            try {
                // TODO@major
                // Optimization: replace with _allowStateChangesStart/End (not available in mobx@6.0.0)
                renderResult = (0, $dZnzp._allowStateChanges)(false, boundOriginalRender);
            } catch (e) {
                error = e;
            }
        });
        if (error) throw error;
        return renderResult;
    }
    return reactiveRender;
}
function $47a6458a96730da2$var$createReaction(admin) {
    return new (0, $dZnzp.Reaction)(admin.name + ".render()", function() {
        if (!admin.mounted) {
            // This is neccessary to avoid react warning about calling forceUpdate on component that isn't mounted yet.
            // This happens when component is abandoned after render - our reaction is already created and reacts to changes.
            // `componenDidMount` runs synchronously after `render`, so unlike functional component, there is no delay during which the reaction could be invalidated.
            // However `componentDidMount` runs AFTER it's descendants' `componentDidMount`, which CAN invalidate the reaction, see #3730. Therefore remember and forceUpdate on mount.
            admin.reactionInvalidatedBeforeMount = true;
            return;
        }
        try {
            admin.forceUpdate == null || admin.forceUpdate();
        } catch (error) {
            var _admin$reaction2;
            (_admin$reaction2 = admin.reaction) == null || _admin$reaction2.dispose();
            admin.reaction = null;
        }
    });
}
function $47a6458a96730da2$var$observerSCU(nextProps, nextState) {
    if ((0, $9d355e114b027ae1$export$55979271896d643e)()) console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
    // update on any state changes (as is the default)
    if (this.state !== nextState) return true;
    // update if props are shallowly not equal, inspired by PureRenderMixin
    // we could return just 'false' here, and avoid the `skipRender` checks etc
    // however, it is nicer if lifecycle events are triggered like usually,
    // so we return true here if props are shallowly modified.
    return !$47a6458a96730da2$var$shallowEqual(this.props, nextProps);
}
function $47a6458a96730da2$var$createObservablePropDescriptor(key) {
    return {
        configurable: true,
        enumerable: true,
        get: function get() {
            var admin = $47a6458a96730da2$var$getAdministration(this);
            var derivation = (0, $dZnzp._getGlobalState)().trackingDerivation;
            if (derivation && derivation !== admin.reaction) throw new Error("[mobx-react] Cannot read \"" + admin.name + "." + key + "\" in a reactive context, as it isn't observable.\n                    Please use component lifecycle method to copy the value into a local observable first.\n                    See https://github.com/mobxjs/mobx/blob/main/packages/mobx-react/README.md#note-on-using-props-and-state-in-derivations");
            return admin[key];
        },
        set: function set(value) {
            $47a6458a96730da2$var$getAdministration(this)[key] = value;
        }
    };
}
function $47a6458a96730da2$export$b6ae1bc530f4c149(component, context) {
    if (context && context.kind !== "class") throw new Error("The @observer decorator can be used on classes only");
    if (component["isMobxInjector"] === true) console.warn("Mobx observer: You are trying to use `observer` on a component that already has `inject`. Please apply `observer` before applying `inject`");
    if (Object.prototype.isPrototypeOf.call((0, $dNU7X.Component), component) || Object.prototype.isPrototypeOf.call((0, $dNU7X.PureComponent), component)) // Class component
    return $47a6458a96730da2$var$makeClassComponentObserver(component);
    else // Function component
    return (0, $3b071b5f52752ff6$export$b6ae1bc530f4c149)(component);
}
function $47a6458a96730da2$var$_extends() {
    return $47a6458a96730da2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $47a6458a96730da2$var$_extends.apply(null, arguments);
}
function $47a6458a96730da2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
var $47a6458a96730da2$var$_excluded = [
    "children"
];
var $47a6458a96730da2$export$f07786cea590ef31 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).createContext({});
function $47a6458a96730da2$export$2881499e37b75b9a(props) {
    var children = props.children, stores = $47a6458a96730da2$var$_objectWithoutPropertiesLoose(props, $47a6458a96730da2$var$_excluded);
    var parentValue = (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).useContext($47a6458a96730da2$export$f07786cea590ef31);
    var mutableProviderRef = (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).useRef($47a6458a96730da2$var$_extends({}, parentValue, stores));
    var value = mutableProviderRef.current;
    var newValue;
    return (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).createElement($47a6458a96730da2$export$f07786cea590ef31.Provider, {
        value: value
    }, children);
}
$47a6458a96730da2$export$2881499e37b75b9a.displayName = "MobXProvider";
/**
 * Store Injection
 */ function $47a6458a96730da2$var$createStoreInjector(grabStoresFn, component, injectNames, makeReactive) {
    // Support forward refs
    var Injector = (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).forwardRef(function(props, ref) {
        var newProps = $47a6458a96730da2$var$_extends({}, props);
        var context = (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).useContext($47a6458a96730da2$export$f07786cea590ef31);
        Object.assign(newProps, grabStoresFn(context || {}, newProps) || {});
        if (ref) newProps.ref = ref;
        return (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).createElement(component, newProps);
    });
    if (makeReactive) Injector = $47a6458a96730da2$export$b6ae1bc530f4c149(Injector);
    Injector["isMobxInjector"] = true; // assigned late to suppress observer warning
    // Static fields from component should be visible on the generated Injector
    $47a6458a96730da2$var$copyStaticProperties(component, Injector);
    Injector["wrappedComponent"] = component;
    Injector.displayName = $47a6458a96730da2$var$getInjectName(component, injectNames);
    return Injector;
}
function $47a6458a96730da2$var$getInjectName(component, injectNames) {
    var displayName;
    var componentName = component.displayName || component.name || component.constructor && component.constructor.name || "Component";
    if (injectNames) displayName = "inject-with-" + injectNames + "(" + componentName + ")";
    else displayName = "inject(" + componentName + ")";
    return displayName;
}
function $47a6458a96730da2$var$grabStoresByName(storeNames) {
    return function(baseStores, nextProps) {
        storeNames.forEach(function(storeName) {
            if (storeName in nextProps // prefer props over stores
            ) return;
            if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
            nextProps[storeName] = baseStores[storeName];
        });
        return nextProps;
    };
}
/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */ function $47a6458a96730da2$export$a976684a0efeb93f() {
    for(var _len = arguments.length, storeNames = new Array(_len), _key = 0; _key < _len; _key++)storeNames[_key] = arguments[_key];
    if (typeof arguments[0] === "function") {
        var grabStoresFn = arguments[0];
        return function(componentClass) {
            return $47a6458a96730da2$var$createStoreInjector(grabStoresFn, componentClass, grabStoresFn.name, true);
        };
    } else return function(componentClass) {
        return $47a6458a96730da2$var$createStoreInjector($47a6458a96730da2$var$grabStoresByName(storeNames), componentClass, storeNames.join("-"), false);
    };
}
var $47a6458a96730da2$var$reactMajorVersion = /*#__PURE__*/ Number.parseInt(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).version.split(".")[0]);
var $47a6458a96730da2$var$warnedAboutDisposeOnUnmountDeprecated = false;
var $47a6458a96730da2$var$protoStoreKey = /*#__PURE__*/ Symbol("disposeOnUnmountProto");
var $47a6458a96730da2$var$instStoreKey = /*#__PURE__*/ Symbol("disposeOnUnmountInst");
function $47a6458a96730da2$var$runDisposersOnWillUnmount() {
    var _this = this;
    [].concat(this[$47a6458a96730da2$var$protoStoreKey] || [], this[$47a6458a96730da2$var$instStoreKey] || []).forEach(function(propKeyOrFunction) {
        var prop = typeof propKeyOrFunction === "string" ? _this[propKeyOrFunction] : propKeyOrFunction;
        if (prop !== undefined && prop !== null) {
            if (Array.isArray(prop)) prop.map(function(f) {
                return f();
            });
            else prop();
        }
    });
}
/**
 * @deprecated `disposeOnUnmount` is not compatible with React 18 and higher.
 */ function $47a6458a96730da2$export$4e749cb731da87a9(target, propertyKeyOrFunction) {
    if (Array.isArray(propertyKeyOrFunction)) return propertyKeyOrFunction.map(function(fn) {
        return $47a6458a96730da2$export$4e749cb731da87a9(target, fn);
    });
    if (!$47a6458a96730da2$var$warnedAboutDisposeOnUnmountDeprecated) {
        if ($47a6458a96730da2$var$reactMajorVersion >= 18) console.error("[mobx-react] disposeOnUnmount is not compatible with React 18 and higher. Don't use it.");
        else console.warn("[mobx-react] disposeOnUnmount is deprecated. It won't work correctly with React 18 and higher.");
        $47a6458a96730da2$var$warnedAboutDisposeOnUnmountDeprecated = true;
    }
    var c = Object.getPrototypeOf(target).constructor;
    var c2 = Object.getPrototypeOf(target.constructor);
    // Special case for react-hot-loader
    var c3 = Object.getPrototypeOf(Object.getPrototypeOf(target));
    if (!(c === (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).Component || c === (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).PureComponent || c2 === (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).Component || c2 === (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).PureComponent || c3 === (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).Component || c3 === (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).PureComponent)) throw new Error("[mobx-react] disposeOnUnmount only supports direct subclasses of React.Component or React.PureComponent.");
    if (typeof propertyKeyOrFunction !== "string" && typeof propertyKeyOrFunction !== "function" && !Array.isArray(propertyKeyOrFunction)) throw new Error("[mobx-react] disposeOnUnmount only works if the parameter is either a property key or a function.");
    // decorator's target is the prototype, so it doesn't have any instance properties like props
    var isDecorator = typeof propertyKeyOrFunction === "string";
    // add property key / function we want run (disposed) to the store
    var componentWasAlreadyModified = !!target[$47a6458a96730da2$var$protoStoreKey] || !!target[$47a6458a96730da2$var$instStoreKey];
    var store = isDecorator ? // decorators are added to the prototype store
    target[$47a6458a96730da2$var$protoStoreKey] || (target[$47a6458a96730da2$var$protoStoreKey] = []) : // functions are added to the instance store
    target[$47a6458a96730da2$var$instStoreKey] || (target[$47a6458a96730da2$var$instStoreKey] = []);
    store.push(propertyKeyOrFunction);
    // tweak the component class componentWillUnmount if not done already
    if (!componentWasAlreadyModified) $47a6458a96730da2$var$patch(target, "componentWillUnmount", $47a6458a96730da2$var$runDisposersOnWillUnmount);
    // return the disposer as is if invoked as a non decorator
    if (typeof propertyKeyOrFunction !== "string") return propertyKeyOrFunction;
}
// Copied from React.PropTypes
function $47a6458a96730da2$var$createChainableTypeChecker(validator) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for(var _len = arguments.length, rest = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)rest[_key - 6] = arguments[_key];
        return (0, $dZnzp.untracked)(function() {
            componentName = componentName || "<<anonymous>>";
            propFullName = propFullName || propName;
            if (props[propName] == null) {
                if (isRequired) {
                    var actual = props[propName] === null ? "null" : "undefined";
                    return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
                }
                return null;
            } else // @ts-ignore rest arg is necessary for some React internals - fails tests otherwise
            return validator.apply(void 0, [
                props,
                propName,
                componentName,
                location,
                propFullName
            ].concat(rest));
        });
    }
    var chainedCheckType = checkType.bind(null, false);
    // Add isRequired to satisfy Requirable
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
// Copied from React.PropTypes
function $47a6458a96730da2$var$isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === "symbol") return true;
    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue["@@toStringTag"] === "Symbol") return true;
    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === "function" && propValue instanceof Symbol) return true;
    return false;
}
// Copied from React.PropTypes
function $47a6458a96730da2$var$getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) return "array";
    if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return "object";
    if ($47a6458a96730da2$var$isSymbol(propType, propValue)) return "symbol";
    return propType;
}
// This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes
function $47a6458a96730da2$var$getPreciseType(propValue) {
    var propType = $47a6458a96730da2$var$getPropType(propValue);
    if (propType === "object") {
        if (propValue instanceof Date) return "date";
        else if (propValue instanceof RegExp) return "regexp";
    }
    return propType;
}
function $47a6458a96730da2$var$createObservableTypeCheckerCreator(allowNativeType, mobxType) {
    return $47a6458a96730da2$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        return (0, $dZnzp.untracked)(function() {
            if (allowNativeType) {
                if ($47a6458a96730da2$var$getPropType(props[propName]) === mobxType.toLowerCase()) return null;
            }
            var mobxChecker;
            switch(mobxType){
                case "Array":
                    mobxChecker = (0, $dZnzp.isObservableArray);
                    break;
                case "Object":
                    mobxChecker = (0, $dZnzp.isObservableObject);
                    break;
                case "Map":
                    mobxChecker = (0, $dZnzp.isObservableMap);
                    break;
                default:
                    throw new Error("Unexpected mobxType: " + mobxType);
            }
            var propValue = props[propName];
            if (!mobxChecker(propValue)) {
                var preciseType = $47a6458a96730da2$var$getPreciseType(propValue);
                var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
                return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
            }
            return null;
        });
    });
}
function $47a6458a96730da2$var$createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
    return $47a6458a96730da2$var$createChainableTypeChecker(function(props, propName, componentName, location, propFullName) {
        for(var _len2 = arguments.length, rest = new Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++)rest[_key2 - 5] = arguments[_key2];
        return (0, $dZnzp.untracked)(function() {
            if (typeof typeChecker !== "function") return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
            else {
                var error = $47a6458a96730da2$var$createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName, location, propFullName);
                if (error instanceof Error) return error;
                var propValue = props[propName];
                for(var i = 0; i < propValue.length; i++){
                    error = typeChecker.apply(void 0, [
                        propValue,
                        i,
                        componentName,
                        location,
                        propFullName + "[" + i + "]"
                    ].concat(rest));
                    if (error instanceof Error) return error;
                }
                return null;
            }
        });
    });
}
var $47a6458a96730da2$var$observableArray = /*#__PURE__*/ $47a6458a96730da2$var$createObservableTypeCheckerCreator(false, "Array");
var $47a6458a96730da2$var$observableArrayOf = /*#__PURE__*/ $47a6458a96730da2$var$createObservableArrayOfTypeChecker.bind(null, false);
var $47a6458a96730da2$var$observableMap = /*#__PURE__*/ $47a6458a96730da2$var$createObservableTypeCheckerCreator(false, "Map");
var $47a6458a96730da2$var$observableObject = /*#__PURE__*/ $47a6458a96730da2$var$createObservableTypeCheckerCreator(false, "Object");
var $47a6458a96730da2$var$arrayOrObservableArray = /*#__PURE__*/ $47a6458a96730da2$var$createObservableTypeCheckerCreator(true, "Array");
var $47a6458a96730da2$var$arrayOrObservableArrayOf = /*#__PURE__*/ $47a6458a96730da2$var$createObservableArrayOfTypeChecker.bind(null, true);
var $47a6458a96730da2$var$objectOrObservableObject = /*#__PURE__*/ $47a6458a96730da2$var$createObservableTypeCheckerCreator(true, "Object");
var $47a6458a96730da2$export$e0c95a451cd220b7 = {
    observableArray: $47a6458a96730da2$var$observableArray,
    observableArrayOf: $47a6458a96730da2$var$observableArrayOf,
    observableMap: $47a6458a96730da2$var$observableMap,
    observableObject: $47a6458a96730da2$var$observableObject,
    arrayOrObservableArray: $47a6458a96730da2$var$arrayOrObservableArray,
    arrayOrObservableArrayOf: $47a6458a96730da2$var$arrayOrObservableArrayOf,
    objectOrObservableObject: $47a6458a96730da2$var$objectOrObservableObject
};
if (!(0, $dNU7X.Component)) throw new Error("mobx-react requires React to be available");
if (!(0, $dZnzp.observable)) throw new Error("mobx-react requires mobx to be available");


var $8fdeac7b23d8f90e$export$71511d61b312f219;
"use strict";

$8fdeac7b23d8f90e$export$71511d61b312f219 = (parcelRequire("ceFTv")).__generator;




function $80aa94f7cd3252af$export$da8ca15f4115b46e() {
    if (typeof window !== 'undefined') {
        const Component = (parcelRequire("bYRhh"));
        return Component.default || Component;
    } else {
        const Component = (parcelRequire("cghEl"));
        return Component.default || Component;
    }
}


var $70d150f8dfa3d626$exports = {};
"use strict";
var $70d150f8dfa3d626$var$e = {
    code: ({ data: e })=>`<pre><code>${e.code}</code></pre>`,
    embed: ({ data: e })=>{
        const t = e.service;
        return "vimeo" === t ? `<iframe src="${e.embed}" height="${e.height}" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>` : "youtube" === t ? `<iframe width="${e.width}" height="${e.height}" src="${e.embed}" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>` : (console.error("[editorjs-html]: Only Youtube & Vimeo embeds are available by default. Write your own embed parser for other options."), "");
    },
    header: ({ data: e })=>`<h${e.level}>${e.text}</h${e.level}>`,
    image: ({ data: e })=>{
        const t = e.caption ? e.caption : "Image";
        return `<img src="${e?.file?.url || e?.url}" alt="${t}" />`;
    },
    list: ({ data: e })=>{
        const t = "unordered" === e.style ? "ul" : "ol", r = (e, t)=>{
            const o = e.map((e)=>{
                if (!e.content && !e.items) return `<li>${e}</li>`;
                let o = "";
                return e.items?.length && (o = r(e.items, t)), e.content ? `<li>${e.content}${o}</li>` : void 0;
            });
            return `<${t}>${o.join("")}</${t}>`;
        };
        return r(e.items, t);
    },
    paragraph: ({ data: e })=>{
        const t = e.alignment || e.align;
        return t ? `<p style="text-align:${t}"> ${e.text} </p>` : `<p>${e.text}</p>`;
    },
    quote: ({ data: e })=>`<blockquote>${e.text}</blockquote> - ${e.caption}`,
    delimiter: ({ data: e })=>"<br/>"
};
$70d150f8dfa3d626$exports = (t = {}, r = {
    strict: !1
})=>{
    const o = {
        ...$70d150f8dfa3d626$var$e,
        ...t
    };
    return {
        parse: (e)=>(({ blocks: e }, t, r)=>e.reduce((e, o)=>{
                    if (o.type in t) return e + t[o.type](o);
                    const i = `[editorjs-html]: Parser function for ${o.type} does not exist`;
                    if (r.strict) throw new Error(i);
                    return console.error(i), e;
                }, ""))(e, o, r),
        parseBlock: (e)=>((e, t, r)=>{
                if (e.type in t) return t[e.type](e);
                const o = `[editorjs-html]: Parser function for ${e.type} does not exist`;
                if (r.strict) throw new Error(o);
                console.error(o);
            })(e, o, r)
    };
};




var $dNU7X = parcelRequire("dNU7X");

var $dNU7X = parcelRequire("dNU7X");

"use client";
const $4843567570d88909$export$666ad80b5007f835 = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $4843567570d88909$export$ff817e17bad2e091 = 'xs';
const $4843567570d88909$var$ThemeContext = /*#__PURE__*/ $dNU7X.createContext({
    prefixes: {},
    breakpoints: $4843567570d88909$export$666ad80b5007f835,
    minBreakpoint: $4843567570d88909$export$ff817e17bad2e091
});
const { Consumer: $4843567570d88909$export$b631efc24e9d5e2f, Provider: $4843567570d88909$var$Provider } = $4843567570d88909$var$ThemeContext;
function $4843567570d88909$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $4843567570d88909$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $4843567570d88909$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $dNU7X.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)($4843567570d88909$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $4843567570d88909$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $dNU7X.useContext)($4843567570d88909$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $4843567570d88909$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $dNU7X.useContext)($4843567570d88909$var$ThemeContext);
    return breakpoints;
}
function $4843567570d88909$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $dNU7X.useContext)($4843567570d88909$var$ThemeContext);
    return minBreakpoint;
}
function $4843567570d88909$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $dNU7X.useContext)($4843567570d88909$var$ThemeContext);
    return dir === 'rtl';
}
function $4843567570d88909$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? 'ref' : 'innerRef' } = opts;
    const Wrapped = /*#__PURE__*/ $dNU7X.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $4843567570d88909$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $4843567570d88909$export$2e2bcd8739ae039 = $4843567570d88909$var$ThemeProvider;



"use client";
const $7309943aa9afa2d4$var$Badge = /*#__PURE__*/ $dNU7X.forwardRef(({ bsPrefix: bsPrefix, bg: bg = 'primary', pill: pill = false, text: text, className: className, as: Component = 'span', ...props }, ref)=>{
    const prefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'badge');
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, pill && `rounded-pill`, text && `text-${text}`, bg && `bg-${bg}`)
    });
});
$7309943aa9afa2d4$var$Badge.displayName = 'Badge';
var $7309943aa9afa2d4$export$2e2bcd8739ae039 = $7309943aa9afa2d4$var$Badge;



var $dNU7X = parcelRequire("dNU7X");

var $dNU7X = parcelRequire("dNU7X");

const $cdcb5a6d0dd9d6ce$var$_excluded = [
    "as",
    "disabled"
];
function $cdcb5a6d0dd9d6ce$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $cdcb5a6d0dd9d6ce$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
function $cdcb5a6d0dd9d6ce$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = 'a';
        else tagName = 'button';
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === 'button') return [
        {
            type: type || 'button',
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === 'a' && $cdcb5a6d0dd9d6ce$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === 'a') {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = '#');
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : 'button',
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === 'a' ? target : undefined,
            'aria-disabled': !disabled ? undefined : disabled,
            rel: tagName === 'a' ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $cdcb5a6d0dd9d6ce$var$Button = /*#__PURE__*/ $dNU7X.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $cdcb5a6d0dd9d6ce$var$_objectWithoutPropertiesLoose(_ref, $cdcb5a6d0dd9d6ce$var$_excluded);
    const [buttonProps, { tagName: Component }] = $cdcb5a6d0dd9d6ce$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$cdcb5a6d0dd9d6ce$var$Button.displayName = 'Button';
var $cdcb5a6d0dd9d6ce$export$2e2bcd8739ae039 = $cdcb5a6d0dd9d6ce$var$Button;




"use client";
const $23c9a6bed94aa817$var$Button = /*#__PURE__*/ $dNU7X.forwardRef(({ as: as, bsPrefix: bsPrefix, variant: variant = 'primary', size: size, active: active = false, disabled: disabled = false, className: className, ...props }, ref)=>{
    const prefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'btn');
    const [buttonProps, { tagName: tagName }] = (0, $cdcb5a6d0dd9d6ce$export$a0ee72f2c720a5c3)({
        tagName: as,
        disabled: disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
    });
});
$23c9a6bed94aa817$var$Button.displayName = 'Button';
var $23c9a6bed94aa817$export$2e2bcd8739ae039 = $23c9a6bed94aa817$var$Button;



var $dNU7X = parcelRequire("dNU7X");


var $dNU7X = parcelRequire("dNU7X");



"use client";
const $35065f18a4e5f9a3$var$CardBody = /*#__PURE__*/ $dNU7X.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'card-body');
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$35065f18a4e5f9a3$var$CardBody.displayName = 'CardBody';
var $35065f18a4e5f9a3$export$2e2bcd8739ae039 = $35065f18a4e5f9a3$var$CardBody;



var $dNU7X = parcelRequire("dNU7X");



"use client";
const $d28e0fcf15181ad0$var$CardFooter = /*#__PURE__*/ $dNU7X.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'card-footer');
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$d28e0fcf15181ad0$var$CardFooter.displayName = 'CardFooter';
var $d28e0fcf15181ad0$export$2e2bcd8739ae039 = $d28e0fcf15181ad0$var$CardFooter;




var $dNU7X = parcelRequire("dNU7X");


var $dNU7X = parcelRequire("dNU7X");
"use client";
const $6b9496ea0bd16a54$var$context = /*#__PURE__*/ $dNU7X.createContext(null);
$6b9496ea0bd16a54$var$context.displayName = 'CardHeaderContext';
var $6b9496ea0bd16a54$export$2e2bcd8739ae039 = $6b9496ea0bd16a54$var$context;



"use client";
const $9942a34c5017b2ce$var$CardHeader = /*#__PURE__*/ $dNU7X.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const prefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'card-header');
    const contextValue = (0, $dNU7X.useMemo)(()=>({
            cardHeaderBsPrefix: prefix
        }), [
        prefix
    ]);
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)((0, $6b9496ea0bd16a54$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, {
            ref: ref,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix)
        })
    });
});
$9942a34c5017b2ce$var$CardHeader.displayName = 'CardHeader';
var $9942a34c5017b2ce$export$2e2bcd8739ae039 = $9942a34c5017b2ce$var$CardHeader;




var $dNU7X = parcelRequire("dNU7X");


"use client";
const $6ec25470060f6639$var$CardImg = /*#__PURE__*/ $dNU7X.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, variant: variant, as: Component = 'img', ...props }, ref)=>{
    const prefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'card-img');
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(variant ? `${prefix}-${variant}` : prefix, className),
        ...props
    });
});
$6ec25470060f6639$var$CardImg.displayName = 'CardImg';
var $6ec25470060f6639$export$2e2bcd8739ae039 = $6ec25470060f6639$var$CardImg;



var $dNU7X = parcelRequire("dNU7X");



"use client";
const $1d0299f9936abf54$var$CardImgOverlay = /*#__PURE__*/ $dNU7X.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'card-img-overlay');
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$1d0299f9936abf54$var$CardImgOverlay.displayName = 'CardImgOverlay';
var $1d0299f9936abf54$export$2e2bcd8739ae039 = $1d0299f9936abf54$var$CardImgOverlay;



var $dNU7X = parcelRequire("dNU7X");



"use client";
const $690852bd17891040$var$CardLink = /*#__PURE__*/ $dNU7X.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'a', ...props }, ref)=>{
    bsPrefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'card-link');
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$690852bd17891040$var$CardLink.displayName = 'CardLink';
var $690852bd17891040$export$2e2bcd8739ae039 = $690852bd17891040$var$CardLink;



var $dNU7X = parcelRequire("dNU7X");



var $dNU7X = parcelRequire("dNU7X");


var $9f4559f6f3060c30$export$2e2bcd8739ae039 = (className)=>/*#__PURE__*/ // eslint-disable-next-line react/display-name
    $dNU7X.forwardRef((p, ref)=>/*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)("div", {
            ...p,
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(p.className, className)
        }));



"use client";
const $c54fbe34273fc468$var$DivStyledAsH6 = (0, $9f4559f6f3060c30$export$2e2bcd8739ae039)('h6');
const $c54fbe34273fc468$var$CardSubtitle = /*#__PURE__*/ $dNU7X.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $c54fbe34273fc468$var$DivStyledAsH6, ...props }, ref)=>{
    bsPrefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'card-subtitle');
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$c54fbe34273fc468$var$CardSubtitle.displayName = 'CardSubtitle';
var $c54fbe34273fc468$export$2e2bcd8739ae039 = $c54fbe34273fc468$var$CardSubtitle;



var $dNU7X = parcelRequire("dNU7X");



"use client";
const $47ca59b8f7d99265$var$CardText = /*#__PURE__*/ $dNU7X.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'p', ...props }, ref)=>{
    bsPrefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'card-text');
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$47ca59b8f7d99265$var$CardText.displayName = 'CardText';
var $47ca59b8f7d99265$export$2e2bcd8739ae039 = $47ca59b8f7d99265$var$CardText;



var $dNU7X = parcelRequire("dNU7X");




"use client";
const $d02780cdf40a4a5a$var$DivStyledAsH5 = (0, $9f4559f6f3060c30$export$2e2bcd8739ae039)('h5');
const $d02780cdf40a4a5a$var$CardTitle = /*#__PURE__*/ $dNU7X.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $d02780cdf40a4a5a$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'card-title');
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$d02780cdf40a4a5a$var$CardTitle.displayName = 'CardTitle';
var $d02780cdf40a4a5a$export$2e2bcd8739ae039 = $d02780cdf40a4a5a$var$CardTitle;



"use client";
const $e391a96e81661736$var$Card = /*#__PURE__*/ $dNU7X.forwardRef(({ bsPrefix: bsPrefix, className: className, bg: bg, text: text, border: border, body: body = false, children: children, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const prefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'card');
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, bg && `bg-${bg}`, text && `text-${text}`, border && `border-${border}`),
        children: body ? /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)((0, $35065f18a4e5f9a3$export$2e2bcd8739ae039), {
            children: children
        }) : children
    });
});
$e391a96e81661736$var$Card.displayName = 'Card';
var $e391a96e81661736$export$2e2bcd8739ae039 = Object.assign($e391a96e81661736$var$Card, {
    Img: (0, $6ec25470060f6639$export$2e2bcd8739ae039),
    Title: (0, $d02780cdf40a4a5a$export$2e2bcd8739ae039),
    Subtitle: (0, $c54fbe34273fc468$export$2e2bcd8739ae039),
    Body: (0, $35065f18a4e5f9a3$export$2e2bcd8739ae039),
    Link: (0, $690852bd17891040$export$2e2bcd8739ae039),
    Text: (0, $47ca59b8f7d99265$export$2e2bcd8739ae039),
    Header: (0, $9942a34c5017b2ce$export$2e2bcd8739ae039),
    Footer: (0, $d28e0fcf15181ad0$export$2e2bcd8739ae039),
    ImgOverlay: (0, $1d0299f9936abf54$export$2e2bcd8739ae039)
});



var $dNU7X = parcelRequire("dNU7X");


"use client";
function $786b27ba1fa4676b$export$2ed43d61a0a9f5a3({ as: as, bsPrefix: bsPrefix, className: className, ...props }) {
    bsPrefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'col');
    const breakpoints = (0, $4843567570d88909$export$8970c8db816a5863)();
    const minBreakpoint = (0, $4843567570d88909$export$d926d6ef38f3fd32)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === 'object' && propValue != null) ({ span: span, offset: offset, order: order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, ...spans, ...classes)
        },
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
const $786b27ba1fa4676b$var$Col = /*#__PURE__*/ $dNU7X.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className: className, ...colProps }, { as: Component = 'div', bsPrefix: bsPrefix, spans: spans }] = $786b27ba1fa4676b$export$2ed43d61a0a9f5a3(props);
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, {
        ...colProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, !spans.length && bsPrefix)
    });
});
$786b27ba1fa4676b$var$Col.displayName = 'Col';
var $786b27ba1fa4676b$export$2e2bcd8739ae039 = $786b27ba1fa4676b$var$Col;



var $dNU7X = parcelRequire("dNU7X");
var $e756898da11911b9$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $e756898da11911b9$export$2e2bcd8739ae039(element, selector) {
    return $e756898da11911b9$var$toArray(element.querySelectorAll(selector));
}


/* eslint-disable no-return-assign */ var $c36f36ded4bef1c0$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $7e72389cdcb8fa2e$export$63fefd044b2bc624 = false;
var $7e72389cdcb8fa2e$export$a614c6b395900f69 = false;
try {
    var $7e72389cdcb8fa2e$var$options = {
        get passive () {
            return $7e72389cdcb8fa2e$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $7e72389cdcb8fa2e$export$a614c6b395900f69 = $7e72389cdcb8fa2e$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $c36f36ded4bef1c0$export$2e2bcd8739ae039) {
        window.addEventListener('test', $7e72389cdcb8fa2e$var$options, $7e72389cdcb8fa2e$var$options);
        window.removeEventListener('test', $7e72389cdcb8fa2e$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $7e72389cdcb8fa2e$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$7e72389cdcb8fa2e$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$7e72389cdcb8fa2e$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $7e72389cdcb8fa2e$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $7e72389cdcb8fa2e$export$2e2bcd8739ae039 = $7e72389cdcb8fa2e$var$addEventListener;



var $dNU7X = parcelRequire("dNU7X");

var $dNU7X = parcelRequire("dNU7X");
function $02389d6585ed519e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $02389d6585ed519e$var$_toPropertyKey(arg) {
    var key = $02389d6585ed519e$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $02389d6585ed519e$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $02389d6585ed519e$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $02389d6585ed519e$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    const wasPropRef = (0, $dNU7X.useRef)(propValue !== undefined);
    const [stateValue, setState] = (0, $dNU7X.useState)(defaultValue);
    const isProp = propValue !== undefined;
    const wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $dNU7X.useCallback)((...args)=>{
            const [value, ...rest] = args;
            let returnValue = handler == null ? void 0 : handler(value, ...rest);
            setState(value);
            return returnValue;
        }, [
            handler
        ])
    ];
}
function $02389d6585ed519e$export$ec55e9daaf703a7d(props, config) {
    return Object.keys(config).reduce((result, fieldName)=>{
        const _ref = result, _defaultKey = $02389d6585ed519e$export$26cbf8c37e721e67(fieldName), { [_defaultKey]: defaultValue, [fieldName]: propsValue } = _ref, rest = $02389d6585ed519e$var$_objectWithoutPropertiesLoose(_ref, [
            _defaultKey,
            fieldName
        ].map($02389d6585ed519e$var$_toPropertyKey));
        const handlerName = config[fieldName];
        const [value, handler] = $02389d6585ed519e$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]);
        return Object.assign({}, rest, {
            [fieldName]: value,
            [handlerName]: handler
        });
    }, props);
}



var $dNU7X = parcelRequire("dNU7X");
function $29c0e647ade0bf2a$export$2e2bcd8739ae039(value) {
    const ref = (0, $dNU7X.useRef)(null);
    (0, $dNU7X.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}



var $dNU7X = parcelRequire("dNU7X");
function $a1e7dfea23729a9b$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $dNU7X.useReducer)((revision)=>revision + 1, 0);
    return dispatch;
}



var $dNU7X = parcelRequire("dNU7X");

var $dNU7X = parcelRequire("dNU7X");

var $dNU7X = parcelRequire("dNU7X");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $65e37d7354dfd4b8$var$useCommittedRef(value) {
    const ref = (0, $dNU7X.useRef)(value);
    (0, $dNU7X.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $65e37d7354dfd4b8$export$2e2bcd8739ae039 = $65e37d7354dfd4b8$var$useCommittedRef;


function $5c6b416708f5301c$export$2e2bcd8739ae039(fn) {
    const ref = (0, $65e37d7354dfd4b8$export$2e2bcd8739ae039)(fn);
    return (0, $dNU7X.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}


function $c88bb54f5a78bc79$export$2e2bcd8739ae039(eventTarget, event, listener, capture = false) {
    const handler = (0, $5c6b416708f5301c$export$2e2bcd8739ae039)(listener);
    (0, $dNU7X.useEffect)(()=>{
        const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}




var $dNU7X = parcelRequire("dNU7X");
const $09485616992a198b$var$DropdownContext = /*#__PURE__*/ $dNU7X.createContext(null);
var $09485616992a198b$export$2e2bcd8739ae039 = $09485616992a198b$var$DropdownContext;



var $dNU7X = parcelRequire("dNU7X");

var $dNU7X = parcelRequire("dNU7X");
function $ff7c1391d2bce6e2$export$2e2bcd8739ae039() {
    return (0, $dNU7X.useState)(null);
}




var $dNU7X = parcelRequire("dNU7X");
var $9b8288c93dde0611$var$has = Object.prototype.hasOwnProperty;
function $9b8288c93dde0611$var$find(iter, tar, key) {
    for (key of iter.keys()){
        if ($9b8288c93dde0611$export$de8294bb3be0322f(key, tar)) return key;
    }
}
function $9b8288c93dde0611$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $9b8288c93dde0611$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === 'object') {
                    tmp = $9b8288c93dde0611$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === 'object') {
                    tmp = $9b8288c93dde0611$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!$9b8288c93dde0611$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($9b8288c93dde0611$var$has.call(foo, ctor) && ++len && !$9b8288c93dde0611$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$9b8288c93dde0611$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}



var $dNU7X = parcelRequire("dNU7X");

var $dNU7X = parcelRequire("dNU7X");
function $58b28b5efd41631b$export$2e2bcd8739ae039() {
    const mounted = (0, $dNU7X.useRef)(true);
    const isMounted = (0, $dNU7X.useRef)(()=>mounted.current);
    (0, $dNU7X.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}


/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $57232c34cff9ab22$var$useSafeState(state) {
    const isMounted = (0, $58b28b5efd41631b$export$2e2bcd8739ae039)();
    return [
        state[0],
        (0, $dNU7X.useCallback)((nextState)=>{
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $57232c34cff9ab22$export$2e2bcd8739ae039 = $57232c34cff9ab22$var$useSafeState;



function $3b8fe2dc5ff68c07$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $d73e6687a1d925d1$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $b2a82a0945aa8fd0$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $b2a82a0945aa8fd0$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $049d14be9b4f15bb$export$8960430cfd85939f = Math.max;
var $049d14be9b4f15bb$export$96ec731ed4dcb222 = Math.min;
var $049d14be9b4f15bb$export$2077e0241d6afd3c = Math.round;



function $17847447eb3676eb$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $3822c5a08263882b$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $17847447eb3676eb$export$2e2bcd8739ae039)());
}


function $28398e533bd4cb4a$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(element) ? (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $3822c5a08263882b$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $0c96e22a9b1659c4$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $edb26c5020cedcb8$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $b2a82a0945aa8fd0$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $37108a593d5d5f50$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}



function $d62284b4ca370c21$export$2e2bcd8739ae039(element) {
    return (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $94c820df5d403ed2$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(element)) >= 0;
}




function $939c0e8e0ce2cee6$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $f85bc6099bdeb764$export$2e2bcd8739ae039(element) {
    if ((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $b2a82a0945aa8fd0$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $8debf15f2d350881$var$getTrueOffsetParent(element) {
    if (!(0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $8debf15f2d350881$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $17847447eb3676eb$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $17847447eb3676eb$export$2e2bcd8739ae039)());
    if (isIE && (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $f85bc6099bdeb764$export$2e2bcd8739ae039)(element);
    if ((0, $b2a82a0945aa8fd0$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $8debf15f2d350881$export$2e2bcd8739ae039(element) {
    var window = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(element);
    var offsetParent = $8debf15f2d350881$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $94c820df5d403ed2$export$2e2bcd8739ae039)(offsetParent) && (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $8debf15f2d350881$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $37108a593d5d5f50$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $8debf15f2d350881$var$getContainingBlock(element) || window;
}


function $f69c37e7bc9eb348$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $32a9692ec37d141e$export$f28d906d67a997f3(min, value, max) {
    return (0, $049d14be9b4f15bb$export$8960430cfd85939f)(min, (0, $049d14be9b4f15bb$export$96ec731ed4dcb222)(value, max));
}
function $32a9692ec37d141e$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $32a9692ec37d141e$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $559cca984964a2c1$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $4e3f355f6e420d75$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $559cca984964a2c1$export$2e2bcd8739ae039)(), paddingObject);
}


function $868fda9c4887b436$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


var $961d5315ffabf519$export$1e95b668f3b82d = 'top';
var $961d5315ffabf519$export$40e543e69a8b3fbb = 'bottom';
var $961d5315ffabf519$export$79ffe56a765070d2 = 'right';
var $961d5315ffabf519$export$eabcd2c8791e7bf4 = 'left';
var $961d5315ffabf519$export$dfb5619354ba860 = 'auto';
var $961d5315ffabf519$export$aec2ce47c367b8c3 = [
    $961d5315ffabf519$export$1e95b668f3b82d,
    $961d5315ffabf519$export$40e543e69a8b3fbb,
    $961d5315ffabf519$export$79ffe56a765070d2,
    $961d5315ffabf519$export$eabcd2c8791e7bf4
];
var $961d5315ffabf519$export$b3571188c770cc5a = 'start';
var $961d5315ffabf519$export$bd5df0f255a350f8 = 'end';
var $961d5315ffabf519$export$390fd549c5303b4d = 'clippingParents';
var $961d5315ffabf519$export$d7b7311ec04a3e8f = 'viewport';
var $961d5315ffabf519$export$ae5ab1c730825774 = 'popper';
var $961d5315ffabf519$export$ca50aac9f3ba507f = 'reference';
var $961d5315ffabf519$export$368f9a87e87fa4e1 = /*#__PURE__*/ $961d5315ffabf519$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $961d5315ffabf519$export$b3571188c770cc5a,
        placement + "-" + $961d5315ffabf519$export$bd5df0f255a350f8
    ]);
}, []);
var $961d5315ffabf519$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($961d5315ffabf519$export$aec2ce47c367b8c3, [
    $961d5315ffabf519$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $961d5315ffabf519$export$b3571188c770cc5a,
        placement + "-" + $961d5315ffabf519$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $961d5315ffabf519$export$421679a7c3d56e = 'beforeRead';
var $961d5315ffabf519$export$aafa59e2e03f2942 = 'read';
var $961d5315ffabf519$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $961d5315ffabf519$export$c65e99957a05207c = 'beforeMain';
var $961d5315ffabf519$export$f22da7240b7add18 = 'main';
var $961d5315ffabf519$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $961d5315ffabf519$export$8d4d2d70e7d46032 = 'beforeWrite';
var $961d5315ffabf519$export$68d8715fc104d294 = 'write';
var $961d5315ffabf519$export$70a6e5159acce2e6 = 'afterWrite';
var $961d5315ffabf519$export$d087d3878fdf71d5 = [
    $961d5315ffabf519$export$421679a7c3d56e,
    $961d5315ffabf519$export$aafa59e2e03f2942,
    $961d5315ffabf519$export$6964f6c886723980,
    $961d5315ffabf519$export$c65e99957a05207c,
    $961d5315ffabf519$export$f22da7240b7add18,
    $961d5315ffabf519$export$bab79516f2d662fe,
    $961d5315ffabf519$export$8d4d2d70e7d46032,
    $961d5315ffabf519$export$68d8715fc104d294,
    $961d5315ffabf519$export$70a6e5159acce2e6
];


var $48ddd81393695a53$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $4e3f355f6e420d75$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $868fda9c4887b436$export$2e2bcd8739ae039)(padding, (0, $961d5315ffabf519$export$aec2ce47c367b8c3)));
};
function $48ddd81393695a53$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $f69c37e7bc9eb348$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $961d5315ffabf519$export$eabcd2c8791e7bf4),
        (0, $961d5315ffabf519$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $48ddd81393695a53$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $0c96e22a9b1659c4$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $961d5315ffabf519$export$1e95b668f3b82d) : (0, $961d5315ffabf519$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $961d5315ffabf519$export$40e543e69a8b3fbb) : (0, $961d5315ffabf519$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $8debf15f2d350881$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $32a9692ec37d141e$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $48ddd81393695a53$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $edb26c5020cedcb8$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $48ddd81393695a53$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $48ddd81393695a53$var$arrow,
    effect: $48ddd81393695a53$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $41cccd7fabe05f63$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $bbe366718497d634$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $bbe366718497d634$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $bbe366718497d634$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $961d5315ffabf519$export$eabcd2c8791e7bf4);
    var sideY = (0, $961d5315ffabf519$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $8debf15f2d350881$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(popper);
            if ((0, $d62284b4ca370c21$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $961d5315ffabf519$export$1e95b668f3b82d) || (placement === (0, $961d5315ffabf519$export$eabcd2c8791e7bf4) || placement === (0, $961d5315ffabf519$export$79ffe56a765070d2)) && variation === (0, $961d5315ffabf519$export$bd5df0f255a350f8)) {
            sideY = (0, $961d5315ffabf519$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $961d5315ffabf519$export$eabcd2c8791e7bf4) || (placement === (0, $961d5315ffabf519$export$1e95b668f3b82d) || placement === (0, $961d5315ffabf519$export$40e543e69a8b3fbb)) && variation === (0, $961d5315ffabf519$export$bd5df0f255a350f8)) {
            sideX = (0, $961d5315ffabf519$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $bbe366718497d634$var$unsetSides);
    var _ref4 = roundOffsets === true ? $bbe366718497d634$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $bbe366718497d634$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $bbe366718497d634$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $bbe366718497d634$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $bbe366718497d634$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $bbe366718497d634$var$computeStyles,
    data: {}
};



var $7bec2a6e2c97de64$var$passive = {
    passive: true
};
function $7bec2a6e2c97de64$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $7bec2a6e2c97de64$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $7bec2a6e2c97de64$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $7bec2a6e2c97de64$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $7bec2a6e2c97de64$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $7bec2a6e2c97de64$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $7bec2a6e2c97de64$var$effect,
    data: {}
};


var $895264d7f1285abd$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $895264d7f1285abd$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $895264d7f1285abd$var$hash[matched];
    });
}



var $3190ee6894c64586$var$hash = {
    start: 'end',
    end: 'start'
};
function $3190ee6894c64586$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $3190ee6894c64586$var$hash[matched];
    });
}








function $e826853427a61d24$export$2e2bcd8739ae039(node) {
    var win = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $53712d9fbfe608a5$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)((0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element)).left + (0, $e826853427a61d24$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $4c6294ad0a5a884e$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(element);
    var html = (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $3822c5a08263882b$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $53712d9fbfe608a5$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $32cb83235cf6af6b$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $e826853427a61d24$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $049d14be9b4f15bb$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $049d14be9b4f15bb$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $53712d9fbfe608a5$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $d62284b4ca370c21$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $049d14be9b4f15bb$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $c3a6bf84ff18f738$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $d62284b4ca370c21$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $a31d6136541392dc$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(node) && (0, $c3a6bf84ff18f738$export$2e2bcd8739ae039)(node)) return node;
    return $a31d6136541392dc$export$2e2bcd8739ae039((0, $f85bc6099bdeb764$export$2e2bcd8739ae039)(node));
}





function $c6fcb9ddb0a619f3$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $a31d6136541392dc$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $c3a6bf84ff18f738$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($c6fcb9ddb0a619f3$export$2e2bcd8739ae039((0, $f85bc6099bdeb764$export$2e2bcd8739ae039)(target)));
}










function $2f76e9cca25369aa$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $3ed34baa7075c065$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $3ed34baa7075c065$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $961d5315ffabf519$export$d7b7311ec04a3e8f) ? (0, $2f76e9cca25369aa$export$2e2bcd8739ae039)((0, $4c6294ad0a5a884e$export$2e2bcd8739ae039)(element, strategy)) : (0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(clippingParent) ? $3ed34baa7075c065$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $2f76e9cca25369aa$export$2e2bcd8739ae039)((0, $32cb83235cf6af6b$export$2e2bcd8739ae039)((0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $3ed34baa7075c065$var$getClippingParents(element) {
    var clippingParents = (0, $c6fcb9ddb0a619f3$export$2e2bcd8739ae039)((0, $f85bc6099bdeb764$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $d62284b4ca370c21$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(element) ? (0, $8debf15f2d350881$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(clippingParent) && (0, $edb26c5020cedcb8$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $37108a593d5d5f50$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $3ed34baa7075c065$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $3ed34baa7075c065$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $3ed34baa7075c065$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $049d14be9b4f15bb$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $049d14be9b4f15bb$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $049d14be9b4f15bb$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $049d14be9b4f15bb$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $3ed34baa7075c065$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $5abf2ff6da597e22$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $961d5315ffabf519$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $961d5315ffabf519$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $961d5315ffabf519$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $961d5315ffabf519$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $f69c37e7bc9eb348$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $961d5315ffabf519$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $961d5315ffabf519$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $f4983c2f7b82930e$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $961d5315ffabf519$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $961d5315ffabf519$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $961d5315ffabf519$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $4e3f355f6e420d75$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $868fda9c4887b436$export$2e2bcd8739ae039)(padding, (0, $961d5315ffabf519$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $961d5315ffabf519$export$ae5ab1c730825774) ? (0, $961d5315ffabf519$export$ca50aac9f3ba507f) : (0, $961d5315ffabf519$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $3ed34baa7075c065$export$2e2bcd8739ae039)((0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $5abf2ff6da597e22$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $2f76e9cca25369aa$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $961d5315ffabf519$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $961d5315ffabf519$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $961d5315ffabf519$export$79ffe56a765070d2),
                (0, $961d5315ffabf519$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $961d5315ffabf519$export$1e95b668f3b82d),
                (0, $961d5315ffabf519$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $5f0f7fd33e6df374$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $961d5315ffabf519$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $961d5315ffabf519$export$368f9a87e87fa4e1) : (0, $961d5315ffabf519$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $961d5315ffabf519$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $7261bb7a28c6c261$var$getExpandedFallbackPlacements(placement) {
    if ((0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement) === (0, $961d5315ffabf519$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $895264d7f1285abd$export$2e2bcd8739ae039)(placement);
    return [
        (0, $3190ee6894c64586$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $3190ee6894c64586$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $7261bb7a28c6c261$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $895264d7f1285abd$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $7261bb7a28c6c261$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement) === (0, $961d5315ffabf519$export$dfb5619354ba860) ? (0, $5f0f7fd33e6df374$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(placement) === (0, $961d5315ffabf519$export$b3571188c770cc5a);
        var isVertical = [
            (0, $961d5315ffabf519$export$1e95b668f3b82d),
            (0, $961d5315ffabf519$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $961d5315ffabf519$export$79ffe56a765070d2) : (0, $961d5315ffabf519$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $961d5315ffabf519$export$40e543e69a8b3fbb) : (0, $961d5315ffabf519$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $895264d7f1285abd$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $895264d7f1285abd$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $7261bb7a28c6c261$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $7261bb7a28c6c261$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $d7d2695ea28b2aa6$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $d7d2695ea28b2aa6$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $961d5315ffabf519$export$1e95b668f3b82d),
        (0, $961d5315ffabf519$export$79ffe56a765070d2),
        (0, $961d5315ffabf519$export$40e543e69a8b3fbb),
        (0, $961d5315ffabf519$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $d7d2695ea28b2aa6$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $d7d2695ea28b2aa6$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $d7d2695ea28b2aa6$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $d7d2695ea28b2aa6$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $d7d2695ea28b2aa6$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $d7d2695ea28b2aa6$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $d7d2695ea28b2aa6$var$hide
};




function $6137a161b4896709$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $961d5315ffabf519$export$eabcd2c8791e7bf4),
        (0, $961d5315ffabf519$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $961d5315ffabf519$export$eabcd2c8791e7bf4),
        (0, $961d5315ffabf519$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $6137a161b4896709$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $961d5315ffabf519$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $6137a161b4896709$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $6137a161b4896709$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $6137a161b4896709$var$offset
};



function $fd3370820cf4bcb1$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $5abf2ff6da597e22$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $fd3370820cf4bcb1$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $fd3370820cf4bcb1$var$popperOffsets,
    data: {}
};





function $45abdfcc61968a12$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $9d3c739e2059661f$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $f4983c2f7b82930e$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $3b8fe2dc5ff68c07$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $41cccd7fabe05f63$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $f69c37e7bc9eb348$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $45abdfcc61968a12$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $961d5315ffabf519$export$1e95b668f3b82d) : (0, $961d5315ffabf519$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $961d5315ffabf519$export$40e543e69a8b3fbb) : (0, $961d5315ffabf519$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $961d5315ffabf519$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $961d5315ffabf519$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $0c96e22a9b1659c4$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $559cca984964a2c1$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $32a9692ec37d141e$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $8debf15f2d350881$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $32a9692ec37d141e$export$f28d906d67a997f3)(tether ? (0, $049d14be9b4f15bb$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $049d14be9b4f15bb$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $961d5315ffabf519$export$1e95b668f3b82d) : (0, $961d5315ffabf519$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $961d5315ffabf519$export$40e543e69a8b3fbb) : (0, $961d5315ffabf519$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $961d5315ffabf519$export$1e95b668f3b82d),
            (0, $961d5315ffabf519$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $32a9692ec37d141e$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $32a9692ec37d141e$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $9d3c739e2059661f$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $9d3c739e2059661f$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};







function $9f852250855e3d87$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $b434581b465cb432$export$2e2bcd8739ae039(node) {
    if (node === (0, $d73e6687a1d925d1$export$2e2bcd8739ae039)(node) || !(0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(node)) return (0, $e826853427a61d24$export$2e2bcd8739ae039)(node);
    else return (0, $9f852250855e3d87$export$2e2bcd8739ae039)(node);
}








function $dbf000ff4b3c4664$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $049d14be9b4f15bb$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $dbf000ff4b3c4664$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(offsetParent) && $dbf000ff4b3c4664$var$isElementScaled(offsetParent);
    var documentElement = (0, $939c0e8e0ce2cee6$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $37108a593d5d5f50$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $c3a6bf84ff18f738$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $b434581b465cb432$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $b2a82a0945aa8fd0$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $28398e533bd4cb4a$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $53712d9fbfe608a5$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $7fa7d91227c213a7$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $7fa7d91227c213a7$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $7fa7d91227c213a7$var$order(modifiers); // order based on phase
    return (0, $961d5315ffabf519$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $348b53990a67b9f2$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $79e2fb482cad3d90$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $b0054ad10f2e8753$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $b0054ad10f2e8753$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $b0054ad10f2e8753$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $b0054ad10f2e8753$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $b0054ad10f2e8753$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $b2a82a0945aa8fd0$export$45a5e7f76e0caa8d)(reference) ? (0, $c6fcb9ddb0a619f3$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $c6fcb9ddb0a619f3$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $c6fcb9ddb0a619f3$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $7fa7d91227c213a7$export$2e2bcd8739ae039)((0, $79e2fb482cad3d90$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$b0054ad10f2e8753$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $dbf000ff4b3c4664$export$2e2bcd8739ae039)(reference, (0, $8debf15f2d350881$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $0c96e22a9b1659c4$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $348b53990a67b9f2$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$b0054ad10f2e8753$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $b0054ad10f2e8753$export$8f7491d57c8f97a9 = /*#__PURE__*/ $b0054ad10f2e8753$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules


const $5bec18f0af4b4d07$export$8f7491d57c8f97a9 = (0, $b0054ad10f2e8753$export$ed5e13716264f202)({
    defaultModifiers: [
        (0, $d7d2695ea28b2aa6$export$2e2bcd8739ae039),
        (0, $fd3370820cf4bcb1$export$2e2bcd8739ae039),
        (0, $bbe366718497d634$export$2e2bcd8739ae039),
        (0, $7bec2a6e2c97de64$export$2e2bcd8739ae039),
        (0, $6137a161b4896709$export$2e2bcd8739ae039),
        (0, $7261bb7a28c6c261$export$2e2bcd8739ae039),
        (0, $9d3c739e2059661f$export$2e2bcd8739ae039),
        (0, $48ddd81393695a53$export$2e2bcd8739ae039)
    ]
});


const $16b0f98161552fa4$var$_excluded = [
    "enabled",
    "placement",
    "strategy",
    "modifiers"
];
function $16b0f98161552fa4$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $16b0f98161552fa4$var$disabledApplyStylesModifier = {
    name: 'applyStyles',
    enabled: false,
    phase: 'afterWrite',
    fn: ()=>undefined
};
// until docjs supports type exports...
const $16b0f98161552fa4$var$ariaDescribedByModifier = {
    name: 'ariaDescribedBy',
    enabled: true,
    phase: 'afterWrite',
    effect: ({ state: state })=>()=>{
            const { reference: reference, popper: popper } = state.elements;
            if ('removeAttribute' in reference) {
                const ids = (reference.getAttribute('aria-describedby') || '').split(',').filter((id)=>id.trim() !== popper.id);
                if (!ids.length) reference.removeAttribute('aria-describedby');
                else reference.setAttribute('aria-describedby', ids.join(','));
            }
        },
    fn: ({ state: state })=>{
        var _popper$getAttribute;
        const { popper: popper, reference: reference } = state.elements;
        const role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
            const ids = reference.getAttribute('aria-describedby');
            if (ids && ids.split(',').indexOf(popper.id) !== -1) return;
            reference.setAttribute('aria-describedby', ids ? `${ids},${popper.id}` : popper.id);
        }
    }
};
const $16b0f98161552fa4$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $16b0f98161552fa4$var$usePopper(referenceElement, popperElement, _ref = {}) {
    let { enabled: enabled = true, placement: placement = 'bottom', strategy: strategy = 'absolute', modifiers: modifiers = $16b0f98161552fa4$var$EMPTY_MODIFIERS } = _ref, config = $16b0f98161552fa4$var$_objectWithoutPropertiesLoose(_ref, $16b0f98161552fa4$var$_excluded);
    const prevModifiers = (0, $dNU7X.useRef)(modifiers);
    const popperInstanceRef = (0, $dNU7X.useRef)();
    const update = (0, $dNU7X.useCallback)(()=>{
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    const forceUpdate = (0, $dNU7X.useCallback)(()=>{
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    const [popperState, setState] = (0, $57232c34cff9ab22$export$2e2bcd8739ae039)((0, $dNU7X.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: {},
            arrow: {}
        }
    }));
    const updateModifier = (0, $dNU7X.useMemo)(()=>({
            name: 'updateStateModifier',
            enabled: true,
            phase: 'write',
            requires: [
                'computeStyles'
            ],
            fn: ({ state: state })=>{
                const styles = {};
                const attributes = {};
                Object.keys(state.elements).forEach((element)=>{
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        }), [
        update,
        forceUpdate,
        setState
    ]);
    const nextModifiers = (0, $dNU7X.useMemo)(()=>{
        if (!(0, $9b8288c93dde0611$export$de8294bb3be0322f)(prevModifiers.current, modifiers)) prevModifiers.current = modifiers;
        return prevModifiers.current;
    }, [
        modifiers
    ]);
    (0, $dNU7X.useEffect)(()=>{
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                updateModifier,
                $16b0f98161552fa4$var$disabledApplyStylesModifier
            ]
        });
    }, [
        strategy,
        placement,
        updateModifier,
        enabled,
        nextModifiers
    ]);
    (0, $dNU7X.useEffect)(()=>{
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $5bec18f0af4b4d07$export$8f7491d57c8f97a9)(referenceElement, popperElement, Object.assign({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                $16b0f98161552fa4$var$ariaDescribedByModifier,
                updateModifier
            ]
        }));
        return ()=>{
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState((s)=>Object.assign({}, s, {
                        attributes: {},
                        styles: {
                            popper: {}
                        }
                    }));
            }
        };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $16b0f98161552fa4$export$2e2bcd8739ae039 = $16b0f98161552fa4$var$usePopper;


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $97c75dca58f4c376$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}



/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $1570e8bef8c3dfba$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $1570e8bef8c3dfba$export$2e2bcd8739ae039 = $1570e8bef8c3dfba$var$removeEventListener;


function $e30c1a8b3e180f01$var$listen(node, eventName, handler, options) {
    (0, $7e72389cdcb8fa2e$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $1570e8bef8c3dfba$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $e30c1a8b3e180f01$export$2e2bcd8739ae039 = $e30c1a8b3e180f01$var$listen;


/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $e2f451e3d449ae45$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}



var $dNU7X = parcelRequire("dNU7X");

var $9abc3dc86fc6eb1f$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $9abc3dc86fc6eb1f$var$__DEV__ = false;
var $9abc3dc86fc6eb1f$var$warning = function() {};
if ($9abc3dc86fc6eb1f$var$__DEV__) {
    var $9abc3dc86fc6eb1f$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $9abc3dc86fc6eb1f$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $9abc3dc86fc6eb1f$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$9abc3dc86fc6eb1f$exports = $9abc3dc86fc6eb1f$var$warning;


const $1379e664ae58b1e2$var$noop = ()=>{};
function $1379e664ae58b1e2$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $1379e664ae58b1e2$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const $1379e664ae58b1e2$export$347601c75fcd4732 = (ref)=>ref && ('current' in ref ? ref.current : ref);
const $1379e664ae58b1e2$var$InitialTriggerEvents = {
    click: 'mousedown',
    mouseup: 'mousedown',
    pointerup: 'pointerdown'
};
/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $1379e664ae58b1e2$var$useClickOutside(ref, onClickOutside = $1379e664ae58b1e2$var$noop, { disabled: disabled, clickTrigger: clickTrigger = 'click' } = {}) {
    const preventMouseClickOutsideRef = (0, $dNU7X.useRef)(false);
    const waitingForTrigger = (0, $dNU7X.useRef)(false);
    const handleMouseCapture = (0, $dNU7X.useCallback)((e)=>{
        const currentTarget = $1379e664ae58b1e2$export$347601c75fcd4732(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($9abc3dc86fc6eb1f$exports)))(!!currentTarget, "ClickOutside captured a close event but does not have a ref to compare it to. useClickOutside(), should be passed a ref that resolves to a DOM node");
        preventMouseClickOutsideRef.current = !currentTarget || $1379e664ae58b1e2$var$isModifiedEvent(e) || !$1379e664ae58b1e2$var$isLeftClickEvent(e) || !!(0, $97c75dca58f4c376$export$2e2bcd8739ae039)(currentTarget, e.target) || waitingForTrigger.current;
        waitingForTrigger.current = false;
    }, [
        ref
    ]);
    const handleInitialMouse = (0, $5c6b416708f5301c$export$2e2bcd8739ae039)((e)=>{
        const currentTarget = $1379e664ae58b1e2$export$347601c75fcd4732(ref);
        if (currentTarget && (0, $97c75dca58f4c376$export$2e2bcd8739ae039)(currentTarget, e.target)) waitingForTrigger.current = true;
        else // When clicking on scrollbars within current target, click events are not triggered, so this ref
        // is never reset inside `handleMouseCapture`. This would cause a bug where it requires 2 clicks
        // to close the overlay.
        waitingForTrigger.current = false;
    });
    const handleMouse = (0, $5c6b416708f5301c$export$2e2bcd8739ae039)((e)=>{
        if (!preventMouseClickOutsideRef.current) onClickOutside(e);
    });
    (0, $dNU7X.useEffect)(()=>{
        var _ownerWindow$event, _ownerWindow$parent;
        if (disabled || ref == null) return undefined;
        const doc = (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)($1379e664ae58b1e2$export$347601c75fcd4732(ref));
        const ownerWindow = doc.defaultView || window;
        // Store the current event to avoid triggering handlers immediately
        // For things rendered in an iframe, the event might originate on the parent window
        // so we should fall back to that global event if the local one doesn't exist
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
        let removeInitialTriggerListener = null;
        if ($1379e664ae58b1e2$var$InitialTriggerEvents[clickTrigger]) removeInitialTriggerListener = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(doc, $1379e664ae58b1e2$var$InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
        // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        const removeMouseCaptureListener = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(doc, clickTrigger, handleMouseCapture, true);
        const removeMouseListener = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(doc, clickTrigger, (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        let mobileSafariHackListeners = [];
        if ('ontouchstart' in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map((el)=>(0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(el, 'mousemove', $1379e664ae58b1e2$var$noop));
        return ()=>{
            removeInitialTriggerListener == null || removeInitialTriggerListener();
            removeMouseCaptureListener();
            removeMouseListener();
            mobileSafariHackListeners.forEach((remove)=>remove());
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleInitialMouse,
        handleMouse
    ]);
}
var $1379e664ae58b1e2$export$2e2bcd8739ae039 = $1379e664ae58b1e2$var$useClickOutside;


function $fc7c8a8c537ddccf$export$ba6dad097c8f5c38(modifiers) {
    const result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
    // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach((m)=>{
        result[m.name] = m;
    });
    return result;
}
function $fc7c8a8c537ddccf$export$af3a999d4a134c86(map = {}) {
    if (Array.isArray(map)) return map;
    return Object.keys(map).map((k)=>{
        map[k].name = k;
        return map[k];
    });
}
function $fc7c8a8c537ddccf$export$2e2bcd8739ae039({ enabled: enabled, enableEvents: enableEvents, placement: placement, flip: flip, offset: offset, fixed: fixed, containerPadding: containerPadding, arrowElement: arrowElement, popperConfig: popperConfig = {} }) {
    var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    const modifiers = $fc7c8a8c537ddccf$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return Object.assign({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? 'fixed' : popperConfig.strategy,
        modifiers: $fc7c8a8c537ddccf$export$af3a999d4a134c86(Object.assign({}, modifiers, {
            eventListeners: {
                enabled: enableEvents,
                options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
            },
            preventOverflow: Object.assign({}, modifiers.preventOverflow, {
                options: containerPadding ? Object.assign({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: Object.assign({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: Object.assign({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: Object.assign({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}



const $f10376ae5d735f71$var$_excluded = [
    "children",
    "usePopper"
];
function $f10376ae5d735f71$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $f10376ae5d735f71$var$noop = ()=>{};
function $f10376ae5d735f71$export$133c4d08f3775d64(options = {}) {
    const context = (0, $dNU7X.useContext)((0, $09485616992a198b$export$2e2bcd8739ae039));
    const [arrowElement, attachArrowRef] = (0, $ff7c1391d2bce6e2$export$2e2bcd8739ae039)();
    const hasShownRef = (0, $dNU7X.useRef)(false);
    const { flip: flip, offset: offset, rootCloseEvent: rootCloseEvent, fixed: fixed = false, placement: placementOverride, popperConfig: popperConfig = {}, enableEventListeners: enableEventListeners = true, usePopper: shouldUsePopper = !!context } = options;
    const show = (context == null ? void 0 : context.show) == null ? !!options.show : context.show;
    if (show && !hasShownRef.current) hasShownRef.current = true;
    const handleClose = (e)=>{
        context == null || context.toggle(false, e);
    };
    const { placement: placement, setMenu: setMenu, menuElement: menuElement, toggleElement: toggleElement } = context || {};
    const popper = (0, $16b0f98161552fa4$export$2e2bcd8739ae039)(toggleElement, menuElement, (0, $fc7c8a8c537ddccf$export$2e2bcd8739ae039)({
        placement: placementOverride || placement || 'bottom-start',
        enabled: shouldUsePopper,
        enableEvents: enableEventListeners == null ? show : enableEventListeners,
        offset: offset,
        flip: flip,
        fixed: fixed,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    const menuProps = Object.assign({
        ref: setMenu || $f10376ae5d735f71$var$noop,
        'aria-labelledby': toggleElement == null ? void 0 : toggleElement.id
    }, popper.attributes.popper, {
        style: popper.styles.popper
    });
    const metadata = {
        show: show,
        placement: placement,
        hasShown: hasShownRef.current,
        toggle: context == null ? void 0 : context.toggle,
        popper: shouldUsePopper ? popper : null,
        arrowProps: shouldUsePopper ? Object.assign({
            ref: attachArrowRef
        }, popper.attributes.arrow, {
            style: popper.styles.arrow
        }) : {}
    };
    (0, $1379e664ae58b1e2$export$2e2bcd8739ae039)(menuElement, handleClose, {
        clickTrigger: rootCloseEvent,
        disabled: !show
    });
    return [
        menuProps,
        metadata
    ];
}
/**
 * Also exported as `<Dropdown.Menu>` from `Dropdown`.
 *
 * @displayName DropdownMenu
 * @memberOf Dropdown
 */ function $f10376ae5d735f71$var$DropdownMenu(_ref) {
    let { children: children, usePopper: usePopperProp = true } = _ref, options = $f10376ae5d735f71$var$_objectWithoutPropertiesLoose(_ref, $f10376ae5d735f71$var$_excluded);
    const [props, meta] = $f10376ae5d735f71$export$133c4d08f3775d64(Object.assign({}, options, {
        usePopper: usePopperProp
    }));
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)((0, $2111e08a92d70add$exports.Fragment), {
        children: children(props, meta)
    });
}
$f10376ae5d735f71$var$DropdownMenu.displayName = 'DropdownMenu';
var /** @component */ $f10376ae5d735f71$export$2e2bcd8739ae039 = $f10376ae5d735f71$var$DropdownMenu;



var $dNU7X = parcelRequire("dNU7X");

var $dNU7X = parcelRequire("dNU7X");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $7d793637e9528142$var$$b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $7d793637e9528142$var$$b5e257d569688ac6$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).createContext($7d793637e9528142$var$$b5e257d569688ac6$var$defaultContext);
const $7d793637e9528142$var$$b5e257d569688ac6$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).createContext(false);
// This is only used in React < 18.
function $7d793637e9528142$var$$b5e257d569688ac6$var$LegacySSRProvider(props) {
    let cur = (0, $dNU7X.useContext)($7d793637e9528142$var$$b5e257d569688ac6$var$SSRContext);
    let counter = $7d793637e9528142$var$$b5e257d569688ac6$var$useCounter(cur === $7d793637e9528142$var$$b5e257d569688ac6$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $dNU7X.useState)(true);
    let value = (0, $dNU7X.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $7d793637e9528142$var$$b5e257d569688ac6$var$defaultContext ? '' : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, $dNU7X.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).createElement($7d793637e9528142$var$$b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).createElement($7d793637e9528142$var$$b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $7d793637e9528142$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $7d793637e9528142$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X)))['useId'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).Fragment, null, props.children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).createElement($7d793637e9528142$var$$b5e257d569688ac6$var$LegacySSRProvider, props);
}
let $7d793637e9528142$var$$b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $7d793637e9528142$var$$b5e257d569688ac6$var$componentIds = new WeakMap();
function $7d793637e9528142$var$$b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (0, $dNU7X.useContext)($7d793637e9528142$var$$b5e257d569688ac6$var$SSRContext);
    let ref = (0, $dNU7X.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $7d793637e9528142$var$$b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $7d793637e9528142$var$$b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $7d793637e9528142$var$$b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $7d793637e9528142$var$$b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $dNU7X.useContext)($7d793637e9528142$var$$b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    ctx === $7d793637e9528142$var$$b5e257d569688ac6$var$defaultContext && $7d793637e9528142$var$$b5e257d569688ac6$var$canUseDOM;
    let counter = $7d793637e9528142$var$$b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $7d793637e9528142$var$$b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).useId();
    let [didSSR] = (0, $dNU7X.useState)($7d793637e9528142$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? 'react-aria' : `react-aria${$7d793637e9528142$var$$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $7d793637e9528142$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X)))['useId'] === 'function' ? $7d793637e9528142$var$$b5e257d569688ac6$var$useModernSSRSafeId : $7d793637e9528142$var$$b5e257d569688ac6$var$useLegacySSRSafeId;
function $7d793637e9528142$var$$b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $7d793637e9528142$var$$b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $7d793637e9528142$var$$b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $7d793637e9528142$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X)))['useSyncExternalStore'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X)))['useSyncExternalStore']($7d793637e9528142$var$$b5e257d569688ac6$var$subscribe, $7d793637e9528142$var$$b5e257d569688ac6$var$getSnapshot, $7d793637e9528142$var$$b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $dNU7X.useContext)($7d793637e9528142$var$$b5e257d569688ac6$var$IsSSRContext);
}




const $736ecc81bc00e940$export$386b1213cf9779d8 = (el)=>{
    var _el$getAttribute;
    return ((_el$getAttribute = el.getAttribute('role')) == null ? void 0 : _el$getAttribute.toLowerCase()) === 'menu';
};
const $736ecc81bc00e940$var$noop = ()=>{};
function $736ecc81bc00e940$export$96df6c7c5036b9a2() {
    const id = (0, $7d793637e9528142$export$619500959fc48b26)();
    const { show: show = false, toggle: toggle = $736ecc81bc00e940$var$noop, setToggle: setToggle, menuElement: menuElement } = (0, $dNU7X.useContext)((0, $09485616992a198b$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $dNU7X.useCallback)((e)=>{
        toggle(!show, e);
    }, [
        show,
        toggle
    ]);
    const props = {
        id: id,
        ref: setToggle || $736ecc81bc00e940$var$noop,
        onClick: handleClick,
        'aria-expanded': !!show
    };
    // This is maybe better down in an effect, but
    // the component is going to update anyway when the menu element
    // is set so might return new props.
    if (menuElement && $736ecc81bc00e940$export$386b1213cf9779d8(menuElement)) props['aria-haspopup'] = true;
    return [
        props,
        {
            show: show,
            toggle: toggle
        }
    ];
}
/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */ function $736ecc81bc00e940$var$DropdownToggle({ children: children }) {
    const [props, meta] = $736ecc81bc00e940$export$96df6c7c5036b9a2();
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)((0, $2111e08a92d70add$exports.Fragment), {
        children: children(props, meta)
    });
}
$736ecc81bc00e940$var$DropdownToggle.displayName = 'DropdownToggle';
var /** @component */ $736ecc81bc00e940$export$2e2bcd8739ae039 = $736ecc81bc00e940$var$DropdownToggle;



var $dNU7X = parcelRequire("dNU7X");


var $dNU7X = parcelRequire("dNU7X");
const $582101cfb39a3e27$var$SelectableContext = /*#__PURE__*/ $dNU7X.createContext(null);
const $582101cfb39a3e27$export$eef49b42fde998a3 = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $582101cfb39a3e27$export$2e2bcd8739ae039 = $582101cfb39a3e27$var$SelectableContext;



var $dNU7X = parcelRequire("dNU7X");
const $ae1fd8ad3481d7e0$var$NavContext = /*#__PURE__*/ $dNU7X.createContext(null);
$ae1fd8ad3481d7e0$var$NavContext.displayName = 'NavContext';
var $ae1fd8ad3481d7e0$export$2e2bcd8739ae039 = $ae1fd8ad3481d7e0$var$NavContext;



const $480d957e106253a4$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $480d957e106253a4$export$635202801f9383a0 = `rrUi`;
function $480d957e106253a4$export$5cc3b7b83e34ade7(property) {
    return `${$480d957e106253a4$export$fd7bcb7e9bef4e8a}${property}`;
}
function $480d957e106253a4$export$7776c0a7cd2eb3e0(property) {
    return `${$480d957e106253a4$export$635202801f9383a0}${property}`;
}



const $aa742208e8ab2365$var$_excluded = [
    "eventKey",
    "disabled",
    "onClick",
    "active",
    "as"
];
function $aa742208e8ab2365$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $aa742208e8ab2365$export$522d7e1e4e0e22b2({ key: key, href: href, active: active, disabled: disabled, onClick: onClick }) {
    const onSelectCtx = (0, $dNU7X.useContext)((0, $582101cfb39a3e27$export$2e2bcd8739ae039));
    const navContext = (0, $dNU7X.useContext)((0, $ae1fd8ad3481d7e0$export$2e2bcd8739ae039));
    const { activeKey: activeKey } = navContext || {};
    const eventKey = (0, $582101cfb39a3e27$export$eef49b42fde998a3)(key, href);
    const isActive = active == null && key != null ? (0, $582101cfb39a3e27$export$eef49b42fde998a3)(activeKey) === eventKey : active;
    const handleClick = (0, $5c6b416708f5301c$export$2e2bcd8739ae039)((event)=>{
        if (disabled) return;
        onClick == null || onClick(event);
        if (onSelectCtx && !event.isPropagationStopped()) onSelectCtx(eventKey, event);
    });
    return [
        {
            onClick: handleClick,
            'aria-disabled': disabled || undefined,
            'aria-selected': isActive,
            [(0, $480d957e106253a4$export$5cc3b7b83e34ade7)('dropdown-item')]: ''
        },
        {
            isActive: isActive
        }
    ];
}
const $aa742208e8ab2365$var$DropdownItem = /*#__PURE__*/ $dNU7X.forwardRef((_ref, ref)=>{
    let { eventKey: eventKey, disabled: disabled, onClick: onClick, active: active, as: Component = (0, $cdcb5a6d0dd9d6ce$export$2e2bcd8739ae039) } = _ref, props = $aa742208e8ab2365$var$_objectWithoutPropertiesLoose(_ref, $aa742208e8ab2365$var$_excluded);
    const [dropdownItemProps] = $aa742208e8ab2365$export$522d7e1e4e0e22b2({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, Object.assign({}, props, {
        ref: ref
    }, dropdownItemProps));
});
$aa742208e8ab2365$var$DropdownItem.displayName = 'DropdownItem';
var $aa742208e8ab2365$export$2e2bcd8739ae039 = $aa742208e8ab2365$var$DropdownItem;





var $dNU7X = parcelRequire("dNU7X");

const $5af5d626dab37c84$var$Context = /*#__PURE__*/ (0, $dNU7X.createContext)((0, $c36f36ded4bef1c0$export$2e2bcd8739ae039) ? window : undefined);
const $5af5d626dab37c84$export$f7d306aeb1cf5fbc = $5af5d626dab37c84$var$Context.Provider;
function $5af5d626dab37c84$export$2e2bcd8739ae039() {
    return (0, $dNU7X.useContext)($5af5d626dab37c84$var$Context);
}



function $83350afb2ae4e28d$var$useRefWithUpdate() {
    const forceUpdate = (0, $a1e7dfea23729a9b$export$2e2bcd8739ae039)();
    const ref = (0, $dNU7X.useRef)(null);
    const attachRef = (0, $dNU7X.useCallback)((element)=>{
        ref.current = element;
        // ensure that a menu set triggers an update for consumers
        forceUpdate();
    }, [
        forceUpdate
    ]);
    return [
        ref,
        attachRef
    ];
}
/**
 * @displayName Dropdown
 * @public
 */ function $83350afb2ae4e28d$var$Dropdown({ defaultShow: defaultShow, show: rawShow, onSelect: onSelect, onToggle: rawOnToggle, itemSelector: itemSelector = `* [${(0, $480d957e106253a4$export$5cc3b7b83e34ade7)('dropdown-item')}]`, focusFirstItemOnShow: focusFirstItemOnShow, placement: placement = 'bottom-start', children: children }) {
    const window = (0, $5af5d626dab37c84$export$2e2bcd8739ae039)();
    const [show, onToggle] = (0, $02389d6585ed519e$export$2ee51287a16ca325)(rawShow, defaultShow, rawOnToggle);
    // We use normal refs instead of useCallbackRef in order to populate the
    // the value as quickly as possible, otherwise the effect to focus the element
    // may run before the state value is set
    const [menuRef, setMenu] = $83350afb2ae4e28d$var$useRefWithUpdate();
    const menuElement = menuRef.current;
    const [toggleRef, setToggle] = $83350afb2ae4e28d$var$useRefWithUpdate();
    const toggleElement = toggleRef.current;
    const lastShow = (0, $29c0e647ade0bf2a$export$2e2bcd8739ae039)(show);
    const lastSourceEvent = (0, $dNU7X.useRef)(null);
    const focusInDropdown = (0, $dNU7X.useRef)(false);
    const onSelectCtx = (0, $dNU7X.useContext)((0, $582101cfb39a3e27$export$2e2bcd8739ae039));
    const toggle = (0, $dNU7X.useCallback)((nextShow, event, source = event == null ? void 0 : event.type)=>{
        onToggle(nextShow, {
            originalEvent: event,
            source: source
        });
    }, [
        onToggle
    ]);
    const handleSelect = (0, $5c6b416708f5301c$export$2e2bcd8739ae039)((key, event)=>{
        onSelect == null || onSelect(key, event);
        toggle(false, event, 'select');
        if (!event.isPropagationStopped()) onSelectCtx == null || onSelectCtx(key, event);
    });
    const context = (0, $dNU7X.useMemo)(()=>({
            toggle: toggle,
            placement: placement,
            show: show,
            menuElement: menuElement,
            toggleElement: toggleElement,
            setMenu: setMenu,
            setToggle: setToggle
        }), [
        toggle,
        placement,
        show,
        menuElement,
        toggleElement,
        setMenu,
        setToggle
    ]);
    if (menuElement && lastShow && !show) focusInDropdown.current = menuElement.contains(menuElement.ownerDocument.activeElement);
    const focusToggle = (0, $5c6b416708f5301c$export$2e2bcd8739ae039)(()=>{
        if (toggleElement && toggleElement.focus) toggleElement.focus();
    });
    const maybeFocusFirst = (0, $5c6b416708f5301c$export$2e2bcd8739ae039)(()=>{
        const type = lastSourceEvent.current;
        let focusType = focusFirstItemOnShow;
        if (focusType == null) focusType = menuRef.current && (0, $736ecc81bc00e940$export$386b1213cf9779d8)(menuRef.current) ? 'keyboard' : false;
        if (focusType === false || focusType === 'keyboard' && !/^key.+$/.test(type)) return;
        const first = (0, $e756898da11911b9$export$2e2bcd8739ae039)(menuRef.current, itemSelector)[0];
        if (first && first.focus) first.focus();
    });
    (0, $dNU7X.useEffect)(()=>{
        if (show) maybeFocusFirst();
        else if (focusInDropdown.current) {
            focusInDropdown.current = false;
            focusToggle();
        }
    // only `show` should be changing
    }, [
        show,
        focusInDropdown,
        focusToggle,
        maybeFocusFirst
    ]);
    (0, $dNU7X.useEffect)(()=>{
        lastSourceEvent.current = null;
    });
    const getNextFocusedChild = (current, offset)=>{
        if (!menuRef.current) return null;
        const items = (0, $e756898da11911b9$export$2e2bcd8739ae039)(menuRef.current, itemSelector);
        let index = items.indexOf(current) + offset;
        index = Math.max(0, Math.min(index, items.length));
        return items[index];
    };
    (0, $c88bb54f5a78bc79$export$2e2bcd8739ae039)((0, $dNU7X.useCallback)(()=>window.document, [
        window
    ]), 'keydown', (event)=>{
        var _menuRef$current, _toggleRef$current;
        const { key: key } = event;
        const target = event.target;
        const fromMenu = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(target);
        const fromToggle = (_toggleRef$current = toggleRef.current) == null ? void 0 : _toggleRef$current.contains(target);
        // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
        // in inscrutability
        const isInput = /input|textarea/i.test(target.tagName);
        if (isInput && (key === ' ' || key !== 'Escape' && fromMenu || key === 'Escape' && target.type === 'search')) return;
        if (!fromMenu && !fromToggle) return;
        if (key === 'Tab' && (!menuRef.current || !show)) return;
        lastSourceEvent.current = event.type;
        const meta = {
            originalEvent: event,
            source: event.type
        };
        switch(key){
            case 'ArrowUp':
                {
                    const next = getNextFocusedChild(target, -1);
                    if (next && next.focus) next.focus();
                    event.preventDefault();
                    return;
                }
            case 'ArrowDown':
                event.preventDefault();
                if (!show) onToggle(true, meta);
                else {
                    const next = getNextFocusedChild(target, 1);
                    if (next && next.focus) next.focus();
                }
                return;
            case 'Tab':
                // on keydown the target is the element being tabbed FROM, we need that
                // to know if this event is relevant to this dropdown (e.g. in this menu).
                // On `keyup` the target is the element being tagged TO which we use to check
                // if focus has left the menu
                (0, $7e72389cdcb8fa2e$export$2e2bcd8739ae039)(target.ownerDocument, 'keyup', (e)=>{
                    var _menuRef$current2;
                    if (e.key === 'Tab' && !e.target || !((_menuRef$current2 = menuRef.current) != null && _menuRef$current2.contains(e.target))) onToggle(false, meta);
                }, {
                    once: true
                });
                break;
            case 'Escape':
                if (key === 'Escape') {
                    event.preventDefault();
                    event.stopPropagation();
                }
                onToggle(false, meta);
                break;
            default:
        }
    });
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)((0, $582101cfb39a3e27$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)((0, $09485616992a198b$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: children
        })
    });
}
$83350afb2ae4e28d$var$Dropdown.displayName = 'Dropdown';
$83350afb2ae4e28d$var$Dropdown.Menu = (0, $f10376ae5d735f71$export$2e2bcd8739ae039);
$83350afb2ae4e28d$var$Dropdown.Toggle = (0, $736ecc81bc00e940$export$2e2bcd8739ae039);
$83350afb2ae4e28d$var$Dropdown.Item = (0, $aa742208e8ab2365$export$2e2bcd8739ae039);
var $83350afb2ae4e28d$export$2e2bcd8739ae039 = $83350afb2ae4e28d$var$Dropdown;


function $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039() {
    return $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039.apply(null, arguments);
}


function $a396812ba85d91d0$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}



var $dNU7X = parcelRequire("dNU7X");
var $0e34bdc1602f642d$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $0e34bdc1602f642d$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$0e34bdc1602f642d$exports = $0e34bdc1602f642d$var$invariant;


var $7f9c7fa70f6cccbb$var$noop = function noop() {};
function $7f9c7fa70f6cccbb$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $7f9c7fa70f6cccbb$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $7f9c7fa70f6cccbb$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$7f9c7fa70f6cccbb$export$26cbf8c37e721e67(prop)] = $7f9c7fa70f6cccbb$var$noop;
        var handler;
    });
    return propTypes;
}
function $7f9c7fa70f6cccbb$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $7f9c7fa70f6cccbb$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $7f9c7fa70f6cccbb$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}


function $52310e7f0777605e$var$_toPropertyKey(arg) {
    var key = $52310e7f0777605e$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $52310e7f0777605e$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $52310e7f0777605e$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $dNU7X.useRef)(propValue !== undefined);
    var _useState = (0, $dNU7X.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $dNU7X.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $52310e7f0777605e$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$7f9c7fa70f6cccbb$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $a396812ba85d91d0$export$2e2bcd8739ae039)(_ref, [
            $7f9c7fa70f6cccbb$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($52310e7f0777605e$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $52310e7f0777605e$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}




function $e3c997c5b70ce726$export$2e2bcd8739ae039(t, e) {
    return $e3c997c5b70ce726$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $e3c997c5b70ce726$export$2e2bcd8739ae039(t, e);
}


function $5122792117adb82d$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $e3c997c5b70ce726$export$2e2bcd8739ae039)(t, o);
}



var $dNU7X = parcelRequire("dNU7X");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $51cb67738c4a415e$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $51cb67738c4a415e$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $51cb67738c4a415e$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$51cb67738c4a415e$var$componentWillMount.__suppressDeprecationWarning = true;
$51cb67738c4a415e$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$51cb67738c4a415e$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $51cb67738c4a415e$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $51cb67738c4a415e$var$componentWillMount;
        prototype.componentWillReceiveProps = $51cb67738c4a415e$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $51cb67738c4a415e$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $307b49f51a960a5b$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $307b49f51a960a5b$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $7f9c7fa70f6cccbb$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($7f9c7fa70f6cccbb$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($0e34bdc1602f642d$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $5122792117adb82d$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$7f9c7fa70f6cccbb$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$7f9c7fa70f6cccbb$export$12ae2baa35bd9b8b(props, key) && $7f9c7fa70f6cccbb$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$7f9c7fa70f6cccbb$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $a396812ba85d91d0$export$2e2bcd8739ae039)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).createElement(Component, (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).Component);
    (0, $51cb67738c4a415e$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({
        innerRef: function innerRef() {}
    }, $7f9c7fa70f6cccbb$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).createElement(UncontrolledComponent, (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $307b49f51a960a5b$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $307b49f51a960a5b$export$2e2bcd8739ae039(newComponent, (0, $4dfb8f1fff0cbd5e$export$2e2bcd8739ae039)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}





var $dNU7X = parcelRequire("dNU7X");

var $dNU7X = parcelRequire("dNU7X");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $e0ec7b15bce9a436$var$useCommittedRef(value) {
    const ref = (0, $dNU7X.useRef)(value);
    (0, $dNU7X.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $e0ec7b15bce9a436$export$2e2bcd8739ae039 = $e0ec7b15bce9a436$var$useCommittedRef;


function $e654881f234539ec$export$2e2bcd8739ae039(fn) {
    const ref = (0, $e0ec7b15bce9a436$export$2e2bcd8739ae039)(fn);
    return (0, $dNU7X.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}



var $dNU7X = parcelRequire("dNU7X");
"use client";
const $1938c922f1d671ee$var$DropdownContext = /*#__PURE__*/ $dNU7X.createContext({});
$1938c922f1d671ee$var$DropdownContext.displayName = 'DropdownContext';
var $1938c922f1d671ee$export$2e2bcd8739ae039 = $1938c922f1d671ee$var$DropdownContext;



var $dNU7X = parcelRequire("dNU7X");



"use client";
const $032794ba65dd0d5a$var$DropdownDivider = /*#__PURE__*/ $dNU7X.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'hr', role: role = 'separator', ...props }, ref)=>{
    bsPrefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'dropdown-divider');
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$032794ba65dd0d5a$var$DropdownDivider.displayName = 'DropdownDivider';
var $032794ba65dd0d5a$export$2e2bcd8739ae039 = $032794ba65dd0d5a$var$DropdownDivider;



var $dNU7X = parcelRequire("dNU7X");



"use client";
const $1dcae7f054717fd3$var$DropdownHeader = /*#__PURE__*/ $dNU7X.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', role: role = 'heading', ...props }, ref)=>{
    bsPrefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'dropdown-header');
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$1dcae7f054717fd3$var$DropdownHeader.displayName = 'DropdownHeader';
var $1dcae7f054717fd3$export$2e2bcd8739ae039 = $1dcae7f054717fd3$var$DropdownHeader;




var $dNU7X = parcelRequire("dNU7X");


var $dNU7X = parcelRequire("dNU7X");






var $dNU7X = parcelRequire("dNU7X");
function $cf86daa98299fa58$export$2e2bcd8739ae039(event, handler, capture = false) {
    const documentTarget = (0, $dNU7X.useCallback)(()=>document, []);
    return (0, $c88bb54f5a78bc79$export$2e2bcd8739ae039)(documentTarget, event, handler, capture);
}



var $dNU7X = parcelRequire("dNU7X");

/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $21ab776cf773fe02$var$useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, $65e37d7354dfd4b8$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $65e37d7354dfd4b8$export$2e2bcd8739ae039)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $dNU7X.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
var $21ab776cf773fe02$export$2e2bcd8739ae039 = $21ab776cf773fe02$var$useInterval;



var $dNU7X = parcelRequire("dNU7X");

function $c0b05bc1820d8809$var$useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, $65e37d7354dfd4b8$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $65e37d7354dfd4b8$export$2e2bcd8739ae039)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $dNU7X.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
var $c0b05bc1820d8809$export$2e2bcd8739ae039 = $c0b05bc1820d8809$var$useRafInterval;



var $dNU7X = parcelRequire("dNU7X");
function $b8ba9983d738a185$export$2e2bcd8739ae039(initialState) {
    const [state, setState] = (0, $dNU7X.useState)(initialState);
    const updater = (0, $dNU7X.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === 'function') setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}



function $7adec4c4b57b35f4$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    const [state, setState] = (0, $b8ba9983d738a185$export$2e2bcd8739ae039)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}





var $dNU7X = parcelRequire("dNU7X");
function $a27fea4f37db21a2$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, $dNU7X.useState)({
        image: null,
        error: null
    });
    (0, $dNU7X.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === 'string') {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
        return ()=>{
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}



var $dNU7X = parcelRequire("dNU7X");

var $dNU7X = parcelRequire("dNU7X");
const $a1527d8ad7595fdd$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $a1527d8ad7595fdd$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $a1527d8ad7595fdd$export$2e2bcd8739ae039 = $a1527d8ad7595fdd$var$isDOM || $a1527d8ad7595fdd$var$isReactNative ? (0, $dNU7X.useLayoutEffect) : (0, $dNU7X.useEffect);


const $59eb6999c7eff0ce$var$targetMap = new WeakMap();
let $59eb6999c7eff0ce$var$resizeObserver;
function $59eb6999c7eff0ce$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $59eb6999c7eff0ce$var$resizeObserver = $59eb6999c7eff0ce$var$resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = $59eb6999c7eff0ce$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $59eb6999c7eff0ce$export$2e2bcd8739ae039(element) {
    const [rect, setRect] = (0, $dNU7X.useState)(null);
    (0, $a1527d8ad7595fdd$export$2e2bcd8739ae039)(()=>{
        if (!element) return;
        $59eb6999c7eff0ce$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $59eb6999c7eff0ce$var$targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            $59eb6999c7eff0ce$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}






const $a22c774b44973b8f$var$_excluded = [
    "onKeyDown"
];
function $a22c774b44973b8f$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $a22c774b44973b8f$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const $a22c774b44973b8f$var$Anchor = /*#__PURE__*/ $dNU7X.forwardRef((_ref, ref)=>{
    let { onKeyDown: onKeyDown } = _ref, props = $a22c774b44973b8f$var$_objectWithoutPropertiesLoose(_ref, $a22c774b44973b8f$var$_excluded);
    const [buttonProps] = (0, $cdcb5a6d0dd9d6ce$export$a0ee72f2c720a5c3)(Object.assign({
        tagName: 'a'
    }, props));
    const handleKeyDown = (0, $5c6b416708f5301c$export$2e2bcd8739ae039)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($a22c774b44973b8f$export$72369ab2cc99204b(props.href) || props.role === 'button') return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$a22c774b44973b8f$var$Anchor.displayName = 'Anchor';
var $a22c774b44973b8f$export$2e2bcd8739ae039 = $a22c774b44973b8f$var$Anchor;




"use client";
const $3968016d3bea97c2$var$DropdownItem = /*#__PURE__*/ $dNU7X.forwardRef(({ bsPrefix: bsPrefix, className: className, eventKey: eventKey, disabled: disabled = false, onClick: onClick, active: active, as: Component = (0, $a22c774b44973b8f$export$2e2bcd8739ae039), ...props }, ref)=>{
    const prefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'dropdown-item');
    const [dropdownItemProps, meta] = (0, $aa742208e8ab2365$export$522d7e1e4e0e22b2)({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, {
        ...props,
        ...dropdownItemProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, meta.isActive && 'active', disabled && 'disabled')
    });
});
$3968016d3bea97c2$var$DropdownItem.displayName = 'DropdownItem';
var $3968016d3bea97c2$export$2e2bcd8739ae039 = $3968016d3bea97c2$var$DropdownItem;



var $dNU7X = parcelRequire("dNU7X");



"use client";
const $dab502137a810cba$var$DropdownItemText = /*#__PURE__*/ $dNU7X.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'dropdown-item-text');
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$dab502137a810cba$var$DropdownItemText.displayName = 'DropdownItemText';
var $dab502137a810cba$export$2e2bcd8739ae039 = $dab502137a810cba$var$DropdownItemText;




var $dNU7X = parcelRequire("dNU7X");


var $dNU7X = parcelRequire("dNU7X");
const $0215886653e4f139$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $0215886653e4f139$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $0215886653e4f139$export$2e2bcd8739ae039 = $0215886653e4f139$var$isDOM || $0215886653e4f139$var$isReactNative ? (0, $dNU7X.useLayoutEffect) : (0, $dNU7X.useEffect);



var $dNU7X = parcelRequire("dNU7X");
const $f21f3c4c3cb27992$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $f21f3c4c3cb27992$export$c9058316764c140e(refA, refB) {
    const a = $f21f3c4c3cb27992$var$toFnRef(refA);
    const b = $f21f3c4c3cb27992$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $f21f3c4c3cb27992$var$useMergedRefs(refA, refB) {
    return (0, $dNU7X.useMemo)(()=>$f21f3c4c3cb27992$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $f21f3c4c3cb27992$export$2e2bcd8739ae039 = $f21f3c4c3cb27992$var$useMergedRefs;





var $dNU7X = parcelRequire("dNU7X");
"use client";
const $471f315a8f1e82e9$var$context = /*#__PURE__*/ $dNU7X.createContext(null);
$471f315a8f1e82e9$var$context.displayName = 'InputGroupContext';
var $471f315a8f1e82e9$export$2e2bcd8739ae039 = $471f315a8f1e82e9$var$context;



var $dNU7X = parcelRequire("dNU7X");
"use client";
// TODO: check
const $f2dcebd9eba06d09$var$context = /*#__PURE__*/ $dNU7X.createContext(null);
$f2dcebd9eba06d09$var$context.displayName = 'NavbarContext';
var $f2dcebd9eba06d09$export$2e2bcd8739ae039 = $f2dcebd9eba06d09$var$context;




parcelRequire("dNU7X");

function $f19962f1c132a571$export$2e2bcd8739ae039(ref, componentName) {
    return ref;
}




"use client";
function $0f2d5d50e787a0d5$export$a2c648e264f4a946(alignEnd, dropDirection, isRTL) {
    const topStart = isRTL ? 'top-end' : 'top-start';
    const topEnd = isRTL ? 'top-start' : 'top-end';
    const bottomStart = isRTL ? 'bottom-end' : 'bottom-start';
    const bottomEnd = isRTL ? 'bottom-start' : 'bottom-end';
    const leftStart = isRTL ? 'right-start' : 'left-start';
    const leftEnd = isRTL ? 'right-end' : 'left-end';
    const rightStart = isRTL ? 'left-start' : 'right-start';
    const rightEnd = isRTL ? 'left-end' : 'right-end';
    let placement = alignEnd ? bottomEnd : bottomStart;
    if (dropDirection === 'up') placement = alignEnd ? topEnd : topStart;
    else if (dropDirection === 'end') placement = alignEnd ? rightEnd : rightStart;
    else if (dropDirection === 'start') placement = alignEnd ? leftEnd : leftStart;
    else if (dropDirection === 'down-centered') placement = 'bottom';
    else if (dropDirection === 'up-centered') placement = 'top';
    return placement;
}
const $0f2d5d50e787a0d5$var$DropdownMenu = /*#__PURE__*/ $dNU7X.forwardRef(({ bsPrefix: bsPrefix, className: className, align: align, rootCloseEvent: rootCloseEvent, flip: flip = true, show: showProps, renderOnMount: renderOnMount, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', popperConfig: popperConfig, variant: variant, ...props }, ref)=>{
    let alignEnd = false;
    const isNavbar = (0, $dNU7X.useContext)((0, $f2dcebd9eba06d09$export$2e2bcd8739ae039));
    const prefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'dropdown-menu');
    const { align: contextAlign, drop: drop, isRTL: isRTL } = (0, $dNU7X.useContext)((0, $1938c922f1d671ee$export$2e2bcd8739ae039));
    align = align || contextAlign;
    const isInputGroup = (0, $dNU7X.useContext)((0, $471f315a8f1e82e9$export$2e2bcd8739ae039));
    const alignClasses = [];
    if (align) {
        if (typeof align === 'object') {
            const keys = Object.keys(align);
            if (keys.length) {
                const brkPoint = keys[0];
                const direction = align[brkPoint];
                // .dropdown-menu-end is required for responsively aligning
                // left in addition to align left classes.
                alignEnd = direction === 'start';
                alignClasses.push(`${prefix}-${brkPoint}-${direction}`);
            }
        } else if (align === 'end') alignEnd = true;
    }
    const placement = $0f2d5d50e787a0d5$export$a2c648e264f4a946(alignEnd, drop, isRTL);
    const [menuProps, { hasShown: hasShown, popper: popper, show: show, toggle: toggle }] = (0, $f10376ae5d735f71$export$133c4d08f3775d64)({
        flip: flip,
        rootCloseEvent: rootCloseEvent,
        show: showProps,
        usePopper: !isNavbar && alignClasses.length === 0,
        offset: [
            0,
            2
        ],
        popperConfig: popperConfig,
        placement: placement
    });
    menuProps.ref = (0, $f21f3c4c3cb27992$export$2e2bcd8739ae039)((0, $f19962f1c132a571$export$2e2bcd8739ae039)(ref, 'DropdownMenu'), menuProps.ref);
    (0, $0215886653e4f139$export$2e2bcd8739ae039)(()=>{
        // Popper's initial position for the menu is incorrect when
        // renderOnMount=true. Need to call update() to correct it.
        if (show) popper == null || popper.update();
    }, [
        show
    ]);
    if (!hasShown && !renderOnMount && !isInputGroup) return null;
    // For custom components provide additional, non-DOM, props;
    if (typeof Component !== 'string') {
        menuProps.show = show;
        menuProps.close = ()=>toggle == null ? void 0 : toggle(false);
        menuProps.align = align;
    }
    let style = props.style;
    if (popper != null && popper.placement) {
        // we don't need the default popper style,
        // menus are display: none when not shown.
        style = {
            ...props.style,
            ...menuProps.style
        };
        props['x-placement'] = popper.placement;
    }
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, {
        ...props,
        ...menuProps,
        style: style,
        ...(alignClasses.length || isNavbar) && {
            'data-bs-popper': 'static'
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, show && 'show', alignEnd && `${prefix}-end`, variant && `${prefix}-${variant}`, ...alignClasses)
    });
});
$0f2d5d50e787a0d5$var$DropdownMenu.displayName = 'DropdownMenu';
var $0f2d5d50e787a0d5$export$2e2bcd8739ae039 = $0f2d5d50e787a0d5$var$DropdownMenu;







var $dNU7X = parcelRequire("dNU7X");




"use client";
const $7858dd9a9524cd94$var$DropdownToggle = /*#__PURE__*/ $dNU7X.forwardRef(({ bsPrefix: bsPrefix, split: split, className: className, childBsPrefix: childBsPrefix, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = (0, $23c9a6bed94aa817$export$2e2bcd8739ae039), ...props }, ref)=>{
    const prefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'dropdown-toggle');
    const dropdownContext = (0, $dNU7X.useContext)((0, $09485616992a198b$export$2e2bcd8739ae039));
    if (childBsPrefix !== undefined) props.bsPrefix = childBsPrefix;
    const [toggleProps] = (0, $736ecc81bc00e940$export$96df6c7c5036b9a2)();
    toggleProps.ref = (0, $f21f3c4c3cb27992$export$2e2bcd8739ae039)(toggleProps.ref, (0, $f19962f1c132a571$export$2e2bcd8739ae039)(ref, 'DropdownToggle'));
    // This intentionally forwards size and variant (if set) to the
    // underlying component, to allow it to render size and style variants.
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, prefix, split && `${prefix}-split`, (dropdownContext == null ? void 0 : dropdownContext.show) && 'show'),
        ...toggleProps,
        ...props
    });
});
$7858dd9a9524cd94$var$DropdownToggle.displayName = 'DropdownToggle';
var $7858dd9a9524cd94$export$2e2bcd8739ae039 = $7858dd9a9524cd94$var$DropdownToggle;






"use client";
const $e9a7ce6542b46802$var$Dropdown = /*#__PURE__*/ $dNU7X.forwardRef((pProps, ref)=>{
    const { bsPrefix: bsPrefix, drop: drop = 'down', show: show, className: className, align: align = 'start', onSelect: onSelect, onToggle: onToggle, focusFirstItemOnShow: focusFirstItemOnShow, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', navbar: _4, autoClose: autoClose = true, ...props } = (0, $52310e7f0777605e$export$2e2bcd8739ae039)(pProps, {
        show: 'onToggle'
    });
    const isInputGroup = (0, $dNU7X.useContext)((0, $471f315a8f1e82e9$export$2e2bcd8739ae039));
    const prefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'dropdown');
    const isRTL = (0, $4843567570d88909$export$35e511eefa30ac5a)();
    const isClosingPermitted = (source)=>{
        // autoClose=false only permits close on button click
        if (autoClose === false) return source === 'click';
        // autoClose=inside doesn't permit close on rootClose
        if (autoClose === 'inside') return source !== 'rootClose';
        // autoClose=outside doesn't permit close on select
        if (autoClose === 'outside') return source !== 'select';
        return true;
    };
    const handleToggle = (0, $e654881f234539ec$export$2e2bcd8739ae039)((nextShow, meta)=>{
        var _meta$originalEvent;
        /** Checking if target of event is ToggleButton,
     * if it is then nullify mousedown event
     */ const isToggleButton = (_meta$originalEvent = meta.originalEvent) == null || (_meta$originalEvent = _meta$originalEvent.target) == null ? void 0 : _meta$originalEvent.classList.contains('dropdown-toggle');
        if (isToggleButton && meta.source === 'mousedown') return;
        if (meta.originalEvent.currentTarget === document && (meta.source !== 'keydown' || meta.originalEvent.key === 'Escape')) meta.source = 'rootClose';
        if (isClosingPermitted(meta.source)) onToggle == null || onToggle(nextShow, meta);
    });
    const alignEnd = align === 'end';
    const placement = (0, $0f2d5d50e787a0d5$export$a2c648e264f4a946)(alignEnd, drop, isRTL);
    const contextValue = (0, $dNU7X.useMemo)(()=>({
            align: align,
            drop: drop,
            isRTL: isRTL
        }), [
        align,
        drop,
        isRTL
    ]);
    const directionClasses = {
        down: prefix,
        'down-centered': `${prefix}-center`,
        up: 'dropup',
        'up-centered': 'dropup-center dropup',
        end: 'dropend',
        start: 'dropstart'
    };
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)((0, $1938c922f1d671ee$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)((0, $83350afb2ae4e28d$export$2e2bcd8739ae039), {
            placement: placement,
            show: show,
            onSelect: onSelect,
            onToggle: handleToggle,
            focusFirstItemOnShow: focusFirstItemOnShow,
            itemSelector: `.${prefix}-item:not(.disabled):not(:disabled)`,
            children: isInputGroup ? props.children : /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, {
                ...props,
                ref: ref,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, show && 'show', directionClasses[drop])
            })
        })
    });
});
$e9a7ce6542b46802$var$Dropdown.displayName = 'Dropdown';
var $e9a7ce6542b46802$export$2e2bcd8739ae039 = Object.assign($e9a7ce6542b46802$var$Dropdown, {
    Toggle: (0, $7858dd9a9524cd94$export$2e2bcd8739ae039),
    Menu: (0, $0f2d5d50e787a0d5$export$2e2bcd8739ae039),
    Item: (0, $3968016d3bea97c2$export$2e2bcd8739ae039),
    ItemText: (0, $dab502137a810cba$export$2e2bcd8739ae039),
    Divider: (0, $032794ba65dd0d5a$export$2e2bcd8739ae039),
    Header: (0, $1dcae7f054717fd3$export$2e2bcd8739ae039)
});



var $dNU7X = parcelRequire("dNU7X");
var $38b29c2dc0019b47$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $38b29c2dc0019b47$var$ReactIs, $38b29c2dc0019b47$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$38b29c2dc0019b47$exports = (parcelRequire("dflA0"))();




"use client";
const $4f87183439e34fd8$export$513805011eaa4892 = {
    /**
   * @default 'img'
   */ bsPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).string,
    /**
   * Sets image as fluid image.
   */ fluid: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    /**
   * Sets image shape as rounded.
   */ rounded: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    /**
   * Sets image shape as circle.
   */ roundedCircle: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool,
    /**
   * Sets image shape as thumbnail.
   */ thumbnail: (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).bool
};
const $4f87183439e34fd8$var$Image = /*#__PURE__*/ $dNU7X.forwardRef(({ bsPrefix: bsPrefix, className: className, fluid: fluid = false, rounded: rounded = false, roundedCircle: roundedCircle = false, thumbnail: thumbnail = false, ...props }, ref)=>{
    bsPrefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'img');
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)("img", {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, fluid && `${bsPrefix}-fluid`, rounded && `rounded`, roundedCircle && `rounded-circle`, thumbnail && `${bsPrefix}-thumbnail`)
    });
});
$4f87183439e34fd8$var$Image.displayName = 'Image';
var $4f87183439e34fd8$export$2e2bcd8739ae039 = $4f87183439e34fd8$var$Image;



var $dNU7X = parcelRequire("dNU7X");



var $dNU7X = parcelRequire("dNU7X");


var $dNU7X = parcelRequire("dNU7X");
const $3927b2f0f910b19d$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $3927b2f0f910b19d$export$c9058316764c140e(refA, refB) {
    const a = $3927b2f0f910b19d$var$toFnRef(refA);
    const b = $3927b2f0f910b19d$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $3927b2f0f910b19d$var$useMergedRefs(refA, refB) {
    return (0, $dNU7X.useMemo)(()=>$3927b2f0f910b19d$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $3927b2f0f910b19d$export$2e2bcd8739ae039 = $3927b2f0f910b19d$var$useMergedRefs;





var $dNU7X = parcelRequire("dNU7X");
const $81e1665cc369d40a$var$TabContext = /*#__PURE__*/ $dNU7X.createContext(null);
var $81e1665cc369d40a$export$2e2bcd8739ae039 = $81e1665cc369d40a$var$TabContext;




var $dNU7X = parcelRequire("dNU7X");







const $be94d7532c5c70fd$var$_excluded = [
    "as",
    "active",
    "eventKey"
];
function $be94d7532c5c70fd$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $be94d7532c5c70fd$export$d7a68693710982a({ key: key, onClick: onClick, active: active, id: id, role: role, disabled: disabled }) {
    const parentOnSelect = (0, $dNU7X.useContext)((0, $582101cfb39a3e27$export$2e2bcd8739ae039));
    const navContext = (0, $dNU7X.useContext)((0, $ae1fd8ad3481d7e0$export$2e2bcd8739ae039));
    const tabContext = (0, $dNU7X.useContext)((0, $81e1665cc369d40a$export$2e2bcd8739ae039));
    let isActive = active;
    const props = {
        role: role
    };
    if (navContext) {
        if (!role && navContext.role === 'tablist') props.role = 'tab';
        const contextControllerId = navContext.getControllerId(key != null ? key : null);
        const contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, $480d957e106253a4$export$5cc3b7b83e34ade7)('event-key')] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
    }
    if (props.role === 'tab') {
        props['aria-selected'] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props['aria-disabled'] = true;
        }
    }
    props.onClick = (0, $5c6b416708f5301c$export$2e2bcd8739ae039)((e)=>{
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive: isActive
        }
    ];
}
const $be94d7532c5c70fd$var$NavItem = /*#__PURE__*/ $dNU7X.forwardRef((_ref, ref)=>{
    let { as: Component = (0, $cdcb5a6d0dd9d6ce$export$2e2bcd8739ae039), active: active, eventKey: eventKey } = _ref, options = $be94d7532c5c70fd$var$_objectWithoutPropertiesLoose(_ref, $be94d7532c5c70fd$var$_excluded);
    const [props, meta] = $be94d7532c5c70fd$export$d7a68693710982a(Object.assign({
        key: (0, $582101cfb39a3e27$export$eef49b42fde998a3)(eventKey, options.href),
        active: active
    }, options));
    // @ts-ignore
    props[(0, $480d957e106253a4$export$5cc3b7b83e34ade7)('active')] = meta.isActive;
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
$be94d7532c5c70fd$var$NavItem.displayName = 'NavItem';
var $be94d7532c5c70fd$export$2e2bcd8739ae039 = $be94d7532c5c70fd$var$NavItem;



const $7578ce5be122ca19$var$_excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function $7578ce5be122ca19$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $7578ce5be122ca19$var$noop = ()=>{};
const $7578ce5be122ca19$var$EVENT_KEY_ATTR = (0, $480d957e106253a4$export$5cc3b7b83e34ade7)('event-key');
const $7578ce5be122ca19$var$Nav = /*#__PURE__*/ $dNU7X.forwardRef((_ref, ref)=>{
    let { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', onSelect: onSelect, activeKey: activeKey, role: role, onKeyDown: onKeyDown } = _ref, props = $7578ce5be122ca19$var$_objectWithoutPropertiesLoose(_ref, $7578ce5be122ca19$var$_excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    const forceUpdate = (0, $a1e7dfea23729a9b$export$2e2bcd8739ae039)();
    const needsRefocusRef = (0, $dNU7X.useRef)(false);
    const parentOnSelect = (0, $dNU7X.useContext)((0, $582101cfb39a3e27$export$2e2bcd8739ae039));
    const tabContext = (0, $dNU7X.useContext)((0, $81e1665cc369d40a$export$2e2bcd8739ae039));
    let getControlledId, getControllerId;
    if (tabContext) {
        role = role || 'tablist';
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const listNode = (0, $dNU7X.useRef)(null);
    const getNextActiveTab = (offset)=>{
        const currentListNode = listNode.current;
        if (!currentListNode) return null;
        const items = (0, $e756898da11911b9$export$2e2bcd8739ae039)(currentListNode, `[${$7578ce5be122ca19$var$EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
        const activeChild = currentListNode.querySelector('[aria-selected=true]');
        if (!activeChild || activeChild !== document.activeElement) return null;
        const index = items.indexOf(activeChild);
        if (index === -1) return null;
        let nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    const handleSelect = (key, event)=>{
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        let nextActiveChild;
        switch(event.key){
            case 'ArrowLeft':
            case 'ArrowUp':
                nextActiveChild = getNextActiveTab(-1);
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, $480d957e106253a4$export$7776c0a7cd2eb3e0)('EventKey')] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $dNU7X.useEffect)(()=>{
        if (listNode.current && needsRefocusRef.current) {
            const activeChild = listNode.current.querySelector(`[${$7578ce5be122ca19$var$EVENT_KEY_ATTR}][aria-selected=true]`);
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    const mergedRef = (0, $3927b2f0f910b19d$export$2e2bcd8739ae039)(ref, listNode);
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)((0, $582101cfb39a3e27$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)((0, $ae1fd8ad3481d7e0$export$2e2bcd8739ae039).Provider, {
            value: {
                role: role,
                // used by NavLink to determine it's role
                activeKey: (0, $582101cfb39a3e27$export$eef49b42fde998a3)(activeKey),
                getControlledId: getControlledId || $7578ce5be122ca19$var$noop,
                getControllerId: getControllerId || $7578ce5be122ca19$var$noop
            },
            children: /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
$7578ce5be122ca19$var$Nav.displayName = 'Nav';
var $7578ce5be122ca19$export$2e2bcd8739ae039 = Object.assign($7578ce5be122ca19$var$Nav, {
    Item: (0, $be94d7532c5c70fd$export$2e2bcd8739ae039)
});






var $dNU7X = parcelRequire("dNU7X");



"use client";
const $b6d5c7a4a7ffdb7e$var$NavItem = /*#__PURE__*/ $dNU7X.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'nav-item');
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$b6d5c7a4a7ffdb7e$var$NavItem.displayName = 'NavItem';
var $b6d5c7a4a7ffdb7e$export$2e2bcd8739ae039 = $b6d5c7a4a7ffdb7e$var$NavItem;




var $dNU7X = parcelRequire("dNU7X");





"use client";
const $fb708a2dee81a3ee$var$NavLink = /*#__PURE__*/ $dNU7X.forwardRef(({ bsPrefix: bsPrefix, className: className, as: Component = (0, $a22c774b44973b8f$export$2e2bcd8739ae039), active: active, eventKey: eventKey, disabled: disabled = false, ...props }, ref)=>{
    bsPrefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'nav-link');
    const [navItemProps, meta] = (0, $be94d7532c5c70fd$export$d7a68693710982a)({
        key: (0, $582101cfb39a3e27$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        disabled: disabled,
        ...props
    });
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, {
        ...props,
        ...navItemProps,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, disabled && 'disabled', meta.isActive && 'active')
    });
});
$fb708a2dee81a3ee$var$NavLink.displayName = 'NavLink';
var $fb708a2dee81a3ee$export$2e2bcd8739ae039 = $fb708a2dee81a3ee$var$NavLink;



"use client";
const $e2aa45c67a610333$var$Nav = /*#__PURE__*/ $dNU7X.forwardRef((uncontrolledProps, ref)=>{
    const { as: as = 'div', bsPrefix: initialBsPrefix, variant: variant, fill: fill = false, justify: justify = false, navbar: navbar, navbarScroll: navbarScroll, className: className, activeKey: activeKey, ...props } = (0, $52310e7f0777605e$export$2e2bcd8739ae039)(uncontrolledProps, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, $4843567570d88909$export$7f387860ebffb32c)(initialBsPrefix, 'nav');
    let navbarBsPrefix;
    let cardHeaderBsPrefix;
    let isNavbar = false;
    const navbarContext = (0, $dNU7X.useContext)((0, $f2dcebd9eba06d09$export$2e2bcd8739ae039));
    const cardHeaderContext = (0, $dNU7X.useContext)((0, $6b9496ea0bd16a54$export$2e2bcd8739ae039));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) ({ cardHeaderBsPrefix: cardHeaderBsPrefix } = cardHeaderContext);
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)((0, $7578ce5be122ca19$export$2e2bcd8739ae039), {
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, {
            [bsPrefix]: !isNavbar,
            [`${navbarBsPrefix}-nav`]: isNavbar,
            [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
            [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
            [`${bsPrefix}-${variant}`]: !!variant,
            [`${bsPrefix}-fill`]: fill,
            [`${bsPrefix}-justified`]: justify
        }),
        ...props
    });
});
$e2aa45c67a610333$var$Nav.displayName = 'Nav';
var $e2aa45c67a610333$export$2e2bcd8739ae039 = Object.assign($e2aa45c67a610333$var$Nav, {
    Item: (0, $b6d5c7a4a7ffdb7e$export$2e2bcd8739ae039),
    Link: (0, $fb708a2dee81a3ee$export$2e2bcd8739ae039)
});




var $dNU7X = parcelRequire("dNU7X");

var $dNU7X = parcelRequire("dNU7X");

var $dNU7X = parcelRequire("dNU7X");
function $f2f42639a2de69b1$export$2e2bcd8739ae039() {
    const mounted = (0, $dNU7X.useRef)(true);
    const isMounted = (0, $dNU7X.useRef)(()=>mounted.current);
    (0, $dNU7X.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}



var $dNU7X = parcelRequire("dNU7X");
function $1a98da92a2a7c20f$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $dNU7X.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $dNU7X = parcelRequire("dNU7X");
function $9b4a5b84875d4ad5$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $1a98da92a2a7c20f$export$2e2bcd8739ae039)(fn);
    (0, $dNU7X.useEffect)(()=>()=>onUnmount.current(), []);
}


/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */ const $a7945cb4433a4625$var$MAX_DELAY_MS = 2 ** 31 - 1;
function $a7945cb4433a4625$var$setChainedTimeout(handleRef, fn, timeoutAtMs) {
    const delayMs = timeoutAtMs - Date.now();
    handleRef.current = delayMs <= $a7945cb4433a4625$var$MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(()=>$a7945cb4433a4625$var$setChainedTimeout(handleRef, fn, timeoutAtMs), $a7945cb4433a4625$var$MAX_DELAY_MS);
}
function $a7945cb4433a4625$export$2e2bcd8739ae039() {
    const isMounted = (0, $f2f42639a2de69b1$export$2e2bcd8739ae039)();
    // types are confused between node and web here IDK
    const handleRef = (0, $dNU7X.useRef)();
    (0, $9b4a5b84875d4ad5$export$2e2bcd8739ae039)(()=>clearTimeout(handleRef.current));
    return (0, $dNU7X.useMemo)(()=>{
        const clear = ()=>clearTimeout(handleRef.current);
        function set(fn, delayMs = 0) {
            if (!isMounted()) return;
            clear();
            if (delayMs <= $a7945cb4433a4625$var$MAX_DELAY_MS) // For simplicity, if the timeout is short, just set a normal timeout.
            handleRef.current = setTimeout(fn, delayMs);
            else $a7945cb4433a4625$var$setChainedTimeout(handleRef, fn, Date.now() + delayMs);
        }
        return {
            set: set,
            clear: clear,
            handleRef: handleRef
        };
    }, []);
}






var $dNU7X = parcelRequire("dNU7X");
function $c3e2c43133c47cee$export$806fcc22e55e107d(e) {
    return e.code === 'Escape' || e.keyCode === 27;
}
function $c3e2c43133c47cee$export$13e065f3a74cfe36() {
    const parts = $dNU7X.version.split('.');
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}
function $c3e2c43133c47cee$export$87943f2672146d57(element) {
    if (!element || typeof element === 'function') return null;
    const { major: major } = $c3e2c43133c47cee$export$13e065f3a74cfe36();
    const childRef = major >= 19 ? element.props.ref : element.ref;
    return childRef;
}



var $dNU7X = parcelRequire("dNU7X");


var $dNU7X = parcelRequire("dNU7X");

var $boCrV = parcelRequire("boCrV");






var $dNU7X = parcelRequire("dNU7X");



const $93a8a6e8ed87fd73$var$noop = ()=>{};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $93a8a6e8ed87fd73$var$useRootClose(ref, onRootClose, { disabled: disabled, clickTrigger: clickTrigger } = {}) {
    const onClose = onRootClose || $93a8a6e8ed87fd73$var$noop;
    (0, $1379e664ae58b1e2$export$2e2bcd8739ae039)(ref, onClose, {
        disabled: disabled,
        clickTrigger: clickTrigger
    });
    const handleKeyUp = (0, $5c6b416708f5301c$export$2e2bcd8739ae039)((e)=>{
        if ((0, $c3e2c43133c47cee$export$806fcc22e55e107d)(e)) onClose(e);
    });
    (0, $dNU7X.useEffect)(()=>{
        if (disabled || ref == null) return undefined;
        const doc = (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)((0, $1379e664ae58b1e2$export$347601c75fcd4732)(ref));
        // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (doc.defaultView || window).event;
        const removeKeyupListener = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(doc, 'keyup', (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        return ()=>{
            removeKeyupListener();
        };
    }, [
        ref,
        disabled,
        handleKeyUp
    ]);
}
var $93a8a6e8ed87fd73$export$2e2bcd8739ae039 = $93a8a6e8ed87fd73$var$useRootClose;





var $dNU7X = parcelRequire("dNU7X");

const $52d62195d224c167$export$c91fd81e6d65f84a = (ref, document)=>{
    if (!(0, $c36f36ded4bef1c0$export$2e2bcd8739ae039)) return null;
    if (ref == null) return (document || (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)()).body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $52d62195d224c167$export$2e2bcd8739ae039(ref, onResolved) {
    const window = (0, $5af5d626dab37c84$export$2e2bcd8739ae039)();
    const [resolvedRef, setRef] = (0, $dNU7X.useState)(()=>$52d62195d224c167$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = $52d62195d224c167$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $dNU7X.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $dNU7X.useEffect)(()=>{
        const nextRef = $52d62195d224c167$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}







var $dNU7X = parcelRequire("dNU7X");



var $dNU7X = parcelRequire("dNU7X");

function $61465c68e35d6f7e$var$NoopTransition({ children: children, in: inProp, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit }) {
    const ref = (0, $dNU7X.useRef)(null);
    const hasEnteredRef = (0, $dNU7X.useRef)(inProp);
    const handleExited = (0, $5c6b416708f5301c$export$2e2bcd8739ae039)(onExited);
    (0, $dNU7X.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $3927b2f0f910b19d$export$2e2bcd8739ae039)(ref, (0, $c3e2c43133c47cee$export$87943f2672146d57)(children));
    const child = /*#__PURE__*/ (0, $dNU7X.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $61465c68e35d6f7e$export$2e2bcd8739ae039 = $61465c68e35d6f7e$var$NoopTransition;



var $dNU7X = parcelRequire("dNU7X");

var $dNU7X = parcelRequire("dNU7X");


const $0cd839ad282dbdc9$var$_excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function $0cd839ad282dbdc9$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $0cd839ad282dbdc9$export$2e2bcd8739ae039(_ref) {
    let { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children } = _ref, props = $0cd839ad282dbdc9$var$_objectWithoutPropertiesLoose(_ref, $0cd839ad282dbdc9$var$_excluded);
    const nodeRef = (0, $dNU7X.useRef)(null);
    const mergedRef = (0, $3927b2f0f910b19d$export$2e2bcd8739ae039)(nodeRef, (0, $c3e2c43133c47cee$export$87943f2672146d57)(children));
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $dNU7X.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $dNU7X.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $dNU7X.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $dNU7X.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $dNU7X.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $dNU7X.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $dNU7X.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef: nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })) : /*#__PURE__*/ (0, $dNU7X.cloneElement)(children, {
            ref: mergedRef
        })
    });
}



const $45d59ec4c767d4a0$var$_excluded = [
    "component"
];
function $45d59ec4c767d4a0$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Normalizes Transition callbacks when nodeRef is used.
const $45d59ec4c767d4a0$var$RTGTransition = /*#__PURE__*/ $dNU7X.forwardRef((_ref, ref)=>{
    let { component: Component } = _ref, props = $45d59ec4c767d4a0$var$_objectWithoutPropertiesLoose(_ref, $45d59ec4c767d4a0$var$_excluded);
    const transitionProps = (0, $0cd839ad282dbdc9$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
var $45d59ec4c767d4a0$export$2e2bcd8739ae039 = $45d59ec4c767d4a0$var$RTGTransition;




function $558b8f56c7c923aa$export$7b286972b8d8ccbf({ in: inProp, onTransition: onTransition }) {
    const ref = (0, $dNU7X.useRef)(null);
    const isInitialRef = (0, $dNU7X.useRef)(true);
    const handleTransition = (0, $5c6b416708f5301c$export$2e2bcd8739ae039)(onTransition);
    (0, $a1527d8ad7595fdd$export$2e2bcd8739ae039)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $a1527d8ad7595fdd$export$2e2bcd8739ae039)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $558b8f56c7c923aa$export$2e2bcd8739ae039({ children: children, in: inProp, onExited: onExited, onEntered: onEntered, transition: transition }) {
    const [exited, setExited] = (0, $dNU7X.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = $558b8f56c7c923aa$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, $3927b2f0f910b19d$export$2e2bcd8739ae039)(ref, (0, $c3e2c43133c47cee$export$87943f2672146d57)(children));
    return exited && !inProp ? null : /*#__PURE__*/ (0, $dNU7X.cloneElement)(children, {
        ref: combinedRef
    });
}
function $558b8f56c7c923aa$export$f41d64aae6d6dba5(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)((0, $45d59ec4c767d4a0$export$2e2bcd8739ae039), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)($558b8f56c7c923aa$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)((0, $61465c68e35d6f7e$export$2e2bcd8739ae039), Object.assign({}, props));
}


/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */ const $eaad36e5cd829225$var$Overlay = /*#__PURE__*/ $dNU7X.forwardRef((props, outerRef)=>{
    const { flip: flip, offset: offset, placement: placement, containerPadding: containerPadding, popperConfig: popperConfig = {}, transition: Transition, runTransition: runTransition } = props;
    const [rootElement, attachRef] = (0, $ff7c1391d2bce6e2$export$2e2bcd8739ae039)();
    const [arrowElement, attachArrowRef] = (0, $ff7c1391d2bce6e2$export$2e2bcd8739ae039)();
    const mergedRef = (0, $3927b2f0f910b19d$export$2e2bcd8739ae039)(attachRef, outerRef);
    const container = (0, $52d62195d224c167$export$2e2bcd8739ae039)(props.container);
    const target = (0, $52d62195d224c167$export$2e2bcd8739ae039)(props.target);
    const [exited, setExited] = (0, $dNU7X.useState)(!props.show);
    const popper = (0, $16b0f98161552fa4$export$2e2bcd8739ae039)(target, rootElement, (0, $fc7c8a8c537ddccf$export$2e2bcd8739ae039)({
        placement: placement,
        enableEvents: !!props.show,
        containerPadding: containerPadding || 5,
        flip: flip,
        offset: offset,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    // TODO: I think this needs to be in an effect
    if (props.show && exited) setExited(false);
    const handleHidden = (...args)=>{
        setExited(true);
        if (props.onExited) props.onExited(...args);
    };
    // Don't un-render the overlay while it's transitioning out.
    const mountOverlay = props.show || !exited;
    (0, $93a8a6e8ed87fd73$export$2e2bcd8739ae039)(rootElement, props.onHide, {
        disabled: !props.rootClose || props.rootCloseDisabled,
        clickTrigger: props.rootCloseEvent
    });
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    const { onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = props;
    let child = props.children(Object.assign({}, popper.attributes.popper, {
        style: popper.styles.popper,
        ref: mergedRef
    }), {
        popper: popper,
        placement: placement,
        show: !!props.show,
        arrowProps: Object.assign({}, popper.attributes.arrow, {
            style: popper.styles.arrow,
            ref: attachArrowRef
        })
    });
    child = (0, $558b8f56c7c923aa$export$f41d64aae6d6dba5)(Transition, runTransition, {
        in: !!props.show,
        appear: true,
        mountOnEnter: true,
        unmountOnExit: true,
        children: child,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered
    });
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($boCrV))).createPortal(child, container) : null;
});
$eaad36e5cd829225$var$Overlay.displayName = 'Overlay';
var $eaad36e5cd829225$export$2e2bcd8739ae039 = $eaad36e5cd829225$var$Overlay;






var $dNU7X = parcelRequire("dNU7X");
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $bb7f18969320ba30$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}





var $dNU7X = parcelRequire("dNU7X");


var $dNU7X = parcelRequire("dNU7X");



"use client";
const $48d24130193bfc94$var$PopoverHeader = /*#__PURE__*/ $dNU7X.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'popover-header');
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$48d24130193bfc94$var$PopoverHeader.displayName = 'PopoverHeader';
var $48d24130193bfc94$export$2e2bcd8739ae039 = $48d24130193bfc94$var$PopoverHeader;



var $dNU7X = parcelRequire("dNU7X");



"use client";
const $47127144ee64271c$var$PopoverBody = /*#__PURE__*/ $dNU7X.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'popover-body');
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix),
        ...props
    });
});
$47127144ee64271c$var$PopoverBody.displayName = 'PopoverBody';
var $47127144ee64271c$export$2e2bcd8739ae039 = $47127144ee64271c$var$PopoverBody;



var $dNU7X = parcelRequire("dNU7X");
class $dedbd669e050bbc5$export$34582a676b91ff07 extends $dNU7X.Component {
}
function $dedbd669e050bbc5$export$c15856915a9b3464(placement, isRTL) {
    let bsDirection = placement;
    if (placement === 'left') bsDirection = isRTL ? 'end' : 'start';
    else if (placement === 'right') bsDirection = isRTL ? 'start' : 'end';
    return bsDirection;
}


function $26a156274e6d0dbd$export$2e2bcd8739ae039(position = 'absolute') {
    return {
        position: position,
        top: '0',
        left: '0',
        opacity: '0',
        pointerEvents: 'none'
    };
}



"use client";
const $3aba1b22127dfbc2$var$Popover = /*#__PURE__*/ $dNU7X.forwardRef(({ bsPrefix: bsPrefix, placement: placement = 'right', className: className, style: style, children: children, body: body, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'popover');
    const isRTL = (0, $4843567570d88909$export$35e511eefa30ac5a)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
    const bsDirection = (0, $dedbd669e050bbc5$export$c15856915a9b3464)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $26a156274e6d0dbd$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsxs)("div", {
        ref: ref,
        role: "tooltip",
        style: computedStyle,
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, decoratedBsPrefix, primaryPlacement && `bs-popover-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)("div", {
                className: "popover-arrow",
                ...arrowProps
            }),
            body ? /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)((0, $47127144ee64271c$export$2e2bcd8739ae039), {
                children: children
            }) : children
        ]
    });
});
$3aba1b22127dfbc2$var$Popover.displayName = 'Popover';
var $3aba1b22127dfbc2$export$2e2bcd8739ae039 = Object.assign($3aba1b22127dfbc2$var$Popover, {
    Header: (0, $48d24130193bfc94$export$2e2bcd8739ae039),
    Body: (0, $47127144ee64271c$export$2e2bcd8739ae039),
    // Default popover offset.
    // https://github.com/twbs/bootstrap/blob/5c32767e0e0dbac2d934bcdee03719a65d3f1187/js/src/popover.js#L28
    POPPER_OFFSET: [
        0,
        8
    ]
});




var $dNU7X = parcelRequire("dNU7X");




"use client";
const $cd4f066234704aac$var$Tooltip = /*#__PURE__*/ $dNU7X.forwardRef(({ bsPrefix: bsPrefix, placement: placement = 'right', className: className, style: style, children: children, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    bsPrefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'tooltip');
    const isRTL = (0, $4843567570d88909$export$35e511eefa30ac5a)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
    const bsDirection = (0, $dedbd669e050bbc5$export$c15856915a9b3464)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $26a156274e6d0dbd$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsxs)("div", {
        ref: ref,
        style: computedStyle,
        role: "tooltip",
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsPrefix, `bs-tooltip-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)("div", {
                className: "tooltip-arrow",
                ...arrowProps
            }),
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)("div", {
                className: `${bsPrefix}-inner`,
                children: children
            })
        ]
    });
});
$cd4f066234704aac$var$Tooltip.displayName = 'Tooltip';
var $cd4f066234704aac$export$2e2bcd8739ae039 = Object.assign($cd4f066234704aac$var$Tooltip, {
    // Default tooltip offset.
    // https://github.com/twbs/bootstrap/blob/beca2a6c7f6bc88b6449339fc76edcda832c59e5/js/src/tooltip.js#L65
    TOOLTIP_OFFSET: [
        0,
        6
    ]
});


"use client";
function $42287fbff1c830f9$export$2e2bcd8739ae039(customOffset) {
    const overlayRef = (0, $dNU7X.useRef)(null);
    const popoverClass = (0, $4843567570d88909$export$7f387860ebffb32c)(undefined, 'popover');
    const tooltipClass = (0, $4843567570d88909$export$7f387860ebffb32c)(undefined, 'tooltip');
    const offset = (0, $dNU7X.useMemo)(()=>({
            name: 'offset',
            options: {
                offset: ()=>{
                    if (customOffset) return customOffset;
                    if (overlayRef.current) {
                        if ((0, $bb7f18969320ba30$export$2e2bcd8739ae039)(overlayRef.current, popoverClass)) return (0, $3aba1b22127dfbc2$export$2e2bcd8739ae039).POPPER_OFFSET;
                        if ((0, $bb7f18969320ba30$export$2e2bcd8739ae039)(overlayRef.current, tooltipClass)) return (0, $cd4f066234704aac$export$2e2bcd8739ae039).TOOLTIP_OFFSET;
                    }
                    return [
                        0,
                        0
                    ];
                }
            }
        }), [
        customOffset,
        popoverClass,
        tooltipClass
    ]);
    return [
        overlayRef,
        [
            offset
        ]
    ];
}




var $dNU7X = parcelRequire("dNU7X");




var $dNU7X = parcelRequire("dNU7X");

var $boCrV = parcelRequire("boCrV");
var $31b91d6a20758467$export$2e2bcd8739ae039 = {
    disabled: false
};




var $dNU7X = parcelRequire("dNU7X");
var $f17fcedc3775cc37$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).createContext(null);


var $59f405bf321f0806$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $fa3810d37f821d51$export$bb38bb9a1161268 = 'unmounted';
var $fa3810d37f821d51$export$84cbff306f539230 = 'exited';
var $fa3810d37f821d51$export$df38205c966be359 = 'entering';
var $fa3810d37f821d51$export$78e9e6e3e014d60a = 'entered';
var $fa3810d37f821d51$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $fa3810d37f821d51$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $5122792117adb82d$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $fa3810d37f821d51$export$84cbff306f539230;
                _this.appearStatus = $fa3810d37f821d51$export$df38205c966be359;
            } else initialStatus = $fa3810d37f821d51$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $fa3810d37f821d51$export$bb38bb9a1161268;
        else initialStatus = $fa3810d37f821d51$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $fa3810d37f821d51$export$bb38bb9a1161268) return {
            status: $fa3810d37f821d51$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $fa3810d37f821d51$export$df38205c966be359 && status !== $fa3810d37f821d51$export$78e9e6e3e014d60a) nextStatus = $fa3810d37f821d51$export$df38205c966be359;
            } else if (status === $fa3810d37f821d51$export$df38205c966be359 || status === $fa3810d37f821d51$export$78e9e6e3e014d60a) nextStatus = $fa3810d37f821d51$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $fa3810d37f821d51$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($boCrV))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $59f405bf321f0806$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $fa3810d37f821d51$export$84cbff306f539230) this.setState({
            status: $fa3810d37f821d51$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($boCrV))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $31b91d6a20758467$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $fa3810d37f821d51$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $fa3810d37f821d51$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $fa3810d37f821d51$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($boCrV))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $31b91d6a20758467$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $fa3810d37f821d51$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $fa3810d37f821d51$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $fa3810d37f821d51$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($boCrV))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $fa3810d37f821d51$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $a396812ba85d91d0$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).createElement((0, $f17fcedc3775cc37$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).Component);
$fa3810d37f821d51$var$Transition.contextType = (0, $f17fcedc3775cc37$export$2e2bcd8739ae039);
$fa3810d37f821d51$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $fa3810d37f821d51$var$noop() {}
$fa3810d37f821d51$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $fa3810d37f821d51$var$noop,
    onEntering: $fa3810d37f821d51$var$noop,
    onEntered: $fa3810d37f821d51$var$noop,
    onExit: $fa3810d37f821d51$var$noop,
    onExiting: $fa3810d37f821d51$var$noop,
    onExited: $fa3810d37f821d51$var$noop
};
$fa3810d37f821d51$var$Transition.UNMOUNTED = $fa3810d37f821d51$export$bb38bb9a1161268;
$fa3810d37f821d51$var$Transition.EXITED = $fa3810d37f821d51$export$84cbff306f539230;
$fa3810d37f821d51$var$Transition.ENTERING = $fa3810d37f821d51$export$df38205c966be359;
$fa3810d37f821d51$var$Transition.ENTERED = $fa3810d37f821d51$export$78e9e6e3e014d60a;
$fa3810d37f821d51$var$Transition.EXITING = $fa3810d37f821d51$export$4aacc83d4d59139f;
var $fa3810d37f821d51$export$2e2bcd8739ae039 = $fa3810d37f821d51$var$Transition;




function $687967af0f2f65dd$export$2e2bcd8739ae039(node) {
    var doc = (0, $e2f451e3d449ae45$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $bab365215d6465d0$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $687967af0f2f65dd$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $bb45a00770e1e637$var$rUpper = /([A-Z])/g;
function $bb45a00770e1e637$export$2e2bcd8739ae039(string) {
    return string.replace($bb45a00770e1e637$var$rUpper, '-$1').toLowerCase();
}


var $b9e9e022259fd181$var$msPattern = /^ms-/;
function $b9e9e022259fd181$export$2e2bcd8739ae039(string) {
    return (0, $bb45a00770e1e637$export$2e2bcd8739ae039)(string).replace($b9e9e022259fd181$var$msPattern, '-ms-');
}


var $cfefa1cd0af90d26$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $cfefa1cd0af90d26$export$2e2bcd8739ae039(value) {
    return !!(value && $cfefa1cd0af90d26$var$supportedTransforms.test(value));
}


function $8e0039237f2a8b13$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $b9e9e022259fd181$export$2e2bcd8739ae039)(property)) || (0, $bab365215d6465d0$export$2e2bcd8739ae039)(node).getPropertyValue((0, $b9e9e022259fd181$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $b9e9e022259fd181$export$2e2bcd8739ae039)(key));
        else if ((0, $cfefa1cd0af90d26$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $b9e9e022259fd181$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $8e0039237f2a8b13$export$2e2bcd8739ae039 = $8e0039237f2a8b13$var$style;




/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $86531d9dcbce6c08$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}


function $d247f6e7f04e903f$var$parseDuration(node) {
    var str = (0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $d247f6e7f04e903f$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $86531d9dcbce6c08$export$2e2bcd8739ae039)(element, 'transitionend', true);
    }, duration + padding);
    var remove = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $d247f6e7f04e903f$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $d247f6e7f04e903f$var$parseDuration(element) || 0;
    var removeEmulate = $d247f6e7f04e903f$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $e30c1a8b3e180f01$export$2e2bcd8739ae039)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}


function $6d550b7bb419a543$var$parseDuration(node, property) {
    const str = (0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(node, property) || '';
    const mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $6d550b7bb419a543$export$2e2bcd8739ae039(element, handler) {
    const duration = $6d550b7bb419a543$var$parseDuration(element, 'transitionDuration');
    const delay = $6d550b7bb419a543$var$parseDuration(element, 'transitionDelay');
    const remove = (0, $d247f6e7f04e903f$export$2e2bcd8739ae039)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}


// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $e830fdd71fd78692$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}



var $dNU7X = parcelRequire("dNU7X");



var $boCrV = parcelRequire("boCrV");
function $1bd1f724dff45789$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) // TODO: Remove in next major.
    // eslint-disable-next-line react/no-find-dom-node
    return (0, (/*@__PURE__*/$parcel$interopDefault($boCrV))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}



"use client";
// Normalizes Transition callbacks when nodeRef is used.
const $c8ab7d3c44949da1$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children, childRef: childRef, ...props }, ref)=>{
    const nodeRef = (0, $dNU7X.useRef)(null);
    const mergedRef = (0, $f21f3c4c3cb27992$export$2e2bcd8739ae039)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $1bd1f724dff45789$export$2e2bcd8739ae039)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    const handleEnter = (0, $dNU7X.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $dNU7X.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $dNU7X.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $dNU7X.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $dNU7X.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $dNU7X.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $dNU7X.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)((0, $fa3810d37f821d51$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).cloneElement(children, {
            ref: attachRef
        })
    });
});
$c8ab7d3c44949da1$var$TransitionWrapper.displayName = 'TransitionWrapper';
var $c8ab7d3c44949da1$export$2e2bcd8739ae039 = $c8ab7d3c44949da1$var$TransitionWrapper;



const $8054c942189b7618$var$fadeStyles = {
    [(0, $fa3810d37f821d51$export$df38205c966be359)]: 'show',
    [(0, $fa3810d37f821d51$export$78e9e6e3e014d60a)]: 'show'
};
const $8054c942189b7618$var$Fade = /*#__PURE__*/ $dNU7X.forwardRef(({ className: className, children: children, transitionClasses: transitionClasses = {}, onEnter: onEnter, ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, $dNU7X.useCallback)((node, isAppearing)=>{
        (0, $e830fdd71fd78692$export$2e2bcd8739ae039)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)((0, $c8ab7d3c44949da1$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $6d550b7bb419a543$export$2e2bcd8739ae039),
        ...props,
        onEnter: handleEnter,
        childRef: (0, $c3e2c43133c47cee$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $dNU7X.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))('fade', className, children.props.className, $8054c942189b7618$var$fadeStyles[status], transitionClasses[status])
            })
    });
});
$8054c942189b7618$var$Fade.displayName = 'Fade';
var $8054c942189b7618$export$2e2bcd8739ae039 = $8054c942189b7618$var$Fade;




"use client";
function $aaad64549b43abc9$var$wrapRefs(props, arrowProps) {
    const { ref: ref } = props;
    const { ref: aRef } = arrowProps;
    props.ref = ref.__wrapped || (ref.__wrapped = (r)=>ref((0, $1bd1f724dff45789$export$2e2bcd8739ae039)(r)));
    arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = (r)=>aRef((0, $1bd1f724dff45789$export$2e2bcd8739ae039)(r)));
}
const $aaad64549b43abc9$var$Overlay = /*#__PURE__*/ $dNU7X.forwardRef(({ children: overlay, transition: transition = (0, $8054c942189b7618$export$2e2bcd8739ae039), popperConfig: popperConfig = {}, rootClose: rootClose = false, placement: placement = 'top', show: outerShow = false, ...outerProps }, outerRef)=>{
    const popperRef = (0, $dNU7X.useRef)({});
    const [firstRenderedState, setFirstRenderedState] = (0, $dNU7X.useState)(null);
    const [ref, modifiers] = (0, $42287fbff1c830f9$export$2e2bcd8739ae039)(outerProps.offset);
    const mergedRef = (0, $f21f3c4c3cb27992$export$2e2bcd8739ae039)(outerRef, ref);
    const actualTransition = transition === true ? (0, $8054c942189b7618$export$2e2bcd8739ae039) : transition || undefined;
    const handleFirstUpdate = (0, $e654881f234539ec$export$2e2bcd8739ae039)((state)=>{
        setFirstRenderedState(state);
        popperConfig == null || popperConfig.onFirstUpdate == null || popperConfig.onFirstUpdate(state);
    });
    (0, $0215886653e4f139$export$2e2bcd8739ae039)(()=>{
        if (firstRenderedState && outerProps.target) // Must wait for target element to resolve before updating popper.
        popperRef.current.scheduleUpdate == null || popperRef.current.scheduleUpdate();
    }, [
        firstRenderedState,
        outerProps.target
    ]);
    (0, $dNU7X.useEffect)(()=>{
        if (!outerShow) setFirstRenderedState(null);
    }, [
        outerShow
    ]);
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)((0, $eaad36e5cd829225$export$2e2bcd8739ae039), {
        ...outerProps,
        ref: mergedRef,
        popperConfig: {
            ...popperConfig,
            modifiers: modifiers.concat(popperConfig.modifiers || []),
            onFirstUpdate: handleFirstUpdate
        },
        transition: actualTransition,
        rootClose: rootClose,
        placement: placement,
        show: outerShow,
        children: (overlayProps, { arrowProps: arrowProps, popper: popperObj, show: show })=>{
            var _popperObj$state;
            $aaad64549b43abc9$var$wrapRefs(overlayProps, arrowProps);
            // Need to get placement from popper object, handling case when overlay is flipped using 'flip' prop
            const updatedPlacement = popperObj == null ? void 0 : popperObj.placement;
            const popper = Object.assign(popperRef.current, {
                state: popperObj == null ? void 0 : popperObj.state,
                scheduleUpdate: popperObj == null ? void 0 : popperObj.update,
                placement: updatedPlacement,
                outOfBoundaries: (popperObj == null || (_popperObj$state = popperObj.state) == null || (_popperObj$state = _popperObj$state.modifiersData.hide) == null ? void 0 : _popperObj$state.isReferenceHidden) || false,
                strategy: popperConfig.strategy
            });
            const hasDoneInitialMeasure = !!firstRenderedState;
            if (typeof overlay === 'function') return overlay({
                ...overlayProps,
                placement: updatedPlacement,
                show: show,
                ...!transition && show && {
                    className: 'show'
                },
                popper: popper,
                arrowProps: arrowProps,
                hasDoneInitialMeasure: hasDoneInitialMeasure
            });
            return /*#__PURE__*/ $dNU7X.cloneElement(overlay, {
                ...overlayProps,
                placement: updatedPlacement,
                arrowProps: arrowProps,
                popper: popper,
                hasDoneInitialMeasure: hasDoneInitialMeasure,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(overlay.props.className, !transition && show && 'show'),
                style: {
                    ...overlay.props.style,
                    ...overlayProps.style
                }
            });
        }
    });
});
$aaad64549b43abc9$var$Overlay.displayName = 'Overlay';
var $aaad64549b43abc9$export$2e2bcd8739ae039 = $aaad64549b43abc9$var$Overlay;




"use client";
function $4345da258e966f14$var$normalizeDelay(delay) {
    return delay && typeof delay === 'object' ? delay : {
        show: delay,
        hide: delay
    };
}
// Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.
function $4345da258e966f14$var$handleMouseOverOut(handler, args, relatedNative) {
    const [e] = args;
    const target = e.currentTarget;
    const related = e.relatedTarget || e.nativeEvent[relatedNative];
    if ((!related || related !== target) && !(0, $97c75dca58f4c376$export$2e2bcd8739ae039)(target, related)) handler(...args);
}
const $4345da258e966f14$var$triggerType = (0, (/*@__PURE__*/$parcel$interopDefault($38b29c2dc0019b47$exports))).oneOf([
    'click',
    'hover',
    'focus'
]);
const $4345da258e966f14$var$OverlayTrigger = ({ trigger: trigger = [
    'hover',
    'focus'
], overlay: overlay, children: children, popperConfig: popperConfig = {}, show: propsShow, defaultShow: defaultShow = false, onToggle: onToggle, delay: propsDelay, placement: placement, flip: flip = placement && placement.indexOf('auto') !== -1, ...props })=>{
    const triggerNodeRef = (0, $dNU7X.useRef)(null);
    const mergedRef = (0, $f21f3c4c3cb27992$export$2e2bcd8739ae039)(triggerNodeRef, (0, $c3e2c43133c47cee$export$87943f2672146d57)(children));
    const timeout = (0, $a7945cb4433a4625$export$2e2bcd8739ae039)();
    const hoverStateRef = (0, $dNU7X.useRef)('');
    const [show, setShow] = (0, $52310e7f0777605e$export$2ee51287a16ca325)(propsShow, defaultShow, onToggle);
    const delay = $4345da258e966f14$var$normalizeDelay(propsDelay);
    const { onFocus: onFocus, onBlur: onBlur, onClick: onClick } = typeof children !== 'function' ? $dNU7X.Children.only(children).props : {};
    const attachRef = (r)=>{
        mergedRef((0, $1bd1f724dff45789$export$2e2bcd8739ae039)(r));
    };
    const handleShow = (0, $dNU7X.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = 'show';
        if (!delay.show) {
            setShow(true);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === 'show') setShow(true);
        }, delay.show);
    }, [
        delay.show,
        setShow,
        timeout
    ]);
    const handleHide = (0, $dNU7X.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = 'hide';
        if (!delay.hide) {
            setShow(false);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === 'hide') setShow(false);
        }, delay.hide);
    }, [
        delay.hide,
        setShow,
        timeout
    ]);
    const handleFocus = (0, $dNU7X.useCallback)((...args)=>{
        handleShow();
        onFocus == null || onFocus(...args);
    }, [
        handleShow,
        onFocus
    ]);
    const handleBlur = (0, $dNU7X.useCallback)((...args)=>{
        handleHide();
        onBlur == null || onBlur(...args);
    }, [
        handleHide,
        onBlur
    ]);
    const handleClick = (0, $dNU7X.useCallback)((...args)=>{
        setShow(!show);
        onClick == null || onClick(...args);
    }, [
        onClick,
        setShow,
        show
    ]);
    const handleMouseOver = (0, $dNU7X.useCallback)((...args)=>{
        $4345da258e966f14$var$handleMouseOverOut(handleShow, args, 'fromElement');
    }, [
        handleShow
    ]);
    const handleMouseOut = (0, $dNU7X.useCallback)((...args)=>{
        $4345da258e966f14$var$handleMouseOverOut(handleHide, args, 'toElement');
    }, [
        handleHide
    ]);
    const triggers = trigger == null ? [] : [].concat(trigger);
    const triggerProps = {
        ref: attachRef
    };
    if (triggers.indexOf('click') !== -1) triggerProps.onClick = handleClick;
    if (triggers.indexOf('focus') !== -1) {
        triggerProps.onFocus = handleFocus;
        triggerProps.onBlur = handleBlur;
    }
    if (triggers.indexOf('hover') !== -1) {
        triggerProps.onMouseOver = handleMouseOver;
        triggerProps.onMouseOut = handleMouseOut;
    }
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsxs)((0, $2111e08a92d70add$exports.Fragment), {
        children: [
            typeof children === 'function' ? children(triggerProps) : /*#__PURE__*/ (0, $dNU7X.cloneElement)(children, triggerProps),
            /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)((0, $aaad64549b43abc9$export$2e2bcd8739ae039), {
                ...props,
                show: show,
                onHide: handleHide,
                flip: flip,
                placement: placement,
                popperConfig: popperConfig,
                target: triggerNodeRef.current,
                children: overlay
            })
        ]
    });
};
var $4345da258e966f14$export$2e2bcd8739ae039 = $4345da258e966f14$var$OverlayTrigger;



var $dNU7X = parcelRequire("dNU7X");


"use client";
const $39d0d74bdb7b93e7$var$Row = /*#__PURE__*/ $dNU7X.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const decoratedBsPrefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'row');
    const breakpoints = (0, $4843567570d88909$export$8970c8db816a5863)();
    const minBreakpoint = (0, $4843567570d88909$export$d926d6ef38f3fd32)();
    const sizePrefix = `${decoratedBsPrefix}-cols`;
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let cols;
        if (propValue != null && typeof propValue === 'object') ({ cols: cols } = propValue);
        else cols = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
    });
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, decoratedBsPrefix, ...classes)
    });
});
$39d0d74bdb7b93e7$var$Row.displayName = 'Row';
var $39d0d74bdb7b93e7$export$2e2bcd8739ae039 = $39d0d74bdb7b93e7$var$Row;



var $dNU7X = parcelRequire("dNU7X");


"use client";
const $45f3ae5f1643f191$var$Spinner = /*#__PURE__*/ $dNU7X.forwardRef(({ bsPrefix: bsPrefix, variant: variant, animation: animation = 'border', size: size, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className: className, ...props }, ref)=>{
    bsPrefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'spinner');
    const bsSpinnerPrefix = `${bsPrefix}-${animation}`;
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, bsSpinnerPrefix, size && `${bsSpinnerPrefix}-${size}`, variant && `text-${variant}`)
    });
});
$45f3ae5f1643f191$var$Spinner.displayName = 'Spinner';
var $45f3ae5f1643f191$export$2e2bcd8739ae039 = $45f3ae5f1643f191$var$Spinner;



var $dNU7X = parcelRequire("dNU7X");


"use client";
const $8a4db44e7eb3b880$var$Table = /*#__PURE__*/ $dNU7X.forwardRef(({ bsPrefix: bsPrefix, className: className, striped: striped, bordered: bordered, borderless: borderless, hover: hover, size: size, variant: variant, responsive: responsive, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'table');
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, decoratedBsPrefix, variant && `${decoratedBsPrefix}-${variant}`, size && `${decoratedBsPrefix}-${size}`, striped && `${decoratedBsPrefix}-${typeof striped === 'string' ? `striped-${striped}` : 'striped'}`, bordered && `${decoratedBsPrefix}-bordered`, borderless && `${decoratedBsPrefix}-borderless`, hover && `${decoratedBsPrefix}-hover`);
    const table = /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)("table", {
        ...props,
        className: classes,
        ref: ref
    });
    if (responsive) {
        let responsiveClass = `${decoratedBsPrefix}-responsive`;
        if (typeof responsive === 'string') responsiveClass = `${responsiveClass}-${responsive}`;
        return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)("div", {
            className: responsiveClass,
            children: table
        });
    }
    return table;
});
$8a4db44e7eb3b880$var$Table.displayName = 'Table';
var $8a4db44e7eb3b880$export$2e2bcd8739ae039 = $8a4db44e7eb3b880$var$Table;


var $7ddf193e68e751e3$exports = {};



var $0b0867a6ee357054$export$71511d61b312f219;
"use strict";
var $e5c30bc2aeee69ad$export$71511d61b312f219;
"use strict";

function $e5c30bc2aeee69ad$var$_super_prop_base(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = $9ac8e64cff09d58e$export$71511d61b312f219(object);
        if (object === null) break;
    }
    return object;
}
$e5c30bc2aeee69ad$export$71511d61b312f219 = $e5c30bc2aeee69ad$var$_super_prop_base;


function $0b0867a6ee357054$var$_get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $0b0867a6ee357054$export$71511d61b312f219 = $0b0867a6ee357054$var$_get = Reflect.get;
    else $0b0867a6ee357054$export$71511d61b312f219 = $0b0867a6ee357054$var$_get = function get(target, property, receiver) {
        var base = $e5c30bc2aeee69ad$export$71511d61b312f219(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $0b0867a6ee357054$var$_get(target, property, receiver || target);
}
$0b0867a6ee357054$export$71511d61b312f219 = $0b0867a6ee357054$var$_get;






var $dYe7D = parcelRequire("dYe7D");

var $dZnzp = parcelRequire("dZnzp");

var $dNU7X = parcelRequire("dNU7X");
function $0fd9d527cd0d1501$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $0fd9d527cd0d1501$var$$9b05bcda60cc529c$exports = {};
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$9b05bcda60cc529c$exports, "likeNull", function() {
    return $0fd9d527cd0d1501$export$61cc6ed0f143570b;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$9b05bcda60cc529c$exports, "isEmpty", function() {
    return $0fd9d527cd0d1501$export$dd1bc94b04021eeb;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$9b05bcda60cc529c$exports, "classNameOf", function() {
    return $0fd9d527cd0d1501$export$a09f818797e212c4;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$9b05bcda60cc529c$exports, "assertInheritance", function() {
    return $0fd9d527cd0d1501$export$170f4e08cad8229d;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$9b05bcda60cc529c$exports, "proxyPrototype", function() {
    return $0fd9d527cd0d1501$export$2a489b3f92f4996a;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$9b05bcda60cc529c$exports, "isUnsafeNumeric", function() {
    return $0fd9d527cd0d1501$export$67a6ce548ae77071;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$9b05bcda60cc529c$exports, "byteLength", function() {
    return $0fd9d527cd0d1501$export$a48f0734ac7c2329;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$9b05bcda60cc529c$exports, "toHyphenCase", function() {
    return $0fd9d527cd0d1501$export$3f34ca2fef821bbd;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$9b05bcda60cc529c$exports, "toCamelCase", function() {
    return $0fd9d527cd0d1501$export$86f54f62aa7a7514;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$9b05bcda60cc529c$exports, "uniqueID", function() {
    return $0fd9d527cd0d1501$export$89912e019eef22aa;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$9b05bcda60cc529c$exports, "encodeBase64", function() {
    return $0fd9d527cd0d1501$export$8fb536984ec8b4d7;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$9b05bcda60cc529c$exports, "decodeBase64", function() {
    return $0fd9d527cd0d1501$export$94fdf11bafc8de6b;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$9b05bcda60cc529c$exports, "objectFrom", function() {
    return $0fd9d527cd0d1501$export$1c8ba402144543e5;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$9b05bcda60cc529c$exports, "DiffStatus", function() {
    return $0fd9d527cd0d1501$export$2ddabb89308e1a22;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$9b05bcda60cc529c$exports, "diffKeys", function() {
    return $0fd9d527cd0d1501$export$14527669107aa301;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$9b05bcda60cc529c$exports, "groupBy", function() {
    return $0fd9d527cd0d1501$export$3f063810d7bf01bd;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$9b05bcda60cc529c$exports, "likeArray", function() {
    return $0fd9d527cd0d1501$export$b5a4d6f439a5044d;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$9b05bcda60cc529c$exports, "isTypedArray", function() {
    return $0fd9d527cd0d1501$export$b119cc7e1840e59c;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$9b05bcda60cc529c$exports, "makeArray", function() {
    return $0fd9d527cd0d1501$export$7b85fd78dd236198;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$9b05bcda60cc529c$exports, "splitArray", function() {
    return $0fd9d527cd0d1501$export$697c3df919c0e61a;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$9b05bcda60cc529c$exports, "countBy", function() {
    return $0fd9d527cd0d1501$export$1d012a0dff3dab06;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$9b05bcda60cc529c$exports, "findDeep", function() {
    return $0fd9d527cd0d1501$export$e6b5ff3168b5942b;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$9b05bcda60cc529c$exports, "treeFrom", function() {
    return $0fd9d527cd0d1501$export$fbc9cd6af26fa64f;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$9b05bcda60cc529c$exports, "cache", function() {
    return $0fd9d527cd0d1501$export$69a3209f1a06c04d;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$9b05bcda60cc529c$exports, "createAsyncIterator", function() {
    return $0fd9d527cd0d1501$export$86c18c6347f4a8c4;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$9b05bcda60cc529c$exports, "mergeStream", function() {
    return $0fd9d527cd0d1501$export$dce9414bed0662c;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$9b05bcda60cc529c$exports, "ByteSize", function() {
    return $0fd9d527cd0d1501$export$271f7c16f175f804;
});
var $0fd9d527cd0d1501$var$$6a9944941b4c1893$exports = {};
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$6a9944941b4c1893$exports, "sum", function() {
    return $0fd9d527cd0d1501$export$8a63f25cc62965f1;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$6a9944941b4c1893$exports, "averageOf", function() {
    return $0fd9d527cd0d1501$export$e1f36757ecda301d;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$6a9944941b4c1893$exports, "varianceOf", function() {
    return $0fd9d527cd0d1501$export$8e694e1eafd55acb;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$6a9944941b4c1893$exports, "standardDeviationOf", function() {
    return $0fd9d527cd0d1501$export$57d7c52a66287430;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$6a9944941b4c1893$exports, "hypotenuseOf", function() {
    return $0fd9d527cd0d1501$export$2b4693832ca3ce16;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$6a9944941b4c1893$exports, "carryFloat", function() {
    return $0fd9d527cd0d1501$export$5b784e078da1ce6;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$6a9944941b4c1893$exports, "fixFloat", function() {
    return $0fd9d527cd0d1501$export$17ec9c9f4f23588c;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$6a9944941b4c1893$exports, "Scalar", function() {
    return $0fd9d527cd0d1501$export$595dbf49c602a1f;
});
function $0fd9d527cd0d1501$export$8a63f25cc62965f1(...data) {
    return data.reduce((sum, item)=>sum + item, 0);
}
function $0fd9d527cd0d1501$export$e1f36757ecda301d(...data) {
    return $0fd9d527cd0d1501$export$8a63f25cc62965f1(...data) / data.length;
}
function $0fd9d527cd0d1501$export$8e694e1eafd55acb(data, sample = false) {
    const average = $0fd9d527cd0d1501$export$e1f36757ecda301d(...data);
    const summary = $0fd9d527cd0d1501$export$8a63f25cc62965f1(...data.map((item)=>(item - average) ** 2));
    return summary / (data.length - (sample ? 1 : 0));
}
function $0fd9d527cd0d1501$export$57d7c52a66287430(data, sample = false) {
    return Math.sqrt($0fd9d527cd0d1501$export$8e694e1eafd55acb(data, sample));
}
function $0fd9d527cd0d1501$export$2b4693832ca3ce16(...data) {
    return Math.sqrt($0fd9d527cd0d1501$export$8a63f25cc62965f1(...data.map((item)=>item ** 2)));
}
function $0fd9d527cd0d1501$export$5b784e078da1ce6(raw, length) {
    const text = raw.toFixed(length + 2);
    const offset = text.indexOf('.') + length + 1;
    const cut = (text)=>text.slice(0, offset - (length ? 0 : 1));
    if (!+text.slice(offset)) return cut(text);
    const result = cut((+cut(text) + 10 ** -length).toFixed(length));
    return result.includes('.') ? result.padEnd(offset, '0') : result;
}
function $0fd9d527cd0d1501$export$17ec9c9f4f23588c(raw, length = 2) {
    const text = raw.toFixed(length + 2);
    const floatOffset = text.indexOf('.');
    if (floatOffset < 0) return length ? `${text}.${'0'.repeat(length)}` : text;
    const offset = floatOffset + length + 1;
    const before = +text[offset - 1], anchor = +text[offset], after = +text[offset + 1];
    const carry = anchor > 5 || anchor === 5 && (!!after || !!(before % 2));
    if (carry) return $0fd9d527cd0d1501$export$5b784e078da1ce6(raw, length);
    const result = text.slice(0, offset - (length ? 0 : 1));
    return result.includes('.') ? result.padEnd(offset, '0') : result;
}
class $0fd9d527cd0d1501$export$595dbf49c602a1f {
    constructor(value){
        this.value = value;
    }
    valueOf() {
        return this.value;
    }
    toShortString(fractionDigits = 2) {
        const { units: units, value: value } = this;
        const { base: base, name: name } = [
            ...units
        ].reverse().find(({ base: base })=>Math.abs(value) >= base) || units[0];
        return `${(value / base).toFixed(fractionDigits)} ${name}`;
    }
    static distanceOf(a, b) {
        return Reflect.construct(this, [
            a - b
        ]);
    }
}
const $0fd9d527cd0d1501$export$61cc6ed0f143570b = (value)=>!(value != null) || Number.isNaN(value);
const $0fd9d527cd0d1501$export$dd1bc94b04021eeb = (value)=>$0fd9d527cd0d1501$export$61cc6ed0f143570b(value) || (typeof value === 'object' ? !Object.keys(value).length : value === '');
const $0fd9d527cd0d1501$export$a09f818797e212c4 = (data)=>Object.prototype.toString.call(data).slice(8, -1);
const $0fd9d527cd0d1501$export$170f4e08cad8229d = (Sub, Super)=>Sub.prototype instanceof Super;
function $0fd9d527cd0d1501$export$2a489b3f92f4996a(target, dataStore, setter) {
    const prototype = Object.getPrototypeOf(target);
    const prototypeProxy = new Proxy(prototype, {
        set: (_, key, value, receiver)=>{
            if (key in receiver) Reflect.set(prototype, key, value, receiver);
            else dataStore[key] = value;
            setter?.(key, value);
            return true;
        },
        get: (prototype, key, receiver)=>key in dataStore ? dataStore[key] : Reflect.get(prototype, key, receiver)
    });
    Object.setPrototypeOf(target, prototypeProxy);
}
const $0fd9d527cd0d1501$export$67a6ce548ae77071 = (raw)=>/^[\d.]+$/.test(raw) && raw.localeCompare(Number.MAX_SAFE_INTEGER + '', undefined, {
        numeric: true
    }) > 0;
const $0fd9d527cd0d1501$export$a48f0734ac7c2329 = (raw)=>raw.replace(/[^\u0021-\u007e\uff61-\uffef]/g, 'xx').length;
const $0fd9d527cd0d1501$export$3f34ca2fef821bbd = (raw)=>raw.replace(/[A-Z]+|[^A-Za-z][A-Za-z]/g, (match, offset)=>`${offset ? '-' : ''}${(match[1] || match[0]).toLowerCase()}`);
const $0fd9d527cd0d1501$export$86f54f62aa7a7514 = (raw, large = false)=>raw.replace(/^[A-Za-z]|[^A-Za-z][A-Za-z]/g, (match, offset)=>offset || large ? (match[1] || match[0]).toUpperCase() : match.toLowerCase());
const $0fd9d527cd0d1501$export$89912e019eef22aa = ()=>(Date.now() + parseInt((Math.random() + '').slice(2))).toString(36);
const $0fd9d527cd0d1501$export$8fb536984ec8b4d7 = (input)=>btoa(String.fromCharCode(...new TextEncoder().encode(input)));
const $0fd9d527cd0d1501$export$94fdf11bafc8de6b = (input)=>new TextDecoder().decode(Uint8Array.from(atob(input), (char)=>char.charCodeAt(0)));
const $0fd9d527cd0d1501$export$1c8ba402144543e5 = (values, keys)=>Object.fromEntries(values.map((value, index)=>[
            keys[index],
            value
        ]));
var $0fd9d527cd0d1501$export$2ddabb89308e1a22 = /*#__PURE__*/ function(DiffStatus) {
    DiffStatus[DiffStatus["Old"] = -1] = "Old";
    DiffStatus[DiffStatus["Same"] = 0] = "Same";
    DiffStatus[DiffStatus["New"] = 1] = "New";
    return DiffStatus;
}({});
function $0fd9d527cd0d1501$export$14527669107aa301(oldList, newList) {
    const map = {};
    for (const item of oldList)map[item] = -1;
    for (const item of newList){
        map[item] ||= 0;
        map[item] += 1;
    }
    return {
        map: map,
        group: $0fd9d527cd0d1501$export$3f063810d7bf01bd(Object.entries(map), ([key, status])=>status)
    };
}
function $0fd9d527cd0d1501$export$b5a4d6f439a5044d(data) {
    if ($0fd9d527cd0d1501$export$61cc6ed0f143570b(data)) return false;
    const { length: length } = data;
    return typeof length === 'number' && length >= 0 && ~~length === length;
}
const $0fd9d527cd0d1501$export$b119cc7e1840e59c = (data)=>data instanceof Object.getPrototypeOf(Int8Array);
function $0fd9d527cd0d1501$export$7b85fd78dd236198(data) {
    if (data instanceof Array) return data;
    if ($0fd9d527cd0d1501$export$61cc6ed0f143570b(data)) return [];
    if ($0fd9d527cd0d1501$export$b5a4d6f439a5044d(data)) return Array.from(data);
    return [
        data
    ];
}
const $0fd9d527cd0d1501$export$697c3df919c0e61a = (array, unitLength)=>array.reduce((grid, item, index)=>{
        (grid[~~(index / unitLength)] ||= [])[index % unitLength] = item;
        return grid;
    }, []);
function $0fd9d527cd0d1501$export$3f063810d7bf01bd(list, iteratee) {
    const data = {};
    for (const item of list){
        let keys = iteratee instanceof Function ? iteratee(item) : item[iteratee];
        if (!(keys instanceof Array)) keys = [
            keys
        ];
        for (const key of new Set(keys.filter((key)=>key != null)))(data[key] = data[key] || []).push(item);
    }
    return data;
}
function $0fd9d527cd0d1501$export$1d012a0dff3dab06(list, iteratee) {
    const group = $0fd9d527cd0d1501$export$3f063810d7bf01bd(list, iteratee);
    const sortedList = Object.entries(group).map(([key, { length: length }])=>[
            key,
            length
        ]);
    return Object.fromEntries(sortedList);
}
function $0fd9d527cd0d1501$export$e6b5ff3168b5942b(list, subKey, handler) {
    for (const item of list){
        if (handler(item)) return [
            item
        ];
        if (item[subKey] instanceof Array) {
            const result = $0fd9d527cd0d1501$export$e6b5ff3168b5942b(item[subKey], subKey, handler);
            if (result.length) return [
                item,
                ...result
            ];
        }
    }
    return [];
}
function $0fd9d527cd0d1501$export$fbc9cd6af26fa64f(list, idKey = 'id', parentIdKey = 'parentId', childrenKey = 'children') {
    list = globalThis.structuredClone?.(list) || JSON.parse(JSON.stringify(list));
    const map = {};
    const roots = [];
    for (const item of list)map[item[idKey]] = item;
    for (const item of list){
        const parent = map[item[parentIdKey]];
        if (!parent) roots.push(item);
        else {
            parent[childrenKey] ||= [];
            parent[childrenKey].push(item);
        }
    }
    if (!roots[0]) throw new ReferenceError('No root node is found');
    return roots;
}
function $0fd9d527cd0d1501$export$69a3209f1a06c04d(executor, title) {
    var cacheData;
    return function(...data) {
        if (cacheData != null) return cacheData;
        console.trace(`[Cache] execute: ${title}`);
        cacheData = executor.call(this, ()=>cacheData = undefined, ...data);
        Promise.resolve(cacheData).then((data)=>console.log(`[Cache] refreshed: ${title} => ${data}`), (error)=>console.error(`[Cache] failed: ${error?.message || error}`));
        return cacheData;
    };
}
async function* $0fd9d527cd0d1501$export$86c18c6347f4a8c4(executor) {
    let { promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers();
    const doneSymbol = Symbol('done'), done = Promise.withResolvers();
    const disposer = executor({
        next: (value)=>resolve(value),
        error: (error)=>{
            reject(error);
            // @ts-ignore
            disposer?.();
        },
        complete: ()=>{
            done.resolve(doneSymbol);
            // @ts-ignore
            disposer?.();
        }
    });
    while(true){
        const value = await Promise.race([
            promise,
            done.promise
        ]);
        if (value === doneSymbol) return;
        yield value;
        ({ promise: promise, resolve: resolve, reject: reject } = Promise.withResolvers());
    }
}
async function* $0fd9d527cd0d1501$export$dce9414bed0662c(...sources) {
    var iterators = sources.map((item)=>item());
    while(iterators[0]){
        const dones = [];
        for(let i = 0, iterator; iterator = iterators[i]; i++){
            const { done: done, value: value } = await iterator.next();
            if (!done) yield value;
            else dones.push(i);
        }
        iterators = iterators.filter((_, i)=>!dones.includes(i));
    }
}
class $0fd9d527cd0d1501$export$271f7c16f175f804 extends $0fd9d527cd0d1501$export$595dbf49c602a1f {
    constructor(...args){
        super(...args), this.units = [
            '',
            'K',
            'M',
            'G',
            'T',
            'P',
            'E',
            'Z',
            'Y'
        ].map((name, i)=>({
                base: 1024 ** i,
                name: name + 'B'
            }));
    }
}
var $0fd9d527cd0d1501$var$$f872d8bba1c0f79f$exports = {};
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$f872d8bba1c0f79f$exports, "Second", function() {
    return $0fd9d527cd0d1501$export$c489aa6f7fd82b1a;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$f872d8bba1c0f79f$exports, "Minute", function() {
    return $0fd9d527cd0d1501$export$cbd942915f33be50;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$f872d8bba1c0f79f$exports, "Quarter", function() {
    return $0fd9d527cd0d1501$export$9b886f8493244014;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$f872d8bba1c0f79f$exports, "Hour", function() {
    return $0fd9d527cd0d1501$export$e99cbb807a5bb10d;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$f872d8bba1c0f79f$exports, "Day", function() {
    return $0fd9d527cd0d1501$export$7a9a31a911eb9a20;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$f872d8bba1c0f79f$exports, "Week", function() {
    return $0fd9d527cd0d1501$export$fca4f8121099df57;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$f872d8bba1c0f79f$exports, "Year", function() {
    return $0fd9d527cd0d1501$export$6ce2f08d515512;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$f872d8bba1c0f79f$exports, "Month", function() {
    return $0fd9d527cd0d1501$export$951c8378cdfec6e6;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$f872d8bba1c0f79f$exports, "Season", function() {
    return $0fd9d527cd0d1501$export$1a4097b876a13bf7;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$f872d8bba1c0f79f$exports, "Timestamp", function() {
    return $0fd9d527cd0d1501$export$d9bcbd5e1ff81430;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$f872d8bba1c0f79f$exports, "diffTime", function() {
    return $0fd9d527cd0d1501$export$506c8e8f8c8edda;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$f872d8bba1c0f79f$exports, "formatDate", function() {
    return $0fd9d527cd0d1501$export$3ae94a2503e890a1;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$f872d8bba1c0f79f$exports, "changeMonth", function() {
    return $0fd9d527cd0d1501$export$62ad822b3a5fd9a0;
});
const $0fd9d527cd0d1501$export$c489aa6f7fd82b1a = 1000;
const $0fd9d527cd0d1501$export$cbd942915f33be50 = $0fd9d527cd0d1501$export$c489aa6f7fd82b1a * 60;
const $0fd9d527cd0d1501$export$9b886f8493244014 = $0fd9d527cd0d1501$export$cbd942915f33be50 * 15;
const $0fd9d527cd0d1501$export$e99cbb807a5bb10d = $0fd9d527cd0d1501$export$9b886f8493244014 * 4;
const $0fd9d527cd0d1501$export$7a9a31a911eb9a20 = $0fd9d527cd0d1501$export$e99cbb807a5bb10d * 24;
const $0fd9d527cd0d1501$export$fca4f8121099df57 = $0fd9d527cd0d1501$export$7a9a31a911eb9a20 * 7;
const $0fd9d527cd0d1501$export$6ce2f08d515512 = $0fd9d527cd0d1501$export$7a9a31a911eb9a20 * 365;
const $0fd9d527cd0d1501$export$951c8378cdfec6e6 = $0fd9d527cd0d1501$export$6ce2f08d515512 / 12;
const $0fd9d527cd0d1501$export$1a4097b876a13bf7 = $0fd9d527cd0d1501$export$951c8378cdfec6e6 * 3;
class $0fd9d527cd0d1501$export$d9bcbd5e1ff81430 extends $0fd9d527cd0d1501$export$595dbf49c602a1f {
    toShortString(fractionDigits = 0) {
        return super.toShortString(fractionDigits);
    }
    constructor(...args){
        super(...args), this.units = [
            {
                base: $0fd9d527cd0d1501$export$c489aa6f7fd82b1a,
                name: 's'
            },
            {
                base: $0fd9d527cd0d1501$export$cbd942915f33be50,
                name: 'm'
            },
            {
                base: $0fd9d527cd0d1501$export$e99cbb807a5bb10d,
                name: 'H'
            },
            {
                base: $0fd9d527cd0d1501$export$7a9a31a911eb9a20,
                name: 'D'
            },
            {
                base: $0fd9d527cd0d1501$export$fca4f8121099df57,
                name: 'W'
            },
            {
                base: $0fd9d527cd0d1501$export$951c8378cdfec6e6,
                name: 'M'
            },
            {
                base: $0fd9d527cd0d1501$export$6ce2f08d515512,
                name: 'Y'
            }
        ];
    }
}
function $0fd9d527cd0d1501$export$506c8e8f8c8edda(end, start = new Date()) {
    const timeDistance = $0fd9d527cd0d1501$export$d9bcbd5e1ff81430.distanceOf(+new Date(end), +new Date(start));
    const [value, unit] = timeDistance.toShortString().split(/\s+/);
    return {
        distance: +value,
        unit: unit
    };
}
function $0fd9d527cd0d1501$var$$f872d8bba1c0f79f$var$fitUnit(value) {
    value = +value + '';
    return (template)=>(value.length < template.length ? value.padStart(template.length, '0') : value).slice(-Math.max(template.length, 2));
}
function $0fd9d527cd0d1501$export$3ae94a2503e890a1(time = new Date(), template = 'YYYY-MM-DD HH:mm:ss') {
    time = time instanceof Date ? time : new Date(time);
    time = new Date(+time - time.getTimezoneOffset() * $0fd9d527cd0d1501$export$cbd942915f33be50);
    const [year, month, day, hour, minute, second, millisecond] = time.toJSON().split(/\D/);
    return template.replace(/ms/g, millisecond).replace(/Y+/g, $0fd9d527cd0d1501$var$$f872d8bba1c0f79f$var$fitUnit(year)).replace(/M+/g, $0fd9d527cd0d1501$var$$f872d8bba1c0f79f$var$fitUnit(month)).replace(/D+/g, $0fd9d527cd0d1501$var$$f872d8bba1c0f79f$var$fitUnit(day)).replace(/H+/g, $0fd9d527cd0d1501$var$$f872d8bba1c0f79f$var$fitUnit(hour)).replace(/m+/g, $0fd9d527cd0d1501$var$$f872d8bba1c0f79f$var$fitUnit(minute)).replace(/s+/g, $0fd9d527cd0d1501$var$$f872d8bba1c0f79f$var$fitUnit(second));
}
function $0fd9d527cd0d1501$export$62ad822b3a5fd9a0(date, delta) {
    date = new Date(date);
    const month = date.getMonth() + delta;
    date.setFullYear(date.getFullYear() + Math.floor(month / 12));
    delta = month % 12;
    date.setMonth(delta < 0 ? 12 + delta : delta);
    return date;
}
var $0fd9d527cd0d1501$var$$ba0e5dc395660a7c$exports = {};
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$ba0e5dc395660a7c$exports, "parseJSON", function() {
    return $0fd9d527cd0d1501$export$27924e57e9afff7f;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$ba0e5dc395660a7c$exports, "toJSValue", function() {
    return $0fd9d527cd0d1501$export$7ea17d45ecdcf634;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$ba0e5dc395660a7c$exports, "parseTextTable", function() {
    return $0fd9d527cd0d1501$export$bb8626e4916f587b;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$ba0e5dc395660a7c$exports, "parseTextTableAsync", function() {
    return $0fd9d527cd0d1501$export$88182f6768071c72;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$ba0e5dc395660a7c$exports, "readTextTable", function() {
    return $0fd9d527cd0d1501$export$2427785258f88523;
});
function $0fd9d527cd0d1501$export$27924e57e9afff7f(raw) {
    function parseItem(value) {
        if (typeof value === 'string' && /^\d+(-\d{1,2}){1,2}/.test(value)) {
            const date = new Date(value);
            if (!Number.isNaN(+date)) return date;
        }
        return value;
    }
    const value = parseItem(raw);
    if (typeof value !== 'string' || $0fd9d527cd0d1501$export$67a6ce548ae77071(value)) return value;
    try {
        return JSON.parse(raw, (key, value)=>parseItem(value));
    } catch  {
        return raw;
    }
}
function $0fd9d527cd0d1501$export$7ea17d45ecdcf634(raw) {
    const parsed = $0fd9d527cd0d1501$export$27924e57e9afff7f(raw);
    if (typeof parsed !== 'string') return parsed;
    const number = +parsed;
    return Number.isNaN(number) || number + '' !== parsed ? parsed : number;
}
function $0fd9d527cd0d1501$var$$ba0e5dc395660a7c$var$readQuoteValue(raw) {
    const quote = raw[0];
    const index = raw.indexOf(quote, 1);
    if (index < 0) throw SyntaxError(`A ${quote} is missing`);
    return raw.slice(1, index);
}
function $0fd9d527cd0d1501$var$$ba0e5dc395660a7c$var$parseRow(row, separator = ',') {
    const list = [];
    do {
        let value;
        if (row[0] === '"' || row[0] === "'") {
            value = $0fd9d527cd0d1501$var$$ba0e5dc395660a7c$var$readQuoteValue(row);
            row = row.slice(value.length + 3);
        } else {
            const index = row.indexOf(separator);
            if (index > -1) {
                value = row.slice(0, index);
                row = row.slice(index + 1);
            } else {
                value = row;
                row = '';
            }
        }
        list.push($0fd9d527cd0d1501$export$7ea17d45ecdcf634(value.trim()));
    }while (row);
    return list;
}
function $0fd9d527cd0d1501$export$bb8626e4916f587b(raw, header, separator = ',') {
    const data = raw.trim().split(/[\r\n]+/).map((row)=>$0fd9d527cd0d1501$var$$ba0e5dc395660a7c$var$parseRow(row, separator));
    return !header ? data : data.slice(1).map((row)=>$0fd9d527cd0d1501$export$1c8ba402144543e5(row, data[0]));
}
const $0fd9d527cd0d1501$export$88182f6768071c72 = async (raw)=>Array.fromAsync($0fd9d527cd0d1501$export$2427785258f88523(raw[Symbol.iterator]()));
async function* $0fd9d527cd0d1501$var$$ba0e5dc395660a7c$var$characterStream(chunks) {
    for await (const chunk of chunks)yield* chunk;
}
async function* $0fd9d527cd0d1501$var$$ba0e5dc395660a7c$var$parseCharacterStream(chars, separator = ',') {
    let inQuote = false;
    let quoteChar = '';
    let prevChar = '';
    let cellBuffer = '';
    let currentRow = [];
    const completeCell = ()=>{
        currentRow.push($0fd9d527cd0d1501$export$7ea17d45ecdcf634(cellBuffer.trim()));
        cellBuffer = '';
    };
    for await (const char of chars){
        if (char === '\n' || char === '\r') {
            if (char === '\n' && prevChar === '\r') {
                prevChar = char;
                continue;
            }
            completeCell();
            if (currentRow.length > 1 || currentRow[0]) yield currentRow;
            currentRow = [];
        } else if ((char === '"' || char === "'") && !inQuote && cellBuffer.trim() === '') {
            inQuote = true;
            quoteChar = char;
        } else if (char === quoteChar && inQuote) {
            inQuote = false;
            quoteChar = '';
        } else if (inQuote) cellBuffer += char;
        else if (char === separator) completeCell();
        else cellBuffer += char;
        prevChar = char;
    }
    if (cellBuffer || currentRow.length > 0) {
        completeCell();
        if (currentRow.length > 1 || currentRow[0]) yield currentRow;
    }
}
async function* $0fd9d527cd0d1501$export$2427785258f88523(chunks, header, separator = ',') {
    let headerRow;
    let isFirstRow = true;
    const chars = $0fd9d527cd0d1501$var$$ba0e5dc395660a7c$var$characterStream(chunks);
    for await (const row of $0fd9d527cd0d1501$var$$ba0e5dc395660a7c$var$parseCharacterStream(chars, separator))if (header && isFirstRow) {
        headerRow = row;
        isFirstRow = false;
    } else yield header && headerRow ? $0fd9d527cd0d1501$export$1c8ba402144543e5(row, headerRow) : row;
}
var $0fd9d527cd0d1501$var$$083124ac4b1a50a0$exports = {};
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$083124ac4b1a50a0$exports, "isXDomain", function() {
    return $0fd9d527cd0d1501$export$71e6483fc2b024eb;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$083124ac4b1a50a0$exports, "parseURLData", function() {
    return $0fd9d527cd0d1501$export$eb9b2aadbe449a20;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$083124ac4b1a50a0$exports, "buildURLData", function() {
    return $0fd9d527cd0d1501$export$13397a83aa5915d6;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$083124ac4b1a50a0$exports, "blobOf", function() {
    return $0fd9d527cd0d1501$export$fd89523fba250fa4;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$083124ac4b1a50a0$exports, "blobFrom", function() {
    return $0fd9d527cd0d1501$export$504fbde693c1771c;
});
const $0fd9d527cd0d1501$export$71e6483fc2b024eb = (URI)=>new URL(URI, document.baseURI).origin !== location.origin;
function $0fd9d527cd0d1501$export$eb9b2aadbe449a20(raw = globalThis.location?.search || '', toBuiltIn = true) {
    const rawData = raw.split('#').map((URI)=>{
        const [before, after] = URI.split('?');
        return new URLSearchParams(after || (before.includes('=') ? before : ''));
    }).join('&');
    const data = new URLSearchParams(rawData);
    return Object.fromEntries([
        ...data.keys()
    ].map((key)=>{
        const list = toBuiltIn ? data.getAll(key).map($0fd9d527cd0d1501$export$27924e57e9afff7f) : data.getAll(key);
        return [
            key,
            list.length < 2 ? list[0] : list
        ];
    }));
}
const $0fd9d527cd0d1501$var$$083124ac4b1a50a0$var$stringify = (value)=>typeof value === 'string' ? value : $0fd9d527cd0d1501$export$b5a4d6f439a5044d(value) ? $0fd9d527cd0d1501$export$7b85fd78dd236198(value) + '' : JSON.stringify(value);
function $0fd9d527cd0d1501$export$13397a83aa5915d6(map) {
    if (!(map instanceof Array)) map = Object.entries(map);
    const list = map.map(([key, value])=>!$0fd9d527cd0d1501$export$dd1bc94b04021eeb(value) && [
            key,
            $0fd9d527cd0d1501$var$$083124ac4b1a50a0$var$stringify(value)
        ]).filter(Boolean);
    return new URLSearchParams(list);
}
const $0fd9d527cd0d1501$export$fd89523fba250fa4 = async (URI)=>(await fetch(URI + '')).blob();
const $0fd9d527cd0d1501$var$$083124ac4b1a50a0$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
function $0fd9d527cd0d1501$export$504fbde693c1771c(URI) {
    var [_, type, __, base64, data] = $0fd9d527cd0d1501$var$$083124ac4b1a50a0$var$DataURI.exec(URI) || [];
    data = base64 ? atob(data) : data;
    const aBuffer = Uint8Array.from(data, (char)=>char.charCodeAt(0));
    return new Blob([
        aBuffer
    ], {
        type: type
    });
}
var $0fd9d527cd0d1501$var$$d677628cc2ac1e37$exports = {};
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$d677628cc2ac1e37$exports, "parseCookie", function() {
    return $0fd9d527cd0d1501$export$d0eaf3e94be578f6;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$d677628cc2ac1e37$exports, "setCookie", function() {
    return $0fd9d527cd0d1501$export$110700823644f4a6;
});
const $0fd9d527cd0d1501$export$d0eaf3e94be578f6 = (value = globalThis.document?.cookie)=>value ? Object.fromEntries(value.split(/;\s*/).map((item)=>item.split('='))) : {};
function $0fd9d527cd0d1501$export$110700823644f4a6(key, value, attributes = {}) {
    const data = `${key}=${value}`, option = Object.entries(attributes).map(([key, value])=>typeof value === 'boolean' ? value ? key : '' : `${key}=${value}`).filter(Boolean).join('; ');
    document.cookie = `${data}; expires=${new Date(0)}`;
    return document.cookie = `${data}; ${option}`;
}
var $0fd9d527cd0d1501$var$$50872bf213056663$exports = {};
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$50872bf213056663$exports, "makeCRC32", function() {
    return $0fd9d527cd0d1501$export$1b9ac4d3de3ffd2e;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$50872bf213056663$exports, "makeSHA", function() {
    return $0fd9d527cd0d1501$export$d51f3b55e8d1aa73;
});
const $0fd9d527cd0d1501$var$$50872bf213056663$var$CRC_32_Table = Array.from(new Array(256), (_, cell)=>{
    for(var j = 0; j < 8; j++)if (cell & 1) cell = cell >> 1 & 0x7fffffff ^ 0xedb88320;
    else cell = cell >> 1 & 0x7fffffff;
    return cell;
});
function $0fd9d527cd0d1501$export$1b9ac4d3de3ffd2e(raw) {
    var value = 0xffffffff;
    for (const char of raw)value = value >> 8 & 0x00ffffff ^ $0fd9d527cd0d1501$var$$50872bf213056663$var$CRC_32_Table[value & 0xff ^ char.charCodeAt(0)];
    return '0x' + ((value ^ 0xffffffff) >>> 0).toString(16);
}
if (typeof self === 'object') {
    if ('msCrypto' in globalThis) {
        // @ts-ignore
        const { subtle: subtle } = globalThis.crypto = globalThis.msCrypto;
        for(const key in subtle){
            const origin = subtle[key];
            if (origin instanceof Function) subtle[key] = function() {
                const observer = origin.apply(this, arguments);
                return new Promise((resolve, reject)=>{
                    observer.oncomplete = ({ target: target })=>resolve(target.result);
                    observer.onabort = observer.onerror = reject;
                });
            };
        }
    }
    const { crypto: crypto1 } = globalThis;
    if (!crypto1?.subtle && crypto1?.['webkitSubtle']) crypto1.subtle = crypto1['webkitSubtle'];
}
async function $0fd9d527cd0d1501$export$d51f3b55e8d1aa73(raw, algorithm = 'SHA-1') {
    const buffer = await crypto.subtle.digest(algorithm, new TextEncoder().encode(raw));
    return Array.from(new Uint8Array(buffer), (byte)=>byte.toString(16).padStart(2, '0')).join('');
}
var $0fd9d527cd0d1501$var$$93a3089d2937b23f$exports = {};
var $0fd9d527cd0d1501$var$$3e0a089cc13f69ad$exports = {};
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$3e0a089cc13f69ad$exports, "XMLNamespace", function() {
    return $0fd9d527cd0d1501$export$f5a4056b78c72efa;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$3e0a089cc13f69ad$exports, "templateOf", function() {
    return $0fd9d527cd0d1501$export$2ee022bbbc550b25;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$3e0a089cc13f69ad$exports, "elementTypeOf", function() {
    return $0fd9d527cd0d1501$export$a549dd5cef7f8327;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$3e0a089cc13f69ad$exports, "isHTMLElementClass", function() {
    return $0fd9d527cd0d1501$export$8eece510bcb9c62c;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$3e0a089cc13f69ad$exports, "tagNameOf", function() {
    return $0fd9d527cd0d1501$export$b8a1af58c024fefd;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$3e0a089cc13f69ad$exports, "isDOMReadOnly", function() {
    return $0fd9d527cd0d1501$export$a2cf0d4bb6e06de4;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$3e0a089cc13f69ad$exports, "parseDOM", function() {
    return $0fd9d527cd0d1501$export$d66b332881d9723f;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$3e0a089cc13f69ad$exports, "stringifyDOM", function() {
    return $0fd9d527cd0d1501$export$b0709844452f8b6b;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$3e0a089cc13f69ad$exports, "walkDOM", function() {
    return $0fd9d527cd0d1501$export$5118471ee5d5453b;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$3e0a089cc13f69ad$exports, "getVisibleText", function() {
    return $0fd9d527cd0d1501$export$be4650432daa84fd;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$3e0a089cc13f69ad$exports, "splitPages", function() {
    return $0fd9d527cd0d1501$export$578e38b4a3e0b255;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$3e0a089cc13f69ad$exports, "importCSS", function() {
    return $0fd9d527cd0d1501$export$7cd14c57bbb84350;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$3e0a089cc13f69ad$exports, "stringifyCSS", function() {
    return $0fd9d527cd0d1501$export$5100419dfae0456d;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$3e0a089cc13f69ad$exports, "insertToCursor", function() {
    return $0fd9d527cd0d1501$export$28d9d24a8cd0ffc2;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$3e0a089cc13f69ad$exports, "scrollTo", function() {
    return $0fd9d527cd0d1501$export$3f99968195accfaf;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$3e0a089cc13f69ad$exports, "watchScroll", function() {
    return $0fd9d527cd0d1501$export$eafdbaa868ea9975;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$3e0a089cc13f69ad$exports, "watchVisible", function() {
    return $0fd9d527cd0d1501$export$36a0c1ca2ae264fa;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$3e0a089cc13f69ad$exports, "formToJSON", function() {
    return $0fd9d527cd0d1501$export$86d7c59254d6a2c9;
});
const $0fd9d527cd0d1501$export$f5a4056b78c72efa = {
    html: 'http://www.w3.org/1999/xhtml',
    svg: 'http://www.w3.org/2000/svg',
    math: 'http://www.w3.org/1998/Math/MathML'
};
const $0fd9d527cd0d1501$var$$3e0a089cc13f69ad$var$templateMap = {};
function $0fd9d527cd0d1501$export$2ee022bbbc550b25(tagName) {
    if ($0fd9d527cd0d1501$var$$3e0a089cc13f69ad$var$templateMap[tagName]) return $0fd9d527cd0d1501$var$$3e0a089cc13f69ad$var$templateMap[tagName];
    const spawn = document.createElement('template');
    spawn.innerHTML = `<${tagName} />`;
    return $0fd9d527cd0d1501$var$$3e0a089cc13f69ad$var$templateMap[tagName] = spawn.content.firstElementChild;
}
function $0fd9d527cd0d1501$export$a549dd5cef7f8327(tagName) {
    if (tagName.includes('-')) return 'html';
    const [prefix, localName] = tagName.split(':');
    if (localName) return prefix === 'html' ? 'html' : 'xml';
    const node = $0fd9d527cd0d1501$export$2ee022bbbc550b25(tagName);
    return node instanceof HTMLElement && !(node instanceof HTMLUnknownElement) ? 'html' : 'xml';
}
const $0fd9d527cd0d1501$export$8eece510bcb9c62c = (Class)=>$0fd9d527cd0d1501$export$170f4e08cad8229d(Class, HTMLElement);
const $0fd9d527cd0d1501$var$$3e0a089cc13f69ad$var$nameMap = new WeakMap();
function $0fd9d527cd0d1501$export$b8a1af58c024fefd(Class) {
    const name = $0fd9d527cd0d1501$var$$3e0a089cc13f69ad$var$nameMap.get(Class);
    if (name) return name;
    var { tagName: tagName } = new Class();
    $0fd9d527cd0d1501$var$$3e0a089cc13f69ad$var$nameMap.set(Class, tagName = tagName.toLowerCase());
    return tagName;
}
function $0fd9d527cd0d1501$export$a2cf0d4bb6e06de4(tagName, propertyName) {
    /**
     * fetch from https://html.spec.whatwg.org/
     */ const ReadOnly_Properties = [
        [
            HTMLLinkElement,
            [
                'sizes'
            ]
        ],
        [
            HTMLIFrameElement,
            [
                'sandbox'
            ]
        ],
        [
            HTMLObjectElement,
            [
                'form'
            ]
        ],
        [
            HTMLInputElement,
            [
                'form',
                'list'
            ]
        ],
        [
            HTMLButtonElement,
            [
                'form'
            ]
        ],
        [
            HTMLSelectElement,
            [
                'form'
            ]
        ],
        [
            HTMLTextAreaElement,
            [
                'form'
            ]
        ],
        [
            HTMLOutputElement,
            [
                'form'
            ]
        ],
        [
            HTMLFieldSetElement,
            [
                'form'
            ]
        ]
    ];
    const template = $0fd9d527cd0d1501$export$2ee022bbbc550b25(tagName);
    for (const [Class, keys] of ReadOnly_Properties)if (template instanceof Class && keys.includes(propertyName)) return true;
    return false;
}
function $0fd9d527cd0d1501$export$d66b332881d9723f(HTML) {
    const spawn = document.createElement('template');
    spawn.innerHTML = HTML;
    return [
        ...spawn.content.childNodes
    ].map((node)=>{
        node.remove();
        return node;
    });
}
const $0fd9d527cd0d1501$export$b0709844452f8b6b = (node)=>new XMLSerializer().serializeToString(node).replace(/ xmlns="http:\/\/www.w3.org\/1999\/xhtml"/g, '');
function* $0fd9d527cd0d1501$export$5118471ee5d5453b(root, type) {
    const children = [
        ...root.childNodes
    ];
    if ($0fd9d527cd0d1501$export$dd1bc94b04021eeb(type) || type === root.nodeType) yield root;
    for (const node of children)yield* $0fd9d527cd0d1501$export$5118471ee5d5453b(node, type);
}
function $0fd9d527cd0d1501$export$be4650432daa84fd(root) {
    var text = '';
    for (const { nodeType: nodeType, parentElement: parentElement, nodeValue: nodeValue } of $0fd9d527cd0d1501$export$5118471ee5d5453b(root))if (nodeType === Node.TEXT_NODE && parentElement.getAttribute('aria-hidden') !== 'true') {
        const { width: width, height: height } = parentElement.getBoundingClientRect();
        if (width && height) text += nodeValue.trim().replace(/\s+/g, ' ');
    }
    return text;
}
function $0fd9d527cd0d1501$export$578e38b4a3e0b255({ offsetWidth: offsetWidth, children: children }, pageHeight = 841.89, pageWidth = 595.28) {
    const scrollHeight = pageHeight / pageWidth * offsetWidth;
    var offset = 0;
    return [
        ...children
    ].reduce((pages, node)=>{
        var { offsetTop: top, offsetHeight: height } = node;
        top += offset;
        var bottom = top + height;
        const bottomOffset = bottom / scrollHeight;
        const topIndex = ~~(top / scrollHeight), bottomIndex = ~~bottomOffset;
        if (topIndex !== bottomIndex) offset += height - bottomOffset;
        (pages[bottomIndex] ||= []).push(node);
        return pages;
    }, []);
}
function $0fd9d527cd0d1501$export$7cd14c57bbb84350(URI, { alternate: alternate, ...options } = {}) {
    const style = [
        ...document.styleSheets
    ].find(({ href: href })=>href === URI);
    if (style) return Promise.resolve(style);
    const link = document.createElement('link');
    return new Promise((resolve, reject)=>{
        link.onload = ()=>resolve(link.sheet);
        link.onerror = (_1, _2, _3, _4, error)=>reject(error);
        Object.assign(link, options);
        link.rel = (alternate ? 'alternate ' : '') + 'stylesheet';
        link.href = URI;
        document.head.append(link);
    });
}
function $0fd9d527cd0d1501$export$5100419dfae0456d(data, depth = 0, indent = '    ') {
    const padding = indent.repeat(depth);
    return Object.entries(data).map(([key, value])=>typeof value !== 'object' ? `${padding}${$0fd9d527cd0d1501$export$3f34ca2fef821bbd(key)}: ${value};` : `${padding}${key} {
${$0fd9d527cd0d1501$export$5100419dfae0456d(value, depth + 1, indent)}
${padding}}`).join('\n');
}
function $0fd9d527cd0d1501$export$28d9d24a8cd0ffc2(...nodes) {
    const fragment = document.createDocumentFragment();
    fragment.append(...nodes);
    for (const node of $0fd9d527cd0d1501$export$5118471ee5d5453b(fragment))if (![
        1,
        3,
        11
    ].includes(node.nodeType) || [
        'meta',
        'title',
        'link',
        'script'
    ].includes(node.nodeName.toLowerCase())) node.replaceWith(...node.childNodes);
    const selection = globalThis.getSelection();
    if (!selection) return;
    const range = selection.getRangeAt(0);
    range.deleteContents();
    range.insertNode(fragment);
}
function $0fd9d527cd0d1501$export$3f99968195accfaf(selector, root, align, justify) {
    const [_, ID] = /^#(.+)/.exec(selector) || [];
    if (ID === 'top') window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
    else (root || document).querySelector(ID ? `[id="${ID}"]` : selector)?.scrollIntoView({
        behavior: 'smooth',
        block: align,
        inline: justify
    });
}
const $0fd9d527cd0d1501$export$eafdbaa868ea9975 = (box, handler, depth = 6)=>Array.from(box.querySelectorAll(Array.from(new Array(depth), (_, index)=>`h${++index}`) + ''), (header)=>{
        new IntersectionObserver(([item])=>{
            if (!item.isIntersecting) return;
            const target = item.target;
            handler({
                target: target,
                links: [
                    ...target.ownerDocument.querySelectorAll(`[href="#${target.id}"]`)
                ]
            });
        }).observe(header);
        if (!header.id.trim()) header.id = header.textContent.trim().replace(/\W+/g, '-');
        return {
            level: +header.tagName[1],
            id: header.id,
            text: header.textContent.trim()
        };
    });
function $0fd9d527cd0d1501$export$36a0c1ca2ae264fa(root, handler) {
    var last = document.visibilityState === 'visible' ? 1 : 0;
    function change(state) {
        if (state === 3 || last === 3) handler(state === 3);
        last = state;
    }
    new IntersectionObserver(([{ isIntersecting: isIntersecting }])=>change(isIntersecting ? last | 2 : last & 1)).observe(root);
    document.addEventListener('visibilitychange', ()=>change(document.visibilityState === 'visible' ? last | 1 : last & 2));
}
function $0fd9d527cd0d1501$export$86d7c59254d6a2c9(form) {
    const { elements: elements } = form, data = {};
    for (const field of elements){
        let { name: name, value: value, checked: checked, defaultValue: defaultValue, selectedOptions: selectedOptions, files: files } = field;
        const type = field.type;
        if (!name || value === '') continue;
        const box = type !== 'fieldset' && field.closest('fieldset');
        if (box && box !== form) continue;
        let parsedValue = value;
        switch(type){
            case 'radio':
            case 'checkbox':
                if (checked) parsedValue = !defaultValue || $0fd9d527cd0d1501$export$7ea17d45ecdcf634(defaultValue);
                else if ($0fd9d527cd0d1501$export$b5a4d6f439a5044d(elements.namedItem(name))) continue;
                else parsedValue = false;
                break;
            case 'select-multiple':
                parsedValue = Array.from(selectedOptions, ({ value: value })=>$0fd9d527cd0d1501$export$7ea17d45ecdcf634(value));
                break;
            case 'fieldset':
                parsedValue = $0fd9d527cd0d1501$export$86d7c59254d6a2c9(field);
                break;
            case 'file':
                parsedValue = files && Array.from(files);
                break;
            case 'date':
            case 'datetime-local':
            case 'month':
            case 'hidden':
            case 'number':
            case 'range':
            case 'select-one':
                parsedValue = $0fd9d527cd0d1501$export$7ea17d45ecdcf634(value);
        }
        if (name in data) data[name] = [].concat(data[name], parsedValue);
        else data[name] = !(parsedValue instanceof Array) || !$0fd9d527cd0d1501$export$dd1bc94b04021eeb(parsedValue[1]) ? parsedValue : parsedValue[0];
    }
    return data;
}
var $0fd9d527cd0d1501$var$$bb23e0c794fefbef$exports = {};
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$bb23e0c794fefbef$exports, "sleep", function() {
    return $0fd9d527cd0d1501$export$e772c8ff12451969;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$bb23e0c794fefbef$exports, "asyncLoop", function() {
    return $0fd9d527cd0d1501$export$57207d71b8c929c8;
});
function $0fd9d527cd0d1501$export$e772c8ff12451969(seconds = 1) {
    return new Promise((resolve)=>setTimeout(resolve, seconds * 1000));
}
function $0fd9d527cd0d1501$export$57207d71b8c929c8(executor, seconds = 1) {
    var stop = false;
    (async ()=>{
        while(!stop){
            const result = executor();
            if (result instanceof Promise) await result;
            await $0fd9d527cd0d1501$export$e772c8ff12451969(seconds);
        }
    })();
    return ()=>stop = true;
}
var $0fd9d527cd0d1501$var$$19ed8aeb7905a045$exports = {};
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$19ed8aeb7905a045$exports, "delegate", function() {
    return $0fd9d527cd0d1501$export$10b1921597150314;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$19ed8aeb7905a045$exports, "documentReady", function() {
    return $0fd9d527cd0d1501$export$3e2b244719956741;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$19ed8aeb7905a045$exports, "promisify", function() {
    return $0fd9d527cd0d1501$export$1d1d2ed6b55cf67f;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$19ed8aeb7905a045$exports, "createMessageServer", function() {
    return $0fd9d527cd0d1501$export$2155c0b5a4b77fb8;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$19ed8aeb7905a045$exports, "createMessageClient", function() {
    return $0fd9d527cd0d1501$export$9d97473344489dfc;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$19ed8aeb7905a045$exports, "serviceWorkerUpdate", function() {
    return $0fd9d527cd0d1501$export$d635d04af3887bbe;
});
function $0fd9d527cd0d1501$export$10b1921597150314(selector, handler) {
    return function(event) {
        var node, path = event.composedPath();
        while((node = path.shift()) && node !== event.currentTarget)if (node instanceof HTMLElement && node.matches(selector)) return handler.call(this, event, node, event.detail);
    };
}
const $0fd9d527cd0d1501$export$3e2b244719956741 = typeof window !== 'undefined' ? new Promise((resolve)=>{
    function done() {
        document?.removeEventListener('DOMContentLoaded', done);
        window.removeEventListener('load', done);
        resolve();
    }
    document?.addEventListener('DOMContentLoaded', done);
    window.addEventListener('load', done);
    setTimeout(function check() {
        document?.readyState === 'complete' ? resolve() : setTimeout(check);
    });
}) : Promise.resolve();
function $0fd9d527cd0d1501$export$1d1d2ed6b55cf67f(scope, element) {
    return new Promise((resolve, reject)=>{
        function end(event) {
            resolve(event), clean();
        }
        function cancel(event) {
            reject(event), clean();
        }
        function clean() {
            element.removeEventListener(scope + 'end', end);
            element.removeEventListener(scope + 'cancel', cancel);
        }
        element.addEventListener(scope + 'end', end);
        element.addEventListener(scope + 'cancel', cancel);
    });
}
function $0fd9d527cd0d1501$export$2155c0b5a4b77fb8(handlers) {
    async function server({ data: { type: type, id: id, ...data }, source: source, origin: origin }) {
        var result = handlers[type]?.(data);
        if (result instanceof Promise) result = await result;
        // @ts-ignore
        source.postMessage({
            ...result,
            id: id
        }, origin);
    }
    globalThis.addEventListener('message', server);
    return ()=>globalThis.removeEventListener('message', server);
}
function $0fd9d527cd0d1501$export$9d97473344489dfc(target, origin = '*') {
    return (type, data)=>new Promise((resolve)=>{
            const UID = $0fd9d527cd0d1501$export$89912e019eef22aa();
            function handler({ data: { id: id, ...data } }) {
                if (id !== UID) return;
                resolve(data);
                globalThis.removeEventListener('message', handler);
            }
            globalThis.addEventListener('message', handler);
            // @ts-ignore
            target.postMessage({
                id: UID,
                type: type,
                ...data
            }, origin);
        });
}
function $0fd9d527cd0d1501$export$d635d04af3887bbe(registration) {
    return new Promise((resolve)=>{
        if (registration.waiting) return resolve(registration.waiting);
        registration.onupdatefound = ()=>registration.installing?.addEventListener('statechange', function() {
                if (this.state === 'installed' && navigator.serviceWorker.controller) resolve(this);
            });
    });
}
var $0fd9d527cd0d1501$var$$7a08303ce13c49c5$exports = {};
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$7a08303ce13c49c5$exports, "PageVector", function() {
    return $0fd9d527cd0d1501$export$1b88f6b6d432a52a;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$7a08303ce13c49c5$exports, "getSwipeVector", function() {
    return $0fd9d527cd0d1501$export$b70f6380221b1350;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$7a08303ce13c49c5$exports, "durationOf", function() {
    return $0fd9d527cd0d1501$export$75d6cbe4503e149;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$7a08303ce13c49c5$exports, "watchMotion", function() {
    return $0fd9d527cd0d1501$export$b2618d51188815c2;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$7a08303ce13c49c5$exports, "transitIn", function() {
    return $0fd9d527cd0d1501$export$490814474ddbb428;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$7a08303ce13c49c5$exports, "animateIn", function() {
    return $0fd9d527cd0d1501$export$3ea201dffb50dfef;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$7a08303ce13c49c5$exports, "transitOut", function() {
    return $0fd9d527cd0d1501$export$d1012c7198c6b460;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$7a08303ce13c49c5$exports, "animateOut", function() {
    return $0fd9d527cd0d1501$export$a35a418b7b17958e;
});
class $0fd9d527cd0d1501$export$1b88f6b6d432a52a {
    constructor(from, to){
        this.from = from;
        this.to = to;
    }
    get length() {
        const { from: from, to: to } = this;
        return Math.sqrt(Math.pow(to.x - from.x, 2) + Math.pow(to.y - from.y, 2) + (to.z != null ? Math.pow(to.z - from.z, 2) : 0));
    }
    get direction() {
        const { from: from, to: to } = this;
        const XD = to.x - from.x, YD = to.y - from.y, ZD = to.z - from.z;
        const XL = Math.abs(XD), YL = Math.abs(YD), ZL = Math.abs(ZD);
        switch(isNaN(ZL) ? Math.max(XL, YL) : Math.max(XL, YL, ZL)){
            case XL:
                return XD > 0 ? 'right' : 'left';
            case YL:
                return YD > 0 ? 'forward' : 'backward';
            case ZL:
                return ZD > 0 ? 'up' : 'down';
        }
    }
}
function $0fd9d527cd0d1501$export$b70f6380221b1350(from, to, threshold = parseInt(getComputedStyle(document.body).fontSize) * 6) {
    const vector = new $0fd9d527cd0d1501$export$1b88f6b6d432a52a(from, to);
    if (vector.length >= threshold && !getSelection()?.toString().trim()) return vector;
}
function $0fd9d527cd0d1501$export$75d6cbe4503e149(type, element) {
    const { transitionDuration: transitionDuration, animationDuration: animationDuration } = getComputedStyle(element);
    const duration = type === 'animation' ? animationDuration : transitionDuration;
    return parseFloat(duration) * (duration.slice(-2) === 'ms' ? 1 : 1000);
}
function $0fd9d527cd0d1501$export$b2618d51188815c2(type, element) {
    return Promise.race([
        $0fd9d527cd0d1501$export$1d1d2ed6b55cf67f(type, element).catch((event)=>Promise.resolve(event)),
        new Promise((resolve)=>setTimeout(resolve, $0fd9d527cd0d1501$export$75d6cbe4503e149(type, element)))
    ]);
}
function $0fd9d527cd0d1501$var$$7a08303ce13c49c5$var$fadeIn(type, element, className, display) {
    element.style.display = display;
    const end = $0fd9d527cd0d1501$export$b2618d51188815c2(type, element);
    return new Promise((resolve)=>requestAnimationFrame(()=>{
            element.classList.add(className);
            end.then(resolve);
        }));
}
async function $0fd9d527cd0d1501$var$$7a08303ce13c49c5$var$fadeOut(type, element, className, remove) {
    const end = $0fd9d527cd0d1501$export$b2618d51188815c2(type, element);
    element.classList.remove(className);
    await end;
    if (remove) element.remove();
    else element.style.display = 'none';
}
function $0fd9d527cd0d1501$export$490814474ddbb428(element, className, display = 'block') {
    return $0fd9d527cd0d1501$var$$7a08303ce13c49c5$var$fadeIn('transition', element, className, display);
}
function $0fd9d527cd0d1501$export$3ea201dffb50dfef(element, className, display = 'block') {
    return $0fd9d527cd0d1501$var$$7a08303ce13c49c5$var$fadeIn('animation', element, className, display);
}
function $0fd9d527cd0d1501$export$d1012c7198c6b460(element, className, remove) {
    return $0fd9d527cd0d1501$var$$7a08303ce13c49c5$var$fadeOut('transition', element, className, remove);
}
function $0fd9d527cd0d1501$export$a35a418b7b17958e(element, className, remove) {
    return $0fd9d527cd0d1501$var$$7a08303ce13c49c5$var$fadeOut('animation', element, className, remove);
}
var $0fd9d527cd0d1501$var$$69bd9f0117925302$exports = {};
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$69bd9f0117925302$exports, "describe", function() {
    return $0fd9d527cd0d1501$export$cd5450f3a47e3789;
});
$0fd9d527cd0d1501$var$$parcel$export($0fd9d527cd0d1501$var$$69bd9f0117925302$exports, "it", function() {
    return $0fd9d527cd0d1501$export$3486a10f30cf1ee4;
});
async function $0fd9d527cd0d1501$export$cd5450f3a47e3789(title, cases) {
    console.log(title);
    console.time(title);
    await cases();
    console.timeEnd(title);
}
async function $0fd9d527cd0d1501$export$3486a10f30cf1ee4(title, userCase, secondsOut = 3) {
    title = '    ' + title;
    console.time(title);
    const expect = (status)=>{
        const assert = typeof status === 'function' ? status : undefined;
        status = assert?.() ?? status;
        if (!status) throw new Error(`Assertion failed: ${title}\n\n${assert || ''}`);
    };
    const timeOut = ()=>$0fd9d527cd0d1501$export$e772c8ff12451969(secondsOut).then(()=>Promise.reject(new RangeError('Timed out')));
    try {
        return await Promise.race([
            userCase(expect),
            timeOut()
        ]);
    } finally{
        console.timeEnd(title);
    }
}


function $7ddf193e68e751e3$var$$parcel$exportWildcard(e, t) {
    return Object.keys(t).forEach(function(r) {
        "default" === r || "__esModule" === r || Object.prototype.hasOwnProperty.call(e, r) || Object.defineProperty(e, r, {
            enumerable: !0,
            get: function() {
                return t[r];
            }
        });
    }), e;
}
function $7ddf193e68e751e3$var$$parcel$interopDefault(e) {
    return e && e.__esModule ? e.default : e;
}
function $7ddf193e68e751e3$var$$parcel$export(e, t, r, a) {
    Object.defineProperty(e, t, {
        get: r,
        set: a,
        enumerable: !0,
        configurable: !0
    });
}
var $7ddf193e68e751e3$var$$0172b398bee57f0a$exports = {};
$7ddf193e68e751e3$var$$parcel$export($7ddf193e68e751e3$var$$0172b398bee57f0a$exports, "isEqualProps", function() {
    return $7ddf193e68e751e3$var$$0172b398bee57f0a$export$7112c88e033533b8;
}), $7ddf193e68e751e3$var$$parcel$export($7ddf193e68e751e3$var$$0172b398bee57f0a$exports, "reaction", function() {
    return $7ddf193e68e751e3$var$$0172b398bee57f0a$export$7203b476385689ae;
}), $7ddf193e68e751e3$var$$parcel$export($7ddf193e68e751e3$var$$0172b398bee57f0a$exports, "ObservedComponent", function() {
    return $7ddf193e68e751e3$var$$0172b398bee57f0a$export$bf180ef329d1efd8;
});
var $7ddf193e68e751e3$var$$0172b398bee57f0a$var$__esDecorate = function(e, t, r, a, s, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var c, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), f = !1, d = r.length - 1; d >= 0; d--){
        var b = {};
        for(var p in a)b[p] = "access" === p ? {} : a[p];
        for(var p in a.access)b.access[p] = a.access[p];
        b.addInitializer = function(e) {
            if (f) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[d])("accessor" === o ? {
            get: u.get,
            set: u.set
        } : u[l], b);
        if ("accessor" === o) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (c = i(v.get)) && (u.get = c), (c = i(v.set)) && (u.set = c), (c = i(v.init)) && s.unshift(c);
        } else (c = i(v)) && ("field" === o ? s.unshift(c) : u[l] = c);
    }
    $ && Object.defineProperty($, a.name, u), f = !0;
}, $7ddf193e68e751e3$var$$0172b398bee57f0a$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, s = 0; s < t.length; s++)r = a ? t[s].call(e, r) : t[s].call(e);
    return a ? r : void 0;
}, $7ddf193e68e751e3$var$$0172b398bee57f0a$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $7ddf193e68e751e3$var$$0172b398bee57f0a$var$__classPrivateFieldSet = function(e, t, r, a, s) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !s) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !s : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? s.call(e, r) : s ? s.value = r : t.set(e, r), r;
}, $7ddf193e68e751e3$var$$0172b398bee57f0a$export$7112c88e033533b8 = function(e, t) {
    return $7ddf193e68e751e3$var$$parcel$interopDefault($dYe7D)(e, t, function(e, t, r) {
        return [
            "_owner",
            "$$typeof"
        ].includes(r) || void 0;
    });
}, $7ddf193e68e751e3$var$$0172b398bee57f0a$var$reactionMap = new WeakMap, $7ddf193e68e751e3$var$$0172b398bee57f0a$export$7203b476385689ae = function(e) {
    return function(t, r) {
        return (0, r.addInitializer)(function() {
            var r = $7ddf193e68e751e3$var$$0172b398bee57f0a$var$reactionMap.get(this) || [];
            r.push({
                expression: e,
                effect: t
            }), $7ddf193e68e751e3$var$$0172b398bee57f0a$var$reactionMap.set(this, r);
        });
    };
}, $7ddf193e68e751e3$var$$0172b398bee57f0a$export$bf180ef329d1efd8 = function() {
    var e, t, r, a, s, n, i, c, o, l, $, u, f = $dNU7X.Component, d = [], b = [], p = [], v = [], _ = [], h = [];
    return r = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, t), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, t, arguments), s.set(e, $7ddf193e68e751e3$var$$0172b398bee57f0a$var$__runInitializers(e, d, e.props)), n.set(e, ($7ddf193e68e751e3$var$$0172b398bee57f0a$var$__runInitializers(e, b), $7ddf193e68e751e3$var$$0172b398bee57f0a$var$__runInitializers(e, p, e.state))), i.set(e, ($7ddf193e68e751e3$var$$0172b398bee57f0a$var$__runInitializers(e, v), $7ddf193e68e751e3$var$$0172b398bee57f0a$var$__runInitializers(e, _, e.context))), a.set(e, $7ddf193e68e751e3$var$$0172b398bee57f0a$var$__runInitializers(e, h)), e;
        }
        return (0, $92f5157d74f7ea45$export$71511d61b312f219)(t, e), (0, $53cdca766716469e$export$71511d61b312f219)(t, [
            {
                key: "observedProps",
                get: function() {
                    return $7ddf193e68e751e3$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, s, "f");
                },
                set: function(e) {
                    $7ddf193e68e751e3$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, s, e, "f");
                }
            },
            {
                key: "observedState",
                get: function() {
                    return $7ddf193e68e751e3$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, n, "f");
                },
                set: function(e) {
                    $7ddf193e68e751e3$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, n, e, "f");
                }
            },
            {
                key: "observedContext",
                get: function() {
                    return $7ddf193e68e751e3$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, i, "f");
                },
                set: function(e) {
                    $7ddf193e68e751e3$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, i, e, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    var e, t = this;
                    $7ddf193e68e751e3$var$$0172b398bee57f0a$var$__classPrivateFieldSet(this, a, null == (e = $7ddf193e68e751e3$var$$0172b398bee57f0a$var$reactionMap.get(this)) ? void 0 : e.map(function(e) {
                        var r = e.expression, a = e.effect;
                        return (0, $dZnzp.reaction)(function(e) {
                            return r(t, e);
                        }, a.bind(t));
                    }), "f");
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    var e;
                    null == (e = $7ddf193e68e751e3$var$$0172b398bee57f0a$var$__classPrivateFieldGet(this, a, "f")) || e.forEach(function(e) {
                        return e();
                    });
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e, r, a) {
                    var s;
                    $7ddf193e68e751e3$var$$0172b398bee57f0a$export$7112c88e033533b8(e, this.props) || (this.observedProps = Object.assign({}, this.props)), $7ddf193e68e751e3$var$$0172b398bee57f0a$export$7112c88e033533b8(r, this.state) || (this.observedState = Object.assign({}, this.state)), null == (s = (0, $0b0867a6ee357054$export$71511d61b312f219)((0, $9ac8e64cff09d58e$export$71511d61b312f219)(t.prototype), "componentDidUpdate", this)) || s.call(this, e, r, a);
                }
            }
        ]), t;
    }(f), a = new WeakMap, s = new WeakMap, n = new WeakMap, i = new WeakMap, t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = f[Symbol.metadata]) ? e : null) : void 0, l = [
        (e = $dZnzp.observable).shallow.bind(e)
    ], $ = [
        (c = $dZnzp.observable).shallow.bind(c)
    ], u = [
        (o = $dZnzp.observable).shallow.bind(o)
    ], $7ddf193e68e751e3$var$$0172b398bee57f0a$var$__esDecorate(r, null, l, {
        kind: "accessor",
        name: "observedProps",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "observedProps" in e;
            },
            get: function(e) {
                return e.observedProps;
            },
            set: function(e, t) {
                e.observedProps = t;
            }
        },
        metadata: t
    }, d, b), $7ddf193e68e751e3$var$$0172b398bee57f0a$var$__esDecorate(r, null, $, {
        kind: "accessor",
        name: "observedState",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "observedState" in e;
            },
            get: function(e) {
                return e.observedState;
            },
            set: function(e, t) {
                e.observedState = t;
            }
        },
        metadata: t
    }, p, v), $7ddf193e68e751e3$var$$0172b398bee57f0a$var$__esDecorate(r, null, u, {
        kind: "accessor",
        name: "observedContext",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "observedContext" in e;
            },
            get: function(e) {
                return e.observedContext;
            },
            set: function(e, t) {
                e.observedContext = t;
            }
        },
        metadata: t
    }, _, h), t && Object.defineProperty(r, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), r;
}(), $7ddf193e68e751e3$var$$621b7277d4dc39e9$exports = {};
$7ddf193e68e751e3$var$$parcel$export($7ddf193e68e751e3$var$$621b7277d4dc39e9$exports, "FormComponent", function() {
    return $7ddf193e68e751e3$var$$621b7277d4dc39e9$export$cec7cafc710f5d68;
});
var $7ddf193e68e751e3$var$$621b7277d4dc39e9$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, s = 0; s < t.length; s++)r = a ? t[s].call(e, r) : t[s].call(e);
    return a ? r : void 0;
}, $7ddf193e68e751e3$var$$621b7277d4dc39e9$var$__esDecorate = function(e, t, r, a, s, n) {
    function i(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var c, o = a.kind, l = "getter" === o ? "get" : "setter" === o ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), f = !1, d = r.length - 1; d >= 0; d--){
        var b = {};
        for(var p in a)b[p] = "access" === p ? {} : a[p];
        for(var p in a.access)b.access[p] = a.access[p];
        b.addInitializer = function(e) {
            if (f) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(i(e || null));
        };
        var v = (0, r[d])("accessor" === o ? {
            get: u.get,
            set: u.set
        } : u[l], b);
        if ("accessor" === o) {
            if (void 0 === v) continue;
            if (null === v || (void 0 === v ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(v)) !== "object") throw TypeError("Object expected");
            (c = i(v.get)) && (u.get = c), (c = i(v.set)) && (u.set = c), (c = i(v.init)) && s.unshift(c);
        } else (c = i(v)) && ("field" === o ? s.unshift(c) : u[l] = c);
    }
    $ && Object.defineProperty($, a.name, u), f = !0;
}, $7ddf193e68e751e3$var$$621b7277d4dc39e9$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $7ddf193e68e751e3$var$$621b7277d4dc39e9$var$__classPrivateFieldSet = function(e, t, r, a, s) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !s) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !s : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? s.call(e, r) : s ? s.value = r : t.set(e, r), r;
}, $7ddf193e68e751e3$var$$621b7277d4dc39e9$export$cec7cafc710f5d68 = function() {
    var e, t, r, a, s, n, i, c, o, l = [], $ = [], u = [];
    return e = function(e) {
        "use strict";
        function n() {
            var e;
            return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, n), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, n, arguments), Object.defineProperty(e, "ref", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($7ddf193e68e751e3$var$$621b7277d4dc39e9$var$__runInitializers(e, l), (0, $dNU7X.createRef)())
            }), s.set(e, $7ddf193e68e751e3$var$$621b7277d4dc39e9$var$__runInitializers(e, $, e.props.defaultValue)), t.set(e, $7ddf193e68e751e3$var$$621b7277d4dc39e9$var$__runInitializers(e, u)), r.set(e, void 0), a.set(e, function(t) {
                !(0, $0fd9d527cd0d1501$export$dd1bc94b04021eeb)(t) && (0, $0fd9d527cd0d1501$export$dd1bc94b04021eeb)(e.innerValue) && (e.innerValue = t);
            }), Object.defineProperty(e, "emitValue", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    var r, a;
                    return null == (a = (r = e.observedProps).onChange) ? void 0 : a.call(r, t && (void 0 === t ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(t)) === "object" ? (0, $dZnzp.toJS)(t) : t);
                }
            }), Object.defineProperty(e, "reset", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function() {
                    return e.innerValue = e.props.defaultValue;
                }
            }), e;
        }
        return (0, $92f5157d74f7ea45$export$71511d61b312f219)(n, e), (0, $53cdca766716469e$export$71511d61b312f219)(n, [
            {
                key: "innerValue",
                get: function() {
                    return $7ddf193e68e751e3$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, s, "f");
                },
                set: function(e) {
                    $7ddf193e68e751e3$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, s, e, "f");
                }
            },
            {
                key: "value",
                get: function() {
                    var e;
                    return null != (e = this.observedProps.value) ? e : this.innerValue;
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    var e, s, n = this;
                    $7ddf193e68e751e3$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, t, (0, $dZnzp.reaction)(function() {
                        return n.observedProps.defaultValue;
                    }, $7ddf193e68e751e3$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, a, "f")), "f"), $7ddf193e68e751e3$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, r, (0, $dZnzp.reaction)(function() {
                        return n.innerValue;
                    }, this.emitValue), "f"), null == (s = null == (e = this.ref.current) ? void 0 : e.form) || s.addEventListener("reset", this.reset);
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    var e, a, s, n;
                    null == (e = $7ddf193e68e751e3$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, t, "f")) || e.call(this), $7ddf193e68e751e3$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, t, void 0, "f"), null == (a = $7ddf193e68e751e3$var$$621b7277d4dc39e9$var$__classPrivateFieldGet(this, r, "f")) || a.call(this), $7ddf193e68e751e3$var$$621b7277d4dc39e9$var$__classPrivateFieldSet(this, r, void 0, "f"), null == (n = null == (s = this.ref.current) ? void 0 : s.form) || n.removeEventListener("reset", this.reset);
                }
            }
        ]), n;
    }($7ddf193e68e751e3$var$$0172b398bee57f0a$export$bf180ef329d1efd8), t = new WeakMap, r = new WeakMap, a = new WeakMap, s = new WeakMap, o = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (c = $7ddf193e68e751e3$var$$0172b398bee57f0a$export$bf180ef329d1efd8[Symbol.metadata]) ? c : null) : void 0, n = [
        $dZnzp.observable
    ], i = [
        $dZnzp.computed
    ], $7ddf193e68e751e3$var$$621b7277d4dc39e9$var$__esDecorate(e, null, n, {
        kind: "accessor",
        name: "innerValue",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "innerValue" in e;
            },
            get: function(e) {
                return e.innerValue;
            },
            set: function(e, t) {
                e.innerValue = t;
            }
        },
        metadata: o
    }, $, u), $7ddf193e68e751e3$var$$621b7277d4dc39e9$var$__esDecorate(e, null, i, {
        kind: "getter",
        name: "value",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "value" in e;
            },
            get: function(e) {
                return e.value;
            }
        },
        metadata: o
    }, null, l), o && Object.defineProperty(e, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: o
    }), e;
}();
$7ddf193e68e751e3$var$$parcel$exportWildcard($7ddf193e68e751e3$exports, $7ddf193e68e751e3$var$$0172b398bee57f0a$exports), $7ddf193e68e751e3$var$$parcel$exportWildcard($7ddf193e68e751e3$exports, $7ddf193e68e751e3$var$$621b7277d4dc39e9$exports);



var $799264a770627072$exports = {};
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    $799264a770627072$exports = factory();
})($799264a770627072$exports, function() {
    'use strict';
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = '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';
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = 'strict';
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                'normal',
                'auto',
                'loose'
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === 'strict' ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function(codePoints, options) {
        if (!options) options = {
            lineBreak: 'normal',
            wordBreak: 'normal'
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === 'keep-all' ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ''
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = '';
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)
        ];
    };
    var getAbsoluteValue = function(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case 'rem':
            case 'em':
                return 16 * token.number; // TODO use correct font-size
            case 'px':
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(' ');
        switch(sideOrCorner){
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function(deg) {
        return Math.PI * deg / 180;
    };
    var color$1 = {
        name: 'color',
        parse: function(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function(color) {
        return (0xff & color) === 0;
    };
    var asString = function(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var parseColorStop = function(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function(angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    'top',
                    'left',
                    'right',
                    'bottom'
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return acc;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case 'at':
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'center':
                        position.push(FIFTY_PERCENT);
                        return false;
                    case 'top':
                    case 'left':
                        position.push(ZERO_LENGTH);
                        return false;
                    case 'right':
                    case 'bottom':
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: 'image',
        parse: function(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === 'none') && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };
    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case 'padding-box':
                        return 1 /* PADDING_BOX */ ;
                    case 'content-box':
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(' ');
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function(value) {
        switch(value){
            case 'no-repeat':
                return 1 /* NO_REPEAT */ ;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */ ;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */ ;
            case 'repeat':
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: 'transparent',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'color'
        };
    };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');
    var borderRadiusForSide = function(side) {
        return {
            name: "border-radius-" + side,
            initialValue: '0 0',
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');
    var borderStyleForSide = function(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: 'solid',
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function(_context, style) {
                switch(style){
                    case 'none':
                        return 0 /* NONE */ ;
                    case 'dashed':
                        return 2 /* DASHED */ ;
                    case 'dotted':
                        return 3 /* DOTTED */ ;
                    case 'double':
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');
    var borderWidthForSide = function(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: '0',
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');
    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, direction) {
            switch(direction){
                case 'rtl':
                    return 1 /* RTL */ ;
                case 'ltr':
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function(display) {
        switch(display){
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */ ;
            case 'inline':
                return 4 /* INLINE */ ;
            case 'run-in':
                return 8 /* RUN_IN */ ;
            case 'flow':
                return 16 /* FLOW */ ;
            case 'flow-root':
                return 32 /* FLOW_ROOT */ ;
            case 'table':
                return 64 /* TABLE */ ;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */ ;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */ ;
            case 'ruby':
                return 512 /* RUBY */ ;
            case 'subgrid':
                return 1024 /* SUBGRID */ ;
            case 'list-item':
                return 2048 /* LIST_ITEM */ ;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */ ;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case 'table-row':
                return 32768 /* TABLE_ROW */ ;
            case 'table-cell':
                return 65536 /* TABLE_CELL */ ;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */ ;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */ ;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */ ;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */ ;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case 'contents':
                return 16777216 /* CONTENTS */ ;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */ ;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */ ;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */ ;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, float) {
            switch(float){
                case 'left':
                    return 1 /* LEFT */ ;
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'inline-start':
                    return 3 /* INLINE_START */ ;
                case 'inline-end':
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'normal') return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, lineBreak) {
            switch(lineBreak){
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function(token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'inside':
                    return 0 /* INSIDE */ ;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, type) {
            switch(type){
                case 'disc':
                    return 0 /* DISC */ ;
                case 'circle':
                    return 1 /* CIRCLE */ ;
                case 'square':
                    return 2 /* SQUARE */ ;
                case 'decimal':
                    return 3 /* DECIMAL */ ;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */ ;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */ ;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */ ;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */ ;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */ ;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */ ;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */ ;
                case 'armenian':
                    return 12 /* ARMENIAN */ ;
                case 'bengali':
                    return 13 /* BENGALI */ ;
                case 'cambodian':
                    return 14 /* CAMBODIAN */ ;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case 'devanagari':
                    return 18 /* DEVANAGARI */ ;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case 'georgian':
                    return 20 /* GEORGIAN */ ;
                case 'gujarati':
                    return 21 /* GUJARATI */ ;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */ ;
                case 'hebrew':
                    return 22 /* HEBREW */ ;
                case 'hiragana':
                    return 23 /* HIRAGANA */ ;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */ ;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */ ;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */ ;
                case 'kannada':
                    return 27 /* KANNADA */ ;
                case 'katakana':
                    return 28 /* KATAKANA */ ;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */ ;
                case 'khmer':
                    return 30 /* KHMER */ ;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case 'lao':
                    return 34 /* LAO */ ;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */ ;
                case 'malayalam':
                    return 36 /* MALAYALAM */ ;
                case 'mongolian':
                    return 37 /* MONGOLIAN */ ;
                case 'myanmar':
                    return 38 /* MYANMAR */ ;
                case 'oriya':
                    return 39 /* ORIYA */ ;
                case 'persian':
                    return 40 /* PERSIAN */ ;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case 'tamil':
                    return 43 /* TAMIL */ ;
                case 'telugu':
                    return 44 /* TELUGU */ ;
                case 'thai':
                    return 45 /* THAI */ ;
                case 'tibetan':
                    return 46 /* TIBETAN */ ;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */ ;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */ ;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case 'none':
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function(side) {
        return {
            name: "margin-" + side,
            initialValue: '0',
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');
    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case 'hidden':
                        return 1 /* HIDDEN */ ;
                    case 'scroll':
                        return 2 /* SCROLL */ ;
                    case 'clip':
                        return 3 /* CLIP */ ;
                    case 'auto':
                        return 4 /* AUTO */ ;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'break-word':
                    return "break-word" /* BREAK_WORD */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function(side) {
        return {
            name: "padding-" + side,
            initialValue: '0',
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: 'length-percentage'
        };
    };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');
    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textAlign) {
            switch(textAlign){
                case 'right':
                    return 2 /* RIGHT */ ;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */ ;
                case 'left':
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case 'relative':
                    return 1 /* RELATIVE */ ;
                case 'absolute':
                    return 2 /* ABSOLUTE */ ;
                case 'fixed':
                    return 3 /* FIXED */ ;
                case 'sticky':
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textTransform) {
            switch(textTransform){
                case 'uppercase':
                    return 2 /* UPPERCASE */ ;
                case 'lowercase':
                    return 1 /* LOWERCASE */ ;
                case 'capitalize':
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === 'none') return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, visibility) {
            switch(visibility){
                case 'hidden':
                    return 1 /* HIDDEN */ ;
                case 'collapse':
                    return 2 /* COLLAPSE */ ;
                case 'visible':
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, wordBreak) {
            switch(wordBreak){
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: 'time',
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case 's':
                    return 1000 * value.number;
                case 'ms':
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case 'underline':
                        return 1 /* UNDERLINE */ ;
                    case 'overline':
                        return 2 /* OVERLINE */ ;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */ ;
                    case 'none':
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(' '));
            return results.map(function(result) {
                return result.indexOf(' ') === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'length'
    };
    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case 'bold':
                    return 700;
                case 'normal':
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case 'oblique':
                    return "oblique" /* OBLIQUE */ ;
                case 'italic':
                    return "italic" /* ITALIC */ ;
                case 'normal':
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === 'none') return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function(quotes, depth, open) {
        if (!quotes) return '';
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return '';
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case 'stroke':
                        layers.push(1 /* STROKE */ );
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */ );
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: 'color'
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case 'all':
                return 1 /* ALL */ ;
            case 'clone':
                return 2 /* CLONE */ ;
            case 'parse':
                return 3 /* PARSE */ ;
            case 'render':
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = '0s';
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = 'none';
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = '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';
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && typeof Uint8Array.prototype.slice !== 'undefined' ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return '';
        var codeUnits = [];
        var index = -1;
        var result = '';
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function(document1) {
        var testElement = document1.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function() {
        return typeof new Image().crossOrigin !== 'undefined';
    };
    var testResponseType = function() {
        return typeof new XMLHttpRequest().responseType === 'string';
    };
    var testSVG = function(document1) {
        var img = new Image();
        var canvas = document1.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function(document1) {
        var canvas = document1.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function(width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === 'function' && typeof window.fetch === 'function' ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error('Node has no owner document');
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'grapheme'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function(text, transform) {
        switch(transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        'OL',
        'UL',
        'MENU'
    ];
    var parseNodeTree = function(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function(node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function(element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function(node) {
        return node.tagName === 'LI';
    };
    var isOLElement = function(node) {
        return node.tagName === 'OL';
    };
    var isInputElement = function(node) {
        return node.tagName === 'INPUT';
    };
    var isHTMLElement = function(node) {
        return node.tagName === 'HTML';
    };
    var isSVGElement = function(node) {
        return node.tagName === 'svg';
    };
    var isBodyElement = function(node) {
        return node.tagName === 'BODY';
    };
    var isCanvasElement = function(node) {
        return node.tagName === 'CANVAS';
    };
    var isVideoElement = function(node) {
        return node.tagName === 'VIDEO';
    };
    var isImageElement = function(node) {
        return node.tagName === 'IMG';
    };
    var isIFrameElement = function(node) {
        return node.tagName === 'IFRAME';
    };
    var isStyleElement = function(node) {
        return node.tagName === 'STYLE';
    };
    var isScriptElement = function(node) {
        return node.tagName === 'SCRIPT';
    };
    var isTextareaElement = function(node) {
        return node.tagName === 'TEXTAREA';
    };
    var isSelectElement = function(node) {
        return node.tagName === 'SELECT';
    };
    var isSlotElement = function(node) {
        return node.tagName === 'SLOT';
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function(node) {
        return node.tagName.indexOf('-') > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            'M',
            'CM',
            'D',
            'CD',
            'C',
            'XC',
            'L',
            'XL',
            'X',
            'IX',
            'V',
            'IV',
            'I'
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    var createAdditiveCounter = function(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix;
    };
    var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? '-' : '') + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function(value, symbols, suffix) {
        if (suffix === void 0) suffix = '. ';
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    var createCounterText = function(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? "\u3001" : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch(type){
            case 0 /* DISC */ :
                return "\u2022" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "\u25E6" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "\u25FE" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error('Cloned element does not have an owner document');
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn('Unable to restore scroll position for cloned document');
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === 'undefined') return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === 'function') return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') clone.loading = 'eager';
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === 'string') return css + rule.cssText;
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var window1 = node.ownerDocument.defaultView;
            if (window1 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window1.getComputedStyle(node);
                var styleBefore = window1.getComputedStyle(node, ':before');
                var styleAfter = window1.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var document1 = clone.ownerDocument;
            if (!document1 || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document1.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = document1.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(document1.createTextNode(node.getAttribute(attr[0].value) || ''));
                    } else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(document1.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : '';
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(document1.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case 'open-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case 'close-quote':
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function(doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += "\"" + doctype.publicId + "\"";
            if (doctype.systemId) str += "\"" + doctype.systemId + "\"";
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function(body, styles) {
        var document1 = body.ownerDocument;
        if (document1) {
            var style = document1.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return 'about:blank';
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === 'string' && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = 'anonymous';
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error('No proxy defined');
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === 'text') resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener('error', function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function(src) {
        return src.substr(0, 4) === 'blob';
    };
    var isSVG = function(src) {
        return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === 'number' && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function(value) {
        return typeof value === 'number';
    };
    var calculateBackgroundSize = function(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function(values, index) {
        var value = values[index];
        if (typeof value === 'undefined') return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === 'normal' || variant === 'small-caps';
            }).join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return 'center';
            case 2 /* RIGHT */ :
                return 'right';
            case 0 /* LEFT */ :
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        '-apple-system',
        'system-ui'
    ];
    var fixIOSSystemFonts = function(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') CacheStorage.setContext(window);
    var renderElement = function(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || typeof element !== 'object') return [
                            2 /*return*/ ,
                            Promise.reject('Invalid element provided as first argument')
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string' ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});


function $e58ef2470199210d$var$$parcel$exportWildcard(e, t) {
    return Object.keys(t).forEach(function(r) {
        "default" === r || "__esModule" === r || Object.prototype.hasOwnProperty.call(e, r) || Object.defineProperty(e, r, {
            enumerable: !0,
            get: function() {
                return t[r];
            }
        });
    }), e;
}
function $e58ef2470199210d$var$$parcel$export(e, t, r, a) {
    Object.defineProperty(e, t, {
        get: r,
        set: a,
        enumerable: !0,
        configurable: !0
    });
}
function $e58ef2470199210d$var$$parcel$interopDefault(e) {
    return e && e.__esModule ? e.default : e;
}
var $e58ef2470199210d$var$$fd019656019bb4f3$exports = {};
function $e58ef2470199210d$var$$fd019656019bb4f3$export$e3607ec2d7a891c4(e) {
    return function(t) {
        return t && new IntersectionObserver(function(t, r) {
            var a, c, n = (0, $44015290ab5c0623$export$71511d61b312f219)(t, 1)[0], o = n.isIntersecting, i = n.target;
            if (o) {
                var s = [
                    "animate__animated",
                    "animate__".concat(e)
                ];
                (a = i.classList).add.apply(a, (0, $ca91dac30bd8a8fe$export$71511d61b312f219)(s)), i.addEventListener("animationend", function() {
                    return (c = i.classList).remove.apply(c, (0, $ca91dac30bd8a8fe$export$71511d61b312f219)(s));
                }, {
                    once: !0
                }), r.disconnect();
            }
        }).observe(t);
    };
}
$e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$fd019656019bb4f3$exports, "animate", function() {
    return $e58ef2470199210d$var$$fd019656019bb4f3$export$e3607ec2d7a891c4;
});
var $e58ef2470199210d$var$$757747c0209676cc$exports = {};
$e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$757747c0209676cc$exports, "Avatar", function() {
    return $e58ef2470199210d$var$$757747c0209676cc$export$e2255cf6045e8d47;
});
var $e58ef2470199210d$var$$757747c0209676cc$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $e58ef2470199210d$var$$757747c0209676cc$export$e2255cf6045e8d47 = function(e) {
    var t = e.className, r = e.style, a = e.size, c = void 0 === a ? 3 : a, n = $e58ef2470199210d$var$$757747c0209676cc$var$__rest(e, [
        "className",
        "style",
        "size"
    ]);
    return (0, $2111e08a92d70add$exports.jsx)("img", Object.assign({
        className: $e58ef2470199210d$var$$parcel$interopDefault($852a55cf17d8b19d$exports)("object-fit-cover rounded-circle", t),
        style: Object.assign({
            width: "".concat(c, "rem"),
            height: "".concat(c, "rem")
        }, r)
    }, n));
};
$e58ef2470199210d$var$$757747c0209676cc$export$e2255cf6045e8d47.displayName = "Avatar";
var $e58ef2470199210d$var$$a40a1c3d6dc84a7a$exports = {};
$e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$a40a1c3d6dc84a7a$exports, "ClickBoundary", function() {
    return $e58ef2470199210d$var$$a40a1c3d6dc84a7a$export$707fce199b8e37aa;
});
var $e58ef2470199210d$var$$a40a1c3d6dc84a7a$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $e58ef2470199210d$var$$a40a1c3d6dc84a7a$export$707fce199b8e37aa = function(e) {
    "use strict";
    function t() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, t), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(e, "root", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: (0, $dNU7X.createRef)()
        }), Object.defineProperty(e, "switchClick", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: function(t) {
                var r, a = e.props, c = a.onInnerClick, n = a.onOuterClick;
                (null == (r = e.root.current) ? void 0 : r.contains(t.target)) ? null == c || c(t) : null == n || n(t);
            }
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(t, e), (0, $53cdca766716469e$export$71511d61b312f219)(t, [
        {
            key: "componentDidMount",
            value: function() {
                window.addEventListener("click", this.switchClick, !0);
            }
        },
        {
            key: "componentWillUnmount",
            value: function() {
                window.removeEventListener("click", this.switchClick, !0);
            }
        },
        {
            key: "render",
            value: function() {
                var e = this.props, t = e.children, r = (e.onInnerClick, e.onOuterClick, $e58ef2470199210d$var$$a40a1c3d6dc84a7a$var$__rest(e, [
                    "children",
                    "onInnerClick",
                    "onOuterClick"
                ]));
                return (0, $2111e08a92d70add$exports.jsx)("div", Object.assign({
                    ref: this.root
                }, r, {
                    children: t
                }));
            }
        }
    ]), t;
}($dNU7X.PureComponent), $e58ef2470199210d$var$$89fa9a64cf869995$exports = {};
$e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$89fa9a64cf869995$exports, "CodeBlock", function() {
    return $e58ef2470199210d$var$$89fa9a64cf869995$export$6c415d1fdae3dfdb;
});
var $e58ef2470199210d$var$$89fa9a64cf869995$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $e58ef2470199210d$var$$89fa9a64cf869995$export$6c415d1fdae3dfdb = function(e) {
    var t = e.className, r = e.language, a = e.children, c = $e58ef2470199210d$var$$89fa9a64cf869995$var$__rest(e, [
        "className",
        "language",
        "children"
    ]), n = "string" == typeof a ? a : $e58ef2470199210d$var$$parcel$interopDefault($946384cc26da4067$exports)((0, $dNU7X.isValidElement)(a) ? a : (0, $2111e08a92d70add$exports.jsx)($2111e08a92d70add$exports.Fragment, {
        children: a
    })), o = (0, $4799ffc520052701$exports.highlight)(n, $4799ffc520052701$exports.languages[r], r);
    return (0, $2111e08a92d70add$exports.jsx)("pre", Object.assign({
        className: "language-".concat(r, " ").concat(void 0 === t ? "" : t)
    }, c, {
        children: (0, $2111e08a92d70add$exports.jsx)("code", {
            dangerouslySetInnerHTML: {
                __html: o
            },
            className: "language-".concat(r)
        })
    }));
}, $e58ef2470199210d$var$$924d73683971f901$exports = {};
$e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$924d73683971f901$exports, "VariantColors", function() {
    return $e58ef2470199210d$var$$924d73683971f901$export$50b010be9260e56b;
}), $e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$924d73683971f901$exports, "text2color", function() {
    return $e58ef2470199210d$var$$924d73683971f901$export$b480d00b75c9ac2d;
});
var $e58ef2470199210d$var$$924d73683971f901$export$50b010be9260e56b = [
    "primary",
    "secondary",
    "success",
    "danger",
    "warning",
    "info",
    "dark",
    "light"
];
function $e58ef2470199210d$var$$924d73683971f901$export$b480d00b75c9ac2d(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [], r = t[0] ? $e58ef2470199210d$var$$924d73683971f901$export$50b010be9260e56b.filter(function(e) {
        return !t.find(function(t) {
            return t === e;
        });
    }) : $e58ef2470199210d$var$$924d73683971f901$export$50b010be9260e56b;
    return r[(0, $ca91dac30bd8a8fe$export$71511d61b312f219)(e).reduce(function(e, t) {
        return e + t.charCodeAt(0);
    }, 0) % r.length];
}
var $e58ef2470199210d$var$$e308f4ff6755d29b$exports = {};
$e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$e308f4ff6755d29b$exports, "DialogClose", function() {
    return $e58ef2470199210d$var$$e308f4ff6755d29b$export$fba2fb7cd781b7ac;
}), $e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$e308f4ff6755d29b$exports, "Dialog", function() {
    return $e58ef2470199210d$var$$e308f4ff6755d29b$export$3ddf2d174ce01153;
});
var $e58ef2470199210d$var$$e308f4ff6755d29b$var$__esDecorate = function(e, t, r, a, c, n) {
    function o(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(o(e || null));
        };
        var m = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = o(m.get)) && (u.get = i), (i = o(m.set)) && (u.set = i), (i = o(m.init)) && c.unshift(i);
        } else (i = o(m)) && ("field" === s ? c.unshift(i) : u[l] = i);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $e58ef2470199210d$var$$e308f4ff6755d29b$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $e58ef2470199210d$var$$e308f4ff6755d29b$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $e58ef2470199210d$var$$e308f4ff6755d29b$var$__classPrivateFieldSet = function(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $e58ef2470199210d$var$$e308f4ff6755d29b$export$fba2fb7cd781b7ac = function(e) {
    "use strict";
    function t() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "Dialog closed";
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, t), (0, $95518c9e748840bb$export$71511d61b312f219)(this, t, [
            e
        ]);
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(t, e), t;
}((0, $3faf9a97cee68ddc$export$71511d61b312f219)(Error)), $e58ef2470199210d$var$$e308f4ff6755d29b$export$3ddf2d174ce01153 = function() {
    var e, t, r, a, c, n, o = [], i = [], s = [], l = [];
    return t = function() {
        "use strict";
        function e(t) {
            var c = this;
            (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, e), r.set(this, $e58ef2470199210d$var$$e308f4ff6755d29b$var$__runInitializers(this, o, {})), a.set(this, ($e58ef2470199210d$var$$e308f4ff6755d29b$var$__runInitializers(this, i), $e58ef2470199210d$var$$e308f4ff6755d29b$var$__runInitializers(this, s, void 0))), Object.defineProperty(this, "Component", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: $e58ef2470199210d$var$$e308f4ff6755d29b$var$__runInitializers(this, l)
            }), this.Component = (0, $47a6458a96730da2$export$b6ae1bc530f4c149)(function(e) {
                return (0, $2111e08a92d70add$exports.jsx)(t, Object.assign({}, e, c.input, {
                    defer: c.defer
                }));
            }), this.Component.displayName = "DialogComponent";
        }
        return (0, $53cdca766716469e$export$71511d61b312f219)(e, [
            {
                key: "input",
                get: function() {
                    return $e58ef2470199210d$var$$e308f4ff6755d29b$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function(e) {
                    $e58ef2470199210d$var$$e308f4ff6755d29b$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "defer",
                get: function() {
                    return $e58ef2470199210d$var$$e308f4ff6755d29b$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function(e) {
                    $e58ef2470199210d$var$$e308f4ff6755d29b$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "open",
                value: function(e) {
                    var t = this;
                    return e && (this.input = e), this.defer = new $c379f9436bbe0249$export$c7e91f8aec23ae14, this.defer.promise.finally(function() {
                        return t.defer = void 0;
                    }), this.defer.promise;
                }
            }
        ]), e;
    }(), r = new WeakMap, a = new WeakMap, e = "function" == typeof Symbol && Symbol.metadata ? Object.create(null) : void 0, c = [
        $dZnzp.observable
    ], n = [
        $dZnzp.observable
    ], $e58ef2470199210d$var$$e308f4ff6755d29b$var$__esDecorate(t, null, c, {
        kind: "accessor",
        name: "input",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "input" in e;
            },
            get: function(e) {
                return e.input;
            },
            set: function(e, t) {
                e.input = t;
            }
        },
        metadata: e
    }, o, i), $e58ef2470199210d$var$$e308f4ff6755d29b$var$__esDecorate(t, null, n, {
        kind: "accessor",
        name: "defer",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "defer" in e;
            },
            get: function(e) {
                return e.defer;
            },
            set: function(e, t) {
                e.defer = t;
            }
        },
        metadata: e
    }, s, l), e && Object.defineProperty(t, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }), t;
}(), $e58ef2470199210d$var$$68aab1d0e8e5016c$exports = {};
$e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$68aab1d0e8e5016c$exports, "Editor", function() {
    return $e58ef2470199210d$var$$68aab1d0e8e5016c$export$7cda8d932e2f33c0;
});
var $e58ef2470199210d$var$$68aab1d0e8e5016c$var$__esDecorate = function(e, t, r, a, c, n) {
    function o(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(o(e || null));
        };
        var m = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = o(m.get)) && (u.get = i), (i = o(m.set)) && (u.set = i), (i = o(m.init)) && c.unshift(i);
        } else (i = o(m)) && ("field" === s ? c.unshift(i) : u[l] = i);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $e58ef2470199210d$var$$68aab1d0e8e5016c$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $e58ef2470199210d$var$$68aab1d0e8e5016c$var$__awaiter = function(e, t, r, a) {
    return new (r || (r = Promise))(function(c, n) {
        function o(e) {
            try {
                s(a.next(e));
            } catch (e) {
                n(e);
            }
        }
        function i(e) {
            try {
                s(a.throw(e));
            } catch (e) {
                n(e);
            }
        }
        function s(e) {
            var t;
            e.done ? c(e.value) : ((t = e.value) instanceof r ? t : new r(function(e) {
                e(t);
            })).then(o, i);
        }
        s((a = a.apply(e, t || [])).next());
    });
}, $e58ef2470199210d$var$$68aab1d0e8e5016c$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $e58ef2470199210d$var$$68aab1d0e8e5016c$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $e58ef2470199210d$var$$68aab1d0e8e5016c$var$__classPrivateFieldSet = function(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $e58ef2470199210d$var$$68aab1d0e8e5016c$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $e58ef2470199210d$var$$68aab1d0e8e5016c$var$ReactEditorJS = (0, $80aa94f7cd3252af$export$da8ca15f4115b46e)(), $e58ef2470199210d$var$$68aab1d0e8e5016c$export$7cda8d932e2f33c0 = function() {
    var e, t, r, a, c, n = [
        $47a6458a96730da2$export$b6ae1bc530f4c149
    ], o = [], i = $dNU7X.Component, s = [], l = [];
    return c = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, t), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(e, "core", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: void 0
            }), r.set(e, $e58ef2470199210d$var$$68aab1d0e8e5016c$var$__runInitializers(e, s, e.props.defaultValue)), Object.defineProperty(e, "save", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($e58ef2470199210d$var$$68aab1d0e8e5016c$var$__runInitializers(e, l), function() {
                    return $e58ef2470199210d$var$$68aab1d0e8e5016c$var$__awaiter(e, void 0, void 0, function() {
                        var e, t;
                        return (0, $8fdeac7b23d8f90e$export$71511d61b312f219)(this, function(r) {
                            switch(r.label){
                                case 0:
                                    if (!(e = this.core)) return [
                                        3,
                                        2
                                    ];
                                    return t = this, [
                                        4,
                                        this.core.save()
                                    ];
                                case 1:
                                    e = t.innerValue = r.sent(), r.label = 2;
                                case 2:
                                    return [
                                        2,
                                        e
                                    ];
                            }
                        });
                    });
                })
            }), e;
        }
        return (0, $92f5157d74f7ea45$export$71511d61b312f219)(t, e), (0, $53cdca766716469e$export$71511d61b312f219)(t, [
            {
                key: "innerValue",
                get: function() {
                    return $e58ef2470199210d$var$$68aab1d0e8e5016c$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function(e) {
                    $e58ef2470199210d$var$$68aab1d0e8e5016c$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, t = this.props, r = t.name, a = t.required, c = (t.children, $e58ef2470199210d$var$$68aab1d0e8e5016c$var$__rest(t, [
                        "name",
                        "required",
                        "children"
                    ])), n = this.innerValue;
                    return (0, $2111e08a92d70add$exports.jsxs)("div", {
                        className: "form-control",
                        tabIndex: -1,
                        onBlur: this.save,
                        children: [
                            (0, $2111e08a92d70add$exports.jsx)("input", {
                                hidden: !0,
                                name: r,
                                required: a,
                                value: JSON.stringify(n)
                            }),
                            (0, $2111e08a92d70add$exports.jsx)($e58ef2470199210d$var$$68aab1d0e8e5016c$var$ReactEditorJS, Object.assign({}, c, {
                                onInitialize: function(t) {
                                    var r;
                                    e.core = t, null == (r = c.onInitialize) || r.call(c, t);
                                }
                            }))
                        ]
                    });
                }
            }
        ]), t;
    }(i), r = new WeakMap, $e58ef2470199210d$var$$68aab1d0e8e5016c$var$__setFunctionName(c, "Editor"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = i[Symbol.metadata]) ? e : null) : void 0, $e58ef2470199210d$var$$68aab1d0e8e5016c$var$__esDecorate(c, null, [
        $dZnzp.observable
    ], {
        kind: "accessor",
        name: "innerValue",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "innerValue" in e;
            },
            get: function(e) {
                return e.innerValue;
            },
            set: function(e, t) {
                e.innerValue = t;
            }
        },
        metadata: t
    }, s, l), $e58ef2470199210d$var$$68aab1d0e8e5016c$var$__esDecorate(null, a = {
        value: c
    }, n, {
        kind: "class",
        name: c.name,
        metadata: t
    }, null, o), c = a.value, t && Object.defineProperty(c, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(c, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "Editor"
    }), $e58ef2470199210d$var$$68aab1d0e8e5016c$var$__runInitializers(c, o), c;
}(), $e58ef2470199210d$var$$db3d9d99c159855a$exports = {};
$e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$db3d9d99c159855a$exports, "parser", function() {
    return $e58ef2470199210d$var$$db3d9d99c159855a$export$8f49e4af10703ce3;
}), $e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$db3d9d99c159855a$exports, "EditorHTML", function() {
    return $e58ef2470199210d$var$$db3d9d99c159855a$export$f9c5335a01b13a5a;
});
var $e58ef2470199210d$var$$db3d9d99c159855a$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $e58ef2470199210d$var$$db3d9d99c159855a$export$8f49e4af10703ce3 = $e58ef2470199210d$var$$parcel$interopDefault($70d150f8dfa3d626$exports)({
    link: function(e) {
        var t = e.data.link;
        return '<a href="'.concat(t, '">').concat(t, "</a>");
    }
}), $e58ef2470199210d$var$$db3d9d99c159855a$export$f9c5335a01b13a5a = function(e) {
    var t = e.data, r = $e58ef2470199210d$var$$db3d9d99c159855a$var$__rest(e, [
        "data"
    ]);
    return (0, $2111e08a92d70add$exports.jsx)("article", Object.assign({}, r, {
        dangerouslySetInnerHTML: {
            __html: $e58ef2470199210d$var$$db3d9d99c159855a$export$8f49e4af10703ce3.parse(t)
        }
    }));
};
$e58ef2470199210d$var$$db3d9d99c159855a$export$f9c5335a01b13a5a.displayName = "EditorHTML";
var $e58ef2470199210d$var$$e400f030e8cea549$exports = {};
$e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$e400f030e8cea549$exports, "HorizontalMarquee", function() {
    return $e58ef2470199210d$var$$e400f030e8cea549$export$4eb895ecfe5a67d5;
}), $e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$e400f030e8cea549$exports, "HorizontalMarqueeBox", function() {
    return $e58ef2470199210d$var$$e400f030e8cea549$export$e22877062eb47c32;
}), $e58ef2470199210d$var$$14c85ffeff1ab241$export$fad3c8302a7540c6 = "_4_3lnG_scrollContainer", $e58ef2470199210d$var$$14c85ffeff1ab241$export$5f81b96ae5b0befd = "_4_3lnG_scrollHeightWrap", $e58ef2470199210d$var$$14c85ffeff1ab241$export$1a22ace05a045e3f = "_4_3lnG_scrollItem", $e58ef2470199210d$var$$14c85ffeff1ab241$export$c7aa240077ad8340 = "_4_3lnG_scrollWrap", $e58ef2470199210d$var$$14c85ffeff1ab241$export$5add10f2a1e13991 = "_4_3lnG_unScrollItem";
var $e58ef2470199210d$var$$e400f030e8cea549$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $e58ef2470199210d$var$$e400f030e8cea549$export$4eb895ecfe5a67d5 = function(e) {
    var t = e.className, r = e.children, a = e.maxWidth, c = e.duration, n = e.height, o = $e58ef2470199210d$var$$e400f030e8cea549$var$__rest(e, [
        "className",
        "children",
        "maxWidth",
        "duration",
        "height"
    ]);
    return (0, $2111e08a92d70add$exports.jsx)("div", Object.assign({
        className: "overflow-hidden mw-100 ".concat(void 0 === t ? "" : t)
    }, o, {
        children: (0, $2111e08a92d70add$exports.jsx)("div", {
            className: "d-inline-block align-top text-nowrap ".concat($e58ef2470199210d$var$$14c85ffeff1ab241$export$c7aa240077ad8340),
            style: {
                maxWidth: void 0 === a ? "100%" : a,
                animationDuration: c,
                height: n,
                lineHeight: n
            },
            children: (0, $2111e08a92d70add$exports.jsx)("div", {
                className: "d-inline-block ".concat($e58ef2470199210d$var$$14c85ffeff1ab241$export$1a22ace05a045e3f),
                style: {
                    animationDuration: c
                },
                children: r
            })
        })
    }));
}, $e58ef2470199210d$var$$e400f030e8cea549$export$e22877062eb47c32 = function(e) {
    var t = e.children, r = e.maxWidth, a = e.duration, c = e.height;
    return c ? (0, $2111e08a92d70add$exports.jsx)("div", {
        className: "overflow-hidden ".concat($e58ef2470199210d$var$$14c85ffeff1ab241$export$5f81b96ae5b0befd),
        style: {
            maxWidth: r,
            "--scroll-height": c
        },
        children: (0, $2111e08a92d70add$exports.jsxs)("div", {
            className: "d-inline-block overflow-hidden mw-100 ".concat($e58ef2470199210d$var$$14c85ffeff1ab241$export$fad3c8302a7540c6),
            children: [
                (0, $2111e08a92d70add$exports.jsx)("div", {
                    className: "d-block overflow-hidden text-wrap text-break ".concat($e58ef2470199210d$var$$14c85ffeff1ab241$export$5add10f2a1e13991),
                    children: t
                }),
                (0, $2111e08a92d70add$exports.jsx)($e58ef2470199210d$var$$e400f030e8cea549$export$4eb895ecfe5a67d5, {
                    duration: a,
                    children: t
                })
            ]
        })
    }) : (0, $2111e08a92d70add$exports.jsx)($e58ef2470199210d$var$$e400f030e8cea549$export$4eb895ecfe5a67d5, {
        maxWidth: r,
        duration: a,
        height: c,
        children: t
    });
};
$e58ef2470199210d$var$$e400f030e8cea549$export$4eb895ecfe5a67d5.displayName = "HorizontalMarquee";
var $e58ef2470199210d$var$$cf5cdc2ffed4bc45$exports = {};
$e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$cf5cdc2ffed4bc45$exports, "Icon", function() {
    return $e58ef2470199210d$var$$cf5cdc2ffed4bc45$export$f04a61298a47a40f;
});
var $e58ef2470199210d$var$$cf5cdc2ffed4bc45$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $e58ef2470199210d$var$$cf5cdc2ffed4bc45$export$f04a61298a47a40f = function(e) {
    var t = e.className, r = e.style, a = e.name, c = e.size, n = $e58ef2470199210d$var$$cf5cdc2ffed4bc45$var$__rest(e, [
        "className",
        "style",
        "name",
        "size"
    ]);
    return (0, $2111e08a92d70add$exports.jsx)("span", Object.assign({
        className: $e58ef2470199210d$var$$parcel$interopDefault($852a55cf17d8b19d$exports)("bi-".concat(a), t),
        style: Object.assign({
            fontSize: c && "".concat(c, "rem")
        }, r)
    }, n));
};
$e58ef2470199210d$var$$cf5cdc2ffed4bc45$export$f04a61298a47a40f.displayName = "Icon";
var $e58ef2470199210d$var$$1f7252b8d0187295$exports = {};
$e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$1f7252b8d0187295$exports, "Loading", function() {
    return $e58ef2470199210d$var$$1f7252b8d0187295$export$669f6ea7d267feaf;
});
var $e58ef2470199210d$var$$1f7252b8d0187295$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $e58ef2470199210d$var$$1f7252b8d0187295$export$669f6ea7d267feaf = function(e) {
    var t = e.className, r = e.children, a = $e58ef2470199210d$var$$1f7252b8d0187295$var$__rest(e, [
        "className",
        "children"
    ]);
    return (0, $2111e08a92d70add$exports.jsxs)("div", Object.assign({
        className: "fixed-top h-100 w-100 d-flex justify-content-center align-items-center opacity-25 bg-black ".concat(void 0 === t ? "" : t)
    }, a, {
        children: [
            (0, $2111e08a92d70add$exports.jsx)($45f3ae5f1643f191$export$2e2bcd8739ae039, {
                animation: "border",
                variant: "success"
            }),
            (0, $2111e08a92d70add$exports.jsx)("span", {
                className: "ml-3 text-white",
                children: void 0 === r ? "Loading..." : r
            })
        ]
    }));
};
$e58ef2470199210d$var$$1f7252b8d0187295$export$669f6ea7d267feaf.displayName = "Loading";
var $e58ef2470199210d$var$$ec6e3ccd45c7b7c0$exports = {};
$e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$ec6e3ccd45c7b7c0$exports, "MonthCalendar", function() {
    return $e58ef2470199210d$var$$ec6e3ccd45c7b7c0$export$d7a7c85c0f5afc4a;
});
var $e58ef2470199210d$var$$a121893c5bead7fc$exports = {};
$e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$a121893c5bead7fc$exports, "OverlayBox", function() {
    return $e58ef2470199210d$var$$a121893c5bead7fc$export$5169ff31790bf260;
});
var $e58ef2470199210d$var$$a121893c5bead7fc$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $e58ef2470199210d$var$$a121893c5bead7fc$export$5169ff31790bf260 = function(e) {
    var t = e.title, r = e.detail, a = e.children, c = $e58ef2470199210d$var$$a121893c5bead7fc$var$__rest(e, [
        "title",
        "detail",
        "children"
    ]);
    return (0, $2111e08a92d70add$exports.jsx)($4345da258e966f14$export$2e2bcd8739ae039, Object.assign({}, c, {
        overlay: r ? (0, $2111e08a92d70add$exports.jsxs)($3aba1b22127dfbc2$export$2e2bcd8739ae039, {
            children: [
                (0, $2111e08a92d70add$exports.jsx)($3aba1b22127dfbc2$export$2e2bcd8739ae039.Header, {
                    children: t
                }),
                (0, $2111e08a92d70add$exports.jsx)($3aba1b22127dfbc2$export$2e2bcd8739ae039.Body, {
                    children: r
                })
            ]
        }) : (0, $2111e08a92d70add$exports.jsx)($cd4f066234704aac$export$2e2bcd8739ae039, {
            children: t
        }),
        children: a
    }));
};
$e58ef2470199210d$var$$a121893c5bead7fc$export$5169ff31790bf260.displayName = "OverlayBox";
var $e58ef2470199210d$var$$ec6e3ccd45c7b7c0$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $e58ef2470199210d$var$$ec6e3ccd45c7b7c0$var$__esDecorate = function(e, t, r, a, c, n) {
    function o(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(o(e || null));
        };
        var m = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = o(m.get)) && (u.get = i), (i = o(m.set)) && (u.set = i), (i = o(m.init)) && c.unshift(i);
        } else (i = o(m)) && ("field" === s ? c.unshift(i) : u[l] = i);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $e58ef2470199210d$var$$ec6e3ccd45c7b7c0$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $e58ef2470199210d$var$$ec6e3ccd45c7b7c0$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $e58ef2470199210d$var$$ec6e3ccd45c7b7c0$var$__classPrivateFieldSet = function(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $e58ef2470199210d$var$$ec6e3ccd45c7b7c0$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $e58ef2470199210d$var$$ec6e3ccd45c7b7c0$export$d7a7c85c0f5afc4a = function() {
    var e, t, r, a, c, n, o, i, s = [
        $47a6458a96730da2$export$b6ae1bc530f4c149
    ], l = [], $ = $7ddf193e68e751e3$exports.ObservedComponent, u = [], d = [], f = [];
    return c = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, t), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, t, arguments), r.set(e, ($e58ef2470199210d$var$$ec6e3ccd45c7b7c0$var$__runInitializers(e, u), $e58ef2470199210d$var$$ec6e3ccd45c7b7c0$var$__runInitializers(e, d, new Date))), Object.defineProperty(e, "renderDate", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($e58ef2470199210d$var$$ec6e3ccd45c7b7c0$var$__runInitializers(e, f), function(t) {
                    var r = e.observedProps, a = (r.variant, r.value), c = r.onSelect, n = (0, $0fd9d527cd0d1501$export$3ae94a2503e890a1)(t, "YYYY-MM-DD"), o = null == a ? void 0 : a.filter(function(e) {
                        var t = e.date;
                        return (0, $0fd9d527cd0d1501$export$3ae94a2503e890a1)(t, "YYYY-MM-DD") === n;
                    });
                    return (0, $2111e08a92d70add$exports.jsxs)("td", {
                        className: $e58ef2470199210d$var$$parcel$interopDefault($852a55cf17d8b19d$exports)({
                            "opacity-50": t.getMonth() !== e.currentDate.getMonth(),
                            "fw-bold": n === (0, $0fd9d527cd0d1501$export$3ae94a2503e890a1)(new Date, "YYYY-MM-DD")
                        }),
                        children: [
                            (0, $2111e08a92d70add$exports.jsx)("time", {
                                className: "d-block",
                                dateTime: t.toJSON(),
                                children: t.getDate()
                            }),
                            null == o ? void 0 : o.map(function(e) {
                                return "object" === (0, $35f6c23f56aaf458$export$71511d61b312f219)(e.content) ? e.content : (0, $2111e08a92d70add$exports.jsx)($e58ef2470199210d$var$$a121893c5bead7fc$export$5169ff31790bf260, {
                                    title: e.content,
                                    children: (0, $2111e08a92d70add$exports.jsx)($7309943aa9afa2d4$export$2e2bcd8739ae039, {
                                        as: "a",
                                        className: "d-inline-block text-decoration-none w-100 text-truncate",
                                        bg: $e58ef2470199210d$var$$924d73683971f901$export$b480d00b75c9ac2d(e.content + "", [
                                            "light"
                                        ]),
                                        href: e.link,
                                        onClick: function() {
                                            return null == c ? void 0 : c(e);
                                        },
                                        children: e.content
                                    })
                                }, e.date + "");
                            })
                        ]
                    }, t + "");
                })
            }), e;
        }
        return (0, $92f5157d74f7ea45$export$71511d61b312f219)(t, e), (0, $53cdca766716469e$export$71511d61b312f219)(t, [
            {
                key: "weekFormatter",
                get: function() {
                    var e, t = this.observedProps.locale, r = void 0 === t ? null == (e = globalThis.navigator) ? void 0 : e.language : t;
                    return new Intl.DateTimeFormat(r, {
                        weekday: "long"
                    });
                }
            },
            {
                key: "currentDate",
                get: function() {
                    return $e58ef2470199210d$var$$ec6e3ccd45c7b7c0$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function(e) {
                    $e58ef2470199210d$var$$ec6e3ccd45c7b7c0$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "dateGrid",
                get: function() {
                    var e = new Date(this.currentDate);
                    e.setDate(1), e = new Date(e - e.getDay() * $0fd9d527cd0d1501$export$7a9a31a911eb9a20);
                    var t = Array.from(Array(42), function(t, r) {
                        return new Date(+e + r * $0fd9d527cd0d1501$export$7a9a31a911eb9a20);
                    });
                    return (0, $0fd9d527cd0d1501$export$697c3df919c0e61a)(t, 7);
                }
            },
            {
                key: "changeMonth",
                value: function(e) {
                    var t, r;
                    this.currentDate = (0, $0fd9d527cd0d1501$export$62ad822b3a5fd9a0)(this.currentDate, e), null == (r = (t = this.props).onChange) || r.call(t, this.currentDate);
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, t = this.weekFormatter, r = this.currentDate, a = this.dateGrid, c = this.observedProps, n = c.style, o = c.variant, i = void 0 === o ? "primary" : o, s = (c.onChange, c.onSelect, $e58ef2470199210d$var$$ec6e3ccd45c7b7c0$var$__rest(c, [
                        "style",
                        "variant",
                        "onChange",
                        "onSelect"
                    ]));
                    return (0, $2111e08a92d70add$exports.jsxs)($8a4db44e7eb3b880$export$2e2bcd8739ae039, Object.assign({}, s, {
                        style: Object.assign({
                            tableLayout: "fixed"
                        }, n),
                        children: [
                            (0, $2111e08a92d70add$exports.jsx)("caption", {
                                children: (0, $2111e08a92d70add$exports.jsxs)("div", {
                                    className: "d-flex justify-content-between align-items-center",
                                    children: [
                                        (0, $2111e08a92d70add$exports.jsx)($23c9a6bed94aa817$export$2e2bcd8739ae039, {
                                            variant: i,
                                            onClick: function() {
                                                return e.changeMonth(-1);
                                            },
                                            children: "<"
                                        }),
                                        (0, $0fd9d527cd0d1501$export$3ae94a2503e890a1)(r, "YYYY-MM"),
                                        (0, $2111e08a92d70add$exports.jsx)($23c9a6bed94aa817$export$2e2bcd8739ae039, {
                                            variant: i,
                                            onClick: function() {
                                                return e.changeMonth(1);
                                            },
                                            children: ">"
                                        })
                                    ]
                                })
                            }),
                            (0, $2111e08a92d70add$exports.jsx)("thead", {
                                children: (0, $2111e08a92d70add$exports.jsx)("tr", {
                                    children: a[0].map(function(e, r, a) {
                                        var c = a.length;
                                        return (0, $2111e08a92d70add$exports.jsx)("td", {
                                            className: "bg-".concat(i, " text-white"),
                                            style: {
                                                width: "calc(100% / ".concat(c, ")")
                                            },
                                            children: t.format(e)
                                        }, r);
                                    })
                                })
                            }),
                            (0, $2111e08a92d70add$exports.jsx)("tbody", {
                                children: a.map(function(t) {
                                    return (0, $2111e08a92d70add$exports.jsx)("tr", {
                                        children: t.map(e.renderDate)
                                    }, t[0] + "");
                                })
                            })
                        ]
                    }));
                }
            }
        ]), t;
    }($), r = new WeakMap, $e58ef2470199210d$var$$ec6e3ccd45c7b7c0$var$__setFunctionName(c, "MonthCalendar"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = $[Symbol.metadata]) ? e : null) : void 0, n = [
        $dZnzp.computed
    ], o = [
        $dZnzp.observable
    ], i = [
        $dZnzp.computed
    ], $e58ef2470199210d$var$$ec6e3ccd45c7b7c0$var$__esDecorate(c, null, n, {
        kind: "getter",
        name: "weekFormatter",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "weekFormatter" in e;
            },
            get: function(e) {
                return e.weekFormatter;
            }
        },
        metadata: t
    }, null, u), $e58ef2470199210d$var$$ec6e3ccd45c7b7c0$var$__esDecorate(c, null, o, {
        kind: "accessor",
        name: "currentDate",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "currentDate" in e;
            },
            get: function(e) {
                return e.currentDate;
            },
            set: function(e, t) {
                e.currentDate = t;
            }
        },
        metadata: t
    }, d, f), $e58ef2470199210d$var$$ec6e3ccd45c7b7c0$var$__esDecorate(c, null, i, {
        kind: "getter",
        name: "dateGrid",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "dateGrid" in e;
            },
            get: function(e) {
                return e.dateGrid;
            }
        },
        metadata: t
    }, null, u), $e58ef2470199210d$var$$ec6e3ccd45c7b7c0$var$__esDecorate(null, a = {
        value: c
    }, s, {
        kind: "class",
        name: c.name,
        metadata: t
    }, null, l), c = a.value, t && Object.defineProperty(c, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(c, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "MonthCalendar"
    }), $e58ef2470199210d$var$$ec6e3ccd45c7b7c0$var$__runInitializers(c, l), c;
}(), $e58ef2470199210d$var$$4f69bf8d62d4bac9$exports = {};
$e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$4f69bf8d62d4bac9$exports, "Nameplate", function() {
    return $e58ef2470199210d$var$$4f69bf8d62d4bac9$export$caa4d5435e8fb601;
});
var $e58ef2470199210d$var$$4f69bf8d62d4bac9$export$caa4d5435e8fb601 = function(e) {
    var t = e.avatar, r = e.name;
    return (0, $2111e08a92d70add$exports.jsxs)($2111e08a92d70add$exports.Fragment, {
        children: [
            (0, $2111e08a92d70add$exports.jsx)($e58ef2470199210d$var$$757747c0209676cc$export$e2255cf6045e8d47, {
                size: 2,
                style: {
                    marginRight: "0.5rem"
                },
                src: t
            }),
            (0, $2111e08a92d70add$exports.jsx)("span", {
                className: "align-middle",
                children: r
            })
        ]
    });
};
$e58ef2470199210d$var$$4f69bf8d62d4bac9$export$caa4d5435e8fb601.displayName = "Nameplate";
var $e58ef2470199210d$var$$d78fd73e1713e936$exports = {};
$e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$d78fd73e1713e936$exports, "PageNav", function() {
    return $e58ef2470199210d$var$$d78fd73e1713e936$export$f24150b9675a2c65;
});
var $e58ef2470199210d$var$$d78fd73e1713e936$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $e58ef2470199210d$var$$d78fd73e1713e936$var$__esDecorate = function(e, t, r, a, c, n) {
    function o(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(o(e || null));
        };
        var m = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = o(m.get)) && (u.get = i), (i = o(m.set)) && (u.set = i), (i = o(m.init)) && c.unshift(i);
        } else (i = o(m)) && ("field" === s ? c.unshift(i) : u[l] = i);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $e58ef2470199210d$var$$d78fd73e1713e936$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $e58ef2470199210d$var$$d78fd73e1713e936$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $e58ef2470199210d$var$$d78fd73e1713e936$var$__classPrivateFieldSet = function(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $e58ef2470199210d$var$$d78fd73e1713e936$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $e58ef2470199210d$var$$d78fd73e1713e936$var$HeadingSelector = Array.from(Array(6), function(e, t) {
    return "h".concat(++t);
}) + "", $e58ef2470199210d$var$$d78fd73e1713e936$export$f24150b9675a2c65 = function() {
    var e, t, r, a, c, n, o, i, s, l = [
        $47a6458a96730da2$export$b6ae1bc530f4c149
    ], $ = [], u = $dNU7X.Component, d = [], f = [], p = [], b = [], m = [];
    return n = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, t), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, t, arguments), r.set(e, ($e58ef2470199210d$var$$d78fd73e1713e936$var$__runInitializers(e, d), $e58ef2470199210d$var$$d78fd73e1713e936$var$__runInitializers(e, f, []))), a.set(e, ($e58ef2470199210d$var$$d78fd73e1713e936$var$__runInitializers(e, p), $e58ef2470199210d$var$$d78fd73e1713e936$var$__runInitializers(e, b, 0))), Object.defineProperty(e, "updateScrollY", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($e58ef2470199210d$var$$d78fd73e1713e936$var$__runInitializers(e, m), function() {
                    return e.scrollY = window.scrollY;
                })
            }), Object.defineProperty(e, "scrollTo", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    return function() {
                        var r, a;
                        setTimeout(function() {
                            return (0, $0fd9d527cd0d1501$export$3f99968195accfaf)('[id="'.concat(t.id, '"]'));
                        }), null == (a = (r = e.props).onItemClick) || a.call(r, t);
                    };
                }
            }), Object.defineProperty(e, "renderLink", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    var r = t.id, a = t.level, c = t.text, n = t.top, o = e.currentActiveId, i = e.props.depth;
                    return a <= (void 0 === i ? 1 / 0 : i) && (0, $2111e08a92d70add$exports.jsx)($e2aa45c67a610333$export$2e2bcd8739ae039.Item, {
                        style: {
                            textIndent: "".concat(a - 1, "rem")
                        },
                        children: (0, $2111e08a92d70add$exports.jsx)($e2aa45c67a610333$export$2e2bcd8739ae039.Link, {
                            href: "#".concat(r),
                            active: o === r,
                            onClick: e.scrollTo({
                                id: r,
                                level: a,
                                text: c,
                                top: n
                            }),
                            children: c
                        })
                    }, r);
                }
            }), e;
        }
        return (0, $92f5157d74f7ea45$export$71511d61b312f219)(t, e), (0, $53cdca766716469e$export$71511d61b312f219)(t, [
            {
                key: "list",
                get: function() {
                    return $e58ef2470199210d$var$$d78fd73e1713e936$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function(e) {
                    $e58ef2470199210d$var$$d78fd73e1713e936$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "scrollY",
                get: function() {
                    return $e58ef2470199210d$var$$d78fd73e1713e936$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function(e) {
                    $e58ef2470199210d$var$$d78fd73e1713e936$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "currentActiveId",
                get: function() {
                    var e, t = this.list, r = this.scrollY, a = t.findIndex(function(e) {
                        return e.top > r;
                    });
                    return null == (e = t[a - 1]) ? void 0 : e.id;
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    globalThis.document && (window.addEventListener("scroll", this.updateScrollY), this.list = Array.from(document.querySelectorAll($e58ef2470199210d$var$$d78fd73e1713e936$var$HeadingSelector), function(e) {
                        e.id || (e.id = (0, $0fd9d527cd0d1501$export$89912e019eef22aa)());
                        var t = e.id, r = e.tagName, a = e.textContent, c = e.offsetTop;
                        return {
                            id: t,
                            level: +r[1],
                            text: a.trim(),
                            top: c
                        };
                    }));
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    var e;
                    null == (e = globalThis.removeEventListener) || e.call(globalThis, "scroll", this.updateScrollY);
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.list, t = this.props, r = t.style, a = t.variant, c = $e58ef2470199210d$var$$d78fd73e1713e936$var$__rest(t, [
                        "style",
                        "variant"
                    ]);
                    return (0, $2111e08a92d70add$exports.jsx)($e2aa45c67a610333$export$2e2bcd8739ae039, Object.assign({}, c, {
                        variant: void 0 === a ? "underline" : a,
                        style: Object.assign({
                            flexDirection: "column"
                        }, r),
                        children: e.map(this.renderLink)
                    }));
                }
            }
        ]), t;
    }(u), r = new WeakMap, a = new WeakMap, $e58ef2470199210d$var$$d78fd73e1713e936$var$__setFunctionName(n, "PageNav"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = u[Symbol.metadata]) ? e : null) : void 0, o = [
        $dZnzp.observable
    ], i = [
        $dZnzp.observable
    ], s = [
        $dZnzp.computed
    ], $e58ef2470199210d$var$$d78fd73e1713e936$var$__esDecorate(n, null, o, {
        kind: "accessor",
        name: "list",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "list" in e;
            },
            get: function(e) {
                return e.list;
            },
            set: function(e, t) {
                e.list = t;
            }
        },
        metadata: t
    }, f, p), $e58ef2470199210d$var$$d78fd73e1713e936$var$__esDecorate(n, null, i, {
        kind: "accessor",
        name: "scrollY",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "scrollY" in e;
            },
            get: function(e) {
                return e.scrollY;
            },
            set: function(e, t) {
                e.scrollY = t;
            }
        },
        metadata: t
    }, b, m), $e58ef2470199210d$var$$d78fd73e1713e936$var$__esDecorate(n, null, s, {
        kind: "getter",
        name: "currentActiveId",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "currentActiveId" in e;
            },
            get: function(e) {
                return e.currentActiveId;
            }
        },
        metadata: t
    }, null, d), $e58ef2470199210d$var$$d78fd73e1713e936$var$__esDecorate(null, c = {
        value: n
    }, l, {
        kind: "class",
        name: n.name,
        metadata: t
    }, null, $), n = c.value, t && Object.defineProperty(n, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(n, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "PageNav"
    }), $e58ef2470199210d$var$$d78fd73e1713e936$var$__runInitializers(n, $), n;
}(), $e58ef2470199210d$var$$5d0c8d8af5c3c7e5$exports = {};
$e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$5d0c8d8af5c3c7e5$exports, "Option", function() {
    return $e58ef2470199210d$var$$5d0c8d8af5c3c7e5$export$36d18380658d5d20;
}), $e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$5d0c8d8af5c3c7e5$exports, "Select", function() {
    return $e58ef2470199210d$var$$5d0c8d8af5c3c7e5$export$ef9b1a59e592288f;
});
var $e58ef2470199210d$var$$5d0c8d8af5c3c7e5$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $e58ef2470199210d$var$$5d0c8d8af5c3c7e5$export$36d18380658d5d20 = function(e) {
    var t = e.value, r = e.children, a = $e58ef2470199210d$var$$5d0c8d8af5c3c7e5$var$__rest(e, [
        "value",
        "children"
    ]);
    return (0, $2111e08a92d70add$exports.jsx)($e9a7ce6542b46802$export$2e2bcd8739ae039.Item, Object.assign({}, a, {
        "data-value": t,
        children: r
    }));
};
$e58ef2470199210d$var$$5d0c8d8af5c3c7e5$export$36d18380658d5d20.displayName = "Option";
var $e58ef2470199210d$var$$5d0c8d8af5c3c7e5$export$ef9b1a59e592288f = function(e) {
    var t = e.className, r = e.style, a = e.variant, c = e.menuVariant, n = e.children, o = e.value, i = e.onChange, s = e.valueRender, l = (0, $0fd9d527cd0d1501$export$7b85fd78dd236198)(n).flat(1 / 0).find(function(e) {
        return (0, $dNU7X.isValidElement)(e) && e.type === $e58ef2470199210d$var$$5d0c8d8af5c3c7e5$export$36d18380658d5d20 && e.props.value === o;
    });
    return (0, $2111e08a92d70add$exports.jsxs)($e9a7ce6542b46802$export$2e2bcd8739ae039, {
        onClick: function(e) {
            var t = e.target.closest(".dropdown-item");
            if (t) {
                var r = t.dataset.value;
                null == i || i(r);
            }
        },
        children: [
            (0, $2111e08a92d70add$exports.jsx)($e9a7ce6542b46802$export$2e2bcd8739ae039.Toggle, {
                className: $e58ef2470199210d$var$$parcel$interopDefault($852a55cf17d8b19d$exports)("w-100", "d-flex", "justify-content-between", "align-items-center", !a && "bg-white text-dark", t),
                style: r,
                variant: a,
                children: (null == s ? void 0 : s(o)) || (0, $2111e08a92d70add$exports.jsx)("div", {
                    className: null == l ? void 0 : l.props.className,
                    children: null == l ? void 0 : l.props.children
                })
            }),
            (0, $2111e08a92d70add$exports.jsx)($e9a7ce6542b46802$export$2e2bcd8739ae039.Menu, {
                variant: c,
                children: n
            })
        ]
    });
};
$e58ef2470199210d$var$$5d0c8d8af5c3c7e5$export$ef9b1a59e592288f.displayName = "Select";
var $e58ef2470199210d$var$$5c7497f9f3fe6432$exports = {};
$e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$5c7497f9f3fe6432$exports, "elementToImage", function() {
    return $e58ef2470199210d$var$$5c7497f9f3fe6432$export$fefa3387c33a1dfc;
}), $e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$5c7497f9f3fe6432$exports, "ShareBox", function() {
    return $e58ef2470199210d$var$$5c7497f9f3fe6432$export$e15a265ebbd5ca8c;
});
var $e58ef2470199210d$var$$5c7497f9f3fe6432$var$__esDecorate = function(e, t, r, a, c, n) {
    function o(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(o(e || null));
        };
        var m = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = o(m.get)) && (u.get = i), (i = o(m.set)) && (u.set = i), (i = o(m.init)) && c.unshift(i);
        } else (i = o(m)) && ("field" === s ? c.unshift(i) : u[l] = i);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $e58ef2470199210d$var$$5c7497f9f3fe6432$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $e58ef2470199210d$var$$5c7497f9f3fe6432$var$__awaiter = function(e, t, r, a) {
    return new (r || (r = Promise))(function(c, n) {
        function o(e) {
            try {
                s(a.next(e));
            } catch (e) {
                n(e);
            }
        }
        function i(e) {
            try {
                s(a.throw(e));
            } catch (e) {
                n(e);
            }
        }
        function s(e) {
            var t;
            e.done ? c(e.value) : ((t = e.value) instanceof r ? t : new r(function(e) {
                e(t);
            })).then(o, i);
        }
        s((a = a.apply(e, t || [])).next());
    });
}, $e58ef2470199210d$var$$5c7497f9f3fe6432$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $e58ef2470199210d$var$$5c7497f9f3fe6432$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $e58ef2470199210d$var$$5c7497f9f3fe6432$var$__classPrivateFieldSet = function(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $e58ef2470199210d$var$$5c7497f9f3fe6432$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
};
function $e58ef2470199210d$var$$5c7497f9f3fe6432$export$fefa3387c33a1dfc(e, t, r) {
    return $e58ef2470199210d$var$$5c7497f9f3fe6432$var$__awaiter(this, void 0, void 0, function() {
        var a;
        return (0, $8fdeac7b23d8f90e$export$71511d61b312f219)(this, function(c) {
            switch(c.label){
                case 0:
                    return [
                        4,
                        $e58ef2470199210d$var$$parcel$interopDefault($799264a770627072$exports)(e, {
                            useCORS: !0
                        })
                    ];
                case 1:
                    return a = c.sent(), [
                        2,
                        new Promise(function(e, c) {
                            return a.toBlob(function(t) {
                                return t ? e(URL.createObjectURL(t)) : c();
                            }, t, r);
                        })
                    ];
            }
        });
    });
}
var $e58ef2470199210d$var$$5c7497f9f3fe6432$export$e15a265ebbd5ca8c = function() {
    var e, t, r, a, c, n, o, i, s = [
        $47a6458a96730da2$export$b6ae1bc530f4c149
    ], l = [], $ = $dNU7X.Component, u = [], d = [], f = [], p = [];
    return n = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, t), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(e, "root", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: (0, $dNU7X.createRef)()
            }), r.set(e, $e58ef2470199210d$var$$5c7497f9f3fe6432$var$__runInitializers(e, u, !1)), a.set(e, ($e58ef2470199210d$var$$5c7497f9f3fe6432$var$__runInitializers(e, d), $e58ef2470199210d$var$$5c7497f9f3fe6432$var$__runInitializers(e, f, ""))), Object.defineProperty(e, "generateImage", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($e58ef2470199210d$var$$5c7497f9f3fe6432$var$__runInitializers(e, p), function() {
                    return $e58ef2470199210d$var$$5c7497f9f3fe6432$var$__awaiter(e, void 0, void 0, function() {
                        var e;
                        return (0, $8fdeac7b23d8f90e$export$71511d61b312f219)(this, function(t) {
                            switch(t.label){
                                case 0:
                                    return this.imageURI && (URL.revokeObjectURL(this.imageURI), this.imageURI = ""), this.loading = !0, e = this, [
                                        4,
                                        $e58ef2470199210d$var$$5c7497f9f3fe6432$export$fefa3387c33a1dfc(this.root.current)
                                    ];
                                case 1:
                                    return e.imageURI = t.sent(), this.loading = !1, [
                                        2
                                    ];
                            }
                        });
                    });
                })
            }), Object.defineProperty(e, "share", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: function(t) {
                    return $e58ef2470199210d$var$$5c7497f9f3fe6432$var$__awaiter(e, void 0, void 0, function() {
                        var e, r, a;
                        return (0, $8fdeac7b23d8f90e$export$71511d61b312f219)(this, function(c) {
                            switch(c.label){
                                case 0:
                                    return t.stopPropagation(), [
                                        4,
                                        (0, $0fd9d527cd0d1501$export$fd89523fba250fa4)(this.imageURI)
                                    ];
                                case 1:
                                    return a = new File([
                                        r = c.sent()
                                    ], "".concat(this.props.title, ".png"), {
                                        type: r.type
                                    }), [
                                        4,
                                        null == (e = navigator.share) ? void 0 : e.call(navigator, Object.assign({
                                            files: [
                                                a
                                            ]
                                        }, this.props))
                                    ];
                                case 2:
                                    return c.sent(), [
                                        2
                                    ];
                            }
                        });
                    });
                }
            }), e;
        }
        return (0, $92f5157d74f7ea45$export$71511d61b312f219)(t, e), (0, $53cdca766716469e$export$71511d61b312f219)(t, [
            {
                key: "loading",
                get: function() {
                    return $e58ef2470199210d$var$$5c7497f9f3fe6432$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function(e) {
                    $e58ef2470199210d$var$$5c7497f9f3fe6432$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "imageURI",
                get: function() {
                    return $e58ef2470199210d$var$$5c7497f9f3fe6432$var$__classPrivateFieldGet(this, a, "f");
                },
                set: function(e) {
                    $e58ef2470199210d$var$$5c7497f9f3fe6432$var$__classPrivateFieldSet(this, a, e, "f");
                }
            },
            {
                key: "componentDidMount",
                value: function() {
                    var e;
                    null == (e = globalThis.addEventListener) || e.call(globalThis, "resize", this.generateImage);
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    var e;
                    null == (e = globalThis.removeEventListener) || e.call(globalThis, "resize", this.generateImage);
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.className, r = e.children, a = $e58ef2470199210d$var$$5c7497f9f3fe6432$var$__rest(e, [
                        "className",
                        "children"
                    ]), c = this.loading, n = this.imageURI;
                    return (0, $2111e08a92d70add$exports.jsxs)($2111e08a92d70add$exports.Fragment, {
                        children: [
                            c && (0, $2111e08a92d70add$exports.jsx)($e58ef2470199210d$var$$1f7252b8d0187295$export$669f6ea7d267feaf, {}),
                            (0, $2111e08a92d70add$exports.jsxs)("div", Object.assign({}, a, {
                                ref: this.root,
                                className: "position-relative ".concat(void 0 === t ? "" : t),
                                onMouseEnter: n ? void 0 : this.generateImage,
                                onTouchStart: n ? void 0 : this.generateImage,
                                children: [
                                    r,
                                    n && (0, $2111e08a92d70add$exports.jsx)($4f87183439e34fd8$export$2e2bcd8739ae039, {
                                        className: "position-absolute start-0 top-0 w-100 h-100",
                                        src: n,
                                        alt: "Share Image",
                                        fluid: !0,
                                        onClick: this.share
                                    })
                                ]
                            }))
                        ]
                    });
                }
            }
        ]), t;
    }($), r = new WeakMap, a = new WeakMap, $e58ef2470199210d$var$$5c7497f9f3fe6432$var$__setFunctionName(n, "ShareBox"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = $[Symbol.metadata]) ? e : null) : void 0, o = [
        $dZnzp.observable
    ], i = [
        $dZnzp.observable
    ], $e58ef2470199210d$var$$5c7497f9f3fe6432$var$__esDecorate(n, null, o, {
        kind: "accessor",
        name: "loading",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "loading" in e;
            },
            get: function(e) {
                return e.loading;
            },
            set: function(e, t) {
                e.loading = t;
            }
        },
        metadata: t
    }, u, d), $e58ef2470199210d$var$$5c7497f9f3fe6432$var$__esDecorate(n, null, i, {
        kind: "accessor",
        name: "imageURI",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "imageURI" in e;
            },
            get: function(e) {
                return e.imageURI;
            },
            set: function(e, t) {
                e.imageURI = t;
            }
        },
        metadata: t
    }, f, p), $e58ef2470199210d$var$$5c7497f9f3fe6432$var$__esDecorate(null, c = {
        value: n
    }, s, {
        kind: "class",
        name: n.name,
        metadata: t
    }, null, l), n = c.value, t && Object.defineProperty(n, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(n, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "ShareBox"
    }), $e58ef2470199210d$var$$5c7497f9f3fe6432$var$__runInitializers(n, l), n;
}(), $e58ef2470199210d$var$$ad4a2cea628613d5$exports = {};
$e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$ad4a2cea628613d5$exports, "SpinnerButton", function() {
    return $e58ef2470199210d$var$$ad4a2cea628613d5$export$4cfabf47f4311ebb;
});
var $e58ef2470199210d$var$$ad4a2cea628613d5$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $e58ef2470199210d$var$$ad4a2cea628613d5$export$4cfabf47f4311ebb = function(e) {
    var t = e.animation, r = e.loading, a = e.disabled, c = e.children, n = $e58ef2470199210d$var$$ad4a2cea628613d5$var$__rest(e, [
        "animation",
        "loading",
        "disabled",
        "children"
    ]);
    return (0, $2111e08a92d70add$exports.jsxs)($23c9a6bed94aa817$export$2e2bcd8739ae039, Object.assign({}, n, {
        disabled: r || a,
        children: [
            r && (0, $2111e08a92d70add$exports.jsxs)($2111e08a92d70add$exports.Fragment, {
                children: [
                    (0, $2111e08a92d70add$exports.jsx)($45f3ae5f1643f191$export$2e2bcd8739ae039, {
                        as: "span",
                        className: c ? "me-2" : "",
                        size: "sm",
                        animation: t,
                        role: "status",
                        "aria-hidden": "true"
                    }),
                    !c && (0, $2111e08a92d70add$exports.jsx)("span", {
                        className: "visually-hidden",
                        children: "Loading..."
                    })
                ]
            }),
            c
        ]
    }));
};
$e58ef2470199210d$var$$ad4a2cea628613d5$export$4cfabf47f4311ebb.displayName = "SpinnerButton";
var $e58ef2470199210d$var$$53fa7c21606566cb$exports = {};
$e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$53fa7c21606566cb$exports, "TableSpinner", function() {
    return $e58ef2470199210d$var$$53fa7c21606566cb$export$4706ba151aa92b7e;
});
var $e58ef2470199210d$var$$53fa7c21606566cb$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $e58ef2470199210d$var$$53fa7c21606566cb$export$4706ba151aa92b7e = function(e) {
    var t = e.animation, r = e.variant, a = e.size, c = e.colSpan, n = $e58ef2470199210d$var$$53fa7c21606566cb$var$__rest(e, [
        "animation",
        "variant",
        "size",
        "colSpan"
    ]);
    return (0, $2111e08a92d70add$exports.jsx)("tr", Object.assign({}, n, {
        children: (0, $2111e08a92d70add$exports.jsx)("td", {
            className: "text-center p-4",
            colSpan: c,
            children: (0, $2111e08a92d70add$exports.jsx)($45f3ae5f1643f191$export$2e2bcd8739ae039, {
                animation: void 0 === t ? "border" : t,
                variant: void 0 === r ? "primary" : r,
                size: a
            })
        })
    }));
};
$e58ef2470199210d$var$$53fa7c21606566cb$export$4706ba151aa92b7e.displayName = "TableSpinner";
var $e58ef2470199210d$var$$03c0468daff9422a$exports = {};
$e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$03c0468daff9422a$exports, "Time", function() {
    return $e58ef2470199210d$var$$03c0468daff9422a$export$680ea196effce5f;
});
var $e58ef2470199210d$var$$03c0468daff9422a$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $e58ef2470199210d$var$$03c0468daff9422a$export$680ea196effce5f = function(e) {
    var t = e.dateTime, r = e.format, a = $e58ef2470199210d$var$$03c0468daff9422a$var$__rest(e, [
        "dateTime",
        "format"
    ]);
    return (0, $2111e08a92d70add$exports.jsx)("time", Object.assign({
        dateTime: new Date(t).toJSON()
    }, a, {
        children: (0, $0fd9d527cd0d1501$export$3ae94a2503e890a1)(t, r)
    }));
}, $e58ef2470199210d$var$$2f5f9093a9aac8ee$exports = {};
$e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$2f5f9093a9aac8ee$exports, "TimeDistance", function() {
    return $e58ef2470199210d$var$$2f5f9093a9aac8ee$export$db3f63f9e19e5969;
});
var $e58ef2470199210d$var$$2f5f9093a9aac8ee$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $e58ef2470199210d$var$$2f5f9093a9aac8ee$var$UnitWords = {
    ms: "millisecond(s)",
    s: "second(s)",
    m: "minute(s)",
    H: "hour(s)",
    D: "day(s)",
    W: "week(s)",
    M: "month(s)",
    Y: "year(s)"
}, $e58ef2470199210d$var$$2f5f9093a9aac8ee$export$db3f63f9e19e5969 = function(e) {
    var t = e.date, r = e.unitWords, a = e.beforeWord, c = e.afterWord, n = $e58ef2470199210d$var$$2f5f9093a9aac8ee$var$__rest(e, [
        "date",
        "unitWords",
        "beforeWord",
        "afterWord"
    ]);
    t = new Date(t);
    var o = (0, $0fd9d527cd0d1501$export$506c8e8f8c8edda)(t), i = o.distance, s = o.unit;
    return (0, $2111e08a92d70add$exports.jsxs)("time", Object.assign({}, n, {
        dateTime: t.toJSON(),
        title: t.toLocaleString(),
        children: [
            Math.abs(i),
            " ",
            (void 0 === r ? $e58ef2470199210d$var$$2f5f9093a9aac8ee$var$UnitWords : r)[s],
            i < 0 ? void 0 === a ? " before" : a : void 0 === c ? " after" : c
        ]
    }));
};
$e58ef2470199210d$var$$2f5f9093a9aac8ee$export$db3f63f9e19e5969.displayName = "TimeDistance";
var $e58ef2470199210d$var$$31b55198d5058ded$exports = {};
$e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$31b55198d5058ded$exports, "Timeline", function() {
    return $e58ef2470199210d$var$$31b55198d5058ded$export$e6a97ba2cae5bb94;
}), $e58ef2470199210d$var$$4bfbcb67a3daf664$export$79ffe56a765070d2 = "TOztta_right", $e58ef2470199210d$var$$4bfbcb67a3daf664$export$cddc5598d4bb8461 = "TOztta_timeline", $e58ef2470199210d$var$$4bfbcb67a3daf664$export$73b7b5b52b6662d7 = "TOztta_timelineItem";
var $e58ef2470199210d$var$$31b55198d5058ded$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $e58ef2470199210d$var$$31b55198d5058ded$export$e6a97ba2cae5bb94 = function(e) {
    var t = e.className, r = e.events, a = e.timeFormat, c = $e58ef2470199210d$var$$31b55198d5058ded$var$__rest(e, [
        "className",
        "events",
        "timeFormat"
    ]);
    return (0, $2111e08a92d70add$exports.jsx)("ol", Object.assign({
        className: "list-unstyled ".concat($e58ef2470199210d$var$$4bfbcb67a3daf664$export$cddc5598d4bb8461, " ").concat(t)
    }, c, {
        children: r.map(function(e) {
            var t = e.title, r = e.summary, c = e.time, n = e.link, o = e.people;
            return (0, $2111e08a92d70add$exports.jsx)("li", {
                className: "position-relative ".concat($e58ef2470199210d$var$$4bfbcb67a3daf664$export$73b7b5b52b6662d7, " ").concat($e58ef2470199210d$var$$4bfbcb67a3daf664$export$79ffe56a765070d2),
                children: (0, $2111e08a92d70add$exports.jsx)($e391a96e81661736$export$2e2bcd8739ae039, {
                    children: (0, $2111e08a92d70add$exports.jsxs)($e391a96e81661736$export$2e2bcd8739ae039.Body, {
                        className: "p-4 d-flex flex-column gap-3 align-items-center",
                        children: [
                            (0, $2111e08a92d70add$exports.jsx)("h3", {
                                className: "h5 m-0",
                                children: (0, $2111e08a92d70add$exports.jsx)("a", {
                                    className: "text-decoration-none stretched-link",
                                    href: n,
                                    children: t
                                })
                            }),
                            (0, $2111e08a92d70add$exports.jsxs)("div", {
                                className: "small text-muted d-flex gap-2",
                                children: [
                                    "\u23F2\uFE0F",
                                    (0, $2111e08a92d70add$exports.jsx)($e58ef2470199210d$var$$03c0468daff9422a$export$680ea196effce5f, {
                                        dateTime: c[0],
                                        format: a
                                    }),
                                    c[1] && "~",
                                    c[1] && (0, $2111e08a92d70add$exports.jsx)($e58ef2470199210d$var$$03c0468daff9422a$export$680ea196effce5f, {
                                        dateTime: c[1],
                                        format: a
                                    })
                                ]
                            }),
                            (0, $2111e08a92d70add$exports.jsx)("ul", {
                                className: "list-unstyled m-0 d-flex gap-2 flex-wrap justify-content-around",
                                children: null == o ? void 0 : o.map(function(e) {
                                    return (0, $2111e08a92d70add$exports.jsx)("li", {
                                        children: (0, $2111e08a92d70add$exports.jsx)($e58ef2470199210d$var$$4f69bf8d62d4bac9$export$caa4d5435e8fb601, Object.assign({}, e))
                                    }, e.name);
                                })
                            }),
                            (0, $2111e08a92d70add$exports.jsx)("p", {
                                className: "m-0",
                                children: r
                            })
                        ]
                    })
                })
            }, t);
        })
    }));
};
$e58ef2470199210d$var$$31b55198d5058ded$export$e6a97ba2cae5bb94.displayName = "Timeline";
var $e58ef2470199210d$var$$f4c02b33c4295ca8$exports = {};
$e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$f4c02b33c4295ca8$exports, "TypeEcho", function() {
    return $e58ef2470199210d$var$$f4c02b33c4295ca8$export$2fe61c915a9818e6;
});
var $e58ef2470199210d$var$$f4c02b33c4295ca8$var$__esDecorate = function(e, t, r, a, c, n) {
    function o(e) {
        if (void 0 !== e && "function" != typeof e) throw TypeError("Function expected");
        return e;
    }
    for(var i, s = a.kind, l = "getter" === s ? "get" : "setter" === s ? "set" : "value", $ = !t && e ? a.static ? e : e.prototype : null, u = t || ($ ? Object.getOwnPropertyDescriptor($, a.name) : {}), d = !1, f = r.length - 1; f >= 0; f--){
        var p = {};
        for(var b in a)p[b] = "access" === b ? {} : a[b];
        for(var b in a.access)p.access[b] = a.access[b];
        p.addInitializer = function(e) {
            if (d) throw TypeError("Cannot add initializers after decoration has completed");
            n.push(o(e || null));
        };
        var m = (0, r[f])("accessor" === s ? {
            get: u.get,
            set: u.set
        } : u[l], p);
        if ("accessor" === s) {
            if (void 0 === m) continue;
            if (null === m || (void 0 === m ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(m)) !== "object") throw TypeError("Object expected");
            (i = o(m.get)) && (u.get = i), (i = o(m.set)) && (u.set = i), (i = o(m.init)) && c.unshift(i);
        } else (i = o(m)) && ("field" === s ? c.unshift(i) : u[l] = i);
    }
    $ && Object.defineProperty($, a.name, u), d = !0;
}, $e58ef2470199210d$var$$f4c02b33c4295ca8$var$__runInitializers = function(e, t, r) {
    for(var a = arguments.length > 2, c = 0; c < t.length; c++)r = a ? t[c].call(e, r) : t[c].call(e);
    return a ? r : void 0;
}, $e58ef2470199210d$var$$f4c02b33c4295ca8$var$__awaiter = function(e, t, r, a) {
    return new (r || (r = Promise))(function(c, n) {
        function o(e) {
            try {
                s(a.next(e));
            } catch (e) {
                n(e);
            }
        }
        function i(e) {
            try {
                s(a.throw(e));
            } catch (e) {
                n(e);
            }
        }
        function s(e) {
            var t;
            e.done ? c(e.value) : ((t = e.value) instanceof r ? t : new r(function(e) {
                e(t);
            })).then(o, i);
        }
        s((a = a.apply(e, t || [])).next());
    });
}, $e58ef2470199210d$var$$f4c02b33c4295ca8$var$__setFunctionName = function(e, t, r) {
    return (void 0 === t ? "undefined" : (0, $35f6c23f56aaf458$export$71511d61b312f219)(t)) === "symbol" && (t = t.description ? "[".concat(t.description, "]") : ""), Object.defineProperty(e, "name", {
        configurable: !0,
        value: r ? "".concat(r, " ", t) : t
    });
}, $e58ef2470199210d$var$$f4c02b33c4295ca8$var$__classPrivateFieldGet = function(e, t, r, a) {
    if ("a" === r && !a) throw TypeError("Private accessor was defined without a getter");
    if ("function" == typeof t ? e !== t || !a : !t.has(e)) throw TypeError("Cannot read private member from an object whose class did not declare it");
    return "m" === r ? a : "a" === r ? a.call(e) : a ? a.value : t.get(e);
}, $e58ef2470199210d$var$$f4c02b33c4295ca8$var$__classPrivateFieldSet = function(e, t, r, a, c) {
    if ("m" === a) throw TypeError("Private method is not writable");
    if ("a" === a && !c) throw TypeError("Private accessor was defined without a setter");
    if ("function" == typeof t ? e !== t || !c : !t.has(e)) throw TypeError("Cannot write private member to an object whose class did not declare it");
    return "a" === a ? c.call(e, r) : c ? c.value = r : t.set(e, r), r;
}, $e58ef2470199210d$var$$f4c02b33c4295ca8$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $e58ef2470199210d$var$$f4c02b33c4295ca8$export$2fe61c915a9818e6 = function() {
    var e, t, r, a, c, n = [
        $47a6458a96730da2$export$b6ae1bc530f4c149
    ], o = [], i = $dNU7X.Component, s = [], l = [];
    return c = function(e) {
        "use strict";
        function t() {
            var e;
            return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, t), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, t, arguments), r.set(e, $e58ef2470199210d$var$$f4c02b33c4295ca8$var$__runInitializers(e, s, "")), Object.defineProperty(e, "init", {
                enumerable: !0,
                configurable: !0,
                writable: !0,
                value: ($e58ef2470199210d$var$$f4c02b33c4295ca8$var$__runInitializers(e, l), function(t) {
                    return t && new IntersectionObserver(function(t, r) {
                        return $e58ef2470199210d$var$$f4c02b33c4295ca8$var$__awaiter(e, [
                            t,
                            r
                        ], void 0, function(e, t) {
                            var r, a, c, n, o, i, s, l, $, u, d;
                            return (0, $8fdeac7b23d8f90e$export$71511d61b312f219)(this, function(f) {
                                switch(f.label){
                                    case 0:
                                        if (!(0, $44015290ab5c0623$export$71511d61b312f219)(e, 1)[0].isIntersecting) return [
                                            2
                                        ];
                                        t.disconnect(), a = (r = this.props).text, n = void 0 === (c = r.intervals) ? 150 : c, o = !0, i = !1, s = void 0, f.label = 1;
                                    case 1:
                                        f.trys.push([
                                            1,
                                            6,
                                            7,
                                            8
                                        ]), l = a[Symbol.iterator](), f.label = 2;
                                    case 2:
                                        if (o = ($ = l.next()).done) return [
                                            3,
                                            5
                                        ];
                                        return u = $.value, [
                                            4,
                                            (0, $0fd9d527cd0d1501$export$e772c8ff12451969)(n / 1e3)
                                        ];
                                    case 3:
                                        f.sent(), this.echoed += u, f.label = 4;
                                    case 4:
                                        return o = !0, [
                                            3,
                                            2
                                        ];
                                    case 5:
                                        return [
                                            3,
                                            8
                                        ];
                                    case 6:
                                        return d = f.sent(), i = !0, s = d, [
                                            3,
                                            8
                                        ];
                                    case 7:
                                        try {
                                            o || null == l.return || l.return();
                                        } finally{
                                            if (i) throw s;
                                        }
                                        return [
                                            7
                                        ];
                                    case 8:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }).observe(t);
                })
            }), e;
        }
        return (0, $92f5157d74f7ea45$export$71511d61b312f219)(t, e), (0, $53cdca766716469e$export$71511d61b312f219)(t, [
            {
                key: "echoed",
                get: function() {
                    return $e58ef2470199210d$var$$f4c02b33c4295ca8$var$__classPrivateFieldGet(this, r, "f");
                },
                set: function(e) {
                    $e58ef2470199210d$var$$f4c02b33c4295ca8$var$__classPrivateFieldSet(this, r, e, "f");
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.className, r = e.text, a = $e58ef2470199210d$var$$f4c02b33c4295ca8$var$__rest(e, [
                        "className",
                        "text"
                    ]), c = this.echoed;
                    return (0, $2111e08a92d70add$exports.jsx)("pre", Object.assign({}, a, {
                        ref: this.init,
                        className: $e58ef2470199210d$var$$parcel$interopDefault($852a55cf17d8b19d$exports)("text-wrap", t),
                        children: c + (c === r ? "" : "_")
                    }));
                }
            }
        ]), t;
    }(i), r = new WeakMap, $e58ef2470199210d$var$$f4c02b33c4295ca8$var$__setFunctionName(c, "TypeEcho"), t = "function" == typeof Symbol && Symbol.metadata ? Object.create(null != (e = i[Symbol.metadata]) ? e : null) : void 0, $e58ef2470199210d$var$$f4c02b33c4295ca8$var$__esDecorate(c, null, [
        $dZnzp.observable
    ], {
        kind: "accessor",
        name: "echoed",
        static: !1,
        private: !1,
        access: {
            has: function(e) {
                return "echoed" in e;
            },
            get: function(e) {
                return e.echoed;
            },
            set: function(e, t) {
                e.echoed = t;
            }
        },
        metadata: t
    }, s, l), $e58ef2470199210d$var$$f4c02b33c4295ca8$var$__esDecorate(null, a = {
        value: c
    }, n, {
        kind: "class",
        name: c.name,
        metadata: t
    }, null, o), c = a.value, t && Object.defineProperty(c, Symbol.metadata, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: t
    }), Object.defineProperty(c, "displayName", {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: "TypeEcho"
    }), $e58ef2470199210d$var$$f4c02b33c4295ca8$var$__runInitializers(c, o), c;
}(), $e58ef2470199210d$var$$77dc12b8e0b9d622$exports = {};
$e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$77dc12b8e0b9d622$exports, "UserRankView", function() {
    return $e58ef2470199210d$var$$77dc12b8e0b9d622$export$4ed039229ec81818;
});
var $e58ef2470199210d$var$$c5da9bad1903a67d$export$5f821f795e2d2901 = function(e) {
    var t = e.email, r = e.website;
    return (0, $2111e08a92d70add$exports.jsxs)("address", {
        className: "mb-0 d-flex justify-content-around gap-2",
        children: [
            t && (0, $2111e08a92d70add$exports.jsx)("a", {
                rel: "noreferrer",
                target: "_blank",
                href: "mailto:" + t,
                children: (0, $2111e08a92d70add$exports.jsx)($e58ef2470199210d$var$$cf5cdc2ffed4bc45$export$f04a61298a47a40f, {
                    name: "envelope"
                })
            }),
            r && (0, $2111e08a92d70add$exports.jsx)("a", {
                rel: "noreferrer",
                target: "_blank",
                href: r,
                children: (0, $2111e08a92d70add$exports.jsx)($e58ef2470199210d$var$$cf5cdc2ffed4bc45$export$f04a61298a47a40f, {
                    name: "globe2"
                })
            })
        ]
    });
};
$e58ef2470199210d$var$$7d37db9df1578ff2$export$5c452ff88e35e47d = "WavURG_image", $e58ef2470199210d$var$$7d37db9df1578ff2$export$30d389775d7a0f3c = "WavURG_medal", $e58ef2470199210d$var$$7d37db9df1578ff2$export$a8ff84c12d48cfa6 = "WavURG_name", $e58ef2470199210d$var$$7d37db9df1578ff2$export$896c314ae37c4db9 = "WavURG_rankBox", $e58ef2470199210d$var$$7d37db9df1578ff2$export$717db1a952ac2d26 = "WavURG_restUsers", $e58ef2470199210d$var$$7d37db9df1578ff2$export$74fdf2685172213b = "WavURG_suspension", $e58ef2470199210d$var$$7d37db9df1578ff2$export$fb184b623420d9be = "WavURG_title", $e58ef2470199210d$var$$7d37db9df1578ff2$export$ec176431609ba4c9 = "WavURG_topUser", $e58ef2470199210d$var$$7d37db9df1578ff2$export$ea7c3e02973c1d5b = "WavURG_topUsers";
var $e58ef2470199210d$var$$77dc12b8e0b9d622$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $e58ef2470199210d$var$$77dc12b8e0b9d622$export$4ed039229ec81818 = function(e) {
    "use strict";
    function t() {
        var e;
        return (0, $2b3af368dbb30b38$export$71511d61b312f219)(this, t), e = (0, $95518c9e748840bb$export$71511d61b312f219)(this, t, arguments), Object.defineProperty(e, "renderMedal", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: function(t) {
                var r, a;
                return (0, $2111e08a92d70add$exports.jsxs)($786b27ba1fa4676b$export$2e2bcd8739ae039, {
                    as: "li",
                    children: [
                        (0, $2111e08a92d70add$exports.jsx)("div", {
                            className: "shadow-lg overflow-hidden rounded-circle m-auto ".concat($e58ef2470199210d$var$$7d37db9df1578ff2$export$5c452ff88e35e47d),
                            children: (0, $2111e08a92d70add$exports.jsx)($4f87183439e34fd8$export$2e2bcd8739ae039, {
                                src: t.avatar,
                                alt: t.name,
                                loading: "lazy",
                                fluid: !0
                            })
                        }),
                        (0, $2111e08a92d70add$exports.jsxs)("div", {
                            className: "position-relative overflow-hidden ".concat($e58ef2470199210d$var$$7d37db9df1578ff2$export$ec176431609ba4c9),
                            children: [
                                (0, $2111e08a92d70add$exports.jsxs)("div", {
                                    className: "position-relative",
                                    children: [
                                        (0, $2111e08a92d70add$exports.jsx)("i", {
                                            className: "d-block overflow-hidden m-auto mb-1 rounded-circle"
                                        }),
                                        (0, $2111e08a92d70add$exports.jsx)("a", {
                                            className: "d-block mb-0 stretched-link",
                                            href: (null == (a = (r = e.props).linkOf) ? void 0 : a.call(r, t)) || "#",
                                            children: t.name
                                        }),
                                        (0, $2111e08a92d70add$exports.jsx)("strong", {
                                            children: t.score
                                        })
                                    ]
                                }),
                                (0, $2111e08a92d70add$exports.jsx)($e58ef2470199210d$var$$c5da9bad1903a67d$export$5f821f795e2d2901, Object.assign({}, t))
                            ]
                        })
                    ]
                }, t.id);
            }
        }), Object.defineProperty(e, "renderRow", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: function(t, r, a) {
                var c, n, o = a.length;
                return (0, $2111e08a92d70add$exports.jsxs)("tr", {
                    className: "position-relative",
                    children: [
                        (0, $2111e08a92d70add$exports.jsx)("td", {
                            className: "align-middle",
                            children: (0, $2111e08a92d70add$exports.jsx)($7309943aa9afa2d4$export$2e2bcd8739ae039, {
                                className: "fw-bold fst-italic",
                                children: (r + 4 + "").padStart((o + "").length, "0")
                            })
                        }),
                        (0, $2111e08a92d70add$exports.jsxs)("td", {
                            className: "position-relative mw-50 text-truncate ".concat($e58ef2470199210d$var$$7d37db9df1578ff2$export$a8ff84c12d48cfa6),
                            children: [
                                (0, $2111e08a92d70add$exports.jsx)("div", {
                                    className: "d-inline-block overflow-hidden align-middle rounded-circle ".concat($e58ef2470199210d$var$$7d37db9df1578ff2$export$5c452ff88e35e47d),
                                    children: (0, $2111e08a92d70add$exports.jsx)($4f87183439e34fd8$export$2e2bcd8739ae039, {
                                        src: t.avatar,
                                        alt: t.name,
                                        loading: "lazy",
                                        fluid: !0
                                    })
                                }),
                                (0, $2111e08a92d70add$exports.jsx)("a", {
                                    className: "ms-2 d-inline-block align-middle stretched-link",
                                    style: {
                                        color: "rgb(248, ".concat((r + 2) * 15, ", ").concat((r + 2) * 35, ")")
                                    },
                                    href: (null == (n = (c = e.props).linkOf) ? void 0 : n.call(c, t)) || "#",
                                    children: t.name
                                })
                            ]
                        }),
                        (0, $2111e08a92d70add$exports.jsx)("td", {
                            className: "align-middle",
                            children: t.score
                        }),
                        (0, $2111e08a92d70add$exports.jsx)("td", {
                            className: "align-middle",
                            children: (0, $2111e08a92d70add$exports.jsx)($e58ef2470199210d$var$$c5da9bad1903a67d$export$5f821f795e2d2901, Object.assign({}, t))
                        })
                    ]
                }, t.id);
            }
        }), e;
    }
    return (0, $92f5157d74f7ea45$export$71511d61b312f219)(t, e), (0, $53cdca766716469e$export$71511d61b312f219)(t, [
        {
            key: "render",
            value: function() {
                var e = this.props, t = e.className, r = e.title, a = e.rank, c = void 0 === a ? [] : a, n = (e.linkOf, $e58ef2470199210d$var$$77dc12b8e0b9d622$var$__rest(e, [
                    "className",
                    "title",
                    "rank",
                    "linkOf"
                ]));
                return (0, $2111e08a92d70add$exports.jsxs)($39d0d74bdb7b93e7$export$2e2bcd8739ae039, Object.assign({
                    className: "".concat($e58ef2470199210d$var$$7d37db9df1578ff2$export$896c314ae37c4db9, " ").concat(void 0 === t ? "" : t)
                }, n, {
                    children: [
                        (0, $2111e08a92d70add$exports.jsxs)($786b27ba1fa4676b$export$2e2bcd8739ae039, {
                            sm: 12,
                            xs: 12,
                            lg: 7,
                            children: [
                                (0, $2111e08a92d70add$exports.jsxs)("div", {
                                    className: "shadow rounded-3 ".concat($e58ef2470199210d$var$$7d37db9df1578ff2$export$fb184b623420d9be),
                                    children: [
                                        (0, $2111e08a92d70add$exports.jsxs)("div", {
                                            className: $e58ef2470199210d$var$$7d37db9df1578ff2$export$30d389775d7a0f3c,
                                            children: [
                                                (0, $2111e08a92d70add$exports.jsx)("i", {
                                                    className: "d-inline-block ms-1 overflow-hidden rounded-circle"
                                                }),
                                                (0, $2111e08a92d70add$exports.jsx)("i", {
                                                    className: "d-inline-block ms-1 overflow-hidden rounded-circle"
                                                }),
                                                (0, $2111e08a92d70add$exports.jsx)("i", {
                                                    className: "d-inline-block ms-1 overflow-hidden rounded-circle"
                                                })
                                            ]
                                        }),
                                        (0, $2111e08a92d70add$exports.jsx)("h3", {
                                            "data-text": r,
                                            className: "position-relative m-auto mb-0 fw-bold text-center",
                                            children: r
                                        })
                                    ]
                                }),
                                (0, $2111e08a92d70add$exports.jsx)($39d0d74bdb7b93e7$export$2e2bcd8739ae039, {
                                    as: "ul",
                                    className: "mt-2 g-0 align-items-end text-center ps-0 pt-2 list-unstyled ".concat($e58ef2470199210d$var$$7d37db9df1578ff2$export$ea7c3e02973c1d5b),
                                    children: c.slice(0, 3).map(this.renderMedal)
                                })
                            ]
                        }),
                        (0, $2111e08a92d70add$exports.jsx)($786b27ba1fa4676b$export$2e2bcd8739ae039, {
                            xs: 12,
                            sm: 12,
                            lg: 5,
                            children: (0, $2111e08a92d70add$exports.jsx)($8a4db44e7eb3b880$export$2e2bcd8739ae039, {
                                className: "my-3 pt-2 ".concat($e58ef2470199210d$var$$7d37db9df1578ff2$export$717db1a952ac2d26),
                                responsive: !0,
                                children: (0, $2111e08a92d70add$exports.jsx)("tbody", {
                                    children: c.slice(3, 10).map(this.renderRow)
                                })
                            })
                        })
                    ]
                }));
            }
        }
    ]), t;
}($dNU7X.PureComponent);
Object.defineProperty($e58ef2470199210d$var$$77dc12b8e0b9d622$export$4ed039229ec81818, "displayName", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "UserRankView"
});
var $e58ef2470199210d$var$$42613c749094b4e3$exports = {};
$e58ef2470199210d$var$$parcel$export($e58ef2470199210d$var$$42613c749094b4e3$exports, "VerticalMarquee", function() {
    return $e58ef2470199210d$var$$42613c749094b4e3$export$125576d08e40b98f;
}), $e58ef2470199210d$var$$c628d4ba96623bb8$export$1a22ace05a045e3f = "QSMqAq_scrollItem", $e58ef2470199210d$var$$c628d4ba96623bb8$export$c7aa240077ad8340 = "QSMqAq_scrollWrap";
var $e58ef2470199210d$var$$42613c749094b4e3$var$__rest = function(e, t) {
    var r = {};
    for(var a in e)Object.prototype.hasOwnProperty.call(e, a) && 0 > t.indexOf(a) && (r[a] = e[a]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) for(var c = 0, a = Object.getOwnPropertySymbols(e); c < a.length; c++)0 > t.indexOf(a[c]) && Object.prototype.propertyIsEnumerable.call(e, a[c]) && (r[a[c]] = e[a[c]]);
    return r;
}, $e58ef2470199210d$var$$42613c749094b4e3$export$125576d08e40b98f = function(e) {
    var t = e.className, r = e.children, a = e.duration, c = $e58ef2470199210d$var$$42613c749094b4e3$var$__rest(e, [
        "className",
        "children",
        "duration"
    ]);
    return (0, $2111e08a92d70add$exports.jsx)("div", Object.assign({
        className: "overflow-hidden ".concat(void 0 === t ? "" : t)
    }, c, {
        children: (0, $2111e08a92d70add$exports.jsx)("div", {
            className: "d-inline-block mw-100 mh-100 ".concat($e58ef2470199210d$var$$c628d4ba96623bb8$export$c7aa240077ad8340),
            style: {
                "--duration": a
            },
            children: (0, $2111e08a92d70add$exports.jsx)("div", {
                className: "d-inline-block ".concat($e58ef2470199210d$var$$c628d4ba96623bb8$export$1a22ace05a045e3f),
                children: r
            })
        })
    }));
};
$e58ef2470199210d$var$$42613c749094b4e3$export$125576d08e40b98f.displayName = "VerticalMarquee", $e58ef2470199210d$var$$parcel$exportWildcard($e58ef2470199210d$exports, $e58ef2470199210d$var$$fd019656019bb4f3$exports), $e58ef2470199210d$var$$parcel$exportWildcard($e58ef2470199210d$exports, $e58ef2470199210d$var$$757747c0209676cc$exports), $e58ef2470199210d$var$$parcel$exportWildcard($e58ef2470199210d$exports, $e58ef2470199210d$var$$a40a1c3d6dc84a7a$exports), $e58ef2470199210d$var$$parcel$exportWildcard($e58ef2470199210d$exports, $e58ef2470199210d$var$$89fa9a64cf869995$exports), $e58ef2470199210d$var$$parcel$exportWildcard($e58ef2470199210d$exports, $e58ef2470199210d$var$$924d73683971f901$exports), $e58ef2470199210d$var$$parcel$exportWildcard($e58ef2470199210d$exports, $e58ef2470199210d$var$$e308f4ff6755d29b$exports), $e58ef2470199210d$var$$parcel$exportWildcard($e58ef2470199210d$exports, $e58ef2470199210d$var$$68aab1d0e8e5016c$exports), $e58ef2470199210d$var$$parcel$exportWildcard($e58ef2470199210d$exports, $e58ef2470199210d$var$$db3d9d99c159855a$exports), $e58ef2470199210d$var$$parcel$exportWildcard($e58ef2470199210d$exports, $e58ef2470199210d$var$$e400f030e8cea549$exports), $e58ef2470199210d$var$$parcel$exportWildcard($e58ef2470199210d$exports, $e58ef2470199210d$var$$cf5cdc2ffed4bc45$exports), $e58ef2470199210d$var$$parcel$exportWildcard($e58ef2470199210d$exports, $e58ef2470199210d$var$$1f7252b8d0187295$exports), $e58ef2470199210d$var$$parcel$exportWildcard($e58ef2470199210d$exports, $e58ef2470199210d$var$$ec6e3ccd45c7b7c0$exports), $e58ef2470199210d$var$$parcel$exportWildcard($e58ef2470199210d$exports, $e58ef2470199210d$var$$4f69bf8d62d4bac9$exports), $e58ef2470199210d$var$$parcel$exportWildcard($e58ef2470199210d$exports, $e58ef2470199210d$var$$a121893c5bead7fc$exports), $e58ef2470199210d$var$$parcel$exportWildcard($e58ef2470199210d$exports, $e58ef2470199210d$var$$d78fd73e1713e936$exports), $e58ef2470199210d$var$$parcel$exportWildcard($e58ef2470199210d$exports, $e58ef2470199210d$var$$5d0c8d8af5c3c7e5$exports), $e58ef2470199210d$var$$parcel$exportWildcard($e58ef2470199210d$exports, $e58ef2470199210d$var$$5c7497f9f3fe6432$exports), $e58ef2470199210d$var$$parcel$exportWildcard($e58ef2470199210d$exports, $e58ef2470199210d$var$$ad4a2cea628613d5$exports), $e58ef2470199210d$var$$parcel$exportWildcard($e58ef2470199210d$exports, $e58ef2470199210d$var$$53fa7c21606566cb$exports), $e58ef2470199210d$var$$parcel$exportWildcard($e58ef2470199210d$exports, $e58ef2470199210d$var$$03c0468daff9422a$exports), $e58ef2470199210d$var$$parcel$exportWildcard($e58ef2470199210d$exports, $e58ef2470199210d$var$$2f5f9093a9aac8ee$exports), $e58ef2470199210d$var$$parcel$exportWildcard($e58ef2470199210d$exports, $e58ef2470199210d$var$$31b55198d5058ded$exports), $e58ef2470199210d$var$$parcel$exportWildcard($e58ef2470199210d$exports, $e58ef2470199210d$var$$f4c02b33c4295ca8$exports), $e58ef2470199210d$var$$parcel$exportWildcard($e58ef2470199210d$exports, $e58ef2470199210d$var$$77dc12b8e0b9d622$exports), $e58ef2470199210d$var$$parcel$exportWildcard($e58ef2470199210d$exports, $e58ef2470199210d$var$$42613c749094b4e3$exports); //# sourceMappingURL=index.js.map



var $dZnzp = parcelRequire("dZnzp");


var $dNU7X = parcelRequire("dNU7X");



var $dNU7X = parcelRequire("dNU7X");



/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $b2203e4764c4f8d8$var$createChainedFunction(...funcs) {
    return funcs.filter((f)=>f != null).reduce((acc, f)=>{
        if (typeof f !== 'function') throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
        if (acc === null) return f;
        return function chainedFunction(...args) {
            // @ts-expect-error ignore "this" error
            acc.apply(this, args);
            // @ts-expect-error ignore "this" error
            f.apply(this, args);
        };
    }, null);
}
var $b2203e4764c4f8d8$export$2e2bcd8739ae039 = $b2203e4764c4f8d8$var$createChainedFunction;





const $ce9fafedfe9434a4$var$MARGINS = {
    height: [
        'marginTop',
        'marginBottom'
    ],
    width: [
        'marginLeft',
        'marginRight'
    ]
};
function $ce9fafedfe9434a4$var$getDefaultDimensionValue(dimension, elem) {
    const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
    const value = elem[offset];
    const margins = $ce9fafedfe9434a4$var$MARGINS[dimension];
    return value + // @ts-expect-error TODO
    parseInt((0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(elem, margins[0]), 10) + // @ts-expect-error TODO
    parseInt((0, $8e0039237f2a8b13$export$2e2bcd8739ae039)(elem, margins[1]), 10);
}
const $ce9fafedfe9434a4$var$collapseStyles = {
    [(0, $fa3810d37f821d51$export$84cbff306f539230)]: 'collapse',
    [(0, $fa3810d37f821d51$export$4aacc83d4d59139f)]: 'collapsing',
    [(0, $fa3810d37f821d51$export$df38205c966be359)]: 'collapsing',
    [(0, $fa3810d37f821d51$export$78e9e6e3e014d60a)]: 'collapse show'
};
const $ce9fafedfe9434a4$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, className: className, children: children, dimension: dimension = 'height', in: inProp = false, timeout: timeout = 300, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, getDimensionValue: getDimensionValue = $ce9fafedfe9434a4$var$getDefaultDimensionValue, ...props }, ref)=>{
    /* Compute dimension */ const computedDimension = typeof dimension === 'function' ? dimension() : dimension;
    /* -- Expanding -- */ const handleEnter = (0, $dNU7X.useMemo)(()=>(0, $b2203e4764c4f8d8$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = '0';
        }, onEnter), [
        computedDimension,
        onEnter
    ]);
    const handleEntering = (0, $dNU7X.useMemo)(()=>(0, $b2203e4764c4f8d8$export$2e2bcd8739ae039)((elem)=>{
            const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
            elem.style[computedDimension] = `${elem[scroll]}px`;
        }, onEntering), [
        computedDimension,
        onEntering
    ]);
    const handleEntered = (0, $dNU7X.useMemo)(()=>(0, $b2203e4764c4f8d8$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onEntered), [
        computedDimension,
        onEntered
    ]);
    /* -- Collapsing -- */ const handleExit = (0, $dNU7X.useMemo)(()=>(0, $b2203e4764c4f8d8$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
            (0, $e830fdd71fd78692$export$2e2bcd8739ae039)(elem);
        }, onExit), [
        onExit,
        getDimensionValue,
        computedDimension
    ]);
    const handleExiting = (0, $dNU7X.useMemo)(()=>(0, $b2203e4764c4f8d8$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onExiting), [
        computedDimension,
        onExiting
    ]);
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)((0, $c8ab7d3c44949da1$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $6d550b7bb419a543$export$2e2bcd8739ae039),
        ...props,
        "aria-expanded": props.role ? inProp : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        childRef: (0, $c3e2c43133c47cee$export$87943f2672146d57)(children),
        in: inProp,
        timeout: timeout,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        children: (state, innerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, children.props.className, $ce9fafedfe9434a4$var$collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
            })
    });
});
$ce9fafedfe9434a4$var$Collapse.displayName = 'Collapse';
var $ce9fafedfe9434a4$export$2e2bcd8739ae039 = $ce9fafedfe9434a4$var$Collapse;



var $dNU7X = parcelRequire("dNU7X");


"use client";
const $1c1e49137edd774f$var$Container = /*#__PURE__*/ $dNU7X.forwardRef(({ bsPrefix: bsPrefix, fluid: fluid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className: className, ...props }, ref)=>{
    const prefix = (0, $4843567570d88909$export$7f387860ebffb32c)(bsPrefix, 'container');
    const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
    return /*#__PURE__*/ (0, $2111e08a92d70add$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($852a55cf17d8b19d$exports)))(className, fluid ? `${prefix}${suffix}` : prefix)
    });
});
$1c1e49137edd774f$var$Container.displayName = 'Container';
var $1c1e49137edd774f$export$2e2bcd8739ae039 = $1c1e49137edd774f$var$Container;


var $3d2450ff1707eb5a$exports = {};
'use strict';
function $3d2450ff1707eb5a$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($3d2450ff1707eb5a$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$3d2450ff1707eb5a$var$checkDCE();

$3d2450ff1707eb5a$exports = (parcelRequire("lnmxF"));




var $dNU7X = parcelRequire("dNU7X");

var $dNU7X = parcelRequire("dNU7X");
const $62e7d3e4bbb57c5d$export$b8efcc4bff45e15b = 1;
function $62e7d3e4bbb57c5d$export$fb237fa819e17281(map) {
    return Object.freeze({
        __version: $62e7d3e4bbb57c5d$export$b8efcc4bff45e15b,
        map: map
    });
}
function $62e7d3e4bbb57c5d$export$9efaf186a2224858(source, extra) {
    return Object.freeze({
        ...source,
        ...extra
    });
}
const $62e7d3e4bbb57c5d$export$7de1b54b0142048f = (0, $dNU7X.createContext)(null);
function $62e7d3e4bbb57c5d$export$ea59151b8430a4e9() {
    const context = (0, $dNU7X.use)($62e7d3e4bbb57c5d$export$7de1b54b0142048f);
    if (context == null) throw new Error('No context provided: useLeafletContext() can only be used in a descendant of <MapContainer>');
    return context;
}



var $dNU7X = parcelRequire("dNU7X");
function $7a431aeadd23a524$export$86f8f9f08863e403() {
    return (0, $62e7d3e4bbb57c5d$export$ea59151b8430a4e9)().map;
}
function $7a431aeadd23a524$export$4c2959913f5c7962(type, handler) {
    const map = $7a431aeadd23a524$export$86f8f9f08863e403();
    (0, $dNU7X.useEffect)(function addMapEventHandler() {
        // @ts-ignore event type
        map.on(type, handler);
        return function removeMapEventHandler() {
            // @ts-ignore event type
            map.off(type, handler);
        };
    }, [
        map,
        type,
        handler
    ]);
    return map;
}
function $7a431aeadd23a524$export$1c51e2c234152172(handlers) {
    const map = $7a431aeadd23a524$export$86f8f9f08863e403();
    (0, $dNU7X.useEffect)(function addMapEventHandlers() {
        map.on(handlers);
        return function removeMapEventHandlers() {
            map.off(handlers);
        };
    }, [
        map,
        handlers
    ]);
    return map;
}


const $b297976844a4920d$export$6d3281b2ea2b0e13 = ({ mapRef: mapRef })=>{
    const map = (0, $7a431aeadd23a524$export$86f8f9f08863e403)();
    (0, $dNU7X.useEffect)(()=>{
        mapRef(map);
    }, [
        map
    ]);
    return (0, $2111e08a92d70add$exports.jsx)((0, $2111e08a92d70add$exports.Fragment), {});
};
$b297976844a4920d$export$6d3281b2ea2b0e13.displayName = 'MapExposer';




var $dNU7X = parcelRequire("dNU7X");
var $8f39e28756ef9331$exports = {};
/* @preserve
 * Leaflet 1.9.4, a JS library for interactive maps. https://leafletjs.com
 * (c) 2010-2023 Vladimir Agafonkin, (c) 2010-2011 CloudMade
 */ (function(global, factory) {
    factory($8f39e28756ef9331$exports);
})($8f39e28756ef9331$exports, function(exports1) {
    'use strict';
    var version = "1.9.4";
    /*
   * @namespace Util
   *
   * Various utility functions, used by Leaflet internally.
   */ // @function extend(dest: Object, src?: Object): Object
    // Merges the properties of the `src` object (or multiple objects) into `dest` object and returns the latter. Has an `L.extend` shortcut.
    function extend(dest) {
        var i, j, len, src;
        for(j = 1, len = arguments.length; j < len; j++){
            src = arguments[j];
            for(i in src)dest[i] = src[i];
        }
        return dest;
    }
    // @function create(proto: Object, properties?: Object): Object
    // Compatibility polyfill for [Object.create](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/create)
    var create$2 = Object.create || function() {
        function F() {}
        return function(proto) {
            F.prototype = proto;
            return new F();
        };
    }();
    // @function bind(fn: Function, …): Function
    // Returns a new function bound to the arguments passed, like [Function.prototype.bind](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
    // Has a `L.bind()` shortcut.
    function bind(fn, obj) {
        var slice = Array.prototype.slice;
        if (fn.bind) return fn.bind.apply(fn, slice.call(arguments, 1));
        var args = slice.call(arguments, 2);
        return function() {
            return fn.apply(obj, args.length ? args.concat(slice.call(arguments)) : arguments);
        };
    }
    // @property lastId: Number
    // Last unique ID used by [`stamp()`](#util-stamp)
    var lastId = 0;
    // @function stamp(obj: Object): Number
    // Returns the unique ID of an object, assigning it one if it doesn't have it.
    function stamp(obj) {
        if (!('_leaflet_id' in obj)) obj['_leaflet_id'] = ++lastId;
        return obj._leaflet_id;
    }
    // @function throttle(fn: Function, time: Number, context: Object): Function
    // Returns a function which executes function `fn` with the given scope `context`
    // (so that the `this` keyword refers to `context` inside `fn`'s code). The function
    // `fn` will be called no more than one time per given amount of `time`. The arguments
    // received by the bound function will be any arguments passed when binding the
    // function, followed by any arguments passed when invoking the bound function.
    // Has an `L.throttle` shortcut.
    function throttle(fn, time, context) {
        var lock, args, wrapperFn, later;
        later = function() {
            // reset lock and call if queued
            lock = false;
            if (args) {
                wrapperFn.apply(context, args);
                args = false;
            }
        };
        wrapperFn = function() {
            if (lock) // called too soon, queue to call later
            args = arguments;
            else {
                // call and lock until later
                fn.apply(context, arguments);
                setTimeout(later, time);
                lock = true;
            }
        };
        return wrapperFn;
    }
    // @function wrapNum(num: Number, range: Number[], includeMax?: Boolean): Number
    // Returns the number `num` modulo `range` in such a way so it lies within
    // `range[0]` and `range[1]`. The returned value will be always smaller than
    // `range[1]` unless `includeMax` is set to `true`.
    function wrapNum(x, range, includeMax) {
        var max = range[1], min = range[0], d = max - min;
        return x === max && includeMax ? x : ((x - min) % d + d) % d + min;
    }
    // @function falseFn(): Function
    // Returns a function which always returns `false`.
    function falseFn() {
        return false;
    }
    // @function formatNum(num: Number, precision?: Number|false): Number
    // Returns the number `num` rounded with specified `precision`.
    // The default `precision` value is 6 decimal places.
    // `false` can be passed to skip any processing (can be useful to avoid round-off errors).
    function formatNum(num, precision) {
        if (precision === false) return num;
        var pow = Math.pow(10, precision === undefined ? 6 : precision);
        return Math.round(num * pow) / pow;
    }
    // @function trim(str: String): String
    // Compatibility polyfill for [String.prototype.trim](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim)
    function trim(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
    }
    // @function splitWords(str: String): String[]
    // Trims and splits the string on whitespace and returns the array of parts.
    function splitWords(str) {
        return trim(str).split(/\s+/);
    }
    // @function setOptions(obj: Object, options: Object): Object
    // Merges the given properties to the `options` of the `obj` object, returning the resulting options. See `Class options`. Has an `L.setOptions` shortcut.
    function setOptions(obj, options) {
        if (!Object.prototype.hasOwnProperty.call(obj, 'options')) obj.options = obj.options ? create$2(obj.options) : {};
        for(var i in options)obj.options[i] = options[i];
        return obj.options;
    }
    // @function getParamString(obj: Object, existingUrl?: String, uppercase?: Boolean): String
    // Converts an object into a parameter URL string, e.g. `{a: "foo", b: "bar"}`
    // translates to `'?a=foo&b=bar'`. If `existingUrl` is set, the parameters will
    // be appended at the end. If `uppercase` is `true`, the parameter names will
    // be uppercased (e.g. `'?A=foo&B=bar'`)
    function getParamString(obj, existingUrl, uppercase) {
        var params = [];
        for(var i in obj)params.push(encodeURIComponent(uppercase ? i.toUpperCase() : i) + '=' + encodeURIComponent(obj[i]));
        return (!existingUrl || existingUrl.indexOf('?') === -1 ? '?' : '&') + params.join('&');
    }
    var templateRe = /\{ *([\w_ -]+) *\}/g;
    // @function template(str: String, data: Object): String
    // Simple templating facility, accepts a template string of the form `'Hello {a}, {b}'`
    // and a data object like `{a: 'foo', b: 'bar'}`, returns evaluated string
    // `('Hello foo, bar')`. You can also specify functions instead of strings for
    // data values — they will be evaluated passing `data` as an argument.
    function template(str, data) {
        return str.replace(templateRe, function(str, key) {
            var value = data[key];
            if (value === undefined) throw new Error('No value provided for variable ' + str);
            else if (typeof value === 'function') value = value(data);
            return value;
        });
    }
    // @function isArray(obj): Boolean
    // Compatibility polyfill for [Array.isArray](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray)
    var isArray = Array.isArray || function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    // @function indexOf(array: Array, el: Object): Number
    // Compatibility polyfill for [Array.prototype.indexOf](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf)
    function indexOf(array, el) {
        for(var i = 0; i < array.length; i++){
            if (array[i] === el) return i;
        }
        return -1;
    }
    // @property emptyImageUrl: String
    // Data URI string containing a base64-encoded empty GIF image.
    // Used as a hack to free memory from unused images on WebKit-powered
    // mobile devices (by setting image `src` to this string).
    var emptyImageUrl = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=';
    // inspired by https://paulirish.com/2011/requestanimationframe-for-smart-animating/
    function getPrefixed(name) {
        return window['webkit' + name] || window['moz' + name] || window['ms' + name];
    }
    var lastTime = 0;
    // fallback for IE 7-8
    function timeoutDefer(fn) {
        var time = +new Date(), timeToCall = Math.max(0, 16 - (time - lastTime));
        lastTime = time + timeToCall;
        return window.setTimeout(fn, timeToCall);
    }
    var requestFn = window.requestAnimationFrame || getPrefixed('RequestAnimationFrame') || timeoutDefer;
    var cancelFn = window.cancelAnimationFrame || getPrefixed('CancelAnimationFrame') || getPrefixed('CancelRequestAnimationFrame') || function(id) {
        window.clearTimeout(id);
    };
    // @function requestAnimFrame(fn: Function, context?: Object, immediate?: Boolean): Number
    // Schedules `fn` to be executed when the browser repaints. `fn` is bound to
    // `context` if given. When `immediate` is set, `fn` is called immediately if
    // the browser doesn't have native support for
    // [`window.requestAnimationFrame`](https://developer.mozilla.org/docs/Web/API/window/requestAnimationFrame),
    // otherwise it's delayed. Returns a request ID that can be used to cancel the request.
    function requestAnimFrame(fn, context, immediate) {
        if (immediate && requestFn === timeoutDefer) fn.call(context);
        else return requestFn.call(window, bind(fn, context));
    }
    // @function cancelAnimFrame(id: Number): undefined
    // Cancels a previous `requestAnimFrame`. See also [window.cancelAnimationFrame](https://developer.mozilla.org/docs/Web/API/window/cancelAnimationFrame).
    function cancelAnimFrame(id) {
        if (id) cancelFn.call(window, id);
    }
    var Util = {
        __proto__: null,
        extend: extend,
        create: create$2,
        bind: bind,
        get lastId () {
            return lastId;
        },
        stamp: stamp,
        throttle: throttle,
        wrapNum: wrapNum,
        falseFn: falseFn,
        formatNum: formatNum,
        trim: trim,
        splitWords: splitWords,
        setOptions: setOptions,
        getParamString: getParamString,
        template: template,
        isArray: isArray,
        indexOf: indexOf,
        emptyImageUrl: emptyImageUrl,
        requestFn: requestFn,
        cancelFn: cancelFn,
        requestAnimFrame: requestAnimFrame,
        cancelAnimFrame: cancelAnimFrame
    };
    // @class Class
    // @aka L.Class
    // @section
    // @uninheritable
    // Thanks to John Resig and Dean Edwards for inspiration!
    function Class() {}
    Class.extend = function(props) {
        // @function extend(props: Object): Function
        // [Extends the current class](#class-inheritance) given the properties to be included.
        // Returns a Javascript function that is a class constructor (to be called with `new`).
        var NewClass = function() {
            setOptions(this);
            // call the constructor
            if (this.initialize) this.initialize.apply(this, arguments);
            // call all constructor hooks
            this.callInitHooks();
        };
        var parentProto = NewClass.__super__ = this.prototype;
        var proto = create$2(parentProto);
        proto.constructor = NewClass;
        NewClass.prototype = proto;
        // inherit parent's statics
        for(var i in this)if (Object.prototype.hasOwnProperty.call(this, i) && i !== 'prototype' && i !== '__super__') NewClass[i] = this[i];
        // mix static properties into the class
        if (props.statics) extend(NewClass, props.statics);
        // mix includes into the prototype
        if (props.includes) {
            checkDeprecatedMixinEvents(props.includes);
            extend.apply(null, [
                proto
            ].concat(props.includes));
        }
        // mix given properties into the prototype
        extend(proto, props);
        delete proto.statics;
        delete proto.includes;
        // merge options
        if (proto.options) {
            proto.options = parentProto.options ? create$2(parentProto.options) : {};
            extend(proto.options, props.options);
        }
        proto._initHooks = [];
        // add method for calling all hooks
        proto.callInitHooks = function() {
            if (this._initHooksCalled) return;
            if (parentProto.callInitHooks) parentProto.callInitHooks.call(this);
            this._initHooksCalled = true;
            for(var i = 0, len = proto._initHooks.length; i < len; i++)proto._initHooks[i].call(this);
        };
        return NewClass;
    };
    // @function include(properties: Object): this
    // [Includes a mixin](#class-includes) into the current class.
    Class.include = function(props) {
        var parentOptions = this.prototype.options;
        extend(this.prototype, props);
        if (props.options) {
            this.prototype.options = parentOptions;
            this.mergeOptions(props.options);
        }
        return this;
    };
    // @function mergeOptions(options: Object): this
    // [Merges `options`](#class-options) into the defaults of the class.
    Class.mergeOptions = function(options) {
        extend(this.prototype.options, options);
        return this;
    };
    // @function addInitHook(fn: Function): this
    // Adds a [constructor hook](#class-constructor-hooks) to the class.
    Class.addInitHook = function(fn) {
        var args = Array.prototype.slice.call(arguments, 1);
        var init = typeof fn === 'function' ? fn : function() {
            this[fn].apply(this, args);
        };
        this.prototype._initHooks = this.prototype._initHooks || [];
        this.prototype._initHooks.push(init);
        return this;
    };
    function checkDeprecatedMixinEvents(includes) {
        /* global L: true */ if (typeof L === 'undefined' || !L || !L.Mixin) return;
        includes = isArray(includes) ? includes : [
            includes
        ];
        for(var i = 0; i < includes.length; i++)if (includes[i] === L.Mixin.Events) console.warn("Deprecated include of L.Mixin.Events: this property will be removed in future releases, please inherit from L.Evented instead.", new Error().stack);
    }
    /*
   * @class Evented
   * @aka L.Evented
   * @inherits Class
   *
   * A set of methods shared between event-powered classes (like `Map` and `Marker`). Generally, events allow you to execute some function when something happens with an object (e.g. the user clicks on the map, causing the map to fire `'click'` event).
   *
   * @example
   *
   * ```js
   * map.on('click', function(e) {
   * 	alert(e.latlng);
   * } );
   * ```
   *
   * Leaflet deals with event listeners by reference, so if you want to add a listener and then remove it, define it as a function:
   *
   * ```js
   * function onClick(e) { ... }
   *
   * map.on('click', onClick);
   * map.off('click', onClick);
   * ```
   */ var Events = {
        /* @method on(type: String, fn: Function, context?: Object): this
  	 * Adds a listener function (`fn`) to a particular event type of the object. You can optionally specify the context of the listener (object the this keyword will point to). You can also pass several space-separated types (e.g. `'click dblclick'`).
  	 *
  	 * @alternative
  	 * @method on(eventMap: Object): this
  	 * Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
  	 */ on: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context);
            }
            return this;
        },
        /* @method off(type: String, fn?: Function, context?: Object): this
  	 * Removes a previously added listener function. If no function is specified, it will remove all the listeners of that particular event from the object. Note that if you passed a custom context to `on`, you must pass the same context to `off` in order to remove the listener.
  	 *
  	 * @alternative
  	 * @method off(eventMap: Object): this
  	 * Removes a set of type/listener pairs.
  	 *
  	 * @alternative
  	 * @method off: this
  	 * Removes all listeners to all events on the object. This includes implicitly attached events.
  	 */ off: function(types, fn, context) {
            if (!arguments.length) // clear all listeners if called without arguments
            delete this._events;
            else if (typeof types === 'object') for(var type in types)this._off(type, types[type], fn);
            else {
                types = splitWords(types);
                var removeAll = arguments.length === 1;
                for(var i = 0, len = types.length; i < len; i++)if (removeAll) this._off(types[i]);
                else this._off(types[i], fn, context);
            }
            return this;
        },
        // attach listener (without syntactic sugar now)
        _on: function(type, fn, context, _once) {
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // check if fn already there
            if (this._listens(type, fn, context) !== false) return;
            if (context === this) // Less memory footprint.
            context = undefined;
            var newListener = {
                fn: fn,
                ctx: context
            };
            if (_once) newListener.once = true;
            this._events = this._events || {};
            this._events[type] = this._events[type] || [];
            this._events[type].push(newListener);
        },
        _off: function(type, fn, context) {
            var listeners, i, len;
            if (!this._events) return;
            listeners = this._events[type];
            if (!listeners) return;
            if (arguments.length === 1) {
                if (this._firingCount) // Set all removed listeners to noop
                // so they are not called if remove happens in fire
                for(i = 0, len = listeners.length; i < len; i++)listeners[i].fn = falseFn;
                // clear all listeners for a type if function isn't specified
                delete this._events[type];
                return;
            }
            if (typeof fn !== 'function') {
                console.warn('wrong listener type: ' + typeof fn);
                return;
            }
            // find fn and remove it
            var index = this._listens(type, fn, context);
            if (index !== false) {
                var listener = listeners[index];
                if (this._firingCount) {
                    // set the removed listener to noop so that's not called if remove happens in fire
                    listener.fn = falseFn;
                    /* copy array in case events are being fired */ this._events[type] = listeners = listeners.slice();
                }
                listeners.splice(index, 1);
            }
        },
        // @method fire(type: String, data?: Object, propagate?: Boolean): this
        // Fires an event of the specified type. You can optionally provide a data
        // object — the first argument of the listener function will contain its
        // properties. The event can optionally be propagated to event parents.
        fire: function(type, data, propagate) {
            if (!this.listens(type, propagate)) return this;
            var event = extend({}, data, {
                type: type,
                target: this,
                sourceTarget: data && data.sourceTarget || this
            });
            if (this._events) {
                var listeners = this._events[type];
                if (listeners) {
                    this._firingCount = this._firingCount + 1 || 1;
                    for(var i = 0, len = listeners.length; i < len; i++){
                        var l = listeners[i];
                        // off overwrites l.fn, so we need to copy fn to a var
                        var fn = l.fn;
                        if (l.once) this.off(type, fn, l.ctx);
                        fn.call(l.ctx || this, event);
                    }
                    this._firingCount--;
                }
            }
            if (propagate) // propagate the event to parents (set with addEventParent)
            this._propagateEvent(event);
            return this;
        },
        // @method listens(type: String, propagate?: Boolean): Boolean
        // @method listens(type: String, fn: Function, context?: Object, propagate?: Boolean): Boolean
        // Returns `true` if a particular event type has any listeners attached to it.
        // The verification can optionally be propagated, it will return `true` if parents have the listener attached to it.
        listens: function(type, fn, context, propagate) {
            if (typeof type !== 'string') console.warn('"string" type argument expected');
            // we don't overwrite the input `fn` value, because we need to use it for propagation
            var _fn = fn;
            if (typeof fn !== 'function') {
                propagate = !!fn;
                _fn = undefined;
                context = undefined;
            }
            var listeners = this._events && this._events[type];
            if (listeners && listeners.length) {
                if (this._listens(type, _fn, context) !== false) return true;
            }
            if (propagate) // also check parents for listeners if event propagates
            for(var id in this._eventParents){
                if (this._eventParents[id].listens(type, fn, context, propagate)) return true;
            }
            return false;
        },
        // returns the index (number) or false
        _listens: function(type, fn, context) {
            if (!this._events) return false;
            var listeners = this._events[type] || [];
            if (!fn) return !!listeners.length;
            if (context === this) // Less memory footprint.
            context = undefined;
            for(var i = 0, len = listeners.length; i < len; i++){
                if (listeners[i].fn === fn && listeners[i].ctx === context) return i;
            }
            return false;
        },
        // @method once(…): this
        // Behaves as [`on(…)`](#evented-on), except the listener will only get fired once and then removed.
        once: function(types, fn, context) {
            // types can be a map of types/handlers
            if (typeof types === 'object') for(var type in types)// we don't process space-separated events here for performance;
            // it's a hot path since Layer uses the on(obj) syntax
            this._on(type, types[type], fn, true);
            else {
                // types can be a string of space-separated words
                types = splitWords(types);
                for(var i = 0, len = types.length; i < len; i++)this._on(types[i], fn, context, true);
            }
            return this;
        },
        // @method addEventParent(obj: Evented): this
        // Adds an event parent - an `Evented` that will receive propagated events
        addEventParent: function(obj) {
            this._eventParents = this._eventParents || {};
            this._eventParents[stamp(obj)] = obj;
            return this;
        },
        // @method removeEventParent(obj: Evented): this
        // Removes an event parent, so it will stop receiving propagated events
        removeEventParent: function(obj) {
            if (this._eventParents) delete this._eventParents[stamp(obj)];
            return this;
        },
        _propagateEvent: function(e) {
            for(var id in this._eventParents)this._eventParents[id].fire(e.type, extend({
                layer: e.target,
                propagatedFrom: e.target
            }, e), true);
        }
    };
    // aliases; we should ditch those eventually
    // @method addEventListener(…): this
    // Alias to [`on(…)`](#evented-on)
    Events.addEventListener = Events.on;
    // @method removeEventListener(…): this
    // Alias to [`off(…)`](#evented-off)
    // @method clearAllEventListeners(…): this
    // Alias to [`off()`](#evented-off)
    Events.removeEventListener = Events.clearAllEventListeners = Events.off;
    // @method addOneTimeEventListener(…): this
    // Alias to [`once(…)`](#evented-once)
    Events.addOneTimeEventListener = Events.once;
    // @method fireEvent(…): this
    // Alias to [`fire(…)`](#evented-fire)
    Events.fireEvent = Events.fire;
    // @method hasEventListeners(…): Boolean
    // Alias to [`listens(…)`](#evented-listens)
    Events.hasEventListeners = Events.listens;
    var Evented = Class.extend(Events);
    /*
   * @class Point
   * @aka L.Point
   *
   * Represents a point with `x` and `y` coordinates in pixels.
   *
   * @example
   *
   * ```js
   * var point = L.point(200, 300);
   * ```
   *
   * All Leaflet methods and options that accept `Point` objects also accept them in a simple Array form (unless noted otherwise), so these lines are equivalent:
   *
   * ```js
   * map.panBy([200, 300]);
   * map.panBy(L.point(200, 300));
   * ```
   *
   * Note that `Point` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Point(x, y, round) {
        // @property x: Number; The `x` coordinate of the point
        this.x = round ? Math.round(x) : x;
        // @property y: Number; The `y` coordinate of the point
        this.y = round ? Math.round(y) : y;
    }
    var trunc = Math.trunc || function(v) {
        return v > 0 ? Math.floor(v) : Math.ceil(v);
    };
    Point.prototype = {
        // @method clone(): Point
        // Returns a copy of the current point.
        clone: function() {
            return new Point(this.x, this.y);
        },
        // @method add(otherPoint: Point): Point
        // Returns the result of addition of the current and the given points.
        add: function(point) {
            // non-destructive, returns a new point
            return this.clone()._add(toPoint(point));
        },
        _add: function(point) {
            // destructive, used directly for performance in situations where it's safe to modify existing point
            this.x += point.x;
            this.y += point.y;
            return this;
        },
        // @method subtract(otherPoint: Point): Point
        // Returns the result of subtraction of the given point from the current.
        subtract: function(point) {
            return this.clone()._subtract(toPoint(point));
        },
        _subtract: function(point) {
            this.x -= point.x;
            this.y -= point.y;
            return this;
        },
        // @method divideBy(num: Number): Point
        // Returns the result of division of the current point by the given number.
        divideBy: function(num) {
            return this.clone()._divideBy(num);
        },
        _divideBy: function(num) {
            this.x /= num;
            this.y /= num;
            return this;
        },
        // @method multiplyBy(num: Number): Point
        // Returns the result of multiplication of the current point by the given number.
        multiplyBy: function(num) {
            return this.clone()._multiplyBy(num);
        },
        _multiplyBy: function(num) {
            this.x *= num;
            this.y *= num;
            return this;
        },
        // @method scaleBy(scale: Point): Point
        // Multiply each coordinate of the current point by each coordinate of
        // `scale`. In linear algebra terms, multiply the point by the
        // [scaling matrix](https://en.wikipedia.org/wiki/Scaling_%28geometry%29#Matrix_representation)
        // defined by `scale`.
        scaleBy: function(point) {
            return new Point(this.x * point.x, this.y * point.y);
        },
        // @method unscaleBy(scale: Point): Point
        // Inverse of `scaleBy`. Divide each coordinate of the current point by
        // each coordinate of `scale`.
        unscaleBy: function(point) {
            return new Point(this.x / point.x, this.y / point.y);
        },
        // @method round(): Point
        // Returns a copy of the current point with rounded coordinates.
        round: function() {
            return this.clone()._round();
        },
        _round: function() {
            this.x = Math.round(this.x);
            this.y = Math.round(this.y);
            return this;
        },
        // @method floor(): Point
        // Returns a copy of the current point with floored coordinates (rounded down).
        floor: function() {
            return this.clone()._floor();
        },
        _floor: function() {
            this.x = Math.floor(this.x);
            this.y = Math.floor(this.y);
            return this;
        },
        // @method ceil(): Point
        // Returns a copy of the current point with ceiled coordinates (rounded up).
        ceil: function() {
            return this.clone()._ceil();
        },
        _ceil: function() {
            this.x = Math.ceil(this.x);
            this.y = Math.ceil(this.y);
            return this;
        },
        // @method trunc(): Point
        // Returns a copy of the current point with truncated coordinates (rounded towards zero).
        trunc: function() {
            return this.clone()._trunc();
        },
        _trunc: function() {
            this.x = trunc(this.x);
            this.y = trunc(this.y);
            return this;
        },
        // @method distanceTo(otherPoint: Point): Number
        // Returns the cartesian distance between the current and the given points.
        distanceTo: function(point) {
            point = toPoint(point);
            var x = point.x - this.x, y = point.y - this.y;
            return Math.sqrt(x * x + y * y);
        },
        // @method equals(otherPoint: Point): Boolean
        // Returns `true` if the given point has the same coordinates.
        equals: function(point) {
            point = toPoint(point);
            return point.x === this.x && point.y === this.y;
        },
        // @method contains(otherPoint: Point): Boolean
        // Returns `true` if both coordinates of the given point are less than the corresponding current point coordinates (in absolute values).
        contains: function(point) {
            point = toPoint(point);
            return Math.abs(point.x) <= Math.abs(this.x) && Math.abs(point.y) <= Math.abs(this.y);
        },
        // @method toString(): String
        // Returns a string representation of the point for debugging purposes.
        toString: function() {
            return 'Point(' + formatNum(this.x) + ', ' + formatNum(this.y) + ')';
        }
    };
    // @factory L.point(x: Number, y: Number, round?: Boolean)
    // Creates a Point object with the given `x` and `y` coordinates. If optional `round` is set to true, rounds the `x` and `y` values.
    // @alternative
    // @factory L.point(coords: Number[])
    // Expects an array of the form `[x, y]` instead.
    // @alternative
    // @factory L.point(coords: Object)
    // Expects a plain object of the form `{x: Number, y: Number}` instead.
    function toPoint(x, y, round) {
        if (x instanceof Point) return x;
        if (isArray(x)) return new Point(x[0], x[1]);
        if (x === undefined || x === null) return x;
        if (typeof x === 'object' && 'x' in x && 'y' in x) return new Point(x.x, x.y);
        return new Point(x, y, round);
    }
    /*
   * @class Bounds
   * @aka L.Bounds
   *
   * Represents a rectangular area in pixel coordinates.
   *
   * @example
   *
   * ```js
   * var p1 = L.point(10, 10),
   * p2 = L.point(40, 60),
   * bounds = L.bounds(p1, p2);
   * ```
   *
   * All Leaflet methods that accept `Bounds` objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * otherBounds.intersects([[10, 10], [40, 60]]);
   * ```
   *
   * Note that `Bounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function Bounds(a, b) {
        if (!a) return;
        var points = b ? [
            a,
            b
        ] : a;
        for(var i = 0, len = points.length; i < len; i++)this.extend(points[i]);
    }
    Bounds.prototype = {
        // @method extend(point: Point): this
        // Extends the bounds to contain the given point.
        // @alternative
        // @method extend(otherBounds: Bounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var min2, max2;
            if (!obj) return this;
            if (obj instanceof Point || typeof obj[0] === 'number' || 'x' in obj) min2 = max2 = toPoint(obj);
            else {
                obj = toBounds(obj);
                min2 = obj.min;
                max2 = obj.max;
                if (!min2 || !max2) return this;
            }
            // @property min: Point
            // The top left corner of the rectangle.
            // @property max: Point
            // The bottom right corner of the rectangle.
            if (!this.min && !this.max) {
                this.min = min2.clone();
                this.max = max2.clone();
            } else {
                this.min.x = Math.min(min2.x, this.min.x);
                this.max.x = Math.max(max2.x, this.max.x);
                this.min.y = Math.min(min2.y, this.min.y);
                this.max.y = Math.max(max2.y, this.max.y);
            }
            return this;
        },
        // @method getCenter(round?: Boolean): Point
        // Returns the center point of the bounds.
        getCenter: function(round) {
            return toPoint((this.min.x + this.max.x) / 2, (this.min.y + this.max.y) / 2, round);
        },
        // @method getBottomLeft(): Point
        // Returns the bottom-left point of the bounds.
        getBottomLeft: function() {
            return toPoint(this.min.x, this.max.y);
        },
        // @method getTopRight(): Point
        // Returns the top-right point of the bounds.
        getTopRight: function() {
            return toPoint(this.max.x, this.min.y);
        },
        // @method getTopLeft(): Point
        // Returns the top-left point of the bounds (i.e. [`this.min`](#bounds-min)).
        getTopLeft: function() {
            return this.min; // left, top
        },
        // @method getBottomRight(): Point
        // Returns the bottom-right point of the bounds (i.e. [`this.max`](#bounds-max)).
        getBottomRight: function() {
            return this.max; // right, bottom
        },
        // @method getSize(): Point
        // Returns the size of the given bounds
        getSize: function() {
            return this.max.subtract(this.min);
        },
        // @method contains(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains(point: Point): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            var min, max;
            if (typeof obj[0] === 'number' || obj instanceof Point) obj = toPoint(obj);
            else obj = toBounds(obj);
            if (obj instanceof Bounds) {
                min = obj.min;
                max = obj.max;
            } else min = max = obj;
            return min.x >= this.min.x && max.x <= this.max.x && min.y >= this.min.y && max.y <= this.max.y;
        },
        // @method intersects(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds
        // intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xIntersects = max2.x >= min.x && min2.x <= max.x, yIntersects = max2.y >= min.y && min2.y <= max.y;
            return xIntersects && yIntersects;
        },
        // @method overlaps(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds
        // overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toBounds(bounds);
            var min = this.min, max = this.max, min2 = bounds.min, max2 = bounds.max, xOverlaps = max2.x > min.x && min2.x < max.x, yOverlaps = max2.y > min.y && min2.y < max.y;
            return xOverlaps && yOverlaps;
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this.min && this.max);
        },
        // @method pad(bufferRatio: Number): Bounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var min = this.min, max = this.max, heightBuffer = Math.abs(min.x - max.x) * bufferRatio, widthBuffer = Math.abs(min.y - max.y) * bufferRatio;
            return toBounds(toPoint(min.x - heightBuffer, min.y - widthBuffer), toPoint(max.x + heightBuffer, max.y + widthBuffer));
        },
        // @method equals(otherBounds: Bounds): Boolean
        // Returns `true` if the rectangle is equivalent to the given bounds.
        equals: function(bounds) {
            if (!bounds) return false;
            bounds = toBounds(bounds);
            return this.min.equals(bounds.getTopLeft()) && this.max.equals(bounds.getBottomRight());
        }
    };
    // @factory L.bounds(corner1: Point, corner2: Point)
    // Creates a Bounds object from two corners coordinate pairs.
    // @alternative
    // @factory L.bounds(points: Point[])
    // Creates a Bounds object from the given array of points.
    function toBounds(a, b) {
        if (!a || a instanceof Bounds) return a;
        return new Bounds(a, b);
    }
    /*
   * @class LatLngBounds
   * @aka L.LatLngBounds
   *
   * Represents a rectangular geographical area on a map.
   *
   * @example
   *
   * ```js
   * var corner1 = L.latLng(40.712, -74.227),
   * corner2 = L.latLng(40.774, -74.125),
   * bounds = L.latLngBounds(corner1, corner2);
   * ```
   *
   * All Leaflet methods that accept LatLngBounds objects also accept them in a simple Array form (unless noted otherwise), so the bounds example above can be passed like this:
   *
   * ```js
   * map.fitBounds([
   * 	[40.712, -74.227],
   * 	[40.774, -74.125]
   * ]);
   * ```
   *
   * Caution: if the area crosses the antimeridian (often confused with the International Date Line), you must specify corners _outside_ the [-180, 180] degrees longitude range.
   *
   * Note that `LatLngBounds` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLngBounds(corner1, corner2) {
        if (!corner1) return;
        var latlngs = corner2 ? [
            corner1,
            corner2
        ] : corner1;
        for(var i = 0, len = latlngs.length; i < len; i++)this.extend(latlngs[i]);
    }
    LatLngBounds.prototype = {
        // @method extend(latlng: LatLng): this
        // Extend the bounds to contain the given point
        // @alternative
        // @method extend(otherBounds: LatLngBounds): this
        // Extend the bounds to contain the given bounds
        extend: function(obj) {
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLng) {
                sw2 = obj;
                ne2 = obj;
            } else if (obj instanceof LatLngBounds) {
                sw2 = obj._southWest;
                ne2 = obj._northEast;
                if (!sw2 || !ne2) return this;
            } else return obj ? this.extend(toLatLng(obj) || toLatLngBounds(obj)) : this;
            if (!sw && !ne) {
                this._southWest = new LatLng(sw2.lat, sw2.lng);
                this._northEast = new LatLng(ne2.lat, ne2.lng);
            } else {
                sw.lat = Math.min(sw2.lat, sw.lat);
                sw.lng = Math.min(sw2.lng, sw.lng);
                ne.lat = Math.max(ne2.lat, ne.lat);
                ne.lng = Math.max(ne2.lng, ne.lng);
            }
            return this;
        },
        // @method pad(bufferRatio: Number): LatLngBounds
        // Returns bounds created by extending or retracting the current bounds by a given ratio in each direction.
        // For example, a ratio of 0.5 extends the bounds by 50% in each direction.
        // Negative values will retract the bounds.
        pad: function(bufferRatio) {
            var sw = this._southWest, ne = this._northEast, heightBuffer = Math.abs(sw.lat - ne.lat) * bufferRatio, widthBuffer = Math.abs(sw.lng - ne.lng) * bufferRatio;
            return new LatLngBounds(new LatLng(sw.lat - heightBuffer, sw.lng - widthBuffer), new LatLng(ne.lat + heightBuffer, ne.lng + widthBuffer));
        },
        // @method getCenter(): LatLng
        // Returns the center point of the bounds.
        getCenter: function() {
            return new LatLng((this._southWest.lat + this._northEast.lat) / 2, (this._southWest.lng + this._northEast.lng) / 2);
        },
        // @method getSouthWest(): LatLng
        // Returns the south-west point of the bounds.
        getSouthWest: function() {
            return this._southWest;
        },
        // @method getNorthEast(): LatLng
        // Returns the north-east point of the bounds.
        getNorthEast: function() {
            return this._northEast;
        },
        // @method getNorthWest(): LatLng
        // Returns the north-west point of the bounds.
        getNorthWest: function() {
            return new LatLng(this.getNorth(), this.getWest());
        },
        // @method getSouthEast(): LatLng
        // Returns the south-east point of the bounds.
        getSouthEast: function() {
            return new LatLng(this.getSouth(), this.getEast());
        },
        // @method getWest(): Number
        // Returns the west longitude of the bounds
        getWest: function() {
            return this._southWest.lng;
        },
        // @method getSouth(): Number
        // Returns the south latitude of the bounds
        getSouth: function() {
            return this._southWest.lat;
        },
        // @method getEast(): Number
        // Returns the east longitude of the bounds
        getEast: function() {
            return this._northEast.lng;
        },
        // @method getNorth(): Number
        // Returns the north latitude of the bounds
        getNorth: function() {
            return this._northEast.lat;
        },
        // @method contains(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle contains the given one.
        // @alternative
        // @method contains (latlng: LatLng): Boolean
        // Returns `true` if the rectangle contains the given point.
        contains: function(obj) {
            if (typeof obj[0] === 'number' || obj instanceof LatLng || 'lat' in obj) obj = toLatLng(obj);
            else obj = toLatLngBounds(obj);
            var sw = this._southWest, ne = this._northEast, sw2, ne2;
            if (obj instanceof LatLngBounds) {
                sw2 = obj.getSouthWest();
                ne2 = obj.getNorthEast();
            } else sw2 = ne2 = obj;
            return sw2.lat >= sw.lat && ne2.lat <= ne.lat && sw2.lng >= sw.lng && ne2.lng <= ne.lng;
        },
        // @method intersects(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle intersects the given bounds. Two bounds intersect if they have at least one point in common.
        intersects: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latIntersects = ne2.lat >= sw.lat && sw2.lat <= ne.lat, lngIntersects = ne2.lng >= sw.lng && sw2.lng <= ne.lng;
            return latIntersects && lngIntersects;
        },
        // @method overlaps(otherBounds: LatLngBounds): Boolean
        // Returns `true` if the rectangle overlaps the given bounds. Two bounds overlap if their intersection is an area.
        overlaps: function(bounds) {
            bounds = toLatLngBounds(bounds);
            var sw = this._southWest, ne = this._northEast, sw2 = bounds.getSouthWest(), ne2 = bounds.getNorthEast(), latOverlaps = ne2.lat > sw.lat && sw2.lat < ne.lat, lngOverlaps = ne2.lng > sw.lng && sw2.lng < ne.lng;
            return latOverlaps && lngOverlaps;
        },
        // @method toBBoxString(): String
        // Returns a string with bounding box coordinates in a 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format. Useful for sending requests to web services that return geo data.
        toBBoxString: function() {
            return [
                this.getWest(),
                this.getSouth(),
                this.getEast(),
                this.getNorth()
            ].join(',');
        },
        // @method equals(otherBounds: LatLngBounds, maxMargin?: Number): Boolean
        // Returns `true` if the rectangle is equivalent (within a small margin of error) to the given bounds. The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(bounds, maxMargin) {
            if (!bounds) return false;
            bounds = toLatLngBounds(bounds);
            return this._southWest.equals(bounds.getSouthWest(), maxMargin) && this._northEast.equals(bounds.getNorthEast(), maxMargin);
        },
        // @method isValid(): Boolean
        // Returns `true` if the bounds are properly initialized.
        isValid: function() {
            return !!(this._southWest && this._northEast);
        }
    };
    // TODO International date line?
    // @factory L.latLngBounds(corner1: LatLng, corner2: LatLng)
    // Creates a `LatLngBounds` object by defining two diagonally opposite corners of the rectangle.
    // @alternative
    // @factory L.latLngBounds(latlngs: LatLng[])
    // Creates a `LatLngBounds` object defined by the geographical points it contains. Very useful for zooming the map to fit a particular set of locations with [`fitBounds`](#map-fitbounds).
    function toLatLngBounds(a, b) {
        if (a instanceof LatLngBounds) return a;
        return new LatLngBounds(a, b);
    }
    /* @class LatLng
   * @aka L.LatLng
   *
   * Represents a geographical point with a certain latitude and longitude.
   *
   * @example
   *
   * ```
   * var latlng = L.latLng(50.5, 30.5);
   * ```
   *
   * All Leaflet methods that accept LatLng objects also accept them in a simple Array form and simple object form (unless noted otherwise), so these lines are equivalent:
   *
   * ```
   * map.panTo([50, 30]);
   * map.panTo({lon: 30, lat: 50});
   * map.panTo({lat: 50, lng: 30});
   * map.panTo(L.latLng(50, 30));
   * ```
   *
   * Note that `LatLng` does not inherit from Leaflet's `Class` object,
   * which means new classes can't inherit from it, and new methods
   * can't be added to it with the `include` function.
   */ function LatLng(lat, lng, alt) {
        if (isNaN(lat) || isNaN(lng)) throw new Error('Invalid LatLng object: (' + lat + ', ' + lng + ')');
        // @property lat: Number
        // Latitude in degrees
        this.lat = +lat;
        // @property lng: Number
        // Longitude in degrees
        this.lng = +lng;
        // @property alt: Number
        // Altitude in meters (optional)
        if (alt !== undefined) this.alt = +alt;
    }
    LatLng.prototype = {
        // @method equals(otherLatLng: LatLng, maxMargin?: Number): Boolean
        // Returns `true` if the given `LatLng` point is at the same position (within a small margin of error). The margin of error can be overridden by setting `maxMargin` to a small number.
        equals: function(obj, maxMargin) {
            if (!obj) return false;
            obj = toLatLng(obj);
            var margin = Math.max(Math.abs(this.lat - obj.lat), Math.abs(this.lng - obj.lng));
            return margin <= (maxMargin === undefined ? 1.0E-9 : maxMargin);
        },
        // @method toString(): String
        // Returns a string representation of the point (for debugging purposes).
        toString: function(precision) {
            return 'LatLng(' + formatNum(this.lat, precision) + ', ' + formatNum(this.lng, precision) + ')';
        },
        // @method distanceTo(otherLatLng: LatLng): Number
        // Returns the distance (in meters) to the given `LatLng` calculated using the [Spherical Law of Cosines](https://en.wikipedia.org/wiki/Spherical_law_of_cosines).
        distanceTo: function(other) {
            return Earth.distance(this, toLatLng(other));
        },
        // @method wrap(): LatLng
        // Returns a new `LatLng` object with the longitude wrapped so it's always between -180 and +180 degrees.
        wrap: function() {
            return Earth.wrapLatLng(this);
        },
        // @method toBounds(sizeInMeters: Number): LatLngBounds
        // Returns a new `LatLngBounds` object in which each boundary is `sizeInMeters/2` meters apart from the `LatLng`.
        toBounds: function(sizeInMeters) {
            var latAccuracy = 180 * sizeInMeters / 40075017, lngAccuracy = latAccuracy / Math.cos(Math.PI / 180 * this.lat);
            return toLatLngBounds([
                this.lat - latAccuracy,
                this.lng - lngAccuracy
            ], [
                this.lat + latAccuracy,
                this.lng + lngAccuracy
            ]);
        },
        clone: function() {
            return new LatLng(this.lat, this.lng, this.alt);
        }
    };
    // @factory L.latLng(latitude: Number, longitude: Number, altitude?: Number): LatLng
    // Creates an object representing a geographical point with the given latitude and longitude (and optionally altitude).
    // @alternative
    // @factory L.latLng(coords: Array): LatLng
    // Expects an array of the form `[Number, Number]` or `[Number, Number, Number]` instead.
    // @alternative
    // @factory L.latLng(coords: Object): LatLng
    // Expects an plain object of the form `{lat: Number, lng: Number}` or `{lat: Number, lng: Number, alt: Number}` instead.
    function toLatLng(a, b, c) {
        if (a instanceof LatLng) return a;
        if (isArray(a) && typeof a[0] !== 'object') {
            if (a.length === 3) return new LatLng(a[0], a[1], a[2]);
            if (a.length === 2) return new LatLng(a[0], a[1]);
            return null;
        }
        if (a === undefined || a === null) return a;
        if (typeof a === 'object' && 'lat' in a) return new LatLng(a.lat, 'lng' in a ? a.lng : a.lon, a.alt);
        if (b === undefined) return null;
        return new LatLng(a, b, c);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.Base
   * Object that defines coordinate reference systems for projecting
   * geographical points into pixel (screen) coordinates and back (and to
   * coordinates in other units for [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services). See
   * [spatial reference system](https://en.wikipedia.org/wiki/Spatial_reference_system).
   *
   * Leaflet defines the most usual CRSs by default. If you want to use a
   * CRS not defined by default, take a look at the
   * [Proj4Leaflet](https://github.com/kartena/Proj4Leaflet) plugin.
   *
   * Note that the CRS instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.
   */ var CRS = {
        // @method latLngToPoint(latlng: LatLng, zoom: Number): Point
        // Projects geographical coordinates into pixel coordinates for a given zoom.
        latLngToPoint: function(latlng, zoom) {
            var projectedPoint = this.projection.project(latlng), scale = this.scale(zoom);
            return this.transformation._transform(projectedPoint, scale);
        },
        // @method pointToLatLng(point: Point, zoom: Number): LatLng
        // The inverse of `latLngToPoint`. Projects pixel coordinates on a given
        // zoom into geographical coordinates.
        pointToLatLng: function(point, zoom) {
            var scale = this.scale(zoom), untransformedPoint = this.transformation.untransform(point, scale);
            return this.projection.unproject(untransformedPoint);
        },
        // @method project(latlng: LatLng): Point
        // Projects geographical coordinates into coordinates in units accepted for
        // this CRS (e.g. meters for EPSG:3857, for passing it to WMS services).
        project: function(latlng) {
            return this.projection.project(latlng);
        },
        // @method unproject(point: Point): LatLng
        // Given a projected coordinate returns the corresponding LatLng.
        // The inverse of `project`.
        unproject: function(point) {
            return this.projection.unproject(point);
        },
        // @method scale(zoom: Number): Number
        // Returns the scale used when transforming projected coordinates into
        // pixel coordinates for a particular zoom. For example, it returns
        // `256 * 2^zoom` for Mercator-based CRS.
        scale: function(zoom) {
            return 256 * Math.pow(2, zoom);
        },
        // @method zoom(scale: Number): Number
        // Inverse of `scale()`, returns the zoom level corresponding to a scale
        // factor of `scale`.
        zoom: function(scale) {
            return Math.log(scale / 256) / Math.LN2;
        },
        // @method getProjectedBounds(zoom: Number): Bounds
        // Returns the projection's bounds scaled and transformed for the provided `zoom`.
        getProjectedBounds: function(zoom) {
            if (this.infinite) return null;
            var b = this.projection.bounds, s = this.scale(zoom), min = this.transformation.transform(b.min, s), max = this.transformation.transform(b.max, s);
            return new Bounds(min, max);
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates.
        // @property code: String
        // Standard code name of the CRS passed into WMS services (e.g. `'EPSG:3857'`)
        //
        // @property wrapLng: Number[]
        // An array of two numbers defining whether the longitude (horizontal) coordinate
        // axis wraps around a given range and how. Defaults to `[-180, 180]` in most
        // geographical CRSs. If `undefined`, the longitude axis does not wrap around.
        //
        // @property wrapLat: Number[]
        // Like `wrapLng`, but for the latitude (vertical) axis.
        // wrapLng: [min, max],
        // wrapLat: [min, max],
        // @property infinite: Boolean
        // If true, the coordinate space will be unbounded (infinite in both axes)
        infinite: false,
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where lat and lng has been wrapped according to the
        // CRS's `wrapLat` and `wrapLng` properties, if they are outside the CRS's bounds.
        wrapLatLng: function(latlng) {
            var lng = this.wrapLng ? wrapNum(latlng.lng, this.wrapLng, true) : latlng.lng, lat = this.wrapLat ? wrapNum(latlng.lat, this.wrapLat, true) : latlng.lat, alt = latlng.alt;
            return new LatLng(lat, lng, alt);
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring
        // that its center is within the CRS's bounds.
        // Only accepts actual `L.LatLngBounds` instances, not arrays.
        wrapLatLngBounds: function(bounds) {
            var center = bounds.getCenter(), newCenter = this.wrapLatLng(center), latShift = center.lat - newCenter.lat, lngShift = center.lng - newCenter.lng;
            if (latShift === 0 && lngShift === 0) return bounds;
            var sw = bounds.getSouthWest(), ne = bounds.getNorthEast(), newSw = new LatLng(sw.lat - latShift, sw.lng - lngShift), newNe = new LatLng(ne.lat - latShift, ne.lng - lngShift);
            return new LatLngBounds(newSw, newNe);
        }
    };
    /*
   * @namespace CRS
   * @crs L.CRS.Earth
   *
   * Serves as the base for CRS that are global such that they cover the earth.
   * Can only be used as the base for other CRS and cannot be used directly,
   * since it does not have a `code`, `projection` or `transformation`. `distance()` returns
   * meters.
   */ var Earth = extend({}, CRS, {
        wrapLng: [
            -180,
            180
        ],
        // Mean Earth Radius, as recommended for use by
        // the International Union of Geodesy and Geophysics,
        // see https://rosettacode.org/wiki/Haversine_formula
        R: 6371000,
        // distance between two geographical points using spherical law of cosines approximation
        distance: function(latlng1, latlng2) {
            var rad = Math.PI / 180, lat1 = latlng1.lat * rad, lat2 = latlng2.lat * rad, sinDLat = Math.sin((latlng2.lat - latlng1.lat) * rad / 2), sinDLon = Math.sin((latlng2.lng - latlng1.lng) * rad / 2), a = sinDLat * sinDLat + Math.cos(lat1) * Math.cos(lat2) * sinDLon * sinDLon, c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
            return this.R * c;
        }
    });
    /*
   * @namespace Projection
   * @projection L.Projection.SphericalMercator
   *
   * Spherical Mercator projection — the most common projection for online maps,
   * used by almost all free and commercial tile providers. Assumes that Earth is
   * a sphere. Used by the `EPSG:3857` CRS.
   */ var earthRadius = 6378137;
    var SphericalMercator = {
        R: earthRadius,
        MAX_LATITUDE: 85.0511287798,
        project: function(latlng) {
            var d = Math.PI / 180, max = this.MAX_LATITUDE, lat = Math.max(Math.min(max, latlng.lat), -max), sin = Math.sin(lat * d);
            return new Point(this.R * latlng.lng * d, this.R * Math.log((1 + sin) / (1 - sin)) / 2);
        },
        unproject: function(point) {
            var d = 180 / Math.PI;
            return new LatLng((2 * Math.atan(Math.exp(point.y / this.R)) - Math.PI / 2) * d, point.x * d / this.R);
        },
        bounds: function() {
            var d = earthRadius * Math.PI;
            return new Bounds([
                -d,
                -d
            ], [
                d,
                d
            ]);
        }()
    };
    /*
   * @class Transformation
   * @aka L.Transformation
   *
   * Represents an affine transformation: a set of coefficients `a`, `b`, `c`, `d`
   * for transforming a point of a form `(x, y)` into `(a*x + b, c*y + d)` and doing
   * the reverse. Used by Leaflet in its projections code.
   *
   * @example
   *
   * ```js
   * var transformation = L.transformation(2, 5, -1, 10),
   * 	p = L.point(1, 2),
   * 	p2 = transformation.transform(p), //  L.point(7, 8)
   * 	p3 = transformation.untransform(p2); //  L.point(1, 2)
   * ```
   */ // factory new L.Transformation(a: Number, b: Number, c: Number, d: Number)
    // Creates a `Transformation` object with the given coefficients.
    function Transformation(a, b, c, d) {
        if (isArray(a)) {
            // use array properties
            this._a = a[0];
            this._b = a[1];
            this._c = a[2];
            this._d = a[3];
            return;
        }
        this._a = a;
        this._b = b;
        this._c = c;
        this._d = d;
    }
    Transformation.prototype = {
        // @method transform(point: Point, scale?: Number): Point
        // Returns a transformed point, optionally multiplied by the given scale.
        // Only accepts actual `L.Point` instances, not arrays.
        transform: function(point, scale) {
            return this._transform(point.clone(), scale);
        },
        // destructive transform (faster)
        _transform: function(point, scale) {
            scale = scale || 1;
            point.x = scale * (this._a * point.x + this._b);
            point.y = scale * (this._c * point.y + this._d);
            return point;
        },
        // @method untransform(point: Point, scale?: Number): Point
        // Returns the reverse transformation of the given point, optionally divided
        // by the given scale. Only accepts actual `L.Point` instances, not arrays.
        untransform: function(point, scale) {
            scale = scale || 1;
            return new Point((point.x / scale - this._b) / this._a, (point.y / scale - this._d) / this._c);
        }
    };
    // factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // @factory L.transformation(a: Number, b: Number, c: Number, d: Number)
    // Instantiates a Transformation object with the given coefficients.
    // @alternative
    // @factory L.transformation(coefficients: Array): Transformation
    // Expects an coefficients array of the form
    // `[a: Number, b: Number, c: Number, d: Number]`.
    function toTransformation(a, b, c, d) {
        return new Transformation(a, b, c, d);
    }
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3857
   *
   * The most common CRS for online maps, used by almost all free and commercial
   * tile providers. Uses Spherical Mercator projection. Set in by default in
   * Map's `crs` option.
   */ var EPSG3857 = extend({}, Earth, {
        code: 'EPSG:3857',
        projection: SphericalMercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * SphericalMercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    var EPSG900913 = extend({}, EPSG3857, {
        code: 'EPSG:900913'
    });
    // @namespace SVG; @section
    // There are several static functions which can be called without instantiating L.SVG:
    // @function create(name: String): SVGElement
    // Returns a instance of [SVGElement](https://developer.mozilla.org/docs/Web/API/SVGElement),
    // corresponding to the class name passed. For example, using 'line' will return
    // an instance of [SVGLineElement](https://developer.mozilla.org/docs/Web/API/SVGLineElement).
    function svgCreate(name) {
        return document.createElementNS('http://www.w3.org/2000/svg', name);
    }
    // @function pointsToPath(rings: Point[], closed: Boolean): String
    // Generates a SVG path string for multiple rings, with each ring turning
    // into "M..L..L.." instructions
    function pointsToPath(rings, closed) {
        var str = '', i, j, len, len2, points, p;
        for(i = 0, len = rings.length; i < len; i++){
            points = rings[i];
            for(j = 0, len2 = points.length; j < len2; j++){
                p = points[j];
                str += (j ? 'L' : 'M') + p.x + ' ' + p.y;
            }
            // closes the ring for polygons; "x" is VML syntax
            str += closed ? Browser.svg ? 'z' : 'x' : '';
        }
        // SVG complains about empty path strings
        return str || 'M0 0';
    }
    /*
   * @namespace Browser
   * @aka L.Browser
   *
   * A namespace with static properties for browser/feature detection used by Leaflet internally.
   *
   * @example
   *
   * ```js
   * if (L.Browser.ielt9) {
   *   alert('Upgrade your browser, dude!');
   * }
   * ```
   */ var style = document.documentElement.style;
    // @property ie: Boolean; `true` for all Internet Explorer versions (not Edge).
    var ie = 'ActiveXObject' in window;
    // @property ielt9: Boolean; `true` for Internet Explorer versions less than 9.
    var ielt9 = ie && !document.addEventListener;
    // @property edge: Boolean; `true` for the Edge web browser.
    var edge = 'msLaunchUri' in navigator && !('documentMode' in document);
    // @property webkit: Boolean;
    // `true` for webkit-based browsers like Chrome and Safari (including mobile versions).
    var webkit = userAgentContains('webkit');
    // @property android: Boolean
    // **Deprecated.** `true` for any browser running on an Android platform.
    var android = userAgentContains('android');
    // @property android23: Boolean; **Deprecated.** `true` for browsers running on Android 2 or Android 3.
    var android23 = userAgentContains('android 2') || userAgentContains('android 3');
    /* See https://stackoverflow.com/a/17961266 for details on detecting stock Android */ var webkitVer = parseInt(/WebKit\/([0-9]+)|$/.exec(navigator.userAgent)[1], 10); // also matches AppleWebKit
    // @property androidStock: Boolean; **Deprecated.** `true` for the Android stock browser (i.e. not Chrome)
    var androidStock = android && userAgentContains('Google') && webkitVer < 537 && !('AudioNode' in window);
    // @property opera: Boolean; `true` for the Opera browser
    var opera = !!window.opera;
    // @property chrome: Boolean; `true` for the Chrome browser.
    var chrome = !edge && userAgentContains('chrome');
    // @property gecko: Boolean; `true` for gecko-based browsers like Firefox.
    var gecko = userAgentContains('gecko') && !webkit && !opera && !ie;
    // @property safari: Boolean; `true` for the Safari browser.
    var safari = !chrome && userAgentContains('safari');
    var phantom = userAgentContains('phantom');
    // @property opera12: Boolean
    // `true` for the Opera browser supporting CSS transforms (version 12 or later).
    var opera12 = 'OTransition' in style;
    // @property win: Boolean; `true` when the browser is running in a Windows platform
    var win = navigator.platform.indexOf('Win') === 0;
    // @property ie3d: Boolean; `true` for all Internet Explorer versions supporting CSS transforms.
    var ie3d = ie && 'transition' in style;
    // @property webkit3d: Boolean; `true` for webkit-based browsers supporting CSS transforms.
    var webkit3d = 'WebKitCSSMatrix' in window && 'm11' in new window.WebKitCSSMatrix() && !android23;
    // @property gecko3d: Boolean; `true` for gecko-based browsers supporting CSS transforms.
    var gecko3d = 'MozPerspective' in style;
    // @property any3d: Boolean
    // `true` for all browsers supporting CSS transforms.
    var any3d = !window.L_DISABLE_3D && (ie3d || webkit3d || gecko3d) && !opera12 && !phantom;
    // @property mobile: Boolean; `true` for all browsers running in a mobile device.
    var mobile = typeof orientation !== 'undefined' || userAgentContains('mobile');
    // @property mobileWebkit: Boolean; `true` for all webkit-based browsers in a mobile device.
    var mobileWebkit = mobile && webkit;
    // @property mobileWebkit3d: Boolean
    // `true` for all webkit-based browsers in a mobile device supporting CSS transforms.
    var mobileWebkit3d = mobile && webkit3d;
    // @property msPointer: Boolean
    // `true` for browsers implementing the Microsoft touch events model (notably IE10).
    var msPointer = !window.PointerEvent && window.MSPointerEvent;
    // @property pointer: Boolean
    // `true` for all browsers supporting [pointer events](https://msdn.microsoft.com/en-us/library/dn433244%28v=vs.85%29.aspx).
    var pointer = !!(window.PointerEvent || msPointer);
    // @property touchNative: Boolean
    // `true` for all browsers supporting [touch events](https://developer.mozilla.org/docs/Web/API/Touch_events).
    // **This does not necessarily mean** that the browser is running in a computer with
    // a touchscreen, it only means that the browser is capable of understanding
    // touch events.
    var touchNative = 'ontouchstart' in window || !!window.TouchEvent;
    // @property touch: Boolean
    // `true` for all browsers supporting either [touch](#browser-touch) or [pointer](#browser-pointer) events.
    // Note: pointer events will be preferred (if available), and processed for all `touch*` listeners.
    var touch = !window.L_NO_TOUCH && (touchNative || pointer);
    // @property mobileOpera: Boolean; `true` for the Opera browser in a mobile device.
    var mobileOpera = mobile && opera;
    // @property mobileGecko: Boolean
    // `true` for gecko-based browsers running in a mobile device.
    var mobileGecko = mobile && gecko;
    // @property retina: Boolean
    // `true` for browsers on a high-resolution "retina" screen or on any screen when browser's display zoom is more than 100%.
    var retina = (window.devicePixelRatio || window.screen.deviceXDPI / window.screen.logicalXDPI) > 1;
    // @property passiveEvents: Boolean
    // `true` for browsers that support passive events.
    var passiveEvents = function() {
        var supportsPassiveOption = false;
        try {
            var opts = Object.defineProperty({}, 'passive', {
                get: function() {
                    supportsPassiveOption = true;
                }
            });
            window.addEventListener('testPassiveEventSupport', falseFn, opts);
            window.removeEventListener('testPassiveEventSupport', falseFn, opts);
        } catch (e) {
        // Errors can safely be ignored since this is only a browser support test.
        }
        return supportsPassiveOption;
    }();
    // @property canvas: Boolean
    // `true` when the browser supports [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
    var canvas$1 = function() {
        return !!document.createElement('canvas').getContext;
    }();
    // @property svg: Boolean
    // `true` when the browser supports [SVG](https://developer.mozilla.org/docs/Web/SVG).
    var svg$1 = !!(document.createElementNS && svgCreate('svg').createSVGRect);
    var inlineSvg = !!svg$1 && function() {
        var div = document.createElement('div');
        div.innerHTML = '<svg/>';
        return (div.firstChild && div.firstChild.namespaceURI) === 'http://www.w3.org/2000/svg';
    }();
    // @property vml: Boolean
    // `true` if the browser supports [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language).
    var vml = !svg$1 && function() {
        try {
            var div = document.createElement('div');
            div.innerHTML = '<v:shape adj="1"/>';
            var shape = div.firstChild;
            shape.style.behavior = 'url(#default#VML)';
            return shape && typeof shape.adj === 'object';
        } catch (e) {
            return false;
        }
    }();
    // @property mac: Boolean; `true` when the browser is running in a Mac platform
    var mac = navigator.platform.indexOf('Mac') === 0;
    // @property mac: Boolean; `true` when the browser is running in a Linux platform
    var linux = navigator.platform.indexOf('Linux') === 0;
    function userAgentContains(str) {
        return navigator.userAgent.toLowerCase().indexOf(str) >= 0;
    }
    var Browser = {
        ie: ie,
        ielt9: ielt9,
        edge: edge,
        webkit: webkit,
        android: android,
        android23: android23,
        androidStock: androidStock,
        opera: opera,
        chrome: chrome,
        gecko: gecko,
        safari: safari,
        phantom: phantom,
        opera12: opera12,
        win: win,
        ie3d: ie3d,
        webkit3d: webkit3d,
        gecko3d: gecko3d,
        any3d: any3d,
        mobile: mobile,
        mobileWebkit: mobileWebkit,
        mobileWebkit3d: mobileWebkit3d,
        msPointer: msPointer,
        pointer: pointer,
        touch: touch,
        touchNative: touchNative,
        mobileOpera: mobileOpera,
        mobileGecko: mobileGecko,
        retina: retina,
        passiveEvents: passiveEvents,
        canvas: canvas$1,
        svg: svg$1,
        vml: vml,
        inlineSvg: inlineSvg,
        mac: mac,
        linux: linux
    };
    /*
   * Extends L.DomEvent to provide touch support for Internet Explorer and Windows-based devices.
   */ var POINTER_DOWN = Browser.msPointer ? 'MSPointerDown' : 'pointerdown';
    var POINTER_MOVE = Browser.msPointer ? 'MSPointerMove' : 'pointermove';
    var POINTER_UP = Browser.msPointer ? 'MSPointerUp' : 'pointerup';
    var POINTER_CANCEL = Browser.msPointer ? 'MSPointerCancel' : 'pointercancel';
    var pEvent = {
        touchstart: POINTER_DOWN,
        touchmove: POINTER_MOVE,
        touchend: POINTER_UP,
        touchcancel: POINTER_CANCEL
    };
    var handle = {
        touchstart: _onPointerStart,
        touchmove: _handlePointer,
        touchend: _handlePointer,
        touchcancel: _handlePointer
    };
    var _pointers = {};
    var _pointerDocListener = false;
    // Provides a touch events wrapper for (ms)pointer events.
    // ref https://www.w3.org/TR/pointerevents/ https://www.w3.org/Bugs/Public/show_bug.cgi?id=22890
    function addPointerListener(obj, type, handler) {
        if (type === 'touchstart') _addPointerDocListener();
        if (!handle[type]) {
            console.warn('wrong event specified:', type);
            return falseFn;
        }
        handler = handle[type].bind(this, handler);
        obj.addEventListener(pEvent[type], handler, false);
        return handler;
    }
    function removePointerListener(obj, type, handler) {
        if (!pEvent[type]) {
            console.warn('wrong event specified:', type);
            return;
        }
        obj.removeEventListener(pEvent[type], handler, false);
    }
    function _globalPointerDown(e) {
        _pointers[e.pointerId] = e;
    }
    function _globalPointerMove(e) {
        if (_pointers[e.pointerId]) _pointers[e.pointerId] = e;
    }
    function _globalPointerUp(e) {
        delete _pointers[e.pointerId];
    }
    function _addPointerDocListener() {
        // need to keep track of what pointers and how many are active to provide e.touches emulation
        if (!_pointerDocListener) {
            // we listen document as any drags that end by moving the touch off the screen get fired there
            document.addEventListener(POINTER_DOWN, _globalPointerDown, true);
            document.addEventListener(POINTER_MOVE, _globalPointerMove, true);
            document.addEventListener(POINTER_UP, _globalPointerUp, true);
            document.addEventListener(POINTER_CANCEL, _globalPointerUp, true);
            _pointerDocListener = true;
        }
    }
    function _handlePointer(handler, e) {
        if (e.pointerType === (e.MSPOINTER_TYPE_MOUSE || 'mouse')) return;
        e.touches = [];
        for(var i in _pointers)e.touches.push(_pointers[i]);
        e.changedTouches = [
            e
        ];
        handler(e);
    }
    function _onPointerStart(handler, e) {
        // IE10 specific: MsTouch needs preventDefault. See #2000
        if (e.MSPOINTER_TYPE_TOUCH && e.pointerType === e.MSPOINTER_TYPE_TOUCH) preventDefault(e);
        _handlePointer(handler, e);
    }
    /*
   * Extends the event handling code with double tap support for mobile browsers.
   *
   * Note: currently most browsers fire native dblclick, with only a few exceptions
   * (see https://github.com/Leaflet/Leaflet/issues/7012#issuecomment-595087386)
   */ function makeDblclick(event) {
        // in modern browsers `type` cannot be just overridden:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only
        var newEvent = {}, prop, i;
        for(i in event){
            prop = event[i];
            newEvent[i] = prop && prop.bind ? prop.bind(event) : prop;
        }
        event = newEvent;
        newEvent.type = 'dblclick';
        newEvent.detail = 2;
        newEvent.isTrusted = false;
        newEvent._simulated = true; // for debug purposes
        return newEvent;
    }
    var delay = 200;
    function addDoubleTapListener(obj, handler) {
        // Most browsers handle double tap natively
        obj.addEventListener('dblclick', handler);
        // On some platforms the browser doesn't fire native dblclicks for touch events.
        // It seems that in all such cases `detail` property of `click` event is always `1`.
        // So here we rely on that fact to avoid excessive 'dblclick' simulation when not needed.
        var last = 0, detail;
        function simDblclick(e) {
            if (e.detail !== 1) {
                detail = e.detail; // keep in sync to avoid false dblclick in some cases
                return;
            }
            if (e.pointerType === 'mouse' || e.sourceCapabilities && !e.sourceCapabilities.firesTouchEvents) return;
            // When clicking on an <input>, the browser generates a click on its
            // <label> (and vice versa) triggering two clicks in quick succession.
            // This ignores clicks on elements which are a label with a 'for'
            // attribute (or children of such a label), but not children of
            // a <input>.
            var path = getPropagationPath(e);
            if (path.some(function(el) {
                return el instanceof HTMLLabelElement && el.attributes.for;
            }) && !path.some(function(el) {
                return el instanceof HTMLInputElement || el instanceof HTMLSelectElement;
            })) return;
            var now = Date.now();
            if (now - last <= delay) {
                detail++;
                if (detail === 2) handler(makeDblclick(e));
            } else detail = 1;
            last = now;
        }
        obj.addEventListener('click', simDblclick);
        return {
            dblclick: handler,
            simDblclick: simDblclick
        };
    }
    function removeDoubleTapListener(obj, handlers) {
        obj.removeEventListener('dblclick', handlers.dblclick);
        obj.removeEventListener('click', handlers.simDblclick);
    }
    /*
   * @namespace DomUtil
   *
   * Utility functions to work with the [DOM](https://developer.mozilla.org/docs/Web/API/Document_Object_Model)
   * tree, used by Leaflet internally.
   *
   * Most functions expecting or returning a `HTMLElement` also work for
   * SVG elements. The only difference is that classes refer to CSS classes
   * in HTML and SVG classes in SVG.
   */ // @property TRANSFORM: String
    // Vendor-prefixed transform style name (e.g. `'webkitTransform'` for WebKit).
    var TRANSFORM = testProp([
        'transform',
        'webkitTransform',
        'OTransform',
        'MozTransform',
        'msTransform'
    ]);
    // webkitTransition comes first because some browser versions that drop vendor prefix don't do
    // the same for the transitionend event, in particular the Android 4.1 stock browser
    // @property TRANSITION: String
    // Vendor-prefixed transition style name.
    var TRANSITION = testProp([
        'webkitTransition',
        'transition',
        'OTransition',
        'MozTransition',
        'msTransition'
    ]);
    // @property TRANSITION_END: String
    // Vendor-prefixed transitionend event name.
    var TRANSITION_END = TRANSITION === 'webkitTransition' || TRANSITION === 'OTransition' ? TRANSITION + 'End' : 'transitionend';
    // @function get(id: String|HTMLElement): HTMLElement
    // Returns an element given its DOM id, or returns the element itself
    // if it was passed directly.
    function get(id) {
        return typeof id === 'string' ? document.getElementById(id) : id;
    }
    // @function getStyle(el: HTMLElement, styleAttrib: String): String
    // Returns the value for a certain style attribute on an element,
    // including computed values or values set through CSS.
    function getStyle(el, style) {
        var value = el.style[style] || el.currentStyle && el.currentStyle[style];
        if ((!value || value === 'auto') && document.defaultView) {
            var css = document.defaultView.getComputedStyle(el, null);
            value = css ? css[style] : null;
        }
        return value === 'auto' ? null : value;
    }
    // @function create(tagName: String, className?: String, container?: HTMLElement): HTMLElement
    // Creates an HTML element with `tagName`, sets its class to `className`, and optionally appends it to `container` element.
    function create$1(tagName, className, container) {
        var el = document.createElement(tagName);
        el.className = className || '';
        if (container) container.appendChild(el);
        return el;
    }
    // @function remove(el: HTMLElement)
    // Removes `el` from its parent element
    function remove(el) {
        var parent = el.parentNode;
        if (parent) parent.removeChild(el);
    }
    // @function empty(el: HTMLElement)
    // Removes all of `el`'s children elements from `el`
    function empty(el) {
        while(el.firstChild)el.removeChild(el.firstChild);
    }
    // @function toFront(el: HTMLElement)
    // Makes `el` the last child of its parent, so it renders in front of the other children.
    function toFront(el) {
        var parent = el.parentNode;
        if (parent && parent.lastChild !== el) parent.appendChild(el);
    }
    // @function toBack(el: HTMLElement)
    // Makes `el` the first child of its parent, so it renders behind the other children.
    function toBack(el) {
        var parent = el.parentNode;
        if (parent && parent.firstChild !== el) parent.insertBefore(el, parent.firstChild);
    }
    // @function hasClass(el: HTMLElement, name: String): Boolean
    // Returns `true` if the element's class attribute contains `name`.
    function hasClass(el, name) {
        if (el.classList !== undefined) return el.classList.contains(name);
        var className = getClass(el);
        return className.length > 0 && new RegExp('(^|\\s)' + name + '(\\s|$)').test(className);
    }
    // @function addClass(el: HTMLElement, name: String)
    // Adds `name` to the element's class attribute.
    function addClass(el, name) {
        if (el.classList !== undefined) {
            var classes = splitWords(name);
            for(var i = 0, len = classes.length; i < len; i++)el.classList.add(classes[i]);
        } else if (!hasClass(el, name)) {
            var className = getClass(el);
            setClass(el, (className ? className + ' ' : '') + name);
        }
    }
    // @function removeClass(el: HTMLElement, name: String)
    // Removes `name` from the element's class attribute.
    function removeClass(el, name) {
        if (el.classList !== undefined) el.classList.remove(name);
        else setClass(el, trim((' ' + getClass(el) + ' ').replace(' ' + name + ' ', ' ')));
    }
    // @function setClass(el: HTMLElement, name: String)
    // Sets the element's class.
    function setClass(el, name) {
        if (el.className.baseVal === undefined) el.className = name;
        else // in case of SVG element
        el.className.baseVal = name;
    }
    // @function getClass(el: HTMLElement): String
    // Returns the element's class.
    function getClass(el) {
        // Check if the element is an SVGElementInstance and use the correspondingElement instead
        // (Required for linked SVG elements in IE11.)
        if (el.correspondingElement) el = el.correspondingElement;
        return el.className.baseVal === undefined ? el.className : el.className.baseVal;
    }
    // @function setOpacity(el: HTMLElement, opacity: Number)
    // Set the opacity of an element (including old IE support).
    // `opacity` must be a number from `0` to `1`.
    function setOpacity(el, value) {
        if ('opacity' in el.style) el.style.opacity = value;
        else if ('filter' in el.style) _setOpacityIE(el, value);
    }
    function _setOpacityIE(el, value) {
        var filter = false, filterName = 'DXImageTransform.Microsoft.Alpha';
        // filters collection throws an error if we try to retrieve a filter that doesn't exist
        try {
            filter = el.filters.item(filterName);
        } catch (e) {
            // don't set opacity to 1 if we haven't already set an opacity,
            // it isn't needed and breaks transparent pngs.
            if (value === 1) return;
        }
        value = Math.round(value * 100);
        if (filter) {
            filter.Enabled = value !== 100;
            filter.Opacity = value;
        } else el.style.filter += ' progid:' + filterName + '(opacity=' + value + ')';
    }
    // @function testProp(props: String[]): String|false
    // Goes through the array of style names and returns the first name
    // that is a valid style name for an element. If no such name is found,
    // it returns false. Useful for vendor-prefixed styles like `transform`.
    function testProp(props) {
        var style = document.documentElement.style;
        for(var i = 0; i < props.length; i++){
            if (props[i] in style) return props[i];
        }
        return false;
    }
    // @function setTransform(el: HTMLElement, offset: Point, scale?: Number)
    // Resets the 3D CSS transform of `el` so it is translated by `offset` pixels
    // and optionally scaled by `scale`. Does not have an effect if the
    // browser doesn't support 3D CSS transforms.
    function setTransform(el, offset, scale) {
        var pos = offset || new Point(0, 0);
        el.style[TRANSFORM] = (Browser.ie3d ? 'translate(' + pos.x + 'px,' + pos.y + 'px)' : 'translate3d(' + pos.x + 'px,' + pos.y + 'px,0)') + (scale ? ' scale(' + scale + ')' : '');
    }
    // @function setPosition(el: HTMLElement, position: Point)
    // Sets the position of `el` to coordinates specified by `position`,
    // using CSS translate or top/left positioning depending on the browser
    // (used by Leaflet internally to position its layers).
    function setPosition(el, point) {
        /*eslint-disable */ el._leaflet_pos = point;
        /* eslint-enable */ if (Browser.any3d) setTransform(el, point);
        else {
            el.style.left = point.x + 'px';
            el.style.top = point.y + 'px';
        }
    }
    // @function getPosition(el: HTMLElement): Point
    // Returns the coordinates of an element previously positioned with setPosition.
    function getPosition(el) {
        // this method is only used for elements previously positioned using setPosition,
        // so it's safe to cache the position for performance
        return el._leaflet_pos || new Point(0, 0);
    }
    // @function disableTextSelection()
    // Prevents the user from generating `selectstart` DOM events, usually generated
    // when the user drags the mouse through a page with text. Used internally
    // by Leaflet to override the behaviour of any click-and-drag interaction on
    // the map. Affects drag interactions on the whole document.
    // @function enableTextSelection()
    // Cancels the effects of a previous [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection).
    var disableTextSelection;
    var enableTextSelection;
    var _userSelect;
    if ('onselectstart' in document) {
        disableTextSelection = function() {
            on(window, 'selectstart', preventDefault);
        };
        enableTextSelection = function() {
            off(window, 'selectstart', preventDefault);
        };
    } else {
        var userSelectProperty = testProp([
            'userSelect',
            'WebkitUserSelect',
            'OUserSelect',
            'MozUserSelect',
            'msUserSelect'
        ]);
        disableTextSelection = function() {
            if (userSelectProperty) {
                var style = document.documentElement.style;
                _userSelect = style[userSelectProperty];
                style[userSelectProperty] = 'none';
            }
        };
        enableTextSelection = function() {
            if (userSelectProperty) {
                document.documentElement.style[userSelectProperty] = _userSelect;
                _userSelect = undefined;
            }
        };
    }
    // @function disableImageDrag()
    // As [`L.DomUtil.disableTextSelection`](#domutil-disabletextselection), but
    // for `dragstart` DOM events, usually generated when the user drags an image.
    function disableImageDrag() {
        on(window, 'dragstart', preventDefault);
    }
    // @function enableImageDrag()
    // Cancels the effects of a previous [`L.DomUtil.disableImageDrag`](#domutil-disabletextselection).
    function enableImageDrag() {
        off(window, 'dragstart', preventDefault);
    }
    var _outlineElement, _outlineStyle;
    // @function preventOutline(el: HTMLElement)
    // Makes the [outline](https://developer.mozilla.org/docs/Web/CSS/outline)
    // of the element `el` invisible. Used internally by Leaflet to prevent
    // focusable elements from displaying an outline when the user performs a
    // drag interaction on them.
    function preventOutline(element) {
        while(element.tabIndex === -1)element = element.parentNode;
        if (!element.style) return;
        restoreOutline();
        _outlineElement = element;
        _outlineStyle = element.style.outlineStyle;
        element.style.outlineStyle = 'none';
        on(window, 'keydown', restoreOutline);
    }
    // @function restoreOutline()
    // Cancels the effects of a previous [`L.DomUtil.preventOutline`]().
    function restoreOutline() {
        if (!_outlineElement) return;
        _outlineElement.style.outlineStyle = _outlineStyle;
        _outlineElement = undefined;
        _outlineStyle = undefined;
        off(window, 'keydown', restoreOutline);
    }
    // @function getSizedParentNode(el: HTMLElement): HTMLElement
    // Finds the closest parent node which size (width and height) is not null.
    function getSizedParentNode(element) {
        do element = element.parentNode;
        while ((!element.offsetWidth || !element.offsetHeight) && element !== document.body);
        return element;
    }
    // @function getScale(el: HTMLElement): Object
    // Computes the CSS scale currently applied on the element.
    // Returns an object with `x` and `y` members as horizontal and vertical scales respectively,
    // and `boundingClientRect` as the result of [`getBoundingClientRect()`](https://developer.mozilla.org/en-US/docs/Web/API/Element/getBoundingClientRect).
    function getScale(element) {
        var rect = element.getBoundingClientRect(); // Read-only in old browsers.
        return {
            x: rect.width / element.offsetWidth || 1,
            y: rect.height / element.offsetHeight || 1,
            boundingClientRect: rect
        };
    }
    var DomUtil = {
        __proto__: null,
        TRANSFORM: TRANSFORM,
        TRANSITION: TRANSITION,
        TRANSITION_END: TRANSITION_END,
        get: get,
        getStyle: getStyle,
        create: create$1,
        remove: remove,
        empty: empty,
        toFront: toFront,
        toBack: toBack,
        hasClass: hasClass,
        addClass: addClass,
        removeClass: removeClass,
        setClass: setClass,
        getClass: getClass,
        setOpacity: setOpacity,
        testProp: testProp,
        setTransform: setTransform,
        setPosition: setPosition,
        getPosition: getPosition,
        get disableTextSelection () {
            return disableTextSelection;
        },
        get enableTextSelection () {
            return enableTextSelection;
        },
        disableImageDrag: disableImageDrag,
        enableImageDrag: enableImageDrag,
        preventOutline: preventOutline,
        restoreOutline: restoreOutline,
        getSizedParentNode: getSizedParentNode,
        getScale: getScale
    };
    /*
   * @namespace DomEvent
   * Utility functions to work with the [DOM events](https://developer.mozilla.org/docs/Web/API/Event), used by Leaflet internally.
   */ // Inspired by John Resig, Dean Edwards and YUI addEvent implementations.
    // @function on(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Adds a listener function (`fn`) to a particular DOM event type of the
    // element `el`. You can optionally specify the context of the listener
    // (object the `this` keyword will point to). You can also pass several
    // space-separated types (e.g. `'click dblclick'`).
    // @alternative
    // @function on(el: HTMLElement, eventMap: Object, context?: Object): this
    // Adds a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    function on(obj, types, fn, context) {
        if (types && typeof types === 'object') for(var type in types)addOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            for(var i = 0, len = types.length; i < len; i++)addOne(obj, types[i], fn, context);
        }
        return this;
    }
    var eventsKey = '_leaflet_events';
    // @function off(el: HTMLElement, types: String, fn: Function, context?: Object): this
    // Removes a previously added listener function.
    // Note that if you passed a custom context to on, you must pass the same
    // context to `off` in order to remove the listener.
    // @alternative
    // @function off(el: HTMLElement, eventMap: Object, context?: Object): this
    // Removes a set of type/listener pairs, e.g. `{click: onClick, mousemove: onMouseMove}`
    // @alternative
    // @function off(el: HTMLElement, types: String): this
    // Removes all previously added listeners of given types.
    // @alternative
    // @function off(el: HTMLElement): this
    // Removes all previously added listeners from given HTMLElement
    function off(obj, types, fn, context) {
        if (arguments.length === 1) {
            batchRemove(obj);
            delete obj[eventsKey];
        } else if (types && typeof types === 'object') for(var type in types)removeOne(obj, type, types[type], fn);
        else {
            types = splitWords(types);
            if (arguments.length === 2) batchRemove(obj, function(type) {
                return indexOf(types, type) !== -1;
            });
            else for(var i = 0, len = types.length; i < len; i++)removeOne(obj, types[i], fn, context);
        }
        return this;
    }
    function batchRemove(obj, filterFn) {
        for(var id in obj[eventsKey]){
            var type = id.split(/\d/)[0];
            if (!filterFn || filterFn(type)) removeOne(obj, type, null, null, id);
        }
    }
    var mouseSubst = {
        mouseenter: 'mouseover',
        mouseleave: 'mouseout',
        wheel: !('onwheel' in window) && 'mousewheel'
    };
    function addOne(obj, type, fn, context) {
        var id = type + stamp(fn) + (context ? '_' + stamp(context) : '');
        if (obj[eventsKey] && obj[eventsKey][id]) return this;
        var handler = function(e) {
            return fn.call(context || obj, e || window.event);
        };
        var originalHandler = handler;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) // Needs DomEvent.Pointer.js
        handler = addPointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') handler = addDoubleTapListener(obj, handler);
        else if ('addEventListener' in obj) {
            if (type === 'touchstart' || type === 'touchmove' || type === 'wheel' || type === 'mousewheel') obj.addEventListener(mouseSubst[type] || type, handler, Browser.passiveEvents ? {
                passive: false
            } : false);
            else if (type === 'mouseenter' || type === 'mouseleave') {
                handler = function(e) {
                    e = e || window.event;
                    if (isExternalTarget(obj, e)) originalHandler(e);
                };
                obj.addEventListener(mouseSubst[type], handler, false);
            } else obj.addEventListener(type, originalHandler, false);
        } else obj.attachEvent('on' + type, handler);
        obj[eventsKey] = obj[eventsKey] || {};
        obj[eventsKey][id] = handler;
    }
    function removeOne(obj, type, fn, context, id) {
        id = id || type + stamp(fn) + (context ? '_' + stamp(context) : '');
        var handler = obj[eventsKey] && obj[eventsKey][id];
        if (!handler) return this;
        if (!Browser.touchNative && Browser.pointer && type.indexOf('touch') === 0) removePointerListener(obj, type, handler);
        else if (Browser.touch && type === 'dblclick') removeDoubleTapListener(obj, handler);
        else if ('removeEventListener' in obj) obj.removeEventListener(mouseSubst[type] || type, handler, false);
        else obj.detachEvent('on' + type, handler);
        obj[eventsKey][id] = null;
    }
    // @function stopPropagation(ev: DOMEvent): this
    // Stop the given event from propagation to parent elements. Used inside the listener functions:
    // ```js
    // L.DomEvent.on(div, 'click', function (ev) {
    // 	L.DomEvent.stopPropagation(ev);
    // });
    // ```
    function stopPropagation(e) {
        if (e.stopPropagation) e.stopPropagation();
        else if (e.originalEvent) e.originalEvent._stopped = true;
        else e.cancelBubble = true;
        return this;
    }
    // @function disableScrollPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'wheel'` events (plus browser variants).
    function disableScrollPropagation(el) {
        addOne(el, 'wheel', stopPropagation);
        return this;
    }
    // @function disableClickPropagation(el: HTMLElement): this
    // Adds `stopPropagation` to the element's `'click'`, `'dblclick'`, `'contextmenu'`,
    // `'mousedown'` and `'touchstart'` events (plus browser variants).
    function disableClickPropagation(el) {
        on(el, 'mousedown touchstart dblclick contextmenu', stopPropagation);
        el['_leaflet_disable_click'] = true;
        return this;
    }
    // @function preventDefault(ev: DOMEvent): this
    // Prevents the default action of the DOM Event `ev` from happening (such as
    // following a link in the href of the a element, or doing a POST request
    // with page reload when a `<form>` is submitted).
    // Use it inside listener functions.
    function preventDefault(e) {
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return this;
    }
    // @function stop(ev: DOMEvent): this
    // Does `stopPropagation` and `preventDefault` at the same time.
    function stop(e) {
        preventDefault(e);
        stopPropagation(e);
        return this;
    }
    // @function getPropagationPath(ev: DOMEvent): Array
    // Compatibility polyfill for [`Event.composedPath()`](https://developer.mozilla.org/en-US/docs/Web/API/Event/composedPath).
    // Returns an array containing the `HTMLElement`s that the given DOM event
    // should propagate to (if not stopped).
    function getPropagationPath(ev) {
        if (ev.composedPath) return ev.composedPath();
        var path = [];
        var el = ev.target;
        while(el){
            path.push(el);
            el = el.parentNode;
        }
        return path;
    }
    // @function getMousePosition(ev: DOMEvent, container?: HTMLElement): Point
    // Gets normalized mouse position from a DOM event relative to the
    // `container` (border excluded) or to the whole page if not specified.
    function getMousePosition(e, container) {
        if (!container) return new Point(e.clientX, e.clientY);
        var scale = getScale(container), offset = scale.boundingClientRect; // left and top  values are in page scale (like the event clientX/Y)
        return new Point(// offset.left/top values are in page scale (like clientX/Y),
        // whereas clientLeft/Top (border width) values are the original values (before CSS scale applies).
        (e.clientX - offset.left) / scale.x - container.clientLeft, (e.clientY - offset.top) / scale.y - container.clientTop);
    }
    //  except , Safari and
    // We need double the scroll pixels (see #7403 and #4538) for all Browsers
    // except OSX (Mac) -> 3x, Chrome running on Linux 1x
    var wheelPxFactor = Browser.linux && Browser.chrome ? window.devicePixelRatio : Browser.mac ? window.devicePixelRatio * 3 : window.devicePixelRatio > 0 ? 2 * window.devicePixelRatio : 1;
    // @function getWheelDelta(ev: DOMEvent): Number
    // Gets normalized wheel delta from a wheel DOM event, in vertical
    // pixels scrolled (negative if scrolling down).
    // Events from pointing devices without precise scrolling are mapped to
    // a best guess of 60 pixels.
    function getWheelDelta(e) {
        return Browser.edge ? e.wheelDeltaY / 2 : e.deltaY && e.deltaMode === 0 ? -e.deltaY / wheelPxFactor : e.deltaY && e.deltaMode === 1 ? -e.deltaY * 20 : e.deltaY && e.deltaMode === 2 ? -e.deltaY * 60 : e.deltaX || e.deltaZ ? 0 : e.wheelDelta ? (e.wheelDeltaY || e.wheelDelta) / 2 : e.detail && Math.abs(e.detail) < 32765 ? -e.detail * 20 : e.detail ? e.detail / -32765 * 60 : 0;
    }
    // check if element really left/entered the event target (for mouseenter/mouseleave)
    function isExternalTarget(el, e) {
        var related = e.relatedTarget;
        if (!related) return true;
        try {
            while(related && related !== el)related = related.parentNode;
        } catch (err) {
            return false;
        }
        return related !== el;
    }
    var DomEvent = {
        __proto__: null,
        on: on,
        off: off,
        stopPropagation: stopPropagation,
        disableScrollPropagation: disableScrollPropagation,
        disableClickPropagation: disableClickPropagation,
        preventDefault: preventDefault,
        stop: stop,
        getPropagationPath: getPropagationPath,
        getMousePosition: getMousePosition,
        getWheelDelta: getWheelDelta,
        isExternalTarget: isExternalTarget,
        addListener: on,
        removeListener: off
    };
    /*
   * @class PosAnimation
   * @aka L.PosAnimation
   * @inherits Evented
   * Used internally for panning animations, utilizing CSS3 Transitions for modern browsers and a timer fallback for IE6-9.
   *
   * @example
   * ```js
   * var myPositionMarker = L.marker([48.864716, 2.294694]).addTo(map);
   *
   * myPositionMarker.on("click", function() {
   * 	var pos = map.latLngToLayerPoint(myPositionMarker.getLatLng());
   * 	pos.y -= 25;
   * 	var fx = new L.PosAnimation();
   *
   * 	fx.once('end',function() {
   * 		pos.y += 25;
   * 		fx.run(myPositionMarker._icon, pos, 0.8);
   * 	});
   *
   * 	fx.run(myPositionMarker._icon, pos, 0.3);
   * });
   *
   * ```
   *
   * @constructor L.PosAnimation()
   * Creates a `PosAnimation` object.
   *
   */ var PosAnimation = Evented.extend({
        // @method run(el: HTMLElement, newPos: Point, duration?: Number, easeLinearity?: Number)
        // Run an animation of a given element to a new position, optionally setting
        // duration in seconds (`0.25` by default) and easing linearity factor (3rd
        // argument of the [cubic bezier curve](https://cubic-bezier.com/#0,0,.5,1),
        // `0.5` by default).
        run: function(el, newPos, duration, easeLinearity) {
            this.stop();
            this._el = el;
            this._inProgress = true;
            this._duration = duration || 0.25;
            this._easeOutPower = 1 / Math.max(easeLinearity || 0.5, 0.2);
            this._startPos = getPosition(el);
            this._offset = newPos.subtract(this._startPos);
            this._startTime = +new Date();
            // @event start: Event
            // Fired when the animation starts
            this.fire('start');
            this._animate();
        },
        // @method stop()
        // Stops the animation (if currently running).
        stop: function() {
            if (!this._inProgress) return;
            this._step(true);
            this._complete();
        },
        _animate: function() {
            // animation loop
            this._animId = requestAnimFrame(this._animate, this);
            this._step();
        },
        _step: function(round) {
            var elapsed = +new Date() - this._startTime, duration = this._duration * 1000;
            if (elapsed < duration) this._runFrame(this._easeOut(elapsed / duration), round);
            else {
                this._runFrame(1);
                this._complete();
            }
        },
        _runFrame: function(progress, round) {
            var pos = this._startPos.add(this._offset.multiplyBy(progress));
            if (round) pos._round();
            setPosition(this._el, pos);
            // @event step: Event
            // Fired continuously during the animation.
            this.fire('step');
        },
        _complete: function() {
            cancelAnimFrame(this._animId);
            this._inProgress = false;
            // @event end: Event
            // Fired when the animation ends.
            this.fire('end');
        },
        _easeOut: function(t) {
            return 1 - Math.pow(1 - t, this._easeOutPower);
        }
    });
    /*
   * @class Map
   * @aka L.Map
   * @inherits Evented
   *
   * The central class of the API — it is used to create a map on a page and manipulate it.
   *
   * @example
   *
   * ```js
   * // initialize the map on the "map" div with a given center and zoom
   * var map = L.map('map', {
   * 	center: [51.505, -0.09],
   * 	zoom: 13
   * });
   * ```
   *
   */ var Map = Evented.extend({
        options: {
            // @section Map State Options
            // @option crs: CRS = L.CRS.EPSG3857
            // The [Coordinate Reference System](#crs) to use. Don't change this if you're not
            // sure what it means.
            crs: EPSG3857,
            // @option center: LatLng = undefined
            // Initial geographic center of the map
            center: undefined,
            // @option zoom: Number = undefined
            // Initial map zoom level
            zoom: undefined,
            // @option minZoom: Number = *
            // Minimum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the lowest of their `minZoom` options will be used instead.
            minZoom: undefined,
            // @option maxZoom: Number = *
            // Maximum zoom level of the map.
            // If not specified and at least one `GridLayer` or `TileLayer` is in the map,
            // the highest of their `maxZoom` options will be used instead.
            maxZoom: undefined,
            // @option layers: Layer[] = []
            // Array of layers that will be added to the map initially
            layers: [],
            // @option maxBounds: LatLngBounds = null
            // When this option is set, the map restricts the view to the given
            // geographical bounds, bouncing the user back if the user tries to pan
            // outside the view. To set the restriction dynamically, use
            // [`setMaxBounds`](#map-setmaxbounds) method.
            maxBounds: undefined,
            // @option renderer: Renderer = *
            // The default method for drawing vector layers on the map. `L.SVG`
            // or `L.Canvas` by default depending on browser support.
            renderer: undefined,
            // @section Animation Options
            // @option zoomAnimation: Boolean = true
            // Whether the map zoom animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            zoomAnimation: true,
            // @option zoomAnimationThreshold: Number = 4
            // Won't animate zoom if the zoom difference exceeds this value.
            zoomAnimationThreshold: 4,
            // @option fadeAnimation: Boolean = true
            // Whether the tile fade animation is enabled. By default it's enabled
            // in all browsers that support CSS3 Transitions except Android.
            fadeAnimation: true,
            // @option markerZoomAnimation: Boolean = true
            // Whether markers animate their zoom with the zoom animation, if disabled
            // they will disappear for the length of the animation. By default it's
            // enabled in all browsers that support CSS3 Transitions except Android.
            markerZoomAnimation: true,
            // @option transform3DLimit: Number = 2^23
            // Defines the maximum size of a CSS translation transform. The default
            // value should not be changed unless a web browser positions layers in
            // the wrong place after doing a large `panBy`.
            transform3DLimit: 8388608,
            // @section Interaction Options
            // @option zoomSnap: Number = 1
            // Forces the map's zoom level to always be a multiple of this, particularly
            // right after a [`fitBounds()`](#map-fitbounds) or a pinch-zoom.
            // By default, the zoom level snaps to the nearest integer; lower values
            // (e.g. `0.5` or `0.1`) allow for greater granularity. A value of `0`
            // means the zoom level will not be snapped after `fitBounds` or a pinch-zoom.
            zoomSnap: 1,
            // @option zoomDelta: Number = 1
            // Controls how much the map's zoom level will change after a
            // [`zoomIn()`](#map-zoomin), [`zoomOut()`](#map-zoomout), pressing `+`
            // or `-` on the keyboard, or using the [zoom controls](#control-zoom).
            // Values smaller than `1` (e.g. `0.5`) allow for greater granularity.
            zoomDelta: 1,
            // @option trackResize: Boolean = true
            // Whether the map automatically handles browser window resize to update itself.
            trackResize: true
        },
        initialize: function(id, options) {
            options = setOptions(this, options);
            // Make sure to assign internal flags at the beginning,
            // to avoid inconsistent state in some edge cases.
            this._handlers = [];
            this._layers = {};
            this._zoomBoundLayers = {};
            this._sizeChanged = true;
            this._initContainer(id);
            this._initLayout();
            // hack for https://github.com/Leaflet/Leaflet/issues/1980
            this._onResize = bind(this._onResize, this);
            this._initEvents();
            if (options.maxBounds) this.setMaxBounds(options.maxBounds);
            if (options.zoom !== undefined) this._zoom = this._limitZoom(options.zoom);
            if (options.center && options.zoom !== undefined) this.setView(toLatLng(options.center), options.zoom, {
                reset: true
            });
            this.callInitHooks();
            // don't animate on browsers without hardware-accelerated transitions or old Android/Opera
            this._zoomAnimated = TRANSITION && Browser.any3d && !Browser.mobileOpera && this.options.zoomAnimation;
            // zoom transitions run with the same duration for all layers, so if one of transitionend events
            // happens after starting zoom animation (propagating to the map pane), we know that it ended globally
            if (this._zoomAnimated) {
                this._createAnimProxy();
                on(this._proxy, TRANSITION_END, this._catchTransitionEnd, this);
            }
            this._addLayers(this.options.layers);
        },
        // @section Methods for modifying map state
        // @method setView(center: LatLng, zoom: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) with the given
        // animation options.
        setView: function(center, zoom, options) {
            zoom = zoom === undefined ? this._zoom : this._limitZoom(zoom);
            center = this._limitCenter(toLatLng(center), zoom, this.options.maxBounds);
            options = options || {};
            this._stop();
            if (this._loaded && !options.reset && options !== true) {
                if (options.animate !== undefined) {
                    options.zoom = extend({
                        animate: options.animate
                    }, options.zoom);
                    options.pan = extend({
                        animate: options.animate,
                        duration: options.duration
                    }, options.pan);
                }
                // try animating pan or zoom
                var moved = this._zoom !== zoom ? this._tryAnimatedZoom && this._tryAnimatedZoom(center, zoom, options.zoom) : this._tryAnimatedPan(center, options.pan);
                if (moved) {
                    // prevent resize handler call, the view will refresh after animation anyway
                    clearTimeout(this._sizeTimer);
                    return this;
                }
            }
            // animation didn't start, just reset the map view
            this._resetView(center, zoom, options.pan && options.pan.noMoveStart);
            return this;
        },
        // @method setZoom(zoom: Number, options?: Zoom/pan options): this
        // Sets the zoom of the map.
        setZoom: function(zoom, options) {
            if (!this._loaded) {
                this._zoom = zoom;
                return this;
            }
            return this.setView(this.getCenter(), zoom, {
                zoom: options
            });
        },
        // @method zoomIn(delta?: Number, options?: Zoom options): this
        // Increases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomIn: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom + delta, options);
        },
        // @method zoomOut(delta?: Number, options?: Zoom options): this
        // Decreases the zoom of the map by `delta` ([`zoomDelta`](#map-zoomdelta) by default).
        zoomOut: function(delta, options) {
            delta = delta || (Browser.any3d ? this.options.zoomDelta : 1);
            return this.setZoom(this._zoom - delta, options);
        },
        // @method setZoomAround(latlng: LatLng, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified geographical point on the map
        // stationary (e.g. used internally for scroll zoom and double-click zoom).
        // @alternative
        // @method setZoomAround(offset: Point, zoom: Number, options: Zoom options): this
        // Zooms the map while keeping a specified pixel on the map (relative to the top-left corner) stationary.
        setZoomAround: function(latlng, zoom, options) {
            var scale = this.getZoomScale(zoom), viewHalf = this.getSize().divideBy(2), containerPoint = latlng instanceof Point ? latlng : this.latLngToContainerPoint(latlng), centerOffset = containerPoint.subtract(viewHalf).multiplyBy(1 - 1 / scale), newCenter = this.containerPointToLatLng(viewHalf.add(centerOffset));
            return this.setView(newCenter, zoom, {
                zoom: options
            });
        },
        _getBoundsCenterZoom: function(bounds, options) {
            options = options || {};
            bounds = bounds.getBounds ? bounds.getBounds() : toLatLngBounds(bounds);
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), zoom = this.getBoundsZoom(bounds, false, paddingTL.add(paddingBR));
            zoom = typeof options.maxZoom === 'number' ? Math.min(options.maxZoom, zoom) : zoom;
            if (zoom === Infinity) return {
                center: bounds.getCenter(),
                zoom: zoom
            };
            var paddingOffset = paddingBR.subtract(paddingTL).divideBy(2), swPoint = this.project(bounds.getSouthWest(), zoom), nePoint = this.project(bounds.getNorthEast(), zoom), center = this.unproject(swPoint.add(nePoint).divideBy(2).add(paddingOffset), zoom);
            return {
                center: center,
                zoom: zoom
            };
        },
        // @method fitBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets a map view that contains the given geographical bounds with the
        // maximum zoom level possible.
        fitBounds: function(bounds, options) {
            bounds = toLatLngBounds(bounds);
            if (!bounds.isValid()) throw new Error('Bounds are not valid.');
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.setView(target.center, target.zoom, options);
        },
        // @method fitWorld(options?: fitBounds options): this
        // Sets a map view that mostly contains the whole world with the maximum
        // zoom level possible.
        fitWorld: function(options) {
            return this.fitBounds([
                [
                    -90,
                    -180
                ],
                [
                    90,
                    180
                ]
            ], options);
        },
        // @method panTo(latlng: LatLng, options?: Pan options): this
        // Pans the map to a given center.
        panTo: function(center, options) {
            return this.setView(center, this._zoom, {
                pan: options
            });
        },
        // @method panBy(offset: Point, options?: Pan options): this
        // Pans the map by a given number of pixels (animated).
        panBy: function(offset, options) {
            offset = toPoint(offset).round();
            options = options || {};
            if (!offset.x && !offset.y) return this.fire('moveend');
            // If we pan too far, Chrome gets issues with tiles
            // and makes them disappear or appear in the wrong place (slightly offset) #2602
            if (options.animate !== true && !this.getSize().contains(offset)) {
                this._resetView(this.unproject(this.project(this.getCenter()).add(offset)), this.getZoom());
                return this;
            }
            if (!this._panAnim) {
                this._panAnim = new PosAnimation();
                this._panAnim.on({
                    'step': this._onPanTransitionStep,
                    'end': this._onPanTransitionEnd
                }, this);
            }
            // don't fire movestart if animating inertia
            if (!options.noMoveStart) this.fire('movestart');
            // animate pan unless animate: false specified
            if (options.animate !== false) {
                addClass(this._mapPane, 'leaflet-pan-anim');
                var newPos = this._getMapPanePos().subtract(offset).round();
                this._panAnim.run(this._mapPane, newPos, options.duration || 0.25, options.easeLinearity);
            } else {
                this._rawPanBy(offset);
                this.fire('move').fire('moveend');
            }
            return this;
        },
        // @method flyTo(latlng: LatLng, zoom?: Number, options?: Zoom/pan options): this
        // Sets the view of the map (geographical center and zoom) performing a smooth
        // pan-zoom animation.
        flyTo: function(targetCenter, targetZoom, options) {
            options = options || {};
            if (options.animate === false || !Browser.any3d) return this.setView(targetCenter, targetZoom, options);
            this._stop();
            var from = this.project(this.getCenter()), to = this.project(targetCenter), size = this.getSize(), startZoom = this._zoom;
            targetCenter = toLatLng(targetCenter);
            targetZoom = targetZoom === undefined ? startZoom : targetZoom;
            var w0 = Math.max(size.x, size.y), w1 = w0 * this.getZoomScale(startZoom, targetZoom), u1 = to.distanceTo(from) || 1, rho = 1.42, rho2 = rho * rho;
            function r(i) {
                var s1 = i ? -1 : 1, s2 = i ? w1 : w0, t1 = w1 * w1 - w0 * w0 + s1 * rho2 * rho2 * u1 * u1, b1 = 2 * s2 * rho2 * u1, b = t1 / b1, sq = Math.sqrt(b * b + 1) - b;
                // workaround for floating point precision bug when sq = 0, log = -Infinite,
                // thus triggering an infinite loop in flyTo
                var log = sq < 0.000000001 ? -18 : Math.log(sq);
                return log;
            }
            function sinh(n) {
                return (Math.exp(n) - Math.exp(-n)) / 2;
            }
            function cosh(n) {
                return (Math.exp(n) + Math.exp(-n)) / 2;
            }
            function tanh(n) {
                return sinh(n) / cosh(n);
            }
            var r0 = r(0);
            function w(s) {
                return w0 * (cosh(r0) / cosh(r0 + rho * s));
            }
            function u(s) {
                return w0 * (cosh(r0) * tanh(r0 + rho * s) - sinh(r0)) / rho2;
            }
            function easeOut(t) {
                return 1 - Math.pow(1 - t, 1.5);
            }
            var start = Date.now(), S = (r(1) - r0) / rho, duration = options.duration ? 1000 * options.duration : 1000 * S * 0.8;
            function frame() {
                var t = (Date.now() - start) / duration, s = easeOut(t) * S;
                if (t <= 1) {
                    this._flyToFrame = requestAnimFrame(frame, this);
                    this._move(this.unproject(from.add(to.subtract(from).multiplyBy(u(s) / u1)), startZoom), this.getScaleZoom(w0 / w(s), startZoom), {
                        flyTo: true
                    });
                } else this._move(targetCenter, targetZoom)._moveEnd(true);
            }
            this._moveStart(true, options.noMoveStart);
            frame.call(this);
            return this;
        },
        // @method flyToBounds(bounds: LatLngBounds, options?: fitBounds options): this
        // Sets the view of the map with a smooth animation like [`flyTo`](#map-flyto),
        // but takes a bounds parameter like [`fitBounds`](#map-fitbounds).
        flyToBounds: function(bounds, options) {
            var target = this._getBoundsCenterZoom(bounds, options);
            return this.flyTo(target.center, target.zoom, options);
        },
        // @method setMaxBounds(bounds: LatLngBounds): this
        // Restricts the map view to the given bounds (see the [maxBounds](#map-maxbounds) option).
        setMaxBounds: function(bounds) {
            bounds = toLatLngBounds(bounds);
            if (this.listens('moveend', this._panInsideMaxBounds)) this.off('moveend', this._panInsideMaxBounds);
            if (!bounds.isValid()) {
                this.options.maxBounds = null;
                return this;
            }
            this.options.maxBounds = bounds;
            if (this._loaded) this._panInsideMaxBounds();
            return this.on('moveend', this._panInsideMaxBounds);
        },
        // @method setMinZoom(zoom: Number): this
        // Sets the lower limit for the available zoom levels (see the [minZoom](#map-minzoom) option).
        setMinZoom: function(zoom) {
            var oldZoom = this.options.minZoom;
            this.options.minZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() < this.options.minZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method setMaxZoom(zoom: Number): this
        // Sets the upper limit for the available zoom levels (see the [maxZoom](#map-maxzoom) option).
        setMaxZoom: function(zoom) {
            var oldZoom = this.options.maxZoom;
            this.options.maxZoom = zoom;
            if (this._loaded && oldZoom !== zoom) {
                this.fire('zoomlevelschange');
                if (this.getZoom() > this.options.maxZoom) return this.setZoom(zoom);
            }
            return this;
        },
        // @method panInsideBounds(bounds: LatLngBounds, options?: Pan options): this
        // Pans the map to the closest view that would lie inside the given bounds (if it's not already), controlling the animation using the options specific, if any.
        panInsideBounds: function(bounds, options) {
            this._enforcingBounds = true;
            var center = this.getCenter(), newCenter = this._limitCenter(center, this._zoom, toLatLngBounds(bounds));
            if (!center.equals(newCenter)) this.panTo(newCenter, options);
            this._enforcingBounds = false;
            return this;
        },
        // @method panInside(latlng: LatLng, options?: padding options): this
        // Pans the map the minimum amount to make the `latlng` visible. Use
        // padding options to fit the display to more restricted bounds.
        // If `latlng` is already within the (optionally padded) display bounds,
        // the map will not be panned.
        panInside: function(latlng, options) {
            options = options || {};
            var paddingTL = toPoint(options.paddingTopLeft || options.padding || [
                0,
                0
            ]), paddingBR = toPoint(options.paddingBottomRight || options.padding || [
                0,
                0
            ]), pixelCenter = this.project(this.getCenter()), pixelPoint = this.project(latlng), pixelBounds = this.getPixelBounds(), paddedBounds = toBounds([
                pixelBounds.min.add(paddingTL),
                pixelBounds.max.subtract(paddingBR)
            ]), paddedSize = paddedBounds.getSize();
            if (!paddedBounds.contains(pixelPoint)) {
                this._enforcingBounds = true;
                var centerOffset = pixelPoint.subtract(paddedBounds.getCenter());
                var offset = paddedBounds.extend(pixelPoint).getSize().subtract(paddedSize);
                pixelCenter.x += centerOffset.x < 0 ? -offset.x : offset.x;
                pixelCenter.y += centerOffset.y < 0 ? -offset.y : offset.y;
                this.panTo(this.unproject(pixelCenter), options);
                this._enforcingBounds = false;
            }
            return this;
        },
        // @method invalidateSize(options: Zoom/pan options): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default. If `options.pan` is `false`, panning will not occur.
        // If `options.debounceMoveend` is `true`, it will delay `moveend` event so
        // that it doesn't happen often even if the method is called many
        // times in a row.
        // @alternative
        // @method invalidateSize(animate: Boolean): this
        // Checks if the map container size changed and updates the map if so —
        // call it after you've changed the map size dynamically, also animating
        // pan by default.
        invalidateSize: function(options) {
            if (!this._loaded) return this;
            options = extend({
                animate: false,
                pan: true
            }, options === true ? {
                animate: true
            } : options);
            var oldSize = this.getSize();
            this._sizeChanged = true;
            this._lastCenter = null;
            var newSize = this.getSize(), oldCenter = oldSize.divideBy(2).round(), newCenter = newSize.divideBy(2).round(), offset = oldCenter.subtract(newCenter);
            if (!offset.x && !offset.y) return this;
            if (options.animate && options.pan) this.panBy(offset);
            else {
                if (options.pan) this._rawPanBy(offset);
                this.fire('move');
                if (options.debounceMoveend) {
                    clearTimeout(this._sizeTimer);
                    this._sizeTimer = setTimeout(bind(this.fire, this, 'moveend'), 200);
                } else this.fire('moveend');
            }
            // @section Map state change events
            // @event resize: ResizeEvent
            // Fired when the map is resized.
            return this.fire('resize', {
                oldSize: oldSize,
                newSize: newSize
            });
        },
        // @section Methods for modifying map state
        // @method stop(): this
        // Stops the currently running `panTo` or `flyTo` animation, if any.
        stop: function() {
            this.setZoom(this._limitZoom(this._zoom));
            if (!this.options.zoomSnap) this.fire('viewreset');
            return this._stop();
        },
        // @section Geolocation methods
        // @method locate(options?: Locate options): this
        // Tries to locate the user using the Geolocation API, firing a [`locationfound`](#map-locationfound)
        // event with location data on success or a [`locationerror`](#map-locationerror) event on failure,
        // and optionally sets the map view to the user's location with respect to
        // detection accuracy (or to the world view if geolocation failed).
        // Note that, if your page doesn't use HTTPS, this method will fail in
        // modern browsers ([Chrome 50 and newer](https://sites.google.com/a/chromium.org/dev/Home/chromium-security/deprecating-powerful-features-on-insecure-origins))
        // See `Locate options` for more details.
        locate: function(options) {
            options = this._locateOptions = extend({
                timeout: 10000,
                watch: false
            }, options);
            if (!('geolocation' in navigator)) {
                this._handleGeolocationError({
                    code: 0,
                    message: 'Geolocation not supported.'
                });
                return this;
            }
            var onResponse = bind(this._handleGeolocationResponse, this), onError = bind(this._handleGeolocationError, this);
            if (options.watch) this._locationWatchId = navigator.geolocation.watchPosition(onResponse, onError, options);
            else navigator.geolocation.getCurrentPosition(onResponse, onError, options);
            return this;
        },
        // @method stopLocate(): this
        // Stops watching location previously initiated by `map.locate({watch: true})`
        // and aborts resetting the map view if map.locate was called with
        // `{setView: true}`.
        stopLocate: function() {
            if (navigator.geolocation && navigator.geolocation.clearWatch) navigator.geolocation.clearWatch(this._locationWatchId);
            if (this._locateOptions) this._locateOptions.setView = false;
            return this;
        },
        _handleGeolocationError: function(error) {
            if (!this._container._leaflet_id) return;
            var c = error.code, message = error.message || (c === 1 ? 'permission denied' : c === 2 ? 'position unavailable' : 'timeout');
            if (this._locateOptions.setView && !this._loaded) this.fitWorld();
            // @section Location events
            // @event locationerror: ErrorEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method) failed.
            this.fire('locationerror', {
                code: c,
                message: 'Geolocation error: ' + message + '.'
            });
        },
        _handleGeolocationResponse: function(pos) {
            if (!this._container._leaflet_id) return;
            var lat = pos.coords.latitude, lng = pos.coords.longitude, latlng = new LatLng(lat, lng), bounds = latlng.toBounds(pos.coords.accuracy * 2), options = this._locateOptions;
            if (options.setView) {
                var zoom = this.getBoundsZoom(bounds);
                this.setView(latlng, options.maxZoom ? Math.min(zoom, options.maxZoom) : zoom);
            }
            var data = {
                latlng: latlng,
                bounds: bounds,
                timestamp: pos.timestamp
            };
            for(var i in pos.coords)if (typeof pos.coords[i] === 'number') data[i] = pos.coords[i];
            // @event locationfound: LocationEvent
            // Fired when geolocation (using the [`locate`](#map-locate) method)
            // went successfully.
            this.fire('locationfound', data);
        },
        // TODO Appropriate docs section?
        // @section Other Methods
        // @method addHandler(name: String, HandlerClass: Function): this
        // Adds a new `Handler` to the map, given its name and constructor function.
        addHandler: function(name, HandlerClass) {
            if (!HandlerClass) return this;
            var handler = this[name] = new HandlerClass(this);
            this._handlers.push(handler);
            if (this.options[name]) handler.enable();
            return this;
        },
        // @method remove(): this
        // Destroys the map and clears all related event listeners.
        remove: function() {
            this._initEvents(true);
            if (this.options.maxBounds) this.off('moveend', this._panInsideMaxBounds);
            if (this._containerId !== this._container._leaflet_id) throw new Error('Map container is being reused by another instance');
            try {
                // throws error in IE6-8
                delete this._container._leaflet_id;
                delete this._containerId;
            } catch (e) {
                /*eslint-disable */ this._container._leaflet_id = undefined;
                /* eslint-enable */ this._containerId = undefined;
            }
            if (this._locationWatchId !== undefined) this.stopLocate();
            this._stop();
            remove(this._mapPane);
            if (this._clearControlPos) this._clearControlPos();
            if (this._resizeRequest) {
                cancelAnimFrame(this._resizeRequest);
                this._resizeRequest = null;
            }
            this._clearHandlers();
            if (this._loaded) // @section Map state change events
            // @event unload: Event
            // Fired when the map is destroyed with [remove](#map-remove) method.
            this.fire('unload');
            var i;
            for(i in this._layers)this._layers[i].remove();
            for(i in this._panes)remove(this._panes[i]);
            this._layers = [];
            this._panes = [];
            delete this._mapPane;
            delete this._renderer;
            return this;
        },
        // @section Other Methods
        // @method createPane(name: String, container?: HTMLElement): HTMLElement
        // Creates a new [map pane](#map-pane) with the given name if it doesn't exist already,
        // then returns it. The pane is created as a child of `container`, or
        // as a child of the main map pane if not set.
        createPane: function(name, container) {
            var className = 'leaflet-pane' + (name ? ' leaflet-' + name.replace('Pane', '') + '-pane' : ''), pane = create$1('div', className, container || this._mapPane);
            if (name) this._panes[name] = pane;
            return pane;
        },
        // @section Methods for Getting Map State
        // @method getCenter(): LatLng
        // Returns the geographical center of the map view
        getCenter: function() {
            this._checkIfLoaded();
            if (this._lastCenter && !this._moved()) return this._lastCenter.clone();
            return this.layerPointToLatLng(this._getCenterLayerPoint());
        },
        // @method getZoom(): Number
        // Returns the current zoom level of the map view
        getZoom: function() {
            return this._zoom;
        },
        // @method getBounds(): LatLngBounds
        // Returns the geographical bounds visible in the current map view
        getBounds: function() {
            var bounds = this.getPixelBounds(), sw = this.unproject(bounds.getBottomLeft()), ne = this.unproject(bounds.getTopRight());
            return new LatLngBounds(sw, ne);
        },
        // @method getMinZoom(): Number
        // Returns the minimum zoom level of the map (if set in the `minZoom` option of the map or of any layers), or `0` by default.
        getMinZoom: function() {
            return this.options.minZoom === undefined ? this._layersMinZoom || 0 : this.options.minZoom;
        },
        // @method getMaxZoom(): Number
        // Returns the maximum zoom level of the map (if set in the `maxZoom` option of the map or of any layers).
        getMaxZoom: function() {
            return this.options.maxZoom === undefined ? this._layersMaxZoom === undefined ? Infinity : this._layersMaxZoom : this.options.maxZoom;
        },
        // @method getBoundsZoom(bounds: LatLngBounds, inside?: Boolean, padding?: Point): Number
        // Returns the maximum zoom level on which the given bounds fit to the map
        // view in its entirety. If `inside` (optional) is set to `true`, the method
        // instead returns the minimum zoom level on which the map view fits into
        // the given bounds in its entirety.
        getBoundsZoom: function(bounds, inside, padding) {
            bounds = toLatLngBounds(bounds);
            padding = toPoint(padding || [
                0,
                0
            ]);
            var zoom = this.getZoom() || 0, min = this.getMinZoom(), max = this.getMaxZoom(), nw = bounds.getNorthWest(), se = bounds.getSouthEast(), size = this.getSize().subtract(padding), boundsSize = toBounds(this.project(se, zoom), this.project(nw, zoom)).getSize(), snap = Browser.any3d ? this.options.zoomSnap : 1, scalex = size.x / boundsSize.x, scaley = size.y / boundsSize.y, scale = inside ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
            zoom = this.getScaleZoom(scale, zoom);
            if (snap) {
                zoom = Math.round(zoom / (snap / 100)) * (snap / 100); // don't jump if within 1% of a snap level
                zoom = inside ? Math.ceil(zoom / snap) * snap : Math.floor(zoom / snap) * snap;
            }
            return Math.max(min, Math.min(max, zoom));
        },
        // @method getSize(): Point
        // Returns the current size of the map container (in pixels).
        getSize: function() {
            if (!this._size || this._sizeChanged) {
                this._size = new Point(this._container.clientWidth || 0, this._container.clientHeight || 0);
                this._sizeChanged = false;
            }
            return this._size.clone();
        },
        // @method getPixelBounds(): Bounds
        // Returns the bounds of the current map view in projected pixel
        // coordinates (sometimes useful in layer and overlay implementations).
        getPixelBounds: function(center, zoom) {
            var topLeftPoint = this._getTopLeftPoint(center, zoom);
            return new Bounds(topLeftPoint, topLeftPoint.add(this.getSize()));
        },
        // TODO: Check semantics - isn't the pixel origin the 0,0 coord relative to
        // the map pane? "left point of the map layer" can be confusing, specially
        // since there can be negative offsets.
        // @method getPixelOrigin(): Point
        // Returns the projected pixel coordinates of the top left point of
        // the map layer (useful in custom layer and overlay implementations).
        getPixelOrigin: function() {
            this._checkIfLoaded();
            return this._pixelOrigin;
        },
        // @method getPixelWorldBounds(zoom?: Number): Bounds
        // Returns the world's bounds in pixel coordinates for zoom level `zoom`.
        // If `zoom` is omitted, the map's current zoom level is used.
        getPixelWorldBounds: function(zoom) {
            return this.options.crs.getProjectedBounds(zoom === undefined ? this.getZoom() : zoom);
        },
        // @section Other Methods
        // @method getPane(pane: String|HTMLElement): HTMLElement
        // Returns a [map pane](#map-pane), given its name or its HTML element (its identity).
        getPane: function(pane) {
            return typeof pane === 'string' ? this._panes[pane] : pane;
        },
        // @method getPanes(): Object
        // Returns a plain object containing the names of all [panes](#map-pane) as keys and
        // the panes as values.
        getPanes: function() {
            return this._panes;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the map.
        getContainer: function() {
            return this._container;
        },
        // @section Conversion Methods
        // @method getZoomScale(toZoom: Number, fromZoom: Number): Number
        // Returns the scale factor to be applied to a map transition from zoom level
        // `fromZoom` to `toZoom`. Used internally to help with zoom animations.
        getZoomScale: function(toZoom, fromZoom) {
            // TODO replace with universal implementation after refactoring projections
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            return crs.scale(toZoom) / crs.scale(fromZoom);
        },
        // @method getScaleZoom(scale: Number, fromZoom: Number): Number
        // Returns the zoom level that the map would end up at, if it is at `fromZoom`
        // level and everything is scaled by a factor of `scale`. Inverse of
        // [`getZoomScale`](#map-getZoomScale).
        getScaleZoom: function(scale, fromZoom) {
            var crs = this.options.crs;
            fromZoom = fromZoom === undefined ? this._zoom : fromZoom;
            var zoom = crs.zoom(scale * crs.scale(fromZoom));
            return isNaN(zoom) ? Infinity : zoom;
        },
        // @method project(latlng: LatLng, zoom: Number): Point
        // Projects a geographical coordinate `LatLng` according to the projection
        // of the map's CRS, then scales it according to `zoom` and the CRS's
        // `Transformation`. The result is pixel coordinate relative to
        // the CRS origin.
        project: function(latlng, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.latLngToPoint(toLatLng(latlng), zoom);
        },
        // @method unproject(point: Point, zoom: Number): LatLng
        // Inverse of [`project`](#map-project).
        unproject: function(point, zoom) {
            zoom = zoom === undefined ? this._zoom : zoom;
            return this.options.crs.pointToLatLng(toPoint(point), zoom);
        },
        // @method layerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding geographical coordinate (for the current zoom level).
        layerPointToLatLng: function(point) {
            var projectedPoint = toPoint(point).add(this.getPixelOrigin());
            return this.unproject(projectedPoint);
        },
        // @method latLngToLayerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the [origin pixel](#map-getpixelorigin).
        latLngToLayerPoint: function(latlng) {
            var projectedPoint = this.project(toLatLng(latlng))._round();
            return projectedPoint._subtract(this.getPixelOrigin());
        },
        // @method wrapLatLng(latlng: LatLng): LatLng
        // Returns a `LatLng` where `lat` and `lng` has been wrapped according to the
        // map's CRS's `wrapLat` and `wrapLng` properties, if they are outside the
        // CRS's bounds.
        // By default this means longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees.
        wrapLatLng: function(latlng) {
            return this.options.crs.wrapLatLng(toLatLng(latlng));
        },
        // @method wrapLatLngBounds(bounds: LatLngBounds): LatLngBounds
        // Returns a `LatLngBounds` with the same size as the given one, ensuring that
        // its center is within the CRS's bounds.
        // By default this means the center longitude is wrapped around the dateline so its
        // value is between -180 and +180 degrees, and the majority of the bounds
        // overlaps the CRS's bounds.
        wrapLatLngBounds: function(latlng) {
            return this.options.crs.wrapLatLngBounds(toLatLngBounds(latlng));
        },
        // @method distance(latlng1: LatLng, latlng2: LatLng): Number
        // Returns the distance between two geographical coordinates according to
        // the map's CRS. By default this measures distance in meters.
        distance: function(latlng1, latlng2) {
            return this.options.crs.distance(toLatLng(latlng1), toLatLng(latlng2));
        },
        // @method containerPointToLayerPoint(point: Point): Point
        // Given a pixel coordinate relative to the map container, returns the corresponding
        // pixel coordinate relative to the [origin pixel](#map-getpixelorigin).
        containerPointToLayerPoint: function(point) {
            return toPoint(point).subtract(this._getMapPanePos());
        },
        // @method layerPointToContainerPoint(point: Point): Point
        // Given a pixel coordinate relative to the [origin pixel](#map-getpixelorigin),
        // returns the corresponding pixel coordinate relative to the map container.
        layerPointToContainerPoint: function(point) {
            return toPoint(point).add(this._getMapPanePos());
        },
        // @method containerPointToLatLng(point: Point): LatLng
        // Given a pixel coordinate relative to the map container, returns
        // the corresponding geographical coordinate (for the current zoom level).
        containerPointToLatLng: function(point) {
            var layerPoint = this.containerPointToLayerPoint(toPoint(point));
            return this.layerPointToLatLng(layerPoint);
        },
        // @method latLngToContainerPoint(latlng: LatLng): Point
        // Given a geographical coordinate, returns the corresponding pixel coordinate
        // relative to the map container.
        latLngToContainerPoint: function(latlng) {
            return this.layerPointToContainerPoint(this.latLngToLayerPoint(toLatLng(latlng)));
        },
        // @method mouseEventToContainerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to the
        // map container where the event took place.
        mouseEventToContainerPoint: function(e) {
            return getMousePosition(e, this._container);
        },
        // @method mouseEventToLayerPoint(ev: MouseEvent): Point
        // Given a MouseEvent object, returns the pixel coordinate relative to
        // the [origin pixel](#map-getpixelorigin) where the event took place.
        mouseEventToLayerPoint: function(e) {
            return this.containerPointToLayerPoint(this.mouseEventToContainerPoint(e));
        },
        // @method mouseEventToLatLng(ev: MouseEvent): LatLng
        // Given a MouseEvent object, returns geographical coordinate where the
        // event took place.
        mouseEventToLatLng: function(e) {
            return this.layerPointToLatLng(this.mouseEventToLayerPoint(e));
        },
        // map initialization methods
        _initContainer: function(id) {
            var container = this._container = get(id);
            if (!container) throw new Error('Map container not found.');
            else if (container._leaflet_id) throw new Error('Map container is already initialized.');
            on(container, 'scroll', this._onScroll, this);
            this._containerId = stamp(container);
        },
        _initLayout: function() {
            var container = this._container;
            this._fadeAnimated = this.options.fadeAnimation && Browser.any3d;
            addClass(container, 'leaflet-container' + (Browser.touch ? ' leaflet-touch' : '') + (Browser.retina ? ' leaflet-retina' : '') + (Browser.ielt9 ? ' leaflet-oldie' : '') + (Browser.safari ? ' leaflet-safari' : '') + (this._fadeAnimated ? ' leaflet-fade-anim' : ''));
            var position = getStyle(container, 'position');
            if (position !== 'absolute' && position !== 'relative' && position !== 'fixed' && position !== 'sticky') container.style.position = 'relative';
            this._initPanes();
            if (this._initControlPos) this._initControlPos();
        },
        _initPanes: function() {
            var panes = this._panes = {};
            this._paneRenderers = {};
            // @section
            //
            // Panes are DOM elements used to control the ordering of layers on the map. You
            // can access panes with [`map.getPane`](#map-getpane) or
            // [`map.getPanes`](#map-getpanes) methods. New panes can be created with the
            // [`map.createPane`](#map-createpane) method.
            //
            // Every map has the following default panes that differ only in zIndex.
            //
            // @pane mapPane: HTMLElement = 'auto'
            // Pane that contains all other map panes
            this._mapPane = this.createPane('mapPane', this._container);
            setPosition(this._mapPane, new Point(0, 0));
            // @pane tilePane: HTMLElement = 200
            // Pane for `GridLayer`s and `TileLayer`s
            this.createPane('tilePane');
            // @pane overlayPane: HTMLElement = 400
            // Pane for vectors (`Path`s, like `Polyline`s and `Polygon`s), `ImageOverlay`s and `VideoOverlay`s
            this.createPane('overlayPane');
            // @pane shadowPane: HTMLElement = 500
            // Pane for overlay shadows (e.g. `Marker` shadows)
            this.createPane('shadowPane');
            // @pane markerPane: HTMLElement = 600
            // Pane for `Icon`s of `Marker`s
            this.createPane('markerPane');
            // @pane tooltipPane: HTMLElement = 650
            // Pane for `Tooltip`s.
            this.createPane('tooltipPane');
            // @pane popupPane: HTMLElement = 700
            // Pane for `Popup`s.
            this.createPane('popupPane');
            if (!this.options.markerZoomAnimation) {
                addClass(panes.markerPane, 'leaflet-zoom-hide');
                addClass(panes.shadowPane, 'leaflet-zoom-hide');
            }
        },
        // private methods that modify map state
        // @section Map state change events
        _resetView: function(center, zoom, noMoveStart) {
            setPosition(this._mapPane, new Point(0, 0));
            var loading = !this._loaded;
            this._loaded = true;
            zoom = this._limitZoom(zoom);
            this.fire('viewprereset');
            var zoomChanged = this._zoom !== zoom;
            this._moveStart(zoomChanged, noMoveStart)._move(center, zoom)._moveEnd(zoomChanged);
            // @event viewreset: Event
            // Fired when the map needs to redraw its content (this usually happens
            // on map zoom or load). Very useful for creating custom overlays.
            this.fire('viewreset');
            // @event load: Event
            // Fired when the map is initialized (when its center and zoom are set
            // for the first time).
            if (loading) this.fire('load');
        },
        _moveStart: function(zoomChanged, noMoveStart) {
            // @event zoomstart: Event
            // Fired when the map zoom is about to change (e.g. before zoom animation).
            // @event movestart: Event
            // Fired when the view of the map starts changing (e.g. user starts dragging the map).
            if (zoomChanged) this.fire('zoomstart');
            if (!noMoveStart) this.fire('movestart');
            return this;
        },
        _move: function(center, zoom, data, supressEvent) {
            if (zoom === undefined) zoom = this._zoom;
            var zoomChanged = this._zoom !== zoom;
            this._zoom = zoom;
            this._lastCenter = center;
            this._pixelOrigin = this._getNewPixelOrigin(center);
            if (!supressEvent) {
                // @event zoom: Event
                // Fired repeatedly during any change in zoom level,
                // including zoom and fly animations.
                if (zoomChanged || data && data.pinch) this.fire('zoom', data);
                // @event move: Event
                // Fired repeatedly during any movement of the map,
                // including pan and fly animations.
                this.fire('move', data);
            } else if (data && data.pinch) this.fire('zoom', data);
            return this;
        },
        _moveEnd: function(zoomChanged) {
            // @event zoomend: Event
            // Fired when the map zoom changed, after any animations.
            if (zoomChanged) this.fire('zoomend');
            // @event moveend: Event
            // Fired when the center of the map stops changing
            // (e.g. user stopped dragging the map or after non-centered zoom).
            return this.fire('moveend');
        },
        _stop: function() {
            cancelAnimFrame(this._flyToFrame);
            if (this._panAnim) this._panAnim.stop();
            return this;
        },
        _rawPanBy: function(offset) {
            setPosition(this._mapPane, this._getMapPanePos().subtract(offset));
        },
        _getZoomSpan: function() {
            return this.getMaxZoom() - this.getMinZoom();
        },
        _panInsideMaxBounds: function() {
            if (!this._enforcingBounds) this.panInsideBounds(this.options.maxBounds);
        },
        _checkIfLoaded: function() {
            if (!this._loaded) throw new Error('Set map center and zoom first.');
        },
        // DOM event handling
        // @section Interaction events
        _initEvents: function(remove) {
            this._targets = {};
            this._targets[stamp(this._container)] = this;
            var onOff = remove ? off : on;
            // @event click: MouseEvent
            // Fired when the user clicks (or taps) the map.
            // @event dblclick: MouseEvent
            // Fired when the user double-clicks (or double-taps) the map.
            // @event mousedown: MouseEvent
            // Fired when the user pushes the mouse button on the map.
            // @event mouseup: MouseEvent
            // Fired when the user releases the mouse button on the map.
            // @event mouseover: MouseEvent
            // Fired when the mouse enters the map.
            // @event mouseout: MouseEvent
            // Fired when the mouse leaves the map.
            // @event mousemove: MouseEvent
            // Fired while the mouse moves over the map.
            // @event contextmenu: MouseEvent
            // Fired when the user pushes the right mouse button on the map, prevents
            // default browser context menu from showing if there are listeners on
            // this event. Also fired on mobile when the user holds a single touch
            // for a second (also called long press).
            // @event keypress: KeyboardEvent
            // Fired when the user presses a key from the keyboard that produces a character value while the map is focused.
            // @event keydown: KeyboardEvent
            // Fired when the user presses a key from the keyboard while the map is focused. Unlike the `keypress` event,
            // the `keydown` event is fired for keys that produce a character value and for keys
            // that do not produce a character value.
            // @event keyup: KeyboardEvent
            // Fired when the user releases a key from the keyboard while the map is focused.
            onOff(this._container, "click dblclick mousedown mouseup mouseover mouseout mousemove contextmenu keypress keydown keyup", this._handleDOMEvent, this);
            if (this.options.trackResize) onOff(window, 'resize', this._onResize, this);
            if (Browser.any3d && this.options.transform3DLimit) (remove ? this.off : this.on).call(this, 'moveend', this._onMoveEnd);
        },
        _onResize: function() {
            cancelAnimFrame(this._resizeRequest);
            this._resizeRequest = requestAnimFrame(function() {
                this.invalidateSize({
                    debounceMoveend: true
                });
            }, this);
        },
        _onScroll: function() {
            this._container.scrollTop = 0;
            this._container.scrollLeft = 0;
        },
        _onMoveEnd: function() {
            var pos = this._getMapPanePos();
            if (Math.max(Math.abs(pos.x), Math.abs(pos.y)) >= this.options.transform3DLimit) // https://bugzilla.mozilla.org/show_bug.cgi?id=1203873 but Webkit also have
            // a pixel offset on very high values, see: https://jsfiddle.net/dg6r5hhb/
            this._resetView(this.getCenter(), this.getZoom());
        },
        _findEventTargets: function(e, type) {
            var targets = [], target, isHover = type === 'mouseout' || type === 'mouseover', src = e.target || e.srcElement, dragging = false;
            while(src){
                target = this._targets[stamp(src)];
                if (target && (type === 'click' || type === 'preclick') && this._draggableMoved(target)) {
                    // Prevent firing click after you just dragged an object.
                    dragging = true;
                    break;
                }
                if (target && target.listens(type, true)) {
                    if (isHover && !isExternalTarget(src, e)) break;
                    targets.push(target);
                    if (isHover) break;
                }
                if (src === this._container) break;
                src = src.parentNode;
            }
            if (!targets.length && !dragging && !isHover && this.listens(type, true)) targets = [
                this
            ];
            return targets;
        },
        _isClickDisabled: function(el) {
            while(el && el !== this._container){
                if (el['_leaflet_disable_click']) return true;
                el = el.parentNode;
            }
        },
        _handleDOMEvent: function(e) {
            var el = e.target || e.srcElement;
            if (!this._loaded || el['_leaflet_disable_events'] || e.type === 'click' && this._isClickDisabled(el)) return;
            var type = e.type;
            if (type === 'mousedown') // prevents outline when clicking on keyboard-focusable element
            preventOutline(el);
            this._fireDOMEvent(e, type);
        },
        _mouseEvents: [
            'click',
            'dblclick',
            'mouseover',
            'mouseout',
            'contextmenu'
        ],
        _fireDOMEvent: function(e, type, canvasTargets) {
            if (e.type === 'click') {
                // Fire a synthetic 'preclick' event which propagates up (mainly for closing popups).
                // @event preclick: MouseEvent
                // Fired before mouse click on the map (sometimes useful when you
                // want something to happen on click before any existing click
                // handlers start running).
                var synth = extend({}, e);
                synth.type = 'preclick';
                this._fireDOMEvent(synth, synth.type, canvasTargets);
            }
            // Find the layer the event is propagating from and its parents.
            var targets = this._findEventTargets(e, type);
            if (canvasTargets) {
                var filtered = []; // pick only targets with listeners
                for(var i = 0; i < canvasTargets.length; i++)if (canvasTargets[i].listens(type, true)) filtered.push(canvasTargets[i]);
                targets = filtered.concat(targets);
            }
            if (!targets.length) return;
            if (type === 'contextmenu') preventDefault(e);
            var target = targets[0];
            var data = {
                originalEvent: e
            };
            if (e.type !== 'keypress' && e.type !== 'keydown' && e.type !== 'keyup') {
                var isMarker = target.getLatLng && (!target._radius || target._radius <= 10);
                data.containerPoint = isMarker ? this.latLngToContainerPoint(target.getLatLng()) : this.mouseEventToContainerPoint(e);
                data.layerPoint = this.containerPointToLayerPoint(data.containerPoint);
                data.latlng = isMarker ? target.getLatLng() : this.layerPointToLatLng(data.layerPoint);
            }
            for(i = 0; i < targets.length; i++){
                targets[i].fire(type, data, true);
                if (data.originalEvent._stopped || targets[i].options.bubblingMouseEvents === false && indexOf(this._mouseEvents, type) !== -1) return;
            }
        },
        _draggableMoved: function(obj) {
            obj = obj.dragging && obj.dragging.enabled() ? obj : this;
            return obj.dragging && obj.dragging.moved() || this.boxZoom && this.boxZoom.moved();
        },
        _clearHandlers: function() {
            for(var i = 0, len = this._handlers.length; i < len; i++)this._handlers[i].disable();
        },
        // @section Other Methods
        // @method whenReady(fn: Function, context?: Object): this
        // Runs the given function `fn` when the map gets initialized with
        // a view (center and zoom) and at least one layer, or immediately
        // if it's already initialized, optionally passing a function context.
        whenReady: function(callback, context) {
            if (this._loaded) callback.call(context || this, {
                target: this
            });
            else this.on('load', callback, context);
            return this;
        },
        // private methods for getting map state
        _getMapPanePos: function() {
            return getPosition(this._mapPane) || new Point(0, 0);
        },
        _moved: function() {
            var pos = this._getMapPanePos();
            return pos && !pos.equals([
                0,
                0
            ]);
        },
        _getTopLeftPoint: function(center, zoom) {
            var pixelOrigin = center && zoom !== undefined ? this._getNewPixelOrigin(center, zoom) : this.getPixelOrigin();
            return pixelOrigin.subtract(this._getMapPanePos());
        },
        _getNewPixelOrigin: function(center, zoom) {
            var viewHalf = this.getSize()._divideBy(2);
            return this.project(center, zoom)._subtract(viewHalf)._add(this._getMapPanePos())._round();
        },
        _latLngToNewLayerPoint: function(latlng, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return this.project(latlng, zoom)._subtract(topLeft);
        },
        _latLngBoundsToNewLayerBounds: function(latLngBounds, zoom, center) {
            var topLeft = this._getNewPixelOrigin(center, zoom);
            return toBounds([
                this.project(latLngBounds.getSouthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthWest(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getSouthEast(), zoom)._subtract(topLeft),
                this.project(latLngBounds.getNorthEast(), zoom)._subtract(topLeft)
            ]);
        },
        // layer point of the current center
        _getCenterLayerPoint: function() {
            return this.containerPointToLayerPoint(this.getSize()._divideBy(2));
        },
        // offset of the specified place to the current center in pixels
        _getCenterOffset: function(latlng) {
            return this.latLngToLayerPoint(latlng).subtract(this._getCenterLayerPoint());
        },
        // adjust center for view to get inside bounds
        _limitCenter: function(center, zoom, bounds) {
            if (!bounds) return center;
            var centerPoint = this.project(center, zoom), viewHalf = this.getSize().divideBy(2), viewBounds = new Bounds(centerPoint.subtract(viewHalf), centerPoint.add(viewHalf)), offset = this._getBoundsOffset(viewBounds, bounds, zoom);
            // If offset is less than a pixel, ignore.
            // This prevents unstable projections from getting into
            // an infinite loop of tiny offsets.
            if (Math.abs(offset.x) <= 1 && Math.abs(offset.y) <= 1) return center;
            return this.unproject(centerPoint.add(offset), zoom);
        },
        // adjust offset for view to get inside bounds
        _limitOffset: function(offset, bounds) {
            if (!bounds) return offset;
            var viewBounds = this.getPixelBounds(), newBounds = new Bounds(viewBounds.min.add(offset), viewBounds.max.add(offset));
            return offset.add(this._getBoundsOffset(newBounds, bounds));
        },
        // returns offset needed for pxBounds to get inside maxBounds at a specified zoom
        _getBoundsOffset: function(pxBounds, maxBounds, zoom) {
            var projectedMaxBounds = toBounds(this.project(maxBounds.getNorthEast(), zoom), this.project(maxBounds.getSouthWest(), zoom)), minOffset = projectedMaxBounds.min.subtract(pxBounds.min), maxOffset = projectedMaxBounds.max.subtract(pxBounds.max), dx = this._rebound(minOffset.x, -maxOffset.x), dy = this._rebound(minOffset.y, -maxOffset.y);
            return new Point(dx, dy);
        },
        _rebound: function(left, right) {
            return left + right > 0 ? Math.round(left - right) / 2 : Math.max(0, Math.ceil(left)) - Math.max(0, Math.floor(right));
        },
        _limitZoom: function(zoom) {
            var min = this.getMinZoom(), max = this.getMaxZoom(), snap = Browser.any3d ? this.options.zoomSnap : 1;
            if (snap) zoom = Math.round(zoom / snap) * snap;
            return Math.max(min, Math.min(max, zoom));
        },
        _onPanTransitionStep: function() {
            this.fire('move');
        },
        _onPanTransitionEnd: function() {
            removeClass(this._mapPane, 'leaflet-pan-anim');
            this.fire('moveend');
        },
        _tryAnimatedPan: function(center, options) {
            // difference between the new and current centers in pixels
            var offset = this._getCenterOffset(center)._trunc();
            // don't animate too far unless animate: true specified in options
            if ((options && options.animate) !== true && !this.getSize().contains(offset)) return false;
            this.panBy(offset, options);
            return true;
        },
        _createAnimProxy: function() {
            var proxy = this._proxy = create$1('div', 'leaflet-proxy leaflet-zoom-animated');
            this._panes.mapPane.appendChild(proxy);
            this.on('zoomanim', function(e) {
                var prop = TRANSFORM, transform = this._proxy.style[prop];
                setTransform(this._proxy, this.project(e.center, e.zoom), this.getZoomScale(e.zoom, 1));
                // workaround for case when transform is the same and so transitionend event is not fired
                if (transform === this._proxy.style[prop] && this._animatingZoom) this._onZoomTransitionEnd();
            }, this);
            this.on('load moveend', this._animMoveEnd, this);
            this._on('unload', this._destroyAnimProxy, this);
        },
        _destroyAnimProxy: function() {
            remove(this._proxy);
            this.off('load moveend', this._animMoveEnd, this);
            delete this._proxy;
        },
        _animMoveEnd: function() {
            var c = this.getCenter(), z = this.getZoom();
            setTransform(this._proxy, this.project(c, z), this.getZoomScale(z, 1));
        },
        _catchTransitionEnd: function(e) {
            if (this._animatingZoom && e.propertyName.indexOf('transform') >= 0) this._onZoomTransitionEnd();
        },
        _nothingToAnimate: function() {
            return !this._container.getElementsByClassName('leaflet-zoom-animated').length;
        },
        _tryAnimatedZoom: function(center, zoom, options) {
            if (this._animatingZoom) return true;
            options = options || {};
            // don't animate if disabled, not supported or zoom difference is too large
            if (!this._zoomAnimated || options.animate === false || this._nothingToAnimate() || Math.abs(zoom - this._zoom) > this.options.zoomAnimationThreshold) return false;
            // offset is the pixel coords of the zoom origin relative to the current center
            var scale = this.getZoomScale(zoom), offset = this._getCenterOffset(center)._divideBy(1 - 1 / scale);
            // don't animate if the zoom origin isn't within one screen from the current center, unless forced
            if (options.animate !== true && !this.getSize().contains(offset)) return false;
            requestAnimFrame(function() {
                this._moveStart(true, options.noMoveStart || false)._animateZoom(center, zoom, true);
            }, this);
            return true;
        },
        _animateZoom: function(center, zoom, startAnim, noUpdate) {
            if (!this._mapPane) return;
            if (startAnim) {
                this._animatingZoom = true;
                // remember what center/zoom to set after animation
                this._animateToCenter = center;
                this._animateToZoom = zoom;
                addClass(this._mapPane, 'leaflet-zoom-anim');
            }
            // @section Other Events
            // @event zoomanim: ZoomAnimEvent
            // Fired at least once per zoom animation. For continuous zoom, like pinch zooming, fired once per frame during zoom.
            this.fire('zoomanim', {
                center: center,
                zoom: zoom,
                noUpdate: noUpdate
            });
            if (!this._tempFireZoomEvent) this._tempFireZoomEvent = this._zoom !== this._animateToZoom;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            // Work around webkit not firing 'transitionend', see https://github.com/Leaflet/Leaflet/issues/3689, 2693
            setTimeout(bind(this._onZoomTransitionEnd, this), 250);
        },
        _onZoomTransitionEnd: function() {
            if (!this._animatingZoom) return;
            if (this._mapPane) removeClass(this._mapPane, 'leaflet-zoom-anim');
            this._animatingZoom = false;
            this._move(this._animateToCenter, this._animateToZoom, undefined, true);
            if (this._tempFireZoomEvent) this.fire('zoom');
            delete this._tempFireZoomEvent;
            this.fire('move');
            this._moveEnd(true);
        }
    });
    // @section
    // @factory L.map(id: String, options?: Map options)
    // Instantiates a map object given the DOM ID of a `<div>` element
    // and optionally an object literal with `Map options`.
    //
    // @alternative
    // @factory L.map(el: HTMLElement, options?: Map options)
    // Instantiates a map object given an instance of a `<div>` HTML element
    // and optionally an object literal with `Map options`.
    function createMap(id, options) {
        return new Map(id, options);
    }
    /*
   * @class Control
   * @aka L.Control
   * @inherits Class
   *
   * L.Control is a base class for implementing map controls. Handles positioning.
   * All other controls extend from this class.
   */ var Control = Class.extend({
        // @section
        // @aka Control Options
        options: {
            // @option position: String = 'topright'
            // The position of the control (one of the map corners). Possible values are `'topleft'`,
            // `'topright'`, `'bottomleft'` or `'bottomright'`
            position: 'topright'
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        /* @section
  	 * Classes extending L.Control will inherit the following methods:
  	 *
  	 * @method getPosition: string
  	 * Returns the position of the control.
  	 */ getPosition: function() {
            return this.options.position;
        },
        // @method setPosition(position: string): this
        // Sets the position of the control.
        setPosition: function(position) {
            var map = this._map;
            if (map) map.removeControl(this);
            this.options.position = position;
            if (map) map.addControl(this);
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTMLElement that contains the control.
        getContainer: function() {
            return this._container;
        },
        // @method addTo(map: Map): this
        // Adds the control to the given map.
        addTo: function(map) {
            this.remove();
            this._map = map;
            var container = this._container = this.onAdd(map), pos = this.getPosition(), corner = map._controlCorners[pos];
            addClass(container, 'leaflet-control');
            if (pos.indexOf('bottom') !== -1) corner.insertBefore(container, corner.firstChild);
            else corner.appendChild(container);
            this._map.on('unload', this.remove, this);
            return this;
        },
        // @method remove: this
        // Removes the control from the map it is currently active on.
        remove: function() {
            if (!this._map) return this;
            remove(this._container);
            if (this.onRemove) this.onRemove(this._map);
            this._map.off('unload', this.remove, this);
            this._map = null;
            return this;
        },
        _refocusOnMap: function(e) {
            // if map exists and event is not a keyboard event
            if (this._map && e && e.screenX > 0 && e.screenY > 0) this._map.getContainer().focus();
        }
    });
    var control = function(options) {
        return new Control(options);
    };
    /* @section Extension methods
   * @uninheritable
   *
   * Every control should extend from `L.Control` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): HTMLElement
   * Should return the container DOM element for the control and add listeners on relevant map events. Called on [`control.addTo(map)`](#control-addTo).
   *
   * @method onRemove(map: Map)
   * Optional method. Should contain all clean up code that removes the listeners previously added in [`onAdd`](#control-onadd). Called on [`control.remove()`](#control-remove).
   */ /* @namespace Map
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addControl(control: Control): this
        // Adds the given control to the map
        addControl: function(control) {
            control.addTo(this);
            return this;
        },
        // @method removeControl(control: Control): this
        // Removes the given control from the map
        removeControl: function(control) {
            control.remove();
            return this;
        },
        _initControlPos: function() {
            var corners = this._controlCorners = {}, l = 'leaflet-', container = this._controlContainer = create$1('div', l + 'control-container', this._container);
            function createCorner(vSide, hSide) {
                var className = l + vSide + ' ' + l + hSide;
                corners[vSide + hSide] = create$1('div', className, container);
            }
            createCorner('top', 'left');
            createCorner('top', 'right');
            createCorner('bottom', 'left');
            createCorner('bottom', 'right');
        },
        _clearControlPos: function() {
            for(var i in this._controlCorners)remove(this._controlCorners[i]);
            remove(this._controlContainer);
            delete this._controlCorners;
            delete this._controlContainer;
        }
    });
    /*
   * @class Control.Layers
   * @aka L.Control.Layers
   * @inherits Control
   *
   * The layers control gives users the ability to switch between different base layers and switch overlays on/off (check out the [detailed example](https://leafletjs.com/examples/layers-control/)). Extends `Control`.
   *
   * @example
   *
   * ```js
   * var baseLayers = {
   * 	"Mapbox": mapbox,
   * 	"OpenStreetMap": osm
   * };
   *
   * var overlays = {
   * 	"Marker": marker,
   * 	"Roads": roadsLayer
   * };
   *
   * L.control.layers(baseLayers, overlays).addTo(map);
   * ```
   *
   * The `baseLayers` and `overlays` parameters are object literals with layer names as keys and `Layer` objects as values:
   *
   * ```js
   * {
   *     "<someName1>": layer1,
   *     "<someName2>": layer2
   * }
   * ```
   *
   * The layer names can contain HTML, which allows you to add additional styling to the items:
   *
   * ```js
   * {"<img src='my-layer-icon' /> <span class='my-layer-item'>My Layer</span>": myLayer}
   * ```
   */ var Layers = Control.extend({
        // @section
        // @aka Control.Layers options
        options: {
            // @option collapsed: Boolean = true
            // If `true`, the control will be collapsed into an icon and expanded on mouse hover, touch, or keyboard activation.
            collapsed: true,
            position: 'topright',
            // @option autoZIndex: Boolean = true
            // If `true`, the control will assign zIndexes in increasing order to all of its layers so that the order is preserved when switching them on/off.
            autoZIndex: true,
            // @option hideSingleBase: Boolean = false
            // If `true`, the base layers in the control will be hidden when there is only one.
            hideSingleBase: false,
            // @option sortLayers: Boolean = false
            // Whether to sort the layers. When `false`, layers will keep the order
            // in which they were added to the control.
            sortLayers: false,
            // @option sortFunction: Function = *
            // A [compare function](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/sort)
            // that will be used for sorting the layers, when `sortLayers` is `true`.
            // The function receives both the `L.Layer` instances and their names, as in
            // `sortFunction(layerA, layerB, nameA, nameB)`.
            // By default, it sorts layers alphabetically by their name.
            sortFunction: function(layerA, layerB, nameA, nameB) {
                return nameA < nameB ? -1 : nameB < nameA ? 1 : 0;
            }
        },
        initialize: function(baseLayers, overlays, options) {
            setOptions(this, options);
            this._layerControlInputs = [];
            this._layers = [];
            this._lastZIndex = 0;
            this._handlingClick = false;
            this._preventClick = false;
            for(var i in baseLayers)this._addLayer(baseLayers[i], i);
            for(i in overlays)this._addLayer(overlays[i], i, true);
        },
        onAdd: function(map) {
            this._initLayout();
            this._update();
            this._map = map;
            map.on('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.on('add remove', this._onLayerChange, this);
            return this._container;
        },
        addTo: function(map) {
            Control.prototype.addTo.call(this, map);
            // Trigger expand after Layers Control has been inserted into DOM so that is now has an actual height.
            return this._expandIfNotCollapsed();
        },
        onRemove: function() {
            this._map.off('zoomend', this._checkDisabledLayers, this);
            for(var i = 0; i < this._layers.length; i++)this._layers[i].layer.off('add remove', this._onLayerChange, this);
        },
        // @method addBaseLayer(layer: Layer, name: String): this
        // Adds a base layer (radio button entry) with the given name to the control.
        addBaseLayer: function(layer, name) {
            this._addLayer(layer, name);
            return this._map ? this._update() : this;
        },
        // @method addOverlay(layer: Layer, name: String): this
        // Adds an overlay (checkbox entry) with the given name to the control.
        addOverlay: function(layer, name) {
            this._addLayer(layer, name, true);
            return this._map ? this._update() : this;
        },
        // @method removeLayer(layer: Layer): this
        // Remove the given layer from the control.
        removeLayer: function(layer) {
            layer.off('add remove', this._onLayerChange, this);
            var obj = this._getLayer(stamp(layer));
            if (obj) this._layers.splice(this._layers.indexOf(obj), 1);
            return this._map ? this._update() : this;
        },
        // @method expand(): this
        // Expand the control container if collapsed.
        expand: function() {
            addClass(this._container, 'leaflet-control-layers-expanded');
            this._section.style.height = null;
            var acceptableHeight = this._map.getSize().y - (this._container.offsetTop + 50);
            if (acceptableHeight < this._section.clientHeight) {
                addClass(this._section, 'leaflet-control-layers-scrollbar');
                this._section.style.height = acceptableHeight + 'px';
            } else removeClass(this._section, 'leaflet-control-layers-scrollbar');
            this._checkDisabledLayers();
            return this;
        },
        // @method collapse(): this
        // Collapse the control container if expanded.
        collapse: function() {
            removeClass(this._container, 'leaflet-control-layers-expanded');
            return this;
        },
        _initLayout: function() {
            var className = 'leaflet-control-layers', container = this._container = create$1('div', className), collapsed = this.options.collapsed;
            // makes this work on IE touch devices by stopping it from firing a mouseout event when the touch is released
            container.setAttribute('aria-haspopup', true);
            disableClickPropagation(container);
            disableScrollPropagation(container);
            var section = this._section = create$1('section', className + '-list');
            if (collapsed) {
                this._map.on('click', this.collapse, this);
                on(container, {
                    mouseenter: this._expandSafely,
                    mouseleave: this.collapse
                }, this);
            }
            var link = this._layersLink = create$1('a', className + '-toggle', container);
            link.href = '#';
            link.title = 'Layers';
            link.setAttribute('role', 'button');
            on(link, {
                keydown: function(e) {
                    if (e.keyCode === 13) this._expandSafely();
                },
                // Certain screen readers intercept the key event and instead send a click event
                click: function(e) {
                    preventDefault(e);
                    this._expandSafely();
                }
            }, this);
            if (!collapsed) this.expand();
            this._baseLayersList = create$1('div', className + '-base', section);
            this._separator = create$1('div', className + '-separator', section);
            this._overlaysList = create$1('div', className + '-overlays', section);
            container.appendChild(section);
        },
        _getLayer: function(id) {
            for(var i = 0; i < this._layers.length; i++){
                if (this._layers[i] && stamp(this._layers[i].layer) === id) return this._layers[i];
            }
        },
        _addLayer: function(layer, name, overlay) {
            if (this._map) layer.on('add remove', this._onLayerChange, this);
            this._layers.push({
                layer: layer,
                name: name,
                overlay: overlay
            });
            if (this.options.sortLayers) this._layers.sort(bind(function(a, b) {
                return this.options.sortFunction(a.layer, b.layer, a.name, b.name);
            }, this));
            if (this.options.autoZIndex && layer.setZIndex) {
                this._lastZIndex++;
                layer.setZIndex(this._lastZIndex);
            }
            this._expandIfNotCollapsed();
        },
        _update: function() {
            if (!this._container) return this;
            empty(this._baseLayersList);
            empty(this._overlaysList);
            this._layerControlInputs = [];
            var baseLayersPresent, overlaysPresent, i, obj, baseLayersCount = 0;
            for(i = 0; i < this._layers.length; i++){
                obj = this._layers[i];
                this._addItem(obj);
                overlaysPresent = overlaysPresent || obj.overlay;
                baseLayersPresent = baseLayersPresent || !obj.overlay;
                baseLayersCount += !obj.overlay ? 1 : 0;
            }
            // Hide base layers section if there's only one layer.
            if (this.options.hideSingleBase) {
                baseLayersPresent = baseLayersPresent && baseLayersCount > 1;
                this._baseLayersList.style.display = baseLayersPresent ? '' : 'none';
            }
            this._separator.style.display = overlaysPresent && baseLayersPresent ? '' : 'none';
            return this;
        },
        _onLayerChange: function(e) {
            if (!this._handlingClick) this._update();
            var obj = this._getLayer(stamp(e.target));
            // @namespace Map
            // @section Layer events
            // @event baselayerchange: LayersControlEvent
            // Fired when the base layer is changed through the [layers control](#control-layers).
            // @event overlayadd: LayersControlEvent
            // Fired when an overlay is selected through the [layers control](#control-layers).
            // @event overlayremove: LayersControlEvent
            // Fired when an overlay is deselected through the [layers control](#control-layers).
            // @namespace Control.Layers
            var type = obj.overlay ? e.type === 'add' ? 'overlayadd' : 'overlayremove' : e.type === 'add' ? 'baselayerchange' : null;
            if (type) this._map.fire(type, obj);
        },
        // IE7 bugs out if you create a radio dynamically, so you have to do it this hacky way (see https://stackoverflow.com/a/119079)
        _createRadioElement: function(name, checked) {
            var radioHtml = '<input type="radio" class="leaflet-control-layers-selector" name="' + name + '"' + (checked ? ' checked="checked"' : '') + '/>';
            var radioFragment = document.createElement('div');
            radioFragment.innerHTML = radioHtml;
            return radioFragment.firstChild;
        },
        _addItem: function(obj) {
            var label = document.createElement('label'), checked = this._map.hasLayer(obj.layer), input;
            if (obj.overlay) {
                input = document.createElement('input');
                input.type = 'checkbox';
                input.className = 'leaflet-control-layers-selector';
                input.defaultChecked = checked;
            } else input = this._createRadioElement('leaflet-base-layers_' + stamp(this), checked);
            this._layerControlInputs.push(input);
            input.layerId = stamp(obj.layer);
            on(input, 'click', this._onInputClick, this);
            var name = document.createElement('span');
            name.innerHTML = ' ' + obj.name;
            // Helps from preventing layer control flicker when checkboxes are disabled
            // https://github.com/Leaflet/Leaflet/issues/2771
            var holder = document.createElement('span');
            label.appendChild(holder);
            holder.appendChild(input);
            holder.appendChild(name);
            var container = obj.overlay ? this._overlaysList : this._baseLayersList;
            container.appendChild(label);
            this._checkDisabledLayers();
            return label;
        },
        _onInputClick: function() {
            // expanding the control on mobile with a click can cause adding a layer - we don't want this
            if (this._preventClick) return;
            var inputs = this._layerControlInputs, input, layer;
            var addedLayers = [], removedLayers = [];
            this._handlingClick = true;
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                if (input.checked) addedLayers.push(layer);
                else if (!input.checked) removedLayers.push(layer);
            }
            // Bugfix issue 2318: Should remove all old layers before readding new ones
            for(i = 0; i < removedLayers.length; i++)if (this._map.hasLayer(removedLayers[i])) this._map.removeLayer(removedLayers[i]);
            for(i = 0; i < addedLayers.length; i++)if (!this._map.hasLayer(addedLayers[i])) this._map.addLayer(addedLayers[i]);
            this._handlingClick = false;
            this._refocusOnMap();
        },
        _checkDisabledLayers: function() {
            var inputs = this._layerControlInputs, input, layer, zoom = this._map.getZoom();
            for(var i = inputs.length - 1; i >= 0; i--){
                input = inputs[i];
                layer = this._getLayer(input.layerId).layer;
                input.disabled = layer.options.minZoom !== undefined && zoom < layer.options.minZoom || layer.options.maxZoom !== undefined && zoom > layer.options.maxZoom;
            }
        },
        _expandIfNotCollapsed: function() {
            if (this._map && !this.options.collapsed) this.expand();
            return this;
        },
        _expandSafely: function() {
            var section = this._section;
            this._preventClick = true;
            on(section, 'click', preventDefault);
            this.expand();
            var that = this;
            setTimeout(function() {
                off(section, 'click', preventDefault);
                that._preventClick = false;
            });
        }
    });
    // @factory L.control.layers(baselayers?: Object, overlays?: Object, options?: Control.Layers options)
    // Creates a layers control with the given layers. Base layers will be switched with radio buttons, while overlays will be switched with checkboxes. Note that all base layers should be passed in the base layers object, but only one should be added to the map during map instantiation.
    var layers = function(baseLayers, overlays, options) {
        return new Layers(baseLayers, overlays, options);
    };
    /*
   * @class Control.Zoom
   * @aka L.Control.Zoom
   * @inherits Control
   *
   * A basic zoom control with two buttons (zoom in and zoom out). It is put on the map by default unless you set its [`zoomControl` option](#map-zoomcontrol) to `false`. Extends `Control`.
   */ var Zoom = Control.extend({
        // @section
        // @aka Control.Zoom options
        options: {
            position: 'topleft',
            // @option zoomInText: String = '<span aria-hidden="true">+</span>'
            // The text set on the 'zoom in' button.
            zoomInText: '<span aria-hidden="true">+</span>',
            // @option zoomInTitle: String = 'Zoom in'
            // The title set on the 'zoom in' button.
            zoomInTitle: 'Zoom in',
            // @option zoomOutText: String = '<span aria-hidden="true">&#x2212;</span>'
            // The text set on the 'zoom out' button.
            zoomOutText: '<span aria-hidden="true">&#x2212;</span>',
            // @option zoomOutTitle: String = 'Zoom out'
            // The title set on the 'zoom out' button.
            zoomOutTitle: 'Zoom out'
        },
        onAdd: function(map) {
            var zoomName = 'leaflet-control-zoom', container = create$1('div', zoomName + ' leaflet-bar'), options = this.options;
            this._zoomInButton = this._createButton(options.zoomInText, options.zoomInTitle, zoomName + '-in', container, this._zoomIn);
            this._zoomOutButton = this._createButton(options.zoomOutText, options.zoomOutTitle, zoomName + '-out', container, this._zoomOut);
            this._updateDisabled();
            map.on('zoomend zoomlevelschange', this._updateDisabled, this);
            return container;
        },
        onRemove: function(map) {
            map.off('zoomend zoomlevelschange', this._updateDisabled, this);
        },
        disable: function() {
            this._disabled = true;
            this._updateDisabled();
            return this;
        },
        enable: function() {
            this._disabled = false;
            this._updateDisabled();
            return this;
        },
        _zoomIn: function(e) {
            if (!this._disabled && this._map._zoom < this._map.getMaxZoom()) this._map.zoomIn(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _zoomOut: function(e) {
            if (!this._disabled && this._map._zoom > this._map.getMinZoom()) this._map.zoomOut(this._map.options.zoomDelta * (e.shiftKey ? 3 : 1));
        },
        _createButton: function(html, title, className, container, fn) {
            var link = create$1('a', className, container);
            link.innerHTML = html;
            link.href = '#';
            link.title = title;
            /*
  		 * Will force screen readers like VoiceOver to read this as "Zoom in - button"
  		 */ link.setAttribute('role', 'button');
            link.setAttribute('aria-label', title);
            disableClickPropagation(link);
            on(link, 'click', stop);
            on(link, 'click', fn, this);
            on(link, 'click', this._refocusOnMap, this);
            return link;
        },
        _updateDisabled: function() {
            var map = this._map, className = 'leaflet-disabled';
            removeClass(this._zoomInButton, className);
            removeClass(this._zoomOutButton, className);
            this._zoomInButton.setAttribute('aria-disabled', 'false');
            this._zoomOutButton.setAttribute('aria-disabled', 'false');
            if (this._disabled || map._zoom === map.getMinZoom()) {
                addClass(this._zoomOutButton, className);
                this._zoomOutButton.setAttribute('aria-disabled', 'true');
            }
            if (this._disabled || map._zoom === map.getMaxZoom()) {
                addClass(this._zoomInButton, className);
                this._zoomInButton.setAttribute('aria-disabled', 'true');
            }
        }
    });
    // @namespace Map
    // @section Control options
    // @option zoomControl: Boolean = true
    // Whether a [zoom control](#control-zoom) is added to the map by default.
    Map.mergeOptions({
        zoomControl: true
    });
    Map.addInitHook(function() {
        if (this.options.zoomControl) {
            // @section Controls
            // @property zoomControl: Control.Zoom
            // The default zoom control (only available if the
            // [`zoomControl` option](#map-zoomcontrol) was `true` when creating the map).
            this.zoomControl = new Zoom();
            this.addControl(this.zoomControl);
        }
    });
    // @namespace Control.Zoom
    // @factory L.control.zoom(options: Control.Zoom options)
    // Creates a zoom control
    var zoom = function(options) {
        return new Zoom(options);
    };
    /*
   * @class Control.Scale
   * @aka L.Control.Scale
   * @inherits Control
   *
   * A simple scale control that shows the scale of the current center of screen in metric (m/km) and imperial (mi/ft) systems. Extends `Control`.
   *
   * @example
   *
   * ```js
   * L.control.scale().addTo(map);
   * ```
   */ var Scale = Control.extend({
        // @section
        // @aka Control.Scale options
        options: {
            position: 'bottomleft',
            // @option maxWidth: Number = 100
            // Maximum width of the control in pixels. The width is set dynamically to show round values (e.g. 100, 200, 500).
            maxWidth: 100,
            // @option metric: Boolean = True
            // Whether to show the metric scale line (m/km).
            metric: true,
            // @option imperial: Boolean = True
            // Whether to show the imperial scale line (mi/ft).
            imperial: true
        },
        onAdd: function(map) {
            var className = 'leaflet-control-scale', container = create$1('div', className), options = this.options;
            this._addScales(options, className + '-line', container);
            map.on(options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
            map.whenReady(this._update, this);
            return container;
        },
        onRemove: function(map) {
            map.off(this.options.updateWhenIdle ? 'moveend' : 'move', this._update, this);
        },
        _addScales: function(options, className, container) {
            if (options.metric) this._mScale = create$1('div', className, container);
            if (options.imperial) this._iScale = create$1('div', className, container);
        },
        _update: function() {
            var map = this._map, y = map.getSize().y / 2;
            var maxMeters = map.distance(map.containerPointToLatLng([
                0,
                y
            ]), map.containerPointToLatLng([
                this.options.maxWidth,
                y
            ]));
            this._updateScales(maxMeters);
        },
        _updateScales: function(maxMeters) {
            if (this.options.metric && maxMeters) this._updateMetric(maxMeters);
            if (this.options.imperial && maxMeters) this._updateImperial(maxMeters);
        },
        _updateMetric: function(maxMeters) {
            var meters = this._getRoundNum(maxMeters), label = meters < 1000 ? meters + ' m' : meters / 1000 + ' km';
            this._updateScale(this._mScale, label, meters / maxMeters);
        },
        _updateImperial: function(maxMeters) {
            var maxFeet = maxMeters * 3.2808399, maxMiles, miles, feet;
            if (maxFeet > 5280) {
                maxMiles = maxFeet / 5280;
                miles = this._getRoundNum(maxMiles);
                this._updateScale(this._iScale, miles + ' mi', miles / maxMiles);
            } else {
                feet = this._getRoundNum(maxFeet);
                this._updateScale(this._iScale, feet + ' ft', feet / maxFeet);
            }
        },
        _updateScale: function(scale, text, ratio) {
            scale.style.width = Math.round(this.options.maxWidth * ratio) + 'px';
            scale.innerHTML = text;
        },
        _getRoundNum: function(num) {
            var pow10 = Math.pow(10, (Math.floor(num) + '').length - 1), d = num / pow10;
            d = d >= 10 ? 10 : d >= 5 ? 5 : d >= 3 ? 3 : d >= 2 ? 2 : 1;
            return pow10 * d;
        }
    });
    // @factory L.control.scale(options?: Control.Scale options)
    // Creates an scale control with the given options.
    var scale = function(options) {
        return new Scale(options);
    };
    var ukrainianFlag = '<svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="8" viewBox="0 0 12 8" class="leaflet-attribution-flag"><path fill="#4C7BE1" d="M0 0h12v4H0z"/><path fill="#FFD500" d="M0 4h12v3H0z"/><path fill="#E0BC00" d="M0 7h12v1H0z"/></svg>';
    /*
   * @class Control.Attribution
   * @aka L.Control.Attribution
   * @inherits Control
   *
   * The attribution control allows you to display attribution data in a small text box on a map. It is put on the map by default unless you set its [`attributionControl` option](#map-attributioncontrol) to `false`, and it fetches attribution texts from layers with the [`getAttribution` method](#layer-getattribution) automatically. Extends Control.
   */ var Attribution = Control.extend({
        // @section
        // @aka Control.Attribution options
        options: {
            position: 'bottomright',
            // @option prefix: String|false = 'Leaflet'
            // The HTML text shown before the attributions. Pass `false` to disable.
            prefix: '<a href="https://leafletjs.com" title="A JavaScript library for interactive maps">' + (Browser.inlineSvg ? ukrainianFlag + ' ' : '') + 'Leaflet</a>'
        },
        initialize: function(options) {
            setOptions(this, options);
            this._attributions = {};
        },
        onAdd: function(map) {
            map.attributionControl = this;
            this._container = create$1('div', 'leaflet-control-attribution');
            disableClickPropagation(this._container);
            // TODO ugly, refactor
            for(var i in map._layers)if (map._layers[i].getAttribution) this.addAttribution(map._layers[i].getAttribution());
            this._update();
            map.on('layeradd', this._addAttribution, this);
            return this._container;
        },
        onRemove: function(map) {
            map.off('layeradd', this._addAttribution, this);
        },
        _addAttribution: function(ev) {
            if (ev.layer.getAttribution) {
                this.addAttribution(ev.layer.getAttribution());
                ev.layer.once('remove', function() {
                    this.removeAttribution(ev.layer.getAttribution());
                }, this);
            }
        },
        // @method setPrefix(prefix: String|false): this
        // The HTML text shown before the attributions. Pass `false` to disable.
        setPrefix: function(prefix) {
            this.options.prefix = prefix;
            this._update();
            return this;
        },
        // @method addAttribution(text: String): this
        // Adds an attribution text (e.g. `'&copy; OpenStreetMap contributors'`).
        addAttribution: function(text) {
            if (!text) return this;
            if (!this._attributions[text]) this._attributions[text] = 0;
            this._attributions[text]++;
            this._update();
            return this;
        },
        // @method removeAttribution(text: String): this
        // Removes an attribution text.
        removeAttribution: function(text) {
            if (!text) return this;
            if (this._attributions[text]) {
                this._attributions[text]--;
                this._update();
            }
            return this;
        },
        _update: function() {
            if (!this._map) return;
            var attribs = [];
            for(var i in this._attributions)if (this._attributions[i]) attribs.push(i);
            var prefixAndAttribs = [];
            if (this.options.prefix) prefixAndAttribs.push(this.options.prefix);
            if (attribs.length) prefixAndAttribs.push(attribs.join(', '));
            this._container.innerHTML = prefixAndAttribs.join(' <span aria-hidden="true">|</span> ');
        }
    });
    // @namespace Map
    // @section Control options
    // @option attributionControl: Boolean = true
    // Whether a [attribution control](#control-attribution) is added to the map by default.
    Map.mergeOptions({
        attributionControl: true
    });
    Map.addInitHook(function() {
        if (this.options.attributionControl) new Attribution().addTo(this);
    });
    // @namespace Control.Attribution
    // @factory L.control.attribution(options: Control.Attribution options)
    // Creates an attribution control.
    var attribution = function(options) {
        return new Attribution(options);
    };
    Control.Layers = Layers;
    Control.Zoom = Zoom;
    Control.Scale = Scale;
    Control.Attribution = Attribution;
    control.layers = layers;
    control.zoom = zoom;
    control.scale = scale;
    control.attribution = attribution;
    /*
  	L.Handler is a base class for handler classes that are used internally to inject
  	interaction features like dragging to classes like Map and Marker.
  */ // @class Handler
    // @aka L.Handler
    // Abstract class for map interaction handlers
    var Handler = Class.extend({
        initialize: function(map) {
            this._map = map;
        },
        // @method enable(): this
        // Enables the handler
        enable: function() {
            if (this._enabled) return this;
            this._enabled = true;
            this.addHooks();
            return this;
        },
        // @method disable(): this
        // Disables the handler
        disable: function() {
            if (!this._enabled) return this;
            this._enabled = false;
            this.removeHooks();
            return this;
        },
        // @method enabled(): Boolean
        // Returns `true` if the handler is enabled
        enabled: function() {
            return !!this._enabled;
        }
    });
    // @section There is static function which can be called without instantiating L.Handler:
    // @function addTo(map: Map, name: String): this
    // Adds a new Handler to the given map with the given name.
    Handler.addTo = function(map, name) {
        map.addHandler(name, this);
        return this;
    };
    var Mixin = {
        Events: Events
    };
    /*
   * @class Draggable
   * @aka L.Draggable
   * @inherits Evented
   *
   * A class for making DOM elements draggable (including touch support).
   * Used internally for map and marker dragging. Only works for elements
   * that were positioned with [`L.DomUtil.setPosition`](#domutil-setposition).
   *
   * @example
   * ```js
   * var draggable = new L.Draggable(elementToDrag);
   * draggable.enable();
   * ```
   */ var START = Browser.touch ? 'touchstart mousedown' : 'mousedown';
    var Draggable = Evented.extend({
        options: {
            // @section
            // @aka Draggable options
            // @option clickTolerance: Number = 3
            // The max number of pixels a user can shift the mouse pointer during a click
            // for it to be considered a valid click (as opposed to a mouse drag).
            clickTolerance: 3
        },
        // @constructor L.Draggable(el: HTMLElement, dragHandle?: HTMLElement, preventOutline?: Boolean, options?: Draggable options)
        // Creates a `Draggable` object for moving `el` when you start dragging the `dragHandle` element (equals `el` itself by default).
        initialize: function(element, dragStartTarget, preventOutline, options) {
            setOptions(this, options);
            this._element = element;
            this._dragStartTarget = dragStartTarget || element;
            this._preventOutline = preventOutline;
        },
        // @method enable()
        // Enables the dragging ability
        enable: function() {
            if (this._enabled) return;
            on(this._dragStartTarget, START, this._onDown, this);
            this._enabled = true;
        },
        // @method disable()
        // Disables the dragging ability
        disable: function() {
            if (!this._enabled) return;
            // If we're currently dragging this draggable,
            // disabling it counts as first ending the drag.
            if (Draggable._dragging === this) this.finishDrag(true);
            off(this._dragStartTarget, START, this._onDown, this);
            this._enabled = false;
            this._moved = false;
        },
        _onDown: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this._moved = false;
            if (hasClass(this._element, 'leaflet-zoom-anim')) return;
            if (e.touches && e.touches.length !== 1) {
                // Finish dragging to avoid conflict with touchZoom
                if (Draggable._dragging === this) this.finishDrag();
                return;
            }
            if (Draggable._dragging || e.shiftKey || e.which !== 1 && e.button !== 1 && !e.touches) return;
            Draggable._dragging = this; // Prevent dragging multiple objects at once.
            if (this._preventOutline) preventOutline(this._element);
            disableImageDrag();
            disableTextSelection();
            if (this._moving) return;
            // @event down: Event
            // Fired when a drag is about to start.
            this.fire('down');
            var first = e.touches ? e.touches[0] : e, sizedParent = getSizedParentNode(this._element);
            this._startPoint = new Point(first.clientX, first.clientY);
            this._startPos = getPosition(this._element);
            // Cache the scale, so that we can continuously compensate for it during drag (_onMove).
            this._parentScale = getScale(sizedParent);
            var mouseevent = e.type === 'mousedown';
            on(document, mouseevent ? 'mousemove' : 'touchmove', this._onMove, this);
            on(document, mouseevent ? 'mouseup' : 'touchend touchcancel', this._onUp, this);
        },
        _onMove: function(e) {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            if (e.touches && e.touches.length > 1) {
                this._moved = true;
                return;
            }
            var first = e.touches && e.touches.length === 1 ? e.touches[0] : e, offset = new Point(first.clientX, first.clientY)._subtract(this._startPoint);
            if (!offset.x && !offset.y) return;
            if (Math.abs(offset.x) + Math.abs(offset.y) < this.options.clickTolerance) return;
            // We assume that the parent container's position, border and scale do not change for the duration of the drag.
            // Therefore there is no need to account for the position and border (they are eliminated by the subtraction)
            // and we can use the cached value for the scale.
            offset.x /= this._parentScale.x;
            offset.y /= this._parentScale.y;
            preventDefault(e);
            if (!this._moved) {
                // @event dragstart: Event
                // Fired when a drag starts
                this.fire('dragstart');
                this._moved = true;
                addClass(document.body, 'leaflet-dragging');
                this._lastTarget = e.target || e.srcElement;
                // IE and Edge do not give the <use> element, so fetch it
                // if necessary
                if (window.SVGElementInstance && this._lastTarget instanceof window.SVGElementInstance) this._lastTarget = this._lastTarget.correspondingUseElement;
                addClass(this._lastTarget, 'leaflet-drag-target');
            }
            this._newPos = this._startPos.add(offset);
            this._moving = true;
            this._lastEvent = e;
            this._updatePosition();
        },
        _updatePosition: function() {
            var e = {
                originalEvent: this._lastEvent
            };
            // @event predrag: Event
            // Fired continuously during dragging *before* each corresponding
            // update of the element's position.
            this.fire('predrag', e);
            setPosition(this._element, this._newPos);
            // @event drag: Event
            // Fired continuously during dragging.
            this.fire('drag', e);
        },
        _onUp: function() {
            // Ignore the event if disabled; this happens in IE11
            // under some circumstances, see #3666.
            if (!this._enabled) return;
            this.finishDrag();
        },
        finishDrag: function(noInertia) {
            removeClass(document.body, 'leaflet-dragging');
            if (this._lastTarget) {
                removeClass(this._lastTarget, 'leaflet-drag-target');
                this._lastTarget = null;
            }
            off(document, 'mousemove touchmove', this._onMove, this);
            off(document, 'mouseup touchend touchcancel', this._onUp, this);
            enableImageDrag();
            enableTextSelection();
            var fireDragend = this._moved && this._moving;
            this._moving = false;
            Draggable._dragging = false;
            if (fireDragend) // @event dragend: DragEndEvent
            // Fired when the drag ends.
            this.fire('dragend', {
                noInertia: noInertia,
                distance: this._newPos.distanceTo(this._startPos)
            });
        }
    });
    /*
   * @namespace PolyUtil
   * Various utility functions for polygon geometries.
   */ /* @function clipPolygon(points: Point[], bounds: Bounds, round?: Boolean): Point[]
   * Clips the polygon geometry defined by the given `points` by the given bounds (using the [Sutherland-Hodgman algorithm](https://en.wikipedia.org/wiki/Sutherland%E2%80%93Hodgman_algorithm)).
   * Used by Leaflet to only show polygon points that are on the screen or near, increasing
   * performance. Note that polygon points needs different algorithm for clipping
   * than polyline, so there's a separate method for it.
   */ function clipPolygon(points, bounds, round) {
        var clippedPoints, edges = [
            1,
            4,
            2,
            8
        ], i, j, k, a, b, len, edge, p;
        for(i = 0, len = points.length; i < len; i++)points[i]._code = _getBitCode(points[i], bounds);
        // for each edge (left, bottom, right, top)
        for(k = 0; k < 4; k++){
            edge = edges[k];
            clippedPoints = [];
            for(i = 0, len = points.length, j = len - 1; i < len; j = i++){
                a = points[i];
                b = points[j];
                // if a is inside the clip window
                if (!(a._code & edge)) {
                    // if b is outside the clip window (a->b goes out of screen)
                    if (b._code & edge) {
                        p = _getEdgeIntersection(b, a, edge, bounds, round);
                        p._code = _getBitCode(p, bounds);
                        clippedPoints.push(p);
                    }
                    clippedPoints.push(a);
                // else if b is inside the clip window (a->b enters the screen)
                } else if (!(b._code & edge)) {
                    p = _getEdgeIntersection(b, a, edge, bounds, round);
                    p._code = _getBitCode(p, bounds);
                    clippedPoints.push(p);
                }
            }
            points = clippedPoints;
        }
        return points;
    }
    /* @function polygonCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polygon.
   */ function polygonCenter(latlngs, crs) {
        var i, j, p1, p2, f, area, x, y, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        area = x = y = 0;
        // polygon centroid algorithm;
        for(i = 0, j = len - 1; i < len; j = i++){
            p1 = points[i];
            p2 = points[j];
            f = p1.y * p2.x - p2.y * p1.x;
            x += (p1.x + p2.x) * f;
            y += (p1.y + p2.y) * f;
            area += f * 3;
        }
        if (area === 0) // Polygon is so small that all points are on same pixel.
        center = points[0];
        else center = [
            x / area,
            y / area
        ];
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    /* @function centroid(latlngs: LatLng[]): LatLng
   * Returns the 'center of mass' of the passed LatLngs.
   */ function centroid(coords) {
        var latSum = 0;
        var lngSum = 0;
        var len = 0;
        for(var i = 0; i < coords.length; i++){
            var latlng = toLatLng(coords[i]);
            latSum += latlng.lat;
            lngSum += latlng.lng;
            len++;
        }
        return toLatLng([
            latSum / len,
            lngSum / len
        ]);
    }
    var PolyUtil = {
        __proto__: null,
        clipPolygon: clipPolygon,
        polygonCenter: polygonCenter,
        centroid: centroid
    };
    /*
   * @namespace LineUtil
   *
   * Various utility functions for polyline points processing, used by Leaflet internally to make polylines lightning-fast.
   */ // Simplify polyline with vertex reduction and Douglas-Peucker simplification.
    // Improves rendering performance dramatically by lessening the number of points to draw.
    // @function simplify(points: Point[], tolerance: Number): Point[]
    // Dramatically reduces the number of points in a polyline while retaining
    // its shape and returns a new array of simplified points, using the
    // [Ramer-Douglas-Peucker algorithm](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm).
    // Used for a huge performance boost when processing/displaying Leaflet polylines for
    // each zoom level and also reducing visual noise. tolerance affects the amount of
    // simplification (lesser value means higher quality but slower and with more points).
    // Also released as a separated micro-library [Simplify.js](https://mourner.github.io/simplify-js/).
    function simplify(points, tolerance) {
        if (!tolerance || !points.length) return points.slice();
        var sqTolerance = tolerance * tolerance;
        // stage 1: vertex reduction
        points = _reducePoints(points, sqTolerance);
        // stage 2: Douglas-Peucker simplification
        points = _simplifyDP(points, sqTolerance);
        return points;
    }
    // @function pointToSegmentDistance(p: Point, p1: Point, p2: Point): Number
    // Returns the distance between point `p` and segment `p1` to `p2`.
    function pointToSegmentDistance(p, p1, p2) {
        return Math.sqrt(_sqClosestPointOnSegment(p, p1, p2, true));
    }
    // @function closestPointOnSegment(p: Point, p1: Point, p2: Point): Number
    // Returns the closest point from a point `p` on a segment `p1` to `p2`.
    function closestPointOnSegment(p, p1, p2) {
        return _sqClosestPointOnSegment(p, p1, p2);
    }
    // Ramer-Douglas-Peucker simplification, see https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm
    function _simplifyDP(points, sqTolerance) {
        var len = points.length, ArrayConstructor = typeof Uint8Array !== "undefined" ? Uint8Array : Array, markers = new ArrayConstructor(len);
        markers[0] = markers[len - 1] = 1;
        _simplifyDPStep(points, markers, sqTolerance, 0, len - 1);
        var i, newPoints = [];
        for(i = 0; i < len; i++)if (markers[i]) newPoints.push(points[i]);
        return newPoints;
    }
    function _simplifyDPStep(points, markers, sqTolerance, first, last) {
        var maxSqDist = 0, index, i, sqDist;
        for(i = first + 1; i <= last - 1; i++){
            sqDist = _sqClosestPointOnSegment(points[i], points[first], points[last], true);
            if (sqDist > maxSqDist) {
                index = i;
                maxSqDist = sqDist;
            }
        }
        if (maxSqDist > sqTolerance) {
            markers[index] = 1;
            _simplifyDPStep(points, markers, sqTolerance, first, index);
            _simplifyDPStep(points, markers, sqTolerance, index, last);
        }
    }
    // reduce points that are too close to each other to a single point
    function _reducePoints(points, sqTolerance) {
        var reducedPoints = [
            points[0]
        ];
        for(var i = 1, prev = 0, len = points.length; i < len; i++)if (_sqDist(points[i], points[prev]) > sqTolerance) {
            reducedPoints.push(points[i]);
            prev = i;
        }
        if (prev < len - 1) reducedPoints.push(points[len - 1]);
        return reducedPoints;
    }
    var _lastCode;
    // @function clipSegment(a: Point, b: Point, bounds: Bounds, useLastCode?: Boolean, round?: Boolean): Point[]|Boolean
    // Clips the segment a to b by rectangular bounds with the
    // [Cohen-Sutherland algorithm](https://en.wikipedia.org/wiki/Cohen%E2%80%93Sutherland_algorithm)
    // (modifying the segment points directly!). Used by Leaflet to only show polyline
    // points that are on the screen or near, increasing performance.
    function clipSegment(a, b, bounds, useLastCode, round) {
        var codeA = useLastCode ? _lastCode : _getBitCode(a, bounds), codeB = _getBitCode(b, bounds), codeOut, p, newCode;
        // save 2nd code to avoid calculating it on the next segment
        _lastCode = codeB;
        while(true){
            // if a,b is inside the clip window (trivial accept)
            if (!(codeA | codeB)) return [
                a,
                b
            ];
            // if a,b is outside the clip window (trivial reject)
            if (codeA & codeB) return false;
            // other cases
            codeOut = codeA || codeB;
            p = _getEdgeIntersection(a, b, codeOut, bounds, round);
            newCode = _getBitCode(p, bounds);
            if (codeOut === codeA) {
                a = p;
                codeA = newCode;
            } else {
                b = p;
                codeB = newCode;
            }
        }
    }
    function _getEdgeIntersection(a, b, code, bounds, round) {
        var dx = b.x - a.x, dy = b.y - a.y, min = bounds.min, max = bounds.max, x, y;
        if (code & 8) {
            x = a.x + dx * (max.y - a.y) / dy;
            y = max.y;
        } else if (code & 4) {
            x = a.x + dx * (min.y - a.y) / dy;
            y = min.y;
        } else if (code & 2) {
            x = max.x;
            y = a.y + dy * (max.x - a.x) / dx;
        } else if (code & 1) {
            x = min.x;
            y = a.y + dy * (min.x - a.x) / dx;
        }
        return new Point(x, y, round);
    }
    function _getBitCode(p, bounds) {
        var code = 0;
        if (p.x < bounds.min.x) code |= 1;
        else if (p.x > bounds.max.x) code |= 2;
        if (p.y < bounds.min.y) code |= 4;
        else if (p.y > bounds.max.y) code |= 8;
        return code;
    }
    // square distance (to avoid unnecessary Math.sqrt calls)
    function _sqDist(p1, p2) {
        var dx = p2.x - p1.x, dy = p2.y - p1.y;
        return dx * dx + dy * dy;
    }
    // return closest point on segment or distance to that point
    function _sqClosestPointOnSegment(p, p1, p2, sqDist) {
        var x = p1.x, y = p1.y, dx = p2.x - x, dy = p2.y - y, dot = dx * dx + dy * dy, t;
        if (dot > 0) {
            t = ((p.x - x) * dx + (p.y - y) * dy) / dot;
            if (t > 1) {
                x = p2.x;
                y = p2.y;
            } else if (t > 0) {
                x += dx * t;
                y += dy * t;
            }
        }
        dx = p.x - x;
        dy = p.y - y;
        return sqDist ? dx * dx + dy * dy : new Point(x, y);
    }
    // @function isFlat(latlngs: LatLng[]): Boolean
    // Returns true if `latlngs` is a flat array, false is nested.
    function isFlat(latlngs) {
        return !isArray(latlngs[0]) || typeof latlngs[0][0] !== 'object' && typeof latlngs[0][0] !== 'undefined';
    }
    function _flat(latlngs) {
        console.warn('Deprecated use of _flat, please use L.LineUtil.isFlat instead.');
        return isFlat(latlngs);
    }
    /* @function polylineCenter(latlngs: LatLng[], crs: CRS): LatLng
   * Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the passed LatLngs (first ring) from a polyline.
   */ function polylineCenter(latlngs, crs) {
        var i, halfDist, segDist, dist, p1, p2, ratio, center;
        if (!latlngs || latlngs.length === 0) throw new Error('latlngs not passed');
        if (!isFlat(latlngs)) {
            console.warn('latlngs are not flat! Only the first ring will be used');
            latlngs = latlngs[0];
        }
        var centroidLatLng = toLatLng([
            0,
            0
        ]);
        var bounds = toLatLngBounds(latlngs);
        var areaBounds = bounds.getNorthWest().distanceTo(bounds.getSouthWest()) * bounds.getNorthEast().distanceTo(bounds.getNorthWest());
        // tests showed that below 1700 rounding errors are happening
        if (areaBounds < 1700) // getting a inexact center, to move the latlngs near to [0, 0] to prevent rounding errors
        centroidLatLng = centroid(latlngs);
        var len = latlngs.length;
        var points = [];
        for(i = 0; i < len; i++){
            var latlng = toLatLng(latlngs[i]);
            points.push(crs.project(toLatLng([
                latlng.lat - centroidLatLng.lat,
                latlng.lng - centroidLatLng.lng
            ])));
        }
        for(i = 0, halfDist = 0; i < len - 1; i++)halfDist += points[i].distanceTo(points[i + 1]) / 2;
        // The line is so small in the current view that all points are on the same pixel.
        if (halfDist === 0) center = points[0];
        else for(i = 0, dist = 0; i < len - 1; i++){
            p1 = points[i];
            p2 = points[i + 1];
            segDist = p1.distanceTo(p2);
            dist += segDist;
            if (dist > halfDist) {
                ratio = (dist - halfDist) / segDist;
                center = [
                    p2.x - ratio * (p2.x - p1.x),
                    p2.y - ratio * (p2.y - p1.y)
                ];
                break;
            }
        }
        var latlngCenter = crs.unproject(toPoint(center));
        return toLatLng([
            latlngCenter.lat + centroidLatLng.lat,
            latlngCenter.lng + centroidLatLng.lng
        ]);
    }
    var LineUtil = {
        __proto__: null,
        simplify: simplify,
        pointToSegmentDistance: pointToSegmentDistance,
        closestPointOnSegment: closestPointOnSegment,
        clipSegment: clipSegment,
        _getEdgeIntersection: _getEdgeIntersection,
        _getBitCode: _getBitCode,
        _sqClosestPointOnSegment: _sqClosestPointOnSegment,
        isFlat: isFlat,
        _flat: _flat,
        polylineCenter: polylineCenter
    };
    /*
   * @namespace Projection
   * @section
   * Leaflet comes with a set of already defined Projections out of the box:
   *
   * @projection L.Projection.LonLat
   *
   * Equirectangular, or Plate Carree projection — the most simple projection,
   * mostly used by GIS enthusiasts. Directly maps `x` as longitude, and `y` as
   * latitude. Also suitable for flat worlds, e.g. game maps. Used by the
   * `EPSG:4326` and `Simple` CRS.
   */ var LonLat = {
        project: function(latlng) {
            return new Point(latlng.lng, latlng.lat);
        },
        unproject: function(point) {
            return new LatLng(point.y, point.x);
        },
        bounds: new Bounds([
            -180,
            -90
        ], [
            180,
            90
        ])
    };
    /*
   * @namespace Projection
   * @projection L.Projection.Mercator
   *
   * Elliptical Mercator projection — more complex than Spherical Mercator. Assumes that Earth is an ellipsoid. Used by the EPSG:3395 CRS.
   */ var Mercator = {
        R: 6378137,
        R_MINOR: 6356752.314245179,
        bounds: new Bounds([
            -20037508.34279,
            -15496570.73972
        ], [
            20037508.34279,
            18764656.23138
        ]),
        project: function(latlng) {
            var d = Math.PI / 180, r = this.R, y = latlng.lat * d, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), con = e * Math.sin(y);
            var ts = Math.tan(Math.PI / 4 - y / 2) / Math.pow((1 - con) / (1 + con), e / 2);
            y = -r * Math.log(Math.max(ts, 1E-10));
            return new Point(latlng.lng * d * r, y);
        },
        unproject: function(point) {
            var d = 180 / Math.PI, r = this.R, tmp = this.R_MINOR / r, e = Math.sqrt(1 - tmp * tmp), ts = Math.exp(-point.y / r), phi = Math.PI / 2 - 2 * Math.atan(ts);
            for(var i = 0, dphi = 0.1, con; i < 15 && Math.abs(dphi) > 1e-7; i++){
                con = e * Math.sin(phi);
                con = Math.pow((1 - con) / (1 + con), e / 2);
                dphi = Math.PI / 2 - 2 * Math.atan(ts * con) - phi;
                phi += dphi;
            }
            return new LatLng(phi * d, point.x * d / r);
        }
    };
    /*
   * @class Projection

   * An object with methods for projecting geographical coordinates of the world onto
   * a flat surface (and back). See [Map projection](https://en.wikipedia.org/wiki/Map_projection).

   * @property bounds: Bounds
   * The bounds (specified in CRS units) where the projection is valid

   * @method project(latlng: LatLng): Point
   * Projects geographical coordinates into a 2D point.
   * Only accepts actual `L.LatLng` instances, not arrays.

   * @method unproject(point: Point): LatLng
   * The inverse of `project`. Projects a 2D point into a geographical location.
   * Only accepts actual `L.Point` instances, not arrays.

   * Note that the projection instances do not inherit from Leaflet's `Class` object,
   * and can't be instantiated. Also, new classes can't inherit from them,
   * and methods can't be added to them with the `include` function.

   */ var index = {
        __proto__: null,
        LonLat: LonLat,
        Mercator: Mercator,
        SphericalMercator: SphericalMercator
    };
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG3395
   *
   * Rarely used by some commercial tile providers. Uses Elliptical Mercator projection.
   */ var EPSG3395 = extend({}, Earth, {
        code: 'EPSG:3395',
        projection: Mercator,
        transformation: function() {
            var scale = 0.5 / (Math.PI * Mercator.R);
            return toTransformation(scale, 0.5, -scale, 0.5);
        }()
    });
    /*
   * @namespace CRS
   * @crs L.CRS.EPSG4326
   *
   * A common CRS among GIS enthusiasts. Uses simple Equirectangular projection.
   *
   * Leaflet 1.0.x complies with the [TMS coordinate scheme for EPSG:4326](https://wiki.osgeo.org/wiki/Tile_Map_Service_Specification#global-geodetic),
   * which is a breaking change from 0.7.x behaviour.  If you are using a `TileLayer`
   * with this CRS, ensure that there are two 256x256 pixel tiles covering the
   * whole earth at zoom level zero, and that the tile coordinate origin is (-180,+90),
   * or (-180,-90) for `TileLayer`s with [the `tms` option](#tilelayer-tms) set.
   */ var EPSG4326 = extend({}, Earth, {
        code: 'EPSG:4326',
        projection: LonLat,
        transformation: toTransformation(1 / 180, 1, -1 / 180, 0.5)
    });
    /*
   * @namespace CRS
   * @crs L.CRS.Simple
   *
   * A simple CRS that maps longitude and latitude into `x` and `y` directly.
   * May be used for maps of flat surfaces (e.g. game maps). Note that the `y`
   * axis should still be inverted (going from bottom to top). `distance()` returns
   * simple euclidean distance.
   */ var Simple = extend({}, CRS, {
        projection: LonLat,
        transformation: toTransformation(1, 0, -1, 0),
        scale: function(zoom) {
            return Math.pow(2, zoom);
        },
        zoom: function(scale) {
            return Math.log(scale) / Math.LN2;
        },
        distance: function(latlng1, latlng2) {
            var dx = latlng2.lng - latlng1.lng, dy = latlng2.lat - latlng1.lat;
            return Math.sqrt(dx * dx + dy * dy);
        },
        infinite: true
    });
    CRS.Earth = Earth;
    CRS.EPSG3395 = EPSG3395;
    CRS.EPSG3857 = EPSG3857;
    CRS.EPSG900913 = EPSG900913;
    CRS.EPSG4326 = EPSG4326;
    CRS.Simple = Simple;
    /*
   * @class Layer
   * @inherits Evented
   * @aka L.Layer
   * @aka ILayer
   *
   * A set of methods from the Layer base class that all Leaflet layers use.
   * Inherits all methods, options and events from `L.Evented`.
   *
   * @example
   *
   * ```js
   * var layer = L.marker(latlng).addTo(map);
   * layer.addTo(map);
   * layer.remove();
   * ```
   *
   * @event add: Event
   * Fired after the layer is added to a map
   *
   * @event remove: Event
   * Fired after the layer is removed from a map
   */ var Layer = Evented.extend({
        // Classes extending `L.Layer` will inherit the following options:
        options: {
            // @option pane: String = 'overlayPane'
            // By default the layer will be added to the map's [overlay pane](#map-overlaypane). Overriding this option will cause the layer to be placed on another pane by default.
            pane: 'overlayPane',
            // @option attribution: String = null
            // String to be shown in the attribution control, e.g. "© OpenStreetMap contributors". It describes the layer data and is often a legal obligation towards copyright holders and tile providers.
            attribution: null,
            bubblingMouseEvents: true
        },
        /* @section
  	 * Classes extending `L.Layer` will inherit the following methods:
  	 *
  	 * @method addTo(map: Map|LayerGroup): this
  	 * Adds the layer to the given map or layer group.
  	 */ addTo: function(map) {
            map.addLayer(this);
            return this;
        },
        // @method remove: this
        // Removes the layer from the map it is currently active on.
        remove: function() {
            return this.removeFrom(this._map || this._mapToAdd);
        },
        // @method removeFrom(map: Map): this
        // Removes the layer from the given map
        //
        // @alternative
        // @method removeFrom(group: LayerGroup): this
        // Removes the layer from the given `LayerGroup`
        removeFrom: function(obj) {
            if (obj) obj.removeLayer(this);
            return this;
        },
        // @method getPane(name? : String): HTMLElement
        // Returns the `HTMLElement` representing the named pane on the map. If `name` is omitted, returns the pane for this layer.
        getPane: function(name) {
            return this._map.getPane(name ? this.options[name] || name : this.options.pane);
        },
        addInteractiveTarget: function(targetEl) {
            this._map._targets[stamp(targetEl)] = this;
            return this;
        },
        removeInteractiveTarget: function(targetEl) {
            delete this._map._targets[stamp(targetEl)];
            return this;
        },
        // @method getAttribution: String
        // Used by the `attribution control`, returns the [attribution option](#gridlayer-attribution).
        getAttribution: function() {
            return this.options.attribution;
        },
        _layerAdd: function(e) {
            var map = e.target;
            // check in case layer gets added and then removed before the map is ready
            if (!map.hasLayer(this)) return;
            this._map = map;
            this._zoomAnimated = map._zoomAnimated;
            if (this.getEvents) {
                var events = this.getEvents();
                map.on(events, this);
                this.once('remove', function() {
                    map.off(events, this);
                }, this);
            }
            this.onAdd(map);
            this.fire('add');
            map.fire('layeradd', {
                layer: this
            });
        }
    });
    /* @section Extension methods
   * @uninheritable
   *
   * Every layer should extend from `L.Layer` and (re-)implement the following methods.
   *
   * @method onAdd(map: Map): this
   * Should contain code that creates DOM elements for the layer, adds them to `map panes` where they should belong and puts listeners on relevant map events. Called on [`map.addLayer(layer)`](#map-addlayer).
   *
   * @method onRemove(map: Map): this
   * Should contain all clean up code that removes the layer's elements from the DOM and removes listeners previously added in [`onAdd`](#layer-onadd). Called on [`map.removeLayer(layer)`](#map-removelayer).
   *
   * @method getEvents(): Object
   * This optional method should return an object like `{ viewreset: this._reset }` for [`addEventListener`](#evented-addeventlistener). The event handlers in this object will be automatically added and removed from the map with your layer.
   *
   * @method getAttribution(): String
   * This optional method should return a string containing HTML to be shown on the `Attribution control` whenever the layer is visible.
   *
   * @method beforeAdd(map: Map): this
   * Optional method. Called on [`map.addLayer(layer)`](#map-addlayer), before the layer is added to the map, before events are initialized, without waiting until the map is in a usable state. Use for early initialization only.
   */ /* @namespace Map
   * @section Layer events
   *
   * @event layeradd: LayerEvent
   * Fired when a new layer is added to the map.
   *
   * @event layerremove: LayerEvent
   * Fired when some layer is removed from the map
   *
   * @section Methods for Layers and Controls
   */ Map.include({
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the map
        addLayer: function(layer) {
            if (!layer._layerAdd) throw new Error('The provided object is not a Layer.');
            var id = stamp(layer);
            if (this._layers[id]) return this;
            this._layers[id] = layer;
            layer._mapToAdd = this;
            if (layer.beforeAdd) layer.beforeAdd(this);
            this.whenReady(layer._layerAdd, layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the map.
        removeLayer: function(layer) {
            var id = stamp(layer);
            if (!this._layers[id]) return this;
            if (this._loaded) layer.onRemove(this);
            delete this._layers[id];
            if (this._loaded) {
                this.fire('layerremove', {
                    layer: layer
                });
                layer.fire('remove');
            }
            layer._map = layer._mapToAdd = null;
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the map
        hasLayer: function(layer) {
            return stamp(layer) in this._layers;
        },
        /* @method eachLayer(fn: Function, context?: Object): this
  	 * Iterates over the layers of the map, optionally specifying context of the iterator function.
  	 * ```
  	 * map.eachLayer(function(layer){
  	 *     layer.bindPopup('Hello');
  	 * });
  	 * ```
  	 */ eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        _addLayers: function(layers) {
            layers = layers ? isArray(layers) ? layers : [
                layers
            ] : [];
            for(var i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        _addZoomLimit: function(layer) {
            if (!isNaN(layer.options.maxZoom) || !isNaN(layer.options.minZoom)) {
                this._zoomBoundLayers[stamp(layer)] = layer;
                this._updateZoomLevels();
            }
        },
        _removeZoomLimit: function(layer) {
            var id = stamp(layer);
            if (this._zoomBoundLayers[id]) {
                delete this._zoomBoundLayers[id];
                this._updateZoomLevels();
            }
        },
        _updateZoomLevels: function() {
            var minZoom = Infinity, maxZoom = -Infinity, oldZoomSpan = this._getZoomSpan();
            for(var i in this._zoomBoundLayers){
                var options = this._zoomBoundLayers[i].options;
                minZoom = options.minZoom === undefined ? minZoom : Math.min(minZoom, options.minZoom);
                maxZoom = options.maxZoom === undefined ? maxZoom : Math.max(maxZoom, options.maxZoom);
            }
            this._layersMaxZoom = maxZoom === -Infinity ? undefined : maxZoom;
            this._layersMinZoom = minZoom === Infinity ? undefined : minZoom;
            // @section Map state change events
            // @event zoomlevelschange: Event
            // Fired when the number of zoomlevels on the map is changed due
            // to adding or removing a layer.
            if (oldZoomSpan !== this._getZoomSpan()) this.fire('zoomlevelschange');
            if (this.options.maxZoom === undefined && this._layersMaxZoom && this.getZoom() > this._layersMaxZoom) this.setZoom(this._layersMaxZoom);
            if (this.options.minZoom === undefined && this._layersMinZoom && this.getZoom() < this._layersMinZoom) this.setZoom(this._layersMinZoom);
        }
    });
    /*
   * @class LayerGroup
   * @aka L.LayerGroup
   * @inherits Interactive layer
   *
   * Used to group several layers and handle them as one. If you add it to the map,
   * any layers added or removed from the group will be added/removed on the map as
   * well. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.layerGroup([marker1, marker2])
   * 	.addLayer(polyline)
   * 	.addTo(map);
   * ```
   */ var LayerGroup = Layer.extend({
        initialize: function(layers, options) {
            setOptions(this, options);
            this._layers = {};
            var i, len;
            if (layers) for(i = 0, len = layers.length; i < len; i++)this.addLayer(layers[i]);
        },
        // @method addLayer(layer: Layer): this
        // Adds the given layer to the group.
        addLayer: function(layer) {
            var id = this.getLayerId(layer);
            this._layers[id] = layer;
            if (this._map) this._map.addLayer(layer);
            return this;
        },
        // @method removeLayer(layer: Layer): this
        // Removes the given layer from the group.
        // @alternative
        // @method removeLayer(id: Number): this
        // Removes the layer with the given internal ID from the group.
        removeLayer: function(layer) {
            var id = layer in this._layers ? layer : this.getLayerId(layer);
            if (this._map && this._layers[id]) this._map.removeLayer(this._layers[id]);
            delete this._layers[id];
            return this;
        },
        // @method hasLayer(layer: Layer): Boolean
        // Returns `true` if the given layer is currently added to the group.
        // @alternative
        // @method hasLayer(id: Number): Boolean
        // Returns `true` if the given internal ID is currently added to the group.
        hasLayer: function(layer) {
            var layerId = typeof layer === 'number' ? layer : this.getLayerId(layer);
            return layerId in this._layers;
        },
        // @method clearLayers(): this
        // Removes all the layers from the group.
        clearLayers: function() {
            return this.eachLayer(this.removeLayer, this);
        },
        // @method invoke(methodName: String, …): this
        // Calls `methodName` on every layer contained in this group, passing any
        // additional parameters. Has no effect if the layers contained do not
        // implement `methodName`.
        invoke: function(methodName) {
            var args = Array.prototype.slice.call(arguments, 1), i, layer;
            for(i in this._layers){
                layer = this._layers[i];
                if (layer[methodName]) layer[methodName].apply(layer, args);
            }
            return this;
        },
        onAdd: function(map) {
            this.eachLayer(map.addLayer, map);
        },
        onRemove: function(map) {
            this.eachLayer(map.removeLayer, map);
        },
        // @method eachLayer(fn: Function, context?: Object): this
        // Iterates over the layers of the group, optionally specifying context of the iterator function.
        // ```js
        // group.eachLayer(function (layer) {
        // 	layer.bindPopup('Hello');
        // });
        // ```
        eachLayer: function(method, context) {
            for(var i in this._layers)method.call(context, this._layers[i]);
            return this;
        },
        // @method getLayer(id: Number): Layer
        // Returns the layer with the given internal ID.
        getLayer: function(id) {
            return this._layers[id];
        },
        // @method getLayers(): Layer[]
        // Returns an array of all the layers added to the group.
        getLayers: function() {
            var layers = [];
            this.eachLayer(layers.push, layers);
            return layers;
        },
        // @method setZIndex(zIndex: Number): this
        // Calls `setZIndex` on every layer contained in this group, passing the z-index.
        setZIndex: function(zIndex) {
            return this.invoke('setZIndex', zIndex);
        },
        // @method getLayerId(layer: Layer): Number
        // Returns the internal ID for a layer
        getLayerId: function(layer) {
            return stamp(layer);
        }
    });
    // @factory L.layerGroup(layers?: Layer[], options?: Object)
    // Create a layer group, optionally given an initial set of layers and an `options` object.
    var layerGroup = function(layers, options) {
        return new LayerGroup(layers, options);
    };
    /*
   * @class FeatureGroup
   * @aka L.FeatureGroup
   * @inherits LayerGroup
   *
   * Extended `LayerGroup` that makes it easier to do the same thing to all its member layers:
   *  * [`bindPopup`](#layer-bindpopup) binds a popup to all of the layers at once (likewise with [`bindTooltip`](#layer-bindtooltip))
   *  * Events are propagated to the `FeatureGroup`, so if the group has an event
   * handler, it will handle events from any of the layers. This includes mouse events
   * and custom events.
   *  * Has `layeradd` and `layerremove` events
   *
   * @example
   *
   * ```js
   * L.featureGroup([marker1, marker2, polyline])
   * 	.bindPopup('Hello world!')
   * 	.on('click', function() { alert('Clicked on a member of the group!'); })
   * 	.addTo(map);
   * ```
   */ var FeatureGroup = LayerGroup.extend({
        addLayer: function(layer) {
            if (this.hasLayer(layer)) return this;
            layer.addEventParent(this);
            LayerGroup.prototype.addLayer.call(this, layer);
            // @event layeradd: LayerEvent
            // Fired when a layer is added to this `FeatureGroup`
            return this.fire('layeradd', {
                layer: layer
            });
        },
        removeLayer: function(layer) {
            if (!this.hasLayer(layer)) return this;
            if (layer in this._layers) layer = this._layers[layer];
            layer.removeEventParent(this);
            LayerGroup.prototype.removeLayer.call(this, layer);
            // @event layerremove: LayerEvent
            // Fired when a layer is removed from this `FeatureGroup`
            return this.fire('layerremove', {
                layer: layer
            });
        },
        // @method setStyle(style: Path options): this
        // Sets the given path options to each layer of the group that has a `setStyle` method.
        setStyle: function(style) {
            return this.invoke('setStyle', style);
        },
        // @method bringToFront(): this
        // Brings the layer group to the top of all other layers
        bringToFront: function() {
            return this.invoke('bringToFront');
        },
        // @method bringToBack(): this
        // Brings the layer group to the back of all other layers
        bringToBack: function() {
            return this.invoke('bringToBack');
        },
        // @method getBounds(): LatLngBounds
        // Returns the LatLngBounds of the Feature Group (created from bounds and coordinates of its children).
        getBounds: function() {
            var bounds = new LatLngBounds();
            for(var id in this._layers){
                var layer = this._layers[id];
                bounds.extend(layer.getBounds ? layer.getBounds() : layer.getLatLng());
            }
            return bounds;
        }
    });
    // @factory L.featureGroup(layers?: Layer[], options?: Object)
    // Create a feature group, optionally given an initial set of layers and an `options` object.
    var featureGroup = function(layers, options) {
        return new FeatureGroup(layers, options);
    };
    /*
   * @class Icon
   * @aka L.Icon
   *
   * Represents an icon to provide when creating a marker.
   *
   * @example
   *
   * ```js
   * var myIcon = L.icon({
   *     iconUrl: 'my-icon.png',
   *     iconRetinaUrl: 'my-icon@2x.png',
   *     iconSize: [38, 95],
   *     iconAnchor: [22, 94],
   *     popupAnchor: [-3, -76],
   *     shadowUrl: 'my-icon-shadow.png',
   *     shadowRetinaUrl: 'my-icon-shadow@2x.png',
   *     shadowSize: [68, 95],
   *     shadowAnchor: [22, 94]
   * });
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * `L.Icon.Default` extends `L.Icon` and is the blue icon Leaflet uses for markers by default.
   *
   */ var Icon = Class.extend({
        /* @section
  	 * @aka Icon options
  	 *
  	 * @option iconUrl: String = null
  	 * **(required)** The URL to the icon image (absolute or relative to your script path).
  	 *
  	 * @option iconRetinaUrl: String = null
  	 * The URL to a retina sized version of the icon image (absolute or relative to your
  	 * script path). Used for Retina screen devices.
  	 *
  	 * @option iconSize: Point = null
  	 * Size of the icon image in pixels.
  	 *
  	 * @option iconAnchor: Point = null
  	 * The coordinates of the "tip" of the icon (relative to its top left corner). The icon
  	 * will be aligned so that this point is at the marker's geographical location. Centered
  	 * by default if size is specified, also can be set in CSS with negative margins.
  	 *
  	 * @option popupAnchor: Point = [0, 0]
  	 * The coordinates of the point from which popups will "open", relative to the icon anchor.
  	 *
  	 * @option tooltipAnchor: Point = [0, 0]
  	 * The coordinates of the point from which tooltips will "open", relative to the icon anchor.
  	 *
  	 * @option shadowUrl: String = null
  	 * The URL to the icon shadow image. If not specified, no shadow image will be created.
  	 *
  	 * @option shadowRetinaUrl: String = null
  	 *
  	 * @option shadowSize: Point = null
  	 * Size of the shadow image in pixels.
  	 *
  	 * @option shadowAnchor: Point = null
  	 * The coordinates of the "tip" of the shadow (relative to its top left corner) (the same
  	 * as iconAnchor if not specified).
  	 *
  	 * @option className: String = ''
  	 * A custom class name to assign to both icon and shadow images. Empty by default.
  	 */ options: {
            popupAnchor: [
                0,
                0
            ],
            tooltipAnchor: [
                0,
                0
            ],
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        // @method createIcon(oldIcon?: HTMLElement): HTMLElement
        // Called internally when the icon has to be shown, returns a `<img>` HTML element
        // styled according to the options.
        createIcon: function(oldIcon) {
            return this._createIcon('icon', oldIcon);
        },
        // @method createShadow(oldIcon?: HTMLElement): HTMLElement
        // As `createIcon`, but for the shadow beneath it.
        createShadow: function(oldIcon) {
            return this._createIcon('shadow', oldIcon);
        },
        _createIcon: function(name, oldIcon) {
            var src = this._getIconUrl(name);
            if (!src) {
                if (name === 'icon') throw new Error('iconUrl not set in Icon options (see the docs).');
                return null;
            }
            var img = this._createImg(src, oldIcon && oldIcon.tagName === 'IMG' ? oldIcon : null);
            this._setIconStyles(img, name);
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            return img;
        },
        _setIconStyles: function(img, name) {
            var options = this.options;
            var sizeOption = options[name + 'Size'];
            if (typeof sizeOption === 'number') sizeOption = [
                sizeOption,
                sizeOption
            ];
            var size = toPoint(sizeOption), anchor = toPoint(name === 'shadow' && options.shadowAnchor || options.iconAnchor || size && size.divideBy(2, true));
            img.className = 'leaflet-marker-' + name + ' ' + (options.className || '');
            if (anchor) {
                img.style.marginLeft = -anchor.x + 'px';
                img.style.marginTop = -anchor.y + 'px';
            }
            if (size) {
                img.style.width = size.x + 'px';
                img.style.height = size.y + 'px';
            }
        },
        _createImg: function(src, el) {
            el = el || document.createElement('img');
            el.src = src;
            return el;
        },
        _getIconUrl: function(name) {
            return Browser.retina && this.options[name + 'RetinaUrl'] || this.options[name + 'Url'];
        }
    });
    // @factory L.icon(options: Icon options)
    // Creates an icon instance with the given options.
    function icon(options) {
        return new Icon(options);
    }
    /*
   * @miniclass Icon.Default (Icon)
   * @aka L.Icon.Default
   * @section
   *
   * A trivial subclass of `Icon`, represents the icon to use in `Marker`s when
   * no icon is specified. Points to the blue marker image distributed with Leaflet
   * releases.
   *
   * In order to customize the default icon, just change the properties of `L.Icon.Default.prototype.options`
   * (which is a set of `Icon options`).
   *
   * If you want to _completely_ replace the default icon, override the
   * `L.Marker.prototype.options.icon` with your own icon instead.
   */ var IconDefault = Icon.extend({
        options: {
            iconUrl: 'marker-icon.png',
            iconRetinaUrl: 'marker-icon-2x.png',
            shadowUrl: 'marker-shadow.png',
            iconSize: [
                25,
                41
            ],
            iconAnchor: [
                12,
                41
            ],
            popupAnchor: [
                1,
                -34
            ],
            tooltipAnchor: [
                16,
                -28
            ],
            shadowSize: [
                41,
                41
            ]
        },
        _getIconUrl: function(name) {
            if (typeof IconDefault.imagePath !== 'string') IconDefault.imagePath = this._detectIconPath();
            // @option imagePath: String
            // `Icon.Default` will try to auto-detect the location of the
            // blue icon images. If you are placing these images in a non-standard
            // way, set this option to point to the right path.
            return (this.options.imagePath || IconDefault.imagePath) + Icon.prototype._getIconUrl.call(this, name);
        },
        _stripUrl: function(path) {
            var strip = function(str, re, idx) {
                var match = re.exec(str);
                return match && match[idx];
            };
            path = strip(path, /^url\((['"])?(.+)\1\)$/, 2);
            return path && strip(path, /^(.*)marker-icon\.png$/, 1);
        },
        _detectIconPath: function() {
            var el = create$1('div', 'leaflet-default-icon-path', document.body);
            var path = getStyle(el, 'background-image') || getStyle(el, 'backgroundImage'); // IE8
            document.body.removeChild(el);
            path = this._stripUrl(path);
            if (path) return path;
            var link = document.querySelector('link[href$="leaflet.css"]');
            if (!link) return '';
            return link.href.substring(0, link.href.length - 11 - 1);
        }
    });
    /*
   * L.Handler.MarkerDrag is used internally by L.Marker to make the markers draggable.
   */ /* @namespace Marker
   * @section Interaction handlers
   *
   * Interaction handlers are properties of a marker instance that allow you to control interaction behavior in runtime, enabling or disabling certain features such as dragging (see `Handler` methods). Example:
   *
   * ```js
   * marker.dragging.disable();
   * ```
   *
   * @property dragging: Handler
   * Marker dragging handler (by both mouse and touch). Only valid when the marker is on the map (Otherwise set [`marker.options.draggable`](#marker-draggable)).
   */ var MarkerDrag = Handler.extend({
        initialize: function(marker) {
            this._marker = marker;
        },
        addHooks: function() {
            var icon = this._marker._icon;
            if (!this._draggable) this._draggable = new Draggable(icon, icon, true);
            this._draggable.on({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).enable();
            addClass(icon, 'leaflet-marker-draggable');
        },
        removeHooks: function() {
            this._draggable.off({
                dragstart: this._onDragStart,
                predrag: this._onPreDrag,
                drag: this._onDrag,
                dragend: this._onDragEnd
            }, this).disable();
            if (this._marker._icon) removeClass(this._marker._icon, 'leaflet-marker-draggable');
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        _adjustPan: function(e) {
            var marker = this._marker, map = marker._map, speed = this._marker.options.autoPanSpeed, padding = this._marker.options.autoPanPadding, iconPos = getPosition(marker._icon), bounds = map.getPixelBounds(), origin = map.getPixelOrigin();
            var panBounds = toBounds(bounds.min._subtract(origin).add(padding), bounds.max._subtract(origin).subtract(padding));
            if (!panBounds.contains(iconPos)) {
                // Compute incremental movement
                var movement = toPoint((Math.max(panBounds.max.x, iconPos.x) - panBounds.max.x) / (bounds.max.x - panBounds.max.x) - (Math.min(panBounds.min.x, iconPos.x) - panBounds.min.x) / (bounds.min.x - panBounds.min.x), (Math.max(panBounds.max.y, iconPos.y) - panBounds.max.y) / (bounds.max.y - panBounds.max.y) - (Math.min(panBounds.min.y, iconPos.y) - panBounds.min.y) / (bounds.min.y - panBounds.min.y)).multiplyBy(speed);
                map.panBy(movement, {
                    animate: false
                });
                this._draggable._newPos._add(movement);
                this._draggable._startPos._add(movement);
                setPosition(marker._icon, this._draggable._newPos);
                this._onDrag(e);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDragStart: function() {
            // @section Dragging events
            // @event dragstart: Event
            // Fired when the user starts dragging the marker.
            // @event movestart: Event
            // Fired when the marker starts moving (because of dragging).
            this._oldLatLng = this._marker.getLatLng();
            // When using ES6 imports it could not be set when `Popup` was not imported as well
            this._marker.closePopup && this._marker.closePopup();
            this._marker.fire('movestart').fire('dragstart');
        },
        _onPreDrag: function(e) {
            if (this._marker.options.autoPan) {
                cancelAnimFrame(this._panRequest);
                this._panRequest = requestAnimFrame(this._adjustPan.bind(this, e));
            }
        },
        _onDrag: function(e) {
            var marker = this._marker, shadow = marker._shadow, iconPos = getPosition(marker._icon), latlng = marker._map.layerPointToLatLng(iconPos);
            // update shadow position
            if (shadow) setPosition(shadow, iconPos);
            marker._latlng = latlng;
            e.latlng = latlng;
            e.oldLatLng = this._oldLatLng;
            // @event drag: Event
            // Fired repeatedly while the user drags the marker.
            marker.fire('move', e).fire('drag', e);
        },
        _onDragEnd: function(e) {
            // @event dragend: DragEndEvent
            // Fired when the user stops dragging the marker.
            cancelAnimFrame(this._panRequest);
            // @event moveend: Event
            // Fired when the marker stops moving (because of dragging).
            delete this._oldLatLng;
            this._marker.fire('moveend').fire('dragend', e);
        }
    });
    /*
   * @class Marker
   * @inherits Interactive layer
   * @aka L.Marker
   * L.Marker is used to display clickable/draggable icons on the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * L.marker([50.5, 30.5]).addTo(map);
   * ```
   */ var Marker = Layer.extend({
        // @section
        // @aka Marker options
        options: {
            // @option icon: Icon = *
            // Icon instance to use for rendering the marker.
            // See [Icon documentation](#L.Icon) for details on how to customize the marker icon.
            // If not specified, a common instance of `L.Icon.Default` is used.
            icon: new IconDefault(),
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option keyboard: Boolean = true
            // Whether the marker can be tabbed to with a keyboard and clicked by pressing enter.
            keyboard: true,
            // @option title: String = ''
            // Text for the browser tooltip that appear on marker hover (no tooltip by default).
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            title: '',
            // @option alt: String = 'Marker'
            // Text for the `alt` attribute of the icon image.
            // [Useful for accessibility](https://leafletjs.com/examples/accessibility/#markers-must-be-labelled).
            alt: 'Marker',
            // @option zIndexOffset: Number = 0
            // By default, marker images zIndex is set automatically based on its latitude. Use this option if you want to put the marker on top of all others (or below), specifying a high value like `1000` (or high negative value, respectively).
            zIndexOffset: 0,
            // @option opacity: Number = 1.0
            // The opacity of the marker.
            opacity: 1,
            // @option riseOnHover: Boolean = false
            // If `true`, the marker will get on top of others when you hover the mouse over it.
            riseOnHover: false,
            // @option riseOffset: Number = 250
            // The z-index offset used for the `riseOnHover` feature.
            riseOffset: 250,
            // @option pane: String = 'markerPane'
            // `Map pane` where the markers icon will be added.
            pane: 'markerPane',
            // @option shadowPane: String = 'shadowPane'
            // `Map pane` where the markers shadow will be added.
            shadowPane: 'shadowPane',
            // @option bubblingMouseEvents: Boolean = false
            // When `true`, a mouse event on this marker will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: false,
            // @option autoPanOnFocus: Boolean = true
            // When `true`, the map will pan whenever the marker is focused (via
            // e.g. pressing `tab` on the keyboard) to ensure the marker is
            // visible within the map's bounds
            autoPanOnFocus: true,
            // @section Draggable marker options
            // @option draggable: Boolean = false
            // Whether the marker is draggable with mouse/touch or not.
            draggable: false,
            // @option autoPan: Boolean = false
            // Whether to pan the map when dragging this marker near its edge or not.
            autoPan: false,
            // @option autoPanPadding: Point = Point(50, 50)
            // Distance (in pixels to the left/right and to the top/bottom) of the
            // map edge to start panning the map.
            autoPanPadding: [
                50,
                50
            ],
            // @option autoPanSpeed: Number = 10
            // Number of pixels the map should pan by.
            autoPanSpeed: 10
        },
        /* @section
  	 *
  	 * In addition to [shared layer methods](#Layer) like `addTo()` and `remove()` and [popup methods](#Popup) like bindPopup() you can also use the following methods:
  	 */ initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
        },
        onAdd: function(map) {
            this._zoomAnimated = this._zoomAnimated && map.options.markerZoomAnimation;
            if (this._zoomAnimated) map.on('zoomanim', this._animateZoom, this);
            this._initIcon();
            this.update();
        },
        onRemove: function(map) {
            if (this.dragging && this.dragging.enabled()) {
                this.options.draggable = true;
                this.dragging.removeHooks();
            }
            delete this.dragging;
            if (this._zoomAnimated) map.off('zoomanim', this._animateZoom, this);
            this._removeIcon();
            this._removeShadow();
        },
        getEvents: function() {
            return {
                zoom: this.update,
                viewreset: this.update
            };
        },
        // @method getLatLng: LatLng
        // Returns the current geographical position of the marker.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Changes the marker position to the given point.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.update();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#marker-setlatlng) or by [dragging](#marker-dragging). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method setZIndexOffset(offset: Number): this
        // Changes the [zIndex offset](#marker-zindexoffset) of the marker.
        setZIndexOffset: function(offset) {
            this.options.zIndexOffset = offset;
            return this.update();
        },
        // @method getIcon: Icon
        // Returns the current icon used by the marker
        getIcon: function() {
            return this.options.icon;
        },
        // @method setIcon(icon: Icon): this
        // Changes the marker icon.
        setIcon: function(icon) {
            this.options.icon = icon;
            if (this._map) {
                this._initIcon();
                this.update();
            }
            if (this._popup) this.bindPopup(this._popup, this._popup.options);
            return this;
        },
        getElement: function() {
            return this._icon;
        },
        update: function() {
            if (this._icon && this._map) {
                var pos = this._map.latLngToLayerPoint(this._latlng).round();
                this._setPos(pos);
            }
            return this;
        },
        _initIcon: function() {
            var options = this.options, classToAdd = 'leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            var icon = options.icon.createIcon(this._icon), addIcon = false;
            // if we're not reusing the icon, remove the old one and init new one
            if (icon !== this._icon) {
                if (this._icon) this._removeIcon();
                addIcon = true;
                if (options.title) icon.title = options.title;
                if (icon.tagName === 'IMG') icon.alt = options.alt || '';
            }
            addClass(icon, classToAdd);
            if (options.keyboard) {
                icon.tabIndex = '0';
                icon.setAttribute('role', 'button');
            }
            this._icon = icon;
            if (options.riseOnHover) this.on({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) on(icon, 'focus', this._panOnFocus, this);
            var newShadow = options.icon.createShadow(this._shadow), addShadow = false;
            if (newShadow !== this._shadow) {
                this._removeShadow();
                addShadow = true;
            }
            if (newShadow) {
                addClass(newShadow, classToAdd);
                newShadow.alt = '';
            }
            this._shadow = newShadow;
            if (options.opacity < 1) this._updateOpacity();
            if (addIcon) this.getPane().appendChild(this._icon);
            this._initInteraction();
            if (newShadow && addShadow) this.getPane(options.shadowPane).appendChild(this._shadow);
        },
        _removeIcon: function() {
            if (this.options.riseOnHover) this.off({
                mouseover: this._bringToFront,
                mouseout: this._resetZIndex
            });
            if (this.options.autoPanOnFocus) off(this._icon, 'focus', this._panOnFocus, this);
            remove(this._icon);
            this.removeInteractiveTarget(this._icon);
            this._icon = null;
        },
        _removeShadow: function() {
            if (this._shadow) remove(this._shadow);
            this._shadow = null;
        },
        _setPos: function(pos) {
            if (this._icon) setPosition(this._icon, pos);
            if (this._shadow) setPosition(this._shadow, pos);
            this._zIndex = pos.y + this.options.zIndexOffset;
            this._resetZIndex();
        },
        _updateZIndex: function(offset) {
            if (this._icon) this._icon.style.zIndex = this._zIndex + offset;
        },
        _animateZoom: function(opt) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, opt.zoom, opt.center).round();
            this._setPos(pos);
        },
        _initInteraction: function() {
            if (!this.options.interactive) return;
            addClass(this._icon, 'leaflet-interactive');
            this.addInteractiveTarget(this._icon);
            if (MarkerDrag) {
                var draggable = this.options.draggable;
                if (this.dragging) {
                    draggable = this.dragging.enabled();
                    this.dragging.disable();
                }
                this.dragging = new MarkerDrag(this);
                if (draggable) this.dragging.enable();
            }
        },
        // @method setOpacity(opacity: Number): this
        // Changes the opacity of the marker.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._map) this._updateOpacity();
            return this;
        },
        _updateOpacity: function() {
            var opacity = this.options.opacity;
            if (this._icon) setOpacity(this._icon, opacity);
            if (this._shadow) setOpacity(this._shadow, opacity);
        },
        _bringToFront: function() {
            this._updateZIndex(this.options.riseOffset);
        },
        _resetZIndex: function() {
            this._updateZIndex(0);
        },
        _panOnFocus: function() {
            var map = this._map;
            if (!map) return;
            var iconOpts = this.options.icon.options;
            var size = iconOpts.iconSize ? toPoint(iconOpts.iconSize) : toPoint(0, 0);
            var anchor = iconOpts.iconAnchor ? toPoint(iconOpts.iconAnchor) : toPoint(0, 0);
            map.panInside(this._latlng, {
                paddingTopLeft: anchor,
                paddingBottomRight: size.subtract(anchor)
            });
        },
        _getPopupAnchor: function() {
            return this.options.icon.options.popupAnchor;
        },
        _getTooltipAnchor: function() {
            return this.options.icon.options.tooltipAnchor;
        }
    });
    // factory L.marker(latlng: LatLng, options? : Marker options)
    // @factory L.marker(latlng: LatLng, options? : Marker options)
    // Instantiates a Marker object given a geographical point and optionally an options object.
    function marker(latlng, options) {
        return new Marker(latlng, options);
    }
    /*
   * @class Path
   * @aka L.Path
   * @inherits Interactive layer
   *
   * An abstract class that contains options and constants shared between vector
   * overlays (Polygon, Polyline, Circle). Do not use it directly. Extends `Layer`.
   */ var Path = Layer.extend({
        // @section
        // @aka Path options
        options: {
            // @option stroke: Boolean = true
            // Whether to draw stroke along the path. Set it to `false` to disable borders on polygons or circles.
            stroke: true,
            // @option color: String = '#3388ff'
            // Stroke color
            color: '#3388ff',
            // @option weight: Number = 3
            // Stroke width in pixels
            weight: 3,
            // @option opacity: Number = 1.0
            // Stroke opacity
            opacity: 1,
            // @option lineCap: String= 'round'
            // A string that defines [shape to be used at the end](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linecap) of the stroke.
            lineCap: 'round',
            // @option lineJoin: String = 'round'
            // A string that defines [shape to be used at the corners](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-linejoin) of the stroke.
            lineJoin: 'round',
            // @option dashArray: String = null
            // A string that defines the stroke [dash pattern](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dasharray). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashArray: null,
            // @option dashOffset: String = null
            // A string that defines the [distance into the dash pattern to start the dash](https://developer.mozilla.org/docs/Web/SVG/Attribute/stroke-dashoffset). Doesn't work on `Canvas`-powered layers in [some old browsers](https://developer.mozilla.org/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility).
            dashOffset: null,
            // @option fill: Boolean = depends
            // Whether to fill the path with color. Set it to `false` to disable filling on polygons or circles.
            fill: false,
            // @option fillColor: String = *
            // Fill color. Defaults to the value of the [`color`](#path-color) option
            fillColor: null,
            // @option fillOpacity: Number = 0.2
            // Fill opacity.
            fillOpacity: 0.2,
            // @option fillRule: String = 'evenodd'
            // A string that defines [how the inside of a shape](https://developer.mozilla.org/docs/Web/SVG/Attribute/fill-rule) is determined.
            fillRule: 'evenodd',
            // className: '',
            // Option inherited from "Interactive layer" abstract class
            interactive: true,
            // @option bubblingMouseEvents: Boolean = true
            // When `true`, a mouse event on this path will trigger the same event on the map
            // (unless [`L.DomEvent.stopPropagation`](#domevent-stoppropagation) is used).
            bubblingMouseEvents: true
        },
        beforeAdd: function(map) {
            // Renderer is set here because we need to call renderer.getEvents
            // before this.getEvents.
            this._renderer = map.getRenderer(this);
        },
        onAdd: function() {
            this._renderer._initPath(this);
            this._reset();
            this._renderer._addPath(this);
        },
        onRemove: function() {
            this._renderer._removePath(this);
        },
        // @method redraw(): this
        // Redraws the layer. Sometimes useful after you changed the coordinates that the path uses.
        redraw: function() {
            if (this._map) this._renderer._updatePath(this);
            return this;
        },
        // @method setStyle(style: Path options): this
        // Changes the appearance of a Path based on the options in the `Path options` object.
        setStyle: function(style) {
            setOptions(this, style);
            if (this._renderer) {
                this._renderer._updateStyle(this);
                if (this.options.stroke && style && Object.prototype.hasOwnProperty.call(style, 'weight')) this._updateBounds();
            }
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all path layers.
        bringToFront: function() {
            if (this._renderer) this._renderer._bringToFront(this);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all path layers.
        bringToBack: function() {
            if (this._renderer) this._renderer._bringToBack(this);
            return this;
        },
        getElement: function() {
            return this._path;
        },
        _reset: function() {
            // defined in child classes
            this._project();
            this._update();
        },
        _clickTolerance: function() {
            // used when doing hit detection for Canvas layers
            return (this.options.stroke ? this.options.weight / 2 : 0) + (this._renderer.options.tolerance || 0);
        }
    });
    /*
   * @class CircleMarker
   * @aka L.CircleMarker
   * @inherits Path
   *
   * A circle of a fixed size with radius specified in pixels. Extends `Path`.
   */ var CircleMarker = Path.extend({
        // @section
        // @aka CircleMarker options
        options: {
            fill: true,
            // @option radius: Number = 10
            // Radius of the circle marker, in pixels
            radius: 10
        },
        initialize: function(latlng, options) {
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            this._radius = this.options.radius;
        },
        // @method setLatLng(latLng: LatLng): this
        // Sets the position of a circle marker to a new location.
        setLatLng: function(latlng) {
            var oldLatLng = this._latlng;
            this._latlng = toLatLng(latlng);
            this.redraw();
            // @event move: Event
            // Fired when the marker is moved via [`setLatLng`](#circlemarker-setlatlng). Old and new coordinates are included in event arguments as `oldLatLng`, `latlng`.
            return this.fire('move', {
                oldLatLng: oldLatLng,
                latlng: this._latlng
            });
        },
        // @method getLatLng(): LatLng
        // Returns the current geographical position of the circle marker
        getLatLng: function() {
            return this._latlng;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle marker. Units are in pixels.
        setRadius: function(radius) {
            this.options.radius = this._radius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of the circle
        getRadius: function() {
            return this._radius;
        },
        setStyle: function(options) {
            var radius = options && options.radius || this._radius;
            Path.prototype.setStyle.call(this, options);
            this.setRadius(radius);
            return this;
        },
        _project: function() {
            this._point = this._map.latLngToLayerPoint(this._latlng);
            this._updateBounds();
        },
        _updateBounds: function() {
            var r = this._radius, r2 = this._radiusY || r, w = this._clickTolerance(), p = [
                r + w,
                r2 + w
            ];
            this._pxBounds = new Bounds(this._point.subtract(p), this._point.add(p));
        },
        _update: function() {
            if (this._map) this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updateCircle(this);
        },
        _empty: function() {
            return this._radius && !this._renderer._bounds.intersects(this._pxBounds);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            return p.distanceTo(this._point) <= this._radius + this._clickTolerance();
        }
    });
    // @factory L.circleMarker(latlng: LatLng, options?: CircleMarker options)
    // Instantiates a circle marker object given a geographical point, and an optional options object.
    function circleMarker(latlng, options) {
        return new CircleMarker(latlng, options);
    }
    /*
   * @class Circle
   * @aka L.Circle
   * @inherits CircleMarker
   *
   * A class for drawing circle overlays on a map. Extends `CircleMarker`.
   *
   * It's an approximation and starts to diverge from a real circle closer to poles (due to projection distortion).
   *
   * @example
   *
   * ```js
   * L.circle([50.5, 30.5], {radius: 200}).addTo(map);
   * ```
   */ var Circle = CircleMarker.extend({
        initialize: function(latlng, options, legacyOptions) {
            if (typeof options === 'number') // Backwards compatibility with 0.7.x factory (latlng, radius, options?)
            options = extend({}, legacyOptions, {
                radius: options
            });
            setOptions(this, options);
            this._latlng = toLatLng(latlng);
            if (isNaN(this.options.radius)) throw new Error('Circle radius cannot be NaN');
            // @section
            // @aka Circle options
            // @option radius: Number; Radius of the circle, in meters.
            this._mRadius = this.options.radius;
        },
        // @method setRadius(radius: Number): this
        // Sets the radius of a circle. Units are in meters.
        setRadius: function(radius) {
            this._mRadius = radius;
            return this.redraw();
        },
        // @method getRadius(): Number
        // Returns the current radius of a circle. Units are in meters.
        getRadius: function() {
            return this._mRadius;
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            var half = [
                this._radius,
                this._radiusY || this._radius
            ];
            return new LatLngBounds(this._map.layerPointToLatLng(this._point.subtract(half)), this._map.layerPointToLatLng(this._point.add(half)));
        },
        setStyle: Path.prototype.setStyle,
        _project: function() {
            var lng = this._latlng.lng, lat = this._latlng.lat, map = this._map, crs = map.options.crs;
            if (crs.distance === Earth.distance) {
                var d = Math.PI / 180, latR = this._mRadius / Earth.R / d, top = map.project([
                    lat + latR,
                    lng
                ]), bottom = map.project([
                    lat - latR,
                    lng
                ]), p = top.add(bottom).divideBy(2), lat2 = map.unproject(p).lat, lngR = Math.acos((Math.cos(latR * d) - Math.sin(lat * d) * Math.sin(lat2 * d)) / (Math.cos(lat * d) * Math.cos(lat2 * d))) / d;
                if (isNaN(lngR) || lngR === 0) lngR = latR / Math.cos(Math.PI / 180 * lat); // Fallback for edge case, #2425
                this._point = p.subtract(map.getPixelOrigin());
                this._radius = isNaN(lngR) ? 0 : p.x - map.project([
                    lat2,
                    lng - lngR
                ]).x;
                this._radiusY = p.y - top.y;
            } else {
                var latlng2 = crs.unproject(crs.project(this._latlng).subtract([
                    this._mRadius,
                    0
                ]));
                this._point = map.latLngToLayerPoint(this._latlng);
                this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;
            }
            this._updateBounds();
        }
    });
    // @factory L.circle(latlng: LatLng, options?: Circle options)
    // Instantiates a circle object given a geographical point, and an options object
    // which contains the circle radius.
    // @alternative
    // @factory L.circle(latlng: LatLng, radius: Number, options?: Circle options)
    // Obsolete way of instantiating a circle, for compatibility with 0.7.x code.
    // Do not use in new applications or plugins.
    function circle(latlng, options, legacyOptions) {
        return new Circle(latlng, options, legacyOptions);
    }
    /*
   * @class Polyline
   * @aka L.Polyline
   * @inherits Path
   *
   * A class for drawing polyline overlays on a map. Extends `Path`.
   *
   * @example
   *
   * ```js
   * // create a red polyline from an array of LatLng points
   * var latlngs = [
   * 	[45.51, -122.68],
   * 	[37.77, -122.43],
   * 	[34.04, -118.2]
   * ];
   *
   * var polyline = L.polyline(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polyline
   * map.fitBounds(polyline.getBounds());
   * ```
   *
   * You can also pass a multi-dimensional array to represent a `MultiPolyline` shape:
   *
   * ```js
   * // create a red polyline from an array of arrays of LatLng points
   * var latlngs = [
   * 	[[45.51, -122.68],
   * 	 [37.77, -122.43],
   * 	 [34.04, -118.2]],
   * 	[[40.78, -73.91],
   * 	 [41.83, -87.62],
   * 	 [32.76, -96.72]]
   * ];
   * ```
   */ var Polyline = Path.extend({
        // @section
        // @aka Polyline options
        options: {
            // @option smoothFactor: Number = 1.0
            // How much to simplify the polyline on each zoom level. More means
            // better performance and smoother look, and less means more accurate representation.
            smoothFactor: 1.0,
            // @option noClip: Boolean = false
            // Disable polyline clipping.
            noClip: false
        },
        initialize: function(latlngs, options) {
            setOptions(this, options);
            this._setLatLngs(latlngs);
        },
        // @method getLatLngs(): LatLng[]
        // Returns an array of the points in the path, or nested arrays of points in case of multi-polyline.
        getLatLngs: function() {
            return this._latlngs;
        },
        // @method setLatLngs(latlngs: LatLng[]): this
        // Replaces all the points in the polyline with the given array of geographical points.
        setLatLngs: function(latlngs) {
            this._setLatLngs(latlngs);
            return this.redraw();
        },
        // @method isEmpty(): Boolean
        // Returns `true` if the Polyline has no LatLngs.
        isEmpty: function() {
            return !this._latlngs.length;
        },
        // @method closestLayerPoint(p: Point): Point
        // Returns the point closest to `p` on the Polyline.
        closestLayerPoint: function(p) {
            var minDistance = Infinity, minPoint = null, closest = _sqClosestPointOnSegment, p1, p2;
            for(var j = 0, jLen = this._parts.length; j < jLen; j++){
                var points = this._parts[j];
                for(var i = 1, len = points.length; i < len; i++){
                    p1 = points[i - 1];
                    p2 = points[i];
                    var sqDist = closest(p, p1, p2, true);
                    if (sqDist < minDistance) {
                        minDistance = sqDist;
                        minPoint = closest(p, p1, p2);
                    }
                }
            }
            if (minPoint) minPoint.distance = Math.sqrt(minDistance);
            return minPoint;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](https://en.wikipedia.org/wiki/Centroid)) of the polyline.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polylineCenter(this._defaultShape(), this._map.options.crs);
        },
        // @method getBounds(): LatLngBounds
        // Returns the `LatLngBounds` of the path.
        getBounds: function() {
            return this._bounds;
        },
        // @method addLatLng(latlng: LatLng, latlngs?: LatLng[]): this
        // Adds a given point to the polyline. By default, adds to the first ring of
        // the polyline in case of a multi-polyline, but can be overridden by passing
        // a specific ring as a LatLng array (that you can earlier access with [`getLatLngs`](#polyline-getlatlngs)).
        addLatLng: function(latlng, latlngs) {
            latlngs = latlngs || this._defaultShape();
            latlng = toLatLng(latlng);
            latlngs.push(latlng);
            this._bounds.extend(latlng);
            return this.redraw();
        },
        _setLatLngs: function(latlngs) {
            this._bounds = new LatLngBounds();
            this._latlngs = this._convertLatLngs(latlngs);
        },
        _defaultShape: function() {
            return isFlat(this._latlngs) ? this._latlngs : this._latlngs[0];
        },
        // recursively convert latlngs input into actual LatLng instances; calculate bounds along the way
        _convertLatLngs: function(latlngs) {
            var result = [], flat = isFlat(latlngs);
            for(var i = 0, len = latlngs.length; i < len; i++)if (flat) {
                result[i] = toLatLng(latlngs[i]);
                this._bounds.extend(result[i]);
            } else result[i] = this._convertLatLngs(latlngs[i]);
            return result;
        },
        _project: function() {
            var pxBounds = new Bounds();
            this._rings = [];
            this._projectLatlngs(this._latlngs, this._rings, pxBounds);
            if (this._bounds.isValid() && pxBounds.isValid()) {
                this._rawPxBounds = pxBounds;
                this._updateBounds();
            }
        },
        _updateBounds: function() {
            var w = this._clickTolerance(), p = new Point(w, w);
            if (!this._rawPxBounds) return;
            this._pxBounds = new Bounds([
                this._rawPxBounds.min.subtract(p),
                this._rawPxBounds.max.add(p)
            ]);
        },
        // recursively turns latlngs into a set of rings with projected coordinates
        _projectLatlngs: function(latlngs, result, projectedBounds) {
            var flat = latlngs[0] instanceof LatLng, len = latlngs.length, i, ring;
            if (flat) {
                ring = [];
                for(i = 0; i < len; i++){
                    ring[i] = this._map.latLngToLayerPoint(latlngs[i]);
                    projectedBounds.extend(ring[i]);
                }
                result.push(ring);
            } else for(i = 0; i < len; i++)this._projectLatlngs(latlngs[i], result, projectedBounds);
        },
        // clip polyline by renderer bounds so that we have less to render for performance
        _clipPoints: function() {
            var bounds = this._renderer._bounds;
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            var parts = this._parts, i, j, k, len, len2, segment, points;
            for(i = 0, k = 0, len = this._rings.length; i < len; i++){
                points = this._rings[i];
                for(j = 0, len2 = points.length; j < len2 - 1; j++){
                    segment = clipSegment(points[j], points[j + 1], bounds, j, true);
                    if (!segment) continue;
                    parts[k] = parts[k] || [];
                    parts[k].push(segment[0]);
                    // if segment goes out of screen, or it's the last one, it's the end of the line part
                    if (segment[1] !== points[j + 1] || j === len2 - 2) {
                        parts[k].push(segment[1]);
                        k++;
                    }
                }
            }
        },
        // simplify each clipped part of the polyline for performance
        _simplifyPoints: function() {
            var parts = this._parts, tolerance = this.options.smoothFactor;
            for(var i = 0, len = parts.length; i < len; i++)parts[i] = simplify(parts[i], tolerance);
        },
        _update: function() {
            if (!this._map) return;
            this._clipPoints();
            this._simplifyPoints();
            this._updatePath();
        },
        _updatePath: function() {
            this._renderer._updatePoly(this);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p, closed) {
            var i, j, k, len, len2, part, w = this._clickTolerance();
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // hit detection for polylines
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    if (!closed && j === 0) continue;
                    if (pointToSegmentDistance(p, part[k], part[j]) <= w) return true;
                }
            }
            return false;
        }
    });
    // @factory L.polyline(latlngs: LatLng[], options?: Polyline options)
    // Instantiates a polyline object given an array of geographical points and
    // optionally an options object. You can create a `Polyline` object with
    // multiple separate lines (`MultiPolyline`) by passing an array of arrays
    // of geographic points.
    function polyline(latlngs, options) {
        return new Polyline(latlngs, options);
    }
    // Retrocompat. Allow plugins to support Leaflet versions before and after 1.1.
    Polyline._flat = _flat;
    /*
   * @class Polygon
   * @aka L.Polygon
   * @inherits Polyline
   *
   * A class for drawing polygon overlays on a map. Extends `Polyline`.
   *
   * Note that points you pass when creating a polygon shouldn't have an additional last point equal to the first one — it's better to filter out such points.
   *
   *
   * @example
   *
   * ```js
   * // create a red polygon from an array of LatLng points
   * var latlngs = [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]];
   *
   * var polygon = L.polygon(latlngs, {color: 'red'}).addTo(map);
   *
   * // zoom the map to the polygon
   * map.fitBounds(polygon.getBounds());
   * ```
   *
   * You can also pass an array of arrays of latlngs, with the first array representing the outer shape and the other arrays representing holes in the outer shape:
   *
   * ```js
   * var latlngs = [
   *   [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *   [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   * ];
   * ```
   *
   * Additionally, you can pass a multi-dimensional array to represent a MultiPolygon shape.
   *
   * ```js
   * var latlngs = [
   *   [ // first polygon
   *     [[37, -109.05],[41, -109.03],[41, -102.05],[37, -102.04]], // outer ring
   *     [[37.29, -108.58],[40.71, -108.58],[40.71, -102.50],[37.29, -102.50]] // hole
   *   ],
   *   [ // second polygon
   *     [[41, -111.03],[45, -111.04],[45, -104.05],[41, -104.05]]
   *   ]
   * ];
   * ```
   */ var Polygon = Polyline.extend({
        options: {
            fill: true
        },
        isEmpty: function() {
            return !this._latlngs.length || !this._latlngs[0].length;
        },
        // @method getCenter(): LatLng
        // Returns the center ([centroid](http://en.wikipedia.org/wiki/Centroid)) of the Polygon.
        getCenter: function() {
            // throws error when not yet added to map as this center calculation requires projected coordinates
            if (!this._map) throw new Error('Must add layer to map before using getCenter()');
            return polygonCenter(this._defaultShape(), this._map.options.crs);
        },
        _convertLatLngs: function(latlngs) {
            var result = Polyline.prototype._convertLatLngs.call(this, latlngs), len = result.length;
            // remove last point if it equals first one
            if (len >= 2 && result[0] instanceof LatLng && result[0].equals(result[len - 1])) result.pop();
            return result;
        },
        _setLatLngs: function(latlngs) {
            Polyline.prototype._setLatLngs.call(this, latlngs);
            if (isFlat(this._latlngs)) this._latlngs = [
                this._latlngs
            ];
        },
        _defaultShape: function() {
            return isFlat(this._latlngs[0]) ? this._latlngs[0] : this._latlngs[0][0];
        },
        _clipPoints: function() {
            // polygons need a different clipping algorithm so we redefine that
            var bounds = this._renderer._bounds, w = this.options.weight, p = new Point(w, w);
            // increase clip padding by stroke width to avoid stroke on clip edges
            bounds = new Bounds(bounds.min.subtract(p), bounds.max.add(p));
            this._parts = [];
            if (!this._pxBounds || !this._pxBounds.intersects(bounds)) return;
            if (this.options.noClip) {
                this._parts = this._rings;
                return;
            }
            for(var i = 0, len = this._rings.length, clipped; i < len; i++){
                clipped = clipPolygon(this._rings[i], bounds, true);
                if (clipped.length) this._parts.push(clipped);
            }
        },
        _updatePath: function() {
            this._renderer._updatePoly(this, true);
        },
        // Needed by the `Canvas` renderer for interactivity
        _containsPoint: function(p) {
            var inside = false, part, p1, p2, i, j, k, len, len2;
            if (!this._pxBounds || !this._pxBounds.contains(p)) return false;
            // ray casting algorithm for detecting if point is in polygon
            for(i = 0, len = this._parts.length; i < len; i++){
                part = this._parts[i];
                for(j = 0, len2 = part.length, k = len2 - 1; j < len2; k = j++){
                    p1 = part[j];
                    p2 = part[k];
                    if (p1.y > p.y !== p2.y > p.y && p.x < (p2.x - p1.x) * (p.y - p1.y) / (p2.y - p1.y) + p1.x) inside = !inside;
                }
            }
            // also check if it's on polygon stroke
            return inside || Polyline.prototype._containsPoint.call(this, p, true);
        }
    });
    // @factory L.polygon(latlngs: LatLng[], options?: Polyline options)
    function polygon(latlngs, options) {
        return new Polygon(latlngs, options);
    }
    /*
   * @class GeoJSON
   * @aka L.GeoJSON
   * @inherits FeatureGroup
   *
   * Represents a GeoJSON object or an array of GeoJSON objects. Allows you to parse
   * GeoJSON data and display it on the map. Extends `FeatureGroup`.
   *
   * @example
   *
   * ```js
   * L.geoJSON(data, {
   * 	style: function (feature) {
   * 		return {color: feature.properties.color};
   * 	}
   * }).bindPopup(function (layer) {
   * 	return layer.feature.properties.description;
   * }).addTo(map);
   * ```
   */ var GeoJSON = FeatureGroup.extend({
        /* @section
  	 * @aka GeoJSON options
  	 *
  	 * @option pointToLayer: Function = *
  	 * A `Function` defining how GeoJSON points spawn Leaflet layers. It is internally
  	 * called when data is added, passing the GeoJSON point feature and its `LatLng`.
  	 * The default is to spawn a default `Marker`:
  	 * ```js
  	 * function(geoJsonPoint, latlng) {
  	 * 	return L.marker(latlng);
  	 * }
  	 * ```
  	 *
  	 * @option style: Function = *
  	 * A `Function` defining the `Path options` for styling GeoJSON lines and polygons,
  	 * called internally when data is added.
  	 * The default value is to not override any defaults:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return {}
  	 * }
  	 * ```
  	 *
  	 * @option onEachFeature: Function = *
  	 * A `Function` that will be called once for each created `Feature`, after it has
  	 * been created and styled. Useful for attaching events and popups to features.
  	 * The default is to do nothing with the newly created layers:
  	 * ```js
  	 * function (feature, layer) {}
  	 * ```
  	 *
  	 * @option filter: Function = *
  	 * A `Function` that will be used to decide whether to include a feature or not.
  	 * The default is to include all features:
  	 * ```js
  	 * function (geoJsonFeature) {
  	 * 	return true;
  	 * }
  	 * ```
  	 * Note: dynamically changing the `filter` option will have effect only on newly
  	 * added data. It will _not_ re-evaluate already included features.
  	 *
  	 * @option coordsToLatLng: Function = *
  	 * A `Function` that will be used for converting GeoJSON coordinates to `LatLng`s.
  	 * The default is the `coordsToLatLng` static method.
  	 *
  	 * @option markersInheritOptions: Boolean = false
  	 * Whether default Markers for "Point" type Features inherit from group options.
  	 */ initialize: function(geojson, options) {
            setOptions(this, options);
            this._layers = {};
            if (geojson) this.addData(geojson);
        },
        // @method addData( <GeoJSON> data ): this
        // Adds a GeoJSON object to the layer.
        addData: function(geojson) {
            var features = isArray(geojson) ? geojson : geojson.features, i, len, feature;
            if (features) {
                for(i = 0, len = features.length; i < len; i++){
                    // only add this if geometry or geometries are set and not null
                    feature = features[i];
                    if (feature.geometries || feature.geometry || feature.features || feature.coordinates) this.addData(feature);
                }
                return this;
            }
            var options = this.options;
            if (options.filter && !options.filter(geojson)) return this;
            var layer = geometryToLayer(geojson, options);
            if (!layer) return this;
            layer.feature = asFeature(geojson);
            layer.defaultOptions = layer.options;
            this.resetStyle(layer);
            if (options.onEachFeature) options.onEachFeature(geojson, layer);
            return this.addLayer(layer);
        },
        // @method resetStyle( <Path> layer? ): this
        // Resets the given vector layer's style to the original GeoJSON style, useful for resetting style after hover events.
        // If `layer` is omitted, the style of all features in the current layer is reset.
        resetStyle: function(layer) {
            if (layer === undefined) return this.eachLayer(this.resetStyle, this);
            // reset any custom styles
            layer.options = extend({}, layer.defaultOptions);
            this._setLayerStyle(layer, this.options.style);
            return this;
        },
        // @method setStyle( <Function> style ): this
        // Changes styles of GeoJSON vector layers with the given style function.
        setStyle: function(style) {
            return this.eachLayer(function(layer) {
                this._setLayerStyle(layer, style);
            }, this);
        },
        _setLayerStyle: function(layer, style) {
            if (layer.setStyle) {
                if (typeof style === 'function') style = style(layer.feature);
                layer.setStyle(style);
            }
        }
    });
    // @section
    // There are several static functions which can be called without instantiating L.GeoJSON:
    // @function geometryToLayer(featureData: Object, options?: GeoJSON options): Layer
    // Creates a `Layer` from a given GeoJSON feature. Can use a custom
    // [`pointToLayer`](#geojson-pointtolayer) and/or [`coordsToLatLng`](#geojson-coordstolatlng)
    // functions if provided as options.
    function geometryToLayer(geojson, options) {
        var geometry = geojson.type === 'Feature' ? geojson.geometry : geojson, coords = geometry ? geometry.coordinates : null, layers = [], pointToLayer = options && options.pointToLayer, _coordsToLatLng = options && options.coordsToLatLng || coordsToLatLng, latlng, latlngs, i, len;
        if (!coords && !geometry) return null;
        switch(geometry.type){
            case 'Point':
                latlng = _coordsToLatLng(coords);
                return _pointToLayer(pointToLayer, geojson, latlng, options);
            case 'MultiPoint':
                for(i = 0, len = coords.length; i < len; i++){
                    latlng = _coordsToLatLng(coords[i]);
                    layers.push(_pointToLayer(pointToLayer, geojson, latlng, options));
                }
                return new FeatureGroup(layers);
            case 'LineString':
            case 'MultiLineString':
                latlngs = coordsToLatLngs(coords, geometry.type === 'LineString' ? 0 : 1, _coordsToLatLng);
                return new Polyline(latlngs, options);
            case 'Polygon':
            case 'MultiPolygon':
                latlngs = coordsToLatLngs(coords, geometry.type === 'Polygon' ? 1 : 2, _coordsToLatLng);
                return new Polygon(latlngs, options);
            case 'GeometryCollection':
                for(i = 0, len = geometry.geometries.length; i < len; i++){
                    var geoLayer = geometryToLayer({
                        geometry: geometry.geometries[i],
                        type: 'Feature',
                        properties: geojson.properties
                    }, options);
                    if (geoLayer) layers.push(geoLayer);
                }
                return new FeatureGroup(layers);
            case 'FeatureCollection':
                for(i = 0, len = geometry.features.length; i < len; i++){
                    var featureLayer = geometryToLayer(geometry.features[i], options);
                    if (featureLayer) layers.push(featureLayer);
                }
                return new FeatureGroup(layers);
            default:
                throw new Error('Invalid GeoJSON object.');
        }
    }
    function _pointToLayer(pointToLayerFn, geojson, latlng, options) {
        return pointToLayerFn ? pointToLayerFn(geojson, latlng) : new Marker(latlng, options && options.markersInheritOptions && options);
    }
    // @function coordsToLatLng(coords: Array): LatLng
    // Creates a `LatLng` object from an array of 2 numbers (longitude, latitude)
    // or 3 numbers (longitude, latitude, altitude) used in GeoJSON for points.
    function coordsToLatLng(coords) {
        return new LatLng(coords[1], coords[0], coords[2]);
    }
    // @function coordsToLatLngs(coords: Array, levelsDeep?: Number, coordsToLatLng?: Function): Array
    // Creates a multidimensional array of `LatLng`s from a GeoJSON coordinates array.
    // `levelsDeep` specifies the nesting level (0 is for an array of points, 1 for an array of arrays of points, etc., 0 by default).
    // Can use a custom [`coordsToLatLng`](#geojson-coordstolatlng) function.
    function coordsToLatLngs(coords, levelsDeep, _coordsToLatLng) {
        var latlngs = [];
        for(var i = 0, len = coords.length, latlng; i < len; i++){
            latlng = levelsDeep ? coordsToLatLngs(coords[i], levelsDeep - 1, _coordsToLatLng) : (_coordsToLatLng || coordsToLatLng)(coords[i]);
            latlngs.push(latlng);
        }
        return latlngs;
    }
    // @function latLngToCoords(latlng: LatLng, precision?: Number|false): Array
    // Reverse of [`coordsToLatLng`](#geojson-coordstolatlng)
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngToCoords(latlng, precision) {
        latlng = toLatLng(latlng);
        return latlng.alt !== undefined ? [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision),
            formatNum(latlng.alt, precision)
        ] : [
            formatNum(latlng.lng, precision),
            formatNum(latlng.lat, precision)
        ];
    }
    // @function latLngsToCoords(latlngs: Array, levelsDeep?: Number, closed?: Boolean, precision?: Number|false): Array
    // Reverse of [`coordsToLatLngs`](#geojson-coordstolatlngs)
    // `closed` determines whether the first point should be appended to the end of the array to close the feature, only used when `levelsDeep` is 0. False by default.
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function.
    function latLngsToCoords(latlngs, levelsDeep, closed, precision) {
        var coords = [];
        for(var i = 0, len = latlngs.length; i < len; i++)// Check for flat arrays required to ensure unbalanced arrays are correctly converted in recursion
        coords.push(levelsDeep ? latLngsToCoords(latlngs[i], isFlat(latlngs[i]) ? 0 : levelsDeep - 1, closed, precision) : latLngToCoords(latlngs[i], precision));
        if (!levelsDeep && closed && coords.length > 0) coords.push(coords[0].slice());
        return coords;
    }
    function getFeature(layer, newGeometry) {
        return layer.feature ? extend({}, layer.feature, {
            geometry: newGeometry
        }) : asFeature(newGeometry);
    }
    // @function asFeature(geojson: Object): Object
    // Normalize GeoJSON geometries/features into GeoJSON features.
    function asFeature(geojson) {
        if (geojson.type === 'Feature' || geojson.type === 'FeatureCollection') return geojson;
        return {
            type: 'Feature',
            properties: {},
            geometry: geojson
        };
    }
    var PointToGeoJSON = {
        toGeoJSON: function(precision) {
            return getFeature(this, {
                type: 'Point',
                coordinates: latLngToCoords(this.getLatLng(), precision)
            });
        }
    };
    // @namespace Marker
    // @section Other methods
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the marker (as a GeoJSON `Point` Feature).
    Marker.include(PointToGeoJSON);
    // @namespace CircleMarker
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the circle marker (as a GeoJSON `Point` Feature).
    Circle.include(PointToGeoJSON);
    CircleMarker.include(PointToGeoJSON);
    // @namespace Polyline
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polyline (as a GeoJSON `LineString` or `MultiLineString` Feature).
    Polyline.include({
        toGeoJSON: function(precision) {
            var multi = !isFlat(this._latlngs);
            var coords = latLngsToCoords(this._latlngs, multi ? 1 : 0, false, precision);
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'LineString',
                coordinates: coords
            });
        }
    });
    // @namespace Polygon
    // @method toGeoJSON(precision?: Number|false): Object
    // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
    // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the polygon (as a GeoJSON `Polygon` or `MultiPolygon` Feature).
    Polygon.include({
        toGeoJSON: function(precision) {
            var holes = !isFlat(this._latlngs), multi = holes && !isFlat(this._latlngs[0]);
            var coords = latLngsToCoords(this._latlngs, multi ? 2 : holes ? 1 : 0, true, precision);
            if (!holes) coords = [
                coords
            ];
            return getFeature(this, {
                type: (multi ? 'Multi' : '') + 'Polygon',
                coordinates: coords
            });
        }
    });
    // @namespace LayerGroup
    LayerGroup.include({
        toMultiPoint: function(precision) {
            var coords = [];
            this.eachLayer(function(layer) {
                coords.push(layer.toGeoJSON(precision).geometry.coordinates);
            });
            return getFeature(this, {
                type: 'MultiPoint',
                coordinates: coords
            });
        },
        // @method toGeoJSON(precision?: Number|false): Object
        // Coordinates values are rounded with [`formatNum`](#util-formatnum) function with given `precision`.
        // Returns a [`GeoJSON`](https://en.wikipedia.org/wiki/GeoJSON) representation of the layer group (as a GeoJSON `FeatureCollection`, `GeometryCollection`, or `MultiPoint`).
        toGeoJSON: function(precision) {
            var type = this.feature && this.feature.geometry && this.feature.geometry.type;
            if (type === 'MultiPoint') return this.toMultiPoint(precision);
            var isGeometryCollection = type === 'GeometryCollection', jsons = [];
            this.eachLayer(function(layer) {
                if (layer.toGeoJSON) {
                    var json = layer.toGeoJSON(precision);
                    if (isGeometryCollection) jsons.push(json.geometry);
                    else {
                        var feature = asFeature(json);
                        // Squash nested feature collections
                        if (feature.type === 'FeatureCollection') jsons.push.apply(jsons, feature.features);
                        else jsons.push(feature);
                    }
                }
            });
            if (isGeometryCollection) return getFeature(this, {
                geometries: jsons,
                type: 'GeometryCollection'
            });
            return {
                type: 'FeatureCollection',
                features: jsons
            };
        }
    });
    // @namespace GeoJSON
    // @factory L.geoJSON(geojson?: Object, options?: GeoJSON options)
    // Creates a GeoJSON layer. Optionally accepts an object in
    // [GeoJSON format](https://tools.ietf.org/html/rfc7946) to display on the map
    // (you can alternatively add it later with `addData` method) and an `options` object.
    function geoJSON(geojson, options) {
        return new GeoJSON(geojson, options);
    }
    // Backward compatibility.
    var geoJson = geoJSON;
    /*
   * @class ImageOverlay
   * @aka L.ImageOverlay
   * @inherits Interactive layer
   *
   * Used to load and display a single image over specific bounds of the map. Extends `Layer`.
   *
   * @example
   *
   * ```js
   * var imageUrl = 'https://maps.lib.utexas.edu/maps/historical/newark_nj_1922.jpg',
   * 	imageBounds = [[40.712216, -74.22655], [40.773941, -74.12544]];
   * L.imageOverlay(imageUrl, imageBounds).addTo(map);
   * ```
   */ var ImageOverlay = Layer.extend({
        // @section
        // @aka ImageOverlay options
        options: {
            // @option opacity: Number = 1.0
            // The opacity of the image overlay.
            opacity: 1,
            // @option alt: String = ''
            // Text for the `alt` attribute of the image (useful for accessibility).
            alt: '',
            // @option interactive: Boolean = false
            // If `true`, the image overlay will emit [mouse events](#interactive-layer) when clicked or hovered.
            interactive: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the image.
            // If a String is provided, the image will have its crossOrigin attribute set to the String provided. This is needed if you want to access image pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option errorOverlayUrl: String = ''
            // URL to the overlay image to show in place of the overlay that failed to load.
            errorOverlayUrl: '',
            // @option zIndex: Number = 1
            // The explicit [zIndex](https://developer.mozilla.org/docs/Web/CSS/CSS_Positioning/Understanding_z_index) of the overlay layer.
            zIndex: 1,
            // @option className: String = ''
            // A custom class name to assign to the image. Empty by default.
            className: ''
        },
        initialize: function(url, bounds, options) {
            this._url = url;
            this._bounds = toLatLngBounds(bounds);
            setOptions(this, options);
        },
        onAdd: function() {
            if (!this._image) {
                this._initImage();
                if (this.options.opacity < 1) this._updateOpacity();
            }
            if (this.options.interactive) {
                addClass(this._image, 'leaflet-interactive');
                this.addInteractiveTarget(this._image);
            }
            this.getPane().appendChild(this._image);
            this._reset();
        },
        onRemove: function() {
            remove(this._image);
            if (this.options.interactive) this.removeInteractiveTarget(this._image);
        },
        // @method setOpacity(opacity: Number): this
        // Sets the opacity of the overlay.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._image) this._updateOpacity();
            return this;
        },
        setStyle: function(styleOpts) {
            if (styleOpts.opacity) this.setOpacity(styleOpts.opacity);
            return this;
        },
        // @method bringToFront(): this
        // Brings the layer to the top of all overlays.
        bringToFront: function() {
            if (this._map) toFront(this._image);
            return this;
        },
        // @method bringToBack(): this
        // Brings the layer to the bottom of all overlays.
        bringToBack: function() {
            if (this._map) toBack(this._image);
            return this;
        },
        // @method setUrl(url: String): this
        // Changes the URL of the image.
        setUrl: function(url) {
            this._url = url;
            if (this._image) this._image.src = url;
            return this;
        },
        // @method setBounds(bounds: LatLngBounds): this
        // Update the bounds that this ImageOverlay covers
        setBounds: function(bounds) {
            this._bounds = toLatLngBounds(bounds);
            if (this._map) this._reset();
            return this;
        },
        getEvents: function() {
            var events = {
                zoom: this._reset,
                viewreset: this._reset
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method setZIndex(value: Number): this
        // Changes the [zIndex](#imageoverlay-zindex) of the image overlay.
        setZIndex: function(value) {
            this.options.zIndex = value;
            this._updateZIndex();
            return this;
        },
        // @method getBounds(): LatLngBounds
        // Get the bounds that this ImageOverlay covers
        getBounds: function() {
            return this._bounds;
        },
        // @method getElement(): HTMLElement
        // Returns the instance of [`HTMLImageElement`](https://developer.mozilla.org/docs/Web/API/HTMLImageElement)
        // used by this overlay.
        getElement: function() {
            return this._image;
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'IMG';
            var img = this._image = wasElementSupplied ? this._url : create$1('img');
            addClass(img, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(img, 'leaflet-zoom-animated');
            if (this.options.className) addClass(img, this.options.className);
            img.onselectstart = falseFn;
            img.onmousemove = falseFn;
            // @event load: Event
            // Fired when the ImageOverlay layer has loaded its image
            img.onload = bind(this.fire, this, 'load');
            img.onerror = bind(this._overlayOnError, this, 'error');
            if (this.options.crossOrigin || this.options.crossOrigin === '') img.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            if (this.options.zIndex) this._updateZIndex();
            if (wasElementSupplied) {
                this._url = img.src;
                return;
            }
            img.src = this._url;
            img.alt = this.options.alt;
        },
        _animateZoom: function(e) {
            var scale = this._map.getZoomScale(e.zoom), offset = this._map._latLngBoundsToNewLayerBounds(this._bounds, e.zoom, e.center).min;
            setTransform(this._image, offset, scale);
        },
        _reset: function() {
            var image = this._image, bounds = new Bounds(this._map.latLngToLayerPoint(this._bounds.getNorthWest()), this._map.latLngToLayerPoint(this._bounds.getSouthEast())), size = bounds.getSize();
            setPosition(image, bounds.min);
            image.style.width = size.x + 'px';
            image.style.height = size.y + 'px';
        },
        _updateOpacity: function() {
            setOpacity(this._image, this.options.opacity);
        },
        _updateZIndex: function() {
            if (this._image && this.options.zIndex !== undefined && this.options.zIndex !== null) this._image.style.zIndex = this.options.zIndex;
        },
        _overlayOnError: function() {
            // @event error: Event
            // Fired when the ImageOverlay layer fails to load its image
            this.fire('error');
            var errorUrl = this.options.errorOverlayUrl;
            if (errorUrl && this._url !== errorUrl) {
                this._url = errorUrl;
                this._image.src = errorUrl;
            }
        },
        // @method getCenter(): LatLng
        // Returns the center of the ImageOverlay.
        getCenter: function() {
            return this._bounds.getCenter();
        }
    });
    // @factory L.imageOverlay(imageUrl: String, bounds: LatLngBounds, options?: ImageOverlay options)
    // Instantiates an image overlay object given the URL of the image and the
    // geographical bounds it is tied to.
    var imageOverlay = function(url, bounds, options) {
        return new ImageOverlay(url, bounds, options);
    };
    /*
   * @class VideoOverlay
   * @aka L.VideoOverlay
   * @inherits ImageOverlay
   *
   * Used to load and display a video player over specific bounds of the map. Extends `ImageOverlay`.
   *
   * A video overlay uses the [`<video>`](https://developer.mozilla.org/docs/Web/HTML/Element/video)
   * HTML5 element.
   *
   * @example
   *
   * ```js
   * var videoUrl = 'https://www.mapbox.com/bites/00188/patricia_nasa.webm',
   * 	videoBounds = [[ 32, -130], [ 13, -100]];
   * L.videoOverlay(videoUrl, videoBounds ).addTo(map);
   * ```
   */ var VideoOverlay = ImageOverlay.extend({
        // @section
        // @aka VideoOverlay options
        options: {
            // @option autoplay: Boolean = true
            // Whether the video starts playing automatically when loaded.
            // On some browsers autoplay will only work with `muted: true`
            autoplay: true,
            // @option loop: Boolean = true
            // Whether the video will loop back to the beginning when played.
            loop: true,
            // @option keepAspectRatio: Boolean = true
            // Whether the video will save aspect ratio after the projection.
            // Relevant for supported browsers. See [browser compatibility](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit)
            keepAspectRatio: true,
            // @option muted: Boolean = false
            // Whether the video starts on mute when loaded.
            muted: false,
            // @option playsInline: Boolean = true
            // Mobile browsers will play the video right where it is instead of open it up in fullscreen mode.
            playsInline: true
        },
        _initImage: function() {
            var wasElementSupplied = this._url.tagName === 'VIDEO';
            var vid = this._image = wasElementSupplied ? this._url : create$1('video');
            addClass(vid, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(vid, 'leaflet-zoom-animated');
            if (this.options.className) addClass(vid, this.options.className);
            vid.onselectstart = falseFn;
            vid.onmousemove = falseFn;
            // @event load: Event
            // Fired when the video has finished loading the first frame
            vid.onloadeddata = bind(this.fire, this, 'load');
            if (wasElementSupplied) {
                var sourceElements = vid.getElementsByTagName('source');
                var sources = [];
                for(var j = 0; j < sourceElements.length; j++)sources.push(sourceElements[j].src);
                this._url = sourceElements.length > 0 ? sources : [
                    vid.src
                ];
                return;
            }
            if (!isArray(this._url)) this._url = [
                this._url
            ];
            if (!this.options.keepAspectRatio && Object.prototype.hasOwnProperty.call(vid.style, 'objectFit')) vid.style['objectFit'] = 'fill';
            vid.autoplay = !!this.options.autoplay;
            vid.loop = !!this.options.loop;
            vid.muted = !!this.options.muted;
            vid.playsInline = !!this.options.playsInline;
            for(var i = 0; i < this._url.length; i++){
                var source = create$1('source');
                source.src = this._url[i];
                vid.appendChild(source);
            }
        }
    });
    // @factory L.videoOverlay(video: String|Array|HTMLVideoElement, bounds: LatLngBounds, options?: VideoOverlay options)
    // Instantiates an image overlay object given the URL of the video (or array of URLs, or even a video element) and the
    // geographical bounds it is tied to.
    function videoOverlay(video, bounds, options) {
        return new VideoOverlay(video, bounds, options);
    }
    /*
   * @class SVGOverlay
   * @aka L.SVGOverlay
   * @inherits ImageOverlay
   *
   * Used to load, display and provide DOM access to an SVG file over specific bounds of the map. Extends `ImageOverlay`.
   *
   * An SVG overlay uses the [`<svg>`](https://developer.mozilla.org/docs/Web/SVG/Element/svg) element.
   *
   * @example
   *
   * ```js
   * var svgElement = document.createElementNS("http://www.w3.org/2000/svg", "svg");
   * svgElement.setAttribute('xmlns', "http://www.w3.org/2000/svg");
   * svgElement.setAttribute('viewBox', "0 0 200 200");
   * svgElement.innerHTML = '<rect width="200" height="200"/><rect x="75" y="23" width="50" height="50" style="fill:red"/><rect x="75" y="123" width="50" height="50" style="fill:#0013ff"/>';
   * var svgElementBounds = [ [ 32, -130 ], [ 13, -100 ] ];
   * L.svgOverlay(svgElement, svgElementBounds).addTo(map);
   * ```
   */ var SVGOverlay = ImageOverlay.extend({
        _initImage: function() {
            var el = this._image = this._url;
            addClass(el, 'leaflet-image-layer');
            if (this._zoomAnimated) addClass(el, 'leaflet-zoom-animated');
            if (this.options.className) addClass(el, this.options.className);
            el.onselectstart = falseFn;
            el.onmousemove = falseFn;
        }
    });
    // @factory L.svgOverlay(svg: String|SVGElement, bounds: LatLngBounds, options?: SVGOverlay options)
    // Instantiates an image overlay object given an SVG element and the geographical bounds it is tied to.
    // A viewBox attribute is required on the SVG element to zoom in and out properly.
    function svgOverlay(el, bounds, options) {
        return new SVGOverlay(el, bounds, options);
    }
    /*
   * @class DivOverlay
   * @inherits Interactive layer
   * @aka L.DivOverlay
   * Base model for L.Popup and L.Tooltip. Inherit from it for custom overlays like plugins.
   */ // @namespace DivOverlay
    var DivOverlay = Layer.extend({
        // @section
        // @aka DivOverlay options
        options: {
            // @option interactive: Boolean = false
            // If true, the popup/tooltip will listen to the mouse events.
            interactive: false,
            // @option offset: Point = Point(0, 0)
            // The offset of the overlay position.
            offset: [
                0,
                0
            ],
            // @option className: String = ''
            // A custom CSS class name to assign to the overlay.
            className: '',
            // @option pane: String = undefined
            // `Map pane` where the overlay will be added.
            pane: undefined,
            // @option content: String|HTMLElement|Function = ''
            // Sets the HTML content of the overlay while initializing. If a function is passed the source layer will be
            // passed to the function. The function should return a `String` or `HTMLElement` to be used in the overlay.
            content: ''
        },
        initialize: function(options, source) {
            if (options && (options instanceof LatLng || isArray(options))) {
                this._latlng = toLatLng(options);
                setOptions(this, source);
            } else {
                setOptions(this, options);
                this._source = source;
            }
            if (this.options.content) this._content = this.options.content;
        },
        // @method openOn(map: Map): this
        // Adds the overlay to the map.
        // Alternative to `map.openPopup(popup)`/`.openTooltip(tooltip)`.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this)) map.addLayer(this);
            return this;
        },
        // @method close(): this
        // Closes the overlay.
        // Alternative to `map.closePopup(popup)`/`.closeTooltip(tooltip)`
        // and `layer.closePopup()`/`.closeTooltip()`.
        close: function() {
            if (this._map) this._map.removeLayer(this);
            return this;
        },
        // @method toggle(layer?: Layer): this
        // Opens or closes the overlay bound to layer depending on its current state.
        // Argument may be omitted only for overlay bound to layer.
        // Alternative to `layer.togglePopup()`/`.toggleTooltip()`.
        toggle: function(layer) {
            if (this._map) this.close();
            else {
                if (arguments.length) this._source = layer;
                else layer = this._source;
                this._prepareOpen();
                // open the overlay on the map
                this.openOn(layer._map);
            }
            return this;
        },
        onAdd: function(map) {
            this._zoomAnimated = map._zoomAnimated;
            if (!this._container) this._initLayout();
            if (map._fadeAnimated) setOpacity(this._container, 0);
            clearTimeout(this._removeTimeout);
            this.getPane().appendChild(this._container);
            this.update();
            if (map._fadeAnimated) setOpacity(this._container, 1);
            this.bringToFront();
            if (this.options.interactive) {
                addClass(this._container, 'leaflet-interactive');
                this.addInteractiveTarget(this._container);
            }
        },
        onRemove: function(map) {
            if (map._fadeAnimated) {
                setOpacity(this._container, 0);
                this._removeTimeout = setTimeout(bind(remove, undefined, this._container), 200);
            } else remove(this._container);
            if (this.options.interactive) {
                removeClass(this._container, 'leaflet-interactive');
                this.removeInteractiveTarget(this._container);
            }
        },
        // @namespace DivOverlay
        // @method getLatLng: LatLng
        // Returns the geographical point of the overlay.
        getLatLng: function() {
            return this._latlng;
        },
        // @method setLatLng(latlng: LatLng): this
        // Sets the geographical point where the overlay will open.
        setLatLng: function(latlng) {
            this._latlng = toLatLng(latlng);
            if (this._map) {
                this._updatePosition();
                this._adjustPan();
            }
            return this;
        },
        // @method getContent: String|HTMLElement
        // Returns the content of the overlay.
        getContent: function() {
            return this._content;
        },
        // @method setContent(htmlContent: String|HTMLElement|Function): this
        // Sets the HTML content of the overlay. If a function is passed the source layer will be passed to the function.
        // The function should return a `String` or `HTMLElement` to be used in the overlay.
        setContent: function(content) {
            this._content = content;
            this.update();
            return this;
        },
        // @method getElement: String|HTMLElement
        // Returns the HTML container of the overlay.
        getElement: function() {
            return this._container;
        },
        // @method update: null
        // Updates the overlay content, layout and position. Useful for updating the overlay after something inside changed, e.g. image loaded.
        update: function() {
            if (!this._map) return;
            this._container.style.visibility = 'hidden';
            this._updateContent();
            this._updateLayout();
            this._updatePosition();
            this._container.style.visibility = '';
            this._adjustPan();
        },
        getEvents: function() {
            var events = {
                zoom: this._updatePosition,
                viewreset: this._updatePosition
            };
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @method isOpen: Boolean
        // Returns `true` when the overlay is visible on the map.
        isOpen: function() {
            return !!this._map && this._map.hasLayer(this);
        },
        // @method bringToFront: this
        // Brings this overlay in front of other overlays (in the same map pane).
        bringToFront: function() {
            if (this._map) toFront(this._container);
            return this;
        },
        // @method bringToBack: this
        // Brings this overlay to the back of other overlays (in the same map pane).
        bringToBack: function() {
            if (this._map) toBack(this._container);
            return this;
        },
        // prepare bound overlay to open: update latlng pos / content source (for FeatureGroup)
        _prepareOpen: function(latlng) {
            var source = this._source;
            if (!source._map) return false;
            if (source instanceof FeatureGroup) {
                source = null;
                var layers = this._source._layers;
                for(var id in layers)if (layers[id]._map) {
                    source = layers[id];
                    break;
                }
                if (!source) return false;
                 // Unable to get source layer.
                // set overlay source to this layer
                this._source = source;
            }
            if (!latlng) {
                if (source.getCenter) latlng = source.getCenter();
                else if (source.getLatLng) latlng = source.getLatLng();
                else if (source.getBounds) latlng = source.getBounds().getCenter();
                else throw new Error('Unable to get source layer LatLng.');
            }
            this.setLatLng(latlng);
            if (this._map) // update the overlay (content, layout, etc...)
            this.update();
            return true;
        },
        _updateContent: function() {
            if (!this._content) return;
            var node = this._contentNode;
            var content = typeof this._content === 'function' ? this._content(this._source || this) : this._content;
            if (typeof content === 'string') node.innerHTML = content;
            else {
                while(node.hasChildNodes())node.removeChild(node.firstChild);
                node.appendChild(content);
            }
            // @namespace DivOverlay
            // @section DivOverlay events
            // @event contentupdate: Event
            // Fired when the content of the overlay is updated
            this.fire('contentupdate');
        },
        _updatePosition: function() {
            if (!this._map) return;
            var pos = this._map.latLngToLayerPoint(this._latlng), offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (this._zoomAnimated) setPosition(this._container, pos.add(anchor));
            else offset = offset.add(pos).add(anchor);
            var bottom = this._containerBottom = -offset.y, left = this._containerLeft = -Math.round(this._containerWidth / 2) + offset.x;
            // bottom position the overlay in case the height of the overlay changes (images loading etc)
            this._container.style.bottom = bottom + 'px';
            this._container.style.left = left + 'px';
        },
        _getAnchor: function() {
            return [
                0,
                0
            ];
        }
    });
    Map.include({
        _initOverlay: function(OverlayClass, content, latlng, options) {
            var overlay = content;
            if (!(overlay instanceof OverlayClass)) overlay = new OverlayClass(options).setContent(content);
            if (latlng) overlay.setLatLng(latlng);
            return overlay;
        }
    });
    Layer.include({
        _initOverlay: function(OverlayClass, old, content, options) {
            var overlay = content;
            if (overlay instanceof OverlayClass) {
                setOptions(overlay, options);
                overlay._source = this;
            } else {
                overlay = old && !options ? old : new OverlayClass(options, this);
                overlay.setContent(content);
            }
            return overlay;
        }
    });
    /*
   * @class Popup
   * @inherits DivOverlay
   * @aka L.Popup
   * Used to open popups in certain places of the map. Use [Map.openPopup](#map-openpopup) to
   * open popups while making sure that only one popup is open at one time
   * (recommended for usability), or use [Map.addLayer](#map-addlayer) to open as many as you want.
   *
   * @example
   *
   * If you want to just bind a popup to marker click and then open it, it's really easy:
   *
   * ```js
   * marker.bindPopup(popupContent).openPopup();
   * ```
   * Path overlays like polylines also have a `bindPopup` method.
   *
   * A popup can be also standalone:
   *
   * ```js
   * var popup = L.popup()
   * 	.setLatLng(latlng)
   * 	.setContent('<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   * or
   * ```js
   * var popup = L.popup(latlng, {content: '<p>Hello world!<br />This is a nice popup.</p>')
   * 	.openOn(map);
   * ```
   */ // @namespace Popup
    var Popup = DivOverlay.extend({
        // @section
        // @aka Popup options
        options: {
            // @option pane: String = 'popupPane'
            // `Map pane` where the popup will be added.
            pane: 'popupPane',
            // @option offset: Point = Point(0, 7)
            // The offset of the popup position.
            offset: [
                0,
                7
            ],
            // @option maxWidth: Number = 300
            // Max width of the popup, in pixels.
            maxWidth: 300,
            // @option minWidth: Number = 50
            // Min width of the popup, in pixels.
            minWidth: 50,
            // @option maxHeight: Number = null
            // If set, creates a scrollable container of the given height
            // inside a popup if its content exceeds it.
            // The scrollable container can be styled using the
            // `leaflet-popup-scrolled` CSS class selector.
            maxHeight: null,
            // @option autoPan: Boolean = true
            // Set it to `false` if you don't want the map to do panning animation
            // to fit the opened popup.
            autoPan: true,
            // @option autoPanPaddingTopLeft: Point = null
            // The margin between the popup and the top left corner of the map
            // view after autopanning was performed.
            autoPanPaddingTopLeft: null,
            // @option autoPanPaddingBottomRight: Point = null
            // The margin between the popup and the bottom right corner of the map
            // view after autopanning was performed.
            autoPanPaddingBottomRight: null,
            // @option autoPanPadding: Point = Point(5, 5)
            // Equivalent of setting both top left and bottom right autopan padding to the same value.
            autoPanPadding: [
                5,
                5
            ],
            // @option keepInView: Boolean = false
            // Set it to `true` if you want to prevent users from panning the popup
            // off of the screen while it is open.
            keepInView: false,
            // @option closeButton: Boolean = true
            // Controls the presence of a close button in the popup.
            closeButton: true,
            // @option autoClose: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the popup closing when another popup is opened.
            autoClose: true,
            // @option closeOnEscapeKey: Boolean = true
            // Set it to `false` if you want to override the default behavior of
            // the ESC key for closing of the popup.
            closeOnEscapeKey: true,
            // @option closeOnClick: Boolean = *
            // Set it if you want to override the default behavior of the popup closing when user clicks
            // on the map. Defaults to the map's [`closePopupOnClick`](#map-closepopuponclick) option.
            // @option className: String = ''
            // A custom CSS class name to assign to the popup.
            className: ''
        },
        // @namespace Popup
        // @method openOn(map: Map): this
        // Alternative to `map.openPopup(popup)`.
        // Adds the popup to the map and closes the previous one.
        openOn: function(map) {
            map = arguments.length ? map : this._source._map; // experimental, not the part of public api
            if (!map.hasLayer(this) && map._popup && map._popup.options.autoClose) map.removeLayer(map._popup);
            map._popup = this;
            return DivOverlay.prototype.openOn.call(this, map);
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupopen: PopupEvent
            // Fired when a popup is opened in the map
            map.fire('popupopen', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupopen: PopupEvent
                // Fired when a popup bound to this layer is opened
                this._source.fire('popupopen', {
                    popup: this
                }, true);
                // For non-path layers, we toggle the popup when clicking
                // again the layer, so prevent the map to reopen it.
                if (!(this._source instanceof Path)) this._source.on('preclick', stopPropagation);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Popup events
            // @event popupclose: PopupEvent
            // Fired when a popup in the map is closed
            map.fire('popupclose', {
                popup: this
            });
            if (this._source) {
                // @namespace Layer
                // @section Popup events
                // @event popupclose: PopupEvent
                // Fired when a popup bound to this layer is closed
                this._source.fire('popupclose', {
                    popup: this
                }, true);
                if (!(this._source instanceof Path)) this._source.off('preclick', stopPropagation);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (this.options.closeOnClick !== undefined ? this.options.closeOnClick : this._map.options.closePopupOnClick) events.preclick = this.close;
            if (this.options.keepInView) events.moveend = this._adjustPan;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-popup', container = this._container = create$1('div', prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-animated');
            var wrapper = this._wrapper = create$1('div', prefix + '-content-wrapper', container);
            this._contentNode = create$1('div', prefix + '-content', wrapper);
            disableClickPropagation(container);
            disableScrollPropagation(this._contentNode);
            on(container, 'contextmenu', stopPropagation);
            this._tipContainer = create$1('div', prefix + '-tip-container', container);
            this._tip = create$1('div', prefix + '-tip', this._tipContainer);
            if (this.options.closeButton) {
                var closeButton = this._closeButton = create$1('a', prefix + '-close-button', container);
                closeButton.setAttribute('role', 'button'); // overrides the implicit role=link of <a> elements #7399
                closeButton.setAttribute('aria-label', 'Close popup');
                closeButton.href = '#close';
                closeButton.innerHTML = '<span aria-hidden="true">&#215;</span>';
                on(closeButton, 'click', function(ev) {
                    preventDefault(ev);
                    this.close();
                }, this);
            }
        },
        _updateLayout: function() {
            var container = this._contentNode, style = container.style;
            style.width = '';
            style.whiteSpace = 'nowrap';
            var width = container.offsetWidth;
            width = Math.min(width, this.options.maxWidth);
            width = Math.max(width, this.options.minWidth);
            style.width = width + 1 + 'px';
            style.whiteSpace = '';
            style.height = '';
            var height = container.offsetHeight, maxHeight = this.options.maxHeight, scrolledClass = 'leaflet-popup-scrolled';
            if (maxHeight && height > maxHeight) {
                style.height = maxHeight + 'px';
                addClass(container, scrolledClass);
            } else removeClass(container, scrolledClass);
            this._containerWidth = this._container.offsetWidth;
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center), anchor = this._getAnchor();
            setPosition(this._container, pos.add(anchor));
        },
        _adjustPan: function() {
            if (!this.options.autoPan) return;
            if (this._map._panAnim) this._map._panAnim.stop();
            // We can endlessly recurse if keepInView is set and the view resets.
            // Let's guard against that by exiting early if we're responding to our own autopan.
            if (this._autopanning) {
                this._autopanning = false;
                return;
            }
            var map = this._map, marginBottom = parseInt(getStyle(this._container, 'marginBottom'), 10) || 0, containerHeight = this._container.offsetHeight + marginBottom, containerWidth = this._containerWidth, layerPos = new Point(this._containerLeft, -containerHeight - this._containerBottom);
            layerPos._add(getPosition(this._container));
            var containerPos = map.layerPointToContainerPoint(layerPos), padding = toPoint(this.options.autoPanPadding), paddingTL = toPoint(this.options.autoPanPaddingTopLeft || padding), paddingBR = toPoint(this.options.autoPanPaddingBottomRight || padding), size = map.getSize(), dx = 0, dy = 0;
            if (containerPos.x + containerWidth + paddingBR.x > size.x) dx = containerPos.x + containerWidth - size.x + paddingBR.x;
            if (containerPos.x - dx - paddingTL.x < 0) dx = containerPos.x - paddingTL.x;
            if (containerPos.y + containerHeight + paddingBR.y > size.y) dy = containerPos.y + containerHeight - size.y + paddingBR.y;
            if (containerPos.y - dy - paddingTL.y < 0) dy = containerPos.y - paddingTL.y;
            // @namespace Map
            // @section Popup events
            // @event autopanstart: Event
            // Fired when the map starts autopanning when opening a popup.
            if (dx || dy) {
                // Track that we're autopanning, as this function will be re-ran on moveend
                if (this.options.keepInView) this._autopanning = true;
                map.fire('autopanstart').panBy([
                    dx,
                    dy
                ]);
            }
        },
        _getAnchor: function() {
            // Where should we anchor the popup on the source layer?
            return toPoint(this._source && this._source._getPopupAnchor ? this._source._getPopupAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Popup
    // @factory L.popup(options?: Popup options, source?: Layer)
    // Instantiates a `Popup` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the popup with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.popup(latlng: LatLng, options?: Popup options)
    // Instantiates a `Popup` object given `latlng` where the popup will open and an optional `options` object that describes its appearance and location.
    var popup = function(options, source) {
        return new Popup(options, source);
    };
    /* @namespace Map
   * @section Interaction Options
   * @option closePopupOnClick: Boolean = true
   * Set it to `false` if you don't want popups to close when user clicks the map.
   */ Map.mergeOptions({
        closePopupOnClick: true
    });
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openPopup(popup: Popup): this
        // Opens the specified popup while closing the previously opened (to make sure only one is opened at one time for usability).
        // @alternative
        // @method openPopup(content: String|HTMLElement, latlng: LatLng, options?: Popup options): this
        // Creates a popup with the specified content and options and opens it in the given point on a map.
        openPopup: function(popup, latlng, options) {
            this._initOverlay(Popup, popup, latlng, options).openOn(this);
            return this;
        },
        // @method closePopup(popup?: Popup): this
        // Closes the popup previously opened with [openPopup](#map-openpopup) (or the given one).
        closePopup: function(popup) {
            popup = arguments.length ? popup : this._popup;
            if (popup) popup.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Popup methods example
   *
   * All layers share a set of methods convenient for binding popups to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindPopup('Hi There!').addTo(map);
   * layer.openPopup();
   * layer.closePopup();
   * ```
   *
   * Popups will also be automatically opened when the layer is clicked on and closed when the layer is removed from the map or another popup is opened.
   */ // @section Popup methods
    Layer.include({
        // @method bindPopup(content: String|HTMLElement|Function|Popup, options?: Popup options): this
        // Binds a popup to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindPopup: function(content, options) {
            this._popup = this._initOverlay(Popup, this._popup, content, options);
            if (!this._popupHandlersAdded) {
                this.on({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = true;
            }
            return this;
        },
        // @method unbindPopup(): this
        // Removes the popup previously bound with `bindPopup`.
        unbindPopup: function() {
            if (this._popup) {
                this.off({
                    click: this._openPopup,
                    keypress: this._onKeyPress,
                    remove: this.closePopup,
                    move: this._movePopup
                });
                this._popupHandlersAdded = false;
                this._popup = null;
            }
            return this;
        },
        // @method openPopup(latlng?: LatLng): this
        // Opens the bound popup at the specified `latlng` or at the default popup anchor if no `latlng` is passed.
        openPopup: function(latlng) {
            if (this._popup) {
                if (!(this instanceof FeatureGroup)) this._popup._source = this;
                if (this._popup._prepareOpen(latlng || this._latlng)) // open the popup on the map
                this._popup.openOn(this._map);
            }
            return this;
        },
        // @method closePopup(): this
        // Closes the popup bound to this layer if it is open.
        closePopup: function() {
            if (this._popup) this._popup.close();
            return this;
        },
        // @method togglePopup(): this
        // Opens or closes the popup bound to this layer depending on its current state.
        togglePopup: function() {
            if (this._popup) this._popup.toggle(this);
            return this;
        },
        // @method isPopupOpen(): boolean
        // Returns `true` if the popup bound to this layer is currently open.
        isPopupOpen: function() {
            return this._popup ? this._popup.isOpen() : false;
        },
        // @method setPopupContent(content: String|HTMLElement|Popup): this
        // Sets the content of the popup bound to this layer.
        setPopupContent: function(content) {
            if (this._popup) this._popup.setContent(content);
            return this;
        },
        // @method getPopup(): Popup
        // Returns the popup bound to this layer.
        getPopup: function() {
            return this._popup;
        },
        _openPopup: function(e) {
            if (!this._popup || !this._map) return;
            // prevent map click
            stop(e);
            var target = e.layer || e.target;
            if (this._popup._source === target && !(target instanceof Path)) {
                // treat it like a marker and figure out
                // if we should toggle it open/closed
                if (this._map.hasLayer(this._popup)) this.closePopup();
                else this.openPopup(e.latlng);
                return;
            }
            this._popup._source = target;
            this.openPopup(e.latlng);
        },
        _movePopup: function(e) {
            this._popup.setLatLng(e.latlng);
        },
        _onKeyPress: function(e) {
            if (e.originalEvent.keyCode === 13) this._openPopup(e);
        }
    });
    /*
   * @class Tooltip
   * @inherits DivOverlay
   * @aka L.Tooltip
   * Used to display small texts on top of map layers.
   *
   * @example
   * If you want to just bind a tooltip to marker:
   *
   * ```js
   * marker.bindTooltip("my tooltip text").openTooltip();
   * ```
   * Path overlays like polylines also have a `bindTooltip` method.
   *
   * A tooltip can be also standalone:
   *
   * ```js
   * var tooltip = L.tooltip()
   * 	.setLatLng(latlng)
   * 	.setContent('Hello world!<br />This is a nice tooltip.')
   * 	.addTo(map);
   * ```
   * or
   * ```js
   * var tooltip = L.tooltip(latlng, {content: 'Hello world!<br />This is a nice tooltip.'})
   * 	.addTo(map);
   * ```
   *
   *
   * Note about tooltip offset. Leaflet takes two options in consideration
   * for computing tooltip offsetting:
   * - the `offset` Tooltip option: it defaults to [0, 0], and it's specific to one tooltip.
   *   Add a positive x offset to move the tooltip to the right, and a positive y offset to
   *   move it to the bottom. Negatives will move to the left and top.
   * - the `tooltipAnchor` Icon option: this will only be considered for Marker. You
   *   should adapt this value if you use a custom icon.
   */ // @namespace Tooltip
    var Tooltip = DivOverlay.extend({
        // @section
        // @aka Tooltip options
        options: {
            // @option pane: String = 'tooltipPane'
            // `Map pane` where the tooltip will be added.
            pane: 'tooltipPane',
            // @option offset: Point = Point(0, 0)
            // Optional offset of the tooltip position.
            offset: [
                0,
                0
            ],
            // @option direction: String = 'auto'
            // Direction where to open the tooltip. Possible values are: `right`, `left`,
            // `top`, `bottom`, `center`, `auto`.
            // `auto` will dynamically switch between `right` and `left` according to the tooltip
            // position on the map.
            direction: 'auto',
            // @option permanent: Boolean = false
            // Whether to open the tooltip permanently or only on mouseover.
            permanent: false,
            // @option sticky: Boolean = false
            // If true, the tooltip will follow the mouse instead of being fixed at the feature center.
            sticky: false,
            // @option opacity: Number = 0.9
            // Tooltip container opacity.
            opacity: 0.9
        },
        onAdd: function(map) {
            DivOverlay.prototype.onAdd.call(this, map);
            this.setOpacity(this.options.opacity);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipopen: TooltipEvent
            // Fired when a tooltip is opened in the map.
            map.fire('tooltipopen', {
                tooltip: this
            });
            if (this._source) {
                this.addEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipopen: TooltipEvent
                // Fired when a tooltip bound to this layer is opened.
                this._source.fire('tooltipopen', {
                    tooltip: this
                }, true);
            }
        },
        onRemove: function(map) {
            DivOverlay.prototype.onRemove.call(this, map);
            // @namespace Map
            // @section Tooltip events
            // @event tooltipclose: TooltipEvent
            // Fired when a tooltip in the map is closed.
            map.fire('tooltipclose', {
                tooltip: this
            });
            if (this._source) {
                this.removeEventParent(this._source);
                // @namespace Layer
                // @section Tooltip events
                // @event tooltipclose: TooltipEvent
                // Fired when a tooltip bound to this layer is closed.
                this._source.fire('tooltipclose', {
                    tooltip: this
                }, true);
            }
        },
        getEvents: function() {
            var events = DivOverlay.prototype.getEvents.call(this);
            if (!this.options.permanent) events.preclick = this.close;
            return events;
        },
        _initLayout: function() {
            var prefix = 'leaflet-tooltip', className = prefix + ' ' + (this.options.className || '') + ' leaflet-zoom-' + (this._zoomAnimated ? 'animated' : 'hide');
            this._contentNode = this._container = create$1('div', className);
            this._container.setAttribute('role', 'tooltip');
            this._container.setAttribute('id', 'leaflet-tooltip-' + stamp(this));
        },
        _updateLayout: function() {},
        _adjustPan: function() {},
        _setPosition: function(pos) {
            var subX, subY, map = this._map, container = this._container, centerPoint = map.latLngToContainerPoint(map.getCenter()), tooltipPoint = map.layerPointToContainerPoint(pos), direction = this.options.direction, tooltipWidth = container.offsetWidth, tooltipHeight = container.offsetHeight, offset = toPoint(this.options.offset), anchor = this._getAnchor();
            if (direction === 'top') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight;
            } else if (direction === 'bottom') {
                subX = tooltipWidth / 2;
                subY = 0;
            } else if (direction === 'center') {
                subX = tooltipWidth / 2;
                subY = tooltipHeight / 2;
            } else if (direction === 'right') {
                subX = 0;
                subY = tooltipHeight / 2;
            } else if (direction === 'left') {
                subX = tooltipWidth;
                subY = tooltipHeight / 2;
            } else if (tooltipPoint.x < centerPoint.x) {
                direction = 'right';
                subX = 0;
                subY = tooltipHeight / 2;
            } else {
                direction = 'left';
                subX = tooltipWidth + (offset.x + anchor.x) * 2;
                subY = tooltipHeight / 2;
            }
            pos = pos.subtract(toPoint(subX, subY, true)).add(offset).add(anchor);
            removeClass(container, 'leaflet-tooltip-right');
            removeClass(container, 'leaflet-tooltip-left');
            removeClass(container, 'leaflet-tooltip-top');
            removeClass(container, 'leaflet-tooltip-bottom');
            addClass(container, 'leaflet-tooltip-' + direction);
            setPosition(container, pos);
        },
        _updatePosition: function() {
            var pos = this._map.latLngToLayerPoint(this._latlng);
            this._setPosition(pos);
        },
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            if (this._container) setOpacity(this._container, opacity);
        },
        _animateZoom: function(e) {
            var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center);
            this._setPosition(pos);
        },
        _getAnchor: function() {
            // Where should we anchor the tooltip on the source layer?
            return toPoint(this._source && this._source._getTooltipAnchor && !this.options.sticky ? this._source._getTooltipAnchor() : [
                0,
                0
            ]);
        }
    });
    // @namespace Tooltip
    // @factory L.tooltip(options?: Tooltip options, source?: Layer)
    // Instantiates a `Tooltip` object given an optional `options` object that describes its appearance and location and an optional `source` object that is used to tag the tooltip with a reference to the Layer to which it refers.
    // @alternative
    // @factory L.tooltip(latlng: LatLng, options?: Tooltip options)
    // Instantiates a `Tooltip` object given `latlng` where the tooltip will open and an optional `options` object that describes its appearance and location.
    var tooltip = function(options, source) {
        return new Tooltip(options, source);
    };
    // @namespace Map
    // @section Methods for Layers and Controls
    Map.include({
        // @method openTooltip(tooltip: Tooltip): this
        // Opens the specified tooltip.
        // @alternative
        // @method openTooltip(content: String|HTMLElement, latlng: LatLng, options?: Tooltip options): this
        // Creates a tooltip with the specified content and options and open it.
        openTooltip: function(tooltip, latlng, options) {
            this._initOverlay(Tooltip, tooltip, latlng, options).openOn(this);
            return this;
        },
        // @method closeTooltip(tooltip: Tooltip): this
        // Closes the tooltip given as parameter.
        closeTooltip: function(tooltip) {
            tooltip.close();
            return this;
        }
    });
    /*
   * @namespace Layer
   * @section Tooltip methods example
   *
   * All layers share a set of methods convenient for binding tooltips to it.
   *
   * ```js
   * var layer = L.Polygon(latlngs).bindTooltip('Hi There!').addTo(map);
   * layer.openTooltip();
   * layer.closeTooltip();
   * ```
   */ // @section Tooltip methods
    Layer.include({
        // @method bindTooltip(content: String|HTMLElement|Function|Tooltip, options?: Tooltip options): this
        // Binds a tooltip to the layer with the passed `content` and sets up the
        // necessary event listeners. If a `Function` is passed it will receive
        // the layer as the first argument and should return a `String` or `HTMLElement`.
        bindTooltip: function(content, options) {
            if (this._tooltip && this.isTooltipOpen()) this.unbindTooltip();
            this._tooltip = this._initOverlay(Tooltip, this._tooltip, content, options);
            this._initTooltipInteractions();
            if (this._tooltip.options.permanent && this._map && this._map.hasLayer(this)) this.openTooltip();
            return this;
        },
        // @method unbindTooltip(): this
        // Removes the tooltip previously bound with `bindTooltip`.
        unbindTooltip: function() {
            if (this._tooltip) {
                this._initTooltipInteractions(true);
                this.closeTooltip();
                this._tooltip = null;
            }
            return this;
        },
        _initTooltipInteractions: function(remove) {
            if (!remove && this._tooltipHandlersAdded) return;
            var onOff = remove ? 'off' : 'on', events = {
                remove: this.closeTooltip,
                move: this._moveTooltip
            };
            if (!this._tooltip.options.permanent) {
                events.mouseover = this._openTooltip;
                events.mouseout = this.closeTooltip;
                events.click = this._openTooltip;
                if (this._map) this._addFocusListeners();
                else events.add = this._addFocusListeners;
            } else events.add = this._openTooltip;
            if (this._tooltip.options.sticky) events.mousemove = this._moveTooltip;
            this[onOff](events);
            this._tooltipHandlersAdded = !remove;
        },
        // @method openTooltip(latlng?: LatLng): this
        // Opens the bound tooltip at the specified `latlng` or at the default tooltip anchor if no `latlng` is passed.
        openTooltip: function(latlng) {
            if (this._tooltip) {
                if (!(this instanceof FeatureGroup)) this._tooltip._source = this;
                if (this._tooltip._prepareOpen(latlng)) {
                    // open the tooltip on the map
                    this._tooltip.openOn(this._map);
                    if (this.getElement) this._setAriaDescribedByOnLayer(this);
                    else if (this.eachLayer) this.eachLayer(this._setAriaDescribedByOnLayer, this);
                }
            }
            return this;
        },
        // @method closeTooltip(): this
        // Closes the tooltip bound to this layer if it is open.
        closeTooltip: function() {
            if (this._tooltip) return this._tooltip.close();
        },
        // @method toggleTooltip(): this
        // Opens or closes the tooltip bound to this layer depending on its current state.
        toggleTooltip: function() {
            if (this._tooltip) this._tooltip.toggle(this);
            return this;
        },
        // @method isTooltipOpen(): boolean
        // Returns `true` if the tooltip bound to this layer is currently open.
        isTooltipOpen: function() {
            return this._tooltip.isOpen();
        },
        // @method setTooltipContent(content: String|HTMLElement|Tooltip): this
        // Sets the content of the tooltip bound to this layer.
        setTooltipContent: function(content) {
            if (this._tooltip) this._tooltip.setContent(content);
            return this;
        },
        // @method getTooltip(): Tooltip
        // Returns the tooltip bound to this layer.
        getTooltip: function() {
            return this._tooltip;
        },
        _addFocusListeners: function() {
            if (this.getElement) this._addFocusListenersOnLayer(this);
            else if (this.eachLayer) this.eachLayer(this._addFocusListenersOnLayer, this);
        },
        _addFocusListenersOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) {
                on(el, 'focus', function() {
                    this._tooltip._source = layer;
                    this.openTooltip();
                }, this);
                on(el, 'blur', this.closeTooltip, this);
            }
        },
        _setAriaDescribedByOnLayer: function(layer) {
            var el = typeof layer.getElement === 'function' && layer.getElement();
            if (el) el.setAttribute('aria-describedby', this._tooltip._container.id);
        },
        _openTooltip: function(e) {
            if (!this._tooltip || !this._map) return;
            // If the map is moving, we will show the tooltip after it's done.
            if (this._map.dragging && this._map.dragging.moving() && !this._openOnceFlag) {
                this._openOnceFlag = true;
                var that = this;
                this._map.once('moveend', function() {
                    that._openOnceFlag = false;
                    that._openTooltip(e);
                });
                return;
            }
            this._tooltip._source = e.layer || e.target;
            this.openTooltip(this._tooltip.options.sticky ? e.latlng : undefined);
        },
        _moveTooltip: function(e) {
            var latlng = e.latlng, containerPoint, layerPoint;
            if (this._tooltip.options.sticky && e.originalEvent) {
                containerPoint = this._map.mouseEventToContainerPoint(e.originalEvent);
                layerPoint = this._map.containerPointToLayerPoint(containerPoint);
                latlng = this._map.layerPointToLatLng(layerPoint);
            }
            this._tooltip.setLatLng(latlng);
        }
    });
    /*
   * @class DivIcon
   * @aka L.DivIcon
   * @inherits Icon
   *
   * Represents a lightweight icon for markers that uses a simple `<div>`
   * element instead of an image. Inherits from `Icon` but ignores the `iconUrl` and shadow options.
   *
   * @example
   * ```js
   * var myIcon = L.divIcon({className: 'my-div-icon'});
   * // you can set .my-div-icon styles in CSS
   *
   * L.marker([50.505, 30.57], {icon: myIcon}).addTo(map);
   * ```
   *
   * By default, it has a 'leaflet-div-icon' CSS class and is styled as a little white square with a shadow.
   */ var DivIcon = Icon.extend({
        options: {
            // @section
            // @aka DivIcon options
            iconSize: [
                12,
                12
            ],
            // iconAnchor: (Point),
            // popupAnchor: (Point),
            // @option html: String|HTMLElement = ''
            // Custom HTML code to put inside the div element, empty by default. Alternatively,
            // an instance of `HTMLElement`.
            html: false,
            // @option bgPos: Point = [0, 0]
            // Optional relative position of the background, in pixels
            bgPos: null,
            className: 'leaflet-div-icon'
        },
        createIcon: function(oldIcon) {
            var div = oldIcon && oldIcon.tagName === 'DIV' ? oldIcon : document.createElement('div'), options = this.options;
            if (options.html instanceof Element) {
                empty(div);
                div.appendChild(options.html);
            } else div.innerHTML = options.html !== false ? options.html : '';
            if (options.bgPos) {
                var bgPos = toPoint(options.bgPos);
                div.style.backgroundPosition = -bgPos.x + 'px ' + -bgPos.y + 'px';
            }
            this._setIconStyles(div, 'icon');
            return div;
        },
        createShadow: function() {
            return null;
        }
    });
    // @factory L.divIcon(options: DivIcon options)
    // Creates a `DivIcon` instance with the given options.
    function divIcon(options) {
        return new DivIcon(options);
    }
    Icon.Default = IconDefault;
    /*
   * @class GridLayer
   * @inherits Layer
   * @aka L.GridLayer
   *
   * Generic class for handling a tiled grid of HTML elements. This is the base class for all tile layers and replaces `TileLayer.Canvas`.
   * GridLayer can be extended to create a tiled grid of HTML elements like `<canvas>`, `<img>` or `<div>`. GridLayer will handle creating and animating these DOM elements for you.
   *
   *
   * @section Synchronous usage
   * @example
   *
   * To create a custom layer, extend GridLayer and implement the `createTile()` method, which will be passed a `Point` object with the `x`, `y`, and `z` (zoom level) coordinates to draw your tile.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords){
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // get a canvas context and draw something on it using coords.x, coords.y and coords.z
   *         var ctx = tile.getContext('2d');
   *
   *         // return the tile so it can be rendered on screen
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section Asynchronous usage
   * @example
   *
   * Tile creation can also be asynchronous, this is useful when using a third-party drawing library. Once the tile is finished drawing it can be passed to the `done()` callback.
   *
   * ```js
   * var CanvasLayer = L.GridLayer.extend({
   *     createTile: function(coords, done){
   *         var error;
   *
   *         // create a <canvas> element for drawing
   *         var tile = L.DomUtil.create('canvas', 'leaflet-tile');
   *
   *         // setup tile width and height according to the options
   *         var size = this.getTileSize();
   *         tile.width = size.x;
   *         tile.height = size.y;
   *
   *         // draw something asynchronously and pass the tile to the done() callback
   *         setTimeout(function() {
   *             done(error, tile);
   *         }, 1000);
   *
   *         return tile;
   *     }
   * });
   * ```
   *
   * @section
   */ var GridLayer = Layer.extend({
        // @section
        // @aka GridLayer options
        options: {
            // @option tileSize: Number|Point = 256
            // Width and height of tiles in the grid. Use a number if width and height are equal, or `L.point(width, height)` otherwise.
            tileSize: 256,
            // @option opacity: Number = 1.0
            // Opacity of the tiles. Can be used in the `createTile()` function.
            opacity: 1,
            // @option updateWhenIdle: Boolean = (depends)
            // Load new tiles only when panning ends.
            // `true` by default on mobile browsers, in order to avoid too many requests and keep smooth navigation.
            // `false` otherwise in order to display new tiles _during_ panning, since it is easy to pan outside the
            // [`keepBuffer`](#gridlayer-keepbuffer) option in desktop browsers.
            updateWhenIdle: Browser.mobile,
            // @option updateWhenZooming: Boolean = true
            // By default, a smooth zoom animation (during a [touch zoom](#map-touchzoom) or a [`flyTo()`](#map-flyto)) will update grid layers every integer zoom level. Setting this option to `false` will update the grid layer only when the smooth animation ends.
            updateWhenZooming: true,
            // @option updateInterval: Number = 200
            // Tiles will not update more than once every `updateInterval` milliseconds when panning.
            updateInterval: 200,
            // @option zIndex: Number = 1
            // The explicit zIndex of the tile layer.
            zIndex: 1,
            // @option bounds: LatLngBounds = undefined
            // If set, tiles will only be loaded inside the set `LatLngBounds`.
            bounds: null,
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = undefined
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: undefined,
            // @option maxNativeZoom: Number = undefined
            // Maximum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels higher than `maxNativeZoom` will be loaded
            // from `maxNativeZoom` level and auto-scaled.
            maxNativeZoom: undefined,
            // @option minNativeZoom: Number = undefined
            // Minimum zoom number the tile source has available. If it is specified,
            // the tiles on all zoom levels lower than `minNativeZoom` will be loaded
            // from `minNativeZoom` level and auto-scaled.
            minNativeZoom: undefined,
            // @option noWrap: Boolean = false
            // Whether the layer is wrapped around the antimeridian. If `true`, the
            // GridLayer will only be displayed once at low zoom levels. Has no
            // effect when the [map CRS](#map-crs) doesn't wrap around. Can be used
            // in combination with [`bounds`](#gridlayer-bounds) to prevent requesting
            // tiles outside the CRS limits.
            noWrap: false,
            // @option pane: String = 'tilePane'
            // `Map pane` where the grid layer will be added.
            pane: 'tilePane',
            // @option className: String = ''
            // A custom class name to assign to the tile layer. Empty by default.
            className: '',
            // @option keepBuffer: Number = 2
            // When panning the map, keep this many rows and columns of tiles before unloading them.
            keepBuffer: 2
        },
        initialize: function(options) {
            setOptions(this, options);
        },
        onAdd: function() {
            this._initContainer();
            this._levels = {};
            this._tiles = {};
            this._resetView(); // implicit _update() call
        },
        beforeAdd: function(map) {
            map._addZoomLimit(this);
        },
        onRemove: function(map) {
            this._removeAllTiles();
            remove(this._container);
            map._removeZoomLimit(this);
            this._container = null;
            this._tileZoom = undefined;
        },
        // @method bringToFront: this
        // Brings the tile layer to the top of all tile layers.
        bringToFront: function() {
            if (this._map) {
                toFront(this._container);
                this._setAutoZIndex(Math.max);
            }
            return this;
        },
        // @method bringToBack: this
        // Brings the tile layer to the bottom of all tile layers.
        bringToBack: function() {
            if (this._map) {
                toBack(this._container);
                this._setAutoZIndex(Math.min);
            }
            return this;
        },
        // @method getContainer: HTMLElement
        // Returns the HTML element that contains the tiles for this layer.
        getContainer: function() {
            return this._container;
        },
        // @method setOpacity(opacity: Number): this
        // Changes the [opacity](#gridlayer-opacity) of the grid layer.
        setOpacity: function(opacity) {
            this.options.opacity = opacity;
            this._updateOpacity();
            return this;
        },
        // @method setZIndex(zIndex: Number): this
        // Changes the [zIndex](#gridlayer-zindex) of the grid layer.
        setZIndex: function(zIndex) {
            this.options.zIndex = zIndex;
            this._updateZIndex();
            return this;
        },
        // @method isLoading: Boolean
        // Returns `true` if any tile in the grid layer has not finished loading.
        isLoading: function() {
            return this._loading;
        },
        // @method redraw: this
        // Causes the layer to clear all the tiles and request them again.
        redraw: function() {
            if (this._map) {
                this._removeAllTiles();
                var tileZoom = this._clampZoom(this._map.getZoom());
                if (tileZoom !== this._tileZoom) {
                    this._tileZoom = tileZoom;
                    this._updateLevels();
                }
                this._update();
            }
            return this;
        },
        getEvents: function() {
            var events = {
                viewprereset: this._invalidateAll,
                viewreset: this._resetView,
                zoom: this._resetView,
                moveend: this._onMoveEnd
            };
            if (!this.options.updateWhenIdle) {
                // update tiles on move, but not more often than once per given interval
                if (!this._onMove) this._onMove = throttle(this._onMoveEnd, this.options.updateInterval, this);
                events.move = this._onMove;
            }
            if (this._zoomAnimated) events.zoomanim = this._animateZoom;
            return events;
        },
        // @section Extension methods
        // Layers extending `GridLayer` shall reimplement the following method.
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, must be overridden by classes extending `GridLayer`.
        // Returns the `HTMLElement` corresponding to the given `coords`. If the `done` callback
        // is specified, it must be called when the tile has finished loading and drawing.
        createTile: function() {
            return document.createElement('div');
        },
        // @section
        // @method getTileSize: Point
        // Normalizes the [tileSize option](#gridlayer-tilesize) into a point. Used by the `createTile()` method.
        getTileSize: function() {
            var s = this.options.tileSize;
            return s instanceof Point ? s : new Point(s, s);
        },
        _updateZIndex: function() {
            if (this._container && this.options.zIndex !== undefined && this.options.zIndex !== null) this._container.style.zIndex = this.options.zIndex;
        },
        _setAutoZIndex: function(compare) {
            // go through all other layers of the same pane, set zIndex to max + 1 (front) or min - 1 (back)
            var layers = this.getPane().children, edgeZIndex = -compare(-Infinity, Infinity); // -Infinity for max, Infinity for min
            for(var i = 0, len = layers.length, zIndex; i < len; i++){
                zIndex = layers[i].style.zIndex;
                if (layers[i] !== this._container && zIndex) edgeZIndex = compare(edgeZIndex, +zIndex);
            }
            if (isFinite(edgeZIndex)) {
                this.options.zIndex = edgeZIndex + compare(-1, 1);
                this._updateZIndex();
            }
        },
        _updateOpacity: function() {
            if (!this._map) return;
            // IE doesn't inherit filter opacity properly, so we're forced to set it on tiles
            if (Browser.ielt9) return;
            setOpacity(this._container, this.options.opacity);
            var now = +new Date(), nextFrame = false, willPrune = false;
            for(var key in this._tiles){
                var tile = this._tiles[key];
                if (!tile.current || !tile.loaded) continue;
                var fade = Math.min(1, (now - tile.loaded) / 200);
                setOpacity(tile.el, fade);
                if (fade < 1) nextFrame = true;
                else {
                    if (tile.active) willPrune = true;
                    else this._onOpaqueTile(tile);
                    tile.active = true;
                }
            }
            if (willPrune && !this._noPrune) this._pruneTiles();
            if (nextFrame) {
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            }
        },
        _onOpaqueTile: falseFn,
        _initContainer: function() {
            if (this._container) return;
            this._container = create$1('div', 'leaflet-layer ' + (this.options.className || ''));
            this._updateZIndex();
            if (this.options.opacity < 1) this._updateOpacity();
            this.getPane().appendChild(this._container);
        },
        _updateLevels: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom;
            if (zoom === undefined) return undefined;
            for(var z in this._levels){
                z = Number(z);
                if (this._levels[z].el.children.length || z === zoom) {
                    this._levels[z].el.style.zIndex = maxZoom - Math.abs(zoom - z);
                    this._onUpdateLevel(z);
                } else {
                    remove(this._levels[z].el);
                    this._removeTilesAtZoom(z);
                    this._onRemoveLevel(z);
                    delete this._levels[z];
                }
            }
            var level = this._levels[zoom], map = this._map;
            if (!level) {
                level = this._levels[zoom] = {};
                level.el = create$1('div', 'leaflet-tile-container leaflet-zoom-animated', this._container);
                level.el.style.zIndex = maxZoom;
                level.origin = map.project(map.unproject(map.getPixelOrigin()), zoom).round();
                level.zoom = zoom;
                this._setZoomTransform(level, map.getCenter(), map.getZoom());
                // force the browser to consider the newly added element for transition
                falseFn(level.el.offsetWidth);
                this._onCreateLevel(level);
            }
            this._level = level;
            return level;
        },
        _onUpdateLevel: falseFn,
        _onRemoveLevel: falseFn,
        _onCreateLevel: falseFn,
        _pruneTiles: function() {
            if (!this._map) return;
            var key, tile;
            var zoom = this._map.getZoom();
            if (zoom > this.options.maxZoom || zoom < this.options.minZoom) {
                this._removeAllTiles();
                return;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                tile.retain = tile.current;
            }
            for(key in this._tiles){
                tile = this._tiles[key];
                if (tile.current && !tile.active) {
                    var coords = tile.coords;
                    if (!this._retainParent(coords.x, coords.y, coords.z, coords.z - 5)) this._retainChildren(coords.x, coords.y, coords.z, coords.z + 2);
                }
            }
            for(key in this._tiles)if (!this._tiles[key].retain) this._removeTile(key);
        },
        _removeTilesAtZoom: function(zoom) {
            for(var key in this._tiles){
                if (this._tiles[key].coords.z !== zoom) continue;
                this._removeTile(key);
            }
        },
        _removeAllTiles: function() {
            for(var key in this._tiles)this._removeTile(key);
        },
        _invalidateAll: function() {
            for(var z in this._levels){
                remove(this._levels[z].el);
                this._onRemoveLevel(Number(z));
                delete this._levels[z];
            }
            this._removeAllTiles();
            this._tileZoom = undefined;
        },
        _retainParent: function(x, y, z, minZoom) {
            var x2 = Math.floor(x / 2), y2 = Math.floor(y / 2), z2 = z - 1, coords2 = new Point(+x2, +y2);
            coords2.z = +z2;
            var key = this._tileCoordsToKey(coords2), tile = this._tiles[key];
            if (tile && tile.active) {
                tile.retain = true;
                return true;
            } else if (tile && tile.loaded) tile.retain = true;
            if (z2 > minZoom) return this._retainParent(x2, y2, z2, minZoom);
            return false;
        },
        _retainChildren: function(x, y, z, maxZoom) {
            for(var i = 2 * x; i < 2 * x + 2; i++)for(var j = 2 * y; j < 2 * y + 2; j++){
                var coords = new Point(i, j);
                coords.z = z + 1;
                var key = this._tileCoordsToKey(coords), tile = this._tiles[key];
                if (tile && tile.active) {
                    tile.retain = true;
                    continue;
                } else if (tile && tile.loaded) tile.retain = true;
                if (z + 1 < maxZoom) this._retainChildren(i, j, z + 1, maxZoom);
            }
        },
        _resetView: function(e) {
            var animating = e && (e.pinch || e.flyTo);
            this._setView(this._map.getCenter(), this._map.getZoom(), animating, animating);
        },
        _animateZoom: function(e) {
            this._setView(e.center, e.zoom, true, e.noUpdate);
        },
        _clampZoom: function(zoom) {
            var options = this.options;
            if (undefined !== options.minNativeZoom && zoom < options.minNativeZoom) return options.minNativeZoom;
            if (undefined !== options.maxNativeZoom && options.maxNativeZoom < zoom) return options.maxNativeZoom;
            return zoom;
        },
        _setView: function(center, zoom, noPrune, noUpdate) {
            var tileZoom = Math.round(zoom);
            if (this.options.maxZoom !== undefined && tileZoom > this.options.maxZoom || this.options.minZoom !== undefined && tileZoom < this.options.minZoom) tileZoom = undefined;
            else tileZoom = this._clampZoom(tileZoom);
            var tileZoomChanged = this.options.updateWhenZooming && tileZoom !== this._tileZoom;
            if (!noUpdate || tileZoomChanged) {
                this._tileZoom = tileZoom;
                if (this._abortLoading) this._abortLoading();
                this._updateLevels();
                this._resetGrid();
                if (tileZoom !== undefined) this._update(center);
                if (!noPrune) this._pruneTiles();
                // Flag to prevent _updateOpacity from pruning tiles during
                // a zoom anim or a pinch gesture
                this._noPrune = !!noPrune;
            }
            this._setZoomTransforms(center, zoom);
        },
        _setZoomTransforms: function(center, zoom) {
            for(var i in this._levels)this._setZoomTransform(this._levels[i], center, zoom);
        },
        _setZoomTransform: function(level, center, zoom) {
            var scale = this._map.getZoomScale(zoom, level.zoom), translate = level.origin.multiplyBy(scale).subtract(this._map._getNewPixelOrigin(center, zoom)).round();
            if (Browser.any3d) setTransform(level.el, translate, scale);
            else setPosition(level.el, translate);
        },
        _resetGrid: function() {
            var map = this._map, crs = map.options.crs, tileSize = this._tileSize = this.getTileSize(), tileZoom = this._tileZoom;
            var bounds = this._map.getPixelWorldBounds(this._tileZoom);
            if (bounds) this._globalTileRange = this._pxBoundsToTileRange(bounds);
            this._wrapX = crs.wrapLng && !this.options.noWrap && [
                Math.floor(map.project([
                    0,
                    crs.wrapLng[0]
                ], tileZoom).x / tileSize.x),
                Math.ceil(map.project([
                    0,
                    crs.wrapLng[1]
                ], tileZoom).x / tileSize.y)
            ];
            this._wrapY = crs.wrapLat && !this.options.noWrap && [
                Math.floor(map.project([
                    crs.wrapLat[0],
                    0
                ], tileZoom).y / tileSize.x),
                Math.ceil(map.project([
                    crs.wrapLat[1],
                    0
                ], tileZoom).y / tileSize.y)
            ];
        },
        _onMoveEnd: function() {
            if (!this._map || this._map._animatingZoom) return;
            this._update();
        },
        _getTiledPixelBounds: function(center) {
            var map = this._map, mapZoom = map._animatingZoom ? Math.max(map._animateToZoom, map.getZoom()) : map.getZoom(), scale = map.getZoomScale(mapZoom, this._tileZoom), pixelCenter = map.project(center, this._tileZoom).floor(), halfSize = map.getSize().divideBy(scale * 2);
            return new Bounds(pixelCenter.subtract(halfSize), pixelCenter.add(halfSize));
        },
        // Private method to load tiles in the grid's active zoom level according to map bounds
        _update: function(center) {
            var map = this._map;
            if (!map) return;
            var zoom = this._clampZoom(map.getZoom());
            if (center === undefined) center = map.getCenter();
            if (this._tileZoom === undefined) return;
             // if out of minzoom/maxzoom
            var pixelBounds = this._getTiledPixelBounds(center), tileRange = this._pxBoundsToTileRange(pixelBounds), tileCenter = tileRange.getCenter(), queue = [], margin = this.options.keepBuffer, noPruneRange = new Bounds(tileRange.getBottomLeft().subtract([
                margin,
                -margin
            ]), tileRange.getTopRight().add([
                margin,
                -margin
            ]));
            // Sanity check: panic if the tile range contains Infinity somewhere.
            if (!(isFinite(tileRange.min.x) && isFinite(tileRange.min.y) && isFinite(tileRange.max.x) && isFinite(tileRange.max.y))) throw new Error('Attempted to load an infinite number of tiles');
            for(var key in this._tiles){
                var c = this._tiles[key].coords;
                if (c.z !== this._tileZoom || !noPruneRange.contains(new Point(c.x, c.y))) this._tiles[key].current = false;
            }
            // _update just loads more tiles. If the tile zoom level differs too much
            // from the map's, let _setView reset levels and prune old tiles.
            if (Math.abs(zoom - this._tileZoom) > 1) {
                this._setView(center, zoom);
                return;
            }
            // create a queue of coordinates to load tiles from
            for(var j = tileRange.min.y; j <= tileRange.max.y; j++)for(var i = tileRange.min.x; i <= tileRange.max.x; i++){
                var coords = new Point(i, j);
                coords.z = this._tileZoom;
                if (!this._isValidTile(coords)) continue;
                var tile = this._tiles[this._tileCoordsToKey(coords)];
                if (tile) tile.current = true;
                else queue.push(coords);
            }
            // sort tile queue to load tiles in order of their distance to center
            queue.sort(function(a, b) {
                return a.distanceTo(tileCenter) - b.distanceTo(tileCenter);
            });
            if (queue.length !== 0) {
                // if it's the first batch of tiles to load
                if (!this._loading) {
                    this._loading = true;
                    // @event loading: Event
                    // Fired when the grid layer starts loading tiles.
                    this.fire('loading');
                }
                // create DOM fragment to append tiles in one batch
                var fragment = document.createDocumentFragment();
                for(i = 0; i < queue.length; i++)this._addTile(queue[i], fragment);
                this._level.el.appendChild(fragment);
            }
        },
        _isValidTile: function(coords) {
            var crs = this._map.options.crs;
            if (!crs.infinite) {
                // don't load tile if it's out of bounds and not wrapped
                var bounds = this._globalTileRange;
                if (!crs.wrapLng && (coords.x < bounds.min.x || coords.x > bounds.max.x) || !crs.wrapLat && (coords.y < bounds.min.y || coords.y > bounds.max.y)) return false;
            }
            if (!this.options.bounds) return true;
            // don't load tile if it doesn't intersect the bounds in options
            var tileBounds = this._tileCoordsToBounds(coords);
            return toLatLngBounds(this.options.bounds).overlaps(tileBounds);
        },
        _keyToBounds: function(key) {
            return this._tileCoordsToBounds(this._keyToTileCoords(key));
        },
        _tileCoordsToNwSe: function(coords) {
            var map = this._map, tileSize = this.getTileSize(), nwPoint = coords.scaleBy(tileSize), sePoint = nwPoint.add(tileSize), nw = map.unproject(nwPoint, coords.z), se = map.unproject(sePoint, coords.z);
            return [
                nw,
                se
            ];
        },
        // converts tile coordinates to its geographical bounds
        _tileCoordsToBounds: function(coords) {
            var bp = this._tileCoordsToNwSe(coords), bounds = new LatLngBounds(bp[0], bp[1]);
            if (!this.options.noWrap) bounds = this._map.wrapLatLngBounds(bounds);
            return bounds;
        },
        // converts tile coordinates to key for the tile cache
        _tileCoordsToKey: function(coords) {
            return coords.x + ':' + coords.y + ':' + coords.z;
        },
        // converts tile cache key to coordinates
        _keyToTileCoords: function(key) {
            var k = key.split(':'), coords = new Point(+k[0], +k[1]);
            coords.z = +k[2];
            return coords;
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            remove(tile.el);
            delete this._tiles[key];
            // @event tileunload: TileEvent
            // Fired when a tile is removed (e.g. when a tile goes off the screen).
            this.fire('tileunload', {
                tile: tile.el,
                coords: this._keyToTileCoords(key)
            });
        },
        _initTile: function(tile) {
            addClass(tile, 'leaflet-tile');
            var tileSize = this.getTileSize();
            tile.style.width = tileSize.x + 'px';
            tile.style.height = tileSize.y + 'px';
            tile.onselectstart = falseFn;
            tile.onmousemove = falseFn;
            // update opacity on tiles in IE7-8 because of filter inheritance problems
            if (Browser.ielt9 && this.options.opacity < 1) setOpacity(tile, this.options.opacity);
        },
        _addTile: function(coords, container) {
            var tilePos = this._getTilePos(coords), key = this._tileCoordsToKey(coords);
            var tile = this.createTile(this._wrapCoords(coords), bind(this._tileReady, this, coords));
            this._initTile(tile);
            // if createTile is defined with a second argument ("done" callback),
            // we know that tile is async and will be ready later; otherwise
            if (this.createTile.length < 2) // mark tile as ready, but delay one frame for opacity animation to happen
            requestAnimFrame(bind(this._tileReady, this, coords, null, tile));
            setPosition(tile, tilePos);
            // save tile in cache
            this._tiles[key] = {
                el: tile,
                coords: coords,
                current: true
            };
            container.appendChild(tile);
            // @event tileloadstart: TileEvent
            // Fired when a tile is requested and starts loading.
            this.fire('tileloadstart', {
                tile: tile,
                coords: coords
            });
        },
        _tileReady: function(coords, err, tile) {
            if (err) // @event tileerror: TileErrorEvent
            // Fired when there is an error loading a tile.
            this.fire('tileerror', {
                error: err,
                tile: tile,
                coords: coords
            });
            var key = this._tileCoordsToKey(coords);
            tile = this._tiles[key];
            if (!tile) return;
            tile.loaded = +new Date();
            if (this._map._fadeAnimated) {
                setOpacity(tile.el, 0);
                cancelAnimFrame(this._fadeFrame);
                this._fadeFrame = requestAnimFrame(this._updateOpacity, this);
            } else {
                tile.active = true;
                this._pruneTiles();
            }
            if (!err) {
                addClass(tile.el, 'leaflet-tile-loaded');
                // @event tileload: TileEvent
                // Fired when a tile loads.
                this.fire('tileload', {
                    tile: tile.el,
                    coords: coords
                });
            }
            if (this._noTilesToLoad()) {
                this._loading = false;
                // @event load: Event
                // Fired when the grid layer loaded all visible tiles.
                this.fire('load');
                if (Browser.ielt9 || !this._map._fadeAnimated) requestAnimFrame(this._pruneTiles, this);
                else // Wait a bit more than 0.2 secs (the duration of the tile fade-in)
                // to trigger a pruning.
                setTimeout(bind(this._pruneTiles, this), 250);
            }
        },
        _getTilePos: function(coords) {
            return coords.scaleBy(this.getTileSize()).subtract(this._level.origin);
        },
        _wrapCoords: function(coords) {
            var newCoords = new Point(this._wrapX ? wrapNum(coords.x, this._wrapX) : coords.x, this._wrapY ? wrapNum(coords.y, this._wrapY) : coords.y);
            newCoords.z = coords.z;
            return newCoords;
        },
        _pxBoundsToTileRange: function(bounds) {
            var tileSize = this.getTileSize();
            return new Bounds(bounds.min.unscaleBy(tileSize).floor(), bounds.max.unscaleBy(tileSize).ceil().subtract([
                1,
                1
            ]));
        },
        _noTilesToLoad: function() {
            for(var key in this._tiles){
                if (!this._tiles[key].loaded) return false;
            }
            return true;
        }
    });
    // @factory L.gridLayer(options?: GridLayer options)
    // Creates a new instance of GridLayer with the supplied options.
    function gridLayer(options) {
        return new GridLayer(options);
    }
    /*
   * @class TileLayer
   * @inherits GridLayer
   * @aka L.TileLayer
   * Used to load and display tile layers on the map. Note that most tile servers require attribution, which you can set under `Layer`. Extends `GridLayer`.
   *
   * @example
   *
   * ```js
   * L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?{foo}', {foo: 'bar', attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'}).addTo(map);
   * ```
   *
   * @section URL template
   * @example
   *
   * A string of the following form:
   *
   * ```
   * 'https://{s}.somedomain.com/blabla/{z}/{x}/{y}{r}.png'
   * ```
   *
   * `{s}` means one of the available subdomains (used sequentially to help with browser parallel requests per domain limitation; subdomain values are specified in options; `a`, `b` or `c` by default, can be omitted), `{z}` — zoom level, `{x}` and `{y}` — tile coordinates. `{r}` can be used to add "&commat;2x" to the URL to load retina tiles.
   *
   * You can use custom keys in the template, which will be [evaluated](#util-template) from TileLayer options, like this:
   *
   * ```
   * L.tileLayer('https://{s}.somedomain.com/{foo}/{z}/{x}/{y}.png', {foo: 'bar'});
   * ```
   */ var TileLayer = GridLayer.extend({
        // @section
        // @aka TileLayer options
        options: {
            // @option minZoom: Number = 0
            // The minimum zoom level down to which this layer will be displayed (inclusive).
            minZoom: 0,
            // @option maxZoom: Number = 18
            // The maximum zoom level up to which this layer will be displayed (inclusive).
            maxZoom: 18,
            // @option subdomains: String|String[] = 'abc'
            // Subdomains of the tile service. Can be passed in the form of one string (where each letter is a subdomain name) or an array of strings.
            subdomains: 'abc',
            // @option errorTileUrl: String = ''
            // URL to the tile image to show in place of the tile that failed to load.
            errorTileUrl: '',
            // @option zoomOffset: Number = 0
            // The zoom number used in tile URLs will be offset with this value.
            zoomOffset: 0,
            // @option tms: Boolean = false
            // If `true`, inverses Y axis numbering for tiles (turn this on for [TMS](https://en.wikipedia.org/wiki/Tile_Map_Service) services).
            tms: false,
            // @option zoomReverse: Boolean = false
            // If set to true, the zoom number used in tile URLs will be reversed (`maxZoom - zoom` instead of `zoom`)
            zoomReverse: false,
            // @option detectRetina: Boolean = false
            // If `true` and user is on a retina display, it will request four tiles of half the specified size and a bigger zoom level in place of one to utilize the high resolution.
            detectRetina: false,
            // @option crossOrigin: Boolean|String = false
            // Whether the crossOrigin attribute will be added to the tiles.
            // If a String is provided, all tiles will have their crossOrigin attribute set to the String provided. This is needed if you want to access tile pixel data.
            // Refer to [CORS Settings](https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_settings_attributes) for valid String values.
            crossOrigin: false,
            // @option referrerPolicy: Boolean|String = false
            // Whether the referrerPolicy attribute will be added to the tiles.
            // If a String is provided, all tiles will have their referrerPolicy attribute set to the String provided.
            // This may be needed if your map's rendering context has a strict default but your tile provider expects a valid referrer
            // (e.g. to validate an API token).
            // Refer to [HTMLImageElement.referrerPolicy](https://developer.mozilla.org/en-US/docs/Web/API/HTMLImageElement/referrerPolicy) for valid String values.
            referrerPolicy: false
        },
        initialize: function(url, options) {
            this._url = url;
            options = setOptions(this, options);
            // detecting retina displays, adjusting tileSize and zoom levels
            if (options.detectRetina && Browser.retina && options.maxZoom > 0) {
                options.tileSize = Math.floor(options.tileSize / 2);
                if (!options.zoomReverse) {
                    options.zoomOffset++;
                    options.maxZoom = Math.max(options.minZoom, options.maxZoom - 1);
                } else {
                    options.zoomOffset--;
                    options.minZoom = Math.min(options.maxZoom, options.minZoom + 1);
                }
                options.minZoom = Math.max(0, options.minZoom);
            } else if (!options.zoomReverse) // make sure maxZoom is gte minZoom
            options.maxZoom = Math.max(options.minZoom, options.maxZoom);
            else // make sure minZoom is lte maxZoom
            options.minZoom = Math.min(options.maxZoom, options.minZoom);
            if (typeof options.subdomains === 'string') options.subdomains = options.subdomains.split('');
            this.on('tileunload', this._onTileRemove);
        },
        // @method setUrl(url: String, noRedraw?: Boolean): this
        // Updates the layer's URL template and redraws it (unless `noRedraw` is set to `true`).
        // If the URL does not change, the layer will not be redrawn unless
        // the noRedraw parameter is set to false.
        setUrl: function(url, noRedraw) {
            if (this._url === url && noRedraw === undefined) noRedraw = true;
            this._url = url;
            if (!noRedraw) this.redraw();
            return this;
        },
        // @method createTile(coords: Object, done?: Function): HTMLElement
        // Called only internally, overrides GridLayer's [`createTile()`](#gridlayer-createtile)
        // to return an `<img>` HTML element with the appropriate image URL given `coords`. The `done`
        // callback is called when the tile has been loaded.
        createTile: function(coords, done) {
            var tile = document.createElement('img');
            on(tile, 'load', bind(this._tileOnLoad, this, done, tile));
            on(tile, 'error', bind(this._tileOnError, this, done, tile));
            if (this.options.crossOrigin || this.options.crossOrigin === '') tile.crossOrigin = this.options.crossOrigin === true ? '' : this.options.crossOrigin;
            // for this new option we follow the documented behavior
            // more closely by only setting the property when string
            if (typeof this.options.referrerPolicy === 'string') tile.referrerPolicy = this.options.referrerPolicy;
            // The alt attribute is set to the empty string,
            // allowing screen readers to ignore the decorative image tiles.
            // https://www.w3.org/WAI/tutorials/images/decorative/
            // https://www.w3.org/TR/html-aria/#el-img-empty-alt
            tile.alt = '';
            tile.src = this.getTileUrl(coords);
            return tile;
        },
        // @section Extension methods
        // @uninheritable
        // Layers extending `TileLayer` might reimplement the following method.
        // @method getTileUrl(coords: Object): String
        // Called only internally, returns the URL for a tile given its coordinates.
        // Classes extending `TileLayer` can override this function to provide custom tile URL naming schemes.
        getTileUrl: function(coords) {
            var data = {
                r: Browser.retina ? '@2x' : '',
                s: this._getSubdomain(coords),
                x: coords.x,
                y: coords.y,
                z: this._getZoomForUrl()
            };
            if (this._map && !this._map.options.crs.infinite) {
                var invertedY = this._globalTileRange.max.y - coords.y;
                if (this.options.tms) data['y'] = invertedY;
                data['-y'] = invertedY;
            }
            return template(this._url, extend(data, this.options));
        },
        _tileOnLoad: function(done, tile) {
            // For https://github.com/Leaflet/Leaflet/issues/3332
            if (Browser.ielt9) setTimeout(bind(done, this, null, tile), 0);
            else done(null, tile);
        },
        _tileOnError: function(done, tile, e) {
            var errorUrl = this.options.errorTileUrl;
            if (errorUrl && tile.getAttribute('src') !== errorUrl) tile.src = errorUrl;
            done(e, tile);
        },
        _onTileRemove: function(e) {
            e.tile.onload = null;
        },
        _getZoomForUrl: function() {
            var zoom = this._tileZoom, maxZoom = this.options.maxZoom, zoomReverse = this.options.zoomReverse, zoomOffset = this.options.zoomOffset;
            if (zoomReverse) zoom = maxZoom - zoom;
            return zoom + zoomOffset;
        },
        _getSubdomain: function(tilePoint) {
            var index = Math.abs(tilePoint.x + tilePoint.y) % this.options.subdomains.length;
            return this.options.subdomains[index];
        },
        // stops loading all tiles in the background layer
        _abortLoading: function() {
            var i, tile;
            for(i in this._tiles)if (this._tiles[i].coords.z !== this._tileZoom) {
                tile = this._tiles[i].el;
                tile.onload = falseFn;
                tile.onerror = falseFn;
                if (!tile.complete) {
                    tile.src = emptyImageUrl;
                    var coords = this._tiles[i].coords;
                    remove(tile);
                    delete this._tiles[i];
                    // @event tileabort: TileEvent
                    // Fired when a tile was loading but is now not wanted.
                    this.fire('tileabort', {
                        tile: tile,
                        coords: coords
                    });
                }
            }
        },
        _removeTile: function(key) {
            var tile = this._tiles[key];
            if (!tile) return;
            // Cancels any pending http requests associated with the tile
            tile.el.setAttribute('src', emptyImageUrl);
            return GridLayer.prototype._removeTile.call(this, key);
        },
        _tileReady: function(coords, err, tile) {
            if (!this._map || tile && tile.getAttribute('src') === emptyImageUrl) return;
            return GridLayer.prototype._tileReady.call(this, coords, err, tile);
        }
    });
    // @factory L.tilelayer(urlTemplate: String, options?: TileLayer options)
    // Instantiates a tile layer object given a `URL template` and optionally an options object.
    function tileLayer(url, options) {
        return new TileLayer(url, options);
    }
    /*
   * @class TileLayer.WMS
   * @inherits TileLayer
   * @aka L.TileLayer.WMS
   * Used to display [WMS](https://en.wikipedia.org/wiki/Web_Map_Service) services as tile layers on the map. Extends `TileLayer`.
   *
   * @example
   *
   * ```js
   * var nexrad = L.tileLayer.wms("http://mesonet.agron.iastate.edu/cgi-bin/wms/nexrad/n0r.cgi", {
   * 	layers: 'nexrad-n0r-900913',
   * 	format: 'image/png',
   * 	transparent: true,
   * 	attribution: "Weather data © 2012 IEM Nexrad"
   * });
   * ```
   */ var TileLayerWMS = TileLayer.extend({
        // @section
        // @aka TileLayer.WMS options
        // If any custom options not documented here are used, they will be sent to the
        // WMS server as extra parameters in each request URL. This can be useful for
        // [non-standard vendor WMS parameters](https://docs.geoserver.org/stable/en/user/services/wms/vendor.html).
        defaultWmsParams: {
            service: 'WMS',
            request: 'GetMap',
            // @option layers: String = ''
            // **(required)** Comma-separated list of WMS layers to show.
            layers: '',
            // @option styles: String = ''
            // Comma-separated list of WMS styles.
            styles: '',
            // @option format: String = 'image/jpeg'
            // WMS image format (use `'image/png'` for layers with transparency).
            format: 'image/jpeg',
            // @option transparent: Boolean = false
            // If `true`, the WMS service will return images with transparency.
            transparent: false,
            // @option version: String = '1.1.1'
            // Version of the WMS service to use
            version: '1.1.1'
        },
        options: {
            // @option crs: CRS = null
            // Coordinate Reference System to use for the WMS requests, defaults to
            // map CRS. Don't change this if you're not sure what it means.
            crs: null,
            // @option uppercase: Boolean = false
            // If `true`, WMS request parameter keys will be uppercase.
            uppercase: false
        },
        initialize: function(url, options) {
            this._url = url;
            var wmsParams = extend({}, this.defaultWmsParams);
            // all keys that are not TileLayer options go to WMS params
            for(var i in options)if (!(i in this.options)) wmsParams[i] = options[i];
            options = setOptions(this, options);
            var realRetina = options.detectRetina && Browser.retina ? 2 : 1;
            var tileSize = this.getTileSize();
            wmsParams.width = tileSize.x * realRetina;
            wmsParams.height = tileSize.y * realRetina;
            this.wmsParams = wmsParams;
        },
        onAdd: function(map) {
            this._crs = this.options.crs || map.options.crs;
            this._wmsVersion = parseFloat(this.wmsParams.version);
            var projectionKey = this._wmsVersion >= 1.3 ? 'crs' : 'srs';
            this.wmsParams[projectionKey] = this._crs.code;
            TileLayer.prototype.onAdd.call(this, map);
        },
        getTileUrl: function(coords) {
            var tileBounds = this._tileCoordsToNwSe(coords), crs = this._crs, bounds = toBounds(crs.project(tileBounds[0]), crs.project(tileBounds[1])), min = bounds.min, max = bounds.max, bbox = (this._wmsVersion >= 1.3 && this._crs === EPSG4326 ? [
                min.y,
                min.x,
                max.y,
                max.x
            ] : [
                min.x,
                min.y,
                max.x,
                max.y
            ]).join(','), url = TileLayer.prototype.getTileUrl.call(this, coords);
            return url + getParamString(this.wmsParams, url, this.options.uppercase) + (this.options.uppercase ? '&BBOX=' : '&bbox=') + bbox;
        },
        // @method setParams(params: Object, noRedraw?: Boolean): this
        // Merges an object with the new parameters and re-requests tiles on the current screen (unless `noRedraw` was set to true).
        setParams: function(params, noRedraw) {
            extend(this.wmsParams, params);
            if (!noRedraw) this.redraw();
            return this;
        }
    });
    // @factory L.tileLayer.wms(baseUrl: String, options: TileLayer.WMS options)
    // Instantiates a WMS tile layer object given a base URL of the WMS service and a WMS parameters/options object.
    function tileLayerWMS(url, options) {
        return new TileLayerWMS(url, options);
    }
    TileLayer.WMS = TileLayerWMS;
    tileLayer.wms = tileLayerWMS;
    /*
   * @class Renderer
   * @inherits Layer
   * @aka L.Renderer
   *
   * Base class for vector renderer implementations (`SVG`, `Canvas`). Handles the
   * DOM container of the renderer, its bounds, and its zoom animation.
   *
   * A `Renderer` works as an implicit layer group for all `Path`s - the renderer
   * itself can be added or removed to the map. All paths use a renderer, which can
   * be implicit (the map will decide the type of renderer and use it automatically)
   * or explicit (using the [`renderer`](#path-renderer) option of the path).
   *
   * Do not use this class directly, use `SVG` and `Canvas` instead.
   *
   * @event update: Event
   * Fired when the renderer updates its bounds, center and zoom, for example when
   * its map has moved
   */ var Renderer = Layer.extend({
        // @section
        // @aka Renderer options
        options: {
            // @option padding: Number = 0.1
            // How much to extend the clip area around the map view (relative to its size)
            // e.g. 0.1 would be 10% of map view in each direction
            padding: 0.1
        },
        initialize: function(options) {
            setOptions(this, options);
            stamp(this);
            this._layers = this._layers || {};
        },
        onAdd: function() {
            if (!this._container) {
                this._initContainer(); // defined by renderer implementations
                // always keep transform-origin as 0 0
                addClass(this._container, 'leaflet-zoom-animated');
            }
            this.getPane().appendChild(this._container);
            this._update();
            this.on('update', this._updatePaths, this);
        },
        onRemove: function() {
            this.off('update', this._updatePaths, this);
            this._destroyContainer();
        },
        getEvents: function() {
            var events = {
                viewreset: this._reset,
                zoom: this._onZoom,
                moveend: this._update,
                zoomend: this._onZoomEnd
            };
            if (this._zoomAnimated) events.zoomanim = this._onAnimZoom;
            return events;
        },
        _onAnimZoom: function(ev) {
            this._updateTransform(ev.center, ev.zoom);
        },
        _onZoom: function() {
            this._updateTransform(this._map.getCenter(), this._map.getZoom());
        },
        _updateTransform: function(center, zoom) {
            var scale = this._map.getZoomScale(zoom, this._zoom), viewHalf = this._map.getSize().multiplyBy(0.5 + this.options.padding), currentCenterPoint = this._map.project(this._center, zoom), topLeftOffset = viewHalf.multiplyBy(-scale).add(currentCenterPoint).subtract(this._map._getNewPixelOrigin(center, zoom));
            if (Browser.any3d) setTransform(this._container, topLeftOffset, scale);
            else setPosition(this._container, topLeftOffset);
        },
        _reset: function() {
            this._update();
            this._updateTransform(this._center, this._zoom);
            for(var id in this._layers)this._layers[id]._reset();
        },
        _onZoomEnd: function() {
            for(var id in this._layers)this._layers[id]._project();
        },
        _updatePaths: function() {
            for(var id in this._layers)this._layers[id]._update();
        },
        _update: function() {
            // Update pixel bounds of renderer container (for positioning/sizing/clipping later)
            // Subclasses are responsible of firing the 'update' event.
            var p = this.options.padding, size = this._map.getSize(), min = this._map.containerPointToLayerPoint(size.multiplyBy(-p)).round();
            this._bounds = new Bounds(min, min.add(size.multiplyBy(1 + p * 2)).round());
            this._center = this._map.getCenter();
            this._zoom = this._map.getZoom();
        }
    });
    /*
   * @class Canvas
   * @inherits Renderer
   * @aka L.Canvas
   *
   * Allows vector layers to be displayed with [`<canvas>`](https://developer.mozilla.org/docs/Web/API/Canvas_API).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/canvas), Canvas is not
   * available in all web browsers, notably IE8, and overlapping geometries might
   * not display properly in some edge cases.
   *
   * @example
   *
   * Use Canvas by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.canvas()
   * });
   * ```
   *
   * Use a Canvas renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.canvas({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var Canvas = Renderer.extend({
        // @section
        // @aka Canvas options
        options: {
            // @option tolerance: Number = 0
            // How much to extend the click tolerance around a path/object on the map.
            tolerance: 0
        },
        getEvents: function() {
            var events = Renderer.prototype.getEvents.call(this);
            events.viewprereset = this._onViewPreReset;
            return events;
        },
        _onViewPreReset: function() {
            // Set a flag so that a viewprereset+moveend+viewreset only updates&redraws once
            this._postponeUpdatePaths = true;
        },
        onAdd: function() {
            Renderer.prototype.onAdd.call(this);
            // Redraw vectors since canvas is cleared upon removal,
            // in case of removing the renderer itself from the map.
            this._draw();
        },
        _initContainer: function() {
            var container = this._container = document.createElement('canvas');
            on(container, 'mousemove', this._onMouseMove, this);
            on(container, 'click dblclick mousedown mouseup contextmenu', this._onClick, this);
            on(container, 'mouseout', this._handleMouseOut, this);
            container['_leaflet_disable_events'] = true;
            this._ctx = container.getContext('2d');
        },
        _destroyContainer: function() {
            cancelAnimFrame(this._redrawRequest);
            delete this._ctx;
            remove(this._container);
            off(this._container);
            delete this._container;
        },
        _updatePaths: function() {
            if (this._postponeUpdatePaths) return;
            var layer;
            this._redrawBounds = null;
            for(var id in this._layers){
                layer = this._layers[id];
                layer._update();
            }
            this._redraw();
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, container = this._container, size = b.getSize(), m = Browser.retina ? 2 : 1;
            setPosition(container, b.min);
            // set canvas size (also clearing it); use double size on retina
            container.width = m * size.x;
            container.height = m * size.y;
            container.style.width = size.x + 'px';
            container.style.height = size.y + 'px';
            if (Browser.retina) this._ctx.scale(2, 2);
            // translate so we use the same path coordinates after canvas element moves
            this._ctx.translate(-b.min.x, -b.min.y);
            // Tell paths to redraw themselves
            this.fire('update');
        },
        _reset: function() {
            Renderer.prototype._reset.call(this);
            if (this._postponeUpdatePaths) {
                this._postponeUpdatePaths = false;
                this._updatePaths();
            }
        },
        _initPath: function(layer) {
            this._updateDashArray(layer);
            this._layers[stamp(layer)] = layer;
            var order = layer._order = {
                layer: layer,
                prev: this._drawLast,
                next: null
            };
            if (this._drawLast) this._drawLast.next = order;
            this._drawLast = order;
            this._drawFirst = this._drawFirst || this._drawLast;
        },
        _addPath: function(layer) {
            this._requestRedraw(layer);
        },
        _removePath: function(layer) {
            var order = layer._order;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else this._drawLast = prev;
            if (prev) prev.next = next;
            else this._drawFirst = next;
            delete layer._order;
            delete this._layers[stamp(layer)];
            this._requestRedraw(layer);
        },
        _updatePath: function(layer) {
            // Redraw the union of the layer's old pixel
            // bounds and the new pixel bounds.
            this._extendRedrawBounds(layer);
            layer._project();
            layer._update();
            // The redraw will extend the redraw bounds
            // with the new pixel bounds.
            this._requestRedraw(layer);
        },
        _updateStyle: function(layer) {
            this._updateDashArray(layer);
            this._requestRedraw(layer);
        },
        _updateDashArray: function(layer) {
            if (typeof layer.options.dashArray === 'string') {
                var parts = layer.options.dashArray.split(/[, ]+/), dashArray = [], dashValue, i;
                for(i = 0; i < parts.length; i++){
                    dashValue = Number(parts[i]);
                    // Ignore dash array containing invalid lengths
                    if (isNaN(dashValue)) return;
                    dashArray.push(dashValue);
                }
                layer.options._dashArray = dashArray;
            } else layer.options._dashArray = layer.options.dashArray;
        },
        _requestRedraw: function(layer) {
            if (!this._map) return;
            this._extendRedrawBounds(layer);
            this._redrawRequest = this._redrawRequest || requestAnimFrame(this._redraw, this);
        },
        _extendRedrawBounds: function(layer) {
            if (layer._pxBounds) {
                var padding = (layer.options.weight || 0) + 1;
                this._redrawBounds = this._redrawBounds || new Bounds();
                this._redrawBounds.extend(layer._pxBounds.min.subtract([
                    padding,
                    padding
                ]));
                this._redrawBounds.extend(layer._pxBounds.max.add([
                    padding,
                    padding
                ]));
            }
        },
        _redraw: function() {
            this._redrawRequest = null;
            if (this._redrawBounds) {
                this._redrawBounds.min._floor();
                this._redrawBounds.max._ceil();
            }
            this._clear(); // clear layers in redraw bounds
            this._draw(); // draw layers
            this._redrawBounds = null;
        },
        _clear: function() {
            var bounds = this._redrawBounds;
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.clearRect(bounds.min.x, bounds.min.y, size.x, size.y);
            } else {
                this._ctx.save();
                this._ctx.setTransform(1, 0, 0, 1, 0, 0);
                this._ctx.clearRect(0, 0, this._container.width, this._container.height);
                this._ctx.restore();
            }
        },
        _draw: function() {
            var layer, bounds = this._redrawBounds;
            this._ctx.save();
            if (bounds) {
                var size = bounds.getSize();
                this._ctx.beginPath();
                this._ctx.rect(bounds.min.x, bounds.min.y, size.x, size.y);
                this._ctx.clip();
            }
            this._drawing = true;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (!bounds || layer._pxBounds && layer._pxBounds.intersects(bounds)) layer._updatePath();
            }
            this._drawing = false;
            this._ctx.restore(); // Restore state before clipping.
        },
        _updatePoly: function(layer, closed) {
            if (!this._drawing) return;
            var i, j, len2, p, parts = layer._parts, len = parts.length, ctx = this._ctx;
            if (!len) return;
            ctx.beginPath();
            for(i = 0; i < len; i++){
                for(j = 0, len2 = parts[i].length; j < len2; j++){
                    p = parts[i][j];
                    ctx[j ? 'lineTo' : 'moveTo'](p.x, p.y);
                }
                if (closed) ctx.closePath();
            }
            this._fillStroke(ctx, layer);
        // TODO optimization: 1 fill/stroke for all features with equal style instead of 1 for each feature
        },
        _updateCircle: function(layer) {
            if (!this._drawing || layer._empty()) return;
            var p = layer._point, ctx = this._ctx, r = Math.max(Math.round(layer._radius), 1), s = (Math.max(Math.round(layer._radiusY), 1) || r) / r;
            if (s !== 1) {
                ctx.save();
                ctx.scale(1, s);
            }
            ctx.beginPath();
            ctx.arc(p.x, p.y / s, r, 0, Math.PI * 2, false);
            if (s !== 1) ctx.restore();
            this._fillStroke(ctx, layer);
        },
        _fillStroke: function(ctx, layer) {
            var options = layer.options;
            if (options.fill) {
                ctx.globalAlpha = options.fillOpacity;
                ctx.fillStyle = options.fillColor || options.color;
                ctx.fill(options.fillRule || 'evenodd');
            }
            if (options.stroke && options.weight !== 0) {
                if (ctx.setLineDash) ctx.setLineDash(layer.options && layer.options._dashArray || []);
                ctx.globalAlpha = options.opacity;
                ctx.lineWidth = options.weight;
                ctx.strokeStyle = options.color;
                ctx.lineCap = options.lineCap;
                ctx.lineJoin = options.lineJoin;
                ctx.stroke();
            }
        },
        // Canvas obviously doesn't have mouse events for individual drawn objects,
        // so we emulate that by calculating what's under the mouse on mousemove/click manually
        _onClick: function(e) {
            var point = this._map.mouseEventToLayerPoint(e), layer, clickedLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) {
                    if (!(e.type === 'click' || e.type === 'preclick') || !this._map._draggableMoved(layer)) clickedLayer = layer;
                }
            }
            this._fireEvent(clickedLayer ? [
                clickedLayer
            ] : false, e);
        },
        _onMouseMove: function(e) {
            if (!this._map || this._map.dragging.moving() || this._map._animatingZoom) return;
            var point = this._map.mouseEventToLayerPoint(e);
            this._handleMouseHover(e, point);
        },
        _handleMouseOut: function(e) {
            var layer = this._hoveredLayer;
            if (layer) {
                // if we're leaving the layer, fire mouseout
                removeClass(this._container, 'leaflet-interactive');
                this._fireEvent([
                    layer
                ], e, 'mouseout');
                this._hoveredLayer = null;
                this._mouseHoverThrottled = false;
            }
        },
        _handleMouseHover: function(e, point) {
            if (this._mouseHoverThrottled) return;
            var layer, candidateHoveredLayer;
            for(var order = this._drawFirst; order; order = order.next){
                layer = order.layer;
                if (layer.options.interactive && layer._containsPoint(point)) candidateHoveredLayer = layer;
            }
            if (candidateHoveredLayer !== this._hoveredLayer) {
                this._handleMouseOut(e);
                if (candidateHoveredLayer) {
                    addClass(this._container, 'leaflet-interactive'); // change cursor
                    this._fireEvent([
                        candidateHoveredLayer
                    ], e, 'mouseover');
                    this._hoveredLayer = candidateHoveredLayer;
                }
            }
            this._fireEvent(this._hoveredLayer ? [
                this._hoveredLayer
            ] : false, e);
            this._mouseHoverThrottled = true;
            setTimeout(bind(function() {
                this._mouseHoverThrottled = false;
            }, this), 32);
        },
        _fireEvent: function(layers, e, type) {
            this._map._fireDOMEvent(e, type || e.type, layers);
        },
        _bringToFront: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (next) next.prev = prev;
            else // Already last
            return;
            if (prev) prev.next = next;
            else if (next) // Update first entry unless this is the
            // single entry
            this._drawFirst = next;
            order.prev = this._drawLast;
            this._drawLast.next = order;
            order.next = null;
            this._drawLast = order;
            this._requestRedraw(layer);
        },
        _bringToBack: function(layer) {
            var order = layer._order;
            if (!order) return;
            var next = order.next;
            var prev = order.prev;
            if (prev) prev.next = next;
            else // Already first
            return;
            if (next) next.prev = prev;
            else if (prev) // Update last entry unless this is the
            // single entry
            this._drawLast = prev;
            order.prev = null;
            order.next = this._drawFirst;
            this._drawFirst.prev = order;
            this._drawFirst = order;
            this._requestRedraw(layer);
        }
    });
    // @factory L.canvas(options?: Renderer options)
    // Creates a Canvas renderer with the given options.
    function canvas(options) {
        return Browser.canvas ? new Canvas(options) : null;
    }
    /*
   * Thanks to Dmitry Baranovsky and his Raphael library for inspiration!
   */ var vmlCreate = function() {
        try {
            document.namespaces.add('lvml', 'urn:schemas-microsoft-com:vml');
            return function(name) {
                return document.createElement('<lvml:' + name + ' class="lvml">');
            };
        } catch (e) {
        // Do not return fn from catch block so `e` can be garbage collected
        // See https://github.com/Leaflet/Leaflet/pull/7279
        }
        return function(name) {
            return document.createElement('<' + name + ' xmlns="urn:schemas-microsoft.com:vml" class="lvml">');
        };
    }();
    /*
   * @class SVG
   *
   *
   * VML was deprecated in 2012, which means VML functionality exists only for backwards compatibility
   * with old versions of Internet Explorer.
   */ // mixin to redefine some SVG methods to handle VML syntax which is similar but with some differences
    var vmlMixin = {
        _initContainer: function() {
            this._container = create$1('div', 'leaflet-vml-container');
        },
        _update: function() {
            if (this._map._animatingZoom) return;
            Renderer.prototype._update.call(this);
            this.fire('update');
        },
        _initPath: function(layer) {
            var container = layer._container = vmlCreate('shape');
            addClass(container, 'leaflet-vml-shape ' + (this.options.className || ''));
            container.coordsize = '1 1';
            layer._path = vmlCreate('path');
            container.appendChild(layer._path);
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            var container = layer._container;
            this._container.appendChild(container);
            if (layer.options.interactive) layer.addInteractiveTarget(container);
        },
        _removePath: function(layer) {
            var container = layer._container;
            remove(container);
            layer.removeInteractiveTarget(container);
            delete this._layers[stamp(layer)];
        },
        _updateStyle: function(layer) {
            var stroke = layer._stroke, fill = layer._fill, options = layer.options, container = layer._container;
            container.stroked = !!options.stroke;
            container.filled = !!options.fill;
            if (options.stroke) {
                if (!stroke) stroke = layer._stroke = vmlCreate('stroke');
                container.appendChild(stroke);
                stroke.weight = options.weight + 'px';
                stroke.color = options.color;
                stroke.opacity = options.opacity;
                if (options.dashArray) stroke.dashStyle = isArray(options.dashArray) ? options.dashArray.join(' ') : options.dashArray.replace(/( *, *)/g, ' ');
                else stroke.dashStyle = '';
                stroke.endcap = options.lineCap.replace('butt', 'flat');
                stroke.joinstyle = options.lineJoin;
            } else if (stroke) {
                container.removeChild(stroke);
                layer._stroke = null;
            }
            if (options.fill) {
                if (!fill) fill = layer._fill = vmlCreate('fill');
                container.appendChild(fill);
                fill.color = options.fillColor || options.color;
                fill.opacity = options.fillOpacity;
            } else if (fill) {
                container.removeChild(fill);
                layer._fill = null;
            }
        },
        _updateCircle: function(layer) {
            var p = layer._point.round(), r = Math.round(layer._radius), r2 = Math.round(layer._radiusY || r);
            this._setPath(layer, layer._empty() ? 'M0 0' : 'AL ' + p.x + ',' + p.y + ' ' + r + ',' + r2 + ' 0,' + 23592600);
        },
        _setPath: function(layer, path) {
            layer._path.v = path;
        },
        _bringToFront: function(layer) {
            toFront(layer._container);
        },
        _bringToBack: function(layer) {
            toBack(layer._container);
        }
    };
    var create = Browser.vml ? vmlCreate : svgCreate;
    /*
   * @class SVG
   * @inherits Renderer
   * @aka L.SVG
   *
   * Allows vector layers to be displayed with [SVG](https://developer.mozilla.org/docs/Web/SVG).
   * Inherits `Renderer`.
   *
   * Due to [technical limitations](https://caniuse.com/svg), SVG is not
   * available in all web browsers, notably Android 2.x and 3.x.
   *
   * Although SVG is not available on IE7 and IE8, these browsers support
   * [VML](https://en.wikipedia.org/wiki/Vector_Markup_Language)
   * (a now deprecated technology), and the SVG renderer will fall back to VML in
   * this case.
   *
   * @example
   *
   * Use SVG by default for all paths in the map:
   *
   * ```js
   * var map = L.map('map', {
   * 	renderer: L.svg()
   * });
   * ```
   *
   * Use a SVG renderer with extra padding for specific vector geometries:
   *
   * ```js
   * var map = L.map('map');
   * var myRenderer = L.svg({ padding: 0.5 });
   * var line = L.polyline( coordinates, { renderer: myRenderer } );
   * var circle = L.circle( center, { renderer: myRenderer } );
   * ```
   */ var SVG = Renderer.extend({
        _initContainer: function() {
            this._container = create('svg');
            // makes it possible to click through svg root; we'll reset it back in individual paths
            this._container.setAttribute('pointer-events', 'none');
            this._rootGroup = create('g');
            this._container.appendChild(this._rootGroup);
        },
        _destroyContainer: function() {
            remove(this._container);
            off(this._container);
            delete this._container;
            delete this._rootGroup;
            delete this._svgSize;
        },
        _update: function() {
            if (this._map._animatingZoom && this._bounds) return;
            Renderer.prototype._update.call(this);
            var b = this._bounds, size = b.getSize(), container = this._container;
            // set size of svg-container if changed
            if (!this._svgSize || !this._svgSize.equals(size)) {
                this._svgSize = size;
                container.setAttribute('width', size.x);
                container.setAttribute('height', size.y);
            }
            // movement: update container viewBox so that we don't have to change coordinates of individual layers
            setPosition(container, b.min);
            container.setAttribute('viewBox', [
                b.min.x,
                b.min.y,
                size.x,
                size.y
            ].join(' '));
            this.fire('update');
        },
        // methods below are called by vector layers implementations
        _initPath: function(layer) {
            var path = layer._path = create('path');
            // @namespace Path
            // @option className: String = null
            // Custom class name set on an element. Only for SVG renderer.
            if (layer.options.className) addClass(path, layer.options.className);
            if (layer.options.interactive) addClass(path, 'leaflet-interactive');
            this._updateStyle(layer);
            this._layers[stamp(layer)] = layer;
        },
        _addPath: function(layer) {
            if (!this._rootGroup) this._initContainer();
            this._rootGroup.appendChild(layer._path);
            layer.addInteractiveTarget(layer._path);
        },
        _removePath: function(layer) {
            remove(layer._path);
            layer.removeInteractiveTarget(layer._path);
            delete this._layers[stamp(layer)];
        },
        _updatePath: function(layer) {
            layer._project();
            layer._update();
        },
        _updateStyle: function(layer) {
            var path = layer._path, options = layer.options;
            if (!path) return;
            if (options.stroke) {
                path.setAttribute('stroke', options.color);
                path.setAttribute('stroke-opacity', options.opacity);
                path.setAttribute('stroke-width', options.weight);
                path.setAttribute('stroke-linecap', options.lineCap);
                path.setAttribute('stroke-linejoin', options.lineJoin);
                if (options.dashArray) path.setAttribute('stroke-dasharray', options.dashArray);
                else path.removeAttribute('stroke-dasharray');
                if (options.dashOffset) path.setAttribute('stroke-dashoffset', options.dashOffset);
                else path.removeAttribute('stroke-dashoffset');
            } else path.setAttribute('stroke', 'none');
            if (options.fill) {
                path.setAttribute('fill', options.fillColor || options.color);
                path.setAttribute('fill-opacity', options.fillOpacity);
                path.setAttribute('fill-rule', options.fillRule || 'evenodd');
            } else path.setAttribute('fill', 'none');
        },
        _updatePoly: function(layer, closed) {
            this._setPath(layer, pointsToPath(layer._parts, closed));
        },
        _updateCircle: function(layer) {
            var p = layer._point, r = Math.max(Math.round(layer._radius), 1), r2 = Math.max(Math.round(layer._radiusY), 1) || r, arc = 'a' + r + ',' + r2 + ' 0 1,0 ';
            // drawing a circle with two half-arcs
            var d = layer._empty() ? 'M0 0' : 'M' + (p.x - r) + ',' + p.y + arc + r * 2 + ',0 ' + arc + -r * 2 + ',0 ';
            this._setPath(layer, d);
        },
        _setPath: function(layer, path) {
            layer._path.setAttribute('d', path);
        },
        // SVG does not have the concept of zIndex so we resort to changing the DOM order of elements
        _bringToFront: function(layer) {
            toFront(layer._path);
        },
        _bringToBack: function(layer) {
            toBack(layer._path);
        }
    });
    if (Browser.vml) SVG.include(vmlMixin);
    // @namespace SVG
    // @factory L.svg(options?: Renderer options)
    // Creates a SVG renderer with the given options.
    function svg(options) {
        return Browser.svg || Browser.vml ? new SVG(options) : null;
    }
    Map.include({
        // @namespace Map; @method getRenderer(layer: Path): Renderer
        // Returns the instance of `Renderer` that should be used to render the given
        // `Path`. It will ensure that the `renderer` options of the map and paths
        // are respected, and that the renderers do exist on the map.
        getRenderer: function(layer) {
            // @namespace Path; @option renderer: Renderer
            // Use this specific instance of `Renderer` for this path. Takes
            // precedence over the map's [default renderer](#map-renderer).
            var renderer = layer.options.renderer || this._getPaneRenderer(layer.options.pane) || this.options.renderer || this._renderer;
            if (!renderer) renderer = this._renderer = this._createRenderer();
            if (!this.hasLayer(renderer)) this.addLayer(renderer);
            return renderer;
        },
        _getPaneRenderer: function(name) {
            if (name === 'overlayPane' || name === undefined) return false;
            var renderer = this._paneRenderers[name];
            if (renderer === undefined) {
                renderer = this._createRenderer({
                    pane: name
                });
                this._paneRenderers[name] = renderer;
            }
            return renderer;
        },
        _createRenderer: function(options) {
            // @namespace Map; @option preferCanvas: Boolean = false
            // Whether `Path`s should be rendered on a `Canvas` renderer.
            // By default, all `Path`s are rendered in a `SVG` renderer.
            return this.options.preferCanvas && canvas(options) || svg(options);
        }
    });
    /*
   * L.Rectangle extends Polygon and creates a rectangle when passed a LatLngBounds object.
   */ /*
   * @class Rectangle
   * @aka L.Rectangle
   * @inherits Polygon
   *
   * A class for drawing rectangle overlays on a map. Extends `Polygon`.
   *
   * @example
   *
   * ```js
   * // define rectangle geographical bounds
   * var bounds = [[54.559322, -5.767822], [56.1210604, -3.021240]];
   *
   * // create an orange rectangle
   * L.rectangle(bounds, {color: "#ff7800", weight: 1}).addTo(map);
   *
   * // zoom the map to the rectangle bounds
   * map.fitBounds(bounds);
   * ```
   *
   */ var Rectangle = Polygon.extend({
        initialize: function(latLngBounds, options) {
            Polygon.prototype.initialize.call(this, this._boundsToLatLngs(latLngBounds), options);
        },
        // @method setBounds(latLngBounds: LatLngBounds): this
        // Redraws the rectangle with the passed bounds.
        setBounds: function(latLngBounds) {
            return this.setLatLngs(this._boundsToLatLngs(latLngBounds));
        },
        _boundsToLatLngs: function(latLngBounds) {
            latLngBounds = toLatLngBounds(latLngBounds);
            return [
                latLngBounds.getSouthWest(),
                latLngBounds.getNorthWest(),
                latLngBounds.getNorthEast(),
                latLngBounds.getSouthEast()
            ];
        }
    });
    // @factory L.rectangle(latLngBounds: LatLngBounds, options?: Polyline options)
    function rectangle(latLngBounds, options) {
        return new Rectangle(latLngBounds, options);
    }
    SVG.create = create;
    SVG.pointsToPath = pointsToPath;
    GeoJSON.geometryToLayer = geometryToLayer;
    GeoJSON.coordsToLatLng = coordsToLatLng;
    GeoJSON.coordsToLatLngs = coordsToLatLngs;
    GeoJSON.latLngToCoords = latLngToCoords;
    GeoJSON.latLngsToCoords = latLngsToCoords;
    GeoJSON.getFeature = getFeature;
    GeoJSON.asFeature = asFeature;
    /*
   * L.Handler.BoxZoom is used to add shift-drag zoom interaction to the map
   * (zoom to a selected bounding box), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option boxZoom: Boolean = true
        // Whether the map can be zoomed to a rectangular area specified by
        // dragging the mouse while pressing the shift key.
        boxZoom: true
    });
    var BoxZoom = Handler.extend({
        initialize: function(map) {
            this._map = map;
            this._container = map._container;
            this._pane = map._panes.overlayPane;
            this._resetStateTimeout = 0;
            map.on('unload', this._destroy, this);
        },
        addHooks: function() {
            on(this._container, 'mousedown', this._onMouseDown, this);
        },
        removeHooks: function() {
            off(this._container, 'mousedown', this._onMouseDown, this);
        },
        moved: function() {
            return this._moved;
        },
        _destroy: function() {
            remove(this._pane);
            delete this._pane;
        },
        _resetState: function() {
            this._resetStateTimeout = 0;
            this._moved = false;
        },
        _clearDeferredResetState: function() {
            if (this._resetStateTimeout !== 0) {
                clearTimeout(this._resetStateTimeout);
                this._resetStateTimeout = 0;
            }
        },
        _onMouseDown: function(e) {
            if (!e.shiftKey || e.which !== 1 && e.button !== 1) return false;
            // Clear the deferred resetState if it hasn't executed yet, otherwise it
            // will interrupt the interaction and orphan a box element in the container.
            this._clearDeferredResetState();
            this._resetState();
            disableTextSelection();
            disableImageDrag();
            this._startPoint = this._map.mouseEventToContainerPoint(e);
            on(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseMove: function(e) {
            if (!this._moved) {
                this._moved = true;
                this._box = create$1('div', 'leaflet-zoom-box', this._container);
                addClass(this._container, 'leaflet-crosshair');
                this._map.fire('boxzoomstart');
            }
            this._point = this._map.mouseEventToContainerPoint(e);
            var bounds = new Bounds(this._point, this._startPoint), size = bounds.getSize();
            setPosition(this._box, bounds.min);
            this._box.style.width = size.x + 'px';
            this._box.style.height = size.y + 'px';
        },
        _finish: function() {
            if (this._moved) {
                remove(this._box);
                removeClass(this._container, 'leaflet-crosshair');
            }
            enableTextSelection();
            enableImageDrag();
            off(document, {
                contextmenu: stop,
                mousemove: this._onMouseMove,
                mouseup: this._onMouseUp,
                keydown: this._onKeyDown
            }, this);
        },
        _onMouseUp: function(e) {
            if (e.which !== 1 && e.button !== 1) return;
            this._finish();
            if (!this._moved) return;
            // Postpone to next JS tick so internal click event handling
            // still see it as "moved".
            this._clearDeferredResetState();
            this._resetStateTimeout = setTimeout(bind(this._resetState, this), 0);
            var bounds = new LatLngBounds(this._map.containerPointToLatLng(this._startPoint), this._map.containerPointToLatLng(this._point));
            this._map.fitBounds(bounds).fire('boxzoomend', {
                boxZoomBounds: bounds
            });
        },
        _onKeyDown: function(e) {
            if (e.keyCode === 27) {
                this._finish();
                this._clearDeferredResetState();
                this._resetState();
            }
        }
    });
    // @section Handlers
    // @property boxZoom: Handler
    // Box (shift-drag with mouse) zoom handler.
    Map.addInitHook('addHandler', 'boxZoom', BoxZoom);
    /*
   * L.Handler.DoubleClickZoom is used to handle double-click zoom on the map, enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option doubleClickZoom: Boolean|String = true
        // Whether the map can be zoomed in by double clicking on it and
        // zoomed out by double clicking while holding shift. If passed
        // `'center'`, double-click zoom will zoom to the center of the
        //  view regardless of where the mouse was.
        doubleClickZoom: true
    });
    var DoubleClickZoom = Handler.extend({
        addHooks: function() {
            this._map.on('dblclick', this._onDoubleClick, this);
        },
        removeHooks: function() {
            this._map.off('dblclick', this._onDoubleClick, this);
        },
        _onDoubleClick: function(e) {
            var map = this._map, oldZoom = map.getZoom(), delta = map.options.zoomDelta, zoom = e.originalEvent.shiftKey ? oldZoom - delta : oldZoom + delta;
            if (map.options.doubleClickZoom === 'center') map.setZoom(zoom);
            else map.setZoomAround(e.containerPoint, zoom);
        }
    });
    // @section Handlers
    //
    // Map properties include interaction handlers that allow you to control
    // interaction behavior in runtime, enabling or disabling certain features such
    // as dragging or touch zoom (see `Handler` methods). For example:
    //
    // ```js
    // map.doubleClickZoom.disable();
    // ```
    //
    // @property doubleClickZoom: Handler
    // Double click zoom handler.
    Map.addInitHook('addHandler', 'doubleClickZoom', DoubleClickZoom);
    /*
   * L.Handler.MapDrag is used to make the map draggable (with panning inertia), enabled by default.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @option dragging: Boolean = true
        // Whether the map is draggable with mouse/touch or not.
        dragging: true,
        // @section Panning Inertia Options
        // @option inertia: Boolean = *
        // If enabled, panning of the map will have an inertia effect where
        // the map builds momentum while dragging and continues moving in
        // the same direction for some time. Feels especially nice on touch
        // devices. Enabled by default.
        inertia: true,
        // @option inertiaDeceleration: Number = 3000
        // The rate with which the inertial movement slows down, in pixels/second².
        inertiaDeceleration: 3400,
        // @option inertiaMaxSpeed: Number = Infinity
        // Max speed of the inertial movement, in pixels/second.
        inertiaMaxSpeed: Infinity,
        // @option easeLinearity: Number = 0.2
        easeLinearity: 0.2,
        // TODO refactor, move to CRS
        // @option worldCopyJump: Boolean = false
        // With this option enabled, the map tracks when you pan to another "copy"
        // of the world and seamlessly jumps to the original one so that all overlays
        // like markers and vector layers are still visible.
        worldCopyJump: false,
        // @option maxBoundsViscosity: Number = 0.0
        // If `maxBounds` is set, this option will control how solid the bounds
        // are when dragging the map around. The default value of `0.0` allows the
        // user to drag outside the bounds at normal speed, higher values will
        // slow down map dragging outside bounds, and `1.0` makes the bounds fully
        // solid, preventing the user from dragging outside the bounds.
        maxBoundsViscosity: 0.0
    });
    var Drag = Handler.extend({
        addHooks: function() {
            if (!this._draggable) {
                var map = this._map;
                this._draggable = new Draggable(map._mapPane, map._container);
                this._draggable.on({
                    dragstart: this._onDragStart,
                    drag: this._onDrag,
                    dragend: this._onDragEnd
                }, this);
                this._draggable.on('predrag', this._onPreDragLimit, this);
                if (map.options.worldCopyJump) {
                    this._draggable.on('predrag', this._onPreDragWrap, this);
                    map.on('zoomend', this._onZoomEnd, this);
                    map.whenReady(this._onZoomEnd, this);
                }
            }
            addClass(this._map._container, 'leaflet-grab leaflet-touch-drag');
            this._draggable.enable();
            this._positions = [];
            this._times = [];
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-grab');
            removeClass(this._map._container, 'leaflet-touch-drag');
            this._draggable.disable();
        },
        moved: function() {
            return this._draggable && this._draggable._moved;
        },
        moving: function() {
            return this._draggable && this._draggable._moving;
        },
        _onDragStart: function() {
            var map = this._map;
            map._stop();
            if (this._map.options.maxBounds && this._map.options.maxBoundsViscosity) {
                var bounds = toLatLngBounds(this._map.options.maxBounds);
                this._offsetLimit = toBounds(this._map.latLngToContainerPoint(bounds.getNorthWest()).multiplyBy(-1), this._map.latLngToContainerPoint(bounds.getSouthEast()).multiplyBy(-1).add(this._map.getSize()));
                this._viscosity = Math.min(1.0, Math.max(0.0, this._map.options.maxBoundsViscosity));
            } else this._offsetLimit = null;
            map.fire('movestart').fire('dragstart');
            if (map.options.inertia) {
                this._positions = [];
                this._times = [];
            }
        },
        _onDrag: function(e) {
            if (this._map.options.inertia) {
                var time = this._lastTime = +new Date(), pos = this._lastPos = this._draggable._absPos || this._draggable._newPos;
                this._positions.push(pos);
                this._times.push(time);
                this._prunePositions(time);
            }
            this._map.fire('move', e).fire('drag', e);
        },
        _prunePositions: function(time) {
            while(this._positions.length > 1 && time - this._times[0] > 50){
                this._positions.shift();
                this._times.shift();
            }
        },
        _onZoomEnd: function() {
            var pxCenter = this._map.getSize().divideBy(2), pxWorldCenter = this._map.latLngToLayerPoint([
                0,
                0
            ]);
            this._initialWorldOffset = pxWorldCenter.subtract(pxCenter).x;
            this._worldWidth = this._map.getPixelWorldBounds().getSize().x;
        },
        _viscousLimit: function(value, threshold) {
            return value - (value - threshold) * this._viscosity;
        },
        _onPreDragLimit: function() {
            if (!this._viscosity || !this._offsetLimit) return;
            var offset = this._draggable._newPos.subtract(this._draggable._startPos);
            var limit = this._offsetLimit;
            if (offset.x < limit.min.x) offset.x = this._viscousLimit(offset.x, limit.min.x);
            if (offset.y < limit.min.y) offset.y = this._viscousLimit(offset.y, limit.min.y);
            if (offset.x > limit.max.x) offset.x = this._viscousLimit(offset.x, limit.max.x);
            if (offset.y > limit.max.y) offset.y = this._viscousLimit(offset.y, limit.max.y);
            this._draggable._newPos = this._draggable._startPos.add(offset);
        },
        _onPreDragWrap: function() {
            // TODO refactor to be able to adjust map pane position after zoom
            var worldWidth = this._worldWidth, halfWidth = Math.round(worldWidth / 2), dx = this._initialWorldOffset, x = this._draggable._newPos.x, newX1 = (x - halfWidth + dx) % worldWidth + halfWidth - dx, newX2 = (x + halfWidth + dx) % worldWidth - halfWidth - dx, newX = Math.abs(newX1 + dx) < Math.abs(newX2 + dx) ? newX1 : newX2;
            this._draggable._absPos = this._draggable._newPos.clone();
            this._draggable._newPos.x = newX;
        },
        _onDragEnd: function(e) {
            var map = this._map, options = map.options, noInertia = !options.inertia || e.noInertia || this._times.length < 2;
            map.fire('dragend', e);
            if (noInertia) map.fire('moveend');
            else {
                this._prunePositions(+new Date());
                var direction = this._lastPos.subtract(this._positions[0]), duration = (this._lastTime - this._times[0]) / 1000, ease = options.easeLinearity, speedVector = direction.multiplyBy(ease / duration), speed = speedVector.distanceTo([
                    0,
                    0
                ]), limitedSpeed = Math.min(options.inertiaMaxSpeed, speed), limitedSpeedVector = speedVector.multiplyBy(limitedSpeed / speed), decelerationDuration = limitedSpeed / (options.inertiaDeceleration * ease), offset = limitedSpeedVector.multiplyBy(-decelerationDuration / 2).round();
                if (!offset.x && !offset.y) map.fire('moveend');
                else {
                    offset = map._limitOffset(offset, map.options.maxBounds);
                    requestAnimFrame(function() {
                        map.panBy(offset, {
                            duration: decelerationDuration,
                            easeLinearity: ease,
                            noMoveStart: true,
                            animate: true
                        });
                    });
                }
            }
        }
    });
    // @section Handlers
    // @property dragging: Handler
    // Map dragging handler (by both mouse and touch).
    Map.addInitHook('addHandler', 'dragging', Drag);
    /*
   * L.Map.Keyboard is handling keyboard interaction with the map, enabled by default.
   */ // @namespace Map
    // @section Keyboard Navigation Options
    Map.mergeOptions({
        // @option keyboard: Boolean = true
        // Makes the map focusable and allows users to navigate the map with keyboard
        // arrows and `+`/`-` keys.
        keyboard: true,
        // @option keyboardPanDelta: Number = 80
        // Amount of pixels to pan when pressing an arrow key.
        keyboardPanDelta: 80
    });
    var Keyboard = Handler.extend({
        keyCodes: {
            left: [
                37
            ],
            right: [
                39
            ],
            down: [
                40
            ],
            up: [
                38
            ],
            zoomIn: [
                187,
                107,
                61,
                171
            ],
            zoomOut: [
                189,
                109,
                54,
                173
            ]
        },
        initialize: function(map) {
            this._map = map;
            this._setPanDelta(map.options.keyboardPanDelta);
            this._setZoomDelta(map.options.zoomDelta);
        },
        addHooks: function() {
            var container = this._map._container;
            // make the container focusable by tabbing
            if (container.tabIndex <= 0) container.tabIndex = '0';
            on(container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.on({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        removeHooks: function() {
            this._removeHooks();
            off(this._map._container, {
                focus: this._onFocus,
                blur: this._onBlur,
                mousedown: this._onMouseDown
            }, this);
            this._map.off({
                focus: this._addHooks,
                blur: this._removeHooks
            }, this);
        },
        _onMouseDown: function() {
            if (this._focused) return;
            var body = document.body, docEl = document.documentElement, top = body.scrollTop || docEl.scrollTop, left = body.scrollLeft || docEl.scrollLeft;
            this._map._container.focus();
            window.scrollTo(left, top);
        },
        _onFocus: function() {
            this._focused = true;
            this._map.fire('focus');
        },
        _onBlur: function() {
            this._focused = false;
            this._map.fire('blur');
        },
        _setPanDelta: function(panDelta) {
            var keys = this._panKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.left.length; i < len; i++)keys[codes.left[i]] = [
                -1 * panDelta,
                0
            ];
            for(i = 0, len = codes.right.length; i < len; i++)keys[codes.right[i]] = [
                panDelta,
                0
            ];
            for(i = 0, len = codes.down.length; i < len; i++)keys[codes.down[i]] = [
                0,
                panDelta
            ];
            for(i = 0, len = codes.up.length; i < len; i++)keys[codes.up[i]] = [
                0,
                -1 * panDelta
            ];
        },
        _setZoomDelta: function(zoomDelta) {
            var keys = this._zoomKeys = {}, codes = this.keyCodes, i, len;
            for(i = 0, len = codes.zoomIn.length; i < len; i++)keys[codes.zoomIn[i]] = zoomDelta;
            for(i = 0, len = codes.zoomOut.length; i < len; i++)keys[codes.zoomOut[i]] = -zoomDelta;
        },
        _addHooks: function() {
            on(document, 'keydown', this._onKeyDown, this);
        },
        _removeHooks: function() {
            off(document, 'keydown', this._onKeyDown, this);
        },
        _onKeyDown: function(e) {
            if (e.altKey || e.ctrlKey || e.metaKey) return;
            var key = e.keyCode, map = this._map, offset;
            if (key in this._panKeys) {
                if (!map._panAnim || !map._panAnim._inProgress) {
                    offset = this._panKeys[key];
                    if (e.shiftKey) offset = toPoint(offset).multiplyBy(3);
                    if (map.options.maxBounds) offset = map._limitOffset(toPoint(offset), map.options.maxBounds);
                    if (map.options.worldCopyJump) {
                        var newLatLng = map.wrapLatLng(map.unproject(map.project(map.getCenter()).add(offset)));
                        map.panTo(newLatLng);
                    } else map.panBy(offset);
                }
            } else if (key in this._zoomKeys) map.setZoom(map.getZoom() + (e.shiftKey ? 3 : 1) * this._zoomKeys[key]);
            else if (key === 27 && map._popup && map._popup.options.closeOnEscapeKey) map.closePopup();
            else return;
            stop(e);
        }
    });
    // @section Handlers
    // @section Handlers
    // @property keyboard: Handler
    // Keyboard navigation handler.
    Map.addInitHook('addHandler', 'keyboard', Keyboard);
    /*
   * L.Handler.ScrollWheelZoom is used by L.Map to enable mouse scroll wheel zoom on the map.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Mouse wheel options
        // @option scrollWheelZoom: Boolean|String = true
        // Whether the map can be zoomed by using the mouse wheel. If passed `'center'`,
        // it will zoom to the center of the view regardless of where the mouse was.
        scrollWheelZoom: true,
        // @option wheelDebounceTime: Number = 40
        // Limits the rate at which a wheel can fire (in milliseconds). By default
        // user can't zoom via wheel more often than once per 40 ms.
        wheelDebounceTime: 40,
        // @option wheelPxPerZoomLevel: Number = 60
        // How many scroll pixels (as reported by [L.DomEvent.getWheelDelta](#domevent-getwheeldelta))
        // mean a change of one full zoom level. Smaller values will make wheel-zooming
        // faster (and vice versa).
        wheelPxPerZoomLevel: 60
    });
    var ScrollWheelZoom = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'wheel', this._onWheelScroll, this);
            this._delta = 0;
        },
        removeHooks: function() {
            off(this._map._container, 'wheel', this._onWheelScroll, this);
        },
        _onWheelScroll: function(e) {
            var delta = getWheelDelta(e);
            var debounce = this._map.options.wheelDebounceTime;
            this._delta += delta;
            this._lastMousePos = this._map.mouseEventToContainerPoint(e);
            if (!this._startTime) this._startTime = +new Date();
            var left = Math.max(debounce - (+new Date() - this._startTime), 0);
            clearTimeout(this._timer);
            this._timer = setTimeout(bind(this._performZoom, this), left);
            stop(e);
        },
        _performZoom: function() {
            var map = this._map, zoom = map.getZoom(), snap = this._map.options.zoomSnap || 0;
            map._stop(); // stop panning and fly animations if any
            // map the delta with a sigmoid function to -4..4 range leaning on -1..1
            var d2 = this._delta / (this._map.options.wheelPxPerZoomLevel * 4), d3 = 4 * Math.log(2 / (1 + Math.exp(-Math.abs(d2)))) / Math.LN2, d4 = snap ? Math.ceil(d3 / snap) * snap : d3, delta = map._limitZoom(zoom + (this._delta > 0 ? d4 : -d4)) - zoom;
            this._delta = 0;
            this._startTime = null;
            if (!delta) return;
            if (map.options.scrollWheelZoom === 'center') map.setZoom(zoom + delta);
            else map.setZoomAround(this._lastMousePos, zoom + delta);
        }
    });
    // @section Handlers
    // @property scrollWheelZoom: Handler
    // Scroll wheel zoom handler.
    Map.addInitHook('addHandler', 'scrollWheelZoom', ScrollWheelZoom);
    /*
   * L.Map.TapHold is used to simulate `contextmenu` event on long hold,
   * which otherwise is not fired by mobile Safari.
   */ var tapHoldDelay = 600;
    // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option tapHold: Boolean
        // Enables simulation of `contextmenu` event, default is `true` for mobile Safari.
        tapHold: Browser.touchNative && Browser.safari && Browser.mobile,
        // @option tapTolerance: Number = 15
        // The max number of pixels a user can shift his finger during touch
        // for it to be considered a valid tap.
        tapTolerance: 15
    });
    var TapHold = Handler.extend({
        addHooks: function() {
            on(this._map._container, 'touchstart', this._onDown, this);
        },
        removeHooks: function() {
            off(this._map._container, 'touchstart', this._onDown, this);
        },
        _onDown: function(e) {
            clearTimeout(this._holdTimeout);
            if (e.touches.length !== 1) return;
            var first = e.touches[0];
            this._startPos = this._newPos = new Point(first.clientX, first.clientY);
            this._holdTimeout = setTimeout(bind(function() {
                this._cancel();
                if (!this._isTapValid()) return;
                // prevent simulated mouse events https://w3c.github.io/touch-events/#mouse-events
                on(document, 'touchend', preventDefault);
                on(document, 'touchend touchcancel', this._cancelClickPrevent);
                this._simulateEvent('contextmenu', first);
            }, this), tapHoldDelay);
            on(document, 'touchend touchcancel contextmenu', this._cancel, this);
            on(document, 'touchmove', this._onMove, this);
        },
        _cancelClickPrevent: function cancelClickPrevent() {
            off(document, 'touchend', preventDefault);
            off(document, 'touchend touchcancel', cancelClickPrevent);
        },
        _cancel: function() {
            clearTimeout(this._holdTimeout);
            off(document, 'touchend touchcancel contextmenu', this._cancel, this);
            off(document, 'touchmove', this._onMove, this);
        },
        _onMove: function(e) {
            var first = e.touches[0];
            this._newPos = new Point(first.clientX, first.clientY);
        },
        _isTapValid: function() {
            return this._newPos.distanceTo(this._startPos) <= this._map.options.tapTolerance;
        },
        _simulateEvent: function(type, e) {
            var simulatedEvent = new MouseEvent(type, {
                bubbles: true,
                cancelable: true,
                view: window,
                // detail: 1,
                screenX: e.screenX,
                screenY: e.screenY,
                clientX: e.clientX,
                clientY: e.clientY
            });
            simulatedEvent._simulated = true;
            e.target.dispatchEvent(simulatedEvent);
        }
    });
    // @section Handlers
    // @property tapHold: Handler
    // Long tap handler to simulate `contextmenu` event (useful in mobile Safari).
    Map.addInitHook('addHandler', 'tapHold', TapHold);
    /*
   * L.Handler.TouchZoom is used by L.Map to add pinch zoom on supported mobile browsers.
   */ // @namespace Map
    // @section Interaction Options
    Map.mergeOptions({
        // @section Touch interaction options
        // @option touchZoom: Boolean|String = *
        // Whether the map can be zoomed by touch-dragging with two fingers. If
        // passed `'center'`, it will zoom to the center of the view regardless of
        // where the touch events (fingers) were. Enabled for touch-capable web
        // browsers.
        touchZoom: Browser.touch,
        // @option bounceAtZoomLimits: Boolean = true
        // Set it to false if you don't want the map to zoom beyond min/max zoom
        // and then bounce back when pinch-zooming.
        bounceAtZoomLimits: true
    });
    var TouchZoom = Handler.extend({
        addHooks: function() {
            addClass(this._map._container, 'leaflet-touch-zoom');
            on(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        removeHooks: function() {
            removeClass(this._map._container, 'leaflet-touch-zoom');
            off(this._map._container, 'touchstart', this._onTouchStart, this);
        },
        _onTouchStart: function(e) {
            var map = this._map;
            if (!e.touches || e.touches.length !== 2 || map._animatingZoom || this._zooming) return;
            var p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]);
            this._centerPoint = map.getSize()._divideBy(2);
            this._startLatLng = map.containerPointToLatLng(this._centerPoint);
            if (map.options.touchZoom !== 'center') this._pinchStartLatLng = map.containerPointToLatLng(p1.add(p2)._divideBy(2));
            this._startDist = p1.distanceTo(p2);
            this._startZoom = map.getZoom();
            this._moved = false;
            this._zooming = true;
            map._stop();
            on(document, 'touchmove', this._onTouchMove, this);
            on(document, 'touchend touchcancel', this._onTouchEnd, this);
            preventDefault(e);
        },
        _onTouchMove: function(e) {
            if (!e.touches || e.touches.length !== 2 || !this._zooming) return;
            var map = this._map, p1 = map.mouseEventToContainerPoint(e.touches[0]), p2 = map.mouseEventToContainerPoint(e.touches[1]), scale = p1.distanceTo(p2) / this._startDist;
            this._zoom = map.getScaleZoom(scale, this._startZoom);
            if (!map.options.bounceAtZoomLimits && (this._zoom < map.getMinZoom() && scale < 1 || this._zoom > map.getMaxZoom() && scale > 1)) this._zoom = map._limitZoom(this._zoom);
            if (map.options.touchZoom === 'center') {
                this._center = this._startLatLng;
                if (scale === 1) return;
            } else {
                // Get delta from pinch to center, so centerLatLng is delta applied to initial pinchLatLng
                var delta = p1._add(p2)._divideBy(2)._subtract(this._centerPoint);
                if (scale === 1 && delta.x === 0 && delta.y === 0) return;
                this._center = map.unproject(map.project(this._pinchStartLatLng, this._zoom).subtract(delta), this._zoom);
            }
            if (!this._moved) {
                map._moveStart(true, false);
                this._moved = true;
            }
            cancelAnimFrame(this._animRequest);
            var moveFn = bind(map._move, map, this._center, this._zoom, {
                pinch: true,
                round: false
            }, undefined);
            this._animRequest = requestAnimFrame(moveFn, this, true);
            preventDefault(e);
        },
        _onTouchEnd: function() {
            if (!this._moved || !this._zooming) {
                this._zooming = false;
                return;
            }
            this._zooming = false;
            cancelAnimFrame(this._animRequest);
            off(document, 'touchmove', this._onTouchMove, this);
            off(document, 'touchend touchcancel', this._onTouchEnd, this);
            // Pinch updates GridLayers' levels only when zoomSnap is off, so zoomSnap becomes noUpdate.
            if (this._map.options.zoomAnimation) this._map._animateZoom(this._center, this._map._limitZoom(this._zoom), true, this._map.options.zoomSnap);
            else this._map._resetView(this._center, this._map._limitZoom(this._zoom));
        }
    });
    // @section Handlers
    // @property touchZoom: Handler
    // Touch zoom handler.
    Map.addInitHook('addHandler', 'touchZoom', TouchZoom);
    Map.BoxZoom = BoxZoom;
    Map.DoubleClickZoom = DoubleClickZoom;
    Map.Drag = Drag;
    Map.Keyboard = Keyboard;
    Map.ScrollWheelZoom = ScrollWheelZoom;
    Map.TapHold = TapHold;
    Map.TouchZoom = TouchZoom;
    exports1.Bounds = Bounds;
    exports1.Browser = Browser;
    exports1.CRS = CRS;
    exports1.Canvas = Canvas;
    exports1.Circle = Circle;
    exports1.CircleMarker = CircleMarker;
    exports1.Class = Class;
    exports1.Control = Control;
    exports1.DivIcon = DivIcon;
    exports1.DivOverlay = DivOverlay;
    exports1.DomEvent = DomEvent;
    exports1.DomUtil = DomUtil;
    exports1.Draggable = Draggable;
    exports1.Evented = Evented;
    exports1.FeatureGroup = FeatureGroup;
    exports1.GeoJSON = GeoJSON;
    exports1.GridLayer = GridLayer;
    exports1.Handler = Handler;
    exports1.Icon = Icon;
    exports1.ImageOverlay = ImageOverlay;
    exports1.LatLng = LatLng;
    exports1.LatLngBounds = LatLngBounds;
    exports1.Layer = Layer;
    exports1.LayerGroup = LayerGroup;
    exports1.LineUtil = LineUtil;
    exports1.Map = Map;
    exports1.Marker = Marker;
    exports1.Mixin = Mixin;
    exports1.Path = Path;
    exports1.Point = Point;
    exports1.PolyUtil = PolyUtil;
    exports1.Polygon = Polygon;
    exports1.Polyline = Polyline;
    exports1.Popup = Popup;
    exports1.PosAnimation = PosAnimation;
    exports1.Projection = index;
    exports1.Rectangle = Rectangle;
    exports1.Renderer = Renderer;
    exports1.SVG = SVG;
    exports1.SVGOverlay = SVGOverlay;
    exports1.TileLayer = TileLayer;
    exports1.Tooltip = Tooltip;
    exports1.Transformation = Transformation;
    exports1.Util = Util;
    exports1.VideoOverlay = VideoOverlay;
    exports1.bind = bind;
    exports1.bounds = toBounds;
    exports1.canvas = canvas;
    exports1.circle = circle;
    exports1.circleMarker = circleMarker;
    exports1.control = control;
    exports1.divIcon = divIcon;
    exports1.extend = extend;
    exports1.featureGroup = featureGroup;
    exports1.geoJSON = geoJSON;
    exports1.geoJson = geoJson;
    exports1.gridLayer = gridLayer;
    exports1.icon = icon;
    exports1.imageOverlay = imageOverlay;
    exports1.latLng = toLatLng;
    exports1.latLngBounds = toLatLngBounds;
    exports1.layerGroup = layerGroup;
    exports1.map = createMap;
    exports1.marker = marker;
    exports1.point = toPoint;
    exports1.polygon = polygon;
    exports1.polyline = polyline;
    exports1.popup = popup;
    exports1.rectangle = rectangle;
    exports1.setOptions = setOptions;
    exports1.stamp = stamp;
    exports1.svg = svg;
    exports1.svgOverlay = svgOverlay;
    exports1.tileLayer = tileLayer;
    exports1.tooltip = tooltip;
    exports1.transformation = toTransformation;
    exports1.version = version;
    exports1.videoOverlay = videoOverlay;
    var oldL = window.L;
    exports1.noConflict = function() {
        window.L = oldL;
        return this;
    };
    // Always export us to window global (see #2364)
    window.L = exports1;
});



const $fda7f0cf135b7497$export$f52ee31d61d0b27b = ({ providerURL: providerURL = 'https://unpkg.com/leaflet.chinatmsproviders@3/src/leaflet.ChineseTmsProviders.js', type: type = 'Normal', data: data = 'Map', vendor: vendor = 'OSM', option: option })=>{
    const map = (0, $7a431aeadd23a524$export$86f8f9f08863e403)();
    (0, $dNU7X.useEffect)(()=>{
        const script = document.createElement('script');
        script.src = providerURL;
        script.onload = ()=>(0, $8f39e28756ef9331$exports.tileLayer)// @ts-ignore
            .chinaProvider([
                vendor,
                type,
                data
            ].join('.'), option).addTo(map);
        document.body.append(script);
    }, [
        map
    ]);
    return (0, $2111e08a92d70add$exports.jsx)((0, $2111e08a92d70add$exports.Fragment), {});
};
$fda7f0cf135b7497$export$f52ee31d61d0b27b.displayName = 'TileLayer';




var $dZnzp = parcelRequire("dZnzp");


var $6d0827628655730a$export$83d89fbfd8236492;
var $6d0827628655730a$export$80e7718417253a51;
var $6d0827628655730a$export$eb3a06aef9e6ee51;
var $6d0827628655730a$export$7020a3240b287705;
var $6d0827628655730a$export$fbb4d68fe60c1629;
'use strict';
var $6d0827628655730a$var$l, $6d0827628655730a$var$s;

$6d0827628655730a$var$l = (parcelRequire("3n3kp"));

$6d0827628655730a$var$s = (parcelRequire("hiPWA"));
$6d0827628655730a$export$83d89fbfd8236492 = $6d0827628655730a$var$l.version;
$6d0827628655730a$export$80e7718417253a51 = $6d0827628655730a$var$l.renderToString;
$6d0827628655730a$export$eb3a06aef9e6ee51 = $6d0827628655730a$var$l.renderToStaticMarkup;
$6d0827628655730a$export$7020a3240b287705 = $6d0827628655730a$var$s.renderToReadableStream;
if ($6d0827628655730a$var$s.resume) $6d0827628655730a$export$fbb4d68fe60c1629 = $6d0827628655730a$var$s.resume;





var $dNU7X = parcelRequire("dNU7X");
function $a05cce34ed6a1d4d$var$MapContainerComponent({ bounds: bounds, boundsOptions: boundsOptions, center: center, children: children, className: className, id: id, placeholder: placeholder, style: style, whenReady: whenReady, zoom: zoom, ...options }, forwardedRef) {
    const [props] = (0, $dNU7X.useState)({
        className: className,
        id: id,
        style: style
    });
    const [context, setContext] = (0, $dNU7X.useState)(null);
    const mapInstanceRef = (0, $dNU7X.useRef)(undefined);
    (0, $dNU7X.useImperativeHandle)(forwardedRef, ()=>context?.map ?? null, [
        context
    ]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: ref callback
    const mapRef = (0, $dNU7X.useCallback)((node)=>{
        if (node !== null && !mapInstanceRef.current) {
            const map = new (0, $8f39e28756ef9331$exports.Map)(node, options);
            mapInstanceRef.current = map;
            if (center != null && zoom != null) map.setView(center, zoom);
            else if (bounds != null) map.fitBounds(bounds, boundsOptions);
            if (whenReady != null) map.whenReady(whenReady);
            setContext((0, $62e7d3e4bbb57c5d$export$fb237fa819e17281)(map));
        }
    }, []);
    (0, $dNU7X.useEffect)(()=>{
        return ()=>{
            context?.map.remove();
        };
    }, [
        context
    ]);
    const contents = context ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).createElement((0, $62e7d3e4bbb57c5d$export$7de1b54b0142048f), {
        value: context
    }, children) : placeholder ?? null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).createElement("div", {
        ...props,
        ref: mapRef
    }, contents);
}
const $a05cce34ed6a1d4d$export$23f3dfd47374502b = /*#__PURE__*/ (0, $dNU7X.forwardRef)($a05cce34ed6a1d4d$var$MapContainerComponent);


var $dNU7X = parcelRequire("dNU7X");
function $4301a05fc053bc5f$export$a080ff44e8067a44(instance, context, container) {
    return Object.freeze({
        instance: instance,
        context: context,
        container: container
    });
}
function $4301a05fc053bc5f$export$2e66ec8a7fb1892f(createElement, updateElement) {
    if (updateElement == null) return function useImmutableLeafletElement(props, context) {
        const elementRef = (0, $dNU7X.useRef)(undefined);
        if (!elementRef.current) elementRef.current = createElement(props, context);
        return elementRef;
    };
    return function useMutableLeafletElement(props, context) {
        const elementRef = (0, $dNU7X.useRef)(undefined);
        if (!elementRef.current) elementRef.current = createElement(props, context);
        const propsRef = (0, $dNU7X.useRef)(props);
        const { instance: instance } = elementRef.current;
        (0, $dNU7X.useEffect)(function updateElementProps() {
            if (propsRef.current !== props) {
                updateElement(instance, props, propsRef.current);
                propsRef.current = props;
            }
        }, [
            instance,
            props,
            updateElement
        ]);
        return elementRef;
    };
}


var $dNU7X = parcelRequire("dNU7X");

var $boCrV = parcelRequire("boCrV");

function $48fae9cf2897d430$export$96eac748c3f41e82(useElement) {
    function ContainerComponent(props, forwardedRef) {
        const { instance: instance, context: context } = useElement(props).current;
        (0, $dNU7X.useImperativeHandle)(forwardedRef, ()=>instance);
        const { children: children } = props;
        return children == null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($dNU7X))).createElement((0, $62e7d3e4bbb57c5d$export$7de1b54b0142048f), {
            value: context
        }, children);
    }
    return /*#__PURE__*/ (0, $dNU7X.forwardRef)(ContainerComponent);
}
function $48fae9cf2897d430$export$bc37ddc24ed05446(useElement) {
    function OverlayComponent(props, forwardedRef) {
        const [isOpen, setOpen] = (0, $dNU7X.useState)(false);
        const { instance: instance } = useElement(props, setOpen).current;
        (0, $dNU7X.useImperativeHandle)(forwardedRef, ()=>instance);
        // biome-ignore lint/correctness/useExhaustiveDependencies: update overlay when children change
        (0, $dNU7X.useEffect)(function updateOverlay() {
            if (isOpen) instance.update();
        }, [
            instance,
            isOpen,
            props.children
        ]);
        // @ts-ignore _contentNode missing in type definition
        const contentNode = instance._contentNode;
        return contentNode ? /*#__PURE__*/ (0, $boCrV.createPortal)(props.children, contentNode) : null;
    }
    return /*#__PURE__*/ (0, $dNU7X.forwardRef)(OverlayComponent);
}
function $48fae9cf2897d430$export$18af5c7a9e9b3664(useElement) {
    function LeafComponent(props, forwardedRef) {
        const { instance: instance } = useElement(props).current;
        (0, $dNU7X.useImperativeHandle)(forwardedRef, ()=>instance);
        return null;
    }
    return /*#__PURE__*/ (0, $dNU7X.forwardRef)(LeafComponent);
}



var $dNU7X = parcelRequire("dNU7X");

function $9229d2caff01c53d$export$28d24ab3914549cd(useElement) {
    return function useLeafletControl(props) {
        const context = (0, $62e7d3e4bbb57c5d$export$ea59151b8430a4e9)();
        const elementRef = useElement(props, context);
        const { instance: instance } = elementRef.current;
        const positionRef = (0, $dNU7X.useRef)(props.position);
        const { position: position } = props;
        (0, $dNU7X.useEffect)(function addControl() {
            instance.addTo(context.map);
            return function removeControl() {
                instance.remove();
            };
        }, [
            context.map,
            instance
        ]);
        (0, $dNU7X.useEffect)(function updateControl() {
            if (position != null && position !== positionRef.current) {
                instance.setPosition(position);
                positionRef.current = position;
            }
        }, [
            instance,
            position
        ]);
        return elementRef;
    };
}



var $dNU7X = parcelRequire("dNU7X");
function $0ff876addb3763e0$export$46b870813daca3d4(map, attribution) {
    const attributionRef = (0, $dNU7X.useRef)(attribution);
    (0, $dNU7X.useEffect)(function updateAttribution() {
        if (attribution !== attributionRef.current && map.attributionControl != null) {
            if (attributionRef.current != null) map.attributionControl.removeAttribution(attributionRef.current);
            if (attribution != null) map.attributionControl.addAttribution(attribution);
        }
        attributionRef.current = attribution;
    }, [
        map,
        attribution
    ]);
}




var $dNU7X = parcelRequire("dNU7X");
function $928e3fe575b9d768$export$8ce912bc34d0dbea(element, eventHandlers) {
    const eventHandlersRef = (0, $dNU7X.useRef)(undefined);
    (0, $dNU7X.useEffect)(function addEventHandlers() {
        if (eventHandlers != null) element.instance.on(eventHandlers);
        eventHandlersRef.current = eventHandlers;
        return function removeEventHandlers() {
            if (eventHandlersRef.current != null) element.instance.off(eventHandlersRef.current);
            eventHandlersRef.current = null;
        };
    }, [
        element,
        eventHandlers
    ]);
}


function $64ead3d75f334a72$export$6ee5d263358f5c0e(props, context) {
    const pane = props.pane ?? context.pane;
    return pane ? {
        ...props,
        pane: pane
    } : props;
}


function $44eb080ddd5236fb$export$d5eca53b0accc0e0(useElement, useLifecycle) {
    return function useDivOverlay(props, setOpen) {
        const context = (0, $62e7d3e4bbb57c5d$export$ea59151b8430a4e9)();
        const elementRef = useElement((0, $64ead3d75f334a72$export$6ee5d263358f5c0e)(props, context), context);
        (0, $0ff876addb3763e0$export$46b870813daca3d4)(context.map, props.attribution);
        (0, $928e3fe575b9d768$export$8ce912bc34d0dbea)(elementRef.current, props.eventHandlers);
        useLifecycle(elementRef.current, context, props, setOpen);
        return elementRef;
    };
}




var $dNU7X = parcelRequire("dNU7X");




function $26d7893a4175e30c$export$cd00a227f8cfb2c2(element, context) {
    (0, $dNU7X.useEffect)(function addLayer() {
        const container = context.layerContainer ?? context.map;
        container.addLayer(element.instance);
        return function removeLayer() {
            context.layerContainer?.removeLayer(element.instance);
            context.map.removeLayer(element.instance);
        };
    }, [
        context,
        element
    ]);
}
function $26d7893a4175e30c$export$73f852c6a5abdefa(useElement) {
    return function useLayer(props) {
        const context = (0, $62e7d3e4bbb57c5d$export$ea59151b8430a4e9)();
        const elementRef = useElement((0, $64ead3d75f334a72$export$6ee5d263358f5c0e)(props, context), context);
        (0, $0ff876addb3763e0$export$46b870813daca3d4)(context.map, props.attribution);
        (0, $928e3fe575b9d768$export$8ce912bc34d0dbea)(elementRef.current, props.eventHandlers);
        $26d7893a4175e30c$export$cd00a227f8cfb2c2(elementRef.current, context);
        return elementRef;
    };
}



var $dNU7X = parcelRequire("dNU7X");




function $aab60bd621557639$export$d0296329a1f118ca(element, props) {
    const optionsRef = (0, $dNU7X.useRef)(undefined);
    (0, $dNU7X.useEffect)(function updatePathOptions() {
        if (props.pathOptions !== optionsRef.current) {
            const options = props.pathOptions ?? {};
            element.instance.setStyle(options);
            optionsRef.current = options;
        }
    }, [
        element,
        props
    ]);
}
function $aab60bd621557639$export$5fea2fe6048fc3db(useElement) {
    return function usePath(props) {
        const context = (0, $62e7d3e4bbb57c5d$export$ea59151b8430a4e9)();
        const elementRef = useElement((0, $64ead3d75f334a72$export$6ee5d263358f5c0e)(props, context), context);
        (0, $928e3fe575b9d768$export$8ce912bc34d0dbea)(elementRef.current, props.eventHandlers);
        (0, $26d7893a4175e30c$export$cd00a227f8cfb2c2)(elementRef.current, context);
        $aab60bd621557639$export$d0296329a1f118ca(elementRef.current, props);
        return elementRef;
    };
}


function $8d415abaa20af89f$export$896a3ef451e396c4(createInstance) {
    function createElement(props, context) {
        return (0, $4301a05fc053bc5f$export$a080ff44e8067a44)(createInstance(props), context);
    }
    const useElement = (0, $4301a05fc053bc5f$export$2e66ec8a7fb1892f)(createElement);
    const useControl = (0, $9229d2caff01c53d$export$28d24ab3914549cd)(useElement);
    return (0, $48fae9cf2897d430$export$18af5c7a9e9b3664)(useControl);
}
function $8d415abaa20af89f$export$8a4d5778bce4c3ac(createElement, updateElement) {
    const useElement = (0, $4301a05fc053bc5f$export$2e66ec8a7fb1892f)(createElement, updateElement);
    const useLayer = (0, $26d7893a4175e30c$export$73f852c6a5abdefa)(useElement);
    return (0, $48fae9cf2897d430$export$96eac748c3f41e82)(useLayer);
}
function $8d415abaa20af89f$export$7d18e209be943d7d(createElement, useLifecycle) {
    const useElement = (0, $4301a05fc053bc5f$export$2e66ec8a7fb1892f)(createElement);
    const useOverlay = (0, $44eb080ddd5236fb$export$d5eca53b0accc0e0)(useElement, useLifecycle);
    return (0, $48fae9cf2897d430$export$bc37ddc24ed05446)(useOverlay);
}
function $8d415abaa20af89f$export$5e776dbe3c7d2790(createElement, updateElement) {
    const useElement = (0, $4301a05fc053bc5f$export$2e66ec8a7fb1892f)(createElement, updateElement);
    const usePath = (0, $aab60bd621557639$export$5fea2fe6048fc3db)(useElement);
    return (0, $48fae9cf2897d430$export$96eac748c3f41e82)(usePath);
}
function $8d415abaa20af89f$export$4f432c6de5c4ddb8(createElement, updateElement) {
    const useElement = (0, $4301a05fc053bc5f$export$2e66ec8a7fb1892f)(createElement, updateElement);
    const useLayer = (0, $26d7893a4175e30c$export$73f852c6a5abdefa)(useElement);
    return (0, $48fae9cf2897d430$export$18af5c7a9e9b3664)(useLayer);
}



const $f4cef3b83e2b02b4$export$e98856a975cab58e = (0, $8d415abaa20af89f$export$8a4d5778bce4c3ac)(function createMarker({ position: position, ...options }, ctx) {
    const marker = new (0, $8f39e28756ef9331$exports.Marker)(position, options);
    return (0, $4301a05fc053bc5f$export$a080ff44e8067a44)(marker, (0, $62e7d3e4bbb57c5d$export$9efaf186a2224858)(ctx, {
        overlayContainer: marker
    }));
}, function updateMarker(marker, props, prevProps) {
    if (props.position !== prevProps.position) marker.setLatLng(props.position);
    if (props.icon != null && props.icon !== prevProps.icon) marker.setIcon(props.icon);
    if (props.zIndexOffset != null && props.zIndexOffset !== prevProps.zIndexOffset) marker.setZIndexOffset(props.zIndexOffset);
    if (props.opacity != null && props.opacity !== prevProps.opacity) marker.setOpacity(props.opacity);
    if (marker.dragging != null && props.draggable !== prevProps.draggable) {
        if (props.draggable === true) marker.dragging.enable();
        else marker.dragging.disable();
    }
});




var $dNU7X = parcelRequire("dNU7X");
const $02e38ff3c7865d8f$export$129a32eedafa97c5 = (0, $8d415abaa20af89f$export$7d18e209be943d7d)(function createPopup(props, context) {
    const popup = new (0, $8f39e28756ef9331$exports.Popup)(props, context.overlayContainer);
    return (0, $4301a05fc053bc5f$export$a080ff44e8067a44)(popup, context);
}, function usePopupLifecycle(element, context, { position: position }, setOpen) {
    (0, $dNU7X.useEffect)(function addPopup() {
        const { instance: instance } = element;
        function onPopupOpen(event) {
            if (event.popup === instance) {
                instance.update();
                setOpen(true);
            }
        }
        function onPopupClose(event) {
            if (event.popup === instance) setOpen(false);
        }
        context.map.on({
            popupopen: onPopupOpen,
            popupclose: onPopupClose
        });
        if (context.overlayContainer == null) {
            // Attach to a Map
            if (position != null) instance.setLatLng(position);
            instance.openOn(context.map);
        } else // Attach to container component
        context.overlayContainer.bindPopup(instance);
        return function removePopup() {
            context.map.off({
                popupopen: onPopupOpen,
                popupclose: onPopupClose
            });
            context.overlayContainer?.unbindPopup();
            context.map.removeLayer(instance);
        };
    }, [
        element,
        context,
        setOpen,
        position
    ]);
});

function $478bc63aff026270$export$b39104a5f1b9296f(layer, props, prevProps) {
    const { opacity: opacity, zIndex: zIndex } = props;
    if (opacity != null && opacity !== prevProps.opacity) layer.setOpacity(opacity);
    if (zIndex != null && zIndex !== prevProps.zIndex) layer.setZIndex(zIndex);
}



const $bddacdf0a02483d8$export$f52ee31d61d0b27b = (0, $8d415abaa20af89f$export$4f432c6de5c4ddb8)(function createTileLayer({ url: url, ...options }, context) {
    const layer = new (0, $8f39e28756ef9331$exports.TileLayer)(url, (0, $64ead3d75f334a72$export$6ee5d263358f5c0e)(options, context));
    return (0, $4301a05fc053bc5f$export$a080ff44e8067a44)(layer, context);
}, function updateTileLayer(layer, props, prevProps) {
    (0, $478bc63aff026270$export$b39104a5f1b9296f)(layer, props, prevProps);
    const { url: url } = props;
    if (url != null && url !== prevProps.url) layer.setUrl(url);
});




var $dNU7X = parcelRequire("dNU7X");
const $169770ec3ce03d79$export$28c660c63b792dea = (0, $8d415abaa20af89f$export$7d18e209be943d7d)(function createTooltip(props, context) {
    const tooltip = new (0, $8f39e28756ef9331$exports.Tooltip)(props, context.overlayContainer);
    return (0, $4301a05fc053bc5f$export$a080ff44e8067a44)(tooltip, context);
}, function useTooltipLifecycle(element, context, { position: position }, setOpen) {
    (0, $dNU7X.useEffect)(function addTooltip() {
        const container = context.overlayContainer;
        if (container == null) return;
        const { instance: instance } = element;
        const onTooltipOpen = (event)=>{
            if (event.tooltip === instance) {
                if (position != null) instance.setLatLng(position);
                instance.update();
                setOpen(true);
            }
        };
        const onTooltipClose = (event)=>{
            if (event.tooltip === instance) setOpen(false);
        };
        container.on({
            tooltipopen: onTooltipOpen,
            tooltipclose: onTooltipClose
        });
        container.bindTooltip(instance);
        return function removeTooltip() {
            container.off({
                tooltipopen: onTooltipOpen,
                tooltipclose: onTooltipClose
            });
            // @ts-ignore protected property
            if (container._map != null) container.unbindTooltip();
        };
    }, [
        element,
        context,
        setOpen,
        position
    ]);
});




function $412f79b931fbf0f7$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $412f79b931fbf0f7$var$$eef213ff4197108b$exports = {};
$412f79b931fbf0f7$var$$parcel$export($412f79b931fbf0f7$var$$eef213ff4197108b$exports, "Stack", function() {
    return $412f79b931fbf0f7$export$694e0d28c7ffc90c;
});
const { push: $412f79b931fbf0f7$var$$eef213ff4197108b$var$push } = Array.prototype;
class $412f79b931fbf0f7$export$694e0d28c7ffc90c {
    use(...middlewares) {
        $412f79b931fbf0f7$var$$eef213ff4197108b$var$push.apply(this, middlewares);
        return this;
    }
    execute(context, depth = 0) {
        const middleware = this[depth];
        if (middleware instanceof Function) return middleware(context, this.execute.bind(this, context, ++depth));
    }
    mount(condition, stack) {
        return this.use((context, next)=>condition(context) ? stack.execute(context) : next());
    }
    constructor(){
        this.length = 0;
    }
}
var $412f79b931fbf0f7$var$$0fe1f1400993ba8a$exports = {};
$412f79b931fbf0f7$var$$parcel$export($412f79b931fbf0f7$var$$0fe1f1400993ba8a$exports, "BodyRequestMethods", function() {
    return $412f79b931fbf0f7$export$4125cfe7e08e2040;
});
$412f79b931fbf0f7$var$$parcel$export($412f79b931fbf0f7$var$$0fe1f1400993ba8a$exports, "HTTPError", function() {
    return $412f79b931fbf0f7$export$aa9d629c530f62a7;
});
$412f79b931fbf0f7$var$$parcel$export($412f79b931fbf0f7$var$$0fe1f1400993ba8a$exports, "headerParser", function() {
    return $412f79b931fbf0f7$export$b725a69477e4d33f;
});
$412f79b931fbf0f7$var$$parcel$export($412f79b931fbf0f7$var$$0fe1f1400993ba8a$exports, "parseHeaders", function() {
    return $412f79b931fbf0f7$export$eea2c1c5e1a37e50;
});
$412f79b931fbf0f7$var$$parcel$export($412f79b931fbf0f7$var$$0fe1f1400993ba8a$exports, "parseBody", function() {
    return $412f79b931fbf0f7$export$3b629cd0ff482602;
});
$412f79b931fbf0f7$var$$parcel$export($412f79b931fbf0f7$var$$0fe1f1400993ba8a$exports, "requestXHR", function() {
    return $412f79b931fbf0f7$export$4f2a8c8c11a6373a;
});
$412f79b931fbf0f7$var$$parcel$export($412f79b931fbf0f7$var$$0fe1f1400993ba8a$exports, "requestFetch", function() {
    return $412f79b931fbf0f7$export$bda27a3e49197b9;
});
$412f79b931fbf0f7$var$$parcel$export($412f79b931fbf0f7$var$$0fe1f1400993ba8a$exports, "parseResponse", function() {
    return $412f79b931fbf0f7$export$ba14d9a5a581e827;
});
$412f79b931fbf0f7$var$$parcel$export($412f79b931fbf0f7$var$$0fe1f1400993ba8a$exports, "parseFetchBody", function() {
    return $412f79b931fbf0f7$export$b7b86d31099674dc;
});
$412f79b931fbf0f7$var$$parcel$export($412f79b931fbf0f7$var$$0fe1f1400993ba8a$exports, "request", function() {
    return $412f79b931fbf0f7$export$b5fe3f66a567bec0;
});
var $412f79b931fbf0f7$var$$22de11b45b0eeb97$exports = {};
$412f79b931fbf0f7$var$$parcel$export($412f79b931fbf0f7$var$$22de11b45b0eeb97$exports, "polyfillProgressEvent", function() {
    return $412f79b931fbf0f7$export$5e6a03ce7b01784;
});
$412f79b931fbf0f7$var$$parcel$export($412f79b931fbf0f7$var$$22de11b45b0eeb97$exports, "parseDocument", function() {
    return $412f79b931fbf0f7$export$b6a9369736b19f4d;
});
$412f79b931fbf0f7$var$$parcel$export($412f79b931fbf0f7$var$$22de11b45b0eeb97$exports, "makeFormData", function() {
    return $412f79b931fbf0f7$export$2c28ab2e118e73f1;
});
$412f79b931fbf0f7$var$$parcel$export($412f79b931fbf0f7$var$$22de11b45b0eeb97$exports, "serializeNode", function() {
    return $412f79b931fbf0f7$export$a0beee2e55fb5dd1;
});
$412f79b931fbf0f7$var$$parcel$export($412f79b931fbf0f7$var$$22de11b45b0eeb97$exports, "serialize", function() {
    return $412f79b931fbf0f7$export$dfdc1655ccc5b9cb;
});
$412f79b931fbf0f7$var$$parcel$export($412f79b931fbf0f7$var$$22de11b45b0eeb97$exports, "streamFromProgress", function() {
    return $412f79b931fbf0f7$export$f8162fcba31fa547;
});
$412f79b931fbf0f7$var$$parcel$export($412f79b931fbf0f7$var$$22de11b45b0eeb97$exports, "emitStreamProgress", function() {
    return $412f79b931fbf0f7$export$cebfdbc318a33abe;
});
$412f79b931fbf0f7$var$$parcel$export($412f79b931fbf0f7$var$$22de11b45b0eeb97$exports, "FileMethod", function() {
    return $412f79b931fbf0f7$export$226b21d2db5eaf9f;
});
$412f79b931fbf0f7$var$$parcel$export($412f79b931fbf0f7$var$$22de11b45b0eeb97$exports, "readAs", function() {
    return $412f79b931fbf0f7$export$e209cbb66c5b18c;
});
$412f79b931fbf0f7$var$$parcel$export($412f79b931fbf0f7$var$$22de11b45b0eeb97$exports, "encodeBase64", function() {
    return $412f79b931fbf0f7$export$8fb536984ec8b4d7;
});
function $412f79b931fbf0f7$export$5e6a03ce7b01784() {
    return globalThis.ProgressEvent ||= class ProgressEvent1 extends Event {
        constructor(type, { lengthComputable: lengthComputable, total: total, loaded: loaded, ...meta } = {}){
            super(type, meta);
            this.lengthComputable = lengthComputable;
            this.total = total;
            this.loaded = loaded;
        }
    };
}
async function $412f79b931fbf0f7$export$b6a9369736b19f4d(text, contentType = '') {
    const [type] = contentType?.split(';') || [];
    return new DOMParser().parseFromString(text, type || 'text/html');
}
function $412f79b931fbf0f7$export$2c28ab2e118e73f1(data) {
    const formData = new FormData();
    for (const [key, value] of Object.entries(data)){
        const list = typeof value !== 'string' && (0, $0fd9d527cd0d1501$export$b5a4d6f439a5044d)(value) ? value : [
            value
        ];
        for (const item of Array.from(list))if (item != null) {
            if (typeof item === 'object') formData.append(key, item, item.name);
            else formData.append(key, item);
        }
    }
    return formData;
}
function $412f79b931fbf0f7$export$a0beee2e55fb5dd1(root) {
    var contentType;
    if (!(root instanceof HTMLFormElement)) return {
        contentType: root instanceof SVGElement ? 'image/svg' : root instanceof Document || root instanceof HTMLElement ? 'text/html' : 'application/xml',
        data: (0, $0fd9d527cd0d1501$export$b0709844452f8b6b)(root)
    };
    if (root.querySelector('input[type="file"][name]')) return {
        contentType: 'multipart/form-data',
        data: new FormData(root)
    };
    const data = (0, $0fd9d527cd0d1501$export$86d7c59254d6a2c9)(root);
    switch(contentType = root.enctype){
        case 'text/plain':
            return {
                contentType: contentType,
                data: Object.entries(data).map(([name, value])=>`${name}=${value}`).join('\n')
            };
        case 'application/x-www-form-urlencoded':
            return {
                contentType: contentType,
                data: new URLSearchParams(data)
            };
        default:
            return {
                contentType: 'application/json',
                data: JSON.stringify(data)
            };
    }
}
function $412f79b931fbf0f7$export$dfdc1655ccc5b9cb(data, contentType) {
    const [type] = contentType?.split(';') || [];
    switch(type){
        case 'application/x-www-form-urlencoded':
            return {
                contentType: contentType,
                data: new URLSearchParams(data)
            };
        case 'multipart/form-data':
            return {
                data: $412f79b931fbf0f7$export$2c28ab2e118e73f1(data)
            };
        case 'application/json':
            return {
                contentType: contentType,
                data: JSON.stringify(data)
            };
        case 'text/html':
        case 'application/xml':
        case 'image/svg':
            return {
                contentType: contentType,
                data: (0, $0fd9d527cd0d1501$export$b0709844452f8b6b)(data)
            };
    }
    if (type) return {
        data: data,
        contentType: contentType
    };
    try {
        if (data instanceof URLSearchParams) return {
            contentType: 'application/x-www-form-urlencoded',
            data: data
        };
    } catch  {}
    try {
        if (data instanceof FormData) return {
            data: data
        };
    } catch  {}
    try {
        if (data instanceof Node) return $412f79b931fbf0f7$export$a0beee2e55fb5dd1(data);
    } catch  {}
    try {
        if ((0, $0fd9d527cd0d1501$export$b119cc7e1840e59c)(data) || data instanceof ArrayBuffer || data instanceof DataView || data instanceof Blob || data instanceof ReadableStream) return {
            contentType: 'application/octet-stream',
            data: data
        };
    } catch  {}
    try {
        return {
            contentType: 'application/json',
            data: JSON.stringify(data)
        };
    } catch  {}
    throw new Error('Unserialized Object needs a specific Content-Type');
}
const $412f79b931fbf0f7$export$f8162fcba31fa547 = (target)=>(0, $0fd9d527cd0d1501$export$86c18c6347f4a8c4)(({ next: next, complete: complete, error: error })=>{
        const handleProgress = ({ loaded: loaded, total: total })=>{
            next({
                loaded: loaded,
                total: total
            });
            if (loaded >= total) complete();
        };
        target.addEventListener('progress', handleProgress);
        target.addEventListener('error', error);
        return ()=>{
            target.removeEventListener('progress', handleProgress);
            target.removeEventListener('error', error);
        };
    });
async function* $412f79b931fbf0f7$export$cebfdbc318a33abe(stream, total, eventTarget) {
    var loaded = 0;
    $412f79b931fbf0f7$export$5e6a03ce7b01784();
    for await (const chunk of stream){
        yield chunk;
        loaded += chunk.byteLength;
        const event = new ProgressEvent('progress', {
            lengthComputable: isNaN(total),
            loaded: loaded,
            total: total
        });
        eventTarget.dispatchEvent(event);
    }
}
var $412f79b931fbf0f7$export$226b21d2db5eaf9f = /*#__PURE__*/ function(FileMethod) {
    FileMethod["text"] = "readAsText";
    FileMethod["dataURL"] = "readAsDataURL";
    FileMethod["binaryString"] = "readAsBinaryString";
    FileMethod["arrayBuffer"] = "readAsArrayBuffer";
    return FileMethod;
}({});
function $412f79b931fbf0f7$export$e209cbb66c5b18c(file, method, encoding) {
    const reader = new FileReader();
    const result = new Promise((resolve, reject)=>{
        reader.onerror = reject;
        reader.onload = ()=>resolve(reader.result);
        reader[$412f79b931fbf0f7$export$226b21d2db5eaf9f[method]](file, encoding);
    });
    return {
        progress: $412f79b931fbf0f7$export$f8162fcba31fa547(reader),
        result: result
    };
}
const $412f79b931fbf0f7$var$$22de11b45b0eeb97$var$DataURI = /^data:(.+?\/(.+?))?(;base64)?,([\s\S]+)/;
async function $412f79b931fbf0f7$export$8fb536984ec8b4d7(raw) {
    if (raw instanceof Blob) {
        const text = await $412f79b931fbf0f7$export$e209cbb66c5b18c(raw, 'dataURL').result;
        return ($412f79b931fbf0f7$var$$22de11b45b0eeb97$var$DataURI.exec(text) || '')[4];
    }
    const text = encodeURIComponent(raw).replace(/%([0-9A-F]{2})/g, (_, p1)=>String.fromCharCode(+('0x' + p1)));
    return btoa(text);
}
var $412f79b931fbf0f7$export$4125cfe7e08e2040 = /*#__PURE__*/ function(BodyRequestMethods) {
    BodyRequestMethods["POST"] = "POST";
    BodyRequestMethods["PUT"] = "PUT";
    BodyRequestMethods["PATCH"] = "PATCH";
    BodyRequestMethods["DELETE"] = "DELETE";
    return BodyRequestMethods;
}({});
class $412f79b931fbf0f7$export$aa9d629c530f62a7 extends URIError {
    constructor(message, request, response){
        super(message), this.request = request, this.response = response;
    }
}
const $412f79b931fbf0f7$export$b725a69477e4d33f = {
    Link: (value)=>Object.fromEntries(Array.from(value.matchAll(/<(\S+?)>; rel="(\w+)"(?:; title="(.*?)")?/g), ([_, URI, rel, title])=>[
                rel,
                {
                    rel: rel,
                    URI: URI,
                    title: title
                }
            ]))
};
const $412f79b931fbf0f7$export$eea2c1c5e1a37e50 = (raw)=>Object.fromEntries(Array.from(raw.trim().matchAll(/^([\w-]+):\s*(.*)/gm), ([_, key, value])=>{
        key = key.replace(/(^[a-z]|-[a-z])/g, (char)=>char.toUpperCase());
        return [
            key,
            $412f79b931fbf0f7$export$b725a69477e4d33f[key]?.(value) ?? value
        ];
    }));
function $412f79b931fbf0f7$export$3b629cd0ff482602(raw, contentType) {
    if (contentType.includes('json')) return (0, $0fd9d527cd0d1501$export$27924e57e9afff7f)(raw);
    if (contentType.match(/html|xml/)) try {
        return $412f79b931fbf0f7$export$b6a9369736b19f4d(raw, contentType);
    } catch  {}
    if (contentType.includes('text')) return raw;
    return new TextEncoder().encode(raw).buffer;
}
function $412f79b931fbf0f7$export$4f2a8c8c11a6373a({ method: method = 'GET', path: path, headers: headers = {}, body: body, signal: signal, ...rest }) {
    const request = new XMLHttpRequest();
    const header = new Headers(headers);
    const bodyPromise = body instanceof globalThis.ReadableStream ? Array.fromAsync(body).then((parts)=>new Blob(parts)) : Promise.resolve(body);
    const abort = ()=>request.abort();
    signal?.addEventListener('abort', abort);
    const response = new Promise((resolve, reject)=>{
        request.onreadystatechange = ()=>{
            const { readyState: readyState, status: status, statusText: statusText, responseType: responseType } = request;
            if (readyState !== 4 || !status && !signal?.aborted) return;
            resolve({
                status: status,
                statusText: statusText,
                headers: $412f79b931fbf0f7$export$eea2c1c5e1a37e50(request.getAllResponseHeaders()),
                body: responseType && responseType !== 'text' ? request.response : request.responseText
            });
        };
        request.onerror = request.ontimeout = reject;
        const [MIMEType] = header.get('Accept')?.split(',') || [
            rest.responseType === 'document' ? 'application/xhtml+xml' : rest.responseType === 'json' ? 'application/json' : ''
        ];
        if (MIMEType) request.overrideMimeType(MIMEType);
        request.open(method, path + '');
        for (const [key, value] of header)request.setRequestHeader(key, value);
        Object.assign(request, rest);
        bodyPromise.then((body)=>request.send(body));
    }).then(({ body: body, ...meta })=>{
        signal?.throwIfAborted();
        const contentType = request.getResponseHeader('Content-Type') || '';
        if (typeof body === 'string' && !contentType.includes('text')) body = $412f79b931fbf0f7$export$3b629cd0ff482602(body, contentType);
        return {
            ...meta,
            body: body
        };
    });
    response.finally(()=>signal?.removeEventListener('abort', abort));
    return {
        response: response,
        upload: $412f79b931fbf0f7$export$f8162fcba31fa547(request.upload),
        download: $412f79b931fbf0f7$export$f8162fcba31fa547(request)
    };
}
function $412f79b931fbf0f7$export$bda27a3e49197b9({ path: path, method: method, headers: headers, withCredentials: withCredentials, body: body, signal: signal, timeout: timeout, responseType: responseType }) {
    const signals = [
        signal,
        timeout && AbortSignal.timeout(timeout)
    ].filter(Boolean);
    headers = headers instanceof Headers ? Object.fromEntries(headers.entries()) : headers instanceof Array ? Object.fromEntries(headers) : headers;
    headers = responseType === 'text' ? {
        ...headers,
        Accept: 'text/plain'
    } : responseType === 'json' ? {
        ...headers,
        Accept: 'application/json'
    } : responseType === 'document' ? {
        ...headers,
        Accept: 'text/html, application/xhtml+xml, application/xml'
    } : responseType === 'arraybuffer' || responseType === 'blob' ? {
        ...headers,
        Accept: 'application/octet-stream'
    } : headers;
    const isStream = body instanceof globalThis.ReadableStream;
    var upload;
    if (isStream) {
        const uploadProgress = new EventTarget();
        body = globalThis.ReadableStream['from']($412f79b931fbf0f7$export$cebfdbc318a33abe(body, +headers['Content-Length'], uploadProgress));
        upload = $412f79b931fbf0f7$export$f8162fcba31fa547(uploadProgress);
    }
    const downloadProgress = new EventTarget();
    const response = fetch(path + '', {
        method: method,
        headers: headers,
        credentials: withCredentials ? 'include' : 'omit',
        body: body,
        signal: signals[0] && AbortSignal.any(signals),
        // @ts-expect-error https://developer.chrome.com/docs/capabilities/web-apis/fetch-streaming-requests
        duplex: isStream ? 'half' : undefined
    }).then((response)=>$412f79b931fbf0f7$export$ba14d9a5a581e827(response, responseType, downloadProgress));
    return {
        response: response,
        upload: upload,
        download: $412f79b931fbf0f7$export$f8162fcba31fa547(downloadProgress)
    };
}
async function $412f79b931fbf0f7$export$ba14d9a5a581e827({ status: status, statusText: statusText, headers: headers, body: body }, responseType, downloadProgress) {
    const stream = globalThis.ReadableStream['from']($412f79b931fbf0f7$export$cebfdbc318a33abe(body, +headers.get('Content-Length'), downloadProgress));
    const contentType = headers.get('Content-Type') || '';
    const header = $412f79b931fbf0f7$export$eea2c1c5e1a37e50([
        ...headers
    ].map(([key, value])=>`${key}: ${value}`).join('\n'));
    const rBody = status === 204 ? undefined : await $412f79b931fbf0f7$export$b7b86d31099674dc(stream, contentType, responseType);
    return {
        status: status,
        statusText: statusText,
        headers: header,
        body: rBody
    };
}
async function $412f79b931fbf0f7$export$b7b86d31099674dc(stream, contentType, responseType) {
    const blob = new Blob(await Array.fromAsync(stream), {
        type: contentType
    });
    if (responseType === 'blob') return blob;
    if (responseType === 'arraybuffer') return blob.arrayBuffer();
    const text = await blob.text();
    if (responseType === 'text') return text;
    return $412f79b931fbf0f7$export$3b629cd0ff482602(text, contentType);
}
const $412f79b931fbf0f7$export$b5fe3f66a567bec0 = typeof globalThis.XMLHttpRequest === 'function' ? $412f79b931fbf0f7$export$4f2a8c8c11a6373a : $412f79b931fbf0f7$export$bda27a3e49197b9;
var $412f79b931fbf0f7$var$$cbd22d3323bef9ca$exports = {};
$412f79b931fbf0f7$var$$parcel$export($412f79b931fbf0f7$var$$cbd22d3323bef9ca$exports, "HTTPClient", function() {
    return $412f79b931fbf0f7$export$45cf759b359d3d24;
});
const { splice: $412f79b931fbf0f7$var$$cbd22d3323bef9ca$var$splice } = Array.prototype;
class $412f79b931fbf0f7$export$45cf759b359d3d24 extends $412f79b931fbf0f7$export$694e0d28c7ffc90c {
    constructor({ baseURI: baseURI = globalThis.document?.baseURI, baseRequest: baseRequest = $412f79b931fbf0f7$export$b5fe3f66a567bec0, ...options } = {}){
        super(), this.defaultWare = async ({ request: request, response: response }, next)=>{
            const { method: method = 'GET', headers: headers = {}, body: body } = request;
            if (method in $412f79b931fbf0f7$export$4125cfe7e08e2040 && body && typeof body === 'object') {
                const { contentType: contentType, data: data } = $412f79b931fbf0f7$export$dfdc1655ccc5b9cb(body, headers['Content-Type']);
                if (contentType) headers['Content-Type'] = contentType;
                request.body = data;
            }
            await next();
            if (response.status > 299) throw new $412f79b931fbf0f7$export$aa9d629c530f62a7(response.statusText, request, response);
        };
        this.baseURI = baseURI;
        this.baseRequest = baseRequest;
        this.options = options;
        super.use(this.defaultWare);
        super.use(async ({ request: data, response: response })=>{
            data.path = new URL(data.path + '', this.baseURI) + '';
            Object.assign(response, await this.baseRequest({
                ...options,
                ...data
            }).response);
        });
    }
    use(...middlewares) {
        $412f79b931fbf0f7$var$$cbd22d3323bef9ca$var$splice.call(this, -2, 0, ...middlewares);
        return this;
    }
    async request(data) {
        const context = {
            request: {
                ...data,
                headers: {
                    ...data.headers
                }
            },
            response: {}
        };
        await this.execute(context);
        return context.response;
    }
    async head(path, headers, options) {
        const { headers: data } = await this.request({
            method: 'HEAD',
            path: path,
            headers: headers,
            ...options
        });
        return data;
    }
    get(path, headers, options) {
        return this.request({
            method: 'GET',
            path: path,
            headers: headers,
            ...options
        });
    }
    post(path, body, headers, options) {
        return this.request({
            method: 'POST',
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    put(path, body, headers, options) {
        return this.request({
            method: 'PUT',
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    patch(path, body, headers, options) {
        return this.request({
            method: 'PATCH',
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    delete(path, body, headers, options) {
        return this.request({
            method: 'DELETE',
            path: path,
            headers: headers,
            body: body,
            ...options
        });
    }
    async *download(path, { headers: headers, chunkSize: chunkSize = 1024 ** 2, range: [start = 0, end = Infinity] = [], ...options } = {}) {
        var total = 0;
        function setEndAsHeader(length) {
            total = length;
            if (end === Infinity) end = total;
        }
        try {
            const { 'Content-Length': length } = await this.head(path, headers, options);
            setEndAsHeader(+length);
        } catch (error) {
            console.error(error);
        }
        for(let i = start, j = i - 1 + chunkSize; i < end; i = j + 1, j += chunkSize){
            const { status: status, headers: { 'Content-Range': range }, body: body } = await this.get(path, {
                ...headers,
                Range: `bytes=${i}-${j}`
            }, options);
            const totalBytes = +range?.split('/').pop();
            if (totalBytes) setEndAsHeader(totalBytes);
            if (status !== 206) {
                yield {
                    total: total,
                    loaded: total,
                    percent: 100,
                    buffer: body
                };
                break;
            }
            const loaded = i + body.byteLength;
            yield {
                total: total,
                loaded: loaded,
                percent: +(loaded / total * 100).toFixed(2),
                buffer: body
            };
        }
    }
}



var $dZnzp = parcelRequire("dZnzp");

var $c5bc142358ed084a$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $c5bc142358ed084a$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $c5bc142358ed084a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c5bc142358ed084a$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $c5bc142358ed084a$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
let $c5bc142358ed084a$export$8ced1cb4a5a69eee = (()=>{
    var _a, _OpenReactMapModel_currentLocation_accessor_storage, _OpenReactMapModel_searchList_accessor_storage, _OpenReactMapModel_reversedAddress_accessor_storage;
    let _instanceExtraInitializers = [];
    let _currentLocation_decorators;
    let _currentLocation_initializers = [];
    let _currentLocation_extraInitializers = [];
    let _searchList_decorators;
    let _searchList_initializers = [];
    let _searchList_extraInitializers = [];
    let _reversedAddress_decorators;
    let _reversedAddress_initializers = [];
    let _reversedAddress_extraInitializers = [];
    let _get_reversedAddressText_decorators;
    return _a = class OpenReactMapModel {
        get currentLocation() {
            return $c5bc142358ed084a$var$__classPrivateFieldGet(this, _OpenReactMapModel_currentLocation_accessor_storage, "f");
        }
        set currentLocation(value) {
            $c5bc142358ed084a$var$__classPrivateFieldSet(this, _OpenReactMapModel_currentLocation_accessor_storage, value, "f");
        }
        get searchList() {
            return $c5bc142358ed084a$var$__classPrivateFieldGet(this, _OpenReactMapModel_searchList_accessor_storage, "f");
        }
        set searchList(value) {
            $c5bc142358ed084a$var$__classPrivateFieldSet(this, _OpenReactMapModel_searchList_accessor_storage, value, "f");
        }
        get reversedAddress() {
            return $c5bc142358ed084a$var$__classPrivateFieldGet(this, _OpenReactMapModel_reversedAddress_accessor_storage, "f");
        }
        set reversedAddress(value) {
            $c5bc142358ed084a$var$__classPrivateFieldSet(this, _OpenReactMapModel_reversedAddress_accessor_storage, value, "f");
        }
        get reversedAddressText() {
            return this.reversedAddress && _a.addressTextOf(this.reversedAddress);
        }
        /**
             * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Geolocation/getCurrentPosition}
             */ locate() {
            return $c5bc142358ed084a$var$__awaiter(this, void 0, void 0, function*() {
                const { coords: { latitude: latitude, longitude: longitude } } = yield new Promise((resolve, reject)=>navigator.geolocation.getCurrentPosition(resolve, reject, {
                        enableHighAccuracy: true
                    }));
                return this.currentLocation = [
                    latitude,
                    longitude
                ];
            });
        }
        /**
             * @see https://nominatim.org/release-docs/develop/api/Search/
             */ search(address) {
            return $c5bc142358ed084a$var$__awaiter(this, void 0, void 0, function*() {
                const { body: body } = yield this.nominatimClient.get(`search?${new URLSearchParams({
                    q: address,
                    format: 'json'
                })}`);
                return this.searchList = body;
            });
        }
        /**
             * @see https://nominatim.org/release-docs/develop/api/Reverse/
             */ reverse(lat, lon) {
            return $c5bc142358ed084a$var$__awaiter(this, void 0, void 0, function*() {
                const { body: body } = yield this.nominatimClient.get(`reverse?${(0, $0fd9d527cd0d1501$export$13397a83aa5915d6)({
                    lat: lat,
                    lon: lon,
                    format: 'json'
                })}`);
                return this.reversedAddress = body;
            });
        }
        static addressTextOf({ address: { country: country, state: state, state_district: state_district, town: town, village: village, road: road, neighbourhood: neighbourhood, building: building, house_number: house_number, amenity: amenity } }) {
            return [
                country,
                state,
                state_district,
                town,
                village,
                road,
                neighbourhood,
                building,
                house_number,
                amenity
            ].filter(Boolean).join(' ');
        }
        constructor(){
            Object.defineProperty(this, "nominatimClient", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($c5bc142358ed084a$var$__runInitializers(this, _instanceExtraInitializers), new (0, $412f79b931fbf0f7$export$45cf759b359d3d24)({
                    baseURI: 'https://nominatim.openstreetmap.org',
                    responseType: 'json'
                }))
            });
            _OpenReactMapModel_currentLocation_accessor_storage.set(this, $c5bc142358ed084a$var$__runInitializers(this, _currentLocation_initializers, void 0));
            _OpenReactMapModel_searchList_accessor_storage.set(this, ($c5bc142358ed084a$var$__runInitializers(this, _currentLocation_extraInitializers), $c5bc142358ed084a$var$__runInitializers(this, _searchList_initializers, [])));
            _OpenReactMapModel_reversedAddress_accessor_storage.set(this, ($c5bc142358ed084a$var$__runInitializers(this, _searchList_extraInitializers), $c5bc142358ed084a$var$__runInitializers(this, _reversedAddress_initializers, void 0)));
            $c5bc142358ed084a$var$__runInitializers(this, _reversedAddress_extraInitializers);
        }
    }, _OpenReactMapModel_currentLocation_accessor_storage = new WeakMap(), _OpenReactMapModel_searchList_accessor_storage = new WeakMap(), _OpenReactMapModel_reversedAddress_accessor_storage = new WeakMap(), (()=>{
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(null) : void 0;
        _currentLocation_decorators = [
            (0, $dZnzp.observable)
        ];
        _searchList_decorators = [
            (0, $dZnzp.observable)
        ];
        _reversedAddress_decorators = [
            (0, $dZnzp.observable)
        ];
        _get_reversedAddressText_decorators = [
            (0, $dZnzp.computed)
        ];
        $c5bc142358ed084a$var$__esDecorate(_a, null, _currentLocation_decorators, {
            kind: "accessor",
            name: "currentLocation",
            static: false,
            private: false,
            access: {
                has: (obj)=>"currentLocation" in obj,
                get: (obj)=>obj.currentLocation,
                set: (obj, value)=>{
                    obj.currentLocation = value;
                }
            },
            metadata: _metadata
        }, _currentLocation_initializers, _currentLocation_extraInitializers);
        $c5bc142358ed084a$var$__esDecorate(_a, null, _searchList_decorators, {
            kind: "accessor",
            name: "searchList",
            static: false,
            private: false,
            access: {
                has: (obj)=>"searchList" in obj,
                get: (obj)=>obj.searchList,
                set: (obj, value)=>{
                    obj.searchList = value;
                }
            },
            metadata: _metadata
        }, _searchList_initializers, _searchList_extraInitializers);
        $c5bc142358ed084a$var$__esDecorate(_a, null, _reversedAddress_decorators, {
            kind: "accessor",
            name: "reversedAddress",
            static: false,
            private: false,
            access: {
                has: (obj)=>"reversedAddress" in obj,
                get: (obj)=>obj.reversedAddress,
                set: (obj, value)=>{
                    obj.reversedAddress = value;
                }
            },
            metadata: _metadata
        }, _reversedAddress_initializers, _reversedAddress_extraInitializers);
        $c5bc142358ed084a$var$__esDecorate(_a, null, _get_reversedAddressText_decorators, {
            kind: "getter",
            name: "reversedAddressText",
            static: false,
            private: false,
            access: {
                has: (obj)=>"reversedAddressText" in obj,
                get: (obj)=>obj.reversedAddressText
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        if (_metadata) Object.defineProperty(_a, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })(), _a;
})();


var $04aabf6d5201c72f$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $04aabf6d5201c72f$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $04aabf6d5201c72f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $04aabf6d5201c72f$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $04aabf6d5201c72f$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
let $04aabf6d5201c72f$export$789ab471c7975d83 = (()=>{
    let _classDecorators = [
        (0, $47a6458a96730da2$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $7ddf193e68e751e3$exports.ObservedComponent);
    let _instanceExtraInitializers = [];
    let _get_eventHandlerMap_decorators;
    let _get_position_decorators;
    let _get_center_decorators;
    let _get_markers_decorators;
    let _search_decorators;
    var OpenReactMap = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            Object.defineProperty(this, "store", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($04aabf6d5201c72f$var$__runInitializers(this, _instanceExtraInitializers), new (0, $c5bc142358ed084a$export$8ced1cb4a5a69eee)())
            });
            Object.defineProperty(this, "changeAddress", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (_a)=>$04aabf6d5201c72f$var$__awaiter(this, [
                        _a
                    ], void 0, function*({ latlng: { lat: lat, lng: lng } }) {
                        const { onChange: onChange } = this.props;
                        if (!onChange) return;
                        const location = yield this.store.reverse(lat, lng);
                        if (!location) return;
                        const { country: country, state: state, state_district: state_district, town: town, village: village, road: road, neighbourhood: neighbourhood, building: building, house_number: house_number, amenity: amenity } = location.address;
                        const address = [
                            country,
                            state,
                            state_district,
                            town,
                            village,
                            road,
                            neighbourhood,
                            building,
                            house_number,
                            amenity
                        ].filter(Boolean).join('');
                        onChange({
                            title: location.display_name,
                            address: address
                        });
                    })
            });
            Object.defineProperty(this, "renderTileLayer", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: (eventHandlers)=>{
                    const URL = this.props.tileLayerURL || 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
                    return (0, $2111e08a92d70add$exports.jsx)((0, $bddacdf0a02483d8$export$f52ee31d61d0b27b), {
                        attribution: (0, $6d0827628655730a$export$eb3a06aef9e6ee51)(this.renderAttribution()),
                        url: URL,
                        eventHandlers: eventHandlers
                    });
                }
            });
        }
        get eventHandlerMap() {
            return Object.entries(this.observedProps).reduce((map, [key, value])=>{
                var _a;
                const [_, type, event] = key.match(/^on([A-Z][a-z]+)(.+)/) || [];
                if (type) (map[_a = type] || (map[_a] = {}))[event.toLowerCase()] = value;
                return map;
            }, {});
        }
        get position() {
            const [location] = this.store.searchList;
            return location && [
                +location.lat,
                +location.lon
            ];
        }
        get center() {
            return this.position || this.observedProps.center;
        }
        get markers() {
            const { markers: markers = [], address: address, title: title = address } = this.observedProps, { position: position } = this;
            return [
                ...markers,
                ...position ? [
                    {
                        position: position,
                        tooltip: title
                    }
                ] : []
            ];
        }
        componentDidMount() {
            this.search();
        }
        search(address = this.props.address) {
            if (address) this.store.search(address);
        }
        renderAttribution() {
            return (0, $2111e08a92d70add$exports.jsxs)((0, $2111e08a92d70add$exports.Fragment), {
                children: [
                    "\u00A9",
                    this.props.attribution || (0, $2111e08a92d70add$exports.jsxs)((0, $2111e08a92d70add$exports.Fragment), {
                        children: [
                            (0, $2111e08a92d70add$exports.jsx)("a", {
                                className: "mx-1",
                                href: "https://www.openstreetmap.org/copyright",
                                children: "OpenStreetMap"
                            }),
                            "contributors"
                        ]
                    })
                ]
            });
        }
        renderMap() {
            const { center: center, markers: markers, eventHandlerMap: eventHandlerMap } = this, _a = this.props, { style: style = {
                height: '100vh',
                maxHeight: '100vw'
            }, mapRef: mapRef, renderTileLayer: renderTileLayer = this.renderTileLayer, zoom: zoom, markers: _, onChange: onChange, children: children } = _a, props = $04aabf6d5201c72f$var$__rest(_a, [
                "style",
                "mapRef",
                "renderTileLayer",
                "zoom",
                "markers",
                "onChange",
                "children"
            ]);
            return (0, $2111e08a92d70add$exports.jsxs)((0, $a05cce34ed6a1d4d$export$23f3dfd47374502b), Object.assign({}, props, {
                style: style,
                center: center,
                zoom: zoom,
                doubleClickZoom: !onChange,
                touchZoom: !onChange,
                ref: onChange && ((map)=>{
                    map === null || map === void 0 || map.on('click', this.changeAddress);
                }),
                children: [
                    mapRef && (0, $2111e08a92d70add$exports.jsx)((0, $b297976844a4920d$export$6d3281b2ea2b0e13), {
                        mapRef: mapRef
                    }),
                    renderTileLayer(eventHandlerMap.TileLayer),
                    markers.map(({ position: position, tooltip: tooltip, popup: popup })=>(0, $2111e08a92d70add$exports.jsx)((0, $f4cef3b83e2b02b4$export$e98856a975cab58e), {
                            position: position,
                            eventHandlers: eventHandlerMap.Marker,
                            children: popup ? (0, $2111e08a92d70add$exports.jsx)((0, $02e38ff3c7865d8f$export$129a32eedafa97c5), {
                                children: popup
                            }) : (0, $2111e08a92d70add$exports.jsx)((0, $169770ec3ce03d79$export$28c660c63b792dea), {
                                permanent: true,
                                children: tooltip
                            })
                        }, position + '')),
                    children
                ]
            }));
        }
        render() {
            const { center: center } = this, { children: children, onChange: onChange } = this.props;
            return (0, $2111e08a92d70add$exports.jsxs)((0, $2111e08a92d70add$exports.Fragment), {
                children: [
                    (0, $2111e08a92d70add$exports.jsx)("link", {
                        rel: "stylesheet",
                        href: "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css"
                    }),
                    !onChange && !center ? children || (0, $2111e08a92d70add$exports.jsx)((0, $2111e08a92d70add$exports.Fragment), {}) : this.renderMap()
                ]
            });
        }
    };
    $04aabf6d5201c72f$var$__setFunctionName(_classThis, "OpenReactMap");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _get_eventHandlerMap_decorators = [
            (0, $dZnzp.computed)
        ];
        _get_position_decorators = [
            (0, $dZnzp.computed)
        ];
        _get_center_decorators = [
            (0, $dZnzp.computed)
        ];
        _get_markers_decorators = [
            (0, $dZnzp.computed)
        ];
        _search_decorators = [
            (0, $7ddf193e68e751e3$exports.reaction)(({ observedProps: observedProps })=>observedProps.address)
        ];
        $04aabf6d5201c72f$var$__esDecorate(_classThis, null, _get_eventHandlerMap_decorators, {
            kind: "getter",
            name: "eventHandlerMap",
            static: false,
            private: false,
            access: {
                has: (obj)=>"eventHandlerMap" in obj,
                get: (obj)=>obj.eventHandlerMap
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $04aabf6d5201c72f$var$__esDecorate(_classThis, null, _get_position_decorators, {
            kind: "getter",
            name: "position",
            static: false,
            private: false,
            access: {
                has: (obj)=>"position" in obj,
                get: (obj)=>obj.position
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $04aabf6d5201c72f$var$__esDecorate(_classThis, null, _get_center_decorators, {
            kind: "getter",
            name: "center",
            static: false,
            private: false,
            access: {
                has: (obj)=>"center" in obj,
                get: (obj)=>obj.center
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $04aabf6d5201c72f$var$__esDecorate(_classThis, null, _get_markers_decorators, {
            kind: "getter",
            name: "markers",
            static: false,
            private: false,
            access: {
                has: (obj)=>"markers" in obj,
                get: (obj)=>obj.markers
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $04aabf6d5201c72f$var$__esDecorate(_classThis, null, _search_decorators, {
            kind: "method",
            name: "search",
            static: false,
            private: false,
            access: {
                has: (obj)=>"search" in obj,
                get: (obj)=>obj.search
            },
            metadata: _metadata
        }, null, _instanceExtraInitializers);
        $04aabf6d5201c72f$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        OpenReactMap = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
    })();
    Object.defineProperty(_classThis, "displayName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 'OpenReactMap'
    });
    (()=>{
        $04aabf6d5201c72f$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return OpenReactMap = _classThis;
})();






Prism.languages.javascript = Prism.languages.extend('clike', {
    'class-name': [
        Prism.languages.clike['class-name'],
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
            lookbehind: true
        }
    ],
    'keyword': [
        {
            pattern: /((?:^|\})\s*)catch\b/,
            lookbehind: true
        },
        {
            pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
            lookbehind: true
        }
    ],
    // Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
    'function': /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
    'number': {
        pattern: RegExp(/(^|[^\w$])/.source + '(?:' + // constant
        (/NaN|Infinity/.source + '|' + // binary integer
        /0[bB][01]+(?:_[01]+)*n?/.source + '|' + // octal integer
        /0[oO][0-7]+(?:_[0-7]+)*n?/.source + '|' + // hexadecimal integer
        /0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source + '|' + // decimal bigint
        /\d+(?:_\d+)*n/.source + '|' + // decimal number (integer or float) but no bigint
        /(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source) + ')' + /(?![\w$])/.source),
        lookbehind: true
    },
    'operator': /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});
Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;
Prism.languages.insertBefore('javascript', 'keyword', {
    'regex': {
        pattern: RegExp(// lookbehind
        // eslint-disable-next-line regexp/no-dupe-characters-character-class
        /((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source + // Regex pattern:
        // There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
        // classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
        // with the only syntax, so we have to define 2 different regex patterns.
        /\//.source + '(?:' + /(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source + '|' + // `v` flag syntax. This supports 3 levels of nested character classes.
        /(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source + ')' + // lookahead
        /(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source),
        lookbehind: true,
        greedy: true,
        inside: {
            'regex-source': {
                pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
                lookbehind: true,
                alias: 'language-regex',
                inside: Prism.languages.regex
            },
            'regex-delimiter': /^\/|\/$/,
            'regex-flags': /^[a-z]+$/
        }
    },
    // This must be declared before keyword because we use "function" inside the look-forward
    'function-variable': {
        pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
        alias: 'function'
    },
    'parameter': [
        {
            pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
            lookbehind: true,
            inside: Prism.languages.javascript
        },
        {
            pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
            lookbehind: true,
            inside: Prism.languages.javascript
        },
        {
            pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
            lookbehind: true,
            inside: Prism.languages.javascript
        },
        {
            pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
            lookbehind: true,
            inside: Prism.languages.javascript
        }
    ],
    'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});
Prism.languages.insertBefore('javascript', 'string', {
    'hashbang': {
        pattern: /^#!.*/,
        greedy: true,
        alias: 'comment'
    },
    'template-string': {
        pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
        greedy: true,
        inside: {
            'template-punctuation': {
                pattern: /^`|`$/,
                alias: 'string'
            },
            'interpolation': {
                pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
                lookbehind: true,
                inside: {
                    'interpolation-punctuation': {
                        pattern: /^\$\{|\}$/,
                        alias: 'punctuation'
                    },
                    rest: Prism.languages.javascript
                }
            },
            'string': /[\s\S]+/
        }
    },
    'string-property': {
        pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
        lookbehind: true,
        greedy: true,
        alias: 'property'
    }
});
Prism.languages.insertBefore('javascript', 'operator', {
    'literal-property': {
        pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
        lookbehind: true,
        alias: 'property'
    }
});
if (Prism.languages.markup) {
    Prism.languages.markup.tag.addInlined('script', 'javascript');
    // add attribute support for all DOM events.
    // https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
    Prism.languages.markup.tag.addAttribute(/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source, 'javascript');
}
Prism.languages.js = Prism.languages.javascript;


(function(Prism1) {
    var javascript = Prism1.util.clone(Prism1.languages.javascript);
    var space = /(?:\s|\/\/.*(?!.)|\/\*(?:[^*]|\*(?!\/))\*\/)/.source;
    var braces = /(?:\{(?:\{(?:\{[^{}]*\}|[^{}])*\}|[^{}])*\})/.source;
    var spread = /(?:\{<S>*\.{3}(?:[^{}]|<BRACES>)*\})/.source;
    /**
	 * @param {string} source
	 * @param {string} [flags]
	 */ function re(source, flags) {
        source = source.replace(/<S>/g, function() {
            return space;
        }).replace(/<BRACES>/g, function() {
            return braces;
        }).replace(/<SPREAD>/g, function() {
            return spread;
        });
        return RegExp(source, flags);
    }
    spread = re(spread).source;
    Prism1.languages.jsx = Prism1.languages.extend('markup', javascript);
    Prism1.languages.jsx.tag.pattern = re(/<\/?(?:[\w.:-]+(?:<S>+(?:[\w.:$-]+(?:=(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s{'"/>=]+|<BRACES>))?|<SPREAD>))*<S>*\/?)?>/.source);
    Prism1.languages.jsx.tag.inside['tag'].pattern = /^<\/?[^\s>\/]*/;
    Prism1.languages.jsx.tag.inside['attr-value'].pattern = /=(?!\{)(?:"(?:\\[\s\S]|[^\\"])*"|'(?:\\[\s\S]|[^\\'])*'|[^\s'">]+)/;
    Prism1.languages.jsx.tag.inside['tag'].inside['class-name'] = /^[A-Z]\w*(?:\.[A-Z]\w*)*$/;
    Prism1.languages.jsx.tag.inside['comment'] = javascript['comment'];
    Prism1.languages.insertBefore('inside', 'attr-name', {
        'spread': {
            pattern: re(/<SPREAD>/.source),
            inside: Prism1.languages.jsx
        }
    }, Prism1.languages.jsx.tag);
    Prism1.languages.insertBefore('inside', 'special-attr', {
        'script': {
            // Allow for two levels of nesting
            pattern: re(/=<BRACES>/.source),
            alias: 'language-javascript',
            inside: {
                'script-punctuation': {
                    pattern: /^=(?=\{)/,
                    alias: 'punctuation'
                },
                rest: Prism1.languages.jsx
            }
        }
    }, Prism1.languages.jsx.tag);
    // The following will handle plain text inside tags
    var stringifyToken = function(token) {
        if (!token) return '';
        if (typeof token === 'string') return token;
        if (typeof token.content === 'string') return token.content;
        return token.content.map(stringifyToken).join('');
    };
    var walkTokens = function(tokens) {
        var openedTags = [];
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            var notTagNorBrace = false;
            if (typeof token !== 'string') {
                if (token.type === 'tag' && token.content[0] && token.content[0].type === 'tag') {
                    // We found a tag, now find its kind
                    if (token.content[0].content[0].content === '</') // Closing tag
                    {
                        if (openedTags.length > 0 && openedTags[openedTags.length - 1].tagName === stringifyToken(token.content[0].content[1])) // Pop matching opening tag
                        openedTags.pop();
                    } else {
                        if (token.content[token.content.length - 1].content === '/>') ;
                        else // Opening tag
                        openedTags.push({
                            tagName: stringifyToken(token.content[0].content[1]),
                            openedBraces: 0
                        });
                    }
                } else if (openedTags.length > 0 && token.type === 'punctuation' && token.content === '{') // Here we might have entered a JSX context inside a tag
                openedTags[openedTags.length - 1].openedBraces++;
                else if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces > 0 && token.type === 'punctuation' && token.content === '}') // Here we might have left a JSX context inside a tag
                openedTags[openedTags.length - 1].openedBraces--;
                else notTagNorBrace = true;
            }
            if (notTagNorBrace || typeof token === 'string') {
                if (openedTags.length > 0 && openedTags[openedTags.length - 1].openedBraces === 0) {
                    // Here we are inside a tag, and not inside a JSX context.
                    // That's plain text: drop any tokens matched.
                    var plainText = stringifyToken(token);
                    // And merge text with adjacent text
                    if (i < tokens.length - 1 && (typeof tokens[i + 1] === 'string' || tokens[i + 1].type === 'plain-text')) {
                        plainText += stringifyToken(tokens[i + 1]);
                        tokens.splice(i + 1, 1);
                    }
                    if (i > 0 && (typeof tokens[i - 1] === 'string' || tokens[i - 1].type === 'plain-text')) {
                        plainText = stringifyToken(tokens[i - 1]) + plainText;
                        tokens.splice(i - 1, 1);
                        i--;
                    }
                    tokens[i] = new Prism1.Token('plain-text', plainText, null, plainText);
                }
            }
            if (token.content && typeof token.content !== 'string') walkTokens(token.content);
        }
    };
    Prism1.hooks.add('after-tokenize', function(env) {
        if (env.language !== 'jsx' && env.language !== 'tsx') return;
        walkTokens(env.tokens);
    });
})(Prism);


(function(Prism1) {
    var typescript = Prism1.util.clone(Prism1.languages.typescript);
    Prism1.languages.tsx = Prism1.languages.extend('jsx', typescript);
    // doesn't work with TS because TS is too complex
    delete Prism1.languages.tsx['parameter'];
    delete Prism1.languages.tsx['literal-property'];
    // This will prevent collisions between TSX tags and TS generic types.
    // Idea by https://github.com/karlhorky
    // Discussion: https://github.com/PrismJS/prism/issues/2594#issuecomment-710666928
    var tag = Prism1.languages.tsx.tag;
    tag.pattern = RegExp(/(^|[^\w$]|(?=<\/))/.source + '(?:' + tag.pattern.source + ')', tag.pattern.flags);
    tag.lookbehind = true;
})(Prism);


(function(Prism1) {
    Prism1.languages.typescript = Prism1.languages.extend('javascript', {
        'class-name': {
            pattern: /(\b(?:class|extends|implements|instanceof|interface|new|type)\s+)(?!keyof\b)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?:\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>)?/,
            lookbehind: true,
            greedy: true,
            inside: null // see below
        },
        'builtin': /\b(?:Array|Function|Promise|any|boolean|console|never|number|string|symbol|unknown)\b/
    });
    // The keywords TypeScript adds to JavaScript
    Prism1.languages.typescript.keyword.push(/\b(?:abstract|declare|is|keyof|readonly|require)\b/, // keywords that have to be followed by an identifier
    /\b(?:asserts|infer|interface|module|namespace|type)\b(?=\s*(?:[{_$a-zA-Z\xA0-\uFFFF]|$))/, // This is for `import type *, {}`
    /\btype\b(?=\s*(?:[\{*]|$))/);
    // doesn't work with TS because TS is too complex
    delete Prism1.languages.typescript['parameter'];
    delete Prism1.languages.typescript['literal-property'];
    // a version of typescript specifically for highlighting types
    var typeInside = Prism1.languages.extend('typescript', {});
    delete typeInside['class-name'];
    Prism1.languages.typescript['class-name'].inside = typeInside;
    Prism1.languages.insertBefore('typescript', 'function', {
        'decorator': {
            pattern: /@[$\w\xA0-\uFFFF]+/,
            inside: {
                'at': {
                    pattern: /^@/,
                    alias: 'operator'
                },
                'function': /^[\s\S]+/
            }
        },
        'generic-function': {
            // e.g. foo<T extends "bar" | "baz">( ...
            pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*<(?:[^<>]|<(?:[^<>]|<[^<>]*>)*>)*>(?=\s*\()/,
            greedy: true,
            inside: {
                'function': /^#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*/,
                'generic': {
                    pattern: /<[\s\S]+/,
                    alias: 'class-name',
                    inside: typeInside
                }
            }
        }
    });
    Prism1.languages.ts = Prism1.languages.typescript;
})(Prism);


const $1728f36c4363f161$export$6e2c8f0811a474ce = ({ className: className = '', title: title, children: children })=>(0, $2111e08a92d70add$exports.jsxs)("section", {
        className: `border bg-white mt-3 p-3 ${className}`,
        children: [
            (0, $2111e08a92d70add$exports.jsx)("h2", {
                className: "h3",
                id: title,
                children: title
            }),
            children
        ]
    });


var $23547c5d26526fed$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var $23547c5d26526fed$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $23547c5d26526fed$var$__setFunctionName = undefined && undefined.__setFunctionName || function(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
};
var $23547c5d26526fed$var$__classPrivateFieldGet = undefined && undefined.__classPrivateFieldGet || function(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var $23547c5d26526fed$var$__classPrivateFieldSet = undefined && undefined.__classPrivateFieldSet || function(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
};
(0, $dZnzp.configure)({
    enforceActions: 'never'
});
let $23547c5d26526fed$export$86fbec116b87613f = (()=>{
    var _App_mapAddressName_accessor_storage, _App_screenPortrait_accessor_storage, _App_menuOpen_accessor_storage;
    let _classDecorators = [
        (0, $47a6458a96730da2$export$b6ae1bc530f4c149)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = (0, $dNU7X.Component);
    let _mapAddressName_decorators;
    let _mapAddressName_initializers = [];
    let _mapAddressName_extraInitializers = [];
    let _screenPortrait_decorators;
    let _screenPortrait_initializers = [];
    let _screenPortrait_extraInitializers = [];
    let _menuOpen_decorators;
    let _menuOpen_initializers = [];
    let _menuOpen_extraInitializers = [];
    var App = _classThis = class extends _classSuper {
        constructor(){
            super(...arguments);
            _App_mapAddressName_accessor_storage.set(this, $23547c5d26526fed$var$__runInitializers(this, _mapAddressName_initializers, "\u6210\u90FD\u5E02"));
            _App_screenPortrait_accessor_storage.set(this, ($23547c5d26526fed$var$__runInitializers(this, _mapAddressName_extraInitializers), $23547c5d26526fed$var$__runInitializers(this, _screenPortrait_initializers, false)));
            _App_menuOpen_accessor_storage.set(this, ($23547c5d26526fed$var$__runInitializers(this, _screenPortrait_extraInitializers), $23547c5d26526fed$var$__runInitializers(this, _menuOpen_initializers, false)));
            Object.defineProperty(this, "updateMeta", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: ($23547c5d26526fed$var$__runInitializers(this, _menuOpen_extraInitializers), ()=>this.screenPortrait = window.innerWidth < window.innerHeight)
            });
        }
        componentDidMount() {
            this.updateMeta();
            window.addEventListener('resize', this.updateMeta);
        }
        get mapAddressName() {
            return $23547c5d26526fed$var$__classPrivateFieldGet(this, _App_mapAddressName_accessor_storage, "f");
        }
        set mapAddressName(value) {
            $23547c5d26526fed$var$__classPrivateFieldSet(this, _App_mapAddressName_accessor_storage, value, "f");
        }
        get screenPortrait() {
            return $23547c5d26526fed$var$__classPrivateFieldGet(this, _App_screenPortrait_accessor_storage, "f");
        }
        set screenPortrait(value) {
            $23547c5d26526fed$var$__classPrivateFieldSet(this, _App_screenPortrait_accessor_storage, value, "f");
        }
        get menuOpen() {
            return $23547c5d26526fed$var$__classPrivateFieldGet(this, _App_menuOpen_accessor_storage, "f");
        }
        set menuOpen(value) {
            $23547c5d26526fed$var$__classPrivateFieldSet(this, _App_menuOpen_accessor_storage, value, "f");
        }
        renderCode(code) {
            return (0, $2111e08a92d70add$exports.jsxs)((0, $2111e08a92d70add$exports.Fragment), {
                children: [
                    code,
                    (0, $2111e08a92d70add$exports.jsx)((0, $e58ef2470199210d$exports.CodeBlock), {
                        language: "tsx",
                        children: code
                    })
                ]
            });
        }
        renderContent() {
            const { mapAddressName: mapAddressName } = this;
            return (0, $2111e08a92d70add$exports.jsxs)((0, $2111e08a92d70add$exports.Fragment), {
                children: [
                    (0, $2111e08a92d70add$exports.jsx)("h1", {
                        id: "top",
                        children: "Open Map examples"
                    }),
                    (0, $2111e08a92d70add$exports.jsx)((0, $1728f36c4363f161$export$6e2c8f0811a474ce), {
                        title: "Basic",
                        children: this.renderCode((0, $2111e08a92d70add$exports.jsx)((0, $04aabf6d5201c72f$export$789ab471c7975d83), {
                            center: [
                                34.32,
                                108.55
                            ],
                            zoom: 4
                        }))
                    }),
                    (0, $2111e08a92d70add$exports.jsx)((0, $1728f36c4363f161$export$6e2c8f0811a474ce), {
                        title: "Display Address",
                        children: this.renderCode((0, $2111e08a92d70add$exports.jsx)((0, $04aabf6d5201c72f$export$789ab471c7975d83), {
                            zoom: 10,
                            title: "\u5929\u5E9C\u4E4B\u56FD",
                            address: "\u6210\u90FD\u5E02"
                        }))
                    }),
                    (0, $2111e08a92d70add$exports.jsx)((0, $1728f36c4363f161$export$6e2c8f0811a474ce), {
                        title: "Pick Address",
                        children: this.renderCode((0, $2111e08a92d70add$exports.jsx)((0, $04aabf6d5201c72f$export$789ab471c7975d83), {
                            center: [
                                30.66,
                                104.06
                            ],
                            zoom: 10,
                            address: mapAddressName,
                            onChange: ({ address: address })=>this.mapAddressName = address
                        }))
                    }),
                    (0, $2111e08a92d70add$exports.jsx)((0, $1728f36c4363f161$export$6e2c8f0811a474ce), {
                        title: "China Tile",
                        children: this.renderCode((0, $2111e08a92d70add$exports.jsx)((0, $04aabf6d5201c72f$export$789ab471c7975d83), {
                            center: [
                                34.32,
                                108.55
                            ],
                            zoom: 4,
                            address: mapAddressName,
                            renderTileLayer: ()=>(0, $2111e08a92d70add$exports.jsx)((0, $fda7f0cf135b7497$export$f52ee31d61d0b27b), {
                                    vendor: "GaoDe"
                                }),
                            onChange: ({ address: address })=>this.mapAddressName = address
                        }))
                    })
                ]
            });
        }
        renderMenu() {
            const { screenPortrait: screenPortrait, menuOpen: menuOpen } = this;
            return (0, $2111e08a92d70add$exports.jsxs)((0, $2111e08a92d70add$exports.Fragment), {
                children: [
                    (0, $2111e08a92d70add$exports.jsx)((0, $23c9a6bed94aa817$export$2e2bcd8739ae039), {
                        className: "my-3 d-md-none",
                        onClick: ()=>this.menuOpen = !menuOpen,
                        children: (0, $2111e08a92d70add$exports.jsx)((0, $e58ef2470199210d$exports.Icon), {
                            name: "list"
                        })
                    }),
                    (0, $2111e08a92d70add$exports.jsx)((0, $ce9fafedfe9434a4$export$2e2bcd8739ae039), {
                        in: screenPortrait ? menuOpen : true,
                        children: (0, $2111e08a92d70add$exports.jsx)("div", {
                            className: "sticky-top",
                            children: (0, $2111e08a92d70add$exports.jsx)((0, $e58ef2470199210d$exports.PageNav), {
                                onClick: ()=>screenPortrait && (this.menuOpen = false)
                            })
                        })
                    })
                ]
            });
        }
        render() {
            return (0, $2111e08a92d70add$exports.jsx)("div", {
                className: "bg-light",
                children: (0, $2111e08a92d70add$exports.jsx)((0, $1c1e49137edd774f$export$2e2bcd8739ae039), {
                    className: "pb-3 py-md-5",
                    fluid: "md",
                    children: (0, $2111e08a92d70add$exports.jsxs)((0, $39d0d74bdb7b93e7$export$2e2bcd8739ae039), {
                        children: [
                            (0, $2111e08a92d70add$exports.jsx)((0, $786b27ba1fa4676b$export$2e2bcd8739ae039), {
                                xs: 12,
                                md: 3,
                                className: "sticky-top bg-light",
                                children: this.renderMenu()
                            }),
                            (0, $2111e08a92d70add$exports.jsx)((0, $786b27ba1fa4676b$export$2e2bcd8739ae039), {
                                xs: 12,
                                md: 9,
                                children: this.renderContent()
                            })
                        ]
                    })
                })
            });
        }
    };
    _App_mapAddressName_accessor_storage = new WeakMap();
    _App_screenPortrait_accessor_storage = new WeakMap();
    _App_menuOpen_accessor_storage = new WeakMap();
    $23547c5d26526fed$var$__setFunctionName(_classThis, "App");
    (()=>{
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _mapAddressName_decorators = [
            (0, $dZnzp.observable)
        ];
        _screenPortrait_decorators = [
            (0, $dZnzp.observable)
        ];
        _menuOpen_decorators = [
            (0, $dZnzp.observable)
        ];
        $23547c5d26526fed$var$__esDecorate(_classThis, null, _mapAddressName_decorators, {
            kind: "accessor",
            name: "mapAddressName",
            static: false,
            private: false,
            access: {
                has: (obj)=>"mapAddressName" in obj,
                get: (obj)=>obj.mapAddressName,
                set: (obj, value)=>{
                    obj.mapAddressName = value;
                }
            },
            metadata: _metadata
        }, _mapAddressName_initializers, _mapAddressName_extraInitializers);
        $23547c5d26526fed$var$__esDecorate(_classThis, null, _screenPortrait_decorators, {
            kind: "accessor",
            name: "screenPortrait",
            static: false,
            private: false,
            access: {
                has: (obj)=>"screenPortrait" in obj,
                get: (obj)=>obj.screenPortrait,
                set: (obj, value)=>{
                    obj.screenPortrait = value;
                }
            },
            metadata: _metadata
        }, _screenPortrait_initializers, _screenPortrait_extraInitializers);
        $23547c5d26526fed$var$__esDecorate(_classThis, null, _menuOpen_decorators, {
            kind: "accessor",
            name: "menuOpen",
            static: false,
            private: false,
            access: {
                has: (obj)=>"menuOpen" in obj,
                get: (obj)=>obj.menuOpen,
                set: (obj, value)=>{
                    obj.menuOpen = value;
                }
            },
            metadata: _metadata
        }, _menuOpen_initializers, _menuOpen_extraInitializers);
        $23547c5d26526fed$var$__esDecorate(null, _classDescriptor = {
            value: _classThis
        }, _classDecorators, {
            kind: "class",
            name: _classThis.name,
            metadata: _metadata
        }, null, _classExtraInitializers);
        App = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: _metadata
        });
        $23547c5d26526fed$var$__runInitializers(_classThis, _classExtraInitializers);
    })();
    return App = _classThis;
})();
(0, $3d2450ff1707eb5a$exports.createRoot)(document.querySelector('main')).render((0, $2111e08a92d70add$exports.jsx)($23547c5d26526fed$export$86fbec116b87613f, {}));


//# sourceMappingURL=preview.9e24b9fb.js.map
